/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 203);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(246)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(245)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common', ['gm.common.constants']).name;


__webpack_require__(238);
__webpack_require__(240);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(248);
__webpack_require__(250);
__webpack_require__(252);
__webpack_require__(254);
__webpack_require__(256);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(262);
__webpack_require__(264);
__webpack_require__(266);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(272);
__webpack_require__(274);
__webpack_require__(276);
__webpack_require__(278);
__webpack_require__(280);
__webpack_require__(282);
__webpack_require__(284);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(295);
__webpack_require__(297);
__webpack_require__(299);
__webpack_require__(302);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(308);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(325);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * State-based routing for AngularJS 1.x
 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
 * @version v1.0.11
 * @link https://ui-router.github.io
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (global, factory) {
	 true ? factory(exports, __webpack_require__(35), __webpack_require__(207)) :
	typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	(factory((global['@uirouter/angularjs'] = {}),global.angular,global['@uirouter/core']));
}(this, (function (exports,ng_from_import,core) { 'use strict';

var ng_from_global = angular;
var ng = (ng_from_import && ng_from_import.module) ? ng_from_import : ng_from_global;

function getNg1ViewConfigFactory() {
    var templateFactory = null;
    return function (path, view) {
        templateFactory = templateFactory || core.services.$injector.get("$templateFactory");
        return [new Ng1ViewConfig(path, view, templateFactory)];
    };
}
var hasAnyKey = function (keys, obj) {
    return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false);
};
/**
 * This is a [[StateBuilder.builder]] function for angular1 `views`.
 *
 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
 * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
 *
 * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
 * and applies the state-level configuration to a view named `$default`.
 */
function ng1ViewsBuilder(state) {
    // Do not process root state
    if (!state.parent)
        return {};
    var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
    // Do not allow a state to have both state-level props and also a `views: {}` property.
    // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
    // However, the `$default` approach should not be mixed with a separate `views: ` block.
    if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
        throw new Error("State '" + state.name + "' has a 'views' object. " +
            "It cannot also have \"view properties\" at the state level.  " +
            "Move the following properties into a view (in the 'views' object): " +
            (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(", ")));
    }
    var views = {}, viewsObject = state.views || { "$default": core.pick(state, allViewKeys) };
    core.forEach(viewsObject, function (config, name) {
        // Account for views: { "": { template... } }
        name = name || "$default";
        // Account for views: { header: "headerComponent" }
        if (core.isString(config))
            config = { component: config };
        // Make a shallow copy of the config object
        config = core.extend({}, config);
        // Do not allow a view to mix props for component-style view with props for template/controller-style view
        if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
            throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: '" + name + "@" + state.name + "'");
        }
        config.resolveAs = config.resolveAs || '$resolve';
        config.$type = "ng1";
        config.$context = state;
        config.$name = name;
        var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
        config.$uiViewName = normalized.uiViewName;
        config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
        views[name] = config;
    });
    return views;
}
var id = 0;
var Ng1ViewConfig = /** @class */ (function () {
    function Ng1ViewConfig(path, viewDecl, factory) {
        var _this = this;
        this.path = path;
        this.viewDecl = viewDecl;
        this.factory = factory;
        this.$id = id++;
        this.loaded = false;
        this.getTemplate = function (uiView, context) {
            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
        };
    }
    Ng1ViewConfig.prototype.load = function () {
        var _this = this;
        var $q = core.services.$q;
        var context = new core.ResolveContext(this.path);
        var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
        var promises = {
            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
            controller: $q.when(this.getController(context))
        };
        return $q.all(promises).then(function (results) {
            core.trace.traceViewServiceEvent("Loaded", _this);
            _this.controller = results.controller;
            core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
            return _this;
        });
    };
    /**
     * Gets the controller for a view configuration.
     *
     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
     */
    Ng1ViewConfig.prototype.getController = function (context) {
        var provider = this.viewDecl.controllerProvider;
        if (!core.isInjectable(provider))
            return this.viewDecl.controller;
        var deps = core.services.$injector.annotate(provider);
        var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
        var resolvable = new core.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    return Ng1ViewConfig;
}());

/** @module view */
/** for typedoc */
/**
 * Service which manages loading of templates from a ViewConfig.
 */
var TemplateFactory = /** @class */ (function () {
    function TemplateFactory() {
        var _this = this;
        /** @hidden */ this._useHttp = ng.version.minor < 3;
        /** @hidden */ this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
                _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
                _this.$http = $http;
                _this.$templateCache = $templateCache;
                return _this;
            }];
    }
    /** @hidden */
    TemplateFactory.prototype.useHttpService = function (value) {
        this._useHttp = value;
    };
    
    /**
     * Creates a template from a configuration object.
     *
     * @param config Configuration object for which to load a template.
     * The following properties are search in the specified order, and the first one
     * that is defined is used to create the template:
     *
     * @param params  Parameters to pass to the template function.
     * @param context The resolve context associated with the template's view
     *
     * @return {string|object}  The template html as a string, or a promise for
     * that string,or `null` if no template is configured.
     */
    TemplateFactory.prototype.fromConfig = function (config, params, context) {
        var defaultTemplate = "<ui-view></ui-view>";
        var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
        var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
        return (core.isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) :
            core.isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) :
                core.isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) :
                    core.isDefined(config.component) ? asComponent(config.component) :
                        core.isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) :
                            asTemplate(defaultTemplate));
    };
    
    /**
     * Creates a template from a string or a function returning a string.
     *
     * @param template html template as a string or function that returns an html template as a string.
     * @param params Parameters to pass to the template function.
     *
     * @return {string|object} The template html as a string, or a promise for that
     * string.
     */
    TemplateFactory.prototype.fromString = function (template, params) {
        return core.isFunction(template) ? template(params) : template;
    };
    
    /**
     * Loads a template from the a URL via `$http` and `$templateCache`.
     *
     * @param {string|Function} url url of the template to load, or a function
     * that returns a url.
     * @param {Object} params Parameters to pass to the url function.
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromUrl = function (url, params) {
        if (core.isFunction(url))
            url = url(params);
        if (url == null)
            return null;
        if (this._useHttp) {
            return this.$http.get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
                .then(function (response) {
                return response.data;
            });
        }
        return this.$templateRequest(url);
    };
    
    /**
     * Creates a template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromProvider = function (provider, params, context) {
        var deps = core.services.$injector.annotate(provider);
        var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
        var resolvable = new core.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    
    /**
     * Creates a component's template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
        var deps = core.services.$injector.annotate(provider);
        var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
        var resolvable = new core.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    
    /**
     * Creates a template from a component's name
     *
     * This implements route-to-component.
     * It works by retrieving the component (directive) metadata from the injector.
     * It analyses the component's bindings, then constructs a template that instantiates the component.
     * The template wires input and output bindings to resolves or from the parent component.
     *
     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
     * @param component {string} Component's name in camel case.
     * @param bindings An object defining the component's bindings: {foo: '<'}
     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
        bindings = bindings || {};
        // Bind once prefix
        var prefix = ng.version.minor >= 3 ? "::" : "";
        // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
        var kebob = function (camelCase) {
            var kebobed = core.kebobString(camelCase);
            return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
        };
        var attributeTpl = function (input) {
            var name = input.name, type = input.type;
            var attrName = kebob(name);
            // If the ui-view has an attribute which matches a binding on the routed component
            // then pass that attribute through to the routed component template.
            // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
            if (uiView.attr(attrName) && !bindings[name])
                return attrName + "='" + uiView.attr(attrName) + "'";
            var resolveName = bindings[name] || name;
            // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
            // some-attr="{{ ::$resolve.someResolveName }}"
            if (type === '@')
                return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
            // Wire "&" callbacks to resolves that return a callback function
            // Get the result of the resolve (should be a function) and annotate it to get its arguments.
            // some-attr="$resolve.someResolveResultName(foo, bar)"
            if (type === '&') {
                var res = context.getResolvable(resolveName);
                var fn = res && res.data;
                var args = fn && core.services.$injector.annotate(fn) || [];
                // account for array style injection, i.e., ['foo', function(foo) {}]
                var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
                return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(",") + ")'";
            }
            // some-attr="::$resolve.someResolveName"
            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
        };
        var attrs = getComponentBindings(component).map(attributeTpl).join(" ");
        var kebobName = kebob(component);
        return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
    };
    
    return TemplateFactory;
}());
// Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
function getComponentBindings(name) {
    var cmpDefs = core.services.$injector.get(name + "Directive"); // could be multiple
    if (!cmpDefs || !cmpDefs.length)
        throw new Error("Unable to find component named '" + name + "'");
    return cmpDefs.map(getBindings).reduce(core.unnestR, []);
}
// Given a directive definition, find its object input attributes
// Use different properties, depending on the type of directive (component, bindToController, normal)
var getBindings = function (def) {
    if (core.isObject(def.bindToController))
        return scopeBindings(def.bindToController);
    return scopeBindings(def.scope);
};
// for ng 1.2 style, process the scope: { input: "=foo" }
// for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
var scopeBindings = function (bindingsObj) { return Object.keys(bindingsObj || {})
    .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
    .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
    .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); }); };

/** @module ng1 */ /** for typedoc */
/**
 * The Angular 1 `StateProvider`
 *
 * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
var StateProvider = /** @class */ (function () {
    function StateProvider(stateRegistry, stateService) {
        this.stateRegistry = stateRegistry;
        this.stateService = stateService;
        core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
    }
    /**
     * Decorates states when they are registered
     *
     * Allows you to extend (carefully) or override (at your own peril) the
     * `stateBuilder` object used internally by [[StateRegistry]].
     * This can be used to add custom functionality to ui-router,
     * for example inferring templateUrl based on the state name.
     *
     * When passing only a name, it returns the current (original or decorated) builder
     * function that matches `name`.
     *
     * The builder functions that can be decorated are listed below. Though not all
     * necessarily have a good use case for decoration, that is up to you to decide.
     *
     * In addition, users can attach custom decorators, which will generate new
     * properties within the state's internal definition. There is currently no clear
     * use-case for this beyond accessing internal states (i.e. $state.$current),
     * however, expect this to become increasingly relevant as we introduce additional
     * meta-programming features.
     *
     * **Warning**: Decorators should not be interdependent because the order of
     * execution of the builder functions in non-deterministic. Builder functions
     * should only be dependent on the state definition object and super function.
     *
     *
     * Existing builder functions and current return values:
     *
     * - **parent** `{object}` - returns the parent state object.
     * - **data** `{object}` - returns state data, including any inherited data that is not
     *   overridden by own values (if any).
     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
     *   or `null`.
     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
     *   navigable).
     * - **params** `{object}` - returns an array of state params that are ensured to
     *   be a super-set of parent's params.
     * - **views** `{object}` - returns a views object where each key is an absolute view
     *   name (i.e. "viewName@stateName") and each value is the config object
     *   (template, controller) for the view. Even when you don't use the views object
     *   explicitly on a state config, one is still created for you internally.
     *   So by decorating this builder function you have access to decorating template
     *   and controller properties.
     * - **ownParams** `{object}` - returns an array of params that belong to the state,
     *   not including any params defined by ancestor states.
     * - **path** `{string}` - returns the full path from the root down to this state.
     *   Needed for state activation.
     * - **includes** `{object}` - returns an object that includes every state that
     *   would pass a `$state.includes()` test.
     *
     * #### Example:
     * Override the internal 'views' builder with a function that takes the state
     * definition, and a reference to the internal function being overridden:
     * ```js
     * $stateProvider.decorator('views', function (state, parent) {
     *   let result = {},
     *       views = parent(state);
     *
     *   angular.forEach(views, function (config, name) {
     *     let autoName = (state.name + '.' + name).replace('.', '/');
     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
     *     result[name] = config;
     *   });
     *   return result;
     * });
     *
     * $stateProvider.state('home', {
     *   views: {
     *     'contact.list': { controller: 'ListController' },
     *     'contact.item': { controller: 'ItemController' }
     *   }
     * });
     * ```
     *
     *
     * ```js
     * // Auto-populates list and item views with /partials/home/contact/list.html,
     * // and /partials/home/contact/item.html, respectively.
     * $state.go('home');
     * ```
     *
     * @param {string} name The name of the builder function to decorate.
     * @param {object} func A function that is responsible for decorating the original
     * builder function. The function receives two parameters:
     *
     *   - `{object}` - state - The state config object.
     *   - `{object}` - super - The original builder function.
     *
     * @return {object} $stateProvider - $stateProvider instance
     */
    StateProvider.prototype.decorator = function (name, func) {
        return this.stateRegistry.decorator(name, func) || this;
    };
    StateProvider.prototype.state = function (name, definition) {
        if (core.isObject(name)) {
            definition = name;
        }
        else {
            definition.name = name;
        }
        this.stateRegistry.register(definition);
        return this;
    };
    /**
     * Registers an invalid state handler
     *
     * This is a passthrough to [[StateService.onInvalid]] for ng1.
     */
    StateProvider.prototype.onInvalid = function (callback) {
        return this.stateService.onInvalid(callback);
    };
    return StateProvider;
}());

/** @module ng1 */ /** */
/**
 * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
 * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
 * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
 */
var getStateHookBuilder = function (hookName) {
    return function stateHookBuilder(state, parentFn) {
        var hook = state[hookName];
        var pathname = hookName === 'onExit' ? 'from' : 'to';
        function decoratedNg1Hook(trans, state) {
            var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
            var locals = core.extend(getLocals(resolveContext), { $state$: state, $transition$: trans });
            return core.services.$injector.invoke(hook, this, locals);
        }
        return hook ? decoratedNg1Hook : undefined;
    };
};

/**
 * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
 */
var Ng1LocationServices = /** @class */ (function () {
    function Ng1LocationServices($locationProvider) {
        // .onChange() registry
        this._urlListeners = [];
        this.$locationProvider = $locationProvider;
        var _lp = core.val($locationProvider);
        core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
    }
    Ng1LocationServices.prototype.dispose = function () { };
    Ng1LocationServices.prototype.onChange = function (callback) {
        var _this = this;
        this._urlListeners.push(callback);
        return function () { return core.removeFrom(_this._urlListeners)(callback); };
    };
    Ng1LocationServices.prototype.html5Mode = function () {
        var html5Mode = this.$locationProvider.html5Mode();
        html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
        return html5Mode && this.$sniffer.history;
    };
    Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
        if (replace === void 0) { replace = false; }
        if (newUrl)
            this.$location.url(newUrl);
        if (replace)
            this.$location.replace();
        if (state)
            this.$location.state(state);
        return this.$location.url();
    };
    Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser) {
        var _this = this;
        this.$location = $location;
        this.$sniffer = $sniffer;
        // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
        $rootScope.$on("$locationChangeSuccess", function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
        var _loc = core.val($location);
        var _browser = core.val($browser);
        // Bind these LocationService functions to $location
        core.createProxyFunctions(_loc, this, _loc, ["replace", "path", "search", "hash"]);
        // Bind these LocationConfig functions to $location
        core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
        // Bind these LocationConfig functions to $browser
        core.createProxyFunctions(_browser, this, _browser, ['baseHref']);
    };
    /**
     * Applys ng1-specific path parameter encoding
     *
     * The Angular 1 `$location` service is a bit weird.
     * It doesn't allow slashes to be encoded/decoded bi-directionally.
     *
     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
     *
     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
     *
     * @param router
     */
    Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
        var pathType = router.urlMatcherFactory.type('path');
        pathType.encode = function (val$$1) {
            return val$$1 != null ? val$$1.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : val$$1;
        };
        pathType.decode = function (val$$1) {
            return val$$1 != null ? val$$1.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : val$$1;
        };
    };
    return Ng1LocationServices;
}());

/** @module url */ /** */
/**
 * Manages rules for client-side URL
 *
 * ### Deprecation warning:
 * This class is now considered to be an internal API
 * Use the [[UrlService]] instead.
 * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
 *
 * This class manages the router rules for what to do when the URL changes.
 *
 * This provider remains for backwards compatibility.
 *
 * @deprecated
 */
var UrlRouterProvider = /** @class */ (function () {
    /** @hidden */
    function UrlRouterProvider(router) {
        this._router = router;
        this._urlRouter = router.urlRouter;
    }
    /** @hidden */
    UrlRouterProvider.prototype.$get = function () {
        var urlRouter = this._urlRouter;
        urlRouter.update(true);
        if (!urlRouter.interceptDeferred)
            urlRouter.listen();
        return urlRouter;
    };
    /**
     * Registers a url handler function.
     *
     * Registers a low level url handler (a `rule`).
     * A rule detects specific URL patterns and returns a redirect, or performs some action.
     *
     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Here's an example of how you might allow case insensitive urls
     *   $urlRouterProvider.rule(function ($injector, $location) {
     *     var path = $location.path(),
     *         normalized = path.toLowerCase();
     *
     *     if (path !== normalized) {
     *       return normalized;
     *     }
     *   });
     * });
     * ```
     *
     * @param ruleFn
     * Handler function that takes `$injector` and `$location` services as arguments.
     * You can use them to detect a url and return a different url as a string.
     *
     * @return [[UrlRouterProvider]] (`this`)
     */
    UrlRouterProvider.prototype.rule = function (ruleFn) {
        var _this = this;
        if (!core.isFunction(ruleFn))
            throw new Error("'rule' must be a function");
        var match = function () {
            return ruleFn(core.services.$injector, _this._router.locationService);
        };
        var rule = new core.BaseUrlRule(match, core.identity);
        this._urlRouter.rule(rule);
        return this;
    };
    
    /**
     * Defines the path or behavior to use when no url can be matched.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // if the path doesn't match any of the urls you configured
     *   // otherwise will take care of routing the user to the
     *   // specified url
     *   $urlRouterProvider.otherwise('/index');
     *
     *   // Example of using function rule as param
     *   $urlRouterProvider.otherwise(function ($injector, $location) {
     *     return '/a/valid/url';
     *   });
     * });
     * ```
     *
     * @param rule
     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
     *
     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
     */
    UrlRouterProvider.prototype.otherwise = function (rule) {
        var _this = this;
        var urlRouter = this._urlRouter;
        if (core.isString(rule)) {
            urlRouter.otherwise(rule);
        }
        else if (core.isFunction(rule)) {
            urlRouter.otherwise(function () { return rule(core.services.$injector, _this._router.locationService); });
        }
        else {
            throw new Error("'rule' must be a string or function");
        }
        return this;
    };
    
    /**
     * Registers a handler for a given url matching.
     *
     * If the handler is a string, it is
     * treated as a redirect, and is interpolated according to the syntax of match
     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
     *
     * If the handler is a function, it is injectable.
     * It gets invoked if `$location` matches.
     * You have the option of inject the match object as `$match`.
     *
     * The handler can return
     *
     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
     *   will continue trying to find another one that matches.
     * - **string** which is treated as a redirect and passed to `$location.url()`
     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
     *     if ($state.$current.navigable !== state ||
     *         !equalForKeys($match, $stateParams) {
     *      $state.transitionTo(state, $match, false);
     *     }
     *   });
     * });
     * ```
     *
     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
     * @param handler The path (or function that returns a path) that you want to redirect your user to.
     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
     *
     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
     */
    UrlRouterProvider.prototype.when = function (what, handler) {
        if (core.isArray(handler) || core.isFunction(handler)) {
            handler = UrlRouterProvider.injectableHandler(this._router, handler);
        }
        this._urlRouter.when(what, handler);
        return this;
    };
    
    UrlRouterProvider.injectableHandler = function (router, handler) {
        return function (match) {
            return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params });
        };
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Prevent $urlRouter from automatically intercepting URL changes;
     *   $urlRouterProvider.deferIntercept();
     * })
     *
     * app.run(function (MyService, $urlRouter, $http) {
     *   $http.get("/stuff").then(function(resp) {
     *     MyService.doStuff(resp.data);
     *     $urlRouter.listen();
     *     $urlRouter.sync();
     *   });
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */
    UrlRouterProvider.prototype.deferIntercept = function (defer) {
        this._urlRouter.deferIntercept(defer);
    };
    
    return UrlRouterProvider;
}());

/**
 * # Angular 1 types
 *
 * UI-Router core provides various Typescript types which you can use for code completion and validating parameter values, etc.
 * The customizations to the core types for Angular UI-Router are documented here.
 *
 * The optional [[$resolve]] service is also documented here.
 *
 * @module ng1
 * @preferred
 */
/** for typedoc */
ng.module("ui.router.angular1", []);
var mod_init = ng.module('ui.router.init', []);
var mod_util = ng.module('ui.router.util', ['ng', 'ui.router.init']);
var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
var mod_cmpt = ng.module('ui.router.compat', ['ui.router']); // tslint:disable-line
var router = null;
$uiRouter.$inject = ['$locationProvider'];
/** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
function $uiRouter($locationProvider) {
    // Create a new instance of the Router when the $uiRouterProvider is initialized
    router = this.router = new core.UIRouter();
    router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
    router.stateRegistry.decorator("views", ng1ViewsBuilder);
    router.stateRegistry.decorator("onExit", getStateHookBuilder("onExit"));
    router.stateRegistry.decorator("onRetain", getStateHookBuilder("onRetain"));
    router.stateRegistry.decorator("onEnter", getStateHookBuilder("onEnter"));
    router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
    var ng1LocationService = router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider);
    Ng1LocationServices.monkeyPatchPathParameterType(router);
    // backwards compat: also expose router instance as $uiRouterProvider.router
    router['router'] = router;
    router['$get'] = $get;
    $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
    function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
        ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser);
        delete router['router'];
        delete router['$get'];
        return router;
    }
    return router;
}
var getProviderFor = function (serviceName) { return ['$uiRouterProvider', function ($urp) {
        var service = $urp.router[serviceName];
        service["$get"] = function () { return service; };
        return service;
    }]; };
// This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
runBlock.$inject = ['$injector', '$q', '$uiRouter'];
function runBlock($injector, $q, $uiRouter) {
    core.services.$injector = $injector;
    core.services.$q = $q;
    // The $injector is now available.
    // Find any resolvables that had dependency annotation deferred
    $uiRouter.stateRegistry.get()
        .map(function (x) { return x.$$state().resolvables; })
        .reduce(core.unnestR, [])
        .filter(function (x) { return x.deps === "deferred"; })
        .forEach(function (resolvable) { return resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi); });
}
// $urlRouter service and $urlRouterProvider
var getUrlRouterProvider = function (uiRouter) {
    return uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter);
};
// $state service and $stateProvider
// $urlRouter service and $urlRouterProvider
var getStateProvider = function () {
    return core.extend(router.stateProvider, { $get: function () { return router.stateService; } });
};
watchDigests.$inject = ['$rootScope'];
function watchDigests($rootScope) {
    $rootScope.$watch(function () { core.trace.approximateDigests++; });
}
mod_init.provider("$uiRouter", $uiRouter);
mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
mod_util.provider('$urlService', getProviderFor('urlService'));
mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
mod_state.provider('$transitions', getProviderFor('transitionService'));
mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
mod_main.factory('$view', function () { return router.viewService; });
mod_main.service("$trace", function () { return core.trace; });
mod_main.run(watchDigests);
mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
mod_state.run(['$state', function ($state) { }]);
mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
mod_init.run(runBlock);
/** @hidden TODO: find a place to move this */
var getLocals = function (ctx) {
    var tokens = ctx.getTokens().filter(core.isString);
    var tuples = tokens.map(function (key) {
        var resolvable = ctx.getResolvable(key);
        var waitPolicy = ctx.getPolicy(resolvable).async;
        return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
    });
    return tuples.reduce(core.applyPairs, {});
};

/**
 * # Angular 1 injectable services
 *
 * This is a list of the objects which can be injected using angular's injector.
 *
 * There are three different kind of injectable objects:
 *
 * ## **Provider** objects
 * #### injectable into a `.config()` block during configtime
 *
 * - [[$uiRouterProvider]]: The UI-Router instance
 * - [[$stateProvider]]: State registration
 * - [[$transitionsProvider]]: Transition hooks
 * - [[$urlServiceProvider]]: All URL related public APIs
 *
 * - [[$uiViewScrollProvider]]: Disable ui-router view scrolling
 * - [[$urlRouterProvider]]: (deprecated) Url matching rules
 * - [[$urlMatcherFactoryProvider]]: (deprecated) Url parsing config
 *
 * ## **Service** objects
 * #### injectable globally during runtime
 *
 * - [[$uiRouter]]: The UI-Router instance
 * - [[$trace]]: Enable transition trace/debug
 * - [[$transitions]]: Transition hooks
 * - [[$state]]: Imperative state related APIs
 * - [[$stateRegistry]]: State registration
 * - [[$urlService]]: All URL related public APIs
 * - [[$uiRouterGlobals]]: Global variables
 * - [[$uiViewScroll]]: Scroll an element into view
 *
 * - [[$stateParams]]: (deprecated) Global state param values
 * - [[$urlRouter]]: (deprecated) URL synchronization
 * - [[$urlMatcherFactory]]: (deprecated) URL parsing config
 *
 * ## **Per-Transition** objects
 *
 * - These kind of objects are injectable into:
 *   - Resolves ([[Ng1StateDeclaration.resolve]]),
 *   - Transition Hooks ([[TransitionService.onStart]], etc),
 *   - Routed Controllers ([[Ng1ViewDeclaration.controller]])
 *
 * #### Different instances are injected based on the [[Transition]]
 *
 * - [[$transition$]]: The current Transition object
 * - [[$stateParams]]: State param values for pending Transition (deprecated)
 * - Any resolve data defined using [[Ng1StateDeclaration.resolve]]
 *
 * @ng1api
 * @preferred
 * @module injectables
 */ /** */
/**
 * The current (or pending) State Parameters
 *
 * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
 *
 * The values are not updated until *after* a `Transition` successfully completes.
 *
 * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
 *
 * ### Deprecation warning:
 *
 * The value injected for `$stateParams` is different depending on where it is injected.
 *
 * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
 * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
 *
 * Because of these confusing details, this service is deprecated.
 *
 * ### Instead of using the global `$stateParams` service object,
 * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
 *
 * ```js
 * MyService.$inject = ['$uiRouterGlobals'];
 * function MyService($uiRouterGlobals) {
 *   return {
 *     paramValues: function () {
 *       return $uiRouterGlobals.params;
 *     }
 *   }
 * }
 * ```
 *
 * ### Instead of using the per-transition `$stateParams` object,
 * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
 *
 * ```js
 * MyController.$inject = ['$transition$'];
 * function MyController($transition$) {
 *   var username = $transition$.params().username;
 *   // .. do something with username
 * }
 * ```
 *
 * ---
 *
 * This object can be injected into other services.
 *
 * #### Deprecated Example:
 * ```js
 * SomeService.$inject = ['$http', '$stateParams'];
 * function SomeService($http, $stateParams) {
 *   return {
 *     getUser: function() {
 *       return $http.get('/api/users/' + $stateParams.username);
 *     }
 *   }
 * };
 * angular.service('SomeService', SomeService);
 * ```
 * @deprecated
 */

/**
 * # Angular 1 Directives
 *
 * These are the directives included in UI-Router for Angular 1.
 * These directives are used in templates to create viewports and link/navigate to states.
 *
 * @ng1api
 * @preferred
 * @module directives
 */ /** for typedoc */
/** @hidden */
function parseStateRef(ref) {
    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/), parsed;
    if (paramsOnly)
        ref = '(' + paramsOnly[1] + ')';
    parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4)
        throw new Error("Invalid state ref '" + ref + "'");
    return { state: parsed[1] || null, paramExpr: parsed[3] || null };
}
/** @hidden */
function stateContext(el) {
    var $uiView = el.parent().inheritedData('$uiView');
    var path = core.parse('$cfg.path')($uiView);
    return path ? core.tail(path).state.name : undefined;
}
/** @hidden */
function processedDef($state, $element, def) {
    var uiState = def.uiState || $state.current.name;
    var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
    return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
}
/** @hidden */
function getTypeInfo(el) {
    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
    var isForm = el[0].nodeName === "FORM";
    return {
        attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
        isAnchor: el.prop("tagName").toUpperCase() === "A",
        clickable: !isForm
    };
}
/** @hidden */
function clickHook(el, $state, $timeout, type, getDef) {
    return function (e) {
        var button = e.which || e.button, target = getDef();
        if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
            // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
            var transition = $timeout(function () {
                $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
            });
            e.preventDefault();
            // if the state has no URL, ignore one preventDefault from the <a> directive.
            var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function () {
                if (ignorePreventDefaultCount-- <= 0)
                    $timeout.cancel(transition);
            };
        }
    };
}
/** @hidden */
function defaultOpts(el, $state) {
    return {
        relative: stateContext(el) || $state.$current,
        inherit: true,
        source: "sref"
    };
}
/** @hidden */
function bindEvents(element, scope, hookFn, uiStateOpts) {
    var events;
    if (uiStateOpts) {
        events = uiStateOpts.events;
    }
    if (!core.isArray(events)) {
        events = ['click'];
    }
    var on = element.on ? 'on' : 'bind';
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var event_1 = events_1[_i];
        element[on](event_1, hookFn);
    }
    scope.$on('$destroy', function () {
        var off = element.off ? 'off' : 'unbind';
        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
            var event_2 = events_2[_i];
            element[off](event_2, hookFn);
        }
    });
}
/**
 * `ui-sref`: A directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of the `ui-sref` is the name of the state to link to.
 *
 * #### Example:
 * This will activate the `home` state when the link is clicked.
 * ```html
 * <a ui-sref="home">Home</a>
 * ```
 *
 * ### Relative Links
 * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create a relative `ui-sref` which always targets the same destination.
 *
 * #### Example:
 * Both these links are relative to the parent state, even when a child state is currently active.
 * ```html
 * <a ui-sref=".child1">child 1 state</a>
 * <a ui-sref=".child2">child 2 state</a>
 * ```
 *
 * This link activates the parent state.
 * ```html
 * <a ui-sref="^">Return</a>
 * ```
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * #### Example:
 * Assuming the `users` state has a url of `/users/`
 * ```html
 * <a ui-sref="users" href="/users/">Users</a>
 * ```
 *
 * ### Parameter Values
 * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
 * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
 * The content inside the parentheses is an expression, evaluated to the parameter values.
 *
 * #### Example:
 * This example renders a list of links to users.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="user in users">
 *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
 * </li>
 * ```
 *
 * Note:
 * The parameter values expression is `$watch`ed for updates.
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 *
 * #### Example:
 * ```html
 * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Other DOM Events
 *
 * You can also customize which DOM events to respond to (instead of `click`) by
 * providing an `events` array in the `ui-sref-opts` attribute.
 *
 * #### Example:
 * ```html
 * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Examples
 * If you have the following template:
 *
 * ```html
 * <a ui-sref="home">Home</a>
 * <a ui-sref="about">About</a>
 * <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * ```
 *
 * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
 *
 * ```html
 * <a href="#/home" ui-sref="home">Home</a>
 * <a href="#/about" ui-sref="about">About</a>
 * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * ```
 *
 * ### Notes
 *
 * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-sref="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 *
 * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
 * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
 */
var uiSref;
uiSref = ['$uiRouter', '$timeout',
    function $StateRefDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: 'A',
            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
            link: function (scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function () { return processedDef($state, element, rawDef); };
                var ref = parseStateRef(attrs.uiSref);
                rawDef.uiState = ref.state;
                rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn)
                        unlinkInfoFn();
                    if (active)
                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null)
                        attrs.$set(type.attr, def.href);
                }
                if (ref.paramExpr) {
                    scope.$watch(ref.paramExpr, function (val$$1) {
                        rawDef.uiStateParams = core.extend({}, val$$1);
                        update();
                    }, true);
                    rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
                }
                update();
                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable)
                    return;
                hookFn = clickHook(element, $state, $timeout, type, getDef);
                bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
            }
        };
    }];
/**
 * `ui-state`: A fully dynamic directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
 * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
 *
 * #### Example:
 * Create a list of links.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Relative Links
 * If the expression evaluates to a relative path, it is processed like [[uiSref]].
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create relative `ui-state` which always targets the same destination.
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * ### Parameter Values
 * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
 * Param values should be provided using the `ui-state-params` attribute.
 * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * This example renders a list of links with param values.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * ```html
 * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Other DOM Events
 *
 * You can also customize which DOM events to respond to (instead of `click`) by
 * providing an `events` array in the `ui-state-opts` attribute.
 *
 * #### Example:
 * ```html
 * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Notes
 *
 * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
 *   However, it might be simpler to use [[uiSref]] parameter-only links.
 *
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 * ```
 */
var uiState;
uiState = ['$uiRouter', '$timeout',
    function $StateRefDynamicDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: 'A',
            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
            link: function (scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function () { return processedDef($state, element, rawDef); };
                var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
                var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return (acc[attr] = core.noop, acc); }, {});
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn)
                        unlinkInfoFn();
                    if (active)
                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null)
                        attrs.$set(type.attr, def.href);
                }
                inputAttrs.forEach(function (field) {
                    rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
                    attrs.$observe(field, function (expr) {
                        watchDeregFns[field]();
                        watchDeregFns[field] = scope.$watch(expr, function (newval) {
                            rawDef[field] = newval;
                            update();
                        }, true);
                    });
                });
                update();
                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable)
                    return;
                hookFn = clickHook(element, $state, $timeout, type, getDef);
                bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
            }
        };
    }];
/**
 * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
 *
 * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
 * related directive's state is active (and remove them when it is inactive).
 *
 * The primary use-case is to highlight the active link in navigation menus,
 * distinguishing it from the inactive menu items.
 *
 * ### Linking to a `ui-sref` or `ui-state`
 * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
 * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
 *
 * ### Matching
 *
 * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
 * This is a "fuzzy match" which uses [[StateService.includes]].
 *
 * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
 * This is an "exact match" which uses [[StateService.is]].
 *
 * ### Parameter values
 * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
 * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
 *
 * #### Example:
 * ```html
 * <li ng-repeat="user in users" ui-sref-active="active">
 *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
 * </li>
 * ```
 *
 * ### Examples
 *
 * Given the following template:
 * #### Example:
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * When the app state is `app.user` (or any child state),
 * and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 *
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * ### Glob mode
 *
 * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
 * The objects keys represent active class names and values represent the respective state names/globs.
 * `ui-sref-active` will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * #### Example:
 * Given the following template, with "admin" being an abstract state:
 * ```html
 * <div ui-sref-active="{'active': 'admin.**'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * ```
 *
 * When the current state is "admin.roles" the "active" class will be applied to both the <div> and <a> elements.
 * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
 *
 * ### Notes:
 *
 * - The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
 */
var uiSrefActive;
uiSrefActive = ['$state', '$stateParams', '$interpolate', '$uiRouter',
    function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
        return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs',
                function ($scope, $element, $attrs) {
                    var states = [], activeEqClass, uiSrefActive;
                    // There probably isn't much point in $observing this
                    // uiSrefActive and uiSrefActiveEq share the same directive object with some
                    // slight difference in logic routing
                    activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
                    try {
                        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
                    }
                    catch (e) {
                        // Do nothing. uiSrefActive is not a valid expression.
                        // Fall back to using $interpolate below
                    }
                    uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
                    if (core.isObject(uiSrefActive)) {
                        core.forEach(uiSrefActive, function (stateOrName, activeClass) {
                            if (core.isString(stateOrName)) {
                                var ref = parseStateRef(stateOrName);
                                addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                            }
                        });
                    }
                    // Allow uiSref to communicate with uiSrefActive[Equals]
                    this.$$addStateInfo = function (newState, newParams) {
                        // we already got an explicit state provided by ui-sref-active, so we
                        // shadow the one that comes from ui-sref
                        if (core.isObject(uiSrefActive) && states.length > 0) {
                            return;
                        }
                        var deregister = addState(newState, newParams, uiSrefActive);
                        update();
                        return deregister;
                    };
                    function updateAfterTransition(trans) {
                        trans.promise.then(update, core.noop);
                    }
                    $scope.$on('$stateChangeSuccess', update);
                    $scope.$on('$destroy', $uiRouter.transitionService.onStart({}, updateAfterTransition));
                    if ($uiRouter.globals.transition) {
                        updateAfterTransition($uiRouter.globals.transition);
                    }
                    function addState(stateName, stateParams, activeClass) {
                        var state = $state.get(stateName, stateContext($element));
                        var stateInfo = {
                            state: state || { name: stateName },
                            params: stateParams,
                            activeClass: activeClass
                        };
                        states.push(stateInfo);
                        return function removeState() {
                            core.removeFrom(states)(stateInfo);
                        };
                    }
                    // Update route state
                    function update() {
                        var splitClasses = function (str) {
                            return str.split(/\s/).filter(core.identity);
                        };
                        var getClasses = function (stateList) {
                            return stateList.map(function (x) { return x.activeClass; }).map(splitClasses).reduce(core.unnestR, []);
                        };
                        var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
                        var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
                        var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
                        var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
                        var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
                        var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
                        $scope.$evalAsync(function () {
                            addClasses.forEach(function (className) { return $element.addClass(className); });
                            removeClasses.forEach(function (className) { return $element.removeClass(className); });
                        });
                    }
                    update();
                }]
        };
    }];
ng.module('ui.router.state')
    .directive('uiSref', uiSref)
    .directive('uiSrefActive', uiSrefActive)
    .directive('uiSrefActiveEq', uiSrefActive)
    .directive('uiState', uiState);

/** @module ng1 */ /** for typedoc */
/**
 * `isState` Filter: truthy if the current state is the parameter
 *
 * Translates to [[StateService.is]] `$state.is("stateName")`.
 *
 * #### Example:
 * ```html
 * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
 * ```
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
    var isFilter = function (state, params, options) {
        return $state.is(state, params, options);
    };
    isFilter.$stateful = true;
    return isFilter;
}
/**
 * `includedByState` Filter: truthy if the current state includes the parameter
 *
 * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
 *
 * #### Example:
 * ```html
 * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
 * ```
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
    var includesFilter = function (state, params, options) {
        return $state.includes(state, params, options);
    };
    includesFilter.$stateful = true;
    return includesFilter;
}
ng.module('ui.router.state')
    .filter('isState', $IsStateFilter)
    .filter('includedByState', $IncludedByStateFilter);

/**
 * @ng1api
 * @module directives
 */ /** for typedoc */
/**
 * `ui-view`: A viewport directive which is filled in by a view from the active state.
 *
 * ### Attributes
 *
 * - `name`: (Optional) A view name.
 *   The name should be unique amongst the other views in the same state.
 *   You can have views of the same name that live in different states.
 *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
 *
 * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
 *   Uses [[$uiViewScroll]] to do the scrolling.
 *
 * - `onload`: Expression to evaluate whenever the view updates.
 *
 * #### Example:
 * A view can be unnamed or named.
 * ```html
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 *
 * <!-- Named (different style) -->
 * <ui-view name="viewName"></ui-view>
 * ```
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 *
 * ```html
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * ```
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the
 * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
 *
 * ```js
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }
 * })
 * ```
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 *
 * ```html
 * <div ui-view="main"></div>
 * ```
 *
 * ```js
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }
 * })
 * ```
 *
 * Really though, you'll use views to set up multiple views:
 *
 * ```html
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * ```
 *
 * ```js
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }
 * })
 * ```
 *
 * #### Examples for `autoscroll`:
 * ```html
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * ```
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * #### Example:
 * ```js
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * ```
 */
var uiView;
uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q',
    function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
        function getRenderer(attrs, scope) {
            return {
                enter: function (element, target, cb) {
                    if (ng.version.minor > 2) {
                        $animate.enter(element, null, target).then(cb);
                    }
                    else {
                        $animate.enter(element, null, target, cb);
                    }
                },
                leave: function (element, cb) {
                    if (ng.version.minor > 2) {
                        $animate.leave(element).then(cb);
                    }
                    else {
                        $animate.leave(element, cb);
                    }
                }
            };
        }
        function configsEqual(config1, config2) {
            return config1 === config2;
        }
        var rootData = {
            $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
            $uiView: {}
        };
        var directive = {
            count: 0,
            restrict: 'ECA',
            terminal: true,
            priority: 400,
            transclude: 'element',
            compile: function (tElement, tAttrs, $transclude) {
                return function (scope, $element, attrs) {
                    var previousEl, currentEl, currentScope, unregister, onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(attrs, scope), viewConfig = undefined, inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
                    var activeUIView = {
                        $type: 'ng1',
                        id: directive.count++,
                        name: name,
                        fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
                        config: null,
                        configUpdated: configUpdatedCallback,
                        get creationContext() {
                            var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
                            // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
                            // See https://github.com/angular-ui/ui-router/issues/3355
                            var fromParentTag = core.parse('$uiView.creationContext')(inherited);
                            return fromParentTagConfig || fromParentTag;
                        }
                    };
                    core.trace.traceUIViewEvent("Linking", activeUIView);
                    function configUpdatedCallback(config) {
                        if (config && !(config instanceof Ng1ViewConfig))
                            return;
                        if (configsEqual(viewConfig, config))
                            return;
                        core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                        viewConfig = config;
                        updateView(config);
                    }
                    $element.data('$uiView', { $uiView: activeUIView });
                    updateView();
                    unregister = $view.registerUIView(activeUIView);
                    scope.$on("$destroy", function () {
                        core.trace.traceUIViewEvent("Destroying/Unregistering", activeUIView);
                        unregister();
                    });
                    function cleanupLastView() {
                        if (previousEl) {
                            core.trace.traceUIViewEvent("Removing (previous) el", previousEl.data('$uiView'));
                            previousEl.remove();
                            previousEl = null;
                        }
                        if (currentScope) {
                            core.trace.traceUIViewEvent("Destroying scope", activeUIView);
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentEl) {
                            var _viewData_1 = currentEl.data('$uiViewAnim');
                            core.trace.traceUIViewEvent("Animate out", _viewData_1);
                            renderer.leave(currentEl, function () {
                                _viewData_1.$$animLeave.resolve();
                                previousEl = null;
                            });
                            previousEl = currentEl;
                            currentEl = null;
                        }
                    }
                    function updateView(config) {
                        var newScope = scope.$new();
                        var animEnter = $q.defer(), animLeave = $q.defer();
                        var $uiViewData = {
                            $cfg: config,
                            $uiView: activeUIView,
                        };
                        var $uiViewAnim = {
                            $animEnter: animEnter.promise,
                            $animLeave: animLeave.promise,
                            $$animLeave: animLeave
                        };
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoading
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description
                         *
                         * Fired once the view **begins loading**, *before* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         * @param {string} viewName Name of the view.
                         */
                        newScope.$emit('$viewContentLoading', name);
                        var cloned = $transclude(newScope, function (clone) {
                            clone.data('$uiViewAnim', $uiViewAnim);
                            clone.data('$uiView', $uiViewData);
                            renderer.enter(clone, $element, function onUIViewEnter() {
                                animEnter.resolve();
                                if (currentScope)
                                    currentScope.$emit('$viewContentAnimationEnded');
                                if (core.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                                    $uiViewScroll(clone);
                                }
                            });
                            cleanupLastView();
                        });
                        currentEl = cloned;
                        currentScope = newScope;
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoaded
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description           *
                         * Fired once the view is **loaded**, *after* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         */
                        currentScope.$emit('$viewContentLoaded', config || viewConfig);
                        currentScope.$eval(onloadExp);
                    }
                };
            }
        };
        return directive;
    }];
$ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q', '$timeout'];
/** @hidden */
function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q, $timeout) {
    var getControllerAs = core.parse('viewDecl.controllerAs');
    var getResolveAs = core.parse('viewDecl.resolveAs');
    return {
        restrict: 'ECA',
        priority: -400,
        compile: function (tElement) {
            var initial = tElement.html();
            tElement.empty();
            return function (scope, $element) {
                var data = $element.data('$uiView');
                if (!data) {
                    $element.html(initial);
                    $compile($element.contents())(scope);
                    return;
                }
                var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
                var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
                $element.html(cfg.getTemplate($element, resolveCtx) || initial);
                core.trace.traceUIViewFill(data.$uiView, $element.html());
                var link = $compile($element.contents());
                var controller = cfg.controller;
                var controllerAs = getControllerAs(cfg);
                var resolveAs = getResolveAs(cfg);
                var locals = resolveCtx && getLocals(resolveCtx);
                scope[resolveAs] = locals;
                if (controller) {
                    var controllerInstance = $controller(controller, core.extend({}, locals, { $scope: scope, $element: $element }));
                    if (controllerAs) {
                        scope[controllerAs] = controllerInstance;
                        scope[controllerAs][resolveAs] = locals;
                    }
                    // TODO: Use $view service as a central point for registering component-level hooks
                    // Then, when a component is created, tell the $view service, so it can invoke hooks
                    // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
                    // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
                    $element.data('$ngControllerController', controllerInstance);
                    $element.children().data('$ngControllerController', controllerInstance);
                    registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
                }
                // Wait for the component to appear in the DOM
                if (core.isString(cfg.viewDecl.component)) {
                    var cmp_1 = cfg.viewDecl.component;
                    var kebobName = core.kebobString(cmp_1);
                    var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", "i");
                    var getComponentController = function () {
                        var directiveEl = [].slice.call($element[0].children)
                            .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
                        return directiveEl && ng.element(directiveEl).data("$" + cmp_1 + "Controller");
                    };
                    var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
                        if (!ctrlInstance)
                            return;
                        registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
                        deregisterWatch_1();
                    });
                }
                link(scope);
            };
        }
    };
}
/** @hidden */
var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
/** @hidden incrementing id */
var _uiCanExitId = 0;
/** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
    // Call $onInit() ASAP
    if (core.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl)) {
        controllerInstance.$onInit();
    }
    var viewState = core.tail(cfg.path).state.self;
    var hookOptions = { bind: controllerInstance };
    // Add component-level hook for onParamsChange
    if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
        var resolveContext = new core.ResolveContext(cfg.path);
        var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
        // Fire callback on any successful transition
        var paramsUpdated = function ($transition$) {
            // Exit early if the $transition$ is the same as the view was created within.
            // Exit early if the $transition$ will exit the state the view is for.
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
                return;
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            var toSchema = $transition$.treeChanges().to.map(function (node) { return node.paramSchema; }).reduce(core.unnestR, []);
            var fromSchema = $transition$.treeChanges().from.map(function (node) { return node.paramSchema; }).reduce(core.unnestR, []);
            // Find the to params that have different values than the from params
            var changedToParams = toSchema.filter(function (param) {
                var idx = fromSchema.indexOf(param);
                return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            // Only trigger callback if a to param has changed or is new
            if (changedToParams.length) {
                var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
                // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
                var newValues = core.filter(toParams, function (val$$1, key) { return changedKeys_1.indexOf(key) !== -1; });
                controllerInstance.uiOnParamsChanged(newValues, $transition$);
            }
        };
        $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
    }
    // Add component-level hook for uiCanExit
    if (core.isFunction(controllerInstance.uiCanExit)) {
        var id_1 = _uiCanExitId++;
        var cacheProp_1 = '_uiCanExitIds';
        // Returns true if a redirect transition already answered truthy
        var prevTruthyAnswer_1 = function (trans) {
            return !!trans && (trans[cacheProp_1] && trans[cacheProp_1][id_1] === true || prevTruthyAnswer_1(trans.redirectedFrom()));
        };
        // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
        var wrappedHook = function (trans) {
            var promise, ids = trans[cacheProp_1] = trans[cacheProp_1] || {};
            if (!prevTruthyAnswer_1(trans)) {
                promise = $q.when(controllerInstance.uiCanExit(trans));
                promise.then(function (val$$1) { return ids[id_1] = (val$$1 !== false); });
            }
            return promise;
        };
        var criteria = { exiting: viewState.name };
        $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
    }
}
ng.module('ui.router.state').directive('uiView', uiView);
ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

/** @module ng1 */ /** */
/** @hidden */
function $ViewScrollProvider() {
    var useAnchorScroll = false;
    this.useAnchorScroll = function () {
        useAnchorScroll = true;
    };
    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
            if (useAnchorScroll) {
                return $anchorScroll;
            }
            return function ($element) {
                return $timeout(function () {
                    $element[0].scrollIntoView();
                }, 0, false);
            };
        }];
}
ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

/**
 * Main entry point for angular 1.x build
 * @module ng1
 */ /** */
var index = "ui.router";

exports['default'] = index;
exports.core = core;
exports.watchDigests = watchDigests;
exports.getLocals = getLocals;
exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
exports.ng1ViewsBuilder = ng1ViewsBuilder;
exports.Ng1ViewConfig = Ng1ViewConfig;
exports.StateProvider = StateProvider;
exports.UrlRouterProvider = UrlRouterProvider;
Object.keys(core).forEach(function (key) { exports[key] = core[key]; });

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Random utility functions used in the UI-Router code
 *
 * These functions are exported, but are subject to change without notice.
 *
 * @preferred
 * @module common
 */
/** for typedoc */
var predicates_1 = __webpack_require__(4);
var hof_1 = __webpack_require__(5);
var coreservices_1 = __webpack_require__(7);
exports.root = (typeof self === 'object' && self.self === self && self) ||
    (typeof global === 'object' && global.global === global && global) || this;
var angular = exports.root.angular || {};
exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
exports.forEach = angular.forEach || _forEach;
exports.extend = Object.assign || _extend;
exports.equals = angular.equals || _equals;
function identity(x) { return x; }
exports.identity = identity;
function noop() { }
exports.noop = noop;
/**
 * Builds proxy functions on the `to` object which pass through to the `from` object.
 *
 * For each key in `fnNames`, creates a proxy function on the `to` object.
 * The proxy function calls the real function on the `from` object.
 *
 *
 * #### Example:
 * This example creates an new class instance whose functions are prebound to the new'd object.
 * ```js
 * class Foo {
 *   constructor(data) {
 *     // Binds all functions from Foo.prototype to 'this',
 *     // then copies them to 'this'
 *     bindFunctions(Foo.prototype, this, this);
 *     this.data = data;
 *   }
 *
 *   log() {
 *     console.log(this.data);
 *   }
 * }
 *
 * let myFoo = new Foo([1,2,3]);
 * var logit = myFoo.log;
 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
 * ```
 *
 * #### Example:
 * This example creates a bound version of a service function, and copies it to another object
 * ```
 *
 * var SomeService = {
 *   this.data = [3, 4, 5];
 *   this.log = function() {
 *     console.log(this.data);
 *   }
 * }
 *
 * // Constructor fn
 * function OtherThing() {
 *   // Binds all functions from SomeService to SomeService,
 *   // then copies them to 'this'
 *   bindFunctions(SomeService, this, SomeService);
 * }
 *
 * let myOtherThing = new OtherThing();
 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
 * ```
 *
 * @param source A function that returns the source object which contains the original functions to be bound
 * @param target A function that returns the target object which will receive the bound functions
 * @param bind A function that returns the object which the functions will be bound to
 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
 */
function createProxyFunctions(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) { latebind = false; }
    var bindFunction = function (fnName) {
        return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function (fnName) { return function lateRebindFunction() {
        target[fnName] = bindFunction(fnName);
        return target[fnName].apply(null, arguments);
    }; };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function (acc, name) {
        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
        return acc;
    }, target);
}
exports.createProxyFunctions = createProxyFunctions;
/**
 * prototypal inheritance helper.
 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
 */
exports.inherit = function (parent, extra) {
    return exports.extend(Object.create(parent), extra);
};
/** Given an array, returns true if the object is found in the array, (using indexOf) */
exports.inArray = hof_1.curry(_inArray);
function _inArray(array, obj) {
    return array.indexOf(obj) !== -1;
}
exports._inArray = _inArray;
/**
 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
 * The same array is returned
 */
exports.removeFrom = hof_1.curry(_removeFrom);
function _removeFrom(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0)
        array.splice(idx, 1);
    return array;
}
exports._removeFrom = _removeFrom;
/** pushes a values to an array and returns the value */
exports.pushTo = hof_1.curry(_pushTo);
function _pushTo(arr, val) {
    return (arr.push(val), val);
}
exports._pushTo = _pushTo;
/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
exports.deregAll = function (functions) {
    return functions.slice().forEach(function (fn) {
        typeof fn === 'function' && fn();
        exports.removeFrom(functions, fn);
    });
};
/**
 * Applies a set of defaults to an options object.  The options object is filtered
 * to only those properties of the objects in the defaultsList.
 * Earlier objects in the defaultsList take precedence when applying defaults.
 */
function defaults(opts) {
    var defaultsList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        defaultsList[_i - 1] = arguments[_i];
    }
    var _defaultsList = defaultsList.concat({}).reverse();
    var defaultVals = exports.extend.apply(null, _defaultsList);
    return exports.extend({}, defaultVals, pick(opts || {}, Object.keys(defaultVals)));
}
exports.defaults = defaults;
/** Reduce function that merges each element of the list into a single object, using extend */
exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
    var path = [];
    for (var n in first.path) {
        if (first.path[n] !== second.path[n])
            break;
        path.push(first.path[n]);
    }
    return path;
}
exports.ancestors = ancestors;
/**
 * Return a copy of the object only containing the whitelisted properties.
 *
 * #### Example:
 * ```
 * var foo = { a: 1, b: 2, c: 3 };
 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
 * ```
 * @param obj the source object
 * @param propNames an Array of strings, which are the whitelisted property names
 */
function pick(obj, propNames) {
    var objCopy = {};
    for (var prop_1 in obj) {
        if (propNames.indexOf(prop_1) !== -1) {
            objCopy[prop_1] = obj[prop_1];
        }
    }
    return objCopy;
}
exports.pick = pick;
/**
 * Return a copy of the object omitting the blacklisted properties.
 *
 * @example
 * ```
 *
 * var foo = { a: 1, b: 2, c: 3 };
 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
 * ```
 * @param obj the source object
 * @param propNames an Array of strings, which are the blacklisted property names
 */
function omit(obj, propNames) {
    return Object.keys(obj)
        .filter(hof_1.not(exports.inArray(propNames)))
        .reduce(function (acc, key) { return (acc[key] = obj[key], acc); }, {});
}
exports.omit = omit;
/**
 * Maps an array, or object to a property (by name)
 */
function pluck(collection, propName) {
    return map(collection, hof_1.prop(propName));
}
exports.pluck = pluck;
/** Filters an Array or an Object's properties based on a predicate */
function filter(collection, callback) {
    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return result[key] = x; };
    exports.forEach(collection, function (item, i) {
        if (callback(item, i))
            accept(item, i);
    });
    return result;
}
exports.filter = filter;
/** Finds an object from an array, or a property of an object, that matches a predicate */
function find(collection, callback) {
    var result;
    exports.forEach(collection, function (item, i) {
        if (result)
            return;
        if (callback(item, i))
            result = item;
    });
    return result;
}
exports.find = find;
/** Given an object, returns a new object, where each property is transformed by the callback function */
exports.mapObj = map;
/** Maps an array or object properties using a callback function */
function map(collection, callback) {
    var result = predicates_1.isArray(collection) ? [] : {};
    exports.forEach(collection, function (item, i) { return result[i] = callback(item, i); });
    return result;
}
exports.map = map;
/**
 * Given an object, return its enumerable property values
 *
 * @example
 * ```
 *
 * let foo = { a: 1, b: 2, c: 3 }
 * let vals = values(foo); // [ 1, 2, 3 ]
 * ```
 */
exports.values = function (obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
};
/**
 * Reduce function that returns true if all of the values are truthy.
 *
 * @example
 * ```
 *
 * let vals = [ 1, true, {}, "hello world"];
 * vals.reduce(allTrueR, true); // true
 *
 * vals.push(0);
 * vals.reduce(allTrueR, true); // false
 * ```
 */
exports.allTrueR = function (memo, elem) { return memo && elem; };
/**
 * Reduce function that returns true if any of the values are truthy.
 *
 *  * @example
 * ```
 *
 * let vals = [ 0, null, undefined ];
 * vals.reduce(anyTrueR, true); // false
 *
 * vals.push("hello world");
 * vals.reduce(anyTrueR, true); // true
 * ```
 */
exports.anyTrueR = function (memo, elem) { return memo || elem; };
/**
 * Reduce function which un-nests a single level of arrays
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnestR = function (memo, elem) { return memo.concat(elem); };
/**
 * Reduce function which recursively un-nests all arrays
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flattenR = function (memo, elem) {
    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
};
/**
 * Reduce function that pushes an object to an array, then returns the array.
 * Mostly just for [[flattenR]] and [[uniqR]]
 */
function pushR(arr, obj) {
    arr.push(obj);
    return arr;
}
exports.pushR = pushR;
/** Reduce function that filters out duplicates */
exports.uniqR = function (acc, token) {
    return exports.inArray(acc, token) ? acc : pushR(acc, token);
};
/**
 * Return a new array with a single level of arrays unnested.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
/**
 * Return a completely flattened version of an array.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
/**
 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
 * @example
 * ```
 *
 * let isNumber = (obj) => typeof(obj) === 'number';
 * let allNumbers = [ 1, 2, 3, 4, 5 ];
 * allNumbers.filter(assertPredicate(isNumber)); //OK
 *
 * let oneString = [ 1, 2, 3, 4, "5" ];
 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
 * ```
 */
exports.assertPredicate = assertFn;
/**
 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
 * @example
 * ```
 *
 * var data = { foo: 1, bar: 2 };
 *
 * let keys = [ 'foo', 'bar' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // values is [1, 2]
 *
 * let keys = [ 'foo', 'bar', 'baz' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // throws Error("Key not found")
 * ```
 */
exports.assertMap = assertFn;
function assertFn(predicateOrMap, errMsg) {
    if (errMsg === void 0) { errMsg = "assert failure"; }
    return function (obj) {
        var result = predicateOrMap(obj);
        if (!result) {
            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
        }
        return result;
    };
}
exports.assertFn = assertFn;
/**
 * Like _.pairs: Given an object, returns an array of key/value pairs
 *
 * @example
 * ```
 *
 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
 * ```
 */
exports.pairs = function (obj) {
    return Object.keys(obj).map(function (key) { return [key, obj[key]]; });
};
/**
 * Given two or more parallel arrays, returns an array of tuples where
 * each tuple is composed of [ a[i], b[i], ... z[i] ]
 *
 * @example
 * ```
 *
 * let foo = [ 0, 2, 4, 6 ];
 * let bar = [ 1, 3, 5, 7 ];
 * let baz = [ 10, 30, 50, 70 ];
 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
 * ```
 */
function arrayTuples() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 0)
        return [];
    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
    var i, result = [];
    for (i = 0; i < maxArrayLen; i++) {
        // This is a hot function
        // Unroll when there are 1-4 arguments
        switch (args.length) {
            case 1:
                result.push([args[0][i]]);
                break;
            case 2:
                result.push([args[0][i], args[1][i]]);
                break;
            case 3:
                result.push([args[0][i], args[1][i], args[2][i]]);
                break;
            case 4:
                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
                break;
            default:
                result.push(args.map(function (array) { return array[i]; }));
                break;
        }
    }
    return result;
}
exports.arrayTuples = arrayTuples;
/**
 * Reduce function which builds an object from an array of [key, value] pairs.
 *
 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
 *
 * Each keyValueTuple should be an array with values [ key: string, value: any ]
 *
 * @example
 * ```
 *
 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
 *
 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 *
 * // Or, more simply:
 * var pairsToObj = pairs.reduce(applyPairs, {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 * ```
 */
function applyPairs(memo, keyValTuple) {
    var key, value;
    if (predicates_1.isArray(keyValTuple))
        key = keyValTuple[0], value = keyValTuple[1];
    if (!predicates_1.isString(key))
        throw new Error("invalid parameters to applyPairs");
    memo[key] = value;
    return memo;
}
exports.applyPairs = applyPairs;
/** Get the last element of an array */
function tail(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
}
exports.tail = tail;
/**
 * shallow copy from src to dest
 */
function copy(src, dest) {
    if (dest)
        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
    if (!dest)
        dest = {};
    return exports.extend(dest, src);
}
exports.copy = copy;
/** Naive forEach implementation works with Objects or Arrays */
function _forEach(obj, cb, _this) {
    if (predicates_1.isArray(obj))
        return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
}
function _extend(toObj) {
    for (var i = 1; i < arguments.length; i++) {
        var obj = arguments[i];
        if (!obj)
            continue;
        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; j++) {
            toObj[keys[j]] = obj[keys[j]];
        }
    }
    return toObj;
}
exports._extend = _extend;
function _equals(o1, o2) {
    if (o1 === o2)
        return true;
    if (o1 === null || o2 === null)
        return false;
    if (o1 !== o1 && o2 !== o2)
        return true; // NaN === NaN
    var t1 = typeof o1, t2 = typeof o2;
    if (t1 !== t2 || t1 !== 'object')
        return false;
    var tup = [o1, o2];
    if (hof_1.all(predicates_1.isArray)(tup))
        return _arraysEq(o1, o2);
    if (hof_1.all(predicates_1.isDate)(tup))
        return o1.getTime() === o2.getTime();
    if (hof_1.all(predicates_1.isRegExp)(tup))
        return o1.toString() === o2.toString();
    if (hof_1.all(predicates_1.isFunction)(tup))
        return true; // meh
    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
        return false;
    var key, keys = {};
    for (key in o1) {
        if (!_equals(o1[key], o2[key]))
            return false;
        keys[key] = true;
    }
    for (key in o2) {
        if (!keys[key])
            return false;
    }
    return true;
}
function _arraysEq(a1, a2) {
    if (a1.length !== a2.length)
        return false;
    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
}
// issue #2676
exports.silenceUncaughtInPromise = function (promise) {
    return promise.catch(function (e) { return 0; }) && promise;
};
exports.silentRejection = function (error) {
    return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
};
//# sourceMappingURL=common.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** Predicates
 *
 * These predicates return true/false based on the input.
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_predicates
 */
/** */
var hof_1 = __webpack_require__(5);
var stateObject_1 = __webpack_require__(26);
var toStr = Object.prototype.toString;
var tis = function (t) { return function (x) { return typeof (x) === t; }; };
exports.isUndefined = tis('undefined');
exports.isDefined = hof_1.not(exports.isUndefined);
exports.isNull = function (o) { return o === null; };
exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
exports.isFunction = tis('function');
exports.isNumber = tis('number');
exports.isString = tis('string');
exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
exports.isArray = Array.isArray;
exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
exports.isState = stateObject_1.StateObject.isState;
/**
 * Predicate which checks if a value is injectable
 *
 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
 * where all the elements in the array are Strings, except the last one, which is a Function
 */
function isInjectable(val) {
    if (exports.isArray(val) && val.length) {
        var head = val.slice(0, -1), tail = val.slice(-1);
        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
    }
    return exports.isFunction(val);
}
exports.isInjectable = isInjectable;
/**
 * Predicate which checks if a value looks like a Promise
 *
 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
 */
exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
//# sourceMappingURL=predicates.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Higher order functions
 *
 * These utility functions are exported, but are subject to change without notice.
 *
 * @module common_hof
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
 *
 * Given a function with N parameters, returns a new function that supports partial application.
 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
 * accept more parameters until all N parameters have been supplied.
 *
 *
 * This contrived example uses a partially applied function as an predicate, which returns true
 * if an object is found in both arrays.
 * @example
 * ```
 * // returns true if an object is in both of the two arrays
 * function inBoth(array1, array2, object) {
 *   return array1.indexOf(object) !== -1 &&
 *          array2.indexOf(object) !== 1;
 * }
 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
 * let foos = [obj1, obj3]
 * let bars = [obj3, obj4, obj5]
 *
 * // A curried "copy" of inBoth
 * let curriedInBoth = curry(inBoth);
 * // Partially apply both the array1 and array2
 * let inFoosAndBars = curriedInBoth(foos, bars);
 *
 * // Supply the final argument; since all arguments are
 * // supplied, the original inBoth function is then called.
 * let obj1InBoth = inFoosAndBars(obj1); // false
 *
 * // Use the inFoosAndBars as a predicate.
 * // Filter, on each iteration, supplies the final argument
 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
 *
 * ```
 *
 * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
 *
 * @param fn
 * @returns {*|function(): (*|any)}
 */
function curry(fn) {
    var initial_args = [].slice.apply(arguments, [1]);
    var func_args_length = fn.length;
    function curried(args) {
        if (args.length >= func_args_length)
            return fn.apply(null, args);
        return function () {
            return curried(args.concat([].slice.apply(arguments)));
        };
    }
    return curried(initial_args);
}
exports.curry = curry;
/**
 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
 * given: f(x), g(x), h(x)
 * let composed = compose(f,g,h)
 * then, composed is: f(g(h(x)))
 */
function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function () {
        var i = start, result = args[start].apply(this, arguments);
        while (i--)
            result = args[i].call(this, result);
        return result;
    };
}
exports.compose = compose;
/**
 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
 * given: f(x), g(x), h(x)
 * let piped = pipe(f,g,h);
 * then, piped is: h(g(f(x)))
 */
function pipe() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return compose.apply(null, [].slice.call(arguments).reverse());
}
exports.pipe = pipe;
/**
 * Given a property name, returns a function that returns that property from an object
 * let obj = { foo: 1, name: "blarg" };
 * let getName = prop("name");
 * getName(obj) === "blarg"
 */
exports.prop = function (name) {
    return function (obj) { return obj && obj[name]; };
};
/**
 * Given a property name and a value, returns a function that returns a boolean based on whether
 * the passed object has a property that matches the value
 * let obj = { foo: 1, name: "blarg" };
 * let getName = propEq("name", "blarg");
 * getName(obj) === true
 */
exports.propEq = curry(function (name, val, obj) { return obj && obj[name] === val; });
/**
 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
 * let getName = prop("nestedObj.name");
 * getName(obj) === "blarg"
 * let propNotFound = prop("this.property.doesnt.exist");
 * propNotFound(obj) === undefined
 */
exports.parse = function (name) {
    return pipe.apply(null, name.split(".").map(exports.prop));
};
/**
 * Given a function that returns a truthy or falsey value, returns a
 * function that returns the opposite (falsey or truthy) value given the same inputs
 */
exports.not = function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return !fn.apply(null, args);
    };
};
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if both functions return truthy for the given arguments
 */
function and(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) && fn2.apply(null, args);
    };
}
exports.and = and;
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if at least one of the functions returns truthy for the given arguments
 */
function or(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) || fn2.apply(null, args);
    };
}
exports.or = or;
/**
 * Check if all the elements of an array match a predicate function
 *
 * @param fn1 a predicate function `fn1`
 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
 */
exports.all = function (fn1) {
    return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); };
};
exports.any = function (fn1) {
    return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); };
};
/** Given a class, returns a Predicate function that returns true if the object is of that class */
exports.is = function (ctor) {
    return function (obj) {
        return (obj != null && obj.constructor === ctor || obj instanceof ctor);
    };
};
/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
exports.eq = function (val) { return function (other) {
    return val === other;
}; };
/** Given a value, returns a function which returns the value */
exports.val = function (v) { return function () { return v; }; };
function invoke(fnName, args) {
    return function (obj) {
        return obj[fnName].apply(obj, args);
    };
}
exports.invoke = invoke;
/**
 * Sorta like Pattern Matching (a functional programming conditional construct)
 *
 * See http://c2.com/cgi/wiki?PatternMatching
 *
 * This is a conditional construct which allows a series of predicates and output functions
 * to be checked and then applied.  Each predicate receives the input.  If the predicate
 * returns truthy, then its matching output function (mapping function) is provided with
 * the input and, then the result is returned.
 *
 * Each combination (2-tuple) of predicate + output function should be placed in an array
 * of size 2: [ predicate, mapFn ]
 *
 * These 2-tuples should be put in an outer array.
 *
 * @example
 * ```
 *
 * // Here's a 2-tuple where the first element is the isString predicate
 * // and the second element is a function that returns a description of the input
 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
 *
 * // Second tuple: predicate "isNumber", mapfn returns a description
 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
 *
 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
 *
 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
 *
 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
 *
 * console.log(descriptionOf(undefined)); // 'notdefined'
 * console.log(descriptionOf(55)); // '(55) That's a number!'
 * console.log(descriptionOf("foo")); // 'Here's your string foo'
 * ```
 *
 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
 * with a Predicate and a mapping/output function
 * @returns {function(any): *}
 */
function pattern(struct) {
    return function (x) {
        for (var i = 0; i < struct.length; i++) {
            if (struct[i][0](x))
                return struct[i][1](x);
        }
    };
}
exports.pattern = pattern;
//# sourceMappingURL=hof.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var gettext = function gettext(s) {
  return s;
};
exports.default = gettext;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.notImplemented = function (fnname) { return function () {
    throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
}; };
var services = {
    $q: undefined,
    $injector: undefined,
};
exports.services = services;
//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module common */ /** for typedoc */
__export(__webpack_require__(3));
__export(__webpack_require__(7));
__export(__webpack_require__(17));
__export(__webpack_require__(5));
__export(__webpack_require__(4));
__export(__webpack_require__(27));
__export(__webpack_require__(9));
__export(__webpack_require__(10));
//# sourceMappingURL=index.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Functions that manipulate strings
 *
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_strings
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var predicates_1 = __webpack_require__(4);
var rejectFactory_1 = __webpack_require__(14);
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var transition_1 = __webpack_require__(18);
var resolvable_1 = __webpack_require__(16);
/**
 * Returns a string shortened to a maximum length
 *
 * If the string is already less than the `max` length, return the string.
 * Else return the string, shortened to `max - 3` and append three dots ("...").
 *
 * @param max the maximum length of the string to return
 * @param str the input string
 */
function maxLength(max, str) {
    if (str.length <= max)
        return str;
    return str.substr(0, max - 3) + "...";
}
exports.maxLength = maxLength;
/**
 * Returns a string, with spaces added to the end, up to a desired str length
 *
 * If the string is already longer than the desired length, return the string.
 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
 *
 * @param length the desired length of the string to return
 * @param str the input string
 */
function padString(length, str) {
    while (str.length < length)
        str += " ";
    return str;
}
exports.padString = padString;
function kebobString(camelCase) {
    return camelCase
        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
        .replace(/([A-Z])/g, function ($1) { return "-" + $1.toLowerCase(); }); // replace rest
}
exports.kebobString = kebobString;
function _toJson(obj) {
    return JSON.stringify(obj);
}
function _fromJson(json) {
    return predicates_1.isString(json) ? JSON.parse(json) : json;
}
function promiseToString(p) {
    return "Promise(" + JSON.stringify(p) + ")";
}
function functionToString(fn) {
    var fnStr = fnToString(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn['name'] || "";
    if (fnName && toStr.match(/function \(/)) {
        return 'function ' + fnName + toStr.substr(9);
    }
    return toStr;
}
exports.functionToString = functionToString;
function fnToString(fn) {
    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || "undefined";
}
exports.fnToString = fnToString;
var stringifyPatternFn = null;
var stringifyPattern = function (value) {
    var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
    stringifyPatternFn = stringifyPatternFn || hof_1.pattern([
        [hof_1.not(predicates_1.isDefined), hof_1.val("undefined")],
        [predicates_1.isNull, hof_1.val("null")],
        [predicates_1.isPromise, hof_1.val("[Promise]")],
        [isRejection, function (x) { return x._transitionRejection.toString(); }],
        [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke("toString")],
        [hof_1.is(transition_1.Transition), hof_1.invoke("toString")],
        [hof_1.is(resolvable_1.Resolvable), hof_1.invoke("toString")],
        [predicates_1.isInjectable, functionToString],
        [hof_1.val(true), common_1.identity]
    ]);
    return stringifyPatternFn(value);
};
function stringify(o) {
    var seen = [];
    function format(val) {
        if (predicates_1.isObject(val)) {
            if (seen.indexOf(val) !== -1)
                return '[circular ref]';
            seen.push(val);
        }
        return stringifyPattern(val);
    }
    return JSON.stringify(o, function (key, val) { return format(val); }).replace(/\\"/g, '"');
}
exports.stringify = stringify;
/** Returns a function that splits a string on a character or substring */
exports.beforeAfterSubstr = function (char) { return function (str) {
    if (!str)
        return ["", ""];
    var idx = str.indexOf(char);
    if (idx === -1)
        return [str, ""];
    return [str.substr(0, idx), str.substr(idx + 1)];
}; };
exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
exports.stripFile = function (str) { return str.replace(/\/[^/]*$/, ''); };
exports.splitHash = exports.beforeAfterSubstr("#");
exports.splitQuery = exports.beforeAfterSubstr("?");
exports.splitEqual = exports.beforeAfterSubstr("=");
exports.trimHashVal = function (str) { return str ? str.replace(/^#/, "") : ""; };
/**
 * Splits on a delimiter, but returns the delimiters in the array
 *
 * #### Example:
 * ```js
 * var splitOnSlashes = splitOnDelim('/');
 * splitOnSlashes("/foo"); // ["/", "foo"]
 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
 * ```
 */
function splitOnDelim(delim) {
    var re = new RegExp("(" + delim + ")", "g");
    return function (str) {
        return str.split(re).filter(common_1.identity);
    };
}
exports.splitOnDelim = splitOnDelim;
;
/**
 * Reduce fn that joins neighboring strings
 *
 * Given an array of strings, returns a new array
 * where all neighboring strings have been joined.
 *
 * #### Example:
 * ```js
 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
 * ```
 */
function joinNeighborsR(acc, x) {
    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
    return common_1.pushR(acc, x);
}
exports.joinNeighborsR = joinNeighborsR;
;
//# sourceMappingURL=strings.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Transition tracing (debug)
 *
 * Enable transition tracing to print transition information to the console,
 * in order to help debug your application.
 * Tracing logs detailed information about each Transition to your console.
 *
 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
 *
 * ### ES6
 * ```js
 * import {trace} from "ui-router-ng2"; // or "angular-ui-router"
 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
 * ```
 *
 * ### CJS
 * ```js
 * let trace = require("angular-ui-router").trace; // or "ui-router-ng2"
 * trace.enable("TRANSITION", "VIEWCONFIG");
 * ```
 *
 * ### Globals
 * ```js
 * let trace = window["angular-ui-router"].trace; // or "ui-router-ng2"
 * trace.enable(); // Trace everything (very verbose)
 * ```
 *
 * ### Angular 1:
 * ```js
 * app.run($trace => $trace.enable());
 * ```
 *
 * @coreapi
 * @module trace
 */ /** for typedoc */
var hof_1 = __webpack_require__(5);
var predicates_1 = __webpack_require__(4);
var strings_1 = __webpack_require__(9);
/** @hidden */
function uiViewString(uiview) {
    if (!uiview)
        return 'ui-view (defunct)';
    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
}
/** @hidden */
var viewConfigString = function (viewConfig) {
    var view = viewConfig.viewDecl;
    var state = view.$context.name || '(root)';
    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
};
/** @hidden */
function normalizedCat(input) {
    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
}
/** @hidden */
var consoleLog = Function.prototype.bind.call(console.log, console);
/** @hidden */
var consoletable = predicates_1.isFunction(console.table) ? console.table.bind(console) : consoleLog.bind(console);
/**
 * Trace categories Enum
 *
 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
 *
 * `trace.enable(Category.TRANSITION)`
 *
 * These can also be provided using a matching string, or position ordinal
 *
 * `trace.enable("TRANSITION")`
 *
 * `trace.enable(1)`
 */
var Category;
(function (Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
})(Category = exports.Category || (exports.Category = {}));
/** @hidden */ var _tid = hof_1.parse("$id");
/** @hidden */ var _rid = hof_1.parse("router.$id");
/** @hidden */ var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
/**
 * Prints UI-Router Transition trace information to the console.
 */
var Trace = /** @class */ (function () {
    /** @hidden */
    function Trace() {
        /** @hidden */
        this._enabled = {};
        this.approximateDigests = 0;
    }
    /** @hidden */
    Trace.prototype._set = function (enabled, categories) {
        var _this = this;
        if (!categories.length) {
            categories = Object.keys(Category)
                .map(function (k) { return parseInt(k, 10); })
                .filter(function (k) { return !isNaN(k); })
                .map(function (key) { return Category[key]; });
        }
        categories.map(normalizedCat).forEach(function (category) { return _this._enabled[category] = enabled; });
    };
    Trace.prototype.enable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(true, categories);
    };
    Trace.prototype.disable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(false, categories);
    };
    /**
     * Retrieves the enabled stateus of a [[Category]]
     *
     * ```js
     * trace.enabled("VIEWCONFIG"); // true or false
     * ```
     *
     * @returns boolean true if the category is enabled
     */
    Trace.prototype.enabled = function (category) {
        return !!this._enabled[normalizedCat(category)];
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionStart = function (trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionIgnored = function (trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookInvocation = function (step, trans, options) {
        if (!this.enabled(Category.HOOK))
            return;
        var event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.functionToString(step.registeredHook.callback);
        console.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
        if (!this.enabled(Category.HOOK))
            return;
        console.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvePath = function (path, when, trans) {
        if (!this.enabled(Category.RESOLVE))
            return;
        console.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
        if (!this.enabled(Category.RESOLVE))
            return;
        console.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceError = function (reason, trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceSuccess = function (finalState, trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
        if (extra === void 0) { extra = ""; }
        if (!this.enabled(Category.UIVIEW))
            return;
        console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
        if (!this.enabled(Category.UIVIEW))
            return;
        this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewFill = function (viewData, html) {
        if (!this.enabled(Category.UIVIEW))
            return;
        this.traceUIViewEvent("Fill", viewData, " with: " + strings_1.maxLength(200, html));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewSync = function (pairs) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        var mapping = pairs.map(function (_a) {
            var uiViewData = _a[0], config = _a[1];
            var uiView = uiViewData.$type + ":" + uiViewData.fqn;
            var view = config && config.viewDecl.$context.name + ": " + config.viewDecl.$name + " (" + config.viewDecl.$type + ")";
            return { 'ui-view fqn': uiView, 'state: view name': view };
        }).sort(function (a, b) { return a['ui-view fqn'].localeCompare(b['ui-view fqn']); });
        consoletable(mapping);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
    };
    return Trace;
}());
exports.Trace = Trace;
/**
 * The [[Trace]] singleton
 *
 * #### Example:
 * ```js
 * import {trace} from "angular-ui-router";
 * trace.enable(1, 5);
 * ```
 */
var trace = new Trace();
exports.trace = trace;
//# sourceMappingURL=trace.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TransitionHookPhase;
(function (TransitionHookPhase) {
    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
})(TransitionHookPhase = exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
var TransitionHookScope;
(function (TransitionHookScope) {
    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
})(TransitionHookScope = exports.TransitionHookScope || (exports.TransitionHookScope = {}));
//# sourceMappingURL=interface.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module state
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var predicates_1 = __webpack_require__(4);
var strings_1 = __webpack_require__(9);
var common_1 = __webpack_require__(8);
/**
 * Encapsulate the target (destination) state/params/options of a [[Transition]].
 *
 * This class is frequently used to redirect a transition to a new destination.
 *
 * See:
 *
 * - [[HookResult]]
 * - [[TransitionHookFn]]
 * - [[TransitionService.onStart]]
 *
 * To create a `TargetState`, use [[StateService.target]].
 *
 * ---
 *
 * This class wraps:
 *
 * 1) an identifier for a state
 * 2) a set of parameters
 * 3) and transition options
 * 4) the registered state object (the [[StateDeclaration]])
 *
 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
 * The `TargetState` class normalizes those options.
 *
 * A `TargetState` may be valid (the state being targeted exists in the registry)
 * or invalid (the state being targeted is not registered).
 */
var TargetState = /** @class */ (function () {
    /**
     * The TargetState constructor
     *
     * Note: Do not construct a `TargetState` manually.
     * To create a `TargetState`, use the [[StateService.target]] factory method.
     *
     * @param _stateRegistry The StateRegistry to use to look up the _definition
     * @param _identifier An identifier for a state.
     *    Either a fully-qualified state name, or the object used to define the state.
     * @param _params Parameters for the target state
     * @param _options Transition options.
     *
     * @internalapi
     */
    function TargetState(_stateRegistry, _identifier, _params, _options) {
        this._stateRegistry = _stateRegistry;
        this._identifier = _identifier;
        this._identifier = _identifier;
        this._params = common_1.extend({}, _params || {});
        this._options = common_1.extend({}, _options || {});
        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
    }
    /** The name of the state this object targets */
    TargetState.prototype.name = function () {
        return this._definition && this._definition.name || this._identifier;
    };
    /** The identifier used when creating this TargetState */
    TargetState.prototype.identifier = function () {
        return this._identifier;
    };
    /** The target parameter values */
    TargetState.prototype.params = function () {
        return this._params;
    };
    /** The internal state object (if it was found) */
    TargetState.prototype.$state = function () {
        return this._definition;
    };
    /** The internal state declaration (if it was found) */
    TargetState.prototype.state = function () {
        return this._definition && this._definition.self;
    };
    /** The target options */
    TargetState.prototype.options = function () {
        return this._options;
    };
    /** True if the target state was found */
    TargetState.prototype.exists = function () {
        return !!(this._definition && this._definition.self);
    };
    /** True if the object is valid */
    TargetState.prototype.valid = function () {
        return !this.error();
    };
    /** If the object is invalid, returns the reason why */
    TargetState.prototype.error = function () {
        var base = this.options().relative;
        if (!this._definition && !!base) {
            var stateName = base.name ? base.name : base;
            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
        }
        if (!this._definition)
            return "No such state '" + this.name() + "'";
        if (!this._definition.self)
            return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function () {
        return "'" + this.name() + "'" + strings_1.stringify(this.params());
    };
    /**
     * Returns a copy of this TargetState which targets a different state.
     * The new TargetState has the same parameter values and transition options.
     *
     * @param state The new state that should be targeted
     */
    TargetState.prototype.withState = function (state) {
        return new TargetState(this._stateRegistry, state, this._params, this._options);
    };
    /**
     * Returns a copy of this TargetState, using the specified parameter values.
     *
     * @param params the new parameter values to use
     * @param replace When false (default) the new parameter values will be merged with the current values.
     *                When true the parameter values will be used instead of the current values.
     */
    TargetState.prototype.withParams = function (params, replace) {
        if (replace === void 0) { replace = false; }
        var newParams = replace ? params : common_1.extend({}, this._params, params);
        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
    };
    /**
     * Returns a copy of this TargetState, using the specified Transition Options.
     *
     * @param options the new options to use
     * @param replace When false (default) the new options will be merged with the current options.
     *                When true the options will be used instead of the current options.
     */
    TargetState.prototype.withOptions = function (options, replace) {
        if (replace === void 0) { replace = false; }
        var newOpts = replace ? options : common_1.extend({}, this._options, options);
        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
    };
    /** Returns true if the object has a state property that might be a state or state name */
    TargetState.isDef = function (obj) {
        return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name));
    };
    return TargetState;
}());
exports.TargetState = TargetState;
//# sourceMappingURL=targetState.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */ /** for typedoc */
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var predicates_1 = __webpack_require__(4);
var coreservices_1 = __webpack_require__(7);
var paramType_1 = __webpack_require__(30);
/** @hidden */ var hasOwn = Object.prototype.hasOwnProperty;
/** @hidden */ var isShorthand = function (cfg) {
    return ["value", "type", "squash", "array", "dynamic"].filter(hasOwn.bind(cfg || {})).length === 0;
};
/** @internalapi */
var DefType;
(function (DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
})(DefType = exports.DefType || (exports.DefType = {}));
/** @hidden */
function unwrapShorthand(cfg) {
    cfg = isShorthand(cfg) && { value: cfg } || cfg;
    getStaticDefaultValue['__cacheable'] = true;
    function getStaticDefaultValue() {
        return cfg.value;
    }
    return common_1.extend(cfg, {
        $$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue,
    });
}
/** @hidden */
function getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== 'string')
        throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
        return paramTypes.type(cfg.type);
    if (urlType)
        return urlType;
    if (!cfg.type) {
        var type = location === DefType.CONFIG ? "any" :
            location === DefType.PATH ? "path" :
                location === DefType.SEARCH ? "query" : "string";
        return paramTypes.type(type);
    }
    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
}
/**
 * @internalapi
 * returns false, true, or the squash value to indicate the "default parameter url squash policy".
 */
function getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false)
        return false;
    if (!predicates_1.isDefined(squash) || squash == null)
        return defaultPolicy;
    if (squash === true || predicates_1.isString(squash))
        return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
}
/** @internalapi */
function getReplace(config, arrayMode, isOptional, squash) {
    var replace, configuredKeys, defaultPolicy = [
        { from: "", to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") },
    ];
    replace = predicates_1.isArray(config.replace) ? config.replace : [];
    if (predicates_1.isString(squash))
        replace.push({ from: squash, to: undefined });
    configuredKeys = common_1.map(replace, hof_1.prop("from"));
    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
}
/** @internalapi */
var Param = /** @class */ (function () {
    function Param(id, type, config, location, urlMatcherFactory) {
        config = unwrapShorthand(config);
        type = getType(config, type, location, id, urlMatcherFactory.paramTypes);
        var arrayMode = getArrayMode();
        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
        var isOptional = config.value !== undefined || location === DefType.SEARCH;
        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
        var squash = getSquashPolicy(config, isOptional, urlMatcherFactory.defaultSquashPolicy());
        var replace = getReplace(config, arrayMode, isOptional, squash);
        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
        function getArrayMode() {
            var arrayDefaults = { array: (location === DefType.SEARCH ? "auto" : false) };
            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
        }
        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
    }
    Param.prototype.isDefaultValue = function (value) {
        return this.isOptional && this.type.equals(this.value(), value);
    };
    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    Param.prototype.value = function (value) {
        var _this = this;
        /**
         * [Internal] Get the default value of a parameter, which may be an injectable function.
         */
        var getDefaultValue = function () {
            if (_this._defaultValueCache)
                return _this._defaultValueCache.defaultValue;
            if (!coreservices_1.services.$injector)
                throw new Error("Injectable functions cannot be called at configuration time");
            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
            if (_this.config.$$fn['__cacheable']) {
                _this._defaultValueCache = { defaultValue: defaultValue };
            }
            return defaultValue;
        };
        var replaceSpecialValues = function (val) {
            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
                var tuple = _a[_i];
                if (tuple.from === val)
                    return tuple.to;
            }
            return val;
        };
        value = replaceSpecialValues(value);
        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function () {
        return this.location === DefType.SEARCH;
    };
    Param.prototype.validates = function (value) {
        // There was no parameter value, but the param is optional
        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
            return true;
        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
        var normalized = this.type.$normalize(value);
        if (!this.type.is(normalized))
            return false;
        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
        var encoded = this.type.encode(normalized);
        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function () {
        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    Param.values = function (params, values) {
        if (values === void 0) { values = {}; }
        var paramValues = {};
        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
            var param = params_1[_i];
            paramValues[param.id] = param.value(values[param.id]);
        }
        return paramValues;
    };
    /**
     * Finds [[Param]] objects which have different param values
     *
     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
     *
     * @param params: The list of Param objects to filter
     * @param values1: The first set of parameter values
     * @param values2: the second set of parameter values
     *
     * @returns any Param objects whose values were different between values1 and values2
     */
    Param.changed = function (params, values1, values2) {
        if (values1 === void 0) { values1 = {}; }
        if (values2 === void 0) { values2 = {}; }
        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
    };
    /**
     * Checks if two param value objects are equal (for a set of [[Param]] objects)
     *
     * @param params The list of [[Param]] objects to check
     * @param values1 The first set of param values
     * @param values2 The second set of param values
     *
     * @returns true if the param values in values1 and values2 are equal
     */
    Param.equals = function (params, values1, values2) {
        if (values1 === void 0) { values1 = {}; }
        if (values2 === void 0) { values2 = {}; }
        return Param.changed(params, values1, values2).length === 0;
    };
    /** Returns true if a the parameter values are valid, according to the Param definitions */
    Param.validates = function (params, values) {
        if (values === void 0) { values = {}; }
        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
    };
    return Param;
}());
exports.Param = Param;
//# sourceMappingURL=param.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(3);
var strings_1 = __webpack_require__(9);
var hof_1 = __webpack_require__(5);
var RejectType;
(function (RejectType) {
    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    RejectType[RejectType["INVALID"] = 4] = "INVALID";
    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    RejectType[RejectType["ERROR"] = 6] = "ERROR";
})(RejectType = exports.RejectType || (exports.RejectType = {}));
/** @hidden */ var id = 0;
var Rejection = /** @class */ (function () {
    function Rejection(type, message, detail) {
        this.$id = id++;
        this.type = type;
        this.message = message;
        this.detail = detail;
    }
    Rejection.prototype.toString = function () {
        var detailString = function (d) {
            return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
        };
        var detail = detailString(this.detail);
        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function () {
        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
    };
    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
    Rejection.isRejectionPromise = function (obj) {
        return obj && (typeof obj.then === 'function') && hof_1.is(Rejection)(obj._transitionRejection);
    };
    /** Returns a Rejection due to transition superseded */
    Rejection.superseded = function (detail, options) {
        var message = "The transition has been superseded by a different transition";
        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
        if (options && options.redirected) {
            rejection.redirected = true;
        }
        return rejection;
    };
    /** Returns a Rejection due to redirected transition */
    Rejection.redirected = function (detail) {
        return Rejection.superseded(detail, { redirected: true });
    };
    /** Returns a Rejection due to invalid transition */
    Rejection.invalid = function (detail) {
        var message = "This transition is invalid";
        return new Rejection(RejectType.INVALID, message, detail);
    };
    /** Returns a Rejection due to ignored transition */
    Rejection.ignored = function (detail) {
        var message = "The transition was ignored";
        return new Rejection(RejectType.IGNORED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */
    Rejection.aborted = function (detail) {
        var message = "The transition has been aborted";
        return new Rejection(RejectType.ABORTED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */
    Rejection.errored = function (detail) {
        var message = "The transition errored";
        return new Rejection(RejectType.ERROR, message, detail);
    };
    /**
     * Returns a Rejection
     *
     * Normalizes a value as a Rejection.
     * If the value is already a Rejection, returns it.
     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
     *
     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
     */
    Rejection.normalize = function (detail) {
        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
    };
    return Rejection;
}());
exports.Rejection = Rejection;
//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */
/** for typedoc */
var interface_1 = __webpack_require__(11);
var common_1 = __webpack_require__(3);
var strings_1 = __webpack_require__(9);
var predicates_1 = __webpack_require__(4);
var hof_1 = __webpack_require__(5);
var trace_1 = __webpack_require__(10);
var coreservices_1 = __webpack_require__(7);
var rejectFactory_1 = __webpack_require__(14);
var targetState_1 = __webpack_require__(12);
var defaultOptions = {
    current: common_1.noop,
    transition: null,
    traceData: {},
    bind: null,
};
/** @hidden */
var TransitionHook = /** @class */ (function () {
    function TransitionHook(transition, stateContext, registeredHook, options) {
        var _this = this;
        this.transition = transition;
        this.stateContext = stateContext;
        this.registeredHook = registeredHook;
        this.options = options;
        this.isSuperseded = function () {
            return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive();
        };
        this.options = common_1.defaults(options, defaultOptions);
        this.type = registeredHook.eventType;
    }
    TransitionHook.prototype.logError = function (err) {
        this.transition.router.stateService.defaultErrorHandler()(err);
    };
    TransitionHook.prototype.invokeHook = function () {
        var _this = this;
        var hook = this.registeredHook;
        if (hook._deregistered)
            return;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent)
            return notCurrent;
        var options = this.options;
        trace_1.trace.traceHookInvocation(this, this.transition, options);
        var invokeCallback = function () {
            return hook.callback.call(options.bind, _this.transition, _this.stateContext);
        };
        var normalizeErr = function (err) {
            return rejectFactory_1.Rejection.normalize(err).toPromise();
        };
        var handleError = function (err) {
            return hook.eventType.getErrorHandler(_this)(err);
        };
        var handleResult = function (result) {
            return hook.eventType.getResultHandler(_this)(result);
        };
        try {
            var result = invokeCallback();
            if (!this.type.synchronous && predicates_1.isPromise(result)) {
                return result.catch(normalizeErr)
                    .then(handleResult, handleError);
            }
            else {
                return handleResult(result);
            }
        }
        catch (err) {
            // If callback throws (synchronously)
            return handleError(rejectFactory_1.Rejection.normalize(err));
        }
        finally {
            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
                hook.deregister();
            }
        }
    };
    /**
     * This method handles the return value of a Transition Hook.
     *
     * A hook can return false (cancel), a TargetState (redirect),
     * or a promise (which may later resolve to false or a redirect)
     *
     * This also handles "transition superseded" -- when a new transition
     * was started while the hook was still running
     */
    TransitionHook.prototype.handleHookResult = function (result) {
        var _this = this;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent)
            return notCurrent;
        // Hook returned a promise
        if (predicates_1.isPromise(result)) {
            // Wait for the promise, then reprocess with the resulting value
            return result.then(function (val) { return _this.handleHookResult(val); });
        }
        trace_1.trace.traceHookResult(result, this.transition, this.options);
        // Hook returned false
        if (result === false) {
            // Abort this Transition
            return rejectFactory_1.Rejection.aborted("Hook aborted transition").toPromise();
        }
        var isTargetState = hof_1.is(targetState_1.TargetState);
        // hook returned a TargetState
        if (isTargetState(result)) {
            // Halt the current Transition and redirect (a new Transition) to the TargetState.
            return rejectFactory_1.Rejection.redirected(result).toPromise();
        }
    };
    /**
     * Return a Rejection promise if the transition is no longer current due
     * to a stopped router (disposed), or a new transition has started and superseded this one.
     */
    TransitionHook.prototype.getNotCurrentRejection = function () {
        var router = this.transition.router;
        // The router is stopped
        if (router._disposed) {
            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
        }
        if (this.transition._aborted) {
            return rejectFactory_1.Rejection.aborted().toPromise();
        }
        // This transition is no longer current.
        // Another transition started while this hook was still running.
        if (this.isSuperseded()) {
            // Abort this transition
            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
        }
    };
    TransitionHook.prototype.toString = function () {
        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
        var event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.fnToString(registeredHook.callback);
        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
    };
    /**
     * Chains together an array of TransitionHooks.
     *
     * Given a list of [[TransitionHook]] objects, chains them together.
     * Each hook is invoked after the previous one completes.
     *
     * #### Example:
     * ```js
     * var hooks: TransitionHook[] = getHooks();
     * let promise: Promise<any> = TransitionHook.chain(hooks);
     *
     * promise.then(handleSuccess, handleError);
     * ```
     *
     * @param hooks the list of hooks to chain together
     * @param waitFor if provided, the chain is `.then()`'ed off this promise
     * @returns a `Promise` for sequentially invoking the hooks (in order)
     */
    TransitionHook.chain = function (hooks, waitFor) {
        // Chain the next hook off the previous
        var createHookChainR = function (prev, nextHook) {
            return prev.then(function () { return nextHook.invokeHook(); });
        };
        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
    };
    /**
     * Invokes all the provided TransitionHooks, in order.
     * Each hook's return value is checked.
     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
     * If no hook returns a promise, then all hooks are processed synchronously.
     *
     * @param hooks the list of TransitionHooks to invoke
     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
     *
     * @returns a promise for the async result, or the result of the callback
     */
    TransitionHook.invokeHooks = function (hooks, doneCallback) {
        for (var idx = 0; idx < hooks.length; idx++) {
            var hookResult = hooks[idx].invokeHook();
            if (predicates_1.isPromise(hookResult)) {
                var remainingHooks = hooks.slice(idx + 1);
                return TransitionHook.chain(remainingHooks, hookResult)
                    .then(doneCallback);
            }
        }
        return doneCallback();
    };
    /**
     * Run all TransitionHooks, ignoring their return value.
     */
    TransitionHook.runAllHooks = function (hooks) {
        hooks.forEach(function (hook) { return hook.invokeHook(); });
    };
    /**
     * These GetResultHandler(s) are used by [[invokeHook]] below
     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
     */
    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
        return hook.handleHookResult(result);
    }; };
    /**
     * If the result is a promise rejection, log it.
     * Otherwise, ignore the result.
     */
    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
        predicates_1.isPromise(result) && result.catch(function (err) {
            return hook.logError(rejectFactory_1.Rejection.normalize(err));
        });
        return undefined;
    }; };
    /**
     * These GetErrorHandler(s) are used by [[invokeHook]] below
     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
     */
    TransitionHook.LOG_ERROR = function (hook) { return function (error) {
        return hook.logError(error);
    }; };
    TransitionHook.REJECT_ERROR = function (hook) { return function (error) {
        return common_1.silentRejection(error);
    }; };
    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
        throw error;
    }; };
    return TransitionHook;
}());
exports.TransitionHook = TransitionHook;
//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module resolve
 */ /** for typedoc */
var common_1 = __webpack_require__(3);
var coreservices_1 = __webpack_require__(7);
var trace_1 = __webpack_require__(10);
var strings_1 = __webpack_require__(9);
var predicates_1 = __webpack_require__(4);
var common_2 = __webpack_require__(8);
// TODO: explicitly make this user configurable
exports.defaultResolvePolicy = {
    when: "LAZY",
    async: "WAIT"
};
/**
 * The basic building block for the resolve system.
 *
 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
 * and the unwrapped-when-complete (.data) result of the resolveFn.
 *
 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
 * resolveFn) and returns the resulting promise.
 *
 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
 * parameter to those fns.
 */
var Resolvable = /** @class */ (function () {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
        this.resolved = false;
        this.promise = undefined;
        if (arg1 instanceof Resolvable) {
            common_1.extend(this, arg1);
        }
        else if (predicates_1.isFunction(resolveFn)) {
            if (common_2.isNullOrUndefined(arg1))
                throw new Error("new Resolvable(): token argument is required");
            if (!predicates_1.isFunction(resolveFn))
                throw new Error("new Resolvable(): resolveFn argument must be a function");
            this.token = arg1;
            this.policy = policy;
            this.resolveFn = resolveFn;
            this.deps = deps || [];
            this.data = data;
            this.resolved = data !== undefined;
            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
        }
        else if (predicates_1.isObject(arg1) && arg1.token && predicates_1.isFunction(arg1.resolveFn)) {
            var literal = arg1;
            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
        }
    }
    Resolvable.prototype.getPolicy = function (state) {
        var thisPolicy = this.policy || {};
        var statePolicy = state && state.resolvePolicy || {};
        return {
            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
        };
    };
    /**
     * Asynchronously resolve this Resolvable's data
     *
     * Given a ResolveContext that this Resolvable is found in:
     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
     * and update the Resolvable's state
     */
    Resolvable.prototype.resolve = function (resolveContext, trans) {
        var _this = this;
        var $q = coreservices_1.services.$q;
        // Gets all dependencies from ResolveContext and wait for them to be resolved
        var getResolvableDependencies = function () {
            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) {
                return resolvable.get(resolveContext, trans);
            }));
        };
        // Invokes the resolve function passing the resolved dependencies as arguments
        var invokeResolveFn = function (resolvedDeps) {
            return _this.resolveFn.apply(null, resolvedDeps);
        };
        /**
         * For RXWAIT policy:
         *
         * Given an observable returned from a resolve function:
         * - enables .cache() mode (this allows multicast subscribers)
         * - then calls toPromise() (this triggers subscribe() and thus fetches)
         * - Waits for the promise, then return the cached observable (not the first emitted value).
         */
        var waitForRx = function (observable$) {
            var cached = observable$.cache(1);
            return cached.take(1).toPromise().then(function () { return cached; });
        };
        // If the resolve policy is RXWAIT, wait for the observable to emit something. otherwise pass through.
        var node = resolveContext.findNode(this);
        var state = node && node.state;
        var maybeWaitForRx = this.getPolicy(state).async === "RXWAIT" ? waitForRx : common_1.identity;
        // After the final value has been resolved, update the state of the Resolvable
        var applyResolvedValue = function (resolvedValue) {
            _this.data = resolvedValue;
            _this.resolved = true;
            trace_1.trace.traceResolvableResolved(_this, trans);
            return _this.data;
        };
        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
        return this.promise = $q.when()
            .then(getResolvableDependencies)
            .then(invokeResolveFn)
            .then(maybeWaitForRx)
            .then(applyResolvedValue);
    };
    /**
     * Gets a promise for this Resolvable's data.
     *
     * Fetches the data and returns a promise.
     * Returns the existing promise if it has already been fetched once.
     */
    Resolvable.prototype.get = function (resolveContext, trans) {
        return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function () {
        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
    };
    Resolvable.prototype.clone = function () {
        return new Resolvable(this);
    };
    Resolvable.fromData = function (token, data) {
        return new Resolvable(token, function () { return data; }, null, null, data);
    };
    return Resolvable;
}());
exports.Resolvable = Resolvable;
//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module core
 */
/**
 * Matches state names using glob-like pattern strings.
 *
 * Globs can be used in specific APIs including:
 *
 * - [[StateService.is]]
 * - [[StateService.includes]]
 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
 *
 * A `Glob` string is a pattern which matches state names.
 * Nested state names are split into segments (separated by a dot) when processing.
 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
 *
 * Globs work according to the following rules:
 *
 * ### Exact match:
 *
 * The glob `'A.B'` matches the state named exactly `'A.B'`.
 *
 * | Glob        |Matches states named|Does not match state named|
 * |:------------|:--------------------|:---------------------|
 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
 *
 * ### Single star (`*`)
 *
 * A single star (`*`) is a wildcard that matches exactly one segment.
 *
 * | Glob        |Matches states named  |Does not match state named |
 * |:------------|:---------------------|:--------------------------|
 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
 *
 * ### Double star (`**`)
 *
 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
 *
 * | Glob        |Matches states named                           |Does not match state named         |
 * |:------------|:----------------------------------------------|:----------------------------------|
 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
 *
 */
var Glob = /** @class */ (function () {
    function Glob(text) {
        this.text = text;
        this.glob = text.split('.');
        var regexpString = this.text.split('.')
            .map(function (seg) {
            if (seg === '**')
                return '(?:|(?:\\.[^.]*)*)';
            if (seg === '*')
                return '\\.[^.]*';
            return '\\.' + seg;
        }).join('');
        this.regexp = new RegExp("^" + regexpString + "$");
    }
    Glob.prototype.matches = function (name) {
        return this.regexp.test('.' + name);
    };
    /** Returns true if the string has glob-like characters in it */
    Glob.is = function (text) {
        return !!/[!,*]+/.exec(text);
    };
    /** Returns a glob from the string, or null if the string isn't Glob-like */
    Glob.fromString = function (text) {
        return Glob.is(text) ? new Glob(text) : null;
    };
    return Glob;
}());
exports.Glob = Glob;
//# sourceMappingURL=glob.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */
/** for typedoc */
var trace_1 = __webpack_require__(10);
var coreservices_1 = __webpack_require__(7);
var strings_1 = __webpack_require__(9);
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var hof_1 = __webpack_require__(5);
var interface_1 = __webpack_require__(11); // has or is using
var transitionHook_1 = __webpack_require__(15);
var hookRegistry_1 = __webpack_require__(28);
var hookBuilder_1 = __webpack_require__(36);
var pathFactory_1 = __webpack_require__(19);
var param_1 = __webpack_require__(13);
var resolvable_1 = __webpack_require__(16);
var resolveContext_1 = __webpack_require__(20);
/** @hidden */
var stateSelf = hof_1.prop("self");
/**
 * Represents a transition between two states.
 *
 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
 *
 * This object contains all contextual information about the to/from states, parameters, resolves.
 * It has information about all states being entered and exited as a result of the transition.
 */
var Transition = /** @class */ (function () {
    /**
     * Creates a new Transition object.
     *
     * If the target state is not valid, an error is thrown.
     *
     * @internalapi
     *
     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
     *        encapsulates the "from state".
     * @param targetState The target state and parameters being transitioned to (also, the transition options)
     * @param router The [[UIRouter]] instance
     */
    function Transition(fromPath, targetState, router) {
        var _this = this;
        /** @hidden */
        this._deferred = coreservices_1.services.$q.defer();
        /**
         * This promise is resolved or rejected based on the outcome of the Transition.
         *
         * When the transition is successful, the promise is resolved
         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
         */
        this.promise = this._deferred.promise;
        /** @hidden Holds the hook registration functions such as those passed to Transition.onStart() */
        this._registeredHooks = {};
        /** @hidden */
        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
        /** Checks if this transition is currently active/running. */
        this.isActive = function () {
            return _this.router.globals.transition === _this;
        };
        this.router = router;
        this._targetState = targetState;
        if (!targetState.valid()) {
            throw new Error(targetState.error());
        }
        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
        this.$id = router.transitionService._transitionCount++;
        var toPath = pathFactory_1.PathUtils.buildToPath(fromPath, targetState);
        this._treeChanges = pathFactory_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
        this.createTransitionHookRegFns();
        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
        this.applyViewConfigs(router);
    }
    /** @hidden */
    Transition.prototype.onBefore = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onStart = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onExit = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onRetain = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onEnter = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onFinish = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onSuccess = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onError = function (criteria, callback, options) { return; };
    /** @hidden
     * Creates the transition-level hook registration functions
     * (which can then be used to register hooks)
     */
    Transition.prototype.createTransitionHookRegFns = function () {
        var _this = this;
        this.router.transitionService._pluginapi._getEvents()
            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
    };
    /** @internalapi */
    Transition.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    Transition.prototype.applyViewConfigs = function (router) {
        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
        pathFactory_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
    };
    /**
     * @internalapi
     *
     * @returns the internal from [State] object
     */
    Transition.prototype.$from = function () {
        return common_1.tail(this._treeChanges.from).state;
    };
    /**
     * @internalapi
     *
     * @returns the internal to [State] object
     */
    Transition.prototype.$to = function () {
        return common_1.tail(this._treeChanges.to).state;
    };
    /**
     * Returns the "from state"
     *
     * Returns the state that the transition is coming *from*.
     *
     * @returns The state declaration object for the Transition's ("from state").
     */
    Transition.prototype.from = function () {
        return this.$from().self;
    };
    /**
     * Returns the "to state"
     *
     * Returns the state that the transition is going *to*.
     *
     * @returns The state declaration object for the Transition's target state ("to state").
     */
    Transition.prototype.to = function () {
        return this.$to().self;
    };
    /**
     * Gets the Target State
     *
     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
     *
     * @returns the [[TargetState]] of this Transition
     */
    Transition.prototype.targetState = function () {
        return this._targetState;
    };
    /**
     * Determines whether two transitions are equivalent.
     * @deprecated
     */
    Transition.prototype.is = function (compare) {
        if (compare instanceof Transition) {
            // TODO: Also compare parameters
            return this.is({ to: compare.$to().name, from: compare.$from().name });
        }
        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to)) ||
            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from)));
    };
    Transition.prototype.params = function (pathname) {
        if (pathname === void 0) { pathname = "to"; }
        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    /**
     * Creates a [[UIInjector]] Dependency Injector
     *
     * Returns a Dependency Injector for the Transition's target state (to state).
     * The injector provides resolve values which the target state has access to.
     *
     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
     *
     * #### Example:
     * ```js
     * .onEnter({ entering: 'myState' }, trans => {
     *   var myResolveValue = trans.injector().get('myResolve');
     *   // Inject a global service from the global/native injector (if it exists)
     *   var MyService = trans.injector().get('MyService');
     * })
     * ```
     *
     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
     * You can use [[UIInjector.getAsync]] to get a promise for the data.
     * #### Example:
     * ```js
     * .onBefore({}, trans => {
     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
     *     return myResolveValue !== 'ABORT';
     *   });
     * });
     * ```
     *
     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
     * #### Example:
     * ```js
     * .onEnter({ to: 'foo.bar' }, trans => {
     *   // returns result of `foo` state's `data` resolve
     *   // even though `foo.bar` also has a `data` resolve
     *   var fooData = trans.injector('foo').get('data');
     * });
     * ```
     *
     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
     * The resolve data from the `from` path will be returned.
     * #### Example:
     * ```js
     * .onExit({ exiting: 'foo.bar' }, trans => {
     *   // Gets the resolve value of `data` from the exiting state.
     *   var fooData = trans.injector(null, 'foo.bar').get('data');
     * });
     * ```
     *
     *
     * @param state Limits the resolves provided to only the resolves the provided state has access to.
     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
     *
     * @returns a [[UIInjector]]
     */
    Transition.prototype.injector = function (state, pathName) {
        if (pathName === void 0) { pathName = "to"; }
        var path = this._treeChanges[pathName];
        if (state)
            path = pathFactory_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
        return new resolveContext_1.ResolveContext(path).injector();
    };
    /**
     * Gets all available resolve tokens (keys)
     *
     * This method can be used in conjunction with [[injector]] to inspect the resolve values
     * available to the Transition.
     *
     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
     * in the Transition's [[TreeChanges.to]] path.
     *
     * #### Example:
     * This example logs all resolve values
     * ```js
     * let tokens = trans.getResolveTokens();
     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
     * ```
     *
     * #### Example:
     * This example creates promises for each resolve value.
     * This triggers fetches of resolves (if any have not yet been fetched).
     * When all promises have all settled, it logs the resolve values.
     * ```js
     * let tokens = trans.getResolveTokens();
     * let promise = tokens.map(token => trans.injector().getAsync(token));
     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
     * ```
     *
     * Note: Angular 1 users whould use `$q.all()`
     *
     * @param pathname resolve context's path name (e.g., `to` or `from`)
     *
     * @returns an array of resolve tokens (keys)
     */
    Transition.prototype.getResolveTokens = function (pathname) {
        if (pathname === void 0) { pathname = "to"; }
        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
    };
    /**
     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
     *
     * #### Example:
     * ```js
     * transitionService.onBefore({}, transition => {
     *   transition.addResolvable({
     *     token: 'myResolve',
     *     deps: ['MyService'],
     *     resolveFn: myService => myService.getData()
     *   });
     * });
     * ```
     *
     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
     */
    Transition.prototype.addResolvable = function (resolvable, state) {
        if (state === void 0) { state = ""; }
        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
        var stateName = (typeof state === "string") ? state : state.name;
        var topath = this._treeChanges.to;
        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
        var resolveContext = new resolveContext_1.ResolveContext(topath);
        resolveContext.addResolvables([resolvable], targetNode.state);
    };
    /**
     * Gets the transition from which this transition was redirected.
     *
     * If the current transition is a redirect, this method returns the transition that was redirected.
     *
     * #### Example:
     * ```js
     * let transitionA = $state.go('A').transition
     * transitionA.onStart({}, () => $state.target('B'));
     * $transitions.onSuccess({ to: 'B' }, (trans) => {
     *   trans.to().name === 'B'; // true
     *   trans.redirectedFrom() === transitionA; // true
     * });
     * ```
     *
     * @returns The previous Transition, or null if this Transition is not the result of a redirection
     */
    Transition.prototype.redirectedFrom = function () {
        return this._options.redirectedFrom || null;
    };
    /**
     * Gets the original transition in a redirect chain
     *
     * A transition might belong to a long chain of multiple redirects.
     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
     *
     * #### Example:
     * ```js
     * // states
     * registry.register({ name: 'A', redirectTo: 'B' });
     * registry.register({ name: 'B', redirectTo: 'C' });
     * registry.register({ name: 'C', redirectTo: 'D' });
     * registry.register({ name: 'D' });
     *
     * let transitionA = $state.go('A').transition
     *
     * $transitions.onSuccess({ to: 'D' }, (trans) => {
     *   trans.to().name === 'D'; // true
     *   trans.redirectedFrom().to().name === 'C'; // true
     *   trans.originalTransition() === transitionA; // true
     *   trans.originalTransition().to().name === 'A'; // true
     * });
     * ```
     *
     * @returns The original Transition that started a redirect chain
     */
    Transition.prototype.originalTransition = function () {
        var rf = this.redirectedFrom();
        return (rf && rf.originalTransition()) || this;
    };
    /**
     * Get the transition options
     *
     * @returns the options for this Transition.
     */
    Transition.prototype.options = function () {
        return this._options;
    };
    /**
     * Gets the states being entered.
     *
     * @returns an array of states that will be entered during this transition.
     */
    Transition.prototype.entering = function () {
        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Gets the states being exited.
     *
     * @returns an array of states that will be exited during this transition.
     */
    Transition.prototype.exiting = function () {
        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
    };
    /**
     * Gets the states being retained.
     *
     * @returns an array of states that are already entered from a previous Transition, that will not be
     *    exited during this Transition
     */
    Transition.prototype.retained = function () {
        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Get the [[ViewConfig]]s associated with this Transition
     *
     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
     *
     * @param pathname the name of the path to fetch views for:
     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
     *
     * @returns a list of ViewConfig objects for the given path.
     */
    Transition.prototype.views = function (pathname, state) {
        if (pathname === void 0) { pathname = "entering"; }
        var path = this._treeChanges[pathname];
        path = !state ? path : path.filter(hof_1.propEq('state', state));
        return path.map(hof_1.prop("views")).filter(common_1.identity).reduce(common_1.unnestR, []);
    };
    Transition.prototype.treeChanges = function (pathname) {
        return pathname ? this._treeChanges[pathname] : this._treeChanges;
    };
    /**
     * Creates a new transition that is a redirection of the current one.
     *
     * This transition can be returned from a [[TransitionService]] hook to
     * redirect a transition to a new state and/or set of parameters.
     *
     * @internalapi
     *
     * @returns Returns a new [[Transition]] instance.
     */
    Transition.prototype.redirect = function (targetState) {
        var redirects = 1, trans = this;
        while ((trans = trans.redirectedFrom()) != null) {
            if (++redirects > 20)
                throw new Error("Too many consecutive Transition redirects (20+)");
        }
        var redirectOpts = { redirectedFrom: this, source: "redirect" };
        // If the original transition was caused by URL sync, then use { location: 'replace' }
        // on the new transition (unless the target state explicitly specifies location: false).
        // This causes the original url to be replaced with the url for the redirect target
        // so the original url disappears from the browser history.
        if (this.options().source === 'url' && targetState.options().location !== false) {
            redirectOpts.location = 'replace';
        }
        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
        targetState = targetState.withOptions(newOptions, true);
        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
        var originalEnteringNodes = this._treeChanges.entering;
        var redirectEnteringNodes = newTransition._treeChanges.entering;
        // --- Re-use resolve data from original transition ---
        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
        // (because of the redirect), the resolves fetched by the original transition are still valid in the
        // redirected transition.
        //
        // This allows you to define a redirect on a parent state which depends on an async resolve value.
        // You can wait for the resolve, then redirect to a child state based on the result.
        // The redirected transition does not have to re-fetch the resolve.
        // ---------------------------------------------------------
        var nodeIsReloading = function (reloadState) { return function (node) {
            return reloadState && node.state.includes[reloadState.name];
        }; };
        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
        var matchingEnteringNodes = pathFactory_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathFactory_1.PathUtils.nonDynamicParams)
            .filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
        matchingEnteringNodes.forEach(function (node, idx) {
            node.resolvables = originalEnteringNodes[idx].resolvables;
        });
        return newTransition;
    };
    /** @hidden If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
    Transition.prototype._changedParams = function () {
        var tc = this._treeChanges;
        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
        // If user explicitly wants a reload
        if (this._options.reload)
            return undefined;
        // If any states are exiting or entering
        if (tc.exiting.length || tc.entering.length)
            return undefined;
        // If to/from path lengths differ
        if (tc.to.length !== tc.from.length)
            return undefined;
        // If the to/from paths are different
        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
            .reduce(common_1.anyTrueR, false);
        if (pathsDiffer)
            return undefined;
        // Find any parameter values that differ
        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
        return tuples.map(function (_a) {
            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
            return param_1.Param.changed(schema, toVals, fromVals);
        }).reduce(common_1.unnestR, []);
    };
    /**
     * Returns true if the transition is dynamic.
     *
     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
     *
     * @returns true if the Transition is dynamic
     */
    Transition.prototype.dynamic = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
    };
    /**
     * Returns true if the transition is ignored.
     *
     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
     *
     * @returns true if the Transition is ignored.
     */
    Transition.prototype.ignored = function () {
        return !!this._ignoredReason();
    };
    /** @hidden */
    Transition.prototype._ignoredReason = function () {
        var pending = this.router.globals.transition;
        var reloadState = this._options.reloadState;
        var same = function (pathA, pathB) {
            if (pathA.length !== pathB.length)
                return false;
            var matching = pathFactory_1.PathUtils.matching(pathA, pathB);
            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
        };
        var newTC = this.treeChanges();
        var pendTC = pending && pending.treeChanges();
        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
            return "SameAsPending";
        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
            return "SameAsCurrent";
    };
    /**
     * Runs the transition
     *
     * This method is generally called from the [[StateService.transitionTo]]
     *
     * @internalapi
     *
     * @returns a promise for a successful transition.
     */
    Transition.prototype.run = function () {
        var _this = this;
        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
        // Gets transition hooks array for the given phase
        var getHooksFor = function (phase) {
            return _this._hookBuilder.buildHooksForPhase(phase);
        };
        // When the chain is complete, then resolve or reject the deferred
        var transitionSuccess = function () {
            trace_1.trace.traceSuccess(_this.$to(), _this);
            _this.success = true;
            _this._deferred.resolve(_this.to());
            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
        };
        var transitionError = function (reason) {
            trace_1.trace.traceError(reason, _this);
            _this.success = false;
            _this._deferred.reject(reason);
            _this._error = reason;
            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
        };
        var runTransition = function () {
            // Wait to build the RUN hook chain until the BEFORE hooks are done
            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
            var done = function () { return coreservices_1.services.$q.when(undefined); };
            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
        };
        var startTransition = function () {
            var globals = _this.router.globals;
            globals.lastStartedTransitionId = _this.$id;
            globals.transition = _this;
            globals.transitionHistory.enqueue(_this);
            trace_1.trace.traceTransitionStart(_this);
            return coreservices_1.services.$q.when(undefined);
        };
        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
            .then(runTransition)
            .then(transitionSuccess, transitionError);
        return this.promise;
    };
    /**
     * Checks if the Transition is valid
     *
     * @returns true if the Transition is valid
     */
    Transition.prototype.valid = function () {
        return !this.error() || this.success !== undefined;
    };
    /**
     * Aborts this transition
     *
     * Imperative API to abort a Transition.
     * This only applies to Transitions that are not yet complete.
     */
    Transition.prototype.abort = function () {
        // Do not set flag if the transition is already complete
        if (predicates_1.isUndefined(this.success)) {
            this._aborted = true;
        }
    };
    /**
     * The Transition error reason.
     *
     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
     *
     * @returns an error message explaining why the transition is invalid, or the reason the transition failed.
     */
    Transition.prototype.error = function () {
        var state = this.$to();
        if (state.self.abstract)
            return "Cannot transition to abstract state '" + state.name + "'";
        var paramDefs = state.parameters(), values = this.params();
        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
        if (invalidParams.length) {
            return "Param values not valid for state '" + state.name + "'. Invalid params: [ " + invalidParams.map(function (param) { return param.id; }).join(', ') + " ]";
        }
        if (this.success === false)
            return this._error;
    };
    /**
     * A string representation of the Transition
     *
     * @returns A string representation of the Transition
     */
    Transition.prototype.toString = function () {
        var fromStateOrName = this.from();
        var toStateOrName = this.to();
        var avoidEmptyHash = function (params) {
            return (params["#"] !== null && params["#"] !== undefined) ? params : common_1.omit(params, ["#"]);
        };
        // (X) means the to state is invalid.
        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? "" : "(X) ", to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
    };
    /** @hidden */
    Transition.diToken = Transition;
    return Transition;
}());
exports.Transition = Transition;
//# sourceMappingURL=transition.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module path */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var targetState_1 = __webpack_require__(12);
var pathNode_1 = __webpack_require__(29);
/**
 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
 */
var PathUtils = /** @class */ (function () {
    function PathUtils() {
    }
    /** Given a PathNode[], create an TargetState */
    PathUtils.makeTargetState = function (registry, path) {
        var state = common_1.tail(path).state;
        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}), {});
    };
    PathUtils.buildPath = function (targetState) {
        var toParams = targetState.params();
        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
    };
    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
    PathUtils.buildToPath = function (fromPath, targetState) {
        var toPath = PathUtils.buildPath(targetState);
        if (targetState.options().inherit) {
            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
        }
        return toPath;
    };
    /**
     * Creates ViewConfig objects and adds to nodes.
     *
     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
     */
    PathUtils.applyViewConfigs = function ($view, path, states) {
        // Only apply the viewConfigs to the nodes for the given states
        path.filter(function (node) { return common_1.inArray(states, node.state); }).forEach(function (node) {
            var viewDecls = common_1.values(node.state.views || {});
            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
            node.views = viewConfigs.reduce(common_1.unnestR, []);
        });
    };
    /**
     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
     *
     * For a parameter in a node to be inherited from the from path:
     * - The toPath's node must have a matching node in the fromPath (by state).
     * - The parameter name must not be found in the toKeys parameter array.
     *
     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
     * it is not inherited from the fromPath.
     */
    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
        if (toKeys === void 0) { toKeys = []; }
        function nodeParamVals(path, state) {
            var node = common_1.find(path, hof_1.propEq('state', state));
            return common_1.extend({}, node && node.paramValues);
        }
        var noInherit = fromPath.map(function (node) { return node.paramSchema; })
            .reduce(common_1.unnestR, [])
            .filter(function (param) { return !param.inherit; })
            .map(hof_1.prop('id'));
        /**
         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
         */
        function makeInheritedParamsNode(toNode) {
            // All param values for the node (may include default key/vals, when key was not found in toParams)
            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
            // limited to only those keys found in toParams
            var incomingParamVals = common_1.pick(toParamVals, toKeys);
            toParamVals = common_1.omit(toParamVals, toKeys);
            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
        }
        // The param keys specified by the incoming toParams
        return toPath.map(makeInheritedParamsNode);
    };
    /**
     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
     */
    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
        var keep = 0, max = Math.min(fromPath.length, toPath.length);
        var nodesMatch = function (node1, node2) {
            return node1.equals(node2, PathUtils.nonDynamicParams);
        };
        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
            keep++;
        }
        /** Given a retained node, return a new node which uses the to node's param values */
        function applyToParams(retainedNode, idx) {
            var cloned = pathNode_1.PathNode.clone(retainedNode);
            cloned.paramValues = toPath[idx].paramValues;
            return cloned;
        }
        var from, retained, exiting, entering, to;
        from = fromPath;
        retained = from.slice(0, keep);
        exiting = from.slice(keep);
        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
        var retainedWithToParams = retained.map(applyToParams);
        entering = toPath.slice(keep);
        to = (retainedWithToParams).concat(entering);
        return { from: from, to: to, retained: retained, exiting: exiting, entering: entering };
    };
    /**
     * Returns a new path which is: the subpath of the first path which matches the second path.
     *
     * The new path starts from root and contains any nodes that match the nodes in the second path.
     * It stops before the first non-matching node.
     *
     * Nodes are compared using their state property and their parameter values.
     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
     *
     * @param pathA the first path
     * @param pathB the second path
     * @param paramsFn a function which returns the parameters to consider when comparing
     *
     * @returns an array of PathNodes from the first path which match the nodes in the second path
     */
    PathUtils.matching = function (pathA, pathB, paramsFn) {
        var done = false;
        var tuples = common_1.arrayTuples(pathA, pathB);
        return tuples.reduce(function (matching, _a) {
            var nodeA = _a[0], nodeB = _a[1];
            done = done || !nodeA.equals(nodeB, paramsFn);
            return done ? matching : matching.concat(nodeA);
        }, []);
    };
    /**
     * Returns true if two paths are identical.
     *
     * @param pathA
     * @param pathB
     * @param paramsFn a function which returns the parameters to consider when comparing
     * @returns true if the the states and parameter values for both paths are identical
     */
    PathUtils.equals = function (pathA, pathB, paramsFn) {
        return pathA.length === pathB.length &&
            PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
    };
    /**
     * Return a subpath of a path, which stops at the first matching node
     *
     * Given an array of nodes, returns a subset of the array starting from the first node,
     * stopping when the first node matches the predicate.
     *
     * @param path a path of [[PathNode]]s
     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
     * @returns a subpath up to the matching node, or undefined if no match is found
     */
    PathUtils.subPath = function (path, predicate) {
        var node = common_1.find(path, predicate);
        var elementIdx = path.indexOf(node);
        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    PathUtils.nonDynamicParams = function (node) {
        return node.state.parameters({ inherit: false })
            .filter(function (param) { return !param.dynamic; });
    };
    /** Gets the raw parameter values from a path */
    PathUtils.paramValues = function (path) {
        return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {});
    };
    return PathUtils;
}());
exports.PathUtils = PathUtils;
//# sourceMappingURL=pathFactory.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module resolve */
/** for typedoc */
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var trace_1 = __webpack_require__(10);
var coreservices_1 = __webpack_require__(7);
var interface_1 = __webpack_require__(37);
var resolvable_1 = __webpack_require__(16);
var pathFactory_1 = __webpack_require__(19);
var strings_1 = __webpack_require__(9);
var common_2 = __webpack_require__(8);
var whens = interface_1.resolvePolicies.when;
var ALL_WHENS = [whens.EAGER, whens.LAZY];
var EAGER_WHENS = [whens.EAGER];
exports.NATIVE_INJECTOR_TOKEN = "Native Injector";
/**
 * Encapsulates Dependency Injection for a path of nodes
 *
 * UI-Router states are organized as a tree.
 * A nested state has a path of ancestors to the root of the tree.
 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
 *
 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
 */
var ResolveContext = /** @class */ (function () {
    function ResolveContext(_path) {
        this._path = _path;
    }
    /** Gets all the tokens found in the resolve context, de-duplicated */
    ResolveContext.prototype.getTokens = function () {
        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
    };
    /**
     * Gets the Resolvable that matches the token
     *
     * Gets the last Resolvable that matches the token in this context, or undefined.
     * Throws an error if it doesn't exist in the ResolveContext
     */
    ResolveContext.prototype.getResolvable = function (token) {
        var matching = this._path.map(function (node) { return node.resolvables; })
            .reduce(common_1.unnestR, [])
            .filter(function (r) { return r.token === token; });
        return common_1.tail(matching);
    };
    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
    ResolveContext.prototype.getPolicy = function (resolvable) {
        var node = this.findNode(resolvable);
        return resolvable.getPolicy(node.state);
    };
    /**
     * Returns a ResolveContext that includes a portion of this one
     *
     * Given a state, this method creates a new ResolveContext from this one.
     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
     *
     * #### Why
     *
     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
     * This method is used to create a narrower context when injecting ancestor nodes.
     *
     * @example
     * `let ABCD = new ResolveContext([A, B, C, D]);`
     *
     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
     * However, `B` should only be able to access resolvables from `A`, `B`.
     *
     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
     * `let AB = ABCD.subcontext(a)`
     */
    ResolveContext.prototype.subContext = function (state) {
        return new ResolveContext(pathFactory_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
    };
    /**
     * Adds Resolvables to the node that matches the state
     *
     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
     * The resolvable is added to the node matching the `state` parameter.
     *
     * These new resolvables are not automatically fetched.
     * The calling code should either fetch them, fetch something that depends on them,
     * or rely on [[resolvePath]] being called when some state is being entered.
     *
     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
     *
     * @param newResolvables the new Resolvables
     * @param state Used to find the node to put the resolvable on
     */
    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
        var node = common_1.find(this._path, hof_1.propEq('state', state));
        var keys = newResolvables.map(function (r) { return r.token; });
        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
    };
    /**
     * Returns a promise for an array of resolved path Element promises
     *
     * @param when
     * @param trans
     * @returns {Promise<any>|any}
     */
    ResolveContext.prototype.resolvePath = function (when, trans) {
        var _this = this;
        if (when === void 0) { when = "LAZY"; }
        // This option determines which 'when' policy Resolvables we are about to fetch.
        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : "LAZY";
        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
        // get the subpath to the state argument, if provided
        trace_1.trace.traceResolvePath(this._path, when, trans);
        var matchesPolicy = function (acceptedVals, whenOrAsync) {
            return function (resolvable) {
                return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
            };
        };
        // Trigger all the (matching) Resolvables in the path
        // Reduce all the "WAIT" Resolvables into an array
        var promises = this._path.reduce(function (acc, node) {
            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
            // For the matching Resolvables, start their async fetch process.
            var subContext = _this.subContext(node.state);
            var getResult = function (r) { return r.get(subContext, trans)
                .then(function (value) { return ({ token: r.token, value: value }); }); };
            nowait.forEach(getResult);
            return acc.concat(wait.map(getResult));
        }, []);
        // Wait for all the "WAIT" resolvables
        return coreservices_1.services.$q.all(promises);
    };
    ResolveContext.prototype.injector = function () {
        return this._injector || (this._injector = new UIInjectorImpl(this));
    };
    ResolveContext.prototype.findNode = function (resolvable) {
        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
    };
    /**
     * Gets the async dependencies of a Resolvable
     *
     * Given a Resolvable, returns its dependencies as a Resolvable[]
     */
    ResolveContext.prototype.getDependencies = function (resolvable) {
        var _this = this;
        var node = this.findNode(resolvable);
        // Find which other resolvables are "visible" to the `resolvable` argument
        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
        var subPath = pathFactory_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
        var availableResolvables = subPath
            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) //all of subpath's resolvables
            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
        var getDependency = function (token) {
            var matching = availableResolvables.filter(function (r) { return r.token === token; });
            if (matching.length)
                return common_1.tail(matching);
            var fromInjector = _this.injector().getNative(token);
            if (common_2.isUndefined(fromInjector)) {
                throw new Error("Could not find Dependency Injection token: " + strings_1.stringify(token));
            }
            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
        };
        return resolvable.deps.map(getDependency);
    };
    return ResolveContext;
}());
exports.ResolveContext = ResolveContext;
var UIInjectorImpl = /** @class */ (function () {
    function UIInjectorImpl(context) {
        this.context = context;
        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
    }
    UIInjectorImpl.prototype.get = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) {
            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
                return resolvable.get(this.context);
            }
            if (!resolvable.resolved) {
                throw new Error("Resolvable async .get() not complete:" + strings_1.stringify(resolvable.token));
            }
            return resolvable.data;
        }
        return this.getNative(token);
    };
    UIInjectorImpl.prototype.getAsync = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable)
            return resolvable.get(this.context);
        return coreservices_1.services.$q.when(this.native.get(token));
    };
    UIInjectorImpl.prototype.getNative = function (token) {
        return this.native && this.native.get(token);
    };
    return UIInjectorImpl;
}());
//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module url
 */
/** for typedoc */
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var predicates_1 = __webpack_require__(4);
var param_1 = __webpack_require__(13);
var strings_1 = __webpack_require__(9);
/** @hidden */
function quoteRegExp(string, param) {
    var surroundPattern = ['', ''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!param)
        return result;
    switch (param.squash) {
        case false:
            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
            break;
        case true:
            result = result.replace(/\/$/, '');
            surroundPattern = ['(?:\/(', ')|\/)?'];
            break;
        default:
            surroundPattern = ["(" + param.squash + "|", ')?'];
            break;
    }
    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
}
/** @hidden */
var memoizeTo = function (obj, prop, fn) {
    return obj[prop] = obj[prop] || fn();
};
/** @hidden */
var splitOnSlash = strings_1.splitOnDelim('/');
/**
 * Matches URLs against patterns.
 *
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL.
 *
 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
 * parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by [[UrlMatcher.exec]].
 *
 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
 * or colon placeholders (`/somePath/:param`).
 *
 * - *A parameter RegExp* may be defined for a param after a colon
 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
 * The regexp must match for the url to be matched.
 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
 *
 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
 *   See [[UrlMatcherFactory.type]] for more information.
 *
 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
 *   A catch-all * parameter value will contain the remainder of the URL.
 *
 * ---
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters).
 * A path parameter matches any number of characters other than '/'. For catch-all
 * placeholders the path parameter matches any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 */
var UrlMatcher = /** @class */ (function () {
    /**
     * @param pattern The pattern to compile into a matcher.
     * @param paramTypes The [[ParamTypes]] registry
     * @param config  A configuration object
     * - `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
     * - `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
     */
    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
        var _this = this;
        this.config = config;
        /** @hidden */
        this._cache = { path: [this] };
        /** @hidden */
        this._children = [];
        /** @hidden */
        this._params = [];
        /** @hidden */
        this._segments = [];
        /** @hidden */
        this._compiled = [];
        this.pattern = pattern;
        this.config = common_1.defaults(this.config, {
            params: {},
            strict: true,
            caseInsensitive: false,
            paramMap: common_1.identity
        });
        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
        //   '*' name
        //   ':' name
        //   '{' name '}'
        //   '{' name ':' regexp '}'
        // The regular expression is somewhat complicated due to the need to allow curly braces
        // inside the regular expression. The placeholder regexp breaks down as follows:
        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
        //    [^{}\\]+                       - anything other than curly braces or backslash
        //    \\.                            - a backslash escape
        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, last = 0, m, patterns = [];
        var checkParamErrors = function (id) {
            if (!UrlMatcher.nameValidator.test(id))
                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if (common_1.find(_this._params, hof_1.propEq('id', id)))
                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
        };
        // Split into static segments separated by path parameter placeholders.
        // The number of segments is always 1 more than the number of parameters.
        var matchDetails = function (m, isSearch) {
            // IE[78] returns '' for unmatched groups instead of null
            var id = m[2] || m[3];
            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
            var makeRegexpType = function (regexp) { return common_1.inherit(paramTypes.type(isSearch ? "query" : "path"), {
                pattern: new RegExp(regexp, _this.config.caseInsensitive ? 'i' : undefined)
            }); };
            return {
                id: id,
                regexp: regexp,
                cfg: _this.config.params[id],
                segment: pattern.substring(last, m.index),
                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
            };
        };
        var p, segment;
        while ((m = placeholder.exec(pattern))) {
            p = matchDetails(m, false);
            if (p.segment.indexOf('?') >= 0)
                break; // we're into the search part
            checkParamErrors(p.id);
            this._params.push(paramFactory.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false)));
            this._segments.push(p.segment);
            patterns.push([p.segment, common_1.tail(this._params)]);
            last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        // Find any search parameter names and remove them from the last segment
        var i = segment.indexOf('?');
        if (i >= 0) {
            var search = segment.substring(i);
            segment = segment.substring(0, i);
            if (search.length > 0) {
                last = 0;
                while ((m = searchPlaceholder.exec(search))) {
                    p = matchDetails(m, true);
                    checkParamErrors(p.id);
                    this._params.push(paramFactory.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true)));
                    last = placeholder.lastIndex;
                    // check if ?&
                }
            }
        }
        this._segments.push(segment);
        this._compiled = patterns.map(function (pattern) { return quoteRegExp.apply(null, pattern); }).concat(quoteRegExp(segment));
    }
    /**
     * Creates a new concatenated UrlMatcher
     *
     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
     *
     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
     */
    UrlMatcher.prototype.append = function (url) {
        this._children.push(url);
        url._cache = {
            path: this._cache.path.concat(url),
            parent: this,
            pattern: null,
        };
        return url;
    };
    /** @hidden */
    UrlMatcher.prototype.isRoot = function () {
        return this._cache.path[0] === this;
    };
    /** Returns the input pattern string */
    UrlMatcher.prototype.toString = function () {
        return this.pattern;
    };
    /**
     * Tests the specified url/path against this matcher.
     *
     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
     * parameter values.  Returns null if the path does not match.
     *
     * The returned object contains the values
     * of any search parameters that are mentioned in the pattern, but their value may be null if
     * they are not present in `search`. This means that search parameters are always treated
     * as optional.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
     *   x: '1', q: 'hello'
     * });
     * // returns { id: 'bob', q: 'hello', r: null }
     * ```
     *
     * @param path    The URL path to match, e.g. `$location.path()`.
     * @param search  URL search parameters, e.g. `$location.search()`.
     * @param hash    URL hash e.g. `$location.hash()`.
     * @param options
     *
     * @returns The captured parameter values.
     */
    UrlMatcher.prototype.exec = function (path, search, hash, options) {
        var _this = this;
        if (search === void 0) { search = {}; }
        if (options === void 0) { options = {}; }
        var match = memoizeTo(this._cache, 'pattern', function () {
            return new RegExp([
                '^',
                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
                _this.config.strict === false ? '\/?' : '',
                '$'
            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
        }).exec(path);
        if (!match)
            return null;
        //options = defaults(options, { isolate: false });
        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
        if (nPathSegments !== match.length - 1)
            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
        function decodePathArray(string) {
            var reverseString = function (str) { return str.split("").reverse().join(""); };
            var unquoteDashes = function (str) { return str.replace(/\\-/g, "-"); };
            var split = reverseString(string).split(/-(?!\\)/);
            var allReversed = common_1.map(split, reverseString);
            return common_1.map(allReversed, unquoteDashes).reverse();
        }
        for (var i = 0; i < nPathSegments; i++) {
            var param = pathParams[i];
            var value = match[i + 1];
            // if the param value matches a pre-replace pair, replace the value before decoding.
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value)
                    value = param.replace[j].to;
            }
            if (value && param.array === true)
                value = decodePathArray(value);
            if (predicates_1.isDefined(value))
                value = param.type.decode(value);
            values[param.id] = param.value(value);
        }
        searchParams.forEach(function (param) {
            var value = search[param.id];
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value)
                    value = param.replace[j].to;
            }
            if (predicates_1.isDefined(value))
                value = param.type.decode(value);
            values[param.id] = param.value(value);
        });
        if (hash)
            values["#"] = hash;
        return values;
    };
    /**
     * @hidden
     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
     *
     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
     *    pattern has no parameters, an empty array is returned.
     */
    UrlMatcher.prototype.parameters = function (opts) {
        if (opts === void 0) { opts = {}; }
        if (opts.inherit === false)
            return this._params;
        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
    };
    /**
     * @hidden
     * Returns a single parameter from this UrlMatcher by id
     *
     * @param id
     * @param opts
     * @returns {T|Param|any|boolean|UrlMatcher|null}
     */
    UrlMatcher.prototype.parameter = function (id, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        var findParam = function () {
            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
                var param = _a[_i];
                if (param.id === id)
                    return param;
            }
        };
        var parent = this._cache.parent;
        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
    };
    /**
     * Validates the input parameter values against this UrlMatcher
     *
     * Checks an object hash of parameters to validate their correctness according to the parameter
     * types of this `UrlMatcher`.
     *
     * @param params The object hash of parameters to validate.
     * @returns Returns `true` if `params` validates, otherwise `false`.
     */
    UrlMatcher.prototype.validates = function (params) {
        var validParamVal = function (param, val) {
            return !param || param.validates(val);
        };
        params = params || {};
        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
    };
    /**
     * Given a set of parameter values, creates a URL from this UrlMatcher.
     *
     * Creates a URL that matches this pattern by substituting the specified values
     * for the path and search parameters.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
     * // returns '/user/bob?q=yes'
     * ```
     *
     * @param values  the values to substitute for the parameters in this pattern.
     * @returns the formatted URL (path and optionally search part).
     */
    UrlMatcher.prototype.format = function (values) {
        if (values === void 0) { values = {}; }
        // Build the full path of UrlMatchers (including all parent UrlMatchers)
        var urlMatchers = this._cache.path;
        // Extract all the static segments and Params (processed as ParamDetails)
        // into an ordered array
        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams)
            .reduce(common_1.unnestR, [])
            .map(function (x) { return predicates_1.isString(x) ? x : getDetails(x); });
        // Extract the query params into a separate array
        var queryParams = urlMatchers.map(UrlMatcher.queryParams)
            .reduce(common_1.unnestR, [])
            .map(getDetails);
        var isInvalid = function (param) { return param.isValid === false; };
        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
            return null;
        }
        /**
         * Given a Param, applies the parameter value, then returns detailed information about it
         */
        function getDetails(param) {
            // Normalize to typed value
            var value = param.value(values[param.id]);
            var isValid = param.validates(value);
            var isDefaultValue = param.isDefaultValue(value);
            // Check if we're in squash mode for the parameter
            var squash = isDefaultValue ? param.squash : false;
            // Allow the Parameter's Type to encode the value
            var encoded = param.type.encode(value);
            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
        }
        // Build up the path-portion from the list of static segments and parameters
        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
            // The element is a static segment (a raw string); just append it
            if (predicates_1.isString(x))
                return acc + x;
            // Otherwise, it's a ParamDetails.
            var squash = x.squash, encoded = x.encoded, param = x.param;
            // If squash is === true, try to remove a slash from the path
            if (squash === true)
                return (acc.match(/\/$/)) ? acc.slice(0, -1) : acc;
            // If squash is a string, use the string for the param value
            if (predicates_1.isString(squash))
                return acc + squash;
            if (squash !== false)
                return acc; // ?
            if (encoded == null)
                return acc;
            // If this parameter value is an array, encode the value using encodeDashes
            if (predicates_1.isArray(encoded))
                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join("-");
            // If the parameter type is "raw", then do not encodeURIComponent
            if (param.raw)
                return acc + encoded;
            // Encode the value
            return acc + encodeURIComponent(encoded);
        }, "");
        // Build the query string by applying parameter values (array or regular)
        // then mapping to key=value, then flattening and joining using "&"
        var queryString = queryParams.map(function (paramDetails) {
            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
            if (encoded == null || (isDefaultValue && squash !== false))
                return;
            if (!predicates_1.isArray(encoded))
                encoded = [encoded];
            if (encoded.length === 0)
                return;
            if (!param.raw)
                encoded = common_1.map(encoded, encodeURIComponent);
            return encoded.map(function (val) { return param.id + "=" + val; });
        }).filter(common_1.identity).reduce(common_1.unnestR, []).join("&");
        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
        return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
    };
    /** @hidden */
    UrlMatcher.encodeDashes = function (str) {
        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
    };
    /** @hidden Given a matcher, return an array with the matcher's path segments and path params, in order */
    UrlMatcher.pathSegmentsAndParams = function (matcher) {
        var staticSegments = matcher._segments;
        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
            .reduce(common_1.unnestR, [])
            .filter(function (x) { return x !== "" && predicates_1.isDefined(x); });
    };
    /** @hidden Given a matcher, return an array with the matcher's query params */
    UrlMatcher.queryParams = function (matcher) {
        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
    };
    /**
     * Compare two UrlMatchers
     *
     * This comparison function converts a UrlMatcher into static and dynamic path segments.
     * Each static path segment is a static string between a path separator (slash character).
     * Each dynamic segment is a path parameter.
     *
     * The comparison function sorts static segments before dynamic ones.
     */
    UrlMatcher.compare = function (a, b) {
        /**
         * Turn a UrlMatcher and all its parent matchers into an array
         * of slash literals '/', string literals, and Param objects
         *
         * This example matcher matches strings like "/foo/:param/tail":
         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
         *
         * Caches the result as `matcher._cache.segments`
         */
        var segments = function (matcher) {
            return matcher._cache.segments = matcher._cache.segments ||
                matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams)
                    .reduce(common_1.unnestR, [])
                    .reduce(strings_1.joinNeighborsR, [])
                    .map(function (x) { return predicates_1.isString(x) ? splitOnSlash(x) : x; })
                    .reduce(common_1.unnestR, []);
        };
        /**
         * Gets the sort weight for each segment of a UrlMatcher
         *
         * Caches the result as `matcher._cache.weights`
         */
        var weights = function (matcher) {
            return matcher._cache.weights = matcher._cache.weights ||
                segments(matcher).map(function (segment) {
                    // Sort slashes first, then static strings, the Params
                    if (segment === '/')
                        return 1;
                    if (predicates_1.isString(segment))
                        return 2;
                    if (segment instanceof param_1.Param)
                        return 3;
                });
        };
        /**
         * Pads shorter array in-place (mutates)
         */
        var padArrays = function (l, r, padVal) {
            var len = Math.max(l.length, r.length);
            while (l.length < len)
                l.push(padVal);
            while (r.length < len)
                r.push(padVal);
        };
        var weightsA = weights(a), weightsB = weights(b);
        padArrays(weightsA, weightsB, 0);
        var cmp, i, pairs = common_1.arrayTuples(weightsA, weightsB);
        for (i = 0; i < pairs.length; i++) {
            cmp = pairs[i][0] - pairs[i][1];
            if (cmp !== 0)
                return cmp;
        }
        return 0;
    };
    /** @hidden */
    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
    return UrlMatcher;
}());
exports.UrlMatcher = UrlMatcher;
//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module vanilla
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
var utils_1 = __webpack_require__(32);
/** A base `LocationServices` */
var BaseLocationServices = /** @class */ (function () {
    function BaseLocationServices(router, fireAfterUpdate) {
        var _this = this;
        this.fireAfterUpdate = fireAfterUpdate;
        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
        this._listeners = [];
        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
        this._location = common_1.root.location;
        this._history = common_1.root.history;
    }
    BaseLocationServices.prototype.url = function (url, replace) {
        if (replace === void 0) { replace = true; }
        if (common_1.isDefined(url) && url !== this._get()) {
            this._set(null, null, url, replace);
            if (this.fireAfterUpdate) {
                this._listeners.forEach(function (cb) { return cb({ url: url }); });
            }
        }
        return utils_1.buildUrl(this);
    };
    BaseLocationServices.prototype.onChange = function (cb) {
        var _this = this;
        this._listeners.push(cb);
        return function () { return common_1.removeFrom(_this._listeners, cb); };
    };
    BaseLocationServices.prototype.dispose = function (router) {
        common_1.deregAll(this._listeners);
    };
    return BaseLocationServices;
}());
exports.BaseLocationServices = BaseLocationServices;
//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__finally__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allSettled__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__any__ = __webpack_require__(397);




// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = __WEBPACK_IMPORTED_MODULE_0__finally__["a" /* default */];

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.any = __WEBPACK_IMPORTED_MODULE_2__any__["a" /* default */];

Promise.allSettled = __WEBPACK_IMPORTED_MODULE_1__allSettled__["a" /* default */];

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(392).setImmediate))

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRequester;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node__ = __webpack_require__(408);


function makeRequester(opts) {
    if (opts.request) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__node__["a" /* makeRequester */])(opts.request);
    }
    return __WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* request */];
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var glob_1 = __webpack_require__(17);
var predicates_1 = __webpack_require__(4);
/**
 * Internal representation of a UI-Router state.
 *
 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
 *
 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
 *
 * This class prototypally inherits from the corresponding [[StateDeclaration]].
 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
 */
var StateObject = /** @class */ (function () {
    /** @deprecated use State.create() */
    function StateObject(config) {
        return StateObject.create(config || {});
    }
    /**
     * Create a state object to put the private/internal implementation details onto.
     * The object's prototype chain looks like:
     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
     *
     * @param stateDecl the user-supplied State Declaration
     * @returns {StateObject} an internal State object
     */
    StateObject.create = function (stateDecl) {
        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
        stateDecl.$$state = function () { return state; };
        state.self = stateDecl;
        state.__stateObjectCache = {
            nameGlob: glob_1.Glob.fromString(state.name) // might return null
        };
        return state;
    };
    /**
     * Returns true if the provided parameter is the same state.
     *
     * Compares the identity of the state against the passed value, which is either an object
     * reference to the actual `State` instance, the original definition object passed to
     * `$stateProvider.state()`, or the fully-qualified name.
     *
     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
     * @returns Returns `true` if `ref` matches the current `State` instance.
     */
    StateObject.prototype.is = function (ref) {
        return this === ref || this.self === ref || this.fqn() === ref;
    };
    /**
     * @deprecated this does not properly handle dot notation
     * @returns Returns a dot-separated name of the state.
     */
    StateObject.prototype.fqn = function () {
        if (!this.parent || !(this.parent instanceof this.constructor))
            return this.name;
        var name = this.parent.fqn();
        return name ? name + "." + this.name : this.name;
    };
    /**
     * Returns the root node of this state's tree.
     *
     * @returns The root of this state's tree.
     */
    StateObject.prototype.root = function () {
        return this.parent && this.parent.root() || this;
    };
    /**
     * Gets the state's `Param` objects
     *
     * Gets the list of [[Param]] objects owned by the state.
     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
     *
     * @param opts options
     */
    StateObject.prototype.parameters = function (opts) {
        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
        var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
        return inherited.concat(common_1.values(this.params))
            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
    };
    /**
     * Returns a single [[Param]] that is owned by the state
     *
     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
     * @param id the name of the [[Param]] to return
     * @param opts options
     */
    StateObject.prototype.parameter = function (id, opts) {
        if (opts === void 0) { opts = {}; }
        return (this.url && this.url.parameter(id, opts) ||
            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
            opts.inherit && this.parent && this.parent.parameter(id));
    };
    StateObject.prototype.toString = function () {
        return this.fqn();
    };
    /** Predicate which returns true if the object is an class with @State() decorator */
    StateObject.isStateClass = function (stateDecl) {
        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
    };
    /** Predicate which returns true if the object is an internal [[StateObject]] object */
    StateObject.isState = function (obj) {
        return predicates_1.isObject(obj['__stateObjectCache']);
    };
    return StateObject;
}());
exports.StateObject = StateObject;
//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module common
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var Queue = /** @class */ (function () {
    function Queue(_items, _limit) {
        if (_items === void 0) { _items = []; }
        if (_limit === void 0) { _limit = null; }
        this._items = _items;
        this._limit = _limit;
    }
    Queue.prototype.enqueue = function (item) {
        var items = this._items;
        items.push(item);
        if (this._limit && items.length > this._limit)
            items.shift();
        return item;
    };
    Queue.prototype.dequeue = function () {
        if (this.size())
            return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function () {
        var current = this._items;
        this._items = [];
        return current;
    };
    Queue.prototype.size = function () {
        return this._items.length;
    };
    Queue.prototype.remove = function (item) {
        var idx = this._items.indexOf(item);
        return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function () {
        return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function () {
        if (this.size())
            return this._items[0];
    };
    return Queue;
}());
exports.Queue = Queue;
//# sourceMappingURL=queue.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var interface_1 = __webpack_require__(11); // has or is using
var glob_1 = __webpack_require__(17);
/**
 * Determines if the given state matches the matchCriteria
 *
 * @hidden
 *
 * @param state a State Object to test against
 * @param criterion
 * - If a string, matchState uses the string as a glob-matcher against the state name
 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
 *   and returns a positive match if any of the globs match.
 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
 * @returns {boolean}
 */
function matchState(state, criterion) {
    var toMatch = predicates_1.isString(criterion) ? [criterion] : criterion;
    function matchGlobs(_state) {
        var globStrings = toMatch;
        for (var i = 0; i < globStrings.length; i++) {
            var glob = new glob_1.Glob(globStrings[i]);
            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
                return true;
            }
        }
        return false;
    }
    var matchFn = (predicates_1.isFunction(toMatch) ? toMatch : matchGlobs);
    return !!matchFn(state);
}
exports.matchState = matchState;
/**
 * @internalapi
 * The registration data for a registered transition hook
 */
var RegisteredHook = /** @class */ (function () {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
        if (options === void 0) { options = {}; }
        this.tranSvc = tranSvc;
        this.eventType = eventType;
        this.callback = callback;
        this.matchCriteria = matchCriteria;
        this.removeHookFromRegistry = removeHookFromRegistry;
        this.invokeCount = 0;
        this._deregistered = false;
        this.priority = options.priority || 0;
        this.bind = options.bind || null;
        this.invokeLimit = options.invokeLimit;
    }
    /**
     * Gets the matching [[PathNode]]s
     *
     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
     *
     * Returning `null` is significant to distinguish between the default
     * "match-all criterion value" of `true` compared to a `() => true` function,
     * when the nodes is an empty array.
     *
     * This is useful to allow a transition match criteria of `entering: true`
     * to still match a transition, even when `entering === []`.  Contrast that
     * with `entering: (state) => true` which only matches when a state is actually
     * being entered.
     */
    RegisteredHook.prototype._matchingNodes = function (nodes, criterion) {
        if (criterion === true)
            return nodes;
        var matching = nodes.filter(function (node) { return matchState(node.state, criterion); });
        return matching.length ? matching : null;
    };
    /**
     * Gets the default match criteria (all `true`)
     *
     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
     *
     * ```js
     * {
     *   to: true,
     *   from: true,
     *   entering: true,
     *   exiting: true,
     *   retained: true,
     * }
     */
    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
        return common_1.map(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
    };
    /**
     * Gets matching nodes as [[IMatchingNodes]]
     *
     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
     *
     * ```js
     * let matches: IMatchingNodes = {
     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
     * };
     * ```
     */
    RegisteredHook.prototype._getMatchingNodes = function (treeChanges) {
        var _this = this;
        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
        return paths.reduce(function (mn, pathtype) {
            // STATE scope criteria matches against every node in the path.
            // TRANSITION scope criteria matches against only the last node in the path
            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
            var path = treeChanges[pathtype.name] || [];
            var nodes = isStateHook ? path : [common_1.tail(path)];
            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name]);
            return mn;
        }, {});
    };
    /**
     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
     *
     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
     */
    RegisteredHook.prototype.matches = function (treeChanges) {
        var matches = this._getMatchingNodes(treeChanges);
        // Check if all the criteria matched the TreeChanges object
        var allMatched = common_1.values(matches).every(common_1.identity);
        return allMatched ? matches : null;
    };
    RegisteredHook.prototype.deregister = function () {
        this.removeHookFromRegistry(this);
        this._deregistered = true;
    };
    return RegisteredHook;
}());
exports.RegisteredHook = RegisteredHook;
/** @hidden Return a registration function of the requested type. */
function makeEvent(registry, transitionService, eventType) {
    // Create the object which holds the registered transition hooks.
    var _registeredHooks = registry._registeredHooks = (registry._registeredHooks || {});
    var hooks = _registeredHooks[eventType.name] = [];
    var removeHookFn = common_1.removeFrom(hooks);
    // Create hook registration function on the IHookRegistry for the event
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
        if (options === void 0) { options = {}; }
        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
        hooks.push(registeredHook);
        return registeredHook.deregister.bind(registeredHook);
    }
    return hookRegistrationFn;
}
exports.makeEvent = makeEvent;
//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module path */ /** for typedoc */
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var param_1 = __webpack_require__(13);
/**
 * @internalapi
 *
 * A node in a [[TreeChanges]] path
 *
 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
 * Each PathNode corresponds to a state being entered, exited, or retained.
 * The stateful information includes parameter values and resolve data.
 */
var PathNode = /** @class */ (function () {
    function PathNode(stateOrNode) {
        if (stateOrNode instanceof PathNode) {
            var node = stateOrNode;
            this.state = node.state;
            this.paramSchema = node.paramSchema.slice();
            this.paramValues = common_1.extend({}, node.paramValues);
            this.resolvables = node.resolvables.slice();
            this.views = node.views && node.views.slice();
        }
        else {
            var state = stateOrNode;
            this.state = state;
            this.paramSchema = state.parameters({ inherit: false });
            this.paramValues = {};
            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
        }
    }
    /** Sets [[paramValues]] for the node, from the values of an object hash */
    PathNode.prototype.applyRawParams = function (params) {
        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
        return this;
    };
    /** Gets a specific [[Param]] metadata that belongs to the node */
    PathNode.prototype.parameter = function (name) {
        return common_1.find(this.paramSchema, hof_1.propEq("id", name));
    };
    /**
     * @returns true if the state and parameter values for another PathNode are
     * equal to the state and param values for this PathNode
     */
    PathNode.prototype.equals = function (node, paramsFn) {
        var diff = this.diff(node, paramsFn);
        return diff && diff.length === 0;
    };
    /**
     * Finds Params with different parameter values on another PathNode.
     *
     * Given another node (of the same state), finds the parameter values which differ.
     * Returns the [[Param]] (schema objects) whose parameter values differ.
     *
     * Given another node for a different state, returns `false`
     *
     * @param node The node to compare to
     * @param paramsFn A function that returns which parameters should be compared.
     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
     */
    PathNode.prototype.diff = function (node, paramsFn) {
        if (this.state !== node.state)
            return false;
        var params = paramsFn ? paramsFn(this) : this.paramSchema;
        return param_1.Param.changed(params, this.paramValues, node.paramValues);
    };
    /** Returns a clone of the PathNode */
    PathNode.clone = function (node) {
        return new PathNode(node);
    };
    return PathNode;
}());
exports.PathNode = PathNode;
//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */
/** */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
/**
 * An internal class which implements [[ParamTypeDefinition]].
 *
 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
 * When a param type definition is registered, an instance of this class is created internally.
 *
 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
 *
 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
 *
 * #### Example:
 * ```js
 * var paramTypeDef = {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 *
 * var paramType = new ParamType(paramTypeDef);
 * ```
 * @internalapi
 */
var ParamType = /** @class */ (function () {
    /**
     * @param def  A configuration object which contains the custom type definition.  The object's
     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
     * @returns a new ParamType object
     */
    function ParamType(def) {
        /** @inheritdoc */
        this.pattern = /.*/;
        /** @inheritdoc */
        this.inherit = true;
        common_1.extend(this, def);
    }
    // consider these four methods to be "abstract methods" that should be overridden
    /** @inheritdoc */
    ParamType.prototype.is = function (val, key) { return true; };
    /** @inheritdoc */
    ParamType.prototype.encode = function (val, key) { return val; };
    /** @inheritdoc */
    ParamType.prototype.decode = function (val, key) { return val; };
    /** @inheritdoc */
    ParamType.prototype.equals = function (a, b) { return a == b; };
    ParamType.prototype.$subPattern = function () {
        var sub = this.pattern.toString();
        return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function () {
        return "{ParamType:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */
    ParamType.prototype.$normalize = function (val) {
        return this.is(val) ? val : this.decode(val);
    };
    /**
     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
     * e.g.:
     * - urlmatcher pattern "/path?{queryParam[]:int}"
     * - url: "/path?queryParam=1&queryParam=2
     * - $stateParams.queryParam will be [1, 2]
     * if `mode` is "auto", then
     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
     */
    ParamType.prototype.$asArray = function (mode, isSearch) {
        if (!mode)
            return this;
        if (mode === "auto" && !isSearch)
            throw new Error("'auto' array mode is for query parameters only");
        return new ArrayType(this, mode);
    };
    return ParamType;
}());
exports.ParamType = ParamType;
/**
 * Wraps up a `ParamType` object to handle array values.
 * @internalapi
 */
function ArrayType(type, mode) {
    var _this = this;
    // Wrap non-array value as array
    function arrayWrap(val) {
        return predicates_1.isArray(val) ? val : (predicates_1.isDefined(val) ? [val] : []);
    }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
        switch (val.length) {
            case 0: return undefined;
            case 1: return mode === "auto" ? val[0] : val;
            default: return val;
        }
    }
    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
        return function handleArray(val) {
            if (predicates_1.isArray(val) && val.length === 0)
                return val;
            var arr = arrayWrap(val);
            var result = common_1.map(arr, callback);
            return (allTruthyMode === true) ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
        };
    }
    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
        return function handleArray(val1, val2) {
            var left = arrayWrap(val1), right = arrayWrap(val2);
            if (left.length !== right.length)
                return false;
            for (var i = 0; i < left.length; i++) {
                if (!callback(left[i], right[i]))
                    return false;
            }
            return true;
        };
    }
    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
        var paramTypeFn = type[name].bind(type);
        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
        _this[name] = wrapperFn(paramTypeFn);
    });
    common_1.extend(this, {
        dynamic: type.dynamic,
        name: type.name,
        pattern: type.pattern,
        inherit: type.inherit,
        is: arrayHandler(type.is.bind(type), true),
        $arrayMode: mode
    });
}
//# sourceMappingURL=paramType.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */
/** for typedoc */
var interface_1 = __webpack_require__(11);
var transition_1 = __webpack_require__(18);
var hookRegistry_1 = __webpack_require__(28);
var coreResolvables_1 = __webpack_require__(212);
var redirectTo_1 = __webpack_require__(213);
var onEnterExitRetain_1 = __webpack_require__(214);
var resolve_1 = __webpack_require__(215);
var views_1 = __webpack_require__(216);
var updateGlobals_1 = __webpack_require__(217);
var url_1 = __webpack_require__(218);
var lazyLoad_1 = __webpack_require__(52);
var transitionEventType_1 = __webpack_require__(53);
var transitionHook_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(4);
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var ignoredTransition_1 = __webpack_require__(219);
var invalidTransition_1 = __webpack_require__(220);
/**
 * The default [[Transition]] options.
 *
 * Include this object when applying custom defaults:
 * let reloadOpts = { reload: true, notify: true }
 * let options = defaults(theirOpts, customDefaults, defaultOptions);
 */
exports.defaultTransOpts = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    custom: {},
    current: function () { return null; },
    source: "unknown"
};
/**
 * This class provides services related to Transitions.
 *
 * - Most importantly, it allows global Transition Hooks to be registered.
 * - It allows the default transition error handler to be set.
 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
 *
 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
 */
var TransitionService = /** @class */ (function () {
    /** @hidden */
    function TransitionService(_router) {
        /** @hidden */
        this._transitionCount = 0;
        /** @hidden The transition hook types, such as `onEnter`, `onStart`, etc */
        this._eventTypes = [];
        /** @hidden The registered transition hooks */
        this._registeredHooks = {};
        /** @hidden The  paths on a criteria object */
        this._criteriaPaths = {};
        this._router = _router;
        this.$view = _router.viewService;
        this._deregisterHookFns = {};
        this._pluginapi = common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
            '_definePathType',
            '_defineEvent',
            '_getPathTypes',
            '_getEvents',
            'getHooks',
        ]);
        this._defineCorePaths();
        this._defineCoreEvents();
        this._registerCoreTransitionHooks();
    }
    /**
     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
     *
     * Registers a transition lifecycle hook, which is invoked during transition construction.
     *
     * This low level hook should only be used by plugins.
     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
     * The Sticky States plugin uses this hook to modify the treechanges.
     *
     * ### Lifecycle
     *
     * `onCreate` hooks are invoked *while a transition is being constructed*.
     *
     * ### Return value
     *
     * The hook's return value is ignored
     *
     * @internalapi
     * @param criteria defines which Transitions the Hook should be invoked for.
     * @param callback the hook function which will be invoked.
     * @param options the registration options
     * @returns a function which deregisters the hook.
     */
    TransitionService.prototype.onCreate = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onBefore = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onStart = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onExit = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onRetain = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onEnter = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onFinish = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onSuccess = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onError = function (criteria, callback, options) { return; };
    /**
     * dispose
     * @internalapi
     */
    TransitionService.prototype.dispose = function (router) {
        common_1.values(this._registeredHooks).forEach(function (hooksArray) { return hooksArray.forEach(function (hook) {
            hook._deregistered = true;
            common_1.removeFrom(hooksArray, hook);
        }); });
    };
    /**
     * Creates a new [[Transition]] object
     *
     * This is a factory function for creating new Transition objects.
     * It is used internally by the [[StateService]] and should generally not be called by application code.
     *
     * @param fromPath the path to the current state (the from state)
     * @param targetState the target state (destination)
     * @returns a Transition
     */
    TransitionService.prototype.create = function (fromPath, targetState) {
        return new transition_1.Transition(fromPath, targetState, this._router);
    };
    /** @hidden */
    TransitionService.prototype._defineCoreEvents = function () {
        var Phase = interface_1.TransitionHookPhase;
        var TH = transitionHook_1.TransitionHook;
        var paths = this._criteriaPaths;
        var NORMAL_SORT = false, REVERSE_SORT = true;
        var ASYNCHRONOUS = false, SYNCHRONOUS = true;
        this._defineEvent("onCreate", Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
        this._defineEvent("onBefore", Phase.BEFORE, 0, paths.to);
        this._defineEvent("onStart", Phase.RUN, 0, paths.to);
        this._defineEvent("onExit", Phase.RUN, 100, paths.exiting, REVERSE_SORT);
        this._defineEvent("onRetain", Phase.RUN, 200, paths.retained);
        this._defineEvent("onEnter", Phase.RUN, 300, paths.entering);
        this._defineEvent("onFinish", Phase.RUN, 400, paths.to);
        this._defineEvent("onSuccess", Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
        this._defineEvent("onError", Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
    };
    /** @hidden */
    TransitionService.prototype._defineCorePaths = function () {
        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
        this._definePathType("to", TRANSITION);
        this._definePathType("from", TRANSITION);
        this._definePathType("exiting", STATE);
        this._definePathType("retained", STATE);
        this._definePathType("entering", STATE);
    };
    /** @hidden */
    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
        if (reverseSort === void 0) { reverseSort = false; }
        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
        if (synchronous === void 0) { synchronous = false; }
        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
        this._eventTypes.push(eventType);
        hookRegistry_1.makeEvent(this, this, eventType);
    };
    ;
    /** @hidden */
    TransitionService.prototype._getEvents = function (phase) {
        var transitionHookTypes = predicates_1.isDefined(phase) ?
            this._eventTypes.filter(function (type) { return type.hookPhase === phase; }) :
            this._eventTypes.slice();
        return transitionHookTypes.sort(function (l, r) {
            var cmpByPhase = l.hookPhase - r.hookPhase;
            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
        });
    };
    /**
     * Adds a Path to be used as a criterion against a TreeChanges path
     *
     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
     * Each state in the exiting path is checked against the criteria and returned as part of the match.
     *
     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
     *
     * @hidden
     */
    TransitionService.prototype._definePathType = function (name, hookScope) {
        this._criteriaPaths[name] = { name: name, scope: hookScope };
    };
    /** * @hidden */
    TransitionService.prototype._getPathTypes = function () {
        return this._criteriaPaths;
    };
    /** @hidden */
    TransitionService.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    /** @hidden */
    TransitionService.prototype._registerCoreTransitionHooks = function () {
        var fns = this._deregisterHookFns;
        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
        // Wire up redirectTo hook
        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
        // Wire up onExit/Retain/Enter state hooks
        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
        // Wire up Resolve hooks
        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
        // Wire up the View management hooks
        fns.loadViews = views_1.registerLoadEnteringViews(this);
        fns.activateViews = views_1.registerActivateViews(this);
        // Updates global state after a transition
        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
        // After globals.current is updated at priority: 10000
        fns.updateUrl = url_1.registerUpdateUrl(this);
        // Lazy load state trees
        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
    };
    return TransitionService;
}());
exports.TransitionService = TransitionService;
//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var common_1 = __webpack_require__(8);
exports.keyValsToObjectR = function (accum, _a) {
    var key = _a[0], val = _a[1];
    if (!accum.hasOwnProperty(key)) {
        accum[key] = val;
    }
    else if (common_1.isArray(accum[key])) {
        accum[key].push(val);
    }
    else {
        accum[key] = [accum[key], val];
    }
    return accum;
};
exports.getParams = function (queryString) {
    return queryString.split("&").filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
};
function parseUrl(url) {
    var orEmptyString = function (x) { return x || ""; };
    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
    return { path: path, search: search, hash: hash, url: url };
}
exports.parseUrl = parseUrl;
exports.buildUrl = function (loc) {
    var path = loc.path();
    var searchObject = loc.search();
    var hash = loc.hash();
    var search = Object.keys(searchObject).map(function (key) {
        var param = searchObject[key];
        var vals = common_1.isArray(param) ? param : [param];
        return vals.map(function (val) { return key + "=" + val; });
    }).reduce(common_1.unnestR, []).join("&");
    return path + (search ? "?" + search : "") + (hash ? "#" + hash : "");
};
function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
    return function (router) {
        var service = router.locationService = new serviceClass(router);
        var configuration = router.locationConfig = new configurationClass(router, isHtml5);
        function dispose(router) {
            router.dispose(service);
            router.dispose(configuration);
        }
        return { name: name, service: service, configuration: configuration, dispose: dispose };
    };
}
exports.locationPluginFactory = locationPluginFactory;
//# sourceMappingURL=utils.js.map

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Span */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoopMetric; });
var Span = /** @class */ (function () {
    function Span(metric, name, startTime) {
        this._dur = 0;
        this._level = 0;
        this._metric = metric;
        this.name = name;
        this.startTime = startTime || new Date();
    }
    Span.prototype.end = function (endTime) {
        this.endTime = endTime ? endTime : new Date();
        this._dur += this.endTime.getTime() - this.startTime.getTime();
        this._metric._incGroup(this.name, this._dur);
        this._metric = null;
    };
    Span.prototype._pause = function () {
        if (this._paused()) {
            return;
        }
        var now = new Date();
        this._dur += now.getTime() - this.startTime.getTime();
        this.startTime = null;
    };
    Span.prototype._resume = function () {
        if (!this._paused()) {
            return;
        }
        this.startTime = new Date();
    };
    Span.prototype._paused = function () {
        return this.startTime == null;
    };
    return Span;
}());

var BaseMetric = /** @class */ (function () {
    function BaseMetric() {
        this._spans = {};
        this._groups = {};
        this.startTime = new Date();
    }
    BaseMetric.prototype.end = function (endTime) {
        if (!this.endTime) {
            this.endTime = endTime || new Date();
        }
    };
    BaseMetric.prototype.isRecording = function () {
        return true;
    };
    BaseMetric.prototype.startSpan = function (name, startTime) {
        var span = this._spans[name];
        if (span) {
            span._level++;
        }
        else {
            span = new Span(this, name, startTime);
            this._spans[name] = span;
        }
    };
    BaseMetric.prototype.endSpan = function (name, endTime) {
        var span = this._spans[name];
        if (!span) {
            console.error('airbrake: span=%s does not exist', name);
            return;
        }
        if (span._level > 0) {
            span._level--;
        }
        else {
            span.end(endTime);
            delete this._spans[span.name];
        }
    };
    BaseMetric.prototype._incGroup = function (name, ms) {
        this._groups[name] = (this._groups[name] || 0) + ms;
    };
    BaseMetric.prototype._duration = function () {
        if (!this.endTime) {
            this.endTime = new Date();
        }
        return this.endTime.getTime() - this.startTime.getTime();
    };
    return BaseMetric;
}());

var NoopMetric = /** @class */ (function () {
    function NoopMetric() {
    }
    NoopMetric.prototype.isRecording = function () {
        return false;
    };
    NoopMetric.prototype.startSpan = function (_name, _startTime) { };
    NoopMetric.prototype.endSpan = function (_name, _startTime) { };
    NoopMetric.prototype._incGroup = function (_name, _ms) { };
    return NoopMetric;
}());

//# sourceMappingURL=metrics.js.map

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasTdigest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TDigestStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TDigestStatGroups; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var tdigest;
var hasTdigest = false;
try {
    tdigest = __webpack_require__(409);
    hasTdigest = true;
}
catch (err) { }
var TDigestStat = /** @class */ (function () {
    function TDigestStat() {
        this.count = 0;
        this.sum = 0;
        this.sumsq = 0;
        this._td = new tdigest.Digest();
    }
    TDigestStat.prototype.add = function (ms) {
        if (ms === 0) {
            ms = 0.00001;
        }
        this.count += 1;
        this.sum += ms;
        this.sumsq += ms * ms;
        if (this._td) {
            this._td.push(ms);
        }
    };
    TDigestStat.prototype.toJSON = function () {
        return {
            count: this.count,
            sum: this.sum,
            sumsq: this.sumsq,
            tdigestCentroids: tdigestCentroids(this._td),
        };
    };
    return TDigestStat;
}());

var TDigestStatGroups = /** @class */ (function (_super) {
    __extends(TDigestStatGroups, _super);
    function TDigestStatGroups() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groups = {};
        return _this;
    }
    TDigestStatGroups.prototype.addGroups = function (totalMs, groups) {
        this.add(totalMs);
        for (var name_1 in groups) {
            if (groups.hasOwnProperty(name_1)) {
                this.addGroup(name_1, groups[name_1]);
            }
        }
    };
    TDigestStatGroups.prototype.addGroup = function (name, ms) {
        var stat = this.groups[name];
        if (!stat) {
            stat = new TDigestStat();
            this.groups[name] = stat;
        }
        stat.add(ms);
    };
    TDigestStatGroups.prototype.toJSON = function () {
        return {
            count: this.count,
            sum: this.sum,
            sumsq: this.sumsq,
            tdigestCentroids: tdigestCentroids(this._td),
            groups: this.groups,
        };
    };
    return TDigestStatGroups;
}(TDigestStat));

function tdigestCentroids(td) {
    var means = [];
    var counts = [];
    td.centroids.each(function (c) {
        means.push(c.mean);
        counts.push(c.n);
    });
    return {
        mean: means,
        count: counts,
    };
}
//# sourceMappingURL=tdshared.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module transition
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var interface_1 = __webpack_require__(11);
var transitionHook_1 = __webpack_require__(15);
/**
 * This class returns applicable TransitionHooks for a specific Transition instance.
 *
 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
 * determined by the type of hook)
 *
 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
 *
 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
 * in the Transition class, so we must also provide the Transition's _treeChanges)
 *
 */
var HookBuilder = /** @class */ (function () {
    function HookBuilder(transition) {
        this.transition = transition;
    }
    HookBuilder.prototype.buildHooksForPhase = function (phase) {
        var _this = this;
        var $transitions = this.transition.router.transitionService;
        return $transitions._pluginapi._getEvents(phase)
            .map(function (type) { return _this.buildHooks(type); })
            .reduce(common_1.unnestR, [])
            .filter(common_1.identity);
    };
    /**
     * Returns an array of newly built TransitionHook objects.
     *
     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
     * - For each of the [[PathNode]]s, creates a TransitionHook
     *
     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
     */
    HookBuilder.prototype.buildHooks = function (hookType) {
        var transition = this.transition;
        var treeChanges = transition.treeChanges();
        // Find all the matching registered hooks for a given hook type
        var matchingHooks = this.getMatchingHooks(hookType, treeChanges);
        if (!matchingHooks)
            return [];
        var baseHookOptions = {
            transition: transition,
            current: transition.options().current
        };
        var makeTransitionHooks = function (hook) {
            // Fetch the Nodes that caused this hook to match.
            var matches = hook.matches(treeChanges);
            // Select the PathNode[] that will be used as TransitionHook context objects
            var matchingNodes = matches[hookType.criteriaMatchPath.name];
            // Return an array of HookTuples
            return matchingNodes.map(function (node) {
                var _options = common_1.extend({
                    bind: hook.bind,
                    traceData: { hookType: hookType.name, context: node }
                }, baseHookOptions);
                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
                return { hook: hook, node: node, transitionHook: transitionHook };
            });
        };
        return matchingHooks.map(makeTransitionHooks)
            .reduce(common_1.unnestR, [])
            .sort(tupleSort(hookType.reverseSort))
            .map(function (tuple) { return tuple.transitionHook; });
    };
    /**
     * Finds all RegisteredHooks from:
     * - The Transition object instance hook registry
     * - The TransitionService ($transitions) global hook registry
     *
     * which matched:
     * - the eventType
     * - the matchCriteria (to, from, exiting, retained, entering)
     *
     * @returns an array of matched [[RegisteredHook]]s
     */
    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges) {
        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
        // Instance and Global hook registries
        var $transitions = this.transition.router.transitionService;
        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
        return registries.map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
            .filter(function (hook) { return hook.matches(treeChanges); }); // Only those satisfying matchCriteria
    };
    return HookBuilder;
}());
exports.HookBuilder = HookBuilder;
/**
 * A factory for a sort function for HookTuples.
 *
 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
 * the EventHook priority.
 *
 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
 * @returns a tuple sort function
 */
function tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
    return function nodeDepthThenPriority(l, r) {
        var factor = reverseDepthSort ? -1 : 1;
        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
}
//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @internalapi */
exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */
/** */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var hof_1 = __webpack_require__(5);
var coreservices_1 = __webpack_require__(7);
var paramType_1 = __webpack_require__(30);
/**
 * A registry for parameter types.
 *
 * This registry manages the built-in (and custom) parameter types.
 *
 * The built-in parameter types are:
 *
 * - [[string]]
 * - [[path]]
 * - [[query]]
 * - [[hash]]
 * - [[int]]
 * - [[bool]]
 * - [[date]]
 * - [[json]]
 * - [[any]]
 */
var ParamTypes = /** @class */ (function () {
    /** @internalapi */
    function ParamTypes() {
        /** @hidden */
        this.enqueue = true;
        /** @hidden */
        this.typeQueue = [];
        /** @internalapi */
        this.defaultTypes = common_1.pick(ParamTypes.prototype, ["hash", "string", "query", "path", "int", "bool", "date", "json", "any"]);
        // Register default types. Store them in the prototype of this.types.
        var makeType = function (definition, name) {
            return new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        };
        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
    }
    /** @internalapi */
    ParamTypes.prototype.dispose = function () {
        this.types = {};
    };
    /**
     * Registers a parameter type
     *
     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
     */
    ParamTypes.prototype.type = function (name, definition, definitionFn) {
        if (!predicates_1.isDefined(definition))
            return this.types[name];
        if (this.types.hasOwnProperty(name))
            throw new Error("A type named '" + name + "' has already been defined.");
        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        if (definitionFn) {
            this.typeQueue.push({ name: name, def: definitionFn });
            if (!this.enqueue)
                this._flushTypeQueue();
        }
        return this;
    };
    /** @internalapi */
    ParamTypes.prototype._flushTypeQueue = function () {
        while (this.typeQueue.length) {
            var type = this.typeQueue.shift();
            if (type.pattern)
                throw new Error("You cannot override a type's .pattern at runtime.");
            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
        }
    };
    return ParamTypes;
}());
exports.ParamTypes = ParamTypes;
/** @hidden */
function initDefaultTypes() {
    var makeDefaultType = function (def) {
        var valToString = function (val) {
            return val != null ? val.toString() : val;
        };
        var defaultTypeBase = {
            encode: valToString,
            decode: valToString,
            is: hof_1.is(String),
            pattern: /.*/,
            equals: function (a, b) { return a == b; },
        };
        return common_1.extend({}, defaultTypeBase, def);
    };
    // Default Parameter Type Definitions
    common_1.extend(ParamTypes.prototype, {
        string: makeDefaultType({}),
        path: makeDefaultType({
            pattern: /[^/]*/,
        }),
        query: makeDefaultType({}),
        hash: makeDefaultType({
            inherit: false,
        }),
        int: makeDefaultType({
            decode: function (val) { return parseInt(val, 10); },
            is: function (val) {
                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
            },
            pattern: /-?\d+/,
        }),
        bool: makeDefaultType({
            encode: function (val) { return val && 1 || 0; },
            decode: function (val) { return parseInt(val, 10) !== 0; },
            is: hof_1.is(Boolean),
            pattern: /0|1/,
        }),
        date: makeDefaultType({
            encode: function (val) {
                return !this.is(val) ? undefined : [
                    val.getFullYear(),
                    ('0' + (val.getMonth() + 1)).slice(-2),
                    ('0' + val.getDate()).slice(-2),
                ].join("-");
            },
            decode: function (val) {
                if (this.is(val))
                    return val;
                var match = this.capture.exec(val);
                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
            },
            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
            equals: function (l, r) {
                return ['getFullYear', 'getMonth', 'getDate']
                    .reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
            },
            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
        }),
        json: makeDefaultType({
            encode: common_1.toJson,
            decode: common_1.fromJson,
            is: hof_1.is(Object),
            equals: common_1.equals,
            pattern: /[^/]*/,
        }),
        // does not encode/decode
        any: makeDefaultType({
            encode: common_1.identity,
            decode: common_1.identity,
            is: function () { return true; },
            equals: common_1.equals,
        }),
    });
}
initDefaultTypes();
//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */
/** */
var common_1 = __webpack_require__(3);
/** @internalapi */
var StateParams = /** @class */ (function () {
    function StateParams(params) {
        if (params === void 0) { params = {}; }
        common_1.extend(this, params);
    }
    /**
     * Merges a set of parameters with all parameters inherited between the common parents of the
     * current state and a given destination state.
     *
     * @param {Object} newParams The set of parameters which will be composited with inherited params.
     * @param {Object} $current Internal definition of object representing the current state.
     * @param {Object} $to Internal definition of object representing state to transition to.
     */
    StateParams.prototype.$inherit = function (newParams, $current, $to) {
        var parents = common_1.ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
        for (var i in parents) {
            if (!parents[i] || !parents[i].params)
                continue;
            parentParams = Object.keys(parents[i].params);
            if (!parentParams.length)
                continue;
            for (var j in parentParams) {
                if (inheritList.indexOf(parentParams[j]) >= 0)
                    continue;
                inheritList.push(parentParams[j]);
                inherited[parentParams[j]] = this[parentParams[j]];
            }
        }
        return common_1.extend({}, inherited, newParams);
    };
    ;
    return StateParams;
}());
exports.StateParams = StateParams;
//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module state */ /** for typedoc */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var strings_1 = __webpack_require__(9);
var hof_1 = __webpack_require__(5);
var resolvable_1 = __webpack_require__(16);
var coreservices_1 = __webpack_require__(7);
var parseUrl = function (url) {
    if (!predicates_1.isString(url))
        return false;
    var root = url.charAt(0) === '^';
    return { val: root ? url.substring(1) : url, root: root };
};
function nameBuilder(state) {
    return state.name;
}
function selfBuilder(state) {
    state.self.$$state = function () { return state; };
    return state.self;
}
function dataBuilder(state) {
    if (state.parent && state.parent.data) {
        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
    }
    return state.data;
}
var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
    return function urlBuilder(state) {
        var stateDec = state;
        // For future states, i.e., states whose name ends with `.**`,
        // match anything that starts with the url prefix
        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
            stateDec.url += "{remainder:any}"; // match any path (.*)
        }
        var parsed = parseUrl(stateDec.url), parent = state.parent;
        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
            params: state.params || {},
            paramMap: function (paramConfig, isSearch) {
                if (stateDec.reloadOnSearch === false && isSearch)
                    paramConfig = common_1.extend(paramConfig || {}, { dynamic: true });
                return paramConfig;
            }
        });
        if (!url)
            return null;
        if (!$urlMatcherFactoryProvider.isMatcher(url))
            throw new Error("Invalid url '" + url + "' in state '" + state + "'");
        return (parsed && parsed.root) ? url : ((parent && parent.navigable) || root()).url.append(url);
    };
};
var getNavigableBuilder = function (isRoot) {
    return function navigableBuilder(state) {
        return !isRoot(state) && state.url ? state : (state.parent ? state.parent.navigable : null);
    };
};
var getParamsBuilder = function (paramFactory) {
    return function paramsBuilder(state) {
        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, config); };
        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
        return urlParams.concat(nonUrlParams).map(function (p) { return [p.id, p]; }).reduce(common_1.applyPairs, {});
    };
};
function pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
}
function includesBuilder(state) {
    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
}
/**
 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
 * validates the `resolve` property and converts it to a [[Resolvable]] array.
 *
 * resolve: input value can be:
 *
 * {
 *   // analyzed but not injected
 *   myFooResolve: function() { return "myFooData"; },
 *
 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
 *
 *   // Array split; "DependencyName" dep as string
 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
 *
 *   // Array split; DependencyType dep as token (compared using ===)
 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
 *
 *   // val.$inject used as deps
 *   // where:
 *   //     corgeResolve.$inject = ["DependencyName"];
 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
 *   // then "DependencyName" dep as string
 *   myCorgeResolve: corgeResolve,
 *
 *  // inject service by name
 *  // When a string is found, desugar creating a resolve that injects the named service
 *   myGraultResolve: "SomeService"
 * }
 *
 * or:
 *
 * [
 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
 * ]
 */
function resolvablesBuilder(state) {
    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
    var objects2Tuples = function (resolveObj, resolvePolicies) {
        return Object.keys(resolveObj || {}).map(function (token) { return ({ token: token, val: resolveObj[token], deps: undefined, policy: resolvePolicies[token] }); });
    };
    /** fetch DI annotations from a function or ng1-style array */
    var annotate = function (fn) {
        var $injector = coreservices_1.services.$injector;
        // ng1 doesn't have an $injector until runtime.
        // If the $injector doesn't exist, use "deferred" literal as a
        // marker indicating they should be annotated when runtime starts
        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || "deferred";
    };
    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
    /** true if the object looks like a provide literal, or a ng2 Provider */
    var isLikeNg2Provider = function (obj) { return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass)); };
    /** true if the object looks like a tuple from obj2Tuples */
    var isTupleFromObj = function (obj) { return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val))); };
    /** extracts the token from a Provider or provide literal */
    var token = function (p) { return p.provide || p.token; };
    /** Given a literal resolve or provider object, returns a Resolvable */
    var literal2Resolvable = hof_1.pattern([
        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(token(p), p.resolveFn, p.deps, p.policy); }],
        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(token(p), p.useFactory, (p.deps || p.dependencies), p.policy); }],
        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return new p.useClass(); }, [], p.policy); }],
        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(token(p), common_1.identity, [p.useExisting], p.policy); }],
    ]);
    var tuple2Resolvable = hof_1.pattern([
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
    ]);
    var item2Resolvable = hof_1.pattern([
        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
        [isResolveLiteral, literal2Resolvable],
        [isLikeNg2Provider, literal2Resolvable],
        [isTupleFromObj, tuple2Resolvable],
        [hof_1.val(true), function (obj) { throw new Error("Invalid resolve value: " + strings_1.stringify(obj)); }]
    ]);
    // If resolveBlock is already an array, use it as-is.
    // Otherwise, assume it's an object and convert to an Array of tuples
    var decl = state.resolve;
    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
}
exports.resolvablesBuilder = resolvablesBuilder;
/**
 * @internalapi A internal global service
 *
 * StateBuilder is a factory for the internal [[StateObject]] objects.
 *
 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
 * [[StateObject]] object, which has an API and is used internally.
 *
 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
 * using the [[builder]] method.
 */
var StateBuilder = /** @class */ (function () {
    function StateBuilder(matcher, urlMatcherFactory) {
        this.matcher = matcher;
        var self = this;
        var root = function () { return matcher.find(""); };
        var isRoot = function (state) { return state.name === ""; };
        function parentBuilder(state) {
            if (isRoot(state))
                return null;
            return matcher.find(self.parentName(state)) || root();
        }
        this.builders = {
            name: [nameBuilder],
            self: [selfBuilder],
            parent: [parentBuilder],
            data: [dataBuilder],
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: [getUrlBuilder(urlMatcherFactory, root)],
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: [getNavigableBuilder(isRoot)],
            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
            // Each framework-specific ui-router implementation should define its own `views` builder
            // e.g., src/ng1/statebuilders/views.ts
            views: [],
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: [pathBuilder],
            // Speed up $state.includes() as it's used a lot
            includes: [includesBuilder],
            resolvables: [resolvablesBuilder]
        };
    }
    /**
     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
     * More than one BuilderFunction can be registered for a given property.
     *
     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
     *
     * @param name The name of the State property being registered for.
     * @param fn The BuilderFunction which will be used to build the State property
     * @returns a function which deregisters the BuilderFunction
     */
    StateBuilder.prototype.builder = function (name, fn) {
        var builders = this.builders;
        var array = builders[name] || [];
        // Backwards compat: if only one builder exists, return it, else return whole arary.
        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
            return array.length > 1 ? array : array[0];
        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
            return;
        builders[name] = array;
        builders[name].push(fn);
        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
    };
    /**
     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
     * properties and API built.
     *
     * @param state an uninitialized State object
     * @returns the built State object
     */
    StateBuilder.prototype.build = function (state) {
        var _a = this, matcher = _a.matcher, builders = _a.builders;
        var parent = this.parentName(state);
        if (parent && !matcher.find(parent, undefined, false)) {
            return null;
        }
        for (var key in builders) {
            if (!builders.hasOwnProperty(key))
                continue;
            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
            state[key] = chain(state);
        }
        return state;
    };
    StateBuilder.prototype.parentName = function (state) {
        // name = 'foo.bar.baz.**'
        var name = state.name || "";
        // segments = ['foo', 'bar', 'baz', '.**']
        var segments = name.split('.');
        // segments = ['foo', 'bar', 'baz']
        var lastSegment = segments.pop();
        // segments = ['foo', 'bar'] (ignore .** segment for future states)
        if (lastSegment === '**')
            segments.pop();
        if (segments.length) {
            if (state.parent) {
                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
            }
            // 'foo.bar'
            return segments.join(".");
        }
        if (!state.parent)
            return "";
        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function (state) {
        var name = state.name;
        if (name.indexOf('.') !== -1 || !state.parent)
            return name;
        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
        return parentName ? parentName + "." + name : name;
    };
    return StateBuilder;
}());
exports.StateBuilder = StateBuilder;
//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module state */ /** for typedoc */
var predicates_1 = __webpack_require__(4);
var common_1 = __webpack_require__(3);
var StateMatcher = /** @class */ (function () {
    function StateMatcher(_states) {
        this._states = _states;
    }
    StateMatcher.prototype.isRelative = function (stateName) {
        stateName = stateName || "";
        return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
    };
    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
        if (matchGlob === void 0) { matchGlob = true; }
        if (!stateOrName && stateOrName !== "")
            return undefined;
        var isStr = predicates_1.isString(stateOrName);
        var name = isStr ? stateOrName : stateOrName.name;
        if (this.isRelative(name))
            name = this.resolvePath(name, base);
        var state = this._states[name];
        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
            return state;
        }
        else if (isStr && matchGlob) {
            var _states = common_1.values(this._states);
            var matches = _states.filter(function (state) {
                return state.__stateObjectCache.nameGlob &&
                    state.__stateObjectCache.nameGlob.matches(name);
            });
            if (matches.length > 1) {
                console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
            }
            return matches[0];
        }
        return undefined;
    };
    StateMatcher.prototype.resolvePath = function (name, base) {
        if (!base)
            throw new Error("No reference point given for path '" + name + "'");
        var baseState = this.find(base);
        var splitName = name.split("."), i = 0, pathLength = splitName.length, current = baseState;
        for (; i < pathLength; i++) {
            if (splitName[i] === "" && i === 0) {
                current = baseState;
                continue;
            }
            if (splitName[i] === "^") {
                if (!current.parent)
                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
                current = current.parent;
                continue;
            }
            break;
        }
        var relName = splitName.slice(i).join(".");
        return current.name + (current.name && relName ? "." : "") + relName;
    };
    return StateMatcher;
}());
exports.StateMatcher = StateMatcher;
//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module state */ /** for typedoc */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var stateObject_1 = __webpack_require__(26);
var hof_1 = __webpack_require__(5);
/** @internalapi */
var StateQueueManager = /** @class */ (function () {
    function StateQueueManager($registry, $urlRouter, states, builder, listeners) {
        this.$registry = $registry;
        this.$urlRouter = $urlRouter;
        this.states = states;
        this.builder = builder;
        this.listeners = listeners;
        this.queue = [];
        this.matcher = $registry.matcher;
    }
    /** @internalapi */
    StateQueueManager.prototype.dispose = function () {
        this.queue = [];
    };
    StateQueueManager.prototype.register = function (stateDecl) {
        var queue = this.queue;
        var state = stateObject_1.StateObject.create(stateDecl);
        var name = state.name;
        if (!predicates_1.isString(name))
            throw new Error("State must have a valid name");
        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(hof_1.prop('name')), name))
            throw new Error("State '" + name + "' is already defined");
        queue.push(state);
        this.flush();
        return state;
    };
    StateQueueManager.prototype.flush = function () {
        var _this = this;
        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
        var registered = [], // states that got registered
        orphans = [], // states that don't yet have a parent registered
        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
        var getState = function (name) {
            return _this.states.hasOwnProperty(name) && _this.states[name];
        };
        while (queue.length > 0) {
            var state = queue.shift();
            var name_1 = state.name;
            var result = builder.build(state);
            var orphanIdx = orphans.indexOf(state);
            if (result) {
                var existingState = getState(name_1);
                if (existingState && existingState.name === name_1) {
                    throw new Error("State '" + name_1 + "' is already defined");
                }
                var existingFutureState = getState(name_1 + ".**");
                if (existingFutureState) {
                    // Remove future state of the same name
                    this.$registry.deregister(existingFutureState);
                }
                states[name_1] = state;
                this.attachRoute(state);
                if (orphanIdx >= 0)
                    orphans.splice(orphanIdx, 1);
                registered.push(state);
                continue;
            }
            var prev = previousQueueLength[name_1];
            previousQueueLength[name_1] = queue.length;
            if (orphanIdx >= 0 && prev === queue.length) {
                // Wait until two consecutive iterations where no additional states were dequeued successfully.
                // throw new Error(`Cannot register orphaned state '${name}'`);
                queue.push(state);
                return states;
            }
            else if (orphanIdx < 0) {
                orphans.push(state);
            }
            queue.push(state);
        }
        if (registered.length) {
            this.listeners.forEach(function (listener) { return listener("registered", registered.map(function (s) { return s.self; })); });
        }
        return states;
    };
    StateQueueManager.prototype.attachRoute = function (state) {
        if (state.abstract || !state.url)
            return;
        this.$urlRouter.rule(this.$urlRouter.urlRuleFactory.create(state));
    };
    return StateQueueManager;
}());
exports.StateQueueManager = StateQueueManager;
//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module state
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var stateMatcher_1 = __webpack_require__(41);
var stateBuilder_1 = __webpack_require__(40);
var stateQueueManager_1 = __webpack_require__(42);
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var StateRegistry = /** @class */ (function () {
    /** @internalapi */
    function StateRegistry(_router) {
        this._router = _router;
        this.states = {};
        this.listeners = [];
        this.matcher = new stateMatcher_1.StateMatcher(this.states);
        this.builder = new stateBuilder_1.StateBuilder(this.matcher, _router.urlMatcherFactory);
        this.stateQueue = new stateQueueManager_1.StateQueueManager(this, _router.urlRouter, this.states, this.builder, this.listeners);
        this._registerRoot();
    }
    /** @internalapi */
    StateRegistry.prototype._registerRoot = function () {
        var rootStateDef = {
            name: '',
            url: '^',
            views: null,
            params: {
                '#': { value: null, type: 'hash', dynamic: true }
            },
            abstract: true
        };
        var _root = this._root = this.stateQueue.register(rootStateDef);
        _root.navigable = null;
    };
    /** @internalapi */
    StateRegistry.prototype.dispose = function () {
        var _this = this;
        this.stateQueue.dispose();
        this.listeners = [];
        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
    };
    /**
     * Listen for a State Registry events
     *
     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
     *
     * #### Example:
     * ```js
     * let allStates = registry.get();
     *
     * // Later, invoke deregisterFn() to remove the listener
     * let deregisterFn = registry.onStatesChanged((event, states) => {
     *   switch(event) {
     *     case: 'registered':
     *       states.forEach(state => allStates.push(state));
     *       break;
     *     case: 'deregistered':
     *       states.forEach(state => {
     *         let idx = allStates.indexOf(state);
     *         if (idx !== -1) allStates.splice(idx, 1);
     *       });
     *       break;
     *   }
     * });
     * ```
     *
     * @param listener a callback function invoked when the registered states changes.
     *        The function receives two parameters, `event` and `state`.
     *        See [[StateRegistryListener]]
     * @return a function that deregisters the listener
     */
    StateRegistry.prototype.onStatesChanged = function (listener) {
        this.listeners.push(listener);
        return function deregisterListener() {
            common_1.removeFrom(this.listeners)(listener);
        }.bind(this);
    };
    /**
     * Gets the implicit root state
     *
     * Gets the root of the state tree.
     * The root state is implicitly created by UI-Router.
     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
     *
     * @return the root [[StateObject]]
     */
    StateRegistry.prototype.root = function () {
        return this._root;
    };
    /**
     * Adds a state to the registry
     *
     * Registers a [[StateDeclaration]] or queues it for registration.
     *
     * Note: a state will be queued if the state's parent isn't yet registered.
     *
     * @param stateDefinition the definition of the state to register.
     * @returns the internal [[StateObject]] object.
     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
     *          If the state was only queued, then the object is not fully built.
     */
    StateRegistry.prototype.register = function (stateDefinition) {
        return this.stateQueue.register(stateDefinition);
    };
    /** @hidden */
    StateRegistry.prototype._deregisterTree = function (state) {
        var _this = this;
        var all = this.get().map(function (s) { return s.$$state(); });
        var getChildren = function (states) {
            var children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
            return children.length === 0 ? children : children.concat(getChildren(children));
        };
        var children = getChildren([state]);
        var deregistered = [state].concat(children).reverse();
        deregistered.forEach(function (state) {
            var $ur = _this._router.urlRouter;
            // Remove URL rule
            $ur.rules().filter(hof_1.propEq("state", state)).forEach($ur.removeRule.bind($ur));
            // Remove state from registry
            delete _this.states[state.name];
        });
        return deregistered;
    };
    /**
     * Removes a state from the registry
     *
     * This removes a state from the registry.
     * If the state has children, they are are also removed from the registry.
     *
     * @param stateOrName the state's name or object representation
     * @returns {StateObject[]} a list of removed states
     */
    StateRegistry.prototype.deregister = function (stateOrName) {
        var _state = this.get(stateOrName);
        if (!_state)
            throw new Error("Can't deregister state; not found: " + stateOrName);
        var deregisteredStates = this._deregisterTree(_state.$$state());
        this.listeners.forEach(function (listener) { return listener("deregistered", deregisteredStates.map(function (s) { return s.self; })); });
        return deregisteredStates;
    };
    StateRegistry.prototype.get = function (stateOrName, base) {
        var _this = this;
        if (arguments.length === 0)
            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
        var found = this.matcher.find(stateOrName, base);
        return found && found.self || null;
    };
    StateRegistry.prototype.decorator = function (name, func) {
        return this.builder.builder(name, func);
    };
    return StateRegistry;
}());
exports.StateRegistry = StateRegistry;
//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module state
 */
/** */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var queue_1 = __webpack_require__(27);
var coreservices_1 = __webpack_require__(7);
var pathFactory_1 = __webpack_require__(19);
var pathNode_1 = __webpack_require__(29);
var transitionService_1 = __webpack_require__(31);
var rejectFactory_1 = __webpack_require__(14);
var targetState_1 = __webpack_require__(12);
var param_1 = __webpack_require__(13);
var glob_1 = __webpack_require__(17);
var resolveContext_1 = __webpack_require__(20);
var lazyLoad_1 = __webpack_require__(52);
var hof_1 = __webpack_require__(5);
/**
 * Provides state related service functions
 *
 * This class provides services related to ui-router states.
 * An instance of this class is located on the global [[UIRouter]] object.
 */
var StateService = /** @class */ (function () {
    /** @internalapi */
    function StateService(router) {
        this.router = router;
        /** @internalapi */
        this.invalidCallbacks = [];
        /** @hidden */
        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
            if ($error$ instanceof Error && $error$.stack) {
                console.error($error$);
                console.error($error$.stack);
            }
            else if ($error$ instanceof rejectFactory_1.Rejection) {
                console.error($error$.toString());
                if ($error$.detail && $error$.detail.stack)
                    console.error($error$.detail.stack);
            }
            else {
                console.error($error$);
            }
        };
        var getters = ['current', '$current', 'params', 'transition'];
        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
        /**
         * The [[Transition]] currently in progress (or null)
         *
         * This is a passthrough through to [[UIRouterGlobals.transition]]
         */
        get: function () { return this.router.globals.transition; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
        /**
         * The latest successful state parameters
         *
         * This is a passthrough through to [[UIRouterGlobals.params]]
         */
        get: function () { return this.router.globals.params; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
        /**
         * The current [[StateDeclaration]]
         *
         * This is a passthrough through to [[UIRouterGlobals.current]]
         */
        get: function () { return this.router.globals.current; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
        /**
         * The current [[StateObject]]
         *
         * This is a passthrough through to [[UIRouterGlobals.$current]]
         */
        get: function () { return this.router.globals.$current; },
        enumerable: true,
        configurable: true
    });
    /** @internalapi */
    StateService.prototype.dispose = function () {
        this.defaultErrorHandler(common_1.noop);
        this.invalidCallbacks = [];
    };
    /**
     * Handler for when [[transitionTo]] is called with an invalid state.
     *
     * Invokes the [[onInvalid]] callbacks, in natural order.
     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
     *
     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
     *
     * @internalapi
     */
    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
        var _this = this;
        var fromState = pathFactory_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
        var globals = this.router.globals;
        var latestThing = function () { return globals.transitionHistory.peekTail(); };
        var latest = latestThing();
        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
        var checkForRedirect = function (result) {
            if (!(result instanceof targetState_1.TargetState)) {
                return;
            }
            var target = result;
            // Recreate the TargetState, in case the state is now defined.
            target = _this.target(target.identifier(), target.params(), target.options());
            if (!target.valid()) {
                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
            }
            if (latestThing() !== latest) {
                return rejectFactory_1.Rejection.superseded().toPromise();
            }
            return _this.transitionTo(target.identifier(), target.params(), target.options());
        };
        function invokeNextCallback() {
            var nextCallback = callbackQueue.dequeue();
            if (nextCallback === undefined)
                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
        }
        return invokeNextCallback();
    };
    /**
     * Registers an Invalid State handler
     *
     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
     * has been called with an invalid state reference parameter
     *
     * Example:
     * ```js
     * stateService.onInvalid(function(to, from, injector) {
     *   if (to.name() === 'foo') {
     *     let lazyLoader = injector.get('LazyLoadService');
     *     return lazyLoader.load('foo')
     *         .then(() => stateService.target('foo'));
     *   }
     * });
     * ```
     *
     * @param {function} callback invoked when the toState is invalid
     *   This function receives the (invalid) toState, the fromState, and an injector.
     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
     *   If one is returned, it is treated as a redirect.
     *
     * @returns a function which deregisters the callback
     */
    StateService.prototype.onInvalid = function (callback) {
        this.invalidCallbacks.push(callback);
        return function deregisterListener() {
            common_1.removeFrom(this.invalidCallbacks)(callback);
        }.bind(this);
    };
    /**
     * Reloads the current state
     *
     * A method that force reloads the current state, or a partial state hierarchy.
     * All resolves are re-resolved, and components reinstantiated.
     *
     * #### Example:
     * ```js
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * ```
     *
     * Note: `reload()` is just an alias for:
     *
     * ```js
     * $state.transitionTo($state.current, $state.params, {
     *   reload: true, inherit: false
     * });
     * ```
     *
     * @param reloadState A state name or a state object.
     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
     *
     * #### Example:
     * ```js
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
     * //and current state is 'contacts.detail.item'
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * ```
     *
     * @returns A promise representing the state of the new transition. See [[StateService.go]]
     */
    StateService.prototype.reload = function (reloadState) {
        return this.transitionTo(this.current, this.params, {
            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
            inherit: false,
            notify: false,
        });
    };
    ;
    /**
     * Transition to a different state and/or parameters
     *
     * Convenience method for transitioning to a new state.
     *
     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
     * inherit from the current parameter values (because of `inherit: true`).
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to Absolute state name, state object, or relative state path (relative to current state).
     *
     * Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to the parent state
     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
     *
     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
     *
     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
     *
     * @param options Transition options
     *
     * @returns {promise} A promise representing the state of the new transition.
     */
    StateService.prototype.go = function (to, params, options) {
        var defautGoOpts = { relative: this.$current, inherit: true };
        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
        return this.transitionTo(to, params, transOpts);
    };
    ;
    /**
     * Creates a [[TargetState]]
     *
     * This is a factory method for creating a TargetState
     *
     * This may be returned from a Transition Hook to redirect a transition, for example.
     */
    StateService.prototype.target = function (identifier, params, options) {
        if (options === void 0) { options = {}; }
        // If we're reloading, find the state object to reload from
        if (predicates_1.isObject(options.reload) && !options.reload.name)
            throw new Error('Invalid reload state object');
        var reg = this.router.stateRegistry;
        options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
        if (options.reload && !options.reloadState)
            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
    };
    ;
    StateService.prototype.getCurrentPath = function () {
        var _this = this;
        var globals = this.router.globals;
        var latestSuccess = globals.successfulTransitions.peekTail();
        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    /**
     * Low-level method for transitioning to a new state.
     *
     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to State name or state object.
     * @param toParams A map of the parameters that will be sent to the state,
     *      will populate $stateParams.
     * @param options Transition options
     *
     * @returns A promise representing the state of the new transition. See [[go]]
     */
    StateService.prototype.transitionTo = function (to, toParams, options) {
        var _this = this;
        if (toParams === void 0) { toParams = {}; }
        if (options === void 0) { options = {}; }
        var router = this.router;
        var globals = router.globals;
        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
        var getCurrent = function () {
            return globals.transition;
        };
        options = common_1.extend(options, { current: getCurrent });
        var ref = this.target(to, toParams, options);
        var currentPath = this.getCurrentPath();
        if (!ref.exists())
            return this._handleInvalidTargetState(currentPath, ref);
        if (!ref.valid())
            return common_1.silentRejection(ref.error());
        /**
         * Special handling for Ignored, Aborted, and Redirected transitions
         *
         * The semantics for the transition.run() promise and the StateService.transitionTo()
         * promise differ. For instance, the run() promise may be rejected because it was
         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
         */
        var rejectedTransitionHandler = function (transition) { return function (error) {
            if (error instanceof rejectFactory_1.Rejection) {
                var isLatest = router.globals.lastStartedTransitionId === transition.$id;
                if (error.type === rejectFactory_1.RejectType.IGNORED) {
                    isLatest && router.urlRouter.update();
                    // Consider ignored `Transition.run()` as a successful `transitionTo`
                    return coreservices_1.services.$q.when(globals.current);
                }
                var detail = error.detail;
                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
                    // by returning the promise for the new (redirect) `Transition.run()`.
                    var redirect = transition.redirect(detail);
                    return redirect.run().catch(rejectedTransitionHandler(redirect));
                }
                if (error.type === rejectFactory_1.RejectType.ABORTED) {
                    isLatest && router.urlRouter.update();
                    return coreservices_1.services.$q.reject(error);
                }
            }
            var errorHandler = _this.defaultErrorHandler();
            errorHandler(error);
            return coreservices_1.services.$q.reject(error);
        }; };
        var transition = this.router.transitionService.create(currentPath, ref);
        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
        // Return a promise for the transition, which also has the transition object on it.
        return common_1.extend(transitionToPromise, { transition: transition });
    };
    ;
    /**
     * Checks if the current state *is* the provided state
     *
     * Similar to [[includes]] but only checks for the full state name.
     * If params is supplied then it will be tested for strict equality against the current
     * active params object, so all params must match with none missing and no extras.
     *
     * #### Example:
     * ```js
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     * ```
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * ```html
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * ```
     *
     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns Returns true if it is the state.
     */
    StateService.prototype.is = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state))
            return undefined;
        if (this.$current !== state)
            return false;
        if (!params)
            return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Checks if the current state *includes* the provided state
     *
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * #### Example when `$state.$current.name === 'contacts.details.item'`
     * ```js
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     * ```
     *
     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
     * ```js
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * ```
     *
     * @param stateOrName A partial name, relative name, glob pattern,
     *   or state object to be searched for within the current state name.
     * @param params A param object, e.g. `{sectionId: section.id}`,
     *   that you'd like to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    StateService.prototype.includes = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
        if (glob) {
            if (!glob.matches(this.$current.name))
                return false;
            stateOrName = this.$current.name;
        }
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
        if (!predicates_1.isDefined(state))
            return undefined;
        if (!predicates_1.isDefined(include[state.name]))
            return false;
        if (!params)
            return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Generates a URL for a state and parameters
     *
     * Returns the url for the given state populated with the given params.
     *
     * #### Example:
     * ```js
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * ```
     *
     * @param stateOrName The state name or state object you'd like to generate a url from.
     * @param params An object of parameter values to fill the state's required parameters.
     * @param options Options object. The options are:
     *
     * @returns {string} compiled state url
     */
    StateService.prototype.href = function (stateOrName, params, options) {
        var defaultHrefOpts = {
            lossy: true,
            inherit: true,
            absolute: false,
            relative: this.$current,
        };
        options = common_1.defaults(options, defaultHrefOpts);
        params = params || {};
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state))
            return null;
        if (options.inherit)
            params = this.params.$inherit(params, this.$current, state);
        var nav = (state && options.lossy) ? state.navigable : state;
        if (!nav || nav.url === undefined || nav.url === null) {
            return null;
        }
        return this.router.urlRouter.href(nav.url, params, {
            absolute: options.absolute,
        });
    };
    ;
    /**
     * Sets or gets the default [[transitionTo]] error handler.
     *
     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
     * This includes errors caused by resolves and transition hooks.
     *
     * Note:
     * This handler does not receive certain Transition rejections.
     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
     *
     * The built-in default error handler logs the error to the console.
     *
     * You can provide your own custom handler.
     *
     * #### Example:
     * ```js
     * stateService.defaultErrorHandler(function() {
     *   // Do not log transitionTo errors
     * });
     * ```
     *
     * @param handler a global error handler function
     * @returns the current global error handler
     */
    StateService.prototype.defaultErrorHandler = function (handler) {
        return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function (stateOrName, base) {
        var reg = this.router.stateRegistry;
        if (arguments.length === 0)
            return reg.get();
        return reg.get(stateOrName, base || this.$current);
    };
    /**
     * Lazy loads a state
     *
     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
     *
     * @param stateOrName the state that should be lazy loaded
     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
     * This noop transition is not actually run.
     *
     * @returns a promise to lazy load
     */
    StateService.prototype.lazyLoad = function (stateOrName, transition) {
        var state = this.get(stateOrName);
        if (!state || !state.lazyLoad)
            throw new Error("Can not lazy load " + stateOrName);
        var currentPath = this.getCurrentPath();
        var target = pathFactory_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
        transition = transition || this.router.transitionService.create(currentPath, target);
        return lazyLoad_1.lazyLoadState(transition, state);
    };
    return StateService;
}());
exports.StateService = StateService;
//# sourceMappingURL=stateService.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module core
 */ /** */
var urlMatcherFactory_1 = __webpack_require__(46);
var urlRouter_1 = __webpack_require__(47);
var transitionService_1 = __webpack_require__(31);
var view_1 = __webpack_require__(49);
var stateRegistry_1 = __webpack_require__(43);
var stateService_1 = __webpack_require__(44);
var globals_1 = __webpack_require__(50);
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var urlService_1 = __webpack_require__(51);
var trace_1 = __webpack_require__(10);
/** @hidden */
var _routerInstance = 0;
/**
 * The master class used to instantiate an instance of UI-Router.
 *
 * UI-Router (for each specific framework) will create an instance of this class during bootstrap.
 * This class instantiates and wires the UI-Router services together.
 *
 * After a new instance of the UIRouter class is created, it should be configured for your app.
 * For instance, app states should be registered with the [[UIRouter.stateRegistry]].
 *
 * ---
 *
 * Normally the framework code will bootstrap UI-Router.
 * If you are bootstrapping UIRouter manually, tell it to monitor the URL by calling
 * [[UrlService.listen]] then [[UrlService.sync]].
 */
var UIRouter = /** @class */ (function () {
    /**
     * Creates a new `UIRouter` object
     *
     * @param locationService a [[LocationServices]] implementation
     * @param locationConfig a [[LocationConfig]] implementation
     * @internalapi
     */
    function UIRouter(locationService, locationConfig) {
        if (locationService === void 0) { locationService = urlService_1.UrlService.locationServiceStub; }
        if (locationConfig === void 0) { locationConfig = urlService_1.UrlService.locationConfigStub; }
        this.locationService = locationService;
        this.locationConfig = locationConfig;
        /** @hidden */ this.$id = _routerInstance++;
        /** @hidden */ this._disposed = false;
        /** @hidden */ this._disposables = [];
        /** Provides trace information to the console */
        this.trace = trace_1.trace;
        /** Provides services related to ui-view synchronization */
        this.viewService = new view_1.ViewService();
        /** Provides services related to Transitions */
        this.transitionService = new transitionService_1.TransitionService(this);
        /** Global router state */
        this.globals = new globals_1.UIRouterGlobals();
        /**
         * Deprecated for public use. Use [[urlService]] instead.
         * @deprecated Use [[urlService]] instead
         */
        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
        /**
         * Deprecated for public use. Use [[urlService]] instead.
         * @deprecated Use [[urlService]] instead
         */
        this.urlRouter = new urlRouter_1.UrlRouter(this);
        /** Provides a registry for states, and related registration services */
        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
        /** Provides services related to states */
        this.stateService = new stateService_1.StateService(this);
        /** Provides services related to the URL */
        this.urlService = new urlService_1.UrlService(this);
        /** @hidden */
        this._plugins = {};
        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
        this.globals.$current = this.stateRegistry.root();
        this.globals.current = this.globals.$current.self;
        this.disposable(this.globals);
        this.disposable(this.stateService);
        this.disposable(this.stateRegistry);
        this.disposable(this.transitionService);
        this.disposable(this.urlRouter);
        this.disposable(locationService);
        this.disposable(locationConfig);
    }
    /** Registers an object to be notified when the router is disposed */
    UIRouter.prototype.disposable = function (disposable) {
        this._disposables.push(disposable);
    };
    /**
     * Disposes this router instance
     *
     * When called, clears resources retained by the router by calling `dispose(this)` on all
     * registered [[disposable]] objects.
     *
     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
     *
     * @param disposable (optional) the disposable to dispose
     */
    UIRouter.prototype.dispose = function (disposable) {
        var _this = this;
        if (disposable && predicates_1.isFunction(disposable.dispose)) {
            disposable.dispose(this);
            return undefined;
        }
        this._disposed = true;
        this._disposables.slice().forEach(function (d) {
            try {
                typeof d.dispose === 'function' && d.dispose(_this);
                common_1.removeFrom(_this._disposables, d);
            }
            catch (ignored) { }
        });
    };
    /**
     * Adds a plugin to UI-Router
     *
     * This method adds a UI-Router Plugin.
     * A plugin can enhance or change UI-Router behavior using any public API.
     *
     * #### Example:
     * ```js
     * import { MyCoolPlugin } from "ui-router-cool-plugin";
     *
     * var plugin = router.addPlugin(MyCoolPlugin);
     * ```
     *
     * ### Plugin authoring
     *
     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
     *
     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
     * For example, it may configure router options or add a Transition Hook.
     *
     * The plugin can then be published as a separate module.
     *
     * #### Example:
     * ```js
     * export class MyAuthPlugin implements UIRouterPlugin {
     *   constructor(router: UIRouter, options: any) {
     *     this.name = "MyAuthPlugin";
     *     let $transitions = router.transitionService;
     *     let $state = router.stateService;
     *
     *     let authCriteria = {
     *       to: (state) => state.data && state.data.requiresAuth
     *     };
     *
     *     function authHook(transition: Transition) {
     *       let authService = transition.injector().get('AuthService');
     *       if (!authService.isAuthenticated()) {
     *         return $state.target('login');
     *       }
     *     }
     *
     *     $transitions.onStart(authCriteria, authHook);
     *   }
     * }
     * ```
     *
     * @param plugin one of:
     *        - a plugin class which implements [[UIRouterPlugin]]
     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
     * @param options options to pass to the plugin class/factory
     * @returns the registered plugin instance
     */
    UIRouter.prototype.plugin = function (plugin, options) {
        if (options === void 0) { options = {}; }
        var pluginInstance = new plugin(this, options);
        if (!pluginInstance.name)
            throw new Error("Required property `name` missing on plugin: " + pluginInstance);
        this._disposables.push(pluginInstance);
        return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function (pluginName) {
        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
    };
    return UIRouter;
}());
exports.UIRouter = UIRouter;
//# sourceMappingURL=router.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module url
 */ /** for typedoc */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var urlMatcher_1 = __webpack_require__(21);
var param_1 = __webpack_require__(13);
var paramTypes_1 = __webpack_require__(38);
/**
 * Factory for [[UrlMatcher]] instances.
 *
 * The factory is available to ng1 services as
 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
 */
var UrlMatcherFactory = /** @class */ (function () {
    function UrlMatcherFactory() {
        var _this = this;
        /** @hidden */ this.paramTypes = new paramTypes_1.ParamTypes();
        /** @hidden */ this._isCaseInsensitive = false;
        /** @hidden */ this._isStrictMode = true;
        /** @hidden */ this._defaultSquashPolicy = false;
        /** @hidden */
        this._getConfig = function (config) {
            return common_1.extend({ strict: _this._isStrictMode, caseInsensitive: _this._isCaseInsensitive }, config);
        };
        /** @internalapi Creates a new [[Param]] for a given location (DefType) */
        this.paramFactory = {
            /** Creates a new [[Param]] from a CONFIG block */
            fromConfig: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.CONFIG, _this);
            },
            /** Creates a new [[Param]] from a url PATH */
            fromPath: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.PATH, _this);
            },
            /** Creates a new [[Param]] from a url SEARCH */
            fromSearch: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.SEARCH, _this);
            },
        };
        common_1.extend(this, { UrlMatcher: urlMatcher_1.UrlMatcher, Param: param_1.Param });
    }
    /** @inheritdoc */
    UrlMatcherFactory.prototype.caseInsensitive = function (value) {
        return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.strictMode = function (value) {
        return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.defaultSquashPolicy = function (value) {
        if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value))
            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
        return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
    };
    /**
     * Creates a [[UrlMatcher]] for the specified pattern.
     *
     * @param pattern  The URL pattern.
     * @param config  The config object hash.
     * @returns The UrlMatcher.
     */
    UrlMatcherFactory.prototype.compile = function (pattern, config) {
        return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, this.paramFactory, this._getConfig(config));
    };
    /**
     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
     *
     * @param object  The object to perform the type check against.
     * @returns `true` if the object matches the `UrlMatcher` interface, by
     *          implementing all the same methods.
     */
    UrlMatcherFactory.prototype.isMatcher = function (object) {
        // TODO: typeof?
        if (!predicates_1.isObject(object))
            return false;
        var result = true;
        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
            if (predicates_1.isFunction(val))
                result = result && (predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]));
        });
        return result;
    };
    ;
    /**
     * Creates and registers a custom [[ParamType]] object
     *
     * A [[ParamType]] can be used to generate URLs with typed parameters.
     *
     * @param name  The type name.
     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
     * @param definitionFn A function that is injected before the app runtime starts.
     *        The result of this function should be a [[ParamTypeDefinition]].
     *        The result is merged into the existing `definition`.
     *        See [[ParamType]] for information on the values accepted.
     *
     * @returns - if a type was registered: the [[UrlMatcherFactory]]
     *   - if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
     *
     * Note: Register custom types *before using them* in a state definition.
     *
     * See [[ParamTypeDefinition]] for examples
     */
    UrlMatcherFactory.prototype.type = function (name, definition, definitionFn) {
        var type = this.paramTypes.type(name, definition, definitionFn);
        return !predicates_1.isDefined(definition) ? type : this;
    };
    ;
    /** @hidden */
    UrlMatcherFactory.prototype.$get = function () {
        this.paramTypes.enqueue = false;
        this.paramTypes._flushTypeQueue();
        return this;
    };
    ;
    /** @internalapi */
    UrlMatcherFactory.prototype.dispose = function () {
        this.paramTypes.dispose();
    };
    return UrlMatcherFactory;
}());
exports.UrlMatcherFactory = UrlMatcherFactory;
//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module url
 */
/** for typedoc */
var common_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(4);
var urlMatcher_1 = __webpack_require__(21);
var hof_1 = __webpack_require__(5);
var urlRule_1 = __webpack_require__(48);
var targetState_1 = __webpack_require__(12);
var common_2 = __webpack_require__(8);
/** @hidden */
function appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === '/')
        return url;
    if (isHtml5)
        return common_2.stripFile(baseHref) + url;
    if (absolute)
        return baseHref.slice(1) + url;
    return url;
}
/** @hidden */
var prioritySort = function (a, b) {
    return (b.priority || 0) - (a.priority || 0);
};
/** @hidden */
var typeSort = function (a, b) {
    var weights = { "STATE": 4, "URLMATCHER": 4, "REGEXP": 3, "RAW": 2, "OTHER": 1 };
    return (weights[a.type] || 0) - (weights[b.type] || 0);
};
/** @hidden */
var urlMatcherSort = function (a, b) {
    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
};
/** @hidden */
var idSort = function (a, b) {
    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
    var useMatchPriority = { STATE: true, URLMATCHER: true };
    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
};
/**
 * Default rule priority sorting function.
 *
 * Sorts rules by:
 *
 * - Explicit priority (set rule priority using [[UrlRulesApi.when]])
 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
 * - Rule registration order (for rule types other than STATE and URLMATCHER)
 *   - Equally sorted State and UrlMatcher rules will each match the URL.
 *     Then, the *best* match is chosen based on how many parameter values were matched.
 *
 * @coreapi
 */
var defaultRuleSortFn;
defaultRuleSortFn = function (a, b) {
    var cmp = prioritySort(a, b);
    if (cmp !== 0)
        return cmp;
    cmp = typeSort(a, b);
    if (cmp !== 0)
        return cmp;
    cmp = urlMatcherSort(a, b);
    if (cmp !== 0)
        return cmp;
    return idSort(a, b);
};
/**
 * Updates URL and responds to URL changes
 *
 * ### Deprecation warning:
 * This class is now considered to be an internal API
 * Use the [[UrlService]] instead.
 * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
 *
 * This class updates the URL when the state changes.
 * It also responds to changes in the URL.
 */
var UrlRouter = /** @class */ (function () {
    /** @hidden */
    function UrlRouter(router) {
        /** @hidden */ this._sortFn = defaultRuleSortFn;
        /** @hidden */ this._rules = [];
        /** @hidden */ this.interceptDeferred = false;
        /** @hidden */ this._id = 0;
        /** @hidden */ this._sorted = false;
        this._router = router;
        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
        common_1.createProxyFunctions(hof_1.val(UrlRouter.prototype), this, hof_1.val(this));
    }
    /** @internalapi */
    UrlRouter.prototype.dispose = function () {
        this.listen(false);
        this._rules = [];
        delete this._otherwiseFn;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sort = function (compareFn) {
        this._rules = this.stableSort(this._rules, this._sortFn = compareFn || this._sortFn);
        this._sorted = true;
    };
    UrlRouter.prototype.ensureSorted = function () {
        this._sorted || this.sort();
    };
    UrlRouter.prototype.stableSort = function (arr, compareFn) {
        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
        arrOfWrapper.sort(function (wrapperA, wrapperB) {
            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
            return cmpDiff === 0
                ? wrapperA.idx - wrapperB.idx
                : cmpDiff;
        });
        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
    };
    /**
     * Given a URL, check all rules and return the best [[MatchResult]]
     * @param url
     * @returns {MatchResult}
     */
    UrlRouter.prototype.match = function (url) {
        var _this = this;
        this.ensureSorted();
        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
        var rules = this.rules();
        if (this._otherwiseFn)
            rules.push(this._otherwiseFn);
        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
        var checkRule = function (rule) {
            var match = rule.match(url, _this._router);
            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
        };
        // The rules are pre-sorted.
        // - Find the first matching rule.
        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
        // - Choose the rule with the highest match weight.
        var best;
        for (var i = 0; i < rules.length; i++) {
            // Stop when there is a 'best' rule and the next rule sorts differently than it.
            if (best && this._sortFn(rules[i], best.rule) !== 0)
                break;
            var current = checkRule(rules[i]);
            // Pick the best MatchResult
            best = (!best || current && current.weight > best.weight) ? current : best;
        }
        return best;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sync = function (evt) {
        if (evt && evt.defaultPrevented)
            return;
        var router = this._router, $url = router.urlService, $state = router.stateService;
        var url = {
            path: $url.path(), search: $url.search(), hash: $url.hash(),
        };
        var best = this.match(url);
        var applyResult = hof_1.pattern([
            [predicates_1.isString, function (newurl) { return $url.url(newurl, true); }],
            [targetState_1.TargetState.isDef, function (def) { return $state.go(def.state, def.params, def.options); }],
            [hof_1.is(targetState_1.TargetState), function (target) { return $state.go(target.state(), target.params(), target.options()); }],
        ]);
        applyResult(best && best.rule.handler(best.match, url, router));
    };
    /** @inheritdoc */
    UrlRouter.prototype.listen = function (enabled) {
        var _this = this;
        if (enabled === false) {
            this._stopFn && this._stopFn();
            delete this._stopFn;
        }
        else {
            return this._stopFn = this._stopFn || this._router.urlService.onChange(function (evt) { return _this.sync(evt); });
        }
    };
    /**
     * Internal API.
     * @internalapi
     */
    UrlRouter.prototype.update = function (read) {
        var $url = this._router.locationService;
        if (read) {
            this.location = $url.path();
            return;
        }
        if ($url.path() === this.location)
            return;
        $url.url(this.location, true);
    };
    /**
     * Internal API.
     *
     * Pushes a new location to the browser history.
     *
     * @internalapi
     * @param urlMatcher
     * @param params
     * @param options
     */
    UrlRouter.prototype.push = function (urlMatcher, params, options) {
        var replace = options && !!options.replace;
        this._router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    /**
     * Builds and returns a URL with interpolated parameters
     *
     * #### Example:
     * ```js
     * matcher = $umf.compile("/about/:person");
     * params = { person: "bob" };
     * $bob = $urlRouter.href(matcher, params);
     * // $bob == "/about/bob";
     * ```
     *
     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
     * @param params An object of parameter values to fill the matcher's required parameters.
     * @param options Options object. The options are:
     *
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
     */
    UrlRouter.prototype.href = function (urlMatcher, params, options) {
        var url = urlMatcher.format(params);
        if (url == null)
            return null;
        options = options || { absolute: false };
        var cfg = this._router.urlService.config;
        var isHtml5 = cfg.html5Mode();
        if (!isHtml5 && url !== null) {
            url = "#" + cfg.hashPrefix() + url;
        }
        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
        if (!options.absolute || !url) {
            return url;
        }
        var slash = (!isHtml5 && url ? '/' : ''), port = cfg.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);
        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
    };
    /**
     * Manually adds a URL Rule.
     *
     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
     * Rules can be created using [[UrlRouter.urlRuleFactory]], or create manually as simple objects.
     *
     * A rule should have a `match` function which returns truthy if the rule matched.
     * It should also have a `handler` function which is invoked if the rule is the best match.
     *
     * @return a function that deregisters the rule
     */
    UrlRouter.prototype.rule = function (rule) {
        var _this = this;
        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
            throw new Error("invalid rule");
        rule.$id = this._id++;
        rule.priority = rule.priority || 0;
        this._rules.push(rule);
        this._sorted = false;
        return function () { return _this.removeRule(rule); };
    };
    /** @inheritdoc */
    UrlRouter.prototype.removeRule = function (rule) {
        common_1.removeFrom(this._rules, rule);
    };
    /** @inheritdoc */
    UrlRouter.prototype.rules = function () {
        this.ensureSorted();
        return this._rules.slice();
    };
    /** @inheritdoc */
    UrlRouter.prototype.otherwise = function (handler) {
        var handlerFn = getHandlerFn(handler);
        this._otherwiseFn = this.urlRuleFactory.create(hof_1.val(true), handlerFn);
        this._sorted = false;
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.initial = function (handler) {
        var handlerFn = getHandlerFn(handler);
        var matchFn = function (urlParts, router) {
            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
        };
        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.when = function (matcher, handler, options) {
        var rule = this.urlRuleFactory.create(matcher, handler);
        if (predicates_1.isDefined(options && options.priority))
            rule.priority = options.priority;
        this.rule(rule);
        return rule;
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.deferIntercept = function (defer) {
        if (defer === undefined)
            defer = true;
        this.interceptDeferred = defer;
    };
    ;
    return UrlRouter;
}());
exports.UrlRouter = UrlRouter;
function getHandlerFn(handler) {
    if (!predicates_1.isFunction(handler) && !predicates_1.isString(handler) && !hof_1.is(targetState_1.TargetState)(handler) && !targetState_1.TargetState.isDef(handler)) {
        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
    }
    return predicates_1.isFunction(handler) ? handler : hof_1.val(handler);
}
//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module url
 */ /** */
var urlMatcher_1 = __webpack_require__(21);
var predicates_1 = __webpack_require__(4);
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
/**
 * Creates a [[UrlRule]]
 *
 * Creates a [[UrlRule]] from a:
 *
 * - `string`
 * - [[UrlMatcher]]
 * - `RegExp`
 * - [[StateObject]]
 * @internalapi
 */
var UrlRuleFactory = /** @class */ (function () {
    function UrlRuleFactory(router) {
        this.router = router;
    }
    UrlRuleFactory.prototype.compile = function (str) {
        return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function (what, handler) {
        var _this = this;
        var makeRule = hof_1.pattern([
            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
            [predicates_1.isState, function (_what) { return _this.fromState(_what, _this.router); }],
            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
        ]);
        var rule = makeRule(what);
        if (!rule)
            throw new Error("invalid 'what' in when()");
        return rule;
    };
    /**
     * A UrlRule which matches based on a UrlMatcher
     *
     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     *
     * ## Handler as UrlMatcher
     *
     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
     * The url is replaced with the result.
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var handler = $umf.compile("/home/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     */
    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
        var _handler = handler;
        if (predicates_1.isString(handler))
            handler = this.router.urlMatcherFactory.compile(handler);
        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
            _handler = function (match) { return handler.format(match); };
        function match(url) {
            var match = urlMatcher.exec(url.path, url.search, url.hash);
            return urlMatcher.validates(match) && match;
        }
        // Prioritize URLs, lowest to highest:
        // - Some optional URL parameters, but none matched
        // - No optional parameters in URL
        // - Some optional parameters, some matched
        // - Some optional parameters, all matched
        function matchPriority(params) {
            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
            if (!optional.length)
                return 0.000001;
            var matched = optional.filter(function (param) { return params[param.id]; });
            return matched.length / optional.length;
        }
        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: "URLMATCHER" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    /**
     * A UrlRule which matches a state by its url
     *
     * #### Example:
     * ```js
     * var rule = factory.fromState($state.get('foo'), router);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match);
     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
     * ```
     */
    UrlRuleFactory.prototype.fromState = function (state, router) {
        /**
         * Handles match by transitioning to matched state
         *
         * First checks if the router should start a new transition.
         * A new transition is not required if the current state's URL
         * and the new URL are already identical
         */
        var handler = function (match) {
            var $state = router.stateService;
            var globals = router.globals;
            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
                $state.transitionTo(state, match, { inherit: true, source: "url" });
            }
        };
        var details = { state: state, type: "STATE" };
        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
    };
    /**
     * A UrlRule which matches based on a regular expression
     *
     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - regexp match array (from `regexp`)
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     *
     * ## Handler as string
     *
     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
     * The string is first interpolated using `string.replace()` style pattern.
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     */
    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
        if (regexp.global || regexp.sticky)
            throw new Error("Rule RegExp must not be global or sticky");
        /**
         * If handler is a string, the url will be replaced by the string.
         * If the string has any String.replace() style variables in it (like `$2`),
         * they will be replaced by the captures from [[match]]
         */
        var redirectUrlTo = function (match) {
            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
                return match[what === '$' ? 0 : Number(what)];
            });
        };
        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
        var match = function (url) {
            return regexp.exec(url.path);
        };
        var details = { regexp: regexp, type: "REGEXP" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    UrlRuleFactory.isUrlRule = function (obj) {
        return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); });
    };
    return UrlRuleFactory;
}());
exports.UrlRuleFactory = UrlRuleFactory;
/**
 * A base rule which calls `match`
 *
 * The value from the `match` function is passed through to the `handler`.
 * @internalapi
 */
var BaseUrlRule = /** @class */ (function () {
    function BaseUrlRule(match, handler) {
        var _this = this;
        this.match = match;
        this.type = "RAW";
        this.matchPriority = function (match) { return 0 - _this.$id; };
        this.handler = handler || common_1.identity;
    }
    return BaseUrlRule;
}());
exports.BaseUrlRule = BaseUrlRule;
//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module view
 */ /** for typedoc */
var common_1 = __webpack_require__(3);
var hof_1 = __webpack_require__(5);
var predicates_1 = __webpack_require__(4);
var trace_1 = __webpack_require__(10);
/**
 * The View service
 *
 * This service pairs existing `ui-view` components (which live in the DOM)
 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
 *
 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
 *   The views from exited states are deactivated via [[deactivateViewConfig]].
 *   (See: the [[registerActivateViews]] Transition Hook)
 *
 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
 *
 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
 * are configured with the matching [[ViewConfig]](s)
 *
 */
var ViewService = /** @class */ (function () {
    function ViewService() {
        var _this = this;
        this._uiViews = [];
        this._viewConfigs = [];
        this._viewConfigFactories = {};
        this._pluginapi = {
            _rootViewContext: this._rootViewContext.bind(this),
            _viewConfigFactory: this._viewConfigFactory.bind(this),
            _registeredUIViews: function () { return _this._uiViews; },
            _activeViewConfigs: function () { return _this._viewConfigs; },
        };
    }
    ViewService.prototype._rootViewContext = function (context) {
        return this._rootContext = context || this._rootContext;
    };
    ;
    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
        this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function (path, decl) {
        var cfgFactory = this._viewConfigFactories[decl.$type];
        if (!cfgFactory)
            throw new Error("ViewService: No view config factory registered for type " + decl.$type);
        var cfgs = cfgFactory(path, decl);
        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
    };
    /**
     * Deactivates a ViewConfig.
     *
     * This function deactivates a `ViewConfig`.
     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
     *
     * @param viewConfig The ViewConfig view to deregister.
     */
    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("<- Removing", viewConfig);
        common_1.removeFrom(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("-> Registering", viewConfig);
        this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function () {
        var _this = this;
        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
        // Return a weighted depth value for a uiView.
        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
        // plus the depth of the state that is populating the uiView
        function uiViewDepth(uiView) {
            var stateDepth = function (context) {
                return context && context.parent ? stateDepth(context.parent) + 1 : 1;
            };
            return (uiView.fqn.split(".").length * 10000) + stateDepth(uiView.creationContext);
        }
        // Return the ViewConfig's context's depth in the context tree.
        function viewConfigDepth(config) {
            var context = config.viewDecl.$context, count = 0;
            while (++count && context.parent)
                context = context.parent;
            return count;
        }
        // Given a depth function, returns a compare function which can return either ascending or descending order
        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
        var matchingConfigPair = function (uiView) {
            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
            if (matchingConfigs.length > 1) {
                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
                // Sort by depth and return the match from the deepest child
                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
            }
            return [uiView, matchingConfigs[0]];
        };
        var configureUIView = function (_a) {
            var uiView = _a[0], viewConfig = _a[1];
            // If a parent ui-view is reconfigured, it could destroy child ui-views.
            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
            if (_this._uiViews.indexOf(uiView) !== -1)
                uiView.configUpdated(viewConfig);
        };
        // Sort views by FQN and state depth. Process uiviews nearest the root first.
        var pairs = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
        trace_1.trace.traceViewSync(pairs);
        pairs.forEach(configureUIView);
    };
    ;
    /**
     * Registers a `ui-view` component
     *
     * When a `ui-view` component is created, it uses this method to register itself.
     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
     *
     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
     * and what the view's state context is.
     *
     * Note: There is no corresponding `deregisterUIView`.
     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
     *
     * @param uiView The metadata for a UIView
     * @return a de-registration function used when the view is destroyed.
     */
    ViewService.prototype.registerUIView = function (uiView) {
        trace_1.trace.traceViewServiceUIViewEvent("-> Registering", uiView);
        var uiViews = this._uiViews;
        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
        if (uiViews.filter(fqnAndTypeMatches).length)
            trace_1.trace.traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
        uiViews.push(uiView);
        this.sync();
        return function () {
            var idx = uiViews.indexOf(uiView);
            if (idx === -1) {
                trace_1.trace.traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
                return;
            }
            trace_1.trace.traceViewServiceUIViewEvent("<- Deregistering", uiView);
            common_1.removeFrom(uiViews)(uiView);
        };
    };
    ;
    /**
     * Returns the list of views currently available on the page, by fully-qualified name.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.available = function () {
        return this._uiViews.map(hof_1.prop("fqn"));
    };
    /**
     * Returns the list of views on the page containing loaded content.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.active = function () {
        return this._uiViews.filter(hof_1.prop("$config")).map(hof_1.prop("name"));
    };
    /**
     * Normalizes a view's name from a state.views configuration block.
     *
     * This should be used by a framework implementation to calculate the values for
     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
     *
     * @param context the context object (state declaration) that the view belongs to
     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
     *
     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
     */
    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
        if (rawViewName === void 0) { rawViewName = ""; }
        // TODO: Validate incoming view name with a regexp to allow:
        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
        var viewAtContext = rawViewName.split("@");
        var uiViewName = viewAtContext[0] || "$default"; // default to unnamed view
        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : "^"; // default to parent context
        // Handle relative view-name sugar syntax.
        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
        if (relativeViewNameSugar) {
            // Clobbers existing contextAnchor (rawViewName validation will fix this)
            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
        }
        if (uiViewName.charAt(0) === '!') {
            uiViewName = uiViewName.substr(1);
            uiViewContextAnchor = ""; // target absolutely from root
        }
        // handle parent relative targeting "^.^.^"
        var relativeMatch = /^(\^(?:\.\^)*)$/;
        if (relativeMatch.exec(uiViewContextAnchor)) {
            var anchor = uiViewContextAnchor.split(".").reduce((function (anchor, x) { return anchor.parent; }), context);
            uiViewContextAnchor = anchor.name;
        }
        else if (uiViewContextAnchor === '.') {
            uiViewContextAnchor = context.name;
        }
        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
    };
    /**
     * Given a ui-view and a ViewConfig, determines if they "match".
     *
     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
     *
     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
     *
     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
     *
     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
     * - the ui-view's name matches the ViewConfig's target name
     * - the ui-view's context matches the ViewConfig's anchor
     *
     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
     * - There exists a parent ui-view where:
     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
     *    - the parent ui-view's context matches the ViewConfig's anchor
     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
     *
     * Example:
     *
     * DOM:
     * <ui-view>                        <!-- created in the root context (name: "") -->
     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
     *       </ui-view>
     *     </ui-view>
     *   </ui-view>
     * </ui-view>
     *
     * uiViews: [
     *  { fqn: "$default",                  creationContext: { name: "" } },
     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
     * ]
     *
     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
     *
     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
     *
     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
     *   the tail of the ui-view's fqn "default.bar"
     *
     * @internalapi
     */
    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
        if (uiView.$type !== viewConfig.viewDecl.$type)
            return false;
        // Split names apart from both viewConfig and uiView into segments
        var vc = viewConfig.viewDecl;
        var vcSegments = vc.$uiViewName.split(".");
        var uivSegments = uiView.fqn.split(".");
        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
            return false;
        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
        var negOffset = (1 - vcSegments.length) || undefined;
        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
    }; };
    return ViewService;
}());
exports.ViewService = ViewService;
//# sourceMappingURL=view.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module core
 */ /** */
var stateParams_1 = __webpack_require__(39);
var queue_1 = __webpack_require__(27);
/**
 * Global router state
 *
 * This is where we hold the global mutable state such as current state, current
 * params, current transition, etc.
 */
var UIRouterGlobals = /** @class */ (function () {
    function UIRouterGlobals() {
        /**
         * Current parameter values
         *
         * The parameter values from the latest successful transition
         */
        this.params = new stateParams_1.StateParams();
        /** @internalapi */
        this.lastStartedTransitionId = -1;
        /** @internalapi */
        this.transitionHistory = new queue_1.Queue([], 1);
        /** @internalapi */
        this.successfulTransitions = new queue_1.Queue([], 1);
    }
    UIRouterGlobals.prototype.dispose = function () {
        this.transitionHistory.clear();
        this.successfulTransitions.clear();
        this.transition = null;
    };
    return UIRouterGlobals;
}());
exports.UIRouterGlobals = UIRouterGlobals;
//# sourceMappingURL=globals.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module url
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var coreservices_1 = __webpack_require__(7);
var common_1 = __webpack_require__(3);
/** @hidden */
var makeStub = function (keys) {
    return keys.reduce(function (acc, key) { return (acc[key] = coreservices_1.notImplemented(key), acc); }, { dispose: common_1.noop });
};
/** @hidden */ var locationServicesFns = ["url", "path", "search", "hash", "onChange"];
/** @hidden */ var locationConfigFns = ["port", "protocol", "host", "baseHref", "html5Mode", "hashPrefix"];
/** @hidden */ var umfFns = ["type", "caseInsensitive", "strictMode", "defaultSquashPolicy"];
/** @hidden */ var rulesFns = ["sort", "when", "initial", "otherwise", "rules", "rule", "removeRule"];
/** @hidden */ var syncFns = ["deferIntercept", "listen", "sync", "match"];
/**
 * API for URL management
 */
var UrlService = /** @class */ (function () {
    /** @hidden */
    function UrlService(router, lateBind) {
        if (lateBind === void 0) { lateBind = true; }
        this.router = router;
        this.rules = {};
        this.config = {};
        // proxy function calls from UrlService to the LocationService/LocationConfig
        var locationServices = function () { return router.locationService; };
        common_1.createProxyFunctions(locationServices, this, locationServices, locationServicesFns, lateBind);
        var locationConfig = function () { return router.locationConfig; };
        common_1.createProxyFunctions(locationConfig, this.config, locationConfig, locationConfigFns, lateBind);
        var umf = function () { return router.urlMatcherFactory; };
        common_1.createProxyFunctions(umf, this.config, umf, umfFns);
        var urlRouter = function () { return router.urlRouter; };
        common_1.createProxyFunctions(urlRouter, this.rules, urlRouter, rulesFns);
        common_1.createProxyFunctions(urlRouter, this, urlRouter, syncFns);
    }
    UrlService.prototype.url = function (newurl, replace, state) { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.path = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.search = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.hash = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.onChange = function (callback) { return; };
    ;
    /**
     * Returns the current URL parts
     *
     * This method returns the current URL components as a [[UrlParts]] object.
     *
     * @returns the current url parts
     */
    UrlService.prototype.parts = function () {
        return { path: this.path(), search: this.search(), hash: this.hash() };
    };
    UrlService.prototype.dispose = function () { };
    /** @inheritdoc */
    UrlService.prototype.sync = function (evt) { return; };
    /** @inheritdoc */
    UrlService.prototype.listen = function (enabled) { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.deferIntercept = function (defer) { return; };
    /** @inheritdoc */
    UrlService.prototype.match = function (urlParts) { return; };
    /** @hidden */
    UrlService.locationServiceStub = makeStub(locationServicesFns);
    /** @hidden */
    UrlService.locationConfigStub = makeStub(locationConfigFns);
    return UrlService;
}());
exports.UrlService = UrlService;
//# sourceMappingURL=urlService.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coreservices_1 = __webpack_require__(7);
/**
 * A [[TransitionHookFn]] that performs lazy loading
 *
 * When entering a state "abc" which has a `lazyLoad` function defined:
 * - Invoke the `lazyLoad` function (unless it is already in process)
 *   - Flag the hook function as "in process"
 *   - The function should return a promise (that resolves when lazy loading is complete)
 * - Wait for the promise to settle
 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
 *   - Flag the hook function as "not in process"
 * - If the hook was successful
 *   - Remove the `lazyLoad` function from the state declaration
 * - If all the hooks were successful
 *   - Retry the transition (by returning a TargetState)
 *
 * ```
 * .state('abc', {
 *   component: 'fooComponent',
 *   lazyLoad: () => System.import('./fooComponent')
 *   });
 * ```
 *
 * See [[StateDeclaration.lazyLoad]]
 */
var lazyLoadHook = function (transition) {
    var router = transition.router;
    function retryTransition() {
        if (transition.originalTransition().options().source !== 'url') {
            // The original transition was not triggered via url sync
            // The lazy state should be loaded now, so re-try the original transition
            var orig = transition.targetState();
            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        // The original transition was triggered via url sync
        // Run the URL rules and find the best match
        var $url = router.urlService;
        var result = $url.match($url.parts());
        var rule = result && result.rule;
        // If the best match is a state, redirect the transition (instead
        // of calling sync() which supersedes the current transition)
        if (rule && rule.type === "STATE") {
            var state = rule.state;
            var params = result.match;
            return router.stateService.target(state, params, transition.options());
        }
        // No matching state found, so let .sync() choose the best non-state match/otherwise
        router.urlService.sync();
    }
    var promises = transition.entering()
        .filter(function (state) { return !!state.$$state().lazyLoad; })
        .map(function (state) { return lazyLoadState(transition, state); });
    return coreservices_1.services.$q.all(promises).then(retryTransition);
};
exports.registerLazyLoadHook = function (transitionService) {
    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
};
/**
 * Invokes a state's lazy load function
 *
 * @param transition a Transition context
 * @param state the state to lazy load
 * @returns A promise for the lazy load result
 */
function lazyLoadState(transition, state) {
    var lazyLoadFn = state.$$state().lazyLoad;
    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
    var promise = lazyLoadFn['_promise'];
    if (!promise) {
        var success = function (result) {
            delete state.lazyLoad;
            delete state.$$state().lazyLoad;
            delete lazyLoadFn['_promise'];
            return result;
        };
        var error = function (err) {
            delete lazyLoadFn['_promise'];
            return coreservices_1.services.$q.reject(err);
        };
        promise = lazyLoadFn['_promise'] =
            coreservices_1.services.$q.when(lazyLoadFn(transition, state))
                .then(updateStateRegistry)
                .then(success, error);
    }
    /** Register any lazy loaded state definitions */
    function updateStateRegistry(result) {
        if (result && Array.isArray(result.states)) {
            result.states.forEach(function (state) { return transition.router.stateRegistry.register(state); });
        }
        return result;
    }
    return promise;
}
exports.lazyLoadState = lazyLoadState;
//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var transitionHook_1 = __webpack_require__(15);
/**
 * This class defines a type of hook, such as `onBefore` or `onEnter`.
 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
 *
 * @interalapi
 */
var TransitionEventType = /** @class */ (function () {
    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
        if (reverseSort === void 0) { reverseSort = false; }
        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
        if (synchronous === void 0) { synchronous = false; }
        this.name = name;
        this.hookPhase = hookPhase;
        this.hookOrder = hookOrder;
        this.criteriaMatchPath = criteriaMatchPath;
        this.reverseSort = reverseSort;
        this.getResultHandler = getResultHandler;
        this.getErrorHandler = getErrorHandler;
        this.synchronous = synchronous;
    }
    return TransitionEventType;
}());
exports.TransitionEventType = TransitionEventType;
//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var index_1 = __webpack_require__(8);
/**
 * An angular1-like promise api
 *
 * This object implements four methods similar to the
 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
 *
 * UI-Router evolved from an angular 1 library to a framework agnostic library.
 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
 *
 * This API provides native ES6 promise support wrapped as a $q-like API.
 * Internally, UI-Router uses this $q object to perform promise operations.
 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
 *
 * $q-like promise api
 */
exports.$q = {
    /** Normalizes a value as a promise */
    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
    /** Normalizes a value as a promise rejection */
    reject: function (val) { return new Promise(function (resolve, reject) { reject(val); }); },
    /** @returns a deferred object, which has `resolve` and `reject` functions */
    defer: function () {
        var deferred = {};
        deferred.promise = new Promise(function (resolve, reject) {
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    },
    /** Like Promise.all(), but also supports object key/promise notation like $q */
    all: function (promises) {
        if (index_1.isArray(promises)) {
            return Promise.all(promises);
        }
        if (index_1.isObject(promises)) {
            // Convert promises map to promises array.
            // When each promise resolves, map it to a tuple { key: key, val: val }
            var chain = Object.keys(promises)
                .map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
            // Then wait for all promises to resolve, and convert them back to an object
            return exports.$q.all(chain).then(function (values) {
                return values.reduce(function (acc, tuple) { acc[tuple.key] = tuple.val; return acc; }, {});
            });
        }
    }
};
//# sourceMappingURL=q.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var index_1 = __webpack_require__(8);
// globally available injectables
var globals = {};
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var ARGUMENT_NAMES = /([^\s,]+)/g;
/**
 * A basic angular1-like injector api
 *
 * This object implements four methods similar to the
 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
 *
 * UI-Router evolved from an angular 1 library to a framework agnostic library.
 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
 *
 * This object provides a naive implementation of a globally scoped dependency injection system.
 * It supports the following DI approaches:
 *
 * ### Function parameter names
 *
 * A function's `.toString()` is called, and the parameter names are parsed.
 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
 *
 * ```js
 * function injectedFunction(FooService, BarService) {
 *   // FooService and BarService are injected
 * }
 * ```
 *
 * ### Function annotation
 *
 * A function may be annotated with an array of dependency names as the `$inject` property.
 *
 * ```js
 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
 * function injectedFunction(fs, bs) {
 *   // FooService and BarService are injected as fs and bs parameters
 * }
 * ```
 *
 * ### Array notation
 *
 * An array provides the names of the dependencies to inject (as strings).
 * The function is the last element of the array.
 *
 * ```js
 * [ 'FooService', 'BarService', function (fs, bs) {
 *   // FooService and BarService are injected as fs and bs parameters
 * }]
 * ```
 *
 * @type {$InjectorLike}
 */
exports.$injector = {
    /** Gets an object from DI based on a string token */
    get: function (name) { return globals[name]; },
    /** Returns true if an object named `name` exists in global DI */
    has: function (name) { return exports.$injector.get(name) != null; },
    /**
     * Injects a function
     *
     * @param fn the function to inject
     * @param context the function's `this` binding
     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
     */
    invoke: function (fn, context, locals) {
        var all = index_1.extend({}, globals, locals || {});
        var params = exports.$injector.annotate(fn);
        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
        if (index_1.isFunction(fn))
            return fn.apply(context, args);
        else
            return fn.slice(-1)[0].apply(context, args);
    },
    /**
     * Returns a function's dependencies
     *
     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
     * @return an array of `string`s
     */
    annotate: function (fn) {
        if (!index_1.isInjectable(fn))
            throw new Error("Not an injectable function: " + fn);
        if (fn && fn.$inject)
            return fn.$inject;
        if (index_1.isArray(fn))
            return fn.slice(0, -1);
        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
        return result || [];
    }
};
//# sourceMappingURL=injector.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var common_1 = __webpack_require__(8);
var baseLocationService_1 = __webpack_require__(22);
/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
var HashLocationService = /** @class */ (function (_super) {
    __extends(HashLocationService, _super);
    function HashLocationService(router) {
        var _this = _super.call(this, router, false) || this;
        common_1.root.addEventListener('hashchange', _this._listener, false);
        return _this;
    }
    HashLocationService.prototype._get = function () {
        return common_1.trimHashVal(this._location.hash);
    };
    HashLocationService.prototype._set = function (state, title, url, replace) {
        this._location.hash = url;
    };
    HashLocationService.prototype.dispose = function (router) {
        _super.prototype.dispose.call(this, router);
        common_1.root.removeEventListener('hashchange', this._listener);
    };
    return HashLocationService;
}(baseLocationService_1.BaseLocationServices));
exports.HashLocationService = HashLocationService;
//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var baseLocationService_1 = __webpack_require__(22);
/** A `LocationServices` that gets/sets the current location from an in-memory object */
var MemoryLocationService = /** @class */ (function (_super) {
    __extends(MemoryLocationService, _super);
    function MemoryLocationService(router) {
        return _super.call(this, router, true) || this;
    }
    MemoryLocationService.prototype._get = function () {
        return this._url;
    };
    MemoryLocationService.prototype._set = function (state, title, url, replace) {
        this._url = url;
    };
    return MemoryLocationService;
}(baseLocationService_1.BaseLocationServices));
exports.MemoryLocationService = MemoryLocationService;
//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var baseLocationService_1 = __webpack_require__(22);
var common_1 = __webpack_require__(8);
/**
 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
 *
 * Uses `history.pushState` and `history.replaceState`
 */
var PushStateLocationService = /** @class */ (function (_super) {
    __extends(PushStateLocationService, _super);
    function PushStateLocationService(router) {
        var _this = _super.call(this, router, true) || this;
        _this._config = router.urlService.config;
        common_1.root.addEventListener('popstate', _this._listener, false);
        return _this;
    }
    ;
    /**
     * Gets the base prefix without:
     * - trailing slash
     * - trailing filename
     * - protocol and hostname
     *
     * If <base href='/base/index.html'>, this returns '/base'.
     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
     *
     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
     */
    PushStateLocationService.prototype._getBasePrefix = function () {
        return common_1.stripFile(this._config.baseHref());
    };
    PushStateLocationService.prototype._get = function () {
        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
        search = common_1.splitQuery(search)[1]; // strip ? if found
        hash = common_1.splitHash(hash)[1]; // strip # if found
        var basePrefix = this._getBasePrefix();
        var exactMatch = pathname === this._config.baseHref();
        var startsWith = pathname.startsWith(basePrefix);
        pathname = exactMatch ? '/' : startsWith ? pathname.substring(basePrefix.length) : pathname;
        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
    };
    PushStateLocationService.prototype._set = function (state, title, url, replace) {
        var fullUrl = this._getBasePrefix() + url;
        if (replace) {
            this._history.replaceState(state, title, fullUrl);
        }
        else {
            this._history.pushState(state, title, fullUrl);
        }
    };
    PushStateLocationService.prototype.dispose = function (router) {
        _super.prototype.dispose.call(this, router);
        common_1.root.removeEventListener('popstate', this._listener);
    };
    return PushStateLocationService;
}(baseLocationService_1.BaseLocationServices));
exports.PushStateLocationService = PushStateLocationService;
//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var predicates_1 = __webpack_require__(4);
var common_1 = __webpack_require__(3);
/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
var MemoryLocationConfig = /** @class */ (function () {
    function MemoryLocationConfig() {
        var _this = this;
        this._baseHref = '';
        this._port = 80;
        this._protocol = "http";
        this._host = "localhost";
        this._hashPrefix = "";
        this.port = function () { return _this._port; };
        this.protocol = function () { return _this._protocol; };
        this.host = function () { return _this._host; };
        this.baseHref = function () { return _this._baseHref; };
        this.html5Mode = function () { return false; };
        this.hashPrefix = function (newval) { return predicates_1.isDefined(newval) ? _this._hashPrefix = newval : _this._hashPrefix; };
        this.dispose = common_1.noop;
    }
    return MemoryLocationConfig;
}());
exports.MemoryLocationConfig = MemoryLocationConfig;
//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var predicates_1 = __webpack_require__(4);
/** A `LocationConfig` that delegates to the browser's `location` object */
var BrowserLocationConfig = /** @class */ (function () {
    function BrowserLocationConfig(router, _isHtml5) {
        if (_isHtml5 === void 0) { _isHtml5 = false; }
        this._isHtml5 = _isHtml5;
        this._baseHref = undefined;
        this._hashPrefix = "";
    }
    BrowserLocationConfig.prototype.port = function () {
        if (location.port) {
            return Number(location.port);
        }
        return this.protocol() === 'https' ? 443 : 80;
    };
    BrowserLocationConfig.prototype.protocol = function () {
        return location.protocol.replace(/:/g, '');
    };
    BrowserLocationConfig.prototype.host = function () {
        return location.hostname;
    };
    BrowserLocationConfig.prototype.html5Mode = function () {
        return this._isHtml5;
    };
    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
        return predicates_1.isDefined(newprefix) ? this._hashPrefix = newprefix : this._hashPrefix;
    };
    ;
    BrowserLocationConfig.prototype.baseHref = function (href) {
        return predicates_1.isDefined(href) ? this._baseHref = href :
            predicates_1.isDefined(this._baseHref) ? this._baseHref : this.applyDocumentBaseHref();
    };
    BrowserLocationConfig.prototype.applyDocumentBaseHref = function () {
        var baseTag = document.getElementsByTagName("base")[0];
        return this._baseHref = baseTag ? baseTag.href.substr(location.origin.length) : "";
    };
    BrowserLocationConfig.prototype.dispose = function () { };
    return BrowserLocationConfig;
}());
exports.BrowserLocationConfig = BrowserLocationConfig;
//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(340);
module.exports = 'vcRecaptcha';


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifier__ = __webpack_require__(391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Notifier", function() { return __WEBPACK_IMPORTED_MODULE_0__notifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_notifier__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BaseNotifier", function() { return __WEBPACK_IMPORTED_MODULE_1__base_notifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queries__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryInfo", function() { return __WEBPACK_IMPORTED_MODULE_2__queries__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scope__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scope", function() { return __WEBPACK_IMPORTED_MODULE_3__scope__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseNotifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsonify_notice__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__processor_esp__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_angular_message__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filter_debounce__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter_ignore_noise__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filter_uncaught_message__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http_req__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__queries__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__queues__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__version__ = __webpack_require__(415);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};













var BaseNotifier = /** @class */ (function () {
    function BaseNotifier(opt) {
        var _this = this;
        this._filters = [];
        this._performanceFilters = [];
        this._scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */]();
        this._onClose = [];
        if (!opt.projectId || !opt.projectKey) {
            throw new Error('airbrake: projectId and projectKey are required');
        }
        this._opt = opt;
        this._opt.host = this._opt.host || 'https://api.airbrake.io';
        this._opt.timeout = this._opt.timeout || 10000;
        this._opt.keysBlocklist = this._opt.keysBlocklist ||
            this._opt.keysBlacklist || [/password/, /secret/];
        this._url = this._opt.host + "/api/v3/projects/" + this._opt.projectId + "/notices?key=" + this._opt.projectKey;
        this._processor = this._opt.processor || __WEBPACK_IMPORTED_MODULE_3__processor_esp__["a" /* espProcessor */];
        this._requester = Object(__WEBPACK_IMPORTED_MODULE_8__http_req__["a" /* makeRequester */])(this._opt);
        this.addFilter(__WEBPACK_IMPORTED_MODULE_6__filter_ignore_noise__["a" /* ignoreNoiseFilter */]);
        this.addFilter(Object(__WEBPACK_IMPORTED_MODULE_5__filter_debounce__["a" /* makeDebounceFilter */])());
        this.addFilter(__WEBPACK_IMPORTED_MODULE_7__filter_uncaught_message__["a" /* uncaughtMessageFilter */]);
        this.addFilter(__WEBPACK_IMPORTED_MODULE_4__filter_angular_message__["a" /* angularMessageFilter */]);
        this.addFilter(function (notice) {
            notice.context.notifier = {
                name: __WEBPACK_IMPORTED_MODULE_12__version__["a" /* NOTIFIER_NAME */],
                version: __WEBPACK_IMPORTED_MODULE_12__version__["c" /* NOTIFIER_VERSION */],
                url: __WEBPACK_IMPORTED_MODULE_12__version__["b" /* NOTIFIER_URL */],
            };
            if (_this._opt.environment) {
                notice.context.environment = _this._opt.environment;
            }
            return notice;
        });
        this.routes = new Routes(this);
        this.queues = new Queues(this);
        this.queries = new __WEBPACK_IMPORTED_MODULE_9__queries__["a" /* QueriesStats */](this._opt);
    }
    BaseNotifier.prototype.close = function () {
        for (var _i = 0, _a = this._onClose; _i < _a.length; _i++) {
            var fn = _a[_i];
            fn();
        }
    };
    BaseNotifier.prototype.scope = function () {
        return this._scope;
    };
    BaseNotifier.prototype.setActiveScope = function (scope) {
        this._scope = scope;
    };
    BaseNotifier.prototype.addFilter = function (filter) {
        this._filters.push(filter);
    };
    BaseNotifier.prototype.addPerformanceFilter = function (performanceFilter) {
        this._performanceFilters.push(performanceFilter);
    };
    BaseNotifier.prototype.notify = function (err) {
        var notice = {
            errors: [],
            context: __assign(__assign({ severity: 'error' }, this.scope().context()), err.context),
            params: err.params || {},
            environment: err.environment || {},
            session: err.session || {},
        };
        if (typeof err !== 'object' || err.error === undefined) {
            err = { error: err };
        }
        if (!err.error) {
            notice.error = new Error("airbrake: got err=" + JSON.stringify(err.error) + ", wanted an Error");
            return __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__["a" /* default */].resolve(notice);
        }
        var error = this._processor(err.error);
        notice.errors.push(error);
        for (var _i = 0, _a = this._filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            var r = filter(notice);
            if (r === null) {
                notice.error = new Error('airbrake: error is filtered');
                return __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__["a" /* default */].resolve(notice);
            }
            notice = r;
        }
        if (!notice.context) {
            notice.context = {};
        }
        notice.context.language = 'JavaScript';
        return this._sendNotice(notice);
    };
    BaseNotifier.prototype._sendNotice = function (notice) {
        var body = Object(__WEBPACK_IMPORTED_MODULE_1__jsonify_notice__["a" /* jsonifyNotice */])(notice, {
            keysBlocklist: this._opt.keysBlocklist,
        });
        if (this._opt.reporter) {
            if (typeof this._opt.reporter === 'function') {
                return this._opt.reporter(notice);
            }
            else {
                console.warn('airbrake: options.reporter must be a function');
            }
        }
        var req = {
            method: 'POST',
            url: this._url,
            body: body,
        };
        return this._requester(req)
            .then(function (resp) {
            notice.id = resp.json.id;
            notice.url = resp.json.url;
            return notice;
        })
            .catch(function (err) {
            notice.error = err;
            return notice;
        });
    };
    BaseNotifier.prototype.wrap = function (fn, props) {
        if (props === void 0) { props = []; }
        if (fn._airbrake) {
            return fn;
        }
        // tslint:disable-next-line:no-this-assignment
        var client = this;
        var airbrakeWrapper = function () {
            var fnArgs = Array.prototype.slice.call(arguments);
            var wrappedArgs = client._wrapArguments(fnArgs);
            try {
                return fn.apply(this, wrappedArgs);
            }
            catch (err) {
                client.notify({ error: err, params: { arguments: fnArgs } });
                this._ignoreNextWindowError();
                throw err;
            }
        };
        for (var prop in fn) {
            if (fn.hasOwnProperty(prop)) {
                airbrakeWrapper[prop] = fn[prop];
            }
        }
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
            var prop = props_1[_i];
            if (fn.hasOwnProperty(prop)) {
                airbrakeWrapper[prop] = fn[prop];
            }
        }
        airbrakeWrapper._airbrake = true;
        airbrakeWrapper.inner = fn;
        return airbrakeWrapper;
    };
    BaseNotifier.prototype._wrapArguments = function (args) {
        for (var i = 0; i < args.length; i++) {
            var arg = args[i];
            if (typeof arg === 'function') {
                args[i] = this.wrap(arg);
            }
        }
        return args;
    };
    BaseNotifier.prototype._ignoreNextWindowError = function () { };
    BaseNotifier.prototype.call = function (fn) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        var wrapper = this.wrap(fn);
        return wrapper.apply(this, Array.prototype.slice.call(arguments, 1));
    };
    return BaseNotifier;
}());

var Routes = /** @class */ (function () {
    function Routes(notifier) {
        this._notifier = notifier;
        this._routes = new __WEBPACK_IMPORTED_MODULE_11__routes__["c" /* RoutesStats */](notifier._opt);
        this._breakdowns = new __WEBPACK_IMPORTED_MODULE_11__routes__["b" /* RoutesBreakdowns */](notifier._opt);
    }
    Routes.prototype.start = function (method, route, statusCode, contentType) {
        if (method === void 0) { method = ''; }
        if (route === void 0) { route = ''; }
        if (statusCode === void 0) { statusCode = 0; }
        if (contentType === void 0) { contentType = ''; }
        var metric = new __WEBPACK_IMPORTED_MODULE_11__routes__["a" /* RouteMetric */](method, route, statusCode, contentType);
        var scope = this._notifier.scope().clone();
        scope.setContext({ httpMethod: method, route: route });
        scope.setRouteMetric(metric);
        this._notifier.setActiveScope(scope);
        return metric;
    };
    Routes.prototype.notify = function (req) {
        req.end();
        for (var _i = 0, _a = this._notifier._performanceFilters; _i < _a.length; _i++) {
            var performanceFilter = _a[_i];
            if (performanceFilter(req) === null) {
                return;
            }
        }
        this._routes.notify(req);
        this._breakdowns.notify(req);
    };
    return Routes;
}());
var Queues = /** @class */ (function () {
    function Queues(notifier) {
        this._notifier = notifier;
        this._queues = new __WEBPACK_IMPORTED_MODULE_10__queues__["b" /* QueuesStats */](notifier._opt);
    }
    Queues.prototype.start = function (queue) {
        var metric = new __WEBPACK_IMPORTED_MODULE_10__queues__["a" /* QueueMetric */](queue);
        var scope = this._notifier.scope().clone();
        scope.setContext({ queue: queue });
        scope.setQueueMetric(metric);
        this._notifier.setActiveScope(scope);
        return metric;
    };
    Queues.prototype.notify = function (q) {
        q.end();
        this._queues.notify(q);
    };
    return Queues;
}());
//# sourceMappingURL=base_notifier.js.map

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metrics__ = __webpack_require__(33);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Scope = /** @class */ (function () {
    function Scope() {
        this._noopMetric = new __WEBPACK_IMPORTED_MODULE_0__metrics__["b" /* NoopMetric */]();
        this._context = {};
        this._historyMaxLen = 20;
        this._history = [];
    }
    Scope.prototype.clone = function () {
        var clone = new Scope();
        clone._context = __assign({}, this._context);
        clone._history = this._history.slice();
        return clone;
    };
    Scope.prototype.setContext = function (context) {
        this._context = __assign(__assign({}, this._context), context);
    };
    Scope.prototype.context = function () {
        var ctx = __assign({}, this._context);
        if (this._history.length > 0) {
            ctx.history = this._history.slice();
        }
        return ctx;
    };
    Scope.prototype.pushHistory = function (state) {
        if (this._isDupState(state)) {
            if (this._lastRecord.num) {
                this._lastRecord.num++;
            }
            else {
                this._lastRecord.num = 2;
            }
            return;
        }
        if (!state.date) {
            state.date = new Date();
        }
        this._history.push(state);
        this._lastRecord = state;
        if (this._history.length > this._historyMaxLen) {
            this._history = this._history.slice(-this._historyMaxLen);
        }
    };
    Scope.prototype._isDupState = function (state) {
        if (!this._lastRecord) {
            return false;
        }
        for (var key in state) {
            if (!state.hasOwnProperty(key) || key === 'date') {
                continue;
            }
            if (state[key] !== this._lastRecord[key]) {
                return false;
            }
        }
        return true;
    };
    Scope.prototype.routeMetric = function () {
        return this._routeMetric || this._noopMetric;
    };
    Scope.prototype.setRouteMetric = function (metric) {
        this._routeMetric = metric;
    };
    Scope.prototype.queueMetric = function () {
        return this._queueMetric || this._noopMetric;
    };
    Scope.prototype.setQueueMetric = function (metric) {
        this._queueMetric = metric;
    };
    return Scope;
}());

//# sourceMappingURL=scope.js.map

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errors; });
var errors = {
    unauthorized: new Error('airbrake: unauthorized: project id or key are wrong'),
    ipRateLimited: new Error('airbrake: IP is rate limited'),
};
//# sourceMappingURL=api.js.map

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QueryInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueriesStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_req__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tdshared__ = __webpack_require__(34);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var FLUSH_INTERVAL = 15000; // 15 seconds
var QueryInfo = /** @class */ (function () {
    function QueryInfo(query) {
        if (query === void 0) { query = ''; }
        this.method = '';
        this.route = '';
        this.query = '';
        this.func = '';
        this.file = '';
        this.line = 0;
        this.startTime = new Date();
        this.query = query;
    }
    QueryInfo.prototype._duration = function () {
        if (!this.endTime) {
            this.endTime = new Date();
        }
        return this.endTime.getTime() - this.startTime.getTime();
    };
    return QueryInfo;
}());

var QueriesStats = /** @class */ (function () {
    function QueriesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/queries-stats?key=" + opt.projectKey;
        this._requester = Object(__WEBPACK_IMPORTED_MODULE_0__http_req__["a" /* makeRequester */])(opt);
    }
    QueriesStats.prototype.start = function (query) {
        if (query === void 0) { query = ''; }
        return new QueryInfo(query);
    };
    QueriesStats.prototype.notify = function (q) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_1__tdshared__["c" /* hasTdigest */]) {
            return;
        }
        var ms = q._duration();
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
        var key = {
            method: q.method,
            route: q.route,
            query: q.query,
            func: q.func,
            file: q.file,
            line: q.line,
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new __WEBPACK_IMPORTED_MODULE_1__tdshared__["a" /* TDigestStat */]();
            this._m[keyStr] = stat;
        }
        stat.add(ms);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    QueriesStats.prototype._flush = function () {
        var queries = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            queries.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            queries: queries,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report queries stats', err);
            }
        });
    };
    return QueriesStats;
}());

//# sourceMappingURL=queries.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports) {


function TreeBase() {}

// removes all nodes from the tree
TreeBase.prototype.clear = function() {
    this._root = null;
    this.size = 0;
};

// returns node data if found, null otherwise
TreeBase.prototype.find = function(data) {
    var res = this._root;

    while(res !== null) {
        var c = this._comparator(data, res.data);
        if(c === 0) {
            return res.data;
        }
        else {
            res = res.get_child(c > 0);
        }
    }

    return null;
};

// returns iterator to node if found, null otherwise
TreeBase.prototype.findIter = function(data) {
    var res = this._root;
    var iter = this.iterator();

    while(res !== null) {
        var c = this._comparator(data, res.data);
        if(c === 0) {
            iter._cursor = res;
            return iter;
        }
        else {
            iter._ancestors.push(res);
            res = res.get_child(c > 0);
        }
    }

    return null;
};

// Returns an iterator to the tree node at or immediately after the item
TreeBase.prototype.lowerBound = function(item) {
    var cur = this._root;
    var iter = this.iterator();
    var cmp = this._comparator;

    while(cur !== null) {
        var c = cmp(item, cur.data);
        if(c === 0) {
            iter._cursor = cur;
            return iter;
        }
        iter._ancestors.push(cur);
        cur = cur.get_child(c > 0);
    }

    for(var i=iter._ancestors.length - 1; i >= 0; --i) {
        cur = iter._ancestors[i];
        if(cmp(item, cur.data) < 0) {
            iter._cursor = cur;
            iter._ancestors.length = i;
            return iter;
        }
    }

    iter._ancestors.length = 0;
    return iter;
};

// Returns an iterator to the tree node immediately after the item
TreeBase.prototype.upperBound = function(item) {
    var iter = this.lowerBound(item);
    var cmp = this._comparator;

    while(iter.data() !== null && cmp(iter.data(), item) === 0) {
        iter.next();
    }

    return iter;
};

// returns null if tree is empty
TreeBase.prototype.min = function() {
    var res = this._root;
    if(res === null) {
        return null;
    }

    while(res.left !== null) {
        res = res.left;
    }

    return res.data;
};

// returns null if tree is empty
TreeBase.prototype.max = function() {
    var res = this._root;
    if(res === null) {
        return null;
    }

    while(res.right !== null) {
        res = res.right;
    }

    return res.data;
};

// returns a null iterator
// call next() or prev() to point to an element
TreeBase.prototype.iterator = function() {
    return new Iterator(this);
};

// calls cb on each node's data, in order
TreeBase.prototype.each = function(cb) {
    var it=this.iterator(), data;
    while((data = it.next()) !== null) {
        if(cb(data) === false) {
            return;
        }
    }
};

// calls cb on each node's data, in reverse order
TreeBase.prototype.reach = function(cb) {
    var it=this.iterator(), data;
    while((data = it.prev()) !== null) {
        if(cb(data) === false) {
            return;
        }
    }
};


function Iterator(tree) {
    this._tree = tree;
    this._ancestors = [];
    this._cursor = null;
}

Iterator.prototype.data = function() {
    return this._cursor !== null ? this._cursor.data : null;
};

// if null-iterator, returns first node
// otherwise, returns next node
Iterator.prototype.next = function() {
    if(this._cursor === null) {
        var root = this._tree._root;
        if(root !== null) {
            this._minNode(root);
        }
    }
    else {
        if(this._cursor.right === null) {
            // no greater node in subtree, go up to parent
            // if coming from a right child, continue up the stack
            var save;
            do {
                save = this._cursor;
                if(this._ancestors.length) {
                    this._cursor = this._ancestors.pop();
                }
                else {
                    this._cursor = null;
                    break;
                }
            } while(this._cursor.right === save);
        }
        else {
            // get the next node from the subtree
            this._ancestors.push(this._cursor);
            this._minNode(this._cursor.right);
        }
    }
    return this._cursor !== null ? this._cursor.data : null;
};

// if null-iterator, returns last node
// otherwise, returns previous node
Iterator.prototype.prev = function() {
    if(this._cursor === null) {
        var root = this._tree._root;
        if(root !== null) {
            this._maxNode(root);
        }
    }
    else {
        if(this._cursor.left === null) {
            var save;
            do {
                save = this._cursor;
                if(this._ancestors.length) {
                    this._cursor = this._ancestors.pop();
                }
                else {
                    this._cursor = null;
                    break;
                }
            } while(this._cursor.left === save);
        }
        else {
            this._ancestors.push(this._cursor);
            this._maxNode(this._cursor.left);
        }
    }
    return this._cursor !== null ? this._cursor.data : null;
};

Iterator.prototype._minNode = function(start) {
    while(start.left !== null) {
        this._ancestors.push(start);
        start = start.left;
    }
    this._cursor = start;
};

Iterator.prototype._maxNode = function(start) {
    while(start.right !== null) {
        this._ancestors.push(start);
        start = start.right;
    }
    this._cursor = start;
};

module.exports = TreeBase;



/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(204);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('root', [_app2.default]);
})();

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(205);

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _alerts = __webpack_require__(228);

var _alerts2 = _interopRequireDefault(_alerts);

var _api = __webpack_require__(234);

var _api2 = _interopRequireDefault(_api);

var _auth = __webpack_require__(237);

var _auth2 = _interopRequireDefault(_auth);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _conf = __webpack_require__(374);

var _conf2 = _interopRequireDefault(_conf);

var _cookies = __webpack_require__(377);

var _cookies2 = _interopRequireDefault(_cookies);

var _countries = __webpack_require__(379);

var _countries2 = _interopRequireDefault(_countries);

var _currencies = __webpack_require__(382);

var _currencies2 = _interopRequireDefault(_currencies);

var _errorReporting = __webpack_require__(390);

var _errorReporting2 = _interopRequireDefault(_errorReporting);

var _formatting = __webpack_require__(423);

var _formatting2 = _interopRequireDefault(_formatting);

var _holding = __webpack_require__(434);

var _holding2 = _interopRequireDefault(_holding);

var _i18n = __webpack_require__(887);

var _i18n2 = _interopRequireDefault(_i18n);

var _phone = __webpack_require__(888);

var _phone2 = _interopRequireDefault(_phone);

var _regions = __webpack_require__(890);

var _regions2 = _interopRequireDefault(_regions);

var _session = __webpack_require__(892);

var _session2 = _interopRequireDefault(_session);

var _support = __webpack_require__(894);

var _support2 = _interopRequireDefault(_support);

var _timezones = __webpack_require__(898);

var _timezones2 = _interopRequireDefault(_timezones);

var _user = __webpack_require__(900);

var _user2 = _interopRequireDefault(_user);

var _onboarding = __webpack_require__(903);

var _onboarding2 = _interopRequireDefault(_onboarding);

var _settings = __webpack_require__(979);

var _settings2 = _interopRequireDefault(_settings);

var _physical = __webpack_require__(1010);

var _physical2 = _interopRequireDefault(_physical);

var _verification = __webpack_require__(1023);

var _verification2 = _interopRequireDefault(_verification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app', ['angular-cache', 'angular-clipboard', 'angularLoad', 'ngMessages', 'ngRoute', 'ngSanitize', 'ngFileUpload', 'ng.shims.placeholder', 'gettext', 'gm.common.2fa', 'gm.common.config', 'gm.common.services', 'gm.common.providers', 'gm.common.user', _angularjs2.default, _alerts2.default, _api2.default, _auth2.default, _common2.default, _conf2.default, _cookies2.default, _countries2.default, _currencies2.default, _errorReporting2.default, _formatting2.default, _holding2.default, _i18n2.default, _phone2.default, _regions2.default, _session2.default, _support2.default, _timezones2.default, _user2.default, _onboarding2.default, _physical2.default, _settings2.default, _verification2.default]).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('app', {
    abstract: true,
    views: {
      root: {
        template: '<div ui-view="app"></div>'
      }
    }
  });

  $urlRouterProvider.when('/', '/overview/balances').otherwise('/overview/balances');
}]).name;


__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
__webpack_require__(1037);
__webpack_require__(1038);
__webpack_require__(1039);
__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1043);
__webpack_require__(1045);
__webpack_require__(1047);
__webpack_require__(1048);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(1052);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
module.exports = 'ng.shims.placeholder';


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/*! angular-shims-placeholder - v0.4.8 - 2016-12-06
* https://github.com/cvn/angular-shims-placeholder
* Copyright (c) 2016 Chad von Nau; Licensed MIT */
(function(angular, document, undefined) {
'use strict';

angular.module('ng.shims.placeholder', [])
.service('placeholderSniffer', ['$document', function($document){
	this.emptyClassName = 'empty',
	this.hasPlaceholder = function() {
		// test for native placeholder support
		var test = $document[0].createElement('input');
		return (test.placeholder !== void 0);
	};
}])
.directive('placeholder', ['$timeout', '$document', '$interpolate', '$injector', 'placeholderSniffer', function($timeout, $document, $interpolate, $injector, placeholderSniffer) {
	if (placeholderSniffer.hasPlaceholder()) return {};

	var documentListenersApplied = false,
		angularVersion = parseFloat(angular.version.full);

	// load $animate if available, to coordinate with other directives that use it
	try {
		var $animate = $injector.get('$animate');
	} catch (e) {}

	// No native support for attribute placeholder
	return {
		restrict: 'A',
		require: '?ngModel',
		// run after ngModel (0) and BOOLEAN_ATTR (100) directives.
		// priority order was reversed in Angular 1.2, so we must account for this
		priority: (angularVersion >= 1.2) ? 110 : -10,
		link: function(scope, elem, attrs, ngModel) {
			var orig_val = getValue(),
				domElem = elem[0],
				elemType = domElem.nodeName.toLowerCase(),
				isInput = elemType === 'input' || elemType === 'textarea',
				is_pwd = attrs.type === 'password',
				text = attrs.placeholder || '',
				emptyClassName = placeholderSniffer.emptyClassName,
				hiddenClassName = 'ng-hide',
				clone;

			if (!isInput) { return; }

			attrs.$observe('placeholder', function (newValue) {
				changePlaceholder(newValue);
			});

			if (is_pwd) { setupPasswordPlaceholder(); }

			// init
			setValue(orig_val);

			// on focus, replace auto-label with empty field
			elem.bind('focus', function() {
				if (elem.hasClass(emptyClassName)) {
					elem.val('');
					elem.removeClass(emptyClassName);
					domElem.select(); // IE8/9 show text cursor after tabbing in
				}
			});

			// on blur, show placeholder if necessary
			elem.bind('blur', updateValue);

			// handler for model-less inputs to interact with non-angular code
			if (!ngModel) {
				elem.bind('change', function (event) {
					changePlaceholder($interpolate(elem.attr('placeholder') || '')(scope), event);
				});
			}

			// model -> view
			if (ngModel) {
				ngModel.$render = function() {
					setValue(ngModel.$viewValue);
					// IE8/9: show text cursor after updating value while
					// focused, this happens when tabbing into a field, and the
					// deferred keydown handler from the previous field fires
					//
					// TODO: remove when tab key behavior is fixed in
					// angular core
					if (isActiveElement(domElem) && !elem.val()) {
						domElem.select();
					}
				};
			}

			if (!documentListenersApplied) {
				// cancel selection of placeholder text on disabled elements
				// disabled elements do not emit selectstart events in IE8/IE9,
				// so bind to $document and catch the event as it bubbles
				$document.bind('selectstart', function (e) {
					var elmn = angular.element(e.target);
					if (elmn.hasClass(emptyClassName) && elmn.prop('disabled')) {
						e.preventDefault();
					}
				});
				documentListenersApplied = true;
			}

			function updateValue(event) {
				var val = elem.val();

				// don't update from placeholder, helps debounce
				if (elem.hasClass(emptyClassName) && val && val === text) { return; }

				conditionalDefer(function(){ setValue(val); }, event);
			}

			function conditionalDefer(callback, event) {
				// IE8/9: ngModel uses a keydown handler with deferrered
				// execution to check for changes to the input. this $timeout 
				// prevents callback from firing before the keydown handler,
				// which is an issue when tabbing out of an input.
				// the conditional tests IE version, matches $sniffer.
				//
				// TODO: remove this function when tab key behavior is fixed in
				// angular core
				if (document.documentMode <= 11 && event) {
					$timeout(callback, 0);
				} else {
					callback();
				}
			}

			function setValue(val) {
				if (!val && val !== 0 && !isActiveElement(domElem)) {
					// show placeholder when necessary
					elem.addClass(emptyClassName);
					elem.val(!is_pwd ? text : '');
				} else {
					// otherwise set input to actual value
					elem.removeClass(emptyClassName);
					elem.val(val);
				}
				if (is_pwd) {
					updatePasswordPlaceholder();
					if ($animate) {
						asyncUpdatePasswordPlaceholder();
					}
				}
			}

			function getValue() {
				if (ngModel) {
					// use eval because $viewValue isn't ready during init
					// TODO: this might not to work during unit tests, investigate
					return scope.$eval(attrs.ngModel) || '';
				}
				return getDomValue() || '';
			}

			// IE8/9: elem.val() on an empty field sometimes returns the
			// placeholder value, so return an empty string instead
			// http://stackoverflow.com/q/11208417/490592
			// I believe IE is persisting the field value across refreshes
			// TODO: vs `elem.attr('value')`
			function getDomValue() {
				var val = elem.val();
				if (val === attrs.placeholder) {
					val = '';
				}
				return val;
			}

			function changePlaceholder(value, event) {
				if (elem.hasClass(emptyClassName) && elem.val() === text) {
					elem.val('');
				}
				text = value;
				updateValue(event);
			}

			// IE9: getting activeElement in an iframe raises error
			// http://tjvantoll.com/2013/08/30/bugs-with-document-activeelement-in-internet-explorer/
			function isActiveElement(elmn) {
				var result = false;
				try {
					result = elmn === document.activeElement;
				} catch (error) {}
				return result;
			}

			function setAttrConditional(elmn, attr, enable, value) {
				if (enable) {
					elmn.attr(attr, value);
				} else {
					elmn.removeAttr(attr);
				}
			}

			// IE8: password inputs cannot display text, and inputs cannot
			// change type, so create a new element to display placeholder
			function setupPasswordPlaceholder() {
				clone = angular.element('<input type="text" value="'+text+'"/>');
				stylePasswordPlaceholder();
				hideElement(clone);
				clone.addClass(emptyClassName)
					.bind('focus', hidePasswordPlaceholderAndFocus);
				domElem.parentNode.insertBefore(clone[0], domElem);

				// keep password placeholder in sync with original element.
				// update element after $watches
				var watchAttrs = [
					attrs.ngDisabled,
					attrs.ngReadonly,
					attrs.ngRequired,
					attrs.ngShow,
					attrs.ngHide
				];
				for (var i = 0; i < watchAttrs.length; i++) {
					if (watchAttrs[i]) {
						scope.$watch(watchAttrs[i], flexibleUpdatePasswordPlaceholder);
					}
				}
			}

			function updatePasswordPlaceholder() {
				stylePasswordPlaceholder();
				if (isNgHidden()) {
					// force hide the placeholder when element is hidden by
					// ngShow/ngHide. we cannot rely on stylePasswordPlaceholder
					// above to copy the ng-hide class, because the ngShow/ngHide
					// $watch functions apply the ng-hide class with $animate, 
					// so the class is not applied when our $watch executes
					hideElement(clone);
				} else if (elem.hasClass(emptyClassName) && domElem !== document.activeElement) {
					showPasswordPlaceholder();
				} else {
					hidePasswordPlaceholder();
				}
			}
			// update element after animation and animation-aware directives
			function asyncUpdatePasswordPlaceholder() {
				if (angularVersion >= 1.3) {
					$animate.addClass(elem, '').then(updatePasswordPlaceholder);
				} else {
					$animate.addClass(elem, '', updatePasswordPlaceholder);
				}
			}
			function flexibleUpdatePasswordPlaceholder() {
				if ($animate) {
					asyncUpdatePasswordPlaceholder();
				} else {
					updatePasswordPlaceholder();
				}
			}

			function stylePasswordPlaceholder() {
				clone.val(text);
				// chaining was failing in v1.0.8
				clone.attr('class', elem.attr('class') || '')
					.attr('style', elem.attr('style') || '')
					.prop('disabled', elem.prop('disabled'))
					.prop('readOnly', elem.prop('readOnly'))
					.prop('required', elem.prop('required'));
				setAttrConditional(clone, 'unselectable', elem.attr('unselectable') === 'on', 'on');
				setAttrConditional(clone, 'tabindex', elem.attr('tabindex') !== undefined, elem.attr('tabindex'));
			}

			function showElement(elmn) {
				if (angularVersion >= 1.2) {
					elmn.removeClass(hiddenClassName);
				} else {
					elmn.css('display', '');
				}
			}

			function hideElement(elmn) {
				if (angularVersion >= 1.2) {
					elmn.addClass(hiddenClassName);
				} else {
					elmn.css('display', 'none');
				}
			}

			function showPasswordPlaceholder() {
				hideElement(elem);
				showElement(clone);
			}

			function hidePasswordPlaceholder() {
				hideElement(clone);
				showElement(elem);
			}

			function hidePasswordPlaceholderAndFocus() {
				hidePasswordPlaceholder();
				domElem.focus();
			}

			function isNgHidden() {
				var hasNgShow = typeof attrs.ngShow !== 'undefined',
					hasNgHide = typeof attrs.ngHide !== 'undefined';
				if (hasNgShow || hasNgHide) {
					return (hasNgShow && !scope.$eval(attrs.ngShow)) ||
						(hasNgHide && scope.$eval(attrs.ngHide));
				} else {
					return false;
				}
			}

		}
	};
}]);

})(window.angular, window.document);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module common
 */ /** */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(8));
__export(__webpack_require__(208));
__export(__webpack_require__(209));
__export(__webpack_require__(210));
__export(__webpack_require__(211));
__export(__webpack_require__(221));
__export(__webpack_require__(222));
__export(__webpack_require__(223));
__export(__webpack_require__(50));
__export(__webpack_require__(45));
__export(__webpack_require__(224));
__export(__webpack_require__(227));
//# sourceMappingURL=index.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(13));
__export(__webpack_require__(38));
__export(__webpack_require__(39));
__export(__webpack_require__(30));
//# sourceMappingURL=index.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module path */ /** for typedoc */
__export(__webpack_require__(29));
__export(__webpack_require__(19));
//# sourceMappingURL=index.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module resolve */ /** for typedoc */
__export(__webpack_require__(37));
__export(__webpack_require__(16));
__export(__webpack_require__(20));
//# sourceMappingURL=index.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(40));
__export(__webpack_require__(26));
__export(__webpack_require__(41));
__export(__webpack_require__(42));
__export(__webpack_require__(43));
__export(__webpack_require__(44));
__export(__webpack_require__(12));
//# sourceMappingURL=index.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */ /** */
var transition_1 = __webpack_require__(18);
var router_1 = __webpack_require__(45);
function addCoreResolvables(trans) {
    trans.addResolvable({ token: router_1.UIRouter, deps: [], resolveFn: function () { return trans.router; }, data: trans.router }, "");
    trans.addResolvable({ token: transition_1.Transition, deps: [], resolveFn: function () { return trans; }, data: trans }, "");
    trans.addResolvable({ token: '$transition$', deps: [], resolveFn: function () { return trans; }, data: trans }, "");
    trans.addResolvable({ token: '$stateParams', deps: [], resolveFn: function () { return trans.params(); }, data: trans.params() }, "");
    trans.entering().forEach(function (state) {
        trans.addResolvable({ token: '$state$', deps: [], resolveFn: function () { return state; }, data: state }, state);
    });
}
exports.registerAddCoreResolvables = function (transitionService) {
    return transitionService.onCreate({}, addCoreResolvables);
};
//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */ /** */
var predicates_1 = __webpack_require__(4);
var coreservices_1 = __webpack_require__(7);
var targetState_1 = __webpack_require__(12);
/**
 * A [[TransitionHookFn]] that redirects to a different state or params
 *
 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
 *
 * See [[StateDeclaration.redirectTo]]
 */
var redirectToHook = function (trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect)
        return;
    var $state = trans.router.stateService;
    function handleResult(result) {
        if (!result)
            return;
        if (result instanceof targetState_1.TargetState)
            return result;
        if (predicates_1.isString(result))
            return $state.target(result, trans.params(), trans.options());
        if (result['state'] || result['params'])
            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
    }
    if (predicates_1.isFunction(redirect)) {
        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
    }
    return handleResult(redirect);
};
exports.registerRedirectToHook = function (transitionService) {
    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
};
//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A factory which creates an onEnter, onExit or onRetain transition hook function
 *
 * The returned function invokes the (for instance) state.onEnter hook when the
 * state is being entered.
 *
 * @hidden
 */
function makeEnterExitRetainHook(hookName) {
    return function (transition, state) {
        var _state = state.$$state();
        var hookFn = _state[hookName];
        return hookFn(transition, state);
    };
}
/**
 * The [[TransitionStateHookFn]] for onExit
 *
 * When the state is being exited, the state's .onExit function is invoked.
 *
 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
 *
 * See: [[IHookRegistry.onExit]]
 */
var onExitHook = makeEnterExitRetainHook('onExit');
exports.registerOnExitHook = function (transitionService) {
    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
};
/**
 * The [[TransitionStateHookFn]] for onRetain
 *
 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
 *
 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
 *
 * See: [[IHookRegistry.onRetain]]
 */
var onRetainHook = makeEnterExitRetainHook('onRetain');
exports.registerOnRetainHook = function (transitionService) {
    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
};
/**
 * The [[TransitionStateHookFn]] for onEnter
 *
 * When the state is being entered, the state's .onEnter function is invoked.
 *
 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
 *
 * See: [[IHookRegistry.onEnter]]
 */
var onEnterHook = makeEnterExitRetainHook('onEnter');
exports.registerOnEnterHook = function (transitionService) {
    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */
/** for typedoc */
var common_1 = __webpack_require__(3);
var resolveContext_1 = __webpack_require__(20);
var hof_1 = __webpack_require__(5);
/**
 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
 *
 * Registered using `transitionService.onStart({}, eagerResolvePath);`
 *
 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var eagerResolvePath = function (trans) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
        .resolvePath("EAGER", trans)
        .then(common_1.noop);
};
exports.registerEagerResolvePath = function (transitionService) {
    return transitionService.onStart({}, eagerResolvePath, { priority: 1000 });
};
/**
 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
 *
 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState);`
 *
 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var lazyResolveState = function (trans, state) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
        .subContext(state.$$state())
        .resolvePath("LAZY", trans)
        .then(common_1.noop);
};
exports.registerLazyResolveState = function (transitionService) {
    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: 1000 });
};
//# sourceMappingURL=resolve.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */ /** for typedoc */
var common_1 = __webpack_require__(3);
var coreservices_1 = __webpack_require__(7);
/**
 * A [[TransitionHookFn]] which waits for the views to load
 *
 * Registered using `transitionService.onStart({}, loadEnteringViews);`
 *
 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
 * In angular 1, this includes loading the templates.
 */
var loadEnteringViews = function (transition) {
    var $q = coreservices_1.services.$q;
    var enteringViews = transition.views("entering");
    if (!enteringViews.length)
        return;
    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
};
exports.registerLoadEnteringViews = function (transitionService) {
    return transitionService.onFinish({}, loadEnteringViews);
};
/**
 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
 *
 * Registered using `transitionService.onSuccess({}, activateViews);`
 *
 * After a transition is complete, this hook deactivates the old views from the previous state,
 * and activates the new views from the destination state.
 *
 * See [[ViewService]]
 */
var activateViews = function (transition) {
    var enteringViews = transition.views("entering");
    var exitingViews = transition.views("exiting");
    if (!enteringViews.length && !exitingViews.length)
        return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
    $view.sync();
};
exports.registerActivateViews = function (transitionService) {
    return transitionService.onSuccess({}, activateViews);
};
//# sourceMappingURL=views.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(3);
/**
 * A [[TransitionHookFn]] which updates global UI-Router state
 *
 * Registered using `transitionService.onBefore({}, updateGlobalState);`
 *
 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
 * After a successful [[Transition]], updates the global values of "the current state"
 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
 *
 * See also the deprecated properties:
 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
 */
var updateGlobalState = function (trans) {
    var globals = trans.router.globals;
    var transitionSuccessful = function () {
        globals.successfulTransitions.enqueue(trans);
        globals.$current = trans.$to();
        globals.current = globals.$current.self;
        common_1.copy(trans.params(), globals.params);
    };
    var clearCurrentTransition = function () {
        // Do not clear globals.transition if a different transition has started in the meantime
        if (globals.transition === trans)
            globals.transition = null;
    };
    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
};
exports.registerUpdateGlobalState = function (transitionService) {
    return transitionService.onCreate({}, updateGlobalState);
};
//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A [[TransitionHookFn]] which updates the URL after a successful transition
 *
 * Registered using `transitionService.onSuccess({}, updateUrl);`
 */
var updateUrl = function (transition) {
    var options = transition.options();
    var $state = transition.router.stateService;
    var $urlRouter = transition.router.urlRouter;
    // Dont update the url in these situations:
    // The transition was triggered by a URL sync (options.source === 'url')
    // The user doesn't want the url to update (options.location === false)
    // The destination state, and all parents have no navigable url
    if (options.source !== 'url' && options.location && $state.$current.navigable) {
        var urlOptions = { replace: options.location === 'replace' };
        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
    }
    $urlRouter.update(true);
};
exports.registerUpdateUrl = function (transitionService) {
    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
};
//# sourceMappingURL=url.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var trace_1 = __webpack_require__(10);
var rejectFactory_1 = __webpack_require__(14);
/**
 * A [[TransitionHookFn]] that skips a transition if it should be ignored
 *
 * This hook is invoked at the end of the onBefore phase.
 *
 * If the transition should be ignored (because no parameter or states changed)
 * then the transition is ignored and not processed.
 */
function ignoredHook(trans) {
    var ignoredReason = trans._ignoredReason();
    if (!ignoredReason)
        return;
    trace_1.trace.traceTransitionIgnored(trans);
    var pending = trans.router.globals.transition;
    // The user clicked a link going back to the *current state* ('A')
    // However, there is also a pending transition in flight (to 'B')
    // Abort the transition to 'B' because the user now wants to be back at 'A'.
    if (ignoredReason === 'SameAsCurrent' && pending) {
        pending.abort();
    }
    return rejectFactory_1.Rejection.ignored().toPromise();
}
exports.registerIgnoredTransitionHook = function (transitionService) {
    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
};
//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
 *
 * This hook is invoked at the end of the onBefore phase.
 * If the transition is invalid (for example, param values do not validate)
 * then the transition is rejected.
 */
function invalidTransitionHook(trans) {
    if (!trans.valid()) {
        throw new Error(trans.error());
    }
}
exports.registerInvalidTransitionHook = function (transitionService) {
    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
};
//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Transition subsystem
 *
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @coreapi
 * @preferred
 * @module transition
 */ /** for typedoc */
__export(__webpack_require__(11));
__export(__webpack_require__(36));
__export(__webpack_require__(28));
__export(__webpack_require__(14));
__export(__webpack_require__(18));
__export(__webpack_require__(15));
__export(__webpack_require__(53));
__export(__webpack_require__(31));
//# sourceMappingURL=index.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(21));
__export(__webpack_require__(46));
__export(__webpack_require__(47));
__export(__webpack_require__(48));
__export(__webpack_require__(51));
//# sourceMappingURL=index.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(49));
//# sourceMappingURL=index.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
__export(__webpack_require__(225));
//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(54));
__export(__webpack_require__(55));
__export(__webpack_require__(22));
__export(__webpack_require__(56));
__export(__webpack_require__(57));
__export(__webpack_require__(58));
__export(__webpack_require__(59));
__export(__webpack_require__(60));
__export(__webpack_require__(32));
__export(__webpack_require__(226));
//# sourceMappingURL=index.js.map

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var browserLocationConfig_1 = __webpack_require__(60);
var hashLocationService_1 = __webpack_require__(56);
var utils_1 = __webpack_require__(32);
var pushStateLocationService_1 = __webpack_require__(58);
var memoryLocationService_1 = __webpack_require__(57);
var memoryLocationConfig_1 = __webpack_require__(59);
var injector_1 = __webpack_require__(55);
var q_1 = __webpack_require__(54);
var coreservices_1 = __webpack_require__(7);
function servicesPlugin(router) {
    coreservices_1.services.$injector = injector_1.$injector;
    coreservices_1.services.$q = q_1.$q;
    return { name: "vanilla.services", $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
}
exports.servicesPlugin = servicesPlugin;
/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
exports.pushStateLocationPlugin = utils_1.locationPluginFactory("vanilla.pushStateLocation", true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
exports.memoryLocationPlugin = utils_1.locationPluginFactory("vanilla.memoryLocation", false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
//# sourceMappingURL=plugins.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * # Core classes and interfaces
 *
 * The classes and interfaces that are core to ui-router and do not belong
 * to a more specific subsystem (such as resolve).
 *
 * @coreapi
 * @preferred
 * @module core
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
/** @internalapi */
var UIRouterPluginBase = /** @class */ (function () {
    function UIRouterPluginBase() {
    }
    UIRouterPluginBase.prototype.dispose = function (router) { };
    return UIRouterPluginBase;
}());
exports.UIRouterPluginBase = UIRouterPluginBase;
//# sourceMappingURL=interface.js.map

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.alerts', []).name;


__webpack_require__(229);
__webpack_require__(231);
__webpack_require__(233);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingAlert.$inject = ['HoldingAlerts'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(230);

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.alerts').directive('holdingAlert', holdingAlert).name;


function holdingAlert(HoldingAlerts) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      canDismiss: '@?',
      onDismiss: '&?',
      title: '@?'
    },
    template: _alert2.default,
    transclude: {
      cta: '?cta',
      main: 'main'
    }
  };

  function link(scope, _element, attrs, _ctrls, transclude) {
    function dimiss() {
      HoldingAlerts.dismiss(scope.canDismiss);

      if ('onDismiss' in attrs) {
        scope.onDismiss();
      }

      scope.isDismissed = true;
    }

    scope.dismiss = dimiss;
    scope.isCtaPresent = transclude.isSlotFilled('cta');
    scope.isDismissed = 'canDismiss' in attrs && HoldingAlerts.isDismissed(scope.canDismiss);
    scope.showDismiss = 'canDismiss' in attrs;
  }
}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-alert ng-show=!isDismissed> <svg class=\"gmw-alert__icon gmw-alert__icon--error\"> <use xlink:href=#cross-icon></use> </svg> <svg class=\"gmw-alert__icon gmw-alert__icon--info\"> <use xlink:href=#circle-issue-icon></use> </svg> <svg class=\"gmw-alert__icon gmw-alert__icon--success\"> <use xlink:href=#checkmark-icon></use> </svg> <svg class=\"gmw-alert__icon gmw-alert__icon--warning\"> <use xlink:href=#pending-icon></use> </svg> <div class=gmw-alert__content> <span class=gmw-alert__title ng-if=title ng-bind=title> </span> <span ng-transclude=main></span> <span class=gmw-alert__cta ng-transclude=cta ng-if=isCtaPresent> </span> </div> <a class=gmw-alert__close-container ng-if=showDismiss ng-click=dismiss()> <svg class=gmw-alert__close-icon> <use xlink:href=#cross-icon></use> </svg> </a> </div> ";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alertLegacy = __webpack_require__(232);

var _alertLegacy2 = _interopRequireDefault(_alertLegacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.alerts').directive('holdingAlertLegacy', holdingAlertLegacy).name;


function holdingAlertLegacy() {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      onClose: '&?',
      title: '@?'
    },
    template: _alertLegacy2.default,
    transclude: true
  };

  function link(scope, _element, attrs, _ctrls, transclude) {
    scope.canClose = 'onClose' in attrs;
  }
}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-alert> <svg class=\"gmw-alert__icon gmw-alert__icon--error\"> <use xlink:href=#cross-icon></use> </svg> <svg class=\"gmw-alert__icon gmw-alert__icon--info\"> <use xlink:href=#circle-issue-icon></use> </svg> <svg class=\"gmw-alert__icon gmw-alert__icon--success\"> <use xlink:href=#checkmark-icon></use> </svg> <svg class=\"gmw-alert__icon gmw-alert__icon--warning\"> <use xlink:href=#pending-icon></use> </svg> <div class=gmw-alert__content> <span class=gmw-alert__title ng-if=title ng-bind=title> </span> <span ng-transclude></span> </div> <a class=gmw-alert__close-container ng-if=canClose ng-click=onClose()> <svg class=gmw-alert__close-icon> <use xlink:href=#cross-icon></use> </svg> </a> </div> ";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingAlerts.$inject = ['HoldingProperties'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = angular.module('app.alerts').factory('HoldingAlerts', HoldingAlerts).name;


function HoldingAlerts(HoldingProperties) {
  'ngInject';

  return {
    dismiss: dismiss,
    isDismissed: isDismissed
  };

  function dismiss(alertKey) {
    var _HoldingProperties$ge = HoldingProperties.get('AlertDismissed'),
        value = _HoldingProperties$ge.value;

    HoldingProperties.set('AlertDismissed', {
      value: Object.assign(value ? value : {}, _defineProperty({}, alertKey, new Date().toISOString()))
    });
  }

  function isDismissed(alertKey) {
    var _HoldingProperties$ge2 = HoldingProperties.get('AlertDismissed'),
        value = _HoldingProperties$ge2.value;

    return value && alertKey in value;
  }
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.api', []).config(['$httpProvider', '$provide', function ($httpProvider, $provide) {
  'ngInject';

  xmlHttpInterceptorFactory.$inject = ['$q', 'x2js'];
  function responseIsXml(response) {
    var contentType = response.headers('content-type');
    if (contentType) {
      return contentType.search(/\Wxml/i) > -1;
    }
    return false;
  }

  function xmlHttpInterceptorFactory($q, x2js) {
    function responseErrorHandler(response) {
      if (response && responseIsXml(response)) {
        response.data = x2js.xml2js(response.data);
      }
      return $q.reject(response);
    }

    function responseHandler(response) {
      if (response && responseIsXml(response)) {
        response.data = x2js.xml2js(response.data);
        return response;
      }
      return $q.when(response);
    }

    return {
      response: responseHandler,
      responseError: responseErrorHandler
    };
  }

  $httpProvider.interceptors.push('xmlHttpInterceptor');
  $provide.factory('xmlHttpInterceptor', xmlHttpInterceptorFactory);
}]).name;


__webpack_require__(235);
__webpack_require__(236);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.api').provider('x2js', x2jsProvider).name;


function x2jsProvider() {
  this.$get = ['X2JS', function (X2JS) {
    return new X2JS({});
  }];
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingApi.$inject = ['$document', '$q', '$http', '$httpParamSerializer', '$state', '$window', 'promiseCache', 'HoldingEnvironment', 'HoldingSession', 'Upload'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.api').factory('HoldingApi', HoldingApi).name;


var API_DEFAULTS = {
  method: 'GET',
  responseType: 'json'
};

function HoldingApi($document, $q, $http, $httpParamSerializer, $state, $window, promiseCache, HoldingEnvironment, HoldingSession, Upload) {
  'ngInject';

  var API_BASE_PATH = HoldingEnvironment.urls.backend;
  var service = {
    delete: deleteMethod,
    download: download,
    get: get,
    getUrl: getUrl,
    patch: patch,
    post: post,
    put: put,
    upload: upload
  };

  return service;

  function callApi(method, path) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (options.captcha) {
      options.headers['X-Captcha-Code'] = options.captcha;
    }

    var url = '' + API_BASE_PATH + path;
    var httpOptions = angular.extend({ method: method, url: url, data: data }, options);
    var optionsWithDefaults = angular.extend({}, API_DEFAULTS, httpOptions);
    return $http(optionsWithDefaults).then(callSuccess, callError).catch(function (error) {
      // auth errors
      if (error.status === 403 && !options.ignore403) {
        HoldingSession.clearSessionId();
        promiseCache.removeAll();
        $state.go('auth.sign-in', {}, {
          reload: true
        });
        return false;
      }

      if (error.data) {
        return $q.reject(angular.extend(error.data, { status: error.status }));
      }
      return $q.reject({
        code: 'GENERIC_ERROR',
        message: 'An error occurred. Please try again later',
        metadata: null,
        status: 0
      });
    });
  }

  function callError(_ref) {
    var data = _ref.data,
        _ref$status = _ref.status,
        status = _ref$status === undefined ? 0 : _ref$status;

    return $q.reject({ data: data, status: status });
  }

  function callSuccess(result) {
    return result.data;
  }

  function deleteMethod(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var sessionId = HoldingSession.getSessionId();

    return callApi('DELETE', url, {}, angular.extend(options, {
      headers: {
        'X-Session-Id': sessionId
      }
    }));
  }

  function download(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var filename = arguments[2];

    options.responseType = 'arraybuffer';

    return get(url, options).then(function (data) {
      var URL = $window.URL || $window.webkitURL;
      var downloadUrl = URL.createObjectURL(new Blob([data]));
      var a = $document[0].createElement('a');

      a.href = downloadUrl;
      a.download = filename;
      a.target = '_blank';
      a.click();
    });
  }

  function get(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return callApi('GET', url, {}, options);
  }

  function getUrl(baseUrl, parameters) {
    var queryString = $httpParamSerializer(parameters);
    return '' + API_BASE_PATH + baseUrl + '?' + queryString;
  }

  function patch(url, data) {
    var sessionId = HoldingSession.getSessionId();
    var options = {
      headers: { 'X-Session-Id': sessionId }
    };
    return callApi('PATCH', url, data, options);
  }

  function post(url, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var sessionId = HoldingSession.getSessionId();

    return callApi('POST', url, data, angular.extend(options, {
      headers: {
        'X-Session-Id': sessionId
      }
    }));
  }

  function put(url, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var sessionId = HoldingSession.getSessionId();

    return callApi('PUT', url, data, angular.extend(options, {
      headers: { 'X-Session-Id': sessionId }
    }));
  }

  function upload(url) {
    var file = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var additionalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var metadata = Upload.json(additionalData);
    var sessionId = HoldingSession.getSessionId();
    var data = { metadata: metadata };
    if (file !== null) {
      data.file = file;
    }

    return Upload.upload({
      url: '' + API_BASE_PATH + url,
      data: data,
      method: 'POST',
      headers: { 'X-Session-Id': sessionId }
    });
  }
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _auth = __webpack_require__(336);

var _auth2 = _interopRequireDefault(_auth);

var _forgotAccountDetailsPhone = __webpack_require__(337);

var _forgotAccountDetailsPhone2 = _interopRequireDefault(_forgotAccountDetailsPhone);

var _forgotAccountDetailsReset = __webpack_require__(338);

var _forgotAccountDetailsReset2 = _interopRequireDefault(_forgotAccountDetailsReset);

var _forgotCredentials = __webpack_require__(339);

var _forgotCredentials2 = _interopRequireDefault(_forgotCredentials);

var _forgotHoldingNumber = __webpack_require__(343);

var _forgotHoldingNumber2 = _interopRequireDefault(_forgotHoldingNumber);

var _forgotPassword = __webpack_require__(346);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _resetPassword = __webpack_require__(349);

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _signIn = __webpack_require__(352);

var _signIn2 = _interopRequireDefault(_signIn);

var _verifyEmail = __webpack_require__(359);

var _verifyEmail2 = _interopRequireDefault(_verifyEmail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth', [_common2.default, _angularjs2.default, _forgotCredentials2.default, _forgotHoldingNumber2.default, _forgotPassword2.default, _resetPassword2.default, _signIn2.default, _verifyEmail2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth', {
    abstract: true,
    parent: 'app',
    views: {
      app: {
        template: _auth2.default
      }
    }
  }).state('auth.forgot-account-details-phone', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Reset your Goldmoney account credentials',
      pageTitle: 'Reset your Goldmoney account credentials',
      skipSetupCheck: true
    },
    url: '/forgot-account-details/phone',
    views: {
      auth: {
        controller: 'ForgotAccountDetailsPhoneController',
        controllerAs: 'forgotAccountDetailsPhoneCtrl',
        template: _forgotAccountDetailsPhone2.default
      }
    }
  }).state('auth.forgot-account-details-reset', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Reset your Goldmoney account credentials',
      pageTitle: 'Reset your Goldmoney account credentials',
      skipSetupCheck: true
    },
    url: '/forgot-account-details/reset',
    views: {
      auth: {
        controller: 'ForgotAccountDetailsResetController',
        controllerAs: 'forgotAccountDetailsResetCtrl',
        template: _forgotAccountDetailsReset2.default
      }
    }
  }).state('auth.forgot-account-details-verify', {
    resolve: {
      VerificationResultResolve: ['$q', '$log', '$stateParams', 'HoldingForgotAccountDetails', function VerificationResultResolve($q, $log, $stateParams, HoldingForgotAccountDetails) {
        'ngInject';

        var token = $stateParams.token;

        if (token) {
          return HoldingForgotAccountDetails.verifyEmail(token).then(function (data) {
            if (data.needVerifyPhone) {
              return $q.resolve({
                state: 'auth.forgot-account-details-phone'
              });
            }
            return $q.resolve({
              state: 'auth.forgot-account-details-reset'
            });
          }).catch(function (_ref) {
            var message = _ref.data.message;

            switch (message) {
              case 'invalid.token':
                return $q.reject({
                  redirectTo: 'auth.sign-in',
                  params: {
                    message: 'email-invalid',
                    reload: true
                  }
                });
              default:
                return $q.reject({
                  redirectTo: 'auth.sign-in',
                  params: {
                    message: 'email-expired',
                    reload: true
                  }
                });
            }
          });
        }

        return $q.reject({
          redirectTo: 'auth.sign-in',
          params: {
            message: 'email-invalid',
            reload: true
          }
        });
      }]
    },
    url: '/forgot-account-details/verify/:token',
    views: {
      auth: {
        controller: 'ForgotAccountDetailsVerifyController',
        controllerAs: 'forgotAccountDetailsCtrl'
      }
    }
  });
}]).name;


__webpack_require__(362);
__webpack_require__(364);
__webpack_require__(366);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recapTableHeader = __webpack_require__(239);

var _recapTableHeader2 = _interopRequireDefault(_recapTableHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var recapTableHeader = {
    bindings: {
        highlight: '=?',
        label: '@'
    },
    template: _recapTableHeader2.default,
    transclude: true
};
exports.default = angular.module('gm.wealth.common').component('gmwRecapTableHeader', recapTableHeader).name;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-recap-table__header> <span class=heading-h5 ng-class=\"{\n      'h-green-text': $ctrl.highlight\n    }\" ng-bind=$ctrl.label> </span> </div> ";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recapTableRow = __webpack_require__(241);

var _recapTableRow2 = _interopRequireDefault(_recapTableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var recapTableRow = {
    bindings: {
        highlight: '=?',
        label: '@'
    },
    template: _recapTableRow2.default,
    transclude: true
};
exports.default = angular.module('gm.wealth.common').component('gmwRecapTableRow', recapTableRow).name;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=$ctrl.label> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-class=\"{\n        'h-green-text': $ctrl.highlight\n      }\" ng-transclude> </span> </div> </div> ";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


BaseFlowController.$inject = ['vm', '$scope', '$state', '$transitions', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var controller = 'BaseFlowController';

exports.default = controller;


angular.module('gm.wealth.common').controller(controller, BaseFlowController);

function BaseFlowController(vm, $scope, $state, $transitions, HoldingFlow) {
  'ngInject';

  vm.next = next;
  vm.cancel = cancel;
  vm.prev = prev;
  vm.checkState = checkCurrentState;

  var checkStateListener = void 0;

  function activate() {
    HoldingFlow.load();

    checkStateListener = $transitions.onStart({}, function (transition) {
      if (!transition) {
        return undefined;
      }return checkState(transition.$to(), transition);
    });

    checkState($state.current);

    $scope.$on('$destroy', function () {
      checkStateListener();
    });
  }

  function cancel() {
    HoldingFlow.cancel();
  }

  function checkCurrentState() {
    checkState($state.current);
  }

  function checkState(state, transition) {
    if (state.name in vm.steps && 'checks' in vm.steps[state.name]) {
      var revertTo = vm.steps[state.name].checks.find(function (check) {
        if (!check.function()) {
          return check;
        }
        return false;
      });
      if (revertTo) {
        if (transition) {
          transition.abort();
        }
        return $state.go(revertTo.revertTo, {}, {
          reload: true
        });
      }
    }
    return undefined;
  }

  function next() {
    if (vm.form) {
      vm.form.$setSubmitted();
    }
    if (vm.form && vm.form.$invalid) {
      return undefined;
    }

    if ($state.current.name in vm.steps && vm.steps[$state.current.name].next) {
      return vm.steps[$state.current.name].next().then(HoldingFlow.next);
    }
    return HoldingFlow.next();
  }

  function prev() {
    return HoldingFlow.prev();
  }

  activate();
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwAction.$inject = ['$parse'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwAction', gmwAction).name;


function gmwAction($parse) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A'
  };
  return directive;

  function link(scope, element, attrs) {
    var fn = $parse(attrs.gmwAction);

    element.on('click', function ($event) {
      element.addClass('loading-button');
      element.prop('disabled', true);

      var callback = function callback() {
        var result = fn(scope, { $event: $event });
        if (result && angular.isFunction(result.finally)) {
          result.finally(function () {
            element.removeClass('loading-button');
            element.prop('disabled', false);
          });
        } else {
          element.removeClass('loading-button');
          element.prop('disabled', false);
        }
      };
      scope.$apply(callback);
    });
  }
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwBoxDatePicker.$inject = ['$document'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _boxDatePicker = __webpack_require__(247);

var _boxDatePicker2 = _interopRequireDefault(_boxDatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwBoxDatePicker', gmwBoxDatePicker).name;


function gmwBoxDatePicker($document) {
  'ngInject';

  var directive = {
    link: link,
    require: 'ngModel',
    replace: true,
    restrict: 'E',
    scope: {
      description: '@?',
      label: '@?',
      maxDate: '=?',
      minDate: '=?',
      options: '=',
      placeholder: '@?'
    },
    template: _boxDatePicker2.default
  };
  return directive;

  function link($scope, _elem, _attrs, ngModel) {
    $scope.activeDate = (0, _moment2.default)();
    $scope.model = ngModel;
    $scope.move = move;
    $scope.select = select;
    $scope.toggleOpen = toggleOpen;

    ngModel.$parsers.push(function (viewValue) {
      if (viewValue) {
        return viewValue.format('YYYY-MM-DD');
      }
      return null;
    });

    ngModel.$formatters.push(function (value) {
      if (value) {
        $scope.activeDate = (0, _moment2.default)(value);
        return (0, _moment2.default)(value);
      }
      return null;
    });

    function close() {
      $scope.open = false;
      angular.element($document).off('click', offClickHandler);
    }

    function move(amount, granularity, $event) {
      $scope.activeDate.add(amount, granularity);
      updateView();
      $event.stopPropagation();
    }

    function open() {
      updateView();
      $scope.open = true;
      angular.element($document).on('click', offClickHandler);
    }

    function offClickHandler() {
      return $scope.$apply(close);
    }

    function select(item, $event) {
      if (item.enabled) {
        ngModel.$setViewValue(item.date);
      } else {
        $event.stopPropagation();
      }
    }

    function toggleOpen($event) {
      if ($scope.open) {
        close();
      } else {
        open();
      }
      $event.stopPropagation();
    }

    function updateView() {
      var startOfMonth = (0, _moment2.default)($scope.activeDate).startOf('month');
      var startDate = (0, _moment2.default)(startOfMonth).startOf('isoWeek');
      var daysBefore = startOfMonth.diff(startDate, 'days');

      var endOfMonth = (0, _moment2.default)($scope.activeDate).endOf('month');
      var endDate = (0, _moment2.default)(endOfMonth).endOf('isoWeek');
      var daysAfter = endDate.diff(endOfMonth, 'days');

      var daysInMonth = $scope.activeDate.daysInMonth();
      var daysDisplayed = daysBefore + daysInMonth + daysAfter;
      var weeksDisplayed = daysDisplayed / 7;

      var weeks = [];
      for (var i = 0; i < weeksDisplayed; i += 1) {
        var week = [];
        for (var j = 0; j < 7; j += 1) {
          var dayNumber = i * 7 + j;
          var date = (0, _moment2.default)(startDate).add(dayNumber, 'days');
          var inactive = dayNumber < daysBefore || dayNumber >= daysBefore + daysInMonth;
          var today = (0, _moment2.default)().isSame(date, 'day');

          var respectsMin = $scope.minDate ? date.isSameOrAfter($scope.minDate, 'day') : true;
          var respectsMax = $scope.maxDate ? date.isSameOrBefore($scope.maxDate, 'day') : true;
          var enabled = respectsMin && respectsMax;

          var weekend = date.isoWeekday() === 6 || date.isoWeekday() === 7;

          var number = date.format('DD');
          var selected = void 0;
          if (ngModel.$modelValue) {
            selected = date.isSame(ngModel.$modelValue, 'day');
          }

          week[j] = {
            date: date,
            enabled: enabled,
            number: number,
            inactive: inactive,
            selected: selected,
            today: today,
            weekend: weekend
          };
        }
        weeks.push(week);
      }
      $scope.weeks = weeks;
    }
  }
}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 61,
	"./af.js": 61,
	"./ar": 62,
	"./ar-dz": 63,
	"./ar-dz.js": 63,
	"./ar-kw": 64,
	"./ar-kw.js": 64,
	"./ar-ly": 65,
	"./ar-ly.js": 65,
	"./ar-ma": 66,
	"./ar-ma.js": 66,
	"./ar-sa": 67,
	"./ar-sa.js": 67,
	"./ar-tn": 68,
	"./ar-tn.js": 68,
	"./ar.js": 62,
	"./az": 69,
	"./az.js": 69,
	"./be": 70,
	"./be.js": 70,
	"./bg": 71,
	"./bg.js": 71,
	"./bm": 72,
	"./bm.js": 72,
	"./bn": 73,
	"./bn-bd": 74,
	"./bn-bd.js": 74,
	"./bn.js": 73,
	"./bo": 75,
	"./bo.js": 75,
	"./br": 76,
	"./br.js": 76,
	"./bs": 77,
	"./bs.js": 77,
	"./ca": 78,
	"./ca.js": 78,
	"./cs": 79,
	"./cs.js": 79,
	"./cv": 80,
	"./cv.js": 80,
	"./cy": 81,
	"./cy.js": 81,
	"./da": 82,
	"./da.js": 82,
	"./de": 83,
	"./de-at": 84,
	"./de-at.js": 84,
	"./de-ch": 85,
	"./de-ch.js": 85,
	"./de.js": 83,
	"./dv": 86,
	"./dv.js": 86,
	"./el": 87,
	"./el.js": 87,
	"./en-au": 88,
	"./en-au.js": 88,
	"./en-ca": 89,
	"./en-ca.js": 89,
	"./en-gb": 90,
	"./en-gb.js": 90,
	"./en-ie": 91,
	"./en-ie.js": 91,
	"./en-il": 92,
	"./en-il.js": 92,
	"./en-in": 93,
	"./en-in.js": 93,
	"./en-nz": 94,
	"./en-nz.js": 94,
	"./en-sg": 95,
	"./en-sg.js": 95,
	"./eo": 96,
	"./eo.js": 96,
	"./es": 97,
	"./es-do": 98,
	"./es-do.js": 98,
	"./es-mx": 99,
	"./es-mx.js": 99,
	"./es-us": 100,
	"./es-us.js": 100,
	"./es.js": 97,
	"./et": 101,
	"./et.js": 101,
	"./eu": 102,
	"./eu.js": 102,
	"./fa": 103,
	"./fa.js": 103,
	"./fi": 104,
	"./fi.js": 104,
	"./fil": 105,
	"./fil.js": 105,
	"./fo": 106,
	"./fo.js": 106,
	"./fr": 107,
	"./fr-ca": 108,
	"./fr-ca.js": 108,
	"./fr-ch": 109,
	"./fr-ch.js": 109,
	"./fr.js": 107,
	"./fy": 110,
	"./fy.js": 110,
	"./ga": 111,
	"./ga.js": 111,
	"./gd": 112,
	"./gd.js": 112,
	"./gl": 113,
	"./gl.js": 113,
	"./gom-deva": 114,
	"./gom-deva.js": 114,
	"./gom-latn": 115,
	"./gom-latn.js": 115,
	"./gu": 116,
	"./gu.js": 116,
	"./he": 117,
	"./he.js": 117,
	"./hi": 118,
	"./hi.js": 118,
	"./hr": 119,
	"./hr.js": 119,
	"./hu": 120,
	"./hu.js": 120,
	"./hy-am": 121,
	"./hy-am.js": 121,
	"./id": 122,
	"./id.js": 122,
	"./is": 123,
	"./is.js": 123,
	"./it": 124,
	"./it-ch": 125,
	"./it-ch.js": 125,
	"./it.js": 124,
	"./ja": 126,
	"./ja.js": 126,
	"./jv": 127,
	"./jv.js": 127,
	"./ka": 128,
	"./ka.js": 128,
	"./kk": 129,
	"./kk.js": 129,
	"./km": 130,
	"./km.js": 130,
	"./kn": 131,
	"./kn.js": 131,
	"./ko": 132,
	"./ko.js": 132,
	"./ku": 133,
	"./ku.js": 133,
	"./ky": 134,
	"./ky.js": 134,
	"./lb": 135,
	"./lb.js": 135,
	"./lo": 136,
	"./lo.js": 136,
	"./lt": 137,
	"./lt.js": 137,
	"./lv": 138,
	"./lv.js": 138,
	"./me": 139,
	"./me.js": 139,
	"./mi": 140,
	"./mi.js": 140,
	"./mk": 141,
	"./mk.js": 141,
	"./ml": 142,
	"./ml.js": 142,
	"./mn": 143,
	"./mn.js": 143,
	"./mr": 144,
	"./mr.js": 144,
	"./ms": 145,
	"./ms-my": 146,
	"./ms-my.js": 146,
	"./ms.js": 145,
	"./mt": 147,
	"./mt.js": 147,
	"./my": 148,
	"./my.js": 148,
	"./nb": 149,
	"./nb.js": 149,
	"./ne": 150,
	"./ne.js": 150,
	"./nl": 151,
	"./nl-be": 152,
	"./nl-be.js": 152,
	"./nl.js": 151,
	"./nn": 153,
	"./nn.js": 153,
	"./oc-lnc": 154,
	"./oc-lnc.js": 154,
	"./pa-in": 155,
	"./pa-in.js": 155,
	"./pl": 156,
	"./pl.js": 156,
	"./pt": 157,
	"./pt-br": 158,
	"./pt-br.js": 158,
	"./pt.js": 157,
	"./ro": 159,
	"./ro.js": 159,
	"./ru": 160,
	"./ru.js": 160,
	"./sd": 161,
	"./sd.js": 161,
	"./se": 162,
	"./se.js": 162,
	"./si": 163,
	"./si.js": 163,
	"./sk": 164,
	"./sk.js": 164,
	"./sl": 165,
	"./sl.js": 165,
	"./sq": 166,
	"./sq.js": 166,
	"./sr": 167,
	"./sr-cyrl": 168,
	"./sr-cyrl.js": 168,
	"./sr.js": 167,
	"./ss": 169,
	"./ss.js": 169,
	"./sv": 170,
	"./sv.js": 170,
	"./sw": 171,
	"./sw.js": 171,
	"./ta": 172,
	"./ta.js": 172,
	"./te": 173,
	"./te.js": 173,
	"./tet": 174,
	"./tet.js": 174,
	"./tg": 175,
	"./tg.js": 175,
	"./th": 176,
	"./th.js": 176,
	"./tk": 177,
	"./tk.js": 177,
	"./tl-ph": 178,
	"./tl-ph.js": 178,
	"./tlh": 179,
	"./tlh.js": 179,
	"./tr": 180,
	"./tr.js": 180,
	"./tzl": 181,
	"./tzl.js": 181,
	"./tzm": 182,
	"./tzm-latn": 183,
	"./tzm-latn.js": 183,
	"./tzm.js": 182,
	"./ug-cn": 184,
	"./ug-cn.js": 184,
	"./uk": 185,
	"./uk.js": 185,
	"./ur": 186,
	"./ur.js": 186,
	"./uz": 187,
	"./uz-latn": 188,
	"./uz-latn.js": 188,
	"./uz.js": 187,
	"./vi": 189,
	"./vi.js": 189,
	"./x-pseudo": 190,
	"./x-pseudo.js": 190,
	"./yo": 191,
	"./yo.js": 191,
	"./zh-cn": 192,
	"./zh-cn.js": 192,
	"./zh-hk": 193,
	"./zh-hk.js": 193,
	"./zh-mo": 194,
	"./zh-mo.js": 194,
	"./zh-tw": 195,
	"./zh-tw.js": 195
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 246;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "<div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=label ng-bind=label> </label> <div style=display:flex> <div class=gmw-box-selector ng-class=\"{\n      'gmw-box-selector--active': open,\n      'gmw-box-selector--filled': !!model.$viewValue,\n    }\" ng-disabled=\"options.length === 0\"> <div class=gmw-box-selector__initial ng-click=toggleOpen($event)> <div class=gmw-box-selector__base-content> <span class=\"ui-text h-dark-text\" ng-if=model.$modelValue ng-bind=\"model.$viewValue.format('LL')\"> </span> <span ng-if=!model.$viewValue ng-bind=\"placeholder ? placeholder : 'Please Select'|translate\"> </span> </div> <svg class=gmw-box-selector__chevron> <use xlink:href=#down-chevron-icon></use> </svg> <span class=\"gmw-box-selector__description ui-micro-text\" ng-if=\"description && !!model.$viewValue\" ng-bind=description> </span> </div> <div class=gmw-box-selector__dropdown-container> <div class=gmw-box-selector__picker-header> <div class=gmw-box-selector__picker-header-controls> <span class=gmw-box-selector__picker-header-controls-year-back ng-click=\"move(-1, 'year', $event)\"> &lt;&lt; </span> <span class=gmw-box-selector__picker-header-controls-month-back ng-click=\"move(-1, 'month', $event)\"> &lt; </span> <span class=gmw-box-selector__picker-header-controls-month ng-bind=\"activeDate.format('MMMM YYYY')\"> </span> <span class=gmw-box-selector__picker-header-controls-month-forward ng-click=\"move(+1, 'month', $event)\"> &gt; </span> <span class=gmw-box-selector__picker-header-controls-year-forward ng-click=\"move(+1, 'year', $event)\"> &gt;&gt; </span> </div> <div class=gmw-box-selector__picker-header-days> <span class=gmw-box-selector__picker-header-day ng-repeat=\"day in weeks[0]\"> <span class=gmw-box-selector__picker-header-day-name ng-bind=\"::day.date.format('ddd')\"> </span> </span> </div> </div> <div class=gmw-box-selector__week ng-repeat=\"week in weeks\"> <div class=gmw-box-selector__day ng-class=\"{\n            'gmw-box-selector__day--inactive': day.inactive || !day.enabled,\n            'gmw-box-selector__day--today': day.today,\n            'gmw-box-selector__day--selected': day.selected,\n            'gmw-box-selector__day--weekend': day.weekend,\n          }\" ng-click=\"select(day, $event)\" ng-repeat=\"day in week\"> <span class=gmw-box-selector__day-number ng-bind=::day.number> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _boxInput = __webpack_require__(249);

var _boxInput2 = _interopRequireDefault(_boxInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwBoxInput', gmwBoxInput).name;


function gmwBoxInput() {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    require: ['ngModel', '^^form'],
    restrict: 'E',
    scope: {
      blur: '&?',
      change: '&?',
      currency: '@?',
      description: '@?',
      focus: '&?',
      isReadonly: '=?',
      hasError: '=?',
      label: '@?',
      noLabel: '=?',
      max: '=?',
      maxlength: '@?',
      metaText: '@?',
      metaUrl: '@?',
      min: '=?',
      minlength: '@?',
      pattern: '@?',
      placeholder: '@?'
    },
    template: _boxInput2.default,
    transclude: {
      metaLeft: '?gmwBoxInputMetaLeft',
      metaRight: '?gmwBoxInputMetaRight',
      labelRight: '?gmwBoxInputLabelRight'
    }
  };
  return directive;

  function link(scope, _element, attrs, ctrl, transclude) {
    var form = ctrl[1];
    var ngModel = ctrl[0];

    scope.form = form;
    scope.name = attrs.name;
    scope.ngModel = ngModel;
    scope.type = attrs.type || 'text';
    scope.model = {
      value: ''
    };

    scope.isMetaLeft = transclude.isSlotFilled('metaLeft');
    scope.isMetaRight = transclude.isSlotFilled('metaRight');
    scope.hasLabelRight = transclude.isSlotFilled('labelRight');

    scope.onBlur = function () {
      scope.active = false;
      ngModel.$setTouched();

      if (angular.isFunction(scope.blur)) {
        scope.blur();
      }
    };

    scope.onChange = function () {
      if (angular.isFunction(scope.change)) {
        scope.change();
      }
    };

    scope.onFocus = function () {
      if (!scope.isReadonly) {
        scope.active = true;

        if (angular.isFunction(scope.focus)) {
          scope.focus();
        }
      }
    };

    ngModel.$render = function () {
      scope.model.value = ngModel.$viewValue;
    };

    scope.$watch('model.value', function (newVal) {
      ngModel.$setViewValue(newVal);
    });

    attrs.$observe('disabled', function (newVal) {
      scope.disabled = newVal;
    });
  }
}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = "<div> <label ng-if=\"label && !noLabel && !hasLabelRight\" class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=label> </label> <label ng-if=\"!label && !noLabel\" class=\"gmw-input-container__label heading-h4 h-dark-text desktop-only desktop-only--xs\"> &nbsp; </label> <label ng-if=\"label && !noLabel && hasLabelRight\" class=\"gmw-input-container__label heading-h4\"> <span class=h-dark-text ng-bind=label> </span> <div ng-transclude=labelRight></div> </label> <div class=gmw-box-input ng-class=\"{\n      'gmw-box-input--focus': active,\n      'gmw-box-input--disabled': disabled,\n      'gmw-box-input--error': (hasError) ? hasError : ngModel.$invalid && (ngModel.$touched || form.$submitted),\n      'gmw-box-input--textarea': type === 'textarea'\n    }\"> <div class=gmw-box-input-meta ng-if=isMetaLeft ng-transclude=metaLeft> </div> <input class=gmw-box-input__input type=email name=\"{{name}}\" ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-maxlength=maxlength ng-minlength=minlength ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'email'\"> <input class=gmw-box-input__input type=url name=\"{{name}}\" ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-maxlength=maxlength ng-minlength=minlength ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'url'\"> <input class=gmw-box-input__input type=tel name=\"{{name}}\" step=any ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-maxlength=maxlength ng-minlength=minlength ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly gmw-min=\"{{min}}\" gmw-max=\"{{max}}\" gmw-format-model-currency=\"{{currency}}\" ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'number'\"> <input class=gmw-box-input__input type=tel name=\"{{name}}\" ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-maxlength=maxlength ng-minlength=minlength ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly gmw-min=\"{{min}}\" gmw-max=\"{{max}}\" ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'tel'\"> <input class=gmw-box-input__input type=text name=\"{{name}}\" ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-maxlength=maxlength ng-minlength=minlength ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'text'\"> <input class=gmw-box-input__input type=password name=\"{{name}}\" ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-maxlength=maxlength ng-minlength=minlength ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'password'\"> <div class=\"gmw-box-input-meta gmw-box-input-meta--reverse\" ng-if=isMetaRight ng-transclude=metaRight> </div> <textarea class=\"gmw-box-input__input gmw-box-input__input--textarea\" name=\"{{name}}\" ng-blur=onBlur() ng-change=onChange() ng-disabled=disabled ng-focus=onFocus() ng-model=model.value ng-model-options=\"{\n        debounce: '$inherit'\n      }\" ng-readonly=isReadonly ng-attr-pattern=\"{{pattern||undefined}}\" placeholder=\"{{placeholder}}\" ng-if=\"type === 'textarea'\">\n    </textarea> <div ng-if=\"metaText && metaUrl\" class=gmw-input-container__meta> <a href=\"{{metaUrl}}\" class=h-blue-link target=_blank ng-bind=metaText> </a> </div> </div> <span class=\"gmw-box-input__description ui-micro-text\" ng-if=description ng-bind=description> </span> </div> ";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _boxInputSimple = __webpack_require__(251);

var _boxInputSimple2 = _interopRequireDefault(_boxInputSimple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwBoxInputSimple', gmwBoxInputSimple).name;


function gmwBoxInputSimple() {
  'ngInject';

  var directive = {
    link: link,
    template: _boxInputSimple2.default,
    restrict: 'E',
    require: ['ngModel', '^^?form'],
    scope: {
      label: '@?',
      placeholder: '@?',
      type: '@?',
      description: '@?'
    },
    transclude: {
      inputRight: '?gmwBoxInputRight',
      metaLeft: '?gmwBoxInputMetaLeft',
      metaRight: '?gmwBoxInputMetaRight',
      metaText: '?gmwBoxInputMetaText'
    }
  };
  return directive;

  function link(scope, _element, attrs, ctrls, transclude) {
    scope.labelSpacer = Object.prototype.hasOwnProperty.call(attrs, 'labelSpacer');
    scope.isInputRight = transclude.isSlotFilled('inputRight');
    scope.isMetaLeft = transclude.isSlotFilled('metaLeft');

    var ngModel = ctrls[0];
    scope.ngModel = ngModel;
    scope.form = ctrls[1];
    scope.isMetaRight = transclude.isSlotFilled('metaRight');
    scope.isMetaText = transclude.isSlotFilled('metaText');

    scope.onBlur = function () {
      scope.active = false;
      ngModel.$setTouched();
    };
    scope.onFocus = function () {
      scope.active = true;
    };

    scope.model = {};
    scope.$watch('model.value', function (value) {
      ngModel.$setViewValue(value);
    });

    ngModel.$parsers.push(function (value) {
      scope.model.value = value;
      return value;
    });

    ngModel.$formatters.push(function (value) {
      scope.model.value = value;
    });
  }
}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = "<div> <label ng-if=labelSpacer class=\"gmw-input-container__label heading-h4 h-dark-text\"> &nbsp; </label> <label ng-if=label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=label> </label> <div class=gmw-box-input ng-class=\"{\n      'gmw-box-input--focus': active,\n      'gmw-box-input--error': ngModel.$invalid && (ngModel.$touched || form.$submitted),\n      'gmw-box-input--textarea': type === 'textarea',\n    }\"> <div class=gmw-box-input-meta ng-if=isMetaLeft ng-transclude=metaLeft> </div> <input class=gmw-box-input__input type=\"{{type||'text'}}\" ng-if=\"type !== 'textarea'\" ng-model=model.value ng-focus=onFocus() ng-blur=onBlur() placeholder=\"{{placeholder}}\"> <textarea class=\"gmw-box-input__input gmw-box-input__input--textarea\" type=\"{{type||'text'}}\" ng-if=\"type === 'textarea'\" ng-model=model.value ng-focus=onFocus() ng-blur=onBlur() placeholder=\"{{placeholder}}\">\n    </textarea> <div class=gmw-box-input-secondary ng-if=isInputRight ng-transclude=inputRight> </div> <div class=\"gmw-box-input-meta gmw-box-input-meta--reverse\" ng-if=isMetaRight ng-transclude=metaRight> </div> <div class=gmw-input-container__meta ng-if=isMetaText ng-transclude=metaText> </div> </div> <span class=\"gmw-box-input__description ui-micro-text\" ng-if=description ng-bind=description> </span> </div> ";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwBoxPhoneInput.$inject = ['$document', '$filter', 'Countries', 'HoldingPhone'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _boxPhoneInput = __webpack_require__(253);

var _boxPhoneInput2 = _interopRequireDefault(_boxPhoneInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwBoxPhoneInput', gmwBoxPhoneInput).name;


function gmwBoxPhoneInput($document, $filter, Countries, HoldingPhone) {
  'ngInject';

  var countryList = Countries.filter(function (c) {
    return !!c.key;
  }).map(prepareCountryForDropdownMenu);

  function prepareCountryForDropdownMenu(_ref) {
    var key = _ref.key,
        country = _ref.country,
        code = _ref.code;

    return {
      id: key.toUpperCase(),
      label: country,
      meta: '+' + code,
      flag: key ? key.toLowerCase() : null,
      code: code
    };
  }

  var directive = {
    link: link,
    require: 'ngModel',
    replace: true,
    restrict: 'E',
    scope: {
      description: '@?',
      label: '@?',
      noLabel: '=?',
      options: '=',
      placeholder: '@?'
    },
    template: _boxPhoneInput2.default,
    transclude: true
  };
  return directive;

  function link(scope, _elem, _attrs, ngModel) {
    scope.stop = stop;
    scope.toggleOpen = toggleOpen;

    scope.model = ngModel;
    scope.view = {
      filterInput: '',
      isOpen: false
    };

    scope.number = {
      nationalPart: '',
      prefix: ''
    };

    scope.filteredCountries = [];
    scope.$watch('view.filterInput', function (filterInput) {
      scope.filteredCountries = $filter('filter')(countryList, filterInput);
    });

    scope.selectCountry = function (country) {
      if (country) {
        scope.number.prefix = country.code;
        scope.number.flag = country.flag;
        close();
      }
    };

    var userCountry = 'US';
    scope.selectCountry(countryList.find(function (country) {
      return country.id === userCountry;
    }));

    scope.$watchCollection('number', function (number) {
      if (number.nationalPart) {
        ngModel.$setViewValue('+' + number.prefix + number.nationalPart);
      }
    });

    ngModel.$formatters.unshift(function (phone) {
      var parsedNumber = HoldingPhone.parsePhonenumber(phone);

      if (parsedNumber) {
        scope.number.nationalPart = parsedNumber.nationalNumber;
        scope.number.prefix = parsedNumber.prefix;
        scope.number.flag = parsedNumber.countryCode ? parsedNumber.countryCode.toLowerCase() : '';
      } else {
        scope.number.nationalPart = null;
      }
    });

    ngModel.$validators.validNumber = function validNumberParser(modelValue, viewValue) {
      var value = modelValue || viewValue;

      return !value || HoldingPhone.isValidPhoneNumber(value);
    };

    function close() {
      scope.open = false;
      angular.element($document).off('click', offClickHandler);
    }

    function offClickHandler() {
      return scope.$apply(close);
    }

    function open() {
      scope.open = true;
      angular.element($document).on('click', offClickHandler);
    }

    function stop($event) {
      $event.stopPropagation();
    }

    function toggleOpen($event) {
      if (scope.open) {
        close();
      } else {
        open();
      }
      $event.stopPropagation();
    }
  }
}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "<div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=label ng-bind=label> </label> <label ng-if=\"!label && !noLabel\" class=\"gmw-input-container__label heading-h4 h-dark-text desktop-only desktop-only--xs\"> &nbsp; </label> <div class=gmw-box-selector ng-class=\"{\n      'gmw-box-selector--active': open,\n      'gmw-box-selector--filled': !!model.$viewValue,\n      'gmw-box-selector--error': model.$dirty && model.$invalid,\n    }\"> <div class=gmw-box-selector__initial ng-click=toggleOpen($event)> <i class=\"gmw-box-selector__flag flag\" ng-if=number.flag ng-class=number.flag> </i> <span class=\"ui-text h-dark-text\" ng-bind=\"'+' + number.prefix\"></span> <span class=\"gmw-dot gmw-dot--light\">&middot;</span> <input class=gmw-box-selector__base-input type=text placeholder=\"{{placeholder ? placeholder : 'Enter'|translate}}\" ng-click=stop($event) ng-model=number.nationalPart> <span class=\"ui-text h-dark-text\" ng-if=\"model.$viewValue && !model.$viewValue.meta && !model.$viewValue.amount\" ng-bind=model.$viewValue.label> </span> <svg class=gmw-box-selector__chevron> <use xlink:href=#down-chevron-icon></use> </svg> <span class=\"gmw-box-selector__description ui-micro-text\" ng-if=description ng-bind=description> </span> </div> <div class=gmw-box-selector__dropdown-container> <ul class=\"small-list small-list--gmw\" ng-if=open> <li ng-repeat=\"item in filteredCountries track by $index\" class=small-list__item ng-class=\"{'small-list__item--selected': number.prefix === item.code}\" ng-click=selectCountry(item)> <i class=\"small-list__item-flag flag\" ng-if=item.flag ng-class=item.flag> </i> <span class=small-list__item-label ng-bind=::item.label></span> <span class=small-list__item-meta ng-bind=::item.meta></span> </li> </ul> </div> </div> </div> ";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwBoxSelector.$inject = ['$document'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _boxSelector = __webpack_require__(255);

var _boxSelector2 = _interopRequireDefault(_boxSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwBoxSelector', gmwBoxSelector).name;


function gmwBoxSelector($document) {
  'ngInject';

  var directive = {
    link: link,
    require: ['ngModel', '^^?form'],
    replace: true,
    restrict: 'E',
    scope: {
      description: '@?',
      label: '@?',
      noLabel: '=?',
      options: '=',
      placeholder: '@?',
      metaText: '@?',
      metaDescription: '@?',
      metaUrl: '@?'
    },
    template: _boxSelector2.default,
    transclude: {
      labelRight: '?gmwLabelRight'
    }
  };
  return directive;

  function link(scope, _elem, attrs, ctrls, transclude) {
    var model = ctrls[0];
    scope.model = model;
    scope.form = ctrls[1];

    scope.readonly = 'readonly' in attrs;
    scope.hasLabelRight = transclude.isSlotFilled('labelRight');

    model.$formatters.push(function (value) {
      if (scope.options && scope.options.length > 0) {
        return scope.options.find(function (_) {
          return _.value === value;
        });
      }
      return null;
    });

    function close() {
      scope.open = false;
      angular.element($document).off('click', offClickHandler);
    }

    function modelFormatter(value) {
      if (scope.options && scope.options.length > 0) {
        return scope.options.find(function (_) {
          return _.value === value;
        });
      }
      return null;
    }

    function modelParser(viewValue) {
      return viewValue.value;
    }

    function offClickHandler() {
      return scope.$apply(close);
    }

    function onDestroy() {
      angular.element($document).off('click', offClickHandler);
    }

    function onModelChanged() {
      if (scope.options) {
        var modelMatch = scope.options.find(function (_) {
          return _.value === model.$modelValue;
        });
        if (modelMatch) {
          model.$setViewValue(modelMatch);
        } else {
          model.$modelValue = null;
        }
      }
    }

    function onOptionsChanged(newOptions, oldOptions) {
      if (newOptions && newOptions !== oldOptions && model.$modelValue) {
        var modelMatch = newOptions.find(function (_) {
          return _.value === model.$modelValue;
        });
        if (modelMatch) {
          model.$setViewValue(modelMatch);
        } else {
          model.$modelValue = null;
        }
      }
    }

    function open() {
      scope.open = true;
      angular.element($document).on('click', offClickHandler);
    }

    function select(item) {
      model.$setViewValue(item);
    }

    function toggleOpen($event) {
      if (scope.options && scope.options.length > 0 && !scope.readonly) {
        if (scope.open) {
          close();
        } else {
          open();
        }
        $event.stopPropagation();
      }
    }

    scope.select = select;
    scope.toggleOpen = toggleOpen;

    model.$formatters.push(modelFormatter);
    model.$parsers.push(modelParser);

    scope.$on('$destroy', onDestroy);
    scope.$watch('options', onOptionsChanged);
    scope.$watch(function () {
      return model.$modelValue;
    }, onModelChanged);
  }
}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=\"label && !hasLabelRight\" ng-bind=label> </label> <label ng-if=\"!label && !noLabel\" class=\"gmw-input-container__label heading-h4 h-dark-text desktop-only desktop-only--xs\"> &nbsp; </label> <label ng-if=\"label && !noLabel && hasLabelRight\" class=gmw-input-container__label> <span class=\"h-dark-text heading-h4\" ng-bind=label> </span> <div ng-transclude=labelRight></div> </label> <div class=gmw-box-selector ng-class=\"{\n      'gmw-box-selector--active': open,\n      'gmw-box-selector--filled': !!model.$viewValue && !readonly,\n      'gmw-box-selector--error': model.$invalid && (model.$dirty || form.$submitted),\n    }\" ng-disabled=\"options.length === 0 || readonly\"> <a ng-if=\"metaText && !metaUrl\" href=javascript:; class=\"gmw-box-selector__meta h-blue-link\"> <span ng-bind=metaText gmw-tooltip=\"{{metaDescription}}\"> </span> </a> <a ng-if=\"metaText && metaUrl\" href=\"{{metaUrl}}\" target=_blank ng-bind=metaText class=\"gmw-box-selector__meta h-blue-link\"> </a> <div class=gmw-box-selector__initial ng-click=toggleOpen($event)> <holding-crypto-badge ng-if=model.$viewValue.crypto crypto=model.$viewValue.crypto> </holding-crypto-badge> <holding-metal-badge ng-if=model.$viewValue.metal metal=model.$viewValue.metal> </holding-metal-badge> <i class=\"gmw-box-selector__flag flag\" ng-if=model.$viewValue.flag ng-class=model.$viewValue.flag|lowercase> </i> <img class=small-list__item-coin ng-if=model.$viewValue.imageUrl ng-src=\"{{model.$viewValue.imageUrl}}\"> <div class=gmw-box-selector__base-content> <div class=gmw-dual-dot-data ng-if=\"model.$viewValue && model.$viewValue.meta\"> <span class=\"ui-text h-dark-text\" ng-bind=model.$viewValue.label></span> <span class=\"gmw-dot gmw-dot--light\">&middot;</span> <span class=\"ui-text h-dark-text\" ng-bind=model.$viewValue.meta></span> </div> <div class=gmw-dual-dot-data ng-if=\"model.$viewValue && model.$viewValue.amount\"> <span class=\"ui-text h-dark-text\" ng-bind=model.$viewValue.label></span> <span class=\"gmw-dot gmw-dot--light\">&middot;</span> <span class=\"ui-text h-dark-text\" ng-bind=model.$viewValue.amount|holdingFormatFunds></span> </div> <div class=gmw-dual-dot-data ng-if=\"model.$viewValue && model.$viewValue.amountMetal\"> <span class=\"ui-text h-dark-text\" ng-bind=model.$viewValue.label></span> <span class=\"gmw-dot gmw-dot--light\">&middot;</span> <span class=\"ui-text h-dark-text\" ng-bind=model.$viewValue.amountMetal|gmwFormatProduct></span> </div> <span class=\"ui-text h-dark-text\" ng-if=\"model.$viewValue && !model.$viewValue.meta && !model.$viewValue.amount && !model.$viewValue.amountMetal\" ng-bind=model.$viewValue.label> </span> <span ng-if=\"!model.$viewValue && !placeholder\" translate> Please Select </span> <span ng-if=\"!model.$viewValue && placeholder\" ng-bind=placeholder> </span> </div> <svg class=gmw-box-selector__chevron ng-if=!readonly> <use xlink:href=#down-chevron-icon></use> </svg> <span class=\"gmw-box-selector__description ui-micro-text\" ng-if=\"description && !!model.$viewValue\" ng-bind=description> </span> </div> <div class=gmw-box-selector__dropdown-container> <ul class=\"small-list small-list--gmw\" ng-if=open> <li ng-repeat=\"item in options track by $index\" class=small-list__item ng-class=\"{\n            'small-list__item--selected': model.$viewValue.value === item.value,\n          }\" ng-click=select(item)> <holding-crypto-badge ng-if=item.crypto crypto=::item.crypto> </holding-crypto-badge> <holding-metal-badge ng-if=item.metal metal=::item.metal> </holding-metal-badge> <i class=\"small-list__item-flag flag\" ng-if=item.flag ng-class=item.flag|lowercase> </i> <img class=small-list__item-coin ng-if=::item.imageUrl ng-src=\"{{::item.imageUrl}}\"> <span class=small-list__item-label ng-bind=::item.label></span> <span class=small-list__item-meta ng-bind=::item.meta></span> <span class=small-list__item-meta ng-if=::item.amount ng-bind=::item.amount|holdingFormatFunds> </span> <span class=small-list__item-meta ng-if=::item.amountMetal ng-bind=::item.amountMetal|gmwFormatProduct> </span> </li> </ul> </div> </div> </div> ";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkbox = __webpack_require__(257);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwCheckbox', gmwCheckbox).name;


function gmwCheckbox() {
  'ngInject';

  var directive = {
    link: link,
    require: 'ngModel',
    replace: true,
    restrict: 'E',
    scope: {},
    template: _checkbox2.default,
    transclude: true
  };
  return directive;

  function link(scope, _elem, _attrs, ngModel) {
    scope.model = ngModel;
    scope.toggle = toggle;

    ngModel.$isEmpty = function (value) {
      return !value;
    };

    function toggle() {
      ngModel.$setViewValue(!ngModel.$viewValue);
    }
  }
}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-checkbox ng-click=toggle()> <div class=gmw-checkbox__box ng-class=\"{'gmw-checkbox__box--checked': !!model.$viewValue}\"> <svg class=gmw-checkbox__check> <use xlink:href=#thick-checkmark-icon></use> </svg> </div> <span ng-transclude></span> </div> ";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwDate.$inject = ['$interval'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwDate', gmwDate).name;


function gmwDate($interval) {
  'ngInject';

  var directive = {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var dateFormat = attrs.gmwDate || 'LL';
      var currentDate = (0, _moment2.default)().format(dateFormat);

      element.html(currentDate);

      var intervalTimer = $interval(function () {
        currentDate = (0, _moment2.default)().format(dateFormat);
        element.html(currentDate);
      }, 1000);

      scope.$on('$destroy', function () {
        $interval.cancel(intervalTimer);
      });
    }
  };
  return directive;
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwDigitsOnly', gmwDigitsOnly).name;


function gmwDigitsOnly() {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    require: 'ngModel'
  };
  return directive;

  function link(scope, _element, _attrs, ctrl) {
    scope.ctrl = ctrl;
    scope.model = {};

    ctrl.$parsers.push(function (value) {
      var newValue = value.replace(/[^0-9]/g, '');
      ctrl.$setViewValue(newValue);
      ctrl.$render();
      return newValue;
    });
  }
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwExpectedUse.$inject = ['HoldingCurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _expectedUse = __webpack_require__(261);

var _expectedUse2 = _interopRequireDefault(_expectedUse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwExpectedUse', gmwExpectedUse).name;


function gmwExpectedUse(HoldingCurrencies) {
  'ngInject';

  var transactionsCountOptions = [{ value: 14, label: 'Less than 15' }, { value: 49, label: '15-49' }, { value: 50, label: '50 or more' }];

  var directive = {
    link: link,
    replace: true,
    restrict: 'E',
    require: ['ngModel', '^^form'],
    scope: true,
    template: _expectedUse2.default
  };
  return directive;

  function link(scope, _element, _attrs, ctrls) {
    var ngModel = ctrls[0];
    scope.ngModel = ngModel;
    scope.form = ctrls[1];

    scope.currencies = HoldingCurrencies.getAllFiatForSelector();
    scope.formattedCurrency = {};
    scope.minExpectedValue = 1;
    scope.transactionsCountOptions = transactionsCountOptions;

    scope.model = {};
    scope.$watch('model', function (value) {
      ngModel.$setViewValue(value);
    });

    ngModel.$parsers.push(function (value) {
      scope.model = value;
      return value;
    });

    ngModel.$formatters.push(function (value) {
      scope.model = value;
    });

    scope.$watch('model.preferredCurrency', function (newCurrency, oldCurrency) {
      if (newCurrency !== oldCurrency) {
        switch (newCurrency) {
          case 'JPY':
            scope.minExpectedValue = 100;
            break;
          default:
            scope.minExpectedValue = 1;
            break;
        }
      }
    });
  }
}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "<div> <gmw-box-selector required name=preferredCurrency class=gmw-input-container ng-model=model.preferredCurrency label=\"{{'Transaction currency'|translate}}\" options=currencies> </gmw-box-selector> <div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Maximum Holding value'|translate\"></span> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'Please enter the maximum Holding value that you expect to reach as a Goldmoney Client.'|translate}}\" ng-bind=\"'How do I answer this?'|translate\"> </a> </label> <gmw-box-input required name=holdingValue type=number no-label=true ng-model=model.holdingValue currency=\"{{model.preferredCurrency}}\" min=minExpectedValue placeholder=0.00> <gmw-box-input-meta-left> {{model.preferredCurrency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Annual number of transactions'|translate\"></span> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'Please estimate the number of times that you will fund your Holding or receive transfers from other Holdings annually.'|translate}}\" ng-bind=\"'How do I answer this?'|translate\"> </a> </label> <gmw-box-selector required no-label=true name=transactionsCount ng-model=model.transactionsCount options=transactionsCountOptions> </gmw-box-selector> </div> <div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Annual transaction value'|translate\"></span> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'Please estimate the total value of the funds that you anticipate adding to your Holding or receive as transfers from other Holdings annually.'|translate}}\" ng-bind=\"'How do I answer this?'|translate\"> </a> </label> <gmw-box-input required name=transactionsValue type=number no-label=true ng-model=model.transactionsValue currency=\"{{model.preferredCurrency}}\" min=minExpectedValue placeholder=0.00> <gmw-box-input-meta-left> {{model.preferredCurrency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> </div> ";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feeTiers = __webpack_require__(263);

var _feeTiers2 = _interopRequireDefault(_feeTiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwFeeTiers', gmwFeeTiers).name;


function gmwFeeTiers() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    scope: {
      currency: '=',
      product: '=',
      tiers: '='
    },
    template: _feeTiers2.default
  };
  return directive;
}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding desktop-only desktop-only--xxs\"> <gmw-recap-table-header label=\"{{'Rate and Fee Tiers'|translate}}\"></gmw-recap-table-header> <div class=gmw-recap-table__body> <div class=gmw-recap-table__row> <div class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span class=gmw-recap-table__value> <span ng-bind=\"'Amount'|translate\"></span>&nbsp;(<span ng-bind=currency></span>) </span> </div> <div class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span class=gmw-recap-table__value> <span ng-bind=\"'Overall Rate'|translate\"></span>&nbsp;(<span ng-bind=product|holdingCurrencySymbol></span>) </span> </div> <div ng-if=\"(product|gmwProductType) === 'Metal' && product|gmwIsInGrams\" class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span class=gmw-recap-table__value> <span ng-bind=\"'Overall Rate (oz)'|translate\"></span> </span> </div> <div class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span class=gmw-recap-table__value> <span ng-bind=\"'Fee'|translate\"></span> </span> </div> </div> <div class=gmw-recap-table__row ng-repeat=\"tier in tiers track by tier.start\"> <div class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span ng-if=tier.end> <span ng-bind=tier.start|holdingFormatCurrency:currency></span> - <span ng-bind=tier.end|holdingFormatCurrency:currency></span> </span> <span ng-if=!tier.end> <span ng-bind=tier.start|holdingFormatCurrency:currency></span>+ </span> </div> <div class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span ng-if=!(tier.overallRate|gmwIsInGrams) ng-bind=tier.overallRate.value|holdingFormatCurrency:currency:4> </span> <span ng-if=tier.overallRate|gmwIsInGrams ng-bind=tier.overallRate.value|holdingFormatCurrency:currency:4> </span> </div> <div ng-if=\"(product|gmwProductType) === 'Metal' && product|gmwIsInGrams\" class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span ng-if=tier.overallRate|gmwIsInGrams ng-bind=tier.overallRate.value|holdingConvertOuncesToGrams|holdingFormatCurrency:currency:4> </span> <span ng-if=!(tier.overallRate|gmwIsInGrams) ng-bind=tier.overallRate.value|holdingFormatCurrency:currency:4> </span> </div> <div class=\"gmw-recap-table__col gmw-recap-table__col--center\"> <span> <span ng-bind=tier.fee.rate></span>% </span> </div> </div> </div> </div> ";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feeTiersMobile = __webpack_require__(265);

var _feeTiersMobile2 = _interopRequireDefault(_feeTiersMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwFeeTiersMobile', gmwFeeTiersMobile).name;


function gmwFeeTiersMobile() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    scope: {
      currency: '=',
      product: '=',
      tiers: '='
    },
    template: _feeTiersMobile2.default
  };
  return directive;
}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding mobile-only mobile-only--xxs\"> <gmw-recap-table-header label=\"{{'Rate and Fee Tiers'|translate}}\"></gmw-recap-table-header> <div class=gmw-recap-table__body> <div ng-repeat=\"tier in tiers track by tier.start\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Amount'|translate\"></span>&nbsp; (<span ng-bind=currency></span>) </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-if=tier.end> <span ng-bind=tier.start|holdingFormatCurrency:currency></span> - <span ng-bind=tier.end|holdingFormatCurrency:currency></span> </span> <span ng-if=!tier.end> <span ng-bind=tier.start|holdingFormatCurrency:currency></span>+ </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Overall Rate'|translate\"></span>&nbsp; (<span ng-bind=product|holdingCurrencySymbol></span>) </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=tier.overallRate.value|holdingFormatCurrency:currency:4> </span> </div> </div> <div ng-if=\"(product|gmwProductType) === 'Metal' && product|gmwIsInGrams\" class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Overall Rate (oz)'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-if=!(tier.overallRate|gmwIsInGrams) ng-bind=tier.overallRate.value|holdingFormatCurrency:currency:4> </span> <span ng-if=tier.overallRate|gmwIsInGrams ng-bind=tier.overallRate.value|holdingConvertOuncesToGrams|holdingFormatCurrency:currency:4> </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Fee'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=tier.fee.rate></span>% </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flag = __webpack_require__(267);

var _flag2 = _interopRequireDefault(_flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwFlag', gmwFlag).name;


function gmwFlag() {
  'ngInject';

  var directive = {
    restrict: 'E',
    template: _flag2.default,
    scope: {
      country: '='
    }
  };
  return directive;
}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = "<i class=flag ng-class=country|lowercase></i> ";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFocusOutFlyoutClose.$inject = ['$document', '$rootScope', '$timeout'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwFocusOutFlyoutClose', gmwFocusOutFlyoutClose).name;


function gmwFocusOutFlyoutClose($document, $rootScope, $timeout) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A'
  };
  return directive;

  function link(scope, element, attrs) {
    var clickInsideTimeout = void 0;
    var isProcessClick = true;

    function onClickInside() {
      isProcessClick = false;

      if (clickInsideTimeout) {
        $timeout.cancel(clickInsideTimeout);
      }

      clickInsideTimeout = $timeout(function () {
        isProcessClick = true;
      }, 10);
    }

    function onClickOutside() {
      if (isProcessClick) {
        $timeout(function () {
          $rootScope.$broadcast('gmw:flyout:close');
        });
      }
    }

    function onDestroy() {
      element.off('click focusin', onClickInside);
      $document.off('click focusin', onClickOutside);
      $timeout.cancel(clickInsideTimeout);
    }

    function onFlyoutStateChange(_origState) {
      var state = scope.$eval(attrs.gmwFocusOutFlyoutClose);
      if (state) {
        $timeout(function () {
          element.on('click focusin', onClickInside);
          $document.on('click focusin', onClickOutside);
        }, 10);
      } else {
        element.off('click focusin', onClickInside);
        $document.off('click focusin', onClickOutside);
      }
    }

    scope.$on('$destroy', onDestroy);
    attrs.$observe('gmwFocusOutFlyoutClose', onFlyoutStateChange);
  }
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatModelCurrency.$inject = ['HoldingCurrencies', 'HoldingFormatting'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwFormatModelCurrency', gmwFormatModelCurrency).name;


function gmwFormatModelCurrency(HoldingCurrencies, HoldingFormatting) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    require: 'ngModel'
  };
  return directive;

  function link(scope, element, attrs, model) {
    function blurHandler() {
      element.val(formattedOutput(model.$modelValue));
    }

    function cleanedOutput(input) {
      var cleaned = input ? input.toString() : '';

      /**
       * /[^\d.]/ - removes non-numeric values
       * /(.*?\..*?){2,}/ - removes duplicate decimals
       */
      if (/[^\d.]/.test(cleaned) || /(.*?\..*?){2,}/.test(cleaned)) {
        // replace commas with decimals
        cleaned = cleaned.replace(',', '.').replace(/[^\d.]/ig, '');
        var hasPoint = false;

        cleaned = cleaned.split('').filter(function (char) {
          if (char !== '.') {
            return true;
          } else if (!hasPoint) {
            hasPoint = true;
            return true;
          }
          return false;
        }).join('');

        model.$setViewValue(cleaned);
        model.$render();
      }
      return cleaned;
    }

    function focusHandler() {
      element.val(model.$modelValue);
    }

    function formattedOutput(str) {
      var currency = HoldingCurrencies.getCurrencyByCode(scope.currencyCode);

      var _HoldingFormatting$fo = HoldingFormatting.formatNumber(str, currency.decimals),
          formatted = _HoldingFormatting$fo.formatted;

      return formatted;
    }

    scope.currencyCode = attrs.gmwFormatModelCurrency || 'USD';

    model.$formatters.push(formattedOutput);
    model.$parsers.push(cleanedOutput);

    element.on('blur', blurHandler);
    element.on('focus', focusHandler);

    attrs.$observe('gmwFormatModelCurrency', function () {
      scope.currencyCode = attrs.gmwFormatModelCurrency || 'USD';
    });

    scope.$on('$destroy', function () {
      element.off('blur', blurHandler);
      element.off('focus', focusHandler);
    });
  }
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _genericCompleteHeader = __webpack_require__(271);

var _genericCompleteHeader2 = _interopRequireDefault(_genericCompleteHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwGenericCompleteHeader', gmwGenericCompleteHeader).name;


function gmwGenericCompleteHeader() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    scope: {
      pending: '=?',
      subTitle: '@?',
      title: '@?'
    },
    template: _genericCompleteHeader2.default
  };
  return directive;
}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-flow-box-success-header ng-class=\"{\n    'gmw-flow-box-success-header--pending': pending,\n  }\"> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--one\"></div> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--two\"></div> <img class=gmw-flow-box-success-header__icon src=/img/order-success-check.svg> <span class=gmw-flow-box-success-header__text> <span class=gmw-flow-box-success-header__title ng-bind=\"'Thank you for placing your order'|translate\" ng-if=!title> </span> <span class=gmw-flow-box-success-header__title ng-bind=title ng-if=title> </span> <span class=gmw-flow-box-success-header__sub-title ng-if=subTitle> <span ng-bind=subTitle></span> </span> </span> </div> ";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwLoadScript.$inject = ['$document', '$timeout'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(273);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwLoadScript', gmwLoadScript).name;


function gmwLoadScript($document, $timeout) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'E',
    scope: {
      src: '='
    },
    template: _loadScript2.default
  };
  return directive;

  function link(scope) {
    var scriptElem = void 0;

    function onSrcChanged(srcVal) {
      if (srcVal) {
        if (scriptElem) {
          $timeout(function () {
            $document[0].body.removeChild(scriptElem);
          });
        }

        $timeout(function () {
          scriptElem = $document[0].createElement('script');
          scriptElem.setAttribute('src', srcVal);
          $document[0].body.append(scriptElem);
        }, 100);
      }
    }

    scope.$watch('src', onSrcChanged);
  }
}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "<div></div> ";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mainTable = __webpack_require__(275);

var _mainTable2 = _interopRequireDefault(_mainTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwMainTable', gmwMainTable).name;


function gmwMainTable() {
  'ngInject';

  link.$inject = ['scope', '_element', 'attrs'];
  var directive = {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {},
    template: _mainTable2.default,
    transclude: true
  };
  return directive;

  function link(scope, _element, attrs) {
    'ngInject';

    scope.desktopOnly = scope.$eval(attrs.desktopOnly);
    scope.hover = scope.$eval(attrs.hover);
    scope.mobileOnly = scope.$eval(attrs.mobileOnly);
    scope.small = scope.$eval(attrs.small);
    scope.fullWidth = 'fullWidth' in attrs;
  }
}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-main-table ng-class=\"{\n    'desktop-only desktop-only--sm': desktopOnly,\n    'gmw-main-table--hover': hover,\n    'mobile-only mobile-only--sm': mobileOnly,\n    'gmw-main-table--small-padding': small,\n    'gmw-main-table--full-width': fullWidth\n  }\" ng-transclude> </div> ";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mainTableBody = __webpack_require__(277);

var _mainTableBody2 = _interopRequireDefault(_mainTableBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwMainTableBody', gmwMainTableBody).name;


function gmwMainTableBody() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    template: _mainTableBody2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-main-table__body ng-transclude> </div> ";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mainTableBodyCol = __webpack_require__(279);

var _mainTableBodyCol2 = _interopRequireDefault(_mainTableBodyCol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwMainTableBodyCol', gmwMainTableBodyCol).name;


function gmwMainTableBodyCol() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    template: _mainTableBodyCol2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-main-table__body-cell ng-transclude> </div> ";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mainTableBodyRow = __webpack_require__(281);

var _mainTableBodyRow2 = _interopRequireDefault(_mainTableBodyRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwMainTableBodyRow', gmwMainTableBodyRow).name;


function gmwMainTableBodyRow() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    template: _mainTableBodyRow2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-main-table__body-row ng-transclude></div> ";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mainTableHeader = __webpack_require__(283);

var _mainTableHeader2 = _interopRequireDefault(_mainTableHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwMainTableHeader', gmwMainTableHeader).name;


function gmwMainTableHeader() {
  'ngInject';

  controller.$inject = ['$scope'];
  var directive = {
    controller: controller,
    controllerAs: 'gmwMainTableHeader',
    link: link,
    replace: true,
    require: ['gmwMainTableHeader', '?ngModel'],
    restrict: 'E',
    scope: {
      sortable: '='
    },
    template: _mainTableHeader2.default,
    transclude: true
  };
  return directive;

  function controller($scope) {
    'ngInject';

    var vm = this;
    vm.setSorting = setSorting;

    function setSorting(newField) {
      var _$scope$model$$modelV = $scope.model.$modelValue,
          field = _$scope$model$$modelV.field,
          type = _$scope$model$$modelV.type;

      var newSorting = { field: newField };
      if (field === newField && type === 'asc') {
        newSorting.type = 'desc';
      } else {
        newSorting.type = 'asc';
      }
      $scope.model.$setViewValue(newSorting);
    }
  }

  function link($scope, _elem, _attrs, ctrls) {
    $scope.model = ctrls[1];
  }
}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-main-table__head ng-transclude> </div> ";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mainTableHeaderCol = __webpack_require__(285);

var _mainTableHeaderCol2 = _interopRequireDefault(_mainTableHeaderCol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwMainTableHeaderCol', gmwMainTableHeaderCol).name;


function gmwMainTableHeaderCol() {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    require: ['^gmwMainTableHeader', '^?ngModel'],
    restrict: 'E',
    template: _mainTableHeaderCol2.default,
    scope: {
      tooltip: '@?'
    },
    transclude: true
  };
  return directive;

  function link(scope, _element, $attrs, ctrls) {
    var field = $attrs.field;

    var _ctrls = _slicedToArray(ctrls, 2),
        ctrl = _ctrls[0],
        ngModel = _ctrls[1];

    function changeSorting() {
      if (field) {
        ctrl.setSorting(field);
      }
    }

    scope.changeSorting = changeSorting;
    scope.hasField = !!field;
    scope.model = ngModel;

    scope.$watch('model.$modelValue', function (value) {
      if (value && value.field === field) {
        scope.sortingDirection = value.type;
      } else {
        scope.sortingDirection = undefined;
      }
    }, true);
  }
}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-main-table__head-cell ng-class=\"{\n    'gmw-main-table__head-cell--sortable': sortable && hasField,\n  }\" ng-click=changeSorting()> <span ng-class=\"{\n      'h-dark-text': !!sortingDirection,\n    }\"> <span ng-transclude></span> <svg class=gmw-main-table__ordering-chevron ng-class=sortingDirection ng-if=!!sortingDirection> <use xlink:href=#down-chevron-icon></use> </svg> <svg class=gmw-main-table__tooltip-indicator ng-if=!!tooltip gmw-tooltip=\"{{tooltip}}\"> <use xlink:href=#info-icon></use> </svg> </span> </div> ";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwMatches', gmwMatches).name;


function gmwMatches() {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    require: 'ngModel'
  };
  return directive;

  function link(_scope, _element, attrs, ctrl) {
    ctrl.$validators.matches = function (modelValue) {
      return modelValue ? modelValue === attrs.gmwMatches : true;
    };
  }
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwMax', gmwMax).name;


function gmwMax() {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    require: 'ngModel'
  };
  return directive;

  function link(scope, _element, attrs, ctrl) {
    function checkValidity(origVal, origMax) {
      var max = parseFloat(origMax);
      var val = origVal;

      if (!isNaN(max)) {
        val = isFinite(parseFloat(val)) ? parseFloat(val) : 0;
        ctrl.$setValidity('max', val <= max);
      } else {
        ctrl.$setValidity('max', true);
      }
    }

    attrs.$observe('gmwMax', function (newMax) {
      checkValidity(ctrl.$viewValue, newMax);
    });

    scope.$watch(function () {
      return ctrl.$viewValue;
    }, function (newVal) {
      checkValidity(newVal, attrs.gmwMax);
    });
  }
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwMin', gmwMin).name;


function gmwMin() {
  'ngInject';

  var directive = {
    link: link,
    require: 'ngModel',
    restrict: 'A'
  };
  return directive;

  function link(_scope, _element, attrs, ctrl) {
    ctrl.$validators.min = function (origVal) {
      var min = attrs.gmwMin;
      var val = origVal;
      min = parseFloat(min);

      if (!isNaN(min)) {
        val = parseFloat(val);
        val = isNaN(val) ? 0 : val;

        ctrl.$setValidity('min', val >= min);
        return val >= min;
      }
      return true;
    };

    attrs.$observe('gmwMin', ctrl.$validate);
  }
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwNumberInt', gmwNumberInt).name;


function gmwNumberInt() {
  'ngInject';

  var directive = {
    link: link,
    require: 'ngModel',
    restrict: 'A'
  };
  return directive;

  function link(_scope, _element, _attrs, ctrl) {
    function validate(text) {
      var str = text ? text.toString() : '';

      if (/[^\d]/.test(str)) {
        var cleaned = str.replace(/[^\d]/ig, '');

        var number = parseInt(cleaned, 10);

        ctrl.$setViewValue(number);
        ctrl.$render();

        return number;
      }

      return parseInt(text, 10);
    }

    ctrl.$parsers.unshift(validate);
  }
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _orderCompleteHeader = __webpack_require__(291);

var _orderCompleteHeader2 = _interopRequireDefault(_orderCompleteHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwOrderCompleteHeader', gmwOrderCompleteHeader).name;


function gmwOrderCompleteHeader() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    scope: {
      orderNumber: '@?'
    },
    template: _orderCompleteHeader2.default
  };
  return directive;
}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-flow-box-success-header> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--one\"></div> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--two\"></div> <img class=gmw-flow-box-success-header__icon src=/img/order-success-check.svg> <span class=gmw-flow-box-success-header__text> <span class=gmw-flow-box-success-header__title ng-bind=\"'Thank you for placing your order'|translate\"> </span> <span class=gmw-flow-box-success-header__sub-title ng-if=orderNumber> <span ng-bind=\"'Order Number:'|translate\"></span> <span ng-bind=orderNumber></span> </span> </span> </div> ";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwPrint.$inject = ['$window'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwPrint', gmwPrint).name;


function gmwPrint($window) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A'
  };
  return directive;

  function link(_scope, element) {
    element.on('click', function () {
      return $window.print();
    });
  }
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radioOption = __webpack_require__(294);

var _radioOption2 = _interopRequireDefault(_radioOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwRadioOption', gmwRadioOption).name;


function gmwRadioOption() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    scope: {
      checked: '=?',
      gmwDisabled: '=?',
      label: '@?',
      small: '=?'
    },
    template: _radioOption2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-radio-container> <div class=gmw-radio ng-disabled=gmwDisabled ng-class=\"{\n      'gmw-radio--checked': checked,\n      'gmw-radio--small': small,\n    }\"> </div> <span class=gmw-radio-container__data ng-if=label> <span class=gmw-radio-container__label ng-class=\"{\n        'h-dark-text': checked,\n      }\" ng-bind=label> </span> <ng-transclude></ng-transclude> </span> </div> ";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwRemainingTime.$inject = ['$interval'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(296);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwRemainingTime', gmwRemainingTime).name;


function gmwRemainingTime($interval) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    scope: {
      gmwRemainingTime: '=',
      gmwRemainingTimeExpired: '=?',
      gmwRemainingTimeFormat: '@?'
    }
  };
  return directive;

  function link(scope, element, attrs) {
    var intervalTimer = $interval(updateTime, 1000);

    function onDestroy() {
      $interval.cancel(intervalTimer);
    }

    function updateTime() {
      var end = (0, _moment2.default)(scope.gmwRemainingTime);
      var now = (0, _moment2.default)();
      var duration = void 0;
      if (now.isSameOrAfter(end)) {
        duration = _moment2.default.duration(0);
        $interval.cancel(intervalTimer);

        if ('gmwRemainingTimeExpired' in attrs) {
          scope.gmwRemainingTimeExpired = true;
        }
      } else {
        duration = _moment2.default.duration(end.diff((0, _moment2.default)()));
      }
      element.html(duration.format({
        template: scope.gmwRemainingTimeFormat ? scope.gmwRemainingTimeFormat : 'mm:ss',
        trim: false
      }));
    }

    updateTime();

    scope.$on('$destroy', onDestroy);
  }
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

/*! Moment Duration Format v1.3.0
 *  https://github.com/jsmreese/moment-duration-format 
 *  Date: 2014-07-15
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2014 John Madhavan-Reese
 *  Released under the MIT license
 */

(function (root, undefined) {

	// repeatZero(qty)
	// returns "0" repeated qty times
	function repeatZero(qty) {
		var result = "";
		
		// exit early
		// if qty is 0 or a negative number
		// or doesn't coerce to an integer
		qty = parseInt(qty, 10);
		if (!qty || qty < 1) { return result; }
		
		while (qty) {
			result += "0";
			qty -= 1;
		}
		
		return result;
	}
	
	// padZero(str, len [, isRight])
	// pads a string with zeros up to a specified length
	// will not pad a string if its length is aready
	// greater than or equal to the specified length
	// default output pads with zeros on the left
	// set isRight to `true` to pad with zeros on the right
	function padZero(str, len, isRight) {
		if (str == null) { str = ""; }
		str = "" + str;
		
		return (isRight ? str : "") + repeatZero(len - str.length) + (isRight ? "" : str);
	}
	
	// isArray
	function isArray(array) {
		return Object.prototype.toString.call(array) === "[object Array]";
	}
	
	// isObject
	function isObject(obj) {
		return Object.prototype.toString.call(obj) === "[object Object]";
	}
	
	// findLast
	function findLast(array, callback) {
		var index = array.length;

		while (index -= 1) {
			if (callback(array[index])) { return array[index]; }
		}
	}

	// find
	function find(array, callback) {
		var index = 0,
			max = array.length,
			match;
			
		if (typeof callback !== "function") {
			match = callback;
			callback = function (item) {
				return item === match;
			};
		}

		while (index < max) {
			if (callback(array[index])) { return array[index]; }
			index += 1;
		}
	}
	
	// each
	function each(array, callback) {
		var index = 0,
			max = array.length;
			
		if (!array || !max) { return; }

		while (index < max) {
			if (callback(array[index], index) === false) { return; }
			index += 1;
		}
	}
	
	// map
	function map(array, callback) {
		var index = 0,
			max = array.length,
			ret = [];

		if (!array || !max) { return ret; }
				
		while (index < max) {
			ret[index] = callback(array[index], index);
			index += 1;
		}
		
		return ret;
	}
	
	// pluck
	function pluck(array, prop) {
		return map(array, function (item) {
			return item[prop];
		});
	}
	
	// compact
	function compact(array) {
		var ret = [];
		
		each(array, function (item) {
			if (item) { ret.push(item); }
		});
		
		return ret;
	}
	
	// unique
	function unique(array) {
		var ret = [];
		
		each(array, function (_a) {
			if (!find(ret, _a)) { ret.push(_a); }
		});
		
		return ret;
	}
	
	// intersection
	function intersection(a, b) {
		var ret = [];
		
		each(a, function (_a) {
			each(b, function (_b) {
				if (_a === _b) { ret.push(_a); }
			});
		});
		
		return unique(ret);
	}
	
	// rest
	function rest(array, callback) {
		var ret = [];
		
		each(array, function (item, index) {
			if (!callback(item)) {
				ret = array.slice(index);
				return false;
			}
		});
		
		return ret;
	}

	// initial
	function initial(array, callback) {
		var reversed = array.slice().reverse();
		
		return rest(reversed, callback).reverse();
	}
	
	// extend
	function extend(a, b) {
		for (var key in b) {
			if (b.hasOwnProperty(key)) { a[key] = b[key]; }
		}
		
		return a;
	}
			
	// define internal moment reference
	var moment;

	if (true) {
		try { moment = __webpack_require__(0); } 
		catch (e) {}
	} 
	
	if (!moment && root.moment) {
		moment = root.moment;
	}
	
	if (!moment) {
		throw "Moment Duration Format cannot find Moment.js";
	}
	
	// moment.duration.format([template] [, precision] [, settings])
	moment.duration.fn.format = function () {

		var tokenizer, tokens, types, typeMap, momentTypes, foundFirst, trimIndex,
			args = [].slice.call(arguments),
			settings = extend({}, this.format.defaults),
			// keep a shadow copy of this moment for calculating remainders
			remainder = moment.duration(this);

		// add a reference to this duration object to the settings for use
		// in a template function
		settings.duration = this;

		// parse arguments
		each(args, function (arg) {
			if (typeof arg === "string" || typeof arg === "function") {
				settings.template = arg;
				return;
			}

			if (typeof arg === "number") {
				settings.precision = arg;
				return;
			}

			if (isObject(arg)) {
				extend(settings, arg);
			}
		});

		// types
		types = settings.types = (isArray(settings.types) ? settings.types : settings.types.split(" "));

		// template
		if (typeof settings.template === "function") {
			settings.template = settings.template.apply(settings);
		}

		// tokenizer regexp
		tokenizer = new RegExp(map(types, function (type) {
			return settings[type].source;
		}).join("|"), "g");

		// token type map function
		typeMap = function (token) {
			return find(types, function (type) {
				return settings[type].test(token);
			});
		};

		// tokens array
		tokens = map(settings.template.match(tokenizer), function (token, index) {
			var type = typeMap(token),
				length = token.length;

			return {
				index: index,
				length: length,

				// replace escaped tokens with the non-escaped token text
				token: (type === "escape" ? token.replace(settings.escape, "$1") : token),

				// ignore type on non-moment tokens
				type: ((type === "escape" || type === "general") ? null : type)

				// calculate base value for all moment tokens
				//baseValue: ((type === "escape" || type === "general") ? null : this.as(type))
			};
		}, this);

		// unique moment token types in the template (in order of descending magnitude)
		momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));

		// exit early if there are no momentTypes
		if (!momentTypes.length) {
			return pluck(tokens, "token").join("");
		}

		// calculate values for each token type in the template
		each(momentTypes, function (momentType, index) {
			var value, wholeValue, decimalValue, isLeast, isMost;

			// calculate integer and decimal value portions
			value = remainder.as(momentType);
			wholeValue = (value > 0 ? Math.floor(value) : Math.ceil(value));
			decimalValue = value - wholeValue;

			// is this the least-significant moment token found?
			isLeast = ((index + 1) === momentTypes.length);

			// is this the most-significant moment token found?
			isMost = (!index);

			// update tokens array
			// using this algorithm to not assume anything about
			// the order or frequency of any tokens
			each(tokens, function (token) {
				if (token.type === momentType) {
					extend(token, {
						value: value,
						wholeValue: wholeValue,
						decimalValue: decimalValue,
						isLeast: isLeast,
						isMost: isMost
					});

					if (isMost) {
						// note the length of the most-significant moment token:
						// if it is greater than one and forceLength is not set, default forceLength to `true`
						if (settings.forceLength == null && token.length > 1) {
							settings.forceLength = true;
						}

						// rationale is this:
						// if the template is "h:mm:ss" and the moment value is 5 minutes, the user-friendly output is "5:00", not "05:00"
						// shouldn't pad the `minutes` token even though it has length of two
						// if the template is "hh:mm:ss", the user clearly wanted everything padded so we should output "05:00"
						// if the user wanted the full padded output, they can set `{ trim: false }` to get "00:05:00"
					}
				}
			});

			// update remainder
			remainder.subtract(wholeValue, momentType);
		});
	
		// trim tokens array
		if (settings.trim) {
			tokens = (settings.trim === "left" ? rest : initial)(tokens, function (token) {
				// return `true` if:
				// the token is not the least moment token (don't trim the least moment token)
				// the token is a moment token that does not have a value (don't trim moment tokens that have a whole value)
				return !(token.isLeast || (token.type != null && token.wholeValue));
			});
		}
		
		
		// build output

		// the first moment token can have special handling
		foundFirst = false;

		// run the map in reverse order if trimming from the right
		if (settings.trim === "right") {
			tokens.reverse();
		}

		tokens = map(tokens, function (token) {
			var val,
				decVal;

			if (!token.type) {
				// if it is not a moment token, use the token as its own value
				return token.token;
			}

			// apply negative precision formatting to the least-significant moment token
			if (token.isLeast && (settings.precision < 0)) {
				val = (Math.floor(token.wholeValue * Math.pow(10, settings.precision)) * Math.pow(10, -settings.precision)).toString();
			} else {
				val = token.wholeValue.toString();
			}
			
			// remove negative sign from the beginning
			val = val.replace(/^\-/, "");

			// apply token length formatting
			// special handling for the first moment token that is not the most significant in a trimmed template
			if (token.length > 1 && (foundFirst || token.isMost || settings.forceLength)) {
				val = padZero(val, token.length);
			}

			// add decimal value if precision > 0
			if (token.isLeast && (settings.precision > 0)) {
				decVal = token.decimalValue.toString().replace(/^\-/, "").split(/\.|e\-/);
				switch (decVal.length) {
					case 1:
						val += "." + padZero(decVal[0], settings.precision, true).slice(0, settings.precision);
						break;
						
					case 2:
						val += "." + padZero(decVal[1], settings.precision, true).slice(0, settings.precision);		
						break;
						
					case 3:
						val += "." + padZero(repeatZero((+decVal[2]) - 1) + (decVal[0] || "0") + decVal[1], settings.precision, true).slice(0, settings.precision);		
						break;
					
					default:
						throw "Moment Duration Format: unable to parse token decimal value.";
				}
			}
			
			// add a negative sign if the value is negative and token is most significant
			if (token.isMost && token.value < 0) {
				val = "-" + val;
			}

			foundFirst = true;

			return val;
		});

		// undo the reverse if trimming from the right
		if (settings.trim === "right") {
			tokens.reverse();
		}

		return tokens.join("");
	};

	moment.duration.fn.format.defaults = {
		// token definitions
		escape: /\[(.+?)\]/,
		years: /[Yy]+/,
		months: /M+/,
		weeks: /[Ww]+/,
		days: /[Dd]+/,
		hours: /[Hh]+/,
		minutes: /m+/,
		seconds: /s+/,
		milliseconds: /S+/,
		general: /.+?/,

		// token type names
		// in order of descending magnitude
		// can be a space-separated token name list or an array of token names
		types: "escape years months weeks days hours minutes seconds milliseconds general",

		// format options

		// trim
		// "left" - template tokens are trimmed from the left until the first moment token that has a value >= 1
		// "right" - template tokens are trimmed from the right until the first moment token that has a value >= 1
		// (the final moment token is not trimmed, regardless of value)
		// `false` - template tokens are not trimmed
		trim: "left",

		// precision
		// number of decimal digits to include after (to the right of) the decimal point (positive integer)
		// or the number of digits to truncate to 0 before (to the left of) the decimal point (negative integer)
		precision: 0,

		// force first moment token with a value to render at full length even when template is trimmed and first moment token has length of 1
		forceLength: null,

		// template used to format duration
		// may be a function or a string
		// template functions are executed with the `this` binding of the settings object
		// so that template strings may be dynamically generated based on the duration object
		// (accessible via `this.duration`)
		// or any of the other settings
		template: function () {
			var types = this.types,
				dur = this.duration,
				lastType = findLast(types, function (type) {
					return dur._data[type];
				});

			// default template strings for each duration dimension type
			switch (lastType) {
				case "seconds":
					return "h:mm:ss";
				case "minutes":
					return "d[d] h:mm";
				case "hours":
					return "d[d] h[h]";
				case "days":
					return "M[m] d[d]";
				case "weeks":
					return "y[y] w[w]";
				case "months":
					return "y[y] M[m]";
				case "years":
					return "y[y]";
				default:
					return "y[y] M[m] d[d] h:mm:ss";
			}
		}
	};

})(this);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebarList = __webpack_require__(298);

var _sidebarList2 = _interopRequireDefault(_sidebarList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwSidebarList', gmwSidebarList).name;


function gmwSidebarList() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    template: _sidebarList2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "<ul class=holding-dashboard-sidebar-help-list ng-transclude></ul> ";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwSidebarListLink.$inject = ['$window', 'GmwModal'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebarListLink = __webpack_require__(300);

var _sidebarListLink2 = _interopRequireDefault(_sidebarListLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sidebarListLinkModal = __webpack_require__(301);

exports.default = angular.module('gm.wealth.common').directive('gmwSidebarListLink', gmwSidebarListLink).name;


function gmwSidebarListLink($window, GmwModal) {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      href: '@?',
      label: '@'
    },
    template: _sidebarListLink2.default,
    transclude: true
  };
  return directive;

  function link(scope, _element, _attrs, _model, transclude) {
    var modalContent = void 0;

    transclude(function (clone) {
      if (clone.length > 1) {
        modalContent = clone[1].outerHTML;
      }
    });

    scope.open = function () {
      if (scope.href) {
        $window.open(scope.href, '_blank');
      }

      if (modalContent) {
        var modalTemplate = '\n          <div class="gmw-modal">\n            <div class="gmw-modal-header">\n              <h4 class="gmw-modal-header__label dark-text">' + scope.label + '</h4>\n              <a\n                href\n                ng-click="sidebarListLinkModalCtrl.close(\'close\')"\n                class="gmw-modal-header__close-container">\n                <svg class="gmw-modal-header__close">\n                  <use xlink:href="#cross-icon"></use>\n                </svg>\n              </a>\n            </div>\n            <div class="gmw-modal__container">\n              <div class="gmw-modal__inner">\n                ' + modalContent + '\n              </div>\n            </div>\n          </div>\n        ';
        GmwModal.showModal({
          template: modalTemplate,
          controller: sidebarListLinkModal.controller,
          controllerAs: sidebarListLinkModal.controllerAs
        });
      }
    };
  }
}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "<li class=holding-dashboard-sidebar-help-list__item> <svg class=holding-dashboard-sidebar-help-list__chevron width=6 height=9> <use xlink:href=#right-chevron-icon></use> </svg> <a class=\"holding-dashboard-sidebar-help-list__label h-medium-text\" ng-bind=label ng-click=open()> </a> </li> ";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SidebarListLinkModalController.$inject = ['close'];
module.exports = {
  controller: 'SidebarListLinkModalController',
  controllerAs: 'sidebarListLinkModalCtrl'
};

angular.module('gm.wealth.common').controller(module.exports.controller, SidebarListLinkModalController);

function SidebarListLinkModalController(close) {
  'ngInject';

  this.close = close;
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebarProgress = __webpack_require__(303);

var _sidebarProgress2 = _interopRequireDefault(_sidebarProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwSidebarProgress', gmwSidebarProgress).name;


function gmwSidebarProgress() {
  'ngInject';

  var directive = {
    controller: function controller() {},

    template: _sidebarProgress2.default,
    bindToController: {
      steps: '='
    },
    controllerAs: 'gmwSidebarProgress',
    replace: true,
    restrict: 'E',
    scope: {
      label: '@'
    },
    transclude: true
  };
  return directive;
}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "<div> <holding-flow-sidebar-section header=\"Current Progress\" sub-header=\"{{label}}\"> <ul class=holding-dashboard-sidebar__list> <ng-transclude></ng-transclude> </ul> </holding-flow-sidebar-section> </div> ";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GmwSubmit = function () {
    function GmwSubmit($parse, $timeout) {
        _classCallCheck(this, GmwSubmit);

        this.$parse = $parse;
        this.$timeout = $timeout;
        this.restrict = 'A';
    }

    _createClass(GmwSubmit, [{
        key: 'compile',
        value: function compile(_element, attrs) {
            var _this = this;

            var fn = this.$parse(attrs.gmwSubmit, undefined, true);
            return function (scope, element) {
                element.on('submit', function ($event) {
                    var btnEl = element.find('button[type=submit]');
                    btnEl.addClass('loading-button');
                    btnEl.prop('disabled', true);
                    _this.$timeout(function () {
                        var result = fn(scope, { $event: $event });
                        if (result && angular.isFunction(result.finally)) {
                            result.finally(function () {
                                btnEl.removeClass('loading-button');
                                btnEl.prop('disabled', false);
                            });
                        } else {
                            btnEl.removeClass('loading-button');
                            btnEl.prop('disabled', false);
                        }
                    });
                });
            };
        }
    }], [{
        key: 'factory',
        value: function factory() {
            var directive = function directive($parse, $timeout) {
                return new GmwSubmit($parse, $timeout);
            };
            directive.$inject = ['$parse', '$timeout'];
            return directive;
        }
    }]);

    return GmwSubmit;
}();

exports.default = angular.module('gm.wealth.common').directive('gmwSubmit', GmwSubmit.factory());

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwTime.$inject = ['$interval'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwTime', gmwTime).name;


function gmwTime($interval) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A'
  };

  function link(scope, element, attrs) {
    var timeFormat = attrs.gmwTime || 'HH:mm';
    updateTime();

    var intervalTimer = $interval(updateTime, 1000);

    scope.$on('$destroy', function () {
      $interval.cancel(intervalTimer);
    });

    function updateTime() {
      var currentTime = (0, _moment2.default)().format(timeFormat);
      element.html(currentTime);
    }
  }

  return directive;
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleOption = __webpack_require__(307);

var _toggleOption2 = _interopRequireDefault(_toggleOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwToggleOption', gmwToggleOption).name;


function gmwToggleOption() {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    require: '^ngModel',
    restrict: 'E',
    scope: {
      label: '@',
      value: '='
    },
    template: _toggleOption2.default
  };
  return directive;

  function link(scope, _element, attrs, ctrl) {
    scope.onClick = onClick;

    function onClick() {
      if (!scope.disabled) {
        ctrl.$setViewValue(scope.value);
      }
    }

    function onValueChange(passed) {
      var value = ctrl.$viewValue;

      scope.active = value === scope.value;
      return passed;
    }

    attrs.$observe('disabled', function () {
      scope.disabled = attrs.disabled || false;
    });
    scope.$watch(function () {
      return scope.value;
    }, onValueChange);
    ctrl.$parsers.unshift(function (modelVal) {
      scope.active = modelVal === scope.value;
      return modelVal;
    });
    ctrl.$formatters.unshift(function (modelVal) {
      scope.active = modelVal === scope.value;
      return modelVal;
    });
  }
}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "<a href class=\"heading-h5 option-toggle__item\" ng-class=\"{\n    'option-toggle__item--active': active\n  }\" ng-click=onClick() ng-bind=label> </a> ";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleOptionGroup = __webpack_require__(309);

var _toggleOptionGroup2 = _interopRequireDefault(_toggleOptionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwToggleOptionGroup', gmwToggleOptionGroup).name;


function gmwToggleOptionGroup() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    template: _toggleOptionGroup2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "<div class=option-toggle ng-transclude> </div> ";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwTooltip.$inject = ['$compile', '$window'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').directive('gmwTooltip', gmwTooltip).name;


function gmwTooltip($compile, $window) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    scope: true
  };
  return directive;

  function link(scope, element, attrs) {
    var template = $compile('<div class="gmw-tooltip" ng-bind-html="tooltip"></div>')(scope);
    var isVisible = false;

    function activeHandler(event) {
      if (!isVisible) {
        element.after(template);
        calculatePosition(event);
        isVisible = true;
      }
    }

    function calculatePosition(event) {
      var pos = event.target.getBoundingClientRect();
      var posTop = pos.top + $window.scrollY;
      var posBottom = pos.bottom + $window.scrollY;

      var offset = template.offset();
      var tipHeight = template.outerHeight();
      var tipWidth = template.outerWidth();
      var elWidth = pos.width || pos.right - pos.left;
      var elHeight = pos.height || posBottom - posTop;
      var tipOffset = 10;

      if (element.hasClass('tooltip-right')) {
        offset.top = posTop - tipHeight / 2 + elHeight / 2;
        offset.left = pos.right + tipOffset;
      } else if (element.hasClass('tooltip-left')) {
        offset.top = posTop - tipHeight / 2 + elHeight / 2;
        offset.left = pos.left - tipWidth - tipOffset;
      } else if (element.hasClass('tooltip-bottom')) {
        offset.top = posTop + elHeight + tipOffset;
        offset.left = pos.left - tipWidth / 2 + elWidth / 2;
      } else {
        offset.top = posTop - tipHeight - tipOffset;
        offset.left = pos.left - tipWidth / 2 + elWidth / 2;
      }

      template.offset(offset);
    }

    function inactiveHandler() {
      if (isVisible) {
        element.nextAll().first().remove();
        isVisible = false;
      }
    }

    function onDestroy() {
      element.off('mouseover focus', activeHandler);
      element.off('mouseleave blur', inactiveHandler);
    }

    element.on('mouseover focus', activeHandler);
    element.on('mouseleave blur', inactiveHandler);

    attrs.$observe('gmwTooltip', function (newVal) {
      scope.tooltip = newVal;
    });

    scope.$on('$destroy', onDestroy);
  }
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwAddPercentage', gmwAddPercentage).name;


function gmwAddPercentage() {
  'ngInject';

  return addPercentage;

  function addPercentage(input, percentage) {
    if (!input || !percentage) {
      return input;
    }
    return input + input * percentage / 100;
  }
}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwAddPeriod', gmwAddPeriod).name;


function gmwAddPeriod() {
  'ngInject';

  return addPeriod;

  function addPeriod(input) {
    if (!input) {
      return input;
    }
    return input.replace(/\.\s*$/, '') + '.';
  }
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwIsArray', gmwIsArray).name;


function gmwIsArray() {
  'ngInject';

  return isArray;

  function isArray(input) {
    return angular.isArray(input);
  }
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwIsInGrams.$inject = ['HoldingCurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwIsInGrams', gmwIsInGrams).name;


function gmwIsInGrams(HoldingCurrencies) {
  'ngInject';

  return isInGrams;

  function isInGrams(input) {
    if (!input) {
      return undefined;
    }
    var metal = void 0;
    if (angular.isString(input)) {
      metal = input;
    }
    if (angular.isObject(input)) {
      if ('currency' in input) {
        metal = input.currency;
      }
      if ('baseCurrency' in input) {
        metal = input.baseCurrency;
      }
    }
    if (!metal) {
      return undefined;
    }
    var currency = HoldingCurrencies.getCurrencyByCode(metal);
    return currency.weightUnit === 'GRAMS';
  }
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GmwProductType = function () {
    function GmwProductType() {
        _classCallCheck(this, GmwProductType);
    }

    _createClass(GmwProductType, null, [{
        key: 'factory',
        value: function factory() {
            var factoryFunction = function factoryFunction(HoldingCurrencies) {
                return function (input) {
                    if (!input) {
                        return undefined;
                    }
                    var currency = HoldingCurrencies.getCurrencyByCode(input.currency || input);
                    return currency.type;
                };
            };
            factoryFunction.$inject = ['HoldingCurrencies'];
            return factoryFunction;
        }
    }]);

    return GmwProductType;
}();

exports.default = angular.module('gm.wealth.common').filter('gmwProductType', GmwProductType.factory()).name;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwRemoveHyphens', gmwRemoveHyphens).name;


function gmwRemoveHyphens() {
  'ngInject';

  return removeHyphens;

  function removeHyphens(input) {
    if (!input) {
      return input;
    }

    return input.replace('-', '');
  }
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwSlashToNewline', gmwSlashToNewline).name;


function gmwSlashToNewline() {
  'ngInject';

  return function (input) {
    if (!input) {
      return input;
    }
    return input.replace(/\\/g, '<br>');
  };
}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwSubtractPercentage', gmwSubtractPercentage).name;


function gmwSubtractPercentage() {
  'ngInject';

  return subtractPercentage;

  function subtractPercentage(input, percentage) {
    if (!input || !percentage) {
      return input;
    }
    return input - input * percentage / 100;
  }
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function translateDigit(digit) {
    switch (digit) {
        case 0:
            return '';
        case 1:
            return '一';
        case 2:
            return '二';
        case 3:
            return '三';
        case 4:
            return '四';
        case 5:
            return '五';
        case 6:
            return '六';
        case 7:
            return '七';
        case 8:
            return '八';
        case 9:
            return '九';
        default:
            return digit.toString();
    }
}
function digitWithPrefix(prefix, digit) {
    switch (digit) {
        case 0:
            return '';
        case 1:
            return prefix;
        default:
            return '' + translateDigit(digit) + prefix;
    }
}

var GmwTranslateNumber = function () {
    function GmwTranslateNumber() {
        _classCallCheck(this, GmwTranslateNumber);
    }

    _createClass(GmwTranslateNumber, null, [{
        key: 'factory',
        value: function factory() {
            var factoryFunction = function factoryFunction() {
                return function (input) {
                    if (input === undefined) {
                        return undefined;
                    }
                    if (false) {
                        var thousands = Math.floor(input / 1000);
                        var hundreds = Math.floor(input % 1000 / 100);
                        var tens = Math.floor(input % 100 / 10);
                        var units = Math.floor(input % 10);
                        return '' + digitWithPrefix('千', thousands) + digitWithPrefix('百', hundreds) + digitWithPrefix('十', tens) + translateDigit(units);
                    }
                    return input.toString();
                };
            };
            return factoryFunction;
        }
    }]);

    return GmwTranslateNumber;
}();

exports.default = angular.module('gm.wealth.common').filter('gmwTranslateNumber', GmwTranslateNumber.factory()).name;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('gmwTruncate', gmwTruncateFilter).name;


function gmwTruncateFilter() {
  'ngInject';

  return function (input, length) {
    if (!input) {
      return input;
    }
    return input.length > length ? input.substring(0, length) + '\u2026' : input;
  };
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingValidationInfo.$inject = ['$interpolate', 'gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').filter('holdingValidationInfo', holdingValidationInfo).name;


function holdingValidationInfo($interpolate, gettextCatalog) {
  'ngInject';

  return function (input) {
    var messages = [];
    if (input.required) {
      messages.push(gettextCatalog.getString('Required'));
    }

    if (input.min && input.min > 1 && input.min !== input.max) {
      messages.push($interpolate(gettextCatalog.getString('at least {{input.min}} characters'))({ input: input }));
    }

    if (input.max && input.max !== input.min) {
      messages.push($interpolate(gettextCatalog.getString('max {{input.max}} characters'))({ input: input }));
    }

    if (input.min && input.max && input.max === input.min) {
      messages.push($interpolate(gettextCatalog.getString('exactly {{input.max}} characters'))({ input: input }));
    }

    if (input.sizes) {
      var sizes = input.sizes.join(' or ');
      messages.push($interpolate(gettextCatalog.getString('{{sizes}} characters'))({ sizes: sizes }));
    }

    return messages.join(', ');
  };
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Gmw2FA.$inject = ['$q', 'GmwModal'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal2fa = __webpack_require__(323);

exports.default = angular.module('gm.wealth.common').factory('Gmw2FA', Gmw2FA).name;


function Gmw2FA($q, GmwModal) {
  'ngInject';

  return {
    executeWith2FA: executeWith2FA
  };

  function executeWith2FA(fn) {
    return fn().catch(function (error) {
      if (error.data && 'message' in error.data && error.data.message === 'error.expecting.twoFA.code') {
        return GmwModal.showModal({
          controller: _modal2fa.controller,
          controllerAs: _modal2fa.controllerAs,
          template: _modal2fa.template,
          inputs: {
            requestSMS: function requestSMS() {
              return fn({ code: '', requestSMS: true });
            }
          }
        }).then(function (modal) {
          return modal.closed.then(function (code) {
            return fn({ code: code });
          });
        });
      }
      return $q.reject(error);
    });
  }
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Modal2FAControler.$inject = ['$scope', 'close', 'requestSMS'];
var _modal2fa = __webpack_require__(324);

var _modal2fa2 = _interopRequireDefault(_modal2fa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _modal2fa2.default,
  controller: 'Modal2FAControler',
  controllerAs: 'modal2FACtrl'
};

angular.module('gm.wealth.common').controller(module.exports.controller, Modal2FAControler);

function Modal2FAControler($scope, close, requestSMS) {
  'ngInject';

  var vm = this;
  vm.requestSMS = requestSMS;

  $scope.$watch('modal2FACtrl.code', function (code) {
    if (code && code.length === 7) {
      close(code);
    }
  });
}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=\"'Two Factor Authentication'|translate\"> </h4> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <span class=gmw-modal__question ng-bind=\"'Enter the 7 digit code sent to your phone'|translate\"> </span> <gmw-box-input-simple gmw-digits-only ng-model=modal2FACtrl.code> </gmw-box-input-simple> </div> <div class=gmw-modal__footer> <div class=\"gmw-modal__footer-col gmw-modal__footer-col--center\"> <a href=javascript:; class=h-blue-link ng-click=modal2FACtrl.requestSMS() translate> Re-send code via SMS </a> </div> </div> </div> </div> ";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


GmwModal.$inject = ['$animate', '$compile', '$controller', '$document', '$q', '$rootScope', '$templateRequest', '$timeout'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('gm.wealth.common').factory('GmwModal', GmwModal).name;


var captchaModal = __webpack_require__(326);
var confirmationModal = __webpack_require__(328);
var helpModal = __webpack_require__(330);
var infoModal = __webpack_require__(332);
var uploadModal = __webpack_require__(334);

function GmwModal($animate, $compile, $controller, $document, $q, $rootScope, $templateRequest, $timeout) {
  'ngInject';

  var overlay = angular.element($document[0].getElementsByClassName('gmw-modal-overlay'));

  return {
    showCaptchaModal: showCaptchaModal,
    showConfirmationModal: showConfirmationModal,
    showHelpModal: showHelpModal,
    showInfoModal: showInfoModal,
    showModal: showModal,
    showUploadModal: showUploadModal
  };

  //  Adds an element to the DOM as the last child of its container
  //  like append, but uses $animate to handle animations. Returns a
  //  promise that is resolved once all animation is complete.
  function appendChild(parent, child) {
    var children = parent.children();
    if (children && children.length > 0) {
      return $animate.enter(child, parent, children[children.length - 1]).then(function () {
        return $animate.addClass(child.find('.gmw-modal'), 'gmw-modal--active');
      });
    }
    return $animate.enter(child, parent);
  }

  //  Returns a promise which gets the template, either
  //  from the template parameter or via a request to the
  //  template url parameter.
  function getTemplate(template, templateUrl) {
    var deferred = $q.defer();
    if (template) {
      deferred.resolve(template);
    } else if (templateUrl) {
      $templateRequest(templateUrl, true).then(function (loadedTemplate) {
        deferred.resolve(loadedTemplate);
      }, function (error) {
        deferred.reject(error);
      });
    } else {
      deferred.reject('No template or templateUrl has been specified.');
    }
    return deferred.promise;
  }

  function hideOverlay() {
    overlay.removeClass('gmw-modal-overlay--active');
  }

  function showCaptchaModal(header) {
    return showModal({
      controller: captchaModal.controller,
      controllerAs: captchaModal.controllerAs,
      inputs: {
        header: header
      },
      template: captchaModal.template
    }).then(function (modal) {
      return modal.closed.then(function (result) {
        if (result) {
          return $q.resolve(result);
        }
        return $q.resolve(false);
      });
    });
  }

  function showConfirmationModal(text) {
    return showModal({
      controller: confirmationModal.controller,
      controllerAs: confirmationModal.controllerAs,
      inputs: {
        text: text
      },
      template: confirmationModal.template
    }).then(function (modal) {
      return modal.closed.then(function (result) {
        if (result === 'yes') {
          return $q.resolve('yes');
        }
        return $q.reject('no');
      });
    });
  }

  function showHelpModal() {
    return showModal({
      controller: helpModal.controller,
      controllerAs: helpModal.controllerAs,
      template: helpModal.template
    }).then(function (modal) {
      return modal.closed;
    });
  }

  function showInfoModal(header, text) {
    return showModal({
      controller: infoModal.controller,
      controllerAs: infoModal.controllerAs,
      inputs: {
        header: header,
        text: text
      },
      template: infoModal.template
    }).then(function (modal) {
      return modal.closed;
    });
  }

  function showModal(options) {
    //  Get the body of the document, we'll add the modal to this.
    var body = angular.element($document[0].body);

    //  Create a deferred we'll resolve when the modal is ready.
    var deferred = $q.defer();

    //  Validate the input parameters.
    var controllerName = options.controller;
    if (!controllerName) {
      deferred.reject('No controller has been specified.');
      return deferred.promise;
    }

    //  Get the actual html of the template.
    getTemplate(options.template, options.templateUrl).then(function (template) {
      //  Create a new scope for the modal.
      var modalScope = (options.scope || $rootScope).$new();
      showOverlay();

      var rootScopeOnClose = $rootScope.$on('$locationChangeSuccess', cleanUpClose);

      if (!options.block) {
        overlay.on('click', cleanUpClose);
      }

      //  Create the inputs object to the controller - this will include
      //  the scope, as well as all inputs provided.
      //  We will also create a deferred that is resolved with a provided
      //  close function. The controller can then call 'close(result)'.
      //  The controller can also provide a delay for closing - this is
      //  helpful if there are closing animations which must finish first.
      var closeDeferred = $q.defer();
      var updateDeferred = $q.defer();
      var closedDeferred = $q.defer();
      var inputs = {
        $scope: modalScope,
        update: updateDeferred.notify,
        close: function close(result, delay) {
          var localDelay = delay;

          if (localDelay === undefined || localDelay === null) {
            localDelay = 0;
          }
          $timeout(function () {
            return cleanUpClose(result);
          }, localDelay);
        }
      };

      //  If we have provided any inputs, pass them to the controller.
      if (options.inputs) {
        angular.extend(inputs, options.inputs);
      }

      //  Compile then link the template element, building the actual element.
      //  Set the $element on the inputs so that it can be injected if required.
      var linkFn = $compile(template);
      var modalElement = linkFn(modalScope);
      inputs.$element = modalElement;

      //  Create the controller, explicitly specifying the scope to use.
      var controllerObjBefore = modalScope[options.controllerAs];
      var modalController = $controller(options.controller, inputs, false, options.controllerAs);

      if (options.controllerAs && controllerObjBefore) {
        angular.extend(modalController, controllerObjBefore);
      }

      //  Finally, append the modal to the dom.
      if (options.appendElement) {
        // append to custom append element
        appendChild(options.appendElement, modalElement);
      } else {
        // append to body when no custom append element is specified
        appendChild(body, modalElement);
      }

      //  We now have a modal object...
      var modal = {
        controller: modalController,
        scope: modalScope,
        element: modalElement,
        updated: updateDeferred.promise,
        close: closeDeferred.promise,
        closed: closedDeferred.promise
      };

      //  ...which is passed to the caller via the promise.
      deferred.resolve(modal);

      function cleanUpClose(result) {
        //  Resolve the 'close' promise.
        closeDeferred.resolve(result);

        //  Let angular remove the element and wait for animations to finish.
        $animate.leave(modalElement).then(function () {
          hideOverlay();
          //  Resolve the 'closed' promise.
          closedDeferred.resolve(result);

          //  We can now clean up the scope
          modalScope.$destroy();

          //  Unless we null out all of these objects we seem to suffer
          //  from memory leaks, if anyone can explain why then I'd
          //  be very interested to know.
          inputs.close = null;
          deferred = null;
          closeDeferred = null;
          modal = null;
          inputs = null;
          modalElement = null;
          modalScope = null;
        });

        // remove event watcher
        if (rootScopeOnClose) {
          rootScopeOnClose();
        }
        overlay.off('click', cleanUpClose);
      }
    }).catch(function (error) {
      return deferred.reject(error);
    });

    return deferred.promise;
  }

  function showOverlay() {
    overlay.addClass('gmw-modal-overlay--active');
  }

  function showUploadModal(text, config) {
    return showModal({
      template: uploadModal.template,
      controller: uploadModal.controller,
      controllerAs: uploadModal.controllerAs,
      inputs: {
        config: config,
        text: text
      }
    }).then(function (modal) {
      return modal.closed;
    });
  }
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CaptchaModalController.$inject = ['$scope', 'close', 'header'];
var _captchaModal = __webpack_require__(327);

var _captchaModal2 = _interopRequireDefault(_captchaModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _captchaModal2.default,
  controller: 'CaptchaModalController',
  controllerAs: 'captchaModalCtrl'
};

angular.module('gm.wealth.common').controller(module.exports.controller, CaptchaModalController);

function CaptchaModalController($scope, close, header) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.header = header;
  vm.model = angular.copy(DEFAULT_MODEL);

  function onCaptchaChanged(newValue, oldValue) {
    if (newValue && newValue !== oldValue) {
      close(vm.model.captcha);
    }
  }

  $scope.$watch(function () {
    return vm.model.captcha;
  }, onCaptchaChanged);
}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=::captchaModalCtrl.header> </h4> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <holding-captcha class=gmw-modal__captcha ng-model=captchaModalCtrl.model.captcha required> </holding-captcha> </div> </div> </div> ";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ConfirmationModalController.$inject = ['close', 'text'];
var _confirmationModal = __webpack_require__(329);

var _confirmationModal2 = _interopRequireDefault(_confirmationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _confirmationModal2.default,
  controller: 'ConfirmationModalController',
  controllerAs: 'confirmModalCtrl'
};

angular.module('gm.wealth.common').controller(module.exports.controller, ConfirmationModalController);

function ConfirmationModalController(close, text) {
  'ngInject';

  var vm = this;

  vm.close = close;
  vm.text = text;
}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=\"'Are you sure?'|translate\"> </h4> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <span class=gmw-modal__question ng-bind=confirmModalCtrl.text> </span> </div> <div class=gmw-modal__footer> <div class=gmw-modal__footer-col> <button class=medium-deny-cta ng-click=\"confirmModalCtrl.close('no')\"> <span ng-bind=\"'No'|translate\"></span> </button> </div> <div class=gmw-modal__footer-col> <button class=medium-confirm-cta ng-click=\"confirmModalCtrl.close('yes')\"> <span ng-bind=\"'Yes'|translate\"></span> </button> </div> </div> </div> </div> ";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HelpModalController.$inject = ['HoldingUser', 'HoldingSupport', 'close'];
var _helpModal = __webpack_require__(331);

var _helpModal2 = _interopRequireDefault(_helpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  controller: 'HelpModalController',
  controllerAs: 'helpModalCtrl',
  template: _helpModal2.default
};

angular.module('gm.wealth.common').controller(module.exports.controller, HelpModalController);

function HelpModalController(HoldingUser, HoldingSupport, close) {
  'ngInject';

  var vm = this;

  vm.user = HoldingUser.get();
  vm.showPhoneNumber = HoldingUser.isAllowed('phoneSupport');
  vm.supportPhoneNumbers = HoldingSupport.getSupportNumber(vm.user.regulation);

  vm.close = close;
}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=\"'Get Help with your Holding'|translate\"> </h4> <a href ng-click=helpModalCtrl.close() class=gmw-modal-header__close-container> <svg class=gmw-modal-header__close> <use xlink:href=#cross-icon></use> </svg> </a> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Support Hours'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=20 height=20> <use xlink:href=#building-icon></use> </svg> <span ng-if=\"helpModalCtrl.user.regulation === 'JFSC' || helpModalCtrl.user.regulation === 'UK'\" ng-bind=\"'Monday to Friday, 09.00 - 17.00 U.K. Time'|translate\"> </span> <span ng-if=\"helpModalCtrl.user.regulation === 'Toronto'\" ng-bind=\"'Monday to Friday, 9am - 5pm EST'|translate\"> </span> </span> </div> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\" ng-if=helpModalCtrl.showPhoneNumber ng-repeat=\"phone in helpModalCtrl.supportPhoneNumbers track by $index\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=::phone.description> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=19 height=19> <use xlink:href=#wired-phone-icon></use> </svg> <a ng-href=\"tel:+{{::phone.country}}{{::phone.number}}\" class=h-blue-link> +{{::phone.country}} {{::phone.number}} </a> </span> </div> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Message Support'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=18 height=14> <use xlink:href=#email-icon></use> </svg> <a ui-sref=holding.dashboard.messages.compose class=h-blue-link ng-bind=\"'Send Message'|translate\"> </a> </span> </div> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Frequently Asked Questions'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=20 height=20> <use xlink:href=#help-icon></use> </svg> <a href holding-external-link=support.main class=h-blue-link ng-bind=\"'Visit our Support Portal'|translate\" target=_blank> </a> </span> </div> </div> </div> </div> ";

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


InfoModalController.$inject = ['close', 'header', 'text'];
var _infoModal = __webpack_require__(333);

var _infoModal2 = _interopRequireDefault(_infoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _infoModal2.default,
  controller: 'InfoModalController',
  controllerAs: 'infoModalCtrl'
};

angular.module('gm.wealth.common').controller(module.exports.controller, InfoModalController);

function InfoModalController(close, header, text) {
  'ngInject';

  var vm = this;

  vm.close = close;
  vm.header = header;
  vm.text = text;
}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-modal> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=::infoModalCtrl.header> </h4> <a href ng-click=infoModalCtrl.close() class=gmw-modal-header__close-container> <svg class=gmw-modal-header__close> <use xlink:href=#cross-icon></use> </svg> </a> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <span class=gmw-modal__question ng-bind=::infoModalCtrl.text></span> </div> </div> </div> ";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


UploadModalController.$inject = ['config', 'close', 'text'];
var _uploadModal = __webpack_require__(335);

var _uploadModal2 = _interopRequireDefault(_uploadModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _uploadModal2.default,
  controller: 'UploadModalController',
  controllerAs: 'uploadModalCtrl'
};

angular.module('gm.wealth.common').controller(module.exports.controller, UploadModalController);

function UploadModalController(config, close, text) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.fileUploadConfig = config;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.text = text;
  vm.upload = upload;

  function upload() {
    close(vm.model.file);
  }
}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-modal ng-form=uploadModalCtrl.uploadForm> <div class=gmw-modal-header> <h4 class=\"gmw-modal-header__label h-dark-text\" ng-bind=::(uploadModalCtrl.text)> </h4> </div> <div class=gmw-modal__container> <div class=gmw-modal__inner> <holding-file-upload ng-model=uploadModalCtrl.model.file document-config=uploadModalCtrl.fileUploadConfig> </holding-file-upload> </div> <div class=gmw-modal__footer> <div class=\"gmw-modal__footer-col gmw-modal__footer-col--center\"> <button class=medium-main-cta ng-click=uploadModalCtrl.upload()> <span ng-bind=\"'Upload'|translate\"></span> </button> </div> </div> </div> </div> ";

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "<holding-auth-header></holding-auth-header> <div class=initial-onboarding-container> <div ui-view=auth></div> </div> ";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Forgot Account Details'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner> <form name=forgotAccountDetailsPhoneCtrl.fpPhoneForm id=fpPhoneForm holding-form-loading=forgotAccountDetailsPhoneCtrl.verifyPhone() novalidate> <div ng-show=\"forgotAccountDetailsPhoneCtrl.fpPhoneForm.$submitted && forgotAccountDetailsPhoneCtrl.fpPhoneForm.$invalid\" ng-messages=forgotAccountDetailsPhoneCtrl.fpPhoneForm.$error> <div ng-message=expired> <holding-alert class=error title=\"{{'Error'|translate}}\"> <main> <span> <span ng-bind=\"'Your password reset token has expired - please'|translate\"></span> <a ui-sref=auth.forgot-credentials class=gmw-alert-link ng-bind=\"'restart the reset process'|translate\"></a> <span ng-bind=\"'and try again.'|translate\"></span> </span> </main> <cta> <a ui-sref=auth.forgot-credentials>Restart password reset process</a> </cta> </holding-alert> </div> <div ng-message=unknown> <holding-alert class=error title=\"{{'Error'|translate}}\"> <main> <span> <span ng-bind=\"'There was an error reseting your password using your phone - please'|translate\"></span> <a ui-sref=auth.forgot-credentials class=gmw-alert-link ng-bind=\"'restart the reset process'|translate\"></a> <span ng-bind=\"'and try again.'|translate\"></span> </span> </main> <cta> <a ui-sref=auth.forgot-credentials ng-bind=\"'Restart password reset process'|translate\"></a> </cta> </holding-alert> </div> </div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\"> Why we verify your mobile phone </label> <p class=\"h-medium-text h-margin-bottom-10\"> {{'We ask for mobile phone verification via SMS text to verify your identity and make sure you are not a robot. Having this additional confirmation is an effective way to keep spammers from abusing our systems and keeps Goldmoney users protected.'|translate}} </p> <p class=\"h-medium-text h-margin-bottom-20\"> {{'You will receive an SMS or call in couple of minutes.'|translate}} </p> <gmw-box-input type=tel required name=token ng-model=forgotAccountDetailsPhoneCtrl.token ng-change=forgotAccountDetailsPhoneCtrl.resetErrors() no-label=true placeholder=\"{{'Enter verification code'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=12px height=20px> <use xlink:href=#mobile-phone-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n            'loading-button': isSubmitting\n          }\" holding-button-disabled=forgotAccountDetailsPhoneCtrl.fpPhoneForm.$invalid> <span ng-bind=\"'Verify Mobile'|translate\"></span> </button> </div> </form> </div> <footer class=initial-onboarding__footer> <span class=initial-onboarding__footer-item> {{'Didn\\'t receive a code?'|translate}} &nbsp; <holding-timeout-click-button action=forgotAccountDetailsPhoneCtrl.resendCode() ng-show=\"!forgotAccountDetailsPhoneCtrl.isResendLoading && !forgotAccountDetailsPhoneCtrl.isResendComplete\"> <a href=javascript:; class=h-blue-link>{{'Resend'|translate}}</a> </holding-timeout-click-button> </span> <span class=initial-onboarding__footer-item> <span ng-show=forgotAccountDetailsPhoneCtrl.isResendLoading class=small-blue-spinner></span> <span ng-show=forgotAccountDetailsPhoneCtrl.isResendComplete class=sent-label> <svg class=sent-label__icon> <use xlink:href=#thick-checkmark-icon></use> </svg> {{'Sent'|translate}} </span> </span> </footer> </section> ";

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Forgot Account Details'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner> <form name=forgotAccountDetailsResetCtrl.fpResetForm id=fpResetForm holding-form-loading=forgotAccountDetailsResetCtrl.setPassword() novalidate> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Set New Password'|translate\"> </label> <holding-alert class=error ng-if=\"forgotAccountDetailsResetCtrl.fpResetForm.$error.matches && forgotAccountDetailsResetCtrl.fpResetForm.$submitted\" title=\"{{'Password Match Error'|translate}}\"> <main> <span ng-bind=\"'Passwords must match.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=\"forgotAccountDetailsResetCtrl.fpResetForm.password.$invalid && forgotAccountDetailsResetCtrl.fpResetForm.$submitted\" title=\"{{'Password Strength Error'|translate}}\"> <main> <span ng-bind=\"'Please enter a stronger password.'|translate\"></span> </main> </holding-alert> <div class=gmw-input-container> <gmw-box-input required type=password name=password ng-model=forgotAccountDetailsResetCtrl.model.password ng-change=\"forgotAccountDetailsResetCtrl.model.repeatPassword = ''\" no-label=true placeholder=\"{{'New password'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=gmw-input-container> <gmw-box-input required type=password name=repeatPassword matches=\"{{forgotAccountDetailsResetCtrl.model.password}}\" ng-model=forgotAccountDetailsResetCtrl.model.repeatPassword no-label=true placeholder=\"{{'Repeat new password'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n            'loading-button': isSubmitting\n          }\" holding-button-disabled=\"forgotAccountDetailsResetCtrl.fpResetForm.$invalid || forgotAccountDetailsResetCtrl.fpResetForm.$submitted\"> <span ng-bind=\"'Set Password'|translate\"></span> </button> </div> </form> </div> </section> ";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _angularRecaptcha = __webpack_require__(196);

var _angularRecaptcha2 = _interopRequireDefault(_angularRecaptcha);

var _forgotCredentials = __webpack_require__(341);

var _forgotCredentials2 = _interopRequireDefault(_forgotCredentials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.forgot-credentials', [_common2.default, _angularjs2.default, _angularRecaptcha2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth.forgot-credentials', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Reset your Goldmoney Holding or Personal account credentials',
      pageTitle: 'Reset your Goldmoney Holding or Personal account credentials',
      skipSetupCheck: true
    },
    params: {
      type: {
        value: null,
        squash: true
      }
    },
    url: '/forgot-credentials/{type:holding|network}',
    views: {
      auth: {
        controller: 'ForgotCredentialsController',
        controllerAs: 'forgotCredentialsCtrl',
        template: _forgotCredentials2.default
      }
    }
  });
}]).name;


__webpack_require__(342);

/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * @license angular-recaptcha build:2018-05-09
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2018 VividCortex
**/

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    ng.module('vcRecaptcha', []);

}(angular));

/*global angular */
(function (ng) {
    'use strict';

    function throwNoKeyException() {
        throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
    }

    var app = ng.module('vcRecaptcha');

    /**
     * An angular service to wrap the reCaptcha API
     */
    app.provider('vcRecaptchaService', function(){
        var provider = this;
        var config = {};
        provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param defaults  object which overrides the current defaults object.
         */
        provider.setDefaults = function(defaults){
            ng.copy(defaults, config);
        };

        /**
         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
         */
        provider.setSiteKey = function(siteKey){
            config.key = siteKey;
        };

        /**
         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param theme  The reCaptcha theme.
         */
        provider.setTheme = function(theme){
            config.theme = theme;
        };

        /**
         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param stoken  The reCaptcha stoken.
         */
        provider.setStoken = function(stoken){
            config.stoken = stoken;
        };

        /**
         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param size  The reCaptcha size.
         */
        provider.setSize = function(size){
            config.size = size;
        };

        /**
         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param type  The reCaptcha type.
         */
        provider.setType = function(type){
            config.type = type;
        };

        /**
         * Sets the reCaptcha language which will be used by default is not specified in a specific directive instance.
         *
         * @param lang  The reCaptcha language.
         */
        provider.setLang = function(lang){
            config.lang = lang;
        };

        /**
         * Sets the reCaptcha badge position which will be used by default if not specified in a specific directive instance.
         *
         * @param badge  The reCaptcha badge position.
         */
        provider.setBadge = function(badge){
            config.badge = badge;
        };

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
         */
        provider.setOnLoadFunctionName = function(onLoadFunctionName){
            provider.onLoadFunctionName = onLoadFunctionName;
        };

        provider.$get = ['$rootScope','$window', '$q', '$document', '$interval', function ($rootScope, $window, $q, $document, $interval) {
            var deferred = $q.defer(), promise = deferred.promise, instances = {}, recaptcha;

            $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];

            var callback = function () {
                recaptcha = $window.grecaptcha;

                deferred.resolve(recaptcha);
            };

            $window.vcRecaptchaApiLoadedCallback.push(callback);

            $window[provider.onLoadFunctionName] = function () {
                $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
                    callback();
                });
            };


            function getRecaptcha() {
                if (!!recaptcha) {
                    return $q.when(recaptcha);
                }

                return promise;
            }

            function validateRecaptchaInstance() {
                if (!recaptcha) {
                    throw new Error('reCaptcha has not been loaded yet.');
                }
            }

            function isRenderFunctionAvailable() {
                return ng.isFunction(($window.grecaptcha || {}).render);
            }


            // Check if grecaptcha.render is not defined already.
            if (isRenderFunctionAvailable()) {
                callback();
            } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
                // wait for script to be loaded.
                var intervalWait = $interval(function() {
                    if (isRenderFunctionAvailable()) {
                        $interval.cancel(intervalWait);
                        callback();
                    }
                }, 25);
            } else {
                // Generate link on demand
                var script = $window.document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://www.google.com/recaptcha/api.js?onload='+provider.onLoadFunctionName+'&render=explicit';
                $document.find('body')[0].appendChild(script);
            }

            return {

                /**
                 * Creates a new reCaptcha object
                 *
                 * @param elm  the DOM element where to put the captcha
                 * @param conf the captcha object configuration
                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
                 */
                create: function (elm, conf) {

                    conf.sitekey = conf.key || config.key;
                    conf.theme = conf.theme || config.theme;
                    conf.stoken = conf.stoken || config.stoken;
                    conf.size = conf.size || config.size;
                    conf.type = conf.type || config.type;
                    conf.hl = conf.lang || config.lang;
                    conf.badge = conf.badge || config.badge;

                    if (!conf.sitekey) {
                        throwNoKeyException();
                    }
                    return getRecaptcha().then(function (recaptcha) {
                        var widgetId = recaptcha.render(elm, conf);
                        instances[widgetId] = elm;
                        return widgetId;
                    });
                },

                /**
                 * Reloads the reCaptcha
                 */
                reload: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.reset(widgetId);

                    // Let everyone know this widget has been reset.
                    $rootScope.$broadcast('reCaptchaReset', widgetId);
                },

                /**
                 * Executes the reCaptcha
                 */
                execute: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.execute(widgetId);
                },

                /**
                 * Get/Set reCaptcha language
                 */
                useLang: function (widgetId, lang) {
                    var instance = instances[widgetId];

                    if (instance) {
                        var iframe = instance.querySelector('iframe');
                        if (lang) {
                            // Setter
                            if (iframe && iframe.src) {
                                var s = iframe.src;
                                if (/[?&]hl=/.test(s)) {
                                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
                                } else {
                                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
                                }

                                iframe.src = s;
                            }
                        } else {
                            // Getter
                            if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
                                return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
                            } else {
                                return null;
                            }
                        }
                    } else {
                        throw new Error('reCaptcha Widget ID not exists', widgetId);
                    }
                },

                /**
                 * Gets the response from the reCaptcha widget.
                 *
                 * @see https://developers.google.com/recaptcha/docs/display#js_api
                 *
                 * @returns {String}
                 */
                getResponse: function (widgetId) {
                    validateRecaptchaInstance();

                    return recaptcha.getResponse(widgetId);
                },

                /**
                 * Gets reCaptcha instance and configuration
                 */
                getInstance: function (widgetId) {
                    return instances[widgetId];
                },

                /**
                 * Destroy reCaptcha instance.
                 */
                destroy: function (widgetId) {
                    delete instances[widgetId];
                }
            };

        }];
    });

}(angular));

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    var app = ng.module('vcRecaptcha');

    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function ($document, $timeout, vcRecaptcha) {

        return {
            restrict: 'A',
            require: "?^^form",
            scope: {
                response: '=?ngModel',
                key: '=?',
                stoken: '=?',
                theme: '=?',
                size: '=?',
                type: '=?',
                lang: '=?',
                badge: '=?',
                tabindex: '=?',
                required: '=?',
                onCreate: '&',
                onSuccess: '&',
                onExpire: '&'
            },
            link: function (scope, elm, attrs, ctrl) {
                scope.widgetId = null;

                if(ctrl && ng.isDefined(attrs.required)){
                    scope.$watch('required', validate);
                }

                var removeCreationListener = scope.$watch('key', function (key) {
                    var callback = function (gRecaptchaResponse) {
                        // Safe $apply
                        $timeout(function () {
                            scope.response = gRecaptchaResponse;
                            validate();

                            // Notify about the response availability
                            scope.onSuccess({response: gRecaptchaResponse, widgetId: scope.widgetId});
                        });
                    };

                    vcRecaptcha.create(elm[0], {

                        callback: callback,
                        key: key,
                        stoken: scope.stoken || attrs.stoken || null,
                        theme: scope.theme || attrs.theme || null,
                        type: scope.type || attrs.type || null,
                        lang: scope.lang || attrs.lang || null,
                        tabindex: scope.tabindex || attrs.tabindex || null,
                        size: scope.size || attrs.size || null,
                        badge: scope.badge || attrs.badge || null,
                        'expired-callback': expired

                    }).then(function (widgetId) {
                        // The widget has been created
                        validate();
                        scope.widgetId = widgetId;
                        scope.onCreate({widgetId: widgetId});

                        scope.$on('$destroy', destroy);

                        scope.$on('reCaptchaReset', function(event, resetWidgetId){
                          if(ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId){
                            scope.response = "";
                            validate();
                          }
                        })

                    });

                    // Remove this listener to avoid creating the widget more than once.
                    removeCreationListener();
                });

                function destroy() {
                  if (ctrl) {
                    // reset the validity of the form if we were removed
                    ctrl.$setValidity('recaptcha', null);
                  }

                  cleanup();
                }

                function expired(){
                    // Safe $apply
                    $timeout(function () {
                        scope.response = "";
                        validate();

                        // Notify about the response availability
                        scope.onExpire({ widgetId: scope.widgetId });
                    });
                }

                function validate(){
                    if(ctrl){
                        ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
                    }
                }

                function cleanup(){
                  vcRecaptcha.destroy(scope.widgetId);

                  // removes elements reCaptcha added.
                  ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
                }
            }
        };
    }]);

}(angular));


/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Retrieve Your Credentials'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner> <div class=gmw-input-container ng-if=!forgotCredentialsCtrl.requestSent> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Select your account type'|translate\"> </label> <gmw-toggle-option-group> <a href class=\"heading-h5 option-toggle__item\" ng-class=\"{\n            'option-toggle__item--active': forgotCredentialsCtrl.model.view === 'holding',\n          }\" ng-click=\"forgotCredentialsCtrl.setView('holding')\" ng-bind=\"'Goldmoney Holding'|translate\"> </a> <a href class=\"heading-h5 option-toggle__item\" ng-class=\"{\n            'option-toggle__item--active': forgotCredentialsCtrl.model.view === 'network',\n          }\" ng-click=\"forgotCredentialsCtrl.setView('network')\" ng-bind=\"'Personal'|translate\"> </a> </gmw-toggle-option-group> </div> <div ng-switch=forgotCredentialsCtrl.model.view> <div ng-switch-default> <form name=forgotCredentialsCtrl.formWealth id=formWealth novalidate holding-form-loading=forgotCredentialsCtrl.requestWealthReset() ng-show=\"!(forgotCredentialsCtrl.wealthPasswordRequestSent || forgotCredentialsCtrl.wealthHoldingRequestSent)\"> <holding-alert class=error ng-if=forgotCredentialsCtrl.wealthResetError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=forgotCredentialsCtrl.wealthResetError></span> </main> </holding-alert> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Forgot your Holding Number?'|translate\"> </label> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Please enter the email address associated with your Holding below to retrieve your Holding number.'|translate\"> </p> <gmw-box-input-simple ng-required=!forgotCredentialsCtrl.model.holding type=email name=email ng-model=forgotCredentialsCtrl.model.email ng-change=\"forgotCredentialsCtrl.model.holding = ''\" ng-model-options=\"{\n                allowInvalid: true,\n              }\" placeholder=\"{{'Enter your email address'|translate}}\"> <gmw-box-input-meta-left> <holding-svg-icon class=gmw-box-input__icon icon=email width=18px height=14px> </holding-svg-icon> </gmw-box-input-meta-left> </gmw-box-input-simple> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Forgot your Holding Password?'|translate\"> </label> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Please enter your Holding number below to begin the password reset process.'|translate\"> </p> <gmw-box-input-simple ng-required=!forgotCredentialsCtrl.model.email type=text name=holding ng-model=forgotCredentialsCtrl.model.holding ng-change=\"forgotCredentialsCtrl.model.email = ''\" placeholder=\"{{'Enter your Holding number'|translate}}\"> <gmw-box-input-meta-left> <holding-svg-icon class=gmw-box-input__icon icon=simple-user width=17 height=16> </holding-svg-icon> </gmw-box-input-meta-left> </gmw-box-input-simple> </div> <div class=initial-onboarding__reCaptcha vc-recaptcha on-expire=forgotCredentialsCtrl.captchExpired() key=forgotCredentialsCtrl.recaptchaKey ng-model=forgotCredentialsCtrl.model.captcha> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button gmw-extra-button-padding\" ng-class=\"{\n                'loading-button': isSubmitting\n              }\" holding-button-disabled=forgotCredentialsCtrl.formWealth.$invalid> <span ng-bind=\"'Continue'|translate\"></span> </button> </div> </form> <div ng-if=forgotCredentialsCtrl.wealthHoldingRequestSent> <holding-alert class=success> <main> <span ng-bind=\"'Your Holding number recovery request has been submitted.'|translate\"></span> </main> </holding-alert> <p class=\"heading-h4 h-dark-text\" ng-bind=\"'Please check your email'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'If there is a Holding number associated with the email address you\\'ve submitted, an email with instructions on how to retrieve the number will be sent to you.'|translate\"> </p> <ul> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'1. Check your email account'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'2. Click the recovery link in the email'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'3. Review the Holding number(s) associated with this email address'|translate\"> </li> </ul> <p class=\"h-medium-text h-margin-top-20\"> <span ng-bind=\"'Note that if there are no open Holdings associated with this email address, you will not receive an email. In this case, please try another email address or'|translate\"></span> <a href=https://support.goldmoney.com/hc/en-us/requests/new class=h-blue-link ng-bind=\"'contact Relationship Management'|translate\"></a>. </p> </div> <div ng-if=forgotCredentialsCtrl.wealthPasswordRequestSent> <holding-alert class=success> <main> <span ng-bind=\"'Password reset email sent.'|translate\"></span> </main> </holding-alert> <p class=\"heading-h4 h-dark-text\" ng-bind=\"'Please check your email'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'An email with instructions on how to reset your password and access your Holding has been sent to you. Please:'|translate\"> </p> <ul> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'1. Check your email account'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'2. Click the password reset link in the email'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'3. Answer the security questions, if required'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'4. Change your password when prompted'|translate\"> </li> </ul> </div> </div> <div ng-switch-when=network> <div ng-show=!forgotCredentialsCtrl.requestSent> <form name=forgotCredentialsCtrl.formNetwork id=formNetwork novalidate holding-form-loading=forgotCredentialsCtrl.requestNetworkPasswordReset()> <holding-alert class=error ng-messages=forgotCredentialsCtrl.formForgot.$error ng-if=\"forgotCredentialsCtrl.formForgot.$invalid && forgotCredentialsCtrl.formForgot.$submitted\" title=\"{{'Error'|translate}}\"> <main> <ul> <li ng-message=email ng-bind=\"'Please enter a valid email address.'|translate\"> </li> <li ng-message=wrong ng-bind=\"'The supplied email address does not match a valid account.'|translate}\"> </li> </ul> </main> </holding-alert> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Forgot your password?'|translate\"> </label> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Please enter your email below. We will send you an email immediately with instructions on how to access your account.'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-10\"> <span ng-bind=\"'If you no longer have access to this email account, please'|translate\"></span> <a href=https://support.goldmoney.com/hc/ class=h-blue-link ng-bind=\"'contact Support'|translate\"></a>. </p> <div class=gmw-input-container> <gmw-box-input required type=email name=email ng-model=forgotCredentialsCtrl.model.email ng-change=forgotCredentialsCtrl.resetError() no-label=true placeholder=\"{{'Enter email address'|translate}}\"> <gmw-box-input-meta-left> <holding-svg-icon class=gmw-box-input__icon icon=email width=18px height=14px> </holding-svg-icon> </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n                  'loading-button': isSubmitting\n                }\" holding-button-disabled=forgotCredentialsCtrl.formNetwork.$invalid> <span ng-bind=\"'Send Recovery Link'|translate\"></span> </button> </div> </form> </div> <div ng-if=forgotCredentialsCtrl.requestSent> <holding-alert class=success> <main> <span ng-bind=\"'Recovery email sent'|translate\"></span> </main> </holding-alert> <p class=\"heading-h4 h-dark-text\" ng-bind=\"'Please check your email'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'An email with instructions on how to access your Account has been sent to you. Please:'|translate\"> </p> <ul> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'1. Check your email account'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'2. Click the reset link in the email'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'3. Verify your mobile phone, if required'|translate\"> </li> <li class=\"h-medium-text h-dark-text h-margin-bottom-5\" ng-bind=\"'4. Change your password when prompted'|translate\"> </li> </ul> </div> </div> </div> </div> <footer class=initial-onboarding__footer> <span class=initial-onboarding__footer-item> <a ui-sref=sign-up class=h-blue-link ng-attr-title=\"{{'Create a Goldmoney Holding now'|translate}}\" ng-bind=\"'Open a Holding'|translate\"></a> </span> <span class=\"initial-onboarding__footer-item initial-onboarding__footer-item--sign-in\"> <a ui-sref=auth.sign-in class=h-blue-link ng-attr-title=\"{{'Sign in to Goldmoney'|translate}}\" ng-bind=\"'Sign In'|translate\"> </a> </span> </footer> </section> ";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ForgotCredentialsController.$inject = ['$log', '$stateParams', 'HoldingConfig', 'vcRecaptchaService', 'HoldingForgotAccountDetails', 'HoldingForgotHoldingDetails'];
angular.module('app.auth.forgot-credentials').controller('ForgotCredentialsController', ForgotCredentialsController);

function ForgotCredentialsController($log, $stateParams, HoldingConfig, vcRecaptchaService, HoldingForgotAccountDetails, HoldingForgotHoldingDetails) {
  'ngInject';

  var DEFAULT_MODEL = {
    view: 'holding'
  };

  var vm = this;

  vm.captchExpired = captchExpired;
  vm.isSubmitting = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.recaptchaKey = HoldingConfig.recaptcha.sitekey;
  vm.requestNetworkPasswordReset = requestNetworkPasswordReset;
  vm.requestSent = false;
  vm.requestWealthReset = requestWealthReset;
  vm.setView = setView;

  function activate() {
    if ($stateParams.type) {
      vm.model.view = $stateParams.type;
    }
  }

  function captchExpired() {
    vm.wealthResetError = 'Captcha verification has expired, please check the checkbox below again to complete your request.';
  }

  function requestNetworkPasswordReset() {
    vm.isSubmitting = true;
    return HoldingForgotAccountDetails.requestPasswordReset(vm.model.email).then(function () {
      vm.isSubmitting = false;
      vm.requestSent = true;
    }).catch(function (error) {
      vm.isSubmitting = false;
      $log.error(error);
    });
  }

  function requestWealthReset() {
    vm.isSubmitting = true;
    vm.wealthResetError = null;
    var promise = void 0;
    if (vm.model.email) {
      promise = HoldingForgotHoldingDetails.forgotHolding(vm.model.email, vm.model.captcha).then(function () {
        vm.wealthHoldingRequestSent = true;
      });
    } else {
      promise = HoldingForgotHoldingDetails.forgotPassword(vm.model.holding, vm.model.captcha).then(function () {
        vm.wealthPasswordRequestSent = true;
      });
    }

    return promise.then(function () {
      vm.requestSent = true;
    }).catch(function (_ref) {
      var message = _ref.message;

      vm.wealthResetError = message;
      vcRecaptchaService.reload();
    }).finally(function () {
      vm.isSubmitting = false;
    });
  }

  function setView(view) {
    vm.model.view = view;
  }

  activate();
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _forgotHoldingNumber = __webpack_require__(344);

var _forgotHoldingNumber2 = _interopRequireDefault(_forgotHoldingNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.forgot-holding-number', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth.forgot-holding-number', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Retrieve your Goldmoney Holding number',
      pageTitle: 'Retrieve your Goldmoney Holding number',
      skipSetupCheck: true
    },
    resolve: {
      HoldingsResolve: ['$q', '$log', '$stateParams', 'HoldingForgotHoldingDetails', function HoldingsResolve($q, $log, $stateParams, HoldingForgotHoldingDetails) {
        'ngInject';

        var deferred = $q.defer();
        var token = $stateParams.token;

        if (token) {
          HoldingForgotHoldingDetails.checkForgotHoldingCode(token).then(function (data) {
            deferred.resolve(data);
          }).catch(function (error) {
            $log.debug(error);
            deferred.resolve(false);
          });
        } else {
          deferred.resolve(false);
        }
        return deferred.promise;
      }]
    },
    url: '/forgot-holding-number/:token',
    views: {
      auth: {
        controller: 'ForgotHoldingNumberController',
        controllerAs: 'forgotHoldingNumberCtrl',
        template: _forgotHoldingNumber2.default
      }
    }
  });
}]).name;


__webpack_require__(345);

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Retrieve Your Holding Number'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner> <h3 class=\"heading-h4 h-dark-text h-margin-bottom-20\" ng-bind=\"'Holding Number Recovery'|translate\"> </h3> <holding-alert class=error ng-if=\"forgotHoldingNumberCtrl.openHoldings.length < 1 && forgotHoldingNumberCtrl.suspendedHoldings.length < 1\" title=\"{{'Holding Number Retrieval Error'|translate}}\"> <main> <span ng-bind=\"'The one-time code to recover your Holding number has expired or is invalid. Please initiate a new request should you still require assistance.'|translate\"></span> </main> <cta> <a ui-sref=auth.forgot-credentials ng-bind=\"'Please try again'|translate\"></a> </cta> </holding-alert> <holding-alert class=error ng-if=\"forgotHoldingNumberCtrl.openHoldings.length < 1 && forgotHoldingNumberCtrl.suspendedHoldings.length === 1\" title=\"{{'Holding Number Retrieval Error'|translate}}\"> <main> <span ng-bind=\"'The Holding that is associated with the email address that you have entered has been suspended and cannot be reactivated at this time.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=\"forgotHoldingNumberCtrl.openHoldings.length < 1 && forgotHoldingNumberCtrl.suspendedHoldings.length > 1\" title=\"{{'Holding Number Retrieval Error'|translate}}\"> <main> <span ng-bind=\"'All the Holdings that are associated with the email address that you have entered have been suspended and cannot be reactivated at this time.'|translate\"></span> </main> </holding-alert> <p class=\"h-medium-text h-margin-bottom-20\" ng-if=\"forgotHoldingNumberCtrl.openHoldings.length === 1\" ng-bind=\"'The Holding number associated with your email address is:'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-20\" ng-if=\"forgotHoldingNumberCtrl.openHoldings.length > 1\" ng-bind=\"'The Holding numbers associated with your email address are:'|translate\"> </p> <div class=\"onboarding-holding-number-box h-margin-bottom-30\" ng-if=\"forgotHoldingNumberCtrl.openHoldings.length > 0\"> <span class=\"onboarding-holding-number-box__item heading-h1 h-dark-text\" ng-repeat=\"openHoldingNumber in forgotHoldingNumberCtrl.openHoldings track by $index\" ng-bind=openHoldingNumber> </span> </div> <div class=initial-onboarding__center-cta ng-if=\"forgotHoldingNumberCtrl.openHoldings.length > 0\"> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=auth.sign-in> <span ng-bind=\"'Continue to Sign In'|translate\"></span> </button> </div> <div class=initial-onboarding__center-cta ng-if=\"forgotHoldingNumberCtrl.openHoldings.length < 1\"> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=auth.forgot-credentials> <span ng-bind=\"'Return to Forgot Holding Details'|translate\"></span> </button> </div> </div> </section> ";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ForgotHoldingNumberController.$inject = ['$state', 'HoldingsResolve'];
angular.module('app.auth.forgot-holding-number').controller('ForgotHoldingNumberController', ForgotHoldingNumberController);

function ForgotHoldingNumberController($state, HoldingsResolve) {
  'ngInject';

  function activate() {
    if (HoldingsResolve) {
      vm.openHoldings = HoldingsResolve.openHoldings;
      vm.suspendedHoldings = HoldingsResolve.suspendedHoldings;
    } else {
      $state.go('auth.forgot-credentials');
    }
  }

  var DEFAULT_MODEL = {};
  var vm = this;

  vm.model = angular.copy(DEFAULT_MODEL);

  activate();
}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _forgotPassword = __webpack_require__(347);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.forgot-password', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth.forgot-password', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    params: {
      token: {
        value: null,
        squash: true
      }
    },
    resolve: {
      CheckIfAuthedResolve: ['$q', 'HoldingUser', function CheckIfAuthedResolve($q, HoldingUser) {
        'ngInject';

        return HoldingUser.checkIfAuthed().then(function (isAuthed) {
          if (isAuthed) {
            return $q.reject({
              redirectTo: 'holding.dashboard.overview',
              params: {
                reload: true
              }
            });
          }
          return $q.resolve(false);
        });
      }]
    },
    url: '/forgot-password/:token',
    views: {
      auth: {
        controller: 'ForgotPasswordController',
        controllerAs: 'forgotPasswordCtrl',
        template: _forgotPassword2.default
      }
    }
  });
}]).name;


__webpack_require__(348);

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Reset Your Holding Password'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner> <form name=forgotPasswordCtrl.form id=form novalidate ng-if=!forgotPasswordCtrl.requested holding-form-loading=forgotPasswordCtrl.submitAnswers()> <h3 class=\"heading-h4 h-dark-text h-margin-bottom-20\" ng-bind=\"'Holding Password Reset'|translate\"> </h3> <holding-alert class=error ng-if=forgotPasswordCtrl.tokenError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=forgotPasswordCtrl.tokenError></span> </main> </holding-alert> <div class=gmw-input-container ng-repeat=\"question in forgotPasswordCtrl.questions track by $index\"> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=question.question.question> </p> <gmw-box-input-simple required type=text name=\"question{{$index}}\" ng-model=question.answer placeholder=\"{{'Your answer'|translate}}\"> </gmw-box-input-simple> </div> <div class=initial-onboarding__center-cta ng-if=\"!forgotPasswordCtrl.tokenError && forgotPasswordCtrl.questions.length > 0\"> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=forgotPasswordCtrl.form.$invalid> <span ng-bind=\"'Continue'|translate\"></span> </button> </div> <div class=initial-onboarding__center-cta ng-if=forgotPasswordCtrl.tokenError> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=auth.forgot-credentials> <span ng-bind=\"'Return to Forgot Holding Details'|translate\"></span> </button> </div> </form> <div ng-if=forgotPasswordCtrl.newPassword> <p class=\"h-medium-text h-margin-bottom-20\" ng-bind=\"'Your new temporary password is:'|translate\"> </p> <div class=\"onboarding-password-box h-margin-bottom-30\"> <span class=\"onboarding-password-box__item heading-h1 h-dark-text\" ng-bind=forgotPasswordCtrl.newPassword> </span> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=auth.sign-in> <span ng-bind=\"'Continue to Sign In'|translate\"></span> </button> </div> </div> <div ng-if=forgotPasswordCtrl.requested> <h3 class=\"heading-h4 h-dark-text h-margin-bottom-20\" ng-bind=\"'Holding Password Reset'|translate\"> </h3> <p class=\"h-medium-text h-margin-bottom-20\" ng-bind=\"'Your request for a new password has been received and will be reviewed as soon as possible.'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-20\" ng-bind=\"'A Goldmoney Relationship Manager may contact you by telephone or send a new password to your email address.'|translate\"> </p> <div class=initial-onboarding__center-cta> <a class=\"medium-main-cta gmw-responsive-button\" href=\"{{forgotPasswordCtrl.siteUrl}}/\" ng-bind=\"'Return to the Goldmoney Home Page'|translate\"> </a> </div> </div> </div> </section> ";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ForgotPasswordController.$inject = ['$stateParams', 'HoldingEnvironment', 'HoldingForgotHoldingDetails'];
angular.module('app.auth.forgot-password').controller('ForgotPasswordController', ForgotPasswordController);

function ForgotPasswordController($stateParams, HoldingEnvironment, HoldingForgotHoldingDetails) {
  'ngInject';

  function activate() {
    HoldingForgotHoldingDetails.checkForgotPasswordCode(token).then(function (_ref) {
      var questions = _ref.questions,
          password = _ref.password;

      if (questions) {
        vm.questions = questions.map(function (question) {
          return { question: question };
        });
      } else if (password) {
        vm.newPassword = password;
      }
    }).catch(function (_ref2) {
      var message = _ref2.message;

      vm.tokenError = message;
    });
  }

  function submitAnswers() {
    HoldingForgotHoldingDetails.answerSecurityQuestions(token, vm.questions).then(function () {
      vm.requested = true;
    }).catch(function (_ref3) {
      var message = _ref3.message;

      vm.tokenError = message;
    });
  }

  var vm = this;
  var token = $stateParams.token || '';

  vm.siteUrl = HoldingEnvironment.urls.site;
  vm.submitAnswers = submitAnswers;

  activate();
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _resetPassword = __webpack_require__(350);

var _resetPassword2 = _interopRequireDefault(_resetPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.reset-password', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth.reset-password', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Reset your Goldmoney Holding password',
      pageTitle: 'Reset your Goldmoney Holding Password',
      skipSetupCheck: true
    },
    url: '/reset-password',
    views: {
      auth: {
        controller: 'ResetPasswordController',
        controllerAs: 'resetPasswordCtrl',
        template: _resetPassword2.default
      }
    }
  });
}]).name;


__webpack_require__(351);

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Reset Holding Password'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner> <form name=resetPasswordCtrl.form id=form holding-form-loading=resetPasswordCtrl.setPassword() novalidate> <holding-alert class=error ng-if=resetPasswordCtrl.resetError title=\"{{'Password Reset Error'|translate}}\"> <main> <span ng-bind=resetPasswordCtrl.resetError></span> </main> </holding-alert> <holding-alert class=error ng-if=\"resetPasswordCtrl.form.$error.matches && resetPasswordCtrl.form.$submitted\" title=\"{{'Password Reset Error'|translate}}\"> <main> <span ng-bind=\"'Passwords must match.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=\"resetPasswordCtrl.form.oldPassword.$error.required && resetPasswordCtrl.form.$submitted\" title=\"{{'Password Reset Error'|translate}}\"> <main> <span ng-bind=\"'Your old password is required.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=\"resetPasswordCtrl.form.password.$invalid && resetPasswordCtrl.form.$submitted\" title=\"{{'Password Reset Error'|translate}}\"> <main> <span ng-bind=\"'Your new password must contain at least one character, one digit, and be at least 8 characters long.'|translate\"></span> </main> </holding-alert> <gmw-box-input-simple required class=gmw-input-container name=oldPassword type=password ng-model=resetPasswordCtrl.model.password label=\"{{'Temporary Password'|translate}}\" placeholder=\"{{'Temporary password'|translate}}\"> <gmw-box-input-meta-left> <holding-svg-icon class=gmw-box-input__icon icon=lock width=15px height=20px> </holding-svg-icon> </gmw-box-input-meta-left> </gmw-box-input-simple> <gmw-box-input-simple required class=gmw-input-container name=password type=password ng-model=resetPasswordCtrl.model.newPassword ng-change=\"resetPasswordCtrl.model.repeatPassword = ''\" label=\"{{'Set New Password'|translate}}\" gmw-validate-password placeholder=\"{{'New password'|translate}}\"> <gmw-box-input-meta-left> <holding-svg-icon class=gmw-box-input__icon icon=lock width=15px height=20px> </holding-svg-icon> </gmw-box-input-meta-left> </gmw-box-input-simple> <gmw-box-input-simple required class=gmw-input-container name=repeatPassword type=password ng-model=resetPasswordCtrl.model.repeatPassword gmw-matches=\"{{resetPasswordCtrl.model.newPassword}}\" placeholder=\"{{'Repeat new password'|translate}}\"> <gmw-box-input-meta-left> <holding-svg-icon class=gmw-box-input__icon icon=lock width=15px height=20px> </holding-svg-icon> </gmw-box-input-meta-left> </gmw-box-input-simple> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n            'loading-button': resetPasswordCtrl.isSubmitting\n          }\"> <span ng-bind=\"'Set Password'|translate\"></span> </button> </div> </form> </div> </section> ";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ResetPasswordController.$inject = ['$state', '$log', 'HoldingSettings'];
angular.module('app.auth.reset-password').controller('ResetPasswordController', ResetPasswordController);

function ResetPasswordController($state, $log, HoldingSettings) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.isSubmitting = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.setPassword = setPassword;

  function setPassword() {
    if (vm.form.$invalid) {
      vm.form.$setSubmitted();
      return undefined;
    }
    return HoldingSettings.updatePassword(vm.model.password, vm.model.newPassword).then(function () {
      vm.isSubmitting = true;
      $state.go('holding.dashboard.overview', {}, {
        reload: true
      });
    }).catch(function (error) {
      vm.isSubmitting = false;
      vm.resetError = error.message;
      $log.error(error.message);
    });
  }
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _signIn = __webpack_require__(353);

var _signIn2 = _interopRequireDefault(_signIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.sign-in', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth.sign-in', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Sign-in to your Goldmoney Holding',
      pageTitle: 'Sign-in to your Goldmoney Holding',
      skipSetupCheck: true
    },
    params: {
      message: {
        squash: true,
        value: null
      }
    },
    resolve: {
      CheckIfAuthedResolve: ['$q', '$stateParams', '$window', 'HoldingUser', 'HoldingAuth', function CheckIfAuthedResolve($q, $stateParams, $window, HoldingUser, HoldingAuth) {
        'ngInject';

        return HoldingUser.checkIfAuthed().then(function (isAuthed) {
          if (isAuthed) {
            if ($stateParams.target && HoldingAuth.isValidRedirectUrl($stateParams.target)) {
              $window.location.href = $stateParams.target;
              return $q.when(false);
            }

            return $q.reject({
              redirectTo: 'holding.dashboard.overview',
              params: {
                reload: true
              }
            });
          }
          return $q.when(false);
        });
      }]
    },
    url: '/sign-in/:message?target',
    views: {
      auth: {
        controller: 'SignInController',
        controllerAs: 'signInCtrl',
        template: _signIn2.default
      }
    }
  });
}]).name;


__webpack_require__(354);
__webpack_require__(356);
__webpack_require__(358);

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Client Access'|translate}}\"> </auth-hero> <holding-pwa-prompt></holding-pwa-prompt> <section class=initial-onboarding> <div class=initial-onboarding__inner> <holding-sign-in-form on-network-sign-in=signInCtrl.onNetworkSignIn() on-wealth-sign-in=signInCtrl.onWealthSignIn() message=signInCtrl.message> </holding-sign-in-form> </div> <footer class=initial-onboarding__footer> <span class=initial-onboarding__footer-item> <span translate>Don't have a Holding yet?</span> <a ui-sref=sign-up class=h-blue-link ng-attr-title=\"{{'Create a Goldmoney Holding now'|translate}}\" ng-bind=\"'Apply here'|translate\"> </a>. </span> </footer> </section> ";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingPwaPrompt.$inject = ['$window', '$location'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pwaPrompt = __webpack_require__(355);

var _pwaPrompt2 = _interopRequireDefault(_pwaPrompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.sign-in').component('holdingPwaPrompt', {
  controller: holdingPwaPrompt,
  template: _pwaPrompt2.default
}).name;


function holdingPwaPrompt($window, $location) {
  'ngInject';

  function closePrompt() {
    vm.displayPrompt = false;
  }

  function isIos() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes($window.navigator.platform) || $window.navigator.userAgent.includes('Mac') && 'ontouchend' in $window.document;
  }

  function isPwa() {
    var _$location$search = $location.search(),
        source = _$location$search.source;

    return source && source === 'web_app_manifest';
  }

  var vm = this;

  vm.closePrompt = closePrompt;
  vm.displayPrompt = true;
  vm.isIos = isIos;
  vm.isPwa = isPwa;
}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = "<div class=mobile-pwa-prompt ng-show=\"$ctrl.isIos() && !$ctrl.isPwa() && $ctrl.displayPrompt\"> <span class=mobile-pwa-prompt__label> <span ng-bind=\"'In Safari, tap'|translate\"></span> <svg class=mobile-pwa-prompt__arrow> <use xlink:href=#ios-arrow-up></use> </svg> <span ng-bind=\"'and then \\'Add to Homescreen\\''|translate\"></span> </span> <a class=mobile-pwa-prompt__icon-container ng-click=$ctrl.closePrompt()> <svg class=mobile-pwa-prompt__icon> <use xlink:href=#cross-icon></use> </svg> </a> </div> ";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingSignInForm.$inject = ['btgUser', 'Gmw2FA', 'HoldingAuth', 'HoldingEnvironment'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signInForm = __webpack_require__(357);

var _signInForm2 = _interopRequireDefault(_signInForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.sign-in').directive('holdingSignInForm', holdingSignInForm).name;


function holdingSignInForm(btgUser, Gmw2FA, HoldingAuth, HoldingEnvironment) {
  'ngInject';

  var ERROR_SMS = 'error.during.sending.sms';
  var ERROR_VERIFICATION = 'error.during.verification';
  var INVALID_CREDENTIALS = 'invalid.credentials';
  var INVALID_AUTH_TOKEN = 'missing.auth.token';
  var MISSING_CAPTCHA = 'missing.captcha';
  var STATE_PARAM_EMAIL_EXPIRED = 'email-expired';
  var STATE_PARAM_EMAIL_INVALID = 'email-invalid';
  var STATE_PARAM_EMAIL_UNVERIFIED = 'email-unverified';
  var STATE_PARAM_EMAIL_VERIFIED = 'email-verified';
  var STATE_PARAM_PASSWORD_RESET = 'reset';
  var STATE_PARAM_SIGNEDOUT = 'logout';
  var STATE_PARAM_PROGRESS_SAVED = 'progress-saved';
  var STATE_PARAM_SUSPENDED = 'suspended';

  return {
    link: link,
    restrict: 'E',
    scope: {
      message: '=?',
      onNetworkSignIn: '&',
      onWealthSignIn: '&'
    },
    template: _signInForm2.default
  };

  function link(scope) {
    function activate() {
      switch (scope.message) {
        case STATE_PARAM_EMAIL_EXPIRED:
          scope.emailExpired = true;
          break;
        case STATE_PARAM_EMAIL_INVALID:
          scope.emailInvalid = true;
          break;
        case STATE_PARAM_EMAIL_VERIFIED:
          scope.emailVerified = true;
          break;
        case STATE_PARAM_PASSWORD_RESET:
          scope.passwordReset = true;
          break;
        case STATE_PARAM_SIGNEDOUT:
          scope.signedOut = true;
          break;
        case STATE_PARAM_SUSPENDED:
          scope.suspended = true;
          break;
        case INVALID_CREDENTIALS:
        case MISSING_CAPTCHA:
          scope.invalidCredentials = true;
          break;
        case ERROR_SMS:
          scope.invalidSms = true;
          break;
        case ERROR_VERIFICATION:
          scope.invalidVerification = true;
          break;
        default:
          break;
      }
    }

    function resetError() {
      ['suspended', 'unknown', 'wrong', 'twoFactAuth'].map(function (error) {
        return scope.formSignIn.$setValidity(error, true);
      });
    }

    function signIn() {
      scope.isSubmitting = true;

      if (!scope.formSignIn.email.$error.required && scope.formSignIn.password.$valid) {
        scope.wealthError = null;
        var promise = void 0;

        // Making a copy since the browser can decide to change the autofilled data
        // between the first and second 2fa call:
        var signInData = angular.copy(scope.model);
        signInData.email = signInData.email.trim();

        if (signInData.email.indexOf('@') > -1) {
          promise = signInNetwork(signInData);
        } else {
          promise = signInHolding(signInData);
        }
        return promise;
      }
      return false;
    }

    function signInNetwork(signInData) {
      return Gmw2FA.executeWith2FA(function (twoFactAuth) {
        return btgUser.signIn(signInData, twoFactAuth, scope.captcha.code);
      }, 'signIn').then(function () {
        if (scope.onNetworkSignIn) {
          scope.onNetworkSignIn();
        }
      }).catch(function (error) {
        if (error && 'data' in error && error.data && 'message' in error.data) {
          scope.emailExpired = false;
          scope.emailVerified = false;
          scope.passwordReset = false;
          scope.signedOut = false;
          scope.suspended = false;
          scope.invalidCredentials = false;
          scope.invalidVerification = false;

          if (error.data.message === INVALID_CREDENTIALS) {
            scope.formSignIn.$setValidity('wrong', false);
            if (scope.captchaNeeded) {
              scope.$broadcast('gm:captcha:reset');
            }
          } else if (error.status === 423) {
            scope.formSignIn.$setValidity('suspended', false);
          } else if (error.data.message === ERROR_VERIFICATION) {
            scope.formSignIn.$setValidity('twoFactAuth', false);
          } else if (error.data.message === 'missing.captcha') {
            scope.captchaNeeded = 'true';
            scope.formSignIn.$setValidity('wrong', true);
            scope.formSignIn.$setValidity('captcha', false);
          } else if (error.data.message === 'invalid.captcha') {
            scope.$broadcast('gm:captcha:reset');
          } else if (error.data.message === INVALID_AUTH_TOKEN) {
            scope.invalidToken = true;
          } else if (error.data.message === 'missing.captcha') {
            scope.formSignIn.$setValidity('unknown', false);
          }
        } else {
          scope.formSignIn.$setValidity('unknown', false);
        }
      });
    }

    function signInHolding(signInData) {
      return HoldingAuth.signIn(signInData).then(function () {
        if (scope.onWealthSignIn) {
          scope.onWealthSignIn();
        }
      }).catch(function (_ref) {
        var message = _ref.message;

        switch (message) {
          case 'The transition has been superseded by a different transition':
            break;
          case 'The transition errored':
          case 'This transition is invalid':
            scope.wealthError = 'An error has occurred, please try again later (#433)';
            break;
          case 'no.owner.he':
            scope.wealthError = 'An error has occurred, please try again later (#434)';
            break;
          default:
            scope.wealthError = message;
            break;
        }
      });
    }

    scope.captcha = {};
    scope.isSubmitting = false;
    scope.resetError = resetError;
    scope.signIn = signIn;
    scope.siteUrl = HoldingEnvironment.urls.site;

    activate();
  }
}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = "<form name=formSignIn id=formSignIn holding-form-loading=signIn() novalidate> <holding-alert class=error ng-if=emailExpired title=\"{{'Expired Verification Link'|translate}}\"> <main> <span> <span ng-bind=\"'The email verification link that we sent you has expired or has already been used.'|translate\"></span> </span> </main> <cta> <a ui-sref=auth.forgot-credentials ng-bind=\"'Please try again'|translate\"></a> </cta> </holding-alert> <holding-alert class=error ng-if=emailInvalid title=\"{{'Invalid Verification Link'|translate}}\"> <main> <span> <span ng-bind=\"'The email verification link used appears to be invalid.'|translate\">T</span> </span> </main> <cta> <a ui-sref=auth.forgot-credentials ng-bind=\"'Please try again'|translate\"></a> </cta> </holding-alert> <holding-alert class=success ng-if=emailVerified title=\"{{'Email Verified Succesfully'|translate}}\"> <main> <span ng-bind=\"'Please sign in to proceed to your Holding.'|translate\"></span> </main> </holding-alert> <holding-alert class=success ng-if=passwordReset title=\"{{'Password Reset Complete'|translate}}\"> <main> <span ng-bind=\"'Please sign in with your new password below.'|translate\"></span> </main> </holding-alert> <holding-alert class=success ng-if=signedOut title=\"{{'Sign Out Successful'|translate}}\"> <main> <span ng-bind=\"'Thank you for using Goldmoney.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=suspended title=\"{{'Account Suspended'|translate}}\"> <main> <span> <span ng-bind=\"'Your account was suspended.'|translate\"></span> </span> </main> <cta> <a href=https://support.goldmoney.com/hc/ ng-bind=\"'Contact Relationship Management for assistance'|translate\"></a> </cta> </holding-alert> <holding-alert class=error ng-if=invalidCredentials title=\"{{'Invalid Credentials'|translate}}\"> <main> <span ng-bind=\"'The supplied email address or phone number and password don\\'t match. Please try again.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=invalidSms title=\"{{'Invalid Credentials'|translate}}\"> <main> <span> <span ng-bind=\"'There was a problem sending your password reset code, please'|translate\"></span> <a class=gmw-alert-link href=https://support.goldmoney.com/hc/ ng-bind=\"'contact Relationship Management'|translate\"></a> <span ng-bind=\"'and verify that your phone number is a mobile number.'|translate\"></span> </span> </main> <cta> <a href=https://support.goldmoney.com/hc/ ng-bind=\"'Contact Relationship Management'|translate\"></a> </cta> </holding-alert> <holding-alert class=error ng-if=invalidVerification title=\"{{'Invalid Two Factor Code'|translate}}\"> <span ng-bind=\"'The two factor authentication code entered was not valid. Please try again.'|translate\"></span> </holding-alert> <holding-alert class=error ng-if=invalidToken title=\"{{'Enable Cookies'|translate}}\"> <main> <span ng-bind=\"'It appears that you are blocking cookies. Please enable cookies to access your account.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=\"formSignIn.$invalid && formSignIn.$submitted && !formSignIn.$error.required\" ng-messages=formSignIn.$error title=\"{{'Error'|translate}}\"> <main> <ul> <li ng-message=captcha> <span ng-bind=\"'Due to multiple failed sign in attempts further verification is required.'|translate\"></span> </li> <li ng-message=password> <span ng-bind=\"'Please enter your password.'|translate\"></span> </li> <li ng-message=suspended> <span> <span ng-bind=\"'Your account was suspended. Please'|translate\"></span> <a class=gmw-alert-link href=https://support.goldmoney.com/hc/ ng-bind=\"'contact Relationship Management'|translate\"></a> <span ng-bind=\"'for assistance.'|translate\"></span> </span> </li> <li ng-message=twoFactAuth> <span ng-bind=\"'The two factor authentication code entered was not valid.'|translate\"></span> </li> <li ng-message=unknown> <span ng-bind=\"'An error has occurred, please try again later.'|translate\"></span> </li> <li ng-message=wrong> <span ng-bind=\"'The supplied email address and password don\\'t match those on record.'|translate\"></span> </li> </ul> </main> </holding-alert> <holding-alert class=error ng-if=wealthError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=wealthError></span> </main> </holding-alert> <div class=gmw-input-container> <span class=\"h-medium-text h-light-text sign-in-holding-number-example\" ng-bind=\"'Ex: 00-11-11-A'|translate\"> </span> <label class=gmw-input-container__label> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'Goldmoney Personal (formerly BitGold) users should use their email address below to sign in'|translate}}\" ng-bind=\"'Looking for your Goldmoney Personal account sign in?'|translate\"> </a> </label> <gmw-box-input required type=text name=email autocomplete=username ng-model=model.email ng-change=resetError() no-label=true placeholder=\"{{'Holding'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=17 height=16> <use xlink:href=#simple-user-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=gmw-input-container> <gmw-box-input required type=password name=password autocomplete=current-password has-error=enabled ng-model=model.password ng-change=resetError() no-label=true placeholder=\"{{'Password'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=initial-onboarding__additional> <gmw-checkbox class=initial-onboarding__additional-check ng-model=model.rememberMe> <span ng-bind=\"'Remember Me'|translate\"></span> </gmw-checkbox> <a class=h-default-link ui-sref=auth.forgot-credentials ng-bind=\"'Forgot your credentials?'|translate\"> </a> </div> <holding-captcha ng-if=captchaNeeded ng-model=captcha.code class=initial-onboarding__reCaptcha name=recaptcha required> </holding-captcha> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button gmw-extra-button-padding\" ng-class=\"{\n        'loading-button': isSubmitting\n      }\" holding-button-disabled=formSignIn.$invalid> <span ng-bind=\"'Sign In'|translate\"></span> </button> </div> <holding-augur name=hid ng-model=model.deviceFingerprint> </holding-augur> </form> ";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SignInController.$inject = ['$window', '$stateParams', '$location', 'HoldingAuth', 'HoldingEnvironment'];
angular.module('app.auth.sign-in').controller('SignInController', SignInController);

function SignInController($window, $stateParams, $location, HoldingAuth, HoldingEnvironment) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.model = angular.copy(DEFAULT_MODEL);
  vm.onNetworkSignIn = onNetworkSignIn;
  vm.onWealthSignIn = onWealthSignIn;
  vm.siteUrl = HoldingEnvironment.urls.site;

  function activate() {
    if ($stateParams.message) {
      vm.message = $stateParams.message;
    }
  }

  function onNetworkSignIn() {
    if ($stateParams.target && HoldingAuth.isValidRedirectUrl($stateParams.target)) {
      $window.location.href = $stateParams.target;
      return false;
    }
    $window.location.href = '/network/vault/overview';
    return false;
  }

  function onWealthSignIn() {
    if ($stateParams.target && HoldingAuth.isValidRedirectUrl($stateParams.target)) {
      $window.location.href = $stateParams.target;
    }
  }

  function path(origDestPath) {
    var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var current = $location.path();

    var destPath = void 0;
    if (origDestPath === '/') {
      destPath = '/vault/overview';
    } else if (!origDestPath) {
      destPath = current;
    } else {
      destPath = origDestPath;
    }
    $location.path(destPath);

    if (replace) {
      $location.replace();
    }
  }

  activate();
}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _verifyEmail = __webpack_require__(360);

var _verifyEmail2 = _interopRequireDefault(_verifyEmail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth.verify-email', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('auth.verify-email', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Verify the email address associated with your Goldmoney Holding',
      pageTitle: 'Email Verification',
      skipSetupCheck: true
    },
    params: {
      code: {
        value: null,
        squash: true
      }
    },
    resolve: {
      VerifyEmailResolve: ['$stateParams', '$q', 'HoldingAuth', function VerifyEmailResolve($stateParams, $q, HoldingAuth) {
        'ngInject';

        var code = $stateParams.code;

        return HoldingAuth.verifyEmail(code).then(function (response) {
          return $q.resolve(true);
        }).catch(function (error) {
          return $q.resolve(error);
        });
      }]
    },
    url: '/verify-email/:code',
    views: {
      auth: {
        controller: 'VerifyEmailController',
        controllerAs: 'verifyEmailCtrl',
        template: _verifyEmail2.default
      }
    }
  });
}]).name;


__webpack_require__(361);

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = "<auth-hero heading=\"{{'Verify your email address'|translate}}\"> </auth-hero> <section class=initial-onboarding> <div class=initial-onboarding__inner ng-if=verifyEmailCtrl.emailVerified> <holding-alert class=success title=\"{{'Email Verification Complete'|translate}}\"> <main> <span ng-bind=\"'You\\'ve successfully verified your email address'|translate\"></span> </main> </holding-alert> <p class=\"gmw-flow-box__description h-dark-text\"> <span ng-bind=\"'Now that you\\'ve verified your email, you can sign back into your Holding using the button below.'|translate\" ng-if=!verifyEmailCtrl.isVerified> </span> <span ng-bind=\"'Now that you\\'ve verified your email, you can return to your Holding using the button below.'|translate\" ng-if=verifyEmailCtrl.isVerified> </span> </p> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=auth.sign-in ng-if=!verifyEmailCtrl.isVerified> <span ng-bind=\"'Sign In to your Holding'|translate\"> </span> </button> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=holding.dashboard.overview ng-if=verifyEmailCtrl.isVerified> <span ng-bind=\"'Holding Overview'|translate\"> </span> </button> </div> </div> <div class=initial-onboarding__inner ng-if=!verifyEmailCtrl.emailVerified> <holding-alert class=error title=\"{{'Email Verification Error'|translate}}\"> <main> <span ng-bind=verifyEmailCtrl.emailVerifiedResult.message></span> </main> </holding-alert> <p class=\"gmw-flow-box__description h-dark-text\"> <span ng-bind=\"'There was an error verifying your email address. Please'|translate\"> </span> <a href=https://support.goldmoney.com/hc/requests/new class=h-blue-link ng-bind=\"'contact us'|translate\" target=_blank> </a> <span ng-bind=\"'so that we can assist you further.'|translate\"></span> </p> <div class=initial-onboarding__dual-cta> <div class=initial-onboarding__dual-cta-col> <a class=\"medium-border-cta gmw-responsive-button\" ng-bind=\"'Sign In to your Holding'|translate\" type=button ui-sref=auth.sign-in> </a> </div> <div class=initial-onboarding__dual-cta-col> <a class=\"medium-main-cta gmw-responsive-button\" href=https://support.goldmoney.com/hc/requests/new target=_blank> <span ng-bind=\"'Contact Support'|translate\"> </span> </a> </div> </div> </div> <footer class=initial-onboarding__footer> <span class=initial-onboarding__footer-item> <span ng-bind=\"'Have questions about verifying your email? Please'|translate\"> </span> <a href=https://support.goldmoney.com/hc/requests/new class=h-blue-link ng-bind=\"'contact us'|translate\" target=_blank> </a> <span ng-bind=\"'for assistance.'|translate\"> </span> </span> </footer> </section> ";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


VerifyEmailController.$inject = ['HoldingUser', 'VerifyEmailResolve'];
angular.module('app.auth.verify-email').controller('VerifyEmailController', VerifyEmailController);

function VerifyEmailController(HoldingUser, VerifyEmailResolve) {
  'ngInject';

  var vm = this;

  vm.emailVerified = VerifyEmailResolve === true;
  vm.emailVerifiedResult = VerifyEmailResolve;
  vm.isVerified = HoldingUser.checkIfAuthed();
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingAuthHeader.$inject = ['$rootScope', 'HoldingEnvironment'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authHeader = __webpack_require__(363);

var _authHeader2 = _interopRequireDefault(_authHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth').directive('holdingAuthHeader', holdingAuthHeader).name;


function holdingAuthHeader($rootScope, HoldingEnvironment) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _authHeader2.default
  };

  function link(scope) {
    var navOpen = void 0;

    function activate() {
      navOpen = false;
    }

    function isNavOpen() {
      return navOpen;
    }

    function toggleNav() {
      navOpen = !navOpen;

      var pageClasses = $rootScope.pageParams.pageBodyClass.split(' ');
      if (navOpen) {
        pageClasses.push('no-scroll');
        $rootScope.pageParams.pageBodyClass = pageClasses.join(' ');
      } else {
        pageClasses.splice(pageClasses.indexOf('no-scroll'), 1);
        $rootScope.pageParams.pageBodyClass = pageClasses.join(' ');
      }
    }

    scope.isNavOpen = isNavOpen;
    scope.siteUrl = HoldingEnvironment.urls.site;
    scope.supportUrl = HoldingEnvironment.urls.support.main;
    scope.toggleNav = toggleNav;

    activate();
  }
}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<header class=onboarding-header> <div class=onboarding-header__top> <div class=\"_wrapper onboarding-header__container\"> <div class=onboarding-header__logo-container> <a href=\"{{siteUrl}}/\"> <svg class=onboarding-header__logo> <use xlink:href=#goldmoney-logo-22></use> </svg> </a> </div> <a href=\"{{supportUrl}}\" class=h-default-link translate> Support </a> </div> </div> </header>";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authHero = __webpack_require__(365);

var _authHero2 = _interopRequireDefault(_authHero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth').directive('authHero', authHero).name;


function authHero() {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {},
    template: _authHero2.default
  };

  function link(scope, _element, attrs) {
    scope.heading = attrs.heading || '';
  }
}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<section class=initial-onboarding-hero> <div class=initial-onboarding-hero__content> <h1 class=heading-h1 ng-bind=heading></h1> </div> </section> ";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingTimeoutClickButton.$inject = ['$timeout', '$interval'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timeoutClickButton = __webpack_require__(367);

var _timeoutClickButton2 = _interopRequireDefault(_timeoutClickButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.auth').directive('holdingTimeoutClickButton', holdingTimeoutClickButton).name;


function holdingTimeoutClickButton($timeout, $interval) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      action: '&',
      init: '@?',
      timeout: '=?'
    },
    template: _timeoutClickButton2.default,
    transclude: true
  };

  function link(scope) {
    function activate() {
      if (!scope.init) {
        startBlockFormTimeout(scope);
      }
    }

    function doAction() {
      startBlockFormTimeout(scope);

      scope.isVerifyLoading = true;
      scope.resendComplete = false;
      scope.action().then(function () {
        scope.resendComplete = true;
        $timeout(function () {
          scope.resendComplete = false;
        }, 3000);
      }).finally(function () {
        scope.isVerifyLoading = false;
      });
    }

    function startBlockFormTimeout(scope) {
      var waitSec = scope.timeout;

      scope.isBlocked = true;
      scope.secondsLeft = waitSec;

      if (scope.blockTimeout) {
        $timeout.cancel(scope.blockTimeout);
      }

      if (scope.secondsLeftInterval) {
        $interval.cancel(scope.secondsLeftInterval);
      }

      scope.blockTimeout = $timeout(function () {
        scope.isBlocked = false;
      }, waitSec * 1000);

      scope.secondsLeftInterval = $interval(function () {
        scope.secondsLeft -= 1;
      }, 1000, waitSec);
    }

    var DEFAULT_TIMEOUT = 60;

    scope.doAction = doAction;
    scope.isBlocked = false;
    scope.isVerifyLoading = false;
    scope.resendComplete = false;
    scope.secondsLeft = 0;
    scope.timeout = scope.timeout || DEFAULT_TIMEOUT;

    activate();
  }
}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<span> <span ng-class=\"{\n    'timeout-click-button_disabled': isBlocked,\n  }\" ng-click=\"isBlocked || doAction()\"> <ng-transclude></ng-transclude> <span class=timer ng-show=\"isBlocked && !resendComplete && !isVerifyLoading\"> <span ng-bind=\"'(available after'|translate\"></span> <span ng-bind=secondsLeft></span> <span ng-bind=\"'seconds)'|translate\"></span> </span> </span> <span ng-show=isVerifyLoading class=\"spinner small-blue-spinner\"></span> <span ng-show=resendComplete class=sent-label> <svg class=sent-label__icon> <use xlink:href=#thick-checkmark-icon></use> </svg> <span ng-bind=\"'Sent'|translate\"></span> </span> </span> ";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingAuth.$inject = ['$q', '$state', '$document', 'GmwSetup', 'HoldingApi', 'HoldingBalances', 'HoldingSession', 'HoldingExpectedUse', 'HoldingProperties', 'promiseCache'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = angular.module('app.auth').factory('HoldingAuth', HoldingAuth).name;


function HoldingAuth($q, $state, $document, GmwSetup, HoldingApi, HoldingBalances, HoldingSession, HoldingExpectedUse, HoldingProperties, promiseCache) {
  'ngInject';

  return {
    agreeToRiskDisclosure: agreeToRiskDisclosure,
    agreeToTerms: agreeToTerms,
    isValidRedirectUrl: isValidRedirectUrl,
    processSession: processSession,
    sendEmailVerificationLink: sendEmailVerificationLink,
    signIn: signIn,
    signOut: signOut,
    verifyEmail: verifyEmail
  };

  function agreeToRiskDisclosure() {
    return HoldingProperties.set('AgreeRiskDisclosure', {
      at: new Date().toISOString()
    });
  }

  function agreeToTerms() {
    return HoldingApi.post('login/terms');
  }

  function isValidRedirectUrl(url) {
    var parser = angular.element($document)[0].createElement('a');
    parser.href = url;
    return parser.hostname.match(/goldmoney.com$/) !== null;
  }

  function processSession(user) {
    HoldingSession.setSessionId(user.sessionCode);

    return $q.all([GmwSetup.getSetupStatus(true), GmwSetup.hasCompletedSetup(), HoldingProperties.load()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          setupStatus = _ref2[0],
          hasCompletedSetup = _ref2[1],
          properties = _ref2[2];

      // change password if required
      if (user.loginFlags.changePassword) {
        return $q.when($state.go('auth.reset-password'));
      }

      // Canadian-resident client must agree to risk disclosure
      var hasCaResidentEntity = setupStatus.entities.some(function (entity) {
        return entity.address.country == 'CA';
      });
      var hasAgreedRiskDisclosure = HoldingProperties.get('AgreeRiskDisclosure');
      if (hasCaResidentEntity && !hasAgreedRiskDisclosure) {
        return $q.when($state.go('holding.splash.legal.risk-disclosure'));
      }

      // client must agree to terms
      if (user.loginFlags.agreeOnTerms) {
        return $q.when($state.go('holding.splash.legal.client-agreement'));
      }

      // check if the client must agree to new terms
      if (user.loginFlags.mustMigrate) {
        return $q.when($state.go('holding.splash.legal.transfer'));
      }

      // check holding setup
      if (!hasCompletedSetup) {
        return $q.when($state.go('setup'));
      }

      // check if the holding should update security questions
      if (user.loginFlags.setSecurityQuestions) {
        return $q.when($state.go('setup.security-questions'));
      }

      // check for jumio
      var entityToJumio = setupStatus.entities.find(function (entity) {
        return 'jumio' in entity.verification && !!entity.verification.jumio;
      });
      if (setupStatus.isFullHolding && hasCompletedSetup && !!entityToJumio && user.active) {
        return $q.when($state.go('holding.splash.kyc.id-netverify', {
          code: entityToJumio.code
        }));
      }

      // check for expected use update needed
      if (user.active) {
        if (!HoldingExpectedUse.hasCompleteValues(setupStatus.expectedUse)) {
          return $q.when($state.go('holding.splash.kyc.expected-use'));
        }

        var lastExpectedUseCollection = moment(setupStatus.expectedUse.updated);
        if (HoldingExpectedUse.hasDefaultValues(setupStatus.expectedUse) && lastExpectedUseCollection.isBefore(moment('2019-05-11'))) {
          return $q.when($state.go('holding.splash.kyc.expected-use'));
        }
      }

      return $q.when($state.go('holding.dashboard.overview', {}, {
        reload: true
      }));
    });
  }

  function sendEmailVerificationLink() {
    return HoldingApi.post('verification/sendEmailVerification');
  }

  function signIn(_ref3) {
    var holdingNumber = _ref3.email,
        passPhrase = _ref3.password,
        _ref3$deviceFingerpri = _ref3.deviceFingerprint,
        deviceFingerprint = _ref3$deviceFingerpri === undefined ? null : _ref3$deviceFingerpri;

    HoldingSession.clearSessionId();

    return HoldingApi.post('login', {
      holdingNumber: holdingNumber,
      passPhrase: passPhrase,
      deviceFingerprint: deviceFingerprint
    }).then(processSession);
  }

  function signOut() {
    return HoldingApi.post('logout').then(function () {
      promiseCache.removeAll();
    });
  }

  function verifyEmail(code) {
    return HoldingApi.post('verification/verifyEmail/' + code);
  }
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingForgotAccountDetails.$inject = ['$window', 'gmApi', 'btgUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.auth').factory('HoldingForgotAccountDetails', HoldingForgotAccountDetails).name;


function HoldingForgotAccountDetails($window, gmApi, btgUser) {
  'ngInject';

  return {
    requestPasswordReset: requestPasswordReset,
    resendPhoneVerificationCode: resendPhoneVerificationCode,
    setPassword: setPassword,
    verifyEmail: verifyEmail,
    verifyPhone: verifyPhone
  };

  function requestPasswordReset(email) {
    return gmApi.post('users/password', {
      email: email
    });
  }

  function resendPhoneVerificationCode() {
    return gmApi.post('users/verifications/passwordResetPhone', {}, {
      auth: true
    });
  }

  function setPassword(password) {
    return gmApi.patch('users/password', {
      password: $window.CryptoJS.SHA512(password).toString($window.CryptoJS.enc.Hex).substr(0, 32)
    }, {
      auth: true
    });
  }

  function verifyEmail(token) {
    return gmApi.put('users/verifications/passwordResetEmail/' + token, {}, {
      token: true
    }).then(function (data) {
      btgUser.generateDefaultProfile({
        email: data.email
      });
      return data;
    });
  }

  function verifyPhone(token) {
    return gmApi.put('users/verifications/passwordResetPhone/' + token, {}, {
      auth: true
    });
  }
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingForgotHoldingDetails.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.auth').factory('HoldingForgotHoldingDetails', HoldingForgotHoldingDetails).name;


function HoldingForgotHoldingDetails(HoldingApi) {
  'ngInject';

  return {
    answerSecurityQuestions: answerSecurityQuestions,
    checkForgotHoldingCode: checkForgotHoldingCode,
    checkForgotPasswordCode: checkForgotPasswordCode,
    forgotHolding: forgotHolding,
    forgotPassword: forgotPassword
  };

  function answerSecurityQuestions(emailCode, answers) {
    return HoldingApi.post('login/forgotten-password/answer', { emailCode: emailCode, answers: answers });
  }

  function checkForgotHoldingCode(code) {
    return HoldingApi.post('login/forgotten-holding/code', { code: code });
  }

  function checkForgotPasswordCode(emailCode) {
    return HoldingApi.post('login/forgotten-password/code', { emailCode: emailCode });
  }

  function forgotHolding(email, captcha) {
    return HoldingApi.post('login/forgotten-holding', { email: email }, { captcha: captcha });
  }

  function forgotPassword(holdingNumber, captcha) {
    return HoldingApi.post('login/forgotten-password', { holdingNumber: holdingNumber }, { captcha: captcha });
  }
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ForgotAccountDetailsPhoneController.$inject = ['$timeout', '$state', 'HoldingForgotAccountDetails'];
angular.module('app.auth').controller('ForgotAccountDetailsPhoneController', ForgotAccountDetailsPhoneController);

function ForgotAccountDetailsPhoneController($timeout, $state, HoldingForgotAccountDetails) {
  'ngInject';

  var vm = this;

  vm.isResendLoading = false;
  vm.isResendComplete = false;
  vm.resendCode = resendCode;
  vm.resetErrors = resetErrors;
  vm.token = '';
  vm.verifyPhone = verifyPhone;

  function resendCode() {
    vm.isResendLoading = true;
    vm.isResendComplete = false;

    return HoldingForgotAccountDetails.resendPhoneVerificationCode().then(function () {
      vm.isResendComplete = true;
      $timeout(function () {
        vm.isResendComplete = false;
      }, 4000);
    }).finally(function () {
      vm.isResendLoading = false;
    });
  }

  function resetErrors() {
    vm.fpPhoneForm.$setValidity('expired', true);
  }

  function showVerifyError(error) {
    if (error.status === 400) {
      vm.fpPhoneForm.$setValidity('expired', false);
    } else {
      vm.fpPhoneForm.$setValidity('unknown', false);
    }
  }

  function verifyPhone() {
    return HoldingForgotAccountDetails.verifyPhone(vm.token).then(function () {
      $state.go('auth.forgot-account-details-reset');
    }).catch(showVerifyError);
  }
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ForgotAccountDetailsResetController.$inject = ['$log', '$state', 'HoldingForgotAccountDetails', 'HoldingEnvironment', 'HoldingCookies'];
angular.module('app.auth').controller('ForgotAccountDetailsResetController', ForgotAccountDetailsResetController);

function ForgotAccountDetailsResetController($log, $state, HoldingForgotAccountDetails, HoldingEnvironment, HoldingCookies) {
  'ngInject';

  function removeToken() {
    HoldingCookies.remove('_bitgold_token_', {
      path: '/',
      domain: '.' + HoldingEnvironment.domain
    });
    HoldingCookies.remove('_bitgold_token_type', {
      path: '/',
      domain: '.' + HoldingEnvironment.domain
    });
  }

  function setPassword() {
    if (vm.fpResetForm.$valid) {
      return HoldingForgotAccountDetails.setPassword(vm.model.password).then(function () {
        removeToken();
        $state.go('auth.sign-in', {
          message: 'reset'
        });
      }).catch(function (error) {
        $log.debug(error);
      });
    }
    return false;
  }

  var DEFAULT_MODEL = {
    password: '',
    repeatPassword: ''
  };

  var vm = this;

  vm.model = angular.copy(DEFAULT_MODEL);
  vm.setPassword = setPassword;
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ForgotAccountDetailsVerifyController.$inject = ['$state', 'VerificationResultResolve'];
angular.module('app.auth').controller('ForgotAccountDetailsVerifyController', ForgotAccountDetailsVerifyController);

function ForgotAccountDetailsVerifyController($state, VerificationResultResolve) {
  'ngInject';

  if (VerificationResultResolve) {
    $state.go(VerificationResultResolve.state, VerificationResultResolve.params);
  } else {
    $state.go('auth.forgot-credentials', {
      type: 'network'
    });
  }
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.conf', []).name;


__webpack_require__(375);
__webpack_require__(376);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.conf').constant('HoldingConfig', {
  airbrake: {
    id: '303998',
    key: 'b604561e3e89c0015216bc2aaf416272'
  },
  recaptcha: {
    sitekey: '6Lcv0iUTAAAAAFaC-bVgyZ5hAmdSV8eFlveACAie'
  },
  settings: {
    errorReporting: {
      enabled: true
    },
    maxPendingTransfers: 10
  }
}).name;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.conf').constant('HoldingEnvironment', {
  domain: 'goldmoney.com',
  env: 'production',
  settings: {
    debug: false,
    log: {
      debug: false
    }
  },
  tokens: {
    strapiAccessToken: 'ceaa0711d00a8bc20da446e4903df8dfd91d9a88e61bdccd2e8412119a07e9e2bf502a22e64314fdb4fd233b3020461fb8f6be5c2e82b30d1072843093eec0238e4568d83b561ade6318b8d089cb7439baaa00bd979d63c013c81f0979e643ca475a6f714a045031a78d71a63629ecab29022d9210f84b84e92ececa1807a733'
  },
  urls: {
    backend: 'https://wealth-api.goldmoney.com/',
    clientAgreement: {
      main: 'https://www.goldmoney.com/client-agreement',
      regulator: {
        canada: 'https://www.goldmoney.com/docs/goldmoney-client-agreement-canada.pdf',
        uk: 'https://www.goldmoney.com/docs/goldmoney-client-agreement-uk.pdf'
      }
    },
    disclaimer: 'https://www.goldmoney.com/disclaimer',
    documents: {
      mailVerification: 'https://gm-public.s3.eu-west-1.amazonaws.com/docs/onboarding/verification-individual-holding.pdf',
      postIdentVerification: 'https://gm-public.s3.eu-west-1.amazonaws.com/docs/onboarding/verification-postident-antragsunterlagen.pdf'
    },
    marketSummary: 'market-summary.goldmoney.com',
    privacy: 'https://www.goldmoney.com/privacy-policy',
    referral: {
      terms: 'https://www.goldmoney.com/docs/goldmoney-referral-program-terms.pdf'
    },
    research: 'https://www.goldmoney.com/research/goldmoney-insights',
    riskDisclosure: 'https://www.goldmoney.com/docs/goldmoney-risk-disclosure-statement.pdf',
    site: 'https://www.goldmoney.com',
    strapi: 'https://data.goldmoney.com/api',
    support: {
      buy: {
        fixed: 'https://support.goldmoney.com/hc/articles/360000744207',
        limits: 'https://support.goldmoney.com/hc/articles/360000737568'
      },
      funding: {
        main: 'https://support.goldmoney.com/hc/sections/115004131728',
        trust: 'https://support.goldmoney.com/hc/articles/360000686667'
      },
      main: 'https://support.goldmoney.com/hc',
      onboarding: {
        countries: 'https://support.goldmoney.com/hc/articles/360000844487',
        documents: 'https://support.goldmoney.com/hc/articles/360000849727',
        id: 'https://support.goldmoney.com/hc/articles/360000854208',
        joint: 'https://support.goldmoney.com/hc/articles/360000844387',
        por: 'https://support.goldmoney.com/hc/articles/360000845247',
        postident: 'https://support.goldmoney.com/hc/articles/360000910308',
        residency: 'https://support.goldmoney.com/hc/articles/360000845527',
        unverified: 'https://support.goldmoney.com/hc/articles/360000849727'
      },
      physical: {
        overview: 'https://support.goldmoney.com/hc/en-us/articles/360025277972'
      },
      redemption: {
        countries: 'https://support.goldmoney.com/hc/articles/360000697747',
        possession: 'https://support.goldmoney.com/hc/articles/360000707848',
        tax: 'https://support.goldmoney.com/hc/articles/360000707868'
      },
      registration: {
        what: 'https://support.goldmoney.com/hc/articles/360000697687',
        difference: 'https://support.goldmoney.com/hc/articles/360000707988'
      },
      sell: {
        fixed: 'https://support.goldmoney.com/hc/articles/360000744207',
        limits: 'https://support.goldmoney.com/hc/articles/360000737568'
      },
      storage: 'https://support.goldmoney.com/hc/sections/360000095347',
      storageRegistered: 'https://support.goldmoney.com/hc/articles/360000668307'
    }
  }
}).name;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.cookies', []).name;


__webpack_require__(378);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingCookies.$inject = ['$log', 'ipCookie'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.cookies').factory('HoldingCookies', HoldingCookies).name;


function HoldingCookies($log, ipCookie) {
  'ngInject';

  return {
    get: get,
    remove: remove,
    set: set
  };

  function get(key) {
    try {
      return ipCookie(key);
    } catch (e) {
      $log.error('Cookies not supported');
    }
    return false;
  }

  function remove(key, options) {
    try {
      ipCookie.remove(key, options);
    } catch (e) {
      $log.error('Cookies not supported');
    }
  }

  function set(key, value, options) {
    try {
      return ipCookie(key, value, options);
    } catch (e) {
      $log.error('Cookies not supported');
    }
    return false;
  }
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.countries', []).name;


__webpack_require__(380);
__webpack_require__(381);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCountryName.$inject = ['HoldingCountries'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.countries').filter('holdingCountryName', holdingCountryName).name;


function holdingCountryName(HoldingCountries) {
  'ngInject';

  return function (input) {
    if (!input) {
      return undefined;
    }
    return HoldingCountries.getCountryByCode(input).name;
  };
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingCountries.$inject = ['$q', 'promiseCache', 'HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.countries').factory('HoldingCountries', HoldingCountries).name;


function HoldingCountries($q, promiseCache, HoldingApi) {
  'ngInject';

  var countries = void 0;
  var countriesPromise = void 0;

  return {
    getAllForSelector: getAllForSelector,
    getAllowedResidence: getAllowedResidence,
    getCurrencyByCountryCode: getCurrencyByCountryCode,
    getCountryByCode: getCountryByCode,
    getPrefix: getPrefix,
    getPrefixes: getPrefixes,
    getProvinces: getProvinces,
    load: load,
    prepareForSelector: prepareForSelector
  };

  function getAllForSelector() {
    return countries.map(prepareForSelector);
  }

  function getAllowedResidence() {
    return countries.filter(isAllowed).map(prepareForSelector);
  }

  function getCurrencyByCountryCode(countryCode) {
    return getCountryByCode(countryCode).currency;
  }

  function getCountryByCode(countryCode) {
    return countries.find(function (_) {
      return _.cc2 === countryCode.toUpperCase();
    });
  }

  function getPrefix(country) {
    return countries.find(function (_) {
      return _.cc2 === country;
    }).phonePrefix;
  }

  function getPrefixes() {
    return countries.filter(isAllowed).filter(function (country) {
      return !!country.phonePrefix;
    }).map(function (_ref) {
      var cc2 = _ref.cc2,
          name = _ref.name,
          phonePrefix = _ref.phonePrefix;
      return {
        value: cc2,
        label: name,
        flag: cc2.toLowerCase(),
        meta: '+' + phonePrefix
      };
    });
  }

  function getProvinces(country) {
    function fetchProvinces() {
      if (!country) {
        return $q.resolve([]);
      }
      return HoldingApi.get('provinces/' + country).then(function (provinces) {
        return provinces.map(function (_ref2) {
          var name = _ref2.name;
          return { label: name, value: name };
        });
      });
    }

    return promiseCache({
      key: 'provinces-' + country,
      ttl: -1,
      promise: function promise() {
        return fetchProvinces();
      }
    });
  }

  function init() {
    return HoldingApi.get('countries').then(function (loadedCountries) {
      countries = loadedCountries;
      return countries;
    });
  }

  function isAllowed(country) {
    return country.signUpAllowed;
  }

  function load() {
    if (!countriesPromise) {
      countriesPromise = init();
    }

    return countriesPromise;
  }

  function prepareForSelector(country) {
    return {
      value: country.cc2,
      label: country.name,
      flag: country.cc2.toLowerCase()
    };
  }
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies', []).name;


__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies').constant('HoldingCurrencyCountries', {
  USD: 'us',
  CAD: 'ca',
  GBP: 'gb',
  EUR: 'eu',
  CHF: 'ch',
  JPY: 'jp',
  AUD: 'au',
  NZD: 'nz',
  HKD: 'hk'
}).name;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCurrencyName.$inject = ['HoldingCurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies').filter('holdingCurrencyName', holdingCurrencyName).name;


function holdingCurrencyName(HoldingCurrencies) {
  'ngInject';

  return function (input) {
    if (!input) {
      return '';
    }

    var currency = HoldingCurrencies.getCurrencyByCode(input.currency || input);
    return currency.currencyNamePlural;
  };
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCurrencyCountry.$inject = ['HoldingCurrencyCountries'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies').filter('holdingCurrencyCountry', holdingCurrencyCountry).name;


function holdingCurrencyCountry(HoldingCurrencyCountries) {
  'ngInject';

  return function (input) {
    if (!input) {
      return '';
    }

    return HoldingCurrencyCountries[input];
  };
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GmwCurrencyPrecision = function () {
    function GmwCurrencyPrecision() {
        _classCallCheck(this, GmwCurrencyPrecision);
    }

    _createClass(GmwCurrencyPrecision, null, [{
        key: 'factory',
        value: function factory() {
            var factoryFunction = function factoryFunction(HoldingCurrencies) {
                return function (input) {
                    if (!input) {
                        return undefined;
                    }
                    var currency = HoldingCurrencies.getCurrencyByCode(input.currency || input);
                    return currency.decimals;
                };
            };
            factoryFunction.$inject = ['HoldingCurrencies'];
            return factoryFunction;
        }
    }]);

    return GmwCurrencyPrecision;
}();

exports.default = angular.module('app.currencies').filter('holdingCurrencyPrecision', GmwCurrencyPrecision.factory()).name;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCurrencySymbol.$inject = ['HoldingCurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies').filter('holdingCurrencySymbol', holdingCurrencySymbol).name;


function holdingCurrencySymbol(HoldingCurrencies) {
  'ngInject';

  return function (input) {
    if (!input) {
      return undefined;
    }

    var currency = HoldingCurrencies.getCurrencyByCode(input);
    return currency.symbol || input;
  };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFormatCurrency.$inject = ['HoldingCurrencies', 'HoldingFormatting'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies').filter('holdingFormatCurrency', holdingFormatCurrency).name;


function holdingFormatCurrency(HoldingCurrencies, HoldingFormatting) {
  'ngInject';

  return function (amount, currencyCode, decimals) {
    if (!angular.isNumber(amount)) {
      return amount;
    }

    var currency = HoldingCurrencies.getCurrencyByCode(currencyCode);
    var displayDecimals = decimals || currency.decimals;

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(amount, displayDecimals),
        sign = _HoldingFormatting$fo.sign,
        formatted = _HoldingFormatting$fo.formatted;

    return '' + (sign ? sign + ' ' : '') + currency.symbol + formatted;
  };
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingCurrencies.$inject = ['HoldingApi', 'HoldingCurrencyCountries'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.currencies').factory('HoldingCurrencies', HoldingCurrencies).name;


function HoldingCurrencies(HoldingApi, HoldingCurrencyCountries) {
  'ngInject';

  var activeLoadPromise = void 0;
  var currencies = void 0;

  return {
    getAllFiatForSelector: getAllFiatForSelector,
    getAllFiatForSelectorWithName: getAllFiatForSelectorWithName,
    getAllForSelectorWithName: getAllForSelectorWithName,
    getCurrencyByCode: getCurrencyByCode,
    getMetals: getMetals,
    getPrecisionByCode: getPrecisionByCode,
    getTypeByCode: getTypeByCode,
    isCurrencyCodeMetal: isCurrencyCodeMetal,
    load: load,
    prepareForSelector: prepareForSelector
  };

  function getAllFiatForSelector() {
    return currencies.filter(isEnabled).filter(isFiat).map(function (currency) {
      return {
        value: currency.code,
        label: currency.code,
        flag: HoldingCurrencyCountries[currency.code]
      };
    });
  }

  function getAllFiatForSelectorWithName() {
    return currencies.filter(isEnabled).filter(isFiat).map(function (currency) {
      return {
        value: currency.code,
        label: currency.currencyNamePlural,
        flag: HoldingCurrencyCountries[currency.code]
      };
    });
  }

  function getAllForSelectorWithName() {
    return currencies.filter(isEnabled).map(function (currency) {
      var selectorCurrency = {
        value: currency.code,
        label: currency.currencyNamePlural
      };

      switch (currency.type) {
        case 'Crypto':
          selectorCurrency.crypto = currency.code;
          break;
        case 'Metal':
          selectorCurrency.metal = currency.code;
          break;
        default:
          selectorCurrency.flag = HoldingCurrencyCountries[currency.code];
          break;
      }
      return selectorCurrency;
    });
  }

  function getCurrencyByCode(code) {
    var currency = currencies.find(function (_) {
      return _.code === code;
    });
    return currency || {
      decimals: 2
    };
  }

  function getMetals() {
    return currencies.filter(isEnabled).filter(isMetal);
  }

  function getPrecisionByCode(code) {
    return getCurrencyByCode(code).decimals;
  }

  function getTypeByCode(code) {
    return getCurrencyByCode(code).type;
  }

  function init() {
    return HoldingApi.get('currencies').then(function (loadedCurrencies) {
      currencies = loadedCurrencies;
      return currencies;
    });
  }

  function isCurrencyCodeMetal(currencyCode) {
    return !isFiat(getCurrencyByCode(currencyCode));
  }

  function isEnabled(currency) {
    return !!currency.enabled;
  }

  function isFiat(currency) {
    return currency.type === 'Fiat';
  }

  function isMetal(currency) {
    return currency.type === 'Metal';
  }

  function load() {
    if (!activeLoadPromise) {
      activeLoadPromise = init();
    }

    return activeLoadPromise;
  }

  function prepareForSelector(code) {
    var currency = getCurrencyByCode(code);
    var selectorCurrency = {
      value: code,
      label: currency.currencyNamePlural
    };
    switch (currency.type) {
      case 'Crypto':
        selectorCurrency.crypto = currency.code;
        break;
      case 'Metal':
        selectorCurrency.metal = currency.code;
        break;
      default:
        selectorCurrency.flag = HoldingCurrencyCountries[currency.code];
        break;
    }
    return selectorCurrency;
  }
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(197);

exports.default = angular.module('app.error-reporting', []).config(['$provide', function ($provide) {
  'ngInject';

  exceptionHandlerDelegate.$inject = ['$delegate', 'HoldingErrorReporting'];
  function exceptionHandlerDelegate($delegate, HoldingErrorReporting) {
    'ngInject';

    return function (exception, cause) {
      $delegate(exception, cause);

      HoldingErrorReporting.report(exception, cause);
    };
  }

  $provide.decorator('$exceptionHandler', exceptionHandlerDelegate);
}]).factory('$exceptionHandler', ['$log', 'HoldingEnvironment', 'HoldingConfig', function ($log, HoldingEnvironment, HoldingConfig) {
  var airbrake = new _browser.Notifier({
    projectId: HoldingConfig.airbrake.id,
    projectKey: HoldingConfig.airbrake.key,
    environment: HoldingEnvironment.env
  });

  airbrake.addFilter(function (notice) {
    notice.context.environment = HoldingEnvironment.env;
    return notice;
  });

  return function (exception, cause) {
    $log.error(exception);
    airbrake.notify({
      error: exception,
      params: {
        angular_cause: cause
      }
    });
  };
}]).name;


__webpack_require__(422);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_notifier__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_window__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instrumentation_console__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instrumentation_dom__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instrumentation_fetch__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__instrumentation_location__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__instrumentation_xhr__ = __webpack_require__(421);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var Notifier = /** @class */ (function (_super) {
    __extends(Notifier, _super);
    function Notifier(opt) {
        var _this = _super.call(this, opt) || this;
        _this.offline = false;
        _this.todo = [];
        _this._ignoreWindowError = 0;
        _this._ignoreNextXHR = 0;
        if (typeof window === 'undefined') {
            return _this;
        }
        _this.addFilter(__WEBPACK_IMPORTED_MODULE_2__filter_window__["a" /* windowFilter */]);
        if (window.addEventListener) {
            _this.onOnline = _this.onOnline.bind(_this);
            window.addEventListener('online', _this.onOnline);
            _this.onOffline = _this.onOffline.bind(_this);
            window.addEventListener('offline', _this.onOffline);
            _this.onUnhandledrejection = _this.onUnhandledrejection.bind(_this);
            window.addEventListener('unhandledrejection', _this.onUnhandledrejection);
            _this._onClose.push(function () {
                window.removeEventListener('online', _this.onOnline);
                window.removeEventListener('offline', _this.onOffline);
                window.removeEventListener('unhandledrejection', _this.onUnhandledrejection);
            });
        }
        // TODO: deprecated
        if (_this._opt.ignoreWindowError) {
            opt.instrumentation.onerror = false;
        }
        _this._instrument(opt.instrumentation);
        return _this;
    }
    Notifier.prototype._instrument = function (opt) {
        if (opt === void 0) { opt = {}; }
        if (opt.console === undefined) {
            opt.console = !isDevEnv(this._opt.environment);
        }
        if (enabled(opt.onerror)) {
            // tslint:disable-next-line:no-this-assignment
            var self_1 = this;
            var oldHandler_1 = window.onerror;
            window.onerror = function abOnerror() {
                if (oldHandler_1) {
                    oldHandler_1.apply(this, arguments);
                }
                self_1.onerror.apply(self_1, arguments);
            };
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__instrumentation_dom__["a" /* instrumentDOM */])(this);
        if (enabled(opt.fetch) && typeof fetch === 'function') {
            Object(__WEBPACK_IMPORTED_MODULE_5__instrumentation_fetch__["a" /* instrumentFetch */])(this);
        }
        if (enabled(opt.history) && typeof history === 'object') {
            Object(__WEBPACK_IMPORTED_MODULE_6__instrumentation_location__["a" /* instrumentLocation */])(this);
        }
        if (enabled(opt.console) && typeof console === 'object') {
            Object(__WEBPACK_IMPORTED_MODULE_3__instrumentation_console__["a" /* instrumentConsole */])(this);
        }
        if (enabled(opt.xhr) && typeof XMLHttpRequest !== 'undefined') {
            Object(__WEBPACK_IMPORTED_MODULE_7__instrumentation_xhr__["a" /* instrumentXHR */])(this);
        }
    };
    Notifier.prototype.notify = function (err) {
        var _this = this;
        if (this.offline) {
            return new __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__["a" /* default */](function (resolve, reject) {
                _this.todo.push({
                    err: err,
                    resolve: resolve,
                    reject: reject,
                });
                while (_this.todo.length > 100) {
                    var j = _this.todo.shift();
                    if (j === undefined) {
                        break;
                    }
                    j.resolve({
                        error: new Error('airbrake: offline queue is too large'),
                    });
                }
            });
        }
        return _super.prototype.notify.call(this, err);
    };
    Notifier.prototype.onOnline = function () {
        this.offline = false;
        var _loop_1 = function (j) {
            this_1.notify(j.err).then(function (notice) {
                j.resolve(notice);
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = this.todo; _i < _a.length; _i++) {
            var j = _a[_i];
            _loop_1(j);
        }
        this.todo = [];
    };
    Notifier.prototype.onOffline = function () {
        this.offline = true;
    };
    Notifier.prototype.onUnhandledrejection = function (e) {
        // Handle native or bluebird Promise rejections
        // https://developer.mozilla.org/en-US/docs/Web/Events/unhandledrejection
        // http://bluebirdjs.com/docs/api/error-management-configuration.html
        var reason = e.reason || (e.detail && e.detail.reason);
        if (!reason) {
            return;
        }
        var msg = reason.message || String(reason);
        if (msg.indexOf && msg.indexOf('airbrake: ') === 0) {
            return;
        }
        if (typeof reason !== 'object' || reason.error === undefined) {
            this.notify({
                error: reason,
                context: {
                    unhandledRejection: true,
                },
            });
            return;
        }
        this.notify(__assign(__assign({}, reason), { context: {
                unhandledRejection: true,
            } }));
    };
    Notifier.prototype.onerror = function (message, filename, line, column, err) {
        if (this._ignoreWindowError > 0) {
            return;
        }
        if (err) {
            this.notify({
                error: err,
                context: {
                    windowError: true,
                },
            });
            return;
        }
        // Ignore errors without file or line.
        if (!filename || !line) {
            return;
        }
        this.notify({
            error: {
                message: message,
                fileName: filename,
                lineNumber: line,
                columnNumber: column,
                noStack: true,
            },
            context: {
                windowError: true,
            },
        });
    };
    Notifier.prototype._ignoreNextWindowError = function () {
        var _this = this;
        this._ignoreWindowError++;
        setTimeout(function () { return _this._ignoreWindowError--; });
    };
    return Notifier;
}(__WEBPACK_IMPORTED_MODULE_1__base_notifier__["a" /* BaseNotifier */]));

function isDevEnv(env) {
    return env && env.startsWith && env.startsWith('dev');
}
function enabled(v) {
    return v === undefined || v === true;
}
//# sourceMappingURL=notifier.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(393);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(394)))

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (finallyConstructor);


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function allSettled(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(
        new TypeError(
          typeof arr +
            ' ' +
            arr +
            ' is not iterable(cannot read property Symbol(Symbol.iterator))'
        )
      );
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        var then = val.then;
        if (typeof then === 'function') {
          then.call(
            val,
            function(val) {
              res(i, val);
            },
            function(e) {
              args[i] = { status: 'rejected', reason: e };
              if (--remaining === 0) {
                resolve(args);
              }
            }
          );
          return;
        }
      }
      args[i] = { status: 'fulfilled', value: val };
      if (--remaining === 0) {
        resolve(args);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (allSettled);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @constructor
 */
function AggregateError(errors, message) {
  (this.name = 'AggregateError'), (this.errors = errors);
  this.message = message || '';
}
AggregateError.prototype = Error.prototype;

function any(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(new TypeError('Promise.any accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return reject();

    var rejectionReasons = [];
    for (var i = 0; i < args.length; i++) {
      try {
        P.resolve(args[i])
          .then(resolve)
          .catch(function(error) {
            rejectionReasons.push(error);
            if (rejectionReasons.length === args.length) {
              reject(
                new AggregateError(
                  rejectionReasons,
                  'All promises were rejected'
                )
              );
            }
          });
      } catch (ex) {
        reject(ex);
      }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (any);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsonifyNotice;
/* unused harmony export truncate */
var FILTERED = '[Filtered]';
var MAX_OBJ_LENGTH = 128;
// jsonifyNotice serializes notice to JSON and truncates params,
// environment and session keys.
function jsonifyNotice(notice, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.maxLength, maxLength = _c === void 0 ? 64000 : _c, _d = _b.keysBlocklist, keysBlocklist = _d === void 0 ? [] : _d;
    if (notice.errors) {
        for (var i = 0; i < notice.errors.length; i++) {
            var t = new Truncator({ keysBlocklist: keysBlocklist });
            notice.errors[i] = t.truncate(notice.errors[i]);
        }
    }
    var s = '';
    var keys = ['context', 'params', 'environment', 'session'];
    for (var level = 0; level < 8; level++) {
        var opts = { level: level, keysBlocklist: keysBlocklist };
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var obj = notice[key];
            if (obj) {
                notice[key] = truncate(obj, opts);
            }
        }
        s = JSON.stringify(notice);
        if (s.length < maxLength) {
            return s;
        }
    }
    var params = {
        json: s.slice(0, Math.floor(maxLength / 2)) + '...',
    };
    keys.push('errors');
    for (var _e = 0, keys_2 = keys; _e < keys_2.length; _e++) {
        var key = keys_2[_e];
        var obj = notice[key];
        if (!obj) {
            continue;
        }
        s = JSON.stringify(obj);
        params[key] = s.length;
    }
    var err = new Error("airbrake: notice exceeds max length and can't be truncated");
    err.params = params;
    throw err;
}
function scale(num, level) {
    return num >> level || 1;
}
var Truncator = /** @class */ (function () {
    function Truncator(opts) {
        this.maxStringLength = 1024;
        this.maxObjectLength = MAX_OBJ_LENGTH;
        this.maxArrayLength = MAX_OBJ_LENGTH;
        this.maxDepth = 8;
        this.keys = [];
        this.keysBlocklist = [];
        this.seen = [];
        var level = opts.level || 0;
        this.keysBlocklist = opts.keysBlocklist || [];
        this.maxStringLength = scale(this.maxStringLength, level);
        this.maxObjectLength = scale(this.maxObjectLength, level);
        this.maxArrayLength = scale(this.maxArrayLength, level);
        this.maxDepth = scale(this.maxDepth, level);
    }
    Truncator.prototype.truncate = function (value, key, depth) {
        if (key === void 0) { key = ''; }
        if (depth === void 0) { depth = 0; }
        if (value === null || value === undefined) {
            return value;
        }
        switch (typeof value) {
            case 'boolean':
            case 'number':
            case 'function':
                return value;
            case 'string':
                return this.truncateString(value);
            case 'object':
                break;
            default:
                return this.truncateString(String(value));
        }
        if (value instanceof String) {
            return this.truncateString(value.toString());
        }
        if (value instanceof Boolean ||
            value instanceof Number ||
            value instanceof Date ||
            value instanceof RegExp) {
            return value;
        }
        if (value instanceof Error) {
            return this.truncateString(value.toString());
        }
        if (this.seen.indexOf(value) >= 0) {
            return "[Circular " + this.getPath(value) + "]";
        }
        var type = objectType(value);
        depth++;
        if (depth > this.maxDepth) {
            return "[Truncated " + type + "]";
        }
        this.keys.push(key);
        this.seen.push(value);
        switch (type) {
            case 'Array':
                return this.truncateArray(value, depth);
            case 'Object':
                return this.truncateObject(value, depth);
            default:
                var saved = this.maxDepth;
                this.maxDepth = 0;
                var obj = this.truncateObject(value, depth);
                obj.__type = type;
                this.maxDepth = saved;
                return obj;
        }
    };
    Truncator.prototype.getPath = function (value) {
        var index = this.seen.indexOf(value);
        var path = [this.keys[index]];
        for (var i = index; i >= 0; i--) {
            var sub = this.seen[i];
            if (sub && getAttr(sub, path[0]) === value) {
                value = sub;
                path.unshift(this.keys[i]);
            }
        }
        return '~' + path.join('.');
    };
    Truncator.prototype.truncateString = function (s) {
        if (s.length > this.maxStringLength) {
            return s.slice(0, this.maxStringLength) + '...';
        }
        return s;
    };
    Truncator.prototype.truncateArray = function (arr, depth) {
        if (depth === void 0) { depth = 0; }
        var length = 0;
        var dst = [];
        for (var i = 0; i < arr.length; i++) {
            var el = arr[i];
            dst.push(this.truncate(el, i.toString(), depth));
            length++;
            if (length >= this.maxArrayLength) {
                break;
            }
        }
        return dst;
    };
    Truncator.prototype.truncateObject = function (obj, depth) {
        if (depth === void 0) { depth = 0; }
        var length = 0;
        var dst = {};
        for (var key in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                continue;
            }
            if (isBlocklisted(key, this.keysBlocklist)) {
                dst[key] = FILTERED;
                continue;
            }
            var value = getAttr(obj, key);
            if (value === undefined || typeof value === 'function') {
                continue;
            }
            dst[key] = this.truncate(value, key, depth);
            length++;
            if (length >= this.maxObjectLength) {
                break;
            }
        }
        return dst;
    };
    return Truncator;
}());
function truncate(value, opts) {
    if (opts === void 0) { opts = {}; }
    var t = new Truncator(opts);
    return t.truncate(value);
}
function getAttr(obj, attr) {
    // Ignore browser specific exception trying to read an attribute (#79).
    try {
        return obj[attr];
    }
    catch (_) {
        return;
    }
}
function objectType(obj) {
    var s = Object.prototype.toString.apply(obj);
    return s.slice('[object '.length, -1);
}
function isBlocklisted(key, keysBlocklist) {
    for (var _i = 0, keysBlocklist_1 = keysBlocklist; _i < keysBlocklist_1.length; _i++) {
        var v = keysBlocklist_1[_i];
        if (v === key) {
            return true;
        }
        if (v instanceof RegExp) {
            if (key.match(v)) {
                return true;
            }
        }
    }
    return false;
}
//# sourceMappingURL=jsonify_notice.js.map

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = espProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_error_stack_parser__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_error_stack_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_error_stack_parser__);

var hasConsole = typeof console === 'object' && console.warn;
function parse(err) {
    try {
        return __WEBPACK_IMPORTED_MODULE_0_error_stack_parser___default.a.parse(err);
    }
    catch (parseErr) {
        if (hasConsole && err.stack) {
            console.warn('ErrorStackParser:', parseErr.toString(), err.stack);
        }
    }
    if (err.fileName) {
        return [err];
    }
    return [];
}
function espProcessor(err) {
    var backtrace = [];
    if (err.noStack) {
        backtrace.push({
            function: err.functionName || '',
            file: err.fileName || '',
            line: err.lineNumber || 0,
            column: err.columnNumber || 0,
        });
    }
    else {
        var frames_2 = parse(err);
        if (frames_2.length === 0) {
            try {
                throw new Error('fake');
            }
            catch (fakeErr) {
                frames_2 = parse(fakeErr);
                frames_2.shift();
                frames_2.shift();
            }
        }
        for (var _i = 0, frames_1 = frames_2; _i < frames_1.length; _i++) {
            var frame = frames_1[_i];
            backtrace.push({
                function: frame.functionName || '',
                file: frame.fileName || '',
                line: frame.lineNumber || 0,
                column: frame.columnNumber || 0,
            });
        }
    }
    var type = err.name ? err.name : '';
    var msg = err.message ? String(err.message) : String(err);
    return {
        type: type,
        message: msg,
        backtrace: backtrace,
    };
}
//# sourceMappingURL=esp.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(401)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('stackframe'));
    } else {
        root.ErrorStackParser = factory(root.StackFrame);
    }
}(this, function ErrorStackParser(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;

    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                return this.parseOpera(error);
            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                return this.parseV8OrIE(error);
            } else if (error.stack) {
                return this.parseFFOrSafari(error);
            } else {
                throw new Error('Cannot parse given Error object');
            }
        },

        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) {
                return [urlLike];
            }

            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
            return [parts[1], parts[2] || undefined, parts[3] || undefined];
        },

        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);

            return filtered.map(function(line) {
                if (line.indexOf('(eval ') > -1) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(,.*$)/g, '');
                }
                var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').replace(/^.*?\s+/, '');

                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);

                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;

                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];

                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },

        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);

            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) {
                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                }

                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                    // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                } else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));

                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },

        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                return this.parseOpera9(e);
            } else if (!e.stack) {
                return this.parseOpera10(e);
            } else {
                return this.parseOpera11(e);
            }
        },

        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];

            for (var i = 2, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
            }

            return result;
        },

        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];

            for (var i = 0, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(
                        new StackFrame({
                            functionName: match[3] || undefined,
                            fileName: match[2],
                            lineNumber: match[1],
                            source: lines[i]
                        })
                    );
                }
            }

            return result;
        },

        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);

            return filtered.map(function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = (tokens.shift() || '');
                var functionName = functionCall
                    .replace(/<anonymous function(: (\w+))?>/, '$2')
                    .replace(/\([^)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) {
                    argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                }
                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                    undefined : argsRaw.split(',');

                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
}));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.StackFrame = factory();
    }
}(this, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }

    function _getter(p) {
        return function() {
            return this[p];
        };
    }

    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
    var numericProps = ['columnNumber', 'lineNumber'];
    var stringProps = ['fileName', 'functionName', 'source'];
    var arrayProps = ['args'];
    var objectProps = ['evalOrigin'];

    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);

    function StackFrame(obj) {
        if (!obj) return;
        for (var i = 0; i < props.length; i++) {
            if (obj[props[i]] !== undefined) {
                this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
    }

    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') {
                throw new TypeError('Args must be an Array');
            }
            this.args = v;
        },

        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) {
                this.evalOrigin = v;
            } else if (v instanceof Object) {
                this.evalOrigin = new StackFrame(v);
            } else {
                throw new TypeError('Eval Origin must be an Object or StackFrame');
            }
        },

        toString: function() {
            var fileName = this.getFileName() || '';
            var lineNumber = this.getLineNumber() || '';
            var columnNumber = this.getColumnNumber() || '';
            var functionName = this.getFunctionName() || '';
            if (this.getIsEval()) {
                if (fileName) {
                    return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                }
                return '[eval]:' + lineNumber + ':' + columnNumber;
            }
            if (functionName) {
                return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
            }
            return fileName + ':' + lineNumber + ':' + columnNumber;
        }
    };

    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf('(');
        var argsEndIndex = str.lastIndexOf(')');

        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
        var locationString = str.substring(argsEndIndex + 1);

        if (locationString.indexOf('@') === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }

        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };

    for (var i = 0; i < booleanProps.length; i++) {
        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        })(booleanProps[i]);
    }

    for (var j = 0; j < numericProps.length; j++) {
        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
            return function(v) {
                if (!_isNumber(v)) {
                    throw new TypeError(p + ' must be a Number');
                }
                this[p] = Number(v);
            };
        })(numericProps[j]);
    }

    for (var k = 0; k < stringProps.length; k++) {
        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
            return function(v) {
                this[p] = String(v);
            };
        })(stringProps[k]);
    }

    return StackFrame;
}));


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = angularMessageFilter;
var re = new RegExp([
    '^',
    '\\[(\\$.+)\\]',
    '\\s',
    '([\\s\\S]+)',
    '$',
].join(''));
function angularMessageFilter(notice) {
    var err = notice.errors[0];
    if (err.type !== '' && err.type !== 'Error') {
        return notice;
    }
    var m = err.message.match(re);
    if (m !== null) {
        err.type = m[1];
        err.message = m[2];
    }
    return notice;
}
//# sourceMappingURL=angular_message.js.map

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeDebounceFilter;
function makeDebounceFilter() {
    var lastNoticeJSON;
    var timeout;
    return function (notice) {
        var s = JSON.stringify(notice.errors);
        if (s === lastNoticeJSON) {
            return null;
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        lastNoticeJSON = s;
        timeout = setTimeout(function () {
            lastNoticeJSON = '';
        }, 1000);
        return notice;
    };
}
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ignoreNoiseFilter;
var IGNORED_MESSAGES = [
    'Script error',
    'Script error.',
    'InvalidAccessError',
];
function ignoreNoiseFilter(notice) {
    var err = notice.errors[0];
    if (err.type === '' && IGNORED_MESSAGES.indexOf(err.message) !== -1) {
        return null;
    }
    if (err.backtrace && err.backtrace.length > 0) {
        var frame = err.backtrace[0];
        if (frame.file === '<anonymous>') {
            return null;
        }
    }
    return notice;
}
//# sourceMappingURL=ignore_noise.js.map

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uncaughtMessageFilter;
var re = new RegExp([
    '^',
    'Uncaught\\s',
    '(.+?)',
    ':\\s',
    '(.+)',
    '$',
].join(''));
function uncaughtMessageFilter(notice) {
    var err = notice.errors[0];
    if (err.type !== '' && err.type !== 'Error') {
        return notice;
    }
    var m = err.message.match(re);
    if (m !== null) {
        err.type = m[1];
        err.message = m[2];
    }
    return notice;
}
//# sourceMappingURL=uncaught_message.js.map

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_fetch__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cross_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(200);



var rateLimitReset = 0;
function request(req) {
    var utime = Date.now() / 1000;
    if (utime < rateLimitReset) {
        return __WEBPACK_IMPORTED_MODULE_1_promise_polyfill__["a" /* default */].reject(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* errors */].ipRateLimited);
    }
    var opt = {
        method: req.method,
        body: req.body,
    };
    return __WEBPACK_IMPORTED_MODULE_0_cross_fetch___default()(req.url, opt).then(function (resp) {
        if (resp.status === 401) {
            throw __WEBPACK_IMPORTED_MODULE_2__api__["a" /* errors */].unauthorized;
        }
        if (resp.status === 429) {
            var s = resp.headers.get('X-RateLimit-Delay');
            if (!s) {
                throw __WEBPACK_IMPORTED_MODULE_2__api__["a" /* errors */].ipRateLimited;
            }
            var n = parseInt(s, 10);
            if (n > 0) {
                rateLimitReset = Date.now() / 1000 + n;
            }
            throw __WEBPACK_IMPORTED_MODULE_2__api__["a" /* errors */].ipRateLimited;
        }
        if (resp.status === 204) {
            return { json: null };
        }
        if (resp.status === 404) {
            throw new Error('404 Not Found');
        }
        if (resp.status >= 200 && resp.status < 300) {
            return resp.json().then(function (json) {
                return { json: json };
            });
        }
        if (resp.status >= 400 && resp.status < 500) {
            return resp.json().then(function (json) {
                var err = new Error(json.message);
                throw err;
            });
        }
        return resp.text().then(function (body) {
            var err = new Error("airbrake: fetch: unexpected response: code=" + resp.status + " body='" + body + "'");
            throw err;
        });
    });
}
//# sourceMappingURL=fetch.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRequester;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(200);


function makeRequester(api) {
    return function (req) {
        return request(req, api);
    };
}
var rateLimitReset = 0;
function request(req, api) {
    var utime = Date.now() / 1000;
    if (utime < rateLimitReset) {
        return __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__["a" /* default */].reject(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* errors */].ipRateLimited);
    }
    return new __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__["a" /* default */](function (resolve, reject) {
        api({
            url: req.url,
            method: req.method,
            body: req.body,
            headers: {
                'content-type': 'application/json',
            },
            timeout: req.timeout,
        }, function (error, resp, body) {
            if (error) {
                reject(error);
                return;
            }
            if (!resp.statusCode) {
                error = new Error("airbrake: request: response statusCode is " + resp.statusCode);
                reject(error);
                return;
            }
            if (resp.statusCode === 401) {
                reject(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* errors */].unauthorized);
                return;
            }
            if (resp.statusCode === 429) {
                reject(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* errors */].ipRateLimited);
                var h = resp.headers['x-ratelimit-delay'];
                if (!h) {
                    return;
                }
                var s = void 0;
                if (typeof h === 'string') {
                    s = h;
                }
                else if (h instanceof Array) {
                    s = h[0];
                }
                else {
                    return;
                }
                var n = parseInt(s, 10);
                if (n > 0) {
                    rateLimitReset = Date.now() / 1000 + n;
                }
                return;
            }
            if (resp.statusCode === 204) {
                resolve({ json: null });
                return;
            }
            if (resp.statusCode >= 200 && resp.statusCode < 300) {
                var json = void 0;
                try {
                    json = JSON.parse(body);
                }
                catch (err) {
                    reject(err);
                    return;
                }
                resolve(json);
                return;
            }
            if (resp.statusCode >= 400 && resp.statusCode < 500) {
                var json = void 0;
                try {
                    json = JSON.parse(body);
                }
                catch (err) {
                    reject(err);
                    return;
                }
                error = new Error(json.message);
                reject(error);
                return;
            }
            body = body.trim();
            error = new Error("airbrake: node: unexpected response: code=" + resp.statusCode + " body='" + body + "'");
            reject(error);
        });
    });
}
//# sourceMappingURL=node.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

//
// TDigest:
//
// approximate distribution percentiles from a stream of reals
//
var RBTree = __webpack_require__(410).RBTree;

function TDigest(delta, K, CX) {
    // allocate a TDigest structure.
    //
    // delta is the compression factor, the max fraction of mass that
    // can be owned by one centroid (bigger, up to 1.0, means more
    // compression). delta=false switches off TDigest behavior and treats
    // the distribution as discrete, with no merging and exact values
    // reported.
    //
    // K is a size threshold that triggers recompression as the TDigest
    // grows during input.  (Set it to 0 to disable automatic recompression)
    //
    // CX specifies how often to update cached cumulative totals used
    // for quantile estimation during ingest (see cumulate()).  Set to
    // 0 to use exact quantiles for each new point.
    //
    this.discrete = (delta === false);
    this.delta = delta || 0.01;
    this.K = (K === undefined) ? 25 : K;
    this.CX = (CX === undefined) ? 1.1 : CX;
    this.centroids = new RBTree(compare_centroid_means);
    this.nreset = 0;
    this.reset();
}

TDigest.prototype.reset = function() {
    // prepare to digest new points.
    //
    this.centroids.clear();
    this.n = 0;
    this.nreset += 1;
    this.last_cumulate = 0;
};

TDigest.prototype.size = function() {
    return this.centroids.size;
};

TDigest.prototype.toArray = function(everything) {
    // return {mean,n} of centroids as an array ordered by mean.
    //
    var result = [];
    if (everything) {
        this._cumulate(true); // be sure cumns are exact
        this.centroids.each(function(c) { result.push(c); });
    } else {
        this.centroids.each(function(c) { result.push({mean:c.mean, n:c.n}); });
    }
    return result;
};

TDigest.prototype.summary = function() {
    var approx = (this.discrete) ? "exact " : "approximating ";
    var s = [approx + this.n + " samples using " + this.size() + " centroids",
             "min = "+this.percentile(0),
             "Q1  = "+this.percentile(0.25),
             "Q2  = "+this.percentile(0.5),
             "Q3  = "+this.percentile(0.75),
             "max = "+this.percentile(1.0)];
    return s.join('\n');
};

function compare_centroid_means(a, b) {
    // order two centroids by mean.
    //
    return (a.mean > b.mean) ? 1 : (a.mean < b.mean) ? -1 : 0;
}

function compare_centroid_mean_cumns(a, b) {
    // order two centroids by mean_cumn.
    //
    return (a.mean_cumn - b.mean_cumn);
}

TDigest.prototype.push = function(x, n) {
    // incorporate value or array of values x, having count n into the
    // TDigest. n defaults to 1.
    //
    n = n || 1;
    x = Array.isArray(x) ? x : [x];
    for (var i = 0 ; i < x.length ; i++) {
        this._digest(x[i], n);
    }
};

TDigest.prototype.push_centroid = function(c) {
    // incorporate centroid or array of centroids c
    //
    c = Array.isArray(c) ? c : [c];
    for (var i = 0 ; i < c.length ; i++) {
        this._digest(c[i].mean, c[i].n);
    }
};

TDigest.prototype._cumulate = function(exact) {
    // update cumulative counts for each centroid
    //
    // exact: falsey means only cumulate after sufficient
    // growth. During ingest, these counts are used as quantile
    // estimates, and they work well even when somewhat out of
    // date. (this is a departure from the publication, you may set CX
    // to 0 to disable).
    //
    if (this.n === this.last_cumulate ||
        !exact && this.CX && this.CX > (this.n / this.last_cumulate)) {
        return;
    }
    var cumn = 0;
    this.centroids.each(function(c) {
        c.mean_cumn = cumn + c.n / 2; // half of n at the mean
        cumn = c.cumn = cumn + c.n;
    });
    this.n = this.last_cumulate = cumn;
};

TDigest.prototype.find_nearest = function(x) {
    // find the centroid closest to x. The assumption of
    // unique means and a unique nearest centroid departs from the
    // paper, see _digest() below
    //
    if (this.size() === 0) {
        return null;
    }
    var iter = this.centroids.lowerBound({mean:x}); // x <= iter || iter==null
    var c = (iter.data() === null) ? iter.prev() : iter.data();
    if (c.mean === x || this.discrete) {
        return c; // c is either x or a neighbor (discrete: no distance func)
    }
    var prev = iter.prev();
    if (prev && Math.abs(prev.mean - x) < Math.abs(c.mean - x)) {
        return prev;
    } else {
        return c;
    }
};

TDigest.prototype._new_centroid = function(x, n, cumn) {
    // create and insert a new centroid into the digest (don't update
    // cumulatives).
    //
    var c = {mean:x, n:n, cumn:cumn};
    this.centroids.insert(c);
    this.n += n;
    return c;
};

TDigest.prototype._addweight = function(nearest, x, n) {
    // add weight at location x to nearest centroid.  adding x to
    // nearest will not shift its relative position in the tree and
    // require reinsertion.
    //
    if (x !== nearest.mean) {
        nearest.mean += n * (x - nearest.mean) / (nearest.n + n);
    }
    nearest.cumn += n;
    nearest.mean_cumn += n / 2;
    nearest.n += n;
    this.n += n;
};

TDigest.prototype._digest = function(x, n) {
    // incorporate value x, having count n into the TDigest.
    //
    var min = this.centroids.min();
    var max = this.centroids.max();
    var nearest = this.find_nearest(x);
    if (nearest && nearest.mean === x) {
        // accumulate exact matches into the centroid without
        // limit. this is a departure from the paper, made so
        // centroids remain unique and code can be simple.
        this._addweight(nearest, x, n);
    } else if (nearest === min) {
        this._new_centroid(x, n, 0); // new point around min boundary
    } else if (nearest === max ) {
        this._new_centroid(x, n, this.n); // new point around max boundary
    } else if (this.discrete) {
        this._new_centroid(x, n, nearest.cumn); // never merge
    } else {
        // conider a merge based on nearest centroid's capacity. if
        // there's not room for all of n, don't bother merging any of
        // it into nearest, as we'll have to make a new centroid
        // anyway for the remainder (departure from the paper).
        var p = nearest.mean_cumn / this.n;
        var max_n = Math.floor(4 * this.n * this.delta * p * (1 - p));
        if (max_n - nearest.n >= n) {
            this._addweight(nearest, x, n);
        } else {
            this._new_centroid(x, n, nearest.cumn);
        }
    }
    this._cumulate(false);
    if (!this.discrete && this.K && this.size() > this.K / this.delta) {
        // re-process the centroids and hope for some compression.
        this.compress();
    }
};

TDigest.prototype.bound_mean = function(x) {
    // find centroids lower and upper such that lower.mean < x <
    // upper.mean or lower.mean === x === upper.mean. Don't call
    // this for x out of bounds.
    //
    var iter = this.centroids.upperBound({mean:x}); // x < iter
    var lower = iter.prev();      // lower <= x
    var upper = (lower.mean === x) ? lower : iter.next();
    return [lower, upper];
};

TDigest.prototype.p_rank = function(x_or_xlist) {
    // return approximate percentile-ranks (0..1) for data value x.
    // or list of x.  calculated according to
    // https://en.wikipedia.org/wiki/Percentile_rank
    //
    // (Note that in continuous mode, boundary sample values will
    // report half their centroid weight inward from 0/1 as the
    // percentile-rank. X values outside the observed range return
    // 0/1)
    //
    // this triggers cumulate() if cumn's are out of date.
    //
    var xs = Array.isArray(x_or_xlist) ? x_or_xlist : [x_or_xlist];
    var ps = xs.map(this._p_rank, this);
    return Array.isArray(x_or_xlist) ? ps : ps[0];
};

TDigest.prototype._p_rank = function(x) {
    if (this.size() === 0) {
        return undefined;
    } else if (x < this.centroids.min().mean) {
        return 0.0;
    } else if (x > this.centroids.max().mean) {
        return 1.0;
    }
    // find centroids that bracket x and interpolate x's cumn from
    // their cumn's.
    this._cumulate(true); // be sure cumns are exact
    var bound = this.bound_mean(x);
    var lower = bound[0], upper = bound[1];
    if (this.discrete) {
        return lower.cumn / this.n;
    } else {
        var cumn = lower.mean_cumn;
        if (lower !== upper) {
            cumn += (x - lower.mean) * (upper.mean_cumn - lower.mean_cumn) / (upper.mean - lower.mean);
        }
        return cumn / this.n;
    }
};

TDigest.prototype.bound_mean_cumn = function(cumn) {
    // find centroids lower and upper such that lower.mean_cumn < x <
    // upper.mean_cumn or lower.mean_cumn === x === upper.mean_cumn. Don't call
    // this for cumn out of bounds.
    //
    // XXX because mean and mean_cumn give rise to the same sort order
    // (up to identical means), use the mean rbtree for our search.
    this.centroids._comparator = compare_centroid_mean_cumns;
    var iter = this.centroids.upperBound({mean_cumn:cumn}); // cumn < iter
    this.centroids._comparator = compare_centroid_means;
    var lower = iter.prev();      // lower <= cumn
    var upper = (lower && lower.mean_cumn === cumn) ? lower : iter.next();
    return [lower, upper];
};

TDigest.prototype.percentile = function(p_or_plist) {
    // for percentage p (0..1), or for each p in a list of ps, return
    // the smallest data value q at which at least p percent of the
    // observations <= q.
    //
    // for discrete distributions, this selects q using the Nearest
    // Rank Method
    // (https://en.wikipedia.org/wiki/Percentile#The_Nearest_Rank_method)
    // (in scipy, same as percentile(...., interpolation='higher')
    //
    // for continuous distributions, interpolates data values between
    // count-weighted bracketing means.
    //
    // this triggers cumulate() if cumn's are out of date.
    //
    var ps = Array.isArray(p_or_plist) ? p_or_plist : [p_or_plist];
    var qs = ps.map(this._percentile, this);
    return Array.isArray(p_or_plist) ? qs : qs[0];
};

TDigest.prototype._percentile = function(p) {
    if (this.size() === 0) {
        return undefined;
    }
    this._cumulate(true); // be sure cumns are exact
    var h = this.n * p;
    var bound = this.bound_mean_cumn(h);
    var lower = bound[0], upper = bound[1];

    if (upper === lower || lower === null || upper === null) {
        return (lower || upper).mean;
    } else if (!this.discrete) {
        return lower.mean + (h - lower.mean_cumn) * (upper.mean - lower.mean) / (upper.mean_cumn - lower.mean_cumn);
    } else if (h <= lower.cumn) {
        return lower.mean;
    } else {
        return upper.mean;
    }
};

function pop_random(choices) {
    // remove and return an item randomly chosen from the array of choices
    // (mutates choices)
    //
    var idx = Math.floor(Math.random() * choices.length);
    return choices.splice(idx, 1)[0];
}

TDigest.prototype.compress = function() {
    // TDigests experience worst case compression (none) when input
    // increases monotonically.  Improve on any bad luck by
    // reconsuming digest centroids as if they were weighted points
    // while shuffling their order (and hope for the best).
    //
    if (this.compressing) {
        return;
    }
    var points = this.toArray();
    this.reset();
    this.compressing = true;
    while (points.length > 0) {
        this.push_centroid(pop_random(points));
    }
    this._cumulate(true);
    this.compressing = false;
};

function Digest(config) {
    // allocate a distribution digest structure. This is an extension
    // of a TDigest structure that starts in exact histogram (discrete)
    // mode, and automatically switches to TDigest mode for large
    // samples that appear to be from a continuous distribution.
    //
    this.config = config || {};
    this.mode = this.config.mode || 'auto'; // disc, cont, auto
    TDigest.call(this, this.mode === 'cont' ? config.delta : false);
    this.digest_ratio = this.config.ratio || 0.9;
    this.digest_thresh = this.config.thresh || 1000;
    this.n_unique = 0;
}
Digest.prototype = Object.create(TDigest.prototype);
Digest.prototype.constructor = Digest;

Digest.prototype.push = function(x_or_xlist) {
    TDigest.prototype.push.call(this, x_or_xlist);
    this.check_continuous();
};

Digest.prototype._new_centroid = function(x, n, cumn) {
    this.n_unique += 1;
    TDigest.prototype._new_centroid.call(this, x, n, cumn);
};

Digest.prototype._addweight = function(nearest, x, n) {
    if (nearest.n === 1) {
        this.n_unique -= 1;
    }
    TDigest.prototype._addweight.call(this, nearest, x, n);
};

Digest.prototype.check_continuous = function() {
    // while in 'auto' mode, if there are many unique elements, assume
    // they are from a continuous distribution and switch to 'cont'
    // mode (tdigest behavior). Return true on transition from
    // disctete to continuous.
    if (this.mode !== 'auto' || this.size() < this.digest_thresh) {
        return false;
    }
    if (this.n_unique / this.size() > this.digest_ratio) {
        this.mode = 'cont';
        this.discrete = false;
        this.delta = this.config.delta || 0.01;
        this.compress();
        return true;
    }
    return false;
};

module.exports = {
    'TDigest': TDigest,
    'Digest': Digest
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    RBTree: __webpack_require__(411),
    BinTree: __webpack_require__(412)
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


var TreeBase = __webpack_require__(202);

function Node(data) {
    this.data = data;
    this.left = null;
    this.right = null;
    this.red = true;
}

Node.prototype.get_child = function(dir) {
    return dir ? this.right : this.left;
};

Node.prototype.set_child = function(dir, val) {
    if(dir) {
        this.right = val;
    }
    else {
        this.left = val;
    }
};

function RBTree(comparator) {
    this._root = null;
    this._comparator = comparator;
    this.size = 0;
}

RBTree.prototype = new TreeBase();

// returns true if inserted, false if duplicate
RBTree.prototype.insert = function(data) {
    var ret = false;

    if(this._root === null) {
        // empty tree
        this._root = new Node(data);
        ret = true;
        this.size++;
    }
    else {
        var head = new Node(undefined); // fake tree root

        var dir = 0;
        var last = 0;

        // setup
        var gp = null; // grandparent
        var ggp = head; // grand-grand-parent
        var p = null; // parent
        var node = this._root;
        ggp.right = this._root;

        // search down
        while(true) {
            if(node === null) {
                // insert new node at the bottom
                node = new Node(data);
                p.set_child(dir, node);
                ret = true;
                this.size++;
            }
            else if(is_red(node.left) && is_red(node.right)) {
                // color flip
                node.red = true;
                node.left.red = false;
                node.right.red = false;
            }

            // fix red violation
            if(is_red(node) && is_red(p)) {
                var dir2 = ggp.right === gp;

                if(node === p.get_child(last)) {
                    ggp.set_child(dir2, single_rotate(gp, !last));
                }
                else {
                    ggp.set_child(dir2, double_rotate(gp, !last));
                }
            }

            var cmp = this._comparator(node.data, data);

            // stop if found
            if(cmp === 0) {
                break;
            }

            last = dir;
            dir = cmp < 0;

            // update helpers
            if(gp !== null) {
                ggp = gp;
            }
            gp = p;
            p = node;
            node = node.get_child(dir);
        }

        // update root
        this._root = head.right;
    }

    // make root black
    this._root.red = false;

    return ret;
};

// returns true if removed, false if not found
RBTree.prototype.remove = function(data) {
    if(this._root === null) {
        return false;
    }

    var head = new Node(undefined); // fake tree root
    var node = head;
    node.right = this._root;
    var p = null; // parent
    var gp = null; // grand parent
    var found = null; // found item
    var dir = 1;

    while(node.get_child(dir) !== null) {
        var last = dir;

        // update helpers
        gp = p;
        p = node;
        node = node.get_child(dir);

        var cmp = this._comparator(data, node.data);

        dir = cmp > 0;

        // save found node
        if(cmp === 0) {
            found = node;
        }

        // push the red node down
        if(!is_red(node) && !is_red(node.get_child(dir))) {
            if(is_red(node.get_child(!dir))) {
                var sr = single_rotate(node, dir);
                p.set_child(last, sr);
                p = sr;
            }
            else if(!is_red(node.get_child(!dir))) {
                var sibling = p.get_child(!last);
                if(sibling !== null) {
                    if(!is_red(sibling.get_child(!last)) && !is_red(sibling.get_child(last))) {
                        // color flip
                        p.red = false;
                        sibling.red = true;
                        node.red = true;
                    }
                    else {
                        var dir2 = gp.right === p;

                        if(is_red(sibling.get_child(last))) {
                            gp.set_child(dir2, double_rotate(p, last));
                        }
                        else if(is_red(sibling.get_child(!last))) {
                            gp.set_child(dir2, single_rotate(p, last));
                        }

                        // ensure correct coloring
                        var gpc = gp.get_child(dir2);
                        gpc.red = true;
                        node.red = true;
                        gpc.left.red = false;
                        gpc.right.red = false;
                    }
                }
            }
        }
    }

    // replace and remove if found
    if(found !== null) {
        found.data = node.data;
        p.set_child(p.right === node, node.get_child(node.left === null));
        this.size--;
    }

    // update root and make it black
    this._root = head.right;
    if(this._root !== null) {
        this._root.red = false;
    }

    return found !== null;
};

function is_red(node) {
    return node !== null && node.red;
}

function single_rotate(root, dir) {
    var save = root.get_child(!dir);

    root.set_child(!dir, save.get_child(dir));
    save.set_child(dir, root);

    root.red = true;
    save.red = false;

    return save;
}

function double_rotate(root, dir) {
    root.set_child(!dir, single_rotate(root.get_child(!dir), !dir));
    return single_rotate(root, dir);
}

module.exports = RBTree;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


var TreeBase = __webpack_require__(202);

function Node(data) {
    this.data = data;
    this.left = null;
    this.right = null;
}

Node.prototype.get_child = function(dir) {
    return dir ? this.right : this.left;
};

Node.prototype.set_child = function(dir, val) {
    if(dir) {
        this.right = val;
    }
    else {
        this.left = val;
    }
};

function BinTree(comparator) {
    this._root = null;
    this._comparator = comparator;
    this.size = 0;
}

BinTree.prototype = new TreeBase();

// returns true if inserted, false if duplicate
BinTree.prototype.insert = function(data) {
    if(this._root === null) {
        // empty tree
        this._root = new Node(data);
        this.size++;
        return true;
    }

    var dir = 0;

    // setup
    var p = null; // parent
    var node = this._root;

    // search down
    while(true) {
        if(node === null) {
            // insert new node at the bottom
            node = new Node(data);
            p.set_child(dir, node);
            ret = true;
            this.size++;
            return true;
        }

        // stop if found
        if(this._comparator(node.data, data) === 0) {
            return false;
        }

        dir = this._comparator(node.data, data) < 0;

        // update helpers
        p = node;
        node = node.get_child(dir);
    }
};

// returns true if removed, false if not found
BinTree.prototype.remove = function(data) {
    if(this._root === null) {
        return false;
    }

    var head = new Node(undefined); // fake tree root
    var node = head;
    node.right = this._root;
    var p = null; // parent
    var found = null; // found item
    var dir = 1;

    while(node.get_child(dir) !== null) {
        p = node;
        node = node.get_child(dir);
        var cmp = this._comparator(data, node.data);
        dir = cmp > 0;

        if(cmp === 0) {
            found = node;
        }
    }

    if(found !== null) {
        found.data = node.data;
        p.set_child(p.right === node, node.get_child(node.left === null));

        this._root = head.right;
        this.size--;
        return true;
    }
    else {
        return false;
    }
};

module.exports = BinTree;



/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QueuesStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_req__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metrics__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tdshared__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var FLUSH_INTERVAL = 15000; // 15 seconds
var QueueMetric = /** @class */ (function (_super) {
    __extends(QueueMetric, _super);
    function QueueMetric(queue) {
        var _this = _super.call(this) || this;
        _this.queue = queue;
        _this.startTime = new Date();
        return _this;
    }
    return QueueMetric;
}(__WEBPACK_IMPORTED_MODULE_1__metrics__["a" /* BaseMetric */]));

var QueuesStats = /** @class */ (function () {
    function QueuesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/queues-stats?key=" + opt.projectKey;
        this._requester = Object(__WEBPACK_IMPORTED_MODULE_0__http_req__["a" /* makeRequester */])(opt);
    }
    QueuesStats.prototype.notify = function (q) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_2__tdshared__["c" /* hasTdigest */]) {
            return;
        }
        var ms = q._duration();
        if (ms === 0) {
            ms = 0.00001;
        }
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
        var key = {
            queue: q.queue,
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new __WEBPACK_IMPORTED_MODULE_2__tdshared__["b" /* TDigestStatGroups */]();
            this._m[keyStr] = stat;
        }
        stat.addGroups(ms, q._groups);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    QueuesStats.prototype._flush = function () {
        var queues = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            queues.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            queues: queues,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report queues breakdowns', err);
            }
        });
    };
    return QueuesStats;
}());

//# sourceMappingURL=queues.js.map

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouteMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RoutesStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RoutesBreakdowns; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_req__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metrics__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tdshared__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var FLUSH_INTERVAL = 15000; // 15 seconds
var RouteMetric = /** @class */ (function (_super) {
    __extends(RouteMetric, _super);
    function RouteMetric(method, route, statusCode, contentType) {
        if (method === void 0) { method = ''; }
        if (route === void 0) { route = ''; }
        if (statusCode === void 0) { statusCode = 0; }
        if (contentType === void 0) { contentType = ''; }
        var _this = _super.call(this) || this;
        _this.method = method;
        _this.route = route;
        _this.statusCode = statusCode;
        _this.contentType = contentType;
        _this.startTime = new Date();
        return _this;
    }
    return RouteMetric;
}(__WEBPACK_IMPORTED_MODULE_1__metrics__["a" /* BaseMetric */]));

var RoutesStats = /** @class */ (function () {
    function RoutesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/routes-stats?key=" + opt.projectKey;
        this._requester = Object(__WEBPACK_IMPORTED_MODULE_0__http_req__["a" /* makeRequester */])(opt);
    }
    RoutesStats.prototype.notify = function (req) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_2__tdshared__["c" /* hasTdigest */]) {
            return;
        }
        var ms = req._duration();
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
        var key = {
            method: req.method,
            route: req.route,
            statusCode: req.statusCode,
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new __WEBPACK_IMPORTED_MODULE_2__tdshared__["a" /* TDigestStat */]();
            this._m[keyStr] = stat;
        }
        stat.add(ms);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    RoutesStats.prototype._flush = function () {
        var routes = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            routes.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            routes: routes,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report routes stats', err);
            }
        });
    };
    return RoutesStats;
}());

var RoutesBreakdowns = /** @class */ (function () {
    function RoutesBreakdowns(opt) {
        this._m = {};
        this._opt = opt;
        this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/routes-breakdowns?key=" + opt.projectKey;
        this._requester = Object(__WEBPACK_IMPORTED_MODULE_0__http_req__["a" /* makeRequester */])(opt);
    }
    RoutesBreakdowns.prototype.notify = function (req) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_2__tdshared__["c" /* hasTdigest */]) {
            return;
        }
        if (req.statusCode < 200 ||
            (req.statusCode >= 300 && req.statusCode < 400) ||
            req.statusCode === 404 ||
            Object.keys(req._groups).length === 0) {
            return;
        }
        var ms = req._duration();
        if (ms === 0) {
            ms = 0.00001;
        }
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
        var key = {
            method: req.method,
            route: req.route,
            responseType: this._responseType(req),
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new __WEBPACK_IMPORTED_MODULE_2__tdshared__["b" /* TDigestStatGroups */]();
            this._m[keyStr] = stat;
        }
        stat.addGroups(ms, req._groups);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    RoutesBreakdowns.prototype._flush = function () {
        var routes = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            routes.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            routes: routes,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report routes breakdowns', err);
            }
        });
    };
    RoutesBreakdowns.prototype._responseType = function (req) {
        if (req.statusCode >= 500) {
            return '5xx';
        }
        if (req.statusCode >= 400) {
            return '4xx';
        }
        if (!req.contentType) {
            return '';
        }
        return req.contentType.split(';')[0].split('/')[-1];
    };
    return RoutesBreakdowns;
}());

//# sourceMappingURL=routes.js.map

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFIER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFIER_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFIER_URL; });
var NOTIFIER_NAME = 'airbrake-js/browser';
var NOTIFIER_VERSION = '1.4.2';
var NOTIFIER_URL = 'https://github.com/airbrake/airbrake-js/tree/master/packages/browser';
//# sourceMappingURL=version.js.map

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windowFilter;
function windowFilter(notice) {
    if (window.navigator && window.navigator.userAgent) {
        notice.context.userAgent = window.navigator.userAgent;
    }
    if (window.location) {
        notice.context.url = String(window.location);
        // Set root directory to group errors on different subdomains together.
        notice.context.rootDirectory =
            window.location.protocol + '//' + window.location.host;
    }
    return notice;
}
//# sourceMappingURL=window.js.map

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instrumentConsole;
var CONSOLE_METHODS = ['debug', 'log', 'info', 'warn', 'error'];
function instrumentConsole(notifier) {
    var _loop_1 = function (m) {
        if (!(m in console)) {
            return "continue";
        }
        var oldFn = console[m];
        var newFn = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            oldFn.apply(console, args);
            notifier.scope().pushHistory({
                type: 'log',
                severity: m,
                arguments: args,
            });
        });
        newFn.inner = oldFn;
        console[m] = newFn;
    };
    // tslint:disable-next-line:no-this-assignment
    for (var _i = 0, CONSOLE_METHODS_1 = CONSOLE_METHODS; _i < CONSOLE_METHODS_1.length; _i++) {
        var m = CONSOLE_METHODS_1[_i];
        _loop_1(m);
    }
}
//# sourceMappingURL=console.js.map

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instrumentDOM;
var elemAttrs = ['type', 'name', 'src'];
function instrumentDOM(notifier) {
    var handler = makeEventHandler(notifier);
    if (window.addEventListener) {
        window.addEventListener('load', handler);
        window.addEventListener('error', function (event) {
            if (getProp(event, 'error')) {
                return;
            }
            handler(event);
        }, true);
    }
    if (typeof document === 'object' && document.addEventListener) {
        document.addEventListener('DOMContentLoaded', handler);
        document.addEventListener('click', handler);
        document.addEventListener('keypress', handler);
    }
}
function makeEventHandler(notifier) {
    return function (event) {
        var target = getProp(event, 'target');
        if (!target) {
            return;
        }
        var state = { type: event.type };
        try {
            state.target = elemPath(target);
        }
        catch (err) {
            state.target = "<" + String(err) + ">";
        }
        notifier.scope().pushHistory(state);
    };
}
function elemName(elem) {
    if (!elem) {
        return '';
    }
    var s = [];
    if (elem.tagName) {
        s.push(elem.tagName.toLowerCase());
    }
    if (elem.id) {
        s.push('#');
        s.push(elem.id);
    }
    if (elem.classList && Array.from) {
        s.push('.');
        s.push(Array.from(elem.classList).join('.'));
    }
    else if (elem.className) {
        var str = classNameString(elem.className);
        if (str !== '') {
            s.push('.');
            s.push(str);
        }
    }
    if (elem.getAttribute) {
        for (var _i = 0, elemAttrs_1 = elemAttrs; _i < elemAttrs_1.length; _i++) {
            var attr = elemAttrs_1[_i];
            var value = elem.getAttribute(attr);
            if (value) {
                s.push("[" + attr + "=\"" + value + "\"]");
            }
        }
    }
    return s.join('');
}
function classNameString(name) {
    if (name.split) {
        return name.split(' ').join('.');
    }
    if (name.baseVal && name.baseVal.split) {
        // SVGAnimatedString
        return name.baseVal.split(' ').join('.');
    }
    console.error('unsupported HTMLElement.className type', typeof name);
    return '';
}
function elemPath(elem) {
    var maxLen = 10;
    var path = [];
    var parent = elem;
    while (parent) {
        var name_1 = elemName(parent);
        if (name_1 !== '') {
            path.push(name_1);
            if (path.length > maxLen) {
                break;
            }
        }
        parent = parent.parentNode;
    }
    if (path.length === 0) {
        return String(elem);
    }
    return path.reverse().join(' > ');
}
function getProp(obj, prop) {
    try {
        return obj[prop];
    }
    catch (_) {
        // Permission denied to access property
        return null;
    }
}
//# sourceMappingURL=dom.js.map

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instrumentFetch;
function instrumentFetch(notifier) {
    // tslint:disable-next-line:no-this-assignment
    var oldFetch = window.fetch;
    window.fetch = function (req, options) {
        var state = {
            type: 'xhr',
            date: new Date(),
        };
        state.method = options && options.method ? options.method : 'GET';
        if (typeof req === 'string') {
            state.url = req;
        }
        else {
            state.method = req.method;
            state.url = req.url;
        }
        // Some platforms (e.g. react-native) implement fetch via XHR.
        notifier._ignoreNextXHR++;
        setTimeout(function () { return notifier._ignoreNextXHR--; });
        return oldFetch
            .apply(this, arguments)
            .then(function (resp) {
            state.statusCode = resp.status;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
            return resp;
        })
            .catch(function (err) {
            state.error = err;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
            throw err;
        });
    };
}
//# sourceMappingURL=fetch.js.map

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instrumentLocation;
var lastLocation = '';
// In some environments (i.e. Cypress) document.location may sometimes be null
function getCurrentLocation() {
    return document.location && document.location.pathname;
}
function instrumentLocation(notifier) {
    lastLocation = getCurrentLocation();
    var oldFn = window.onpopstate;
    window.onpopstate = function abOnpopstate(_event) {
        var url = getCurrentLocation();
        if (url) {
            recordLocation(notifier, url);
        }
        if (oldFn) {
            return oldFn.apply(this, arguments);
        }
    };
    var oldPushState = history.pushState;
    history.pushState = function abPushState(_state, _title, url) {
        if (url) {
            recordLocation(notifier, url.toString());
        }
        oldPushState.apply(this, arguments);
    };
}
function recordLocation(notifier, url) {
    var index = url.indexOf('://');
    if (index >= 0) {
        url = url.slice(index + 3);
        index = url.indexOf('/');
        url = index >= 0 ? url.slice(index) : '/';
    }
    else if (url.charAt(0) !== '/') {
        url = '/' + url;
    }
    notifier.scope().pushHistory({
        type: 'location',
        from: lastLocation,
        to: url,
    });
    lastLocation = url;
}
//# sourceMappingURL=location.js.map

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instrumentXHR;
function instrumentXHR(notifier) {
    function recordReq(req) {
        var state = req.__state;
        state.statusCode = req.status;
        state.duration = new Date().getTime() - state.date.getTime();
        notifier.scope().pushHistory(state);
    }
    var oldOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function abOpen(method, url, _async, _user, _password) {
        if (notifier._ignoreNextXHR === 0) {
            this.__state = {
                type: 'xhr',
                method: method,
                url: url,
            };
        }
        oldOpen.apply(this, arguments);
    };
    var oldSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function abSend(_data) {
        var oldFn = this.onreadystatechange;
        this.onreadystatechange = function (_ev) {
            if (this.readyState === 4 && this.__state) {
                recordReq(this);
            }
            if (oldFn) {
                return oldFn.apply(this, arguments);
            }
        };
        if (this.__state) {
            this.__state.date = new Date();
        }
        return oldSend.apply(this, arguments);
    };
}
//# sourceMappingURL=xhr.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingErrorReporting.$inject = ['$window', '$injector', 'HoldingEnvironment', 'HoldingAppVersionValue', 'HoldingConfig'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(197);

exports.default = angular.module('app.error-reporting').factory('HoldingErrorReporting', HoldingErrorReporting).name;


function HoldingErrorReporting($window, $injector, HoldingEnvironment, HoldingAppVersionValue, HoldingConfig) {
  'ngInject';

  var airbrake = new _browser.Notifier({
    projectId: HoldingConfig.airbrake.id,
    projectKey: HoldingConfig.airbrake.key,
    environment: HoldingEnvironment.env
  });

  return {
    constructErrorFromApi: constructErrorFromApi,
    report: report
  };

  function constructErrorFromApi(error) {
    return {
      type: error && 'status' in error ? error.status : 999,
      message: error && 'data' in error && error.data && 'message' in error.data ? error.data.message : 'No error message'
    };
  }

  function report(error, cause) {
    if (HoldingConfig.settings.errorReporting.enabled) {
      var user = $injector.get('HoldingUser');

      airbrake.addFilter(function (notice) {
        notice.context.environment = HoldingEnvironment.env;
        notice.context.version = HoldingAppVersionValue;
        return notice;
      });

      airbrake.notify({
        error: error,
        params: {
          angular_cause: cause
        },
        session: user.get()
      });
    }
  }
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting', []).name;


__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatAmount.$inject = ['HoldingCurrencies', '$filter'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('gmwFormatAmount', gmwFormatAmount).name;


function gmwFormatAmount(HoldingCurrencies, $filter) {
  'ngInject';

  return formatFiat;

  function formatFiat(input, decimals) {
    if (!input) {
      return input;
    }
    var isMetal = HoldingCurrencies.isCurrencyCodeMetal(input.currency);
    var filter = isMetal ? 'gmwFormatProduct' : 'holdingFormatFunds';
    return $filter(filter)(input, decimals);
  }
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatBalance.$inject = ['HoldingCurrencies', 'HoldingFormatting'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('gmwFormatBalance', gmwFormatBalance).name;


function gmwFormatBalance(HoldingCurrencies, HoldingFormatting) {
  'ngInject';

  return formatFiat;

  function formatFiat(input) {
    var useSymbolForMetal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!input) {
      return input;
    }

    var currency = HoldingCurrencies.getCurrencyByCode(input.currency);
    var isMetal = HoldingCurrencies.isCurrencyCodeMetal(input.currency);

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(input.amount, currency.decimals),
        formatted = _HoldingFormatting$fo.formatted;

    var symbol = isMetal && useSymbolForMetal ? currency.symbol : '';
    return '' + formatted + symbol;
  }
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.formatting').filter('gmwFormatDate', gmwFormatDate).name;


function gmwFormatDate() {
  'ngInject';

  return formatDate;

  function formatDate(input) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MMM-DD';

    return (0, _moment2.default)(input).format(format);
  }
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.formatting').filter('gmwFormatDateTime', gmwFormatDateTime).name;


function gmwFormatDateTime() {
  'ngInject';

  return formatDateTime;

  function formatDateTime(input) {
    if (!input) {
      return input;
    }

    return (0, _moment2.default)(input).format('YYYY-MMM-DD HH:mm:ss');
  }
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatNumber.$inject = ['HoldingFormatting'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('gmwFormatNumber', gmwFormatNumber).name;


function gmwFormatNumber(HoldingFormatting) {
  'ngInject';

  return formatFiat;

  function formatFiat(input) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(input, decimals),
        sign = _HoldingFormatting$fo.sign,
        formatted = _HoldingFormatting$fo.formatted;

    return '' + (sign ? sign + ' ' : '') + formatted;
  }
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('holdingFormatPercentage', holdingFormatPercentage).name;


function holdingFormatPercentage() {
  'ngInject';

  return formatPercentage;

  function formatPercentage(input) {
    var hasSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var number = parseFloat(input);
    if (isNaN(number)) {
      return '';
    }

    var sign = '';
    if (hasSign) {
      sign = number > 0 ? '+' : '';
    }
    return '' + sign + number.toFixed(2) + '%';
  }
}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatProduct.$inject = ['HoldingCurrencies', 'HoldingFormatting', 'HoldingTroyRate'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('gmwFormatProduct', gmwFormatProduct).name;


function gmwFormatProduct(HoldingCurrencies, HoldingFormatting, HoldingTroyRate) {
  'ngInject';

  return formatProduct;

  function formatProduct(input) {
    var weightUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var capitalize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!input) {
      return input;
    }

    var currency = HoldingCurrencies.getCurrencyByCode(input.currency);

    var amount = void 0;
    var displayUnit = void 0;
    if (weightUnit === 'oz' && currency.weightUnit === 'GRAMS') {
      amount = input.amount / HoldingTroyRate;
      displayUnit = weightUnit;
    } else if (weightUnit === 'g' && currency.weightUnit === 'OUNCES') {
      amount = input.amount * HoldingTroyRate;
      displayUnit = weightUnit;
    } else {
      amount = input.amount;
      displayUnit = currency.symbol;
    }

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(amount, currency.decimals),
        sign = _HoldingFormatting$fo.sign,
        formatted = _HoldingFormatting$fo.formatted;

    return '' + sign + formatted + ' ' + (capitalize ? displayUnit.toUpperCase() : displayUnit);
  }
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatProductRate.$inject = ['$sce', 'HoldingCurrencies', 'HoldingFormatting', 'HoldingTroyRate'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('gmwFormatProductRate', gmwFormatProductRate).name;


function gmwFormatProductRate($sce, HoldingCurrencies, HoldingFormatting, HoldingTroyRate) {
  'ngInject';

  return formatProductRate;

  function formatProductRate(input, weightUnit) {
    var displayInInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!input) {
      return undefined;
    }
    var fiatCurrency = HoldingCurrencies.getCurrencyByCode(input.quoteCurrency);
    var baseCurrency = HoldingCurrencies.getCurrencyByCode(input.baseCurrency);

    var rate = void 0;
    var displayUnit = void 0;
    if (weightUnit === 'oz' && baseCurrency.weightUnit === 'GRAMS') {
      rate = input.value * HoldingTroyRate;
      displayUnit = weightUnit;
    } else if (weightUnit === 'g' && baseCurrency.weightUnit === 'OUNCES') {
      rate = input.value / HoldingTroyRate;
      displayUnit = weightUnit;
    } else {
      rate = input.value;
      displayUnit = baseCurrency.symbol;
    }

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(rate, 4),
        formatted = _HoldingFormatting$fo.formatted;

    if (displayInInput) {
      return formatted + ' \u2044 ' + displayUnit;
    }

    var formattedRate = '' + fiatCurrency.symbol + formatted + '&nbsp;\u2044&nbsp;' + displayUnit;
    return $sce.trustAsHtml(formattedRate);
  }
}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFormatWeight.$inject = ['HoldingFormatting'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').filter('gmwFormatWeight', gmwFormatWeight).name;


function gmwFormatWeight(HoldingFormatting) {
  'ngInject';

  return formatWeight;

  function formatWeight(input, metal) {
    if (!input) {
      return input;
    }

    var weightUnit = input.weightUnit;

    var displayUnit = void 0;
    if (weightUnit === 'OUNCES') {
      displayUnit = 'oz';
    } else if (weightUnit === 'GRAMS') {
      switch (metal) {
        case 'Gold':
          displayUnit = 'gg';
          break;
        case 'Silver':
          displayUnit = 'sg';
          break;
        case 'Platinum':
          displayUnit = 'pt';
          break;
        case 'Palladium':
          displayUnit = 'pd';
          break;
        default:
          displayUnit = 'g';
      }
    }

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(input.amount, 3),
        sign = _HoldingFormatting$fo.sign,
        formatted = _HoldingFormatting$fo.formatted;

    return '' + sign + formatted + displayUnit;
  }
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.formatting').factory('HoldingFormatting', HoldingFormatting).name;


function HoldingFormatting() {
  'ngInject';

  return {
    formatNumber: formatNumber,
    formatNumberWithOriginalDecimals: formatNumberWithOriginalDecimals
  };

  function formatNumber(input) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

    var number = parseFloat(input);
    if (isNaN(number)) {
      return '';
    }

    var negative = number < 0;
    var parts = Math.abs(number).toFixed(decimals).split('.');

    var formatted = parts[0].split('').reverse().reduce(function (origRes, part, indx) {
      var res = origRes + (indx > 0 && indx % 3 === 0 ? ',' : '');
      return res.concat(part);
    }, '').split('').reverse().join('');

    formatted += parts[1] ? '.' + parts[1] : '';

    var sign = negative ? '-' : '';

    return { sign: sign, formatted: formatted };
  }

  function formatNumberWithOriginalDecimals(input) {
    var number = parseFloat(input);
    if (isNaN(number)) {
      return '';
    }

    var negative = number < 0;
    var parts = Math.abs(number).toString().split('.');

    var formatted = parts[0].split('').reverse().reduce(function (res, part, indx) {
      var separator = indx > 0 && indx % 3 === 0 ? ',' : '';
      return res.concat(separator).concat(part);
    }, '').split('').reverse().join('');

    formatted += parts[1] ? '.' + parts[1] : '';

    var sign = negative ? '-' : '';

    return { sign: sign, formatted: formatted };
  }
}

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _dashboard = __webpack_require__(435);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _properties = __webpack_require__(862);

var _properties2 = _interopRequireDefault(_properties);

var _splash = __webpack_require__(864);

var _splash2 = _interopRequireDefault(_splash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding', [_common2.default, _angularjs2.default, _dashboard2.default, _properties2.default, _splash2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding', {
    abstract: true,
    parent: 'app',
    resolve: {
      CountriesResolve: ['HoldingCountries', function CountriesResolve(HoldingCountries) {
        'ngInject';

        return HoldingCountries.load();
      }],
      CurrenciesResolve: ['HoldingCurrencies', function CurrenciesResolve(HoldingCurrencies) {
        'ngInject';

        return HoldingCurrencies.load();
      }],
      PromotionalResolve: ['HoldingPromotions', 'UserResolve', function PromotionalResolve(HoldingPromotions, UserResolve) {
        'ngInject';

        HoldingPromotions.clearPromoCookie();
      }],
      PropertiesResolve: ['HoldingProperties', 'UserResolve', function PropertiesResolve(HoldingProperties, UserResolve) {
        'ngInject';

        return HoldingProperties.load();
      }],
      SetupResolve: ['$q', 'GmwSetup', function SetupResolve($q, GmwSetup) {
        'ngInject';

        return GmwSetup.getSetupStatus(true);
      }],
      ShouldVerifyEmailResolve: ['$q', 'SetupResolve', function ShouldVerifyEmailResolve($q, SetupResolve) {
        'ngInject';

        var emails = SetupResolve.emails;

        var verificationNeeded = emails ? emails.some(function (email) {
          return !email.migrated && !('verified' in email);
        }) : false;

        return $q.resolve(verificationNeeded);
      }],
      TimezonesResolve: ['HoldingTimezones', function TimezonesResolve(HoldingTimezones) {
        'ngInject';

        return HoldingTimezones.load();
      }],
      UserResolve: ['HoldingUser', function UserResolve(HoldingUser) {
        'ngInject';

        return HoldingUser.load();
      }]
    },
    views: {
      app: {
        template: '<div ui-view="holding"></div>'
      }
    }
  });
}]).name;


__webpack_require__(885);
__webpack_require__(886);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _bankAccounts = __webpack_require__(436);

var _bankAccounts2 = _interopRequireDefault(_bankAccounts);

var _bars = __webpack_require__(469);

var _bars2 = _interopRequireDefault(_bars);

var _cryptocurrencies = __webpack_require__(506);

var _cryptocurrencies2 = _interopRequireDefault(_cryptocurrencies);

var _flow = __webpack_require__(514);

var _flow2 = _interopRequireDefault(_flow);

var _funds = __webpack_require__(537);

var _funds2 = _interopRequireDefault(_funds);

var _governance = __webpack_require__(612);

var _governance2 = _interopRequireDefault(_governance);

var _metals = __webpack_require__(642);

var _metals2 = _interopRequireDefault(_metals);

var _messages = __webpack_require__(716);

var _messages2 = _interopRequireDefault(_messages);

var _overview = __webpack_require__(751);

var _overview2 = _interopRequireDefault(_overview);

var _promotions = __webpack_require__(795);

var _promotions2 = _interopRequireDefault(_promotions);

var _transfers = __webpack_require__(805);

var _transfers2 = _interopRequireDefault(_transfers);

var _vaults = __webpack_require__(824);

var _vaults2 = _interopRequireDefault(_vaults);

var _dashboard = __webpack_require__(832);

var _dashboard2 = _interopRequireDefault(_dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard', [_common2.default, _angularjs2.default, _bankAccounts2.default, _bars2.default, _cryptocurrencies2.default, _flow2.default, _funds2.default, _governance2.default, _messages2.default, _metals2.default, _overview2.default, _promotions2.default, _transfers2.default, _vaults2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard', {
    abstract: true,
    resolve: {
      MessagesResolve: ['HoldingMessages', 'UserResolve', function MessagesResolve(HoldingMessages, UserResolve) {
        'ngInject';

        return HoldingMessages.getUnreadMessages();
      }]
    },
    views: {
      holding: {
        controller: 'DashboardController',
        controllerAs: 'dashboardCtrl',
        template: _dashboard2.default
      }
    }
  });
}]).name;


__webpack_require__(833);
__webpack_require__(835);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(840);
__webpack_require__(842);
__webpack_require__(844);
__webpack_require__(846);
__webpack_require__(848);
__webpack_require__(850);
__webpack_require__(852);
__webpack_require__(854);
__webpack_require__(856);
__webpack_require__(858);
__webpack_require__(860);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts', [_angularjs2.default, _common2.default]).name;


__webpack_require__(437);
__webpack_require__(439);
__webpack_require__(441);
__webpack_require__(443);
__webpack_require__(445);
__webpack_require__(447);
__webpack_require__(448);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bankAccountFieldErrors = __webpack_require__(438);

var _bankAccountFieldErrors2 = _interopRequireDefault(_bankAccountFieldErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts').directive('holdingBankAccountFieldErrors', holdingBankAccountFieldErrors).name;


function holdingBankAccountFieldErrors() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      field: '=',
      name: '@',
      validation: '=?'
    },
    template: _bankAccountFieldErrors2.default
  };
}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<holding-alert-legacy class=error ng-if=\"field.$touched && field.$dirty && field.$invalid\"> <span ng-messages=field.$error> <span ng-message=required translate> The {{name}} field is required. </span> <span ng-message=minlength> <span ng-if=\"validation && validation.min && validation.min !== validation.max\" translate> The {{name}} field must be at least {{validation.min}} characters long. </span> <span ng-if=\"validation && validation.min && validation.min === validation.max\" translate> The {{name}} field must be exactly {{validation.min}} characters long. </span> <span ng-if=\"!validation || !validation.min\" translate> The {{name}} field is too short. </span> </span> <span ng-message=maxlength> <span ng-if=\"validation && validation.max && validation.max !== validation.min\" translate> The {{name}} field must be at most {{validation.max}} characters long. </span> <span ng-if=\"validation && validation.max && validation.max === validation.min\" translate> The {{name}} field must be exactly {{validation.max}} characters long. </span> <span ng-if=\"!validation || !validation.max\" translate> The {{name}} field is too long. </span> </span> <span ng-message=pattern translate> The {{name}} field must be <span ng-repeat=\"size in validation.sizes\">{{size}}<span ng-if=!$last> or </span></span> characters long. </span> </span> </holding-alert-legacy> ";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bankAccountNameSelector = __webpack_require__(440);

var _bankAccountNameSelector2 = _interopRequireDefault(_bankAccountNameSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts').directive('holdingBankAccountNameSelector', holdingBankAccountNameSelector).name;


function holdingBankAccountNameSelector() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      description: '@?',
      label: '@',
      options: '='
    },
    template: _bankAccountNameSelector2.default
  };

  function getCodes(options) {
    if (!options) {
      return [];
    }
    return options.filter(function (option) {
      return !!option.selected;
    }).map(function (option) {
      return option.code;
    });
  }

  function link(scope, _elem, _attrs, model) {
    scope.$watch('options', function (val, oldVal) {
      if (!val) {
        model.$setViewValue(null);
        return;
      }
      if (val.length === 1) {
        val[0].selected = true;
      }
      var codes = getCodes(val);
      var oldCodes = getCodes(oldVal);
      if (codes.length > 0) {
        model.$setViewValue(codes);
        model.$setTouched();
        model.$setDirty();
      } else {
        model.$setViewValue(null);
        if (codes.length === oldCodes.length) {
          model.$setPristine();
        } else {
          model.$setTouched();
          model.$setDirty();
        }
      }
    }, true);
  }
}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=label> </label> <gmw-checkbox name=\"select-name-{{item.code}}\" ng-if=\"options.length > 1\" class=gmw-checkbox--multiple ng-repeat=\"item in options\" ng-model=item.selected> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-bind=item.name></span> </gmw-checkbox> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"options.length===1\" ng-bind=options[0].name></span> <span class=\"gmw-box-input__description ui-micro-text\" ng-if=\"description && options.length > 1\" ng-bind=description> </span> </div> ";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bankAccountTypeSelector = __webpack_require__(442);

var _bankAccountTypeSelector2 = _interopRequireDefault(_bankAccountTypeSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts').directive('holdingBankAccountTypeSelector', holdingBankAccountTypeSelector).name;


function holdingBankAccountTypeSelector() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      enabledTypes: '='
    },
    template: _bankAccountTypeSelector2.default
  };

  function link(scope, _elem, _attrs, model) {
    function select(type) {
      scope.type = type;
      if (scope.enabledTypes.includes(type)) {
        model.$setViewValue(type);
      }
    }

    scope.$watch('enabledTypes', function (types) {
      scope.brokerageDisabled = !types.includes('Brokerage');
      scope.personalDisabled = !types.includes('Personal');
      if (types.length === 1) {
        scope.type = types[0];
        model.$setViewValue(types[0]);
      }
      scope.selectorTypes = types.map(function (type) {
        return {
          value: type,
          label: type
        };
      });
    });

    scope.$watch('type', select);
    model.$formatters.push(function (type) {
      scope.type = type;
    });

    scope.model = model;
    scope.select = select;
  }
}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text desktop-only desktop-only--sm\" ng-bind=\"'Type Of Account'|translate\"> </label> <gmw-main-table desktop-only=true hover=true small=true> <gmw-main-table-body> <gmw-main-table-body-row ng-click=\"select('Personal')\" ng-disabled=personalDisabled> <gmw-main-table-body-col class=\"heading-h5 gmw-main-table__body-cell--20\"> <span ng-bind=\"'PERSONAL'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-bind=\"'Your personal bank account'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option gmw-disabled=personalDisabled checked=\"model.$viewValue === 'Personal'\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> <gmw-main-table-body-row ng-click=\"select('Brokerage')\" ng-disabled=brokerageDisabled> <gmw-main-table-body-col class=\"heading-h5 gmw-main-table__body-cell--20\"> <span ng-bind=\"'BROKERAGE'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-bind=\"'Your brokerage bank account'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option gmw-disabled=brokerageDisabled checked=\"model.$viewValue === 'Brokerage'\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <gmw-box-selector required name=accountType label=\"{{'Type of Account'|translate}}\" class=\"gmw-input-container mobile-only mobile-only--sm\" ng-model=type options=selectorTypes> </gmw-box-selector> </div> ";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingBankAccountSelector.$inject = ['HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bankAccountSelector = __webpack_require__(444);

var _bankAccountSelector2 = _interopRequireDefault(_bankAccountSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts').directive('holdingBankAccountSelector', holdingBankAccountSelector).name;


function holdingBankAccountSelector(HoldingUser) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      accounts: '='
    },
    require: 'ngModel',
    template: _bankAccountSelector2.default,
    transclude: true
  };

  function link(scope, _element, _attrs, ngModel) {
    scope.model = ngModel;
    scope.selectBank = function (bank) {
      return ngModel.$setViewValue(bank);
    };
    scope.user = HoldingUser.get();
  }
}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Select Bank Account'|translate\"> </label> <gmw-main-table desktop-only=true class=gmw-main-table--no-margin hover=true small=true full-width=true> <gmw-main-table-body> <gmw-main-table-body-row ng-click=selectBank(account) ng-repeat=\"account in accounts\"> <gmw-main-table-body-col class=gmw-main-table__body-cell--10> <gmw-flag country=::(account.currencyCode|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::account.currencyCode></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::account.nickName> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--15 h-light-text\" ng-bind=::account.accountNumber> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::account.transferText> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option checked=\"model.$viewValue === account\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=gmw-input-container__tooltip ng-show=\"model.$viewValue.euroText && (user.regulation == 'JFSC' || user.regulation == 'UK')\"> <a href class=tooltip-bottom ng-bind=\"'What transfer method will you use?'|translate\" gmw-tooltip=\"{{::model.$viewValue.euroText}}\"></a> </div> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"account in accounts\" ng-click=selectBank(account)> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <gmw-flag country=::(account.currencyCode|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::account.currencyCode></span> </div> <div class=gmw-simple-table__head-right> <gmw-radio-option checked=\"model.$viewValue === account\" label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Nickname'|translate\"></span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=::account.nickName></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Account'|translate\"></span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=::account.accountNumber></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Transfer Method'|translate\"></span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=::account.transferText></span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingBankAccounts.$inject = ['HoldingBankAccounts', 'HoldingUser', 'GmwModal'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bankAccounts = __webpack_require__(446);

var _bankAccounts2 = _interopRequireDefault(_bankAccounts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts').directive('holdingBankAccounts', holdingBankAccounts).name;


function holdingBankAccounts(HoldingBankAccounts, HoldingUser, GmwModal) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      accounts: '='
    },
    template: _bankAccounts2.default
  };

  function link(scope) {
    var addBankAccountPermission = HoldingUser.getPermission('addBankAccount');
    scope.isLocked = addBankAccountPermission.message === 'lock';
    scope.remove = remove;

    function remove(account) {
      GmwModal.showConfirmationModal('Do you want to delete this bank account?').then(function () {
        return HoldingBankAccounts.remove(account);
      }).then(function () {
        return scope.$emit('gmw:bank-accounts.updated');
      });
    }
  }
}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<gmw-main-table desktop-only=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--20 heading-h5 h-light-text\" ng-bind=\"'Nickname'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Currency'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Account Number'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--10></gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--10></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"account in accounts track by account.code\" ng-disabled=!account.canAftr> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--20 h-light-text\"> <span ng-bind=::account.nickName.value|gmwTruncate:10></span> <svg class=gmw-main-table__body-cell__tooltip-indicator ng-if=!account.canAftr gmw-tooltip=\"{{'We cannot currently accept funds from institutions located in this bank account\\'s country'|translate}}\"> <use xlink:href=#gmw-info-icon></use> </svg> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=account.currencyCode.value|holdingCurrencyCountry></gmw-flag> <span ng-bind=::account.currencyCode.value></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::account.accountNumber.value> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--10> <a class=h-blue-link ng-bind=\"'View'|translate\" ui-sref=\"holding.dashboard.bank-accounts.details({ code:account.code })\"></a> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--10 ng-if=\"!isLocked && account.canDelete\"> <a class=h-red-link ng-bind=\"'Delete'|translate\" ng-click=remove(account)> </a> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"account in accounts track by account.code\" ng-disabled=!account.canAftr> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <a class=h-blue-link ui-sref=\"holding.dashboard.bank-accounts.details({ code:account.code })\">View</a> </div> <div class=gmw-simple-table__head-right ng-if=\"!isLocked && account.canDelete\"> <a class=h-red-link ng-click=remove(account)> Delete </a> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Nickname'|translate\"> </span> <span class=gmw-simple-table__value ng-class=\"{\n              'gmw-simple-table__value--disabled': !account.canAftr,\n            }\" ng-bind=::account.nickName.value|gmwTruncate:15> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Currency'|translate\"> </span> <span class=gmw-simple-table__value ng-class=\"{\n              'gmw-simple-table__value--disabled': !account.canAftr,\n            }\"> <gmw-flag country=account.currencyCode.value|holdingCurrencyCountry></gmw-flag> <span ng-bind=::account.currencyCode.value></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Account Number'|translate\"> </span> <span class=gmw-simple-table__value ng-class=\"{\n              'gmw-simple-table__value--disabled': !account.canAftr,\n            }\" ng-bind=::account.accountNumber.value> </span> </div> <div class=gmw-simple-table__row ng-if=!account.canAftr> <span class=gmw-simple-table__label ng-bind=\"'Can Add Funds'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=\"'We cannot currently accept funds from institutions located in this bank account\\'s country.'|translate\"> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingBankAccounts.$inject = ['HoldingApi', 'HoldingUser', 'promiseCache'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.bank-accounts').factory('HoldingBankAccounts', HoldingBankAccounts).name;


function HoldingBankAccounts(HoldingApi, HoldingUser, promiseCache) {
  'ngInject';

  var CACHE_KEY = 'user.bank.accounts';

  return {
    add: add,
    canAddBankAccount: canAddBankAccount,
    get: get,
    getByCode: getByCode,
    getFields: getFields,
    getSettings: getSettings,
    remove: remove,
    showAddBankAccount: showAddBankAccount
  };

  function add(model) {
    return HoldingApi.post('bankAccount', model).then(clearCache);
  }

  function canAddBankAccount() {
    return HoldingUser.isAllowed('addBankAccount');
  }

  function clearCache(result) {
    promiseCache.remove(CACHE_KEY);
    return result;
  }

  function get() {
    return promiseCache({
      key: CACHE_KEY,
      ttl: -1,
      promise: function promise() {
        return HoldingApi.get('bankAccount');
      }
    });
  }

  function getByCode(code) {
    return get().then(function (accounts) {
      return accounts.find(function (_) {
        return _.code.toString() === code;
      });
    });
  }

  function getFields(currency, country, type) {
    return HoldingApi.get('bankAccount/' + currency + '/' + country + '/' + type + '/fields').then(function (rawFields) {
      var fields = {};
      rawFields.forEach(function (field) {
        var min = void 0;
        if (field.length && field.length.minimum) {
          min = field.length.minimum;
        }
        if (field.length && field.length.sizes && field.length.sizes.length === 1) {
          min = field.length.sizes[0];
        }
        var max = void 0;
        if (field.length && field.length.maximum) {
          max = field.length.maximum;
        }
        if (field.length && field.length.sizes && field.length.sizes.length === 1) {
          max = field.length.sizes[0];
        }
        var pattern = void 0;
        var sizes = void 0;
        if (field.length && field.length.sizes && field.length.sizes.length > 1) {
          sizes = field.length.sizes;
          pattern = getPattern(field.length.sizes);
        }
        var show = field.validation !== 'not-relevant';
        var required = field.validation === 'mandatory';
        fields[field.value] = { show: show, required: required, min: min, max: max, pattern: pattern, sizes: sizes };
      });
      return fields;
    });
  }

  function getPattern(sizes) {
    if (!sizes) {
      return null;
    }
    var pattern = sizes.map(function (size) {
      return '\\w{' + size + '}';
    }).join('|');
    return '(' + pattern + ')';
  }

  function getSettings() {
    return HoldingApi.get('bankAccount/countries');
  }

  function remove(_ref) {
    var code = _ref.code;

    return HoldingApi.delete('bankAccount/' + code).then(clearCache);
  }

  function showAddBankAccount() {
    return !HoldingUser.isHidden('addBankAccount');
  }
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(449);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(450);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts', {
    data: {
      heroNoMobileActionTabs: true
    },
    url: '/bank-accounts',
    views: {
      hero: {
        controller: ['HoldingBankAccounts', function controller(HoldingBankAccounts) {
          'ngInject';

          this.showAddBankAccount = HoldingBankAccounts.showAddBankAccount();
        }],
        controllerAs: 'bankAccountsHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });

  $urlRouterProvider.when('/bank-accounts', '/bank-accounts/overview');
  $urlRouterProvider.when('/bank-accounts/link', '/bank-accounts/link/account');
}]).name;


__webpack_require__(451);
__webpack_require__(454);
__webpack_require__(466);

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.funds.add.detail'|isState\" ui-sref=holding.dashboard.funds.add> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.bank-accounts.details'|isState\" ui-sref=holding.dashboard.bank-accounts> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.funds.remove.detail'|isState\" ui-sref=holding.dashboard.funds.remove> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> </holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Bank Accounts'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center></section> <section class=\"holding-dashboard-hero-actions__right holding-dashboard-hero-actions__right--has-actions\" ng-if=bankAccountsHeroCtrl.showAddBankAccount ng-hide=\"'holding.dashboard.bank-accounts.link'|includedByState\"> <button ui-sref=holding.dashboard.bank-accounts.link class=small-main-cta> <span ng-bind=\"'Link Bank Account'|translate\"></span> </button> </section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=bank-accounts-main></div> ";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _details = __webpack_require__(452);

var _details2 = _interopRequireDefault(_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.details', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bank Accounts - Account Details'
    },
    resolve: {
      BankAccountDetailsResolve: ['$q', '$stateParams', 'HoldingBankAccounts', function BankAccountDetailsResolve($q, $stateParams, HoldingBankAccounts) {
        var code = $stateParams.code;

        return HoldingBankAccounts.getByCode(code).then(function (account) {
          return $q.resolve(account);
        }).catch(function () {
          return $q.reject({
            redirectTo: 'holding.dashboard.bank-accounts.overview',
            params: {
              reload: true
            }
          });
        });
      }]
    },
    url: '/{code:[0-9]+}',
    views: {
      'bank-accounts-main': {
        controller: 'BankAccountDetailsController',
        controllerAs: 'bankAccountDetailsCtrl',
        template: _details2.default
      }
    }
  });
}]);

__webpack_require__(453);

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'View Bank Account Details'|translate\"></h2> </header> <div class=gmw-flow-box-container> <holding-alert-legacy class=warning ng-if=!bankAccountDetailsCtrl.account.canAftr> <span ng-bind=\"'We cannot currently accept funds from this bank account. Please'|translate\"></span> <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.compose({ category: 'FUNDS_TRANSFER' })\" ui-sref-opts=\"{\n            reload: true,\n          }\" ng-bind=\"'contact Relationship Management'|translate\"></a> <span ng-bind=\"'to inquire as to the cause.'|translate\"></span> </holding-alert-legacy> <div class=gmw-recap-table> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.nickName.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Nickname'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.nickName.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.bankName.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Bank name'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.bankName.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.address1.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Bank Address 1'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.address1.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.address2.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Bank Address 2'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.address2.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.address3.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Bank Address 3'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.address3.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.countryCode.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Bank Country'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=bankAccountDetailsCtrl.account.countryCode.value></gmw-flag> <span ng-bind=::bankAccountDetailsCtrl.account.countryCode.value|holdingCountryName></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.currencyCode.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Currency'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=bankAccountDetailsCtrl.account.currencyCode.value|holdingCurrencyCountry></gmw-flag> <span ng-bind=::bankAccountDetailsCtrl.account.currencyCode.value></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=!bankAccountDetailsCtrl.account.canAftr> <div class=gmw-recap-table__col ng-bind=\"'Can Add Funds'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=\"'We cannot currently accept funds from this bank account.'|translate\"></span> </span> </div> </div> <div class=gmw-recap-table__callout> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.routingNumber.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'ABA/Routing Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.routingNumber.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.transitNumber.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Transit/Branch codes'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.transitNumber.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.sortCode.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Sort code'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.sortCode.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.swift.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'SWIFT/BIC'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.swift.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.iban.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'IBAN code'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.iban.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.accountNumber.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Account Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.accountNumber.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.accountName.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Account Name'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.accountName.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.numberFFCT.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'FFCT Account Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.numberFFCT.value></span> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.nameFFCT.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'FFCT Account Name'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.nameFFCT.value></span> </div> </div> </div> <div class=gmw-recap-table__row ng-if=::bankAccountDetailsCtrl.account.otherInfo.shouldShow> <div class=gmw-recap-table__col ng-bind=\"'Correspondent bank details / other instructions / bank transfer memo'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::bankAccountDetailsCtrl.account.otherInfo.value></span> </div> </div> </div> </div> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


BankAccountDetailsController.$inject = ['BankAccountDetailsResolve'];
angular.module('app.holding.dashboard.bank-accounts').controller('BankAccountDetailsController', BankAccountDetailsController);

function BankAccountDetailsController(BankAccountDetailsResolve) {
  'ngInject';

  var vm = this;

  function activate() {
    vm.account = BankAccountDetailsResolve;
  }

  activate();
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _linkFlow = __webpack_require__(455);

var _linkFlow2 = _interopRequireDefault(_linkFlow);

var _link = __webpack_require__(456);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.link', {
    data: {
      flow: _linkFlow2.default
    },
    resolve: {
      CanAddBankAccountResolve: ['$q', 'HoldingBankAccounts', function CanAddBankAccountResolve($q, HoldingBankAccounts) {
        return $q.when(HoldingBankAccounts.canAddBankAccount());
      }],
      SettingsResolve: ['$q', 'HoldingBankAccounts', function SettingsResolve($q, HoldingBankAccounts) {
        'ngInject';

        return HoldingBankAccounts.getSettings().then(function (settings) {
          if (settings.availableNumberOfBankAccounts === 0) {
            return $q.reject({
              redirectTo: 'holding.dashboard.bank-accounts.overview',
              params: {
                reload: true
              }
            });
          }
          return $q.resolve(settings);
        });
      }]
    },
    url: '/link',
    views: {
      'bank-accounts-main': {
        controller: 'LinkBankAccountController',
        controllerAs: 'linkBankAccountCtrl',
        template: _link2.default
      }
    }
  });
}]);

__webpack_require__(457);
__webpack_require__(459);
__webpack_require__(461);
__webpack_require__(463);
__webpack_require__(464);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Link Bank Account'),
    cancel: {
        state: 'holding.dashboard.bank-accounts'
    },
    complete: {
        label: (0, _gettext2.default)('Back to Overview'),
        state: 'holding.dashboard.bank-accounts.overview'
    },
    steps: [{
        key: 'account',
        state: 'holding.dashboard.bank-accounts.link.account',
        heading: (0, _gettext2.default)('Link Bank Account'),
        label: (0, _gettext2.default)('Choose Account Type')
    }, {
        key: 'details',
        state: 'holding.dashboard.bank-accounts.link.details',
        heading: (0, _gettext2.default)('Link Bank Account'),
        label: (0, _gettext2.default)('Enter Account Details')
    }, {
        key: 'review',
        state: 'holding.dashboard.bank-accounts.link.review',
        heading: (0, _gettext2.default)('Review Bank Account Details'),
        label: (0, _gettext2.default)('Review'),
        cancel: true,
        controls: {
            next: (0, _gettext2.default)('Link Account')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.bank-accounts.link.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "<section class=\"gmw-flow-box gmw-flow-box--center\" ng-if=!linkBankAccountCtrl.canAddBankAccount> <holding-permission-based-empty-state permission=addBankAccount></holding-permission-based-empty-state> </section> <div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" ng-if=linkBankAccountCtrl.canAddBankAccount gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view ng-if=linkBankAccountCtrl.canAddBankAccount> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I add funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How do I link my brokerage account to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360028703052> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _account = __webpack_require__(458);

var _account2 = _interopRequireDefault(_account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.link.account', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bank Accounts - Link Account - Choose Account Type'
    },
    url: '/account',
    views: {
      step: {
        template: _account2.default
      }
    }
  });
}]);

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please select the currency, the country, and the type of bank account you wish to link to your Holding.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=linkBankAccountCtrl.form> <holding-alert-legacy class=info> <span ng-bind=\"'Please note the Goldmoney will not accept funds if the linked bank account:'|translate\"></span> <ul class=gmw-alert-list> <li> <span ng-bind=\"'Has a different name than the names asscoiated with your Holding, or'|translate\"></span> </li> <li> <span ng-bind=\"'If the bank account is registered in the name of a Living Trust or a Revocable Family Trust'|translate\"></span> - <a href holding-external-link=support.funding.trust class=gmw-alert-link ng-bind=\"'Read more...'|translate\"></a> </li> </ul> </holding-alert-legacy> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.currencyCode options=linkBankAccountCtrl.currencies label=\"{{'Select Currency'|translate}}\"> </gmw-box-selector> <gmw-box-selector required name=country class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.countryCode options=linkBankAccountCtrl.countries label=\"{{'Country of Bank Location'|translate}}\"> </gmw-box-selector> </div> <holding-bank-account-type-selector ng-model=linkBankAccountCtrl.model.bankAccountRelationshipType enabled-types=linkBankAccountCtrl.relationshipTypes required> </holding-bank-account-type-selector> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=linkBankAccountCtrl.cancel() on-next=linkBankAccountCtrl.next() step-disabled=\"linkBankAccountCtrl.form.$invalid || linkBankAccountCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(460);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.link.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bank Accounts - Link Account - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "<gmw-generic-complete-header title=\"{{'Bank Account Linked'|translate}}\" sub-title=\"{{'Ready for funding, redemption'|translate}}\"> </gmw-generic-complete-header> <div class=gmw-flow-box-container> <div class=\"gmw-recap-table gmw-recap-table--shadow\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span class=\"h-center-text h-dark-text h-full-width\" translate> Your '{{linkBankAccountCtrl.model.name}}' bank account is now linked to your Holding. </span> </div> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ui-sref=holding.dashboard.overview ui-sref-opts=\"{\n        reload: true,\n      }\" ng-bind=\"'Holding Overview'|translate\"> </button> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=holding.dashboard.funds.add.bank-wire ui-sref-opts=\"{\n        reload: true,\n      }\" ng-bind=\"'Fund Holding'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _details = __webpack_require__(462);

var _details2 = _interopRequireDefault(_details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.link.details', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bank Accounts - Link Account - Enter Account Details'
    },
    url: '/details',
    views: {
      step: {
        template: _details2.default
      }
    }
  });
}]);

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please provide the bank account details below.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=linkBankAccountCtrl.form> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.nickName name=\"{{'Nickname'|translate}}\" validation=linkBankAccountCtrl.fields.Nickname> </holding-bank-account-field-errors> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.name name=\"{{'Bank Name'|translate}}\" validation=linkBankAccountCtrl.fields.Name> </holding-bank-account-field-errors> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input ng-if=linkBankAccountCtrl.fields.Nickname.show ng-required=linkBankAccountCtrl.fields.Nickname.required minlength=\"{{linkBankAccountCtrl.fields.Nickname.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.Nickname.max}}\" pattern=\"{{linkBankAccountCtrl.fields.Nickname.pattern}}\" name=nickName has-error=\"linkBankAccountCtrl.form.nickName.$dirty && linkBankAccountCtrl.form.nickName.$invalid\" class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.nickName placeholder=\"{{'Nickname'|translate}}\" description=\"{{linkBankAccountCtrl.fields.Nickname|holdingValidationInfo}}\" no-label=true> </gmw-box-input> <gmw-box-input ng-if=linkBankAccountCtrl.fields.Name.show ng-required=linkBankAccountCtrl.fields.Name.required minlength=\"{{linkBankAccountCtrl.fields.Name.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.Name.max}}\" pattern=\"{{linkBankAccountCtrl.fields.Name.pattern}}\" name=name has-error=\"linkBankAccountCtrl.form.name.$dirty && linkBankAccountCtrl.form.name.$invalid\" class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.name placeholder=\"{{'Bank name'|translate}}\" description=\"{{linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage' ? 'Name of the bank your brokerage company uses to receive funds – ' : null}} {{linkBankAccountCtrl.fields.Name|holdingValidationInfo}}\" no-label=true> </gmw-box-input> </div> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.address1 name=\"{{'Address Line 1'|translate}}\" validation=linkBankAccountCtrl.fields.Address1> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.Address1.show ng-required=linkBankAccountCtrl.fields.Address1.required minlength=\"{{linkBankAccountCtrl.fields.Address1.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.Address1.max}}\" pattern=\"{{linkBankAccountCtrl.fields.Address1.pattern}}\" name=address1 has-error=\"linkBankAccountCtrl.form.address1.$dirty && linkBankAccountCtrl.form.address1.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.address1 label=\"{{'Bank Address'|translate}}\" placeholder=\"{{'Street name & number'|translate}}\" description=\"{{linkBankAccountCtrl.fields.Address1|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.address2 name=\"{{'Address Line 2'|translate}}\" validation=linkBankAccountCtrl.fields.Address2> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.Address2.show ng-required=linkBankAccountCtrl.fields.Address2.required minlength=\"{{linkBankAccountCtrl.fields.Address2.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.Address2.max}}\" pattern=\"{{linkBankAccountCtrl.fields.Address2.pattern}}\" no-label=true name=address2 has-error=\"linkBankAccountCtrl.form.address2.$dirty && linkBankAccountCtrl.form.address2.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.address2 placeholder=\"{{'Building & unit number or \\'N/A\\''|translate}}\" description=\"{{linkBankAccountCtrl.fields.Address2|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.address3 name=\"{{'Address Line 3'|translate}}\" validation=linkBankAccountCtrl.fields.Address3> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.Address3.show ng-required=linkBankAccountCtrl.fields.Address3.required minlength=\"{{linkBankAccountCtrl.fields.Address3.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.Address3.max}}\" pattern=\"{{linkBankAccountCtrl.fields.Address3.pattern}}\" name=address3 no-label=true has-error=\"linkBankAccountCtrl.form.address3.$dirty && linkBankAccountCtrl.form.address3.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.address3 placeholder=\"{{'City, province/state, postal code'|translate}}\" description=\"{{linkBankAccountCtrl.fields.Address3|holdingValidationInfo}}\"> </gmw-box-input> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required readonly=readonly disabled=disabled name=country class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.countryCode options=linkBankAccountCtrl.countries label=\"{{'Bank Country'|translate}}\"> </gmw-box-selector> <gmw-box-selector required readonly=readonly disabled=disabled name=currency class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.currencyCode options=linkBankAccountCtrl.currencies label=\"{{'Currency'|translate}}\"> </gmw-box-selector> </div> <holding-bank-account-field-errors ng-if=linkBankAccountCtrl.fields.SwiftCode.show field=linkBankAccountCtrl.form.swiftCode name=\"{{'SWIFT / BIC Code'|translate}}\" validation=linkBankAccountCtrl.fields.SwiftCode> </holding-bank-account-field-errors> <holding-bank-account-field-errors ng-if=linkBankAccountCtrl.fields.IBAN.show field=linkBankAccountCtrl.form.iban name=\"{{'IBAN'|translate}}\" validation=linkBankAccountCtrl.fields.IBAN> </holding-bank-account-field-errors> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input ng-if=linkBankAccountCtrl.fields.SwiftCode.show ng-required=linkBankAccountCtrl.fields.SwiftCode.required minlength=\"{{linkBankAccountCtrl.fields.SwiftCode.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.SwiftCode.max}}\" pattern=\"{{linkBankAccountCtrl.fields.SwiftCode.pattern}}\" name=swiftCode has-error=\"linkBankAccountCtrl.form.swiftCode.$dirty && linkBankAccountCtrl.form.swiftCode.$invalid\" class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.swiftCode label=\"{{'Bank Details'|translate}}\" placeholder=\"{{'SWIFT/BIC code'|translate}}\" description=\"{{linkBankAccountCtrl.fields.SwiftCode|holdingValidationInfo}}\"> </gmw-box-input> <gmw-box-input ng-if=linkBankAccountCtrl.fields.IBAN.show ng-required=linkBankAccountCtrl.fields.IBAN.required minlength=\"{{linkBankAccountCtrl.fields.IBAN.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.IBAN.max}}\" pattern=\"{{linkBankAccountCtrl.fields.IBAN.pattern}}\" name=iban has-error=\"linkBankAccountCtrl.form.iban.$dirty && linkBankAccountCtrl.form.iban.$invalid\" class=gmw-input-container--split-half__col ng-model=linkBankAccountCtrl.model.iban placeholder=\"{{'IBAN code'|translate}}\" description=\"{{linkBankAccountCtrl.fields.IBAN|holdingValidationInfo}}\"> </gmw-box-input> </div> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.routingNumber name=\"{{'ABA/Routing Number'|translate}}\" validation=linkBankAccountCtrl.fields.RoutingNumber> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.RoutingNumber.show ng-required=linkBankAccountCtrl.fields.RoutingNumber.required minlength=\"{{linkBankAccountCtrl.fields.RoutingNumber.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.RoutingNumber.max}}\" pattern=\"{{linkBankAccountCtrl.fields.RoutingNumber.pattern}}\" no-label=true name=routingNumber has-error=\"linkBankAccountCtrl.form.routingNumber.$dirty && linkBankAccountCtrl.form.routingNumber.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.routingNumber placeholder=\"{{'ABA/Routing number'|translate}}\" description=\"{{linkBankAccountCtrl.fields.RoutingNumber|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.transitNumber name=\"{{'Transit Number'|translate}}\" validation=linkBankAccountCtrl.fields.TransitNumber> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.TransitNumber.show ng-required=linkBankAccountCtrl.fields.TransitNumber.required minlength=\"{{linkBankAccountCtrl.fields.TransitNumber.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.TransitNumber.max}}\" pattern=\"{{linkBankAccountCtrl.fields.TransitNumber.pattern}}\" no-label=true name=transitNumber has-error=\"linkBankAccountCtrl.form.transitNumber.$dirty && linkBankAccountCtrl.form.transitNumber.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.transitNumber placeholder=\"{{'Transit number'|translate}}\" description=\"{{linkBankAccountCtrl.fields.TransitNumber|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.sortCode name=\"{{'Sort Code'|translate}}\" validation=linkBankAccountCtrl.fields.SortCode> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.SortCode.show ng-required=linkBankAccountCtrl.fields.SortCode.required minlength=\"{{linkBankAccountCtrl.fields.SortCode.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.SortCode.max}}\" pattern=\"{{linkBankAccountCtrl.fields.SortCode.pattern}}\" no-label=true name=sortCode has-error=\"linkBankAccountCtrl.form.sortCode.$dirty && linkBankAccountCtrl.form.sortCode.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.sortCode placeholder=\"{{'Sort code'|translate}}\" description=\"{{linkBankAccountCtrl.fields.SortCode|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.accountNumber name=\"{{'Account Number'|translate}}\" validation=linkBankAccountCtrl.fields.AccountNumber> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.AccountNumber.show ng-required=linkBankAccountCtrl.fields.AccountNumber.required minlength=\"{{linkBankAccountCtrl.fields.AccountNumber.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.AccountNumber.max}}\" pattern=\"{{linkBankAccountCtrl.fields.AccountNumber.pattern}}\" no-label=true name=accountNumber has-error=\"linkBankAccountCtrl.form.accountNumber.$dirty && linkBankAccountCtrl.form.accountNumber.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.accountNumber placeholder=\"{{'Account number'|translate}}\" description=\"{{linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage' ? 'The brokerage company\\'s account number at the bank – ' : null}} {{linkBankAccountCtrl.fields.AccountNumber|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage'\" field=linkBankAccountCtrl.form.accountNameFixed name=\"{{'Account Name'|translate}}\" validation=linkBankAccountCtrl.fields.AccountName> </holding-bank-account-field-errors> <gmw-box-input ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage'\" required no-label=true name=accountNameFixed has-error=\"linkBankAccountCtrl.form.accountNameFixed.$dirty && linkBankAccountCtrl.form.accountNameFixed.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.accountNameFixed placeholder=\"{{'Brokerage name'|translate}}\" description=\"Brokerage Company – Required\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.accountNumberFFCT name=\"{{'\\'FFCT\\' Account Number'|translate}}\" validation=linkBankAccountCtrl.fields.AccountNumberFFCT> </holding-bank-account-field-errors> <gmw-box-input ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage'\" required minlength=\"{{linkBankAccountCtrl.fields.AccountNumberFFCT.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.AccountNumberFFCT.max}}\" pattern=\"{{linkBankAccountCtrl.fields.AccountNumberFFCT.pattern}}\" name=accountNumberFFCT no-label=true has-error=\"linkBankAccountCtrl.form.accountNumberFFCT.$dirty && linkBankAccountCtrl.form.accountNumberFFCT.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.accountNumberFFCT placeholder=\"{{'FFCT account number'|translate}}\" description=\"Your account number with the brokerage company – {{linkBankAccountCtrl.fields.AccountNumberFFCT|holdingValidationInfo}}\"> </gmw-box-input> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.accountNameSelected name=\"{{(linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage' ? '\\'FFCT\\' Account Name' : 'Account Name')|translate}}\"> </holding-bank-account-field-errors> <holding-alert-legacy class=warning ng-if=\"linkBankAccountCtrl.accountNames.length > 1\"> <span ng-bind=\"'Please note, if the bank account that is being linked to this joint Holding is in a sole name only, we will require a written signed confirmation from the other entity stating that they provide authorisation for withdrawals to be sent to the bank account held in the other parties sole name. We will request this written authorization upon your first withrawl request being initiated.'|translate\"></span> </holding-alert-legacy> <holding-bank-account-name-selector required name=accountNameSelected label=\"{{(linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage' ? 'FFCT Account Name' : 'Account Name')|translate}}\" options=linkBankAccountCtrl.accountNames ng-model=linkBankAccountCtrl.model.accountNameSelected description=\"{{'Check the name of each person named on this bank account, i.e., check both names if it is a joint account – Required'|translate}}\"> </holding-bank-account-name-selector> <holding-bank-account-field-errors field=linkBankAccountCtrl.form.otherInfo name=\"{{'Other Instructions'|translate}}\" validation=linkBankAccountCtrl.fields.OtherInstructions> </holding-bank-account-field-errors> <gmw-box-input ng-if=linkBankAccountCtrl.fields.OtherInstructions.show ng-required=linkBankAccountCtrl.fields.OtherInstructions.required minlength=\"{{linkBankAccountCtrl.fields.OtherInstructions.min}}\" maxlength=\"{{linkBankAccountCtrl.fields.OtherInstructions.max}}\" pattern=\"{{linkBankAccountCtrl.fields.OtherInstructions.pattern}}\" name=otherInfo no-label=true has-error=\"linkBankAccountCtrl.form.otherInfo.$dirty && linkBankAccountCtrl.form.otherInfo.$invalid\" class=gmw-input-container ng-model=linkBankAccountCtrl.model.otherInfo placeholder=\"{{'Correspondent bank details / other instructions / bank wire memo'|translate}}\" type=textarea description=\"{{linkBankAccountCtrl.fields.OtherInstructions|holdingValidationInfo}}\"> </gmw-box-input> <div class=gmw-flow-box__callout> <p translate> Please review and confirm the information you have entered above, then click <span class=h-dark-text>Next Step</span>. To modify the currency, country or type of your bank account, click the back arrow at the top of this page. </p> </div> <holding-alert-legacy class=error ng-if=linkBankAccountCtrl.error> <span ng-bind=linkBankAccountCtrl.error></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=linkBankAccountCtrl.cancel() on-next=linkBankAccountCtrl.next()> </holding-flow-controls> </footer> ";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LinkBankAccountController.$inject = ['$controller', '$q', '$scope', 'HoldingBankAccounts', 'HoldingCurrencies', 'SettingsResolve', 'CanAddBankAccountResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app.holding.dashboard.bank-accounts').controller('LinkBankAccountController', LinkBankAccountController);

function LinkBankAccountController($controller, $q, $scope, HoldingBankAccounts, HoldingCurrencies, SettingsResolve, CanAddBankAccountResolve) {
  'ngInject';

  var vm = this;
  var model = {
    accountNumber: '',
    accountNameFixed: '',
    accountNumberFFCT: '',
    address1: '',
    address2: '',
    address3: '',
    bankAccountRelationshipType: '',
    iban: '',
    nickName: '',
    name: '',
    otherInfo: '',
    routingNumber: '',
    sortCode: '',
    swiftCode: '',
    transitNumber: ''
  };
  var result = {};
  var didComplete = void 0;

  vm.steps = {
    'holding.dashboard.bank-accounts.link.details': {
      checks: [{
        function: checkAccount,
        revertTo: 'holding.dashboard.bank-accounts.link.account'
      }]
    },
    'holding.dashboard.bank-accounts.link.review': {
      checks: [{
        function: checkDetails,
        revertTo: 'holding.dashboard.bank-accounts.link.details'
      }],
      next: executeAdd
    },
    'holding.dashboard.bank-accounts.link.complete': {
      checks: [{
        function: checkAccount,
        revertTo: 'holding.dashboard.bank-accounts.link.account'
      }, {
        function: checkDetails,
        revertTo: 'holding.dashboard.bank-accounts.link.details'
      }, {
        function: checkComplete,
        revertTo: 'holding.dashboard.bank-accounts.link.review'
      }]
    }
  };

  vm.model = model;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    vm.currencies = SettingsResolve.currencies.map(HoldingCurrencies.prepareForSelector);
    vm.countries = SettingsResolve.countries.map(function (country) {
      return {
        value: country.cc2,
        label: country.name,
        flag: country.cc2
      };
    });
    vm.accountNames = SettingsResolve.owners;
    vm.canAddBankAccount = CanAddBankAccountResolve;
  }

  function checkAccount() {
    return !!vm.model.bankAccountRelationshipType;
  }

  function checkComplete() {
    return didComplete;
  }

  function checkDetails() {
    return !!vm.model.nickName;
  }

  function complete(data) {
    result.model = angular.copy(model);
    result.data = data;
    didComplete = true;
  }

  function executeAdd() {
    return HoldingBankAccounts.add(vm.model).then(complete).catch(function (error) {
      vm.error = error.message;
      return $q.reject(error);
    });
  }

  function onUpdatedAccountName(selected) {
    if (selected) {
      vm.selectedNames = vm.accountNames.filter(function (_) {
        return selected.includes(_.code);
      }).map(function (_) {
        return _.name;
      }).join(', ');
    } else {
      vm.selectedNames = '';
    }
  }

  function onUpdatedCountryCode(countryCode) {
    if (countryCode) {
      vm.relationshipTypes = SettingsResolve.countries.find(function (_) {
        return _.cc2 === countryCode;
      }).bankAccountRelationshipTypes;
    } else {
      vm.relationshipTypes = ['Personal', 'Brokerage'];
    }
  }

  function updateFields(_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        currencyCode = _ref2[0],
        countryCode = _ref2[1],
        type = _ref2[2];

    if (currencyCode && countryCode && type) {
      HoldingBankAccounts.getFields(currencyCode, countryCode, type).then(function (fields) {
        vm.fields = fields;
      });
    }
  }

  activate();

  $scope.$watchGroup(['linkBankAccountCtrl.model.currencyCode', 'linkBankAccountCtrl.model.countryCode', 'linkBankAccountCtrl.model.bankAccountRelationshipType'], updateFields);
  $scope.$watch('linkBankAccountCtrl.model.accountNameSelected', onUpdatedAccountName);
  $scope.$watch('linkBankAccountCtrl.model.countryCode', onUpdatedCountryCode);
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(465);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.link.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bank Accounts - Link Account - Review Bank Account Details'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container ng-form=linkBankAccountCtrl.form> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Nickname'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=linkBankAccountCtrl.model.nickName></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Bank Name'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=linkBankAccountCtrl.model.name></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Bank Address 1'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=linkBankAccountCtrl.model.address1></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Bank Address 2'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=linkBankAccountCtrl.model.address2></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Bank Address 3'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=linkBankAccountCtrl.model.address3></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Bank Country'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=linkBankAccountCtrl.model.countryCode></gmw-flag> <span ng-bind=linkBankAccountCtrl.model.countryCode|holdingCountryName></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Currency'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=linkBankAccountCtrl.model.currencyCode|holdingCurrencyCountry></gmw-flag> <span ng-bind=linkBankAccountCtrl.model.currencyCode|holdingCurrencyName></span> </span> </div> </div> <div class=gmw-recap-table__callout> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.routingNumber> <div class=gmw-recap-table__col ng-bind=\"'ABA/Routing Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.routingNumber></span> </div> </div> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.transitNumber> <div class=gmw-recap-table__col ng-bind=\"'Transit/Branch codes'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.transitNumber></span> </div> </div> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.sortCode> <div class=gmw-recap-table__col ng-bind=\"'Sort code'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.sortCode></span> </div> </div> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.swiftCode> <div class=gmw-recap-table__col ng-bind=\"'SWIFT/BIC'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.swiftCode></span> </div> </div> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.iban> <div class=gmw-recap-table__col ng-bind=\"'IBAN code'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.iban></span> </div> </div> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.accountNumber> <div class=gmw-recap-table__col ng-bind=\"'Account Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.accountNumber></span> </div> </div> <div class=gmw-recap-table__row ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType !== 'Brokerage'\"> <div class=gmw-recap-table__col ng-bind=\"'Account Name'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.selectedNames></span> </div> </div> <div class=gmw-recap-table__row ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage'\"> <div class=gmw-recap-table__col ng-bind=\"'Brokerage name'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.accountNameFixed></span> </div> </div> <div class=gmw-recap-table__row ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage'\"> <div class=gmw-recap-table__col ng-bind=\"'FFCT Account Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.model.accountNumberFFCT></span> </div> </div> <div class=gmw-recap-table__row ng-if=\"linkBankAccountCtrl.model.bankAccountRelationshipType === 'Brokerage'\"> <div class=gmw-recap-table__col ng-bind=\"'FFCT Account Name'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=linkBankAccountCtrl.selectedNames></span> </div> </div> </div> <div class=gmw-recap-table__row ng-if=linkBankAccountCtrl.model.otherInfo> <div class=gmw-recap-table__col> <span ng-bind=\"'Correspondent bank details / other instructions / bank wire memo'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=linkBankAccountCtrl.model.otherInfo></span> </span> </div> </div> </div> </div> <div class=gmw-flow-box__callout> <p translate> Confirm you have reviewed the information above, then click <span class=h-dark-text ng-bind=\"'Link Account'|translate\"></span>. Alternatively, click the back arrow at the top of this page to change the account details, or click <span class=h-dark-text ng-bind=\"'Cancel'|translate\"></span> to go back to Manage Bank Accounts. </p> </div> <holding-alert-legacy class=error ng-if=linkBankAccountCtrl.error> <span ng-bind=linkBankAccountCtrl.error></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls ng-if=!linkBankAccountCtrl.expired on-cancel=linkBankAccountCtrl.cancel() on-next=linkBankAccountCtrl.next() step-disabled=\"linkBankAccountCtrl.form.$invalid || linkBankAccountCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _overview = __webpack_require__(467);

var _overview2 = _interopRequireDefault(_overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bank-accounts').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bank-accounts.overview', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bank Accounts'
    },
    resolve: {
      AccountsResolve: ['$q', 'HoldingBankAccounts', function AccountsResolve($q, HoldingBankAccounts) {
        'ngInject';

        return HoldingBankAccounts.get().then(function (accounts) {
          return accounts.map(function (account) {
            account.canAftr = true;
            return account;
          });
        });
      }],
      SettingsResolve: ['$q', 'HoldingBankAccounts', 'AccountsResolve', function SettingsResolve($q, HoldingBankAccounts, AccountsResolve) {
        'ngInject';

        return HoldingBankAccounts.getSettings().then(function (settings) {
          if (settings.availableNumberOfBankAccounts > 0) {
            if (AccountsResolve.length > 0) {
              return $q.resolve(true);
            }
            return $q.reject({ redirectTo: 'holding.dashboard.bank-accounts.link' });
          }
          return settings;
        });
      }]
    },
    url: '/overview',
    views: {
      'bank-accounts-main': {
        controller: 'ManageAccountsOverviewController',
        controllerAs: 'manageAccountsOverviewCtrl',
        template: _overview2.default
      }
    }
  });
}]);

__webpack_require__(468);

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-messages-mobile-new mobile-only mobile-only--xs\" ui-sref=holding.dashboard.bank-accounts.link> <svg class=gmw-messages-mobile-new__icon> <use xlink:href=#plus-icon></use> </svg> <span class=heading-h5 ng-bind=\"'Add Bank Account'|translate\"></span> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Bank Accounts'|translate\"></h2> <p class=gmw-flow-box__header-description ng-bind=\"'Your Holding is linked to the following bank accounts, which can be used to wire funds to and from Goldmoney.'|translate\"> </p> </header> <div class=gmw-flow-box-container> <holding-alert-legacy class=info ng-if=manageAccountsOverviewCtrl.isLocked> <span ng-bind=\"'You\\'ve previously locked the ability to add or make changes to your linked bank accounts. Please contact'|translate\"></span> <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\">Relationship Management</a> <span ng-bind=\"'to change this security setting.'|translate\"></span> </holding-alert-legacy> <holding-alert-legacy class=info ng-if=!manageAccountsOverviewCtrl.canAdd> <span ng-bind=\"'You\\'ve linked the maximum number of bank accounts permitted at this time.'|translate\"></span> </holding-alert-legacy> <holding-bank-accounts ng-if=\"manageAccountsOverviewCtrl.accounts.length > 0\" accounts=manageAccountsOverviewCtrl.accounts> </holding-bank-accounts> </div> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I Add Funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ManageAccountsOverviewController.$inject = ['$scope', '$state', 'HoldingBankAccounts', 'HoldingUser', 'AccountsResolve'];
angular.module('app.holding.dashboard.bank-accounts').controller('ManageAccountsOverviewController', ManageAccountsOverviewController);

function ManageAccountsOverviewController($scope, $state, HoldingBankAccounts, HoldingUser, AccountsResolve) {
  'ngInject';

  var vm = this;

  function activate() {
    vm.canAdd = true;

    loadAccounts();
  }

  function loadAccounts() {
    HoldingBankAccounts.get().then(function (accounts) {
      vm.accounts = accounts;
    });

    var addBankAccountPermission = HoldingUser.getPermission('addBankAccount');
    vm.isLocked = addBankAccountPermission.message === 'lock';

    if (!vm.isLocked) {
      HoldingBankAccounts.getSettings().then(function (_ref) {
        var availableNumberOfBankAccounts = _ref.availableNumberOfBankAccounts;

        vm.canAdd = availableNumberOfBankAccounts > 0;
      });
    }
  }

  activate();

  $scope.$on('gmw:bank-accounts.updated', loadAccounts);
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars', [_angularjs2.default, _common2.default]).name;


__webpack_require__(470);
__webpack_require__(472);
__webpack_require__(474);
__webpack_require__(476);
__webpack_require__(478);
__webpack_require__(480);
__webpack_require__(482);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _availableUnregisteredBalance = __webpack_require__(471);

var _availableUnregisteredBalance2 = _interopRequireDefault(_availableUnregisteredBalance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingAvailableUnregisteredBalance', holdingAvailableUnregisteredBalance).name;


function holdingAvailableUnregisteredBalance() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      balance: '=',
      vault: '='
    },
    template: _availableUnregisteredBalance2.default
  };
}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "<div> <span class=\"heading-h2 h-dark-text\" ng-bind=\"'Available Unregistered Balance'|translate\"> </span> <gmw-main-table desktop-only=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Metal'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Grams'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Ounces'|translate\"> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col class=h-light-text> <holding-metal-badge metal=balance.currency></holding-metal-badge> <span ng-bind=balance.currency></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=vault|holdingVaultCustodian></span>&nbsp; <span ng-bind=bar.vault|holdingVaultLocation></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=\"balance|gmwFormatProduct:'g'\"> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=\"balance|gmwFormatProduct:'oz'\"> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <holding-metal-badge metal=balance.currency></holding-metal-badge> <span ng-bind=balance.currency></span> </div> <div class=gmw-simple-table__head-right> <gmw-flag country=vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=vault|holdingVaultCustodian></span> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Vault'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\"> <span ng-bind=vault|holdingVaultCustodian></span>&nbsp; <span ng-bind=vault|holdingVaultLocation></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Grams'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=\"balance|gmwFormatProduct:'g'\"> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Ounces'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=\"balance|gmwFormatProduct:'oz'\"> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _barList = __webpack_require__(473);

var _barList2 = _interopRequireDefault(_barList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingBarList', holdingBarList).name;


function holdingBarList() {
  'ngInject';

  return {
    link: link,
    require: '?ngModel',
    restrict: 'E',
    scope: {
      bars: '=',
      metal: '=',
      productCode: '=',
      select: '=',
      sortable: '=?',
      sorting: '=?'
    },
    template: _barList2.default
  };

  function link(scope, _element, attrs, model) {
    scope.showVault = Object.prototype.hasOwnProperty.call(attrs, 'vault');
    scope.showRegistrationId = Object.prototype.hasOwnProperty.call(attrs, 'registrationId');
    scope.showRegistrationDate = Object.prototype.hasOwnProperty.call(attrs, 'registrationDate');
    scope.model = model;
    scope.viewModel = {};

    scope.$watch('sorting', function (value) {
      scope.viewModel.sorting = value;
    });
    scope.$watch('viewModel.sorting', function (value) {
      scope.sorting = value;
    });

    scope.selectBar = function (bar) {
      if (scope.select && model) {
        model.$setViewValue(bar);
      }
    };
  }
}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "<gmw-main-table desktop-only=true small=true> <gmw-main-table-header ng-model=viewModel.sorting> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=refiner> <span ng-bind=\"'Bar Refiner'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=serialNumber> <span ng-bind=\"'Serial No.'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=assay> <span ng-bind=\"'Assay'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=grossUnit> <span ng-bind=\"'Gross Wt.'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=weightFineGM ng-if=\"metal === 'Gold'\"> <span ng-bind=\"'Fine Wt.'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=registrationId ng-if=::showRegistrationId> <span ng-bind=\"'Registration ID'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" field=barRegistrationDate ng-if=::showRegistrationDate> <span ng-bind=\"'Registration Date'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\" ng-if=::showVault> </gmw-main-table-header-col> <gmw-main-table-header-col ng-if=select class=\"gmw-main-table__head-cell--select heading-h5 h-light-text\"> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"bar in bars track by bar.code\" ng-click=selectBar(bar)> <gmw-main-table-body-col class=h-light-text ng-bind=::(bar.refiner|gmwTruncate:12)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::(bar.serialNumber)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::(bar.assay)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-if=\"metal === 'Gold'\"> <span ng-if=\"bar.productCode === 'GOLD_GDB'\" ng-bind=bar.weightGrossOunces|gmwFormatWeight:bar.metal> </span> <span ng-if=\"bar.productCode !== 'GOLD_GDB'\" ng-bind=bar.weightGrossGrams|gmwFormatWeight:bar.metal> </span> </span> <span ng-if=\"metal !== 'Gold'\"> <span ng-bind=::(bar.weightGrossOunces|gmwFormatWeight:bar.metal) class=h-dark-text></span> &nbsp;=&nbsp; <span ng-bind=::(bar.weightGrossGrams|gmwFormatWeight:bar.metal)></span> </span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-if=\"metal === 'Gold'\"> <span ng-bind=::(bar.weightFineOunces|gmwFormatWeight:bar.metal)></span>&nbsp;=&nbsp; <span ng-bind=::(bar.weightFineGrams|gmwFormatWeight:bar.metal) class=h-dark-text></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-if=::showRegistrationId ng-bind=\"::(bar.registrationId || '-')\"> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-if=::showRegistrationDate ng-bind=\"::((bar.barRegistrationDate|gmwFormatDate) || '-')\"> </gmw-main-table-body-col> <gmw-main-table-body-col ng-if=::showVault class=h-light-text> <gmw-flag country=bar.location|holdingVaultCountryCode></gmw-flag> <span ng-bind=bar.location|holdingVaultCustodian></span> </gmw-main-table-body-col> <gmw-main-table-body-col ng-if=select class=gmw-main-table__body-cell--select> <gmw-radio-option checked=\"model.$viewValue.code === bar.code\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"bar in bars track by bar.code\" ng-click=selectBar(bar)> <div class=gmw-simple-table__head ng-if=::showVault> <div class=gmw-simple-table__head-left> <holding-metal-badge metal=bar.metal></holding-metal-badge> <span ng-bind=bar.barProductCode|holdingProductName></span>&nbsp; </div> <div class=gmw-simple-table__head-right> <div> <gmw-radio-option ng-if=select checked=\"model.$viewValue.code === bar.code\" label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Vault'|translate\"> </span> <span class=gmw-simple-table__value> <gmw-flag country=bar.location|holdingVaultCountryCode></gmw-flag> <span ng-bind=bar.location|holdingVaultCustodian></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Bar Refiner'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bar.refiner> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Serial Number'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bar.serialNumber> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Assay'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bar.assay> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Gross Weight'|translate\"> </span> <span class=gmw-simple-table__value> <span ng-if=\"metal === 'Gold'\"> <span ng-if=\"bar.productCode === 'GOLD_GDB'\" ng-bind=bar.weightGrossOunces|gmwFormatWeight:bar.metal> </span> <span ng-if=\"bar.productCode !== 'GOLD_GDB'\" ng-bind=bar.weightGrossGrams|gmwFormatWeight:bar.metal> </span> </span> <span ng-if=\"metal !== 'Gold'\"> <span ng-bind=::(bar.weightGrossOunces|gmwFormatWeight:bar.metal)></span> &nbsp;=&nbsp; <span ng-bind=::(bar.weightGrossGrams|gmwFormatWeight:bar.metal)></span> </span> </span> </div> <div class=gmw-simple-table__row ng-if=\"metal==='Gold'\"> <span ng-bind=::(bar.weightFineOunces|gmwFormatWeight:bar.metal)></span> &nbsp;=&nbsp; <span ng-bind=::(bar.weightFineGrams|gmwFormatWeight:bar.metal)></span> </div> <div class=gmw-simple-table__row ng-if=::showRegistrationId> <span class=gmw-simple-table__label ng-bind=\"'Registration ID'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bar.registrationId> </span> </div> <div class=gmw-simple-table__row ng-if=::showRegistrationDate> <span class=gmw-simple-table__label ng-bind=\"'Registration Date'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bar.barRegistrationDate|gmwFormatDate> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingBarsBalance.$inject = ['HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _barsBalance = __webpack_require__(475);

var _barsBalance2 = _interopRequireDefault(_barsBalance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingBarsBalance', holdingBarsBalance).name;


function holdingBarsBalance(HoldingUser) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      bars: '=',
      equivalentCurrency: '='
    },
    template: _barsBalance2.default
  };

  function link(scope) {
    function closeMenu() {
      moreMenuFlyoutActive = undefined;
      moreMenuMobileFlyoutActive = undefined;
    }

    function isMoreMenuFlyoutActive(index) {
      return moreMenuFlyoutActive === index;
    }

    function isMoreMenuMobileFlyoutActive(index) {
      return moreMenuMobileFlyoutActive === index;
    }

    function openMoreMenuFlyout(index) {
      moreMenuFlyoutActive = index;
    }

    function openMoreMenuMobileFlyout(index) {
      moreMenuMobileFlyoutActive = index;
    }

    var moreMenuFlyoutActive = void 0,
        moreMenuMobileFlyoutActive = void 0;
    var user = HoldingUser.get();

    scope.canRegisterBars = HoldingUser.isAllowed('allocateBars');
    scope.closeMenu = closeMenu;
    scope.isMoreMenuFlyoutActive = isMoreMenuFlyoutActive;
    scope.isMoreMenuMobileFlyoutActive = isMoreMenuMobileFlyoutActive;
    scope.openMoreMenuFlyout = openMoreMenuFlyout;
    scope.openMoreMenuMobileFlyout = openMoreMenuMobileFlyout;
    scope.user = user;

    var flyoutListener = scope.$on('gmw:flyout:close', closeMenu);
    scope.$on('$destroy', function () {
      flyoutListener();
    });
  }
}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <header class=gmw-table-header> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title desktop-only desktop-only--xs\" ng-bind=\"'Registered Bars'|translate\"> </h2> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title mobile-only mobile-only--xs\" ng-bind=\"'Bars'|translate\"> </h2> <div class=\"gmw-table-header__actions desktop-only desktop-only--xs\" ng-if=canRegisterBars> <button class=small-main-cta ui-sref=holding.dashboard.bars.registration ng-bind=\"'Manage Bars'|translate\"> </button> </div> <div class=\"gmw-table-header__actions mobile-only mobile-only--xs\" ng-if=canRegisterBars> <div class=gmw-dual-dot-data> <a ui-sref=holding.dashboard.bars.registration class=\"heading-h5 h-gold-text\" ng-bind=\"'Manage'|translate\"> </a> </div> </div> </header> <gmw-main-table desktop-only=true> <gmw-main-table-header class=gmw-main-table__head--extra-right-padding> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--30 heading-h5 h-light-text\" ng-bind=\"'Bar Type'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--10 gmw-main-table__head-cell--align-right\" ng-bind=\"'Quantity'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--20\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--align-right\" ng-bind=\"'Balance'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--15 gmw-main-table__head-cell--align-right\"> <span ng-bind=\"('In '|translate) + equivalentCurrency\"></span> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"bar in bars track by $index\"> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--30 h-light-text\"> <a ui-sref=\"holding.dashboard.bars.registered({\n            location: bar.vault,\n            product: bar.barProductionCode,\n          })\"> <holding-metal-badge metal=::bar.barCurrCode></holding-metal-badge> <span ng-bind=bar.barProductionCode|holdingProductName></span> </a> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-light-text gmw-main-table__body-cell--10 gmw-main-table__head-cell--align-right\"> <span ng-bind=bar.barCount></span>&nbsp; <span ng-if=\"bar.barCount > 1\" ng-bind=\"'bars'|translate\"></span> <span ng-if=\"bar.barCount === 1\" ng-bind=\"'bar'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--20> <gmw-flag country=bar.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=bar.vault|holdingVaultCustodian></span>&nbsp; <span ng-bind=bar.vault|holdingVaultLocation></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-light-text gmw-main-table__head-cell--align-right\"> <span ng-if=\"bar.spendable.currency !== 'Silver'\" ng-bind=\"(bar.gram|gmwFormatNumber) + ' G'\"></span> <span ng-if=\"bar.spendable.currency === 'Silver'\" ng-bind=\"(bar.oz|gmwFormatNumber) + ' OZ'\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-dark-text gmw-main-table__body-cell--15 gmw-main-table__head-cell--align-right\" ng-bind=bar.equivalent|holdingFormatFunds> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--icon ng-if=!user.locked ng-click=openMoreMenuFlyout($index) gmw-focus-out-flyout-close=\"{{isMoreMenuFlyoutActive($index)}}\"> <holding-bars-more-menu is-active=isMoreMenuFlyoutActive($index) bar=bar> </holding-bars-more-menu> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"bar in bars track by $index\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <a ui-sref=\"holding.dashboard.bars.registered({ location: bar.vault, product: bar.barProductionCode })\"> <holding-metal-badge metal=::bar.barCurrCode></holding-metal-badge> <span ng-bind=bar.barProductionCode|holdingProductName></span> </a> </div> <div class=gmw-simple-table__head-right> <gmw-flag country=bar.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=bar.vault|holdingVaultCustodian></span> </div> <div class=\"c-vault-more gmw-simple-table__head-more\" ng-if=!user.locked> <div class=c-vault-more__icon-container ng-click=openMoreMenuMobileFlyout($index) gmw-focus-out-flyout-close=\"{{isMoreMenuMobileFlyoutActive($index)}}\"> <holding-bars-more-menu is-active=isMoreMenuMobileFlyoutActive($index) bar=bar> </holding-bars-more-menu> <holding-svg-icon class=c-vault-more__icon icon=vertical-more> </holding-svg-icon> </div> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Quantity'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\"> <span ng-bind=bar.barCount></span>&nbsp; <span ng-if=\"bar.barCount > 1\" ng-bind=\"'bars'|translate\"></span> <span ng-if=\"bar.barCount === 1\" ng-bind=\"'bar'|translate\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Vault'|translate\"></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\"> <span ng-bind=bar.vault|holdingVaultCustodian></span>&nbsp; <span ng-bind=bar.vault|holdingVaultLocation></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Grams'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=\"(bar.gram|gmwFormatNumber) + ' G'\"> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Ounces'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=\"(bar.oz|gmwFormatNumber) + ' OZ'\"> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"('In '|translate) + equivalentCurrency\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=bar.equivalent|holdingFormatFunds> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingBarsMoreMenu.$inject = ['HoldingUser', 'HoldingBars', 'HoldingTransactions'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _barsMoreMenu = __webpack_require__(477);

var _barsMoreMenu2 = _interopRequireDefault(_barsMoreMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingBarsMoreMenu', holdingBarsMoreMenu).name;


function holdingBarsMoreMenu(HoldingUser, HoldingBars, HoldingTransactions) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      bar: '=',
      isActive: '='
    },
    template: _barsMoreMenu2.default
  };

  function link(scope) {
    function hasLockedMetal() {
      return scope.metal.locks ? scope.metal.locks.length > 0 : false;
    }

    function hasReservedMetal() {
      return scope.metal.reserved && 'amount' in scope.metal.reserved ? scope.metal.reserved.amount > 0 : false;
    }

    function hasSpendableMetal() {
      return scope.metal.spendable && 'amount' in scope.metal.spendable ? scope.metal.spendable.amount > 0 : false;
    }

    scope.canDeregisterMetal = HoldingUser.isAllowed('allocateBars');
    HoldingBars.getRegistrationProducts().then(function (products) {
      scope.canRegisterMetal = HoldingUser.isAllowed('allocateBars') && products.filter(function (product) {
        return product.barProductCode === scope.bar.barProductionCode;
      }).filter(function (product) {
        return product.vaults.find(function (vault) {
          return vault === scope.bar.vault;
        });
      }).length > 0;
    });
  }
}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "<div class=c-vault-more> <div class=c-vault-menu ng-class=\"{\n      'c-vault-menu--active': isActive,\n    }\"> <span class=\"c-vault-menu__balance h-margin-top-10\"> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your total registered bar balance'|translate}}\"> <span ng-bind=\"'Balance:'|translate\"></span> </span> <span class=h-dark-text> <span ng-if=\"bar.spendable.currency !== 'Silver'\"> <span ng-bind=bar.spendable|gmwFormatProduct:null:true></span> </span> <span ng-if=\"bar.spendable.currency === 'Silver'\"> <span ng-bind=\"(bar.spendable.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </span> </span> <hr class=c-vault-menu__divider> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.bars.registered({\n        product: bar.barProductionCode,\n        location: bar.vault,\n      })\"> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=bar-document width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Registration details'|translate\"></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.bars.registration({\n        product: bar.barProductionCode,\n        vault: bar.vault,\n      })\" ng-if=canRegisterMetal> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=document-star width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Register more bars'|translate\"></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.bars.registration({\n        product: bar.barProductionCode,\n        vault: bar.vault,\n      })\" ng-if=canDeregisterMetal> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=document-false width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Deregister bars'|translate\"></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.messages.compose({\n        category: 'COLLECT_DELIVER_METAL',\n      })\" ng-if=canDeregisterMetal> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=delivery width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Take delivery'|translate\"></span> </span> </a> </div> <div class=c-vault-more__icon-container> <holding-svg-icon class=c-vault-more__icon icon=vertical-more> </holding-svg-icon> </div> </div> ";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _registeredBars = __webpack_require__(479);

var _registeredBars2 = _interopRequireDefault(_registeredBars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingRegisteredBars', holdingRegisteredBars).name;


function holdingRegisteredBars() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      metal: '=',
      totals: '=',
      vault: '='
    },
    template: _registeredBars2.default
  };
}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=registered-bars-header> <span class=\"heading-h2 h-dark-text\" ng-bind=\"'Registered Bars'|translate\"> </span> <span class=\"heading-h5 h-gold-text\"> <span ng-bind=\"'Registration ID:'|translate\"></span> <span ng-bind=totals.registrationId></span> </span> </div> <gmw-main-table desktop-only=true small=true ng-if=\"totals.number > 0\"> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Quantity'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Assay'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Gross weight'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-if=\"metal === 'Gold'\" ng-bind=\"'Fine weight'|translate\"> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col class=h-light-text> <span ng-bind=totals.barProductCode|holdingProductName></span>&nbsp; <span ng-if=\"totals.number > 1\">{{totals.number}} bars</span> <span ng-if=\"totals.number === 1\">{{totals.number}} bar</span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=totals.assay> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=totals.weightGrossGrams|gmwFormatWeight> </gmw-main-table-body-col> <gmw-main-table-body-col ng-if=\"metal === 'Gold'\" class=h-light-text ng-bind=totals.weightFineGrams|gmwFormatWeight> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\" ng-if=\"totals.number > 0\"> <div class=gmw-simple-table> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <holding-metal-badge metal=metal></holding-metal-badge> </div> <div class=gmw-simple-table__head-right> <gmw-flag country=vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=vault|holdingVaultCustodian></span> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Quantity'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\"> <span ng-if=\"totals.number > 1\">{{totals.number}} bars</span> <span ng-if=\"totals.number === 1\">{{totals.number}} bar</span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Assay'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=totals.assay> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Gross Weight'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=totals.weightGrossGrams|gmwFormatWeight> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-if=\"metal === 'Gold'\" ng-bind=\"'Fine Weight'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=totals.weightFineGrams|gmwFormatWeight> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _registrationRecap = __webpack_require__(481);

var _registrationRecap2 = _interopRequireDefault(_registrationRecap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingRegistrationRecap', holdingRegistrationRecap).name;


function holdingRegistrationRecap() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      bars: '=',
      mode: '=',
      totals: '='
    },
    template: _registrationRecap2.default
  };
}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <gmw-recap-table-header ng-if=\"mode === 'register'\" label=\"{{'Bar Registration Summary'|translate}}\"> </gmw-recap-table-header> <gmw-recap-table-header ng-if=\"mode === 'deregister'\" label=\"{{'Bar Deregistration Summary'|translate}}\"> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Total Weight'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-switch=totals.metal> <span ng-switch-when=Silver ng-bind=totals.weightGrossOunces|gmwFormatWeight> </span> <span ng-switch-when=Gold ng-bind=totals.weightFineGrams|gmwFormatWeight> </span> <span ng-switch-default ng-bind=totals.weightGrossGrams|gmwFormatWeight> </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-switch=mode> <span ng-switch-when=deregister translate>Deregistration Fee</span> <span ng-switch-when=register translate>Registration Fee</span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=totals.totalFee|gmwFormatWeight></span> <span class=h-light-text> ({{totals.fee|gmwFormatWeight}} ⁄ bar) </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-switch=mode> <span ng-switch-when=deregister ng-bind=\"'Total Addition to Unregistered Metal Weight'|translate\"> </span> <span ng-switch-when=register ng-bind=\"'Total Deduction from Unregistered Metal Weight'|translate\"> </span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-switch=mode> <span ng-switch-when=register ng-bind=totals.weightPlusFee|gmwFormatWeight> </span> <span ng-switch-when=deregister ng-bind=totals.weightPlusFee|gmwFormatWeight> </span> </span> </div> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <gmw-recap-table-header ng-if=\"mode === 'register'\" label=\"{{'Bar Registration Details'|translate}}\"> </gmw-recap-table-header> <gmw-recap-table-header ng-if=\"mode === 'deregister'\" label=\"{{'Bar Deregistration Details'|translate}}\"> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\" ng-repeat=\"bar in bars\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Bar Refiner'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=bar.refiner></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Serial Number'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=bar.serialNumber></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Assay'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=bar.assay></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Gross Weight'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-switch=bar.metal> <span ng-switch-when=Silver ng-bind=bar.weightGrossOunces|gmwFormatWeight> </span> <span ng-switch-default ng-bind=bar.weightGrossGrams|gmwFormatWeight> </span> </span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=\"bar.metal === 'Gold'\"> <div class=gmw-recap-table__col> <span ng-bind=\"'Fine Weight'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=bar.weightFineOunces|gmwFormatWeight> </span> &nbsp;=&nbsp; <span class=h-dark-text ng-bind=bar.weightFineGrams|gmwFormatWeight> </span> </span> </div> </div> </div> </div> ";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redemptionsList = __webpack_require__(483);

var _redemptionsList2 = _interopRequireDefault(_redemptionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').directive('holdingRedemptionsList', holdingRedemptionsList).name;


function holdingRedemptionsList() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      orders: '='
    },
    template: _redemptionsList2.default
  };
}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "<gmw-main-table desktop-only=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Order Placed'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'ID'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Quantity'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Method'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Status'|translate\"> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"order in orders track by order.number\"> <gmw-main-table-body-col class=h-light-text ng-bind=::(order.placedAt|gmwFormatDateTime)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::order.number> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-repeat=\"bar in order.bars\"> {{::bar.qty}} &times; <span ng-if=\"bar.metal.amount === 100\">100 gram bar<span ng-if=!$last>,</span></span> <span ng-if=\"bar.metal.amount === 1000\">1 kilogram bar<span ng-if=!$last>,</span></span> </span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-if=::order.delivery>Delivery</span> <span ng-if=::!order.delivery>Collection</span> </gmw-main-table-body-col> <gmw-main-table-body-col ng-switch=::order.status> <span ng-switch-when=Received class=h-orange-text> In progress </span> <span ng-switch-when=Processed class=h-blue-text> <span ng-if=::order.delivery>Preparing for Shipment</span> <span ng-if=::!order.delivery>Ready for Collection</span> </span> <span ng-switch-when=Completed class=h-green-text> <span ng-if=::order.delivery>Shipped</span> <span ng-if=::!order.delivery>Collected</span> </span> <span ng-switch-when=Canceled class=h-red-text> Canceled </span> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"order in orders track by order.number\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <span ng-bind=\"'Order ID'|translate\"></span> <span ng-bind=order.number></span> </div> <div class=gmw-simple-table__head-right ng-switch=::order.status> <span ng-switch-when=Received class=h-orange-text> In progress </span> <span ng-switch-when=Processed class=h-blue-text> <span ng-if=::order.delivery>Preparing for Shipment</span> <span ng-if=::!order.delivery>Ready for Collection</span> </span> <span ng-switch-when=Completed class=h-green-text> <span ng-if=::order.delivery>Shipped</span> <span ng-if=::!order.delivery>Collected</span> </span> <span ng-switch-when=Canceled class=h-red-text> Canceled </span> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Order Placed'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::(order.placedAt|gmwFormatDateTime)> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Quantity'|translate\"> </span> <span class=gmw-simple-table__value> <span ng-repeat=\"bar in order.bars\"> {{::bar.qty}} &times; <span ng-if=\"bar.metal.amount === 100\">100 gram bar<span ng-if=!$last>,</span></span> <span ng-if=\"bar.metal.amount === 1000\">1 kilogram bar<span ng-if=!$last>,</span></span> </span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Method'|translate\"> </span> <span class=gmw-simple-table__value> <span ng-if=::order.delivery>Delivery</span> <span ng-if=::!order.delivery>Collection</span> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingProductName.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.bars').filter('holdingProductName', holdingProductName).name;


function holdingProductName(gettextCatalog) {
  'ngInject';

  var productCodeDescriptions = {
    GOLD_GDB: gettextCatalog.getString('Gold Good Delivery Bar'),
    GOLD_1KG: gettextCatalog.getString('Gold 1kg Bar'),
    GOLD_100G: gettextCatalog.getString('Gold 100g Bar'),
    SILVER_GDB: gettextCatalog.getString('Silver Good Delivery Bar'),
    SILVER_1KG: gettextCatalog.getString('Silver 1kg Bar'),
    PLATINUM_GDB: gettextCatalog.getString('Platinum Good Delivery Bar'),
    PALLADIUM_GDB: gettextCatalog.getString('Palladium Good Delivery Bar')
  };

  return function (input) {
    var capitalize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var productName = productCodeDescriptions[input];
    return capitalize ? productName : productName.toLowerCase();
  };
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.bars').filter('holdingProductMetal', holdingProductMetal).name;


function holdingProductMetal() {
  'ngInject';

  return productName;

  function productName(input) {
    switch (input) {
      case 'GOLD_GDB':
      case 'GOLD_1KG':
      case 'GOLD_100G':
        return 'Gold';
      case 'SILVER_GDB':
        return 'Silver';
      case 'SILVER_1KG':
        return 'Silver';
      case 'PLATINUM_GDB':
        return 'Platinum';
      case 'PALLADIUM_GDB':
        return 'Palladium';
      default:
        return undefined;
    }
  }
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingBars.$inject = ['$rootScope', 'HoldingApi', 'HoldingUser', 'promiseCache'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.bars').factory('HoldingBars', HoldingBars).name;


function HoldingBars($rootScope, HoldingApi, HoldingUser, promiseCache) {
  'ngInject';

  var key = 'gmw:bars:available';

  return {
    deregister: deregister,
    getAll: getAll,
    getAvailableBalance: getAvailableBalance,
    getAvailableBars: getAvailableBars,
    getCurrencyFromProduct: getCurrencyFromProduct,
    getFilters: getFilters,
    getRandomBars: getRandomBars,
    getRegisteredBars: getRegisteredBars,
    getRegistrationProducts: getRegistrationProducts,
    getTotals: getTotals,
    getWeightPlusFee: getWeightPlusFee,
    getWeightFromProduct: getWeightFromProduct,
    isGDB: isGDB,
    register: register,
    showRegisterBars: showRegisterBars
  };

  function addDefault(bar) {
    if (!bar.qty) {
      bar.qty = 0;
    }
    return bar;
  }

  function deregister(bars, _ref) {
    var barProductCode = _ref.barProductCode,
        location = _ref.vault;

    var barCodes = bars.map(function (bar) {
      return bar.code;
    });
    return HoldingApi.put('bars/deallocated', { barCodes: barCodes, barProductCode: barProductCode, location: location }).then(notifyBarsChanged);
  }

  function getAll(_ref2) {
    var metal = _ref2.metal,
        location = _ref2.location,
        barProductCode = _ref2.barProductCode,
        page = _ref2.page,
        sorting = _ref2.sorting;

    var params = {
      metal: metal,
      location: location,
      barProductCode: barProductCode,
      'dataLimit.limit': 25,
      'dataLimit.offset': 25 * page,
      'sorting.field': sorting.field,
      'sorting.type': sorting.type
    };
    return HoldingApi.get('bars/all', { params: params });
  }

  function getAvailableBalance(_ref3) {
    var barProductCode = _ref3.barProductCode,
        location = _ref3.vault;

    return HoldingApi.get('bars/availableBalance', { params: { barProductCode: barProductCode, location: location } }).then(function (_ref4) {
      var available = _ref4.available;
      return available;
    });
  }

  function getAvailableBars(_ref5) {
    var barProductCode = _ref5.barProductCode,
        _ref5$page = _ref5.page,
        page = _ref5$page === undefined ? 0 : _ref5$page,
        sorting = _ref5.sorting,
        location = _ref5.vault;

    var metal = getCurrencyFromProduct(barProductCode);
    var params = {
      barProductCode: barProductCode,
      location: location,
      metal: metal,
      'sorting.field': sorting.field,
      'sorting.type': sorting.type
    };
    if (isGDB(barProductCode)) {
      params['dataLimit.limit'] = 10;
      params['dataLimit.offset'] = 10 * page;
    }
    return HoldingApi.get('bars/available', { params: params });
  }

  function getCurrencyFromProduct(productCode) {
    switch (productCode) {
      case 'GOLD_GDB':
      case 'GOLD_1KG':
      case 'GOLD_100G':
      default:
        return 'Gold';
      case 'SILVER_GDB':
      case 'SILVER_1KG':
        return 'Silver';
      case 'PLATINUM_GDB':
        return 'Platinum';
      case 'PALLADIUM_GDB':
        return 'Palladium';
    }
  }

  function getFilters() {
    return HoldingApi.get('bars/filters');
  }

  function getRandomBars(_ref6) {
    var amount = _ref6.amount,
        barProductCode = _ref6.barProductCode,
        location = _ref6.vault;

    var params = {
      metal: getCurrencyFromProduct(barProductCode),
      location: location,
      barProductCode: barProductCode,
      'dataLimit.limit': amount
    };
    return HoldingApi.get('bars/availableRandom', { params: params });
  }

  function getRegisteredBars(_ref7) {
    var barProductCode = _ref7.barProductCode,
        location = _ref7.location,
        sorting = _ref7.sorting;

    var params = {
      barProductCode: barProductCode,
      location: location,
      'dataLimit.limit': Number.MAX_SAFE_INTEGER,
      'sorting.field': sorting.field,
      'sorting.type': sorting.type
    };
    return HoldingApi.get('bars/registered', { params: params });
  }

  function getRegistrationProducts() {
    return promiseCache({
      key: key,
      ttl: 600000,
      promise: function promise() {
        return HoldingApi.get('bars/availableProduct');
      }
    });
  }

  function getWeightFromProduct(productCode) {
    switch (productCode) {
      case 'GOLD_100G':
        return 100;
      case 'GOLD_1KG':
        return 1000;
      case 'SILVER_1KG':
        return 32.1507;
      case 'SILVER_GDB':
        return 1000;
      case 'PLATINUM_100G':
        return 100;
      case 'PLATINUM_GDB':
        return 1000;
      case 'PALLADIUM_100G':
        return 100;
      case 'PALLADIUM_GDB':
        return 1000;
      default:
        return 12441.3907;
    }
  }

  function getTotals(bars) {
    return bars.reduce(function (prev, curr) {
      return {
        number: prev.number + 1,
        metal: curr.metal,
        weightFineGrams: {
          amount: prev.weightFineGrams.amount + curr.weightFineGrams.amount,
          currency: curr.metal,
          weightUnit: 'GRAMS'
        },
        weightFineOunces: {
          amount: prev.weightFineOunces.amount + curr.weightFineOunces.amount,
          currency: curr.metal,
          weightUnit: 'OUNCES'
        },
        weightGrossGrams: {
          amount: prev.weightGrossGrams.amount + curr.weightGrossGrams.amount,
          currency: curr.metal,
          weightUnit: 'GRAMS'
        },
        weightGrossOunces: {
          amount: prev.weightGrossOunces.amount + curr.weightGrossOunces.amount,
          currency: curr.metal,
          weightUnit: 'OUNCES'
        },
        totalFee: {
          amount: prev.totalFee.amount + (curr.fee ? curr.fee.amount : 0),
          currency: curr.fee ? curr.fee.currency : getCurrencyFromProduct(curr.productCode),
          weightUnit: curr.metal === 'Silver' ? 'OUNCES' : 'GRAMS'
        },
        fee: {
          amount: curr.fee ? curr.fee.amount : 0,
          currency: curr.fee ? curr.fee.currency : getCurrencyFromProduct(curr.productCode),
          weightUnit: curr.metal === 'Silver' ? 'OUNCES' : 'GRAMS'
        },
        weightPlusFee: {
          amount: prev.weightPlusFee.amount + getWeightPlusFee(curr),
          currency: getCurrencyFromProduct(curr.productCode),
          weightUnit: curr.metal === 'Silver' ? 'OUNCES' : 'GRAMS'
        }
      };
    }, {
      number: 0,
      weightFineGrams: { amount: 0 },
      weightFineOunces: { amount: 0 },
      weightGrossGrams: { amount: 0 },
      weightGrossOunces: { amount: 0 },
      totalFee: { amount: 0 },
      fee: { amount: 0 },
      weightPlusFee: { amount: 0 }
    });
  }

  function getWeightPlusFee(bar) {
    var fee = bar.fee ? bar.fee.amount : 0;
    switch (bar.metal) {
      case 'Silver':
        return bar.weightGrossOunces.amount + fee;
      case 'Gold':
        return bar.weightFineGrams.amount + fee;
      default:
        return bar.weightGrossGrams.amount + fee;
    }
  }

  function isGDB(productCode) {
    return ['GOLD_GDB', 'SILVER_GDB', 'PLATINUM_GDB', 'PALLADIUM_GDB'].includes(productCode);
  }

  function notifyBarsChanged() {
    $rootScope.$broadcast('gmw:balance:changed');
  }

  function register(bars, barRegistrationId, _ref8) {
    var barProductCode = _ref8.barProductCode,
        location = _ref8.vault;

    var barCodes = bars.map(function (bar) {
      return bar.code;
    });
    return HoldingApi.post('bars', { barCodes: barCodes, barRegistrationId: barRegistrationId, barProductCode: barProductCode, location: location }).then(notifyBarsChanged);
  }

  function showRegisterBars() {
    return !HoldingUser.isHidden('allocateBars');
  }
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(488);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(489);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.bars').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars', {
    abstract: true,
    url: '/bars',
    views: {
      hero: {
        controller: ['HoldingBars', function controller(HoldingBars) {
          'ngInject';

          this.showRegisterBars = HoldingBars.showRegisterBars();
        }],
        controllerAs: 'barsHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });

  $urlRouterProvider.when('/bars', '/bars/delivery');
  $urlRouterProvider.when('/bars/registration', '/bars/registration/select');
}]).name;


__webpack_require__(490);
__webpack_require__(493);
__webpack_require__(496);

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Bar Registration'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center ng-if=barsHeroCtrl.showRegisterBars> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item ng-if=barsHeroCtrl.showRegisterBars label=\"'Registration'|translate\" mobile-label=\"'Registration'|translate\" ui-sref=holding.dashboard.bars.registration ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item ng-if=barsHeroCtrl.showRegisterBars label=\"'Lists'|translate\" mobile-label=\"'Lists'|translate\" ui-sref=holding.dashboard.bars.lists ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=bars-main></div> ";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lists = __webpack_require__(491);

var _lists2 = _interopRequireDefault(_lists);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bars').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars.lists', {
    data: {
      pageTitle: 'Bar Registration - Bar Lists'
    },
    url: '/lists',
    views: {
      'bars-main': {
        controller: 'BarsListsController',
        controllerAs: 'barsListsCtrl',
        template: _lists2.default
      }
    }
  });
}]);

__webpack_require__(492);

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h4 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Bar Lists'|translate\"></h4> </header> <div class=gmw-flow-box-container ng-form=barsListsCtrl.form> <div ng-if=barsListsCtrl.error> <holding-alert-legacy class=error> <span ng-bind=barsListsCtrl.error></span> </holding-alert-legacy> </div> <div class=\"gmw-input-container gmw-input-container--split-thirds\"> <gmw-box-selector required name=metal class=gmw-input-container--split-thirds__col ng-model=barsListsCtrl.params.metal options=barsListsCtrl.metalOptions> </gmw-box-selector> <gmw-box-selector required name=barProductCode class=gmw-input-container--split-thirds__col ng-model=barsListsCtrl.params.barProductCode options=barsListsCtrl.barProductCodeOptions> </gmw-box-selector> <gmw-box-selector required name=vault class=gmw-input-container--split-thirds__col ng-model=barsListsCtrl.params.location options=barsListsCtrl.vaultOptions> </gmw-box-selector> </div> <div ng-if=barsListsCtrl.total> <h5 class=\"heading-h2 h-dark-text\" translate> {{barsListsCtrl.params.location|holdingVaultCustodian}} {{barsListsCtrl.params.location|holdingVaultLocation}} {{barsListsCtrl.params.barProductCode|holdingProductName}} Bar List ({{barsListsCtrl.total.count}} bars) </h5> <div class=gmw-flow-box__description> <div class=gmw-bars-totals> <span ng-bind=\"'Total Gross Weight (ounces):'|translate\"></span> <span class=h-dark-text ng-bind=barsListsCtrl.total.weightGrossOunces|gmwFormatWeight:barsListsCtrl.params.metal> </span> </div> <div class=gmw-bars-totals ng-if=\"barsListsCtrl.params.metal !== 'Gold'\"> <span ng-bind=\"'Total Gross Weight (grams):'|translate\"></span> <span class=h-dark-text ng-bind=barsListsCtrl.total.weightGrossGrams|gmwFormatWeight:barsListsCtrl.params.metal> </span> </div> <div class=gmw-bars-totals ng-if=\"barsListsCtrl.params.metal === 'Gold'\"> <span ng-bind=\"'Total Fine Weight (ounces):'|translate\"></span> <span class=h-dark-text ng-bind=barsListsCtrl.total.weightFineOunces|gmwFormatWeight:barsListsCtrl.params.metal> </span> </div> <div class=gmw-bars-totals ng-if=\"barsListsCtrl.params.metal === 'Gold'\"> <span ng-bind=\"'Total Fine Weight (grams):'|translate\"></span> <span class=h-dark-text ng-bind=barsListsCtrl.total.weightFineGrams|gmwFormatWeight:barsListsCtrl.params.metal> </span> </div> </div> </div> <holding-bar-list ng-if=barsListsCtrl.bars bars=barsListsCtrl.bars metal=barsListsCtrl.params.metal product-code=barsListsCtrl.params.barProductCode sorting=barsListsCtrl.params.sorting registration-id sortable=true> </holding-bar-list> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ng-if=barsListsCtrl.showPrev ng-click=barsListsCtrl.prevPage() ng-bind=\"'Previous'|translate\" ng-disabled=barsListsCtrl.updating> </button> </div> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <span class=\"heading-h4 h-gold-text\" translate> Page {{(barsListsCtrl.params.page + 1)|gmwTranslateNumber}} of {{barsListsCtrl.totalPages|gmwTranslateNumber}} </span> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ng-if=barsListsCtrl.showNext ng-click=barsListsCtrl.nextPage() ng-bind=\"'Next'|translate\" ng-disabled=barsListsCtrl.updating> </button> </div> </footer> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I Add Funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


BarsListsController.$inject = ['$filter', '$scope', 'gettextCatalog', 'HoldingBars', 'HoldingVaults', 'HoldingAppUtilities'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app.holding.dashboard.bars').controller('BarsListsController', BarsListsController);

function BarsListsController($filter, $scope, gettextCatalog, HoldingBars, HoldingVaults, HoldingAppUtilities) {
  'ngInject';

  var vm = this;
  vm.nextPage = nextPage;
  vm.prevPage = prevPage;

  vm.params = {
    page: 0,
    sorting: {
      field: 'refiner',
      type: 'asc'
    }
  };

  activate();

  function activate() {
    var productNameFilter = $filter('holdingProductName');
    var locationNameFilter = $filter('holdingVaultLocation');

    HoldingBars.getFilters().then(function (filters) {
      vm.filters = filters;

      vm.metalOptions = ['Gold', 'Silver', 'Platinum', 'Palladium'].map(function (value) {
        return {
          value: value,
          label: gettextCatalog.getString(value),
          metal: value
        };
      });
      vm.params.metal = 'Gold';

      $scope.$watch('barsListsCtrl.params.metal', function (metal) {
        if (metal) {
          vm.barProductCodeOptions = Object.keys(vm.filters[metal]).map(function (productCode) {
            return {
              value: productCode,
              label: productNameFilter(productCode)
            };
          });
          vm.params.barProductCode = Object.keys(vm.filters[metal])[0];
        }
      });

      $scope.$watchGroup(['barsListsCtrl.params.metal', 'barsListsCtrl.params.barProductCode'], function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            metal = _ref2[0],
            barProductCode = _ref2[1];

        if (metal && barProductCode) {
          vm.vaultOptions = vm.filters[metal][barProductCode].map(function (vault) {
            var vaultInfo = HoldingVaults.getVaultInfoById(vault);
            var name = vaultInfo.name;
            var country = locationNameFilter(vault);
            return {
              value: vault,
              label: name + ' ' + country
            };
          });
          vm.params.location = vm.filters[metal][barProductCode][0];
        }
      });

      $scope.$watchGroup(['barsListsCtrl.params.metal', 'barsListsCtrl.params.barProductCode', 'barsListsCtrl.params.location', 'barsListsCtrl.params.page', 'barsListsCtrl.params.sorting.field', 'barsListsCtrl.params.sorting.type'], HoldingAppUtilities.throttle(updateBars, 100));
    });
  }

  function nextPage() {
    vm.params.page += 1;
  }

  function prevPage() {
    vm.params.page -= 1;
  }

  function updateBars(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 4),
        metal = _ref4[0],
        barProductCode = _ref4[1],
        location = _ref4[2],
        page = _ref4[3];

    vm.error = null;
    vm.total = null;
    if (metal && barProductCode && location) {
      vm.updating = true;
      HoldingBars.getAll(vm.params).then(function (_ref5) {
        var bars = _ref5.bars,
            count = _ref5.count;

        vm.bars = bars;
        vm.total = count;
        vm.showNext = (page + 1) * 25 < count.count;
        vm.showPrev = page > 0;
        vm.totalPages = Math.ceil(count.count / 25);
      }).catch(function (error) {
        vm.error = error.message;
      }).finally(function () {
        vm.updating = false;
      });
    }
  }
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _registered = __webpack_require__(494);

var _registered2 = _interopRequireDefault(_registered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bars').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars.registered', {
    data: {
      pageTitle: 'Bar Registration - Managed Registered Bars'
    },
    url: '/registered/:location/:product',
    views: {
      'bars-main': {
        controller: 'RegisteredBarsController',
        controllerAs: 'registeredBarsCtrl',
        template: _registered2.default
      }
    }
  });
}]);

__webpack_require__(495);

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h4 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Your Registered Bars'|translate\"></h4> </header> <div class=gmw-flow-box-container ng-form=registeredBarsCtrl.form> <div ng-if=registeredBarsCtrl.error> <holding-alert-legacy class=error> <span ng-bind=registeredBarsCtrl.error></span> </holding-alert-legacy> </div> <div ng-if=registeredBarsCtrl.total> <h5 class=\"heading-h2 h-dark-text\"> {{registeredBarsCtrl.model.location|holdingVaultCustodian}} {{registeredBarsCtrl.model.location|holdingVaultLocation}} {{registeredBarsCtrl.model.barProductCode|holdingProductName}} Bar List ({{registeredBarsCtrl.total.count}} bars) </h5> <h6 class=\"h-large-text h-gold-text\"> <span ng-bind=\"'Registration ID:'|translate\"></span><span ng-bind=registeredBarsCtrl.registrationId></span> </h6> <div class=gmw-flow-box__description> <div class=gmw-bars-totals> <span ng-bind=\"'Total Gross Weight (ounces):'|translate\"></span> <span class=h-dark-text ng-bind=registeredBarsCtrl.total.weightGrossOunces|gmwFormatWeight:registeredBarsCtrl.model.currency> </span> </div> <div class=gmw-bars-totals ng-if=\"registeredBarsCtrl.model.currency !== 'Gold'\"> <span ng-bind=\"'Total Gross Weight (grams):'|translate\"></span> <span class=h-dark-text ng-bind=registeredBarsCtrl.total.weightGrossGrams|gmwFormatWeight:registeredBarsCtrl.model.currency> </span> </div> <div class=gmw-bars-totals ng-if=\"registeredBarsCtrl.model.currency === 'Gold'\"> <span ng-bind=\"'Total Fine Weight (ounces):'|translate\"></span> <span class=h-dark-text ng-bind=registeredBarsCtrl.total.weightFineOunces|gmwFormatWeight:registeredBarsCtrl.model.currency> </span> </div> <div class=gmw-bars-totals ng-if=\"registeredBarsCtrl.model.currency === 'Gold'\"> <span ng-bind=\"'Total Fine Weight (grams):'|translate\"></span> <span class=h-dark-text ng-bind=registeredBarsCtrl.total.weightFineGrams|gmwFormatWeight:registeredBarsCtrl.model.currency> </span> </div> </div> </div> <holding-bar-list ng-if=registeredBarsCtrl.bars bars=registeredBarsCtrl.paginatedItems metal=registeredBarsCtrl.model.currency product-code=registeredBarsCtrl.model.barProductCode sorting=registeredBarsCtrl.model.sorting registration-date sortable=true> </holding-bar-list> <div class=h-center-text> <a class=h-blue-link ng-click=registeredBarsCtrl.showMore() ng-if=\"!registeredBarsCtrl.showingAll && registeredBarsCtrl.pages > 1\" ng-bind=\"'Show me more bars at a time'|translate\"> </a> <a class=h-blue-link ng-click=registeredBarsCtrl.showLess() ng-if=registeredBarsCtrl.showingAll ng-bind=\"'Show me less bars at a time'|translate\"> </a> </div> </div> <footer class=gmw-flow-box-footer ng-if=\"!registeredBarsCtrl.showingAll && registeredBarsCtrl.pages > 1\"> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ng-if=registeredBarsCtrl.showPrev ng-click=registeredBarsCtrl.prevPage() ng-bind=\"'Previous'|translate\" ng-disabled=registeredBarsCtrl.updating> </button> </div> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <span class=\"heading-h4 h-gold-text\"> Page {{registeredBarsCtrl.page + 1}} of {{registeredBarsCtrl.pages}} </span> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ng-if=registeredBarsCtrl.showNext ng-click=registeredBarsCtrl.nextPage() ng-bind=\"'Next'|translate\" ng-disabled=registeredBarsCtrl.updating> </button> </div> </footer> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I Add Funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


BarsListsController.$inject = ['$filter', '$scope', '$state', '$stateParams', 'HoldingBars'];
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('app.holding.dashboard.bars').controller('RegisteredBarsController', BarsListsController);

function BarsListsController($filter, $scope, $state, $stateParams, HoldingBars) {
  'ngInject';

  function activate() {
    HoldingBars.getFilters().then(function (filters) {
      vm.filters = filters;
      if (!$stateParams.location || !$stateParams.product) {
        $state.go('bars');
      }

      vm.model = {
        currency: HoldingBars.getCurrencyFromProduct($stateParams.product),
        barProductCode: $stateParams.product,
        location: $stateParams.location,
        sorting: {
          field: 'refiner',
          type: 'asc'
        }
      };

      $scope.$watchGroup(['registeredBarsCtrl.model.sorting.field', 'registeredBarsCtrl.model.sorting.type'], updateRegisteredBars);
    });
  }

  function nextPage() {
    vm.page += 1;
    updatePagination();
  }

  function prevPage() {
    vm.page -= 1;
    updatePagination();
  }

  function showMore() {
    vm.showingAll = true;
    updatePagination();
  }

  function showLess() {
    vm.showingAll = false;
    updatePagination();
  }

  function updatePagination() {
    vm.showNext = (vm.page + 1) * vm.limit < vm.total.count;
    vm.showPrev = vm.page > 0;
    vm.pages = Math.ceil(vm.total.count / vm.limit);
    var offset = vm.page * vm.limit;
    if (vm.showingAll) {
      vm.paginatedItems = vm.bars;
    } else {
      vm.paginatedItems = $filter('limitTo')(vm.bars, vm.limit, offset);
    }
  }

  function updateRegisteredBars() {
    return HoldingBars.getRegisteredBars(vm.model).then(function (_ref) {
      var bars = _ref.bars,
          registrationId = _ref.registrationId;

      vm.registrationId = registrationId;
      vm.bars = bars;
      vm.total = HoldingBars.getTotals(bars);
      var assays = [].concat(_toConsumableArray(new Set(bars.map(function (_) {
        return _.assay;
      })))).sort();
      vm.total.assay = assays.join(' - ');
      vm.total.barProductCode = vm.model.barProductCode;
      vm.total.count = vm.bars.length;

      vm.page = 0;
      vm.limit = 20;
      updatePagination();
    });
  }

  var vm = this;
  vm.nextPage = nextPage;
  vm.prevPage = prevPage;
  vm.showingAll = false;
  vm.showMore = showMore;
  vm.showLess = showLess;

  activate();
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _registrationFlow = __webpack_require__(497);

var _registrationFlow2 = _interopRequireDefault(_registrationFlow);

var _registration = __webpack_require__(498);

var _registration2 = _interopRequireDefault(_registration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bars').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars.registration', {
    data: {
      flow: _registrationFlow2.default
    },
    params: {
      product: {
        type: 'string',
        value: null
      },
      vault: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      SelectedProductResolve: ['$q', '$stateParams', function SelectedProductResolve($q, $stateParams) {
        'ngInject';

        return 'product' in $stateParams ? $q.when($stateParams.product) : $q.when();
      }],
      SelectedVaultResolve: ['$q', '$stateParams', function SelectedVaultResolve($q, $stateParams) {
        'ngInject';

        return 'vault' in $stateParams ? $q.when($stateParams.vault) : $q.when();
      }]
    },
    url: '/registration',
    views: {
      'bars-main': {
        controller: 'RegistrationController',
        controllerAs: 'registrationCtrl',
        template: _registration2.default
      }
    }
  });
}]);

__webpack_require__(499);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(504);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Register Bars'),
    cancel: {
        state: 'holding.dashboard.bars.registration'
    },
    complete: {
        label: (0, _gettext2.default)('Back to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'select',
        state: 'holding.dashboard.bars.registration.select',
        heading: (0, _gettext2.default)('Bar Registration'),
        label: (0, _gettext2.default)('Select Bar & Vault')
    }, {
        key: 'review',
        state: 'holding.dashboard.bars.registration.review',
        cancel: true,
        heading: (0, _gettext2.default)('Bar Registration'),
        label: (0, _gettext2.default)('Review'),
        controls: {
            next: (0, _gettext2.default)('Complete')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.bars.registration.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'What is a registered bar?'|translate}}\" href holding-external-link=support.registration.what> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What is the difference between a registered bar and undivided metal?'|translate}}\" href holding-external-link=support.registration.difference> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(500);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bars').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars.registration.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bar Registration - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-flow-box-success-header> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--one\"></div> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--two\"></div> <img class=gmw-flow-box-success-header__icon src=/img/order-success-check.svg> <span class=gmw-flow-box-success-header__text> <span class=gmw-flow-box-success-header__title ng-bind=\"'Request Complete'|translate\"> </span> <span class=gmw-flow-box-success-header__sub-title ng-switch=registrationCtrl.mode> <span ng-switch-when=register ng-bind=\"'Bars Registered'|translate\"></span> <span ng-switch-when=deregister ng-bind=\"'Bars Deregistered'|translate\"></span> </span> </span> </div> <div class=gmw-flow-box-container> <holding-registration-recap mode=registrationCtrl.mode bars=registrationCtrl.preview.bars totals=registrationCtrl.preview.totals> </holding-registration-recap> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=registrationCtrl.cancel() on-next=registrationCtrl.next()> </holding-flow-controls> </footer> ";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RegistrationController.$inject = ['$controller', '$filter', '$q', '$scope', 'HoldingBars', 'HoldingTroyRate', 'HoldingVaults', 'HoldingAppUtilities', 'HoldingUser', 'SelectedProductResolve', 'SelectedVaultResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('app.holding.dashboard.bars').controller('RegistrationController', RegistrationController);

function RegistrationController($controller, $filter, $q, $scope, HoldingBars, HoldingTroyRate, HoldingVaults, HoldingAppUtilities, HoldingUser, SelectedProductResolve, SelectedVaultResolve) {
  'ngInject';

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    var productNameFilter = $filter('holdingProductName');
    var locationNameFilter = $filter('holdingVaultLocation');

    HoldingBars.getRegistrationProducts().then(function (products) {
      vm.products = products.map(function (_) {
        return _.barProductCode;
      });

      vm.barProductCodeOptions = products.map(function (product) {
        return {
          value: product.barProductCode,
          label: productNameFilter(product.barProductCode)
        };
      });

      vm.products = {};
      products.forEach(function (product) {
        vm.products[product.barProductCode] = product.vaults;
      });

      $scope.$watch('registrationCtrl.model.barProductCode', function (productCode) {
        if (productCode) {
          vm.vaultOptions = vm.products[productCode].map(function (vault) {
            var vaultInfo = HoldingVaults.getVaultInfoById(vault);
            var name = vaultInfo.name;
            var country = locationNameFilter(vault);
            return {
              value: vault,
              label: name + ' ' + country
            };
          });

          vm.model.vault = SelectedVaultResolve;
          if (!vm.products[productCode].includes(vm.model.vault)) {
            vm.model.vault = vm.products[productCode][0];
          }
        }
      });

      if (SelectedProductResolve && Object.keys(vm.products).includes(SelectedProductResolve)) {
        vm.model.barProductCode = SelectedProductResolve;
      } else if (Object.keys(vm.products).includes('GOLD_100G')) {
        vm.model.barProductCode = 'GOLD_100G';
      } else {
        vm.model.barProductCode = products[0].barProductCode;
      }
    });
  }

  function checkComplete() {
    return didComplete;
  }

  function checkSelection() {
    return !!vm.mode;
  }

  function executeRegistration() {
    vm.executionError = null;
    switch (vm.mode) {
      case 'deregister':
        return HoldingBars.deregister(vm.preview.bars, vm.model).then(complete).catch(function (_ref) {
          var message = _ref.message;

          vm.executionError = message;
          return $q.reject(message);
        });
      case 'register':
      default:
        return HoldingBars.register(vm.preview.bars, vm.model.registrationId, vm.model).then(complete).catch(function (_ref2) {
          var message = _ref2.message;

          vm.executionError = message;
          return $q.reject(message);
        });
    }
  }

  function complete(data) {
    result.model = angular.copy(vm.model);
    result.data = data;
    didComplete = true;
  }

  function nextPage() {
    vm.model.page += 1;
  }

  function prevPage() {
    vm.model.page -= 1;
  }

  function previewRegistration() {
    vm.preview = {};
    if (vm.isGDB) {
      if (vm.mode === 'deregister') {
        vm.preview.bars = [vm.model.deregisterGDB];
      } else {
        vm.preview.bars = [vm.model.registerGDB];
      }
      vm.preview.totals = HoldingBars.getTotals(vm.preview.bars);
      return $q.when(vm.preview);
    }
    if (vm.mode === 'deregister') {
      vm.preview.bars = vm.registeredBars.slice(0, vm.model.amount);
      vm.preview.totals = HoldingBars.getTotals(vm.preview.bars);
    } else {
      return HoldingBars.getRandomBars(vm.model).then(function (_ref3) {
        var bars = _ref3.bars;

        vm.preview.bars = bars;
        vm.preview.totals = HoldingBars.getTotals(bars);
        return vm.preview;
      });
    }
    return $q.when(vm.preview);
  }

  function updateBalance() {
    return HoldingBars.getAvailableBalance(vm.model).then(function (available) {
      vm.available = available;
    });
  }

  function updateData(_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        barProductCode = _ref5[0],
        location = _ref5[1];

    vm.model.page = 0;
    if (barProductCode && location) {
      vm.updating = true;
      $q.all([updateBalance(), updateRegisteredBars()]).then(throttledRegistrable).finally(function () {
        vm.updating = false;
      });
    }
  }

  function updateRegisteredBars() {
    return HoldingBars.getRegisteredBars(vm.model).then(function (_ref6) {
      var bars = _ref6.bars,
          registrationId = _ref6.registrationId;

      vm.hasRegistrationId = !!registrationId;
      if (HoldingBars.isGDB(vm.model.barProductCode)) {
        vm.registeredBars = [];
        vm.registeredTotals = { registrationId: registrationId };
        vm.registeredGDB = bars;
      } else {
        vm.registeredGDB = [];
        vm.registeredBars = bars;
        vm.registeredTotals = HoldingBars.getTotals(bars);
        var assays = [].concat(_toConsumableArray(new Set(bars.map(function (_) {
          return _.assay;
        })))).sort();
        vm.registeredTotals.assay = assays.join(' - ');
        vm.registeredTotals.barProductCode = vm.model.barProductCode;
        vm.registeredTotals.registrationId = registrationId;
        vm.deregistrable = vm.registeredTotals.number;
      }
    });
  }

  function updateRegistrable() {
    if (vm.model.barProductCode) {
      vm.isGDB = HoldingBars.isGDB(vm.model.barProductCode);

      return HoldingBars.getAvailableBars(vm.model).then(function (_ref7) {
        var bars = _ref7.bars,
            count = _ref7.count;

        vm.registrableBars = bars;
        if (!vm.isGDB && bars.length > 0) {
          var barWeight = HoldingBars.getWeightPlusFee(bars[0]);
          var metal = HoldingBars.getCurrencyFromProduct(vm.model.barProductCode);

          vm.registrable = {
            number: Math.floor(vm.available.amount / barWeight),
            total: count.count
          };
        } else {
          vm.registrable = {
            number: 0,
            total: count.count
          };
        }
        if (vm.isGDB) {
          vm.showPrev = vm.model.page !== 0;
          vm.showNext = count.count > (vm.model.page + 1) * 10;
          vm.totalPages = Math.ceil(count.count / 10);
        } else {
          vm.showPrev = false;
          vm.showNext = false;
        }
      });
    }
  }

  var vm = this;
  var model = {
    page: 0,
    sorting: {
      field: 'refiner',
      type: 'asc'
    }
  };
  var result = {};
  var didComplete = void 0;

  vm.model = angular.copy(model);
  vm.nextPage = nextPage;
  vm.prevPage = prevPage;
  vm.result = result;
  vm.steps = {
    'holding.dashboard.bars.registration.select': {
      next: previewRegistration
    },
    'holding.dashboard.bars.registration.review': {
      checks: [{
        function: checkSelection,
        revertTo: 'holding.dashboard.bars.registration.select'
      }],
      next: executeRegistration
    },
    'holding.dashboard.bars.registration.complete': {
      checks: [{
        function: checkSelection,
        revertTo: 'holding.dashboard.bars.registration.select'
      }, {
        function: checkComplete,
        revertTo: 'holding.dashboard.bars.registration.review'
      }]
    }
  };
  vm.updating = true;

  var throttledRegistrable = HoldingAppUtilities.throttle(updateRegistrable, 100);

  activate();

  $scope.$watchGroup(['registrationCtrl.model.barProductCode', 'registrationCtrl.model.vault'], HoldingAppUtilities.throttle(updateData, 100));

  $scope.$watch('registrationCtrl.model.page', function (newVal, oldVal) {
    if (newVal !== oldVal) {
      throttledRegistrable();
    }
  });

  $scope.$watchGroup(['registrationCtrl.model.sorting.field', 'registrationCtrl.model.sorting.type'], function () {
    throttledRegistrable();
  });
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(503);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bars').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars.registration.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bar Registration - Review Registration Information'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-switch=registrationCtrl.mode> <span ng-switch-when=register> You have indicated that you would like to <span class=h-dark-text>register</span> the following bars in <span class=h-dark-text>{{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}</span>: </span> <span ng-switch-when=deregister> You have indicated that you would like to <span class=h-dark-text>deregister</span> the following bars in <span class=h-dark-text>{{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}</span>: </span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=registrationCtrl.form> <holding-registration-recap mode=registrationCtrl.mode bars=registrationCtrl.preview.bars totals=registrationCtrl.preview.totals> </holding-registration-recap> <div ng-if=!registrationCtrl.hasRegistrationId> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Registration ID'|translate\"> </label> <p class=gmw-flow-box__description> <span ng-bind=\"'Please enter a “Registration ID” and click Confirm to complete the registration. The Registration ID will be displayed on the public bar list. Do not enter personal information, such as your name, unless you willing to disclose it publicly.'|translate\"></span> </p> <gmw-box-input class=gmw-input-container name=registrationId type=text required has-error=\"registrationCtrl.form.registrationId.$dirty && registrationCtrl.form.registrationId.$invalid\" ng-model=registrationCtrl.model.registrationId no-label placeholder=\"{{'Registration ID'|translate}}\"> </gmw-box-input> </div> <div class=gmw-flow-box__callout ng-switch=registrationCtrl.mode> <p class=h-margin-bottom-20 translate ng-switch-when=register> By clicking <span class=h-dark-text>Confirm</span>, the <span ng-if=\"registrationCtrl.preview.bars.length === 1\">bar</span> <span ng-if=\"registrationCtrl.preview.bars.length > 1\">bars</span> will be registered to you with the above Registration ID and your Holding will be charged a fee of {{registrationCtrl.preview.totals.totalFee|gmwFormatWeight}} for this service. </p> <p translate ng-switch-when=deregister> By clicking <span class=h-dark-text>Complete</span>, the <span ng-if=\"registrationCtrl.preview.bars.length === 1\">bar</span> <span ng-if=\"registrationCtrl.preview.bars.length > 1\">bars</span> will be deregistered to from your Holding. No fee will be charged for this service. </p> </div> <holding-alert-legacy class=error ng-if=registrationCtrl.executionError> <span ng-bind=registrationCtrl.executionError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=registrationCtrl.cancel() on-next=registrationCtrl.next() step-disabled=\"registrationCtrl.form.$invalid || registrationCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _select = __webpack_require__(505);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.bars').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.bars.registration.select', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Bar Registration - Select Bar & Vault'
    },
    url: '/select',
    views: {
      step: {
        template: _select2.default
      }
    }
  });
}]);

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span> Please ensure you retain sufficient unregistered metal or currency in your Holding to cover the monthly storage fee obligations for your registered bars. <a href holding-external-link=support.storageRegistered class=h-blue-link>Read more</a> </span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=registrationCtrl.form> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=barProductCode class=gmw-input-container--split-half__col ng-model=registrationCtrl.model.barProductCode label=\"{{'Select Bar Type'|translate}}\" options=registrationCtrl.barProductCodeOptions> </gmw-box-selector> <gmw-box-selector required name=vault class=gmw-input-container--split-half__col ng-model=registrationCtrl.model.vault label=\"{{'Select Vault'|translate}}\" options=registrationCtrl.vaultOptions> </gmw-box-selector> </div> <holding-available-unregistered-balance ng-if=registrationCtrl.available balance=registrationCtrl.available vault=registrationCtrl.model.vault> </holding-available-unregistered-balance> <holding-registered-bars ng-if=registrationCtrl.registeredBars totals=registrationCtrl.registeredTotals vault=registrationCtrl.model.vault metal=registrationCtrl.model.barProductCode|holdingProductMetal> </holding-registered-bars> <holding-bar-list ng-if=\"registrationCtrl.registeredGDB && registrationCtrl.registeredGDB.length > 0\" bars=registrationCtrl.registeredGDB metal=registrationCtrl.model.barProductCode|holdingProductMetal product-code=registrationCtrl.model.barProductCode name=deregisterGDB ng-required=\"registrationCtrl.mode === 'deregister'\" vault select=\"registrationCtrl.mode === 'deregister'\" ng-model=registrationCtrl.model.deregisterGDB> </holding-bar-list> <div class=gmw-input-container ng-if=!registrationCtrl.updating> <gmw-toggle-option-group ng-model=registrationCtrl.mode> <gmw-toggle-option label=\"{{'Register'|translate}}\" value=\"'register'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Deregister'|translate}}\" value=\"'deregister'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <holding-alert class=warning ng-if=\"registrationCtrl.mode === 'register' && registrationCtrl.registrableBars.length === 0\" title=\"{{'Please Note'|translate}}\"> <main> <span> There are currently no {{registrationCtrl.model.barProductCode|holdingProductName}} available at {{registrationCtrl.available.currency}} in {{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}. </span> </main> </holding-alert> <holding-alert class=warning ng-if=\"registrationCtrl.mode === 'deregister' && registrationCtrl.registeredGDB.length === 0 && registrationCtrl.registeredBars.length === 0\" title=\"{{'Please Note'|translate}}\"> <main> <span> You do not have any registered {{registrationCtrl.model.barProductCode|holdingProductName}}(s) in {{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}. </span> </main> </holding-alert> <div ng-if=\"!registrationCtrl.updating && !registrationCtrl.isGDB\"> <holding-alert class=info ng-if=\"registrationCtrl.mode === 'register' && registrationCtrl.registrableBars.length > 0\" title=\"{{'Please Note'|translate}}\"> <main> <span> <span> You can register {{registrationCtrl.registrable.number}} &times; {{registrationCtrl.model.barProductCode|holdingProductName}}(s) (incl. registration fees) at {{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}. </span> <br><br> <span> Total Goldmoney inventory for {{registrationCtrl.model.barProductCode|holdingProductName}} at {{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}: {{registrationCtrl.registrable.total}} bar(s) </span> </span> </main> </holding-alert> <holding-alert class=info ng-if=\"registrationCtrl.mode === 'deregister' && registrationCtrl.registeredBars.length > 0\" title=\"{{'Please Note'|translate}}\"> <main> <span> You can deregister {{registrationCtrl.deregistrable}} &times; {{registrationCtrl.model.barProductCode|holdingProductName}}(s) at {{registrationCtrl.model.vault|holdingVaultCustodian}} {{registrationCtrl.model.vault|holdingVaultLocation}}. </span> </main> </holding-alert> <gmw-box-input class=gmw-input-container name=amount ng-if=\"(registrationCtrl.mode === 'register' && registrationCtrl.registrableBars.length > 0) || (registrationCtrl.mode === 'deregister' && registrationCtrl.registeredBars.length > 0)\" type=text required has-error=\"registrationCtrl.form.amount.$dirty && registrationCtrl.form.amount.$invalid\" gmw-max=\"{{registrationCtrl.mode === 'register' ? registrationCtrl.registrable.number : registrationCtrl.deregistrable}}\" ng-model=registrationCtrl.model.amount label=\"{{'Enter quantity'|translate}}\" gmw-number-int placeholder=\"{{'Number of bars'|translate}}\"> </gmw-box-input> <div class=gmw-flow-box__description ng-if=\"(registrationCtrl.mode === 'register' && registrationCtrl.registrableBars.length > 0)\"> <span ng-bind=\"'If you want to register more bars than currently available in our inventory, please'|translate\"></span> <a class=h-blue-link ui-sref=\"holding.dashboard.messages.compose({\n          category: 'OTHER',\n          subject: 'Bar inventory request'\n        })\" ng-bind=\"'contact us'|translate\"></a> <span ng-bind=\"'to request additional bars.'|translate\"></span> </div> </div> <holding-bar-list ng-if=\"registrationCtrl.isGDB && registrationCtrl.mode === 'register' && registrationCtrl.registrableBars && registrationCtrl.registrableBars.length > 0\" bars=registrationCtrl.registrableBars metal=registrationCtrl.model.barProductCode|holdingProductMetal product-code=registrationCtrl.model.barProductCode name=registerGDB required vault select=true ng-model=registrationCtrl.model.registerGDB sorting=registrationCtrl.model.sorting sortable=true> </holding-bar-list> <div class=gmw-registration-pagination ng-if=\"registrationCtrl.mode === 'register' && (registrationCtrl.showPrev || registrationCtrl.showNext)\"> <div class=gmw-registration-pagination__col> <button ng-if=registrationCtrl.showPrev class=\"medium-main-cta gmw-responsive-button\" gmw-action=registrationCtrl.prevPage()> <span ng-bind=\"'Previous'|translate\"></span> </button> </div> <span class=\"heading-h4 h-gold-text\" ng-if=\"registrationCtrl.showPrev || registrationCtrl.showNext\"> <span ng-bind=\"'Page'|translate\"></span>&nbsp; <span ng-bind=\"registrationCtrl.model.page + 1\"></span>&nbsp; <span ng-bind=\"'of'|translate\"></span>&nbsp; <span ng-bind=registrationCtrl.totalPages></span> </span> <div class=gmw-registration-pagination__col> <button ng-if=registrationCtrl.showNext class=\"medium-main-cta gmw-responsive-button\" gmw-action=registrationCtrl.nextPage()> <span ng-bind=\"'Next'|translate\"></span> </button> </div> </div> <div ng-if=\"registrationCtrl.mode !== 'deregister'\"> <div class=gmw-flow-box__description> <span class=\"heading-h5 h-dark-text\" ng-bind=\"'Storage fees for registered bars'|translate\"></span> <span ng-bind=\"'Storage fees apply to registered bars, which will be deducted in arrears. Please ensure you retain sufficient unregistered metal or currency in your Holding to cover this ongoing storage fee obligation. Should there be insufficient unregistered metal or currency, we will deregister your smallest registered bar to collect any storage fees due.'|translate\"></span> <a href holding-external-link=support.storage class=h-blue-link ng-bind=\"'Read more'|translate\"></a>. </div> <div class=gmw-flow-box__description> <span class=\"heading-h5 h-dark-text\" ng-bind=\"'Delivery or collection'|translate\"></span> <span ng-bind=\"'We can arrange delivery of registered bars to many locations worldwide; simply'|translate\"></span> <a class=h-blue-link ui-sref=\"holding.dashboard.messages.compose({\n          category: 'COLLECT_DELIVER_METAL',\n        })\" ng-bind=\"'contact us'|translate\"></a> <span ng-bind=\"'for more information. Alternatively, we offer collection of registered bars from the vault where your bars are stored.'|translate\"></span> <a href holding-external-link=support.storage class=h-blue-link ng-bind=\"'Read more'|translate\"></a>. </div> <div class=gmw-flow-box__description> <span class=\"heading-h5 h-dark-text\" ng-bind=\"'Customs duty and tax'|translate\"></span> <span ng-bind=\"'In accordance with our terms and conditions, you are responsible for the payment of any customs duties or taxes that may arise from the delivery or collection of your metal.'|translate\"></span> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=registrationCtrl.cancel() on-next=registrationCtrl.next() step-disabled=\"registrationCtrl.form.$invalid || registrationCtrl.form.$submitted || (!registrationCtrl.model.amount && !registrationCtrl.model.registerGDB && !registrationCtrl.model.deregisterGDB)\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.cryptocurrencies', []).name;


__webpack_require__(507);
__webpack_require__(509);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cryptoBadge = __webpack_require__(508);

var _cryptoBadge2 = _interopRequireDefault(_cryptoBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.cryptocurrencies').directive('holdingCryptoBadge', holdingCryptoBadge).name;


function holdingCryptoBadge() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      crypto: '='
    },
    template: _cryptoBadge2.default
  };
}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "<i class=\"gmw-crypto-badge gmw-crypto-badge--{{crypto.toLowerCase()}}\"></i> ";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementCrypto = __webpack_require__(510);

var _statementCrypto2 = _interopRequireDefault(_statementCrypto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.cryptocurrencies').directive('holdingStatementCrypto', holdingStatementCrypto).name;


function holdingStatementCrypto() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      cryptos: '=',
      total: '='
    },
    template: _statementCrypto2.default
  };
}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-statement__table desktop-only desktop-only--sm\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Crypto'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" ng-bind=\"'Total Amount'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\"> <span ng-bind=::total.currency></span> <span ng-bind=\"'Equivalent'|translate\"></span> </span> </div> <div class=gmw-statement__table-row ng-repeat=\"crypto in cryptos\"> <span class=gmw-statement__table-cell--value> <holding-crypto-badge crypto=::crypto.crypto.currency></holding-crypto-badge> <span ng-bind=::crypto.crypto.currency></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=crypto.crypto|gmwFormatProduct></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=crypto.equivalent|holdingFormatFunds></span> </span> </div> <div class=gmw-statement__total> <span class=gmw-statement__total-label ng-bind=\"'Total Cryptocurrency Value'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=total.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=total.currency> </span> </span> </div> </div> <div class=\"gmw-statement__table mobile-only mobile-only--sm\" ng-repeat=\"crypto in cryptos\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Crypto'|translate\"> </span> <span class=gmw-statement__table-cell--value> <holding-crypto-badge crypto=::crypto.crypto.currency></holding-crypto-badge> <span ng-bind=::crypto.crypto.currency></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Total Amount'|translate\"> </span> <span class=gmw-statement__table-cell--value> <span ng-bind=crypto.crypto|gmwFormatProduct></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header> <span ng-bind=::total.currency></span> <span ng-bind=\"'Equivalent'|translate\"></span> </span> <span class=gmw-statement__table-cell--value> <span ng-bind=crypto.equivalent|holdingFormatFunds></span> </span> </div> </div> <div class=\"gmw-statement__total mobile-only mobile-only--sm\"> <span class=gmw-statement__total-label ng-bind=\"'Total Cryptocurrency Value'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=total.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=total.currency> </span> </span> </div> ";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCryptocurrencyName.$inject = ['HoldingCryptocurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.cryptocurrencies').filter('holdingCryptocurrencyName', holdingCryptocurrencyName).name;


function holdingCryptocurrencyName(HoldingCryptocurrencies) {
  'ngInject';

  return function (input) {
    if (!input) {
      return '';
    }

    var currency = HoldingCryptocurrencies.getCurrencyByCode(input.currency || input);
    return currency.name;
  };
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCryptocurrencySymbol.$inject = ['HoldingCryptocurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.cryptocurrencies').filter('holdingCryptocurrencySymbol', holdingCryptocurrencySymbol).name;


function holdingCryptocurrencySymbol(HoldingCryptocurrencies) {
  'ngInject';

  return function (input) {
    if (!input) {
      return undefined;
    }

    var currency = HoldingCryptocurrencies.getCurrencyByCode(input);
    return currency.symbol || input;
  };
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.cryptocurrencies').factory('HoldingCryptocurrencies', HoldingCryptocurrencies).name;


function HoldingCryptocurrencies() {
  'ngInject';

  var CURRENCIES = [{
    code: 'Bitcoin',
    name: 'Bitcoin',
    symbol: 'BTC',
    decimals: 8
  }, {
    code: 'Ether',
    name: 'Ether',
    symbol: 'ETH',
    decimals: 8
  }];

  return {
    getCurrencyByCode: getCurrencyByCode
  };

  function getCurrencyByCode(code) {
    return CURRENCIES.find(function (currency) {
      return currency.code === code;
    }) || CURRENCIES[0];
  }
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow', [_angularjs2.default, _common2.default]).name;


__webpack_require__(515);
__webpack_require__(517);
__webpack_require__(519);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(524);
__webpack_require__(526);
__webpack_require__(528);
__webpack_require__(530);
__webpack_require__(532);
__webpack_require__(534);
__webpack_require__(536);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdinFlowpBack.$inject = ['$transitions', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowBack = __webpack_require__(516);

var _flowBack2 = _interopRequireDefault(_flowBack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdinFlowpBack', holdinFlowpBack).name;


function holdinFlowpBack($transitions, HoldingFlow) {
  'ngInject';

  link.$inject = ['scope'];
  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _flowBack2.default
  };

  function link(scope) {
    'ngInject';

    var stateChangeDeregister = $transitions.onSuccess({}, onStateChangeSuccess);

    function activate() {
      getFlow();
    }

    function back() {
      HoldingFlow.prev();
    }

    function getFlow() {
      HoldingFlow.load();

      scope.isActive = !!HoldingFlow.prevStep();
    }

    function onDestroy() {
      stateChangeDeregister();
    }

    function onStateChangeSuccess() {
      getFlow();
    }

    scope.back = back;
    scope.isActive = false;

    scope.$on('$destroy', onDestroy);

    activate();
  }
}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "<div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=isActive ng-click=back()> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> ";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFlowControls.$inject = ['HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowControls = __webpack_require__(518);

var _flowControls2 = _interopRequireDefault(_flowControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowControls', holdingFlowControls).name;


function holdingFlowControls(HoldingFlow) {
  'ngInject';

  link.$inject = ['scope', 'element', 'attrs', '_ctrl', 'transclude'];
  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      hideNext: '=?',
      onCancel: '&',
      onNext: '&',
      stepDisabled: '=?'
    },
    template: _flowControls2.default,
    transclude: true
  };

  function link(scope, element, attrs, _ctrl, transclude) {
    'ngInject';

    function cancel() {
      scope.onCancel();
    }

    function getFlow() {
      HoldingFlow.load();
      scope.isComplete = HoldingFlow.isComplete();
      scope.showCancel = HoldingFlow.isCancellable();

      if (scope.isComplete) {
        var flow = HoldingFlow.getFlow();

        scope.nextLabel = 'label' in flow.complete ? flow.complete.label : 'Complete';
      } else {
        var currentStep = HoldingFlow.currentStep();

        scope.nextLabel = 'controls' in currentStep && 'next' in currentStep.controls ? currentStep.controls.next : 'Next Step';
      }
    }

    function next() {
      var button = element.find('.medium-main-cta');
      scope.isLoading = true;
      if ('spinner' in attrs) {
        button.addClass('loading-button');
      }
      var result = scope.onNext();
      if (result && angular.isFunction(result.then)) {
        result.then(function () {
          button.removeClass('loading-button');
          scope.isLoading = false;
        }).catch(function () {
          button.removeClass('loading-button');
          scope.isLoading = false;
        });
      } else {
        button.removeClass('loading-button');
        scope.isLoading = false;
      }
    }

    scope.cancel = cancel;
    scope.next = next;

    transclude(function (clone) {
      element.find('ng-transclude').after(clone).remove();
    });

    getFlow();
  }
}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-flow-box-footer__col ng-class=\"{\n    'gmw-flow-box-footer__col--center': isComplete\n  }\"> <ng-transclude></ng-transclude> <button class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-click=cancel() ng-show=showCancel> <span ng-bind=\"'Cancel'|translate\"></span> </button> <button class=\"medium-main-cta gmw-responsive-button\" ng-click=next() ng-hide=hideNext ng-disabled=\"stepDisabled || isLoading\"> <span ng-bind=nextLabel|translate></span> </button> </div> ";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFlowHeader.$inject = ['gettextCatalog', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowHeader = __webpack_require__(520);

var _flowHeader2 = _interopRequireDefault(_flowHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowHeader', holdingFlowHeader).name;


function holdingFlowHeader(gettextCatalog, HoldingFlow) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _flowHeader2.default,
    transclude: true
  };

  function link(scope, _element, attrs) {
    function setHeading() {
      if (attrs.heading) {
        scope.heading = attrs.heading;
      } else {
        var step = HoldingFlow.currentStep();
        scope.heading = gettextCatalog.getString(step.heading);
      }
    }

    HoldingFlow.load();
    setHeading();
    attrs.$observe('heading', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        setHeading();
      }
    });
  }
}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = "<header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=heading> </h2> <ng-transclude></ng-transclude> </header> ";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFlowHideComplete.$inject = ['$transitions', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowHideComplete', holdingFlowHideComplete).name;


function holdingFlowHideComplete($transitions, HoldingFlow) {
  'ngInject';

  link.$inject = ['scope', 'element'];
  return {
    link: link,
    restrict: 'A'
  };

  function link(scope, element) {
    'ngInject';

    function currentIndex(stepIndex) {
      return parseInt(stepIndex, 10) + 1;
    }

    function getFlow() {
      HoldingFlow.load();
      scope.steps = HoldingFlow.getSteps();
      scope.currentStep = currentIndex(HoldingFlow.currentStepIndex());
    }

    function isComplete() {
      return scope.currentStep === scope.steps.length;
    }

    getFlow();

    var stateChangeDeregister = $transitions.onSuccess({}, function () {
      getFlow();

      if (isComplete()) {
        element.attr('style', 'display:none !important');
      }
    });

    scope.$on('$destroy', function () {
      stateChangeDeregister();
    });
  }
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFlowIndicator.$inject = ['$rootScope', '$transitions', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowIndicator = __webpack_require__(523);

var _flowIndicator2 = _interopRequireDefault(_flowIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowIndicator', holdingFlowIndicator).name;


function holdingFlowIndicator($rootScope, $transitions, HoldingFlow) {
  'ngInject';

  link.$inject = ['scope'];
  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _flowIndicator2.default
  };

  function link(scope) {
    'ngInject';

    var flowUpdatedDeregister = $rootScope.$on('flow:updated', getFlow);
    var stateChangeDeregister = $transitions.onSuccess({}, getFlow);

    function activate() {
      getFlow();
    }

    function currentIndex(stepIndex) {
      return parseInt(stepIndex, 10) + 1;
    }

    function getFlow() {
      HoldingFlow.load();
      scope.steps = HoldingFlow.getSteps();
      scope.currentStep = currentIndex(HoldingFlow.currentStepIndex());
    }

    function onDestroy() {
      flowUpdatedDeregister();
      stateChangeDeregister();
    }

    activate();

    scope.$on('$destroy', onDestroy);
  }
}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "<span class=\"heading-h5 h-gold-text\" translate> Step {{currentStep}} - {{steps.length}} </span> ";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowSidebar = __webpack_require__(525);

var _flowSidebar2 = _interopRequireDefault(_flowSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowSidebar', holdingFlowSidebar).name;


function holdingFlowSidebar() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    template: _flowSidebar2.default,
    transclude: true
  };
}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = "<section class=holding-dashboard-sidebar ng-transclude></section> ";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowSidebarList = __webpack_require__(527);

var _flowSidebarList2 = _interopRequireDefault(_flowSidebarList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowSidebarList', holdingFlowSidebarList).name;


function holdingFlowSidebarList() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    template: _flowSidebarList2.default,
    transclude: true
  };
}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = "<ul class=holding-dashboard-sidebar-help-list ng-transclude></ul> ";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFlowSidebarProgressSection.$inject = ['$rootScope', '$transitions', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowSidebarProgressSection = __webpack_require__(529);

var _flowSidebarProgressSection2 = _interopRequireDefault(_flowSidebarProgressSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowSidebarProgressSection', holdingFlowSidebarProgressSection).name;


function holdingFlowSidebarProgressSection($rootScope, $transitions, HoldingFlow) {
  'ngInject';

  link.$inject = ['scope'];
  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _flowSidebarProgressSection2.default
  };

  function link(scope) {
    'ngInject';

    function getFlow() {
      HoldingFlow.load();
      scope.label = HoldingFlow.getFlow().name;
      scope.steps = HoldingFlow.getSteps();
      scope.currentStep = HoldingFlow.currentStepIndex();
    }

    getFlow();

    var stateChangeDeregister = $transitions.onSuccess({}, getFlow);

    var flowUpdateDeregister = $rootScope.$on('flow:updated', getFlow);

    scope.$on('$destroy', function () {
      stateChangeDeregister();
      flowUpdateDeregister();
    });
  }
}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = "<div class=holding-dashboard-sidebar__section> <h3 class=\"heading-h4 h-gold-text\" ng-bind=\"'Current Progress'|translate\"> </h3> <h4 class=\"heading-h2 h-dark-text\" ng-bind=label|translate> </h4> <holding-flow-sidebar-progress-steps steps=steps></holding-flow-sidebar-progress-steps> </div> ";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowSidebarProgressStep = __webpack_require__(531);

var _flowSidebarProgressStep2 = _interopRequireDefault(_flowSidebarProgressStep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowSidebarProgressStep', holdingFlowSidebarProgressStep).name;


function holdingFlowSidebarProgressStep() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      label: '@',
      state: '@',
      status: '@'
    },
    template: _flowSidebarProgressStep2.default
  };
}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = "<li class=holding-dashboard-sidebar__list-item ng-class=\"{\n    'holding-dashboard-sidebar__list-item--complete': status === 'complete'\n  }\" ui-sref-active=holding-dashboard-sidebar__list-item--current> <i class=holding-dashboard-sidebar__indicator></i> <a class=\"holding-dashboard-sidebar__label heading-h5\" ng-show=\"status === 'complete'\" ui-sref=\"{{state}}\" ui-sref-opts=\"{\n      inherit: false,\n    }\" ng-bind=label|translate> </a> <span class=\"holding-dashboard-sidebar__label heading-h5\" ng-show=\"status !== 'complete'\" ng-bind=label|translate> </span> </li> ";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFlowSidebarProgressSteps.$inject = ['$transitions', '$rootScope', 'HoldingFlow'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowSidebarProgressSteps = __webpack_require__(533);

var _flowSidebarProgressSteps2 = _interopRequireDefault(_flowSidebarProgressSteps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowSidebarProgressSteps', holdingFlowSidebarProgressSteps).name;


function holdingFlowSidebarProgressSteps($transitions, $rootScope, HoldingFlow) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      steps: '='
    },
    template: _flowSidebarProgressSteps2.default
  };

  function link(scope) {
    var stateChangeDeregister = $transitions.onSuccess({}, getFlow);
    var flowUpdatedDeregister = $rootScope.$on('flow:updated', getFlow);

    function activate() {
      getFlow();
    }

    function getFlow() {
      HoldingFlow.load();
      scope.label = HoldingFlow.getFlow().name;
      scope.steps = HoldingFlow.getSteps();
      scope.currentStep = HoldingFlow.currentStepIndex();
    }

    function onDestroy() {
      flowUpdatedDeregister();
      stateChangeDeregister();
    }

    scope.stepState = function (index) {
      if (index === scope.currentStep) {
        if (index === scope.steps.length - 1) {
          return 'complete';
        }
        return 'current';
      } else if (index < scope.currentStep) {
        return 'complete';
      }
      return 'pending';
    };

    activate();

    scope.$on('$destroy', onDestroy);
  }
}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = "<ul class=holding-dashboard-sidebar__list> <holding-flow-sidebar-progress-step label=\"{{::step.label}}\" state=\"{{::step.state}}\" status=\"{{stepState($index)}}\" ng-repeat=\"step in steps track by step.key\"> </holding-flow-sidebar-progress-step> </ul> ";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowSidebarSection = __webpack_require__(535);

var _flowSidebarSection2 = _interopRequireDefault(_flowSidebarSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.flow').directive('holdingFlowSidebarSection', holdingFlowSidebarSection).name;


function holdingFlowSidebarSection() {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _flowSidebarSection2.default,
    transclude: true
  };

  function link(scope, _elem, attrs) {
    scope.header = attrs.header || '';
    scope.subHeader = attrs.subHeader || '';

    attrs.$observe('header', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        scope.header = newVal;
      }
    });

    attrs.$observe('subHeader', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        scope.subHeader = newVal;
      }
    });
  }
}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "<div class=holding-dashboard-sidebar__section> <h3 class=\"heading-h4 h-gold-text\" ng-if=header ng-bind=header> </h3> <h4 class=\"heading-h2 h-dark-text\" ng-if=subHeader ng-bind=subHeader> </h4> <ng-transclude></ng-transclude> </div> ";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingFlow.$inject = ['$rootScope', '$state'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.flow').factory('HoldingFlow', HoldingFlow).name;


function HoldingFlow($rootScope, $state) {
  'ngInject';

  var flowState = {};

  return {
    cancel: cancel,
    complete: complete,
    currentStep: currentStep,
    currentStepIndex: currentStepIndex,
    getFlow: getFlow,
    getSteps: getSteps,
    hasSidebar: hasSidebar,
    isCancellable: isCancellable,
    isComplete: isComplete,
    load: load,
    next: next,
    nextStep: nextStep,
    prev: prev,
    prevStep: prevStep,
    setStateEnabled: setStateEnabled
  };

  function cancel() {
    var currentFlow = getFlow();

    if ('cancel' in currentFlow) {
      $state.go(currentFlow.cancel.state, {}, {
        reload: true
      });
    }
    return false;
  }

  function complete() {
    var currentFlow = getFlow();

    if ('complete' in currentFlow) {
      $state.go(currentFlow.complete.state, {}, {
        reload: true
      });
    }
    return false;
  }

  function currentStep() {
    if (!hasSteps()) {
      return false;
    }

    var currentSteps = getSteps();

    return currentSteps.find(function (_) {
      return _.state === $state.current.name;
    });
  }

  function currentStepIndex() {
    if (!hasSteps()) {
      return -1;
    }

    var curStep = currentStep();
    var curSteps = getSteps();

    return curSteps.indexOf(curStep);
  }

  function getFlow() {
    return flowState;
  }

  function getSteps() {
    var currentFlow = getFlow();
    if (currentFlow && 'steps' in currentFlow) {
      return currentFlow.steps.filter(function (_) {
        return !_.disabled;
      });
    }
    return [];
  }

  function hasData(state) {
    return 'data' in state && state.data !== null;
  }

  function hasFlow(state) {
    return hasData(state) && 'flow' in state.data && state.data.flow !== null;
  }

  function hasParent(state) {
    return 'parent' in state && state.parent !== null;
  }

  function hasSidebar() {
    var currentFlow = getFlow();

    return 'sidebar' in currentFlow ? true : currentFlow.sidebar;
  }

  function hasSteps() {
    var currentSteps = getSteps();
    return angular.isArray(currentSteps) && currentSteps.length > 0;
  }

  function isCancellable() {
    var thisStep = currentStep();

    return thisStep && 'cancel' in thisStep && thisStep.cancel;
  }

  function isComplete() {
    var thisStep = currentStep();

    return thisStep && 'complete' in thisStep && thisStep.complete;
  }

  function load() {
    var flow = hasParent($state.current) ? $state.get($state.current.parent) : $state.current;

    flowState = hasFlow(flow) ? flow.data.flow : {};
    return flowState;
  }

  function next() {
    if (!hasSteps()) {
      return false;
    }

    var moveTo = nextStep();
    if (moveTo) {
      var opts = 'options' in moveTo ? moveTo.options : {};
      return $state.go(moveTo.state, opts);
    }
    return false;
  }

  function nextStep() {
    if (!hasSteps()) {
      return false;
    }

    var curStep = currentStep();
    var curSteps = getSteps();
    var curStepIndex = curSteps.indexOf(curStep);

    if (isComplete()) {
      return getFlow().complete;
    }

    return curStepIndex > -1 && curStepIndex < curSteps.length ? curSteps[curStepIndex + 1] : false;
  }

  function prev() {
    if (!hasSteps()) {
      return false;
    }

    var moveTo = prevStep();

    if (moveTo) {
      var curSteps = getSteps();
      if (curSteps.indexOf(moveTo) > 0 || moveTo.keepStateOnPrev) {
        $state.go(moveTo.state);
      } else {
        $state.go(moveTo.state, {}, {
          reload: true
        });
      }
    }
    return false;
  }

  function prevStep() {
    if (!hasSteps()) {
      return false;
    }

    var curStep = currentStep();

    var curSteps = getSteps();
    var curStepIndex = curSteps.indexOf(curStep);

    if (curStepIndex === 0 && !!curStep.returnTo) {
      return { state: curStep.returnTo };
    }

    if (curStepIndex === 0 || !curStep || curStep.complete) {
      return false;
    }

    return 'prev' in curStep ? curSteps.find(function (step) {
      return step.state === curStep.prev;
    }) : curSteps[curStepIndex - 1];
  }

  function setStateEnabled(key, enabled) {
    var step = 'steps' in flowState ? flowState.steps.find(function (_) {
      return _.key === key;
    }) : false;
    if (step) {
      step.disabled = !enabled;
      $rootScope.$emit('flow:updated');
    }
  }
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _fees = __webpack_require__(538);

var _fees2 = _interopRequireDefault(_fees);

var _add = __webpack_require__(540);

var _add2 = _interopRequireDefault(_add);

var _exchange = __webpack_require__(560);

var _exchange2 = _interopRequireDefault(_exchange);

var _remove = __webpack_require__(570);

var _remove2 = _interopRequireDefault(_remove);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds', [_angularjs2.default, _common2.default, _add2.default, _exchange2.default, _remove2.default]).component('holdingFees', _fees2.default).name;


__webpack_require__(589);
__webpack_require__(591);
__webpack_require__(593);
__webpack_require__(595);
__webpack_require__(597);
__webpack_require__(599);
__webpack_require__(601);
__webpack_require__(603);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fees = __webpack_require__(539);

var _fees2 = _interopRequireDefault(_fees);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fees = {
    bindings: {
        fees: '<'
    },
    template: _fees2.default
};
exports.default = Fees;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=$ctrl.fees> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--margin-bottom\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Convenience Fee'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=$ctrl.fees.feePercentage|holdingFormatPercentage:false> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Fee Amount'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=$ctrl.fees.feeAmount|holdingFormatFunds> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Amount After Fee'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=$ctrl.fees.amountWithoutFee|holdingFormatFunds> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds.add', [_angularjs2.default, _common2.default]).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add', {
    params: {
      currency: {
        type: 'string',
        value: null
      }
    },
    url: '/add'
  });

  $urlRouterProvider.when('/funds/add', '/funds/add/overview');
}]).name;


__webpack_require__(541);
__webpack_require__(551);
__webpack_require__(554);
__webpack_require__(557);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bankWireFlow = __webpack_require__(542);

var _bankWireFlow2 = _interopRequireDefault(_bankWireFlow);

var _bankWire = __webpack_require__(543);

var _bankWire2 = _interopRequireDefault(_bankWire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.bank-wire', {
    data: {
      flow: _bankWireFlow2.default
    },
    resolve: {
      AccountsResolve: ['$q', 'HoldingBankAccounts', 'CanAddFundsResolve', function AccountsResolve($q, HoldingBankAccounts, CanAddFundsResolve) {
        'ngInject';

        return HoldingBankAccounts.get().then(function (accounts) {
          if (accounts.length > 0) {
            return $q.resolve(true);
          }
          return $q.reject({
            redirectTo: 'holding.dashboard.bank-accounts.link'
          });
        });
      }],
      AvailableBanksResolve: ['HoldingFunds', 'CanAddFundsResolve', function AvailableBanksResolve(HoldingFunds, CanAddFundsResolve) {
        'ngInject';

        return HoldingFunds.getAftrBanks();
      }],
      CanAddFundsResolve: ['HoldingFunds', function CanAddFundsResolve(HoldingFunds) {
        'ngInject';

        return HoldingFunds.resolveCanAddFunds();
      }],
      SelectedCurrencyResolve: ['$q', '$stateParams', function SelectedCurrencyResolve($q, $stateParams) {
        'ngInject';

        return 'currency' in $stateParams ? $q.when($stateParams.currency) : $q.when();
      }]
    },
    url: '/bank-wire',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'AddFundsBankWireController',
        controllerAs: 'addFundsBankWireCtrl',
        template: _bankWire2.default
      }
    }
  });

  $urlRouterProvider.when('/funds/add/bank-wire', '/funds/add/bank-wire/amount');
}]);

__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(547);
__webpack_require__(549);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Add Funds'),
    cancel: {
        state: 'holding.dashboard.funds.add'
    },
    complete: {
        label: (0, _gettext2.default)('Review Pending Transfers'),
        state: 'holding.dashboard.funds.add'
    },
    steps: [{
        key: 'amount',
        state: 'holding.dashboard.funds.add.bank-wire.amount',
        heading: (0, _gettext2.default)('Add Funds via Bank Wire'),
        label: (0, _gettext2.default)('Enter Amount')
    }, {
        key: 'review',
        state: 'holding.dashboard.funds.add.bank-wire.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Transfer'),
        label: (0, _gettext2.default)('Review Transfer')
    }, {
        key: 'complete',
        state: 'holding.dashboard.funds.add.bank-wire.complete',
        complete: true,
        heading: (0, _gettext2.default)('Transfer Instructions'),
        label: (0, _gettext2.default)('Transfer Instructions')
    }]
};
exports.default = flow;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I Add Funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddFundsBankWireController.$inject = ['$controller', '$scope', '$q', 'HoldingUser', 'HoldingFunds', 'HoldingCurrencies', 'HoldingProperties', 'AvailableBanksResolve', 'SelectedCurrencyResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app.holding.dashboard.funds.add').controller('AddFundsBankWireController', AddFundsBankWireController);

function AddFundsBankWireController($controller, $scope, $q, HoldingUser, HoldingFunds, HoldingCurrencies, HoldingProperties, AvailableBanksResolve, SelectedCurrencyResolve) {
  'ngInject';

  var DEFAULT_MODEL = {
    amount: {
      currency: SelectedCurrencyResolve
    },
    moneyTransferFundingSelected: false
  };

  var vm = this;
  var result = {};

  var didComplete = false;

  vm.steps = {
    'holding.dashboard.funds.add.bank-wire.review': {
      checks: [{
        function: checkInfo,
        revertTo: 'holding.dashboard.funds.add.bank-wire.amount'
      }],
      next: executeAdd
    },
    'holding.dashboard.funds.add.bank-wire.complete': {
      checks: [{
        function: checkInfo,
        revertTo: 'holding.dashboard.funds.add.bank-wire.amount'
      }, {
        function: checkComplete,
        revertTo: 'holding.dashboard.funds.add.bank-wire.review'
      }]
    }
  };

  vm.banks = [];
  vm.bankDocumentUploadConfig = {
    extensions: ['.jpg', '.jpeg', '.pdf', '.png'],
    maxFiles: 1,
    maxSize: '5000000'
  };
  vm.isCurrencySelected = isCurrencySelected;
  vm.isMigrated = HoldingProperties.get('HoldingRegulationMigrationStarted');
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.moneyTransferDocumentUploadConfig = {
    extensions: ['.jpg', '.jpeg', '.pdf', '.png'],
    maxFiles: 10,
    maxSize: '5000000'
  };
  vm.result = result;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    vm.user = HoldingUser.get();
    vm.holdingNumber = vm.user.holdingNumber;

    vm.allBanks = AvailableBanksResolve;
    vm.currencies = availableCurrencies();
  }

  function checkComplete() {
    return didComplete;
  }

  function checkInfo() {
    return !!vm.model.amount.amount && !!vm.model.amount.currency && !!vm.model.bank;
  }

  function availableCurrencies() {
    return uniq(AvailableBanksResolve.map(function (_) {
      return _.instructions.currency;
    })).filter(function (currency) {
      return vm.moneyTransferFundingSelected && vm.user.regulation === 'Toronto' ? ['CAD', 'EUR', 'USD'].find(function (enabled) {
        return enabled === currency;
      }) : currency;
    }).map(HoldingCurrencies.prepareForSelector).sort(function (a, b) {
      if (a.label.toUpperCase() < b.label.toUpperCase()) {
        return -1;
      } else if (a.label.toUpperCase() > b.label.toUpperCase()) {
        return 1;
      }
      return 0;
    });
  }

  function executeAdd() {
    return HoldingFunds.addFundsBankWire(vm.model).then(function (data) {
      vm.result.model = angular.copy(vm.model);
      vm.result.data = data;
      didComplete = true;
    }).catch(function (_ref) {
      var message = _ref.message;

      vm.executionError = message;
      return $q.reject(message);
    });
  }

  function isCurrencySelected() {
    return !!vm.model.amount.currency;
  }

  function onCurrencyChange(currency) {
    if (currency) {
      HoldingFunds.getMaxAftr(currency).then(function (_ref2) {
        var maxAFTRAmt = _ref2.maxAFTRAmt,
            maxAllowedConverted = _ref2.maxAllowedConverted,
            maximumFundable = _ref2.maximumFundable,
            totalPendingAFTRs = _ref2.totalPendingAFTRs,
            totalTxnLog = _ref2.totalTxnLog;

        vm.maxAftr = maxAFTRAmt;
        vm.maxAllowedConverted = maxAllowedConverted;
        vm.maximumFundable = maximumFundable;
        vm.totalPendingAftrs = totalPendingAFTRs;
        vm.totalTxnLog = totalTxnLog;
      });
    }
  }

  function uniq(a) {
    return Array.from(new Set(a));
  }

  function updateAvailableBanks(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        currency = _ref4[0],
        allBanks = _ref4[1];

    vm.banks = allBanks && allBanks.filter(function (bank) {
      return bank.instructions.currency === currency;
    }).map(function (bank) {
      return {
        value: bank,
        label: bank.location
      };
    });
  }

  activate();

  $scope.$watch(function () {
    return vm.moneyTransferFundingSelected;
  }, function () {
    vm.currencies = availableCurrencies();
  });
  $scope.$watch(function () {
    return vm.model.amount.currency;
  }, onCurrencyChange);
  $scope.$watchGroup([function () {
    return vm.model.amount.currency;
  }, function () {
    return vm.allBanks;
  }], updateAvailableBanks);
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _amount = __webpack_require__(546);

var _amount2 = _interopRequireDefault(_amount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.bank-wire.amount', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Add Funds - Bank Wire - Enter Amount'
    },
    url: '/amount',
    views: {
      step: {
        template: _amount2.default
      }
    }
  });
}]);

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Select currency and enter the amount you wish to transfer to Goldmoney’s bank location to fund your Holding. Please note:'|translate\"> </p> <ul class=\"gmw-basic-list gmw-flow-box__header-list\"> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Your Holding may only be funded by bank accounts in your own name.'|translate\"> </span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'We do not accept cash deposits - these funds will not be accepted and will be returned without being credited to your Holding.'|translate\"> </span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'It may take up to six business days to process your bank transfer. You will be notified via secure message when funds have been successfully deposited.'|translate\"> </span> </li> </ul> <p class=gmw-flow-box__header-description> <span class=h-base-text ng-bind=\"'Please see our'|translate\"></span> <a holding-external-link=support.funding.main class=h-blue-link ng-bind=\"'Funding and Transfers FAQs'|translate\"></a> <span class=h-base-text ng-bind=\"'for more details.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=addFundsBankWireCtrl.form> <holding-alert ng-if=addFundsBankWireCtrl.isMigrated can-dismiss=migrationAddFundsBank_1611854173 class=warning title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'We\\'ve changed our banking relationships - please ensure that you transfer funds to the correct institution using the information provided once you complete initiating your funding. Funds sent to the incorrect institution will be returned to your bank at a cost to you, and could take up to 10 business days.'|translate\"></span> </main> </holding-alert> <div class=gmw-flow-box__callout> <holding-alert ng-if=addFundsBankWireCtrl.moneyTransferFundingSelected class=info title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'If you are transfering funds via a money transfer provider, please ensure that you upload the required proof of funds documentation on the Pending Transactions screen after you send the funds.'|translate\"></span> <span ng-if=\"addFundsBankWireCtrl.user.regulation === 'Toronto'\" ng-bind=\"'Also note that we can only accept funds from these providers in USD, EUR, and CAD.'|translate\"></span> </main> </holding-alert> <p class=gmw-flow-box__callout-block> <gmw-checkbox ng-model=addFundsBankWireCtrl.moneyTransferFundingSelected> <span> <span ng-bind=\"'I will be transfering funds via TransferWise, Revolut or a similar money transfer provider.'|translate\"></span> </span> </gmw-checkbox> </p> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=addFundsBankWireCtrl.model.amount.currency options=addFundsBankWireCtrl.currencies label=\"{{'Currency You Intend To Wire'|translate}}\"> </gmw-box-selector> <gmw-box-selector required name=bank class=gmw-input-container--split-half__col ng-model=addFundsBankWireCtrl.model.bank options=addFundsBankWireCtrl.banks label=\"{{'Goldmoney\\'s Bank Location'|translate}}\"> </gmw-box-selector> </div> <div ng-if=addFundsBankWireCtrl.form.amount.$touched ng-messages=addFundsBankWireCtrl.form.amount.$error> <ng-message when=max> <holding-alert ng-if=\"addFundsBankWireCtrl.maxAftr.amount > 0\" class=error title=\"{{'Error'|translate}}\"> <main> <span> The maximum amount of funds that you may add at this time is {{addFundsBankWireCtrl.maxAftr|holdingFormatFunds}}. </span> </main> </holding-alert> <holding-alert ng-if=\"addFundsBankWireCtrl.maxAftr.amount === 0\" class=error title=\"{{'Transfer Restrictions'|translate}}\"> <main> <span ng-if=\"addFundsBankWireCtrl.model.amount.currency === 'USD'\"> Based on the current status of your Holding, the total amount you may transfer into your Holding is {{addFundsBankWireCtrl.maximumFundable|holdingFormatFunds}}. </span> <span ng-if=\"addFundsBankWireCtrl.model.amount.currency !== 'USD'\"> Based on the current status of your Holding, the total amount you may transfer into your Holding is the equivalent value of {{addFundsBankWireCtrl.maximumFundable|holdingFormatFunds}} ({{addFundsBankWireCtrl.maxAllowedConverted|holdingFormatFunds}} at current rates). </span> <span ng-if=\"addFundsBankWireCtrl.totalPendingAftrs.amount > 0 && addFundsBankWireCtrl.totalTxnLog.amount > 0\"> You have already placed Add Funds Transfers to the equivalent value of {{addFundsBankWireCtrl.totalPendingAftrs|holdingFormatFunds}}, and your Holding's history indicates that the equivalent value of {{addFundsBankWireCtrl.totalTxnLog|holdingFormatFunds}} has already been transferred into your Holding. </span> <span ng-if=\"addFundsBankWireCtrl.totalPendingAftrs.amount > 0 && addFundsBankWireCtrl.totalTxnLog.amount === 0\"> You have already placed Add Funds Transfers to the equivalent value of {{addFundsBankWireCtrl.totalPendingAftrs|holdingFormatFunds}}. </span> <span ng-if=\"addFundsBankWireCtrl.totalPendingAftrs.amount === 0 && addFundsBankWireCtrl.totalTxnLog.amount > 0\"> Your Holding's history indicates that the equivalent value of {{addFundsBankWireCtrl.totalTxnLog|holdingFormatFunds}} has already been transferred into your Holding. </span> <span ng-if=\"addFundsBankWireCtrl.totalPendingAftrs.amount === 0 && addFundsBankWireCtrl.totalTxnLog.amount === 0\"> An unexpected error occurred when attempting to verify the maximum amount of {{addFundsBankWireCtrl.model.amount.currency}} that may be added to your Holding. </span> </main> </holding-alert> </ng-message> <ng-message when=required> <holding-alert class=error title=\"{{'Error'|translate}}\"> <main> <span ng-bind=\"'Please enter a valid amount'|translate\"></span> </main> </holding-alert> </ng-message> </div> <gmw-box-input required name=amount type=number currency=\"{{addFundsBankWireCtrl.model.amount.currency}}\" class=gmw-input-container ng-model=addFundsBankWireCtrl.model.amount.amount ng-model-options=\"{\n      debounce: 400,\n    }\" label=\"{{'Amount to Transfer'|translate}}\" max=addFundsBankWireCtrl.maxAftr.amount placeholder=0.00> <gmw-box-input-meta-left> {{addFundsBankWireCtrl.model.amount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=addFundsBankWireCtrl.cancel() on-next=addFundsBankWireCtrl.next() step-disabled=\"addFundsBankWireCtrl.form.$invalid || addFundsBankWireCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(548);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.bank-wire.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Add Funds - Bank Wire - Transfer Instructions'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please provide the below instructions to your bank to initiate transferring the indicated funds to Goldmoney. Should you need the below instructions in the future, they can be found in your Pending Funds Transfers under Add Funds.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=\"warning no-print\"> <span> <span ng-bind=\"'Please note:'|translate\"></span> <ul class=gmw-alert-list> <li> <span ng-bind=\"'Ensure that you include the specific `REFERENCE NUMBER` and \\'DO NOT CONVERT FUNDS\\' instructions as detailed below.'|translate\"></span> </li> <li> <span ng-bind=\"'We do not accept cash deposits - these funds will not be accepted and will be returned without being credited to your Holding.'|translate\"></span> </li> <li ng-if=addFundsBankWireCtrl.moneyTransferFundingSelected> <span ng-bind=\"'If you are transfering funds via TransferWise, Revolut or a similar money transfer provider, please ensure that you have provided the required proof of funds documentation to us after you send the funds.'|translate\"></span> </li> </ul> </span> </holding-alert-legacy> <holding-transfer-instructions amount=addFundsBankWireCtrl.result.model.amount bank=addFundsBankWireCtrl.result.model.bank transfer-number=addFundsBankWireCtrl.result.data.paymentReference> </holding-transfer-instructions> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button gmw-print class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-bind=\"'Print Instructions'|translate\"> </button> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" ui-sref=\"holding.dashboard.funds.add.detail({\n        code: addFundsBankWireCtrl.result.data.paymentCode,\n      })\"> <span ng-bind=\"'Review Pending Transfer'|translate\"></span> </button> </div> </footer> ";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(550);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.bank-wire.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Add Funds - Bank Wire - Review Transfer'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please confirm the information below is correct before proceeding.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=addFundsBankWireCtrl.form> <div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Currency'|translate\"> </span> <span class=gmw-to-and-from__data> <gmw-flag country=addFundsBankWireCtrl.model.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=addFundsBankWireCtrl.model.amount.currency></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=addFundsBankWireCtrl.model.amount|holdingFormatFunds> </span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--single gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Receiving Bank'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=addFundsBankWireCtrl.model.bank.location> </span> </div> </div> </div> <holding-alert-legacy class=error ng-if=addFundsBankWireCtrl.executionError> <span ng-bind=addFundsBankWireCtrl.executionError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=addFundsBankWireCtrl.cancel() on-next=addFundsBankWireCtrl.next() step-disabled=\"addFundsBankWireCtrl.form.$invalid || addFundsBankWireCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _detail = __webpack_require__(552);

var _detail2 = _interopRequireDefault(_detail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.detail', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Add Funds - Funds Transfer Detail'
    },
    resolve: {
      PendingTransferResolve: ['$q', '$log', '$stateParams', 'HoldingFunds', function PendingTransferResolve($q, $log, $stateParams, HoldingFunds) {
        'ngInject';

        var deferred = $q.defer();
        HoldingFunds.getPendingAddFunds().then(function (transfers) {
          var transfer = transfers.find(function (_) {
            return _.code.toString() === $stateParams.code;
          });

          if (!transfer) {
            deferred.reject({
              redirectTo: 'holding.dashboard.funds.add.overview'
            });
          }

          deferred.resolve(transfer);
        }).catch(function (error) {
          $log.error(error);
          deferred.reject({
            redirectTo: 'holding.dashboard.funds.add.overview'
          });
        });
        return deferred.promise;
      }]
    },
    url: '/:code',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'AddFundsDetailController',
        controllerAs: 'addFundsDetailCtrl',
        template: _detail2.default
      }
    }
  });
}]);

__webpack_require__(553);

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view ng-form=addFundsDetailCtrl.form> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Transfer Details'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\" ng-bind=\"'Please use the following instructions to send funds to Goldmoney.'|translate\"> </p> </header> <div class=gmw-flow-box-container> <holding-alert-legacy ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\" class=\"warning no-print\"> <span> <span ng-bind=\"'Please note:'|translate\"></span> <ul class=gmw-alert-list> <li> <span ng-bind=\"'Ensure that you include the specific `REFERENCE NUMBER` and \\'DO NOT CONVERT FUNDS\\' instructions as detailed below.'|translate\"></span> </li> <li> <span ng-bind=\"'We do not accept cash deposits - these funds will not be accepted and will be returned without being credited to your Holding.'|translate\"></span> </li> <li> <span ng-bind=\"'If you are transfering funds via TransferWise, Revolut or a similar money transfer provider, please ensure that you have provided the'|translate\"></span> <a href=#proof-of-funds class=gmw-alert-link ng-bind=\"'required documentation'|translate\"></a> <span ng-bind=\"'below.'|translate\"></span> </li> </ul> </span> </holding-alert-legacy> <div class=\"gmw-recap-table no-print\"> <div class=gmw-recap-table__body> <gmw-recap-table-row label=\"{{'Add Funds Transfer Number'|translate}}\"> <span ng-bind=::addFundsDetailCtrl.transfer.number></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Status'|translate}}\"> <span ng-bind=::(addFundsDetailCtrl.transfer.status|holdingFormatFundsAddStatus:addFundsDetailCtrl.transfer.trm)></span> </gmw-recap-table-row> <gmw-recap-table-row ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\" label=\"{{'Bank Location'|translate}}\"> <span ng-bind=::addFundsDetailCtrl.transfer.gBankAftrLoc></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Currency'|translate}}\"> <gmw-flag country=addFundsDetailCtrl.transfer.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=::addFundsDetailCtrl.transfer.amount.currency></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Amount'|translate}}\"> <span ng-bind=::(addFundsDetailCtrl.transfer.amount|holdingFormatFunds)> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Date Requested'|translate}}\"> <span ng-bind=::(addFundsDetailCtrl.transfer.ts|gmwFormatDateTime)></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Add Funds Via'|translate}}\"> <span ng-bind=::addFundsDetailCtrl.getAftrType(addFundsDetailCtrl.transfer)></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Date Received'|translate}}\"> <span ng-switch=::addFundsDetailCtrl.transfer.trm> <span ng-switch-when=BankWire ng-bind=\"'Awaiting Receipt'|translate\"></span> <span ng-switch-default> <span ng-if=!addFundsDetailCtrl.transfer.recon ng-bind=\"'Awaiting Confirmation'|translate\"> </span> <span ng-if=addFundsDetailCtrl.transfer.recon ng-bind=addFundsDetailCtrl.transfer.recon|gmwFormatDateTime> </span> </span> </span> </gmw-recap-table-row> </div> </div> <holding-transfer-instructions ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\" amount=addFundsDetailCtrl.transfer.amount bank=addFundsDetailCtrl.bank transfer-number=addFundsDetailCtrl.transfer.number> </holding-transfer-instructions> <div id=proof-of-funds class=\"h-margin-top-30 no-print\" ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\"> <holding-alert-legacy class=warning> <span ng-bind=\"'Please note, if asked by Goldmoney Staff to provide proof of funds documents for TransferWise, Revolut or a similar money transfer provider, please use the upload form below.'|translate\"></span> </holding-alert-legacy> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=gmw-input-container--split-half__col> <div class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Bank Statement Upload'|translate\"> </div> <div class=gmw-input-container__description> <span ng-bind=\"'Please upload a clear copy of a bank account statement showing:'|translate\"></span> <ul class=gmw-basic-list> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Your name, matching the name associated with your Holding, and;'|translate\"> </span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'The date and amount of the funds transfer from your bank account to the money transfer service.'|translate\"> </span> </li> </ul> </div> <holding-file-upload name=bankDocument ng-model=addFundsDetailCtrl.model.bankDocument document-config=addFundsDetailCtrl.bankDocumentUploadConfig ng-required=\"!addFundsDetailCtrl.model.moneyTransferDocument || addFundsDetailCtrl.model.moneyTransferDocument.length < 1\"> </holding-file-upload> </div> <div class=gmw-input-container--split-half__col> <div class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Money Transfer Statement'|translate\"> </div> <div class=gmw-input-container__description> <span ng-bind=\"'Please upload a clear copy of a statement from your money transfer service account showing:'|translate\"></span> <ul class=gmw-basic-list> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Your name, matching the name associated with your Holding, and;'|translate\"> </span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'The date and amount of the funds transfer from your money service account to Goldmoney.'|translate\"> </span> </li> </ul> </div> <holding-file-upload name=moneyTransferDocument ng-model=addFundsDetailCtrl.model.moneyTransferDocument document-config=addFundsDetailCtrl.moneyTransferDocumentUploadConfig ng-required=\"!addFundsDetailCtrl.model.bankDocument || addFundsDetailCtrl.model.bankDocument.length < 1\"> </holding-file-upload> </div> </div> <holding-alert-legacy class=error ng-if=addFundsDetailCtrl.uploadError> <span ng-bind=addFundsDetailCtrl.uploadError></span> </holding-alert-legacy> <holding-alert-legacy class=success ng-if=addFundsDetailCtrl.uploadSuccess> <span ng-bind=\"'Your proof of funds documents have been submitted and will be reviewed once we receive your funds.'|translate\"></span> </holding-alert-legacy> </div> </div> <footer class=\"gmw-flow-box-footer gmw-flow-box-footer--multi-button\" ng-if=\"addFundsDetailCtrl.transfer.status === 'Received' || addFundsDetailCtrl.transfer.trm === 'BankWire'\"> <div class=\"gmw-flow-box-footer__col mobile-only mobile-only--md\" ng-if=\"addFundsDetailCtrl.transfer.status === 'Received'\"> <button class=\"medium-deny-cta gmw-responsive-button\" ng-click=addFundsDetailCtrl.cancel()> <span ng-bind=\"'Cancel Transfer'|translate\"></span> </button> </div> <div class=\"gmw-flow-box-footer__col desktop-only desktop-only--md\" ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\"> <button gmw-print class=\"medium-border-cta gmw-responsive-button\"> <span ng-bind=\"'Print Instructions'|translate\"></span> </button> </div> <div class=\"gmw-flow-box-footer__col mobile-only mobile-only--md gmw-flow-box-footer__col--center\" ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\"> <button gmw-print class=\"medium-border-cta gmw-responsive-button\"> <span ng-bind=\"'Print Instructions'|translate\"></span> </button> </div> <div class=gmw-flow-box-footer__col ng-if=\"addFundsDetailCtrl.transfer.trm === 'BankWire'\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n            'loading-button': addFundsDetailCtrl.isUploading\n          }\" ng-disabled=\"addFundsDetailCtrl.form.$invalid || addFundsDetailCtrl.form.$submitted\" ng-click=addFundsDetailCtrl.uploadDocuments()> <span ng-bind=\"'Upload Documents'|translate\"></span> </button> </div> </footer> </div> <div class=sidebar-app-view__sidebar> <section class=holding-dashboard-sidebar> <div class=holding-dashboard-sidebar__box> <span class=h-dark-text ng-bind=addFundsDetailCtrl.transfer.number></span> </div> <div class=\"holding-dashboard-sidebar__box holding-dashboard-sidebar__box--pointer\" ng-if=\"addFundsDetailCtrl.transfer.status === 'Received'\" ng-click=addFundsDetailCtrl.cancel()> <span class=holding-dashboard-sidebar__box--command> <holding-svg-icon class=remove-icon icon=cross width=16px height=16px> </holding-svg-icon> <span ng-bind=\"'Cancel Add Funds Transfer'|translate\"></span> </span> </div> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I Add Funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </section> </div> </section> ";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddFundsDetailController.$inject = ['$state', '$log', 'gettextCatalog', 'HoldingUser', 'HoldingFunds', 'GmwModal', 'PendingTransferResolve'];
angular.module('app.holding.dashboard.funds.add').controller('AddFundsDetailController', AddFundsDetailController);

function AddFundsDetailController($state, $log, gettextCatalog, HoldingUser, HoldingFunds, GmwModal, PendingTransferResolve) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.bankDocumentUploadConfig = {
    extensions: ['.jpg', '.jpeg', '.pdf', '.png'],
    maxFiles: 10,
    maxSize: '5000000'
  };
  vm.cancel = cancel;
  vm.getAftrType = getAftrType;
  vm.isUploading = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.moneyTransferDocumentUploadConfig = {
    extensions: ['.jpg', '.jpeg', '.pdf', '.png'],
    maxFiles: 10,
    maxSize: '5000000'
  };
  vm.uploadDocuments = uploadDocuments;
  vm.uploadSuccess = false;

  function activate() {
    vm.user = HoldingUser.get();
    vm.holdingNumber = vm.user.holdingNumber;
    vm.transfer = PendingTransferResolve;

    if (vm.transfer.bankInstructions) {
      vm.bank = {
        instructions: vm.transfer.bankInstructions
      };

      if ('intermediaryBank' in vm.transfer.bankInstructions) {
        vm.bank.intermediaryBank = vm.transfer.bankInstructions.intermediaryBank;
        delete vm.bank.instructions.intermediaryBank;
      }
    }
  }

  function cancel() {
    GmwModal.showConfirmationModal('Do you want to cancel this transfer?').then(function () {
      HoldingFunds.cancelAddFunds(vm.transfer).then(function () {
        return goToOverview(true);
      });
    });
  }

  function getAftrType(aftr) {
    if (aftr && 'trm' in aftr) {
      return HoldingFunds.getAftrMethod(aftr.trm).label;
    }
    return 'Unknown';
  }

  function goToOverview() {
    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    $state.go('holding.dashboard.funds.add.overview', {}, { reload: reload });
  }

  function uploadDocuments() {
    vm.isUploading = true;
    vm.uploadSuccess = false;
    return HoldingFunds.uploadProofOfFundsDocument(vm.model.bankDocument).then(HoldingFunds.uploadProofOfFundsDocument(vm.model.moneyTransferDocument), function (_ref) {
      var data = _ref.data;

      if (data && 'message' in data) {
        switch (data.message) {
          case 'missing.data.part':
            vm.uploadError = 'An error has occurred during document upload, please try again later.';
            break;
          default:
            vm.uploadError = data.message;
            break;
        }
      } else {
        vm.uploadError = 'An error has occurred during document upload, please try again later.';
      }
    }).then(function () {
      vm.model.bankDocument = null;
      vm.model.moneyTransferDocument = null;
      vm.uploadSuccess = true;
    }).finally(function () {
      vm.isUploading = false;
      vm.form.$submitted = true;
    });
  }

  activate();
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _expectedUse = __webpack_require__(555);

var _expectedUse2 = _interopRequireDefault(_expectedUse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.expected-use', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Add Funds - Expected Holding Use'
    },
    params: {
      method: undefined,
      stateParams: undefined
    },
    resolve: {
      CanAddFundsResolve: ['$q', 'HoldingFunds', 'IsFeatureAllowedResolve', function CanAddFundsResolve($q, HoldingFunds, IsFeatureAllowedResolve) {
        'ngInject';

        if (IsFeatureAllowedResolve) {
          return HoldingFunds.resolveCanAddFunds('holding.dashboard.funds.add.overview');
        }
        return $q.reject({
          redirectTo: 'holding.dashboard.funds.add.overview'
        });
      }],
      IsFeatureAllowedResolve: ['$q', 'HoldingUser', function IsFeatureAllowedResolve($q, HoldingUser) {
        'ngInject';

        return $q.when(HoldingUser.isAllowed('addFunds'));
      }]
    },
    url: '/expected-use',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'AddFundsExpectedUseController',
        controllerAs: 'addFundsExpectedUseCtrl',
        template: _expectedUse2.default
      }
    }
  });
}]);

__webpack_require__(556);

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=addFundsExpectedUseCtrl.form> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-if=addFundsExpectedUseCtrl.model.isUpdate ng-bind=\"'Update Your Expected Use Information'|translate\"> </h2> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-if=!addFundsExpectedUseCtrl.model.isUpdate ng-bind=\"'Provide Your Expected Use Information'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-if=addFundsExpectedUseCtrl.model.isUpdate ng-bind=\"'We periodically need to update information about how you plan to use your Holding. Please make your best estimates below before adding funds.'|translate\"> </p> <p class=gmw-flow-box__header-description ng-if=!addFundsExpectedUseCtrl.model.isUpdate ng-bind=\"'In order to add funds, we first need to gather some information about how you plan to use your Holding. Please make your best estimates below.'|translate\"> </p> </header> <div class=gmw-flow-box-container> <gmw-expected-use class=gmw-input-container ng-model=addFundsExpectedUseCtrl.model.expectedUse> </gmw-expected-use> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col></div> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n        'loading-button': addFundsExpectedUseCtrl.isSelected,\n      }\" ng-click=addFundsExpectedUseCtrl.next() ng-disabled=\"addFundsExpectedUseCtrl.form.$invalid || addFundsExpectedUseCtrl.form.$submitted\"> <span ng-bind=\"'Next Step'|translate\"></span> </button> </footer> </div> ";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddFundsExpectedUseController.$inject = ['$state', '$q', '$log', '$stateParams', 'HoldingPreferences', 'GmwSetup', 'HoldingExpectedUse'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app.holding.dashboard.funds.add').controller('AddFundsExpectedUseController', AddFundsExpectedUseController);

function AddFundsExpectedUseController($state, $q, $log, $stateParams, HoldingPreferences, GmwSetup, HoldingExpectedUse) {
  'ngInject';

  var vm = this;
  var model = {
    expectedUse: {},
    isUpdate: true
  };

  vm.isSelected = false;
  vm.model = angular.copy(model);
  vm.next = next;

  function activate() {
    $q.all([GmwSetup.getSetupStatus(), HoldingPreferences.getPreferences()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          expectedUse = _ref2[0].expectedUse,
          displayCurrency = _ref2[1].displayCurrency;

      vm.model.expectedUse = expectedUse;
      if (HoldingExpectedUse.hasDefaultValues(expectedUse)) {
        vm.model.expectedUse.holdingValue = null;
        vm.model.expectedUse.transactionsValue = null;
        vm.model.expectedUse.transactionsCount = null;
        vm.model.isUpdate = false;
      }
      if (!HoldingExpectedUse.hasCompleteValues(expectedUse)) {
        vm.model.isUpdate = false;
      }
      vm.model.expectedUse.preferredCurrency = displayCurrency;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function next() {
    vm.isSelected = true;

    vm.model.expectedUse.holdingValue = parseInt(vm.model.expectedUse.holdingValue, 10);
    vm.model.expectedUse.transactionsValue = parseInt(vm.model.expectedUse.transactionsValue, 10);

    GmwSetup.updateExpectedUse(vm.model.expectedUse).then(function () {
      $state.go($stateParams.method, Object.assign({}, $stateParams.stateParams));
    }).catch(function (error) {
      $log.error(error);
    });
  }

  activate();
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _overview = __webpack_require__(558);

var _overview2 = _interopRequireDefault(_overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.add').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.add.overview', {
    data: {
      pageTitle: 'Add Funds - Pending Funds Transfers'
    },
    resolve: {
      HasPendingFundsResolve: ['$q', '$stateParams', 'HoldingFunds', function HasPendingFundsResolve($q, $stateParams, HoldingFunds) {
        'ngInject';

        return HoldingFunds.getPendingAddFunds().then(function (transfers) {
          if (transfers.length < 1) {
            return $q.resolve(false);
          }
          return $q.resolve(true);
        });
      }],
      ShouldCompleteExpectedUseResolve: ['$q', 'GmwSetup', 'HoldingExpectedUse', function ShouldCompleteExpectedUseResolve($q, GmwSetup, HoldingExpectedUse) {
        'ngInject';

        return GmwSetup.getSetupStatus(true).then(function (_ref) {
          var expectedUse = _ref.expectedUse;

          if (!HoldingExpectedUse.hasCompleteValues(expectedUse)) {
            return $q.when(true);
          }

          var lastExpectedUseCollection = (0, _moment2.default)(expectedUse.updated);
          if (lastExpectedUseCollection.isBefore((0, _moment2.default)().subtract(1, 'years'))) {
            return $q.when(true);
          }

          if (HoldingExpectedUse.hasDefaultValues(expectedUse) && lastExpectedUseCollection.isBefore((0, _moment2.default)('2019-05-11'))) {
            return $q.when(true);
          }
          return $q.when(false);
        });
      }]
    },
    url: '/overview',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'AddFundsOverviewController',
        controllerAs: 'addFundsOverviewCtrl',
        template: _overview2.default
      }
    }
  });
}]);

__webpack_require__(559);

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Pending Funds Transfers'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-bind=\"'Please note it may take up to six business days to process your funds transfers.'|translate\"> </p> </header> <div class=gmw-flow-box-container ng-form=addFundsOverviewCtrl.overviewForm> <div ng-show=addFundsOverviewCtrl.overviewForm.$invalid ng-messages=addFundsOverviewCtrl.overviewForm.$error> <div ng-message=loading> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred loading your pending transfers, please try again later.'|translate\"></span> </holding-alert-legacy> </div> <div ng-message=maxTransfers> <holding-alert-legacy class=info> <span ng-bind=\"'Note, that you have reached the maximium number of pending transfers permitted. You will be able to initiate another transfer once an existing pending transfer has cleared.'|translate\"></span> </holding-alert-legacy> </div> <div ng-message=partner> <holding-alert-legacy class=error> <span ng-bind=::addFundsOverviewCtrl.error.message></span> </holding-alert-legacy> </div> </div> <div ng-hide=addFundsOverviewCtrl.overviewForm.$error.loading> <holding-pending-add pending-transfers=addFundsOverviewCtrl.pendingTransfers></holding-pending-add> </div> </div> <footer class=gmw-flow-box-footer ng-show=\"addFundsOverviewCtrl.overviewForm.$valid && addFundsOverviewCtrl.canInitiateAdd\"> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button ng-click=addFundsOverviewCtrl.next() class=\"medium-main-cta gmw-responsive-button\"> <span ng-bind=\"'Initiate Another Fund Transfer'|translate\"></span> </button> </div> </footer> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I Add Funds?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360026787831> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What type of bank account can I use?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How much money can I send to my Holding?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddFundsOverviewController.$inject = ['$log', '$state', '$stateParams', 'HoldingFunds', 'HoldingConfig', 'HoldingUser', 'ShouldCompleteExpectedUseResolve', 'HasPendingFundsResolve'];
angular.module('app.holding.dashboard.funds.add').controller('AddFundsOverviewController', AddFundsOverviewController);

function AddFundsOverviewController($log, $state, $stateParams, HoldingFunds, HoldingConfig, HoldingUser, ShouldCompleteExpectedUseResolve, HasPendingFundsResolve) {
  'ngInject';

  function activate() {
    HoldingFunds.getPendingAddFunds().then(function (transfers) {
      vm.pendingTransfers = transfers;
      vm.loadedTransfers = true;

      if (vm.pendingTransfers.filter(function (transfer) {
        return transfer.status !== 'Completed';
      }).length >= HoldingConfig.settings.maxPendingTransfers) {
        vm.overviewForm.$setValidity('maxTransfers', false);
      }
    }).catch(function (error) {
      $log.error(error);

      if (error && 'code' in error) {
        switch (error.code) {
          case 'UNAUTHORIZED':
            vm.error = error;
            vm.overviewForm.$setValidity('partner', false);
            break;
          default:
            vm.overviewForm.$setValidity('loading', false);
            break;
        }
      } else {
        vm.overviewForm.$setValidity('loading', false);
      }
    });
  }

  function next() {
    if (ShouldCompleteExpectedUseResolve) {
      return $state.go('holding.dashboard.funds.add.expected-use', {
        method: 'holding.dashboard.funds.add.bank-wire'
        //stateParams: method.stateParams,
      });
    }
    return $state.go('holding.dashboard.funds.add.bank-wire');
  }

  if (!HasPendingFundsResolve) {
    $state.go('holding.dashboard.funds.add.bank-wire');
  }

  var vm = this;

  vm.canInitiateAdd = HoldingUser.isAllowed('addFunds');
  vm.next = next;

  activate();
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _exchangeFlow = __webpack_require__(561);

var _exchangeFlow2 = _interopRequireDefault(_exchangeFlow);

var _exchange = __webpack_require__(562);

var _exchange2 = _interopRequireDefault(_exchange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds.exchange', [_angularjs2.default, _common2.default]).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.exchange', {
    data: {
      flow: _exchangeFlow2.default
    },
    params: {
      currency: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      SelectedCurrencyResolve: ['$q', '$stateParams', function SelectedCurrencyResolve($q, $stateParams) {
        'ngInject';

        return 'currency' in $stateParams ? $q.when($stateParams.currency) : $q.when();
      }]
    },
    url: '/exchange',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'CurrencyExchangeController',
        controllerAs: 'currencyExchangeCtrl',
        template: _exchange2.default
      }
    }
  });

  $urlRouterProvider.when('/funds/exchange', '/funds/exchange/amount');
}]).name;


__webpack_require__(563);
__webpack_require__(565);
__webpack_require__(567);
__webpack_require__(568);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Currency Exchange'),
    cancel: {
        state: 'holding.dashboard.funds.exchange'
    },
    complete: {
        label: (0, _gettext2.default)('Return to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'amount',
        state: 'holding.dashboard.funds.exchange.amount',
        heading: (0, _gettext2.default)('Exchange Funds'),
        label: (0, _gettext2.default)('Select Currencies & Amount')
    }, {
        key: 'review',
        state: 'holding.dashboard.funds.exchange.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Your Order'),
        label: (0, _gettext2.default)('Review Funds Exchange'),
        controls: {
            next: (0, _gettext2.default)('Place Order')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.funds.exchange.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete Exchange')
    }]
};
exports.default = flow;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'What currencies can I exchange?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000737908> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How is the exchange rate determined?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004131728> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _amount = __webpack_require__(564);

var _amount2 = _interopRequireDefault(_amount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.exchange').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.exchange.amount', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Funds - Select Currencies & Amount'
    },
    url: '/amount',
    views: {
      step: {
        template: _amount2.default
      }
    }
  });
}]);

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> Exchange between currencies. Currency exchange rates are determined by the Goldmoney <a href holding-external-link=support.buy.fixed class=h-blue-link>Fixed Buy Price/Fixed Sell Price.</a> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=currencyExchangeCtrl.form> <div ng-show=currencyExchangeCtrl.form.$invalid ng-messages=currencyExchangeCtrl.form.$error> <div ng-message=nofunds> <holding-alert-legacy class=warning> <span ng-bind=\"'You do not have any funds available for exchange. You may only exchange spendable funds that are the proceeds of a previous sale.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=fromCurrency class=gmw-input-container--split-half__col ng-model=currencyExchangeCtrl.model.fromCurrency options=currencyExchangeCtrl.currencies label=\"{{'Sell Currency'|translate}}\"> </gmw-box-selector> <gmw-box-selector required name=toCurrency class=gmw-input-container--split-half__col ng-model=currencyExchangeCtrl.model.toCurrency options=currencyExchangeCtrl.toCurrencies label=\"{{'Buy Currency'|translate}}\"> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input required name=amount type=number currency=\"{{currencyExchangeCtrl.model.amount.currency}}\" class=gmw-input-container--split-half__col ng-model=currencyExchangeCtrl.model.amount.amount ng-model-options=\"{\n        debounce: 400,\n      }\" label=\"{{'Amount to Exchange'|translate}}\" max=currencyExchangeCtrl.maxExchangeAmount.amount placeholder=0.00> <gmw-box-input-meta-left> {{currencyExchangeCtrl.model.amount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> <gmw-box-selector required name=amountCurrency class=gmw-input-container--split-half__col ng-model=currencyExchangeCtrl.model.amount.currency options=currencyExchangeCtrl.amountCurrencies> </gmw-box-selector> </div> <div class=gmw-flow-box__callout ng-if=\"currencyExchangeCtrl.isFromCurrencySelected() && currencyExchangeCtrl.isToCurrencySelected()\"> <p class=gmw-flow-box__callout-block> <gmw-checkbox ng-model=currencyExchangeCtrl.exchangeMaxAmount> <span> <span ng-bind=\"'Exchange all of your'|translate\"></span> <span ng-bind=currencyExchangeCtrl.model.fromCurrency></span> <span ng-bind=\"'into'|translate\"></span> <span ng-bind=currencyExchangeCtrl.model.toCurrency></span> <span ng-bind=\"'-'|translate\"></span> <span class=h-dark-text ng-bind=currencyExchangeCtrl.maxExchangeAmount|holdingFormatFunds></span>. </span> </gmw-checkbox> </p> </div> <gmw-fee-tiers ng-if=currencyExchangeCtrl.loadedRates currency=currencyExchangeCtrl.model.fromCurrency product=currencyExchangeCtrl.model.toCurrency tiers=currencyExchangeCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=currencyExchangeCtrl.loadedRates currency=currencyExchangeCtrl.model.fromCurrency product=currencyExchangeCtrl.model.toCurrency tiers=currencyExchangeCtrl.tiers> </gmw-fee-tiers-mobile> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\" ng-if=currencyExchangeCtrl.loadedRates> <gmw-recap-table-header label=\"{{'Your Provisional Rate'|translate}}\" highlight=true> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Sell Amount'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.sellAmount|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Exchange Rate'|translate}}\"> <span ng-bind-html=currencyExchangeCtrl.ratePrice|gmwFormatProductRate></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Amount'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.buyAmount|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Exchange Fee'|translate}}\"> <span ng-bind=\"::currencyExchangeCtrl.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Price Last Updated'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.lastUpdated|gmwFormatDateTime></span> </gmw-recap-table-row> </div> </div> <holding-alert-legacy class=error ng-if=currencyExchangeCtrl.lockError> <span ng-bind=currencyExchangeCtrl.lockError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=currencyExchangeCtrl.cancel() on-next=currencyExchangeCtrl.next() step-disabled=\"currencyExchangeCtrl.form.$invalid || currencyExchangeCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(566);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.exchange').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.exchange.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Funds - Complete Exchange'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = "<gmw-order-complete-header order-number=\"{{::currencyExchangeCtrl.result.data.orderNo}}\"></gmw-order-complete-header> <div class=gmw-flow-box-container> <div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Sold'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=::currencyExchangeCtrl.result.data.sell.currency> </span> <span class=gmw-to-and-from__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=::currencyExchangeCtrl.result.data.sell|holdingFormatFunds> </span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Purchased'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=::currencyExchangeCtrl.result.data.buy.currency> </span> <span class=gmw-to-and-from__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=::currencyExchangeCtrl.result.data.buy|holdingFormatFunds> </span> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Exchange Rate'|translate}}\"> <span ng-bind-html=currencyExchangeCtrl.result.data.ratePrice|gmwFormatProductRate></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Rate Lock Time'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.locked.rateLockTime|gmwFormatDateTime></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Order Completion Time'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.locked.orderCompletionTime|gmwFormatDate></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Exchange Fee'|translate}}\"> <span ng-bind=\"::currencyExchangeCtrl.locked.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> </div> </div> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=currencyExchangeCtrl.cancel() on-next=currencyExchangeCtrl.next()> <button gmw-print class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-bind=\"'Print Order'|translate\"> </button> </holding-flow-controls> </footer> ";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CurrencyExchangeController.$inject = ['$controller', '$q', '$scope', '$stateParams', 'HoldingCurrencies', 'HoldingFunds', 'HoldingUser', 'SelectedCurrencyResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.exchange').controller('CurrencyExchangeController', CurrencyExchangeController);

function CurrencyExchangeController($controller, $q, $scope, $stateParams, HoldingCurrencies, HoldingFunds, HoldingUser, SelectedCurrencyResolve) {
  'ngInject';

  var vm = this;
  var model = {
    amount: {
      currency: SelectedCurrencyResolve
    }
  };
  var result = {};
  var didComplete = void 0;

  vm.steps = {
    'holding.dashboard.funds.exchange.amount': {
      checks: [],
      next: executeLock
    },
    'holding.dashboard.funds.exchange.review': {
      checks: [{
        function: checkAmount,
        revertTo: 'holding.dashboard.funds.exchange.amount'
      }],
      next: executeExchange
    },
    'holding.dashboard.funds.exchange.complete': {
      checks: [{
        function: checkAmount,
        revertTo: 'holding.dashboard.funds.exchange.amount'
      }, {
        function: checkComplete,
        revertTo: 'holding.dashboard.funds.exchange.review'
      }]
    }
  };

  vm.isFromCurrencySelected = isFromCurrencySelected;
  vm.isToCurrencySelected = isToCurrencySelected;
  vm.model = model;
  vm.result = result;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    vm.user = HoldingUser.get();

    vm.allCurrencies = HoldingCurrencies.getAllFiatForSelectorWithName();
    HoldingFunds.getExchangeCurrencies().then(function (currencies) {
      vm.currencies = currencies.map(function (currency) {
        var ret = HoldingCurrencies.prepareForSelector(currency.spendable.currency);
        ret.amount = currency.spendable;
        return ret;
      });

      if ($stateParams.currency) {
        vm.model.fromCurrency = $stateParams.currency;
      }

      if (vm.form) {
        vm.form.$setValidity('nofunds', vm.currencies.length > 0);
      }
    });
  }

  function checkComplete() {
    return didComplete;
  }

  function checkAmount() {
    return !!vm.model.amount.amount && !!vm.model.amount.currency;
  }

  function clearExchangeAmount() {
    vm.model.amount.amount = '';
  }

  function clearExchangeMaxAmount() {
    vm.exchangeMaxAmount = false;
  }

  function complete(data) {
    result.model = angular.copy(vm.model);
    result.data = data;
    didComplete = true;
  }

  function executeExchange() {
    return HoldingFunds.exchangeCurrencies(model).then(complete).catch(function (_ref) {
      var message = _ref.message;

      vm.orderError = message;
      return $q.reject();
    });
  }

  function executeLock() {
    return HoldingFunds.getExchangeRateLocked(model).then(function (locked) {
      vm.locked = locked;
    }).catch(function (_ref2) {
      var message = _ref2.message;

      vm.lockError = message;
      return $q.reject();
    });
  }

  function isFromCurrencySelected() {
    return !!vm.model.fromCurrency;
  }

  function isToCurrencySelected() {
    return !!vm.model.toCurrency;
  }

  function onCurrenciesUpdate(currencies) {
    if (currencies.every(function (_) {
      return !!_;
    })) {
      vm.amountCurrencies = currencies.map(HoldingCurrencies.prepareForSelector);
      vm.model.amount.currency = currencies[0];
    } else {
      vm.amountCurrencies = [];
      vm.model.amount.currency = undefined;
    }
  }

  function onExchangeMaxAmount() {
    var exchangeMaxAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (exchangeMaxAmount) {
      vm.model.amount = vm.maxExchangeAmount;
    }
  }

  function onFromCurrencyUpdate(currency) {
    if (currency) {
      clearExchangeMaxAmount();
      clearExchangeAmount();
      var fromCurrency = vm.currencies.find(function (_) {
        return _.value === currency;
      });
      vm.maxExchangeAmount = fromCurrency.amount;
    } else {
      vm.maxExchangeAmount = undefined;
    }

    vm.toCurrencies = vm.allCurrencies.filter(function (_) {
      return _.value !== currency;
    });
    if (!vm.toCurrencies.map(function (_) {
      return _.value;
    }).includes(vm.model.toCurrency)) {
      vm.model.toCurrency = undefined;
    }
  }

  function updateAmounts(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3),
        rate = _ref4[0],
        _ref4$ = _ref4[1],
        amount = _ref4$ === undefined ? 0 : _ref4$,
        currency = _ref4[2];

    if (rate && currency) {
      if (currency === model.fromCurrency) {
        vm.sellAmount = { amount: amount, currency: currency };
        vm.buyAmount = {
          amount: amount / rate,
          currency: model.toCurrency
        };
      } else {
        vm.sellAmount = {
          amount: amount * rate,
          currency: model.fromCurrency
        };
        vm.buyAmount = { amount: amount, currency: currency };
      }
    }
  }

  function updateRates(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 4),
        fromCurrency = _ref6[0],
        toCurrency = _ref6[1],
        amount = _ref6[2],
        amountCurrency = _ref6[3];

    vm.loadedRates = false;
    if (fromCurrency && toCurrency && amount && amountCurrency) {
      HoldingFunds.getExchangeRate(model).then(function (_ref7) {
        var buy = _ref7.buy,
            rateFeePercentage = _ref7.rateFeePercentage,
            rates = _ref7.rates,
            ratePrice = _ref7.ratePrice,
            sell = _ref7.sell,
            tiers = _ref7.tiers;

        vm.buyAmount = buy;
        vm.sellAmount = sell;
        vm.ratePrice = ratePrice;
        vm.rateFeePercentage = rateFeePercentage;
        vm.tiers = tiers;
        vm.lastUpdated = (0, _moment2.default)();
        vm.loadedRates = true;
      });
    }
  }

  activate();

  $scope.$watch('currencyExchangeCtrl.exchangeMaxAmount', onExchangeMaxAmount);

  $scope.$watch('currencyExchangeCtrl.model.fromCurrency', onFromCurrencyUpdate);

  $scope.$watchGroup(['currencyExchangeCtrl.model.fromCurrency', 'currencyExchangeCtrl.model.toCurrency'], onCurrenciesUpdate);

  $scope.$watchGroup(['currencyExchangeCtrl.model.fromCurrency', 'currencyExchangeCtrl.model.toCurrency', 'currencyExchangeCtrl.model.amount.amount', 'currencyExchangeCtrl.model.amount.currency'], updateRates);

  $scope.$watchGroup(['currencyExchangeCtrl.rate', 'currencyExchangeCtrl.model.amount.amount', 'currencyExchangeCtrl.model.amount.currency'], updateAmounts);
}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(569);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.exchange').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.exchange.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Funds - Review Funds Exchange'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Please review your currency exchange request below to ensure that you are satisfied with the details.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=currencyExchangeCtrl.form> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Sell Amount'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.locked.sell|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Exchange Rate'|translate}}\"> <span ng-bind-html=currencyExchangeCtrl.locked.ratePrice|gmwFormatProductRate></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Amount'|translate}}\"> <span ng-bind=::currencyExchangeCtrl.locked.buy|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Exchange Fee'|translate}}\"> <span ng-bind=\"::currencyExchangeCtrl.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <p class=h-margin-bottom-20> <span ng-bind=\"'Carefully review your order information. Once placed, your order cannot be modified or cancelled.'|translate\"></span> </p> <p class=h-margin-bottom-20 translate> <span ng-bind=\"'The final overall rate for this order will be based on the rate on'|translate\"></span> <span ng-bind=currencyExchangeCtrl.locked.rateLockTime|gmwFormatDateTime></span>. <span ng-bind=\"'Your order will be completed by'|translate\"></span> <span ng-bind=currencyExchangeCtrl.locked.orderCompletionTime|gmwFormatDate></span>. </p> <gmw-checkbox class=h-margin-bottom-20 ng-model=currencyExchangeCtrl.lockDisclaimer required> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-bind=\"'Click the box to confirm you understand the actual rate charged for your purchase will be determined using the foreign exchange rate set by our bank at the date and time specified.'|translate\"></span> </gmw-checkbox> <gmw-checkbox ng-model=buyModelCtrl.terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I accept the terms of the'|translate\"></span> <a ng-if=\"currencyExchangeCtrl.user.regulation == 'Toronto'\" class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Goldmoney Client Agreement'|translate\"></a> <a ng-if=\"currencyExchangeCtrl.user.regulation == 'UK'\" class=h-blue-link holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Goldmoney Client Agreement'|translate\"></a>. </span> </gmw-checkbox> </div> <holding-alert-legacy class=error ng-if=currencyExchangeCtrl.orderError> <span ng-bind=currencyExchangeCtrl.orderError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=currencyExchangeCtrl.cancel() on-next=currencyExchangeCtrl.next() step-disabled=\"currencyExchangeCtrl.form.$invalid || currencyExchangeCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds.remove', [_angularjs2.default, _common2.default]).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove', {
    params: {
      currency: {
        type: 'string',
        value: null
      }
    },
    url: '/remove'
  });

  $urlRouterProvider.when('/funds/remove', '/funds/remove/overview');
}]).name;


__webpack_require__(571);
__webpack_require__(583);
__webpack_require__(586);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bankWireFlow = __webpack_require__(572);

var _bankWireFlow2 = _interopRequireDefault(_bankWireFlow);

var _bankWire = __webpack_require__(573);

var _bankWire2 = _interopRequireDefault(_bankWire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.bank-wire', {
    data: {
      flow: _bankWireFlow2.default
    },
    resolve: {
      LoadResolve: ['$q', '$log', 'HoldingFunds', 'HoldingConfig', function LoadResolve($q, $log, HoldingFunds, HoldingConfig) {
        'ngInject';

        var deferred = $q.defer();

        HoldingFunds.getPendingRemoveFunds().then(function (transfers) {
          if (transfers.length < HoldingConfig.settings.maxPendingTransfers) {
            deferred.resolve();
          } else {
            deferred.reject({
              redirectTo: 'holding.dashboard.funds.remove.overview'
            });
          }
        }).catch(function (error) {
          $log.error(error);
          deferred.reject({
            redirectTo: 'holding.dashboard.funds.remove.overview'
          });
        });
        return deferred.promise;
      }]
    },
    url: '/bank-wire?destType&destId',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'RemoveFundsBankWireController',
        controllerAs: 'removeFundsBankWireCtrl',
        template: _bankWire2.default
      }
    }
  });

  $urlRouterProvider.when('/funds/remove/bank-wire?destType&destId', '/funds/remove/bank-wire/destination?destType&destId');
}]);

__webpack_require__(574);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(579);
__webpack_require__(581);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Withdraw Funds'),
    cancel: {
        state: 'holding.dashboard.funds.remove'
    },
    complete: {
        label: (0, _gettext2.default)('View Pending Withdrawals'),
        state: 'holding.dashboard.funds.remove'
    },
    steps: [{
        key: 'destination',
        state: 'holding.dashboard.funds.remove.bank-wire.destination',
        heading: (0, _gettext2.default)('Withdraw Funds'),
        label: (0, _gettext2.default)('Select Destination')
    }, {
        key: 'amount',
        state: 'holding.dashboard.funds.remove.bank-wire.amount',
        heading: (0, _gettext2.default)('Enter Amount'),
        label: (0, _gettext2.default)('Enter Amount')
    }, {
        key: 'review',
        state: 'holding.dashboard.funds.remove.bank-wire.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Withdrawal'),
        label: (0, _gettext2.default)('Review Withdrawal'),
        controls: {
            next: (0, _gettext2.default)('Confirm')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.funds.remove.bank-wire.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "<section class=\"gmw-flow-box gmw-flow-box--center\" ng-if=!removeFundsBankWireCtrl.canRemoveFunds> <holding-permission-based-empty-state permission=removeFunds></holding-permission-based-empty-state> </section> <div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" ng-if=removeFundsBankWireCtrl.canRemoveFunds gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view ng-if=removeFundsBankWireCtrl.canRemoveFunds> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step ng-form=removeFundsBankWireCtrl.createForm> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How long does a withdrawal take to process?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000534308> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _amount = __webpack_require__(575);

var _amount2 = _interopRequireDefault(_amount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateConfig = {
  data: {
    heroNoMobileActionTabs: true,
    pageTitle: 'Withdraw Funds - Bank Wire - Enter Amount'
  },
  url: '/amount',
  views: {
    step: {
      template: _amount2.default
    }
  }
};

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.bank-wire.amount', stateConfig);
}]);

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Select currency and enter the amount you wish to transfer to the selected bank.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=removeFundsBankWireCtrl.createForm> <div class=gmw-input-container ng-show=\"removeFundsBankWireCtrl.methods.length > 0\"> <gmw-box-selector ng-required=\"removeFundsBankWireCtrl.methods.length > 0\" name=method ng-model=removeFundsBankWireCtrl.model.method options=removeFundsBankWireCtrl.methods label=\"{{'Select Transfer Method'|translate}}\"> </gmw-box-selector> <div class=gmw-input-container__tooltip> <a href class=\"h-blue-link tooltip-bottom\" ng-bind=\"'What transfer method should I use?'|translate\" gmw-tooltip=\"{{'Depending on the speed of the transfer required, select the appropriate transfer method. Any additional costs incurred will be reflected in the transfer fees.'|translate}}\"></a> </div> </div> <div ng-show=\"removeFundsBankWireCtrl.createForm.amount.$dirty && removeFundsBankWireCtrl.createForm.amount.$invalid\" ng-messages=removeFundsBankWireCtrl.createForm.amount.$error> <div ng-message=min> <holding-alert class=error title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'The minimum transfer amount is'|translate\"></span> <span ng-bind=removeFundsBankWireCtrl.getMinTransfer()|holdingFormatFunds></span> <span ng-bind=\"' - please enter a larger amount.'|translate\"></span> </main> </holding-alert> </div> <div ng-message=max> <holding-alert class=error title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'The maximum transfer amount is'|translate\"></span> <span ng-bind=removeFundsBankWireCtrl.getMaxTransfer()|holdingFormatFunds></span> <span ng-bind=\"' - please enter a smaller amount.'|translate\"></span> </main> </holding-alert> </div> </div> <holding-alert class=warning ng-if=removeFundsBankWireCtrl.isCurrencyMismatch() title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'Please note that you may incur a conversion fee if the currency of the funds you are transferring differs from the currency of the receiving bank account.'|translate\"></span> </main> </holding-alert> <holding-alert class=error ng-if=\"removeFundsBankWireCtrl.getMinTransfer().amount > removeFundsBankWireCtrl.getMaxTransfer().amount\" title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'The balance of the selected currency does not meet the minimum withdrawal requirements. Please select another currency,'|translate\"></span> <a class=gmw-alert-link ui-sref=holding.dashboard.metals.sell ng-bind=\"'Sell Metal'|translate\"></a> <span ng-bind=\"'or'|translate\"></span> <a class=gmw-alert-link ui-sref=holding.dashboard.funds.add ng-bind=\"'Add Funds'|translate\"></a> <span ng-bind=\"'to proceed.'|translate\"></span> </main> </holding-alert> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=removeFundsBankWireCtrl.model.amount.currency options=removeFundsBankWireCtrl.rftrCurrencies label=\"{{'Select Currency & Enter Amount'|translate}}\"> </gmw-box-selector> <gmw-box-input ng-disabled=!removeFundsBankWireCtrl.isCurrencySelected() required name=amount type=number currency=\"{{removeFundsBankWireCtrl.model.amount.currency}}\" class=gmw-input-container--split-half__col has-error=\"removeFundsBankWireCtrl.createForm.amount.$dirty && removeFundsBankWireCtrl.createForm.amount.$invalid\" ng-model=removeFundsBankWireCtrl.model.amount.amount min=removeFundsBankWireCtrl.getMinTransfer().amount max=removeFundsBankWireCtrl.getMaxTransfer().amount placeholder=0.00> <gmw-box-input-meta-left> {{removeFundsBankWireCtrl.model.amount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=gmw-input-container ng-if=removeFundsBankWireCtrl.model.funding.destination.requireClientNotes> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Reason for Withdrawal'|translate\"></span> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'In order to complete your request, our banking partners require us to include the intended use of your funds being wired to ' + removeFundsBankWireCtrl.model.funding.destination.countryName + '.'}}\" ng-bind=\"'Why is this needed?'|translate\"> </a> </label> <gmw-box-input-simple name=clientNotes type=textarea placeholder=\"{{'Please enter your intended use of these funds in ' + removeFundsBankWireCtrl.model.funding.destination.countryName + '.'}}\" ng-model=removeFundsBankWireCtrl.model.clientNotes required> </gmw-box-input-simple> </div> <div class=gmw-flow-box__callout> <p class=\"h-margin-bottom-20 h-dark-text\" ng-bind=\"'Please note that your bank may charge a transfer fee.'|translate\"> </p> <p ng-bind=\"'All bank fees will be deducted from your currency balance. If the balance is not sufficient, the fees will be deducted from the transfer amount.'|translate\"></p> </div> <holding-alert-legacy class=error ng-if=removeFundsBankWireCtrl.amountError> <span ng-bind=removeFundsBankWireCtrl.amountError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=removeFundsBankWireCtrl.cancel() on-next=removeFundsBankWireCtrl.next() step-disabled=\"removeFundsBankWireCtrl.createForm.$invalid || removeFundsBankWireCtrl.createForm.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RemoveFundsBankWireController.$inject = ['$controller', '$scope', '$stateParams', '$q', '$log', 'HoldingBalances', 'HoldingFlow', 'HoldingFunds', 'GmwSetup', 'HoldingCurrencies', 'HoldingUser'];
angular.module('app.holding.dashboard.funds.remove').controller('RemoveFundsBankWireController', RemoveFundsBankWireController);

function reduceAmounts(prev, curr) {
  return { amount: prev.amount + curr.amount, currency: curr.currency };
}

function sumEquivalents(objects, user) {
  return objects.map(function (_) {
    return _.equivalent;
  }).reduce(reduceAmounts, { amount: 0, currency: user.currency });
}

function RemoveFundsBankWireController($controller, $scope, $stateParams, $q, $log, HoldingBalances, HoldingFlow, HoldingFunds, GmwSetup, HoldingCurrencies, HoldingUser) {
  HoldingBalances.getBalances(), 'ngInject';

  var MIN_TRANSFER = 0.01;

  var vm = this;

  var didComplete = void 0;

  vm.steps = {
    'holding.dashboard.funds.remove.bank-wire.amount': {
      checks: [{
        function: checkDestination,
        revertTo: 'holding.dashboard.funds.remove.bank-wire.destination'
      }],
      next: processAmount
    },
    'holding.dashboard.funds.remove.bank-wire.review': {
      checks: [{
        function: checkDestination,
        revertTo: 'holding.dashboard.funds.remove.bank-wire.destination'
      }, {
        function: checkAmount,
        revertTo: 'holding.dashboard.funds.remove.bank-wire.amount'
      }],
      next: processReview
    },
    'holding.dashboard.funds.remove.bank-wire.complete': {
      checks: [{
        function: checkDestination,
        revertTo: 'holding.dashboard.funds.remove.bank-wire.destination'
      }, {
        function: checkAmount,
        revertTo: 'holding.dashboard.funds.remove.bank-wire.amount'
      }, {
        function: checkComplete,
        revertTo: 'holding.dashboard.funds.remove.bank-wire.review'
      }]
    }
  };

  vm.banks = [];
  vm.complete = complete;
  vm.getMaxTransfer = getMaxTransfer;
  vm.getMinTransfer = getMinTransfer;
  vm.isBankAddressRequired = isBankAddressRequired;
  vm.isBankSwiftRequired = isBankSwiftRequired;
  vm.isCurrencyMismatch = isCurrencyMismatch;
  vm.isCurrencySelected = isCurrencySelected;
  vm.isDestinationSelected = isDestinationSelected;
  vm.methods = [];
  vm.model = {
    amount: {},
    clientNotes: null,
    funding: {
      destination: {}
    }
  };
  vm.result = {};
  vm.rftrCurrencies = [];
  vm.selectFundingSource = selectFundingSource;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    vm.user = HoldingUser.get();

    vm.canRemoveFunds = false;
    HoldingBalances.getBalances().then(function (_ref) {
      var fiat = _ref.fiat;

      vm.canRemoveFunds = HoldingUser.isAllowed('removeFunds') && sumEquivalents(fiat, vm.user).amount > 0;
    });

    HoldingFunds.getRftrBanks().then(function (banks) {
      vm.banks = banks;

      if (vm.createForm) {
        vm.createForm.$setValidity('accounts', hasBankAccounts());
      }

      vm.model.funding.type = 'bank';
      if (vm.banks.banks.length === 1) {
        vm.model.funding.destination = vm.banks.banks[0];
      }

      if ($stateParams.destId) {
        vm.model.funding.destination = vm.banks.banks.find(function (_) {
          return _.bankAccountId.toString() === $stateParams.destId;
        });
      }

      vm.rftrCurrencies = availableCurrencies();
    }).catch(function (error) {
      $log.error(error);

      if (vm.createForm) {
        vm.createForm.$setValidity('loading', false);
      }
    });
  }

  function availableCurrencies() {
    var currencies = getMaxRftrFromSource(vm.banks);

    if (currencies.length === 1) {
      vm.model.amount.currency = currencies[0].value;
    }
    return currencies;
  }

  function checkAmount() {
    return !!vm.model.amount.amount;
  }

  function checkDestination() {
    return !!vm.model.funding.destination.bankAccountId || vm.model.funding.destination.code;
  }

  function checkComplete() {
    return didComplete;
  }

  function complete() {
    HoldingFlow.complete();
  }

  function executeOrder() {
    return HoldingFunds.createRemoveFundsBank(vm.model).then(function (_ref2) {
      var feeAmount = _ref2.feeAmount,
          rftrNumber = _ref2.rftrNumber;

      vm.model.feeAmount = feeAmount;
      vm.result.orderNumber = rftrNumber;
      didComplete = true;
    });
  }

  function fundDestinationChanged(newVal, oldVal) {
    if (vm.createForm) {
      vm.createForm.$setValidity('destination', isDestinationSelected());
    }
    vm.rftrCurrencies = availableCurrencies();

    if (newVal && newVal !== oldVal) {
      if (isDestinationSelected()) {
        if (vm.createForm) {
          vm.createForm.$setValidity('bankWireNofunds', vm.rftrCurrencies.length > 0);
        }

        vm.methods = newVal.methodOptions.map(function (_ref3) {
          var methodOption = _ref3.methodOption,
              description = _ref3.description;
          return {
            label: HoldingFunds.getRftrMethod(methodOption).label,
            meta: description,
            value: methodOption
          };
        });
      } else {
        vm.methods = [];
      }
    }
  }

  function getMaxTransfer() {
    return 'currency' in vm.model.amount ? vm.banks.maximumRFTRAmountResult[vm.model.amount.currency].maxRFTRAmount : undefined;
  }

  function getMaxRftrFromSource(source) {
    var currencies = [];

    if (!('maximumRFTRAmountResult' in source)) {
      return currencies;
    }

    angular.forEach(source.maximumRFTRAmountResult, function (_ref4) {
      var maxRFTRAmount = _ref4.maxRFTRAmount;

      currencies.push(angular.extend(HoldingCurrencies.prepareForSelector(maxRFTRAmount.currency), {
        amount: maxRFTRAmount
      }));
    });

    return currencies.sort(function (a, b) {
      if (a.label.toUpperCase() < b.label.toUpperCase()) {
        return -1;
      } else if (a.label.toUpperCase() > b.label.toUpperCase()) {
        return 1;
      }
      return 0;
    });
  }

  function getMinTransfer() {
    return {
      amount: MIN_TRANSFER,
      currency: vm.model.amount.currency
    };
  }

  function hasBankAccounts() {
    return 'banks' in vm.banks && vm.banks.banks !== null && vm.banks.banks.length > 0;
  }

  function isBankAddressRequired() {
    return vm.model.shouldUpdateAddress;
  }

  function isBankSwiftRequired() {
    return vm.model.shouldUpdateSwiftCode;
  }

  function isCurrencyMismatch() {
    if (!isDestinationSelected()) {
      return false;
    }
    if (!('currency' in vm.model.amount) || !vm.model.amount.currency) {
      return false;
    }
    return vm.model.funding.destination.currencyCode !== vm.model.amount.currency;
  }

  function isCurrencySelected() {
    return !!vm.model.amount.currency;
  }

  function isDestinationSelected() {
    return 'currencyCode' in vm.model.funding.destination;
  }

  function processAmount() {
    vm.amountError = null;

    return HoldingFunds.initiateRemoveFundsBank(vm.model).then(function (_ref5) {
      var shouldUpdateAddress = _ref5.shouldUpdateAddress,
          shouldUpdateSwiftCode = _ref5.shouldUpdateSwiftCode,
          feeAmount = _ref5.feeAmount,
          pinRequired = _ref5.pinRequired;

      vm.model.feeAmount = feeAmount;
      vm.model.shouldUpdateAddress = shouldUpdateAddress;
      vm.model.shouldUpdateSwiftCode = shouldUpdateSwiftCode;
      vm.pinRequired = pinRequired;
    }).catch(function (_ref6) {
      var message = _ref6.message;

      vm.amountError = message;
      return $q.reject();
    });
  }

  function processReview() {
    vm.reviewError = null;

    return executeOrder().catch(function (_ref7) {
      var message = _ref7.message;

      vm.reviewError = message;
      return $q.reject();
    });
  }

  function selectFundingSource(source) {
    vm.model.funding.destination = source;
  }

  function uniq(a) {
    return Array.from(new Set(a));
  }

  $scope.$watch(function () {
    return vm.model.funding.destination;
  }, fundDestinationChanged);

  activate();
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(578);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateConfig = {
  data: {
    heroNoMobileActionTabs: true,
    pageTitle: 'Withdraw Funds - Bank Wire - Complete'
  },
  url: '/complete',
  views: {
    step: {
      template: _complete2.default
    }
  }
};

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.bank-wire.complete', stateConfig);
}]);

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = "<gmw-order-complete-header order-number=\"{{removeFundsBankWireCtrl.result.orderNumber}}\"></gmw-order-complete-header> <div class=gmw-flow-box-container> <div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Currency'|translate\"></span> <span class=gmw-to-and-from__data> <gmw-flag country=::(removeFundsBankWireCtrl.model.funding.destination.currencyCode|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::removeFundsBankWireCtrl.model.amount.currency|translate></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Amount'|translate\"></span> <span class=gmw-to-and-from__data ng-bind=::removeFundsBankWireCtrl.model.amount|holdingFormatFunds></span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--single gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Destination'|translate\"></span> <span class=gmw-to-and-from__data> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.funding.destination.nickName></span> </span> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Transfer Fee'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.feeAmount|holdingFormatFunds></span> </div> </div> </div> </div> <div class=gmw-flow-box__callout> <p ng-bind=\"'Requests received before 14:30 Europe/London will be processed on the same day, provided it is a business day; otherwise, requests will be processed on the next business day.'|translate\"> </p> </div> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=removeFundsBankWireCtrl.cancel() on-next=removeFundsBankWireCtrl.next()> </holding-flow-controls> </footer> ";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _destination = __webpack_require__(580);

var _destination2 = _interopRequireDefault(_destination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateConfig = {
  data: {
    heroNoMobileActionTabs: true,
    pageTitle: 'Withdraw Funds - Bank Wire - Select Destination'
  },
  url: '/destination?destType&destId',
  views: {
    step: {
      template: _destination2.default
    }
  }
};

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.bank-wire.destination', stateConfig);
}]);

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Select your funds destination from the available options below. Please note:'|translate\"> </p> <ul class=\"gmw-basic-list gmw-flow-box__header-list\"> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'You may only withdraw funds from your Holding that are the proceeds of a previous metal sale.'|translate\"> </span> </li> </ul> </holding-flow-header> <div class=gmw-flow-box-container ng-form=removeFundsBankWireCtrl.createForm> <div ng-show=removeFundsBankWireCtrl.createForm.$invalid ng-messages=removeFundsBankWireCtrl.createForm.$error> <div ng-message=accounts> <holding-alert class=info> <main> <span ng-bind=\"'In order to initiate a withdrawal, you must first connect a bank account.'|translate\"></span> </main> <cta> <a ui-sref=holding.dashboard.bank-accounts ng-bind=\"'Connect your bank account'|translate\"></a> </cta> </holding-alert> </div> <div ng-message=loading> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred loading your accounts, please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <div ng-hide=\"removeFundsBankWireCtrl.createForm.$error.accounts || removeFundsBankWireCtrl.createForm.$error.loading\"> <div ng-show=removeFundsBankWireCtrl.createForm.$invalid ng-messages=removeFundsBankWireCtrl.createForm.$error> <div ng-message=bankWireNofunds> <holding-alert class=warning> <main> <span ng-bind=\"'You do not have any available funds for withdrawal. Please note that you may only withdraw funds from your Holding that are the proceeds of a previous sale.'|translate\"></span> </main> </holding-alert> </div> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Select Bank Account'|translate\"> </label> <gmw-main-table desktop-only=true class=gmw-main-table--no-margin hover=true small=true full-width=true> <gmw-main-table-body> <gmw-main-table-body-row ng-click=removeFundsBankWireCtrl.selectFundingSource(bank) ng-repeat=\"bank in ::removeFundsBankWireCtrl.banks.banks track by $index\"> <gmw-main-table-body-col class=gmw-main-table__body-cell--10> <gmw-flag country=::(bank.currencyCode|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::bank.currencyCode></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::bank.nickName|gmwTruncate:10> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--15 h-light-text\" ng-bind=::bank.accountNumber> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::bank.transferText> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option checked=\"removeFundsBankWireCtrl.model.funding.destination === bank\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=gmw-input-container__tooltip ng-show=\"removeFundsBankWireCtrl.model.funding.destination.euroText && removeFundsBankWireCtrl.user.regulation == 'UK'\"> <a href class=\"h-blue-link tooltip-bottom\" ng-bind=\"'What transfer method will you use?'|translate\" gmw-tooltip=\"{{::removeFundsBankWireCtrl.model.funding.destination.euroText}}\"> </a> </div> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"bank in ::removeFundsBankWireCtrl.banks.banks track by $index\" ng-click=removeFundsBankWireCtrl.selectFundingSource(bank)> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <gmw-flag country=::(bank.currencyCode|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::bank.currencyCode></span> </div> <div class=gmw-simple-table__head-right> <gmw-radio-option checked=\"removeFundsBankWireCtrl.model.funding.destination === bank\" label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Nickname'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bank.nickName|gmwTruncate:15> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Account'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bank.accountNumber> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Transfer Method'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::bank.transferText> </span> </div> </div> </div> </div> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=removeFundsBankWireCtrl.cancel() on-next=removeFundsBankWireCtrl.next() step-disabled=\"removeFundsBankWireCtrl.createForm.$invalid || removeFundsBankWireCtrl.createForm.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(582);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateConfig = {
  data: {
    heroNoMobileActionTabs: true,
    pageTitle: 'Withdraw Funds - Bank Wire - Review Withdrawal'
  },
  url: '/review',
  views: {
    step: {
      template: _review2.default
    }
  }
};

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.bank-wire.review', stateConfig);
}]);

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span> You have requested to transfer {{::removeFundsBankWireCtrl.model.amount|holdingFormatFunds}} from your currency balance to your bank account. <span ng-if=removeFundsBankWireCtrl.pinRequired>Your funds transfer PIN has been sent to you via email or text message.</span> </span> </p> </holding-flow-header> <div class=gmw-flow-box-container> <div ng-show=removeFundsBankWireCtrl.createForm.$invalid ng-messages=removeFundsBankWireCtrl.createForm.$error> <div ng-message=loading> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred loading your accounts, please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <div ng-hide=removeFundsBankWireCtrl.createForm.$error.loading ng-form=removeFundsBankWireCtrl.createForm> <div ng-if=removeFundsBankWireCtrl.reviewError> <holding-alert-legacy class=error> <span ng-bind=removeFundsBankWireCtrl.reviewError></span> </holding-alert-legacy> </div> <div ng-show=\"removeFundsBankWireCtrl.createForm.pin.$dirty && removeFundsBankWireCtrl.createForm.pin.$invalid\" ng-messages=removeFundsBankWireCtrl.createForm.pin.$error> <div ng-message=required> <holding-alert-legacy class=error> <span ng-bind=\"'Please enter a valid pin value.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=gmw-flow-pin ng-if=removeFundsBankWireCtrl.pinRequired> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=gmw-input-container--split-half__col> <span class=\"gmw-flow-pin__title heading-h4 h-dark-text\" ng-bind=\"'Enter Transfer Pin'|translate\"> </span> <a href class=h-blue-link ng-bind=\"'What is this?'|translate\" gmw-tooltip=\"{{'Two-step authentication requires that you enter a seven-digit PIN code to transfer funds. This randomly generated PIN has been sent via email or text message (per your account settings). Please enter the PIN to complete your transfer.'|translate}}\"> </a> </div> <div class=gmw-input-container--split-half__col> <gmw-box-input required name=pin no-label=true has-error=\"removeFundsBankWireCtrl.createForm.pin.$dirty && removeFundsBankWireCtrl.createForm.pin.$invalid\" ng-model=removeFundsBankWireCtrl.model.pin placeholder=\"{{'Enter pin'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> </div> </div> <div ng-if=\"removeFundsBankWireCtrl.isBankAddressRequired() || removeFundsBankWireCtrl.isBankSwiftRequired()\"> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Confirm Bank Information'|translate\"></span> <p class=gmw-flow-box__description ng-bind=\"'Please enter/confirm the information below to complete your withdrawal request.'|translate\"> </p> </div> <div class=gmw-input-container ng-if=removeFundsBankWireCtrl.isBankAddressRequired()> <gmw-box-input required name=address1 type=text has-error=\"removeFundsBankWireCtrl.createForm.address1.$dirty && removeFundsBankWireCtrl.createForm.address1.$invalid\" ng-model=removeFundsBankWireCtrl.model.funding.destination.address1 label=\"{{'Bank Address'|translate}}\" placeholder=\"{{'Enter street address'|translate}}\"> </gmw-box-input> </div> <div class=gmw-input-container ng-if=removeFundsBankWireCtrl.isBankAddressRequired()> <gmw-box-input required name=address2 no-label=true type=text has-error=\"removeFundsBankWireCtrl.createForm.address2.$dirty && removeFundsBankWireCtrl.createForm.address2.$invalid\" ng-model=removeFundsBankWireCtrl.model.funding.destination.address2 placeholder=\"{{'Enter city, region'|translate}}\"> </gmw-box-input> </div> <div class=gmw-input-container ng-if=removeFundsBankWireCtrl.isBankAddressRequired()> <gmw-box-input name=address3 no-label=true type=text has-error=\"removeFundsBankWireCtrl.createForm.address3.$dirty && removeFundsBankWireCtrl.createForm.address3.$invalid\" ng-model=removeFundsBankWireCtrl.model.funding.destination.address3 placeholder=\"{{'Enter additonal info (optional)'|translate}}\"> </gmw-box-input> </div> <div class=gmw-input-container ng-if=removeFundsBankWireCtrl.isBankSwiftRequired()> <gmw-box-input required name=swiftCode type=text has-error=\"removeFundsBankWireCtrl.createForm.swiftCode.$dirty && removeFundsBankWireCtrl.createForm.swiftCode.$invalid\" ng-model=removeFundsBankWireCtrl.model.funding.destination.swiftCode label=\"{{'SWIFT/BIC Code'|translate}}\" placeholder=\"{{'Enter SWIFT/BIC code'|translate}}\"> </gmw-box-input> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <gmw-recap-table-header label=\"{{'Transfer Details'|translate}}\"></gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Amount to Transfer'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.amount|holdingFormatFunds></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Transfer Fee'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.feeAmount|holdingFormatFunds></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Destination Bank Account'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=::removeFundsBankWireCtrl.model.funding.destination.nickName></span><br> <span ng-bind=::removeFundsBankWireCtrl.model.funding.destination.name></span><br> <span ng-bind=::removeFundsBankWireCtrl.model.funding.destination.address1></span><br> <span ng-bind=::removeFundsBankWireCtrl.model.funding.destination.address2></span><br> <span ng-bind=::removeFundsBankWireCtrl.model.funding.destination.address3></span><br> <span ng-bind=::removeFundsBankWireCtrl.model.funding.destination.countryName></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=removeFundsBankWireCtrl.model.funding.destination.sortCode> <div class=gmw-recap-table__col ng-bind=\"'Sort Code'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.funding.destination.sortCode></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Account Number'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.funding.destination.accountNumber></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Account Name'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.funding.destination.accountName></span> </div> </div> <div class=gmw-recap-table__row ng-if=removeFundsBankWireCtrl.showClientNotes> <div class=gmw-recap-table__col ng-bind=\"'Reason for Withdrawal'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsBankWireCtrl.model.clientNotes></span> </div> </div> </div> </div> <div class=gmw-flow-box__callout> <span> Click <span class=h-dark-text>Confirm</span> to complete the transfer of funds. Should you wish to modify your withdrawal, please click the back arrow above. </span> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=removeFundsBankWireCtrl.cancel() on-next=removeFundsBankWireCtrl.next() step-disabled=\"removeFundsBankWireCtrl.createForm.$invalid || removeFundsBankWireCtrl.createForm.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _detail = __webpack_require__(584);

var _detail2 = _interopRequireDefault(_detail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.detail', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Withdraw Funds - Funds Transfer Detail'
    },
    url: '/{code:[0-9]+}',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'RemoveFundsDetailController',
        controllerAs: 'removeFundsDetailCtrl',
        template: _detail2.default
      }
    }
  });
}]);

__webpack_require__(585);

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Transfer Details'|translate\"></h2> </header> <div class=gmw-flow-box-container> <div class=gmw-recap-table> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Withdraw Funds Transfer Number'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsDetailCtrl.transfer.number></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Status'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::(removeFundsDetailCtrl.transfer.status|holdingFormatFundsRemoveStatus)></span> </div> </div> <div class=gmw-recap-table__row ng-if=\"removeFundsDetailCtrl.transfer.accountTypeCode === 'BankAccount'\"> <div class=gmw-recap-table__col ng-bind=\"'Destination'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::removeFundsDetailCtrl.transfer.bankAccountNickName></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Account Type'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-switch=::removeFundsDetailCtrl.transfer.accountTypeCode> <span ng-switch-when=BankAccount ng-bind=\"'Bank Account'|translate\"></span> <span ng-switch-when=PrepaidCard ng-bind=\"'Prepaid Card'|translate\"></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Currency'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=removeFundsDetailCtrl.transfer.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=::removeFundsDetailCtrl.transfer.amount.currency></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Amount'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::(removeFundsDetailCtrl.transfer.amount|holdingFormatFunds)></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Date Requested'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::(removeFundsDetailCtrl.transfer.ts|gmwFormatDateTime)></span> </div> </div> </div> </div> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <div class=holding-dashboard-sidebar__box> <span class=holding-dashboard-sidebar__box-title ng-bind=\"'Withdraw funds transfer number'|translate\"> </span> <span class=h-dark-text ng-bind=removeFundsDetailCtrl.transfer.number></span> </div> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How long does a withdrawal take to process?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000534308> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RemoveFundsDetailController.$inject = ['$state', 'HoldingFunds'];
angular.module('app.holding.dashboard.funds.remove').controller('RemoveFundsDetailController', RemoveFundsDetailController);

function RemoveFundsDetailController($state, HoldingFunds) {
  'ngInject';

  var vm = this;

  function activate() {
    HoldingFunds.getPendingRemoveFunds().then(function (transfers) {
      var transfer = transfers.find(function (_) {
        return _.code.toString() === $state.params.code;
      });

      if (!transfer) {
        goToOverview();
      }
      vm.transfer = transfer;
    }).catch(goToOverview);
  }

  function goToOverview() {
    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    $state.go('holding.dashboard.funds.remove.overview', {}, { reload: reload });
  }

  activate();
}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _overview = __webpack_require__(587);

var _overview2 = _interopRequireDefault(_overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.funds.remove').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds.remove.overview', {
    data: {
      pageTitle: 'Withdraw Funds - Pending Funds Transfers'
    },
    resolve: {
      LoadResolve: ['$q', '$log', 'HoldingFunds', function LoadResolve($q, $log, HoldingFunds) {
        'ngInject';

        var deferred = $q.defer();

        HoldingFunds.getPendingRemoveFunds().then(function (transfers) {
          if (transfers.length > 0) {
            deferred.resolve(true);
          } else {
            deferred.reject({
              redirectTo: 'holding.dashboard.funds.remove.bank-wire.destination'
            });
          }
        }).catch(function (error) {
          $log.error(error);

          if (error && 'code' in error) {
            switch (error.code) {
              case 'UNAUTHORIZED':
                deferred.resolve();
                break;
              default:
                deferred.reject({
                  redirectTo: 'holding.dashboard.funds.remove.bank-wire.destination'
                });
                break;
            }
          } else {
            deferred.reject({
              redirectTo: 'holding.dashboard.funds.remove.bank-wire.destination'
            });
          }
        });

        return deferred.promise;
      }]
    },
    url: '/overview',
    views: {
      'funds-main@holding.dashboard.funds': {
        controller: 'RemoveFundsOverviewController',
        controllerAs: 'removeFundsOverviewCtrl',
        template: _overview2.default
      }
    }
  });
}]);

__webpack_require__(588);

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Funds Withdrawals'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-bind=\"'Please note it may take up to six business days to process wire transfer(s).'|translate\"> </p> </header> <div class=gmw-flow-box-container ng-form=removeFundsOverviewCtrl.overviewForm> <div ng-show=removeFundsOverviewCtrl.overviewForm.$invalid ng-messages=removeFundsOverviewCtrl.overviewForm.$error> <div ng-message=loading> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred loading your pending transfers, please try again later.'|translate\"></span> </holding-alert-legacy> </div> <div ng-message=maxTransfers> <holding-alert-legacy class=info> <span ng-bind=\"'Note, that you have reached the maximium number of pending transfers permitted. You will be able to initiate another transfer once an existing pending transfer has cleared.'|translate\"></span> </holding-alert-legacy> </div> <div ng-message=partner> <holding-alert-legacy class=error> <span ng-bind=::removeFundsOverviewCtrl.error.message></span> </holding-alert-legacy> </div> </div> <div ng-hide=removeFundsOverviewCtrl.overviewForm.$error.loading> <holding-pending-remove pending-transfers=removeFundsOverviewCtrl.pendingTransfers> </holding-pending-remove> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button ui-sref=holding.dashboard.funds.remove.bank-wire class=\"medium-main-cta gmw-responsive-button\" ng-show=removeFundsOverviewCtrl.overviewForm.$valid> <span ng-bind=\"'Initiate Another Withdraw Funds Transfer'|translate\"></span> </button> </div> </footer> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How long does a withdrawal take to process?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000534308> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RemoveFundsOverviewController.$inject = ['$log', 'HoldingFunds', 'HoldingConfig', 'HoldingUser'];
angular.module('app.holding.dashboard.funds.remove').controller('RemoveFundsOverviewController', RemoveFundsOverviewController);

function RemoveFundsOverviewController($log, HoldingFunds, HoldingConfig, HoldingUser) {
  'ngInject';

  var vm = this;

  function activate() {
    vm.canRemoveFunds = HoldingUser.isAllowed('removeFunds');

    HoldingFunds.getPendingRemoveFunds().then(function (transfers) {
      vm.pendingTransfers = transfers;

      if (transfers.length >= HoldingConfig.settings.maxPendingTransfers) {
        vm.overviewForm.$setValidity('maxTransfers', false);
      }
    }).catch(function (error) {
      $log.error(error);

      if (error && 'code' in error) {
        switch (error.code) {
          case 'UNAUTHORIZED':
            vm.error = error;
            vm.overviewForm.$setValidity('partner', false);
            break;
          default:
            vm.overviewForm.$setValidity('loading', false);
            break;
        }
      } else {
        vm.overviewForm.$setValidity('loading', false);
      }
    });
  }

  activate();
}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFundsBalance.$inject = ['HoldingUser', 'HoldingFunds'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fundsBalance = __webpack_require__(590);

var _fundsBalance2 = _interopRequireDefault(_fundsBalance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingFundsBalance', holdingFundsBalance).name;


function holdingFundsBalance(HoldingUser, HoldingFunds) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      equivalentCurrency: '=',
      funds: '='
    },
    template: _fundsBalance2.default
  };

  function link(scope) {
    function closeMenu() {
      moreMenuFlyoutActive = undefined;
      moreMenuMobileFlyoutActive = undefined;
    }

    function hasLockedFunds(currency) {
      return currency.locked && 'amount' in currency.locked ? currency.locked.amount > 0 : false;
    }

    function hasReservedFunds(currency) {
      return currency.reserved && 'amount' in currency.reserved ? currency.reserved.amount > 0 : false;
    }

    function isMoreMenuFlyoutActive(index) {
      return moreMenuFlyoutActive === index;
    }

    function isMoreMenuMobileFlyoutActive(index) {
      return moreMenuMobileFlyoutActive === index;
    }

    function onDestroy() {
      flyoutListener();
    }

    function onFundsUpdated(funds) {
      scope.funds.sort(function (fundA, fundB) {
        return fundB.equivalent.amount - fundA.equivalent.amount;
      });
    }

    function openMoreMenuFlyout(index) {
      moreMenuFlyoutActive = index;
    }

    function openMoreMenuMobileFlyout(index) {
      moreMenuMobileFlyoutActive = index;
    }

    var moreMenuFlyoutActive = void 0,
        moreMenuMobileFlyoutActive = void 0;
    var flyoutListener = scope.$on('gmw:flyout:close', closeMenu);
    var user = HoldingUser.get();

    HoldingFunds.getPendingAddFunds().then(function (hasPendingAddFundsTransfers) {
      scope.canAddFunds = HoldingUser.isAllowed('addFunds') || hasPendingAddFundsTransfers.length > 0;
    });
    HoldingFunds.getPendingRemoveFunds().then(function (hasPendingRemoveFundsTransfers) {
      scope.canRemoveFunds = !HoldingUser.isHidden('removeFunds') || hasPendingRemoveFundsTransfers.length > 0;
    });
    scope.hasLockedFunds = hasLockedFunds;
    scope.hasReservedFunds = hasReservedFunds;
    scope.isMoreMenuFlyoutActive = isMoreMenuFlyoutActive;
    scope.isMoreMenuMobileFlyoutActive = isMoreMenuMobileFlyoutActive;
    scope.openMoreMenuFlyout = openMoreMenuFlyout;
    scope.openMoreMenuMobileFlyout = openMoreMenuMobileFlyout;
    scope.user = user;

    scope.$on('$destroy', onDestroy);
    scope.$watch('funds', onFundsUpdated);
  }
}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <header class=gmw-table-header> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title desktop-only desktop-only--xs\" ng-bind=\"'Currency Funds'|translate\"> </h2> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title mobile-only mobile-only--xs\" ng-bind=\"'Funds'|translate\"> </h2> <div class=\"gmw-table-header__actions desktop-only desktop-only--xs\"> <button class=gmw-button-spacer ng-class=\"{\n          'gmw-button-spacer--small': canAddFunds,\n          'small-secondary-cta': canAddFunds,\n          'small-main-cta': !canAddFunds,\n        }\" ng-if=canRemoveFunds ui-sref=holding.dashboard.funds.remove ng-bind=\"'Withdraw Funds'|translate\"> </button> <button class=small-main-cta ng-if=canAddFunds ui-sref=holding.dashboard.funds.add ng-bind=\"'Add Funds'|translate\"> </button> </div> <div class=\"gmw-table-header__actions mobile-only mobile-only--xs\"> <div class=gmw-dual-dot-data> <a ui-sref=holding.dashboard.funds.remove class=heading-h5 ng-class=\"{\n            'h-base-text': canAddFunds,\n            'h-gold-text': !canAddFunds,\n          }\" ng-if=canRemoveFunds ng-bind=\"'Withdraw'|translate\"> </a> <span class=\"gmw-dot gmw-dot--light gmw-dot--medium-margin\" ng-if=\"canAddFunds && canRemoveFunds\"> &middot; </span> <a ng-if=canAddFunds ui-sref=holding.dashboard.funds.add class=\"heading-h5 h-gold-text\" ng-bind=\"'Add'|translate\"> </a> </div> </div> </header> <gmw-main-table desktop-only=true> <gmw-main-table-header class=gmw-main-table__head--extra-right-padding> <gmw-main-table-header-col class=\"heading-h5 h-light-text\"> <span ng-bind=\"'Currency'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--align-right\"> <span ng-bind=\"'Balance'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--align-right\"> <span ng-bind=\"'FX Rate'|translate\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--align-right\"> <span ng-bind=\"('In '|translate) + equivalentCurrency\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--icon></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"currency in funds track by currency.currencyCode\"> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=currency.currencyCode|holdingCurrencyCountry></gmw-flag> <span ng-bind=currency.currencyCode></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-light-text gmw-main-table__body-cell--align-right\"> <span ng-bind=currency.balance|holdingFormatFunds></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-light-text gmw-main-table__body-cell--align-right\" ng-bind=currency.rate|gmwFormatNumber> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-dark-text gmw-main-table__body-cell--align-right\"> <holding-svg-icon ng-if=\"hasLockedFunds(currency) && !hasReservedFunds(currency)\" gmw-tooltip=\"{{'There are locked balances affecting the amount of funds available - exact amounts are found on the local balance menu'|translate}}\" class=gmw-main-table__body-cell__encumbered-indicator width=14px height=14px icon=octagon-pending> </holding-svg-icon> <holding-svg-icon ng-if=\"hasLockedFunds(currency) && hasReservedFunds(currency)\" gmw-tooltip=\"{{'There are reserved balances and locked balances affecting the amount of funds available - exact amounts are found on the local balance menu'|translate}}\" class=gmw-main-table__body-cell__encumbered-indicator width=14px height=14px icon=octagon-pending> </holding-svg-icon> <holding-svg-icon ng-if=\"!hasLockedFunds(currency) && hasReservedFunds(currency)\" gmw-tooltip=\"{{'There are reserved balances affecting the amount of funds available - exact amounts are found on the local balance menu'|translate}}\" class=gmw-main-table__body-cell__encumbered-indicator width=14px height=14px icon=octagon-pending> </holding-svg-icon> <span ng-bind=currency.equivalent|holdingFormatFunds></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--icon ng-if=!user.locked ng-click=openMoreMenuFlyout(currency.currencyCode) gmw-focus-out-flyout-close=\"{{isMoreMenuFlyoutActive(currency.currencyCode)}}\"> <holding-funds-more-menu currency=currency is-active=isMoreMenuFlyoutActive(currency.currencyCode)> </holding-funds-more-menu> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"currency in funds track by currency.currencyCode\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <gmw-flag country=currency.currencyCode|holdingCurrencyCountry></gmw-flag> <span ng-bind=currency.currencyCode></span> </div> <div class=gmw-simple-table__head-right></div> <div class=\"c-vault-more gmw-simple-table__head-more\" ng-if=!user.locked> <div class=c-vault-more__icon-container ng-click=openMoreMenuMobileFlyout(currency.currencyCode) gmw-focus-out-flyout-close=\"{{isMoreMenuMobileFlyoutActive(currency.currencyCode)}}\"> <holding-funds-more-menu currency=currency is-active=isMoreMenuMobileFlyoutActive(currency.currencyCode)> </holding-funds-more-menu> <holding-svg-icon class=c-vault-more__icon icon=vertical-more> </holding-svg-icon> </div> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Balance'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=currency.balance|holdingFormatFunds> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Reserved'|translate\"></span> <holding-svg-icon class=gmw-simple-table__tooltip-indicator gmw-tooltip=\"{{'Your currency that has not been used to purchase metal, and thus cannot be withdrawn'|translate}}\" icon=info> </holding-svg-icon> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=currency.reserved|holdingFormatFunds> </span> </div> <div class=gmw-simple-table__row ng-repeat=\"lock in currency.locks track by $index\"> <span class=gmw-simple-table__label> <span ng-bind=\"'Locked'|translate\"></span> <holding-svg-icon class=gmw-simple-table__tooltip-indicator gmw-tooltip=\"{{lock.memo + '; Released on ' + (lock.unlockTs|gmwFormatDate)}}\" icon=info> </holding-svg-icon> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=lock.amount|holdingFormatFunds> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Available'|translate\"></span> <holding-svg-icon class=gmw-simple-table__tooltip-indicator gmw-tooltip=\"{{'Your currency balance that is available to be withdrawn'|translate}}\" icon=info> </holding-svg-icon> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=currency.spendable|holdingFormatFunds> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'FX Rate'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=currency.rate|gmwFormatNumber> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"('In '|translate) + equivalentCurrency\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=currency.equivalent|holdingFormatFunds> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFundsMoreMenu.$inject = ['HoldingUser', 'HoldingFunds'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fundsMoreMenu = __webpack_require__(592);

var _fundsMoreMenu2 = _interopRequireDefault(_fundsMoreMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingFundsMoreMenu', holdingFundsMoreMenu).name;


function holdingFundsMoreMenu(HoldingUser, HoldingFunds) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      currency: '=',
      isActive: '='
    },
    template: _fundsMoreMenu2.default
  };

  function link(scope) {
    function hasLockedFunds() {
      return scope.currency.locks ? scope.currency.locks.length > 0 : false;
    }

    function hasPendingAddFunds() {
      return scope.pendingAddFundsTransfers && scope.pendingAddFundsTransfers.length > 0 ? !!scope.pendingAddFundsTransfers.find(function (transfer) {
        return transfer.amount.currency === scope.currency.currencyCode;
      }) : false;
    }

    function hasPendingRemoveFunds() {
      return scope.pendingRemoveFundsTransfers && scope.pendingRemoveFundsTransfers.length > 0 ? !!scope.pendingRemoveFundsTransfers.find(function (transfer) {
        return transfer.amount.currency === scope.currency.currencyCode;
      }) : false;
    }

    function hasReservedFunds() {
      return scope.currency.reserved && 'amount' in scope.currency.reserved ? scope.currency.reserved.amount > 0 : false;
    }

    function hasSpendableFunds() {
      return scope.currency.spendable && 'amount' in scope.currency.spendable ? scope.currency.spendable.amount > 0 : false;
    }

    HoldingFunds.getPendingAddFunds().then(function (pendingAddFundsTransfers) {
      scope.pendingAddFundsTransfers = pendingAddFundsTransfers;
      scope.canAddFunds = HoldingUser.isAllowed('addFunds') || pendingAddFundsTransfers.length > 0;
    });
    HoldingFunds.getPendingRemoveFunds().then(function (pendingRemoveFundsTransfers) {
      scope.pendingRemoveFundsTransfers = pendingRemoveFundsTransfers;
      scope.canRemoveFunds = HoldingUser.isAllowed('removeFunds') || pendingRemoveFundsTransfers.length > 0;
    });
    scope.canBuyMetal = HoldingUser.isAllowed('buy') && hasSpendableFunds();
    scope.canExchangeFunds = HoldingUser.isAllowed('exchangeFiat');
    scope.canTransferFunds = HoldingUser.isAllowed('makePayment') && HoldingUser.getPermission('makePayment').currencies.find(function (currency) {
      return currency === scope.currency.currencyCode;
    });
    scope.hasLockedFunds = hasLockedFunds;
    scope.hasPendingAddFunds = hasPendingAddFunds;
    scope.hasPendingRemoveFunds = hasPendingRemoveFunds;
    scope.hasReservedFunds = hasReservedFunds;
    scope.hasSpendableFunds = hasSpendableFunds;
  }
}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "<div class=c-vault-more> <div class=c-vault-menu ng-class=\"{\n      'c-vault-menu--active': isActive,\n    }\"> <span class=c-vault-menu__balance> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your total balance including currency that is reserved'|translate}}\"> <span ng-bind=\"'Balance:'|translate\"></span> </span> <span class=h-dark-text> <span ng-bind=currency.balance|holdingFormatFunds></span> </span> </span> <span class=c-vault-menu__balance ng-if=hasReservedFunds()> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your currency that has not been used to purchase metal, and thus cannot be withdrawn'|translate}}\"> <span ng-bind=\"'Reserved:'|translate\"></span> </span> <span class=h-dark-text> <span ng-bind=currency.reserved|holdingFormatFunds></span> </span> </span> <span class=c-vault-menu__balance ng-if=hasLockedFunds() ng-repeat=\"lock in currency.locks track by $index\"> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{lock.memo + '; Released on ' + (lock.unlockTs|gmwFormatDate)}}\" ng-bind=\"'Locked:'|translate\"> </span> <span class=h-dark-text> <span ng-bind=lock.amount|holdingFormatFunds></span> </span> </span> <span class=c-vault-menu__balance ng-if=\"hasLockedFunds() || hasReservedFunds()\"> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your currency balance that is available to be withdrawn'|translate}}\"> <span ng-bind=\"'Available:'|translate\"></span> </span> <span class=h-dark-text> <span ng-bind=currency.spendable|holdingFormatFunds></span> </span> </span> <hr class=c-vault-menu__divider ng-if=\"hasPendingAddFunds() || hasPendingRemoveFunds()\"> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.funds.add({\n        currency: currency.currencyCode,\n      })\" ng-if=hasPendingAddFunds()> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=add-funds width=22px height=17px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'View pending add funds'|translate\"></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.funds.remove({\n        currency: currency.currencyCode,\n      })\" ng-if=hasPendingRemoveFunds()> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=withdraw-funds width=22px height=16px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'View pending withdrawals'|translate\"></span> </span> </a> <hr class=c-vault-menu__divider> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.funds.add({\n        currency: currency.currencyCode,\n      })\" ng-if=canAddFunds> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=add-funds width=22px height=17px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Add more'|translate\"></span> <span ng-bind=currency.currencyCode></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.funds.remove({\n        currency: currency.currencyCode,\n      })\" ng-if=\"canRemoveFunds && hasSpendableFunds()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=withdraw-funds width=22px height=16px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Withdraw your'|translate\"></span> <span ng-bind=currency.currencyCode></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.funds.exchange({\n        currency: currency.currencyCode,\n      })\" ng-if=\"canExchangeFunds && hasSpendableFunds()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=exchange-funds width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Exchange your'|translate\"></span> <span ng-bind=currency.currencyCode></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.metals.buy({\n        currency: currency.currencyCode,\n      })\" ng-if=canBuyMetal> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=buy-metal width=25px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Spend your'|translate\"></span> <span ng-bind=currency.currencyCode></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.transfers.new({\n        type: 'currency',\n        currency: currency.currencyCode,\n      })\" ng-if=\"canTransferFunds && hasSpendableFunds()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=dual-send-payment width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\" ng-bind=\"'Transfer to another Holding'|translate\"> </span> </a> </div> <div class=c-vault-more__icon-container> <holding-svg-icon class=c-vault-more__icon icon=vertical-more> </holding-svg-icon> </div> </div> ";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globalMethodSelector = __webpack_require__(594);

var _globalMethodSelector2 = _interopRequireDefault(_globalMethodSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingGlobalMethodSelector', holdingGlobalMethodSelector).name;


function holdingGlobalMethodSelector() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      options: '='
    },
    template: _globalMethodSelector2.default
  };

  function link(scope, _elem, _attrs, ngModel) {
    function select(option) {
      if (option.available !== false) {
        ngModel.$setViewValue(option.id);
      }
    }

    scope.model = ngModel;
    scope.select = select;
  }
}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-global-method-selector ng-repeat=\"option in options track by option.id\" ng-class=\"{\n    'gmw-global-method-selector--disabled': option.available === false,\n    'gmw-global-method-selector--selected': $parent.model.$viewValue === option.id,\n  }\"> <span class=\"gmw-global-method-selector__not-available heading-h6 h-light-text\" ng-bind=\"'Not Available'|translate\"> </span> <div class=gmw-global-method-selector__inner ng-click=$parent.select(option)> <div class=gmw-global-method-selector__select> <gmw-radio-option ng-show=\"option.available !== false\" checked=\"$parent.model.$viewValue === option.id\"> </gmw-radio-option> <gmw-radio-option ng-show=\"option.available === false\" gmw-disabled=\"option.available === false\"> </gmw-radio-option> </div> <div class=gmw-global-method-selector__icon-container> <i class=\"gmw-global-method-selector__icon gmw-global-method-selector__icon--{{option.id}}\"></i> </div> <div class=gmw-global-method-selector__label> <h1 class=\"h-dark-text heading-h4\" ng-bind=::option.label> </h1> <div class=\"h-light-text h-margin-top-5 h-medium-text desktop-only desktop-only--xs\" ng-if=option.description ng-bind=::option.description> </div> <div class=\"h-light-text h-margin-top-5 h-medium-text desktop-only desktop-only--xs\" ng-if=!option.description translate> Transfer funds from your {{option.label}} account. </div> </div> </div> </div> ";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingPendingAdd.$inject = ['HoldingFunds'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pendingAdd = __webpack_require__(596);

var _pendingAdd2 = _interopRequireDefault(_pendingAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingPendingAdd', holdingPendingAdd).name;


function holdingPendingAdd(HoldingFunds) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      pendingTransfers: '='
    },
    template: _pendingAdd2.default
  };

  function link(scope) {
    scope.getAftrType = getAftrType;

    function getAftrType(aftr) {
      if (aftr && 'trm' in aftr) {
        return HoldingFunds.getAftrMethod(aftr.trm).label;
      }
      return 'Unknown';
    }
  }
}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = "<gmw-main-table desktop-only=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--20 heading-h5 h-light-text\" ng-bind=\"'Type'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Amount'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Date Requested'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col></gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--5></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"transfer in pendingTransfers track by transfer.code\"> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--20 h-light-text\" ng-bind=::getAftrType(transfer)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=transfer.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=::transfer.amount.currency></span> <span class=\"gmw-dot gmw-dot--light\" ng-bind=\"'&middot;'\"></span> <span ng-bind=::(transfer.amount|holdingFormatFunds)></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::(transfer.ts|gmwFormatDateTime)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-orange-text ng-bind=::(transfer.status|holdingFormatFundsAddStatus:transfer.trm)> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--5> <a class=h-blue-link ng-bind=\"'Details'|translate\" ui-sref=\"holding.dashboard.funds.add.detail({\n            code: transfer.code,\n          })\"></a> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"transfer in pendingTransfers track by transfer.code\"> <div class=gmw-simple-table__head> <div class=\"gmw-simple-table__head-left h-orange-text\" ng-bind=\"'Pending Fund Transfer'|translate\"></div> <div class=gmw-simple-table__head-right> <a class=h-blue-link ui-sref=\"holding.dashboard.funds.add.detail({\n            code: transfer.code,\n          })\" ng-bind=\"'Details'|translate\"></a> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Date Requested'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.ts|gmwFormatDateTime> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Transfer Number'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.number> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Type'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::getAftrType(transfer)> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Currency'|translate\"> </span> <span class=gmw-simple-table__value> <gmw-flag country=transfer.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=::transfer.amount.currency></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.amount|holdingFormatFunds> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Status'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.status|holdingFormatFundsAddStatus:transfer.trm> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pendingRemove = __webpack_require__(598);

var _pendingRemove2 = _interopRequireDefault(_pendingRemove);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingPendingRemove', holdingPendingRemove).name;


function holdingPendingRemove() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      pendingTransfers: '='
    },
    template: _pendingRemove2.default
  };
}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "<gmw-main-table desktop-only=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Destination'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Amount'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Date Requested'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col></gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--5></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"transfer in pendingTransfers track by transfer.code\"> <gmw-main-table-body-col class=h-light-text ng-switch=transfer.accountTypeCode> <span ng-switch-when=BankAccount ng-bind=::transfer.bankAccountNickName></span> <span ng-switch-when=PrepaidCard ng-bind=\"'Prepaid Card'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=transfer.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=::transfer.amount.currency></span> <span class=\"gmw-dot gmw-dot--light\">•</span> <span ng-bind=::(transfer.amount|holdingFormatFunds)></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=::(transfer.ts|gmwFormatDateTime)> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-orange-text ng-bind=::(transfer.status|holdingFormatFundsRemoveStatus)> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--5> <a class=h-blue-link ng-bind=\"'Details'|translate\" ui-sref=\"holding.dashboard.funds.remove.detail({\n            code: transfer.code,\n          })\"></a> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"transfer in pendingTransfers track by transfer.code\"> <div class=gmw-simple-table__head> <div class=\"gmw-simple-table__head-left h-orange-text\" ng-bind=\"'Pending Fund Transfer'|translate\"></div> <div class=gmw-simple-table__head-right> <a class=h-blue-link ui-sref=\"holding.dashboard.funds.remove.detail({\n          code: transfer.code,\n        })\">Details</a> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Date Requested'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.ts|gmwFormatDateTime> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Transfer Number'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.number> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Destination'|translate\"> </span> <span class=gmw-simple-table__value ng-switch=::transfer.accountTypeCode> <span ng-switch-when=BankAccount ng-bind=::transfer.bankAccountNickName></span> <span ng-switch-when=PrepaidCard ng-bind=\"'Prepaid Card'|translate\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Currency'|translate\"> </span> <span class=gmw-simple-table__value> <gmw-flag country=transfer.amount.currency|holdingCurrencyCountry></gmw-flag> <span ng-bind=::transfer.amount.currency></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.amount|holdingFormatFunds> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Status'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=::transfer.status|holdingFormatFundsRemoveStatus> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regionalMethodSelector = __webpack_require__(600);

var _regionalMethodSelector2 = _interopRequireDefault(_regionalMethodSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingRegionalMethodSelector', holdingRegionalMethodSelector).name;


function holdingRegionalMethodSelector() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      options: '='
    },
    template: _regionalMethodSelector2.default
  };
  return directive;

  function link(scope, _elem, _attrs, ngModel) {
    function select(option) {
      if (option.available !== false) {
        ngModel.$setViewValue(option.id);
      }
    }

    scope.model = ngModel;
    scope.select = select;
  }
}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-regional-method-selector ng-repeat=\"option in options track by option.id\" ng-class=\"{\n    'gmw-regional-method-selector--disabled': option.available === false,\n    'gmw-regional-method-selector--selected': $parent.model.$viewValue === option.id,\n  }\"> <span class=\"gmw-regional-method-selector__not-available heading-h6 h-light-text\" ng-bind=\"'Not Available'|translate\"> </span> <div class=gmw-regional-method-selector__inner ng-click=$parent.select(option)> <div class=gmw-regional-method-selector__select> <gmw-radio-option ng-show=\"option.available !== false\" checked=\"$parent.model.$viewValue === option.id\"> </gmw-radio-option> <gmw-radio-option ng-show=\"option.available === false\" gmw-disabled=\"option.available === false\"> </gmw-radio-option> </div> <div class=gmw-regional-method-selector__icon-container> <i class=\"gmw-regional-method-selector__icon gmw-regional-method-selector__icon--{{option.id}}\"></i> </div> <div class=gmw-regional-method-selector__label> <h1 class=\"h-dark-text heading-h4\" ng-bind=::option.label> </h1> <div class=\"h-light-text h-margin-top-5 h-medium-text desktop-only desktop-only--xs\" ng-if=::option.description ng-bind=::option.description> </div> <div class=\"h-light-text h-margin-top-5 h-medium-text desktop-only desktop-only--xs\" ng-if=!option.description> Transfer funds from your {{option.label}} account. </div> </div> </div> </div> ";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementFunds = __webpack_require__(602);

var _statementFunds2 = _interopRequireDefault(_statementFunds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingStatementFunds', holdingStatementFunds).name;


function holdingStatementFunds() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      fiat: '=',
      total: '='
    },
    template: _statementFunds2.default
  };
}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-statement__table desktop-only desktop-only--sm\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Currency'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" ng-bind=\"'Total'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" translate> {{::total.currency}} Rate </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" translate> {{::total.currency}} Equivalent </span> </div> <div class=gmw-statement__table-row ng-repeat=\"currency in fiat\"> <span class=gmw-statement__table-cell--value> <gmw-flag country=::(currency.amount.currency|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::currency.amount.currency></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\" ng-bind=::currency.amount|holdingFormatFunds> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=::currency.rate.value|gmwFormatNumber:4></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=::currency.equivalent|holdingFormatFunds></span> </span> </div> <div class=gmw-statement__total> <span class=gmw-statement__total-label ng-bind=\"'Total Currency Funds Value'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=total.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=total.currency> </span> </span> </div> </div> <div class=\"gmw-statement__table mobile-only mobile-only--sm\" ng-repeat=\"currency in fiat\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Currency'|translate\"> </span> <span class=gmw-statement__table-cell--value> <gmw-flag country=::(currency.amount.currency|holdingCurrencyCountry)></gmw-flag> <span ng-bind=::currency.amount.currency></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Total'|translate\"> </span> <span class=gmw-statement__table-cell--value ng-bind=::currency.amount|holdingFormatFunds> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header translate> {{::total.currency}} Rate </span> <span class=gmw-statement__table-cell--value> <span ng-bind=::currency.rate.value|gmwFormatNumber:4></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header translate> {{::total.currency}} Equivalent </span> <span class=gmw-statement__table-cell--value> <span ng-bind=::currency.equivalent|holdingFormatFunds></span> </span> </div> </div> <div class=\"gmw-statement__total mobile-only mobile-only--sm\"> <span class=gmw-statement__total-label ng-bind=\"'Total Currency Funds Value'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=total.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=total.currency> </span> </span> </div> ";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingTransferInstructions.$inject = ['HoldingUser', 'HoldingSupport'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transferInstructions = __webpack_require__(604);

var _transferInstructions2 = _interopRequireDefault(_transferInstructions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').directive('holdingTransferInstructions', holdingTransferInstructions).name;


function holdingTransferInstructions(HoldingUser, HoldingSupport) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      amount: '=',
      bank: '=',
      transferNumber: '='
    },
    template: _transferInstructions2.default
  };

  function link(scope) {
    scope.user = HoldingUser.get();
    scope.showPhoneNumber = HoldingUser.isAllowed('phoneSupport');
    scope.supportPhoneNumbers = HoldingSupport.getSupportNumber(scope.user.regulation);

    if ('intermediaryBank' in scope.bank.instructions) {
      scope.bank.intermediaryBank = scope.bank.instructions.intermediaryBank;
      delete scope.bank.instructions.intermediaryBank;
    }
  }
}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=gmw-recap-table> <div class=gmw-recap-table__body> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Instruct Your Bank To Transfer'|translate\"></h4> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Amount'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=amount|holdingFormatFunds></span> </div> </div> <div class=gmw-recap-table__row ng-repeat=\"(key, value) in bank.instructions track by $index\"> <div class=gmw-recap-table__col> <span ng-switch=key> <span ng-switch-when=attn ng-bind=\"'Attention'|translate\"></span> <span ng-switch-when=bankName ng-bind=\"'Bank Name'|translate\"></span> <span ng-switch-when=address ng-bind=\"'Address'|translate\"></span> <span ng-switch-when=accountName ng-bind=\"'Account Name'|translate\"></span> <span ng-switch-when=accountNumber ng-bind=\"'Account Number'|translate\"></span> <span ng-switch-when=currency ng-bind=\"'Currency'|translate\"></span> <span ng-switch-when=sortCode ng-bind=\"'Sort Code'|translate\"></span> <span ng-switch-when=swiftCode ng-bind=\"'Swift Code'|translate\"></span> <span ng-switch-when=iban ng-bind=\"'IBAN'|translate\"></span> <span ng-switch-default ng-bind=::key></span> </span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-if=!(value|gmwIsArray) ng-bind=::value> </span> <span class=gmw-recap-table__value ng-if=value|gmwIsArray> <span ng-repeat=\"line in ::value track by $index\"> <span ng-bind=line></span><br ng-if=!$last> </span> </span> </div> </div> <div class=gmw-recap-table__callout> <span ng-bind=\"'Please ensure that these details are included in the transfer:'|translate\"></span> <span class=gmw-recap-table__callout-data> <span ng-bind=\"'REFERENCE NUMBER: '|translate\"></span> <span ng-bind=transferNumber|gmwRemoveHyphens></span> </span> <span class=gmw-recap-table__callout-data> <span ng-bind=\"'DO NOT CONVERT FUNDS'|translate\"></span> </span> </div> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Your Bank May Also Ask For'|translate\"> </h4> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Goldmoney\\'s Address'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-if=\"user.regulation == 'Toronto'\"> Goldmoney Vault Inc<br> 334 Adelaide St W #307<br> Toronto, Ontario<br> M5V 1R4<br> Canada <span ng-if=showPhoneNumber ng-repeat=\"phone in supportPhoneNumbers track by $index\"> <br>+{{::phone.country}} {{::phone.number}} </span> </span> <span class=gmw-recap-table__value ng-if=\"user.regulation == 'UK'\"> Goldmoney Vault (UK) Limited<br> Station Approach<br> Victoria, St Austell<br> Cornwall PL26 8LG<br> United Kingdom <span ng-if=showPhoneNumber ng-repeat=\"phone in supportPhoneNumbers track by $index\"> <br>+{{::phone.country}} {{::phone.number}} </span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=bank.intermediaryBank> <div class=gmw-recap-table__col ng-bind=\"'Intermediary/correspondent bank'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-repeat=\"line in ::bank.intermediaryBank track by $index\"> <span ng-bind=line></span><br ng-if=!$last> </span> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFormatFunds.$inject = ['HoldingCurrencies', 'HoldingFormatting'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.funds').filter('holdingFormatFunds', holdingFormatFunds).name;


function holdingFormatFunds(HoldingCurrencies, HoldingFormatting) {
  'ngInject';

  return function (input, decimals) {
    if (!input) {
      return input;
    }

    var currency = HoldingCurrencies.getCurrencyByCode(input.currency);
    var displayDecimals = decimals || currency.decimals;

    var _HoldingFormatting$fo = HoldingFormatting.formatNumber(input.amount, displayDecimals),
        sign = _HoldingFormatting$fo.sign,
        formatted = _HoldingFormatting$fo.formatted;

    return '' + (sign ? '' + sign : '') + currency.symbol + formatted;
  };
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFormatFundsAddStatus.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.funds').filter('holdingFormatFundsAddStatus', holdingFormatFundsAddStatus).name;


function holdingFormatFundsAddStatus(gettextCatalog) {
  'ngInject';

  return formatFundsAddStatus;

  function formatFundsAddStatus(input) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    switch (input) {
      case 'Canceled':
        return gettextCatalog.getString('Canceled');
      case 'Completed':
        return gettextCatalog.getString('Completed');
      case 'Processed':
        return gettextCatalog.getString('Processed');
      case 'Paid':
        return gettextCatalog.getString('Paid');
      case 'Received':
        return gettextCatalog.getString('Awaiting Receipt');
      default:
        return input;
    }
  }
}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFormatFundsRemoveStatus.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.funds').filter('holdingFormatFundsRemoveStatus', holdingFormatFundsRemoveStatus).name;


function holdingFormatFundsRemoveStatus(gettextCatalog) {
  'ngInject';

  return formatFundsRemoveStatus;

  function formatFundsRemoveStatus(input) {
    switch (input) {
      case 'Canceled':
        return gettextCatalog.getString('Canceled');
      case 'Completed':
        return gettextCatalog.getString('Completed');
      case 'Debited':
        return gettextCatalog.getString('Debited');
      case 'Postponed':
        return gettextCatalog.getString('Postponed');
      case 'Processed':
        return gettextCatalog.getString('Processed');
      case 'Received':
        return gettextCatalog.getString('Pending');
      default:
        return input;
    }
  }
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingFunds.$inject = ['$q', '$log', 'gettextCatalog', 'promiseCache', 'HoldingApi', 'HoldingConfig', 'HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.funds').factory('HoldingFunds', HoldingFunds).name;


function HoldingFunds($q, $log, gettextCatalog, promiseCache, HoldingApi, HoldingConfig, HoldingUser) {
  'ngInject';

  var AFTR_METHODS = [{
    key: 'BankWire',
    label: gettextCatalog.getString('Bank Wire')
  }, {
    key: 'Braintree',
    label: gettextCatalog.getString('Credit Card')
  }, {
    key: 'Crypto',
    label: gettextCatalog.getString('Cryptocurrency')
  }, {
    key: 'BitPay',
    label: gettextCatalog.getString('Cryptocurrency via BitPay')
  }, {
    key: 'PayPal',
    label: gettextCatalog.getString('PayPal')
  }, {
    key: 'SafechargeApplePay',
    label: gettextCatalog.getString('Apple Pay')
  }, {
    key: 'SafechargeAliPay',
    label: gettextCatalog.getString('AliPay')
  }, {
    key: 'SafechargeAstroPay',
    label: gettextCatalog.getString('AstroPay')
  }, {
    key: 'SafechargeCard',
    label: gettextCatalog.getString('Credit Card')
  }, {
    key: 'SafechargeCardFree',
    label: gettextCatalog.getString('Goldmoney Prepaid Card')
  }, {
    key: 'SafechargeEPS',
    label: gettextCatalog.getString('EPS')
  }, {
    key: 'SafechargeEpayBG',
    label: gettextCatalog.getString('ePay.bg')
  }, {
    key: 'SafechargeEuteller',
    label: gettextCatalog.getString('Euteller')
  }, {
    key: 'SafechargeGiropay',
    label: gettextCatalog.getString('Giropay')
  }, {
    key: 'SafechargeHalCash',
    label: gettextCatalog.getString('HalCash')
  }, {
    key: 'SafechargeIDeal',
    label: gettextCatalog.getString('IDeal')
  }, {
    key: 'SafechargeMisterCash',
    label: gettextCatalog.getString('Mister Cash')
  }, {
    key: 'SafechargeMultibanco',
    label: gettextCatalog.getString('Multibanco')
  }, {
    key: 'SafechargeNeosurf',
    label: gettextCatalog.getString('Neosurf')
  }, {
    key: 'SafechargePOLIAU',
    label: gettextCatalog.getString('POLi Payments')
  }, {
    key: 'SafechargePOLINZ',
    label: gettextCatalog.getString('POLi Payments')
  }, {
    key: 'SafechargeSEPA',
    label: gettextCatalog.getString('SEPA')
  }, {
    key: 'SafechargeSofort',
    label: gettextCatalog.getString('SOFORT')
  }, {
    key: 'SafechargeSporopay',
    label: gettextCatalog.getString('Sporopay')
  }, {
    key: 'SafechargeTeleIngreso',
    label: gettextCatalog.getString('Teleingreso')
  }, {
    key: 'SafechargeTrustPay',
    label: gettextCatalog.getString('TrustPay')
  }, {
    key: 'SafechargeUnionPay',
    label: gettextCatalog.getString('China UnionPay')
  }, {
    key: 'SafechargeWebmoney',
    label: gettextCatalog.getString('WebMoney')
  }, {
    key: 'SafechargeWeChat',
    label: gettextCatalog.getString('WeChat Pay')
  }, {
    key: 'SafechargeYandexMoney',
    label: gettextCatalog.getString('Yandex.Money')
  }];
  var CACHE_TTL = 600000;
  var KEY_PENDING_ADD_FUNDS = 'pendingAddFunds';
  var KEY_PENDING_REMOVE_FUNDS = 'pendingRemoveFunds';
  var RFTR_METHODS = [{
    key: 'CHAPS',
    label: gettextCatalog.getString('Faster Payment/CHAPS')
  }, {
    key: 'GIRO',
    label: gettextCatalog.getString('Giro Transfer')
  }, {
    key: 'SEPA',
    label: gettextCatalog.getString('SEPA Transfer')
  }, {
    key: 'WIRE',
    label: gettextCatalog.getString('Bank Wire')
  }];

  var model = {};

  return {
    addFundsBankWire: addFundsBankWire,
    cancelAddFunds: cancelAddFunds,
    clearPendingAddCache: clearPendingAddCache,
    clearPendingRemoveCache: clearPendingRemoveCache,
    createRemoveFundsBank: createRemoveFundsBank,
    exchangeCurrencies: exchangeCurrencies,
    getAftrBanks: getAftrBanks,
    getAftrMethod: getAftrMethod,
    getExchangeCurrencies: getExchangeCurrencies,
    getExchangeRate: getExchangeRate,
    getExchangeRateLocked: getExchangeRateLocked,
    getMaxAftr: getMaxAftr,
    getPendingAddFunds: getPendingAddFunds,
    getPendingRemoveFunds: getPendingRemoveFunds,
    getRftrBanks: getRftrBanks,
    getRftrMethod: getRftrMethod,
    initiateRemoveFundsBank: initiateRemoveFundsBank,
    model: model,
    resolveCanAddFunds: resolveCanAddFunds,
    setExpectedUse: setExpectedUse,
    showAddFunds: showAddFunds,
    showExchangeFunds: showExchangeFunds,
    showRemoveFunds: showRemoveFunds,
    uploadProofOfFundsDocument: uploadProofOfFundsDocument
  };

  function addFundsBankWire(_ref) {
    var amount = _ref.amount,
        bankLocation = _ref.bank.location;

    return HoldingApi.post('funds/add', {
      amount: amount,
      bankLocation: bankLocation
    }).then(clearPendingAddCache);
  }

  function cancelAddFunds(_ref2) {
    var code = _ref2.code;

    return HoldingApi.delete('funds/add/' + code).then(clearPendingAddCache);
  }

  function clearPendingAddCache(result) {
    promiseCache.remove(KEY_PENDING_ADD_FUNDS);
    return result;
  }

  function clearPendingRemoveCache(result) {
    promiseCache.remove(KEY_PENDING_REMOVE_FUNDS);
    return result;
  }

  function createRemoveFundsBank(_ref3, sellOrderNumber) {
    var amount = _ref3.amount,
        clientNotes = _ref3.clientNotes,
        _ref3$funding$destina = _ref3.funding.destination,
        address1 = _ref3$funding$destina.address1,
        address2 = _ref3$funding$destina.address2,
        address3 = _ref3$funding$destina.address3,
        bankAccountId = _ref3$funding$destina.bankAccountId,
        swiftCode = _ref3$funding$destina.swiftCode,
        pin = _ref3.pin,
        transferMethod = _ref3.method,
        shouldUpdateAddress = _ref3.shouldUpdateAddress,
        shouldUpdateSwiftCode = _ref3.shouldUpdateSwiftCode;

    var data = {
      amount: amount,
      bankAccountId: bankAccountId,
      pin: pin,
      transferMethod: transferMethod,
      sellOrderNumber: sellOrderNumber,
      clientNotes: clientNotes
    };

    if (shouldUpdateAddress) {
      data.newBankAddress = {
        address1: address1,
        address2: address2,
        address3: address3
      };
    }

    if (shouldUpdateSwiftCode) {
      data.newSwiftCode = {
        swiftCode: swiftCode
      };
    }

    return HoldingApi.post('funds/remove/create', data).then(clearPendingRemoveCache);
  }

  function exchangeCurrencies(data) {
    return HoldingApi.post('ctc/exchange', data);
  }

  function getAftrBanks() {
    return promiseCache({
      ttl: CACHE_TTL,
      promise: function promise() {
        return HoldingApi.get('funds/add/banks');
      }
    });
  }

  function getAftrMethod(method) {
    return AFTR_METHODS.find(function (_) {
      return method === _.key;
    });
  }

  function getExchangeCurrencies() {
    return HoldingApi.get('ctc/currencies');
  }

  function getExchangeRate(_ref4) {
    var amount = _ref4.amount,
        fromCurrency = _ref4.fromCurrency,
        toCurrency = _ref4.toCurrency;

    return HoldingApi.patch('ctc/rates', {
      amount: amount,
      fromCurrency: fromCurrency,
      toCurrency: toCurrency
    });
  }

  function getExchangeRateLocked(data) {
    return HoldingApi.patch('ctc/calculate', data);
  }

  function getMaxAftr(currencyCode) {
    return HoldingApi.post('funds/maxAftr', {
      currencyCode: currencyCode
    });
  }

  function getPendingAddFunds() {
    return promiseCache({
      ttl: CACHE_TTL,
      key: KEY_PENDING_ADD_FUNDS,
      promise: function promise() {
        return HoldingApi.get('funds/add/pending');
      }
    });
  }

  function getPendingRemoveFunds() {
    return promiseCache({
      ttl: CACHE_TTL,
      key: KEY_PENDING_REMOVE_FUNDS,
      promise: function promise() {
        return HoldingApi.get('funds/remove/pending');
      }
    });
  }

  function getRftrBanks() {
    var sell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return HoldingApi.get('funds/remove/banks', { params: { sell: sell } });
  }

  function getRftrMethod(method) {
    return RFTR_METHODS.find(function (_) {
      return method === _.key;
    });
  }

  function initiateRemoveFundsBank(_ref5, sellOrderNumber) {
    var amount = _ref5.amount,
        bankAccountId = _ref5.funding.destination.bankAccountId,
        transferMethod = _ref5.method;

    return HoldingApi.post('funds/remove/preview', {
      amount: amount,
      bankAccountId: bankAccountId,
      transferMethod: transferMethod,
      sellOrderNumber: sellOrderNumber
    });
  }

  function resolveCanAddFunds() {
    var rejectionState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'holding.dashboard.funds.add.overview';

    var deferred = $q.defer();
    getPendingAddFunds().then(function (transfers) {
      if (transfers.filter(function (transfer) {
        return transfer.status !== 'Completed';
      }).length >= HoldingConfig.settings.maxPendingTransfers) {
        deferred.reject({
          redirectTo: rejectionState
        });
      } else {
        deferred.resolve();
      }
    }).catch(function (error) {
      $log.error(error);
      if (error && 'code' in error) {
        switch (error.code) {
          case 'UNAUTHORIZED':
            deferred.resolve();
            break;
          default:
            deferred.reject({
              redirectTo: rejectionState
            });
            break;
        }
      } else {
        deferred.reject({
          redirectTo: rejectionState
        });
      }
    });
    return deferred.promise;
  }

  function setExpectedUse(model) {
    return HoldingApi.post('verification/expectedUse', {
      model: model
    });
  }

  function showAddFunds() {
    return !HoldingUser.isHidden('addFunds');
  }

  function showExchangeFunds() {
    return !HoldingUser.isHidden('exchangeFiat');
  }

  function showRemoveFunds() {
    return !HoldingUser.isHidden('removeFunds');
  }

  function uploadProofOfFundsDocument(file) {
    return HoldingApi.upload('holdings/upload', file, {
      uploadType: 'ProofOfFunds'
    });
  }
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(610);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(611);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.funds').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.funds', {
    abstract: true,
    url: '/funds',
    views: {
      hero: {
        controller: ['HoldingFunds', function controller(HoldingFunds) {
          'ngInject';

          this.showAddFunds = HoldingFunds.showAddFunds();
          this.showExchangeFunds = HoldingFunds.showExchangeFunds();
          this.showRemoveFunds = HoldingFunds.showRemoveFunds();
        }],
        controllerAs: 'fundsHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });
}]).name;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.funds.add.detail'|isState\" ui-sref=holding.dashboard.funds.add ui-sref-opts=\"{\n          reload: true\n        }\"> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.bank-accounts.details'|isState\" ui-sref=holding.dashboard.bank-accounts ui-sref-opts=\"{\n          reload: true\n        }\"> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.funds.remove.detail'|isState\" ui-sref=holding.dashboard.funds.remove ui-sref-opts=\"{\n          reload: true\n        }\"> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> </holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Manage Funds'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center ng-if=\"fundsHeroCtrl.showAddFunds || fundsHeroCtrl.showExchangeFunds || fundsHeroCtrl.showRemoveFunds\"> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Add Funds'|translate\" mobile-label=\"'Add'|translate\" ui-sref=holding.dashboard.funds.add ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ng-if=fundsHeroCtrl.showAddFunds> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Withdraw Funds'|translate\" mobile-label=\"'Withdraw'|translate\" ui-sref=holding.dashboard.funds.remove ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ng-if=fundsHeroCtrl.showRemoveFunds> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Exchange Funds'|translate\" mobile-label=\"'Exchange'|translate\" ui-sref=holding.dashboard.funds.exchange ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ng-if=fundsHeroCtrl.showExchangeFunds> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=funds-main></div> ";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance', [_angularjs2.default, _common2.default]).name;


__webpack_require__(613);

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(614);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(615);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance', {
    data: {
      skipSetupCheck: true
    },
    url: '/governance',
    views: {
      hero: {
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });

  $urlRouterProvider.when('/governance', '/governance/audit-reports');
}]).name;


__webpack_require__(616);
__webpack_require__(624);
__webpack_require__(634);

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Governance'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Reports'|translate\" mobile-label=\"'Reports'|translate\" ui-sref=holding.dashboard.governance.reports ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Insurance Certificates'|translate\" mobile-label=\"'Certificates'|translate\" ui-sref=holding.dashboard.governance.insurance ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Vault Video'|translate\" mobile-label=\"'Video'|translate\" ui-sref=holding.dashboard.governance.vault-video ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=governance-main></div> ";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _insuranceFlow = __webpack_require__(617);

var _insuranceFlow2 = _interopRequireDefault(_insuranceFlow);

var _insurance = __webpack_require__(618);

var _insurance2 = _interopRequireDefault(_insurance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.insurance', {
    url: '/insurance',
    views: {
      'governance-main': {
        controller: 'GovernanceInsuranceController',
        controllerAs: 'governanceInsuranceCtrl',
        template: _insurance2.default
      }
    },
    data: {
      flow: _insuranceFlow2.default,
      skipSetupCheck: true
    }
  });

  $urlRouterProvider.when('/governance/insurance', '/governance/insurance/');
}]).name;


__webpack_require__(619);
__webpack_require__(621);
__webpack_require__(622);

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Insurance'),
    sidebar: false,
    steps: [{
        key: 'landing',
        state: 'holding.dashboard.governance.insurance.landing',
        heading: (0, _gettext2.default)('Insurance Certificates')
    }, {
        key: 'details',
        state: 'holding.dashboard.governance.insurance.certificates',
        heading: (0, _gettext2.default)('Insurance Certificates')
    }]
};
exports.default = flow;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _certificates = __webpack_require__(620);

var _certificates2 = _interopRequireDefault(_certificates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.insurance.certificates', {
    data: {
      skipSetupCheck: true
    },
    url: '/certificates',
    views: {
      step: {
        template: _certificates2.default
      }
    }
  });
}]).name;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\" ng-form=governanceInsuranceCtrl.downloadForm> <holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Please select the vault below to view the corresponding insurance certificate.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=error ng-if=governanceInsuranceCtrl.downloadForm.$error.unknown> <span ng-bind=\"'An error occurred loading the vault insurance certificates.'|translate\"></span> </holding-alert-legacy> <gmw-box-selector required class=gmw-input-container ng-class=\"{\n        'gmw-input-container--rule-bottom': governanceInsuranceCtrl.certificates\n      }\" name=vault label=\"{{'Filter By a Specific Vault'|translate}}\" ng-model=governanceInsuranceCtrl.model.vault.id options=governanceInsuranceCtrl.vaults placeholder=\"{{'Select vault'|translate}}\"> </gmw-box-selector> <gmw-main-table desktop-only=true hover=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--20 heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--25 heading-h5 h-light-text\" ng-bind=\"'From'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--25 heading-h5 h-light-text\" ng-bind=\"'To'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\"></gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--select></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"certificate in governanceInsuranceCtrl.certificates track by $index\" ng-click=governanceInsuranceCtrl.selectCertificate(certificate)> <gmw-main-table-body-col class=gmw-main-table__body-cell--20> <gmw-flag country=certificate.vault.id|holdingVaultCountryCode></gmw-flag> <span ng-bind=certificate.vault.id|holdingVaultCustodian></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--25> <span ng-bind=certificate.validFrom|gmwFormatDate></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--25> <span ng-bind=certificate.validTo|gmwFormatDate></span> </gmw-main-table-body-col> <gmw-main-table-body-col> <span class=\"h-blue-text tooltip-bottom\" ng-click=governanceInsuranceCtrl.showMoreInfo(certificate) ng-bind=\"'Learn More'|translate\"> </span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option checked=governanceInsuranceCtrl.isCertificateSelected(certificate)></gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-click=governanceInsuranceCtrl.selectCertificate(certificate) ng-class=\"{\n          'gmw-simple-table--selected': governanceInsuranceCtrl.isCertificateSelected(report),\n        }\" ng-repeat=\"certificate in governanceInsuranceCtrl.certificates track by $index\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <gmw-flag country=certificate.vault.id|holdingVaultCountryCode></gmw-flag> <span ng-bind=certificate.vault.id|holdingVaultCustodian></span> </div> <div class=gmw-simple-table__head-right> <gmw-radio-option checked=governanceReportsCtrl.isAuditReportSelected(report) label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Valid From'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=certificate.validFrom|gmwFormatDate> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Valid To'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=certificate.validTo|gmwFormatDate> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label></span> <span class=gmw-simple-table__value> <span class=h-blue-text ng-click=governanceInsuranceCtrl.showMoreInfo(certificate) ng-bind=\"'Learn More'|translate\"> </span> </span> </div> </div> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"></div> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=\"governanceInsuranceCtrl.downloadForm.$error.unknown || !governanceInsuranceCtrl.isCertificateSelected()\" ng-click=governanceInsuranceCtrl.downloadCertificate()> <span ng-bind=\"'Download'|translate\"></span> </button> </footer> </div> ";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


GovernanceInsuranceController.$inject = ['$controller', 'gettextCatalog', '$state', '$scope', '$window', 'GmwModal', 'HoldingProperties', 'HoldingVaults', 'HoldingEnvironment'];
angular.module('app.holding.dashboard.governance').controller('GovernanceInsuranceController', GovernanceInsuranceController);

function GovernanceInsuranceController($controller, gettextCatalog, $state, $scope, $window, GmwModal, HoldingProperties, HoldingVaults, HoldingEnvironment) {
  'ngInject';

  var DEFAULT_MODEL = {
    vault: {
      id: 'all'
    }
  };

  var vm = this;
  vm.steps = {
    'holding.dashboard.governance.insurance.certificates': {
      checks: [{
        function: checkAgreedToTerms,
        revertTo: 'holding.dashboard.governance.insurance.landing'
      }]
    }
  };

  var CERTIFICATES = void 0;
  var agreedToTerms = false;
  var selectedCertificate = void 0;

  vm.downloadCertificate = downloadCertificate;
  vm.isCertificateSelected = isCertificateSelected;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.selectCertificate = selectCertificate;
  vm.showMoreInfo = showMoreInfo;
  vm.viewCertificates = viewCertificates;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    HoldingVaults.getInsuranceCertificates().then(function (certificates) {
      vm.certificates = CERTIFICATES = certificates.map(function (_ref) {
        var id = _ref.id,
            vault = _ref.vault;

        return {
          id: id,
          vault: HoldingVaults.getVaultInfoById(vault)
        };
      });

      vm.vaults = certificates.filter(function (certificate, index, self) {
        return self.findIndex(function (t) {
          return t.vault === certificate.vault;
        }) === index;
      }).filter(function (certificate) {
        return certificate.vault !== 'NONE';
      }).map(function (_ref2) {
        var vault = _ref2.vault;

        var vaultInfo = HoldingVaults.getVaultInfoById(vault);
        return {
          value: vault,
          label: '' + vaultInfo.name + (vaultInfo.location ? ' ' + vaultInfo.location : ''),
          flag: vaultInfo.countryCode
        };
      }).sort(function (a, b) {
        if (a.value > b.value) {
          return 1;
        } else if (b.value > a.value) {
          return -1;
        }
        return 0;
      });
      vm.vaults.unshift({
        value: 'all',
        label: 'All vaults'
      });
    }).catch(function (error) {
      if (vm.downloadForm) {
        vm.downloadForm.$setValidity('unknown', false);
      }
    });
  }

  function checkAgreedToTerms() {
    return agreedToTerms;
  }

  function downloadCertificate() {
    $window.open(HoldingEnvironment.urls.backend + 'vaults/download/' + selectedCertificate.id);
  }

  function isCertificateSelected() {
    var certificate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    return certificate ? selectedCertificate === certificate : !!selectedCertificate;
  }

  function onSelectedCertificateChanged() {
    if (vm.downloadForm) {
      if (selectedCertificate) {
        vm.downloadForm.$setValidity('selected', true);
      } else {
        vm.downloadForm.$setValidity('selected', false);
      }
    }
  }

  function onVaultChanged(vaultId, oldVaultId) {
    if (vaultId && vaultId !== oldVaultId && vaultId !== 'all') {
      vm.certificates = CERTIFICATES.filter(function (certificate) {
        return certificate.vault.id === vaultId;
      });
    } else {
      vm.certificates = CERTIFICATES;
    }
  }

  function selectCertificate(certificate) {
    if (isCertificateSelected(certificate)) {
      selectedCertificate = null;
    } else {
      selectedCertificate = certificate;
    }
  }

  function showMoreInfo(certificate) {
    GmwModal.showInfoModal(certificate.vault.name, certificate.vault.insurance.description);
  }

  function viewCertificates() {
    agreedToTerms = true;
    HoldingProperties.set('AgreeTermsVaultCertificates', {
      at: new Date().toISOString()
    });
    $state.go('holding.dashboard.governance.insurance.certificates');
  }

  $scope.$watch(function () {
    return vm.model.vault.id;
  }, onVaultChanged);
  $scope.$watch(function () {
    return selectedCertificate;
  }, onSelectedCertificateChanged);

  activate();
}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _landing = __webpack_require__(623);

var _landing2 = _interopRequireDefault(_landing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.insurance.landing', {
    data: {
      skipSetupCheck: true
    },
    url: '/',
    views: {
      step: {
        template: _landing2.default
      }
    }
  });
}]).name;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\" ng-form=governanceInsuranceCtrl.downloadForm> <holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=error ng-if=governanceInsuranceCtrl.downloadForm.$error.unknown> <span ng-bind=\"'An error occurred loading the vault insurance certificates.'|translate\"></span> </holding-alert-legacy> <p class=gmw-flow-box__description ng-if=!governanceInsuranceCtrl.downloadForm.$error.unknown> <span ng-bind=\"'All of the metals stored with our vault providers are fully insured; we post the latest versions of our insurance certificates here for our clients to review. These certificates are provided on a confidential basis - by clicking \\'I Agree\\', you agree not to distribute them to third parties.'|translate\"></span> </p> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col></div> <button class=\"medium-main-cta gmw-responsive-button\" ng-click=governanceInsuranceCtrl.viewCertificates() holding-button-disabled=governanceInsuranceCtrl.downloadForm.$error.unknown> <span ng-bind=\"'I Agree'|translate\"></span> </button> </footer> </div> ";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reportsFlow = __webpack_require__(625);

var _reportsFlow2 = _interopRequireDefault(_reportsFlow);

var _reports = __webpack_require__(626);

var _reports2 = _interopRequireDefault(_reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.reports', {
    url: '/reports',
    views: {
      'governance-main': {
        controller: 'GovernanceReportsController',
        controllerAs: 'governanceReportsCtrl',
        template: _reports2.default
      }
    },
    data: {
      flow: _reportsFlow2.default,
      skipSetupCheck: true
    }
  });

  $urlRouterProvider.when('/governance/reports', '/governance/reports/');
}]).name;


__webpack_require__(627);
__webpack_require__(629);
__webpack_require__(631);
__webpack_require__(632);

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Reports'),
    sidebar: false,
    steps: [{
        key: 'landing',
        state: 'holding.dashboard.governance.reports.landing',
        heading: (0, _gettext2.default)('Governance Reports')
    }, {
        key: 'audit',
        state: 'holding.dashboard.governance.reports.audit',
        heading: (0, _gettext2.default)('Audit Reports')
    }, {
        key: 'inventory',
        state: 'holding.dashboard.governance.reports.vault-inventory',
        heading: (0, _gettext2.default)('Vault Inventory Reports'),
        prev: 'holding.dashboard.governance.reports.landing'
    }]
};
exports.default = flow;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _audit = __webpack_require__(628);

var _audit2 = _interopRequireDefault(_audit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.reports.audit', {
    data: {
      skipSetupCheck: true
    },
    url: '/audit',
    views: {
      step: {
        template: _audit2.default
      }
    }
  });
}]).name;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center gmw-flow-box--full-width\" ng-form=governanceReportsCtrl.auditReportForm> <holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'The data below provides a complete history of all internal reports that have been provided by our auditors.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=governanceReportsCtrl.downloadForm> <holding-alert-legacy class=error ng-if=governanceReportsCtrl.downloadForm.$error.unknown> <span ng-bind=\"'An error occurred loading the audit reports.'|translate\"></span> </holding-alert-legacy> <gmw-box-selector required class=gmw-input-container ng-class=\"{\n        'gmw-input-container--rule-bottom': governanceReportsCtrl.auditReports\n      }\" name=vault label=\"{{'Filter By a Specific Vault'|translate}}\" ng-model=governanceReportsCtrl.model.auditReports.vault options=governanceReportsCtrl.auditReportVaults placeholder=\"{{'Select vault'|translate}}\"> </gmw-box-selector> <gmw-main-table ng-if=governanceReportsCtrl.auditReports desktop-only=true full-width=true hover=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--20 heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Report'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--15 heading-h5 h-light-text\" ng-bind=\"'From'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--15 heading-h5 h-light-text\" ng-bind=\"'To'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--select></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"report in governanceReportsCtrl.auditReports track by $index\" ng-click=governanceReportsCtrl.selectAuditReport(report)> <gmw-main-table-body-col class=gmw-main-table__body-cell--20> <gmw-flag ng-if=\"report.vault !== 'NONE'\" country=report.vault|holdingVaultCountryCode></gmw-flag> <span ng-if=\"report.vault !== 'NONE'\" ng-bind=report.vault|holdingVaultCustodian></span> </gmw-main-table-body-col> <gmw-main-table-body-col> <span ng-bind=report.name></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--15> <span ng-bind=report.validFrom|gmwFormatDate></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--15> <span ng-bind=report.validTo|gmwFormatDate></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option checked=governanceReportsCtrl.isAuditReportSelected(report)></gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\" ng-if=governanceReportsCtrl.auditReports> <div class=gmw-simple-table ng-click=governanceReportsCtrl.selectAuditReport(report) ng-class=\"{\n          'gmw-simple-table--selected': governanceReportsCtrl.isAuditReportSelected(report),\n        }\" ng-repeat=\"report in governanceReportsCtrl.auditReports track by $index\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <gmw-flag ng-if=\"report.vault !== 'NONE'\" country=report.vault|holdingVaultCountryCode></gmw-flag> <span ng-if=\"report.vault !== 'NONE'\" ng-bind=report.vault|holdingVaultCustodian></span> </div> <div class=gmw-simple-table__head-right> <gmw-radio-option checked=governanceReportsCtrl.isAuditReportSelected(report) label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Report'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=report.name> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Valid From'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=report.validFrom|gmwFormatDate> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Valid To'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=report.validTo|gmwFormatDate> </span> </div> </div> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"></div> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=\"governanceReportsCtrl.downloadForm.$error.unknown || !governanceReportsCtrl.isAuditReportSelected()\" ng-click=governanceReportsCtrl.downloadAuditReport()> <span ng-bind=\"'Download'|translate\"></span> </button> </footer> </div> ";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _landing = __webpack_require__(630);

var _landing2 = _interopRequireDefault(_landing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.reports.landing', {
    data: {
      skipSetupCheck: true
    },
    url: '/',
    views: {
      step: {
        template: _landing2.default
      }
    }
  });
}]).name;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\"> <div class=gmw-flow-box-container> <section class=gmw-governance-reports-landing__section> <div class=gmw-governance-reports-landing__text-wrap> <h2 class=\"gmw-governance-reports-landing__heading heading-h1 h-dark-text\" ng-bind=\"'Audit Reports'|translate\"> </h2> <p class=gmw-flow-box__description> <span ng-bind=\"'Goldmoney\\'s custodial holdings are regularly audited. These reports are provided on a confidential basis - by clicking \\'I Agree\\', you agree not to distribute them to third parties.'|translate\"></span> </p> </div> <button class=\"medium-main-cta gmw-responsive-button\" ng-click=governanceReportsCtrl.viewAuditReports()> <span ng-bind=\"'I Agree'|translate\"></span> </button> </section> <section class=gmw-governance-reports-landing__section> <div class=gmw-governance-reports-landing__text-wrap> <h2 class=\"gmw-governance-reports-landing__heading heading-h1 h-dark-text\" ng-bind=\"'Vault Inventory Reports'|translate\"> </h2> <p class=gmw-flow-box__description> <span ng-bind=\"'Our vault operators provide us with regular inventory reports, confirming the quantities and types of metals that we have custody of. These reports are provided to you on a confidential basis - by clicking \\'I Agree\\', you agree not to distribute them to third parties.'|translate\"></span> </p> </div> <button class=\"medium-main-cta gmw-responsive-button\" ng-click=governanceReportsCtrl.viewVaultInventoryReports()> <span ng-bind=\"'I Agree'|translate\"></span> </button> </section> </div> </div> ";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


GovernanceReportsController.$inject = ['$controller', '$scope', '$state', '$window', 'HoldingEnvironment', 'HoldingProperties', 'HoldingVaults'];
angular.module('app.holding.dashboard.governance').controller('GovernanceReportsController', GovernanceReportsController);

function GovernanceReportsController($controller, $scope, $state, $window, HoldingEnvironment, HoldingProperties, HoldingVaults) {
  'ngInject';

  var DEFAULT_MODEL = {
    auditReports: {
      vault: 'all'
    },
    vaultInventoryReports: {
      vault: 'all'
    }
  };

  var vm = this;
  vm.steps = {
    'holding.dashboard.governance.reports.audit': {
      checks: [{
        function: checkAgreedToTerms,
        revertTo: 'holding.dashboard.governance.reports.landing'
      }]
    },
    'holding.dashboard.governance.reports.vault-inventory': {
      checks: [{
        function: checkAgreedToTerms,
        revertTo: 'holding.dashboard.governance.reports.landing'
      }]
    }
  };

  var AUDIT_REPORTS = void 0;
  var VAULT_INVENTORY_REPORTS = void 0;

  var agreedToTerms = false;
  var selectedAuditReport = void 0,
      selectedVaultInventoryReport = void 0;

  vm.downloadAuditReport = downloadAuditReport;
  vm.downloadVaultInventoryReport = downloadVaultInventoryReport;
  vm.isAuditReportSelected = isAuditReportSelected;
  vm.isVaultInventoryReportSelected = isVaultInventoryReportSelected;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.selectAuditReport = selectAuditReport;
  vm.selectVaultInventoryReport = selectVaultInventoryReport;
  vm.viewAuditReports = viewAuditReports;
  vm.viewVaultInventoryReports = viewVaultInventoryReports;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    HoldingVaults.getAuditReports().then(function (auditReports) {
      vm.auditReports = AUDIT_REPORTS = auditReports;

      vm.auditReportVaults = auditReports.filter(function (report, index, self) {
        return self.findIndex(function (t) {
          return t.vault === report.vault;
        }) === index;
      }).filter(function (report) {
        return report.vault !== 'NONE';
      }).map(function (_ref) {
        var vault = _ref.vault;

        var vaultInfo = HoldingVaults.getVaultInfoById(vault);
        return {
          value: vault,
          label: '' + vaultInfo.name + (vaultInfo.location ? ' ' + vaultInfo.location : ''),
          flag: vaultInfo.countryCode
        };
      }).sort(function (a, b) {
        if (a.value > b.value) {
          return 1;
        } else if (b.value > a.value) {
          return -1;
        }
        return 0;
      });
      vm.auditReportVaults.unshift({
        value: 'all',
        label: 'All vaults'
      });
    }).catch(function (error) {
      if (vm.downloadForm) {
        vm.downloadForm.$setValidity('unknown', false);
      }
    });

    HoldingVaults.getVaultInventoryReports().then(function (vaultInventoryReports) {
      vm.vaultInventoryReports = VAULT_INVENTORY_REPORTS = vaultInventoryReports;

      vm.vaultInventoryReportVaults = vaultInventoryReports.filter(function (report, index, self) {
        return self.findIndex(function (t) {
          return t.vault === report.vault;
        }) === index;
      }).filter(function (report) {
        return report.vault !== 'NONE';
      }).map(function (_ref2) {
        var vault = _ref2.vault;

        var vaultInfo = HoldingVaults.getVaultInfoById(vault);
        return {
          value: vault,
          label: '' + vaultInfo.name + (vaultInfo.location ? ' ' + vaultInfo.location : ''),
          flag: vaultInfo.countryCode
        };
      }).sort(function (a, b) {
        if (a.value > b.value) {
          return 1;
        } else if (b.value > a.value) {
          return -1;
        }
        return 0;
      });
      vm.vaultInventoryReportVaults.unshift({
        value: 'all',
        label: 'All vaults'
      });
    }).catch(function (error) {
      if (vm.downloadForm) {
        vm.downloadForm.$setValidity('unknown', false);
      }
    });
  }

  function checkAgreedToTerms() {
    return agreedToTerms;
  }

  function downloadAuditReport() {
    $window.open(HoldingEnvironment.urls.backend + 'vaults/download/' + selectedAuditReport.id);
  }

  function downloadVaultInventoryReport() {
    $window.open(HoldingEnvironment.urls.backend + 'vaults/download/' + selectedVaultInventoryReport.id);
  }

  function isAuditReportSelected() {
    var report = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    return report ? selectedAuditReport === report : !!selectedAuditReport;
  }

  function isVaultInventoryReportSelected() {
    var report = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    return report ? selectedVaultInventoryReport === report : !!selectedVaultInventoryReport;
  }

  function onAuditReportVaultChanged(vaultId, oldVaultId) {
    if (vaultId && vaultId !== oldVaultId && vaultId !== 'all') {
      vm.auditReports = AUDIT_REPORTS.filter(function (report) {
        return report.vault === vaultId;
      });
    } else {
      vm.auditReports = AUDIT_REPORTS;
    }
  }

  function onVaultInventoryReportVaultChanged(vaultId, oldVaultId) {
    if (vaultId && vaultId !== oldVaultId && vaultId !== 'all') {
      vm.vaultInventoryReports = VAULT_INVENTORY_REPORTS.filter(function (report) {
        return report.vault === vaultId;
      });
    } else {
      vm.vaultInventoryReports = VAULT_INVENTORY_REPORTS;
    }
  }

  function selectAuditReport(report) {
    if (isAuditReportSelected(report)) {
      selectedAuditReport = null;
    } else {
      selectedAuditReport = report;
    }
  }

  function selectVaultInventoryReport(report) {
    if (isVaultInventoryReportSelected(report)) {
      selectedVaultInventoryReport = null;
    } else {
      selectedVaultInventoryReport = report;
    }
  }

  function viewAuditReports() {
    agreedToTerms = true;
    HoldingProperties.set('AgreeTermsAuditReports', {
      at: new Date().toISOString()
    });
    $state.go('holding.dashboard.governance.reports.audit');
  }

  function viewVaultInventoryReports() {
    agreedToTerms = true;
    HoldingProperties.set('AgreeTermsVaultInventoryReports', {
      at: new Date().toISOString()
    });
    $state.go('holding.dashboard.governance.reports.vault-inventory');
  }

  $scope.$watch(function () {
    return vm.model.auditReports.vault;
  }, onAuditReportVaultChanged);
  $scope.$watch(function () {
    return vm.model.vaultInventoryReports.vault;
  }, onVaultInventoryReportVaultChanged);

  activate();
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultInventory = __webpack_require__(633);

var _vaultInventory2 = _interopRequireDefault(_vaultInventory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.reports.vault-inventory', {
    data: {
      skipSetupCheck: true
    },
    url: '/vault-inventory',
    views: {
      step: {
        template: _vaultInventory2.default
      }
    }
  });
}]).name;

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\"> <holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'The inventory reports below set out the gross and fine weight of each bar held in the chosen vaults on behalf of our customers, including: its unique serial number, fineness, and the name of the refiner who produced it.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=info> <span ng-bind=\"'Please note that we typically receive our vault inventory lists by the 15th of the month.'|translate\"></span> </holding-alert-legacy> <holding-alert-legacy class=error ng-if=governanceReportsCtrl.downloadForm.$error.unknown> <span ng-bind=\"'An error occurred loading the audit reports.'|translate\"></span> </holding-alert-legacy> <gmw-box-selector required class=gmw-input-container ng-class=\"{\n        'gmw-input-container--rule-bottom': governanceReportsCtrl.auditReports\n      }\" name=vault label=\"{{'Filter By a Specific Vault'|translate}}\" ng-model=governanceReportsCtrl.model.vaultInventoryReports.vault options=governanceReportsCtrl.vaultInventoryReportVaults placeholder=\"{{'Select vault'|translate}}\"> </gmw-box-selector> <gmw-main-table ng-if=governanceReportsCtrl.vaultInventoryReports desktop-only=true full-width=true hover=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--20 heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Report'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--15 heading-h5 h-light-text\" ng-bind=\"'From'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--15 heading-h5 h-light-text\" ng-bind=\"'To'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--select></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"report in governanceReportsCtrl.vaultInventoryReports track by $index\" ng-click=governanceReportsCtrl.selectVaultInventoryReport(report)> <gmw-main-table-body-col class=gmw-main-table__body-cell--20> <gmw-flag ng-if=\"report.vault !== 'NONE'\" country=report.vault|holdingVaultCountryCode></gmw-flag> <span ng-if=\"report.vault !== 'NONE'\" ng-bind=report.vault|holdingVaultCustodian></span> </gmw-main-table-body-col> <gmw-main-table-body-col> <span ng-bind=report.name></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--15> <span ng-bind=report.validFrom|gmwFormatDate></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--15> <span ng-bind=report.validTo|gmwFormatDate></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option checked=governanceReportsCtrl.isVaultInventoryReportSelected(report)></gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\" ng-if=governanceReportsCtrl.vaultInventoryReports> <div class=gmw-simple-table ng-click=governanceReportsCtrl.selectVaultInventoryReport(report) ng-class=\"{\n          'gmw-simple-table--selected': governanceReportsCtrl.isVaultInventoryReportSelected(report),\n        }\" ng-repeat=\"report in governanceReportsCtrl.vaultInventoryReports track by $index\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <gmw-flag ng-if=\"report.vault !== 'NONE'\" country=report.vault|holdingVaultCountryCode></gmw-flag> <span ng-if=\"report.vault !== 'NONE'\" ng-bind=report.vault|holdingVaultCustodian></span> </div> <div class=gmw-simple-table__head-right> <gmw-radio-option checked=governanceReportsCtrl.isAuditReportSelected(report) label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Report'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=report.name> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Valid From'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=report.validFrom|gmwFormatDate> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Valid To'|translate\"> </span> <span class=gmw-simple-table__value ng-bind=report.validTo|gmwFormatDate> </span> </div> </div> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"></div> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=\"governanceReportsCtrl.downloadForm.$error.unknown || !governanceReportsCtrl.isVaultInventoryReportSelected()\" ng-click=governanceReportsCtrl.downloadVaultInventoryReport()> <span ng-bind=\"'Download'|translate\"></span> </button> </footer> </div> ";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultVideoFlow = __webpack_require__(635);

var _vaultVideoFlow2 = _interopRequireDefault(_vaultVideoFlow);

var _vaultVideo = __webpack_require__(636);

var _vaultVideo2 = _interopRequireDefault(_vaultVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.vault-video', {
    url: '/vault-video',
    views: {
      'governance-main': {
        controller: 'GovernanceVaultVideosController',
        controllerAs: 'governanceVaultVideosCtrl',
        template: _vaultVideo2.default
      }
    },
    data: {
      flow: _vaultVideoFlow2.default,
      skipSetupCheck: true
    }
  });

  $urlRouterProvider.when('/governance/vault-video', '/governance/vault-video/');
}]).name;


__webpack_require__(637);
__webpack_require__(639);
__webpack_require__(640);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Vault Video'),
    sidebar: false,
    steps: [{
        key: 'landing',
        state: 'holding.dashboard.governance.vault-video.landing',
        heading: (0, _gettext2.default)('Vault Video')
    }, {
        key: 'details',
        state: 'holding.dashboard.governance.vault-video.video',
        heading: (0, _gettext2.default)('Vault Video')
    }]
};
exports.default = flow;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _landing = __webpack_require__(638);

var _landing2 = _interopRequireDefault(_landing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.vault-video.landing', {
    data: {
      skipSetupCheck: true
    },
    url: '/',
    views: {
      step: {
        template: _landing2.default
      }
    }
  });
}]).name;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\"> <holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container> <p class=gmw-flow-box__description> <span ng-bind=\"'Thanks to our storage partner, Loomis International (previously VIA MAT International), we are able to provide you with a rare look into a state-of-the-art high security precious metals vault.'|translate\"></span> <br><br> <span ng-bind=\"'Before viewing this exclusive video, please confirm your acceptance of the following terms:'|translate\"></span> </p> <ol class=gmw-number-list type=1> <li class=gmw-number-list__item> <span class=medium-text ng-bind=\"'Only the Holding owners can view the video;'|translate\"></span> </li> <li class=gmw-number-list__item> <span class=medium-text ng-bind=\"'You must not record, reproduce, copy, share, or distribute this video in any form;'|translate\"></span> </li> <li class=gmw-number-list__item> <span class=medium-text ng-bind=\"'Goldmoney owns all rights in respect of the video;'|translate\"></span> </li> <li class=gmw-number-list__item> <span class=medium-text ng-bind=\"'We reserve the right to disable access to your Holding and/or terminate your relationship with us if, in our opinion, you have failed to comply with these terms.'|translate\"></span> </li> </ol> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col></div> <button class=\"medium-main-cta gmw-responsive-button\" ng-click=governanceVaultVideosCtrl.viewVaultVideos()> <span ng-bind=\"'I Agree'|translate\"></span> </button> </footer> </div> ";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


GovernanceVaultVideosController.$inject = ['$controller', '$scope', '$state', 'HoldingProperties'];
angular.module('app.holding.dashboard.governance').controller('GovernanceVaultVideosController', GovernanceVaultVideosController);

function GovernanceVaultVideosController($controller, $scope, $state, HoldingProperties) {
  'ngInject';

  var vm = this;
  vm.steps = {
    'holding.dashboard.governance.vault-video.video': {
      checks: [{
        function: checkAgreedToTerms,
        revertTo: 'holding.dashboard.governance.vault-video.landing'
      }]
    }
  };

  var agreedToTerms = false;

  vm.viewVaultVideos = viewVaultVideos;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
  }

  function checkAgreedToTerms() {
    return agreedToTerms;
  }

  function viewVaultVideos() {
    agreedToTerms = true;
    HoldingProperties.set('AgreeTermsVaultVideo', {
      at: new Date().toISOString()
    });
    $state.go('holding.dashboard.governance.vault-video.video');
  }

  activate();
}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _video = __webpack_require__(641);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.governance').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.governance.vault-video.video', {
    data: {
      skipSetupCheck: true
    },
    url: '/video',
    views: {
      step: {
        template: _video2.default
      }
    }
  });
}]).name;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\"> <holding-flow-header> <p class=gmw-flow-box__header-description translate> <span ng-bind=\"'An exclusive look inside one of our Loomis International (formerly VIA MAT International) vaults.'|translate\"> </span></p> </holding-flow-header> <div class=gmw-flow-box-container> <p class=gmw-flow-box__description--center> <video class=gmw-flow-box__video src=https://gm-public.s3.eu-west-1.amazonaws.com/videos/vault-video-viamat.mp4 poster=/img/vault-video-viamat.jpg controls> <span translate> Sorry, your browser doesn't support embedded videos. You can <a class=h-blue-link href=https://gm-public.s3.eu-west-1.amazonaws.com/videos/vault-video-viamat.mp4> download the video directly </a> to watch on your computer. </span> </video> </p> </div> </div> ";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals', [_angularjs2.default, _common2.default]).name;


__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(646);
__webpack_require__(648);
__webpack_require__(650);
__webpack_require__(652);
__webpack_require__(654);
__webpack_require__(656);
__webpack_require__(658);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.metals').constant('HoldingTroyRate', 31.1034).name;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyVaultSelector = __webpack_require__(645);

var _buyVaultSelector2 = _interopRequireDefault(_buyVaultSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingBuyVaultSelector', holdingBuyVaultSelector).name;


function holdingBuyVaultSelector() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      description: '@?',
      label: '@?',
      vaults: '='
    },
    template: _buyVaultSelector2.default
  };

  function link(scope, _elem, _attrs, ctrl) {
    function select(vault) {
      if (vault.enabled) {
        ctrl.$setViewValue(vault.vault);
      }
    }

    scope.model = ctrl;
    scope.select = select;
  }
}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\"> <span ng-if=label ng-bind=label></span> <span ng-if=!label ng-bind=\"'Select Vault'|translate\"></span> </label> <p class=gmw-input-container__description> <span ng-if=description ng-bind=description></span> <span ng-if=!description ng-bind=\"'Select the vault that you would like to store your metal in. Storage fees can vary by vault provider and location.'|translate\"></span> </p> <gmw-main-table desktop-only=true hover=true small=true full-width=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Custodian'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Location'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text h-center-text\" ng-bind=\"'Monthly Storage Fees'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--select heading-h5 h-light-text\"> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-click=select(vault) ng-disabled=!vault.enabled ng-repeat=\"vault in vaults track by vault.vault\"> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=::(vault.vault|holdingVaultCountryCode)></gmw-flag> <span ng-bind=::(vault.vault|holdingVaultLocation)></span> <holding-svg-icon ng-if=vault.disabledMessage gmw-tooltip=\"{{vault.disabledMessage}}\" class=gmw-main-table__body-cell__tooltip-indicator icon=gmw-info> </holding-svg-icon> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-bind=::(vault.vault|holdingVaultCustodian)></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <span ng-bind=::(vault.vault|holdingVaultCountry)></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--center h-light-text\"> <span ng-bind=::vault.storageFee></span>% </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option gmw-disabled=!vault.enabled checked=\"model.$viewValue === vault.vault\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <gmw-main-table mobile-only=true hover=true small=true full-width=true> <gmw-main-table mobile-only=true small=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Storage Fees'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--select></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-click=select(vault) ng-disabled=!vault.enabled ng-repeat=\"vault in vaults track by vault.vault\"> <gmw-main-table-body-col> <gmw-flag country=::(vault.vault|holdingVaultCountryCode)></gmw-flag> <span ng-bind=::(vault.vault|holdingVaultCustodian)></span> <svg class=gmw-main-table__body-cell__tooltip-indicator ng-if=vault.disabledMessage gmw-tooltip=\"{{vault.disabledMessage}}\"> <use xlink:href=#gmw-info-icon></use> </svg> </gmw-main-table-body-col> <gmw-main-table-body-col> <span ng-bind=::vault.storageFee></span>% / month </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option gmw-disabled=!vault.enabled checked=\"model.$viewValue === vault.vault\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> </gmw-main-table> </div> ";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metalBadge = __webpack_require__(647);

var _metalBadge2 = _interopRequireDefault(_metalBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingMetalBadge', holdingMetalBadge).name;


var metals = {
  Gold: {
    element: 'Au'
  },
  Silver: {
    element: 'Ag'
  },
  Platinum: {
    element: 'Pt'
  },
  Palladium: {
    element: 'Pd'
  }
};

function holdingMetalBadge() {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _metalBadge2.default,
    scope: {
      metal: '='
    }
  };

  function link($scope) {
    $scope.getClass = function () {
      var metal = metals[$scope.metal];
      return metal ? metal.element.toLowerCase() : metal;
    };

    $scope.getElement = function () {
      var metal = metals[$scope.metal];
      return metal ? metal.element : metal;
    };
  }
}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "<i class=\"gmw-metal-badge gmw-metal-badge--{{getClass()}}\"> <span ng-bind=getElement()></span> </i> ";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metalToggle = __webpack_require__(649);

var _metalToggle2 = _interopRequireDefault(_metalToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingMetalToggle', holdingMetalToggle).name;


function holdingMetalToggle() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      metals: '=',
      label: '@'
    },
    template: _metalToggle2.default
  };

  function link(scope, _element, _attrs, ngModel) {
    function select(metal) {
      ngModel.$setViewValue(metal);
    }

    scope.model = ngModel;
    scope.select = select;
  }
}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=label> </label> <gmw-toggle-option-group> <a class=\"heading-h5 option-toggle__item\" ng-repeat=\"metal in metals track by metal\" href ng-class=\"{'option-toggle__item--active': model.$viewValue === metal}\" ng-click=select(metal) ng-switch=metal> <span ng-switch-when=Gold ng-bind=\"'Gold'|translate\"> </span> <span ng-switch-when=Silver ng-bind=\"'Silver'|translate\"> </span> <span ng-switch-when=Platinum ng-bind=\"'Platinum'|translate\"> </span> <span ng-switch-when=Palladium ng-bind=\"'Palladium'|translate\"> </span> </a> </gmw-toggle-option-group> </div> ";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingMetalsBalance.$inject = ['HoldingUser', 'GmwSetup', 'HoldingTransactions', 'HoldingTroyRate'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metalsBalance = __webpack_require__(651);

var _metalsBalance2 = _interopRequireDefault(_metalsBalance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingMetalsBalance', holdingMetalsBalance).name;


function holdingMetalsBalance(HoldingUser, GmwSetup, HoldingTransactions, HoldingTroyRate) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      equivalentCurrency: '=',
      metals: '='
    },
    template: _metalsBalance2.default
  };

  function link(scope) {
    function closeMenu() {
      moreMenuFlyoutActive = undefined;
      moreMenuMobileFlyoutActive = undefined;
    }

    function hasLockedBalance(metal) {
      return metal.locked && 'amount' in metal.locked ? metal.locked.amount > 0 : false;
    }

    function hasMetal() {
      return scope.metals !== null && scope.metals.length > 0;
    }

    function hasReservedMetal(metal) {
      return metal.reserved && 'amount' in metal.reserved ? metal.reserved.amount > 0 : false;
    }

    function isMoreMenuFlyoutActive(index) {
      return moreMenuFlyoutActive === index;
    }

    function isMoreMenuMobileFlyoutActive(index) {
      return moreMenuMobileFlyoutActive === index;
    }

    function openMoreMenuFlyout(index) {
      moreMenuFlyoutActive = index;
    }

    function openMoreMenuMobileFlyout(index) {
      moreMenuMobileFlyoutActive = index;
    }

    var moreMenuFlyoutActive = void 0,
        moreMenuMobileFlyoutActive = void 0;
    var user = HoldingUser.get();

    GmwSetup.hasCompletedSetup().then(function (hasCompletedSetup) {
      scope.canBuyMetal = hasCompletedSetup && !user.locked;
    });

    scope.canRedeemPhysicalSchiffGold = HoldingUser.isAllowed('schiffgold') && !user.locked;
    scope.canSellMetal = HoldingUser.canSellMetal() && hasMetal();
    scope.hasReservedMetal = hasReservedMetal;
    scope.isMoreMenuFlyoutActive = isMoreMenuFlyoutActive;
    scope.isMoreMenuMobileFlyoutActive = isMoreMenuMobileFlyoutActive;
    scope.openMoreMenuFlyout = openMoreMenuFlyout;
    scope.openMoreMenuMobileFlyout = openMoreMenuMobileFlyout;
    scope.troyRate = HoldingTroyRate;
    scope.user = user;

    var flyoutListener = scope.$on('gmw:flyout:close', closeMenu);
    scope.$on('$destroy', function () {
      flyoutListener();
    });
  }
}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <header class=gmw-table-header> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title desktop-only desktop-only--xs\" ng-bind=\"'Precious Metals'|translate\"> </h2> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title mobile-only mobile-only--xs\" ng-bind=\"'Metals'|translate\"> </h2> <div class=\"gmw-table-header__actions desktop-only desktop-only--xs\" ng-if=\"canRedeemPhysicalSchiffGold || canBuyMetal || canSellMetal\"> <button class=\"small-border-cta gmw-button-spacer\" ng-class=\"{\n          'gmw-button-spacer--small': canBuyMetal || canSellMetal\n        }\" ng-if=canRedeemPhysicalSchiffGold ui-sref=physical.schiffgold.catalog ng-bind=\"'Convert to Coins'|translate\"> </button> <button class=\"small-secondary-cta gmw-button-spacer\" ng-class=\"{\n          'gmw-button-spacer--small': canBuyMetal\n        }\" ng-if=canSellMetal ui-sref=holding.dashboard.metals.sell ng-bind=\"'Sell Metal'|translate\"> </button> <button class=small-main-cta ui-sref=holding.dashboard.metals.buy ng-if=canBuyMetal ng-bind=\"'Buy Metal'|translate\"> </button> </div> <div class=\"gmw-table-header__actions mobile-only mobile-only--xs\" ng-if=\"canRedeemPhysicalSchiffGold || canBuyMetal || canSellMetal\"> <div class=gmw-dual-dot-data> <a ui-sref=physical.schiffgold.catalog ng-if=canRedeemPhysicalSchiffGold class=\"heading-h5 h-base-text\" ng-bind=\"'Coins'|translate\"> </a> <span class=\"gmw-dot gmw-dot--light gmw-dot--medium-margin\" ng-if=\"canBuyMetal || canSellMetal\" ng-bind=\"'&middot;'\"> </span> <a ui-sref=holding.dashboard.metals.sell ng-if=canSellMetal class=\"heading-h5 h-base-text\" ng-bind=\"'Sell'|translate\"> </a> <span class=\"gmw-dot gmw-dot--light gmw-dot--medium-margin\" ng-if=canBuyMetal ng-bind=\"'&middot;'\"> </span> <a ui-sref=holding.dashboard.metals.buy ng-if=canBuyMetal class=\"heading-h5 h-gold-text\" ng-bind=\"'Buy'|translate\"> </a> </div> </div> </header> <gmw-main-table desktop-only=true> <gmw-main-table-header class=gmw-main-table__head--extra-right-padding> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--15 heading-h5 h-light-text\" ng-bind=\"'Metal'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--20 heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text gmw-main-table__head-cell--align-right\" ng-bind=\"'Balance'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--25 heading-h5 h-light-text gmw-main-table__head-cell--align-right\"> <span ng-bind=\"('In '|translate) + equivalentCurrency\"></span> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--icon></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"metal in metals track by $index\"> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--15 h-light-text\"> <holding-metal-badge metal=::metal.currencyCode></holding-metal-badge> <span ng-bind=metal.currencyCode|translate></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--20> <gmw-flag country=metal.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=metal.vault|holdingVaultCustodian></span>&nbsp; <span ng-bind=metal.vault|holdingVaultLocation></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"h-light-text gmw-main-table__body-cell--align-right\"> <span ng-if=\"metal.balance.currency !== 'Silver'\"> <span ng-bind=metal.balance|gmwFormatProduct:null:true></span> <span class=\"gmw-dot gmw-dot--light\" ng-bind=\"'&middot;'\"></span> <span ng-bind=\"((metal.balance.amount / troyRate)|gmwFormatNumber) + ' OZ'\"></span> </span> <span ng-if=\"metal.balance.currency === 'Silver'\"> <span ng-bind=\"((metal.balance.amount * troyRate)|gmwFormatNumber) + ' SG'\"></span> <span class=\"gmw-dot gmw-dot--light\" ng-bind=\"'&middot;'\"></span> <span ng-bind=\"(metal.balance.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </gmw-main-table-body-col> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--25 h-dark-text gmw-main-table__body-cell--align-right\"> <holding-svg-icon ng-if=\"hasLockedBalance(metal) && !hasReservedMetal(metal)\" gmw-tooltip=\"{{'There are pending orders (reflected as reserved balances) or locked balances affecting the amount of metal available - exact amounts are found on the local balance menu'|translate}}\" class=gmw-main-table__body-cell__encumbered-indicator width=14px height=14px icon=octagon-pending> </holding-svg-icon> <holding-svg-icon ng-if=\"hasLockedBalance(metal) && hasReservedMetal(metal)\" gmw-tooltip=\"{{'There are pending orders (reflected as reserved balances) and locked balances affecting the amount of metal available - exact amounts are found on the local balance menu'|translate}}\" class=gmw-main-table__body-cell__encumbered-indicator width=14px height=14px icon=octagon-pending> </holding-svg-icon> <holding-svg-icon ng-if=\"!hasLockedBalance(metal) && hasReservedMetal(metal)\" gmw-tooltip=\"{{'There are pending orders (reflected as reserved balances) affecting the amount of metal available - exact amounts are found on the local balance menu'|translate}}\" class=gmw-main-table__body-cell__encumbered-indicator width=14px height=14px icon=octagon-pending> </holding-svg-icon> <span ng-bind=metal.equivalent|holdingFormatFunds></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--icon ng-if=!user.locked ng-click=openMoreMenuFlyout($index) gmw-focus-out-flyout-close=\"{{isMoreMenuFlyoutActive($index)}}\"> <holding-metals-more-menu is-active=isMoreMenuFlyoutActive($index) metal=metal> </holding-metals-more-menu> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-repeat=\"metal in metals track by $index\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <holding-metal-badge metal=metal.currencyCode></holding-metal-badge> <span ng-bind=metal.currencyCode></span> </div> <div class=gmw-simple-table__head-right> <gmw-flag country=metal.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=metal.vault|holdingVaultCustodian></span> </div> <div class=\"c-vault-more gmw-simple-table__head-more\" ng-if=!user.locked> <div class=c-vault-more__icon-container ng-click=openMoreMenuMobileFlyout($index) gmw-focus-out-flyout-close=\"{{isMoreMenuMobileFlyoutActive($index)}}\"> <holding-metals-more-menu is-active=isMoreMenuMobileFlyoutActive($index) metal=metal> </holding-metals-more-menu> <holding-svg-icon class=c-vault-more__icon icon=vertical-more> </holding-svg-icon> </div> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Location'|translate\"></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\"> <span ng-bind=metal.vault|holdingVaultCustodian></span>&nbsp; <span ng-bind=metal.vault|holdingVaultLocation></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Grams'|translate\"></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.balance.currency !== 'Silver'\"> <span ng-bind=metal.balance|gmwFormatProduct:null:true></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.balance.currency === 'Silver'\"> <span ng-bind=\"((metal.balance.amount * troyRate)|gmwFormatNumber) + ' SG'\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Ounces'|translate\"></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.balance.currency !== 'Silver'\"> <span ng-bind=\"((metal.balance.amount / troyRate)|gmwFormatNumber) + ' OZ'\"></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.balance.currency === 'Silver'\"> <span ng-bind=\"(metal.balance.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Reserved'|translate\"></span> <holding-svg-icon class=gmw-simple-table__tooltip-indicator gmw-tooltip=\"{{'Your metal that is currently reserved for pending orders'|translate}}\" icon=info> </holding-svg-icon> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.reserved.currency !== 'Silver'\"> <span ng-bind=metal.reserved|gmwFormatProduct:null:true></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.reserved.currency === 'Silver'\"> <span ng-bind=\"(metal.reserved.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </div> <div class=gmw-simple-table__row ng-repeat=\"lock in metal.locks track by $index\"> <span class=gmw-simple-table__label> <span ng-bind=\"'Locked'|translate\"></span> <holding-svg-icon class=gmw-simple-table__tooltip-indicator gmw-tooltip=\"{{lock.memo + '; Released on ' + (lock.unlockTs|gmwFormatDate)}}\" icon=info> </holding-svg-icon> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"lock.amount.currency !== 'Silver'\"> <span ng-bind=lock.amount|gmwFormatProduct:null:true></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"lock.amount.currency === 'Silver'\"> <span ng-bind=\"(lock.amount.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label> <span ng-bind=\"'Available'|translate\"></span> <holding-svg-icon class=gmw-simple-table__tooltip-indicator gmw-tooltip=\"{{'Your metal balance that is available to be sold or transferred'|translate}}\" icon=info> </holding-svg-icon> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.spendable.currency !== 'Silver'\"> <span ng-bind=metal.spendable|gmwFormatProduct:null:true></span> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-if=\"metal.spendable.currency === 'Silver'\"> <span ng-bind=\"(metal.spendable.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"('In '|translate) + equivalentCurrency\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=metal.equivalent|holdingFormatFunds> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingMetalsMoreMenu.$inject = ['HoldingUser', 'HoldingBars', 'HoldingTransactions'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metalsMoreMenu = __webpack_require__(653);

var _metalsMoreMenu2 = _interopRequireDefault(_metalsMoreMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingMetalsMoreMenu', holdingMetalsMoreMenu).name;


function holdingMetalsMoreMenu(HoldingUser, HoldingBars, HoldingTransactions) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      isActive: '=',
      metal: '='
    },
    template: _metalsMoreMenu2.default
  };

  function link(scope) {
    function hasLockedMetal() {
      return scope.metal.locks ? scope.metal.locks.length > 0 : false;
    }

    function hasPendingTransactions() {
      return scope.pendingTransactions && scope.pendingTransactions.length > 0 ? !!scope.pendingTransactions.find(function (transaction) {
        return transaction.vault === scope.metal.vault && transaction.product.currency === scope.metal.currencyCode;
      }) : false;
    }

    function hasReservedMetal() {
      return scope.metal.reserved && 'amount' in scope.metal.reserved ? scope.metal.reserved.amount > 0 : false;
    }

    function hasSpendableMetal() {
      return scope.metal.spendable && 'amount' in scope.metal.spendable ? scope.metal.spendable.amount > 0 : false;
    }

    scope.canBuyMetal = HoldingUser.isAllowed('buy');
    scope.canExchangeMetal = HoldingUser.isAllowed('exchange');
    scope.canSellMetal = HoldingUser.isAllowed('sell');
    scope.canTransferMetal = HoldingUser.isAllowed('makePayment') && HoldingUser.getPermission('makePayment').currencies.find(function (currency) {
      return currency === scope.metal.currencyCode;
    });
    scope.hasLockedMetal = hasLockedMetal;
    scope.hasPendingTransactions = hasPendingTransactions;
    scope.hasReservedMetal = hasReservedMetal;
    scope.hasSpendableMetal = hasSpendableMetal;

    HoldingBars.getRegistrationProducts().then(function (products) {
      scope.canRegisterMetal = HoldingUser.isAllowed('allocateBars') && products.filter(function (product) {
        return HoldingBars.getCurrencyFromProduct(product.barProductCode) === scope.metal.currencyCode;
      }).filter(function (product) {
        return product.vaults.find(function (vault) {
          return vault === scope.metal.vault;
        });
      }).filter(function (product) {
        return HoldingBars.getWeightFromProduct(product.barProductCode) < scope.metal.spendable.amount;
      }).length > 0;
    });

    HoldingTransactions.getPendingTransactions().then(function (pendingTransactions) {
      scope.pendingTransactions = pendingTransactions;
    });
  }
}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "<div class=c-vault-more> <div class=c-vault-menu ng-class=\"{\n      'c-vault-menu--active': isActive,\n    }\"> <span class=c-vault-menu__balance> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your total balance including metal that is reserved and locked'|translate}}\"> <span ng-bind=\"'Balance:'|translate\"></span> </span> <span class=h-dark-text> <span ng-if=\"metal.balance.currency !== 'Silver'\"> <span ng-bind=metal.balance|gmwFormatProduct:null:true></span> </span> <span ng-if=\"metal.balance.currency === 'Silver'\"> <span ng-bind=\"(metal.balance.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </span> </span> <span class=c-vault-menu__balance ng-if=hasReservedMetal()> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your metal that is currently reserved for pending orders'|translate}}\"> <span ng-bind=\"'Reserved:'|translate\"></span> </span> <span class=h-dark-text> <span ng-if=\"metal.reserved.currency !== 'Silver'\"> <span ng-bind=metal.reserved|gmwFormatProduct:null:true></span> </span> <span ng-if=\"metal.reserved.currency === 'Silver'\"> <span ng-bind=\"(metal.reserved.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </span> </span> <span class=c-vault-menu__balance ng-if=hasLockedMetal() ng-repeat=\"lock in metal.locks track by $index\"> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{lock.memo + '; Released on ' + (lock.unlockTs|gmwFormatDate)}}\" ng-bind=\"'Locked:'|translate\"> </span> <span class=h-dark-text> <span ng-if=\"lock.amount.currency !== 'Silver'\"> <span ng-bind=lock.amount|gmwFormatProduct:null:true></span> </span> <span ng-if=\"lock.amount.currency === 'Silver'\"> <span ng-bind=\"(lock.amount.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </span> </span> <span class=c-vault-menu__balance ng-if=\"hasLockedMetal() || hasReservedMetal()\"> <span class=\"h-medium-text c-vault-menu__balance_label\" gmw-tooltip=\"{{'Your metal balance that is available to be sold or transferred'|translate}}\"> <span ng-bind=\"'Available:'|translate\"></span> </span> <span class=h-dark-text> <span ng-if=\"metal.spendable.currency !== 'Silver'\"> <span ng-bind=metal.spendable|gmwFormatProduct:null:true></span> </span> <span ng-if=\"metal.spendable.currency === 'Silver'\"> <span ng-bind=\"(metal.spendable.amount|gmwFormatNumber) + ' OZ'\"></span> </span> </span> </span> <hr class=c-vault-menu__divider ng-if=hasPendingTransactions()> <a class=c-vault-menu__item ui-sref=holding.dashboard.overview.transactions ng-if=hasPendingTransactions()> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=transactions width=28px height=19px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'View pending orders'|translate\"></span> </span> </a> <hr class=c-vault-menu__divider> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.metals.buy({\n        metal: metal.currencyCode,\n        vault: metal.vault,\n      })\" ng-if=canBuyMetal> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=buy-metal width=25px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Buy more'|translate\"></span> <span ng-bind=metal.currencyCode></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.metals.sell({\n        metal: metal.currencyCode,\n        vault: metal.vault,\n      })\" ng-if=\"canSellMetal && hasSpendableMetal()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=sell-metal width=25px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Sell your'|translate\"></span> <span ng-bind=metal.currencyCode></span> </span> </a> <a class=c-vault-menu__item ui-sref=holding.dashboard.bars.registration ng-if=\"canRegisterMetal && hasSpendableMetal()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=dual-bar-registration width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Register metal'|translate\"></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.metals.exchange({\n        metal: metal.currencyCode,\n        vault: metal.vault,\n      })\" ng-if=\"canExchangeMetal && hasSpendableMetal()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=exchange-metal width=26px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\"> <span ng-bind=\"'Exchange to another metal'|translate\"></span> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.metals.vault-exchange({\n        sourceMetal: metal.currencyCode,\n        sourceVault: metal.vault,\n      })\" ng-if=\"canExchangeMetal && hasSpendableMetal()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon icon=small-safe width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\" ng-bind=\"'Exchange to another vault'|translate\"> </span> </a> <a class=c-vault-menu__item ui-sref=\"holding.dashboard.transfers.new({\n        type: 'metal',\n        currency: metal.currencyCode,\n        vault: metal.vault,\n      })\" ng-if=\"canTransferMetal && hasSpendableMetal()\"> <div class=c-vault-menu__icon-container> <holding-svg-icon class=c-vault-menu__icon icon=dual-send-payment width=24px height=24px> </holding-svg-icon> </div> <span class=\"h-dark-text ui-text\" ng-bind=\"'Transfer ownership'|translate\"> </span> </a> </div> <div class=c-vault-more__icon-container> <holding-svg-icon class=c-vault-more__icon icon=vertical-more> </holding-svg-icon> </div> </div> ";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sellResultData = __webpack_require__(655);

var _sellResultData2 = _interopRequireDefault(_sellResultData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingSellResultData', holdingSellResultData).name;


function holdingSellResultData() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      data: '=',
      destination: '='
    },
    template: _sellResultData2.default
  };
}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Metal'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=data.sell.currency|translate> </span> <span class=gmw-to-and-from__label ng-bind=\"'Sell Amount'|translate\"> </span> <span class=gmw-to-and-from__data> <span ng-bind=data.sell|gmwFormatProduct></span> </span> <span class=gmw-to-and-from__label ng-if=data.sell|gmwIsInGrams ng-bind=\"'Ounce Equivalent'|translate\"> </span> <span class=gmw-to-and-from__data ng-if=data.sell|gmwIsInGrams> <span ng-bind=\"data.sell|gmwFormatProduct:'oz'\"></span> </span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label> <span ng-bind=\"'Will Receive'|translate\"></span> (<span ng-bind=::data.buy.currency|holdingCurrencySymbol></span>) </span> <span class=gmw-to-and-from__data ng-bind=::data.buy|holdingFormatFunds> </span> <span class=gmw-to-and-from__label> <span ng-bind=\"'Funds Destination'|translate\"></span> </span> <span class=gmw-to-and-from__data ng-switch=destination> <span ng-switch-when=bankAccount translate>Bank Account</span> <span ng-switch-when=prepaidCard translate>Prepaid Card</span> <span ng-switch-default translate>Holdings</span> </span> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row ng-if=\"data.location !== 'NONE'\" label=\"{{'Vault'|translate}}\"> <gmw-flag country=::data.location|holdingVaultCountryCode></gmw-flag> <span ng-bind=::data.location|holdingVaultCustodian></span> <span ng-bind=::data.location|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row ng-if=data.sell|gmwIsInGrams label=\"{{'Goldmoney Sell Rate'|translate}} ({{::data.sell.currency|holdingCurrencySymbol}})\"> <span ng-bind-html=::data.rateBidPrice|gmwFormatProductRate></span> </gmw-recap-table-row> <gmw-recap-table-row ng-if=data.sell|gmwIsInGrams label=\"{{'Goldmoney Sell Rate (oz)'|translate}}\"> <span ng-bind-html=\"::data.ratePrice|gmwFormatProductRate:'oz'\"></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Sell Fee'|translate}}\"> {{::data.rateFeePercentage}}% </gmw-recap-table-row> <gmw-recap-table-row ng-if=data.sell|gmwIsInGrams label=\"{{'Overall Sell Rate'|translate}} ({{::data.sell.currency|holdingCurrencySymbol}})\"> <span ng-bind-html=::data.ratePrice|gmwFormatProductRate></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Overall Sell Rate (oz)'|translate}}\"> <span ng-bind-html=\"::data.ratePrice|gmwFormatProductRate:'oz'\"></span> </gmw-recap-table-row> </div> </div> ";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sellVaultSelector = __webpack_require__(657);

var _sellVaultSelector2 = _interopRequireDefault(_sellVaultSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingSellVaultSelector', holdingSellVaultSelector).name;


function holdingSellVaultSelector() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      description: '@?',
      equivalentCurrency: '=',
      label: '@?',
      vaults: '='
    },
    template: _sellVaultSelector2.default
  };

  function link(scope, _elem, _attrs, ctrl) {
    function select(vault) {
      if (vault.enabled) {
        ctrl.$setViewValue(vault);
      }
    }

    scope.model = ctrl;
    scope.select = select;
  }
}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\"> <span ng-if=label ng-bind=label></span> <span ng-if=!label ng-bind=\"'Select Vault'|translate\"></span> </label> <p class=gmw-input-container__description> <span ng-if=description ng-bind=description></span> <span ng-if=!description ng-bind=\"'Select the metal that you’d like to sell in part or full. Please repeat the process to sell multiple metals.'|translate\"></span> </p> <gmw-main-table desktop-only=true hover=true small=true full-width=true> <gmw-main-table-header> <gmw-main-table-header-col class=\"gmw-main-table__head-cell--15 heading-h5 h-light-text\" ng-bind=\"'Metal'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Vault'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Grams'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"('In '|translate) + equivalentCurrency\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--select></gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-click=select(vault) ng-disabled=!vault.enabled ng-repeat=\"vault in vaults track by $index\"> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--15 h-light-text\"> <holding-metal-badge metal=::vault.product></holding-metal-badge> <span ng-bind=::vault.product></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=::vault.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vault.vault|holdingVaultCustodian></span> <svg class=gmw-main-table__body-cell__tooltip-indicator ng-if=vault.disabledMessage gmw-tooltip=\"{{vault.disabledMessage}}\"> <use xlink:href=#gmw-info-icon></use> </svg> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text ng-bind=vault.totalSpendable|gmwFormatProduct> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-dark-text ng-bind=vault.equivalent|holdingFormatFunds> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--select> <gmw-radio-option gmw-disabled=!vault.enabled checked=\"model.$viewValue === vault\"> </gmw-radio-option> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=\"gmw-simple-table-section mobile-only mobile-only--sm\"> <div class=gmw-simple-table ng-click=select(vault) ng-disabled=!vault.enabled ng-class=\"{\n        'gmw-simple-table--selected': model.$viewValue === vault,\n      }\" ng-repeat=\"vault in vaults track by $index\"> <div class=gmw-simple-table__head> <div class=gmw-simple-table__head-left> <holding-metal-badge metal=::vault.product></holding-metal-badge> <span ng-bind=::vault.product></span> </div> <div class=gmw-simple-table__head-right> <gmw-radio-option gmw-disabled=!vault.enabled checked=\"model.$viewValue === vault\" label=\"{{'Select'|translate}}\" small=true> </gmw-radio-option> </div> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Vault'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\"> <gmw-flag country=::vault.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vault.vault|holdingVaultCustodian></span> <svg class=gmw-simple-table__value__tooltip-indicator ng-if=vault.disabledMessage gmw-tooltip=\"{{vault.disabledMessage}}\"> <use xlink:href=#gmw-info-icon></use> </svg> </span> </div> <div class=gmw-simple-table__row ng-if=\"vault.product !== 'Silver'\"> <span class=gmw-simple-table__label ng-bind=\"'Grams'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=vault.totalSpendable|gmwFormatProduct> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Ounces'|translate\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=\"vault.totalSpendable|gmwFormatProduct:'oz'\"> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"('In '|translate) + equivalentCurrency\"> </span> <span class=\"gmw-simple-table__value gmw-simple-table__value--align-right\" ng-bind=vault.equivalent|holdingFormatFunds> </span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementMetals = __webpack_require__(659);

var _statementMetals2 = _interopRequireDefault(_statementMetals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').directive('holdingStatementMetals', holdingStatementMetals).name;


function holdingStatementMetals() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      metals: '=',
      total: '='
    },
    template: _statementMetals2.default
  };
}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-statement__table desktop-only desktop-only--sm\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Metal'|translate\"> </span> <span class=gmw-statement__table-cell--header ng-bind=\"'Vault'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" ng-bind=\"'Total Grams'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" ng-bind=\"'Total Ounces'|translate\"> </span> <span class=\"gmw-statement__table-cell--header gmw-statement__table-cell--header-right\" translate> {{::total.currency}} Equivalent </span> </div> <div class=gmw-statement__table-row ng-repeat=\"metal in metals\"> <span class=gmw-statement__table-cell--value> <holding-metal-badge metal=::metal.metal.currency></holding-metal-badge> <span ng-bind=metal.metal.currency|translate></span> </span> <span class=gmw-statement__table-cell--value> <gmw-flag country=::metal.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=::metal.vault|holdingVaultCustodian></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=\"metal.metal|gmwFormatProduct:'g'\"></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=\"metal.metal|gmwFormatProduct:'oz'\"></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\"> <span ng-bind=metal.equivalent|holdingFormatFunds></span> </span> </div> <div class=gmw-statement__total> <span class=gmw-statement__total-label ng-bind=\"'Total Precious Metals Value'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=total.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=total.currency> </span> </span> </div> </div> <div class=\"gmw-statement__table mobile-only mobile-only--sm\" ng-repeat=\"metal in metals\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Metal'|translate\"> </span> <span class=gmw-statement__table-cell--value> <holding-metal-badge metal=::metal.metal.currency></holding-metal-badge> <span ng-bind=::metal.metal.currency></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Vault'|translate\"> </span> <span class=gmw-statement__table-cell--value> <gmw-flag country=::metal.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=::metal.vault|holdingVaultCustodian></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Total Grams'|translate\"> </span> <span class=gmw-statement__table-cell--value> <span ng-bind=\"metal.metal|gmwFormatProduct:'g'\"></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=\"'Total Ounces'|translate\"> </span> <span class=gmw-statement__table-cell--value> <span ng-bind=\"metal.metal|gmwFormatProduct:'oz'\"></span> </span> </div> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header translate> {{::total.currency}} Equivalent </span> <span class=gmw-statement__table-cell--value> <span ng-bind=metal.equivalent|holdingFormatFunds></span> </span> </div> </div> <div class=\"gmw-statement__total mobile-only mobile-only--sm\"> <span class=gmw-statement__total-label ng-bind=\"'Total Precious Metals Value'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=total.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=total.currency> </span> </span> </div> ";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingConvertGramsToOunces.$inject = ['HoldingTroyRate'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.metals').filter('holdingConvertGramsToOunces', holdingConvertGramsToOunces).name;


function holdingConvertGramsToOunces(HoldingTroyRate) {
  'ngInject';

  return function (input) {
    if (!input) {
      return input;
    }
    return input / HoldingTroyRate;
  };
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingConvertOuncesToGrams.$inject = ['HoldingTroyRate'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.metals').filter('holdingConvertOuncesToGrams', holdingConvertOuncesToGrams).name;


function holdingConvertOuncesToGrams(HoldingTroyRate) {
  'ngInject';

  return function (input) {
    if (!input) {
      return input;
    }
    return input * HoldingTroyRate;
  };
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingMetals.$inject = ['HoldingApi', 'HoldingTransactions', 'HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.metals').factory('HoldingMetals', HoldingMetals).name;


function HoldingMetals(HoldingApi, HoldingTransactions, HoldingUser) {
  'ngInject';

  var METALS = ['Gold', 'Silver', 'Platinum', 'Palladium'];
  var UNITS = [{
    name: 'Grams',
    value: 'GRAMS'
  }, {
    name: 'Ounces',
    value: 'OUNCES'
  }];

  return {
    getAllUnitsForSelectorWithName: getAllUnitsForSelectorWithName,
    getBuyCurrencies: getBuyCurrencies,
    getBuyRates: getBuyRates,
    getBuyVaults: getBuyVaults,
    getExchangeDestinations: getExchangeDestinations,
    getExchangeRates: getExchangeRates,
    getExchangeSources: getExchangeSources,
    getMetals: getMetals,
    getSellRates: getSellRates,
    getSellVaults: getSellVaults,
    lockBuyPrice: lockBuyPrice,
    lockExchangePrice: lockExchangePrice,
    lockSellPrice: lockSellPrice,
    placeBuyOrder: placeBuyOrder,
    placeExchangeOrder: placeExchangeOrder,
    placeSellOrder: placeSellOrder,
    showBuyMetal: showBuyMetal,
    showExchangeMetal: showExchangeMetal,
    showSellMetal: showSellMetal
  };

  function getAllUnitsForSelectorWithName() {
    return UNITS.map(function (unit) {
      return {
        label: unit.name,
        value: unit.value
      };
    });
  }

  function getBuyCurrencies() {
    return HoldingApi.get('buy/currencies');
  }

  function getBuyRates(amount, product, currency, location) {
    return HoldingApi.patch('buy/rates', { amount: amount, product: product, currency: currency, location: location });
  }

  function getBuyVaults() {
    return HoldingApi.get('buy/vaults/metals');
  }

  function getExchangeDestinations(metal) {
    return HoldingApi.get('mtm/destination', { params: { metal: metal } }).then(function (destinations) {
      return destinations.map(function (_ref) {
        var disabledMessage = _ref.disabledMessage,
            enabled = _ref.enabled,
            product = _ref.product,
            storageFee = _ref.fee,
            vault = _ref.vault;
        return {
          disabledMessage: disabledMessage,
          enabled: enabled,
          product: product,
          vault: vault,
          storageFee: storageFee
        };
      });
    });
  }

  function getExchangeRates(amount, _ref2, buyLocation, buyProduct, isSellAmount) {
    var sellLocation = _ref2.vault,
        sellProduct = _ref2.product;

    return HoldingApi.patch('mtm/rates', {
      amount: amount,
      sellLocation: sellLocation,
      sellProduct: sellProduct,
      buyLocation: buyLocation,
      buyProduct: buyProduct,
      isSellAmount: isSellAmount
    });
  }

  function getExchangeSources() {
    return HoldingApi.get('mtm/source');
  }

  function getMetals() {
    return angular.copy(METALS);
  }

  function getSellRates(product, currency, location) {
    return HoldingApi.patch('sell/rates', { product: product, currency: currency, location: location });
  }

  function getSellVaults() {
    return HoldingApi.get('sell/vaults/metals');
  }

  function lockBuyPrice(product, currency, location, amount) {
    return HoldingApi.patch('buy/calculate', { product: product, currency: currency, location: location, amount: amount });
  }

  function lockExchangePrice(_ref3, buyLocation, buyProduct, amount, isSellAmount) {
    var sellLocation = _ref3.vault,
        sellProduct = _ref3.product;

    return HoldingApi.patch('mtm/calculate', {
      sellLocation: sellLocation,
      sellProduct: sellProduct,
      buyLocation: buyLocation,
      buyProduct: buyProduct,
      amount: amount,
      isSellAmount: isSellAmount
    });
  }

  function lockSellPrice(product, currency, location, amount) {
    return HoldingApi.patch('sell/calculate', { product: product, currency: currency, location: location, amount: amount });
  }

  function placeBuyOrder(product, currency, location, amount) {
    return HoldingApi.post('buy/buy', { product: product, currency: currency, location: location, amount: amount }).then(function (result) {
      HoldingTransactions.clearCache();
      return result;
    });
  }

  function placeExchangeOrder(_ref4, buyLocation, buyProduct, amount, isSellAmount) {
    var sellLocation = _ref4.vault,
        sellProduct = _ref4.product;

    return HoldingApi.post('mtm/exchange', {
      sellLocation: sellLocation,
      sellProduct: sellProduct,
      buyLocation: buyLocation,
      buyProduct: buyProduct,
      amount: amount,
      isSellAmount: isSellAmount
    });
  }

  function placeSellOrder(product, currency, location, amount) {
    return HoldingApi.post('sell/sell', { product: product, currency: currency, location: location, amount: amount }).then(function (result) {
      HoldingTransactions.clearCache();
      return result;
    });
  }

  function showBuyMetal() {
    return !HoldingUser.isHidden('buy');
  }

  function showExchangeMetal() {
    return !HoldingUser.isHidden('exchange');
  }

  function showSellMetal() {
    return !HoldingUser.isHidden('sell');
  }
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(664);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(665);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals', {
    abstract: true,
    url: '/metals',
    views: {
      hero: {
        controller: ['HoldingMetals', function controller(HoldingMetals) {
          'ngInject';

          this.showBuyMetal = HoldingMetals.showBuyMetal();
          this.showExchangeMetal = HoldingMetals.showExchangeMetal();
          this.showSellMetal = HoldingMetals.showSellMetal();
        }],
        controllerAs: 'metalsHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });

  $urlRouterProvider.when('/metals', '/metals/buy');
}]).name;


__webpack_require__(666);
__webpack_require__(678);
__webpack_require__(690);
__webpack_require__(704);

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Precious Metals'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center ng-if=\"metalsHeroCtrl.showBuyMetal || metalsHeroCtrl.showExchangeMetal || metalsHeroCtrl.showSellMetal\"> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Buy Metal'|translate\" mobile-label=\"'Buy'|translate\" ng-if=metalsHeroCtrl.showBuyMetal ui-sref=holding.dashboard.metals.buy ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Sell Metal'|translate\" mobile-label=\"'Sell'|translate\" ng-if=metalsHeroCtrl.showSellMetal ui-sref=holding.dashboard.metals.sell ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item ng-if=metalsHeroCtrl.showExchangeMetal label=\"'Exchange Metal'|translate\" mobile-label=\"'Ex. Metal'|translate\" ui-sref=holding.dashboard.metals.exchange ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item ng-if=metalsHeroCtrl.showExchangeMetal label=\"'Vault Exchange'|translate\" mobile-label=\"'Vault Ex.'|translate\" ui-sref=holding.dashboard.metals.vault-exchange ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=metals-main></div> ";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyFlow = __webpack_require__(667);

var _buyFlow2 = _interopRequireDefault(_buyFlow);

var _buy = __webpack_require__(668);

var _buy2 = _interopRequireDefault(_buy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.buy', {
    data: {
      flow: _buyFlow2.default
    },
    params: {
      currency: {
        type: 'string',
        value: null
      },
      metal: {
        type: 'string',
        value: null
      },
      vault: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      SelectedCurrencyResolve: ['$q', '$stateParams', function SelectedCurrencyResolve($q, $stateParams) {
        'ngInject';

        return 'currency' in $stateParams ? $q.when($stateParams.currency) : $q.when();
      }],
      SelectedMetalResolve: ['$q', '$stateParams', function SelectedMetalResolve($q, $stateParams) {
        'ngInject';

        return 'metal' in $stateParams ? $q.when($stateParams.metal) : $q.when();
      }],
      SelectedVaultResolve: ['$q', '$stateParams', function SelectedVaultResolve($q, $stateParams) {
        'ngInject';

        return 'vault' in $stateParams ? $q.when($stateParams.vault) : $q.when();
      }]
    },
    url: '/buy',
    views: {
      'metals-main@holding.dashboard.metals': {
        controller: 'BuyMetalController',
        controllerAs: 'buyMetalCtrl',
        template: _buy2.default
      }
    }
  });

  $urlRouterProvider.when('/metals/buy', '/metals/buy/amount');
}]).name;


__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(672);
__webpack_require__(674);
__webpack_require__(676);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Buy Precious Metals'),
    cancel: {
        state: 'holding.dashboard.metals.buy'
    },
    complete: {
        label: (0, _gettext2.default)('Return to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'amount',
        state: 'holding.dashboard.metals.buy.amount',
        heading: (0, _gettext2.default)('Buy Vaulted, Allocated Precious Metals'),
        label: (0, _gettext2.default)('Select Metal & Amount')
    }, {
        key: 'vault',
        state: 'holding.dashboard.metals.buy.vault',
        heading: (0, _gettext2.default)('Select Storage Vault'),
        label: (0, _gettext2.default)('Select Vault')
    }, {
        key: 'review',
        state: 'holding.dashboard.metals.buy.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Metal Purchase'),
        label: (0, _gettext2.default)('Review Purchase'),
        controls: {
            next: (0, _gettext2.default)('Place Order')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.metals.buy.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "<section class=\"gmw-flow-box gmw-flow-box--center\" ng-if=!buyMetalCtrl.canBuyMetal> <holding-permission-based-empty-state permission=canBuyMetal></holding-permission-based-empty-state> </section> <section ng-if=buyMetalCtrl.canBuyMetal> <div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I buy metals?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000520188> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How long does a purchase take to process?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000686007> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> </section> ";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


BuyMetalController.$inject = ['$controller', '$q', '$scope', '$state', '$timeout', 'HoldingUser', 'HoldingMetals', 'HoldingCurrencies', 'HoldingPromotions', 'SelectedCurrencyResolve', 'SelectedMetalResolve', 'SelectedVaultResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').controller('BuyMetalController', BuyMetalController);

function BuyMetalController($controller, $q, $scope, $state, $timeout, HoldingUser, HoldingMetals, HoldingCurrencies, HoldingPromotions, SelectedCurrencyResolve, SelectedMetalResolve, SelectedVaultResolve) {
  'ngInject';

  var vm = this;
  var model = {
    fiatAmount: {},
    metalAmount: {}
  };
  var result = {};
  vm.steps = {
    'holding.dashboard.metals.buy.vault': {
      checks: [{
        function: checkAmount,
        revertTo: 'holding.dashboard.metals.buy.amount'
      }],
      next: lockPrice
    },
    'holding.dashboard.metals.buy.review': {
      checks: [{
        function: checkAmount,
        revertTo: 'holding.dashboard.metals.buy.amount'
      }, {
        function: checkVault,
        revertTo: 'holding.dashboard.metals.buy.vault'
      }],
      next: placeOrder
    },
    'holding.dashboard.metals.buy.complete': {
      checks: [{
        function: checkComplete,
        revertTo: 'holding.dashboard.metals.buy.review'
      }]
    }
  };

  vm.allVaults = [];
  vm.buyPromoMinimum = buyPromoMinimum;
  vm.clearFiat = clearFiat;
  vm.clearMetal = clearMetal;
  vm.currencies = [];
  vm.isCurrencySelected = isCurrencySelected;
  vm.maxFiatAmounts = {};
  vm.maxMetalAmounts = {};
  vm.model = model;
  vm.refresh = lockPrice;
  vm.result = result;
  vm.selectBrinksZurich = selectBrinksZurich;
  vm.selectLoomisLondon = selectLoomisLondon;
  vm.vaults = [];

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    vm.user = HoldingUser.get();
    vm.canBuyMetal = HoldingUser.canBuyMetal();

    HoldingMetals.getBuyVaults().then(function (vaults) {
      vm.allVaults = vaults;
      if (SelectedVaultResolve) {
        vm.model.vault = vm.allVaults.some(function (vault) {
          return vault.vault === SelectedVaultResolve && vault.enabled;
        }) ? SelectedVaultResolve : undefined;
      }

      vm.metals = vaults.reduce(function (prev, curr) {
        if (!prev.includes(curr.product)) {
          prev.push(curr.product);
        }
        return prev;
      }, []);

      vm.selectorMetals = vm.metals.map(function (metal) {
        return {
          label: metal,
          value: metal
        };
      });
      vm.maxMetalAmounts = {};
      vaults.forEach(function (_ref) {
        var maxBuyable = _ref.maxBuyable;

        vm.maxMetalAmounts[maxBuyable.currency] = maxBuyable;
      });

      if (SelectedMetalResolve) {
        vm.model.metal = vm.metals.some(function (metal) {
          return metal === SelectedMetalResolve;
        }) ? SelectedMetalResolve : undefined;
      } else {
        vm.model.metal = vm.metals[0];
      }
    }).catch(function (_ref2) {
      var code = _ref2.code;

      if (code === 'UNAUTHORIZED') {
        $state.go('holding.dashboard.overview', {}, {
          reload: true
        });
      }
    });

    HoldingMetals.getBuyCurrencies().then(function (currencies) {
      vm.currencies = currencies.map(function (_ref3) {
        var amount = _ref3.spendable;
        return angular.extend(HoldingCurrencies.prepareForSelector(amount.currency), { amount: amount });
      });
      vm.maxFiatAmounts = {};
      currencies.forEach(function (_ref4) {
        var spendable = _ref4.spendable;

        vm.maxFiatAmounts[spendable.currency] = spendable;
      });
      if (vm.form) {
        vm.form.$setValidity('noFunds', vm.currencies.length > 0);
      }

      if (SelectedCurrencyResolve) {
        vm.model.currency = SelectedCurrencyResolve;
      } else if (vm.currencies.find(function (_) {
        return _.value === vm.user.currency;
      })) {
        vm.model.currency = vm.currencies.find(function (_) {
          return _.value === vm.user.currency;
        }).value;
      } else {
        var highestCurrency = vm.currencies.reduce(function (prev, curr) {
          if (curr.amount.amount > prev.amount.amount) {
            return curr;
          }
          return prev;
        }, { amount: { amount: -1 } });
        vm.model.currency = highestCurrency.value;
      }
    });

    HoldingPromotions.getPromoCode().then(function (promoCode) {
      vm.promoCode = promoCode;
      vm.showPromotionBanner = !!vm.promoCode;
    });
  }

  function buyPromoMinimum() {
    vm.model.metal = 'Silver';
    $timeout(function () {
      clearFiat();
      vm.model.metalAmount.amount = 35;
    });
  }

  function checkAmount() {
    return !!(vm.model.fiatAmount.amount || vm.model.metalAmount.amount);
  }

  function checkComplete() {
    return !!result.complete;
  }

  function checkVault() {
    return !!vm.model.vault;
  }

  function clearBuyMaxFiat() {
    vm.buyMaxFiatAmount = false;
  }

  function clearFiat() {
    vm.model.fiatAmount.amount = '';
  }

  function clearMetal() {
    vm.model.metalAmount.amount = '';
  }

  function filterVaults(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        metal = _ref6[0],
        allVaults = _ref6[1];

    vm.vaults = allVaults.filter(function (v) {
      return v.product === metal;
    });
    if (!vm.vaults.find(function (v) {
      return v.vault === vm.model.vault;
    })) {
      vm.model.vault = undefined;
    }
  }

  function isCurrencySelected() {
    return !!vm.model.currency;
  }

  function lockPrice() {
    vm.lockError = null;
    var amount = vm.model.fiatAmount.amount ? vm.model.fiatAmount : vm.model.metalAmount;
    return HoldingMetals.lockBuyPrice(vm.model.metal, vm.model.currency, vm.model.vault, amount).then(function (locked) {
      vm.locked = locked;
      vm.lockedExpiration = (0, _moment2.default)().add(locked.validFor, 'seconds');
      $timeout(function () {
        vm.expired = true;
      }, locked.validFor * 1000);
      vm.expired = false;
    }).catch(function (_ref7) {
      var message = _ref7.message;

      vm.lockError = message;
      return $q.reject();
    });
  }

  function placeOrder() {
    vm.orderError = null;
    var amount = vm.model.fiatAmount.amount ? vm.model.fiatAmount : vm.model.metalAmount;
    return HoldingMetals.placeBuyOrder(vm.model.metal, vm.model.currency, vm.model.vault, amount).then(function (data) {
      result.data = data;
      result.complete = true;
    }).catch(function (_ref8) {
      var message = _ref8.message;

      vm.orderError = message;
      return $q.reject();
    });
  }

  function selectBrinksZurich() {
    vm.model.vault = 'BRINKS_ZURICH';
  }

  function selectLoomisLondon() {
    vm.model.vault = 'VIAMAT_LONDON';
  }

  function updateRates(_ref9) {
    var _ref10 = _slicedToArray(_ref9, 5),
        product = _ref10[0],
        currency = _ref10[1],
        location = _ref10[2],
        fiatAmount = _ref10[3],
        metalAmount = _ref10[4];

    var amount = fiatAmount ? { currency: currency, amount: fiatAmount } : { currency: vm.model.metal, amount: metalAmount };
    vm.loadedRates = false;
    if (amount.amount && product && currency && location) {
      HoldingMetals.getBuyRates(amount, product, currency, location).then(function (_ref11) {
        var spotRate = _ref11.rates.spotRate,
            tiers = _ref11.tiers,
            bonus = _ref11.bonus;

        vm.spotRate = {
          value: spotRate,
          quoteCurrency: vm.model.currency,
          baseCurrency: vm.model.metal
        };
        vm.rateBonus = bonus;
        vm.lastUpdated = (0, _moment2.default)();
        vm.loadedRates = true;

        tiers.forEach(function (tier, index) {
          if (index + 1 < tiers.length) {
            tier.end = tiers[index + 1].start - 1;
          }
        });
        vm.tiers = tiers;
      }).catch(function (_ref12) {
        var message = _ref12.message;

        vm.ratesError = message;
      });
    }
  }

  function updateTier(_ref13) {
    var _ref14 = _slicedToArray(_ref13, 3),
        tiers = _ref14[0],
        amount = _ref14[1],
        metalAmount = _ref14[2];

    if (tiers && (amount || metalAmount)) {
      vm.tier = tiers.reduce(function (prev, curr) {
        if (amount && amount > curr.start) {
          return curr;
        }
        if (metalAmount && metalAmount * curr.fee.rate > curr.start) {
          return curr;
        }

        return prev;
      }, { start: -1, fee: { rate: 0 } });
    }
  }

  function updateTotal(_ref15) {
    var _ref16 = _slicedToArray(_ref15, 4),
        tier = _ref16[0],
        rate = _ref16[1],
        amount = _ref16[2],
        metalAmount = _ref16[3];

    if (tier && rate && (amount || metalAmount)) {
      var actualRate = rate * (1 + tier.fee.rate / 100);
      vm.overallRate = {
        value: actualRate,
        quoteCurrency: vm.model.currency,
        baseCurrency: vm.model.metal
      };
      if (amount) {
        vm.sellAmount = {
          amount: amount,
          currency: model.currency
        };
        vm.buyAmount = {
          amount: amount / actualRate,
          currency: model.metal
        };
      } else {
        vm.sellAmount = {
          amount: metalAmount * actualRate,
          currency: model.currency
        };
        vm.buyAmount = {
          amount: metalAmount,
          currency: model.metal
        };
      }
    }
  }

  activate();

  $scope.$watchGroup(['buyMetalCtrl.model.metal', 'buyMetalCtrl.allVaults'], filterVaults);

  $scope.$watch('buyMetalCtrl.buyMaxFiatAmount', function (buyMaxFiatAmount) {
    if (buyMaxFiatAmount) {
      vm.model.fiatAmount.amount = vm.maxFiatAmount.amount;
    }
  });

  $scope.$watch('buyMetalCtrl.model.currency', function (currency) {
    clearFiat();
    clearMetal();
    clearBuyMaxFiat();
    vm.model.fiatAmount.currency = currency;
    vm.maxFiatAmount = vm.maxFiatAmounts[currency];
  });
  $scope.$watch('buyMetalCtrl.model.metal', function (metal) {
    clearFiat();
    clearMetal();
    clearBuyMaxFiat();
    vm.model.metalAmount.currency = metal;
    vm.maxMetalAmount = vm.maxMetalAmounts[metal];
  });

  $scope.$watchGroup(['buyMetalCtrl.model.metal', 'buyMetalCtrl.model.currency', 'buyMetalCtrl.model.vault', 'buyMetalCtrl.model.fiatAmount.amount', 'buyMetalCtrl.model.metalAmount.amount'], updateRates);

  $scope.$watchGroup(['buyMetalCtrl.tiers', 'buyMetalCtrl.model.fiatAmount.amount', 'buyMetalCtrl.model.metalAmount.amount'], updateTier);

  $scope.$watchGroup(['buyMetalCtrl.tier', 'buyMetalCtrl.spotRate.value', 'buyMetalCtrl.model.fiatAmount.amount', 'buyMetalCtrl.model.metalAmount.amount'], updateTotal);
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(671);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.buy.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Buy Metal - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "<gmw-order-complete-header order-number=\"{{::buyMetalCtrl.result.data.orderNo}}\"></gmw-order-complete-header> <div class=gmw-flow-box-container> <div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Metal'|translate\"> </span> <span class=gmw-to-and-from__data> <holding-metal-badge metal=buyMetalCtrl.model.metal></holding-metal-badge> <span ng-bind=buyMetalCtrl.result.data.buy.currency|translate></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Buy Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=buyMetalCtrl.result.data.sell|holdingFormatFunds> </span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col ng-if=buyMetalCtrl.locked.rateLocked> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\" ng-if=buyMetalCtrl.result.data.buy|gmwIsInGrams> <span class=gmw-to-and-from__label> <span ng-bind=\"'Will Receive'|translate\"></span> (<span ng-bind=::buyMetalCtrl.result.data.buy.currency|holdingCurrencySymbol></span>) </span> <span class=gmw-to-and-from__data ng-bind=::buyMetalCtrl.result.data.buy|gmwFormatProduct> </span> <span class=gmw-to-and-from__label> <span ng-bind=\"'Will Receive (oz)'|translate\"></span> </span> <span class=gmw-to-and-from__data ng-bind=\"::buyMetalCtrl.result.data.buy|gmwFormatProduct:'oz'\"> </span> </div> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--single gmw-to-and-from__box--small\" ng-if=!(buyMetalCtrl.result.data.buy|gmwIsInGrams)> <span class=gmw-to-and-from__label> <span ng-bind=\"'Will Receive (oz)'|translate\"></span> </span> <span class=gmw-to-and-from__data ng-bind=::buyMetalCtrl.result.data.buy|gmwFormatProduct> </span> </div> </div> <div class=gmw-to-and-from__col ng-if=!buyMetalCtrl.locked.rateLocked> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\" ng-if=buyMetalCtrl.result.data.buy|gmwIsInGrams> <span class=gmw-to-and-from__label> <span ng-bind=\"'Approximate Amount'|translate\"></span> (<span ng-bind=::buyMetalCtrl.result.data.buy.currency|holdingCurrencySymbol></span>) </span> <span class=gmw-to-and-from__data ng-bind=::buyMetalCtrl.result.data.buy|gmwFormatProduct> </span> <span class=gmw-to-and-from__label> <span ng-bind=\"'Approximate Amount (oz)'|translate\"></span> </span> <span class=gmw-to-and-from__data ng-bind=\"::buyMetalCtrl.result.data.buy|gmwFormatProduct:'oz'\"> </span> </div> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--single gmw-to-and-from__box--small\" ng-if=!(buyMetalCtrl.result.data.buy|gmwIsInGrams)> <span class=gmw-to-and-from__label> <span ng-bind=\"'Approximate Amount (oz)'|translate\"></span> </span> <span class=gmw-to-and-from__data ng-bind=::buyMetalCtrl.result.data.buy|gmwFormatProduct> </span> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Vault'|translate}}\"> <gmw-flag country=::buyMetalCtrl.result.data.location|holdingVaultCountryCode></gmw-flag> <span ng-bind=::buyMetalCtrl.result.data.location|holdingVaultCustodian></span> <span ng-bind=::buyMetalCtrl.result.data.location|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Buy Price'|translate}}\"> <span ng-bind-html=\"::buyMetalCtrl.result.data.rateAskPrice|gmwFormatProductRate:'oz'\"></span> <span ng-if=buyMetalCtrl.result.data.buy|gmwIsInGrams> (<span ng-bind-html=\"::buyMetalCtrl.result.data.rateAskPrice|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Fee'|translate}}\"> <span ng-bind=::buyMetalCtrl.result.data.rateFeePercentage></span>% </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Overall Rate'|translate}}\"> <span ng-bind-html=\"::buyMetalCtrl.result.data.ratePrice|gmwFormatProductRate:'oz'\"></span> <span ng-if=::buyMetalCtrl.result.data.buy|gmwIsInGrams> (<span ng-bind-html=\"::buyMetalCtrl.result.data.ratePrice|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row ng-if=::buyMetalCtrl.result.data.bonus label=\"{{'Bonus'|translate}}\"> <span class=h-green-text> <span ng-bind=\"::buyMetalCtrl.result.data.bonus|gmwFormatProduct:'oz'\"></span> <span ng-if=::buyMetalCtrl.result.data.bonus.currency|gmwIsInGrams> (<span ng-bind=\"::buyMetalCtrl.result.data.bonus|gmwFormatProduct:'g'\"></span>) </span> </span> </gmw-recap-table-row> </div> </div> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=buyMetalCtrl.cancel() on-next=buyMetalCtrl.next()> <button gmw-print class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-bind=\"'Print Order'|translate\"> </button> </holding-flow-controls> </footer> ";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _amount = __webpack_require__(673);

var _amount2 = _interopRequireDefault(_amount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.buy.amount', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Buy Metal - Select Metal & Amount'
    },
    url: '/amount',
    views: {
      step: {
        template: _amount2.default
      }
    }
  });
}]);

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> <span ng-bind=\"'Please select the precious metal and amount that you would like to purchase below.'|translate\"> </span></p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=buyMetalCtrl.form> <div ng-show=buyMetalCtrl.form.$invalid ng-messages=buyMetalCtrl.form.$error> <div ng-message=noFunds> <holding-alert-legacy class=warning> <span ng-bind=\"'You do not have any funds available to buy metal'|translate\"></span>. </holding-alert-legacy> </div> </div> <holding-alert class=info ng-if=\"!buyMetalCtrl.form.$error.noFunds && buyMetalCtrl.showPromotionBanner && !buyMetalCtrl.form.$submitted\" title=\"Please Note\"> <main> <span ng-bind=\"'Our current one-time'|translate\"></span> <span ng-bind=\"buyMetalCtrl.promoCode.rate * 100 + '%'\"></span> <span ng-bind=\"'purchase bonus on'|translate\"></span> <span ng-bind=buyMetalCtrl.promoCode.product|lowercase></span> <span ng-bind=\"'is only available for purchases of at least'|translate\"></span> <span ng-bind=\"buyMetalCtrl.promoCode.minProductAmountOpt + (buyMetalCtrl.promoCode.product == 'Silver' ? 'oz' : 'g')\"></span>. </main> <cta> <a ng-click=buyMetalCtrl.buyPromoMinimum()> <span ng-bind=\"'Buy'|translate\"></span> <span ng-bind=\"buyMetalCtrl.promoCode.minProductAmountOpt + (buyMetalCtrl.promoCode.product == 'Silver' ? 'oz' : 'g')\"></span> <span ng-bind=\"'of'|translate\"></span> <span ng-bind=buyMetalCtrl.promoCode.product></span> <span ng-bind=\"'now'|translate\"></span> </a> </cta> </holding-alert> <holding-metal-toggle class=\"desktop-only desktop-only--xs\" label=\"{{'Select Metal'|translate}}\" ng-model=buyMetalCtrl.model.metal metals=buyMetalCtrl.metals> </holding-metal-toggle> <gmw-box-selector required name=metals class=\"gmw-input-container mobile-only mobile-only--xs\" ng-model=buyMetalCtrl.model.metal options=buyMetalCtrl.selectorMetals label=\"{{'Select Metal'|translate}}\"> </gmw-box-selector> <div class=gmw-input-container> <gmw-box-selector required name=currency class=gmw-input-container ng-model=buyMetalCtrl.model.currency options=buyMetalCtrl.currencies label=\"{{'Select Currency to Use'|translate}}\"> </gmw-box-selector> </div> <div ng-show=\"buyMetalCtrl.form.fiatAmount.$dirty && buyMetalCtrl.form.fiatAmount.$invalid\" ng-messages=buyMetalCtrl.form.fiatAmount.$error> <div ng-message=max> <holding-alert-legacy class=error> <span> <span ng-bind=\"'The maximum buy amount for'|translate\"></span> <span ng-bind=buyMetalCtrl.model.currency></span> <span ng-bind=\"'is'|translate\"></span> <span ng-bind=buyMetalCtrl.maxFiatAmount|holdingFormatFunds></span>. </span> </holding-alert-legacy> </div> </div> <div ng-show=\"buyMetalCtrl.form.metalAmount.$dirty && buyMetalCtrl.form.metalAmount.$invalid\" ng-messages=buyMetalCtrl.form.metalAmount.$error> <div ng-message=max> <holding-alert-legacy class=error> <span> <span ng-bind=\"'The maximum buy amount for'|translate\"></span> <span ng-bind=buyMetalCtrl.maxMetalAmount|holdingCurrencyName></span> <span ng-bind=\"'is'|translate\"></span> <span ng-bind=buyMetalCtrl.maxMetalAmount|gmwFormatProduct></span>. </span> </holding-alert-legacy> </div> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input name=fiatAmount type=number currency=\"{{buyMetalCtrl.model.fiatAmount.currency}}\" ng-required=!(buyMetalCtrl.model.metalAmount.amount) class=gmw-input-container--split-half__col has-error=\"buyMetalCtrl.form.fiatAmount.$dirty && buyMetalCtrl.form.fiatAmount.$invalid\" ng-model=buyMetalCtrl.model.fiatAmount.amount ng-model-options=\"{\n        debounce: 400,\n      }\" change=buyMetalCtrl.clearMetal() label=\"{{'Enter Amount to Buy'|translate}}\" max=buyMetalCtrl.maxFiatAmount.amount placeholder=0.00> <gmw-box-input-meta-left> {{buyMetalCtrl.model.fiatAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> <span class=\"gmw-input-container--split-half__or heading-h5\" ng-bind=\"'OR'|translate\"></span> <gmw-box-input name=metalAmount type=number currency=\"{{buyMetalCtrl.model.metal}}\" ng-required=!(buyMetalCtrl.model.fiatAmount.amount) class=gmw-input-container--split-half__col has-error=\"buyMetalCtrl.form.metalAmount.$dirty && buyMetalCtrl.form.metalAmount.$invalid\" ng-model=buyMetalCtrl.model.metalAmount.amount ng-model-options=\"{\n        debounce: 400,\n      }\" change=buyMetalCtrl.clearFiat() max=buyMetalCtrl.maxMetalAmount.amount placeholder=0.000> <gmw-box-input-meta-right> {{buyMetalCtrl.model.metal|holdingCurrencySymbol}} </gmw-box-input-meta-right> </gmw-box-input> </div> <div class=gmw-flow-box__callout ng-if=buyMetalCtrl.isCurrencySelected()> <p class=gmw-flow-box__callout-block> <gmw-checkbox ng-model=buyMetalCtrl.buyMaxFiatAmount> <span translate> <span ng-bind=\"'Buy the maximum amount of'|translate\"></span> <span ng-bind=buyMetalCtrl.model.metal></span> <span ng-bind=\"'-'|translate\"></span> <span class=h-dark-text ng-bind=buyMetalCtrl.maxFiatAmount|holdingFormatFunds></span>. </span> </gmw-checkbox> </p> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=buyMetalCtrl.cancel() on-next=buyMetalCtrl.next() step-disabled=\"buyMetalCtrl.form.$invalid || buyMetalCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(675);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.buy.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Buy Metal - Review Purchase Details'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Please review your purchase request below to ensure that you are satisfied with the details.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=buyMetalCtrl.form> <div class=\"gmw-flow-box__callout h-default-text\" ng-if=!buyMetalCtrl.expired> <span class=h-center-text> <span ng-bind=\"'The rates shown will expire in'|translate\"></span> <span class=h-dark-text gmw-remaining-time=buyMetalCtrl.lockedExpiration></span> </span> </div> <holding-alert ng-if=buyMetalCtrl.expired class=warning title=\"{{'Rates Expired'|translate}}\"> <main> <span ng-bind=\"'The locked metal price rates have expired.'|translate\"> </span> </main> <cta> <a ng-click=buyMetalCtrl.refresh() ng-bind=\"'Refresh Locked Rates'|translate\"> </a> </cta> </holding-alert> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Metal'|translate}}\"> <holding-metal-badge metal=buyMetalCtrl.model.metal></holding-metal-badge> <span ng-bind=buyMetalCtrl.model.metal></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault'|translate}}\"> <gmw-flag country=buyMetalCtrl.model.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=buyMetalCtrl.model.vault|holdingVaultCustodian></span> <span ng-bind=buyMetalCtrl.model.vault|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Amount'|translate}}\"> <span ng-bind=buyMetalCtrl.locked.sell|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Buy Price'|translate}}\"> <span ng-bind-html=\"buyMetalCtrl.locked.rateAskPrice|gmwFormatProductRate:'oz'\"></span> <span ng-if=buyMetalCtrl.locked.buy|gmwIsInGrams> (<span ng-bind-html=\"buyMetalCtrl.locked.rateAskPrice|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Fee'|translate}}\"> <span ng-bind=\"buyMetalCtrl.locked.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Overall Rate'|translate}}\"> <span ng-bind-html=\"buyMetalCtrl.locked.ratePrice|gmwFormatProductRate:'oz'\"></span> <span ng-if=buyMetalCtrl.model.metal|gmwIsInGrams> (<span ng-bind-html=\"buyMetalCtrl.locked.ratePrice|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'You Will Receive'|translate}}\" ng-if=buyMetalCtrl.locked.rateLocked> <span class=h-green-text> <span ng-bind=\"buyMetalCtrl.locked.buy|gmwFormatProduct:'oz'\"></span> <span ng-if=buyMetalCtrl.model.metal|gmwIsInGrams ng-bind=\"buyMetalCtrl.locked.buy|gmwFormatProduct:'g'\"> </span> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Approximate Amount'|translate}}\" ng-if=!buyMetalCtrl.locked.rateLocked> <span class=h-green-text> <span ng-bind=\"buyMetalCtrl.locked.buy|gmwFormatProduct:'oz'\"></span> <span ng-if=buyMetalCtrl.model.metal|gmwIsInGrams ng-bind=\"buyMetalCtrl.locked.buy|gmwFormatProduct:'g'\"> </span> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Bonus'|translate}}\" ng-if=buyMetalCtrl.locked.bonus> <span class=h-green-text> <span ng-bind=\"buyMetalCtrl.locked.bonus|gmwFormatProduct:'oz'\"></span> <span ng-if=buyMetalCtrl.model.metal|gmwIsInGrams> (<span ng-bind=\"buyMetalCtrl.locked.bonus|gmwFormatProduct:'g'\"></span>) </span> </span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <p class=h-margin-bottom-20> <span ng-bind=\"'Carefully review your order information. Once'|translate\"></span> <span class=h-dark-text ng-bind=\"'Place Order'|translate\"></span> <span ng-bind=\"'is clicked, your order will be executed and cannot be modified or cancelled'|translate\"></span>. </p> <p class=h-margin-bottom-20 ng-if=!buyMetalCtrl.locked.rateLocked> <span ng-bind=\"'The final overall rate for this order will be based on the applicable Goldmoney'|translate\"></span> <a href class=h-blue-link holding-external-link=support.buy.fixed ng-bind=\"'Fixed Buy Price'|translate\"></a> <span ng-bind=\"'on'|translate\"></span> <span ng-bind=buyMetalCtrl.locked.rateLockTime|gmwFormatDate></span>. <span ng-bind=\"'Your order will be completed by'|translate\"></span> <span ng-bind=buyMetalCtrl.locked.orderCompletionTime|gmwFormatDate></span>. </p> <gmw-checkbox class=h-margin-bottom-20 ng-if=!buyMetalCtrl.locked.rateLocked ng-model=buyMetalCtrl.lockDisclaimer required> <span class=\"h-dark-text h-medium-text h-bold-text\" translate> <span ng-bind=\"'Please check to confirm you understand that the amounts above are indicative only and that the final overall rate charged will be based on the applicable Goldmoney'|translate\"></span> <a href class=h-blue-link holding-external-link=support.buy.fixed ng-bind=\"'Fixed Buy Price'|translate\"></a>. </span> </gmw-checkbox> <gmw-checkbox ng-model=buyModelCtrl.terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I accept the terms of the'|translate\"></span> <a ng-if=\"buyMetalCtrl.user.regulation == 'Toronto'\" class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Goldmoney Client Agreement'|translate\"></a> <a ng-if=\"buyMetalCtrl.user.regulation == 'UK'\" class=h-blue-link holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Goldmoney Client Agreement'|translate\"></a>. </span> </gmw-checkbox> </div> <holding-alert-legacy class=error ng-if=buyMetalCtrl.orderError> <span ng-bind=buyMetalCtrl.orderError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls ng-if=!buyMetalCtrl.expired on-cancel=buyMetalCtrl.cancel() on-next=buyMetalCtrl.next() step-disabled=\"buyMetalCtrl.form.$invalid || buyMetalCtrl.form.$submitted\"> </holding-flow-controls> <div class=gmw-flow-box-footer__col ng-if=buyMetalCtrl.expired> <button ng-click=buyMetalCtrl.refresh() class=\"medium-main-cta gmw-responsive-button\" ng-bind=\"'Refresh Locked Rates'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vault = __webpack_require__(677);

var _vault2 = _interopRequireDefault(_vault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.buy.vault', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Buy Metal - Select Storage Vault'
    },
    url: '/vault',
    views: {
      step: {
        template: _vault2.default
      }
    }
  });
}]);

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> <span ng-bind=\"'Your precious metal will be stored in the vault you select from the options below. Please note that our storage fees and metal prices can vary by vault.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=buyMetalCtrl.form> <holding-alert-legacy class=info> <span> <span ng-bind=\"'Please note that due to the COVID-19 pandemic and strains on the precious metal supply chain, we have temporarily reduced the number of vaults that certain metals can be purchased and stored in.'|translate\"></span> </span> </holding-alert-legacy> <holding-buy-vault-selector required label=\"{{'Select Vault'|translate}}\" vaults=buyMetalCtrl.vaults ng-model=buyMetalCtrl.model.vault small> </holding-buy-vault-selector> <div ng-if=buyMetalCtrl.ratesError> <holding-alert-legacy class=error> <span ng-bind=buyMetalCtrl.ratesError></span> </holding-alert-legacy> </div> <div ng-if=buyMetalCtrl.loadedRates> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Buy Summary'|translate\"></span> <p class=gmw-flow-box__description> <span ng-bind=\"'The below rates are provisional. You will be provided with a final rate prior to making your purchase.'|translate\"></span> </p> </div> <gmw-fee-tiers ng-if=buyMetalCtrl.loadedRates currency=buyMetalCtrl.model.currency product=buyMetalCtrl.model.metal tiers=buyMetalCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=buyMetalCtrl.loadedRates currency=buyMetalCtrl.model.currency product=buyMetalCtrl.model.metal tiers=buyMetalCtrl.tiers> </gmw-fee-tiers-mobile> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\" ng-if=buyMetalCtrl.loadedRates> <gmw-recap-table-header label=\"{{'Your Provisional Rate'|translate}}\" highlight=true> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Metal'|translate}}\"> <holding-metal-badge metal=buyMetalCtrl.model.metal></holding-metal-badge> <span ng-bind=buyMetalCtrl.model.metal></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault'|translate}}\"> <gmw-flag country=buyMetalCtrl.model.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=buyMetalCtrl.model.vault|holdingVaultCustodian></span> <span ng-bind=buyMetalCtrl.model.vault|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Amount'|translate}}\"> <span ng-bind=buyMetalCtrl.sellAmount|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Buy Price'|translate}}\"> <span ng-bind-html=\"buyMetalCtrl.spotRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=buyMetalCtrl.spotRate|gmwIsInGrams> (<span ng-bind-html=\"buyMetalCtrl.spotRate|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Buy Fee'|translate}}\"> <span ng-bind=buyMetalCtrl.tier.fee.rate></span>% </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Overall Rate'|translate}}\"> <span ng-bind-html=\"buyMetalCtrl.overallRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=buyMetalCtrl.overallRate|gmwIsInGrams> (<span ng-bind-html=\"buyMetalCtrl.overallRate|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'You Will Receive'|translate}}\"> <span class=h-green-text> <span ng-bind=\"buyMetalCtrl.buyAmount|gmwFormatProduct:'oz'\"></span> <span ng-if=buyMetalCtrl.buyAmount|gmwIsInGrams ng-bind=buyMetalCtrl.buyAmount|gmwFormatProduct> </span> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Bonus'|translate}}\" ng-if=buyMetalCtrl.rateBonus> <span class=h-green-text> <span ng-bind=\"buyMetalCtrl.rateBonus|gmwFormatProduct:'oz'\"></span> <span ng-if=buyMetalCtrl.model.metal|gmwIsInGrams> (<span ng-bind=\"buyMetalCtrl.rateBonus|gmwFormatProduct:'g'\"></span>) </span> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Price Last Updated'|translate}}\"> <span ng-bind=buyMetalCtrl.lastUpdated|gmwFormatDateTime></span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <span> <span ng-bind=\"'Please review your order on the next page. You will have one minute to place your order and confirm acceptance of our'|translate\"></span> <a href class=h-blue-link ng-if=\"buyMetalCtrl.user.regulation == 'Toronto'\" holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Client Agreement'|translate\"></a> <a href class=h-blue-link ng-if=\"buyMetalCtrl.user.regulation == 'UK'\" holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Client Agreement'|translate\"></a> <span ng-bind=\"'on the following page before rates expire, so we suggest you read it now before clicking'|translate\"></span> <span class=h-dark-text ng-bind=\"'Next Step'|translate\"></span>. </span> </div> <holding-alert-legacy class=error ng-if=buyMetalCtrl.lockError> <span ng-bind=buyMetalCtrl.lockError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=buyMetalCtrl.cancel() on-next=buyMetalCtrl.next() step-disabled=\"buyMetalCtrl.form.$invalid || buyMetalCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _exchangeFlow = __webpack_require__(679);

var _exchangeFlow2 = _interopRequireDefault(_exchangeFlow);

var _exchange = __webpack_require__(680);

var _exchange2 = _interopRequireDefault(_exchange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.exchange', {
    data: {
      flow: _exchangeFlow2.default
    },
    params: {
      metal: {
        type: 'string',
        value: null
      },
      vault: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      SelectedMetalResolve: ['$q', '$stateParams', function SelectedMetalResolve($q, $stateParams) {
        'ngInject';

        return 'metal' in $stateParams ? $q.when($stateParams.metal) : $q.when();
      }],
      SelectedVaultResolve: ['$q', '$stateParams', function SelectedVaultResolve($q, $stateParams) {
        'ngInject';

        return 'vault' in $stateParams ? $q.when($stateParams.vault) : $q.when();
      }]
    },
    url: '/exchange',
    views: {
      'metals-main@holding.dashboard.metals': {
        controller: 'ExchangeMetalController',
        controllerAs: 'exchangeMetalCtrl',
        template: _exchange2.default
      }
    }
  });

  $urlRouterProvider.when('/metals/exchange', '/metals/exchange/sell');
}]).name;


__webpack_require__(681);
__webpack_require__(683);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(688);

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Exchange Metal'),
    cancel: {
        state: 'holding.dashboard.metals.exchange'
    },
    complete: {
        label: (0, _gettext2.default)('Return to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'metal',
        state: 'holding.dashboard.metals.exchange.sell',
        heading: (0, _gettext2.default)('Exchange One Metal to Another'),
        label: (0, _gettext2.default)('Select Metal to Exchange')
    }, {
        key: 'amount',
        state: 'holding.dashboard.metals.exchange.buy',
        heading: (0, _gettext2.default)('Select Metal to Buy in Exchange'),
        label: (0, _gettext2.default)('Select Metal to Buy')
    }, {
        key: 'review',
        state: 'holding.dashboard.metals.exchange.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Your Order'),
        label: (0, _gettext2.default)('Review'),
        controls: {
            next: (0, _gettext2.default)('Place Order')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.metals.exchange.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I exchange metals?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000516027> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How do I change vaults?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000679208> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buy = __webpack_require__(682);

var _buy2 = _interopRequireDefault(_buy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.exchange.buy', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Metal - Select Metal to Buy'
    },
    url: '/buy',
    views: {
      step: {
        template: _buy2.default
      }
    }
  });
}]).name;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span translate> Select the metal you wish to buy in exchange. All exchange orders are executed in USD. </span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=exchangeMetalCtrl.form> <holding-metal-toggle class=\"desktop-only desktop-only--xs\" label=\"{{'Select Metal'|translate}}\" ng-model=exchangeMetalCtrl.model.destinationMetal metals=exchangeMetalCtrl.metals> </holding-metal-toggle> <gmw-box-selector required name=metals class=\"gmw-input-container mobile-only mobile-only--xs\" ng-model=exchangeMetalCtrl.model.destinationMetal options=exchangeMetalCtrl.selectorMetals label=\"{{'Select Metal'|translate}}\"> </gmw-box-selector> <div class=\"gmw-input-container gmw-input-container--split-half\" ng-if=!exchangeMetalCtrl.sellAll> <gmw-box-input name=fiatAmount type=number currency=USD ng-required=!(exchangeMetalCtrl.model.metalAmount.amount) class=gmw-input-container--split-half__col has-error=\"exchangeMetalCtrl.form.fiatAmount.$dirty && exchangeMetalCtrl.form.fiatAmount.$invalid\" ng-model=exchangeMetalCtrl.model.fiatAmount.amount ng-model-options=\"{\n        debounce: 400,\n      }\" change=exchangeMetalCtrl.clearMetal() label=\"{{'Enter Amount'|translate}}\" placeholder=0.00> <gmw-box-input-meta-left> {{'USD'|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> <span class=\"gmw-input-container--split-half__or heading-h5\" ng-bind=\"'OR'|translate\"> </span> <gmw-box-input name=metalAmount type=number currency=\"{{exchangeMetalCtrl.model.metalAmount.currency}}\" ng-required=!(exchangeMetalCtrl.model.fiatAmount.amount) class=gmw-input-container--split-half__col has-error=\"exchangeMetalCtrl.form.metalAmount.$dirty && exchangeMetalCtrl.form.metalAmount.$invalid\" ng-model=exchangeMetalCtrl.model.metalAmount.amount ng-model-options=\"{\n        debounce: 400,\n      }\" change=exchangeMetalCtrl.clearFiat() placeholder=0.000> <gmw-box-input-meta-right> {{exchangeMetalCtrl.model.metalAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-right> </gmw-box-input> </div> <div class=gmw-flow-box__callout> <p class=gmw-flow-box__callout-block> <gmw-checkbox ng-model=exchangeMetalCtrl.sellAll> <span translate> Exchange all available {{exchangeMetalCtrl.model.source.totalSpendable|holdingCurrencyName|lowercase}} balance at {{exchangeMetalCtrl.model.source.vault|holdingVaultCustodian}} {{exchangeMetalCtrl.model.source.vault|holdingVaultLocation}} - <span class=h-dark-text>{{exchangeMetalCtrl.model.source.totalSpendable|gmwFormatProduct}}</span>. </span> </gmw-checkbox> </p> </div> <holding-alert-legacy class=error ng-if=exchangeMetalCtrl.rateError> <span ng-bind=exchangeMetalCtrl.rateError></span> </holding-alert-legacy> <holding-buy-vault-selector required label=\"{{'Select Vault'|translate}}\" vaults=exchangeMetalCtrl.destinations ng-model=exchangeMetalCtrl.model.destinationVault small> </holding-buy-vault-selector> <div ng-if=exchangeMetalCtrl.loadedRates> <span class=\"heading-h4 h-dark-text\" translate>Buy Summary</span> <p class=gmw-flow-box__description translate> The rates below are indicative and you will be provided with a final rate prior to making any purchase. </p> </div> <gmw-fee-tiers ng-if=\"exchangeMetalCtrl.loadedRates && exchangeMetalCtrl.isSellAll\" currency=exchangeMetalCtrl.model.currency product=exchangeMetalCtrl.model.metal tiers=exchangeMetalCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=\"exchangeMetalCtrl.loadedRates && exchangeMetalCtrl.isSellAll\" currency=exchangeMetalCtrl.model.currency product=exchangeMetalCtrl.model.metal tiers=exchangeMetalCtrl.tiers> </gmw-fee-tiers-mobile> <gmw-fee-tiers ng-if=exchangeMetalCtrl.loadedRates currency=exchangeMetalCtrl.model.currency product=exchangeMetalCtrl.model.destinationMetal tiers=exchangeMetalCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=exchangeMetalCtrl.loadedRates currency=exchangeMetalCtrl.model.currency product=exchangeMetalCtrl.model.destinationMetal tiers=exchangeMetalCtrl.tiers> </gmw-fee-tiers-mobile> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\" ng-if=exchangeMetalCtrl.loadedRates> <gmw-recap-table-header label=\"{{'Your Provisional Rate'|translate}}\" highlight=true> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Source Metal'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <holding-metal-badge metal=exchangeMetalCtrl.model.metal></holding-metal-badge> <span ng-bind=exchangeMetalCtrl.model.metal></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Source Vault'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=exchangeMetalCtrl.model.source.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=exchangeMetalCtrl.model.source.vault|holdingVaultCustodian></span> <span ng-bind=exchangeMetalCtrl.model.source.vault|holdingVaultLocation></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Exchange Amount'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=exchangeMetalCtrl.buyAmountFiat|gmwFormatAmount></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Goldmoney Sell Price'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind-html=\"exchangeMetalCtrl.sellSpotRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=exchangeMetalCtrl.sellSpotRate|gmwIsInGrams> (<span ng-bind-html=\"exchangeMetalCtrl.sellSpotRate|gmwFormatProductRate:'g'\"></span>) </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Destination Metal'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <holding-metal-badge metal=exchangeMetalCtrl.model.destinationMetal></holding-metal-badge> <span ng-bind=exchangeMetalCtrl.model.destinationMetal></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Destination Vault'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=exchangeMetalCtrl.model.destinationVault|holdingVaultCountryCode></gmw-flag> <span ng-bind=exchangeMetalCtrl.model.destinationVault|holdingVaultCustodian></span> <span ng-bind=exchangeMetalCtrl.model.destinationVault|holdingVaultLocation></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Goldmoney Buy Price'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind-html=\"exchangeMetalCtrl.buySpotRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=exchangeMetalCtrl.buySpotRate|gmwIsInGrams> (<span ng-bind-html=\"exchangeMetalCtrl.buySpotRate|gmwFormatProductRate:'g'\"></span>) </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Exchange Fee'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-if=exchangeMetalCtrl.tier> <span ng-bind=exchangeMetalCtrl.tier.fee.rate></span>% </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'You Will Receive'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span class=h-green-text> <span ng-bind=\"exchangeMetalCtrl.buyAmountMetal|gmwFormatProduct:'oz'\"></span> <span ng-if=exchangeMetalCtrl.buyAmountMetal|gmwIsInGrams> ({{exchangeMetalCtrl.buyAmountMetal|gmwFormatProduct:'g'}}) </span> </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Price Last Updated'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=exchangeMetalCtrl.lastUpdated|gmwFormatDateTime></span> </div> </div> </div> </div> <div class=gmw-flow-box__callout> <span ng-if=\"exchangeMetalCtrl.user.regulation == 'Toronto'\" translate> Please review your order on the following page. You will be asked to confirm your acceptance of our <a class=h-blue-link holding-external-link=clientAgreement.regulator.canada>Client Agreement</a>. As you will have only 1 minute to review and place your order after clicking <span class=h-dark-text>Next Step</span>, we suggest you read it now. </span> <span ng-if=\"exchangeMetalCtrl.user.regulation == 'UK'\" translate> Please review your order on the following page. You will be asked to confirm your acceptance of our <a class=h-blue-link holding-external-link=clientAgreement.regulator.uk>Client Agreement</a>. As you will have only 1 minute to review and place your order after clicking <span class=h-dark-text>Next Step</span>, we suggest you read it now. </span> </div> <holding-alert-legacy class=error ng-if=exchangeMetalCtrl.lockError> <span ng-bind=exchangeMetalCtrl.lockError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=exchangeMetalCtrl.cancel() on-next=exchangeMetalCtrl.next() step-disabled=\"exchangeMetalCtrl.form.$invalid || exchangeMetalCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _complete = __webpack_require__(684);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.exchange.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Metal - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]).name;

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "<gmw-order-complete-header order-number=\"{{::exchangeMetalCtrl.result.data.orderNo}}\"></gmw-order-complete-header> <div class=gmw-flow-box-container> <div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Exchanged Metal'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=exchangeMetalCtrl.result.data.exchangedAmount.currency> </span> <span class=gmw-to-and-from__label ng-bind=\"'Exchanged Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"exchangeMetalCtrl.result.data.exchangedAmount|gmwFormatProduct:'g'\"> </span> <span class=gmw-to-and-from__label ng-bind=\"'Ounces Equivalent'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"exchangeMetalCtrl.result.data.exchangedAmount|gmwFormatProduct:'oz'\"> </span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Destination Metal'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=exchangeMetalCtrl.result.data.buy.currency> </span> <span class=gmw-to-and-from__label ng-if=exchangeMetalCtrl.locked.rateLocked ng-bind=\"'Will Receive'|translate\"> </span> <span class=gmw-to-and-from__label ng-if=!exchangeMetalCtrl.locked.rateLocked ng-bind=\"'Approximate Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"exchangeMetalCtrl.result.data.buy|gmwFormatProduct:'g'\"> </span> <span class=gmw-to-and-from__label ng-bind=\"'Ounces Equivalent'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"exchangeMetalCtrl.result.data.buy|gmwFormatProduct:'oz'\"> </span> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'USD Equivalent'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=::exchangeMetalCtrl.result.data.exchangedFiatAmount|holdingFormatFunds></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=exchangeMetalCtrl.result.data.exchangedAmount|gmwIsInGrams> <div class=gmw-recap-table__col> <span> <span ng-bind=\"'Overall Sell Rate'|translate\"></span> (<span ng-bind=::exchangeMetalCtrl.result.data.exchangedAmount.currency|holdingCurrencySymbol></span>) </span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind-html=::exchangeMetalCtrl.result.data.sellRatePrice|gmwFormatProductRate></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Overall Sell Rate (oz)'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind-html=\"::exchangeMetalCtrl.result.data.sellRatePrice|gmwFormatProductRate:'oz'\"></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=exchangeMetalCtrl.result.data.buy|gmwIsInGrams> <div class=gmw-recap-table__col> <span> <span ng-bind=\"'Overall Buy Rate'|translate\"></span> (<span ng-bind=::exchangeMetalCtrl.result.data.buy.currency|holdingCurrencySymbol></span>) </span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind-html=::exchangeMetalCtrl.result.data.buyRatePrice|gmwFormatProductRate></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Overall Buy Rate (oz)'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind-html=\"::exchangeMetalCtrl.result.data.buyRatePrice|gmwFormatProductRate:'oz'\"></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Buy Fee'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=::exchangeMetalCtrl.result.data.rateFeePercentage></span>% </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Origin'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=::exchangeMetalCtrl.result.data.exchangedLocation|holdingVaultCountryCode></gmw-flag> <span ng-bind=::exchangeMetalCtrl.result.data.exchangedLocation|holdingVaultCustodian></span> <span ng-bind=::exchangeMetalCtrl.result.data.exchangedLocation|holdingVaultLocation></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Destination'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <gmw-flag country=::exchangeMetalCtrl.result.data.buyLocation|holdingVaultCountryCode></gmw-flag> <span ng-bind=::exchangeMetalCtrl.result.data.buyLocation|holdingVaultCustodian></span> <span ng-bind=::exchangeMetalCtrl.result.data.buyLocation|holdingVaultLocation></span> </span> </div> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=exchangeMetalCtrl.cancel() on-next=exchangeMetalCtrl.next()> <button gmw-print class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-bind=\"'Print Order'|translate\"> </button> </holding-flow-controls> </footer> ";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ExchangeMetalController.$inject = ['$controller', '$q', '$scope', '$state', '$timeout', 'HoldingMetals', 'HoldingUser', 'SelectedMetalResolve', 'SelectedVaultResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').controller('ExchangeMetalController', ExchangeMetalController);

function ExchangeMetalController($controller, $q, $scope, $state, $timeout, HoldingMetals, HoldingUser, SelectedMetalResolve, SelectedVaultResolve) {
  'ngInject';

  var vm = this;
  var model = {
    currency: 'USD',
    fiatAmount: {
      currency: 'USD'
    },
    metalAmount: {}
  };
  var result = {};

  vm.steps = {
    'holding.dashboard.metals.exchange.sell': {
      checks: []
    },
    'holding.dashboard.metals.exchange.buy': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.metals.exchange.sell'
      }],
      next: lockPrice
    },
    'holding.dashboard.metals.exchange.review': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.metals.exchange.sell'
      }, {
        function: checkAmount,
        revertTo: 'holding.dashboard.metals.exchange.buy'
      }],
      next: placeOrder
    },
    'holding.dashboard.metals.exchange.complete': {
      checks: [{
        function: checkComplete,
        revertTo: 'holding.dashboard.metals.exchange.review'
      }]
    }
  };

  vm.clearFiat = clearFiat;
  vm.clearMetal = clearMetal;
  vm.model = model;
  vm.refresh = lockPrice;
  vm.result = result;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    vm.user = HoldingUser.get();
    vm.equivalentCurrency = vm.user.currency;

    vm.metals = HoldingMetals.getMetals();
    vm.selectorMetals = vm.metals.map(function (metal) {
      return {
        label: metal,
        value: metal
      };
    });
    vm.model.destinationMetal = vm.metals[0];

    HoldingMetals.getExchangeSources().then(function (sources) {
      vm.sources = sources;

      if (SelectedMetalResolve && SelectedVaultResolve) {
        vm.model.source = vm.sources.find(function (source) {
          return source.vault === SelectedVaultResolve && source.enabled && source.product === SelectedMetalResolve;
        });
      }
    }).catch(function (_ref) {
      var code = _ref.code;

      if (code === 'UNAUTHORIZED') {
        $state.go('holding.dashboard.overview', {}, {
          reload: true
        });
      }
    });
  }

  function checkAmount() {
    return !!(model.fiatAmount.amount || model.metalAmount.amount);
  }

  function checkComplete() {
    return !!result.complete;
  }

  function checkVault() {
    return !!vm.model.source;
  }

  function clearFiat() {
    vm.model.fiatAmount.amount = '';
    vm.sellAll = false;
  }

  function clearMetal() {
    vm.model.metalAmount.amount = '';
    vm.sellAll = false;
  }

  function lockPrice() {
    vm.lockError = null;
    var amount = model.fiatAmount.amount ? model.fiatAmount : model.metalAmount;
    return HoldingMetals.lockExchangePrice({
      vault: vm.model.source.vault,
      product: vm.model.metal
    }, vm.model.destinationVault, vm.model.destinationMetal, amount, vm.model.isSellAmount).then(function (locked) {
      vm.locked = locked;
      vm.lockedExpiration = (0, _moment2.default)().add(locked.validFor, 'seconds');
      $timeout(function () {
        vm.expired = true;
      }, locked.validFor * 1000);
      vm.expired = false;
    }).catch(function (_ref2) {
      var message = _ref2.message;

      vm.lockError = message;
      return $q.reject();
    });
  }

  function onDestinationMetalUpdated(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        destinationMetal = _ref4[0],
        sourceVault = _ref4[1];

    if (destinationMetal) {
      if (!vm.sellAll) {
        vm.model.metalAmount.currency = destinationMetal;
      }
      vm.model.destinationVault = null;
      vm.destinations = [];
      return HoldingMetals.getExchangeDestinations(destinationMetal).then(function (destinations) {
        vm.destinations = destinations.filter(function (destination) {
          return destination.vault !== sourceVault || destination.vault === sourceVault && destination.product !== vm.model.metal;
        });
      });
    }
  }

  function onSourceVaultUpdated(vault) {
    if (vault) {
      vm.model.metal = vm.sources.find(function (v) {
        return v === vault;
      }).product;
    }
  }

  function placeOrder() {
    vm.orderError = null;
    var amount = model.fiatAmount.amount ? model.fiatAmount : model.metalAmount;
    return HoldingMetals.placeExchangeOrder({
      vault: vm.model.source.vault,
      product: vm.model.metal
    }, vm.model.destinationVault, vm.model.destinationMetal, amount, vm.model.isSellAmount).then(function (data) {
      result.data = data;
      result.complete = true;
    }).catch(function (_ref5) {
      var message = _ref5.message;

      vm.orderError = message;
      return $q.reject();
    });
  }

  function resetLockError() {
    vm.lockError = null;
    vm.form.$submitted = false;
  }

  function resetRateError() {
    vm.rateError = null;
  }

  function updateRates(_ref6) {
    var _ref7 = _slicedToArray(_ref6, 7),
        sellLocation = _ref7[0],
        sellProduct = _ref7[1],
        buyLocation = _ref7[2],
        buyProduct = _ref7[3],
        fiatAmount = _ref7[4],
        metalAmount = _ref7[5],
        isSellAmount = _ref7[6];

    vm.loadedRates = false;

    var amount = fiatAmount ? vm.model.fiatAmount : vm.model.metalAmount;
    if (amount.amount && sellLocation && sellProduct && buyLocation && buyProduct) {
      resetLockError();
      resetRateError();
      HoldingMetals.getExchangeRates(amount, {
        vault: sellLocation,
        product: sellProduct
      }, buyLocation, buyProduct, isSellAmount).then(function (_ref8) {
        var buyRate = _ref8.buyRates.spotRate,
            sellRate = _ref8.sellRates.spotRate,
            tiers = _ref8.tiers;

        vm.buySpotRate = {
          value: buyRate,
          quoteCurrency: 'USD',
          baseCurrency: vm.model.destinationMetal
        };
        vm.sellSpotRate = {
          value: sellRate,
          quoteCurrency: 'USD',
          baseCurrency: vm.model.source.product
        };
        vm.lastUpdated = (0, _moment2.default)();
        vm.loadedRates = true;

        tiers.forEach(function (tier, index) {
          if (index + 1 < tiers.length) {
            tier.end = tiers[index + 1].start - 1;
          }
        });
        vm.tiers = tiers;
      }).catch(function (_ref9) {
        var message = _ref9.message;

        vm.rateError = message;
      });
    }
  }

  function updateSellAll(sellAll) {
    vm.model.isSellAmount = sellAll;
    if (sellAll) {
      vm.model.metalAmount = vm.model.source.totalSpendable;
      vm.model.fiatAmount.amount = undefined;
    } else {
      vm.model.metalAmount = {
        currency: vm.model.destinationMetal
      };
    }
  }

  function updateTier(_ref10) {
    var _ref11 = _slicedToArray(_ref10, 3),
        tiers = _ref11[0],
        amount = _ref11[1],
        metalAmount = _ref11[2];

    if (tiers && (amount || metalAmount)) {
      vm.tier = tiers.reduce(function (prev, curr) {
        if (amount && amount > curr.start) {
          return curr;
        }
        if (metalAmount && metalAmount * curr.fee.rate > curr.start) {
          return curr;
        }

        return prev;
      }, { start: -1, fee: { rate: 0 } });
    }
  }

  function updateTotal(_ref12) {
    var _ref13 = _slicedToArray(_ref12, 5),
        tier = _ref13[0],
        buyRate = _ref13[1],
        sellRate = _ref13[2],
        amount = _ref13[3],
        metalAmount = _ref13[4];

    if (tier && buyRate && (amount || metalAmount)) {
      var actualRate = buyRate * (1 + tier.fee.rate / 100);
      if (vm.model.isSellAmount) {
        vm.buyAmountFiat = {
          amount: metalAmount,
          currency: model.metal
        };
        vm.buyAmountMetal = {
          amount: metalAmount * sellRate / actualRate,
          currency: model.destinationMetal
        };
      } else if (amount) {
        vm.buyAmountFiat = {
          amount: amount,
          currency: model.fiatAmount.currency
        };
        vm.buyAmountMetal = {
          amount: amount / actualRate,
          currency: model.destinationMetal
        };
      } else {
        vm.buyAmountFiat = {
          amount: metalAmount * actualRate,
          currency: model.fiatAmount.currency
        };
        vm.buyAmountMetal = {
          amount: metalAmount,
          currency: model.destinationMetal
        };
      }
    }
  }

  activate();

  $scope.$watch('exchangeMetalCtrl.model.source', onSourceVaultUpdated);
  $scope.$watchGroup(['exchangeMetalCtrl.model.destinationMetal', 'exchangeMetalCtrl.model.source.vault'], onDestinationMetalUpdated);
  $scope.$watch('exchangeMetalCtrl.sellAll', updateSellAll);
  $scope.$watchGroup(['exchangeMetalCtrl.model.source.vault', 'exchangeMetalCtrl.model.metal', 'exchangeMetalCtrl.model.destinationVault', 'exchangeMetalCtrl.model.destinationMetal', 'exchangeMetalCtrl.model.fiatAmount.amount', 'exchangeMetalCtrl.model.metalAmount.amount', 'exchangeMetalCtrl.model.isSellAmount'], updateRates);
  $scope.$watchGroup(['exchangeMetalCtrl.tiers', 'exchangeMetalCtrl.model.fiatAmount.amount', 'exchangeMetalCtrl.model.metalAmount.amount'], updateTier);
  $scope.$watchGroup(['exchangeMetalCtrl.tier', 'exchangeMetalCtrl.buySpotRate.value', 'exchangeMetalCtrl.sellSpotRate.value', 'exchangeMetalCtrl.model.fiatAmount.amount', 'exchangeMetalCtrl.model.metalAmount.amount'], updateTotal);
}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _review = __webpack_require__(687);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.exchange.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Metal - Review Your Order'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]).name;

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container ng-form=exchangeMetalCtrl.form> <div class=\"gmw-flow-box__callout h-default-text\" ng-if=!exchangeMetalCtrl.expired> <span class=h-center-text> <span ng-bind=\"'The rates shown will expire in'|translate\"></span> <span class=h-dark-text gmw-remaining-time=exchangeMetalCtrl.lockedExpiration></span> </span> </div> <holding-alert ng-if=exchangeMetalCtrl.expired class=warning title=\"{{'Rates Expired'|translate}}\"> <main> <span ng-bind=\"'The locked metal price rates have expired.'|translate\"> </span> </main> <cta> <a ng-click=exchangeMetalCtrl.refresh() ng-bind=\"'Refresh Locked Rates'|translate\"> </a> </cta> </holding-alert> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <gmw-recap-table-header ng-if=exchangeMetalCtrl.locked.rateLocked label=\"{{'You Will Receive'|translate}}\"> </gmw-recap-table-header> <gmw-recap-table-header ng-if=!exchangeMetalCtrl.locked.rateLocked label=\"{{'Approximate Amount You Will Receive'|translate}}\"> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Amount'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=\"exchangeMetalCtrl.locked.buy|gmwFormatProduct:'g'\"></span> (<span ng-bind-html=\"exchangeMetalCtrl.locked.buyRatePrice|gmwFormatProductRate:'g'\"></span>) </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Ounce Equivalent'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=\"exchangeMetalCtrl.locked.buy|gmwFormatProduct:'oz'\"></span> (<span ng-bind-html=\"exchangeMetalCtrl.locked.buyRatePrice|gmwFormatProductRate:'oz'\"></span>) </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Metal'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=exchangeMetalCtrl.model.destinationMetal></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Vault'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=exchangeMetalCtrl.locked.buyLocation|holdingVaultCustodian></span> <span ng-bind=exchangeMetalCtrl.locked.buyLocation|holdingVaultLocation></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Metal Value'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span> <span class=h-green-text ng-bind-html=exchangeMetalCtrl.locked.exchangedFiatAmount|holdingFormatFunds></span> </span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Exchange Fee'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=exchangeMetalCtrl.locked.rateFeePercentage></span>% </span> </div> </div> </div> <gmw-recap-table-header label=\"{{'Exchange Amount'|translate}}\"></gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Exchange Amount'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=\"exchangeMetalCtrl.locked.exchangedAmount|gmwFormatProduct:'g'\"></span> (<span ng-bind-html=\"exchangeMetalCtrl.locked.sellRatePrice|gmwFormatProductRate:'g'\"></span>) </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Ounce Equivalent'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=\"exchangeMetalCtrl.locked.exchangedAmount|gmwFormatProduct:'oz'\"></span> (<span ng-bind-html=\"exchangeMetalCtrl.locked.sellRatePrice|gmwFormatProductRate:'oz'\"></span>) </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Metal'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=exchangeMetalCtrl.model.metal></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Vault'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=exchangeMetalCtrl.locked.exchangedLocation|holdingVaultCustodian></span> <span ng-bind=exchangeMetalCtrl.locked.exchangedLocation|holdingVaultLocation></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Metal Value'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span> <span class=h-green-text ng-bind-html=exchangeMetalCtrl.locked.exchangedFiatAmount|holdingFormatFunds></span> </span> </span> </div> </div> </div> </div> <div class=gmw-flow-box__callout> <p class=h-margin-bottom-20 translate> Please carefully review your order. When you click <span class=h-dark-text>Place Order</span>, your order will be executed and cannot be changed or cancelled. </p> <p class=h-margin-bottom-20 translate ng-if=!exchangeMetalCtrl.locked.rateLocked> The final overall rate for this order will be based on the applicable Goldmoney <a href class=h-blue-link holding-external-link=support.buy.fixed>Fixed Buy Price</a> on {{exchangeMetalCtrl.locked.rateLockTime|gmwFormatDate}}. Your order will be completed by {{exchangeMetalCtrl.locked.orderCompletionTime|gmwFormatDate}}. </p> <gmw-checkbox class=h-margin-bottom-20 ng-if=!exchangeMetalCtrl.locked.rateLocked ng-model=exchangeMetalCtrl.lockDisclaimer required> <span class=\"h-dark-text h-medium-text h-bold-text\" translate> Please check to confirm you understand that the amounts above are indicative only and that the final overall rate charged will be based on the applicable Goldmoney <a href class=h-blue-link holding-external-link=support.buy.fixed>Fixed Buy Price</a>. </span> </gmw-checkbox> <gmw-checkbox ng-model=buyModelCtrl.terms required> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"exchangeMetalCtrl.user.regulation == 'Toronto'\" translate> Please confirm you accept the terms of our <a href class=h-blue-link holding-external-link=clientAgreement.regulator.canada>Client Agreement</a> </span> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"exchangeMetalCtrl.user.regulation == 'UK'\" translate> Please confirm you accept the terms of our <a href class=h-blue-link holding-external-link=clientAgreement.regulator.uk>Client Agreement</a> </span> </gmw-checkbox> </div> <holding-alert-legacy class=error ng-if=exchangeMetalCtrl.orderError> <span ng-bind=exchangeMetalCtrl.orderError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls ng-if=!exchangeMetalCtrl.expired on-cancel=exchangeMetalCtrl.cancel() on-next=exchangeMetalCtrl.next() step-disabled=\"exchangeMetalCtrl.form.$invalid || exchangeMetalCtrl.form.$submitted\"> </holding-flow-controls> <div class=gmw-flow-box-footer__col ng-if=exchangeMetalCtrl.expired> <button ng-click=exchangeMetalCtrl.refresh() class=\"medium-main-cta gmw-responsive-button\" ng-bind=\"'Refresh Locked Rates'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sell = __webpack_require__(689);

var _sell2 = _interopRequireDefault(_sell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.exchange.sell', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Exchange Metal - Select Metal to Exchange'
    },
    url: '/sell',
    views: {
      step: {
        template: _sell2.default
      }
    }
  });
}]).name;

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> Our Metal Exchange tool allows you to exchange one precious metal to another type of metal at a discounted rate. You may exchange any amount of metal at the current applicable Goldmoney Buy and Sell Price, or the next Goldmoney <a href holding-external-link=support.buy.fixed class=h-blue-link>Fixed Buy and Sell Price</a> according to our <a href holding-external-link=support.buy.limits class=h-blue-link>Daily Trading Limits</a>. </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=exchangeMetalCtrl.form> <holding-sell-vault-selector required equivalent-currency=\"'USD'\" label=\"{{'Select Metal to Exchange'|translate}}\" description=\"{{'Select the metal to exchange. To exchange metal from multiple locations, you will need to repeat this process for each metal individually.'|translate}}\" vaults=exchangeMetalCtrl.sources ng-model=exchangeMetalCtrl.model.source> </holding-sell-vault-selector> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=exchangeMetalCtrl.cancel() on-next=exchangeMetalCtrl.next() step-disabled=\"exchangeMetalCtrl.form.$invalid || exchangeMetalCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sellFlow = __webpack_require__(691);

var _sellFlow2 = _interopRequireDefault(_sellFlow);

var _sell = __webpack_require__(692);

var _sell2 = _interopRequireDefault(_sell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.sell', {
    data: {
      flow: _sellFlow2.default
    },
    params: {
      metal: {
        type: 'string',
        value: null
      },
      vault: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      SelectedMetalResolve: ['$q', '$stateParams', function SelectedMetalResolve($q, $stateParams) {
        'ngInject';

        return 'metal' in $stateParams ? $q.when($stateParams.metal) : $q.when();
      }],
      SelectedVaultResolve: ['$q', '$stateParams', function SelectedVaultResolve($q, $stateParams) {
        'ngInject';

        return 'vault' in $stateParams ? $q.when($stateParams.vault) : $q.when();
      }]
    },
    url: '/sell',
    views: {
      'metals-main@holding.dashboard.metals': {
        controller: 'SellMetalController',
        controllerAs: 'sellMetalCtrl',
        template: _sell2.default
      }
    }
  });

  $urlRouterProvider.when('/metals/sell', '/metals/sell/vault');
}]).name;


__webpack_require__(693);
__webpack_require__(695);
__webpack_require__(697);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(702);

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Sell Metal'),
    cancel: {
        state: 'holding.dashboard.metals.sell'
    },
    complete: {
        label: (0, _gettext2.default)('Return to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'vault',
        state: 'holding.dashboard.metals.sell.vault',
        heading: (0, _gettext2.default)('Sell Metal'),
        label: (0, _gettext2.default)('Select Vault & Metal')
    }, {
        key: 'amount',
        state: 'holding.dashboard.metals.sell.amount',
        heading: (0, _gettext2.default)('Enter Proceeds Destination and Sale Amount'),
        label: (0, _gettext2.default)('Destination & Amount')
    }, {
        key: 'review',
        state: 'holding.dashboard.metals.sell.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Your Sell Order'),
        label: (0, _gettext2.default)('Review'),
        controls: {
            next: (0, _gettext2.default)('Place Order')
        }
    }, {
        key: 'withdraw',
        state: 'holding.dashboard.metals.sell.withdraw',
        cancel: true,
        disabled: true,
        heading: (0, _gettext2.default)('Withdraw Funds Order'),
        label: (0, _gettext2.default)('Withdraw Funds'),
        controls: {
            next: (0, _gettext2.default)('Place Order')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.metals.sell.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I sell metals?'|translate}}\" href=https://support.goldmoney.com/hc/sections/115004146247> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amount = __webpack_require__(694);

var _amount2 = _interopRequireDefault(_amount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.sell.amount', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Sell Metal - Select Destination & Amount'
    },
    url: '/amount',
    views: {
      step: {
        template: _amount2.default
      }
    }
  });
}]).name;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container ng-form=sellMetalCtrl.form> <div class=\"gmw-input-container gmw-input-container--split-half\" ng-class=\"{\n      'gmw-input-container--split-half': sellMetalCtrl.model.destination === 'holding',\n    }\"> <gmw-box-selector name=destination ng-class=\"{\n        'gmw-input-container--split-half__col': sellMetalCtrl.model.destination === 'holding',\n      }\" ng-model=sellMetalCtrl.model.destination options=sellMetalCtrl.destinations placeholder=\"{{'Holding'|translate}}\" label=\"{{'Select Destination'|translate}}\"> </gmw-box-selector> <gmw-box-selector ng-if=\"sellMetalCtrl.model.destination === 'holding'\" required name=currency class=gmw-input-container--split-half__col ng-model=sellMetalCtrl.model.currency options=sellMetalCtrl.currencies label=\"{{'Select Currency'|translate}}\"> </gmw-box-selector> </div> <holding-bank-account-selector required class=gmw-input-container ng-if=\"sellMetalCtrl.model.destination === 'bankAccount'\" ng-model=sellMetalCtrl.model.bankAccount accounts=sellMetalCtrl.banks> </holding-bank-account-selector> <holding-card-selector required class=gmw-input-container ng-if=\"sellMetalCtrl.model.destination === 'prepaidCard'\" ng-model=sellMetalCtrl.model.card cards=sellMetalCtrl.cards> </holding-card-selector> <div class=gmw-input-container ng-if=\"sellMetalCtrl.model.destination === 'bankAccount' && sellMetalCtrl.methods.length > 0\"> <gmw-box-selector required name=method ng-model=sellMetalCtrl.model.method options=sellMetalCtrl.methods label=\"{{'Select Transfer Method'|translate}}\"> </gmw-box-selector> <div class=gmw-input-container__tooltip> <a href class=tooltip-bottom ng-bind=\"'What transfer method should I use?'|translate\" gmw-tooltip=\"{{'Depending on the speed of the transfer required, select the appropriate transfer method. Any additional costs incurred will be reflected in the transfer fees.'|translate}}\"> </a> </div> </div> <div ng-show=\"sellMetalCtrl.form.fiatAmount.$dirty && sellMetalCtrl.form.fiatAmount.$invalid\" ng-messages=sellMetalCtrl.form.fiatAmount.$error> <div ng-message=min> <holding-alert-legacy class=error> <span translate> The minimum transfer amount is {{sellMetalCtrl.minFiat|holdingFormatFunds}} - please enter a larger amount. </span> </holding-alert-legacy> </div> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input name=fiatAmount type=number ng-required=!(sellMetalCtrl.model.metalAmount.amount) class=gmw-input-container--split-half__col ng-model=sellMetalCtrl.model.fiatAmount.amount ng-model-options=\"{\n        debounce: 400\n      }\" min=\"sellMetalCtrl.model.metalAmount.amount ? null : sellMetalCtrl.minFiat.amount\" change=sellMetalCtrl.clearMetal() label=\"{{'Enter Amount'|translate}}\" placeholder=0.00> <gmw-box-input-meta-left> {{sellMetalCtrl.model.fiatAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> <span class=\"gmw-input-container--split-half__or heading-h5\" ng-bind=\"'OR'|translate\"> </span> <gmw-box-input name=metalAmount ng-required=!(sellMetalCtrl.model.fiatAmount.amount) class=gmw-input-container--split-half__col ng-model=sellMetalCtrl.model.metalAmount.amount ng-model-options=\"{\n        debounce: 400\n      }\" change=sellMetalCtrl.clearFiat() placeholder=0.000> <gmw-box-input-meta-right> {{sellMetalCtrl.model.metal|holdingCurrencySymbol}} </gmw-box-input-meta-right> </gmw-box-input> </div> <div class=gmw-flow-box__callout> <gmw-checkbox ng-model=sellMetalCtrl.sellAll> <span translate> Sell your maximum available {{sellMetalCtrl.model.vault.totalSpendable|holdingCurrencyName|lowercase}} balance at {{sellMetalCtrl.model.vault.vault|holdingVaultCustodian}} {{sellMetalCtrl.model.vault.vault|holdingVaultLocation}} - <span class=h-dark-text>{{sellMetalCtrl.model.vault.totalSpendable|gmwFormatProduct}}</span>. </span> </gmw-checkbox> </div> <gmw-fee-tiers ng-if=sellMetalCtrl.loadedRates currency=sellMetalCtrl.model.currency product=sellMetalCtrl.model.metal tiers=sellMetalCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=sellMetalCtrl.loadedRates currency=sellMetalCtrl.model.currency product=sellMetalCtrl.model.metal tiers=sellMetalCtrl.tiers> </gmw-fee-tiers-mobile> <div class=\"gmw-recap-table gmw-recap-table--small-padding\" ng-if=sellMetalCtrl.loadedRates> <gmw-recap-table-header label=\"{{'Your Provisional Rate'|translate}}\" highlight=true> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Price Last Updated'|translate}}\"> {{sellMetalCtrl.lastUpdated|gmwFormatDateTime}} </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Metal'|translate}}\"> <holding-metal-badge metal=sellMetalCtrl.model.metal></holding-metal-badge> <span ng-bind=sellMetalCtrl.model.metal></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault'|translate}}\"> <gmw-flag country=sellMetalCtrl.model.vault.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=sellMetalCtrl.model.vault.vault|holdingVaultCustodian></span> <span ng-bind=sellMetalCtrl.model.vault.vault|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Sell Amount'|translate}}\"> <span ng-bind=\"sellMetalCtrl.sellAmount|gmwFormatProduct:'oz'\"></span> <span ng-if=sellMetalCtrl.sellAmount|gmwIsInGrams> (<span ng-bind=sellMetalCtrl.sellAmount|gmwFormatProduct></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Sell Price'|translate}}\"> <span ng-bind-html=\"sellMetalCtrl.spotRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=sellMetalCtrl.spotRate|gmwIsInGrams> (<span ng-bind-html=\"sellMetalCtrl.spotRate|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Sell Fee'|translate}}\"> {{sellMetalCtrl.tier.fee.rate}}% </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Overall Rate'|translate}}\"> <span ng-bind-html=\"sellMetalCtrl.overallRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=sellMetalCtrl.overallRate|gmwIsInGrams> (<span ng-bind-html=\"sellMetalCtrl.overallRate|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'You Will Receive'|translate}}\"> <span class=h-green-text ng-bind=sellMetalCtrl.buyAmount|holdingFormatFunds> </span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <span ng-if=\"sellMetalCtrl.user.regulation == 'Toronto'\" translate> Please review your order on the next page. You will have one minute to place your order and confirm acceptance of our <a class=h-blue-link holding-external-link=clientAgreement.regulator.canada>Client Agreement</a> on the following page before rates expire, so we suggest you read it now before clicking <span class=h-dark-text>Next Step</span>. </span> <span ng-if=\"sellMetalCtrl.user.regulation == 'UK'\" translate> Please review your order on the next page. You will have one minute to place your order and confirm acceptance of our <a class=h-blue-link holding-external-link=clientAgreement.regulator.uk>Client Agreement</a> on the following page before rates expire, so we suggest you read it now before clicking <span class=h-dark-text>Next Step</span>. </span> </div> <holding-alert-legacy class=error ng-if=sellMetalCtrl.lockError> <span ng-bind=sellMetalCtrl.lockError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=sellMetalCtrl.cancel() on-next=sellMetalCtrl.next() step-disabled=\"sellMetalCtrl.form.$invalid || sellMetalCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _complete = __webpack_require__(696);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.sell.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Sell Metal - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]).name;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = "<gmw-order-complete-header order-number=\"{{::sellMetalCtrl.result.data.orderNo}}\"></gmw-order-complete-header> <div class=gmw-flow-box-container> <holding-sell-result-data data=sellMetalCtrl.result.data destination=sellMetalCtrl.model.destination> </holding-sell-result-data> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow-padding\" ng-if=sellMetalCtrl.feeAmount> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Transfer Fee'|translate\"></div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::sellMetalCtrl.feeAmount|holdingFormatFunds></span> </div> </div> </div> </div> <div class=gmw-flow-box__callout ng-if=sellMetalCtrl.feeAmount> <p translate> Requests received before 14:30 Europe/London will be processed on the same day, provided it is a business day; otherwise, requests will be processed on the next business day. </p> </div> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=sellMetalCtrl.cancel() on-next=sellMetalCtrl.next()> <button gmw-print class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-bind=\"'Print Order'|translate\"> </button> </holding-flow-controls> </footer> ";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _review = __webpack_require__(698);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.sell.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Sell Metal - Review your Order'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]).name;

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container ng-form=sellMetalCtrl.form> <div class=\"gmw-flow-box__callout h-default-text gmw-flow-box__callout--bottom-margin\" ng-if=!sellMetalCtrl.expired> <span class=h-center-text> <span ng-bind=\"'The rates shown will expire in'|translate\"></span> <span class=h-dark-text gmw-remaining-time=sellMetalCtrl.lockedExpiration></span> </span> </div> <holding-alert ng-if=sellMetalCtrl.expired class=warning title=\"{{'Rates Expired'|translate}}\"> <main> <span ng-bind=\"'The locked metal price rates have expired.'|translate\"> </span> </main> <cta> <a ng-click=sellMetalCtrl.refresh() ng-bind=\"'Refresh Locked Rates'|translate\"> </a> </cta> </holding-alert> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Metal'|translate}}\"> {{sellMetalCtrl.model.metal}} </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault'|translate}}\"> {{sellMetalCtrl.model.vault.vault|holdingVaultCustodian}} {{sellMetalCtrl.model.vault.vault|holdingVaultLocation}} </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Sell Amount'|translate}}\"> <span ng-bind=\"sellMetalCtrl.locked.sell|gmwFormatProduct:'oz'\"></span> <span ng-if=sellMetalCtrl.locked.sell|gmwIsInGrams> (<span ng-bind=sellMetalCtrl.locked.sell|gmwFormatProduct></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Sell Price'|translate}}\"> <span ng-bind-html=\"sellMetalCtrl.locked.rateBidPrice|gmwFormatProductRate:'oz'\"></span> <span ng-if=sellMetalCtrl.locked.rateBidPrice|gmwIsInGrams> (<span ng-bind-html=\"sellMetalCtrl.locked.rateBidPrice|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Sell Fee'|translate}}\"> {{sellMetalCtrl.locked.rateFeePercentage}}% </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Overall Rate'|translate}}\"> <span ng-bind-html=\"sellMetalCtrl.locked.ratePrice|gmwFormatProductRate:'oz'\"></span> <span ng-if=sellMetalCtrl.locked.ratePrice|gmwIsInGrams> (<span ng-bind-html=\"sellMetalCtrl.locked.ratePrice|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'You Will Receive'|translate}}\" ng-if=sellMetalCtrl.locked.rateLocked> <span class=h-green-text ng-bind=sellMetalCtrl.locked.buy|holdingFormatFunds> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Approximate Amount'|translate}}\" ng-if=!sellMetalCtrl.locked.rateLocked> <span class=h-green-text ng-bind=sellMetalCtrl.locked.buy|holdingFormatFunds> </span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <p class=h-margin-bottom-20 translate> Carefully review your order information. Once <span class=h-dark-text>Place Order</span> is clicked, your order will be executed and cannot be modified or cancelled. </p> <p class=h-margin-bottom-20 translate ng-if=!sellMetalCtrl.locked.rateLocked> The final overall rate for this order will be based on the <a href class=h-blue-link holding-external-link=support.sell.fixed>applicable Goldmoney Fixed Sell Price</a> on {{sellMetalCtrl.locked.rateLockTime|gmwFormatDate}}. Your order will be completed by {{sellMetalCtrl.locked.orderCompletionTime|gmwFormatDate}}. </p> <gmw-checkbox class=h-margin-bottom-20 ng-if=!sellMetalCtrl.locked.rateLocked ng-model=sellMetalCtrl.lockDisclaimer required> <span class=\"h-dark-text h-medium-text h-bold-text\" translate> Please check to confirm you understand that the amounts above are indicative only and that the final overall rate charged will be based on the <a href class=h-blue-link holding-external-link=support.sell.fixed>applicable Goldmoney Fixed Sell Price</a>. </span> </gmw-checkbox> <gmw-checkbox ng-model=sellMetalCtrl.terms required> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"sellMetalCtrl.user.regulation == 'Toronto'\" translate> I accept the terms of the <a class=h-blue-link holding-external-link=clientAgreement.regulator.canada>Goldmoney Client Agreement</a>. </span> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"sellMetalCtrl.user.regulation == 'UK'\" translate> I accept the terms of the <a class=h-blue-link holding-external-link=clientAgreement.regulator.uk>Goldmoney Client Agreement</a>. </span> </gmw-checkbox> </div> <holding-alert ng-if=sellMetalCtrl.orderError class=error title=\"{{'Error'|translate}}\"> <main> <span ng-bind=sellMetalCtrl.orderError></span> </main> </holding-alert> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls ng-if=!sellMetalCtrl.expired on-cancel=sellMetalCtrl.cancel() on-next=sellMetalCtrl.next() step-disabled=\"sellMetalCtrl.form.$invalid || sellMetalCtrl.form.$submitted\" spinner> </holding-flow-controls> <div class=gmw-flow-box-footer__col ng-if=sellMetalCtrl.expired> <button ng-click=sellMetalCtrl.refresh() class=\"medium-main-cta gmw-responsive-button\" ng-bind=\"'Refresh Locked Rates'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SellMetalController.$inject = ['$controller', '$q', '$scope', '$state', '$timeout', 'gettextCatalog', 'HoldingCurrencies', 'HoldingUser', 'HoldingFunds', 'HoldingMetals', 'HoldingFlow', 'SelectedMetalResolve', 'SelectedVaultResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').controller('SellMetalController', SellMetalController);

function SellMetalController($controller, $q, $scope, $state, $timeout, gettextCatalog, HoldingCurrencies, HoldingUser, HoldingFunds, HoldingMetals, HoldingFlow, SelectedMetalResolve, SelectedVaultResolve) {
  'ngInject';

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    vm.canRemoveFunds = HoldingUser.isAllowed('removeFunds');
    if (!vm.canRemoveFunds) {
      var _HoldingUser$getPermi = HoldingUser.getPermission('removeFunds');

      vm.canRemoveFundsReason = _HoldingUser$getPermi.message;
    }

    vm.user = HoldingUser.get();
    vm.equivalentCurrency = vm.user.currency;

    HoldingFunds.getRftrBanks(true).then(function (_ref) {
      var banks = _ref.banks;

      vm.banks = banks;
    });

    vm.currencies = HoldingCurrencies.getAllFiatForSelector();
    if (vm.currencies.length === 1) {
      vm.model.currency = vm.currencies[0].value;
    }

    HoldingMetals.getSellVaults().then(function (vaults) {
      vm.sources = vaults;

      if (SelectedMetalResolve && SelectedVaultResolve) {
        vm.model.vault = vm.sources.find(function (source) {
          return source.vault === SelectedVaultResolve && source.enabled && source.product === SelectedMetalResolve;
        });
      }
    }).catch(function (_ref2) {
      var code = _ref2.code;

      if (code === 'UNAUTHORIZED') {
        $state.go('holding.dashboard.overview', {}, {
          reload: true
        });
      }
    });

    $scope.$watch('sellMetalCtrl.model.vault', function (vault) {
      if (vault) {
        vm.model.metal = vm.sources.find(function (v) {
          return v === vault;
        }).product;
      }
    });

    $scope.$watch('sellMetalCtrl.model.currency', function (currency) {
      vm.model.fiatAmount.currency = currency;
    });

    $scope.$watch('sellMetalCtrl.model.metal', function (metal) {
      vm.model.metalAmount.currency = metal;
    });

    $scope.$watch('sellMetalCtrl.sellAll', updateSellAll);

    $scope.$watchGroup(['sellMetalCtrl.model.metal', 'sellMetalCtrl.model.currency', 'sellMetalCtrl.model.vault.vault', 'sellMetalCtrl.model.fiatAmount.amount', 'sellMetalCtrl.model.metalAmount.amount'], updateRates);

    $scope.$watchGroup(['sellMetalCtrl.tiers', 'sellMetalCtrl.model.fiatAmount.amount', 'sellMetalCtrl.model.metalAmount.amount'], updateTier);

    $scope.$watchGroup(['sellMetalCtrl.tier', 'sellMetalCtrl.spotRate.value', 'sellMetalCtrl.model.fiatAmount.amount', 'sellMetalCtrl.model.metalAmount.amount'], updateTotal);

    $scope.$watch('sellMetalCtrl.model.bankAccount', onUpdateBank);

    HoldingFlow.load();
    $scope.$watch('sellMetalCtrl.model.destination', updateStates);

    $scope.$watchGroup(['sellMetalCtrl.model.destination', 'sellMetalCtrl.model.bankAccount', 'sellMetalCtrl.model.currency'], updateMin);
  }

  function cancelLockTimer() {
    $timeout.cancel(lockTimer);
  }

  function checkAmount() {
    return !!(model.fiatAmount.amount || model.metalAmount.amount);
  }

  function checkComplete() {
    return !!result.complete;
  }

  function checkVault() {
    return !!model.vault;
  }

  function clearFiat() {
    vm.model.fiatAmount.amount = '';
  }

  function clearMetal() {
    vm.sellAll = false;
    vm.model.metalAmount.amount = '';
  }

  function complete() {
    HoldingFlow.complete();
  }

  function lockPrice() {
    vm.lockError = null;
    var amount = model.fiatAmount.amount ? model.fiatAmount : model.metalAmount;
    return HoldingMetals.lockSellPrice(model.metal, model.currency, model.vault.vault, amount).then(function (locked) {
      vm.locked = locked;
      vm.lockedExpiration = (0, _moment2.default)().add(locked.validFor, 'seconds');
      lockTimer = $timeout(function () {
        vm.expired = true;
      }, locked.validFor * 1000);
      vm.expired = false;
    }).catch(function (_ref3) {
      var message = _ref3.message;

      vm.lockError = message;
      return $q.reject();
    });
  }

  function onUpdateBank(bank) {
    if (bank) {
      vm.model.currency = bank.currencyCode;
      vm.methods = bank.methodOptions.map(function (_ref4) {
        var methodOption = _ref4.methodOption,
            description = _ref4.description;
        return {
          label: methodOption,
          meta: description,
          value: methodOption
        };
      });
    } else {
      vm.model.currency = undefined;
      vm.methods = null;
    }
  }

  function placeOrder() {
    cancelLockTimer();

    vm.orderError = null;
    var amount = vm.model.fiatAmount.amount ? vm.model.fiatAmount : vm.model.metalAmount;
    return HoldingMetals.placeSellOrder(vm.model.metal, vm.model.currency, vm.model.vault.vault, amount).then(function (data) {
      result.data = data;
      result.complete = true;

      if (vm.model.destination === 'bankAccount') {
        return HoldingFunds.initiateRemoveFundsBank({
          amount: data.buy,
          funding: {
            destination: { bankAccountId: vm.model.bankAccount.bankAccountId }
          },
          method: vm.model.method
        }, data.orderNo).then(function (_ref5) {
          var shouldUpdateAddress = _ref5.shouldUpdateAddress,
              shouldUpdateSwiftCode = _ref5.shouldUpdateSwiftCode,
              feeAmount = _ref5.feeAmount,
              pinRequired = _ref5.pinRequired;

          vm.shouldUpdateAddress = shouldUpdateAddress;
          vm.shouldUpdateSwiftCode = shouldUpdateSwiftCode;
          vm.feeAmount = feeAmount;
          vm.pinRequired = pinRequired;
        }).catch(function (_ref6) {
          var message = _ref6.message;

          vm.orderError = message;
          return $q.reject();
        });
      }
      return undefined;
    }).catch(function (_ref7) {
      var message = _ref7.message;

      vm.orderError = message;
      return $q.reject();
    });
  }

  function placeRftrOrder() {
    vm.orderError = null;

    return HoldingFunds.createRemoveFundsBank({
      amount: result.data.buy,
      funding: {
        destination: {
          bankAccountId: vm.model.bankAccount.bankAccountId,
          address1: vm.address1,
          address2: vm.address3,
          address3: vm.address3,
          swiftCode: vm.swiftCode
        }
      },
      pin: vm.pin,
      method: vm.model.method,
      shouldUpdateAddress: vm.shouldUpdateAddress,
      shouldUpdateSwiftCode: vm.shouldUpdateSwiftCode
    }, result.data.orderNo).then(function (_ref8) {
      var feeAmount = _ref8.feeAmount,
          rftrNumber = _ref8.rftrNumber;

      vm.model.feeAmount = feeAmount;
      vm.result.orderNumber = rftrNumber;
    }).catch(function (_ref9) {
      var message = _ref9.message;

      vm.orderError = message;
      return $q.reject();
    });;
  }

  function updateMin(_ref10) {
    var _ref11 = _slicedToArray(_ref10, 3),
        destination = _ref11[0],
        _bankAccount = _ref11[1],
        currency = _ref11[2];

    if (!currency) {
      vm.minFiat = null;
    } else {
      var amount = void 0;
      switch (destination) {
        case 'bankAccount':
          amount = 0.1;
          break;
        case 'holding':
        default:
          amount = 0;
          break;
      }
      vm.minFiat = {
        amount: amount,
        currency: currency
      };
    }
  }

  function updateRates(_ref12) {
    var _ref13 = _slicedToArray(_ref12, 5),
        product = _ref13[0],
        currency = _ref13[1],
        location = _ref13[2],
        amount = _ref13[3],
        metalAmount = _ref13[4];

    vm.loadedRates = false;
    if (product && currency && location && (amount || metalAmount)) {
      HoldingMetals.getSellRates(product, currency, location).then(function (_ref14) {
        var spotRate = _ref14.rates.spotRate,
            tiers = _ref14.tiers;

        vm.spotRate = {
          value: spotRate,
          quoteCurrency: vm.model.currency,
          baseCurrency: vm.model.metal
        };
        vm.lastUpdated = (0, _moment2.default)();
        vm.loadedRates = true;

        tiers.forEach(function (tier, index) {
          if (index + 1 < tiers.length) {
            tier.end = tiers[index + 1].start - 1;
          }
        });
        vm.tiers = tiers;
      });
    }
  }

  function updateSellAll(sellAll) {
    if (sellAll) {
      vm.model.metalAmount.amount = vm.model.vault.totalSpendable.amount;
      vm.model.fiatAmount.amount = undefined;
    } else {
      vm.model.metalAmount.amount = undefined;
    }
  }

  function updateStates(destination) {
    vm.model.currency = null;
    switch (destination) {
      case 'bankAccount':
        HoldingFlow.setStateEnabled('withdraw', true);
        break;
      default:
        vm.model.bankAccount = null;
        HoldingFlow.setStateEnabled('withdraw', false);
    }
  }

  function updateTier(_ref15) {
    var _ref16 = _slicedToArray(_ref15, 3),
        tiers = _ref16[0],
        amount = _ref16[1],
        metalAmount = _ref16[2];

    if (tiers && (amount || metalAmount)) {
      vm.tier = tiers.reduce(function (prev, curr) {
        if (amount && amount > curr.start) {
          return curr;
        }
        if (metalAmount && metalAmount * curr.fee.rate > curr.start) {
          return curr;
        }

        return prev;
      }, { start: -1, fee: { rate: 0 } });
    }
  }

  function updateTotal(_ref17) {
    var _ref18 = _slicedToArray(_ref17, 4),
        tier = _ref18[0],
        rate = _ref18[1],
        amount = _ref18[2],
        metalAmount = _ref18[3];

    if (tier && rate && (amount || metalAmount)) {
      var actualRate = rate * (1 - tier.fee.rate / 100);
      vm.overallRate = {
        value: actualRate,
        quoteCurrency: vm.model.currency,
        baseCurrency: vm.model.metal
      };
      if (amount) {
        vm.buyAmount = {
          amount: amount,
          currency: model.currency
        };
        vm.sellAmount = {
          amount: amount / actualRate,
          currency: model.metal
        };
      } else {
        vm.buyAmount = {
          amount: metalAmount * actualRate,
          currency: model.currency
        };
        vm.sellAmount = {
          amount: metalAmount,
          currency: model.metal
        };
      }
    }
  }

  var lockTimer = void 0;

  var vm = this;
  var model = {
    destination: 'holding',
    fiatAmount: {},
    metalAmount: {}
  };
  var result = {};

  vm.banks = [];
  vm.clearFiat = clearFiat;
  vm.clearMetal = clearMetal;
  vm.complete = complete;
  vm.currencies = [];
  vm.destinations = [{
    label: gettextCatalog.getString('Holding'),
    value: 'holding'
  }];
  if (HoldingUser.isAllowed('removeFunds')) {
    vm.destinations.push({
      label: gettextCatalog.getString('Bank Account'),
      value: 'bankAccount'
    });
  }
  vm.model = model;
  vm.refresh = lockPrice;
  vm.result = result;
  vm.sources = [];
  vm.steps = {
    'holding.dashboard.metals.sell.amount': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.metals.sell.vault'
      }],
      next: lockPrice
    },
    'holding.dashboard.metals.sell.review': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.metals.sell.vault'
      }, {
        function: checkAmount,
        revertTo: 'holding.dashboard.metals.sell.amount'
      }],
      next: placeOrder
    },
    'holding.dashboard.metals.sell.withdraw': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.metals.sell.vault'
      }, {
        function: checkAmount,
        revertTo: 'holding.dashboard.metals.sell.amount'
      }],
      next: placeRftrOrder
    },
    'holding.dashboard.metals.sell.complete': {
      checks: [{
        function: checkComplete,
        revertTo: 'holding.dashboard.metals.sell.review'
      }]
    }
  };

  activate();
}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vault = __webpack_require__(701);

var _vault2 = _interopRequireDefault(_vault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.sell.vault', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Sell Metal - Select Vault & Metal'
    },
    url: '/vault',
    views: {
      step: {
        template: _vault2.default
      }
    }
  });
}]).name;

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> You can sell any amount of metal at the current Goldmoney Sell Price, which is displayed during the order process, or the next <a href holding-external-link=support.buy.fixed class=h-blue-link>Goldmoney Fixed Sell Price</a> according to our <a href holding-external-link=support.buy.limits class=h-blue-link>daily trading limits</a>. </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=sellMetalCtrl.form> <holding-alert-legacy class=warning ng-if=\"!sellMetalCtrl.canRemoveFunds && !sellMetalCtrl.form.$submitted\" ng-switch=sellMetalCtrl.canRemoveFundsReason> <div ng-switch-when=cdd> <span ng-bind=\"'Some information about your Holding needs to be confirmed before the proceeds of any sale of metal can be withdrawn. Be sure to'|translate\"></span> <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n          reload: true,\n        }\" ng-bind=\"'contact Relationship Management'|translate\"></a> <span ng-bind=\"'to discuss this matter further.'|translate\"></span> </div> </holding-alert-legacy> <holding-sell-vault-selector required equivalent-currency=sellMetalCtrl.equivalentCurrency label=\"{{'Select Vault'|translate}}\" vaults=sellMetalCtrl.sources ng-model=sellMetalCtrl.model.vault> </holding-sell-vault-selector> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=sellMetalCtrl.cancel() on-next=sellMetalCtrl.next() step-disabled=\"sellMetalCtrl.form.$invalid || sellMetalCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withdraw = __webpack_require__(703);

var _withdraw2 = _interopRequireDefault(_withdraw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.sell.withdraw', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Sell Metal - Withdraw Funds Order'
    },
    url: '/withdraw',
    views: {
      step: {
        template: _withdraw2.default
      }
    }
  });
}]).name;

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=\"gmw-flow-box__header-description medium-text\" ng-switch=sellMetalCtrl.model.destination> <span ng-switch-when=bankAccount translate> You have requested {{::sellMetalCtrl.model.amount|holdingFormatFunds}} from your currency balance to your bank account. </span> <span ng-switch-when=prepaidCard translate> You have requested {{::sellMetalCtrl.model.amount|holdingFormatFunds}} from your currency balance to your prepaid card. </span> <span ng-if=sellMetalCtrl.pinRequired ng-bind=\"'A funds transfer PIN has been sent to you.'|translate\"> </span> </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-sell-result-data data=sellMetalCtrl.result.data destination=sellMetalCtrl.model.destination> </holding-sell-result-data> <form name=sellMetalCtrl.rtfrForm> <div ng-show=\"sellMetalCtrl.rftrForm.pin.$dirty && sellMetalCtrl.rftrForm.pin.$invalid\" ng-messages=sellMetalCtrl.rftrForm.pin.$error> <div ng-message=required> <holding-alert-legacy class=error> <span ng-bind=\"'Please enter a valid pin value.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=gmw-flow-pin ng-if=sellMetalCtrl.pinRequired> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=gmw-input-container--split-half__col> <span class=\"gmw-flow-pin__title heading-h4 h-dark-text\" ng-bind=\"'Enter Funds Transfer Pin'|translate\"> </span> <a href class=h-blue-link ng-bind=\"'What is this?'|translate\" gmw-tooltip=\"{{'Two-step authentication requires that you enter a seven-digit PIN code to transfer funds. This randomly generated PIN has been sent via email or text message (per your account settings). Please enter the PIN to complete your transfer.'|translate}}\"> </a> </div> <div class=gmw-input-container--split-half__col> <gmw-box-input required name=pin no-label=true has-error=\"sellMetalCtrl.rftrForm.pin.$dirty && sellMetalCtrl.rftrForm.pin.$invalid\" ng-model=sellMetalCtrl.pin placeholder=\"{{'Enter pin'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> </div> </div> <div ng-if=\"sellMetalCtrl.shouldUpdateAddress || sellMetalCtrl.shouldUpdateSwift\"> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Confirm Bank Information'|translate\"></span> <p class=gmw-flow-box__description ng-bind=\"'Please enter/confirm the information below to complete your withdrawal request.'|translate\"> </p> </div> <div class=gmw-input-container ng-if=sellMetalCtrl.shouldUpdateAddress> <gmw-box-input required name=address1 type=text has-error=\"sellMetalCtrl.rftrForm.address1.$dirty && sellMetalCtrl.rftrForm.address1.$invalid\" ng-model=sellMetalCtrl.address1 label=\"{{'Bank Address'|translate}}\" placeholder=\"{{'Enter street address'|translate}}\"> </gmw-box-input> </div> <div class=gmw-input-container ng-if=sellMetalCtrl.shouldUpdateAddress> <gmw-box-input required name=address2 no-label=true type=text has-error=\"sellMetalCtrl.rftrForm.address2.$dirty && sellMetalCtrl.rftrForm.address2.$invalid\" ng-model=sellMetalCtrl.address2 placeholder=\"{{'Enter city, region'|translate}}\"> </gmw-box-input> </div> <div class=gmw-input-container ng-if=sellMetalCtrl.shouldUpdateAddress> <gmw-box-input name=address3 no-label=true type=text has-error=\"sellMetalCtrl.rftrForm.address3.$dirty && sellMetalCtrl.rftrForm.address3.$invalid\" ng-model=sellMetalCtrl.address3 placeholder=\"{{'Enter additonal info (optional)'|translate}}\"> </gmw-box-input> </div> <div class=gmw-input-container ng-if=sellMetalCtrl.shouldUpdateSwift> <gmw-box-input required name=swiftCode type=text has-error=\"sellMetalCtrl.rftrForm.swiftCode.$dirty && sellMetalCtrl.rftrForm.swiftCode.$invalid\" ng-model=sellMetalCtrl.swiftCode label=\"{{'SWIFT/BIC Code'|translate}}\" placeholder=\"{{'Enter SWIFT/BIC code'|translate}}\"> </gmw-box-input> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <gmw-recap-table-header label=\"{{'Transfer Details'|translate}}\"></gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Amount to Transfer'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::sellMetalCtrl.result.data.buy|holdingFormatFunds></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Transfer Fee'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::sellMetalCtrl.feeAmount|holdingFormatFunds></span> </div> </div> <div ng-if=\"sellMetalCtrl.model.destination === 'bankAccount'\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Destination Bank Account'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=::sellMetalCtrl.model.bankAccount.nickName></span><br> <span ng-bind=::sellMetalCtrl.model.bankAccount.name></span><br> <span ng-bind=::sellMetalCtrl.model.bankAccount.address1></span><br> <span ng-bind=::sellMetalCtrl.model.bankAccount.address2></span><br> <span ng-bind=::sellMetalCtrl.model.bankAccount.address3></span><br> <span ng-bind=::sellMetalCtrl.model.bankAccount.countryName></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=sellMetalCtrl.model.bankAccount.sortCode> <div class=gmw-recap-table__col ng-bind=\"'Sort Code'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::sellMetalCtrl.model.bankAccount.sortCode></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Account Number'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::sellMetalCtrl.model.bankAccount.accountNumber></span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=\"'Account Name'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::sellMetalCtrl.model.bankAccount.accountName></span> </div> </div> </div> </div> </div> </form> <holding-alert ng-if=sellMetalCtrl.orderError class=\"error h-margin-top-20 gmw-alert--no-margin\" title=\"{{'Error'|translate}}\"> <main> <span ng-bind=sellMetalCtrl.orderError></span> </main> </holding-alert> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=sellMetalCtrl.cancel() on-next=sellMetalCtrl.next() step-disabled=\"sellMetalCtrl.rftrForm.$invalid || sellMetalCtrl.rftrForm.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultExchangeFlow = __webpack_require__(705);

var _vaultExchangeFlow2 = _interopRequireDefault(_vaultExchangeFlow);

var _vaultExchange = __webpack_require__(706);

var _vaultExchange2 = _interopRequireDefault(_vaultExchange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.metals').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.vault-exchange', {
    data: {
      flow: _vaultExchangeFlow2.default
    },
    params: {
      sourceMetal: {
        type: 'string',
        value: null
      },
      sourceVault: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      SelectedSourceMetalResolve: ['$q', '$stateParams', function SelectedSourceMetalResolve($q, $stateParams) {
        'ngInject';

        return 'sourceMetal' in $stateParams ? $q.when($stateParams.sourceMetal) : $q.when();
      }],
      SelectedSourceVaultResolve: ['$q', '$stateParams', function SelectedSourceVaultResolve($q, $stateParams) {
        'ngInject';

        return 'sourceVault' in $stateParams ? $q.when($stateParams.sourceVault) : $q.when();
      }]
    },
    url: '/vault-exchange',
    views: {
      'metals-main@holding.dashboard.metals': {
        controller: 'VaultExchangeController',
        controllerAs: 'vaultExchangeCtrl',
        template: _vaultExchange2.default
      }
    }
  });

  $urlRouterProvider.when('/metals/vault-exchange', '/metals/vault-exchange/source');
}]).name;


__webpack_require__(707);
__webpack_require__(709);
__webpack_require__(711);
__webpack_require__(713);
__webpack_require__(715);

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Vault Exchange'),
    cancel: {
        state: 'holding.dashboard.metals.vault-exchange'
    },
    complete: {
        label: (0, _gettext2.default)('Return to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'metal',
        state: 'holding.dashboard.metals.vault-exchange.source',
        heading: (0, _gettext2.default)('Exchange Your Metal to Another Vault'),
        label: (0, _gettext2.default)('Select Metal')
    }, {
        key: 'amount',
        state: 'holding.dashboard.metals.vault-exchange.destination',
        heading: (0, _gettext2.default)('Choose a Destination Vault'),
        label: (0, _gettext2.default)('Select Destination')
    }, {
        key: 'review',
        state: 'holding.dashboard.metals.vault-exchange.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Vault Exchange'),
        label: (0, _gettext2.default)('Review Exchange'),
        controls: {
            next: (0, _gettext2.default)('Place Order')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.metals.vault-exchange.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I change vaults?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000679208> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How do I exchange metals?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000516027> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> ";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(708);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.vault-exchange.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Vault Exchange - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "<gmw-order-complete-header order-number=\"{{::vaultExchangeCtrl.result.data.orderNo}}\"></gmw-order-complete-header> <div class=gmw-flow-box-container> <div class=\"gmw-to-and-from gmw-to-and-from--padded\"> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Source'|translate\"> </span> <span class=gmw-to-and-from__data> <gmw-flag country=::vaultExchangeCtrl.result.data.exchangedLocation|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vaultExchangeCtrl.result.data.exchangedLocation|holdingVaultCustodian></span> <span class=h-margin-left-5 ng-bind=::vaultExchangeCtrl.result.data.exchangedLocation|holdingVaultLocation></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Metal'|translate\"> </span> <span class=gmw-to-and-from__data> <holding-metal-badge metal=vaultExchangeCtrl.model.source.product></holding-metal-badge> <span ng-bind=::vaultExchangeCtrl.model.source.product></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"::vaultExchangeCtrl.result.data.exchangedAmount|gmwFormatProduct:'g'\"> </span> <span class=gmw-to-and-from__label ng-bind=\"'Ounces Equiv.'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"::vaultExchangeCtrl.result.data.exchangedAmount|gmwFormatProduct:'oz'\"> </span> </div> </div> <div class=gmw-to-and-from__arrow> <svg class=gmw-to-and-from__arrow-icon> <use xlink:href=#right-arrow-icon></use> </svg> </div> <div class=gmw-to-and-from__col> <div class=\"gmw-to-and-from__box gmw-to-and-from__box--small\"> <span class=gmw-to-and-from__label ng-bind=\"'Destination'|translate\"> </span> <span class=gmw-to-and-from__data> <gmw-flag country=::vaultExchangeCtrl.result.data.buyLocation|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vaultExchangeCtrl.result.data.buyLocation|holdingVaultCustodian></span> <span class=h-margin-left-5 ng-bind=::vaultExchangeCtrl.result.data.buyLocation|holdingVaultLocation></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Metal'|translate\"> </span> <span class=gmw-to-and-from__data> <holding-metal-badge metal=::vaultExchangeCtrl.model.source.product></holding-metal-badge> <span ng-bind=::vaultExchangeCtrl.model.source.product></span> </span> <span class=gmw-to-and-from__label ng-bind=\"'Amount'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"::vaultExchangeCtrl.result.data.buy|gmwFormatProduct:'g'\"> </span> <span class=gmw-to-and-from__label ng-bind=\"'Ounces Equiv.'|translate\"> </span> <span class=gmw-to-and-from__data ng-bind=\"::vaultExchangeCtrl.result.data.buy|gmwFormatProduct:'oz'\"> </span> </div> </div> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'USD Equivalent'|translate}}\"> <span ng-bind=::vaultExchangeCtrl.result.data.exchangedFiatAmount|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault Exchange Fee'|translate}}\"> <span ng-bind=\"::vaultExchangeCtrl.result.data.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> </div> </div> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-cancel=vaultExchangeCtrl.cancel() on-next=vaultExchangeCtrl.next()> <button gmw-print class=\"medium-border-cta gmw-button-spacer gmw-button-spacer--medium gmw-responsive-button\" ng-bind=\"'Print Order'|translate\"> </button> </holding-flow-controls> </footer> ";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _destination = __webpack_require__(710);

var _destination2 = _interopRequireDefault(_destination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.vault-exchange.destination', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Vault Exchange - Select Destination Vault'
    },
    url: '/destination',
    views: {
      step: {
        template: _destination2.default
      }
    }
  });
}]);

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Next, please select the vault location that you would like to re-buy your '|translate\"></span> <span ng-bind=vaultExchangeCtrl.model.source.totalSpendable|holdingCurrencyName|lowercase></span> <span ng-bind=\"'in to complete the vault exchange.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=vaultExchangeCtrl.form> <holding-alert class=error ng-if=vaultExchangeCtrl.rateError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=vaultExchangeCtrl.rateError></span> </main> </holding-alert> <holding-alert class=warning ng-if=\"vaultExchangeCtrl.destinations.length < 1\" title=\"{{'No Destination Locations Available'|translate}}\"> <main> <span ng-bind=\"'There are no available destination vaults to exchange your metal to'|translate\"></span> <span ng-if=vaultExchangeCtrl.user.shariaFlag ng-bind=\"'as your Holding is set to \\'Shariah Compliant\\', which limits your available vault selection'|translate\"></span> <span ng-bind=\"'- please contact Relationship Management if you need more information.'|translate\"></span> </main> <cta> <a ui-sref=\"holding.dashboard.messages.compose({\n          category: 'OTHER',\n          subject: 'No destination vaults available in vault exchange',\n        })\" ng-bind=\"'Contact Relationship Management'|translate\"> </a> </cta> </holding-alert> <div ng-if=\"vaultExchangeCtrl.destinations.length > 0\"> <holding-buy-vault-selector label=\"{{'Select Destination Vault'|translate}}\" vaults=vaultExchangeCtrl.destinations ng-model=vaultExchangeCtrl.model.destination small required> </holding-buy-vault-selector> <gmw-fee-tiers ng-if=\"vaultExchangeCtrl.loadedRates && vaultExchangeCtrl.isSellAll\" currency=vaultExchangeCtrl.model.currency product=vaultExchangeCtrl.model.source.product tiers=vaultExchangeCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=\"vaultExchangeCtrl.loadedRates && vaultExchangeCtrl.isSellAll\" currency=vaultExchangeCtrl.model.currency product=vaultExchangeCtrl.model.source.product tiers=vaultExchangeCtrl.tiers> </gmw-fee-tiers-mobile> <gmw-fee-tiers ng-if=vaultExchangeCtrl.loadedRates currency=vaultExchangeCtrl.model.currency product=vaultExchangeCtrl.model.source.product tiers=vaultExchangeCtrl.tiers> </gmw-fee-tiers> <gmw-fee-tiers-mobile ng-if=vaultExchangeCtrl.loadedRates currency=vaultExchangeCtrl.model.currency product=vaultExchangeCtrl.model.source.product tiers=vaultExchangeCtrl.tiers> </gmw-fee-tiers-mobile> <div ng-if=vaultExchangeCtrl.loadedRates> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Vault Exchange Summary'|translate\"></span> <p class=gmw-flow-box__description ng-bind=\"'The rates below are indicative - will be provided with a final rate prior to confirming any vault exchange request.'|translate\"> </p> </div> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\" ng-if=vaultExchangeCtrl.loadedRates> <gmw-recap-table-header label=\"{{'Your Provisional Rate'|translate}}\" highlight=true> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Metal'|translate}}\"> <holding-metal-badge metal=::vaultExchangeCtrl.model.source.product></holding-metal-badge> <span ng-bind=::vaultExchangeCtrl.model.source.product></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Amount'|translate}}\"> <span ng-bind-html=::vaultExchangeCtrl.buyAmountFiat|gmwFormatAmount></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Source Vault'|translate}}\"> <gmw-flag country=::vaultExchangeCtrl.model.source.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vaultExchangeCtrl.model.source.vault|holdingVaultCustodian></span> <span ng-bind=::vaultExchangeCtrl.model.source.vault|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Sell Price'|translate}}\"> <span ng-bind-html=\"::vaultExchangeCtrl.sellSpotRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=vaultExchangeCtrl.sellSpotRate|gmwIsInGrams> (<span ng-bind-html=\"::vaultExchangeCtrl.sellSpotRate|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Destination Vault'|translate}}\"> <gmw-flag country=::vaultExchangeCtrl.model.destination|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vaultExchangeCtrl.model.destination|holdingVaultCustodian></span> <span ng-bind=::vaultExchangeCtrl.model.destination|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Goldmoney Buy Price'|translate}}\"> <span ng-bind-html=\"::vaultExchangeCtrl.buySpotRate|gmwFormatProductRate:'oz'\"></span> <span ng-if=vaultExchangeCtrl.buySpotRate|gmwIsInGrams> (<span ng-bind-html=\"::vaultExchangeCtrl.buySpotRate|gmwFormatProductRate:'g'\"></span>) </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault Exchange Fee'|translate}}\"> <span ng-bind=\"vaultExchangeCtrl.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> <gmw-recap-table-row highlight=true label=\"{{'You Will Receive'|translate}}\"> <span ng-if=vaultExchangeCtrl.buyAmountMetal|gmwIsInGrams> <span ng-bind=\"::vaultExchangeCtrl.buyAmountMetal|gmwFormatProduct:'g'\"></span> <span ng-bind=\"'(~' + (vaultExchangeCtrl.buyAmountMetal|gmwFormatProduct:'oz') + ')'\"></span> </span> <span ng-if=!vaultExchangeCtrl.buyAmountMetal|gmwIsInGrams> <span ng-bind=\"::vaultExchangeCtrl.buyAmountMetal|gmwFormatProduct:'oz'\"></span> </span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Price Last Updated'|translate}}\"> <span ng-bind=::vaultExchangeCtrl.lastUpdated|gmwFormatDateTime></span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <span ng-if=\"vaultExchangeCtrl.user.regulation == 'Toronto'\" translate> Please review your order on the following page. Please note that you will be asked to confirm your acceptance of our <a class=h-blue-link holding-external-link=clientAgreement.regulator.canada>client agreement</a>. </span> <span ng-if=\"vaultExchangeCtrl.user.regulation == 'UK'\" translate> Please review your order on the following page. Please note that you will be asked to confirm your acceptance of our <a class=h-blue-link holding-external-link=clientAgreement.regulator.uk>client agreement</a>. </span> </div> <holding-alert-legacy class=error ng-if=vaultExchangeCtrl.lockError> <span ng-bind=vaultExchangeCtrl.lockError></span> </holding-alert-legacy> </div> </div> <footer class=gmw-flow-box-footer ng-if=\"vaultExchangeCtrl.destinations.length > 0\"> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=vaultExchangeCtrl.cancel() on-next=vaultExchangeCtrl.next() step-disabled=\"vaultExchangeCtrl.form.$invalid || vaultExchangeCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(712);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.vault-exchange.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Vault Exchange - Review your Order'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Please review your vault exchange request below to ensure that you are satisfied with the details.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=vaultExchangeCtrl.form> <div class=\"gmw-flow-box__callout h-default-text\" ng-if=!vaultExchangeCtrl.expired> <span class=h-center-text> <span ng-bind=\"'The rates shown will expire in'|translate\"></span> <span class=h-dark-text gmw-remaining-time=vaultExchangeCtrl.lockedExpiration></span> </span> </div> <holding-alert ng-if=vaultExchangeCtrl.expired class=warning title=\"{{'Rates Expired'|translate}}\"> <main> <span ng-bind=\"'The locked metal price rates have expired.'|translate\"> </span> </main> <cta> <a ng-click=vaultExchangeCtrl.refresh() ng-bind=\"'Refresh Locked Rates'|translate\"> </a> </cta> </holding-alert> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--narrow\"> <gmw-recap-table-header label=\"{{'You Are Exchanging'|translate}}\"></gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Metal'|translate}}\"> <holding-metal-badge metal=vaultExchangeCtrl.model.source.product></holding-metal-badge> <span ng-bind=vaultExchangeCtrl.model.source.product></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Source Vault'|translate}}\"> <gmw-flag country=::vaultExchangeCtrl.locked.exchangedLocation|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vaultExchangeCtrl.locked.exchangedLocation|holdingVaultCustodian></span> <span ng-bind=::vaultExchangeCtrl.locked.exchangedLocation|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Source Amount'|translate}}\"> <span ng-bind=\"::vaultExchangeCtrl.locked.exchangedAmount|gmwFormatProduct:'g'\"></span> (<span ng-bind-html=\"::vaultExchangeCtrl.locked.sellRatePrice|gmwFormatProductRate:'g'\"></span>) </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Ounce Equivalent'|translate}}\"> <span ng-bind=\"::vaultExchangeCtrl.locked.exchangedAmount|gmwFormatProduct:'oz'\"></span> (<span ng-bind-html=\"::vaultExchangeCtrl.locked.sellRatePrice|gmwFormatProductRate:'oz'\"></span>) </gmw-recap-table-row> <gmw-recap-table-row highlight=true label=\"{{'USD Equivalent'|translate}}\"> <span ng-bind-html=::vaultExchangeCtrl.locked.exchangedFiatAmount|holdingFormatFunds></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Vault Exchange Fee'|translate}}\"> <span ng-bind=\"vaultExchangeCtrl.locked.rateFeePercentage + '%'\"></span> </gmw-recap-table-row> </div> <gmw-recap-table-header ng-if=vaultExchangeCtrl.locked.rateLocked label=\"{{'You Will Receive'|translate}}\"> </gmw-recap-table-header> <gmw-recap-table-header ng-if=!vaultExchangeCtrl.locked.rateLocked label=\"{{'Approximate Amount You Will Receive'|translate}}\"> </gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <gmw-recap-table-row label=\"{{'Destination Vault'|translate}}\"> <gmw-flag country=::vaultExchangeCtrl.locked.buyLocation|holdingVaultCountryCode></gmw-flag> <span ng-bind=::vaultExchangeCtrl.locked.buyLocation|holdingVaultCustodian></span> <span ng-bind=::vaultExchangeCtrl.locked.buyLocation|holdingVaultLocation></span> </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Destination Amount'|translate}}\"> <span ng-bind=\"::vaultExchangeCtrl.locked.buy|gmwFormatProduct:'g'\"></span> (<span ng-bind-html=\"::vaultExchangeCtrl.locked.buyRatePrice|gmwFormatProductRate:'g'\"></span>) </gmw-recap-table-row> <gmw-recap-table-row label=\"{{'Ounce Equivalent'|translate}}\"> <span ng-bind=\"::vaultExchangeCtrl.locked.buy|gmwFormatProduct:'oz'\"></span> (<span ng-bind-html=\"::vaultExchangeCtrl.locked.buyRatePrice|gmwFormatProductRate:'oz'\"></span>) </gmw-recap-table-row> <gmw-recap-table-row highlight=true label=\"{{'USD Equivalent'|translate}}\"> <span ng-bind=::vaultExchangeCtrl.locked.exchangedFiatAmount|holdingFormatFunds></span> </gmw-recap-table-row> </div> </div> <div class=gmw-flow-box__callout> <p class=h-margin-bottom-20 translate> Please carefully review your order. When you click <span class=h-dark-text>Place Order</span>, your order will be executed and cannot be changed or cancelled. </p> <p class=h-margin-bottom-20 translate ng-if=!vaultExchangeCtrl.locked.rateLocked> The final overall rate for this order will be based on the applicable Goldmoney <a href class=h-blue-link holding-external-link=support.buy.fixed>Fixed Buy Price</a> on {{vaultExchangeCtrl.locked.rateLockTime|gmwFormatDate}}. Your order will be completed by {{vaultExchangeCtrl.locked.orderCompletionTime|gmwFormatDate}}. </p> <gmw-checkbox class=h-margin-bottom-20 ng-if=!vaultExchangeCtrl.locked.rateLocked ng-model=vaultExchangeCtrl.lockDisclaimer required> <span class=\"h-dark-text h-medium-text h-bold-text\" translate> Please check to confirm you understand that the amounts above are indicative only and that the final overall rate charged will be based on the applicable Goldmoney <a href class=h-blue-link holding-external-link=support.buy.fixed>Fixed Buy Price</a>. </span> </gmw-checkbox> <gmw-checkbox ng-model=buyModelCtrl.terms required> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"vaultExchangeCtrl.user.regulation == 'Toronto'\" translate> Please confirm you accept the terms of our <a href class=h-blue-link holding-external-link=clientAgreement.regulator.canada>Client Agreement</a> </span> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"vaultExchangeCtrl.user.regulation == 'UK'\" translate> Please confirm you accept the terms of our <a href class=h-blue-link holding-external-link=clientAgreement.regulator.uk>Client Agreement</a> </span> </gmw-checkbox> </div> <holding-alert-legacy class=error ng-if=vaultExchangeCtrl.orderError> <span ng-bind=vaultExchangeCtrl.orderError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls ng-if=!vaultExchangeCtrl.expired on-cancel=vaultExchangeCtrl.cancel() on-next=vaultExchangeCtrl.next() step-disabled=\"vaultExchangeCtrl.form.$invalid || vaultExchangeCtrl.form.$submitted\"> </holding-flow-controls> <div class=gmw-flow-box-footer__col ng-if=vaultExchangeCtrl.expired> <button ng-click=vaultExchangeCtrl.refresh() class=\"medium-main-cta gmw-responsive-button\" ng-bind=\"'Refresh Locked Rates'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _source = __webpack_require__(714);

var _source2 = _interopRequireDefault(_source);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.metals.vault-exchange.source', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Vault Exchange - Select Metal to Exchange'
    },
    url: '/source',
    views: {
      step: {
        template: _source2.default
      }
    }
  });
}]);

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Our Vault Exchange tool allows you to \\'transfer\\' some or all of your metal from one location to another by selling metal you own in the source vault below and re-buying it in a new location of your choosing at a discounted rate.'|translate\"></span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=vaultExchangeCtrl.form> <holding-alert ng-if=\"!vaultExchangeCtrl.form.$submitted && vaultExchangeCtrl.currentPromotion.sale\" class=info can-dismiss=\"vaultExchangeAlert_' + vaultExchangeCtrl.currentPromotion.start\" title=\"{{'Promotional Pricing'|translate}}\"> <main> <span> <span ng-bind=\"'Be sure to take advantage of our limited time '|translate\"></span> <span ng-bind=\"vaultExchangeCtrl.currentPromotion.rate + '%'\"></span> <span ng-bind=\"'vault exchange fee promotion'|translate\"></span>. </span> </main> </holding-alert> <holding-sell-vault-selector equivalent-currency=\"'USD'\" label=\"{{'Select Metal to Exchange'|translate}}\" description=\"{{'Select the metal to exchange. To exchange metal from multiple locations, you will need to repeat this process for each vault individually.'|translate}}\" vaults=vaultExchangeCtrl.sources ng-model=vaultExchangeCtrl.model.source required> </holding-sell-vault-selector> <div class=gmw-input-container ng-if=\"!vaultExchangeCtrl.sellAll && vaultExchangeCtrl.isSourceSelected()\"> <label class=\"gmw-input-container__label heading-h4\"> <span class=h-dark-text ng-bind=\"'Enter the Amount to Transfer'|translate\"> </span> </label> <p class=gmw-input-container__description> <span ng-bind=\"'Enter the amount of your metal you would like to exchange in either USD or weight of metal.'|translate\"></span> </p> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input name=fiatAmount type=number currency=USD no-label=true ng-required=!(vaultExchangeCtrl.model.metalAmount.amount) class=gmw-input-container--split-half__col has-error=\"vaultExchangeCtrl.form.fiatAmount.$dirty && vaultExchangeCtrl.form.fiatAmount.$invalid\" ng-model=vaultExchangeCtrl.model.fiatAmount.amount ng-model-options=\"{\n          debounce: 400,\n        }\" change=vaultExchangeCtrl.clearMetal() placeholder=0.00> <gmw-box-input-meta-left> {{'USD'|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> <span class=\"gmw-input-container--split-half__or gmw-input-container--split-half__or--no-label heading-h5\" ng-bind=\"'OR'|translate\"> </span> <gmw-box-input name=metalAmount type=number currency=\"{{vaultExchangeCtrl.model.metalAmount.currency}}\" no-label=true ng-required=!(vaultExchangeCtrl.model.fiatAmount.amount) class=gmw-input-container--split-half__col has-error=\"vaultExchangeCtrl.form.metalAmount.$dirty && vaultExchangeCtrl.form.metalAmount.$invalid\" ng-model=vaultExchangeCtrl.model.metalAmount.amount ng-model-options=\"{\n          debounce: 400,\n        }\" change=vaultExchangeCtrl.clearFiat() placeholder=0.000> <gmw-box-input-meta-right> {{vaultExchangeCtrl.model.metalAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-right> </gmw-box-input> </div> </div> <div class=gmw-flow-box__callout ng-if=vaultExchangeCtrl.isSourceSelected()> <p class=gmw-flow-box__callout-block> <gmw-checkbox ng-model=vaultExchangeCtrl.sellAll> <span translate> Transfer all available {{vaultExchangeCtrl.model.source.totalSpendable|holdingCurrencyName|lowercase}} balance at {{vaultExchangeCtrl.model.source.vault|holdingVaultCustodian}} {{vaultExchangeCtrl.model.source.vault|holdingVaultLocation}} - <span class=h-dark-text>{{vaultExchangeCtrl.model.source.totalSpendable|gmwFormatProduct}}</span>. </span> </gmw-checkbox> </p> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=vaultExchangeCtrl.cancel() on-next=vaultExchangeCtrl.next() step-disabled=\"vaultExchangeCtrl.form.$invalid || vaultExchangeCtrl.form.$submitted\" spinner> </holding-flow-controls> </footer> ";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


VaultExchangeController.$inject = ['$controller', '$q', '$scope', '$state', '$timeout', 'HoldingMetals', 'HoldingUser', 'HoldingPromotions', 'SelectedSourceMetalResolve', 'SelectedSourceVaultResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.metals').controller('VaultExchangeController', VaultExchangeController);

function VaultExchangeController($controller, $q, $scope, $state, $timeout, HoldingMetals, HoldingUser, HoldingPromotions, SelectedSourceMetalResolve, SelectedSourceVaultResolve) {
  'ngInject';

  var vm = this;
  var model = {
    currency: 'USD',
    fiatAmount: {
      currency: 'USD'
    },
    metalAmount: {}
  };
  var result = {};

  vm.steps = {
    'holding.dashboard.metals.vault-exchange.source': {
      checks: []
    },
    'holding.dashboard.metals.vault-exchange.destination': {
      checks: [{
        function: isSourceSelected,
        revertTo: 'holding.dashboard.metals.vault-exchange.source'
      }],
      next: lockPrice
    },
    'holding.dashboard.metals.vault-exchange.review': {
      checks: [{
        function: isSourceSelected,
        revertTo: 'holding.dashboard.metals.vault-exchange.source'
      }, {
        function: isAmountEntered,
        revertTo: 'holding.dashboard.metals.vault-exchange.destination'
      }],
      next: placeOrder
    },
    'holding.dashboard.metals.vault-exchange.complete': {
      checks: [{
        function: isComplete,
        revertTo: 'holding.dashboard.metals.vault-exchange.review'
      }]
    }
  };

  vm.clearFiat = clearFiat;
  vm.clearMetal = clearMetal;
  vm.currentPromotion = HoldingPromotions.isVaultExchangeSale();
  vm.isSourceSelected = isSourceSelected;
  vm.model = model;
  vm.refresh = lockPrice;
  vm.result = result;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    vm.user = HoldingUser.get();
    vm.equivalentCurrency = vm.user.currency;

    vm.metals = HoldingMetals.getMetals();
    vm.selectorMetals = vm.metals.map(function (metal) {
      return {
        label: metal,
        value: metal
      };
    });

    HoldingMetals.getExchangeSources().then(function (sources) {
      vm.sources = sources;

      if (SelectedSourceMetalResolve && SelectedSourceVaultResolve) {
        vm.model.source = vm.sources.find(function (source) {
          return source.vault === SelectedSourceVaultResolve && source.enabled && source.product === SelectedSourceMetalResolve;
        });
      }
    }).catch(function (_ref) {
      var code = _ref.code;

      if (code === 'UNAUTHORIZED') {
        $state.go('holding.dashboard.overview', {}, {
          reload: true
        });
      }
    });
  }

  function clearFiat() {
    vm.model.fiatAmount.amount = '';
    vm.sellAll = false;
  }

  function clearMetal() {
    vm.model.metalAmount.amount = '';
    vm.sellAll = false;
  }

  function isAmountEntered() {
    return !!(model.fiatAmount.amount || model.metalAmount.amount);
  }

  function isComplete() {
    return !!result.complete;
  }

  function isSourceSelected() {
    return !!vm.model.source;
  }

  function lockPrice() {
    var amount = model.fiatAmount.amount ? model.fiatAmount : model.metalAmount;

    return HoldingMetals.lockExchangePrice(vm.model.source, vm.model.destination, vm.model.destinationMetal, amount, model.isSellAmount).then(function (locked) {
      vm.locked = locked;
      vm.lockedExpiration = (0, _moment2.default)().add(locked.validFor, 'seconds');
      $timeout(function () {
        vm.expired = true;
      }, locked.validFor * 1000);
      vm.expired = false;
    }).catch(function (_ref2) {
      var message = _ref2.message;

      vm.lockError = message;
      return $q.reject();
    });
  }

  function placeOrder() {
    vm.orderError = null;
    var amount = model.fiatAmount.amount ? model.fiatAmount : model.metalAmount;

    return HoldingMetals.placeExchangeOrder(vm.model.source, vm.model.destination, vm.model.destinationMetal, amount, model.isSellAmount).then(function (data) {
      result.data = data;
      result.complete = true;
    }).catch(function (_ref3) {
      var message = _ref3.message;

      vm.orderError = message;
      return $q.reject();
    });
  }

  function onDestinationUpdate(newMetal, oldMetal) {
    if (newMetal && newMetal !== oldMetal) {
      if (!vm.sellAll) {
        vm.model.metalAmount.currency = newMetal;
      }
      vm.model.destination = null;
      vm.destinations = [];

      return HoldingMetals.getExchangeDestinations(newMetal).then(function (destinations) {
        vm.destinations = destinations.filter(function (destination) {
          return destination.vault !== vm.model.source.vault;
        });
      });
    }
  }

  function onSourceUpdated(newSource, oldSource) {
    if (newSource && newSource !== oldSource) {
      var metal = vm.sources.find(function (v) {
        return v === newSource;
      }).product;
      vm.model.destinationMetal = metal;
    }
  }

  function resetLockError() {
    vm.lockError = null;
    vm.form.$submitted = false;
  }

  function resetRateError() {
    vm.rateError = null;
  }

  function updateRates(_ref4) {
    var _ref5 = _slicedToArray(_ref4, 6),
        source = _ref5[0],
        destination = _ref5[1],
        destinationMetal = _ref5[2],
        fiatAmount = _ref5[3],
        metalAmount = _ref5[4],
        isSellAmount = _ref5[5];

    vm.loadedRates = false;
    var amount = fiatAmount ? vm.model.fiatAmount : vm.model.metalAmount;
    if (amount.amount && source && destination && destinationMetal) {
      resetLockError();
      resetRateError();
      HoldingMetals.getExchangeRates(amount, source, destination, destinationMetal, isSellAmount).then(function (_ref6) {
        var buyRate = _ref6.buyRates.spotRate,
            rateFeePercentage = _ref6.rateFeePercentage,
            sellRate = _ref6.sellRates.spotRate,
            tiers = _ref6.tiers;

        vm.buySpotRate = {
          value: buyRate,
          quoteCurrency: 'USD',
          baseCurrency: vm.model.destinationMetal
        };
        vm.rateFeePercentage = rateFeePercentage;
        vm.sellSpotRate = {
          value: sellRate,
          quoteCurrency: 'USD',
          baseCurrency: vm.model.source.product
        };
        vm.lastUpdated = (0, _moment2.default)();
        vm.loadedRates = true;

        tiers.forEach(function (tier, index) {
          if (index + 1 < tiers.length) {
            tier.end = tiers[index + 1].start - 1;
          }
        });
        vm.tiers = tiers;
      }).catch(function (_ref7) {
        var message = _ref7.message;

        vm.rateError = message;
      });
    }
  }

  function updateSellAll(sellAll) {
    vm.model.isSellAmount = sellAll;
    if (sellAll) {
      vm.model.metalAmount = vm.model.source.totalSpendable;
      vm.model.fiatAmount.amount = undefined;
    } else {
      vm.model.metalAmount = {
        currency: vm.model.destinationMetal
      };
    }
  }

  function updateTier(_ref8) {
    var _ref9 = _slicedToArray(_ref8, 3),
        tiers = _ref9[0],
        amount = _ref9[1],
        metalAmount = _ref9[2];

    if (tiers && (amount || metalAmount)) {
      vm.tier = tiers.reduce(function (prev, curr) {
        if (amount && amount > curr.start) {
          return curr;
        }
        if (metalAmount && metalAmount * curr.fee.rate > curr.start) {
          return curr;
        }

        return prev;
      }, { start: -1, fee: { rate: 0 } });
    }
  }

  function updateTotal(_ref10) {
    var _ref11 = _slicedToArray(_ref10, 5),
        tier = _ref11[0],
        buyRate = _ref11[1],
        sellRate = _ref11[2],
        amount = _ref11[3],
        metalAmount = _ref11[4];

    if (tier && buyRate && (amount || metalAmount)) {
      var actualRate = buyRate * (1 + tier.fee.rate / 100);
      if (vm.model.isSellAmount) {
        vm.buyAmountFiat = {
          amount: metalAmount,
          currency: vm.model.source.product
        };
        vm.buyAmountMetal = {
          amount: metalAmount * sellRate / actualRate,
          currency: model.destinationMetal
        };
      } else if (amount) {
        vm.buyAmountFiat = {
          amount: amount,
          currency: model.fiatAmount.currency
        };
        vm.buyAmountMetal = {
          amount: amount / actualRate,
          currency: model.destinationMetal
        };
      } else {
        vm.buyAmountFiat = {
          amount: metalAmount * actualRate,
          currency: model.fiatAmount.currency
        };
        vm.buyAmountMetal = {
          amount: metalAmount,
          currency: model.destinationMetal
        };
      }
    }
  }

  activate();

  $scope.$watch('vaultExchangeCtrl.model.destinationMetal', onDestinationUpdate);
  $scope.$watch('vaultExchangeCtrl.model.source', onSourceUpdated);
  $scope.$watch('vaultExchangeCtrl.sellAll', updateSellAll);
  $scope.$watchGroup(['vaultExchangeCtrl.model.source', 'vaultExchangeCtrl.model.destination', 'vaultExchangeCtrl.model.destinationMetal', 'vaultExchangeCtrl.model.fiatAmount.amount', 'vaultExchangeCtrl.model.metalAmount.amount', 'vaultExchangeCtrl.model.isSellAmount'], updateRates);
  $scope.$watchGroup(['vaultExchangeCtrl.tiers', 'vaultExchangeCtrl.model.fiatAmount.amount', 'vaultExchangeCtrl.model.metalAmount.amount'], updateTier);
  $scope.$watchGroup(['vaultExchangeCtrl.tier', 'vaultExchangeCtrl.buySpotRate.value', 'vaultExchangeCtrl.sellSpotRate.value', 'vaultExchangeCtrl.model.fiatAmount.amount', 'vaultExchangeCtrl.model.metalAmount.amount'], updateTotal);
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.messages', [_angularjs2.default, _common2.default]).name;


__webpack_require__(717);
__webpack_require__(719);
__webpack_require__(721);
__webpack_require__(723);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingMessagesFolderListItem.$inject = ['HoldingMessages'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messagesFolderListItem = __webpack_require__(718);

var _messagesFolderListItem2 = _interopRequireDefault(_messagesFolderListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.messages').directive('holdingMessagesFolderListItem', holdingMessagesFolderListItem).name;


function holdingMessagesFolderListItem(HoldingMessages) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      canDelete: '=?',
      folder: '=',
      message: '=',
      onDelete: '&?',
      onSave: '&?'
    },
    template: _messagesFolderListItem2.default
  };

  function link(scope, _element, attrs) {
    function isMessageRead() {
      return !HoldingMessages.canMarkReadFromFolder(scope.folder) || 'read' in scope.message;
    }

    function isMessageSaved() {
      return scope.message && 'saved' in scope.message && scope.message.saved;
    }

    scope.canDelete = 'canDelete' in attrs ? scope.canDelete : true;
    scope.canSave = HoldingMessages.canSaveFromFolder(scope.folder);
    scope.isMessageRead = isMessageRead;
    scope.isMessageSaved = isMessageSaved;
  }
}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-messages-folder-item ng-class=\"{\n    'gmw-messages-folder-item--unread': !isMessageRead()\n  }\"> <a href class=gmw-messages-folder-item__body ui-sref=\"holding.dashboard.messages.folder.message({\n      messageFolder: folder,\n      messageId: message.code\n    })\"> <span class=\"gmw-messages-folder-item__title h-default-text\" ng-bind=message.subject> </span> <span ng-bind=\"message.sent|gmwFormatDate:'MMMM DD, YYYY'\"></span> </a> <div class=gmw-messages-folder-item__actions ng-if=\"canDelete || canSave\"> <button ng-if=canSave class=gmw-messages-action-button ng-class=\"{\n        'gmw-messages-action-button--favorite': !message.saved,\n      }\" ng-click=onSave()> <div class=gmw-messages-action-button__inner> <svg class=gmw-messages-action-button__icon ng-class=\"{\n            'gmw-messages-action-button__icon--active': message.saved,\n          }\" width=20 height=20> <use xlink:href=#star-fill-icon ng-if=message.saved></use> <use xlink:href=#star-outline-icon ng-if=!message.saved></use> </svg> </div> </button> <button class=\"gmw-messages-action-button gmw-messages-action-button--delete gmw-messages-action-button--space\" ng-if=canDelete ng-click=onDelete()> <div class=gmw-messages-action-button__inner> <svg class=gmw-messages-action-button__icon width=18 height=19> <use xlink:href=#trash-icon></use> </svg> </div> </button> </div> </div> ";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messagesFolderListNewsItem = __webpack_require__(720);

var _messagesFolderListNewsItem2 = _interopRequireDefault(_messagesFolderListNewsItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.messages').directive('holdingMessagesFolderListNewsItem', holdingMessagesFolderListNewsItem).name;


function holdingMessagesFolderListNewsItem() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      message: '='
    },
    template: _messagesFolderListNewsItem2.default
  };
}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-messages-folder-item> <a href class=gmw-messages-folder-item__body ui-sref=\"holding.dashboard.messages.news.message({\n      messageId: message.code\n    })\"> <span class=\"gmw-messages-folder-item__title h-default-text\" ng-bind=message.title|holdingStripHtml> </span> <span ng-bind=\"message.ts|gmwFormatDate:'MMMM DD, YYYY'\"></span> </a> </div> ";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingMessagesSidebarList.$inject = ['$log', 'HoldingMessages'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messagesSidebarList = __webpack_require__(722);

var _messagesSidebarList2 = _interopRequireDefault(_messagesSidebarList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.messages').directive('holdingMessagesSidebarList', holdingMessagesSidebarList).name;


function holdingMessagesSidebarList($log, HoldingMessages) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      folder: '@',
      label: '@'
    },
    template: _messagesSidebarList2.default
  };

  function link(scope, _element, attrs) {
    function onFolderChanged() {
      HoldingMessages.getFolderMessages(scope.folder, {
        'dataLimit.limit': 3
      }).then(function (groupMessages) {
        scope.messages = groupMessages.messages;
      }).catch(function (error) {
        $log.error(error);
      });
    }

    scope.label = attrs.label || '';
    scope.$watch('folder', onFolderChanged);
  }
}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "<div class=holding-dashboard-sidebar__section ng-class=\"{\n    'holding-dashboard-sidebar__section--remove-border': !messages || messages.length < 1,\n  }\" ng-show=\"messages && messages.length\"> <h5 class=\"heading-h2 h-dark-text\" ng-bind=label> </h5> <ul class=gmw-messages-sidebar-list> <li ng-repeat=\"message in messages | limitTo:3 track by message.code\"> <a href class=gmw-messages-sidebar-list__item ui-sref=\"holding.dashboard.messages.folder.message({\n          messageFolder: folder,\n          messageId: message.code,\n        })\"> <span class=gmw-messages-sidebar-list__title> <span class=gmw-messages-sidebar-list__title-inner ng-bind=message.subject> </span> </span> <span ng-bind=\"message.sent|gmwFormatDate:'MMMM DD, YYYY'\"></span> </a> </li> </ul> <a href class=gmw-more-link ui-sref=\"holding.dashboard.messages.folder({\n      messageFolder: folder,\n    })\" ui-sref-opts=\"{\n      reload: true\n    }\"> <span ng-bind=\"'View All'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> ";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingMessagesSidebarNewsList.$inject = ['$log', 'HoldingMessages'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messagesSidebarNewsList = __webpack_require__(724);

var _messagesSidebarNewsList2 = _interopRequireDefault(_messagesSidebarNewsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.messages').directive('holdingMessagesSidebarNewsList', holdingMessagesSidebarNewsList).name;


function holdingMessagesSidebarNewsList($log, HoldingMessages) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {},
    template: _messagesSidebarNewsList2.default
  };

  function link(scope) {
    HoldingMessages.getNewsMessages().then(function (newsMessages) {
      scope.messages = newsMessages;
    }).catch(function (error) {
      $log.error(error);
    });
  }
}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "<div class=holding-dashboard-sidebar__section ng-class=\"{\n    'holding-dashboard-sidebar__section--remove-border': !messages,\n  }\" ng-show=messages> <h5 class=\"heading-h2 h-dark-text\" ng-bind=\"'Latest Service Updates'|translate\"> </h5> <ul class=gmw-messages-sidebar-list> <li ng-repeat=\"message in messages | limitTo:3 track by message.code\"> <a href class=gmw-messages-sidebar-list__item ui-sref=\"holding.dashboard.messages.news.message({\n          messageId: message.code,\n        })\"> <span class=gmw-messages-sidebar-list__title> <span class=gmw-messages-sidebar-list__title-inner ng-bind=message.title|holdingStripHtml> </span> </span> <span ng-bind=\"message.ts|gmwFormatDate:'MMMM DD, YYYY'\"></span> </a> </li> </ul> <a href class=gmw-more-link ui-sref=holding.dashboard.messages.news ui-sref-opts=\"{\n      reload: true,\n    }\"> <span ng-bind=\"'View All'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> ";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.messages').filter('holdingStripHtml', holdingStripHtml).name;


function holdingStripHtml() {
  'ngInject';

  return function (input) {
    var div = angular.element('<div></div>');
    div.html(input);
    return div.text().replace(/<\/?[^>]+>/g, '');
  };
}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingMessages.$inject = ['$q', 'HoldingApi', 'HoldingUser', 'gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.messages').factory('HoldingMessages', HoldingMessages).name;


function HoldingMessages($q, HoldingApi, HoldingUser, gettextCatalog) {
  'ngInject';

  var CONTENT_DELAY = 300000;
  var FOLDERS = [{
    id: 'inbox',
    name: gettextCatalog.getString('Inbox')
  }, {
    id: 'saved',
    name: gettextCatalog.getString('Saved Messages')
  }, {
    id: 'sent',
    name: gettextCatalog.getString('Sent Messages'),
    canMarkRead: false,
    canReply: false,
    canSave: false
  }];
  var FOLDER_DISPLAY_COUNT = 6;
  var FOLDER_DISPLAY_SORT_FIELD = 'dtm';
  var MESSAGE_CATEGORIES = [{
    type: 'BUY_SELL_EXCHANGE',
    description: gettextCatalog.getString('Metal buy/sell/exchange')
  }, {
    type: 'COLLECT_DELIVER_METAL',
    description: gettextCatalog.getString('Metal collection/delivery')
  }, {
    type: 'FUNDS_TRANSFER',
    description: gettextCatalog.getString('Funds transfers')
  }, {
    type: 'CONTACT',
    description: gettextCatalog.getString('Update contact details')
  }, {
    type: 'DOC',
    description: gettextCatalog.getString('Application submission')
  }, {
    type: 'GENERAL_QUESTIONS',
    description: gettextCatalog.getString('General questions')
  }, {
    type: 'OTHER',
    description: gettextCatalog.getString('Other')
  }];

  var SORT_OPTIONS = [{
    id: 'dtm',
    description: gettextCatalog.getString('Newest first'),
    type: 'desc'
  }, {
    id: 'subject',
    description: gettextCatalog.getString('By subject'),
    type: 'asc'
  }];

  var UNREAD_MESSAGES = void 0;

  return {
    canMarkReadFromFolder: canMarkReadFromFolder,
    canReplyFromFolder: canReplyFromFolder,
    canSaveFromFolder: canSaveFromFolder,
    deleteMessage: deleteMessage,
    getFolderDisplayCount: getFolderDisplayCount,
    getFolderDisplaySortField: getFolderDisplaySortField,
    getFolderFromId: getFolderFromId,
    getFolderMessage: getFolderMessage,
    getFolderMessages: getFolderMessages,
    getMessageCategoriesForSelector: getMessageCategoriesForSelector,
    getNewsMessage: getNewsMessage,
    getNewsMessages: getNewsMessages,
    getSortOptionById: getSortOptionById,
    getSortOptionsForSelector: getSortOptionsForSelector,
    getUnreadMessages: getUnreadMessages,
    getUnreadUpdateInterval: getUnreadUpdateInterval,
    markLocalMessageRead: markLocalMessageRead,
    markMessageRead: markMessageRead,
    saveMessage: saveMessage,
    sendMessage: sendMessage,
    sendReply: sendReply,
    showMessaging: showMessaging,
    showServiceUpdates: showServiceUpdates,
    unsaveMessage: unsaveMessage
  };

  function canMarkReadFromFolder(folderId) {
    var folder = getFolderFromId(folderId);

    return 'canMarkRead' in folder ? folder.canMarkRead : true;
  }

  function canReplyFromFolder(folderId) {
    var folder = getFolderFromId(folderId);

    return 'canReply' in folder ? folder.canReply : true;
  }

  function canSaveFromFolder(folderId) {
    var folder = getFolderFromId(folderId);
    return folder && 'canSave' in folder ? folder.canSave : true;
  }

  function deleteMessage(messageId) {
    return HoldingApi.post('messages/' + messageId + '/delete');
  }

  function getFolderDisplayCount() {
    return FOLDER_DISPLAY_COUNT;
  }

  function getFolderDisplaySortField() {
    return FOLDER_DISPLAY_SORT_FIELD;
  }

  function getFolderFromId(folderId) {
    return FOLDERS.find(function (folder) {
      return folder.id === folderId;
    });
  }

  function getFolderMessage(messageFolder, messageId) {
    return HoldingApi.get('messages/' + messageFolder + '?messageId=' + messageId);
  }

  function getFolderMessages(messageFolder) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return HoldingApi.get('messages/' + messageFolder, {
      params: Object.assign({}, {
        'dataLimit.offset': 0,
        'sorting.field': 'dtm',
        'sorting.type': 'desc'
      }, params)
    });
  }

  function getMessageCategoriesForSelector() {
    return $q.when(MESSAGE_CATEGORIES.map(function (category) {
      return {
        value: category.type,
        label: category.description
      };
    }));
  }

  function getNewsMessage(messageId) {
    var deferred = $q.defer();
    getNewsMessages().then(function (messages) {
      if (angular.isArray(messages)) {
        var message = messages.find(function (m) {
          return m.code === messageId;
        });
        deferred.resolve(message);
      } else {
        deferred.resolve(undefined);
      }
    });
    return deferred.promise;
  }

  function getNewsMessages() {
    return HoldingApi.get('news');
  }

  function getSortOptionById(sortOptionId) {
    return angular.copy(SORT_OPTIONS).find(function (option) {
      return option.id === sortOptionId;
    });
  }

  function getSortOptionsForSelector() {
    return $q.when(angular.copy(SORT_OPTIONS).map(function (option) {
      return {
        value: option.id,
        label: option.description
      };
    }));
  }

  function getUnreadMessages() {
    var bustCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!UNREAD_MESSAGES || bustCache) {
      return HoldingApi.get('messages/unread').then(function (unreadMessages) {
        UNREAD_MESSAGES = unreadMessages;
        return unreadMessages;
      });
    }
    return $q.when(UNREAD_MESSAGES);
  }

  function getUnreadUpdateInterval() {
    return angular.copy(CONTENT_DELAY);
  }

  function markLocalMessageRead(messageId, messages) {
    var readMessage = messages.find(function (message) {
      return message.code === messageId;
    });
    readMessage.read = true;
  }

  function markMessageRead(messageId) {
    return HoldingApi.post('messages/' + messageId + '/read');
  }

  function saveMessage(messageId) {
    return HoldingApi.post('messages/' + messageId + '/saved');
  }

  function sendMessage(category, subject, body) {
    var file = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return HoldingApi.upload('messages', file, {
      category: category,
      subject: subject,
      body: body
    });
  }

  function sendReply(messageId, reply) {
    var file = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return HoldingApi.upload('messages/' + messageId + '/reply', file, {
      reply: reply
    });
  }

  function showMessaging() {
    return HoldingUser.isAllowed('messaging');
  }

  function showServiceUpdates() {
    return HoldingUser.isAllowed('viewNews');
  }

  function unsaveMessage(messageId) {
    return HoldingApi.post('messages/' + messageId + '/inbox');
  }
}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(728);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(729);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.messages').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages', {
    abstract: true,
    data: {
      skipSetupCheck: true
    },
    url: '/messages',
    views: {
      hero: {
        controller: ['HoldingMessages', function controller(HoldingMessages) {
          this.showMessaging = HoldingMessages.showMessaging();
          this.showServiceUpdates = HoldingMessages.showServiceUpdates();
        }],
        controllerAs: 'messagesHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });
}]).name;


__webpack_require__(730);
__webpack_require__(733);
__webpack_require__(742);

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"'holding.dashboard.messages.compose'|isState\" ui-sref=\"holding.dashboard.messages.folder({\n          messageFolder: 'inbox'\n        })\"> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> </holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Messages'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Inbox'|translate\" ng-if=messagesHeroCtrl.showMessaging ui-sref=\"holding.dashboard.messages.folder({\n          messageFolder: 'inbox'\n        })\" ui-sref-opts=\"{\n          reload: true\n        }\" ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Sent Messages'|translate\" mobile-label=\"'Sent'|translate\" ng-if=messagesHeroCtrl.showMessaging ui-sref=\"holding.dashboard.messages.folder({\n          messageFolder: 'sent'\n        })\" ui-sref-opts=\"{\n          reload: true\n        }\" ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Service Updates'|translate\" mobile-label=\"'Updates'|translate\" ng-if=messagesHeroCtrl.showServiceUpdates ui-sref=holding.dashboard.messages.news ui-sref-opts=\"{\n          reload: true\n        }\" ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=\"holding-dashboard-hero-actions__right holding-dashboard-hero-actions__right--has-actions\"> <button class=small-main-cta ui-sref=holding.dashboard.messages.compose ng-bind=\"'New Message'|translate\"> </button> </section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=holding.dashboard.messages-main></div> ";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _compose = __webpack_require__(731);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.compose', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Messages - Compose New Message',
      skipSetupCheck: true
    },
    url: '/compose?category&subject',
    views: {
      'messages-main': {
        controller: 'MessagesComposeController',
        controllerAs: 'messagesComposeCtrl',
        template: _compose2.default
      }
    },
    resolve: {
      CanComposeMessageResolve: ['$q', 'HoldingUser', function CanComposeMessageResolve($q, HoldingUser) {
        'ngInject';

        if (!HoldingUser.isAllowed('messaging')) {
          return $q.reject({
            redirectTo: 'holding.dashboard.overview',
            params: {
              reload: true
            }
          });
        }
        return $q.resolve(true);
      }],
      MessageCategoriesResolve: ['$q', 'HoldingMessages', function MessageCategoriesResolve($q, HoldingMessages) {
        'ngInject';

        var deferred = $q.defer();
        HoldingMessages.getMessageCategoriesForSelector().then(function (messages) {
          deferred.resolve(messages);
        }).catch(function (error) {
          deferred.resolve(error);
        });
        return deferred.promise;
      }]
    }
  });
}]);

__webpack_require__(732);

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--center\" ng-form=messagesComposeCtrl.composeForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Create a New Message'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-bind=\"'Complete the below form to send a secure message to your personal Relationship Manager.'|translate\"> </p> </header> <div class=\"gmw-flow-box-container gmw-messages-compose\"> <div class=gmw-input-container> <gmw-box-selector required name=category no-label=true ng-model=messagesComposeCtrl.model.category options=messagesComposeCtrl.categories placeholder=\"{{'Select category'|translate}}\"> </gmw-box-selector> </div> <div class=gmw-input-container> <gmw-box-input name=subject no-label=true ng-model=messagesComposeCtrl.model.subject placeholder=\"{{'Subject'|translate}}\" required> </gmw-box-input> </div> <div class=gmw-input-container> <gmw-box-input class=gmw-messages-compose-textarea type=textarea name=body no-label=true ng-model=messagesComposeCtrl.model.body placeholder=\"{{'Enter your message here'|translate}}\" required> </gmw-box-input> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Upload Attachments'|translate\"> </label> <holding-file-upload ng-model=messagesComposeCtrl.model.file document-config=messagesComposeCtrl.fileUploadConfig no-browse-label> </holding-file-upload> </div> </div> <div ng-messages=messagesComposeCtrl.composeForm.$error> <div class=gmw-messages-compose-alert ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::messagesComposeCtrl.errorMessage></span> </holding-alert-legacy> </div> <div class=gmw-messages-compose-alert ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=\"gmw-messages-compose-alert success\" ng-if=messagesComposeCtrl.displaySentAlert> <span ng-bind=\"'Your message has been sent securely.'|translate\"></span> <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.folder({\n        messageFolder: 'sent'\n      })\" ui-sref-opts=\"{\n        reload: true\n      }\" ng-bind=\"'View message'|translate\"></a>. </holding-alert-legacy> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': messagesComposeCtrl.isSending\n        }\" holding-button-disabled=messagesComposeCtrl.composeForm.$invalid ng-click=messagesComposeCtrl.send() ng-bind=\"'Send Message'|translate\" type=submit> </button> </div> </footer> </div> ";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessagesComposeController.$inject = ['$log', '$stateParams', 'HoldingMessages', 'MessageCategoriesResolve'];
angular.module('app.holding.dashboard.messages').controller('MessagesComposeController', MessagesComposeController);

function MessagesComposeController($log, $stateParams, HoldingMessages, MessageCategoriesResolve) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.displaySentAlert = false;
  vm.fileUploadConfig = {
    extensions: ['.pdf', '.png', '.gif', '.jpg', '.jpeg'],
    maxFiles: 10,
    maxSize: '8000000',
    maxTotalSize: '50000000'
  };
  vm.isSending = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.send = send;

  function activate() {
    vm.categories = MessageCategoriesResolve;

    if ($stateParams.category) {
      vm.model.category = $stateParams.category;
    }
    if ($stateParams.subject) {
      vm.model.subject = $stateParams.subject;
    }
  }

  function clearForm() {
    vm.model.body = null;
    vm.model.category = null;
    vm.model.file = null;
    vm.model.subject = null;
    if (vm.composeForm) {
      vm.composeForm.$setUntouched();
      vm.composeForm.$setPristine();
    }
  }

  function send() {
    var uploadFile = 'file' in vm.model && vm.model.file ? vm.model.file : null;

    vm.isSending = true;

    HoldingMessages.sendMessage(vm.model.category, vm.model.subject, vm.model.body, uploadFile).then(function () {
      vm.displaySentAlert = true;
      clearForm();
    }).catch(function (error) {
      $log.error(error);

      if (vm.composeForm) {
        if ('data' in error && 'code' in error.data) {
          switch (error.data.code) {
            case 'INVALID_INPUT':
              vm.composeForm.$setValidity('input', false);
              vm.errorMessage = error.data.message;
              break;
            default:
              vm.composeForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.composeForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSending = false;
    });
  }

  activate();
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _folderFlow = __webpack_require__(734);

var _folderFlow2 = _interopRequireDefault(_folderFlow);

var _folder = __webpack_require__(735);

var _folder2 = _interopRequireDefault(_folder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.folder', {
    data: {
      flow: _folderFlow2.default,
      skipSetupCheck: true
    },
    resolve: {
      CanViewMessagesResolve: ['$q', 'HoldingUser', function CanViewMessagesResolve($q, HoldingUser) {
        'ngInject';

        if (!HoldingUser.isAllowed('messaging')) {
          return $q.reject({
            redirectTo: 'holding.dashboard.overview',
            params: {
              reload: true
            }
          });
        }
        return $q.resolve(true);
      }],
      MessagesResolve: ['$q', '$stateParams', 'HoldingMessages', 'CanViewMessagesResolve', function MessagesResolve($q, $stateParams, HoldingMessages, CanViewMessagesResolve) {
        'ngInject';

        var deferred = $q.defer();
        var folderPromises = [HoldingMessages.getFolderMessages($stateParams.messageFolder, {
          'dataLimit.limit': HoldingMessages.getFolderDisplayCount(),
          'sorting.field': HoldingMessages.getFolderDisplaySortField()
        })];
        if ($stateParams.messageFolder !== 'saved') {
          folderPromises.push(HoldingMessages.getFolderMessages('saved', {
            'dataLimit.limit': HoldingMessages.getFolderDisplayCount(),
            'sorting.field': HoldingMessages.getFolderDisplaySortField()
          }));
        }

        $q.all(folderPromises).then(function (messages) {
          deferred.resolve(messages);
        }).catch(function (error) {
          deferred.resolve(error);
        });
        return deferred.promise;
      }]
    },
    url: '/{messageFolder:inbox|saved|sent}',
    views: {
      'messages-main@holding.dashboard.messages': {
        controller: 'MessagesFolderController',
        controllerAs: 'messagesFolderCtrl',
        template: _folder2.default
      }
    }
  });

  $urlRouterProvider.when('/messages/inbox', '/messages/inbox/');
  $urlRouterProvider.when('/messages/saved', '/messages/saved/');
  $urlRouterProvider.when('/messages/sent', '/messages/sent/');
}]);

__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(739);

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var flow = {
    steps: [{
        key: 'list',
        state: 'holding.dashboard.messages.folder.list'
    }, {
        key: 'details',
        state: 'holding.dashboard.messages.folder.message'
    }]
};
exports.default = flow;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessagesFolderController.$inject = ['$stateParams', '$log', '$q', '$timeout', '$scope', 'HoldingMessages', 'GmwModal', 'MessagesResolve', 'gettextCatalog'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app.holding.dashboard.messages').controller('MessagesFolderController', MessagesFolderController);

function MessagesFolderController($stateParams, $log, $q, $timeout, $scope, HoldingMessages, GmwModal, MessagesResolve, gettextCatalog) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  var itemOffset = 0;
  var savedAlertTimer = void 0;

  vm.deleteMessage = deleteMessage;
  vm.displaySavedAlert = false;
  vm.displayUnsavedAlert = false;
  vm.getNewerMessages = getNewerMessages;
  vm.getOlderMessages = getOlderMessages;
  vm.hasNewerMessages = hasNewerMessages;
  vm.hasOlderMessages = hasOlderMessages;
  vm.isMessageSaved = isMessageSaved;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.model.data = {
    limit: HoldingMessages.getFolderDisplayCount(),
    offset: itemOffset
  };
  vm.reloadFolder = reloadFolder;
  vm.saveMessage = saveMessage;
  vm.showServiceUpdates = HoldingMessages.showServiceUpdates();

  function activate() {
    vm.model.folder = HoldingMessages.getFolderFromId($stateParams.messageFolder);
    if (vm.model.folder.id !== 'saved') {
      var _MessagesResolve = _slicedToArray(MessagesResolve, 2),
          folderMessages = _MessagesResolve[0],
          savedMessages = _MessagesResolve[1];

      vm.model.messages = calculateSavedMessages(folderMessages.messages);
      vm.model.messageCount = folderMessages.totals;
      vm.model.savedMessages = savedMessages.messages.map(function (message) {
        message.saved = true;
        return message;
      });
    } else {
      var _MessagesResolve2 = _slicedToArray(MessagesResolve, 1),
          _folderMessages = _MessagesResolve2[0];

      vm.model.messages = calculateSavedMessages(_folderMessages.messages);
      vm.model.messageCount = _folderMessages.totals;
    }
    vm.model.sort = {
      field: HoldingMessages.getFolderDisplaySortField(),
      type: 'desc'
    };

    HoldingMessages.getSortOptionsForSelector().then(function (sortOptions) {
      vm.sortOptions = sortOptions;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function calculateSavedMessages(allMessages) {
    return allMessages.map(function (message) {
      message.saved = folderExists() && vm.model.folder.id === 'saved';
      return message;
    });
  }

  function deleteMessage(message) {
    var confirmationPrompt = gettextCatalog.getString('Delete this message?');
    GmwModal.showConfirmationModal(confirmationPrompt).then(function () {
      vm.model.messages.splice(vm.model.messages.indexOf(message), 1);
      return HoldingMessages.deleteMessage(message.code);
    }).then(function () {
      reloadFolder();
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function displaySavedAlert() {
    $timeout.cancel(savedAlertTimer);
    vm.displaySavedAlert = true;
    savedAlertTimer = $timeout(function () {
      vm.displaySavedAlert = false;
    }, 10000);
  }

  function displayUnsavedAlert() {
    $timeout.cancel(savedAlertTimer);
    vm.displayUnsavedAlert = true;
    savedAlertTimer = $timeout(function () {
      vm.displayUnsavedAlert = false;
    }, 10000);
  }

  function folderExists() {
    return 'folder' in vm.model && 'name' in vm.model.folder && vm.model.folder.name && vm.model.folder.name.length > 0;
  }

  function getNewerMessages() {
    itemOffset = Math.max(itemOffset -= vm.model.data.limit, 0);
    reloadFolder();
  }

  function getOlderMessages() {
    itemOffset += vm.model.data.limit;
    reloadFolder();
  }

  function hasNewerMessages() {
    return vm.model.data.offset > 0;
  }

  function hasOlderMessages() {
    return vm.model.data.offset + vm.model.data.limit < vm.model.messageCount;
  }

  function isMessageSaved() {
    return folderExists() && vm.model.folder.id === 'saved';
  }

  function onDestroy() {
    $timeout.cancel(savedAlertTimer);
  }

  function onSortFieldChanged(newSortOption, oldSortOption) {
    if (newSortOption !== oldSortOption) {
      vm.model.sort.type = HoldingMessages.getSortOptionById(vm.model.sort.field).type;
      reloadFolder();
    }
  }

  function reloadFolder() {
    var folderPromises = [HoldingMessages.getFolderMessages($stateParams.messageFolder, {
      'dataLimit.limit': vm.model.data.limit,
      'dataLimit.offset': itemOffset,
      'sorting.field': vm.model.sort.field,
      'sorting.type': vm.model.sort.type
    })];
    if ($stateParams.messageFolder !== 'saved') {
      folderPromises.push(HoldingMessages.getFolderMessages('saved', {
        'dataLimit.limit': HoldingMessages.getFolderDisplayCount(),
        'sorting.field': HoldingMessages.getFolderDisplaySortField()
      }));
    }

    $q.all(folderPromises).then(function (reloadedMessages) {
      var folderMessages = void 0;
      var savedMessages = void 0;
      if (vm.model.folder.id !== 'saved') {
        var _reloadedMessages = _slicedToArray(reloadedMessages, 2);

        folderMessages = _reloadedMessages[0];
        savedMessages = _reloadedMessages[1];

        vm.model.messages = calculateSavedMessages(folderMessages.messages);
        vm.model.savedMessages = savedMessages.messages;
      } else {
        var _reloadedMessages2 = _slicedToArray(reloadedMessages, 1);

        folderMessages = _reloadedMessages2[0];

        vm.model.messages = calculateSavedMessages(folderMessages.messages);
      }

      vm.model.messageCount = folderMessages.totals;
      if (folderMessages.totals && folderMessages.totals <= itemOffset) {
        itemOffset = Math.max(itemOffset - vm.model.data.limit, 0);
        reloadFolder();
      }

      vm.model.data.offset = itemOffset;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function saveMessage(message) {
    if (message.saved) {
      HoldingMessages.unsaveMessage(message.code).then(function () {
        reloadFolder();
        displayUnsavedAlert();
      }).catch(function (error) {
        $log.error(error);
      });
    } else {
      HoldingMessages.saveMessage(message.code).then(function () {
        reloadFolder();
        displaySavedAlert();
      }).catch(function (error) {
        $log.error(error);
      });
    }
  }

  $scope.$on('$destroy', onDestroy);
  $scope.$watch(function () {
    return vm.model.sort.field;
  }, onSortFieldChanged);

  activate();
}

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _list = __webpack_require__(738);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.folder.list', {
    data: {
      pageTitle: 'Messages',
      skipSetupCheck: true
    },
    url: '/',
    views: {
      step: {
        template: _list2.default
      }
    }
  });
}]);

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-messages-mobile-new mobile-only mobile-only--xs\" ui-sref=holding.dashboard.messages.compose gmw-flow-hide-complete> <svg class=gmw-messages-mobile-new__icon> <use xlink:href=#plus-icon></use> </svg> <span class=heading-h5 ng-bind=\"'New Message'|translate\"></span> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=\"gmw-flow-box__header gmw-flow-box__header--has-actions gmw-messages-folder-header\"> <div class=gmw-flow-box__header-info-wrap> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=messagesFolderCtrl.model.folder.name> </h2> </div> <div class=gmw-flow-box__header-actions ng-if=\"messagesFolderCtrl.model.messages && messagesFolderCtrl.model.messages.length > 0\"> <gmw-box-selector required name=sort no-label=true ng-model=messagesFolderCtrl.model.sort.field options=messagesFolderCtrl.sortOptions> </gmw-box-selector> </div> </header> <section class=gmw-messages-folder-group> <div class=gmw-messages-folder-container> <holding-alert-legacy class=\"gmw-messages-folder-alert info\" ng-if=messagesFolderCtrl.displaySavedAlert> <span translate> Your message has been moved to your <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.folder({ messageFolder: 'saved' })\" ui-sref-opts=\"{ reload: true }\">'Saved' folder</a>. </span> </holding-alert-legacy> <holding-alert-legacy class=\"gmw-messages-folder-alert info\" ng-if=messagesFolderCtrl.displayUnsavedAlert> <span translate> Your message has been moved to your <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.folder({ messageFolder: 'inbox' })\" ui-sref-opts=\"{ reload: true }\">'Inbox' folder</a>. </span> </holding-alert-legacy> <div ng-if=\"!messagesFolderCtrl.model.messages || messagesFolderCtrl.model.messages.length === 0\" class=gmw-empty-state> <div class=\"gmw-empty-state__img gmw-empty-state__img--messages\"></div> <span class=\"heading-h3 h-light-text\" ng-bind=\"'No Messages'|translate\"> </span> </div> <holding-messages-folder-list-item folder=messagesFolderCtrl.model.folder.id message=message on-delete=messagesFolderCtrl.deleteMessage(message) on-save=messagesFolderCtrl.saveMessage(message) ng-repeat=\"message in messagesFolderCtrl.model.messages|limitTo:messagesFolderCtrl.displayCount track by message.code\"> </holding-messages-folder-list-item> </div> <footer class=\"gmw-flow-box-footer gmw-flow-box-footer--multi-button\" ng-if=\"messagesFolderCtrl.hasOlderMessages() || messagesFolderCtrl.hasNewerMessages() && messagesFolderCtrl.model.messages.length > 0\"> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ng-click=messagesFolderCtrl.getOlderMessages() ng-if=messagesFolderCtrl.hasOlderMessages()> <span ng-bind=\"'Older'|translate\"></span> </button> </div> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--align-right\"> <button class=\"medium-border-cta gmw-responsive-button\" ng-click=messagesFolderCtrl.getNewerMessages() ng-if=messagesFolderCtrl.hasNewerMessages()> <span ng-bind=\"'Newer'|translate\"></span> </button> </div> </footer> </section> <section ng-if=\"messagesFolderCtrl.model.savedMessages && messagesFolderCtrl.model.savedMessages.length > 0\" class=\"gmw-messages-folder-group mobile-only mobile-only--md\"> <header class=\"gmw-flow-box__header gmw-flow-box__header--has-actions gmw-messages-folder-header\" ng-if=\"messagesFolderCtrl.model.savedMessages && messagesFolderCtrl.model.savedMessages.length > 0 && messagesFolderCtrl.model.folder.id !== 'saved'\"> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Saved'|translate\"> </h2> </header> <div class=gmw-messages-folder-container> <holding-messages-folder-list-item folder=\"'saved'\" on-delete=messagesFolderCtrl.deleteMessage(message) on-save=messagesFolderCtrl.saveMessage(message) message=message ng-repeat=\"message in messagesFolderCtrl.model.savedMessages|limitTo:3 track by message.code\"> </holding-messages-folder-list-item> </div> <footer class=\"gmw-flow-box-footer gmw-flow-box-footer--multi-button\" ng-if=\"messagesFolderCtrl.hasOlderMessages() || messagesFolderCtrl.hasNewerMessages() && messagesFolderCtrl.model.messages.length > 0\"> <div class=gmw-flow-box-footer__col> <a class=\"medium-border-cta gmw-responsive-button\" ui-sref=\"holding.dashboard.messages.folder({\n              messageFolder: 'saved',\n            })\" ui-sref-opts=\"{\n              reload: true\n            }\"> <span ng-bind=\"'View All Saved'|translate\"></span> </a> </div> </footer> </section> </div> <div class=\"sidebar-app-view__sidebar holding-dashboard-sidebar\"> <holding-messages-sidebar-news-list ng-if=messagesFolderCtrl.showServiceUpdates> </holding-messages-sidebar-news-list> <holding-messages-sidebar-list folder=saved ng-if=\"messagesFolderCtrl.model.folder.id !== 'saved'\" label=\"{{'Saved Messages'|translate}}\"> </holding-messages-sidebar-list> </div> </section> ";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _message = __webpack_require__(740);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.folder.message', {
    data: {
      pageTitle: 'Messages - Message Details',
      skipSetupCheck: true
    },
    resolve: {
      CanViewMessagesResolve: ['$q', 'HoldingUser', function CanViewMessagesResolve($q, HoldingUser) {
        'ngInject';

        if (!HoldingUser.isAllowed('messaging')) {
          return $q.reject({
            redirectTo: 'holding.dashboard.overview',
            params: {
              reload: true
            }
          });
        }
        return $q.resolve(true);
      }],
      MessageResolve: ['$q', '$stateParams', 'HoldingMessages', 'CanViewMessagesResolve', function MessageResolve($q, $stateParams, HoldingMessages, CanViewMessagesResolve) {
        'ngInject';

        var deferred = $q.defer();
        HoldingMessages.getFolderMessage($stateParams.messageFolder, $stateParams.messageId).then(function (response) {
          if ('messages' in response && angular.isArray(response.messages) && response.messages.length > 0) {
            deferred.resolve(response.messages[0]);
          } else {
            deferred.resolve(false);
          }
        }).catch(function (error) {
          deferred.resolve(error);
        });
        return deferred.promise;
      }]
    },
    url: '/{messageId:int}',
    views: {
      step: {
        controller: 'MessagesFolderMessageController',
        controllerAs: 'messagesFolderMessageCtrl',
        template: _message2.default
      }
    }
  });
}]);

__webpack_require__(741);

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ng-form=messagesFolderMessageCtrl.replyForm> <header class=\"gmw-flow-box__header gmw-flow-box__header--has-actions\"> <div class=gmw-flow-box__header-info-wrap> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=messagesFolderMessageCtrl.model.message.subject> </h2> <p class=\"gmw-flow-box__header-description h-gold-text\" ng-bind=\"messagesFolderMessageCtrl.model.message.sent|gmwFormatDate:'MMMM DD, YYYY'\"> </p> </div> <div class=\"gmw-flow-box__header-actions desktop-only desktop-only--xs\"> <button ng-if=\"messagesFolderMessageCtrl.canSaveMessage() && !messagesFolderMessageCtrl.isMessageSaved()\" class=\"gmw-messages-action-button gmw-messages-action-button--favorite\" ng-click=messagesFolderMessageCtrl.saveMessage()> <div class=gmw-messages-action-button__inner> <svg class=gmw-messages-action-button__icon width=20 height=20> <use xlink:href=#star-outline-icon></use> </svg> </div> </button> <button ng-if=messagesFolderMessageCtrl.isMessageSaved() class=\"gmw-messages-action-button gmw-messages-action-button--active\"> <div class=gmw-messages-action-button__inner> <svg class=\"gmw-messages-action-button__icon gmw-messages-action-button__icon--active\" width=20 height=20> <use xlink:href=#star-fill-icon></use> </svg> </div> </button> <button class=\"gmw-messages-action-button gmw-messages-action-button--space\" ng-click=messagesFolderMessageCtrl.printMessage()> <div class=gmw-messages-action-button__inner> <svg class=gmw-messages-action-button__icon width=20 height=23> <use xlink:href=#gmw-print-icon></use> </svg> </div> </button> <button class=\"gmw-messages-action-button gmw-messages-action-button--delete gmw-messages-action-button--space\" ng-click=messagesFolderMessageCtrl.deleteMessage()> <div class=gmw-messages-action-button__inner> <svg class=gmw-messages-action-button__icon width=18 height=19> <use xlink:href=#trash-icon></use> </svg> </div> </button> </div> </header> <div class=gmw-flow-box-container> <div class=\"gmw-messages-msg-content h-default-text\" ng-class-even=\"'gmw-messages-msg-content--alt'\" ng-repeat=\"message in messagesFolderMessageCtrl.model.thread track by $index\" ng-bind=::(message)> </div> </div> <form class=gmw-messages-msg-footer ng-if=messagesFolderMessageCtrl.canReplyMessage()> <div ng-messages=messagesFolderMessageCtrl.replyForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::messagesComposeCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=success ng-if=messagesFolderMessageCtrl.displaySentAlert> <span ng-bind=\"'Your reply message has been sent securely.'|translate\"></span> <a class=gmw-alert-link ui-sref=\"holding.dashboard.messages.folder({\n            messageFolder: 'sent'\n          })\" ui-sref-opts=\"{\n            reload: true\n          }\" ng-bind=\"'View sent messages'|translate\"></a>. </holding-alert-legacy> <gmw-box-input type=textarea name=reply no-label=true ng-model=messagesFolderMessageCtrl.model.reply placeholder=\"{{'Enter your message here'|translate}}\" required> </gmw-box-input> <div class=gmw-messages-msg-footer__actions> <div class=gmw-messages-msg-footer__actions-col> <a href=javascript:; class=heading-h6 ng-click=messagesFolderMessageCtrl.openUploadDialog() ng-show=!messagesFolderMessageCtrl.hasFileUpload() ng-bind=\"'Upload Attachment'|translate\"> </a> <div ng-if=messagesFolderMessageCtrl.hasFileUpload() class=gmw-messages-attachment ng-repeat=\"file in messagesFolderMessageCtrl.model.file track by $index\"> <svg class=gmw-messages-attachment__icon> <use xlink:href=#file-line-icon></use> </svg> <span class=h-dark-text ng-bind=file.name> </span> <span class=gmw-messages-attachment__file-size ng-bind=\"messagesFolderMessageCtrl.fileUploadSize(file) + 'MB'\"> </span> <svg class=gmw-messages-attachment__remove ng-click=messagesFolderMessageCtrl.clearFile(file)> <use xlink:href=#cross-icon></use> </svg> </div> </div> <div class=gmw-messages-msg-footer__actions-col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n              'loading-button': messagesFolderMessageCtrl.isSending\n            }\" holding-button-disabled=messagesFolderMessageCtrl.replyForm.$invalid ng-click=messagesFolderMessageCtrl.sendReply()> <span ng-bind=\"'Send Message'|translate\"></span> </button> </div> </div> </form> </div> <div class=\"sidebar-app-view__sidebar holding-dashboard-sidebar\"> <holding-messages-sidebar-news-list ng-if=messagesFolderMessageCtrl.showServiceUpdates> </holding-messages-sidebar-news-list> <holding-messages-sidebar-list folder=saved label=\"{{'Saved Messages'|translate}}\"> </holding-messages-sidebar-list> </div> </section> ";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessagesFolderMessageController.$inject = ['$log', '$state', '$scope', '$window', '$filter', '$stateParams', 'HoldingMessages', 'GmwModal', 'MessageResolve', 'gettextCatalog'];
angular.module('app.holding.dashboard.messages').controller('MessagesFolderMessageController', MessagesFolderMessageController);

function MessagesFolderMessageController($log, $state, $scope, $window, $filter, $stateParams, HoldingMessages, GmwModal, MessageResolve, gettextCatalog) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.canReplyMessage = canReplyMessage;
  vm.canSaveMessage = canSaveMessage;
  vm.clearFile = clearFile;
  vm.deleteMessage = deleteMessage;
  vm.displaySentAlert = false;
  vm.fileUploadSize = fileUploadSize;
  vm.hasFileUpload = hasFileUpload;
  vm.isMessageSaved = isMessageSaved;
  vm.isSending = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.openUploadDialog = openUploadDialog;
  vm.printMessage = printMessage;
  vm.saveMessage = saveMessage;
  vm.sendReply = sendReply;
  vm.showServiceUpdates = HoldingMessages.showServiceUpdates();

  function activate() {
    vm.model.folder = $stateParams.messageFolder;
    vm.model.message = MessageResolve;

    if (MessageResolve) {
      if (HoldingMessages.canMarkReadFromFolder(vm.model.folder) && !isMessageRead()) {
        HoldingMessages.markMessageRead(vm.model.message.code);
        HoldingMessages.markLocalMessageRead(vm.model.message.code, $scope.messagesFolderCtrl.model.messages);
      }

      createMessageThread();
    }
  }

  function canReplyMessage() {
    return HoldingMessages.canReplyFromFolder(vm.model.folder);
  }

  function canSaveMessage() {
    return HoldingMessages.canSaveFromFolder(vm.model.folder);
  }

  function clearForm() {
    vm.model.file = null;
    vm.model.reply = null;
    if (vm.replyForm) {
      vm.replyForm.$setUntouched();
      vm.replyForm.$setPristine();
    }
  }

  function clearFile(file) {
    if ('file' in vm.model && vm.model.file !== null) {
      vm.model.file.splice(vm.model.file.indexOf(file), 1);
    }
  }

  function createMessageThread() {
    vm.model.thread = vm.model.message.body.split('----------').map(function (threadedMessage) {
      return threadedMessage.trim();
    });
  }

  function deleteMessage() {
    var confirmationPrompt = gettextCatalog.getString('Delete this message?');
    GmwModal.showConfirmationModal(confirmationPrompt).then(function () {
      return HoldingMessages.deleteMessage(vm.model.message.code);
    }).then(function () {
      $state.go('^', {}, {
        reload: true
      });
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function fileUploadSize(file) {
    return file !== null && 'size' in file ? $filter('number')(file.size / 1000000, 2) : 0;
  }

  function folderExists() {
    return 'folder' in vm.model && angular.isString(vm.model.folder);
  }

  function hasFileUpload() {
    return 'file' in vm.model && vm.model.file !== null && angular.isArray(vm.model.file) && vm.model.file.length > 0;
  }

  function isMessageRead() {
    return 'message' in vm.model && 'read' in vm.model.message;
  }

  function isMessageSaved() {
    return folderExists() && vm.model.folder === 'saved' || 'message' in vm.model && vm.model.message && 'saved' in vm.model.message && vm.model.message.saved;
  }

  function openUploadDialog() {
    var uploadConfig = {
      extensions: ['.pdf', '.png', '.gif', '.jpg', '.jpeg'],
      maxFiles: 10,
      maxSize: '8000000',
      maxTotalSize: '50000000'
    };
    var uploadPrompt = gettextCatalog.getString('Upload Attachment');

    GmwModal.showUploadModal(uploadPrompt, uploadConfig).then(function (file) {
      vm.model.file = file;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function printMessage() {
    $window.print();
  }

  function saveMessage() {
    HoldingMessages.saveMessage(vm.model.message.code).then(function () {
      $state.go('holding.dashboard.messages.folder.message', {
        messageFolder: 'saved',
        messageId: vm.model.message.code
      });
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function sendReply() {
    var uploadFile = 'file' in vm.model && vm.model.file ? vm.model.file : null;

    vm.isSending = true;

    HoldingMessages.sendReply(vm.model.message.code, vm.model.reply, uploadFile).then(function () {
      vm.displaySentAlert = true;
      clearForm();
    }).catch(function (error) {
      $log.error(error);

      if (vm.replyForm) {
        if ('data' in error && 'code' in error.data) {
          switch (error.data.code) {
            case 'INVALID_INPUT':
              vm.replyForm.$setValidity('input', false);
              vm.errorMessage = error.data.message;
              break;
            default:
              vm.replyForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.replyForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSending = false;
    });
  }

  activate();
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _newsFlow = __webpack_require__(743);

var _newsFlow2 = _interopRequireDefault(_newsFlow);

var _news = __webpack_require__(744);

var _news2 = _interopRequireDefault(_news);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.news', {
    data: {
      flow: _newsFlow2.default,
      skipSetupCheck: true
    },
    resolve: {
      CanViewNewsResolve: ['$q', 'HoldingUser', function CanViewNewsResolve($q, HoldingUser) {
        'ngInject';

        if (!HoldingUser.isAllowed('viewNews')) {
          return $q.reject({
            redirectTo: 'holding.dashboard.overview',
            params: {
              reload: true
            }
          });
        }
        return $q.resolve(true);
      }],
      MessagesResolve: ['$q', 'HoldingMessages', 'CanViewNewsResolve', function MessagesResolve($q, HoldingMessages, CanViewNewsResolve) {
        'ngInject';

        var deferred = $q.defer();
        HoldingMessages.getNewsMessages().then(function (messages) {
          deferred.resolve(messages);
        }).catch(function (error) {
          deferred.resolve(error);
        });
        return deferred.promise;
      }]
    },
    url: '/news',
    views: {
      'messages-main@holding.dashboard.messages': {
        controller: 'MessagesNewsController',
        controllerAs: 'messagesNewsCtrl',
        template: _news2.default
      }
    }
  });

  $urlRouterProvider.when('/messages/news', '/messages/news/');
}]);

__webpack_require__(745);
__webpack_require__(747);
__webpack_require__(750);

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Messages'),
    sidebar: false,
    steps: [{
        key: 'list',
        state: 'holding.dashboard.messages.news.list'
    }, {
        key: 'details',
        state: 'holding.dashboard.messages.news.message'
    }]
};
exports.default = flow;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _list = __webpack_require__(746);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.news.list', {
    data: {
      pageTitle: 'Messages - Service Updates',
      skipSetupCheck: true
    },
    resolve: {
      CanViewNewsResolve: ['$q', 'HoldingUser', function CanViewNewsResolve($q, HoldingUser) {
        'ngInject';

        if (!HoldingUser.isAllowed('viewNews')) {
          return $q.reject({
            redirectTo: 'holding.dashboard.overview',
            params: {
              reload: true
            }
          });
        }
        return $q.resolve(true);
      }]
    },
    url: '/',
    views: {
      step: {
        template: _list2.default
      }
    }
  });
}]);

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=\"gmw-flow-box__header gmw-messages-folder-header\"> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Service Updates'|translate\"></h2> </header> <div class=gmw-messages-folder-container> <div ng-if=\"!messagesNewsCtrl.model.messages && messagesNewsCtrl.model.messages.length === 0\" class=gmw-empty-state> <div class=\"gmw-empty-state__img gmw-empty-state__img--messages\"></div> <span class=\"heading-h3 h-light-text\" ng-bind=\"'No Messages'|translate\"> </span> </div> <holding-messages-folder-list-news-item message=message ng-repeat=\"message in messagesNewsCtrl.model.messages track by message.code\"> </holding-messages-folder-list-news-item> </div> </div> <div class=\"sidebar-app-view__sidebar holding-dashboard-sidebar\"> <holding-messages-sidebar-news-list ng-if=holding.dashboard.messagesNewsMessageCtrl.showServiceUpdates> </holding-messages-sidebar-news-list> <holding-messages-sidebar-list folder=saved label=\"{{'Saved Messages'|translate}}\"> </holding-messages-sidebar-list> </div> </section> ";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _message = __webpack_require__(748);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.messages').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.messages.news.message', {
    data: {
      pageTitle: 'Messages - Service Updates - Update Details',
      skipSetupCheck: true
    },
    resolve: {
      CanViewNewsResolve: ['$q', 'HoldingUser', function CanViewNewsResolve($q, HoldingUser) {
        'ngInject';

        if (!HoldingUser.isAllowed('viewNews')) {
          return $q.reject({
            redirectTo: 'holding.dashboard.overview',
            params: {
              reload: true
            }
          });
        }
        return $q.resolve(true);
      }],
      MessageResolve: ['$q', '$stateParams', 'HoldingMessages', 'CanViewNewsResolve', function MessageResolve($q, $stateParams, HoldingMessages, CanViewNewsResolve) {
        'ngInject';

        var deferred = $q.defer();
        HoldingMessages.getNewsMessage($stateParams.messageId).then(function (message) {
          deferred.resolve(message);
        }).catch(function (error) {
          deferred.resolve(error);
        });
        return deferred.promise;
      }]
    },
    url: '/{messageId:int}',
    views: {
      heroNoMobileActionTabs: true,
      step: {
        controller: 'MessagesNewsMessageController',
        controllerAs: 'messagesNewsMessageCtrl',
        template: _message2.default
      }
    }
  });
}]);

__webpack_require__(749);

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "<section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=messagesNewsMessageCtrl.model.message.title|holdingStripHtml> </h2> <p class=\"gmw-flow-box__header-description h-gold-text\" ng-bind=\"messagesNewsMessageCtrl.model.message.ts|gmwFormatDate:'MMMM DD, YYYY'\"> </p> </header> <div class=gmw-flow-box-container> <div class=\"gmw-messages-msg-content gmw-messages-msg-content--full h-default-text\" ng-bind=::(messagesNewsMessageCtrl.model.message.body|holdingStripHtml)> </div> </div> </div> <div class=\"sidebar-app-view__sidebar holding-dashboard-sidebar\"> <holding-messages-sidebar-news-list ng-if=messagesNewsMessageCtrl.showServiceUpdates> </holding-messages-sidebar-news-list> <holding-messages-sidebar-list folder=saved label=\"{{'Saved Messages'|translate}}\"> </holding-messages-sidebar-list> </div> </section> ";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessagesNewsMessageController.$inject = ['HoldingMessages', 'MessageResolve'];
angular.module('app.holding.dashboard.messages').controller('MessagesNewsMessageController', MessagesNewsMessageController);

function MessagesNewsMessageController(HoldingMessages, MessageResolve) {
  'ngInject';

  var DEFAULT_MODEL = {};
  var vm = this;

  vm.model = angular.copy(DEFAULT_MODEL);
  vm.showServiceUpdates = HoldingMessages.showServiceUpdates();

  function activate() {
    vm.model.message = MessageResolve;
  }

  activate();
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessagesNewsController.$inject = ['MessagesResolve'];
angular.module('app.holding.dashboard.messages').controller('MessagesNewsController', MessagesNewsController);

function MessagesNewsController(MessagesResolve) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  vm.model = angular.copy(DEFAULT_MODEL);

  function activate() {
    vm.model.messages = MessagesResolve;
  }

  activate();
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview', ['angular-promise-cache', _angularjs2.default, _common2.default]).name;


__webpack_require__(752);
__webpack_require__(754);
__webpack_require__(756);
__webpack_require__(758);
__webpack_require__(760);
__webpack_require__(762);
__webpack_require__(764);
__webpack_require__(766);
__webpack_require__(768);
__webpack_require__(770);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingOverviewSidebarMarkets.$inject = ['$scope', '$timeout', '$interval', 'HoldingUser', 'HoldingMarkets', 'HoldingCurrencies', 'HoldingTroyRate', 'HoldingVaults'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overviewSidebarMarkets = __webpack_require__(753);

var _overviewSidebarMarkets2 = _interopRequireDefault(_overviewSidebarMarkets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').component('holdingOverviewSidebarMarkets', {
  controller: holdingOverviewSidebarMarkets,
  template: _overviewSidebarMarkets2.default
}).name;


function holdingOverviewSidebarMarkets($scope, $timeout, $interval, HoldingUser, HoldingMarkets, HoldingCurrencies, HoldingTroyRate, HoldingVaults) {
  'ngInject';

  function cancelTimers() {
    $interval.cancel(contentTimer);
    $timeout.cancel(contentUpdatingTimer);
    $timeout.cancel(ratesUpdatingTimer);
  }

  function findGoldRate(rates, quoteCurrency) {
    return findRateGroupByCurrency(rates, quoteCurrency).find(function (_) {
      return _.quoteCurrency === quoteCurrency && _.baseCurrency === 'Gold';
    }).avg;
  }

  function findMetalRate(rates, baseCurrency) {
    var rate = findRateGroupByCurrency(rates, baseCurrency).find(function (_) {
      return _.baseCurrency === baseCurrency && _.quoteCurrency === vm.model.currency;
    });

    if (vm.model.units === 'oz') {
      return {
        amount: rate.avg * (baseCurrency === 'Silver' ? 1 : HoldingTroyRate),
        currency: rate.quoteCurrency
      };
    }

    return {
      amount: rate.avg / (baseCurrency === 'Silver' ? HoldingTroyRate : 1),
      currency: rate.quoteCurrency
    };
  }

  function findMetalSpotPriceByCurrency(rates, baseCurrency, type) {
    var spotRate = rates.find(function (_) {
      return _.baseCurrency === baseCurrency && _.quoteCurrency === vm.model.currency;
    });
    if (vm.model.units === 'oz') {
      return {
        amount: spotRate[type] * (baseCurrency === 'Silver' ? 1 : HoldingTroyRate),
        currency: vm.model.currency
      };
    }

    return {
      amount: spotRate[type] / (baseCurrency === 'Silver' ? HoldingTroyRate : 1),
      currency: vm.model.currency
    };
  }

  function findRateGroupByCurrency(rates, baseCurrency) {
    var rateGroupIndex = 0;
    rates.forEach(function (ratesGroup, idx) {
      if (ratesGroup[idx].baseCurrency === baseCurrency) {
        rateGroupIndex = idx;
      }
    });
    return rates[rateGroupIndex];
  }

  function isMetal(product) {
    switch (product) {
      case 'Gold':
      case 'Silver':
      case 'Platinum':
      case 'Palladium':
        return true;
      default:
        return false;
    }
  }

  function onMetalCurrencyChanged() {
    updateMarketData();
  }

  function onMetalVaultChanged(vault, prevVault) {
    if (vault !== prevVault) {
      vm.isContentUpdating = true;
      startUpdating();
      updateMarketData();
    }
  }

  function onMetalUnitChanged() {
    updateMarketData();
  }

  function onRatesChanged() {
    updateMarketData();
  }

  function startUpdating() {
    cancelTimers();
    updateRates(vm.model.vault);
    contentTimer = $interval(function () {
      updateRates(vm.model.vault);
    }, CONTENT_DELAY);
  }

  function updateMarketData() {
    if (vm.rates && '24h' in vm.rates && 'current' in vm.rates) {
      var metals = [];
      vm.rates.current.forEach(function (current) {
        return metals.push(current[0].baseCurrency);
      });

      vm.metals = metals.filter(isMetal).map(function (baseCurrency) {
        var price24h = findMetalRate(vm.rates['24h'], baseCurrency);
        var price = {
          avg: findMetalRate(vm.rates.current, baseCurrency),
          bid: findMetalSpotPriceByCurrency(vm.rates.spot, baseCurrency, 'bid'),
          ask: findMetalSpotPriceByCurrency(vm.rates.spot, baseCurrency, 'ask')
        };

        return {
          baseCurrency: baseCurrency,
          price: price,
          change24h: ((price.avg.amount - price24h.amount) / price24h.amount * 100).toFixed(2)
        };
      });

      vm.fx = fxItems.map(function (_ref) {
        var quoteCurrency = _ref.quoteCurrency,
            baseCurrency = _ref.baseCurrency;

        var price24h = findGoldRate(vm.rates['24h'], quoteCurrency);
        var basePrice24h = findGoldRate(vm.rates['24h'], baseCurrency);

        var price = findGoldRate(vm.rates.current, quoteCurrency);
        var basePrice = findGoldRate(vm.rates.current, baseCurrency);

        var rate = (basePrice / price).toFixed(4);
        var rate24h = (basePrice24h / price24h).toFixed(4);
        var change24h = ((rate - rate24h) / rate24h * 100).toFixed(2);

        return {
          quoteCurrency: quoteCurrency,
          baseCurrency: baseCurrency,
          rate: rate,
          change24h: change24h
        };
      });

      contentUpdatingTimer = $timeout(function () {
        vm.isContentUpdating = false;
      }, 500);
    }
  }

  function updateRates(vault) {
    if (!vm.isContentUpdating) {
      vm.areRatesUpdating = true;
    }
    return HoldingMarkets.getSummary(vault).then(function (rates) {
      vm.rates = rates;

      ratesUpdatingTimer = $timeout(function () {
        vm.areRatesUpdating = false;
      }, 500);
    });
  }

  var CONTENT_DELAY = 60000;
  var DEFAULT_MODEL = {
    units: 'g',
    tableOption: 'metals',
    vault: ''
  };

  var fxItems = [{
    quoteCurrency: 'EUR',
    baseCurrency: 'USD'
  }, {
    quoteCurrency: 'USD',
    baseCurrency: 'JPY'
  }, {
    quoteCurrency: 'GBP',
    baseCurrency: 'USD'
  }, {
    quoteCurrency: 'AUD',
    baseCurrency: 'USD'
  }, {
    quoteCurrency: 'USD',
    baseCurrency: 'CAD'
  }, {
    quoteCurrency: 'USD',
    baseCurrency: 'CHF'
  }];
  var user = HoldingUser.get();
  var vm = this;
  var contentTimer = void 0,
      contentUpdatingTimer = void 0,
      ratesUpdatingTimer = void 0;

  vm.areRatesUpdating = false;
  vm.currencies = HoldingCurrencies.getAllFiatForSelector();
  vm.isContentUpdating = true;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.model.currency = angular.copy(user.currency);
  vm.vaults = HoldingVaults.getVaultsForSelector();
  vm.vaults.unshift({
    value: '',
    label: 'Best prices from all vaults'
  });

  vm.$onDestroy = function () {
    cancelTimers();
  };

  vm.$onInit = function () {
    startUpdating();

    $scope.$watch(function () {
      return vm.model.currency;
    }, onMetalCurrencyChanged);
    $scope.$watch(function () {
      return vm.model.units;
    }, onMetalUnitChanged);
    $scope.$watch(function () {
      return vm.model.vault;
    }, onMetalVaultChanged);
    $scope.$watch(function () {
      return vm.rates;
    }, onRatesChanged, true);
  };
}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "<section class=holding-floating-sidebar-section> <h5 class=\"heading-h2 h-dark-text holding-floating-sidebar-heading\" ng-bind=\"'Market Summary'|translate\"> </h5> <gmw-toggle-option-group ng-model=$ctrl.model.tableOption> <gmw-toggle-option value=\"'metals'\" label=\"{{'Metals'|translate}}\"> </gmw-toggle-option> <gmw-toggle-option value=\"'fx'\" label=\"{{'FX'|translate}}\"> </gmw-toggle-option> </gmw-toggle-option-group> <div ng-switch=$ctrl.model.tableOption> <div class=gmw-summary-table-quad ng-switch-when=metals> <div class=gmw-summary-table-quad__tools> <div class=gmw-summary-table-quad__tools-col> <gmw-toggle-option-group ng-model=$ctrl.model.units> <gmw-toggle-option value=\"'g'\" label=\"{{'G'|translate}}\"> </gmw-toggle-option> <gmw-toggle-option value=\"'oz'\" label=\"{{'OZ'|translate}}\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=gmw-summary-table-quad__tools-col> <gmw-box-selector required name=category no-label=true ng-model=$ctrl.model.currency options=$ctrl.currencies> </gmw-box-selector> </div> </div> <gmw-box-selector ng-model=$ctrl.model.vault options=$ctrl.vaults placeholder=\"{{'Best prices from all vaults'|translate}}\" no-label=true> </gmw-box-selector> <header class=gmw-summary-table-quad__header> <div class=gmw-summary-table-quad__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'Metal'|translate\"> </span> </div> <div class=gmw-summary-table-quad__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'24hr'|translate\"> </span> </div> <div class=gmw-summary-table-quad__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'Sell'|translate\"> </span> </div> <div class=gmw-summary-table-quad__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'Buy'|translate\"> </span> </div> <div class=gmw-summary-table-spinner ng-class=\"{\n            'gmw-summary-table-spinner--show': $ctrl.areRatesUpdating,\n          }\"> </div> </header> <div class=gmw-summary-table-quad__body> <div class=gmw-summary-table-loading-overlay ng-class=\"{\n            'gmw-summary-table-loading-overlay--show': $ctrl.isContentUpdating,\n          }\"> </div> <div class=gmw-summary-table-quad__row ng-repeat=\"metal in $ctrl.metals track by $index\"> <div class=gmw-summary-table-quad__col> <holding-metal-badge metal=metal.baseCurrency></holding-metal-badge> <span class=h-small-text ng-bind=\"metal.baseCurrency | translate\"></span> </div> <div class=gmw-summary-table-quad__col> <holding-percentage-change class=h-small-text percentage=metal.change24h> </holding-percentage-change> </div> <div class=gmw-summary-table-quad__col> <span class=h-small-text ng-bind=metal.price.bid|holdingFormatFunds:3> </span> </div> <div class=gmw-summary-table-quad__col> <span class=h-small-text ng-bind=metal.price.ask|holdingFormatFunds:3> </span> </div> </div> </div> </div> <div class=gmw-summary-table ng-switch-when=fx> <header class=gmw-summary-table__header> <div class=gmw-summary-table__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'Currency'|translate\"> </span> </div> <div class=gmw-summary-table__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'24hr'|translate\"> </span> </div> <div class=gmw-summary-table__col> <span class=\"heading-h6 h-light-text\" ng-bind=\"'Rate'|translate\"> </span> </div> <div class=gmw-summary-table-spinner ng-class=\"{\n            'gmw-summary-table-spinner--show': $ctrl.areRatesUpdating,\n          }\"> </div> </header> <div class=gmw-summary-table__body> <div class=gmw-summary-table-loading-overlay ng-class=\"{\n            'gmw-summary-table-loading-overlay--show': $ctrl.isContentUpdating,\n          }\"> </div> <div class=gmw-summary-table__row ng-repeat=\"item in $ctrl.fx track by $index\"> <div class=gmw-summary-table__col> <span class=\"h-small-text h-dark-text\" ng-bind=\"item.quoteCurrency + '/' + item.baseCurrency\"> </span> </div> <div class=gmw-summary-table__col> <holding-percentage-change class=h-small-text percentage=item.change24h> </holding-percentage-change> </div> <div class=gmw-summary-table__col> <span class=h-small-text ng-bind=item.rate> </span> </div> </div> </div> </div> </div> </section> ";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingOverviewSidebarResearch.$inject = ['$scope', '$interval', 'HoldingResearch', 'HoldingEnvironment'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overviewSidebarResearch = __webpack_require__(755);

var _overviewSidebarResearch2 = _interopRequireDefault(_overviewSidebarResearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').component('holdingOverviewSidebarResearch', {
  controller: holdingOverviewSidebarResearch,
  template: _overviewSidebarResearch2.default
}).name;


function holdingOverviewSidebarResearch($scope, $interval, HoldingResearch, HoldingEnvironment) {
  'ngInject';

  function onDestroy() {
    $interval.cancel(contentTimer);
  }

  function updateContent() {
    HoldingResearch.getResearch().then(function (data) {
      vm.research = data;
    });
  }

  var CONTENT_DELAY = 300000;

  var vm = this;
  var contentTimer = void 0;

  vm.makeURL = function (pathname) {
    return HoldingEnvironment.urls.site + '/research/' + pathname;
  };

  updateContent();
  contentTimer = $interval(function () {
    updateContent();
  }, CONTENT_DELAY);

  $scope.$on('$destroy', onDestroy);
}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "<section class=holding-floating-sidebar-section> <h5 class=\"heading-h2 h-dark-text holding-floating-sidebar-heading\" ng-bind=\"'Latest Insights'|translate\"> </h5> <div class=gmw-research-list> <a ng-href=\"{{$ctrl.makeURL(item.slug)}}\" target=_blank class=gmw-research-list__item ng-repeat=\"item in $ctrl.research|limitTo:3 track by $index\"> <h4 class=\"gmw-research-list__title h-dark-text h-default-text\" ng-bind=item.title> </h4> <div class=gmw-research-list__meta> <span class=\"heading-h6 h-light-text\" ng-bind=\"item.pubDate.format('LL')\"> </span> <span class=\"gmw-dot gmw-dot--light\">&middot;</span> <span class=\"heading-h6 h-light-text\" ng-bind=item.author> </span> </div> </a> </div> </section> ";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _balanceTotal = __webpack_require__(757);

var _balanceTotal2 = _interopRequireDefault(_balanceTotal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingBalanceTotal', holdingBalanceTotal).name;


function holdingBalanceTotal() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      amount: '='
    },
    template: _balanceTotal2.default,
    transclude: true
  };
}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "<div class=\"balance-total-bar _wrapper\"> <div class=balance-total-bar__inner> <span class=\"balance-total-bar__label heading-h3\" ng-transclude></span> <div class=balance-total-bar__data ng-if=amount> <span class=\"balance-total-bar__amount heading-h2\" ng-bind=amount|holdingFormatFunds> </span> <a href class=\"balance-total-bar__currency heading-h6\" ui-sref=settings-profile.preferences ng-bind=amount.currency> </a> </div> <div class=balance-total-bar__data ng-if=!amount> <span class=\"balance-total-bar__amount heading-h2\" ng-bind=\"'—'\"></span> </div> </div> </div> ";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _percentageChange = __webpack_require__(759);

var _percentageChange2 = _interopRequireDefault(_percentageChange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingPercentageChange', holdingPercentageChange).name;


function holdingPercentageChange() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      percentage: '='
    },
    template: _percentageChange2.default
  };
}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "<span ng-class=\"{\n    'h-red-text': (percentage < 0),\n    'h-green-text': (percentage >= 0)\n  }\" ng-bind=percentage|holdingFormatPercentage> </span> ";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingStatement.$inject = ['HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statement = __webpack_require__(761);

var _statement2 = _interopRequireDefault(_statement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingStatement', holdingStatement).name;


function holdingStatement(HoldingUser) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      statement: '=',
      datedBy: '='
    },
    template: _statement2.default,
    transclude: true
  };

  function link(scope) {
    var user = HoldingUser.get();
    scope.regulator = user.regulation;
  }
}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-statement> <div class=gmw-statement__header> <div class=gmw-statement__header-column> <img class=gmw-statement__logo src=/img/brand/goldmoney-wealth-logo--statements.svg> <p class=gmw-statement__header-address ng-if=\"regulator === 'Toronto'\"> Goldmoney Vault Inc<br> 334 Adelaide St W, #307<br> Toronto • Ontario • M5V 1R4<br> Canada </p> <p class=gmw-statement__header-address ng-if=\"regulator === 'UK'\"> Goldmoney Vault (UK) Limited<br> Station Approach<br> Victoria, St Austell<br> Cornwall • PL26 8LG<br> United Kingdom </p> </div> <div class=gmw-statement__header-column> <div class=gmw-statement__header-row> <span class=gmw-statement__header-label ng-bind=\"'Created Date'|translate\"> </span> <span class=gmw-statement__header-value ng-bind=\"statement.created.tz('GMT').format('DD MMM YYYY - z HH:mm')\"> </span> </div> <div class=gmw-statement__header-row> <span class=gmw-statement__header-label ng-bind=\"'Holding Number'|translate\"> </span> <span class=gmw-statement__header-value ng-bind=statement.user.holdingNumber> </span> </div> <div class=gmw-statement__header-row> <span class=gmw-statement__header-label ng-bind=\"'Holding Name'|translate\"> </span> <span class=gmw-statement__header-value ng-bind=statement.user.name> </span> </div> <div class=gmw-statement__header-row ng-if=statement.month> <span class=gmw-statement__header-label ng-bind=\"'Month'|translate\"> </span> <span class=gmw-statement__header-value ng-bind=\"statement.month.format('MMMM YYYY')\"> </span> </div> <div class=gmw-statement__header-row ng-if=statement.startMonth> <span class=gmw-statement__header-label ng-bind=\"'Period'|translate\"> </span> <span class=gmw-statement__header-value> <span ng-bind=\"statement.startMonth.format('MMM YYYY')\"></span> - <span ng-bind=\"statement.endMonth.format('MMM YYYY')\"></span> </span> </div> <div class=gmw-statement__header-row ng-if=statement.date> <span class=gmw-statement__header-label ng-bind=\"'Date'|translate\"> </span> <span class=gmw-statement__header-value ng-bind=\"statement.date.format('LL')\"> </span> </div> <div class=gmw-statement__header-row> <span class=gmw-statement__header-label ng-bind=\"'Statement Currency'|translate\"> </span> <span class=gmw-statement__header-value ng-bind=statement.user.currency> </span> </div> </div> </div> <div class=gmw-statement__content ng-transclude></div> <div class=gmw-statement__footer> <p translate>The statement above is generated based on dates/times in the standard GMT/UTC timezone.</p> <p ng-if=datedBy translate> All metal prices are based on the closing LBMA/LPPM fix rates or applicable Goldmoney Fixed Sell Prices on {{datedBy|gmwFormatDate:'DD MMMM YYYY'}}*. </p> <p ng-if=datedBy translate>All currency exchange rates are sourced from market-leading foreign exchange (FX) data providers on {{datedBy|gmwFormatDate:'DD MMMM YYYY'}}.</p> <p translate> Goldmoney does not make any representation or give any warranty as to the accuracy, reliability, timeliness, correct sequencing or completeness of information provided by third party providers and accepts no responsibility for errors, omissions, disruptions and delays in providing such data by these providers. </p> <p translate>*Should the price have occurred prior to the 3 September 2014, the metal prices are based on the closing LBMA/LPPM fix rates, should it have occurred thereafter, the applicable Goldmoney Fixed Sell Prices will be used. </p> </div> </div> ";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementMovements = __webpack_require__(763);

var _statementMovements2 = _interopRequireDefault(_statementMovements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingStatementMovements', holdingStatementMovements).name;


function holdingStatementMovements() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      movements: '='
    },
    template: _statementMovements2.default
  };
}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-statement__table> <div ng-repeat=\"currency in movements\"> <div class=gmw-statement__table-row> <span class=gmw-statement__table-cell--header ng-bind=::currency|holdingCurrencyName> </span> </div> <div class=gmw-statement__table-row ng-repeat=\"movement in currency.movements\"> <span class=gmw-statement__table-cell--value> <span ng-bind=::movement.descriptionType></span> </span> <span class=\"gmw-statement__table-cell--value gmw-statement__table-cell--value-right\" ng-bind=::movement.amountFormatted> </span> </div> <div class=gmw-statement__total> <span class=gmw-statement__total-label ng-bind=\"'Net Movement on Holding'|translate\"> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h2\" ng-bind=currency.totalFormatted> </span> </span> </div> </div> </div> ";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementRates = __webpack_require__(765);

var _statementRates2 = _interopRequireDefault(_statementRates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingStatementRates', holdingStatementRates).name;


function holdingStatementRates() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      products: '='
    },
    template: _statementRates2.default
  };
}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-statement__rates> <div class=gmw-statement__rates-row ng-repeat=\"offset in [0, 2, 4]\"> <div class=gmw-statement__rates-rate ng-repeat=\"product in products|limitTo:2:offset\"> <span ng-if=\"(product.baseCurrency|gmwProductType) === 'Metal'\"> <span class=gmw-statement__rates-label ng-bind=product.baseCurrency|translate> </span>: <span class=gmw-statement__rates-value> <span ng-bind-html=\"product|gmwFormatProductRate:'g'\"></span> <span translate>or</span> <span ng-bind-html=\"product|gmwFormatProductRate:'oz'\"></span> </span> </span> <span ng-if=\"(product.baseCurrency|gmwProductType) === 'Crypto'\"> <span class=gmw-statement__rates-label ng-bind=::product.baseCurrency> </span>: <span class=gmw-statement__rates-value> <span ng-bind-html=product|gmwFormatProductRate></span> </span> </span> </div> </div> </div> ";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementTransactions = __webpack_require__(767);

var _statementTransactions2 = _interopRequireDefault(_statementTransactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingStatementTransactions', holdingStatementTransactions).name;


function holdingStatementTransactions() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      transactions: '='
    },
    template: _statementTransactions2.default
  };
}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-simple-table ng-repeat=\"transaction in transactions\"> <div class=gmw-simple-table__head> <div class=\"gmw-simple-table__head-left h-dark-text\"> <span ng-bind=::transaction.transactionDescription></span>:&nbsp; <span ng-bind=::transaction.code></span> </div> <gmw-vault-logo vault=::transaction.vault></gmw-vault-logo> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Date & Time'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.created|gmwFormatDateTime></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Transaction ID'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.code></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Transaction Type'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.transactionDescription></span> </div> </div> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row ng-if=\"::transaction.vault !== 'NONE'\"> <span class=gmw-simple-table__label ng-bind=\"'Vault'|translate\"></span> <span class=gmw-simple-table__value> <span> <span ng-bind=::transaction.vault|holdingVaultCustodian></span> - <span ng-bind=::transaction.vault|holdingVaultLocation></span> </span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Product / Currency'|translate\"></span> <span class=gmw-simple-table__value> <span ng-if=::!!(transaction.amountPaid) ng-bind=::transaction.amountPaid|holdingCurrencyName> </span> <span ng-if=::!!(transaction.amountReceived) ng-bind=::transaction.amountReceived|holdingCurrencyName> </span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Amount (Paid) / Received'|translate\"></span> <span class=gmw-simple-table__value> <span ng-if=::!!(transaction.amountPaid)> (<span ng-bind=::transaction.amountPaid|gmwFormatAmount></span>) </span> <span ng-if=::!!(transaction.amountReceived) ng-bind=::transaction.amountReceived|gmwFormatAmount> </span> </span> </div> </div> </div> <div class=gmw-simple-table__footer> <span class=h-dark-text translate> Memo: </span> &nbsp;&nbsp; <span ng-bind=::transaction.memo></span> </div> </div> ";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statementTotal = __webpack_require__(769);

var _statementTotal2 = _interopRequireDefault(_statementTotal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingStatementTotal', holdingStatementTotal).name;


function holdingStatementTotal() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      amount: '='
    },
    template: _statementTotal2.default,
    transclude: true
  };
}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-statement__total gmw-statement__total--section-total\"> <span class=gmw-statement__total-label ng-transclude> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h1\" ng-bind=amount.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=amount.currency> </span> </span> </div> ";

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transactionItem = __webpack_require__(771);

var _transactionItem2 = _interopRequireDefault(_transactionItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').directive('holdingTransactionItem', holdingTransactionItem).name;


function holdingTransactionItem() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      transaction: '='
    },
    template: _transactionItem2.default,
    transclude: true
  };
}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-simple-table gmw-simple-table--max-width gmw-simple-table--has-footer\"> <div class=gmw-simple-table__head> <div class=\"gmw-simple-table__head-left h-dark-text\"> <span ng-switch=::transaction.type class=h-margin-right-5> <span ng-switch-when=Buy ng-switch=::transaction.description> <span ng-switch-when=CurrencyExchange class=h-dark-text ng-bind=\"'Exchange Order:'|translate\"> </span> <span ng-switch-default class=h-green-text ng-bind=\"'Buy Order:'|translate\"> </span> </span> <span class=h-red-text ng-switch-when=Sell ng-bind=\"'Sell Order:'|translate\"></span> <span class=h-dark-text ng-switch-when=Exchange ng-bind=\"'Exchange Order:'|translate\"></span> </span> <span class=h-margin-right-5 ng-bind=::transaction.number></span> <span class=h-margin-right-5 ng-bind=\"'-'\"></span> <span class=h-green-text ng-if=\"::transaction.status === 'Completed'\" ng-bind=\"'Complete'|translate\"></span> <span class=h-orange-text ng-if=\"::transaction.status !== 'Completed'\" ng-bind=\"'Pending'|translate\"></span> </div> <gmw-vault-logo vault=::transaction.vault></gmw-vault-logo> </div> <div class=gmw-simple-table__body> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Order Date'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.created|gmwFormatDateTime></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Order Number'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.number></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Vault'|translate\"></span> <span class=gmw-simple-table__value> <span ng-if=\"transaction.vault === 'NONE'\" ng-bind=\"'N/A'|translate\"> </span> <span ng-if=\"transaction.vault !== 'NONE'\"> <gmw-flag country=::transaction.vault|holdingVaultCountryCode></gmw-flag> <span ng-bind=::transaction.vault|holdingVaultCustodian></span> <span ng-bind=::transaction.vault|holdingVaultLocation></span> </span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Order Type'|translate\"></span> <span class=gmw-simple-table__value ng-switch=::transaction.description> <span ng-switch-when=Buy ng-bind=\"'Buy'|translate\"></span> <span ng-switch-when=Convert ng-bind=\"'Convert from'|translate\"></span> <span ng-switch-when=CurrencyExchange ng-bind=\"'Currency Exchange'|translate\"></span> <span ng-switch-when=FromVault ng-bind=\"'Vault exchange of'|translate\"></span> <span ng-switch-when=Into ng-bind=\"'Exchange into'|translate\"></span> <span ng-switch-when=IntoVault ng-bind=\"'Vault exchange of'|translate\"></span> <span ng-switch-when=Sell ng-bind=\"'Sell'|translate\"></span> <span ng-switch-when=TransferFrom ng-bind=\"'Buy'|translate\"></span> <span ng-switch-when=TransferTo ng-bind=\"'Sell'|translate\"></span> <span ng-switch-default ng-bind=::transaction.description></span>&nbsp; <span ng-if=\"::transaction.description !== 'CurrencyExchange'\" ng-bind=::transaction.product|holdingCurrencyName|lowercase> </span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Order Amount'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.product|gmwFormatProduct></span> </div> <div class=gmw-simple-table__row ng-if=::transaction.bonus> <span class=gmw-simple-table__label ng-bind=\"'Bonus'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.bonus|gmwFormatProduct></span> </div> </div> <div class=gmw-simple-table__col> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Currency Equivalent'|translate\"></span> <span class=gmw-simple-table__value ng-bind=::transaction.fiat|holdingFormatFunds></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Payment Type'|translate\"></span> <span class=gmw-simple-table__value ng-switch=::transaction.paymentType> <span ng-switch-when=cfunds ng-bind=\"'Currency Balance'|translate\"></span> <span ng-switch-when=check ng-bind=\"'Check'|translate\"></span> <span ng-switch-when=wire ng-bind=\"'Bank Wire'|translate\"></span> <span ng-switch-when=exchange ng-bind=\"'Exchange'|translate\"></span> <span ng-switch-when=transfer ng-bind=\"'Transfer'|translate\"></span> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Rate'|translate\"></span> <span class=gmw-simple-table__value ng-bind-html=::transaction.rate|gmwFormatProductRate> </span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Goldmoney Fee'|translate\"></span> <span class=gmw-simple-table__value ng-bind=\"transaction.feeRate + '%'\"></span> </div> <div class=gmw-simple-table__row> <span class=gmw-simple-table__label ng-bind=\"'Rate Locked'|translate\"></span> <span class=gmw-simple-table__value ng-bind=\"'Yes'|translate\" ng-if=::transaction.rateLocked></span> <span class=gmw-simple-table__value ng-bind=\"'No'|translate\" ng-if=::!transaction.rateLocked></span> </div> </div> </div> <div class=gmw-simple-table__footer> <p class=gmw-simple-table__footer-item> <span class=h-dark-text ng-bind=\"'Order Type:'|translate\"></span>&nbsp; <span ng-switch=::transaction.description> <span ng-switch-when=Buy ng-bind=\"'Buy'|translate\"></span> <span ng-switch-when=Convert ng-bind=\"'Convert from'|translate\"></span> <span ng-switch-when=CurrencyExchange ng-bind=\"'Currency Exchange'|translate\"></span> <span ng-switch-when=FromVault ng-bind=\"'Vault exchange of'|translate\"></span> <span ng-switch-when=Into ng-bind=\"'Exchange into'|translate\"></span> <span ng-switch-when=IntoVault ng-bind=\"'Vault exchange of'|translate\"></span> <span ng-switch-when=Sell ng-bind=\"'Sell'|translate\"></span> <span ng-switch-when=TransferFrom ng-bind=\"'Buy'|translate\"></span> <span ng-switch-when=TransferTo ng-bind=\"'Sell'|translate\"></span> <span ng-switch-default ng-bind=::transaction.description></span> </span> <span ng-if=\"::transaction.description !== 'CurrencyExchange'\" ng-bind=::transaction.product|holdingCurrencyName|lowercase> </span> </p> <p class=gmw-simple-table__footer-item> <span class=h-dark-text ng-bind=\"'Order Status:'|translate\"></span>&nbsp; <span ng-switch=::transaction.status> <span ng-switch-when=Completed ng-bind=\"'Completed'|translate\"></span> <span ng-switch-when=Committed ng-bind=\"'Committed'|translate\"></span> <span ng-switch-when=CommittedToBeCompletedOn> <span ng-bind=\"'Committed, to be completed on'|translate\"></span> <span ng-bind=::transaction.toBeCompletedDate|gmwFormatDate></span> </span> </span> </p> </div> </div> ";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').filter('holdingEndOfMonth', holdingEndOfMonth).name;


function holdingEndOfMonth() {
  'ngInject';

  return function (input) {
    return (0, _moment2.default)(input).endOf('month').format('DD MMM YYYY');
  };
}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').filter('holdingStartOfMonth', holdingStartOfMonth).name;


function holdingStartOfMonth() {
  'ngInject';

  return function (input) {
    return (0, _moment2.default)(input).startOf('month').format('DD MMM YYYY');
  };
}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingTransactionDetailType.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.overview').filter('holdingTransactionDetailType', holdingTransactionDetailType).name;


function holdingTransactionDetailType(gettextCatalog) {
  'ngInject';

  var TRANSACTION_DETAIL_TYPES = {
    Payment: gettextCatalog.getString('Payment'),
    PaymentFee: gettextCatalog.getString('Payment Fee'),
    AccountFee: gettextCatalog.getString('Account Fee'),
    StorageFee: gettextCatalog.getString('Storage Fee'),
    Transfer: gettextCatalog.getString('Transfer'),
    BankWireFee: gettextCatalog.getString('Bank Wire Fee'),
    USBankWireFee: gettextCatalog.getString('US Bank Wire Fee'),
    UKBankWireFee: gettextCatalog.getString('UK Bank Wire Fee'),
    AdministrativeFee: gettextCatalog.getString('Administrative Fee'),
    EURetentionTax: gettextCatalog.getString('EU Retention Tax'),
    PartnerFee: gettextCatalog.getString('Partner Fee'),
    AllocationFee: gettextCatalog.getString('Allocation Fee'),
    BarFabricationWeight: gettextCatalog.getString('Bar Fabrication Weight'),
    BarFabricationFee: gettextCatalog.getString('Bar Fabrication Fee'),
    BarFabricationShippingFee: gettextCatalog.getString('Bar Fabrication Shipping Fee'),
    BarFabricationCollectionFee: gettextCatalog.getString('Bar Fabrication Collection Fee'),
    OneYearStorageFee: gettextCatalog.getString('One Year Storage Fee'),
    TwoYearStorageFee: gettextCatalog.getString('Two Year Storage Fee'),
    SEPA: gettextCatalog.getString('SEPA'),
    BuyGoldFee: gettextCatalog.getString('Buy Gold Fee'),
    BuySilverFee: gettextCatalog.getString('Buy Silver Fee'),
    BuyPlatinumFee: gettextCatalog.getString('Buy Platinum Fee'),
    BuyPalladiumFee: gettextCatalog.getString('Buy Palladium Fee'),
    ExchangeGoldFee: gettextCatalog.getString('Exchange Gold Fee'),
    ExchangeSilverFee: gettextCatalog.getString('Exchange Silver Fee'),
    ExchangePlatinumFee: gettextCatalog.getString('Exchange Platinum Fee'),
    ExchangePalladiumFee: gettextCatalog.getString('Exchange Palladium Fee'),
    SellGoldFee: gettextCatalog.getString('Sell Gold Fee'),
    SellSilverFee: gettextCatalog.getString('Sell Silver Fee'),
    SellPlatinumFee: gettextCatalog.getString('Sell Platinum Fee'),
    SellPalladiumFee: gettextCatalog.getString('Sell Palladium Fee'),
    PrepaidLoadFee: gettextCatalog.getString('Prepaid Load Fee'),
    BuyGoldLimitFee: gettextCatalog.getString('Buy Gold Limit Fee'),
    BuySilverLimitFee: gettextCatalog.getString('Buy Silver Limit Fee'),
    BuyPlatinumLimitFee: gettextCatalog.getString('Buy Platinum Limit Fee'),
    BuyPalladiumLimitFee: gettextCatalog.getString('Buy Palladium Limit Fee'),
    SellGoldLimitFee: gettextCatalog.getString('Sell Gold Limit Fee'),
    SellSilverLimitFee: gettextCatalog.getString('Sell Silver Limit Fee'),
    SellPlatinumLimitFee: gettextCatalog.getString('Sell Platinum Limit Fee'),
    SellPalladiumLimitFee: gettextCatalog.getString('Sell Palladium Limit Fee'),
    BuyCryptoLimitFee: gettextCatalog.getString('Buy Crypto Limit Fee'),
    SellCryptoLimitFee: gettextCatalog.getString('Sell Crypto Limit Fee')
  };

  return function (input) {
    if (!input) {
      return input;
    }
    return TRANSACTION_DETAIL_TYPES[input];
  };
}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingTransactionType.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.overview').filter('holdingTransactionType', holdingTransactionType).name;


function holdingTransactionType(gettextCatalog) {
  'ngInject';

  var TRANSACTION_TYPES = {
    Payment: gettextCatalog.getString('Transfer'),
    LostPassphraseCharge: gettextCatalog.getString('Lost Passphrase Charge'),
    UserHoldingClosure: gettextCatalog.getString('User Holding Closure'),
    MonthlyAccountFee: gettextCatalog.getString('Monthly Account Fee'),
    ZeroOutFee: gettextCatalog.getString('Zero Out Fee'),
    Transfer: gettextCatalog.getString('Transfer'),
    PrivilegedTransfer: gettextCatalog.getString('Privileged Transfer'),
    MonthlyFeeStorage: gettextCatalog.getString('Monthly Fee Storage'),
    BuyingSelling: gettextCatalog.getString('Buying Selling'),
    RTFR: gettextCatalog.getString('RTFR'),
    GAP: gettextCatalog.getString('GAP'),
    AFTR: gettextCatalog.getString('AFTR'),
    Interest: gettextCatalog.getString('Interest'),
    PartnerFee: gettextCatalog.getString('Partner Fee'),
    CurrencyToCurrencyExchange: gettextCatalog.getString('Currency To Currency Exchange'),
    AllocationFee: gettextCatalog.getString('Allocation Fee'),
    BarFabricationWeightOfBar: gettextCatalog.getString('Bar Fabrication Weight Of Bar'),
    BarFabricationFee: gettextCatalog.getString('Bar Fabrication Fee'),
    BarFabricationShippingFee: gettextCatalog.getString('Bar Fabrication Shipping Fee'),
    BarFabricationPickupFee: gettextCatalog.getString('Bar Fabrication Pickup Fee')
  };

  return function (input) {
    if (!input) {
      return input;
    }
    return TRANSACTION_TYPES[input];
  };
}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingBalances.$inject = ['$rootScope', 'HoldingApi', 'promiseCache'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.overview').factory('HoldingBalances', HoldingBalances).name;


function HoldingBalances($rootScope, HoldingApi, promiseCache) {
  'ngInject';

  var key = 'gmw:balances';

  $rootScope.$on('gmw:balance:changed', function () {
    promiseCache.remove(key);
  });

  return {
    clearCache: clearCache,
    getBalances: getBalances
  };

  function clearCache() {
    promiseCache.remove(key);
  }

  function getBalances() {
    return promiseCache({
      key: key,
      ttl: 600000,
      promise: function promise() {
        return HoldingApi.get('balances');
      }
    });
  }
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingMarkets.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.overview').factory('HoldingMarkets', HoldingMarkets).name;


function HoldingMarkets(HoldingApi) {
  'ngInject';

  return {
    getSummary: getSummary
  };

  function getSummary(vault) {
    return HoldingApi.get('markets/summary', {
      params: {
        vault: vault
      }
    }).then(function (_ref) {
      var rates = _ref.rates;
      return rates;
    });
  }

  function parseEquity(_ref2) {
    var ChangeinPercent = _ref2.ChangeinPercent,
        LastTradePriceOnly = _ref2.LastTradePriceOnly,
        Name = _ref2.Name;

    return {
      change: ChangeinPercent ? parseFloat(ChangeinPercent.replace('%', '')) : 0,
      lastTrade: parseFloat(LastTradePriceOnly),
      name: indexes[Name].name || Name,
      country: indexes[Name].country
    };
  }
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingResearch.$inject = ['HoldingEnvironment', 'promiseCache', '$http'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').factory('HoldingResearch', HoldingResearch).name;


function HoldingResearch(HoldingEnvironment, promiseCache, $http) {
  'ngInject';

  var options = {
    headers: {
      Accept: 'application/rss+xml, text/plain, */*'
    },
    responseType: 'text'
  };

  return {
    getResearch: getResearch
  };

  function getResearch() {
    var STRAPI_API_BASE_PATH = HoldingEnvironment.urls.strapi;

    return promiseCache({
      ttl: 600000,
      promise: function promise() {
        return $http({
          headers: {
            'Authorization': 'Bearer ' + HoldingEnvironment.tokens.strapiAccessToken,
            'Content-Type': 'application/json'
          },
          method: 'GET',
          url: STRAPI_API_BASE_PATH + '/articles?fields[0]=body&fields[1]=title&fields[2]=publishDate&fields[3]=slug&filters[publishDate][$lte]=' + new Date().toJSON() + '&sort[0]=publishDate%3Adesc&populate=%2A&publicationState=live&pagination[page]=1&pagination[pageSize]=2',
          withCredentials: false
        }).then(function (_ref) {
          var data = _ref.data.data;
          return data.map(function (_ref2) {
            var _ref2$attributes = _ref2.attributes,
                name = _ref2$attributes.author.data.attributes.name,
                publishDate = _ref2$attributes.publishDate,
                slug = _ref2$attributes.slug,
                title = _ref2$attributes.title;
            return {
              author: name,
              pubDate: (0, _moment2.default)(publishDate),
              slug: slug,
              title: title
            };
          });
        });
      }
    });
  }
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingStatements.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').factory('HoldingStatements', HoldingStatements).name;


function HoldingStatements(HoldingApi) {
  'ngInject';

  return {
    getEndOfMonthStatement: getEndOfMonthStatement,
    getMonthlyStatement: getMonthlyStatement,
    getTransactionsStatement: getTransactionsStatement,
    getYearHighStatement: getYearHighStatement
  };

  function getEndOfMonthStatement(params) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'browse';

    switch (type) {
      case 'print':
        return HoldingApi.getUrl('statements/balance/print', params);
      case 'pdf':
        {
          return HoldingApi.getUrl('statements/balance/pdf', params);
        }
      case 'browse':
      default:
        return HoldingApi.get('statements/balance', { params: params });
    }
  }

  function getMonthlyStatement(params) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'browse';

    switch (type) {
      case 'print':
        return HoldingApi.getUrl('statements/monthly/print', params);
      case 'pdf':
        {
          return HoldingApi.getUrl('statements/monthly/pdf', params);
        }
      case 'browse':
      default:
        return HoldingApi.get('statements/monthly', { params: params });
    }
  }

  function getTransactionsStatement(data) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'browse';
    var page = arguments[2];

    var params = angular.copy(data);
    ['currency', 'transactions', 'vault'].forEach(function (key) {
      if (params[key] === 'all') {
        delete params[key];
      }
    });
    params['sorting.field'] = 'date';
    params['sorting.type'] = 'asc';
    if (page) {
      params['dataLimit.limit'] = 10;
      params['dataLimit.offset'] = (page - 1) * 10;
    }

    switch (type) {
      case 'browse':
      default:
        return HoldingApi.get('statements/transactions', { params: params });
      case 'excel':
        {
          var date = (0, _moment2.default)().format('YYYYMMDD');
          var filename = 'gm' + date + '.xls';
          return HoldingApi.getUrl('statements/transactions/excel', params, filename);
        }
    }
  }

  function getYearHighStatement(params) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'browse';

    switch (type) {
      case 'print':
        return HoldingApi.getUrl('statements/highest-value/print', params);
      case 'pdf':
        {
          return HoldingApi.getUrl('statements/highest-value/pdf', params);
        }
      case 'browse':
      default:
        return HoldingApi.get('statements/highest-value', { params: params });
    }
  }
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingTransactions.$inject = ['HoldingApi', 'promiseCache'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.overview').factory('HoldingTransactions', HoldingTransactions).name;


function HoldingTransactions(HoldingApi, promiseCache) {
  'ngInject';

  var CACHE_KEY = 'ordersRecent';

  return {
    clearCache: clearCache,
    getPendingTransactions: getPendingTransactions,
    getTransactions: getTransactions
  };

  function clearCache() {
    promiseCache.remove(CACHE_KEY);
  }

  function getPendingTransactions() {
    return getTransactions().then(function (transactions) {
      return transactions && transactions.filter(function (transaction) {
        return transaction.status !== 'Completed';
      });
    });
  }

  function getTransactions() {
    return promiseCache({
      key: CACHE_KEY,
      ttl: 600000,
      promise: function promise() {
        return HoldingApi.get('orders/recent');
      }
    });
  }
}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(782);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(783);

var _main2 = _interopRequireDefault(_main);

var _sidebar = __webpack_require__(784);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.overview').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.overview', {
    url: '/overview',
    views: {
      hero: {
        template: _hero2.default
      },
      main: {
        template: _main2.default
      },
      'overview-sidebar@holding.dashboard.overview': {
        controller: 'SidebarController',
        controllerAs: 'sidebarCtrl',
        template: _sidebar2.default
      }
    }
  });

  $urlRouterProvider.when('/overview', '/overview/balances');
}]).name;


__webpack_require__(785);
__webpack_require__(788);
__webpack_require__(791);
__webpack_require__(794);

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions-floating-sidebar> <section class=holding-dashboard-hero-actions-floating-sidebar__main> <div class=holding-dashboard-hero-actions-floating-sidebar__main-title> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <h1 class=heading-h2 ng-bind=\"'Holding Overview'|translate\"></h1> </div> <div class=holding-dashboard-hero-actions-floating-sidebar__main-tabs> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Balances'|translate\" ui-sref=holding.dashboard.overview.balances ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Transactions'|translate\" ui-sref=holding.dashboard.overview.transactions ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Statements'|translate\" ui-sref=holding.dashboard.overview.statements ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </div> </section> <section class=holding-dashboard-hero-actions-floating-sidebar__spacer></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "<section class=floating-sidebar-app-view> <div class=\"floating-sidebar-app-view__main floating-sidebar-app-view__main--no-bottom-margin\" ui-view=overview-main> </div> <div class=floating-sidebar-app-view__sidebar ng-class=\"{\n      'floating-sidebar-app-view__sidebar--has-msg': true,\n    }\" ui-view=overview-sidebar> </div> </section> ";

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<section class=holding-floating-sidebar-new-messages ui-sref=\"holding.dashboard.messages.folder({\n    messageFolder: 'inbox',\n  })\" ui-sref-opts=\"{\n    reload: true,\n  }\" ng-if=\"sidebarCtrl.showMessaging && sidebarCtrl.unreadMessages > 0\"> <div class=holding-floating-sidebar-new-messages__content> <div class=gmw-new-messages-icon> <svg class=gmw-new-messages-icon__icon width=24px height=15px> <use xlink:href=#gmw-messages-icon-active--alt></use> </svg> </div> <span class=h-default-text> <span ng-bind=sidebarCtrl.unreadMessages></span> <span ng-bind=\"'Unread'|translate\"></span> <span ng-if=\"sidebarCtrl.unreadMessages != 1\" ng-bind=\"'Messages'|translate\"></span> <span ng-if=\"sidebarCtrl.unreadMessages == 1\" ng-bind=\"'Message'|translate\"></span> </span> </div> <svg class=holding-floating-sidebar-new-messages__arrow> <use xlink:href=#right-arrow-icon></use> </svg> </section> <section class=\"holding-floating-sidebar-message holding-floating-sidebar-message--alert\" ng-if=\"sidebarCtrl.showVerification && !sidebarCtrl.hasCompletedSetup\"> <div class=holding-floating-sidebar-message__icon-col> <img src=/img/icons/verify-person-icon.svg alt=\"Verification Badge\"> </div> <div class=holding-floating-sidebar-message__data> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Holding Setup'|translate\"> </h4> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Please complete setting up your Holding so that our team can begin the verification process.'|translate\"> </p> <a href class=gmw-more-link ui-sref=setup> <span ng-bind=\"'Complete Setup'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </section> <section class=\"holding-floating-sidebar-message holding-floating-sidebar-message--alert\" ng-if=\"sidebarCtrl.showVerification && sidebarCtrl.hasCompletedSetup && !sidebarCtrl.user.verified && sidebarCtrl.needsVerification\"> <div class=holding-floating-sidebar-message__icon-col> <img src=/img/icons/verify-person-icon.svg alt=\"Verification Badge\"> </div> <div class=holding-floating-sidebar-message__data> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Holding Verification'|translate\"> </h4> <p class=\"h-medium-text h-margin-bottom-10\" ng-if=sidebarCtrl.canAddFunds ng-bind=\"'Please complete additional verification to enable access to additional features.'|translate\"> </p> <p class=\"h-medium-text h-margin-bottom-10\" ng-if=!sidebarCtrl.canAddFunds ng-bind=\"'Please complete additional verification to enable funding and purchase precious metals.'|translate\"> </p> <a href class=gmw-more-link ui-sref=verification> <span ng-bind=\"'Verify Now'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </section> <section class=\"holding-floating-sidebar-message holding-floating-sidebar-message--alert\" ng-if=\"sidebarCtrl.showVerification && !sidebarCtrl.user.verified && !sidebarCtrl.needsVerification && sidebarCtrl.hasCompletedSetup && sidebarCtrl.hasSetSecurityQuestions\"> <div class=holding-floating-sidebar-message__icon-col> <img src=/img/icons/verify-person-icon.svg alt=\"Verification Badge\"> </div> <div class=holding-floating-sidebar-message__data> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Verification In-Progress'|translate\"> </h4> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Verification review of your Holding is currently in progress.'|translate\"> </p> </div> </section> <section class=holding-floating-sidebar-message ng-if=\"sidebarCtrl.hasCompletedSetup && !sidebarCtrl.needsVerification && !sidebarCtrl.hasSetSecurityQuestions\"> <div class=holding-floating-sidebar-message__icon-col> <img src=/img/icons/security-badge-icon.svg alt=\"Security Badge\"> </div> <div class=holding-floating-sidebar-message__data> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Set up your security questions'|translate\"> </h4> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Setting security questions will allow us to verify your identity over the phone.'|translate\"> </p> <a href class=gmw-more-link ui-sref=setup.security-questions> <span ng-bind=\"'Setup'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </section> <holding-overview-sidebar-markets></holding-overview-sidebar-markets> <holding-overview-sidebar-research></holding-overview-sidebar-research> ";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _balances = __webpack_require__(786);

var _balances2 = _interopRequireDefault(_balances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.overview').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.overview.balances', {
    data: {
      pageTitle: 'Holding Balances'
    },
    url: '/balances',
    views: {
      'overview-main': {
        controller: 'BalancesController',
        controllerAs: 'balancesCtrl',
        template: _balances2.default
      }
    }
  });
}]);

__webpack_require__(787);

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<section class=\"holding-floating-sidebar-new-messages holding-floating-sidebar-new-messages--show-on-balance\" ui-sref=\"holding.dashboard.messages.folder({\n    messageFolder: 'inbox'\n  })\" ui-sref-opts=\"{\n    reload: true,\n  }\" ng-if=\"balancesCtrl.showMessaging && balancesCtrl.unreadMessages > 0\"> <div class=holding-floating-sidebar-new-messages__content> <div class=gmw-new-messages-icon> <svg class=gmw-new-messages-icon__icon width=24px height=15px> <use xlink:href=#gmw-messages-icon-active--alt></use> </svg> </div> <span class=h-default-text> <span ng-bind=balancesCtrl.unreadMessages></span> <span ng-bind=\"'Unread'|translate\"></span> <span ng-if=\"balancesCtrl.unreadMessages != 1\" ng-bind=\"'Messages'|translate\"></span> <span ng-if=\"balancesCtrl.unreadMessages == 1\" ng-bind=\"'Message'|translate\"></span> </span> </div> <svg class=holding-floating-sidebar-new-messages__arrow> <use xlink:href=#right-arrow-icon></use> </svg> </section> <section class=\"holding-floating-sidebar-message holding-floating-sidebar-message--show-on-balance\" ng-if=\"balancesCtrl.hasCompletedSetup && !balancesCtrl.needsVerification && balancesCtrl.user.loginFlags.setSecurityQuestions\"> <div class=holding-floating-sidebar-message__icon-col> <img src=/img/icons/security-badge-icon.svg alt=\"Security Badge\"> </div> <div class=holding-floating-sidebar-message__data> <h4 class=\"heading-h4 h-dark-text\" ng-bind=\"'Set up your security questions'|translate\"> </h4> <p class=\"h-medium-text h-margin-bottom-10\" ng-bind=\"'Setting security questions will allow us to verify your identity over the phone.'|translate\"> </p> <a href class=gmw-more-link ui-sref=setup.security-questions> <span ng-bind=\"'Setup'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </section> <div class=_wrapper ng-if=balancesCtrl.user.locked> <holding-alert class=error title=\"{{'Holding Locked'|translate}}\"> <main> <span> <span ng-if=\"!balancesCtrl.user.lockReason || balancesCtrl.user.lockReason.length < 1\" ng-bind=\"'Your Holding is currently locked pending resolution of an outstanding issue.'|translate\"></span> <span ng-if=\"balancesCtrl.user.lockReason.length > 0\" ng-bind=balancesCtrl.user.lockReason|gmwAddPeriod></span> </span> </main> <cta> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ng-bind=\"'Contact our Relationship Management Team'|translate\"></a> </cta> </holding-alert> </div> <div class=_wrapper ng-if=\"balancesCtrl.user.holdingStatus == 'Restricted'\"> <holding-alert class=error title=\"{{'Holding Restricted'|translate}}\"> <main> <span> <span ng-bind=\"'Your Holding is currently restricted from withdrawing funds. Please review your messages and contact our Relationship Management Team to resolve any outstanding requests.'|translate\"></span> </span> </main> <cta> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ng-bind=\"'Contact our Relationship Management Team'|translate\"></a> </cta> </holding-alert> </div> <div class=_wrapper ng-if=balancesCtrl.showVerifyEmail> <holding-alert class=info ng-if=!balancesCtrl.showVerifyEmailSent title=\"{{'Action Required: Verify Your Email'|translate}}\"> <main> <span> <span ng-bind=\"'To ensure security and deliverability, please click the link below to send a verification email to the address on record.'|translate\"> </span> </span> </main> <cta> <a ng-bind=\"'Send Verification Link'|translate\" ng-click=balancesCtrl.sendEmailVerificationLink()> </a> </cta> </holding-alert> <holding-alert class=success ng-if=balancesCtrl.showVerifyEmailSent title=\"{{'Email Verification Link Sent'|translate}}\"> <main> <span> <span ng-bind=\"'Please click on the link contained in the verification email we\\'ve just sent to complete the verification process'|translate\"> </span> </span> </main> </holding-alert> </div> <div class=gmw-new-holding ng-if=\"balancesCtrl.holdingTotal.amount === 0\"> <div class=gmw-new-holding__intro> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Welcome to your Goldmoney Holding'|translate\"> </h1> </div> <div class=\"gmw-verification-step gmw-new-holding__step\" ng-if=\"balancesCtrl.hasCompletedSetup && !balancesCtrl.user.verified && balancesCtrl.needsVerification\"> <div class=gmw-verification-step__inner> <img class=\"h-margin-right-20 desktop-only desktop-only--xs\" src=/img/icons/clipboard-check-icon.svg> <div class=gmw-verification-step__description> <span class=\"heading-h4 h-dark-text h-margin-bottom-5\" ng-bind=\"'Further Verification Required'|translate\"> </span> <p class=h-medium-text ng-bind=\"'In order to access all features available to our Clients, including funding your Holding and access to precious metals, please complete the verification process by paper forms.'|translate\"> </p> </div> </div> <div class=h-flex> <div class=\"gmw-verification-step__action gmw-verification-step__action--go\" ui-sref=verification> <holding-svg-icon class=gmw-verification-step__arrow icon=right-arrow> </holding-svg-icon> </div> </div> </div> <div class=\"gmw-verification-step gmw-new-holding__step\" ng-if=\"balancesCtrl.hasCompletedSetup && !balancesCtrl.user.verified && !balancesCtrl.needsVerification\"> <div class=gmw-verification-step__inner> <img class=\"h-margin-right-20 desktop-only desktop-only--xs\" src=/img/icons/clipboard-check-icon.svg> <div class=gmw-verification-step__description> <span class=\"heading-h4 h-dark-text h-margin-bottom-5\" ng-bind=\"'Holding Setup Complete, Verification In-Progress'|translate\"> </span> <p class=h-medium-text ng-bind=\"'Thank you for submitting your information. Our team will begin the review process and will advise you on any further information or documentation that is required to complete your verification.'|translate\"> </p> </div> </div> </div> <div class=gmw-new-holding-funds> <img class=\"gmw-new-holding-funds__graphic h-margin-bottom-20\" src=/img/holding-welcome-graphic-temp.png srcset=\"/img/holding-welcome-graphic.png, /img/holding-welcome-graphic@2x.png 2x\"> <h2 class=\"heading-h4 h-dark-text h-margin-bottom-10\" ng-bind=\"'Add Funds to your Holding'|translate\"> </h2> <p class=\"h-default-text gmw-new-holding-funds__description\" ng-bind=\"'Funds can be added into any one of 9 national currencies.'|translate\"> </p> <button ng-if=balancesCtrl.canInitiateAdd ui-sref=holding.dashboard.funds.add class=medium-main-cta ng-bind=\"'Fund My Holding'|translate\"> </button> <button ng-if=!balancesCtrl.canInitiateAdd class=medium-main-cta ng-bind=\"'Holding Locked'|translate\"> </button> </div> </div> <div ng-if=\"balancesCtrl.hasCompletedSetup && balancesCtrl.user.verified && !balancesCtrl.needsVerification && balancesCtrl.loadedBalances\"> <holding-promotions-pager></holding-promotions-pager> <div class=_wrapper> <holding-alert ng-if=balancesCtrl.loadingError class=error title=\"{{'Loading Error'|translate}}\"> <main> <span ng-bind=\"'There was an error retrieving some or all of your balances.'|translate\"></span> <cta> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ng-bind=\"'Contact our Relationship Management Team'|translate\"></a>. </cta> </main> </holding-alert> </div> <section class=gmw-table-section ng-if=\"balancesCtrl.bars.length > 0\"> <holding-bars-balance bars=balancesCtrl.bars equivalent-currency=balancesCtrl.equivalentCurrency> </holding-bars-balance> <holding-balance-total amount=balancesCtrl.barsTotal> <span class=\"desktop-only desktop-only--xxs\" ng-bind=\"'Total Registered Bars Balance'|translate\"> </span> <span class=\"mobile-only mobile-only--xxs\" ng-bind=\"'Bars Total'|translate\"> </span> </holding-balance-total> </section> <section class=gmw-table-section ng-if=\"balancesCtrl.metals.length > 0\"> <holding-metals-balance metals=balancesCtrl.metals equivalent-currency=balancesCtrl.equivalentCurrency> </holding-metals-balance> <holding-balance-total amount=balancesCtrl.metalsTotal> <span class=\"desktop-only desktop-only--xxs\" ng-bind=\"'Total Precious Metals Balance'|translate\"> </span> <span class=\"mobile-only mobile-only--xxs\" ng-bind=\"'Metals Total'|translate\"> </span> </holding-balance-total> </section> <section class=gmw-table-section ng-if=\"balancesCtrl.funds.length > 0\"> <holding-funds-balance funds=balancesCtrl.funds equivalent-currency=balancesCtrl.equivalentCurrency> </holding-funds-balance> <holding-balance-total amount=balancesCtrl.fundsTotal> <span class=\"desktop-only desktop-only--xxs\" ng-bind=\"'Total Currency Funds Balance'|translate\"> </span> <span class=\"mobile-only mobile-only--xxs\" ng-bind=\"'Currency Total'|translate\"> </span> </holding-balance-total> </section> <div class=\"balance-total-bar balance-total-bar--large _wrapper\" ng-if=\"balancesCtrl.holdingTotal.amount > 0\"> <div class=balance-total-bar__inner> <span class=\"balance-total-bar__label heading-h2\" translate> Total Holding Value </span> <div class=balance-total-bar__data> <span class=\"balance-total-bar__amount heading-h1\" ng-bind=balancesCtrl.holdingTotal|holdingFormatFunds> </span> <a href class=\"balance-total-bar__currency heading-h6\" ui-sref=settings-profile.preferences ng-bind=balancesCtrl.holdingTotal.currency> </a> </div> </div> </div> </div> ";

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


BalancesController.$inject = ['$log', '$q', '$interval', '$scope', '$rootScope', 'HoldingAuth', 'HoldingBalances', 'HoldingTransactions', 'HoldingUser', 'HoldingMessages', 'GmwSetup', 'ShouldVerifyEmailResolve'];
angular.module('app.holding.dashboard.overview').controller('BalancesController', BalancesController);

function BalancesController($log, $q, $interval, $scope, $rootScope, HoldingAuth, HoldingBalances, HoldingTransactions, HoldingUser, HoldingMessages, GmwSetup, ShouldVerifyEmailResolve) {
  'ngInject';

  function activate() {
    checkUnread();
    contentTimer = $interval(function () {
      checkUnread();
    }, CONTENT_DELAY);

    HoldingBalances.getBalances().then(function (_ref) {
      var bars = _ref.bars,
          fiat = _ref.fiat,
          metals = _ref.metals;

      vm.loadedBalances = true;

      vm.bars = bars;
      vm.barsTotal = sumEquivalents(bars);
      vm.funds = fiat;
      vm.fundsTotal = sumEquivalents(fiat);
      vm.metals = metals;
      vm.metalsTotal = sumEquivalents(metals);
    }).catch(function (error) {
      vm.loadingError = true;
    }).finally(function () {
      vm.holdingTotal = [vm.barsTotal, vm.fundsTotal, vm.metalsTotal].reduce(reduceAmounts, { amount: 0, currency: vm.user.currency });
    });

    $q.all([GmwSetup.needsVerification(), GmwSetup.hasCompletedSetup()]).then(function (response) {
      vm.needsVerification = response[0];
      vm.hasCompletedSetup = response[1];
    });
  }

  function checkUnread() {
    HoldingMessages.getUnreadMessages(false).then(function (unreadMessages) {
      vm.unreadMessages = unreadMessages.unread;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function onBalancesChanged(_event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { intervals: 1 };

    var index = 1;
    var pollingInterval = $interval(function () {
      HoldingBalances.getBalances().then(function (_ref2) {
        var bars = _ref2.bars,
            fiat = _ref2.fiat,
            metals = _ref2.metals;

        vm.bars = bars;
        vm.funds = fiat;
        vm.metals = metals;

        if (index >= data.intervals) {
          $interval.cancel(pollingInterval);
        }
        index += 1;
      });
    }, 5000);
  }

  function onDestroy() {
    $interval.cancel(contentTimer);
  }

  function reduceAmounts(prev, curr) {
    return { amount: prev.amount + curr.amount, currency: curr.currency };
  }

  function sendEmailVerificationLink() {
    HoldingAuth.sendEmailVerificationLink().then(function () {
      vm.showVerifyEmailSent = true;
    });
  }

  function sumEquivalents(objects) {
    return objects.map(function (_) {
      return _.equivalent;
    }).reduce(reduceAmounts, { amount: 0, currency: vm.user.currency });
  }

  var CONTENT_DELAY = 300000;
  var vm = this;

  var contentTimer = void 0;

  vm.user = HoldingUser.get();
  vm.canInitiateAdd = HoldingUser.isAllowed('addFunds');
  vm.equivalentCurrency = vm.user.currency;
  vm.sendEmailVerificationLink = sendEmailVerificationLink;
  vm.showMessaging = HoldingUser.isAllowed('messaging');
  vm.showVerification = HoldingUser.isAllowed('verification');
  vm.showVerifyEmail = ShouldVerifyEmailResolve;
  vm.showVerifyEmailSent = false;

  activate();

  $scope.$on('$destroy', onDestroy);
  $rootScope.$on('gmw:balance:changed', onBalancesChanged);
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _statements = __webpack_require__(789);

var _statements2 = _interopRequireDefault(_statements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.overview').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.overview.statements', {
    data: {
      pageTitle: 'Holding Statements'
    },
    url: '/statements',
    views: {
      'overview-main': {
        controller: 'StatementsController',
        controllerAs: 'statementsCtrl',
        template: _statements2.default
      }
    }
  });
}]);

__webpack_require__(790);

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <div class=\"gmw-flow-box gmw-flow-box--center gmw-statements-box\" ng-form=statementsCtrl.form> <div class=\"gmw-flow-box__full-header gmw-statements-select-header\"> <span class=\"gmw-statements-select-header__label heading-h4 h-dark-text\" ng-bind=\"'Select Report Type'|translate\"> </span> <div class=gmw-statements-select-header__selector> <div class=gmw-input-container> <gmw-box-selector description=\"{{'Report Type'|translate}}\" required options=statementsCtrl.statementTypes ng-model=statementsCtrl.type name=reportType no-label=true> </gmw-box-selector> </div> </div> </div> <header class=gmw-flow-box__header ng-switch=statementsCtrl.type> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-switch-when=transactions ng-bind=\"'Transaction Report'|translate\"> </h2> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-switch-when=endOfMonth ng-bind=\"'End of Month Balance Summary'|translate\"> </h2> <h2 ng-switch-when=yearHigh class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Highest Value on a Transaction Date in a Year'|translate\"> </h2> <p ng-switch-when=yearHigh class=gmw-flow-box__header-description> This report captures the highest value of your Holding on any day that you transacted in the previous 12 months from the month and year selected below. </p> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-switch-when=monthly ng-bind=\"'Monthly Statement'|translate\"> </h2> </header> <div class=gmw-flow-box-container ng-switch=statementsCtrl.type> <div ng-switch-when=transactions> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=show class=gmw-input-container--split-half__col ng-model=statementsCtrl.transactions.transactions options=statementsCtrl.showOptions description=\"{{'Show'|translate}}\" no-label=true> </gmw-box-selector> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=statementsCtrl.transactions.currency options=statementsCtrl.currencyOptions description=\"{{'Select Product or Currency'|translate}}\" no-label=true> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=show class=gmw-input-container--split-half__col ng-model=statementsCtrl.transactions.vault options=statementsCtrl.vaults description=\"{{'Vaults'|translate}}\" no-label=true> </gmw-box-selector> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=statementsCtrl.transactions.equivalent options=statementsCtrl.currencyDisplayOptions description=\"{{'Display Currency'|translate}}\" placeholder=\"{{'Select display currency'|translate}}\" no-label=true> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-date-picker required name=dateFrom class=gmw-input-container--split-half__col ng-model=statementsCtrl.transactions.from description=\"{{'Date From'|translate}}\" max-date=statementsCtrl.maxDate min-date=statementsCtrl.minDate> </gmw-box-date-picker> <gmw-box-date-picker required name=dateTo class=gmw-input-container--split-half__col ng-model=statementsCtrl.transactions.to description=\"{{'Date To'|translate}}\" max-date=statementsCtrl.maxDate min-date=statementsCtrl.transactions.from> </gmw-box-date-picker> </div> <gmw-box-input name=keyword class=gmw-input-container ng-model=statementsCtrl.transactions.memo placeholder=\"{{'Keyword search'|translate}}\" no-label=true> </gmw-box-input> <div class=gmw-input-container> <gmw-toggle-option-group ng-model=statementsCtrl.transactionType> <gmw-toggle-option label=\"{{'Browse'|translate}}\" value=\"'browse'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Spreadsheet'|translate}}\" value=\"'excel'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=gmw-input-container ng-if=\"statementsCtrl.transactionType === 'browse'\"> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=label> </label> <gmw-checkbox name=show-all ng-model=statementsCtrl.showAllTransactions> <span class=\"h-dark-text h-medium-text h-bold-text\" translate>Show All Transactions</span> </gmw-checkbox> </div> <div class=gmw-statements-generate-button-container> <button ng-if=!statementsCtrl.transactionsUrl class=\"medium-main-cta gmw-responsive-button\" gmw-action=statementsCtrl.generateReport()> <span ng-bind=\"'Generate Report'|translate\"></span> </button> <a ng-if=\"statementsCtrl.transactionsUrl && statementsCtrl.transactions.currency !== 'all'\" class=\"medium-main-cta gmw-responsive-button gmw-statements-generate-button\" ng-href=\"{{statementsCtrl.transactionsUrl}}\" target=_blank> <span ng-bind=\"'Open Report'|translate\"></span> </a> </div> <holding-alert-legacy class=warning ng-if=\"statementsCtrl.transactionsUrl && statementsCtrl.transactions.currency === 'all'\"> <span translate>Select a product or a currency first.</span> </holding-alert-legacy> <holding-statement ng-if=statementsCtrl.transactionsStatement statement=statementsCtrl.transactionsStatement> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Results'|translate\"> </span> <holding-statement-transactions transactions=statementsCtrl.transactionsStatement.details></holding-statement-transactions> </div> </holding-statement> </div> <div ng-switch-when=endOfMonth> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=show class=gmw-input-container--split-half__col ng-model=statementsCtrl.endOfMonth.month options=statementsCtrl.monthOptions description=\"{{'Month'|translate}}\" no-label=true> </gmw-box-selector> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=statementsCtrl.endOfMonth.year options=statementsCtrl.yearOptions description=\"{{'Year'|translate}}\" no-label=true> </gmw-box-selector> </div> <div class=gmw-input-container> <gmw-toggle-option-group ng-model=statementsCtrl.endOfMonthType> <gmw-toggle-option label=\"{{'Browse'|translate}}\" value=\"'browse'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Print'|translate}}\" value=\"'print'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'PDF Download'|translate}}\" value=\"'pdf'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=gmw-statements-generate-button-container ng-if=statementsCtrl.validDate(statementsCtrl.endOfMonth)> <button ng-if=!statementsCtrl.endOfMonthUrl class=\"medium-main-cta gmw-responsive-button\" gmw-action=statementsCtrl.generateReport()> <span ng-bind=\"'Generate Report'|translate\"></span> </button> <a ng-if=statementsCtrl.endOfMonthUrl class=\"medium-main-cta gmw-responsive-button gmw-statements-generate-button\" ng-href=\"{{statementsCtrl.endOfMonthUrl}}\" target=_blank> <span ng-bind=\"'Open Report'|translate\"></span> </a> </div> <holding-alert-legacy class=warning ng-if=!statementsCtrl.validDate(statementsCtrl.endOfMonth)> <span>You can not request a report for a month which has not yet ended.</span> </holding-alert-legacy> <holding-statement ng-if=statementsCtrl.endOfMonthStatement statement=statementsCtrl.endOfMonthStatement dated-by=statementsCtrl.endOfMonthStatement.datedBy> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Precious Metal Balance'|translate\"> </span> <holding-statement-metals metals=statementsCtrl.endOfMonthStatement.metals total=statementsCtrl.endOfMonthStatement.metalTotal> </holding-statement-metals> </div> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Cryptocurrency Balance'|translate\"> </span> <holding-statement-crypto cryptos=statementsCtrl.endOfMonthStatement.crypto total=statementsCtrl.endOfMonthStatement.cryptoTotal> </holding-statement-crypto> </div> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Currency Funds Balance'|translate\"> </span> <holding-statement-funds fiat=statementsCtrl.endOfMonthStatement.fiats total=statementsCtrl.endOfMonthStatement.fiatTotal> </holding-statement-funds> </div> <holding-statement-total amount=statementsCtrl.endOfMonthStatement.total> <span ng-bind=\"'Total Holding Balance'|translate\"></span> </holding-statement-total> <holding-statement-rates products=statementsCtrl.endOfMonthStatement.productRates> </holding-statement-rates> </holding-statement> </div> <div ng-switch-when=yearHigh> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=show class=gmw-input-container--split-half__col ng-model=statementsCtrl.yearHigh.month options=statementsCtrl.monthOptions description=\"{{'Month*'|translate}}\" no-label=true> </gmw-box-selector> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=statementsCtrl.yearHigh.year options=statementsCtrl.yearOptions description=\"{{'Year'|translate}}\" no-label=true> </gmw-box-selector> </div> <gmw-box-selector required name=exactDate class=gmw-input-container ng-if=\"statementsCtrl.yearDates.length > 1 && statementsCtrl.yearlyType !== 'browse'\" ng-model=statementsCtrl.yearHigh.exactDate options=statementsCtrl.yearDates description=\"{{'Exact Date'|translate}}\"> </gmw-box-selector> <holding-alert-legacy class=info> <span translate> * Month will reflect the last month in a 12 month cycle. </span> </holding-alert-legacy> <div class=gmw-input-container> <gmw-toggle-option-group ng-model=statementsCtrl.yearlyType> <gmw-toggle-option label=\"{{'Browse'|translate}}\" value=\"'browse'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Print'|translate}}\" ng-disabled=\"statementsCtrl.yearHighReportError.length > 0\" value=\"'print'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'PDF Download'|translate}}\" ng-disabled=\"statementsCtrl.yearHighReportError.length > 0\" value=\"'pdf'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <holding-alert-legacy class=warning ng-if=!statementsCtrl.validDate(statementsCtrl.yearHigh)> <span translate>You can not request a report for a month which has not yet ended.</span> </holding-alert-legacy> <holding-alert-legacy class=error ng-if=statementsCtrl.yearHighReportError> <span ng-bind=statementsCtrl.yearHighReportError></span> </holding-alert-legacy> <div class=gmw-statements-generate-button-container ng-if=statementsCtrl.validDate(statementsCtrl.yearHigh)> <button ng-if=!statementsCtrl.yearlyUrl class=\"medium-main-cta gmw-responsive-button\" gmw-action=statementsCtrl.generateReport()> <span ng-bind=\"'Generate Report'|translate\"></span> </button> <a ng-if=statementsCtrl.yearlyUrl class=\"medium-main-cta gmw-responsive-button gmw-statements-generate-button\" ng-href=\"{{statementsCtrl.yearlyUrl}}\" target=_blank> <span ng-bind=\"'Open Report'|translate\"></span> </a> </div> <holding-statement ng-if=statementsCtrl.yearHighStatements ng-repeat=\"statement in statementsCtrl.yearHighStatements\" statement=statement dated-by=statementsCtrl.endOfMonthStatement.result.datedBy> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Precious Metal Balance'|translate\"> </span> <holding-statement-metals metals=statement.result.metals total=statement.result.metalTotal> </holding-statement-metals> </div> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Cryptocurrency Balance'|translate\"> </span> <holding-statement-crypto cryptos=statement.result.crypto total=statement.result.cryptoTotal> </holding-statement-crypto> </div> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" ng-bind=\"'Currency Funds Balance'|translate\"> </span> <holding-statement-funds fiat=statement.result.fiats total=statement.result.fiatTotal> </holding-statement-funds> </div> <holding-statement-total amount=statement.result.total> <span ng-bind=\"'Total'|translate\"></span> </holding-statement-total> <holding-statement-rates products=statement.result.productRates> </holding-statement-rates> </holding-statement> </div> <div ng-switch-when=monthly> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=show class=gmw-input-container--split-half__col ng-model=statementsCtrl.monthly.month options=statementsCtrl.monthOptions description=\"{{'Month'|translate}}\" no-label=true> </gmw-box-selector> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=statementsCtrl.monthly.year options=statementsCtrl.yearOptions description=\"{{'Year'|translate}}\" no-label=true> </gmw-box-selector> </div> <div class=gmw-input-container> <gmw-toggle-option-group ng-model=statementsCtrl.monthlyType> <gmw-toggle-option label=\"{{'Browse'|translate}}\" value=\"'browse'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Print'|translate}}\" value=\"'print'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'PDF Download'|translate}}\" value=\"'pdf'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=gmw-statements-generate-button-container ng-if=statementsCtrl.validDate(statementsCtrl.monthly)> <button ng-if=!statementsCtrl.monthlyUrl class=\"medium-main-cta gmw-responsive-button\" gmw-action=statementsCtrl.generateReport()> <span ng-bind=\"'Generate Report'|translate\"></span> </button> <a ng-if=statementsCtrl.monthlyUrl class=\"medium-main-cta gmw-responsive-button gmw-statements-generate-button\" ng-href=\"{{statementsCtrl.monthlyUrl}}\" target=_blank> <span ng-bind=\"'Open Report'|translate\"></span> </a> </div> <holding-alert-legacy class=warning ng-if=!statementsCtrl.validDate(statementsCtrl.monthly)> <span translate>You can not request a report for a month which has not yet ended.</span> </holding-alert-legacy> <holding-statement ng-if=statementsCtrl.monthlyStatement statement=statementsCtrl.monthlyStatement dated-by=statementsCtrl.endOfMonthStatement.closeBalance.datedBy> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" translate> Opening Balances as of {{statementsCtrl.monthlyStatement.month|holdingStartOfMonth}} </span> <holding-statement-metals metals=statementsCtrl.monthlyStatement.openBalance.metals total=statementsCtrl.monthlyStatement.openBalance.metalTotal> </holding-statement-metals> <holding-statement-crypto cryptos=statementsCtrl.monthlyStatement.openBalance.crypto total=statementsCtrl.monthlyStatement.openBalance.cryptoTotal> </holding-statement-crypto> <holding-statement-funds fiat=statementsCtrl.monthlyStatement.openBalance.fiats total=statementsCtrl.monthlyStatement.openBalance.fiatTotal> </holding-statement-funds> </div> <holding-statement-total amount=statementsCtrl.monthlyStatement.openBalance.total> <span ng-bind=\"'Total'|translate\"></span> </holding-statement-total> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" translate> Assets Movements - {{statementsCtrl.monthlyStatement.month|holdingStartOfMonth}} to {{statementsCtrl.monthlyStatement.month|holdingEndOfMonth}} </span> <holding-statement-movements movements=statementsCtrl.monthlyStatement.moneyMovements></holding-statement-movements> </div> <holding-statement-rates products=statementsCtrl.monthlyStatement.openBalance.productRates> </holding-statement-rates> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" translate> Closing Balances as of {{statementsCtrl.monthlyStatement.month|holdingEndOfMonth}} </span> <holding-statement-metals metals=statementsCtrl.monthlyStatement.closeBalance.metals total=statementsCtrl.monthlyStatement.closeBalance.metalTotal> </holding-statement-metals> <holding-statement-crypto cryptos=statementsCtrl.monthlyStatement.closeBalance.crypto total=statementsCtrl.monthlyStatement.closeBalance.cryptoTotal> </holding-statement-crypto> <holding-statement-funds fiat=statementsCtrl.monthlyStatement.closeBalance.fiats total=statementsCtrl.monthlyStatement.closeBalance.fiatTotal> </holding-statement-funds> </div> <holding-statement-total amount=statementsCtrl.monthlyStatement.closeBalance.total> <span ng-bind=\"'Total'|translate\"></span> </holding-statement-total> <holding-statement-rates products=statementsCtrl.monthlyStatement.closeBalance.productRates> </holding-statement-rates> <div class=gmw-statement__section> <span class=\"gmw-statement__section-title heading-h1\" translate> Detailed Transaction Statement - {{statementsCtrl.monthlyStatement.month|holdingStartOfMonth}} to {{statementsCtrl.monthlyStatement.month|holdingEndOfMonth}} </span> <holding-statement-transactions ng-if=statementsCtrl.monthlyStatement.transactionDetails.length transactions=statementsCtrl.monthlyStatement.transactionDetails> </holding-statement-transactions> </div> </holding-statement> </div> </div> <footer class=gmw-flow-box-footer ng-if=\"statementsCtrl.showPrev || statementsCtrl.showNext\"> <div class=gmw-flow-box-footer__col> <button ng-if=statementsCtrl.showPrev class=\"medium-main-cta gmw-responsive-button\" gmw-action=statementsCtrl.prevPage()> <span ng-bind=\"'Previous'|translate\"></span> </button> </div> <span class=\"heading-h4 h-gold-text\" ng-if=\"statementsCtrl.showPrev || statementsCtrl.showNext\"> Page {{statementsCtrl.page}} of {{statementsCtrl.totalPages}} </span> <div class=gmw-flow-box-footer__col> <button ng-if=statementsCtrl.showNext class=\"medium-main-cta gmw-responsive-button\" gmw-action=statementsCtrl.nextPage()> <span ng-bind=\"'Next'|translate\"></span> </button> </div> </footer> </div> </div> ";

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


StatementsController.$inject = ['$scope', '$log', '$filter', 'gettextCatalog', 'HoldingUser', 'HoldingCurrencies', 'HoldingStatements'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.overview').controller('StatementsController', StatementsController);

function StatementsController($scope, $log, $filter, gettextCatalog, HoldingUser, HoldingCurrencies, HoldingStatements) {
  'ngInject';

  var DATE_FORMAT = 'YYYY-MM-DD';
  var vm = this;

  vm.generateReport = generateReport;
  vm.nextPage = nextPage;
  vm.prevPage = prevPage;
  vm.validDate = validDate;

  vm.statementTypes = [{
    value: 'transactions',
    label: gettextCatalog.getString('Transaction Reports')
  }, {
    value: 'endOfMonth',
    label: gettextCatalog.getString('End of Month Balance Summary')
  }, {
    value: 'yearHigh',
    label: gettextCatalog.getString('Highest Value on a Transaction Date in Year')
  }, {
    value: 'monthly',
    label: gettextCatalog.getString('Monthly Statement')
  }];
  vm.type = 'transactions';

  vm.showOptions = [{
    value: 'all',
    label: gettextCatalog.getString('All Transactions')
  }, {
    value: 'buyingselling',
    label: gettextCatalog.getString('Buying / Selling / Exchanging')
  }, {
    value: 'transfers',
    label: gettextCatalog.getString('Funds Transfers')
  }, {
    value: 'payments',
    label: gettextCatalog.getString('Payments')
  }, {
    value: 'fee',
    label: gettextCatalog.getString('Fees')
  }];

  var allCurrencies = [{
    value: 'all',
    label: gettextCatalog.getString('All Products & Currencies')
  }];
  vm.currencyOptions = allCurrencies.concat(HoldingCurrencies.getAllForSelectorWithName());

  function vaultDescription(vault) {
    var custodian = $filter('holdingVaultCustodian')(vault);
    var location = $filter('holdingVaultLocation')(vault);
    return custodian + ' ' + location;
  }

  var allVaults = [{
    value: 'all',
    label: gettextCatalog.getString('All Vaults')
  }];

  vm.vaults = allVaults.concat(['BRINKS_SINGAPORE', 'BRINKS_TORONTO', 'G4S_HONGKONG', 'MALCAAMIT_SINGAPORE', 'RHENUS_ZURICH', 'VIAMAT_FRANKFURT', 'VIAMAT_HONGKONG', 'VIAMAT_LONDON', 'VIAMAT_SINGAPORE', 'VIAMAT_ZURICH'].map(function (value) {
    return {
      value: value,
      label: vaultDescription(value)
    };
  }));

  var today = (0, _moment2.default)();

  vm.transactions = {
    currency: 'all',
    transactions: 'all',
    from: (0, _moment2.default)(today).subtract(1, 'days').format(DATE_FORMAT),
    to: today.format(DATE_FORMAT),
    vault: 'all'
  };
  vm.page = 1;
  vm.transactionType = 'browse';

  // End of Month Balance, Monthly Statement, All Year High

  vm.currencyDisplayOptions = HoldingCurrencies.getAllFiatForSelectorWithName();

  vm.monthOptions = _moment2.default.localeData()._months.map(function (label, index) {
    return {
      label: label,
      value: index + 1
    };
  });
  vm.yearOptions = range((0, _moment2.default)().year(), 2003).map(function (value) {
    return {
      value: value,
      label: value
    };
  });

  vm.endOfMonth = {
    month: today.month(),
    year: today.year()
  };
  vm.endOfMonthType = 'browse';
  vm.maxDate = today.format(DATE_FORMAT);
  vm.minDate = (0, _moment2.default)('01-01-2001', DATE_FORMAT);
  vm.monthly = {
    month: today.month(),
    year: today.year()
  };
  vm.monthlyType = 'browse';

  vm.yearHigh = {
    month: 12,
    year: today.year() - 1
  };
  vm.yearlyType = 'browse';

  activate();

  function activate() {
    vm.user = HoldingUser.get();

    $scope.$watch('statementsCtrl.type', function () {
      vm.endOfMonthStatement = null;
      vm.monthlyStatement = null;
      vm.transactionsStatement = null;
      vm.showPrev = null;
      vm.showNext = null;
      vm.yearHighStatements = null;
    });

    $scope.$watchGroup(['statementsCtrl.type', 'statementsCtrl.yearHigh.month', 'statementsCtrl.yearHigh.year'], getDatesYearly);

    $scope.$watchGroup(['statementsCtrl.type', 'statementsCtrl.monthlyType', 'statementsCtrl.monthly.month', 'statementsCtrl.monthly.year'], getMonthlyUrl);

    $scope.$watchGroup(['statementsCtrl.type', 'statementsCtrl.endOfMonthType', 'statementsCtrl.endOfMonth.month', 'statementsCtrl.endOfMonth.year'], getEndOfMonthUrl);

    $scope.$watchGroup(['statementsCtrl.type', 'statementsCtrl.transactionType', 'statementsCtrl.transactions.transactions', 'statementsCtrl.transactions.currency', 'statementsCtrl.transactions.equivalent', 'statementsCtrl.transactions.vault', 'statementsCtrl.transactions.from', 'statementsCtrl.transactions.to', 'statementsCtrl.transactions.memo'], getTransactionsUrl, true);

    $scope.$watch('statementsCtrl.transactions.from', updateDateLimitsFrom);

    $scope.$watchGroup(['statementsCtrl.type', 'statementsCtrl.yearlyType', 'statementsCtrl.yearHigh.month', 'statementsCtrl.yearHigh.year', 'statementsCtrl.yearHigh.exactDate'], getYearlyUrl);
  }

  function generateEndOfMonthReport() {
    vm.endOfMonthStatement = null;
    return HoldingStatements.getEndOfMonthStatement(vm.endOfMonth, vm.endOfMonthType).then(function (result) {
      vm.endOfMonthStatement = result;
      vm.endOfMonthStatement.created = (0, _moment2.default)();
      vm.endOfMonthStatement.user = vm.user;
      vm.endOfMonthStatement.month = getMomentFromMonth(vm.endOfMonth);
    });
  }

  function generateMonthlyReport() {
    vm.monthlyStatement = null;
    return HoldingStatements.getMonthlyStatement(vm.monthly, vm.monthlyType).then(function (result) {
      vm.monthlyStatement = result;
      vm.monthlyStatement.created = (0, _moment2.default)();
      vm.monthlyStatement.user = vm.user;
      vm.monthlyStatement.month = getMomentFromMonth(vm.monthly);
    });
  }

  function generateTransactionsReport() {
    vm.transactionsStatement = null;
    var page = vm.showAllTransactions ? null : vm.page;
    return HoldingStatements.getTransactionsStatement(vm.transactions, vm.transactionType, page).then(function (result) {
      if (vm.showAllTransactions) {
        vm.page = 1;
        vm.showPrev = false;
        vm.showNext = false;
      } else {
        vm.showPrev = vm.page > 1;
        vm.totalPages = Math.ceil(result.count / 10);
        vm.showNext = vm.page < vm.totalPages;
      }
      vm.transactionsStatement = result;
      vm.transactionsStatement.created = (0, _moment2.default)();
      vm.transactionsStatement.user = angular.copy(vm.user);
      vm.transactionsStatement.user.currency = result.equivalentCurrency;
    });
  }

  function generateReport() {
    switch (vm.type) {
      case 'endOfMonth':
        return generateEndOfMonthReport();
      case 'monthly':
        return generateMonthlyReport();
      case 'transactions':
        return generateTransactionsReport();
      case 'yearHigh':
        return generateYearHighReport();
      default:
        return undefined;
    }
  }

  function generateYearHighReport() {
    vm.yearHighStatements = null;
    vm.yearHighReportError = null;
    return HoldingStatements.getYearHighStatement(vm.yearHigh, vm.yearlyType).then(function (result) {
      var now = (0, _moment2.default)();
      vm.yearHighStatements = result.values.map(function (value) {
        value.created = now;
        value.user = vm.user;
        value.date = (0, _moment2.default)(value.date);
        value.endMonth = getMomentFromMonth(vm.yearHigh);
        value.startMonth = getMomentFromMonth(vm.yearHigh).subtract(11, 'months');
        return value;
      });
    }).catch(function (error) {
      $log.error(error);
      vm.yearHighReportError = error.message;
    });
  }

  function getDatesYearly(_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        type = _ref2[0],
        month = _ref2[1],
        year = _ref2[2];

    if (type === 'yearHigh' && month && year) {
      vm.yearHigh.exactDate = null;
      vm.yearHighReportError = null;
      return HoldingStatements.getYearHighStatement(vm.yearHigh).then(function (result) {
        var dates = result.values.map(function (_) {
          return _.date;
        });
        vm.yearHigh.exactDate = dates[0];
        vm.yearDates = dates.map(function (value) {
          return {
            value: value,
            label: value
          };
        });
      }).catch(function (error) {
        $log.error(error);
        vm.yearHighReportError = error.message;
      });
    }
    return undefined;
  }

  function getMonthlyUrl(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 4),
        type = _ref4[0],
        monthlyType = _ref4[1],
        month = _ref4[2],
        year = _ref4[3];

    if (type === 'monthly' && month && year && (monthlyType === 'print' || monthlyType === 'pdf')) {
      vm.monthlyUrl = HoldingStatements.getMonthlyStatement(vm.monthly, vm.monthlyType);
    } else {
      vm.monthlyUrl = null;
    }
  }

  function getTransactionsUrl(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        type = _ref6[0],
        transactionsType = _ref6[1];

    if (type === 'transactions' && transactionsType === 'excel') {
      vm.transactionsUrl = HoldingStatements.getTransactionsStatement(vm.transactions, vm.transactionType);
    } else {
      vm.transactionsUrl = null;
    }
  }

  function getEndOfMonthUrl(_ref7) {
    var _ref8 = _slicedToArray(_ref7, 4),
        type = _ref8[0],
        endOfMonthType = _ref8[1],
        month = _ref8[2],
        year = _ref8[3];

    if (type === 'endOfMonth' && month && year && (endOfMonthType === 'print' || endOfMonthType === 'pdf')) {
      vm.endOfMonthUrl = HoldingStatements.getEndOfMonthStatement(vm.endOfMonth, vm.endOfMonthType);
    } else {
      vm.endOfMonthUrl = null;
    }
  }

  function getYearlyUrl(_ref9) {
    var _ref10 = _slicedToArray(_ref9, 5),
        type = _ref10[0],
        yearlyType = _ref10[1],
        month = _ref10[2],
        year = _ref10[3],
        exactDate = _ref10[4];

    if (type === 'yearHigh' && month && year && exactDate && (yearlyType === 'print' || yearlyType === 'pdf')) {
      vm.yearlyUrl = HoldingStatements.getYearHighStatement(vm.yearHigh, vm.yearlyType);
    } else {
      vm.yearlyUrl = null;
    }
  }

  function getMomentFromMonth(_ref11) {
    var month = _ref11.month,
        year = _ref11.year;

    return (0, _moment2.default)({
      year: year,
      month: month - 1
    });
  }

  function nextPage() {
    vm.page += 1;
    return generateTransactionsReport();
  }

  function prevPage() {
    vm.page -= 1;
    return generateTransactionsReport();
  }

  function range(begin, end) {
    var result = [];
    for (var i = begin; i >= end; i -= 1) {
      result.push(i);
    }
    return result;
  }

  function updateDateLimitsFrom(from, oldFrom) {
    if (from !== oldFrom) {
      if ((0, _moment2.default)(vm.transactions.to).isBefore(from)) {
        vm.transactions.to = from;
      }
    }
  }

  function validDate(_ref12) {
    var month = _ref12.month,
        year = _ref12.year;

    return (0, _moment2.default)({ year: year, month: month - 1 }).isBefore((0, _moment2.default)(), 'month');
  }
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _transactions = __webpack_require__(792);

var _transactions2 = _interopRequireDefault(_transactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.overview').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.overview.transactions', {
    data: {
      pageTitle: 'Holding Transactions'
    },
    url: '/transactions',
    views: {
      'overview-main': {
        controller: 'TransactionsController',
        controllerAs: 'transactionsCtrl',
        template: _transactions2.default
      }
    }
  });
}]);

__webpack_require__(793);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <div ng-if=transactionsCtrl.loadedTransactions> <div class=gmw-table-section ng-if=\"transactionsCtrl.pendingTransactions.length > 0\"> <header class=gmw-table-header> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title\" ng-bind=\"'Pending Transactions'|translate\"> </h2> </header> <holding-transaction-item ng-repeat=\"transaction in transactionsCtrl.pendingTransactions track by $index\" transaction=transaction> </holding-transaction-item> </div> <div class=gmw-table-section ng-if=\"transactionsCtrl.completedTransactions.length > 0\"> <header class=gmw-table-header> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title\" ng-bind=\"'Completed Transactions'|translate\"> </h2> </header> <holding-transaction-item ng-repeat=\"transaction in transactionsCtrl.completedTransactions track by $index\" transaction=transaction> </holding-transaction-item> </div> <div class=gmw-empty-state ng-if=\"transactionsCtrl.transactions.length < 1\"> <div class=\"gmw-empty-state__img gmw-empty-state__img--transactions\"></div> <span> <span class=\"heading-h3 h-light-text\" ng-bind=\"'You have no pending or recently completed transactions. Looking for historical transactions?'|translate\"> </span> <a class=h-light-link ui-sref=holding.dashboard.overview.statements ng-bind=\"'View your Statements'|translate\"></a><span class=\"heading-h3 h-light-text\">.</span> </span> </div> </div> <div class=gmw-table-section ng-if=transactionsCtrl.loadingError> <header class=gmw-table-header> <h2 class=\"heading-h2 h-dark-text gmw-table-header__title\" ng-bind=\"'Completed & Pending Transactions'|translate\"> </h2> </header> <holding-alert-legacy class=error> <span ng-bind=\"'An error retrieving your recent transactions, please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> ";

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


TransactionsController.$inject = ['$log', 'HoldingTransactions'];
angular.module('app.holding.dashboard.overview').controller('TransactionsController', TransactionsController);

function TransactionsController($log, HoldingTransactions) {
  'ngInject';

  var vm = this;

  function activate() {
    HoldingTransactions.getTransactions().then(function (transactions) {
      vm.loadedTransactions = true;
      vm.transactions = angular.copy(transactions).map(function (transaction) {
        transaction.rate = {
          value: transaction.rate,
          quoteCurrency: transaction.fiat.currency,
          baseCurrency: transaction.product.currency
        };
        return transaction;
      });
      vm.pendingTransactions = angular.copy(vm.transactions).filter(isNotCompleted);
      vm.completedTransactions = angular.copy(vm.transactions).filter(isCompleted);
    }).catch(function (error) {
      $log.error(error);
      vm.loadingError = true;
    });
  }

  function isCompleted(transaction) {
    return transaction.status === 'Completed';
  }

  function isNotCompleted(transaction) {
    return transaction.status !== 'Completed';
  }

  activate();
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SidebarController.$inject = ['$q', '$interval', '$log', '$scope', 'HoldingMessages', 'HoldingUser', 'GmwSetup'];
angular.module('app.holding.dashboard.overview').controller('SidebarController', SidebarController);

function SidebarController($q, $interval, $log, $scope, HoldingMessages, HoldingUser, GmwSetup) {
  'ngInject';

  function activate() {
    var user = HoldingUser.get();

    vm.canAddFunds = HoldingUser.isAllowed('addFunds');

    GmwSetup.hasCompletedSetup().then(function (hasCompletedSetup) {
      vm.hasCompletedSetup = hasCompletedSetup;
    });

    vm.hasSetSecurityQuestions = !user.loginFlags.setSecurityQuestions;

    GmwSetup.needsVerification().then(function (needsVerification) {
      vm.needsVerification = needsVerification;
    });

    vm.showMessaging = HoldingMessages.showMessaging();
    vm.showVerification = HoldingUser.isAllowed('verification');
    vm.user = user;

    checkUnread();
    contentTimer = $interval(function () {
      checkUnread();
    }, CONTENT_DELAY);
  }

  function checkUnread() {
    HoldingMessages.getUnreadMessages(false).then(function (unreadMessages) {
      vm.unreadMessages = unreadMessages.unread;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function onDestroy() {
    $interval.cancel(contentTimer);
  }

  var CONTENT_DELAY = 300000;

  var vm = this;
  var contentTimer = void 0;

  activate();

  $scope.$on('$destroy', onDestroy);
}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.promotions', [_angularjs2.default, _common2.default]).name;


__webpack_require__(796);
__webpack_require__(798);
__webpack_require__(800);
__webpack_require__(802);
__webpack_require__(804);

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promotionBanner = __webpack_require__(797);

var _promotionBanner2 = _interopRequireDefault(_promotionBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.promotions').directive('holdingPromotionBanner', holdingPromotionBanner).name;


function holdingPromotionBanner() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      canClose: '=?',
      onClose: '&?'
    },
    template: _promotionBanner2.default,
    transclude: true
  };
}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <div class=holding-special-banner> <div class=holding-special-banner__close-container ng-if=canClose ng-click=onClose()> <svg class=holding-special-banner__close-icon> <use xlink:href=#cross-icon></use> </svg> </div> <div class=holding-special-banner__container ng-transclude></div> </div> </div> ";

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promotionBonusBanner = __webpack_require__(799);

var _promotionBonusBanner2 = _interopRequireDefault(_promotionBonusBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.promotions').directive('holdingPromotionBonusBanner', holdingPromotionBonusBanner).name;


function holdingPromotionBonusBanner() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      bonus: '=',
      onClose: '&?'
    },
    template: _promotionBonusBanner2.default
  };

  function link(scope, _element, attrs) {
    scope.canClose = 'onClose' in attrs;
  }
}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "<holding-promotion-banner can-close=canClose on-close=onClose()> <div class=holding-special-banner__copy> <span class=\"h-large-text h-white-text h-margin-bottom-5\"> <span ng-bind=\"'Claim a'|translate\"></span> <span ng-bind=\"bonus.rate * 100 + '%'\"></span> <span ng-bind=\"'bonus on your next purchase of'|translate\"></span> <span ng-bind=bonus.product|lowercase></span> </span> <p class=\"h-default-text h-white-80-text\"> <span ng-if=bonus.minProductAmountOpt> <span ng-bind=\"'Minimum'|translate\"></span> <span ng-bind=\"bonus.minProductAmountOpt + (bonus.product == 'Silver' ? 'oz' : 'g')\"></span> </span> <span ng-if=bonus.maxProductAmountOpt> <span ng-if=!bonus.minProductAmountOpt ng-bind=\"'Maximum'|translate\"></span> <span ng-if=bonus.minProductAmountOpt ng-bind=\"'maximum'|translate\"></span> <span ng-bind=\"bonus.maxProductAmountOpt + (bonus.product == 'Silver' ? 'oz' : 'g')\"></span> </span> <span ng-bind=\"'purchase'|translate\"></span>. <a class=h-blue-link ng-if=bonus.fullTermsUrl ng-href=\"{{bonus.fullTermsUrl}}\" ng-bind=\"'Terms Apply'|translate\"> </a> </p> </div> <div class=holding-special-banner__meta ng-if=bonus.expiry> <span class=\"heading-h4 h-gold-text\" ng-bind=\"'Valid Until'|translate\"> </span> <span class=\"heading-h2 h-white-text\" ng-bind=\"bonus.expiry|gmwFormatDate:'MMMM Do, YYYY'\"> </span> </div> </holding-promotion-banner> ";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingPromotionVaultExchangeBanner.$inject = ['HoldingPromotions'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promotionVaultExchangeBanner = __webpack_require__(801);

var _promotionVaultExchangeBanner2 = _interopRequireDefault(_promotionVaultExchangeBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.promotions').directive('holdingPromotionVaultExchangeBanner', holdingPromotionVaultExchangeBanner).name;


function holdingPromotionVaultExchangeBanner(HoldingPromotions) {
  'ngInject';

  return {
    link: link,
    restrict: 'E',
    scope: {
      bonus: '=',
      onClose: '&?'
    },
    template: _promotionVaultExchangeBanner2.default
  };

  function link(scope, _element, attrs) {
    scope.canClose = 'onClose' in attrs;
    scope.vaultExchangePromotion = HoldingPromotions.isVaultExchangeSale();
  }
}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "<holding-promotion-banner can-close=canClose on-close=onClose()> <div class=holding-special-banner__copy> <span class=\"h-large-text h-white-text h-margin-bottom-5\"> <span ng-bind=\"'Move your metal for just'|translate\"></span> <span ng-bind=\"vaultExchangePromotion.rate + '%'\"></span> </span> <p class=\"h-default-text h-white-80-text\"> <span ng-bind=\"'The Vault Exchange feature allows you to sell and re-buy your metal in a new location at a discounted rate.'|translate\"></span> </p> </div> <div class=holding-special-banner__meta> <button class=medium-white-cta ui-sref=holding.dashboard.metals.vault-exchange ng-bind=\"'Get Started'|translate\"> </button> </div> </holding-promotion-banner> ";

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingPromotionsPager.$inject = ['HoldingPromotions'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promotionsPager = __webpack_require__(803);

var _promotionsPager2 = _interopRequireDefault(_promotionsPager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.promotions').directive('holdingPromotionsPager', holdingPromotionsPager).name;


function holdingPromotionsPager(HoldingPromotions) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _promotionsPager2.default,
    transclude: true
  };

  function link(scope) {
    // buy promotion logic
    HoldingPromotions.getPromoCode().then(function (promoCode) {
      scope.promoCode = promoCode;
      scope.showBonusPromotionBanner = !!promoCode;
    });
  }
}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "<div> <holding-promotion-bonus-banner ng-if=showBonusPromotionBanner bonus=promoCode> </holding-promotion-bonus-banner> </div> ";

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingPromotions.$inject = ['HoldingApi', 'HoldingCookies', 'HoldingProperties'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = angular.module('app.holding.dashboard.promotions').factory('HoldingPromotions', HoldingPromotions).name;


function HoldingPromotions(HoldingApi, HoldingCookies, HoldingProperties) {
  'ngInject';

  return {
    clearPromoCookie: clearPromoCookie,
    dismissPromotionBanner: dismissPromotionBanner,
    getPromoCode: getPromoCode,
    isPromotionBannerDismissed: isPromotionBannerDismissed,
    isVaultExchangeSale: isVaultExchangeSale
  };

  function clearPromoCookie() {
    HoldingCookies.remove('promo_code', {
      domain: '.goldmoney.com',
      path: '/'
    });
  }

  function dismissPromotionBanner(bannerKey) {
    var _HoldingProperties$ge = HoldingProperties.get('PromotionDismissed'),
        value = _HoldingProperties$ge.value;

    HoldingProperties.set('PromotionDismissed', {
      value: Object.assign(value ? value : {}, _defineProperty({}, bannerKey, new Date().toISOString()))
    });
  }

  function getPromoCode() {
    return HoldingApi.get('buy/promo').then(function (_ref) {
      var promo = _ref.promo;
      return promo;
    });
  }

  function isPromotionBannerDismissed(bannerKey) {
    var _HoldingProperties$ge2 = HoldingProperties.get('PromotionDismissed'),
        value = _HoldingProperties$ge2.value;

    return value && bannerKey in value;
  }

  function isVaultExchangeSale() {
    return {
      expiry: null,
      rate: 0.5,
      sale: true,
      start: 1601475863
    };
  }
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.transfers', [_angularjs2.default, _common2.default]).name;


__webpack_require__(806);
__webpack_require__(808);
__webpack_require__(809);

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transferRecap = __webpack_require__(807);

var _transferRecap2 = _interopRequireDefault(_transferRecap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.transfers').directive('holdingTransferRecap', holdingTransferRecap).name;


function holdingTransferRecap() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      equivalent: '=',
      info: '=',
      type: '='
    },
    template: _transferRecap2.default
  };
}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-recap-table gmw-recap-table--margin-bottom gmw-recap-table--shadow gmw-recap-table--narrow gmw-recap-table--small-padding\"> <gmw-recap-table-header label=\"{{'Transfer Details'|translate}}\"></gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Transfer Type'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-switch=type> <span ng-switch-when=metal ng-bind=\"'Metal'|translate\"></span> <span ng-switch-when=currency ng-bind=\"'Currency'|translate\"></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Transfer Method'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=info.money.currency|holdingCurrencyName></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=\"type === 'metal'\"> <div class=gmw-recap-table__col> <span ng-bind=\"'Withdraw from'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=info.vault|holdingVaultCustodian></span> <span ng-bind=info.vault|holdingVaultLocation></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Amount'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-switch=type> <span ng-switch-when=currency ng-bind=info.money|holdingFormatFunds></span> <span ng-switch-default ng-bind=info.money|gmwFormatProduct></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Fee'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-switch=type> <span ng-switch-when=currency ng-bind=info.fee|holdingFormatFunds></span> <span ng-switch-default ng-bind=info.fee|gmwFormatProduct></span> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col> <span ng-bind=\"'Send to'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=info.payeeNumber></span> </span> </div> </div> <div class=gmw-recap-table__row ng-if=info.memo> <div class=gmw-recap-table__col> <span ng-bind=\"'Message'|translate\"></span> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value> <span ng-bind=info.memo></span> </span> </div> </div> </div> </div> ";

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingTransfers.$inject = ['$rootScope', 'HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.transfers').factory('HoldingTransfers', HoldingTransfers).name;


function HoldingTransfers($rootScope, HoldingApi) {
  'ngInject';

  return {
    getHoldings: getHoldings,
    getVaults: getVaults,
    invite: invite,
    previewTransfer: previewTransfer,
    sendTransfer: sendTransfer,
    updateTransferAlias: updateTransferAlias
  };

  function getHoldings(email) {
    return HoldingApi.get('payments/recipients/' + email);
  }

  function getVaults() {
    return HoldingApi.get('payments/vaults');
  }

  function invite(email) {
    return HoldingApi.post('payments/invites/' + email);
  }

  function previewTransfer(model) {
    return HoldingApi.post('payments/preview', model, { ignore403: true });
  }

  function sendTransfer(model) {
    return HoldingApi.post('payments', model).then(function (result) {
      $rootScope.$broadcast('gmw:balance:changed');
      return result;
    });
  }

  function updateTransferAlias(userAlias) {
    var alias = userAlias;
    if (!alias || alias.length === 0) {
      alias = null;
    }
    return HoldingApi.put('holdings/alias', { alias: alias });
  }
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(810);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(811);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.transfers').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.transfers', {
    abstract: true,
    data: {
      heroNoMobileActionTabs: true
    },
    url: '/transfers',
    views: {
      hero: {
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    }
  });

  $urlRouterProvider.when('/transfers', '/transfers/new');
}]).name;


__webpack_require__(812);

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Transfers'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center></section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=transfers-main></div> ";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _newFlow = __webpack_require__(813);

var _newFlow2 = _interopRequireDefault(_newFlow);

var _new = __webpack_require__(814);

var _new2 = _interopRequireDefault(_new);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.transfers').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.transfers.new', {
    data: {
      flow: _newFlow2.default,
      heroNoMobileActionTabs: true
    },
    params: {
      currency: {
        type: 'string',
        value: null
      },
      type: {
        type: 'string',
        value: null
      },
      vault: {
        type: 'string',
        value: null
      }
    },
    resolve: {
      CanSendTransferResolve: ['$q', 'HoldingUser', function CanSendTransferResolve($q, HoldingUser) {
        'ngInject';

        return $q.when(HoldingUser.isAllowed('makePayment'));
      }],
      SelectedCurrencyResolve: ['$q', '$stateParams', function SelectedCurrencyResolve($q, $stateParams) {
        'ngInject';

        return 'currency' in $stateParams ? $q.when($stateParams.currency) : $q.when();
      }],
      SelectedTypeResolve: ['$q', '$stateParams', function SelectedTypeResolve($q, $stateParams) {
        'ngInject';

        return 'type' in $stateParams ? $q.when($stateParams.type) : $q.when();
      }],
      SelectedVaultResolve: ['$q', '$stateParams', function SelectedVaultResolve($q, $stateParams) {
        'ngInject';

        return 'vault' in $stateParams ? $q.when($stateParams.vault) : $q.when();
      }]
    },
    url: '/new',
    views: {
      'transfers-main': {
        controller: 'NewTransferController',
        controllerAs: 'newTransferCtrl',
        template: _new2.default
      }
    }
  });

  $urlRouterProvider.when('/transfers/new', '/transfers/new/type');
}]);

__webpack_require__(815);
__webpack_require__(817);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(822);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('New Metal Transfer'),
    cancel: {
        state: 'holding.dashboard.transfers.new'
    },
    complete: {
        label: (0, _gettext2.default)('Back to Overview'),
        state: 'holding.dashboard.overview',
        options: {
            reload: true
        }
    },
    steps: [{
        key: 'type',
        state: 'holding.dashboard.transfers.new.type',
        heading: (0, _gettext2.default)('Select Transfer Type'),
        label: (0, _gettext2.default)('Transfer Type')
    }, {
        key: 'amount',
        state: 'holding.dashboard.transfers.new.amount',
        heading: (0, _gettext2.default)('Select Amount & Recipient'),
        label: (0, _gettext2.default)('Amount & Recipient')
    }, {
        key: 'review',
        state: 'holding.dashboard.transfers.new.review',
        cancel: true,
        heading: (0, _gettext2.default)('Review Transfer'),
        label: (0, _gettext2.default)('Review'),
        controls: {
            next: (0, _gettext2.default)('Send Transfer')
        }
    }, {
        key: 'complete',
        state: 'holding.dashboard.transfers.new.complete',
        complete: true,
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "<section class=\"gmw-flow-box gmw-flow-box--center\" ng-if=!newTransferCtrl.canSendTransfer> <holding-permission-based-empty-state permission=makePayment></holding-permission-based-empty-state> </section> <section ng-if=newTransferCtrl.canSendTransfer> <div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I buy metals?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000520188> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'How long does a purchase take to process?'|translate}}\" href=https://support.goldmoney.com/hc/articles/360000686007> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> </section> ";

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _amount = __webpack_require__(816);

var _amount2 = _interopRequireDefault(_amount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.transfers').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.transfers.new.amount', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Transfers - Select Amount & Recipient'
    },
    url: '/amount',
    views: {
      step: {
        template: _amount2.default
      }
    }
  });
}]);

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container ng-form=newTransferCtrl.form> <div ng-switch=newTransferCtrl.currencyType> <div ng-switch-when=metal> <div class=gmw-flow-box__description> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Transfer Calculator'|translate\"></span> <p translate> Use the calculator to determine the amount of metal you would like to transfer or directly enter the weight below. </p> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=currency class=gmw-input-container--split-half__col ng-model=newTransferCtrl.fiatAmount.currency options=newTransferCtrl.allCurrencies no-label=true> </gmw-box-selector> <gmw-box-input name=fiatAmount type=number currency=\"{{newTransferCtrl.fiatAmount.currency}}\" class=gmw-input-container--split-half__col has-error=\"newTransferCtrl.form.fiatAmount.$dirty && newTransferCtrl.form.fiatAmount.$invalid\" ng-model=newTransferCtrl.fiatAmount.amount focus=\"newTransferCtrl.setLastTouched('fiat')\" no-label=true ng-model-options=\"{\n            debounce: 400,\n          }\" placeholder=0.00> <gmw-box-input-meta-left> {{newTransferCtrl.fiatAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> <div class=\"gmw-input-container gmw-input-container--margin-bottom gmw-input-container--split-thirds\"> <gmw-box-input name=amount required type=number currency=\"{{newTransferCtrl.model.money.currency}}\" class=gmw-input-container--split-thirds__col has-error=\"newTransferCtrl.form.amount.$dirty && newTransferCtrl.form.amount.$invalid\" ng-model=newTransferCtrl.model.money.amount focus=\"newTransferCtrl.setLastTouched('metal')\" label=\"{{newTransferCtrl.model.money.currency}} Weight\" max=newTransferCtrl.max.amount ng-model-options=\"{\n            debounce: 400,\n          }\" placeholder=\"{{(0).toFixed(newTransferCtrl.model.money|holdingCurrencyPrecision)}}\"> <gmw-box-input-meta-right> {{newTransferCtrl.model.money.currency|holdingCurrencySymbol}} </gmw-box-input-meta-right> </gmw-box-input> <gmw-box-input name=rateGram currency=\"{{newTransferCtrl.fiatAmount.currency}}\" class=gmw-input-container--split-thirds__col ng-model=newTransferCtrl.gramsRate label=\"{{'Price per Gram'|translate}}\" is-readonly=true ng-disabled=true placeholder=0.00> <gmw-box-input-meta-left> {{newTransferCtrl.fiatAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> <gmw-box-input name=rateOunce currency=\"{{newTransferCtrl.fiatAmount.currency}}\" class=gmw-input-container--split-thirds__col ng-model=newTransferCtrl.ouncesRate label=\"{{'Price per Ounce'|translate}}\" is-readonly=true ng-disabled=true placeholder=0.00> <gmw-box-input-meta-left> {{newTransferCtrl.fiatAmount.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> </div> <div ng-switch-when=currency> <gmw-box-input class=\"gmw-input-container gmw-input-container--margin-bottom\" required name=currencyAmount type=number currency=\"{{newTransferCtrl.model.money.currency}}\" has-error=\"newTransferCtrl.form.amount.$dirty && newTransferCtrl.form.amount.$invalid\" ng-model=newTransferCtrl.model.money.amount label=\"{{'Enter Amount'|translate}}\" max=newTransferCtrl.max.amount placeholder=0.00> <gmw-box-input-label-right> <span class=heading-h4>Total {{newTransferCtrl.max.currency}}: <span class=h-dark-text> {{newTransferCtrl.max|holdingFormatFunds}} </span> </span> </gmw-box-input-label-right> <gmw-box-input-meta-left> {{newTransferCtrl.model.money.currency|holdingCurrencySymbol}} </gmw-box-input-meta-left> </gmw-box-input> </div> </div> <div class=gmw-flow-box__description> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Select Recipient'|translate\"></span> <p translate> To send a transfer to a Holding owner, enter their Holding number below or enter the recipient’s Transfer Alias. Access your <a ui-sref=settings-profile.preferences class=h-blue-link>Holding Preferences</a> if you would like to create your own Transfer Alias. </p> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input ng-required=!(newTransferCtrl.model.alias) change=newTransferCtrl.clearAlias() name=number class=gmw-input-container--split-half__col ng-model=newTransferCtrl.model.number label=\"{{'Send to Holding'|translate}}\" has-error=\"newTransferCtrl.form.number.$dirty && newTransferCtrl.form.number.$invalid\" placeholder=\"{{'Holding number eg. 00-00-00-00-A'|translate}}\"> </gmw-box-input> <span class=\"gmw-input-container--split-half__or heading-h5\" ng-bind=\"'OR'|translate\"></span> <gmw-box-input ng-required=!(newTransferCtrl.model.number) change=newTransferCtrl.clearNumber() name=alias class=gmw-input-container--split-half__col ng-model=newTransferCtrl.model.alias label=\"{{'Send to Transfer Alias'|translate}}\" has-error=\"newTransferCtrl.form.alias.$dirty && newTransferCtrl.form.alias.$invalid\" placeholder=\"{{'Transfer alias'|translate}}\"> </gmw-box-input> </div> <holding-alert class=error ng-if=newTransferCtrl.previewError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=newTransferCtrl.previewError></span> </main> </holding-alert> <div class=gmw-flow-box__description ng-if=\"newTransferCtrl.invite === 'show'\"> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Send Invite'|translate\"></span> <p translate> Invite a friend to apply for a Goldmoney Holding so that they may receive transfers from you in the future. Note, a transfer is not sent from your Holding when sending an invitation. </p> </div> <gmw-box-input-simple name=recipient class=gmw-input-container ng-if=\"newTransferCtrl.invite === 'show'\" ng-model=newTransferCtrl.email placeholder=\"{{'Enter recipient\\'s email'|translate}}\"> </gmw-box-input-simple> <div class=gmw-transfers-search-button-container> <a class=h-blue-link ng-if=!newTransferCtrl.invite ng-click=newTransferCtrl.showInvite() ng-bind=\"'Invite a Friend'|translate\"> </a> <button ng-if=\"newTransferCtrl.invite === 'show'\" class=\"medium-main-cta gmw-responsive-button\" ng-disabled=!newTransferCtrl.email gmw-action=newTransferCtrl.sendInvite()> <span ng-bind=\"'Send Invite'|translate\"></span> </button> <a href ng-if=\"newTransferCtrl.invite === 'complete'\" ng-click=\"\" ng-bind=\"'Invite Sent'|translate\"> </a> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=newTransferCtrl.cancel() on-next=newTransferCtrl.next() spinner step-disabled=\"newTransferCtrl.form.$invalid || newTransferCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _complete = __webpack_require__(818);

var _complete2 = _interopRequireDefault(_complete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.transfers').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.transfers.new.complete', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Transfers - Complete'
    },
    url: '/complete',
    views: {
      step: {
        template: _complete2.default
      }
    }
  });
}]);

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-flow-box-success-header> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--one\"></div> <div class=\"gmw-flow-box-success-header__angle gmw-flow-box-success-header__angle--two\"></div> <img class=gmw-flow-box-success-header__icon src=/img/order-success-check.svg> <span class=gmw-flow-box-success-header__text> <span class=gmw-flow-box-success-header__title ng-bind=\"'Your transfer has been sent'|translate\"> </span> </span> </div> <div class=gmw-flow-box-container ng-form=newTransferCtrl.form> <holding-transfer-recap info=newTransferCtrl.result.data type=newTransferCtrl.currencyType equivalent=newTransferCtrl.fiatAmount> </holding-transfer-recap> </div> <footer class=gmw-flow-box-footer> <holding-flow-controls on-next=newTransferCtrl.next()> </holding-flow-controls> </footer> ";

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


NewTransferController.$inject = ['$controller', '$filter', '$q', '$scope', '$state', 'HoldingCurrencies', 'HoldingMarkets', 'HoldingTransfers', 'HoldingUser', 'CanSendTransferResolve', 'SelectedCurrencyResolve', 'SelectedTypeResolve', 'SelectedVaultResolve'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('app.holding.dashboard.transfers').controller('NewTransferController', NewTransferController);

function NewTransferController($controller, $filter, $q, $scope, $state, HoldingCurrencies, HoldingMarkets, HoldingTransfers, HoldingUser, CanSendTransferResolve, SelectedCurrencyResolve, SelectedTypeResolve, SelectedVaultResolve) {
  'ngInject';

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    vaultsPromise = HoldingTransfers.getVaults().then(function (vaults) {
      var spendableVaults = vaults.filter(function (_) {
        return _.spendable.amount > 0;
      });

      var metalVaults = spendableVaults.filter(isType('Metal')).filter(function (vault) {
        return currencies.find(function (currency) {
          return currency === vault.currencyCode;
        });
      });
      var fiatVaults = spendableVaults.filter(isType('Fiat')).filter(function (vault) {
        return currencies.find(function (currency) {
          return currency === vault.currencyCode;
        });
      });

      if (SelectedTypeResolve && ['Currency', 'Metal'].find(function (type) {
        return type.toLowerCase() === SelectedTypeResolve;
      })) {
        vm.currencyType = SelectedTypeResolve;
      } else {
        if (metalVaults.length > 0) {
          vm.currencyType = 'metal';
        } else if (fiatVaults.length > 0) {
          vm.currencyType = 'currency';
        }
      }

      vm.showSelector = [metalVaults, fiatVaults].filter(function (_) {
        return _.length > 0;
      }).length > 1;

      vm.showMetalSelector = metalVaults.length > 0;
      vm.showFiatSelector = fiatVaults.length > 0;

      vm.currencies = fiatVaults.map(function (_ref) {
        var amount = _ref.spendable;
        return angular.extend(HoldingCurrencies.prepareForSelector(amount.currency), { amount: amount });
      });

      var metals = [].concat(_toConsumableArray(new Set(metalVaults.map(function (_) {
        return _.currencyCode;
      }))));
      vm.metals = metals;
      vm.selectorMetals = metals.map(function (metal) {
        return {
          label: metal,
          value: metal
        };
      });

      return { metals: metals, metalVaults: metalVaults, fiatVaults: fiatVaults };
    }).catch(function (_ref2) {
      var code = _ref2.code;

      if (code === 'UNAUTHORIZED') {
        $state.go('holding.dashboard.overview', {}, {
          reload: true
        });
      }
    });
  }

  function checkAmount() {
    return !!vm.model.money.amount;
  }

  function checkComplete() {
    return !!vm.result.complete;
  }

  function checkVault() {
    switch (vm.currencyType) {
      case 'metal':
      default:
        return !!vm.model.money.currency && !!vm.model.vault;
      case 'currency':
        return !!vm.model.money.currency;
    }
  }

  function clearAlias() {
    vm.model.alias = null;
  }

  function clearNumber() {
    vm.model.number = null;
  }

  function flatten(list) {
    return list.reduce(function (a, b) {
      return a.concat(Array.isArray(b) ? flatten(b) : b);
    }, []);
  }

  function getVaultLabel(vault) {
    var custodian = vaultCustodian(vault);
    var country = vaultLocation(vault);
    return custodian + ' ' + country;
  }

  function isType(type) {
    return function (v) {
      return HoldingCurrencies.getTypeByCode(v.currencyCode) === type;
    };
  }

  function onCurrencyChange(currency) {
    if (currency && vm.currencyType === 'metal') {
      vaultsPromise.then(function (_ref3) {
        var metalVaults = _ref3.metalVaults;

        vm.vaults = metalVaults.filter(function (_) {
          return _.currencyCode === currency;
        }).map(function (vault) {
          return {
            value: vault.vault,
            label: getVaultLabel(vault.vault),
            amountMetal: vault.spendable
          };
        });

        if (SelectedVaultResolve && vm.vaults.find(function (vault) {
          return vault.value === SelectedVaultResolve;
        })) {
          var targetVault = vm.vaults.find(function (vault) {
            return vault.value === SelectedVaultResolve;
          });
          vm.model.vault = targetVault.value;
          vm.max = targetVault.amountMetal;
        } else {
          vm.model.vault = vm.vaults[0].value;
          vm.max = vm.vaults[0].amountMetal;
        }
      });
    }

    if (currency && vm.currencyType === 'currency') {
      vm.max = vm.currencies.find(function (_) {
        return _.value === currency;
      }).amount;
      vm.model.vault = 'NONE';
    }
  }

  function onCurrencyTypeChange(currencyType) {
    switch (currencyType) {
      case 'metal':
        vaultsPromise.then(function (_ref4) {
          var metals = _ref4.metals;

          vm.model.money = {
            currency: metals[0],
            amount: undefined
          };

          if (SelectedCurrencyResolve) {
            vm.model.money.currency = vm.metals.find(function (metal) {
              return metal === SelectedCurrencyResolve;
            });
          }
        });
        break;
      case 'currency':
        vaultsPromise.then(function (_ref5) {
          var fiatVaults = _ref5.fiatVaults;

          vm.model.money = {
            currency: fiatVaults[0].currencyCode,
            amount: undefined
          };

          if (SelectedCurrencyResolve && vm.currencies.find(function (currency) {
            return currency.value === SelectedCurrencyResolve;
          })) {
            vm.model.money.currency = vm.currencies.find(function (currency) {
              return currency.value === SelectedCurrencyResolve;
            }).value;
          }
        });
        break;
      default:
        vm.model.money = {
          currency: null,
          amount: 0
        };
    }
  }

  function onEquivalentCurrencyChange(_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        currency = _ref7[0],
        equivalentCurrency = _ref7[1];

    if (currency && equivalentCurrency && vm.currencyType === 'metal') {
      updateRates(vm.model.vault).then(function (rates) {
        var equivalentRate = rates[currency][equivalentCurrency];
        vm.rate = equivalentRate.value;
        vm.gramsRate = formatRate(equivalentRate, 'g', true);
        vm.ouncesRate = formatRate(equivalentRate, 'oz', true);

        updateMetalAmount(vm.fiatAmount.amount);
      });
    }
  }

  function onFiatAmountChange(amount) {
    if (vm.lastTouched === 'fiat') {
      updateMetalAmount(amount);
      if (amount) {
        vm.form.amount.$setDirty();
      }
    }
  }

  function onMetalAmountChange(amount) {
    if (vm.lastTouched === 'metal') {
      if (!amount) {
        vm.fiatAmount.amount = undefined;
      } else {
        vm.fiatAmount.amount = round(amount * vm.rate, 2);
        vm.form.fiatAmount.$setDirty();
      }
    }
  }

  function onVaultChange(vaultId) {
    if (vaultId && vm.vaults && vm.currencyType === 'metal') {
      var vault = vm.vaults.find(function (_) {
        return _.value === vaultId;
      });
      vm.max = vault.amountMetal;

      updateRates(vm.model.vault);
    }
  }

  function preview() {
    vm.previewError = null;

    return HoldingTransfers.previewTransfer(vm.model).then(function (previewResult) {
      vm.preview = previewResult;
    }).catch(function (error) {
      if (error.code === 'NOT_FOUND') {
        vm.invite = 'show';
      }
      vm.previewError = error.message;
      return $q.reject(error);
    });
  }

  function round(number, precision) {
    var rounded = Math.round(number + 'e+' + precision);
    return +(rounded + 'e-' + precision);
  }

  function sendInvite() {
    return HoldingTransfers.invite(vm.email).then(function () {
      vm.invite = 'complete';
    });
  }

  function sendTransfer() {
    vm.executionError = null;
    return HoldingTransfers.sendTransfer(vm.model).then(function (transferResult) {
      vm.result.data = transferResult;
      vm.result.complete = true;
    }).catch(function (error) {
      vm.executionError = error.message;
      return $q.reject(error);
    });
  }

  function selectHolding(holding) {
    vm.model.receiver = holding;
  }

  function setLastTouched(lastTouched) {
    vm.lastTouched = lastTouched;
  }

  function showInvite() {
    vm.invite = 'show';
  }

  function updateMetalAmount(fiatAmount) {
    if (!fiatAmount) {
      vm.model.money.amount = undefined;
    } else {
      vm.model.money.amount = round(fiatAmount / vm.rate, HoldingCurrencies.getPrecisionByCode(vm.model.money.currency));
    }
  }

  function updateRates(vault) {
    return vaultsPromise.then(function () {
      return HoldingMarkets.getSummary(vault);
    }).then(function (_ref8) {
      var current = _ref8.current;

      var allRates = flatten(current).map(function (_ref9) {
        var quoteCurrency = _ref9.quoteCurrency,
            baseCurrency = _ref9.baseCurrency,
            value = _ref9.avg;
        return { quoteCurrency: quoteCurrency, baseCurrency: baseCurrency, value: value };
      });
      var rates = {};
      vm.metals.forEach(function (metal) {
        rates[metal] = {};
        var metalRates = allRates.filter(function (_) {
          return _.baseCurrency === metal;
        });
        metalRates.forEach(function (rate) {
          rates[rate.baseCurrency][rate.quoteCurrency] = rate;
        });
      });
      return rates;
    });
  }

  var DEFAULT_MODEL = {
    money: {},
    vault: null
  };

  var ratesPromise = void 0,
      vaultsPromise = void 0;
  var vm = this;

  var _HoldingUser$getPermi = HoldingUser.getPermission('makePayment'),
      currencies = _HoldingUser$getPermi.currencies;

  var formatRate = $filter('gmwFormatProductRate');
  var vaultCustodian = $filter('holdingVaultCustodian');
  var vaultLocation = $filter('holdingVaultLocation');

  vm.canSendTransfer = CanSendTransferResolve;
  vm.clearAlias = clearAlias;
  vm.clearNumber = clearNumber;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.refresh = preview;
  vm.result = {};
  vm.sendInvite = sendInvite;
  vm.selectHolding = selectHolding;
  vm.setLastTouched = setLastTouched;
  vm.showInvite = showInvite;
  vm.steps = {
    'holding.dashboard.transfers.new.type': {
      checks: []
    },
    'holding.dashboard.transfers.new.amount': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.transfers.new.type'
      }],
      next: preview
    },
    'holding.dashboard.transfers.new.review': {
      checks: [{
        function: checkVault,
        revertTo: 'holding.dashboard.transfers.new.type'
      }, {
        function: checkAmount,
        revertTo: 'holding.dashboard.transfers.new.amount'
      }],
      next: sendTransfer
    },
    'holding.dashboard.transfers.new.complete': {
      checks: [{
        function: checkComplete,
        revertTo: 'holding.dashboard.transfers.new.review'
      }]
    }
  };

  if (CanSendTransferResolve) {
    vm.allCurrencies = HoldingCurrencies.getAllFiatForSelector();
    vm.fiatAmount = {
      currency: vm.allCurrencies[0].value,
      amount: null
    };

    activate();

    $scope.$watch('newTransferCtrl.currencyType', onCurrencyTypeChange);
    $scope.$watch('newTransferCtrl.model.money.currency', onCurrencyChange);
    $scope.$watchGroup(['newTransferCtrl.model.money.currency', 'newTransferCtrl.fiatAmount.currency'], onEquivalentCurrencyChange);
    $scope.$watch('newTransferCtrl.fiatAmount.amount', onFiatAmountChange);
    $scope.$watch('newTransferCtrl.model.money.amount', onMetalAmountChange);
    $scope.$watch('newTransferCtrl.model.vault', onVaultChange);
  }
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _review = __webpack_require__(821);

var _review2 = _interopRequireDefault(_review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.transfers').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.transfers.new.review', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Transfers - Review Transfer'
    },
    url: '/review',
    views: {
      step: {
        template: _review2.default
      }
    }
  });
}]);

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container ng-form=newTransferCtrl.form> <div ng-show=\"newTransferCtrl.form.pin.$dirty && newTransferCtrl.form.pin.$invalid\" ng-messages=newTransferCtrl.form.pin.$error> <div ng-message=required> <holding-alert-legacy class=error> <span ng-bind=\"'Please enter a valid pin value.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=gmw-flow-pin ng-if=newTransferCtrl.preview.pin> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=gmw-input-container--split-half__col> <span class=\"gmw-flow-pin__title heading-h4 h-dark-text\" ng-bind=\"'Enter PIN Code to Authenticate'|translate\"> </span> <a href class=h-blue-link ng-bind=\"'What is this?'|translate\" gmw-tooltip=\"{{'Two-step authentication requires that you enter a seven-digit PIN code to send a transfer. This randomly generated PIN has been sent via email or text message (per your account settings). Please enter the PIN to complete your transfer.'|translate}}\"> </a> </div> <div class=gmw-input-container--split-half__col> <gmw-box-input required name=pin no-label=true has-error=\"newTransferCtrl.form.pin.$dirty && newTransferCtrl.form.pin.$invalid\" ng-model=newTransferCtrl.model.pin placeholder=\"{{'Enter PIN'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> </div> </div> <holding-transfer-recap info=newTransferCtrl.preview type=newTransferCtrl.currencyType equivalent=newTransferCtrl.fiatAmount> </holding-transfer-recap> <div class=gmw-flow-box__description> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Reference'|translate\"></span> <p translate> The below message will be included in the recipient’s email notification and/or Holding statement along with your name and Holding number. </p> </div> <gmw-box-input type=textarea name=memo class=gmw-input-container ng-model=newTransferCtrl.model.memo no-label=true placeholder=\"{{'Enter message'|translate}}\"> </gmw-box-input> <holding-alert-legacy class=error ng-if=newTransferCtrl.executionError> <span ng-bind=newTransferCtrl.executionError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=newTransferCtrl.cancel() on-next=newTransferCtrl.next() spinner step-disabled=\"newTransferCtrl.form.$invalid || newTransferCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _type = __webpack_require__(823);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.transfers').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.dashboard.transfers.new.type', {
    data: {
      heroNoMobileActionTabs: true,
      pageTitle: 'Transfers - Select Transfer Type'
    },
    url: '/type',
    views: {
      step: {
        template: _type2.default
      }
    }
  });
}]);

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> Select your transfer preferences and, if applicable, the vault from which you wish to fund your transfer. </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=newTransferCtrl.form> <holding-alert-legacy class=error ng-if=\"newTransferCtrl.metals.length === 0 && newTransferCtrl.currencies.length === 0\"> <span translate>You have nothing available to send.</span> </holding-alert-legacy> <div class=gmw-input-container ng-if=newTransferCtrl.showSelector> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Select Transfer Type'|translate\"> </label> <gmw-toggle-option-group ng-model=newTransferCtrl.currencyType> <gmw-toggle-option ng-if=newTransferCtrl.showMetalSelector label=\"{{'Metal'|translate}}\" value=\"'metal'\"> </gmw-toggle-option> <gmw-toggle-option ng-if=newTransferCtrl.showFiatSelector label=\"{{'Currency'|translate}}\" value=\"'currency'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div ng-switch=newTransferCtrl.currencyType> <div ng-switch-when=metal> <holding-metal-toggle name=metals class=\"desktop-only desktop-only--xs\" label=\"{{'Select Metal'|translate}}\" ng-model=newTransferCtrl.model.money.currency metals=newTransferCtrl.metals> </holding-metal-toggle> <gmw-box-selector required name=metals class=\"gmw-input-container mobile-only mobile-only--xs\" ng-model=newTransferCtrl.model.money.currency options=newTransferCtrl.selectorMetals label=\"{{'Select Metal'|translate}}\"> </gmw-box-selector> <gmw-box-selector required name=vault class=gmw-input-container ng-model=newTransferCtrl.model.vault options=newTransferCtrl.vaults label=\"{{'Select Vault'|translate}}\"> </gmw-box-selector> </div> <div ng-switch-when=currency> <gmw-box-selector required name=currency class=gmw-input-container ng-model=newTransferCtrl.model.money.currency options=newTransferCtrl.currencies label=\"{{'Select Currency'|translate}}\"> </gmw-box-selector> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=newTransferCtrl.cancel() on-next=newTransferCtrl.next() spinner step-disabled=\"newTransferCtrl.form.$invalid || newTransferCtrl.form.$submitted || !newTransferCtrl.currencyType\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.vaults', []).name;


__webpack_require__(825);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwVaultLogo.$inject = ['HoldingVaults'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultLogo = __webpack_require__(826);

var _vaultLogo2 = _interopRequireDefault(_vaultLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.vaults').directive('gmwVaultLogo', gmwVaultLogo).name;


function gmwVaultLogo(HoldingVaults) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'E',
    replace: true,
    template: _vaultLogo2.default,
    scope: {
      vault: '='
    }
  };
  return directive;

  function link(scope, _element, attrs) {
    function getVaultInfo() {
      return HoldingVaults.getVaultInfoById(scope.vault);
    }

    scope.hideFlag = 'hideFlag' in attrs;
    scope.getVaultInfo = getVaultInfo;
  }
}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "<span class=gmw-vault-logo> <gmw-flag country=getVaultInfo().countryCode ng-if=\"!hideFlag && getVaultInfo().countryCode\"> </gmw-flag> <svg class=gmw-vault-logo__custodian ng-if=getVaultInfo().icon ng-style=getVaultInfo().icon.style> <use ng-attr-xlink:href=\"{{getVaultInfo().icon.id}}\" xlink:href=\"\"></use> </svg> </span> ";

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingVaultCustodian.$inject = ['gettextCatalog', 'HoldingVaults'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.vaults').filter('holdingVaultCustodian', holdingVaultCustodian).name;


function holdingVaultCustodian(gettextCatalog, HoldingVaults) {
  'ngInject';

  var custodians = {
    brinks: gettextCatalog.getString('Brink’s'),
    g4s: gettextCatalog.getString('G4S'),
    malcaamit: gettextCatalog.getString('Malca-Amit'),
    rcm: gettextCatalog.getString('Royal Canadian Mint'),
    rhenus: gettextCatalog.getString('Rhenus'),
    viamat: gettextCatalog.getString('Loomis')
  };

  return function (input) {
    var vault = HoldingVaults.getVaultInfoById(input);
    return custodians[vault.custodian];
  };
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingVaultCountry.$inject = ['HoldingVaults'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.vaults').filter('holdingVaultCountry', holdingVaultCountry).name;


function holdingVaultCountry(HoldingVaults) {
  'ngInject';

  var countries = {
    ca: 'Canada',
    ch: 'Switzerland',
    de: 'Germany',
    gb: 'UK',
    hk: 'Hong Kong',
    sg: 'Singapore',
    ae: 'Dubai',
    us: 'USA'
  };

  return function (input) {
    var vault = HoldingVaults.getVaultInfoById(input);
    return countries[vault.countryCode];
  };
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingVaultCountryCode.$inject = ['HoldingVaults'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.vaults').filter('holdingVaultCountryCode', holdingVaultCountryCode).name;


function holdingVaultCountryCode(HoldingVaults) {
  'ngInject';

  return function (input) {
    if (!input) {
      return undefined;
    }
    return HoldingVaults.getVaultInfoById(input).countryCode;
  };
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingVaultLocation.$inject = ['HoldingVaults'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.vaults').filter('holdingVaultLocation', holdingVaultLocation).name;


function holdingVaultLocation(HoldingVaults) {
  'ngInject';

  return function (input) {
    var vault = HoldingVaults.getVaultInfoById(input);
    return vault.location;
  };
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingVaults.$inject = ['$q', 'HoldingApi', 'gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.vaults').factory('HoldingVaults', HoldingVaults).name;


function HoldingVaults($q, HoldingApi, gettextCatalog) {
  'ngInject';

  var vaults = [{
    custodian: 'brinks',
    id: 'BRINKS_HONGKONG',
    name: 'Brink’s',
    location: gettextCatalog.getString('Hong Kong'),
    countryCode: 'hk',
    icon: {
      id: '#brinks-logo',
      style: {
        width: '62px',
        height: '12px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Brink\'s Hong Kong Limited insures the metal stored at it\'s Hong Kong vault against risks such as theft, meaning that your metals are protected. The insurance certificate cites coverage \'For an amount of USD 10,000,000 of property\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'brinks',
    id: 'BRINKS_LONDON',
    name: 'Brink’s',
    location: gettextCatalog.getString('London'),
    countryCode: 'gb',
    icon: {
      id: '#brinks-logo',
      style: {
        width: '62px',
        height: '12px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Brink\'s Limited insures the metal stored at it\'s London vault against risks such as theft, meaning that your metals are protected. The insurance certificate cites coverage \'For an amount of USD 10,000,000 of property\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'brinks',
    id: 'BRINKS_NEWYORK',
    name: 'Brink’s',
    location: gettextCatalog.getString('New York'),
    countryCode: 'us',
    icon: {
      id: '#brinks-logo',
      style: {
        width: '62px',
        height: '12px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Brink\'s Inc insures the metal stored at it\'s New York vault against risks such as theft, meaning that your metals are protected. The insurance certificate cites coverage \'For an amount of USD 10,000,000 of property\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'brinks',
    id: 'BRINKS_SINGAPORE',
    name: 'Brink’s',
    location: gettextCatalog.getString('Singapore'),
    countryCode: 'sg',
    icon: {
      id: '#brinks-logo',
      style: {
        width: '62px',
        height: '12px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Brink\'s Singapore Pte Limited insures the metal stored at it\'s Singapore vault against risks such as theft, meaning that your metals are protected. The insurance certificate cites coverage \'For an amount of USD 200,000,000 of property\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'brinks',
    id: 'BRINKS_TORONTO',
    name: 'Brink’s',
    location: gettextCatalog.getString('Toronto'),
    countryCode: 'ca',
    icon: {
      id: '#brinks-logo',
      style: {
        width: '62px',
        height: '12px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Brink\'s Canada Limited insures the metal stored at it\'s Toronto vault against risks such as theft, meaning that your metals are protected. The insurance certificate cites coverage \'For an amount of CDN 50,000,000 of property\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'brinks',
    id: 'BRINKS_ZURICH',
    name: 'Brink’s',
    location: gettextCatalog.getString('Zurich'),
    countryCode: 'ch',
    icon: {
      id: '#brinks-logo',
      style: {
        width: '62px',
        height: '12px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Brink\'s Switzerland Limited insures the metal stored at it\'s Zurich vault against risks such as theft, meaning that your metals are protected. The insurance certificate cites coverage \'For an amount of USD 10,000,000 of property\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'g4s',
    id: 'G4S_HONGKONG',
    name: 'G4S',
    location: gettextCatalog.getString('Hong Kong'),
    countryCode: 'hk',
    icon: {
      id: '#g4s-logo',
      style: {
        width: '61px',
        height: '24px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('G4S International Logistics (Hong Kong) Limited insures its Hong Kong vault against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 200,000,000 any one loss for property in any one location\'. Should the total value of metal in any one location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'viamat',
    id: 'VIAMAT_FRANKFURT',
    name: 'Loomis',
    location: gettextCatalog.getString('Frankfurt'),
    countryCode: 'de',
    icon: {
      id: '#loomis-logo',
      style: {
        width: '31px',
        height: '16px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Loomis International insures the vaults against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 50,000,000 any one loss for property in any one location\'. A \'location\' is a single secured facility, and there may be more than one secured facility in each city where Goldmoney stores precious metals (i.e., multiple vault locations spread out across a city). Should the total value of metal in any one location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'viamat',
    id: 'VIAMAT_HONGKONG',
    name: 'Loomis',
    location: gettextCatalog.getString('Hong Kong'),
    countryCode: 'hk',
    icon: {
      id: '#loomis-logo',
      style: {
        width: '31px',
        height: '16px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Loomis International insures the vaults against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 50,000,000 any one loss for property in any one location\'. A \'location\' is a single secured facility, and there may be more than one secured facility in each city where Goldmoney stores precious metals (i.e., multiple vault locations spread out across a city). Should the total value of metal in any one location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'viamat',
    id: 'VIAMAT_LONDON',
    name: 'Loomis',
    location: gettextCatalog.getString('London'),
    countryCode: 'gb',
    icon: {
      id: '#loomis-logo',
      style: {
        width: '31px',
        height: '16px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Loomis International insures the vaults against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 50,000,000 any one loss for property in any one location\'. A \'location\' is a single secured facility, and there may be more than one secured facility in each city where Goldmoney stores precious metals (i.e., multiple vault locations spread out across a city). Should the total value of metal in any one location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'viamat',
    id: 'VIAMAT_SINGAPORE',
    name: 'Loomis',
    location: gettextCatalog.getString('Singapore'),
    countryCode: 'sg',
    icon: {
      id: '#loomis-logo',
      style: {
        width: '31px',
        height: '16px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Loomis International insures the vaults against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 50,000,000 any one loss for property in any one location\'. A \'location\' is a single secured facility, and there may be more than one secured facility in each city where Goldmoney stores precious metals (i.e., multiple vault locations spread out across a city). Should the total value of metal in any one location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'viamat',
    id: 'VIAMAT_ZURICH',
    name: 'Loomis',
    location: gettextCatalog.getString('Zurich'),
    countryCode: 'ch',
    icon: {
      id: '#loomis-logo',
      style: {
        width: '31px',
        height: '16px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Loomis International insures the vaults against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 50,000,000 any one loss for property in any one location\'. A \'location\' is a single secured facility, and there may be more than one secured facility in each city where Goldmoney stores precious metals (i.e., multiple vault locations spread out across a city). Should the total value of metal in any one location reach this amount, additional insurance coverage will be provided.')
    }
  }, {
    custodian: 'malcaamit',
    id: 'MALCAAMIT_SINGAPORE',
    name: 'Malca-Amit',
    location: gettextCatalog.getString('Singapore'),
    countryCode: 'sg',
    icon: {
      id: '#malca-amit-logo',
      style: {
        width: '25px',
        height: '18px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('The Malca-Amit International Network arranges insurance of the precious metal stored in its vaults. The insurance policy provides \'All Risks Liability Insurance\' cover of USD 2,000,000,000.')
    }
  }, {
    custodian: 'rcm',
    id: 'RCM_OTTAWA',
    name: 'Royal Canadian Mint',
    location: gettextCatalog.getString('Ottawa'),
    countryCode: 'ca',
    icon: {
      id: '#rcm-logo',
      style: {
        width: '70px',
        height: '20px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('The Royal Canadian Mint insures it\'s vaults against risks such as theft so that your precious metals are protected. The insurance states coverage for \'USD 50,000,000 any one loss.')
    }
  }, {
    custodian: 'rhenus',
    id: 'RHENUS_ZURICH',
    name: 'Rhenus',
    location: gettextCatalog.getString('Zurich'),
    countryCode: 'ch',
    icon: {
      id: '#rhenus-logo',
      style: {
        width: '69px',
        height: '13px'
      }
    },
    insurance: {
      description: gettextCatalog.getString('Rhenus Freight Logistics AG insures its Zurich Airport vault against risks such as theft, meaning that the gold you store with them is protected. The insurance cites coverage \'in the amount of CHF 3,000,000\'. Should the total value of metal in this location reach this amount, additional insurance coverage will be provided.')
    }
  }];

  return {
    getAuditReports: getAuditReports,
    getInsuranceCertificate: getInsuranceCertificate,
    getInsuranceCertificates: getInsuranceCertificates,
    getVaultInfoById: getVaultInfoById,
    getVaultInventoryReports: getVaultInventoryReports,
    getVaultsForSelector: getVaultsForSelector
  };

  function getAuditReports() {
    return getVaultUploads('Audit').then(sortUploads);
  }

  function getInsuranceCertificate(vault) {
    return getVaultUploads('Insurance', vault).then(sortUploads).then(uniqueVaultUploads);
  }

  function getInsuranceCertificates() {
    return getVaultUploads('Insurance').then(sortUploads).then(uniqueVaultUploads);
  }

  function getVaultInfoById(id) {
    return vaults.find(function (vault) {
      return vault.id === id;
    }) || {
      custodian: '',
      countryCode: ''
    };
  }

  function getVaultInventoryReports() {
    return getVaultUploads('Inventory').then(sortUploads);
  }

  function getVaultsForSelector() {
    return vaults.filter(function (vault) {
      return !['BRINKS_HONGKONG', 'VIAMAT_HONGKONG', 'G4S_HONGKONG', 'RHENUS_ZURICH', 'MALCAAMIT_SINGAPORE', 'VIAMAT_FRANKFURT'].some(function (closedVault) {
        return closedVault === vault.id;
      });
    }).map(function (_ref) {
      var countryCode = _ref.countryCode,
          id = _ref.id,
          location = _ref.location,
          name = _ref.name;

      return {
        flag: countryCode,
        label: name + ' ' + location,
        value: id
      };
    });
  }

  function getVaultUploads(uploadType, vault) {
    return HoldingApi.get('vaults/uploads', {
      params: {
        uploadType: uploadType,
        vault: vault
      }
    });
  }

  function sortUploads(uploads) {
    return uploads.sort(function (a, b) {
      var dateA = (0, _moment2.default)(a.validTo);
      var dateB = (0, _moment2.default)(b.validTo);

      if (dateA.isBefore(dateB)) {
        return 1;
      } else if (dateB.isBefore(dateA)) {
        return -1;
      }
      return 0;
    });
  }

  function uniqueVaultUploads(uploads) {
    return uploads.filter(function (upload, index, self) {
      return self.findIndex(function (t) {
        return t.vault === upload.vault;
      }) === index;
    });
  }
}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-menu></holding-dashboard-menu> <div class=outer-core-wrapper> <div class=core-wrapper> <holding-dashboard-global-alerts></holding-dashboard-global-alerts> <section class=holding-dashboard-hero ng-class=\"{\n        'holding-dashboard-hero--no-tabs': $root.pageParams.heroNoMobileActionTabs,\n      }\" ui-view=hero> </section> <main class=core-wrapper__main ui-view=main> </main> <footer class=\"gmw-footer desktop-only desktop-only--xs\" ng-class=\"{\n        'gmw-footer--hide': $root.pageParams.hideFooter,\n      }\"> <span class=gmw-footer__copyright> <span ng-bind=\"'&copy; Copyright '|translate\"></span> <span ng-bind=dashboardCtrl.currentYear></span> <span ng-bind=\"' Goldmoney Inc. All rights reserved.'|translate\"></span> </span> <nav class=gmw-footer__nav> <a href holding-external-link=privacy class=\"gmw-footer__nav-item h-default-link\" ng-bind=\"'Privacy Policy'|translate\"> </a> <a href holding-external-link=clientAgreement.regulator.canada ng-if=\"dashboardCtrl.user.regulation == 'Toronto'\" class=\"gmw-footer__nav-item h-default-link\" ng-bind=\"'Client Agreement'|translate\"> </a> <a href holding-external-link=clientAgreement.regulator.uk ng-if=\"dashboardCtrl.user.regulation == 'UK'\" class=\"gmw-footer__nav-item h-default-link\" ng-bind=\"'Client Agreement'|translate\"> </a> <a href holding-external-link=disclaimer class=\"gmw-footer__nav-item h-default-link\" ng-bind=\"'Disclaimer'|translate\"> </a> </nav> </footer> </div> </div> <holding-gtm ng-if=dashboardCtrl.user.tracking></holding-gtm> <holding-dashboard-tutorial-menu></holding-dashboard-tutorial-menu> ";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingDashboardMenu.$inject = ['$q', '$log', '$transitions', '$rootScope', '$state', 'GmwModal', 'HoldingAuth', 'HoldingUser', 'HoldingProperties', 'GmwSetup', 'HoldingFunds', 'HoldingBalances', 'HoldingBankAccounts', 'HoldingTransactions'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardMenu = __webpack_require__(834);

var _dashboardMenu2 = _interopRequireDefault(_dashboardMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').component('holdingDashboardMenu', {
  controller: HoldingDashboardMenu,
  template: _dashboardMenu2.default
}).name;


function HoldingDashboardMenu($q, $log, $transitions, $rootScope, $state, GmwModal, HoldingAuth, HoldingUser, HoldingProperties, GmwSetup, HoldingFunds, HoldingBalances, HoldingBankAccounts, HoldingTransactions) {
  'ngInject';

  var vm = this;

  vm.user = HoldingUser.get();

  vm.closeNav = closeNav;
  vm.holdingNumber = vm.user.holdingNumber;
  vm.isFullHolding = vm.user.isFullHolding;
  vm.isShariahHolding = vm.user.shariaFlag;
  vm.name = vm.user.name;
  vm.openHelpModal = openHelpModal;
  vm.signOut = signOut;
  vm.toggleNav = toggleNav;
  vm.verified = vm.user.verified;
  vm.viewedTutorial = HoldingProperties.get('ViewedTutorial');

  $q.all([GmwSetup.hasCompletedSetup(), GmwSetup.needsVerification(), HoldingFunds.getRftrBanks(), HoldingBalances.getBalances(), HoldingFunds.getPendingAddFunds(), HoldingFunds.getPendingRemoveFunds()]).then(function (response) {
    vm.hasCompletedSetup = response[0];
    vm.needsVerification = response[1];
    vm.banks = response[2];
    var _response$ = response[3];
    vm.bars = _response$.bars;
    vm.fiat = _response$.fiat;
    vm.metals = _response$.metals;
    vm.pendingAddFundsTransfers = response[4];
    vm.pendingRemoveFundsTransfers = response[5];
  }).catch(function (error) {
    $log.error(error);
  }).finally(function () {
    // funding
    vm.showAddFunds = !HoldingUser.isHidden('addFunds');
    vm.allowAddFunds = HoldingUser.isAllowed('addFunds');
    vm.showExchangeFunds = !HoldingUser.isHidden('exchangeFiat');
    vm.allowExchangeFunds = HoldingUser.isAllowed('exchangeFiat') && hasFunds();
    vm.showRemoveFunds = !HoldingUser.isHidden('removeFunds');
    vm.allowRemoveFunds = HoldingUser.isAllowed('removeFunds');

    // metals
    vm.showBuyMetal = !HoldingUser.isHidden('buy');
    vm.allowBuyMetal = vm.hasCompletedSetup && !vm.user.locked;
    vm.showExchangeMetal = !HoldingUser.isHidden('exchange');
    vm.allowExchangeMetal = HoldingUser.isAllowed('exchange') && hasMetal();
    vm.showSellMetal = !HoldingUser.isHidden('sell');
    vm.allowSellMetal = HoldingUser.canSellMetal() && hasMetal();

    // transfers
    vm.showMakeTransfer = !HoldingUser.isHidden('makePayment');
    vm.allowMakeTransfer = HoldingUser.isAllowed('makePayment');

    // bar registration
    vm.showRegisterBars = !HoldingUser.isHidden('allocateBars');
    vm.allowRegisterBars = HoldingUser.isAllowed('allocateBars');

    // physical - baird bars
    vm.showRedeemBars = !HoldingUser.isHidden('redeemBars');
    vm.allowRedeemBars = HoldingUser.isAllowed('redeemBars');

    // bank accounts
    vm.showManageBankAccount = !HoldingUser.isHidden('addBankAccount') || !HoldingUser.isHidden('deleteBankAccount');
    vm.allowManageBankAccount = HoldingUser.isAllowed('addBankAccount') || HoldingUser.isAllowed('deleteBankAccount');
    vm.showLockBankAccount = vm.showManageBankAccount;

    HoldingBankAccounts.getSettings().then(function (settings) {
      var _HoldingUser$getPermi = HoldingUser.getPermission('addBankAccount'),
          maxBanksCount = _HoldingUser$getPermi.max;

      vm.showAddBankAccount = !HoldingUser.isHidden('addBankAccount') && HoldingUser.isAllowed('addBankAccount') && vm.banks && vm.banks.banks && vm.banks.banks.length < maxBanksCount && settings.availableNumberOfBankAccounts > 0;
    });

    // messaging
    vm.showMessaging = HoldingUser.isAllowed('messaging');
    vm.showServiceUpdates = HoldingUser.isAllowed('viewNews');

    // settings
    vm.showNotificationSettings = HoldingUser.isAllowed('receiveEmail');
    vm.showSmsPinSettings = HoldingUser.isAllowed('enableSMS');
    vm.showUpgrade = !vm.isFullHolding && !isPartnerManagedHolding();

    // verification
    vm.showVerification = HoldingUser.isAllowed('verification');
  });

  function closeNav() {
    if (!vm.viewedTutorial) {
      $rootScope.$broadcast('gmw:tutorial:secondary:show');
    }
    vm.navOpen = false;
  }

  function hasBankAccounts() {
    return 'banks' in vm && 'banks' in vm.banks && vm.banks.banks !== null && vm.banks.banks.length > 0;
  }

  function hasFunds() {
    return 'fiat' in vm && sumEquivalents(vm.fiat).amount > 0;
  }

  function hasMetal() {
    return 'metals' in vm && vm.metals !== null && vm.metals.length > 0;
  }

  function isPartnerManagedHolding() {
    return 'partnerCode' in vm.user && vm.user.partnerCode !== 'NONE';
  }

  function isStateActive(state) {
    return !vm.navOpen && $state.includes(state);
  }

  function openHelpModal() {
    GmwModal.showHelpModal();
  }

  function reduceAmounts(prev, curr) {
    return { amount: prev.amount + curr.amount, currency: curr.currency };
  }

  function setTutorialViewed() {
    vm.viewedTutorial = true;
  }

  function signOut() {
    HoldingAuth.signOut().then(function () {
      $state.go('auth.sign-in', {
        message: 'logout'
      });
    });
  }

  function sumEquivalents(objects) {
    return objects.map(function (_) {
      return _.equivalent;
    }).reduce(reduceAmounts, { amount: 0, currency: vm.user.currency });
  }

  function toggleNav() {
    vm.navOpen = !vm.navOpen;
  }

  $rootScope.$on('gmw:menu:main:toggle', toggleNav);
  $rootScope.$on('gmw:menu:tutorial:viewed', setTutorialViewed);
  $transitions.onSuccess({}, closeNav);
}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"mobile-tab-nav mobile-only mobile-only--xs\" ng-class=\"{\n    'mobile-tab-nav--nav-open': $ctrl.navOpen\n  }\"> <div class=mobile-tab-nav-item ui-sref=holding.dashboard.overview.balances ng-class=\"{\n      'mobile-tab-nav-item--active': $ctrl.isStateActive('holding.dashboard.overview.balances'),\n    }\"> <holding-svg-icon class=mobile-tab-nav-item__icon icon=overview width=19px height=20px></holding-svg-icon> <label class=mobile-tab-nav-item__label ng-bind=\"'Overview'|translate\"> </label> </div> <div class=mobile-tab-nav-item ui-sref=holding.dashboard.overview.transactions ng-class=\"{\n      'mobile-tab-nav-item--active': $ctrl.isStateActive('holding.dashboard.overview.transactions'),\n    }\"> <holding-svg-icon class=mobile-tab-nav-item__icon icon=transactions width=28px height=19px></holding-svg-icon> <label class=mobile-tab-nav-item__label ng-bind=\"'Transactions'|translate\"> </label> </div> <div class=mobile-tab-nav-item ui-sref=holding.dashboard.metals.buy ng-class=\"{\n      'mobile-tab-nav-item--active': $ctrl.isStateActive('metals.buy'),\n    }\"> <holding-svg-icon class=mobile-tab-nav-item__icon icon=dual-gold-bar-plus width=22px height=20px></holding-svg-icon> <label class=mobile-tab-nav-item__label ng-bind=\"'Buy Metal'|translate\"> </label> </div> <div class=mobile-tab-nav-item ui-sref=holding.dashboard.metals.sell ng-class=\"{\n      'mobile-tab-nav-item--active': $ctrl.isStateActive('metals.sell'),\n    }\"> <holding-svg-icon class=mobile-tab-nav-item__icon icon=dual-gold-bar-minus width=22px height=20px></holding-svg-icon> <label class=mobile-tab-nav-item__label ng-bind=\"'Sell Metal'|translate\"> </label> </div> <div class=mobile-tab-nav-item ng-class=\"{\n      'mobile-tab-nav-item--active': $ctrl.navOpen,\n    }\" ng-click=$ctrl.toggleNav()> <svg class=mobile-tab-nav-item__icon width=22 height=16> <use xlink:href=#more-nav-icon></use> </svg> <label class=mobile-tab-nav-item__label ng-bind=\"'More'|translate\"> </label> </div> </nav> <nav class=gmw-slide-nav ng-class=\"{\n    'gmw-slide-nav--active': $ctrl.navOpen,\n  }\"> <div class=\"gmw-slide-nav-mobile-top mobile-only mobile-only--xs\"> <div class=gmw-slide-nav-mobile-top__info> <a href=/ > <svg class=gmw-slide-nav-mobile-top__logo> <use xlink:href=#goldmoney-logo-22></use> </svg> </a> <div class=gmw-dual-dot-data> <span class=heading-h5 ng-bind=$ctrl.holdingNumber></span> <span class=\"gmw-dot gmw-dot--light\" ng-if=!$ctrl.isFullHolding>&middot;</span> <span class=heading-h5 ng-bind=\"'Basic Holding'|translate\" ng-if=!$ctrl.isFullHolding></span> </div> </div> <a href=javascript:; class=gmw-slide-nav-mobile-help-button ng-click=$ctrl.openHelpModal()> <holding-svg-icon class=gmw-slide-nav-mobile-help-button__icon icon=help width=20px height=20px></holding-svg-icon> <span class=heading-h6 ng-bind=\"'Help'|translate\"> </span> </a> <div class=holding-dashboard-hero-bg> <div class=\"holding-dashboard-hero-bg__angle holding-dashboard-hero-bg__angle--three\"></div> <div class=\"holding-dashboard-hero-bg__angle holding-dashboard-hero-bg__angle--two\"></div> <div class=\"holding-dashboard-hero-bg__angle holding-dashboard-hero-bg__angle--one\"></div> </div> </div> <div class=gmw-slide-nav__container> <div class=\"gmw-slide-nav-top-bar desktop-only desktop-only--xs\"> <div class=gmw-slide-nav-top-bar__user> <span class=\"gmw-slide-nav-top-bar__welcome heading-h4 h-gold-text\" ng-bind=\"'Welcome'|translate\"> </span> <span class=\"gmw-slide-nav-top-bar__name heading-h2 h-dark-text\" ng-bind=$ctrl.name> </span> </div> <a href class=gmw-slide-nav-top-bar__close ng-click=$ctrl.closeNav()> <holding-svg-icon class=gmw-slide-nav-top-bar__close-icon icon=cross></holding-svg-icon> </a> </div> <div class=\"gmw-slide-nav-date-bar desktop-only desktop-only--xs\"> <span class=heading-h6> <span class=heading-h6 gmw-date></span> - <span class=heading-h6 gmw-time></span> </span> </div> <div class=\"gmw-slide-nav-mobile-meta-bar mobile-only mobile-only--xs\"> <div class=\"gmw-slide-nav-mobile-meta-bar__date heading-h5\"> <span gmw-date></span> - <span gmw-time></span> </div> <a href class=gmw-slide-nav-signout-button ng-click=$ctrl.signOut()> <holding-svg-icon class=gmw-slide-nav-signout-button__icon icon=signout></holding-svg-icon> <span class=heading-h5 ng-bind=\"'Sign Out'|translate\"></span> </a> </div> <div class=gmw-slide-nav-main> <a ng-if=\"$ctrl.showVerification && !$ctrl.hasCompletedSetup\" ui-sref=setup class=gmw-slide-nav-verify> <img class=h-margin-right-20 src=/img/icons/verify-person-icon.svg> <div class=gmw-slide-nav-verify__content> <span class=\"h-default-text h-dark-text\" ng-bind=\"'Continue Holding Setup'|translate\"> </span> </div> <svg class=gmw-slide-nav-verify__arrow> <use xlink:href=#right-arrow-icon></use> </svg> </a> <a ng-if=\"$ctrl.showVerification && $ctrl.needsVerification\" ui-sref=verification class=gmw-slide-nav-verify> <img class=h-margin-right-20 src=/img/icons/verify-person-icon.svg> <div class=gmw-slide-nav-verify__content> <span class=\"h-default-text h-dark-text\" ng-bind=\"'Verify Holding'|translate\"> </span> <span class=h-medium-text ng-bind=\"'Verification not submitted'|translate\"> </span> </div> <svg class=gmw-slide-nav-verify__arrow> <use xlink:href=#right-arrow-icon></use> </svg> </a> <holding-dashboard-menu-nav-section> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=overview width=21px height=19px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Holding Overview'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item disabled=!$ctrl.hasCompletedSetup ui-sref=holding.dashboard.overview.balances ng-bind=\"'Balances'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.overview.transactions ng-bind=\"'Transactions'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.overview.statements ng-bind=\"'Statements'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section disabled=\"!$ctrl.allowBuyMetal && !$ctrl.allowSellMetal && !$ctrl.allowExchangeMetal\"> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=metal-to-metal width=22px height=20px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Precious Metals'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ng-if=$ctrl.showBuyMetal disabled=!$ctrl.allowBuyMetal ui-sref=holding.dashboard.metals.buy ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Buy Metals'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ng-if=$ctrl.showSellMetal disabled=!$ctrl.allowSellMetal ui-sref=holding.dashboard.metals.sell ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Sell Metals'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item disabled=!$ctrl.allowExchangeMetal ng-if=$ctrl.showExchangeMetal ui-sref=holding.dashboard.metals.exchange ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Exchange Metal'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item disabled=!$ctrl.allowExchangeMetal ng-if=$ctrl.showExchangeMetal ui-sref=holding.dashboard.metals.vault-exchange ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Vault Exchange'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=dual-bar-registration width=24px height=24px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Bar Registration'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ng-if=$ctrl.showRegisterBars disabled=!$ctrl.allowRegisterBars ui-sref=holding.dashboard.bars.registration ng-bind=\"'Register/Manage Bars'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.bars.lists ng-bind=\"'Bar Lists'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section ng-if=\"$ctrl.showAddFunds || $ctrl.showExchangeFunds || $ctrl.showRemoveFunds\" disabled=\"!$ctrl.allowAddFunds && !$ctrl.allowExchangeFunds && !$ctrl.allowRemoveFunds\"> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=gmw-wallet width=20px height=20px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Manage Funds'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item disabled=!$ctrl.allowAddFunds ng-if=$ctrl.showAddFunds ui-sref=holding.dashboard.funds.add ng-bind=\"'Add Funds'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item disabled=!$ctrl.allowRemoveFunds ng-if=$ctrl.showRemoveFunds ui-sref=holding.dashboard.funds.remove ng-bind=\"'Withdraw Funds'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item disabled=!$ctrl.allowExchangeFunds ng-if=$ctrl.showExchangeFunds ui-sref=holding.dashboard.funds.exchange ng-bind=\"'Exchange Funds'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section ng-if=$ctrl.showRedeemBars disabled=!$ctrl.allowRedeemBars> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=metal-bar-and-coin width=24px height=24px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Goldmoney Physical'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item disabled=!$ctrl.allowRedeemBars ui-sref=physical.delivery ng-bind=\"'Goldmoney Brand Gold Bars'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section ng-if=$ctrl.showMakeTransfer disabled=!$ctrl.allowMakeTransfer> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=dual-send-payment width=24px height=24px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Transfers'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ng-if=$ctrl.showMakeTransfer disabled=!$ctrl.allowMakeTransfer ui-sref=holding.dashboard.transfers.new ng-bind=\"'Initiate New Transfer'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=statements width=18px height=20px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Governance'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.governance.reports ng-bind=\"'Reports'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.governance.insurance ng-bind=\"'Insurance Certificates'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.governance.vault-video ng-bind=\"'Vault Video'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <holding-dashboard-menu-nav-section disabled=\"!$ctrl.showMessaging && !$ctrl.showServiceUpdates\"> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=gmw-messages width=22px height=13px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'Messages'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ui-sref=\"holding.dashboard.messages.folder({ messageFolder: 'inbox' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-if=$ctrl.showMessaging ng-bind=\"'Inbox'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=\"holding.dashboard.messages.folder({ messageFolder: 'sent' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-if=$ctrl.showMessaging ng-bind=\"'Sent Messages'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=holding.dashboard.messages.news ui-sref-opts=\"{\n              reload: true,\n            }\" ng-if=$ctrl.showServiceUpdates ng-bind=\"'Service Updates'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> <div class=\"mobile-only mobile-only--xs\"> <holding-dashboard-menu-nav-section> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=dual-cog width=20px height=20px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'More'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ui-sref=settings-profile ng-bind=\"'Profile Settings'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ui-sref=settings-security ng-bind=\"'Security Settings'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ng-if=$ctrl.showManageBankAccount disabled=!$ctrl.allowManageBankAccount ui-sref=holding.dashboard.bank-accounts ng-bind=\"'Manage Bank Accounts'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item ng-if=$ctrl.showReferral ui-sref=holding.dashboard.referral ng-bind=\"'Referral Program'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item holding-external-link=privacy ng-bind=\"'Privacy Policy'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item holding-external-link=clientAgreement.regulator.canada ng-if=\"$ctrl.user.regulation == 'Toronto'\" ng-bind=\"'Client Agreement'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item holding-external-link=clientAgreement.regulator.uk ng-if=\"$ctrl.user.regulation == 'UK'\" ng-bind=\"'Client Agreement'|translate\"> </holding-dashboard-menu-nav-item> <holding-dashboard-menu-nav-item holding-external-link=disclaimer ng-bind=\"'Disclaimer'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> </div> <div class=\"desktop-only desktop-only--xs\"> <holding-dashboard-menu-nav-section ng-if=$ctrl.showReferral> <holding-svg-icon class=gmw-slide-nav-list-heading__icon icon=dual-cog width=20px height=20px> </holding-svg-icon> <holding-dashboard-menu-nav-title ng-bind=\"'More'|translate\"></holding-dashboard-menu-nav-title> <holding-dashboard-menu-nav-items> <holding-dashboard-menu-nav-item ng-if=$ctrl.showReferral ui-sref=holding.dashboard.referral ng-bind=\"'Referral Program'|translate\"> </holding-dashboard-menu-nav-item> </holding-dashboard-menu-nav-items> </holding-dashboard-menu-nav-section> </div> </div> <div class=\"gmw-slide-nav-account-bar desktop-only desktop-only--xs\"> <div class=gmw-slide-nav-account-bar__info> <span class=\"heading-h3 h-dark-text\" ng-bind=\"'Holding'|translate\"> </span> <div class=gmw-dual-dot-data> <span class=heading-h6 ng-bind=$ctrl.holdingNumber> </span> <span class=\"gmw-dot gmw-dot--light\" ng-if=!$ctrl.isFullHolding> &middot; </span> <span class=heading-h6 ng-if=!$ctrl.isFullHolding ng-bind=\"'Basic Holding'|translate\"> </span> </div> <div ng-if=$ctrl.isShariahHolding> <span class=heading-h6 ng-bind=\"'Shariah Compliant'|translate\"> </span> </div> </div> <a href class=gmw-slide-nav-account-bar__sign-out ng-click=$ctrl.signOut()> <holding-svg-icon class=gmw-slide-nav-signout-button__icon icon=signout></holding-svg-icon> <span class=heading-h6 ng-bind=\"'Sign Out'|translate\"> </span> </a> </div> </div> </nav> <div class=\"gmw-slide-nav__click-off-area desktop-only desktop-only--xs\" ng-if=$ctrl.navOpen ng-class=\"{\n    'gmw-slide-nav__click-off-area--tutorial': !$ctrl.viewedTutorial,\n  }\" ng-click=$ctrl.closeNav()> <div class=gmw-slide-nav-tutorial ng-show=!$ctrl.viewedTutorial> <span class=heading-h1> Clicking the menu's 'close' button or anywhere off the menu will close it. </span> </div> </div> ";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingDashboardGlobalAlerts.$inject = ['$rootScope', '$state', 'HoldingMessages', 'HoldingProperties'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _dashboardGlobalAlerts = __webpack_require__(836);

var _dashboardGlobalAlerts2 = _interopRequireDefault(_dashboardGlobalAlerts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').component('holdingDashboardGlobalAlerts', {
  controller: holdingDashboardGlobalAlerts,
  template: _dashboardGlobalAlerts2.default
}).name;


function holdingDashboardGlobalAlerts($rootScope, $state, HoldingMessages, HoldingProperties) {
  'ngInject';

  function reviewNews() {
    HoldingProperties.set('ViewedNews', {
      at: new Date().toISOString()
    });

    $state.go('holding.dashboard.messages.news.message', {
      messageId: vm.displayNewsNoticeMessage
    }, {
      reload: true
    });
  }

  var vm = this;

  vm.displayNewsNotice = false;
  vm.globalAlerts = $rootScope.globalAlerts;
  vm.reviewNews = reviewNews;

  HoldingMessages.getNewsMessages().then(function (messages) {
    var lastUpdate = messages[0];
    var lastUpdateTs = (0, _moment2.default)(lastUpdate.ts).format('X');
    var lastViewedTs = HoldingProperties.get('ViewedNews') ? (0, _moment2.default)(HoldingProperties.get('ViewedNews').at).format('X') : 1534364754;

    vm.displayNewsNotice = lastViewedTs < lastUpdateTs;
    vm.displayNewsNoticeMessage = lastUpdate.code;
  });
}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "<section> <div class=holding-global-alert ng-if=$ctrl.globalAlerts.reloadApp> <a href class=holding-global-alert__link ng-bind=\"'Refresh the page'|translate\" holding-reload-page></a>&nbsp; <span ng-bind=\"'to update to the latest version.'|translate\"></span> </div> <div class=holding-global-alert ng-if=\"!$ctrl.globalAlerts.reloadApp && $ctrl.displayNewsNotice\"> <span ng-bind=\"'We\\'ve posted an important service update'|translate\"></span>&nbsp;-&nbsp; <a ng-click=$ctrl.reviewNews() class=holding-global-alert__link ng-bind=\"'click here'|translate\"></a>&nbsp; <span ng-bind=\"'to review.'|translate\"></span> </div> </section> ";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


DashboardController.$inject = ['$interval', '$scope', 'HoldingMessages', 'UserResolve'];
angular.module('app.holding.dashboard').controller('DashboardController', DashboardController);

function DashboardController($interval, $scope, HoldingMessages, UserResolve) {
  'ngInject';

  function onDestroy() {
    $interval.cancel(unreadMessageTimer);
  }

  var CONTENT_DELAY = 300000;
  var vm = this;
  var unreadMessageTimer = void 0;

  vm.currentYear = new Date().getFullYear();
  vm.user = UserResolve;
  unreadMessageTimer = $interval(function () {
    HoldingMessages.getUnreadMessages();
  }, HoldingMessages.getUnreadUpdateInterval());

  $scope.$on('$destroy', onDestroy);
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingDashboardHeader.$inject = ['$log', '$state', '$window', '$rootScope', '$interval', '$timeout', 'HoldingMessages', 'HoldingUser', 'HoldingSupport', 'HoldingAuth', 'GmwSetup'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardHeader = __webpack_require__(839);

var _dashboardHeader2 = _interopRequireDefault(_dashboardHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardHeader', holdingDashboardHeader).name;


function holdingDashboardHeader($log, $state, $window, $rootScope, $interval, $timeout, HoldingMessages, HoldingUser, HoldingSupport, HoldingAuth, GmwSetup) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _dashboardHeader2.default
  };

  function link(scope) {
    function activate() {
      checkUnread();
      unreadTimer = $interval(function () {
        checkUnread();
      }, UNREAD_DELAY);
    }

    function checkUnread() {
      HoldingMessages.getUnreadMessages(false).then(function (unreadMessages) {
        scope.unreadMessages = unreadMessages.unread;
      }).catch(function (error) {
        $log.error(error);
      });
    }

    function closeFlyout() {
      supportFlyoutActive = false;
      userMenuFlyoutActive = false;
    }

    function includesState(state) {
      return $state.includes(state);
    }

    function isSupportFlyoutActive() {
      return supportFlyoutActive;
    }

    function isUserMenuFlyoutActive() {
      return userMenuFlyoutActive;
    }

    function onDestroy() {
      $interval.cancel(unreadTimer);
      flyoutListener();
    }

    function openLiveChat() {
      GmwSetup.getSetupStatus().then(function (_ref) {
        var emails = _ref.emails;

        var user = HoldingUser.get();
        var prefill = {
          name: {
            value: user.name,
            readOnly: false
          }
        };
        var lastValidEmail = emails.slice().reverse().find(function (email) {
          return !!email.verified || email.migrated;
        });
        if (lastValidEmail) {
          Object.assign(prefill, {
            email: {
              value: lastValidEmail.email,
              readOnly: false
            }
          });
        }

        $window.zE('webWidget', 'prefill', prefill);
        $window.zE('webWidget', 'open');
        $window.zE('webWidget', 'show');
        $timeout(function () {
          supportFlyoutActive = false;
        });
      });
    }

    function openSecondaryMenuFlyout() {
      userMenuFlyoutActive = true;
    }

    function openSupportFlyout() {
      supportFlyoutActive = true;
    }

    function signOut() {
      HoldingAuth.signOut().then(function () {
        $state.go('auth.sign-in', {
          message: 'logout'
        });
      });
    }

    var UNREAD_DELAY = 300000;

    var flyoutListener = scope.$on('gmw:flyout:close', closeFlyout);
    var user = HoldingUser.get();

    var supportFlyoutActive = false;
    var userMenuFlyoutActive = false;
    var unreadTimer = void 0;

    scope.allowManageBankAccount = HoldingUser.isAllowed('addBankAccount') || HoldingUser.isAllowed('deleteBankAccount');
    scope.includesState = includesState;
    scope.isSupportFlyoutActive = isSupportFlyoutActive;
    scope.isUserMenuFlyoutActive = isUserMenuFlyoutActive;
    scope.openLiveChat = openLiveChat;
    scope.openSecondaryMenuFlyout = openSecondaryMenuFlyout;
    scope.openSupportFlyout = openSupportFlyout;
    scope.partnerCode = user.partnerCode;
    scope.showManageBankAccount = !HoldingUser.isHidden('addBankAccount') || !HoldingUser.isHidden('deleteBankAccount');
    scope.showMessaging = HoldingUser.isAllowed('messaging');
    scope.showPhoneNumber = HoldingUser.isAllowed('phoneSupport');
    scope.signOut = signOut;
    scope.supportPhoneNumbers = HoldingSupport.getSupportNumber(user.regulation);
    scope.unreadMessages = 0;
    scope.user = user;

    scope.$on('$destroy', onDestroy);
    $rootScope.$on('gmw:menu:secondary:toggle', openSecondaryMenuFlyout);

    activate();
  }
}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "<header class=holding-dashboard-header> <a class=holding-dashboard-header__logo-container ui-sref=holding.dashboard.overview ui-sref-opts=\"{\n      reload: true,\n    }\" ng-switch=partnerCode> <div class=\"holding-dashboard-header__logo holding-dashboard-header__logo--entrust\" ng-switch-when=HKTC> </div> <div class=\"holding-dashboard-header__logo holding-dashboard-header__logo--standard-life\" ng-switch-when=SL> </div> <svg ng-switch-default class=holding-dashboard-header__logo> <use xlink:href=#goldmoney-logo-22></use> </svg> </a> <nav class=holding-dashboard-header-nav> <span class=\"holding-dashboard-header-nav-item gmw-flyout-hook\" ng-class=\"{\n        'gmw-flyout-hook--active': isSupportFlyoutActive(),\n      }\" ng-click=openSupportFlyout() gmw-focus-out-flyout-close=\"{{isSupportFlyoutActive()}}\"> <svg class=holding-dashboard-header-nav-item__icon width=20 height=20> <use xlink:href=#help-icon></use> </svg> <span class=\"holding-dashboard-header-nav-item__label heading-h5\" ng-bind=\"'Support'|translate\"> </span> <div class=gmw-flyout-container> <div class=\"gmw-flyout gmw-help-flyout\"> <div class=gmw-support-info-item> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Support Hours'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=20 height=20> <use xlink:href=#building-icon></use> </svg> <span ng-if=\"user.regulation === 'JFSC' || user.regulation === 'UK'\" ng-bind=\"'Monday to Friday, 09.00 - 17.00 U.K. Time'|translate\"> </span> <span ng-if=\"user.regulation === 'Toronto'\" ng-bind=\"'Monday to Friday, 9am - 5pm EST'|translate\"> </span> </span> </div> <div class=gmw-support-info-item ng-if=showPhoneNumber ng-repeat=\"phone in supportPhoneNumbers track by $index\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=::phone.description> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=19 height=19> <use xlink:href=#wired-phone-icon></use> </svg> <a ng-href=\"tel:+{{::phone.country}}{{::phone.number}}\" class=h-blue-link> +{{::phone.country}} {{::phone.number}} </a> </span> </div> <footer class=gmw-help-flyout-footer> <a class=gmw-help-flyout-footer__item ng-click=openLiveChat()> <div class=\"gmw-help-flyout-footer__icon-container gmw-live-chat-indicator live-chat-indicator-hook\"> <svg class=gmw-help-flyout-footer__icon width=21 height=18> <use xlink:href=#chat-message-icon></use> </svg> </div> <span class=heading-h6 ng-bind=\"'Live Chat'|translate\"> </span> </a> <a href holding-external-link=support.main class=gmw-help-flyout-footer__item> <div class=gmw-help-flyout-footer__icon-container> <svg class=gmw-help-flyout-footer__icon width=20 height=20> <use xlink:href=#help-icon></use> </svg> </div> <span class=heading-h6 ng-bind=\"'FAQ'|translate\"></span> </a> </footer> </div> </div> </span> <a class=holding-dashboard-header-nav-item ng-if=showMessaging ui-sref=\"holding.dashboard.messages.folder({ messageFolder: 'inbox' })\" ui-sref-opts=\"{\n        reload: true,\n      }\" ng-class=\"{\n        'holding-dashboard-header-nav-item--active': includesState('messages') || unreadMessages > 0,\n      }\"> <svg ng-if=\"unreadMessages < 1\" class=holding-dashboard-header-nav-item__icon width=22px height=13px> <use xlink:href=#gmw-messages-icon></use> </svg> <div ng-if=\"unreadMessages > 0\" class=gmw-new-messages-icon> <svg class=gmw-new-messages-icon__icon width=24px height=15px> <use xlink:href=#gmw-messages-icon-active></use> </svg> </div> <span class=\"holding-dashboard-header-nav-item__label heading-h5\"> <span ng-if=\"unreadMessages > 0\" ng-bind=unreadMessages></span> <span ng-if=\"unreadMessages != 1\" ng-bind=\"'Messages'|translate\"></span> <span ng-if=\"unreadMessages == 1\" ng-bind=\"'Message'|translate\"></span> </span> </a> <i class=\"gmw-dot gmw-dot--light\" ng-if=showMessaging>&middot;</i> <span class=\"holding-dashboard-header-user-menu-label gmw-flyout-hook\" ng-class=\"{ 'gmw-flyout-hook--active': isUserMenuFlyoutActive() }\" ng-click=openSecondaryMenuFlyout() gmw-focus-out-flyout-close=\"{{isUserMenuFlyoutActive()}}\"> <span class=heading-h5 ng-bind=::user.name> </span> <svg class=holding-dashboard-header-user-menu-label__chevron> <use xlink:href=#down-chevron-icon></use> </svg> <div class=\"gmw-flyout-container gmw-flyout-container-user-menu\"> <div class=\"gmw-flyout gmw-flyout--off-white gmw-user-menu-flyout\"> <div class=gmw-user-menu-flyout__holding-info> <div class=\"gmw-user-menu-flyout__holding-info-label heading-h3 h-dark-text\" ng-bind=\"'Holding'|translate\"> </div> <div class=\"gmw-user-menu-flyout__holding-info-holding heading-h4 h-light-text\" ng-bind=::user.holdingNumber> </div> </div> <ul class=medium-list> <li class=medium-list__item ui-sref=settings-profile ui-sref-opts=\"{\n                reload: true,\n              }\"> <div class=gmw-user-menu-flyout__icon-container> <svg class=gmw-user-menu-flyout__icon width=21 height=23> <use xlink:href=#user-circle-icon></use> </svg> </div> <span class=medium-list__item-label ng-bind=\"'Profile Settings'|translate\"> </span> </li> <li class=medium-list__item ui-sref=settings-security ui-sref-opts=\"{\n                reload: true,\n              }\"> <div class=gmw-user-menu-flyout__icon-container> <svg class=gmw-user-menu-flyout__icon width=19 height=19> <use xlink:href=#cc-camera-icon></use> </svg> </div> <span class=medium-list__item-label ng-bind=\"'Security Settings'|translate\"></span> </li> <li class=medium-list__item ng-if=showManageBankAccount ng-class=\"{\n                'gmw-user-menu-flyout__item--disabled': !allowManageBankAccount,\n              }\" ui-sref=holding.dashboard.bank-accounts ui-sref-opts=\"{\n                reload: true,\n              }\"> <div class=gmw-user-menu-flyout__icon-container> <svg class=gmw-user-menu-flyout__icon width=21 height=20> <use xlink:href=#bank-account-v2-icon></use> </svg> </div> <span class=medium-list__item-label ng-bind=\"'Manage Bank Accounts'|translate\"> </span> </li> </ul> <hr class=gmw-user-menu-flyout__divider> <ul class=medium-list> <li class=medium-list__item ng-click=signOut()> <div class=gmw-user-menu-flyout__icon-container> <svg class=\"gmw-user-menu-flyout__icon gmw-user-menu-flyout__icon--sign-out\" width=14 height=16> <use xlink:href=#signout-icon></use> </svg> </div> <span class=medium-list__item-label ng-bind=\"'Sign Out'|translate\"></span> </li> </ul> </div> </div> </span> </nav> </header> ";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingDashboardHeroActionsMainControls.$inject = ['$interval', '$log', '$rootScope', 'HoldingMessages'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardHeroActionsMainControls = __webpack_require__(841);

var _dashboardHeroActionsMainControls2 = _interopRequireDefault(_dashboardHeroActionsMainControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardHeroActionsMainControls', holdingDashboardHeroActionsMainControls).name;


function holdingDashboardHeroActionsMainControls($interval, $log, $rootScope, HoldingMessages) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _dashboardHeroActionsMainControls2.default,
    transclude: {
      rightMobileAction: '?rightMobileAction'
    }
  };

  function link(scope, _element, _attrs, _ctrl, transclude) {
    var UNREAD_DELAY = 300000;

    var unreadTimer = void 0;

    function activate() {
      checkUnread();
      unreadTimer = $interval(function () {
        checkUnread();
      }, UNREAD_DELAY);
    }

    function checkUnread() {
      HoldingMessages.getUnreadMessages(false).then(function (unreadMessages) {
        scope.unreadMessages = unreadMessages.unread;
      }).catch(function (error) {
        $log.error(error);
      });
    }

    function onDestroy() {
      $interval.cancel(unreadTimer);
    }

    function toggleNav() {
      $rootScope.$broadcast('gmw:menu:main:toggle');
    }

    scope.toggleNav = toggleNav;
    scope.unreadMessages = 0;

    scope.$on('$destroy', onDestroy);

    activate();
  }
}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "<div class=holding-dashboard-hero-actions__controls> <holding-flow-back></holding-flow-back> <ng-transclude></ng-transclude> <div class=\"holding-dashboard-hero-actions__button desktop-only desktop-only--xs\" ng-click=toggleNav()> <div class=nav-icon> <span class=nav-icon__line></span> <span class=nav-icon__line></span> <span class=nav-icon__line></span> <span class=nav-icon__line></span> </div> </div> <div class=\"holding-dashboard-hero-actions__mobile-msg mobile-only mobile-only--xs\" ng-transclude=rightMobileAction> <div class=gmw-new-messages-icon ui-sref=\"holding.dashboard.messages.folder({\n        messageFolder: 'inbox'\n      })\" ui-sref-opts=\"{\n        reload: true,\n      }\"> <svg ng-if=\"unreadMessages < 1\" class=holding-dashboard-header-nav-item__icon width=22px height=13px> <use xlink:href=#gmw-messages-icon></use> </svg> <svg ng-if=\"unreadMessages > 0\" class=gmw-new-messages-icon__icon width=24px height=15px> <use xlink:href=#gmw-messages-icon-active></use> </svg> </div> </div> </div> ";

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardHeroActionsMainTitle = __webpack_require__(843);

var _dashboardHeroActionsMainTitle2 = _interopRequireDefault(_dashboardHeroActionsMainTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardHeroActionsMainTitle', holdingDashboardHeroActionsMainTitle).name;


function holdingDashboardHeroActionsMainTitle() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      title: '@'
    },
    template: _dashboardHeroActionsMainTitle2.default
  };
}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<h1 class=\"holding-dashboard-hero-actions__left__title heading-h2\" ng-bind=title></h1> ";

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardHeroActionsTabs = __webpack_require__(845);

var _dashboardHeroActionsTabs2 = _interopRequireDefault(_dashboardHeroActionsTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardHeroActionsTabs', holdingDashboardHeroActionsTabs).name;


function holdingDashboardHeroActionsTabs() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {},
    template: _dashboardHeroActionsTabs2.default,
    transclude: true
  };
}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "<div class=holding-dashboard-hero-actions-tabs ng-transclude> </div> ";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardHeroActionsTabsItem = __webpack_require__(847);

var _dashboardHeroActionsTabsItem2 = _interopRequireDefault(_dashboardHeroActionsTabsItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardHeroActionsTabsItem', holdingDashboardHeroActionsTabsItem).name;


function holdingDashboardHeroActionsTabsItem() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    template: _dashboardHeroActionsTabsItem2.default,
    scope: {
      label: '=',
      mobileLabel: '=?'
    }
  };
}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "<a href class=holding-dashboard-hero-actions-tabs-item> <span class=holding-dashboard-hero-actions-tabs-item__label ng-class=\"{\n      'desktop-only desktop-only--xs': mobileLabel\n    }\" ng-bind=label> </span> <span class=\"holding-dashboard-hero-actions-tabs-item__label mobile-only mobile-only--xs\" ng-if=mobileLabel ng-bind=mobileLabel> </span> </a> ";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardHeroBg = __webpack_require__(849);

var _dashboardHeroBg2 = _interopRequireDefault(_dashboardHeroBg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardHeroBg', holdingDashboardHeroBg).name;


function holdingDashboardHeroBg() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    template: _dashboardHeroBg2.default
  };
}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=holding-dashboard-hero-bg></div> </div> ";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardMenuNavItem = __webpack_require__(851);

var _dashboardMenuNavItem2 = _interopRequireDefault(_dashboardMenuNavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardMenuNavItem', holdingDashboardMenuNavItem).name;


function holdingDashboardMenuNavItem() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      disabled: '=?'
    },
    template: _dashboardMenuNavItem2.default,
    transclude: true
  };
}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "<a class=gmw-slide-nav-list-item ng-class=\"{\n    'gmw-slide-nav-list-item--disabled': disabled,\n    'gmw-slide-nav-list-item--reload': reload,\n  }\" ui-sref-active=gmw-slide-nav-list-item--active ng-transclude> </a> ";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardMenuNavSection = __webpack_require__(853);

var _dashboardMenuNavSection2 = _interopRequireDefault(_dashboardMenuNavSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('holdingDashboardMenuNavSection', holdingDashboardMenuNavSection).name;


function holdingDashboardMenuNavSection() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {
      disabled: '=?'
    },
    template: _dashboardMenuNavSection2.default,
    transclude: {
      icon: 'holdingSvgIcon',
      items: 'holdingDashboardMenuNavItems',
      title: 'holdingDashboardMenuNavTitle'
    }
  };
}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-slide-nav-main__section ng-class=\"{'gmw-slide-nav-main__section--disabled': disabled}\"> <div class=gmw-slide-nav-list-heading> <div class=gmw-slide-nav-list-heading__icon-container ng-transclude=icon> </div> <h3 class=\"heading-h3 h-dark-text\" ng-transclude=title></h3> </div> <div ng-transclude=items></div> </div> ";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingSetupSidebar.$inject = ['HoldingUser', 'HoldingSupport'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupSidebar = __webpack_require__(855);

var _setupSidebar2 = _interopRequireDefault(_setupSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('holdingSetupSidebar', holdingSetupSidebar).name;


function holdingSetupSidebar(HoldingUser, HoldingSupport) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _setupSidebar2.default
  };

  function link(scope) {
    scope.user = HoldingUser.get();
    scope.showPhoneNumber = HoldingUser.isAllowed('phoneSupport');
    scope.supportPhoneNumbers = HoldingSupport.getSupportNumber(scope.user.regulation);
  }
}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<aside class=\"floating-sidebar-app-view__sidebar floating-sidebar-app-view__sidebar--no-footer\"> <div class=\"holding-floating-sidebar-section holding-floating-sidebar-section--hide-on-break\"> <div class=gmw-holding-number-box> <span class=\"gmw-holding-number-box__label heading-h5\" ng-bind=\"'Holding'|translate\"> </span> <h1 class=\"heading-h1 h-white-text\" ng-bind=user.holdingNumber> </h1> </div> </div> <div class=holding-floating-sidebar-section> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Support Hours'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=20 height=20> <use xlink:href=#building-icon></use> </svg> <span ng-if=\"user.regulation === 'JFSC' || user.regulation === 'UK'\" ng-bind=\"'Monday to Friday, 09.00 - 17.00 U.K. Time'|translate\"> </span> <span ng-if=\"user.regulation === 'Toronto'\" ng-bind=\"'Monday to Friday, 9am - 5pm EST'|translate\"> </span> </span> </div> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\" ng-if=showPhoneNumber ng-repeat=\"phone in supportPhoneNumbers track by $index\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=::phone.description> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=19 height=19> <use xlink:href=#wired-phone-icon></use> </svg> <a ng-href=\"tel:+{{::phone.country}}{{::phone.number}}\" class=h-blue-link> +{{::phone.country}} {{::phone.number}} </a> </span> </div> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Message Support'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=18 height=14> <use xlink:href=#email-icon></use> </svg> <a ui-sref=holding.dashboard.messages.compose class=h-blue-link ng-bind=\"'Send Message'|translate\"> </a> </span> </div> <div class=\"gmw-support-info-item gmw-support-info-item--no-padding\"> <h6 class=\"h-large-text h-dark-text\" ng-bind=\"'Frequently Asked Questions'|translate\"> </h6> <span class=gmw-support-info-item__data> <svg class=gmw-support-info-item__grey-icon width=20 height=20> <use xlink:href=#help-icon></use> </svg> <a href holding-external-link=support.main class=h-blue-link ng-bind=\"'Visit our Support Portal'|translate\" target=_blank> </a> </span> </div> </div> </aside> ";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingDashboardTutorialMenu.$inject = ['$rootScope', 'HoldingProperties'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dashboardTutorialMenu = __webpack_require__(857);

var _dashboardTutorialMenu2 = _interopRequireDefault(_dashboardTutorialMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingDashboardTutorialMenu', holdingDashboardTutorialMenu).name;


function holdingDashboardTutorialMenu($rootScope, HoldingProperties) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {},
    template: _dashboardTutorialMenu2.default
  };

  function link(scope) {
    function closePrimary() {
      $rootScope.$broadcast('gmw:menu:main:toggle');
      scope.isOpenMain = false;
      HoldingProperties.set('ViewedTutorial', {
        at: new Date().toISOString()
      });
    }

    function closeSecondary() {
      $rootScope.$broadcast('gmw:menu:secondary:toggle');
      $rootScope.$broadcast('gmw:menu:tutorial:viewed');
      scope.isOpenSecondary = false;
    }

    function showSecondary() {
      scope.isOpenSecondary = true;
    }

    var viewedTutorial = HoldingProperties.get('ViewedTutorial');

    scope.closePrimary = closePrimary;
    scope.closeSecondary = closeSecondary;
    scope.isOpenMain = viewedTutorial === false;

    $rootScope.$on('gmw:tutorial:secondary:show', showSecondary);
  }
}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"desktop-only desktop-only--xs\"> <div class=\"c-tutorial c-tutorial--main\" ng-show=isOpenMain ng-click=closePrimary()> <span class=\"h-dark-text h-margin-bottom-10\"> Main Holding Menu </span> <span class=\"h-medium-text h-margin-bottom-10\"> Use this menu to access all your Holding features, such as funding options, buying, and selling. </span> <span class=h-blue-text> Got It </span> </div> <div class=\"c-tutorial c-tutorial--secondary\" ng-show=isOpenSecondary ng-click=closeSecondary()> <span class=\"h-dark-text h-margin-bottom-10\"> Personal Holding Menu </span> <span class=\"h-medium-text h-margin-bottom-10\"> This is where you access settings and options for your Holding, as well as sign out. </span> <span class=h-blue-text> Got It </span> </div> <div class=\"c-nav-tutorial-overlay c-nav-tutorial-overlay--main\" ng-show=isOpenMain> </div> <div class=\"c-nav-tutorial-overlay c-nav-tutorial-overlay--secondary\" ng-show=isOpenSecondary> </div> </nav> ";

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gtm = __webpack_require__(859);

var _gtm2 = _interopRequireDefault(_gtm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingGtm', holdingGtm).name;


function holdingGtm() {
  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    scope: {},
    template: _gtm2.default
  };
}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "<span> <noscript> <iframe src=\"//www.googletagmanager.com/ns.html?id=GTM-53TJNNP\" height=0 width=0 style=display:none;visibility:hidden></iframe> </noscript> <script>!function(e,t,a,n,g){e[n]=e[n]||[],e[n].push({\"gtm.start\":(new Date).getTime(),event:\"gtm.js\"});var m=t.getElementsByTagName(a)[0],r=t.createElement(a);r.async=!0,r.src=\"//www.googletagmanager.com/gtm.js?id=GTM-53TJNNP\",m.parentNode.insertBefore(r,m)}(window,document,\"script\",\"dataLayer\")</script> </span> ";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingPermissionBasedEmptyState.$inject = ['HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permissionBasedEmptyState = __webpack_require__(861);

var _permissionBasedEmptyState2 = _interopRequireDefault(_permissionBasedEmptyState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard').directive('holdingPermissionBasedEmptyState', holdingPermissionBasedEmptyState).name;


function holdingPermissionBasedEmptyState(HoldingUser) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      permission: '@'
    },
    template: _permissionBasedEmptyState2.default
  };

  function link(scope) {
    scope.$watch('permission', function (newPermission) {
      switch (newPermission) {
        case 'buyMetal':
          break;
        default:
          var _HoldingUser$getPermi = HoldingUser.getPermission(newPermission);

          scope.reason = _HoldingUser$getPermi.message;

          break;
      }
    });
  }
}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=permission> <div ng-switch-when=addBankAccount ng-switch=reason> <div class=gmw-permissions-based-empty-state ng-switch-when=max> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/bank-transfer-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Maximum Linked Accounts Reached'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You\\'ve reached the maximum number of linked bank accounts'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'If you wish to link a new bank account you should remove an existing bank account from your Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=holding.dashboard.bank-accounts ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Manage Bank Accounts'|translate\"> </button> </div> </div> </div> </div> <div ng-switch-when=buyMetal> <div class=gmw-permissions-based-empty-state> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Verification Required'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You must be fully verified in order to purchase precious metals'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Your Holding is currently unverified so you are limited to certain features until you verify your Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=verification ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Verify Holding'|translate\"> </button> <a href holding-external-link=support.onboarding.documents class=gmw-more-link> <span ng-bind=\"'More info'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </div> </div> </div> <div ng-switch-when=makePayment ng-switch=reason> <div class=gmw-permissions-based-empty-state ng-switch-when=basic> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Transfers Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Your Holding is not eligible to make or receive transfers'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss upgrading your Holding to a Full Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cap> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Verification Required'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You must be fully verified to use this feature'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'While your Holding is pending verification, you are limited to certain features. To check on your verification status, please contact our Relationship Management team.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> <a href holding-external-link=support.onboarding.documents class=gmw-more-link> <span ng-bind=\"'More info'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cdd> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Transfers Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Some information about your Holding needs to be confirmed'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss re-enabling transfers.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=lock> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/security-badge-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Transfers Disabled'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Your current security settings prevent transfers out from your Holding'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'You\\'ve previously disabled transfers out from your Holding. To re-enable transfers, please contact our Relationship Management team.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> </div> <div ng-switch-when=redeemBars ng-switch=reason> <div class=gmw-permissions-based-empty-state ng-switch-when=basic> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Goldmoney Bars are Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Your Holding is not eligible to take delivery of Goldmoney Bars'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss upgrading your Holding to a Full Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cap> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Verification Required'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You must be fully verified to use this feature'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'While your Holding is pending verification, you are limited to certain features. To check on your verification status, please contact our Relationship Management team.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> <a href holding-external-link=support.onboarding.documents class=gmw-more-link> <span ng-bind=\"'More info'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cdd> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Goldmoney Bars are Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Some information about your Holding needs to be confirmed'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss re-enabling Goldmoney Bar delivery.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> </div> <div ng-switch-when=refer ng-switch=reason> <div class=gmw-permissions-based-empty-state ng-switch-when=basic> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Referral Program Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Your Holding is not eligible to participate in the Referral Program'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss upgrading your Holding to a Full Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cap> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Verification Required'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You must be fully verified to enroll in our referral program'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'While your Holding is pending verification, you are limited to certain features. To check on your verification status, please contact our Relationship Management team.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> <a href holding-external-link=support.onboarding.documents class=gmw-more-link> <span ng-bind=\"'More info'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cdd> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Referral Program Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Some information about your Holding needs to be confirmed'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss re-enabling participation in the Referral Program.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> </div> <div ng-switch-when=removeFunds ng-switch=reason> <div class=gmw-permissions-based-empty-state ng-switch-when=cap> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Verification Required'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You must be fully verified in order to withdraw funds'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Your Holding is currently unverified so you are limited to certain Holding features until you verify your Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=verification ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Verify Holding'|translate\"> </button> <a href holding-external-link=support.onboarding.documents class=gmw-more-link> <span ng-bind=\"'More info'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cdd> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Fund Withdrawal Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Some information about your Holding needs to be confirmed'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss re-enabling fund withdrawal from your Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-default> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/bank-transfer-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Insufficient Balance'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You do not have any available funds for withdrawal. Please note that you may only withdraw funds from your Holding that are the proceeds of a previous sale.'|translate\"> </span> </div> </div> </div> <div ng-switch-when=schiffgold ng-switch=reason> <div class=gmw-permissions-based-empty-state ng-switch-when=basic> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Goldmoney Physical is Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Your Holding is not eligible to redeem coins or bars via Goldmoney Physical'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss upgrading your Holding to a Full Holding.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cap> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Verification Required'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'You must be fully verified to use this feature'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'While your Holding is pending verification, you are limited to certain features. To check on your verification status, please contact our Relationship Management team.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> <a href holding-external-link=support.onboarding.documents class=gmw-more-link> <span ng-bind=\"'More info'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </div> </div> </div> <div class=gmw-permissions-based-empty-state ng-switch-when=cdd> <div class=gmw-permissions-based-empty-state__icon-col> <div class=gmw-permissions-based-empty-state__icon> <img src=/img/icons/verify-person-icon.svg> </div> </div> <div class=gmw-permissions-based-empty-state__content> <h1 class=\"heading-h1 h-dark-text h-margin-bottom-10\" ng-bind=\"'Goldmoney Physical is Unavailable'|translate\"> </h1> <span class=\"h-default-text h-light-text h-margin-bottom-10\" ng-bind=\"'Some information about your Holding needs to be confirmed'|translate\"> </span> <p class=\"h-default-text h-margin-bottom-25\" ng-bind=\"'Please contact our Relationship Management team to discuss re-enabling redeeming coins and bars via Goldmoney Physical.'|translate\"> </p> <div class=\"h-flex gmw-permissions-based-empty-state__cta\"> <button class=\"medium-main-cta gmw-responsive-button h-margin-right-20 gmw-permissions-based-empty-state__button\" ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" ui-sref-opts=\"{\n              reload: true,\n            }\" ng-bind=\"'Contact Us'|translate\"> </button> </div> </div> </div> </div> </div> ";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.properties', []).name;


__webpack_require__(863);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingProperties.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.properties').factory('HoldingProperties', HoldingProperties).name;


function HoldingProperties(HoldingApi) {
  'ngInject';

  var localProperties = null;

  return {
    get: get,
    load: load,
    set: set
  };

  function get(property) {
    return property in localProperties && angular.copy(localProperties[property]);
  }

  function load() {
    return HoldingApi.get('properties').then(function (properties) {
      localProperties = properties;
      return properties;
    });
  }

  function set(property, value) {
    localProperties[property] = value;
    return HoldingApi.put('properties/' + property, value).then(load);
  }
}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _kyc = __webpack_require__(865);

var _kyc2 = _interopRequireDefault(_kyc);

var _legal = __webpack_require__(872);

var _legal2 = _interopRequireDefault(_legal);

var _splash = __webpack_require__(884);

var _splash2 = _interopRequireDefault(_splash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash', [_common2.default, _angularjs2.default, _kyc2.default, _legal2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash', {
    abstract: true,
    url: '/splash',
    views: {
      holding: {
        template: _splash2.default
      }
    }
  });
}]).name;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _expectedUse = __webpack_require__(866);

var _expectedUse2 = _interopRequireDefault(_expectedUse);

var _idNetverify = __webpack_require__(869);

var _idNetverify2 = _interopRequireDefault(_idNetverify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.kyc', [_common2.default, _angularjs2.default, _expectedUse2.default, _idNetverify2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.kyc', {
    abstract: true,
    url: '/kyc',
    views: {
      splash: {
        template: '<div ui-view="kyc"></div>'
      }
    }
  });
}]).name;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _expectedUse = __webpack_require__(867);

var _expectedUse2 = _interopRequireDefault(_expectedUse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.kyc.expected-use', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.kyc.expected-use', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    url: '/expected-use',
    views: {
      kyc: {
        controller: 'ExpectedUseController',
        controllerAs: 'expectedUseCtrl',
        template: _expectedUse2.default
      }
    }
  });
}]).name;


__webpack_require__(868);

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "<gmw-sign-in-hero heading=\"{{'Please Update your Expected Holding Use Information'|translate}}\"> </gmw-sign-in-hero> <div class=initial-onboarding-sidebar-container> <section class=\"initial-onboarding onboarding-sidebar-container__main onboarding-sidebar-container__main--flex\"> <div class=initial-onboarding__inner> <form name=expectedUseCtrl.form id=form holding-form-loading=expectedUseCtrl.updateExpectedUse() novalidate> <holding-alert class=error ng-if=expectedUseCtrl.updateError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=expectedUseCtrl.updateError></span> </main> </holding-alert> <p class=\"gmw-flow-box__description h-dark-text\"> <span ng-bind=\"'We periodically need to update information about how you plan to use your Holding. Please'|translate\"></span> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" class=h-blue-link ng-bind=\"'contact us'|translate\"></a> <span ng-bind=\"'if you have any questions.'|translate\"></span> </p> <gmw-expected-use class=gmw-input-container ng-model=expectedUseCtrl.model.expectedUse> </gmw-expected-use> <div class=initial-onboarding__dual-cta> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-border-cta h-margin-right-20\" type=button ng-click=expectedUseCtrl.signOut()> <span ng-bind=\"'Sign Out'|translate\"></span> </button> </div> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n                'loading-button': expectedUseCtrl.isSubmitting\n              }\" ng-disabled=\"expectedUseCtrl.form.$invalid || expectedUseCtrl.form.$submitted\"> <span ng-bind=\"'Continue to Overview'|translate\"></span> </button> </div> </div> </form> </div> </section> </div> ";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ExpectedUseController.$inject = ['$state', '$q', '$log', '$stateParams', 'HoldingAuth', 'HoldingPreferences', 'GmwSetup', 'HoldingExpectedUse'];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app.holding.splash.kyc.expected-use').controller('ExpectedUseController', ExpectedUseController);

function ExpectedUseController($state, $q, $log, $stateParams, HoldingAuth, HoldingPreferences, GmwSetup, HoldingExpectedUse) {
  'ngInject';

  var vm = this;
  var model = {
    expectedUse: {}
  };

  vm.isSelected = false;
  vm.model = angular.copy(model);
  vm.signOut = signOut;
  vm.updateExpectedUse = updateExpectedUse;

  function activate() {
    $q.all([GmwSetup.getSetupStatus(), HoldingPreferences.getPreferences()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          expectedUse = _ref2[0].expectedUse,
          displayCurrency = _ref2[1].displayCurrency;

      vm.model.expectedUse = expectedUse;
      if (HoldingExpectedUse.hasDefaultValues(expectedUse)) {
        vm.model.expectedUse.holdingValue = null;
        vm.model.expectedUse.transactionsValue = null;
        vm.model.expectedUse.transactionsCount = null;
      }
      vm.model.expectedUse.preferredCurrency = displayCurrency;
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function updateExpectedUse() {
    if (vm.form.$invalid) {
      vm.form.$setSubmitted();
      return undefined;
    }

    vm.isSubmitting = true;

    vm.model.expectedUse.holdingValue = parseInt(vm.model.expectedUse.holdingValue, 10);
    vm.model.expectedUse.transactionsValue = parseInt(vm.model.expectedUse.transactionsValue, 10);

    GmwSetup.updateExpectedUse(vm.model.expectedUse).then(function () {
      $state.go('holding.dashboard.overview', {}, {
        reload: true
      });
    }).catch(function (error) {
      vm.isSubmitting = false;
      vm.updateError = error.message;
      $log.error(error.message);
    });
  }

  function signOut() {
    HoldingAuth.signOut().then(function () {
      $state.go('auth.sign-in', {
        message: 'logout'
      });
    });
  }

  activate();
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _idNetverify = __webpack_require__(870);

var _idNetverify2 = _interopRequireDefault(_idNetverify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.kyc.id-netverify', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.kyc.id-netverify', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    params: {
      code: {
        type: 'int'
      }
    },
    url: '/id-netverify/:code',
    views: {
      kyc: {
        controller: 'IdNetverifyController',
        controllerAs: 'idNetverifyCtrl',
        template: _idNetverify2.default
      }
    }
  });
}]).name;


__webpack_require__(871);

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "<gmw-sign-in-hero heading=\"{{'Please update your identification'|translate}}\"> </gmw-sign-in-hero> <div class=initial-onboarding-sidebar-container> <section class=\"initial-onboarding onboarding-sidebar-container__main onboarding-sidebar-container__main--flex\"> <div class=initial-onboarding__inner> <form name=idNetverifyCtrl.form id=form holding-form-loading=idNetverifyCtrl.proceed() novalidate> <p class=\"gmw-flow-box__description h-dark-text\"> We periodically need to update the information we hold on our clients. Please click on the 'proceed' button below to go through our online identification service. If you have any questions or concerns, please <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" class=h-blue-link>contact us</a>. </p> <div class=initial-onboarding__dual-cta> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-border-cta h-margin-right-20\" type=button ng-click=idNetverifyCtrl.signOut()> <span ng-bind=\"'Sign Out'|translate\"></span> </button> </div> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n                'loading-button': idNetverifyCtrl.isSubmitting\n              }\"> <span ng-bind=\"'Proceed'|translate\"></span> </button> </div> </div> </form> </div> </section> </div> ";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


IdNetverifyController.$inject = ['$state', '$stateParams', 'HoldingAuth'];
angular.module('app.holding.splash.kyc.id-netverify').controller('IdNetverifyController', IdNetverifyController);

function IdNetverifyController($state, $stateParams, HoldingAuth) {
  'ngInject';

  var vm = this;

  vm.isSubmitting = false;
  vm.proceed = proceed;
  vm.signOut = signOut;

  function proceed() {
    $state.go('verification.netverify.perform', {
      code: $stateParams.code
    });
  }

  function signOut() {
    HoldingAuth.signOut().then(function () {
      $state.go('auth.sign-in', {
        message: 'logout'
      }, {
        reload: true
      });
    });
  }
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _clientAgreement = __webpack_require__(873);

var _clientAgreement2 = _interopRequireDefault(_clientAgreement);

var _riskDisclosure = __webpack_require__(876);

var _riskDisclosure2 = _interopRequireDefault(_riskDisclosure);

var _transfer = __webpack_require__(879);

var _transfer2 = _interopRequireDefault(_transfer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.legal', [_common2.default, _angularjs2.default, _clientAgreement2.default, _riskDisclosure2.default, _transfer2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.legal', {
    abstract: true,
    url: '/legal',
    views: {
      splash: {
        template: '<div ui-view="legal"></div>'
      }
    }
  });
}]).name;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _clientAgreement = __webpack_require__(874);

var _clientAgreement2 = _interopRequireDefault(_clientAgreement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.legal.client-agreement', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.legal.client-agreement', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    url: '/client-agreement',
    views: {
      legal: {
        controller: 'ClientAgreementController',
        controllerAs: 'clientAgreementCtrl',
        template: _clientAgreement2.default
      }
    }
  });
}]).name;


__webpack_require__(875);

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "<gmw-sign-in-hero heading=\"{{'Please review and accept our Client Agreement'|translate}}\"> </gmw-sign-in-hero> <div class=initial-onboarding-sidebar-container> <section class=\"initial-onboarding onboarding-sidebar-container__main onboarding-sidebar-container__main--flex\"> <div class=initial-onboarding__inner> <form name=clientAgreementCtrl.form id=form holding-form-loading=clientAgreementCtrl.agreeToTerms() novalidate> <holding-alert class=error ng-if=clientAgreementCtrl.agreeError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=clientAgreementCtrl.agreeError></span> </main> </holding-alert> <holding-alert class=error ng-if=\"clientAgreementCtrl.form.$submitted && !clientAgreementCtrl.terms\" title=\"{{'Error'|translate}}\"> <main> <span ng-bind=\"'You must accept the Client Agreement.'|translate\"></span> </main> </holding-alert> <div class=gmw-input-container> <gmw-checkbox ng-model=clientAgreementCtrl.terms class=h-margin-bottom-20 name=terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read, understood, and accept the terms of the'|translate\"></span> <a href ng-if=\"clientAgreementCtrl.user.regulation == 'Toronto'\" class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Goldmoney Client Agreement'|translate\"></a> <a href ng-if=\"clientAgreementCtrl.user.regulation == 'UK'\" class=h-blue-link holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Goldmoney Client Agreement'|translate\"></a> </span> </gmw-checkbox> </div> <div class=initial-onboarding__dual-cta> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-border-cta h-margin-right-20\" type=button ng-click=clientAgreementCtrl.signOut()> <span ng-bind=\"'Sign Out'|translate\"></span> </button> </div> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n                'loading-button': clientAgreementCtrl.isSubmitting\n              }\"> <span ng-bind=\"'Accept'|translate\"></span> </button> </div> </div> </form> </div> </section> </div> ";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ClientAgreementController.$inject = ['$state', '$log', 'HoldingAuth', 'UserResolve'];
angular.module('app.holding.splash.legal.client-agreement').controller('ClientAgreementController', ClientAgreementController);

function ClientAgreementController($state, $log, HoldingAuth, UserResolve) {
  'ngInject';

  var vm = this;

  vm.isSubmitting = false;
  vm.agreeToTerms = agreeToTerms;
  vm.signOut = signOut;

  function activate() {
    vm.user = UserResolve;
  }

  function agreeToTerms() {
    if (vm.form.$invalid) {
      vm.form.$setSubmitted();
      return undefined;
    }

    return HoldingAuth.agreeToTerms().then(function () {
      vm.isSubmitting = true;
      $state.go('holding.dashboard.overview', {}, {
        reload: true
      });
    }).catch(function (error) {
      vm.isSubmitting = false;
      vm.agreeError = error.message;
      $log.error(error.message);
    });
  }

  function signOut() {
    HoldingAuth.signOut().then(function () {
      $state.go('auth.sign-in', {
        message: 'logout'
      }, {
        reload: true
      });
    });
  }

  activate();
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _riskDisclosure = __webpack_require__(877);

var _riskDisclosure2 = _interopRequireDefault(_riskDisclosure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.legal.risk-disclosure', [_common2.default, _angularjs2.default]).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.legal.risk-disclosure', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    url: '/risk-disclosure',
    views: {
      legal: {
        controller: 'RiskDisclosureController',
        controllerAs: 'riskDisclosureCtrl',
        template: _riskDisclosure2.default
      }
    }
  });
}]).name;


__webpack_require__(878);

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "<gmw-sign-in-hero heading=\"{{'Please review our Risk Disclosure Statement'|translate}}\"> </gmw-sign-in-hero> <div class=initial-onboarding-sidebar-container> <section class=\"initial-onboarding onboarding-sidebar-container__main onboarding-sidebar-container__main--flex\"> <div class=initial-onboarding__inner> <form name=riskDisclosureCtrl.form id=form holding-form-loading=riskDisclosureCtrl.agreeToRiskDisclosure() novalidate> <holding-alert class=error ng-if=riskDisclosureCtrl.agreeError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=riskDisclosureCtrl.agreeError></span> </main> </holding-alert> <holding-alert class=error ng-if=\"riskDisclosureCtrl.form.$submitted && !riskDisclosureCtrl.terms\" title=\"{{'Error'|translate}}\"> <main> <span ng-bind=\"'You must acknowledge that you have read & understand the Risk Disclosure Statement before proceeding.'|translate\"></span> </main> </holding-alert> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'We recently sent by email to all of our Canadian-resident clients our Risk Disclosure Statement, which is available for download'|translate\"></span> <a href class=h-blue-link holding-external-link=riskDisclosure ng-bind=\"'here'|translate\"></a>. </p> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'The Risk Disclosure Statement has been prepared for the purpose of describing in plain words to clients and prospective clients of Goldmoney the way we enable our clients to hold and access precious metals and some of the risks associated with owning precious metals.'|translate\"></span> </p> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'In order to continue to your Holding, please ensure that you have read the provided Risk Disclosure Statement and complete the following acknowledgement.'|translate\"></span> </p> <div class=gmw-input-container> <gmw-checkbox ng-model=riskDisclosureCtrl.terms class=h-margin-bottom-20 name=terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have received, read, and understood the'|translate\"></span> <a href class=h-blue-link holding-external-link=riskDisclosure ng-bind=\"'Goldmoney Risk Disclosure Statement'|translate\"></a> </span> </gmw-checkbox> </div> <div class=initial-onboarding__dual-cta> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-border-cta h-margin-right-20\" type=button ng-click=riskDisclosureCtrl.signOut()> <span ng-bind=\"'Sign Out'|translate\"></span> </button> </div> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n                'loading-button': riskDisclosureCtrl.isSubmitting\n              }\"> <span ng-bind=\"'Confirm'|translate\"></span> </button> </div> </div> </form> </div> </section> </div> ";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RiskDisclosureController.$inject = ['$state', '$log', 'HoldingAuth', 'UserResolve'];
angular.module('app.holding.splash.legal.risk-disclosure').controller('RiskDisclosureController', RiskDisclosureController);

function RiskDisclosureController($state, $log, HoldingAuth, UserResolve) {
  'ngInject';

  var vm = this;

  vm.isSubmitting = false;
  vm.agreeToRiskDisclosure = agreeToRiskDisclosure;
  vm.signOut = signOut;

  function activate() {
    vm.user = UserResolve;
  }

  function agreeToRiskDisclosure() {
    if (vm.form.$invalid) {
      vm.form.$setSubmitted();
      return undefined;
    }

    return HoldingAuth.agreeToRiskDisclosure().then(function () {
      vm.isSubmitting = true;
      $state.go('holding.dashboard.overview', {}, {
        reload: true
      });
    }).catch(function (error) {
      vm.isSubmitting = false;
      vm.agreeError = error.message;
      $log.error(error.message);
    });
  }

  function signOut() {
    HoldingAuth.signOut().then(function () {
      $state.go('auth.sign-in', {
        message: 'logout'
      }, {
        reload: true
      });
    });
  }

  activate();
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.legal.transfer', [_common2.default, _angularjs2.default]).name;


__webpack_require__(880);
__webpack_require__(881);

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingTransfer.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.splash.legal.transfer').factory('HoldingTransfer', HoldingTransfer).name;


function HoldingTransfer(HoldingApi) {
  'ngInject';

  return {
    migrate: migrate
  };

  function migrate() {
    return HoldingApi.post('holdings/regulation/migrate', {}, {
      auth: true
    });
  }
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transfer = __webpack_require__(882);

var _transfer2 = _interopRequireDefault(_transfer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.splash.legal.transfer').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('holding.splash.legal.transfer', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    resolve: {
      BanksResolve: ['HoldingFunds', function BanksResolve(HoldingFunds) {
        'ngInject';

        return HoldingFunds.getRftrBanks();
      }]
    },
    url: '/transfer',
    views: {
      legal: {
        controller: 'TransferController',
        controllerAs: 'transferCtrl',
        template: _transfer2.default
      }
    }
  });
}]).name;


__webpack_require__(883);

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "<gmw-sign-in-hero heading=\"{{'Client Agreement Changes'|translate}}\"> </gmw-sign-in-hero> <div class=initial-onboarding-sidebar-container> <section class=\"initial-onboarding onboarding-sidebar-container__main onboarding-sidebar-container__main--flex\"> <div class=initial-onboarding__inner> <form name=transferCtrl.form id=form holding-form-loading=transferCtrl.agreeToTerms() novalidate> <holding-alert class=error ng-if=transferCtrl.agreeError title=\"{{'Error'|translate}}\"> <main> <span ng-bind=transferCtrl.agreeError></span> </main> </holding-alert> <holding-alert class=error ng-if=\"transferCtrl.form.$submitted && !transferCtrl.agreeError && !transferCtrl.terms\" title=\"{{'Error'|translate}}\"> <main> <span ng-bind=\"'You must accept the new Client Agreement to proceed.'|translate\"></span> </main> </holding-alert> <div ng-switch=transferCtrl.user.regulation> <div ng-switch-when=JFSC> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'We\\'ve made some changes to the'|translate\"></span> <a href class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Client Agreement'|translate\"></a> <span ng-bind=\"'that governs your relationship with us, including:'|translate\"></span> </p> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'Your Holding will now be managed by our Canadian business, Goldmoney Vault Inc'|translate\"></li> <li ng-if=transferCtrl.isSepaImpacted ng-bind=\"'We will no longer support bank transfers via SEPA'|translate\"></li> <li ng-bind=\"'We will be discontinuing metal transfers and currency exchanges'|translate\"></li> </ul> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'In addition to the above changes, we also want to highlight that accepting the new Client Agreement will mean:'|translate\"></span> </p> <span class=\"h-block h-large-text h-dark-text h-bold-text h-margin-bottom-5\" ng-bind=\"'No Vaulting, Precious Metal or Fee Changes'|translate\"> </span> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'Our industry-leading vault offerings, precious metal selection, and low fees are unchanged'|translate\"></li> </ul> <span class=\"h-block h-large-text h-dark-text h-bold-text h-margin-bottom-5\" ng-bind=\"'Improved Support'|translate\"> </span> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'We are reducing our response times and increasing our level of support via Live Chat'|translate\"></li> </ul> <p class=\"h-default-text h-dark-text h-margin-bottom-20\"> <span ng-bind=\"'Should you have any questions about the changes to your Holding, please'|translate\"></span> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" class=h-blue-link ng-bind=\"'contact us'|translate\"></a>. </p> <div class=gmw-flow-box__callout> <div class=gmw-input-container> <gmw-checkbox ng-model=transferCtrl.terms name=terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read and accept the terms of the new'|translate\"></span> <a href class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Client Agreement'|translate\"></a> </span> </gmw-checkbox> </div> </div> </div> <div ng-switch-when=Toronto> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'We\\'ve made some changes to the'|translate\"></span> <a href class=h-blue-link holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Client Agreement'|translate\"></a> <span ng-bind=\"'that governs your relationship with us, including:'|translate\"></span> </p> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'Your Holding will now be managed by our United Kingdom-based business, Goldmoney Vault (UK) Limited'|translate\"></li> </ul> <p class=\"h-default-text h-dark-text h-margin-bottom-20\"> <span ng-bind=\"'In addition to the above changes, we also want to highlight that accepting the new Client Agreement will mean:'|translate\"></span> </p> <span class=\"h-block h-large-text h-dark-text h-bold-text h-margin-bottom-5\" ng-bind=\"'No Vaulting, Precious Metal or Fee Changes'|translate\"> </span> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'Our industry-leading vault offerings, precious metal selection, and low fees are unchanged'|translate\"></li> </ul> <p class=\"h-default-text h-dark-text h-margin-bottom-20\"> <span ng-bind=\"'Should you have any questions about the changes to your Holding, please'|translate\"></span> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" class=h-blue-link ng-bind=\"'contact us'|translate\"></a>. </p> <div class=gmw-flow-box__callout> <div class=gmw-input-container> <gmw-checkbox ng-model=transferCtrl.terms name=terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read and accept the terms of the new'|translate\"></span> <a href class=h-blue-link holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Client Agreement'|translate\"></a> </span> </gmw-checkbox> </div> </div> </div> <div ng-switch-when=UK> <p class=\"h-default-text h-dark-text h-margin-bottom-15\"> <span ng-bind=\"'We\\'ve made some changes to the'|translate\"></span> <a href class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Client Agreement'|translate\"></a> <span ng-bind=\"'that governs your relationship with us, including:'|translate\"></span> </p> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'Your Holding will now be managed by our Canada-based business, Goldmoney Vault Inc.'|translate\"></li> </ul> <p class=\"h-default-text h-dark-text h-margin-bottom-20\"> <span ng-bind=\"'In addition to the above changes, we also want to highlight that accepting the new Client Agreement will mean:'|translate\"></span> </p> <span class=\"h-block h-large-text h-dark-text h-bold-text h-margin-bottom-5\" ng-bind=\"'No Vaulting, Precious Metal or Fee Changes'|translate\"> </span> <ul class=\"initial-onboarding__list h-default-text h-margin-bottom-15\"> <li ng-bind=\"'Our industry-leading vault offerings, precious metal selection, and low fees are unchanged'|translate\"></li> </ul> <p class=\"h-default-text h-dark-text h-margin-bottom-20\"> <span ng-bind=\"'Should you have any questions about the changes to your Holding, please'|translate\"></span> <a ui-sref=\"holding.dashboard.messages.compose({ category: 'OTHER' })\" class=h-blue-link ng-bind=\"'contact us'|translate\"></a>. </p> <div class=gmw-flow-box__callout> <div class=gmw-input-container> <gmw-checkbox ng-model=transferCtrl.terms name=terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read and accept the terms of the new'|translate\"></span> <a href class=h-blue-link holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Client Agreement'|translate\"></a> </span> </gmw-checkbox> </div> </div> </div> </div> <div class=\"initial-onboarding__dual-cta h-margin-top-20\"> <div class=initial-onboarding__dual-cta-col> <a class=\"medium-border-cta h-margin-right-20\" ui-sref=holding.dashboard.overview.balances> <span ng-bind=\"'Continue to Holding'|translate\"></span> </a> </div> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n                'loading-button': transferCtrl.isSubmitting\n              }\" ng-disabled=\"transferCtrl.form.$invalid || transferCtrl.form.$submitted\"> <span ng-bind=\"'I Accept'|translate\"></span> </button> </div> </div> </form> </div> </section> </div> ";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


TransferController.$inject = ['$state', '$log', 'HoldingTransfer', 'HoldingProperties', 'HoldingAuth', 'BanksResolve', 'UserResolve'];
angular.module('app.holding.splash.legal.transfer').controller('TransferController', TransferController);

function TransferController($state, $log, HoldingTransfer, HoldingProperties, HoldingAuth, BanksResolve, UserResolve) {
  'ngInject';

  var vm = this;

  vm.agreeToTerms = agreeToTerms;
  vm.isSepaImpacted = BanksResolve.banks.find(function (bank) {
    return bank.currencyCode === 'EUR';
  });
  vm.isSubmitting = false;
  vm.signOut = signOut;
  vm.user = UserResolve;

  function agreeToTerms() {
    if (vm.form.$invalid) {
      vm.form.$setSubmitted();
      return undefined;
    }

    vm.isSubmitting = true;
    return HoldingTransfer.migrate().then(function () {
      HoldingProperties.set('AgreeTermsHoldingRegulationMigration', {
        at: new Date().toISOString()
      });
      return $state.go('holding.dashboard.overview', {}, {
        reload: true
      });
    }).catch(function (error) {
      vm.isSubmitting = false;
      if (error.message === 'holding.migrate.flag') {
        $state.go('holding.dashboard.overview', {}, {
          reload: true
        });
      } else {
        vm.agreeError = error.message;
        $log.error(error.message);

        vm.terms = false;
      }
    });
  }

  function signOut() {
    HoldingAuth.signOut().then(function () {
      $state.go('auth.sign-in', {
        message: 'logout'
      });
    });
  }
}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "<gmw-onboarding-header></gmw-onboarding-header> <div ui-view=splash></div> ";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding').run(['$injector', '$transitions', 'GmwSetup', function ($injector, $transitions, GmwSetup) {
  'ngInject';

  $transitions.onStart({}, function (transition) {
    if (!transition) {
      return;
    }

    var _transition$$to = transition.$to(),
        data = _transition$$to.data,
        name = _transition$$to.name;

    if (data && 'flow' in data && data.flow && data.flow.controller) {
      $injector.invoke([data.flow.controller, function (flowService) {
        var redirectTo = flowService.checkState(name);
        if (redirectTo) {
          return transition.router.stateService.target(redirectTo);
        } else if (flowService.updateState) {
          flowService.updateState(name);
        }
      }]);
    }
  });

  $transitions.onSuccess({}, function (transition) {
    if (!transition) {
      return;
    }

    var _transition$$to2 = transition.$to(),
        data = _transition$$to2.data;

    if (!(data && data.skipSetupCheck)) {
      GmwSetup.hasCompletedSetup().then(function (hasCompletedSetup) {
        if (!hasCompletedSetup) {
          return transition.router.stateService.target('setup');
        }
      });
    }
  });
}]).name;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingExpectedUse.$inject = ['$window', '$q'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding').factory('HoldingExpectedUse', HoldingExpectedUse).name;


function HoldingExpectedUse($window, $q) {
  'ngInject';

  return {
    hasCompleteValues: hasCompleteValues,
    hasDefaultValues: hasDefaultValues
  };

  function hasCompleteValues(expectedUse) {
    if ('holdingValue' in expectedUse && 'transactionsValue' in expectedUse && 'transactionsCount' in expectedUse) {
      return true;
    }
    return false;
  }

  function hasDefaultValues(expectedUse) {
    if (expectedUse.holdingValue === 500000 && expectedUse.transactionsValue === 250000 && expectedUse.transactionsCount === 10) {
      return true;
    } else if (expectedUse.holdingValue === 1000000 && expectedUse.transactionsValue === 500000 && expectedUse.transactionsCount === 10) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.i18n', []).run(['gettextCatalog', function (gettextCatalog) {
  'ngInject';

  gettextCatalog.setCurrentLanguage("en");
  gettextCatalog.debug = true;
}]).name;


if (false) {
  // eslint-disable-next-line global-require
  _moment2.default.locale('zh-cn');
  require('./i18n/zh.po');
}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.phone', []).name;


__webpack_require__(889);

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingPhone.$inject = ['$window'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.phone').factory('HoldingPhone', HoldingPhone).name;


function HoldingPhone($window) {
  'ngInject';

  var phoneUtils = $window.libphonenumber.PhoneNumberUtil.getInstance();

  return {
    isValidPhoneNumber: isValidPhoneNumber,
    getPhoneCountryCode: getPhoneCountryCode,
    parsePhonenumber: parsePhonenumber
  };

  function isValidCaOrUs(phone, countryCode) {
    if (['CA', 'US'].indexOf(countryCode) > -1) {
      return phone.substr(0, 2) === '+1';
    }

    return true;
  }

  function isValidPhoneNumber(phone) {
    var origCountryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var result = void 0;

    if (!phone) {
      return false;
    }

    try {
      var parsedPhone = phoneUtils.parse(phone);
      var countryCode = origCountryCode || phoneUtils.getRegionCodeForNumber(parsedPhone);

      result = phoneUtils.isValidNumberForRegion(parsedPhone, countryCode) && isValidCaOrUs(phone, countryCode);
    } catch (e) {
      return false;
    }

    return result;
  }

  function getPhoneCountryCode(phone) {
    try {
      var phoneObj = phoneUtils.parse(phone);
      return phoneUtils.getRegionCodeForNumber(phoneObj);
    } catch (e) {
      return null;
    }
  }

  function parsePhonenumber(number) {
    try {
      var phoneObj = phoneUtils.parse(number);

      return {
        nationalNumber: phoneObj.getNationalNumber(),
        prefix: phoneObj.getCountryCode(),
        countryCode: phoneUtils.getRegionCodeForNumber(phoneObj)
      };
    } catch (e) {
      return null;
    }
  }
}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.regions', []).name;


__webpack_require__(891);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingRegions.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.regions').factory('HoldingRegions', HoldingRegions).name;


function HoldingRegions(HoldingApi) {
  'ngInject';

  return {
    getRegionsByCountryCode: getRegionsByCountryCode,
    prepareForSelector: prepareForSelector
  };

  function getRegionsByCountryCode(countryCode) {
    return HoldingApi.get('provinces/' + countryCode.toUpperCase());
  }

  function prepareForSelector(region) {
    return {
      value: region.symbol,
      label: region.name
    };
  }
}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.session', []).name;


__webpack_require__(893);

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.session').factory('HoldingSession', HoldingSession).name;


function HoldingSession() {
  'ngInject';

  var sessionId = null;

  return {
    clearSessionId: clearSessionId,
    getSessionId: getSessionId,
    setSessionId: setSessionId
  };

  function clearSessionId() {
    sessionId = null;
  }

  function getSessionId() {
    return sessionId;
  }

  function setSessionId(newSessionId) {
    sessionId = newSessionId;
  }
}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.support', []).name;


__webpack_require__(895);
__webpack_require__(897);

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingLiveChatCta.$inject = ['$window'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _liveChatCta = __webpack_require__(896);

var _liveChatCta2 = _interopRequireDefault(_liveChatCta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.support').directive('holdingLiveChatCta', holdingLiveChatCta).name;


function holdingLiveChatCta($window) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _liveChatCta2.default
  };

  function link(scope) {
    function openLiveChat() {
      $window.zE('webWidget', 'open');
      $window.zE('webWidget', 'show');
    }

    scope.openLiveChat = openLiveChat;
  }
}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "<a class=\"gmw-live-chat-cta live-chat-indicator-hook\" ng-click=openLiveChat()> <div class=gmw-live-chat-cta__icon-container> <svg class=gmw-live-chat-cta__icon width=30 height=26> <use xlink:href=#dual-messages-icon></use> </svg> </div> <div class=gmw-live-chat-cta__content> <span class=\"heading-h5 h-dark-text\"> Need Help? </span> <span class=h-medium-text> <i class=gmw-live-chat-cta__indicator></i> Live Chat Online Now </span> </div> <svg class=gmw-live-chat-cta__arrow width=16 height=16> <use xlink:href=#right-arrow-icon></use> </svg> </a> ";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingSupport.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.support').factory('HoldingSupport', HoldingSupport).name;


function HoldingSupport(gettextCatalog) {
  'ngInject';

  return {
    getSupportNumber: getSupportNumber
  };

  function getSupportNumber(regulator) {
    switch (regulator) {
      case 'JFSC':
        return [{
          description: gettextCatalog.getString('USA & Canada'),
          country: 1,
          number: '855-583-GOLD (4653)',
          numberRaw: 8555834653
        }, {
          description: gettextCatalog.getString('U.K. & International'),
          country: 44,
          number: '1534-633-900',
          numberRaw: 1534633900
        }];
      case 'Toronto':
        return [{
          description: gettextCatalog.getString('USA, Canada & International'),
          country: 1,
          number: '(855) 498-1854',
          numberRaw: 8554981854
        }, {
          description: gettextCatalog.getString('U.K. & Europe'),
          country: 44,
          number: '(808) 501-5812',
          numberRaw: 8085015812
        }];
      case 'UK':
        return [{
          description: gettextCatalog.getString('USA, Canada & International'),
          country: 1,
          number: '(855) 449-1142',
          numberRaw: 8554491142
        }, {
          description: gettextCatalog.getString('U.K. & Europe'),
          country: 44,
          number: '(808) 164-9643',
          numberRaw: 8081649643
        }];
      default:
        return {};
    }
  }
}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.timezones', []).name;


__webpack_require__(899);

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingTimezones.$inject = ['HoldingApi'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.timezones').factory('HoldingTimezones', HoldingTimezones).name;


function HoldingTimezones(HoldingApi) {
  'ngInject';

  var activeLoadPromise = void 0;
  var timezones = void 0;

  return {
    getAllForSelector: getAllForSelector,
    getAllForSelectorWithName: getAllForSelectorWithName,
    getTimezoneByCode: getTimezoneByCode,
    load: load,
    prepareForSelector: prepareForSelector
  };

  function getAllForSelector() {
    return timezones.map(function (_) {
      return prepareForSelector(_.nameShort);
    });
  }

  function getAllForSelectorWithName() {
    return timezones.map(function (currency) {
      return {
        value: currency.nameShort,
        label: currency.name
      };
    });
  }

  function getTimezoneByCode(nameShort) {
    var timezone = timezones.find(function (_) {
      return _.nameShort === nameShort;
    });
    return timezone || null;
  }

  function init() {
    return HoldingApi.get('timezone').then(function (loadedTimezones) {
      timezones = loadedTimezones;
    });
  }

  function load() {
    if (!activeLoadPromise) {
      activeLoadPromise = init();
    }

    return activeLoadPromise;
  }

  function prepareForSelector(code) {
    return {
      value: code,
      label: code.toUpperCase()
    };
  }
}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.user', []).name;


__webpack_require__(901);

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingUser.$inject = ['HoldingApi', 'HoldingSession', 'HoldingCurrencies'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _momentTimezoneWithData = __webpack_require__(902);

var _momentTimezoneWithData2 = _interopRequireDefault(_momentTimezoneWithData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.user').factory('HoldingUser', HoldingUser).name;


function HoldingUser(HoldingApi, HoldingSession, HoldingCurrencies) {
  'ngInject';

  var localPermissions = void 0;
  var localUser = null;

  return {
    canAddFundsCreditCard: canAddFundsCreditCard,
    canBuyMetal: canBuyMetal,
    canFundViaMethod: canFundViaMethod,
    canSellMetal: canSellMetal,
    checkIfAuthed: checkIfAuthed,
    get: get,
    getPermission: getPermission,
    hasFundingConfirmationPeriod: hasFundingConfirmationPeriod,
    init: init,
    isAllowed: isAllowed,
    isForbidden: isForbidden,
    isHidden: isHidden,
    load: load
  };

  function canAddFundsCreditCard() {
    if (localPermissions.addFunds.state !== 'allowed') {
      return false;
    }

    return !!localPermissions.addFunds.methods.find(function (method) {
      return method === 'Braintree';
    });
  }

  function canBuyMetal() {
    if (localPermissions.buy.state !== 'allowed') {
      return false;
    }

    var metalCodes = HoldingCurrencies.getMetals().map(function (currency) {
      return currency.code;
    });
    var enabledCurrencies = localPermissions.buy.products;
    var enabledMetals = metalCodes.filter(function (c) {
      return enabledCurrencies.includes(c);
    });
    return enabledMetals && enabledMetals.length > 0;
  }

  function canFundViaMethod(method) {
    var _getPermission = getPermission('addFunds'),
        methods = _getPermission.methods;

    return $q.when(methods && !!methods.find(function (_) {
      return _ === method;
    }));
  }

  function canSellMetal() {
    if (localPermissions.sell.state !== 'allowed') {
      return false;
    }

    var metalCodes = HoldingCurrencies.getMetals().map(function (currency) {
      return currency.code;
    });
    var enabledCurrencies = localPermissions.buy.products;
    var enabledMetals = metalCodes.filter(function (c) {
      return enabledCurrencies.includes(c);
    });
    return enabledMetals && enabledMetals.length > 0;
  }

  function checkIfAuthed() {
    return HoldingApi.get('refresh', {
      ignore403: true
    }).then(function (user) {
      HoldingSession.setSessionId(user.sessionCode);
    }).then(function () {
      return true;
    }, function () {
      return false;
    });
  }

  function get() {
    return angular.copy(localUser);
  }

  function getPermission(permission) {
    return localPermissions[permission];
  }

  function hasFundingConfirmationPeriod(method) {
    var _getPermission2 = getPermission('addFunds'),
        confirmationPeriods = _getPermission2.confirmationPeriods;

    if (confirmationPeriods) {
      var methodConfirmationPeriod = confirmationPeriods.find(function (_) {
        return _.method === method;
      });
      return $q.when(methodConfirmationPeriod && methodConfirmationPeriod.period);
    }

    return $q.when(false);
  }

  function init(user) {
    localUser = user;
  }

  function isAllowed(permission) {
    return localPermissions[permission] && 'state' in localPermissions[permission] ? localPermissions[permission].state === 'allowed' : false;
  }

  function isForbidden(permission) {
    return localPermissions[permission] && 'state' in localPermissions[permission] ? localPermissions[permission].state === 'forbidden' : false;
  }

  function isHidden(permission) {
    return localPermissions[permission] && 'state' in localPermissions[permission] ? localPermissions[permission].state === 'hidden' : false;
  }

  function load() {
    return HoldingApi.get('refresh').then(function (user) {
      init(user);
      HoldingSession.setSessionId(user.sessionCode);
      localPermissions = user.holdingPermissions;

      _momentTimezoneWithData2.default.tz.setDefault(user.timeZone);
      _momentTimezoneWithData2.default.fn.zoneName = function zoneName() {
        return this._z.name;
      };

      return user;
    });
  }
}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.4.0
//! author : Tim Wood
//! license : MIT
//! github.com/moment/moment-timezone
!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b(require("moment")):b(a.moment)}(this,function(a){"use strict";function b(a){return a>96?a-87:a>64?a-29:a-48}function c(a){var c,d=0,e=a.split("."),f=e[0],g=e[1]||"",h=1,i=0,j=1;for(45===a.charCodeAt(0)&&(d=1,j=-1),d;d<f.length;d++)c=b(f.charCodeAt(d)),i=60*i+c;for(d=0;d<g.length;d++)h/=60,c=b(g.charCodeAt(d)),i+=c*h;return i*j}function d(a){for(var b=0;b<a.length;b++)a[b]=c(a[b])}function e(a,b){for(var c=0;b>c;c++)a[c]=Math.round((a[c-1]||0)+6e4*a[c]);a[b-1]=1/0}function f(a,b){var c,d=[];for(c=0;c<b.length;c++)d[c]=a[b[c]];return d}function g(a){var b=a.split("|"),c=b[2].split(" "),g=b[3].split(""),h=b[4].split(" ");return d(c),d(g),d(h),e(h,g.length),{name:b[0],abbrs:f(b[1].split(" "),g),offsets:f(c,g),untils:h}}function h(a){a&&this._set(g(a))}function i(a){return(a||"").toLowerCase().replace(/\//g,"_")}function j(a){var b,c,d;for("string"==typeof a&&(a=[a]),b=0;b<a.length;b++)c=a[b].split("|")[0],d=i(c),v[d]=a[b],x[d]=c}function k(a,b){a=i(a);var c,d=v[a];return d instanceof h?d:"string"==typeof d?(d=new h(d),v[a]=d,d):w[a]&&b!==k&&(c=k(w[a],k))?(d=v[a]=new h,d._set(c),d.name=x[a],d):null}function l(){var a,b=[];for(a in x)x.hasOwnProperty(a)&&(v[a]||v[w[a]])&&x[a]&&b.push(x[a]);return b.sort()}function m(a){var b,c,d,e;for("string"==typeof a&&(a=[a]),b=0;b<a.length;b++)c=a[b].split("|"),d=i(c[0]),e=i(c[1]),w[d]=e,x[d]=c[0],w[e]=d,x[e]=c[1]}function n(a){j(a.zones),m(a.links),r.dataVersion=a.version}function o(a){return o.didShowError||(o.didShowError=!0,q("moment.tz.zoneExists('"+a+"') has been deprecated in favor of !moment.tz.zone('"+a+"')")),!!k(a)}function p(a){return!(!a._a||void 0!==a._tzm)}function q(a){"undefined"!=typeof console&&"function"==typeof console.error&&console.error(a)}function r(b){var c=Array.prototype.slice.call(arguments,0,-1),d=arguments[arguments.length-1],e=k(d),f=a.utc.apply(null,c);return e&&!a.isMoment(b)&&p(f)&&f.add(e.parse(f),"minutes"),f.tz(d),f}function s(a){return function(){return this._z?this._z.abbr(this):a.call(this)}}function t(a){return function(){return this._z=null,a.apply(this,arguments)}}if(void 0!==a.tz)return q("Moment Timezone "+a.tz.version+" was already loaded "+(a.tz.dataVersion?"with data from ":"without any data")+a.tz.dataVersion),a;var u="0.4.0",v={},w={},x={},y=a.version.split("."),z=+y[0],A=+y[1];(2>z||2===z&&6>A)&&q("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js "+a.version+". See momentjs.com"),h.prototype={_set:function(a){this.name=a.name,this.abbrs=a.abbrs,this.untils=a.untils,this.offsets=a.offsets},_index:function(a){var b,c=+a,d=this.untils;for(b=0;b<d.length;b++)if(c<d[b])return b},parse:function(a){var b,c,d,e,f=+a,g=this.offsets,h=this.untils,i=h.length-1;for(e=0;i>e;e++)if(b=g[e],c=g[e+1],d=g[e?e-1:e],c>b&&r.moveAmbiguousForward?b=c:b>d&&r.moveInvalidForward&&(b=d),f<h[e]-6e4*b)return g[e];return g[i]},abbr:function(a){return this.abbrs[this._index(a)]},offset:function(a){return this.offsets[this._index(a)]}},r.version=u,r.dataVersion="",r._zones=v,r._links=w,r._names=x,r.add=j,r.link=m,r.load=n,r.zone=k,r.zoneExists=o,r.names=l,r.Zone=h,r.unpack=g,r.unpackBase60=c,r.needsOffset=p,r.moveInvalidForward=!0,r.moveAmbiguousForward=!1;var B=a.fn;a.tz=r,a.defaultZone=null,a.updateOffset=function(b,c){var d,e=a.defaultZone;void 0===b._z&&(e&&p(b)&&!b._isUTC&&(b._d=a.utc(b._a)._d,b.utc().add(e.parse(b),"minutes")),b._z=e),b._z&&(d=b._z.offset(b),Math.abs(d)<16&&(d/=60),void 0!==b.utcOffset?b.utcOffset(-d,c):b.zone(d,c))},B.tz=function(b){return b?(this._z=k(b),this._z?a.updateOffset(this):q("Moment Timezone has no data for "+b+". See http://momentjs.com/timezone/docs/#/data-loading/."),this):this._z?this._z.name:void 0},B.zoneName=s(B.zoneName),B.zoneAbbr=s(B.zoneAbbr),B.utc=t(B.utc),a.tz.setDefault=function(b){return(2>z||2===z&&9>A)&&q("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js "+a.version+"."),a.defaultZone=b?k(b):null,a};var C=a.momentProperties;return"[object Array]"===Object.prototype.toString.call(C)?(C.push("_z"),C.push("_a")):C&&(C._z=null),n({version:"2015d",zones:["Africa/Abidjan|GMT|0|0|","Africa/Addis_Ababa|EAT|-30|0|","Africa/Algiers|CET|-10|0|","Africa/Bangui|WAT|-10|0|","Africa/Blantyre|CAT|-20|0|","Africa/Cairo|EET EEST|-20 -30|010101010|1Cby0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0","Africa/Casablanca|WET WEST|0 -10|01010101010101010101010101010101010101010|1Cco0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uo0 e00 DA0 11A0 rA0 e00 Jc0 WM0 m00 gM0 M00 WM0 jc0 e00 RA0 11A0 dA0 e00 Uo0 11A0 800 gM0 Xc0","Africa/Ceuta|CET CEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Africa/Johannesburg|SAST|-20|0|","Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00","Africa/Windhoek|WAST WAT|-20 -10|01010101010101010101010|1C1c0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0","America/Adak|HST HDT|a0 90|01010101010101010101010|1BR00 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1BQX0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Anguilla|AST|40|0|","America/Araguaina|BRT BRST|30 20|010|1IdD0 Lz0","America/Argentina/Buenos_Aires|ART|30|0|","America/Asuncion|PYST PYT|30 40|01010101010101010101010|1C430 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0","America/Atikokan|EST|50|0|","America/Bahia|BRT BRST|30 20|010|1FJf0 Rb0","America/Bahia_Banderas|MST CDT CST|70 50 60|01212121212121212121212|1C1l0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Belem|BRT|30|0|","America/Belize|CST|60|0|","America/Boa_Vista|AMT|40|0|","America/Bogota|COT|50|0|","America/Boise|MST MDT|70 60|01010101010101010101010|1BQV0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Campo_Grande|AMST AMT|30 40|01010101010101010101010|1BIr0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10","America/Cancun|CST CDT EST|60 50 50|010101010102|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0","America/Caracas|VET|4u|0|","America/Cayenne|GFT|30|0|","America/Chicago|CST CDT|60 50|01010101010101010101010|1BQU0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Chihuahua|MST MDT|70 60|01010101010101010101010|1C1l0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Creston|MST|70|0|","America/Dawson|PST PDT|80 70|01010101010101010101010|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Detroit|EST EDT|50 40|01010101010101010101010|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Eirunepe|AMT ACT|40 50|01|1KLE0","America/Glace_Bay|AST ADT|40 30|01010101010101010101010|1BQS0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Godthab|WGT WGST|30 20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","America/Goose_Bay|AST ADT|40 30|01010101010101010101010|1BQQ1 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Grand_Turk|EST EDT AST|50 40 40|0101010101012|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Guayaquil|ECT|50|0|","America/Guyana|GYT|40|0|","America/Havana|CST CDT|50 40|01010101010101010101010|1BQR0 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0","America/La_Paz|BOT|40|0|","America/Lima|PET|50|0|","America/Merida|CST CDT|60 50|01010101010101010101010|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Metlakatla|PST|80|0|","America/Miquelon|PMST PMDT|30 20|01010101010101010101010|1BQR0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Montevideo|UYST UYT|20 30|01010101010101010101010|1BQQ0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10","America/Noronha|FNT|20|0|","America/North_Dakota/Beulah|MST MDT CST CDT|70 60 60 50|01232323232323232323232|1BQV0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Paramaribo|SRT|30|0|","America/Port-au-Prince|EST EDT|50 40|0101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Santa_Isabel|PST PDT|80 70|01010101010101010101010|1C1m0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Santiago|CLST CLT CLT|30 40 30|010101010102|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","America/Sao_Paulo|BRST BRT|20 30|01010101010101010101010|1BIq0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10","America/Scoresbysund|EGT EGST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1BQPv 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Antarctica/Casey|CAST AWST|-b0 -80|0101|1BN30 40P0 KL0","Antarctica/Davis|DAVT DAVT|-50 -70|0101|1BPw0 3Wn0 KN0","Antarctica/DumontDUrville|DDUT|-a0|0|","Antarctica/Macquarie|AEDT MIST|-b0 -b0|01|1C140","Antarctica/Mawson|MAWT|-50|0|","Antarctica/McMurdo|NZDT NZST|-d0 -c0|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Antarctica/Rothera|ROTT|30|0|","Antarctica/Syowa|SYOT|-30|0|","Antarctica/Troll|UTC CEST|0 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Antarctica/Vostok|VOST|-60|0|","Asia/Aden|AST|-30|0|","Asia/Almaty|ALMT|-60|0|","Asia/Amman|EET EEST|-20 -30|010101010101010101010|1BVy0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0","Asia/Anadyr|ANAT ANAST ANAT|-c0 -c0 -b0|0120|1BWe0 1qN0 WM0","Asia/Aqtau|AQTT|-50|0|","Asia/Ashgabat|TMT|-50|0|","Asia/Baku|AZT AZST|-40 -50|01010101010101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Bangkok|ICT|-70|0|","Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1BWm0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0","Asia/Bishkek|KGT|-60|0|","Asia/Brunei|BNT|-80|0|","Asia/Calcutta|IST|-5u|0|","Asia/Chita|YAKT YAKST YAKT IRKT|-90 -a0 -a0 -80|01023|1BWh0 1qM0 WM0 8Hz0","Asia/Choibalsan|CHOT CHOST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Chongqing|CST|-80|0|","Asia/Dacca|BDT|-60|0|","Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1C0m0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0","Asia/Dili|TLT|-90|0|","Asia/Dubai|GST|-40|0|","Asia/Dushanbe|TJT|-50|0|","Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1BVW1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0","Asia/Hebron|EET EEST|-20 -30|0101010101010101010101010|1BVy0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0","Asia/Hong_Kong|HKT|-80|0|","Asia/Hovd|HOVT HOVST|-70 -80|0101010101010|1O8H0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Irkutsk|IRKT IRKST IRKT|-80 -90 -90|01020|1BWi0 1qM0 WM0 8Hz0","Asia/Istanbul|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Jakarta|WIB|-70|0|","Asia/Jayapura|WIT|-90|0|","Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1BVA0 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0","Asia/Kabul|AFT|-4u|0|","Asia/Kamchatka|PETT PETST PETT|-c0 -c0 -b0|0120|1BWe0 1qN0 WM0","Asia/Karachi|PKT|-50|0|","Asia/Kashgar|XJT|-60|0|","Asia/Kathmandu|NPT|-5J|0|","Asia/Khandyga|VLAT VLAST VLAT YAKT YAKT|-a0 -b0 -b0 -a0 -90|010234|1BWg0 1qM0 WM0 17V0 7zD0","Asia/Krasnoyarsk|KRAT KRAST KRAT|-70 -80 -80|01020|1BWj0 1qM0 WM0 8Hz0","Asia/Kuala_Lumpur|MYT|-80|0|","Asia/Magadan|MAGT MAGST MAGT MAGT|-b0 -c0 -c0 -a0|01023|1BWf0 1qM0 WM0 8Hz0","Asia/Makassar|WITA|-80|0|","Asia/Manila|PHT|-80|0|","Asia/Nicosia|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Novokuznetsk|KRAT NOVST NOVT NOVT|-70 -70 -60 -70|01230|1BWj0 1qN0 WM0 8Hz0","Asia/Novosibirsk|NOVT NOVST NOVT|-60 -70 -70|01020|1BWk0 1qM0 WM0 8Hz0","Asia/Omsk|OMST OMSST OMST|-60 -70 -70|01020|1BWk0 1qM0 WM0 8Hz0","Asia/Oral|ORAT|-50|0|","Asia/Pyongyang|KST|-90|0|","Asia/Qyzylorda|QYZT|-60|0|","Asia/Rangoon|MMT|-6u|0|","Asia/Sakhalin|SAKT SAKST SAKT|-a0 -b0 -b0|01020|1BWg0 1qM0 WM0 8Hz0","Asia/Samarkand|UZT|-50|0|","Asia/Singapore|SGT|-80|0|","Asia/Srednekolymsk|MAGT MAGST MAGT SRET|-b0 -c0 -c0 -b0|01023|1BWf0 1qM0 WM0 8Hz0","Asia/Tbilisi|GET|-40|0|","Asia/Tehran|IRST IRDT|-3u -4u|01010101010101010101010|1BTUu 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0","Asia/Thimbu|BTT|-60|0|","Asia/Tokyo|JST|-90|0|","Asia/Ulaanbaatar|ULAT ULAST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Ust-Nera|MAGT MAGST MAGT VLAT VLAT|-b0 -c0 -c0 -b0 -a0|010234|1BWf0 1qM0 WM0 17V0 7zD0","Asia/Vladivostok|VLAT VLAST VLAT|-a0 -b0 -b0|01020|1BWg0 1qM0 WM0 8Hz0","Asia/Yakutsk|YAKT YAKST YAKT|-90 -a0 -a0|01020|1BWh0 1qM0 WM0 8Hz0","Asia/Yekaterinburg|YEKT YEKST YEKT|-50 -60 -60|01020|1BWl0 1qM0 WM0 8Hz0","Asia/Yerevan|AMT AMST|-40 -50|01010|1BWm0 1qM0 WM0 1qM0","Atlantic/Azores|AZOT AZOST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Canary|WET WEST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Cape_Verde|CVT|10|0|","Atlantic/South_Georgia|GST|20|0|","Atlantic/Stanley|FKST FKT|30 40|010|1C6R0 U10","Australia/ACT|AEDT AEST|-b0 -a0|01010101010101010101010|1C140 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1C14u 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Brisbane|AEST|-a0|0|","Australia/Darwin|ACST|-9u|0|","Australia/Eucla|ACWST|-8J|0|","Australia/LHI|LHDT LHST|-b0 -au|01010101010101010101010|1C130 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu","Australia/Perth|AWST|-80|0|","Chile/EasterIsland|EASST EAST EAST|50 60 50|010101010102|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","Eire|GMT IST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Etc/GMT+1|GMT+1|10|0|","Etc/GMT+10|GMT+10|a0|0|","Etc/GMT+11|GMT+11|b0|0|","Etc/GMT+12|GMT+12|c0|0|","Etc/GMT+2|GMT+2|20|0|","Etc/GMT+3|GMT+3|30|0|","Etc/GMT+4|GMT+4|40|0|","Etc/GMT+5|GMT+5|50|0|","Etc/GMT+6|GMT+6|60|0|","Etc/GMT+7|GMT+7|70|0|","Etc/GMT+8|GMT+8|80|0|","Etc/GMT+9|GMT+9|90|0|","Etc/GMT-1|GMT-1|-10|0|","Etc/GMT-10|GMT-10|-a0|0|","Etc/GMT-11|GMT-11|-b0|0|","Etc/GMT-12|GMT-12|-c0|0|","Etc/GMT-13|GMT-13|-d0|0|","Etc/GMT-14|GMT-14|-e0|0|","Etc/GMT-2|GMT-2|-20|0|","Etc/GMT-3|GMT-3|-30|0|","Etc/GMT-4|GMT-4|-40|0|","Etc/GMT-5|GMT-5|-50|0|","Etc/GMT-6|GMT-6|-60|0|","Etc/GMT-7|GMT-7|-70|0|","Etc/GMT-8|GMT-8|-80|0|","Etc/GMT-9|GMT-9|-90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Belfast|GMT BST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Kaliningrad|EET EEST FET|-20 -30 -30|01020|1BWo0 1qM0 WM0 8Hz0","Europe/Minsk|EET EEST FET MSK|-20 -30 -30 -30|01023|1BWo0 1qM0 WM0 8Hy0","Europe/Moscow|MSK MSD MSK|-30 -40 -40|01020|1BWn0 1qM0 WM0 8Hz0","Europe/Samara|SAMT SAMST SAMT|-40 -40 -30|0120|1BWm0 1qN0 WM0","Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|01010101023|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0","HST|HST|a0|0|","Indian/Chagos|IOT|-60|0|","Indian/Christmas|CXT|-70|0|","Indian/Cocos|CCT|-6u|0|","Indian/Kerguelen|TFT|-50|0|","Indian/Mahe|SCT|-40|0|","Indian/Maldives|MVT|-50|0|","Indian/Mauritius|MUT|-40|0|","Indian/Reunion|RET|-40|0|","Kwajalein|MHT|-c0|0|","MET|MET MEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","NZ-CHAT|CHADT CHAST|-dJ -cJ|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Pacific/Apia|SST SDT WSDT WSST|b0 a0 -e0 -d0|01012323232323232323232|1Dbn0 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Pacific/Bougainville|PGT BST|-a0 -b0|01|1NwE0","Pacific/Chuuk|CHUT|-a0|0|","Pacific/Efate|VUT|-b0|0|","Pacific/Enderbury|PHOT|-d0|0|","Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0","Pacific/Fiji|FJST FJT|-d0 -c0|01010101010101010101010|1BWe0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 xA0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1SM0","Pacific/Funafuti|TVT|-c0|0|","Pacific/Galapagos|GALT|60|0|","Pacific/Gambier|GAMT|90|0|","Pacific/Guadalcanal|SBT|-b0|0|","Pacific/Guam|ChST|-a0|0|","Pacific/Kiritimati|LINT|-e0|0|","Pacific/Kosrae|KOST|-b0|0|","Pacific/Marquesas|MART|9u|0|","Pacific/Midway|SST|b0|0|","Pacific/Nauru|NRT|-c0|0|","Pacific/Niue|NUT|b0|0|","Pacific/Norfolk|NFT|-bu|0|","Pacific/Noumea|NCT|-b0|0|","Pacific/Palau|PWT|-90|0|","Pacific/Pohnpei|PONT|-b0|0|","Pacific/Port_Moresby|PGT|-a0|0|","Pacific/Rarotonga|CKT|a0|0|","Pacific/Tahiti|TAHT|a0|0|","Pacific/Tarawa|GILT|-c0|0|","Pacific/Tongatapu|TOT|-d0|0|","Pacific/Wake|WAKT|-c0|0|","Pacific/Wallis|WFT|-c0|0|"],links:["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Bissau","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Monrovia","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|America/Danmarkshavn","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Etc/GMT","Africa/Abidjan|Etc/GMT+0","Africa/Abidjan|Etc/GMT-0","Africa/Abidjan|Etc/GMT0","Africa/Abidjan|Etc/Greenwich","Africa/Abidjan|GMT","Africa/Abidjan|GMT+0","Africa/Abidjan|GMT-0","Africa/Abidjan|GMT0","Africa/Abidjan|Greenwich","Africa/Abidjan|Iceland","Africa/Addis_Ababa|Africa/Asmara","Africa/Addis_Ababa|Africa/Asmera","Africa/Addis_Ababa|Africa/Dar_es_Salaam","Africa/Addis_Ababa|Africa/Djibouti","Africa/Addis_Ababa|Africa/Juba","Africa/Addis_Ababa|Africa/Kampala","Africa/Addis_Ababa|Africa/Khartoum","Africa/Addis_Ababa|Africa/Mogadishu","Africa/Addis_Ababa|Africa/Nairobi","Africa/Addis_Ababa|Indian/Antananarivo","Africa/Addis_Ababa|Indian/Comoro","Africa/Addis_Ababa|Indian/Mayotte","Africa/Algiers|Africa/Tunis","Africa/Bangui|Africa/Brazzaville","Africa/Bangui|Africa/Douala","Africa/Bangui|Africa/Kinshasa","Africa/Bangui|Africa/Lagos","Africa/Bangui|Africa/Libreville","Africa/Bangui|Africa/Luanda","Africa/Bangui|Africa/Malabo","Africa/Bangui|Africa/Ndjamena","Africa/Bangui|Africa/Niamey","Africa/Bangui|Africa/Porto-Novo","Africa/Blantyre|Africa/Bujumbura","Africa/Blantyre|Africa/Gaborone","Africa/Blantyre|Africa/Harare","Africa/Blantyre|Africa/Kigali","Africa/Blantyre|Africa/Lubumbashi","Africa/Blantyre|Africa/Lusaka","Africa/Blantyre|Africa/Maputo","Africa/Cairo|Egypt","Africa/Casablanca|Africa/El_Aaiun","Africa/Ceuta|Arctic/Longyearbyen","Africa/Ceuta|Atlantic/Jan_Mayen","Africa/Ceuta|CET","Africa/Ceuta|Europe/Amsterdam","Africa/Ceuta|Europe/Andorra","Africa/Ceuta|Europe/Belgrade","Africa/Ceuta|Europe/Berlin","Africa/Ceuta|Europe/Bratislava","Africa/Ceuta|Europe/Brussels","Africa/Ceuta|Europe/Budapest","Africa/Ceuta|Europe/Busingen","Africa/Ceuta|Europe/Copenhagen","Africa/Ceuta|Europe/Gibraltar","Africa/Ceuta|Europe/Ljubljana","Africa/Ceuta|Europe/Luxembourg","Africa/Ceuta|Europe/Madrid","Africa/Ceuta|Europe/Malta","Africa/Ceuta|Europe/Monaco","Africa/Ceuta|Europe/Oslo","Africa/Ceuta|Europe/Paris","Africa/Ceuta|Europe/Podgorica","Africa/Ceuta|Europe/Prague","Africa/Ceuta|Europe/Rome","Africa/Ceuta|Europe/San_Marino","Africa/Ceuta|Europe/Sarajevo","Africa/Ceuta|Europe/Skopje","Africa/Ceuta|Europe/Stockholm","Africa/Ceuta|Europe/Tirane","Africa/Ceuta|Europe/Vaduz","Africa/Ceuta|Europe/Vatican","Africa/Ceuta|Europe/Vienna","Africa/Ceuta|Europe/Warsaw","Africa/Ceuta|Europe/Zagreb","Africa/Ceuta|Europe/Zurich","Africa/Ceuta|Poland","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|America/Juneau","America/Anchorage|America/Nome","America/Anchorage|America/Sitka","America/Anchorage|America/Yakutat","America/Anchorage|US/Alaska","America/Anguilla|America/Antigua","America/Anguilla|America/Aruba","America/Anguilla|America/Barbados","America/Anguilla|America/Blanc-Sablon","America/Anguilla|America/Curacao","America/Anguilla|America/Dominica","America/Anguilla|America/Grenada","America/Anguilla|America/Guadeloupe","America/Anguilla|America/Kralendijk","America/Anguilla|America/Lower_Princes","America/Anguilla|America/Marigot","America/Anguilla|America/Martinique","America/Anguilla|America/Montserrat","America/Anguilla|America/Port_of_Spain","America/Anguilla|America/Puerto_Rico","America/Anguilla|America/Santo_Domingo","America/Anguilla|America/St_Barthelemy","America/Anguilla|America/St_Kitts","America/Anguilla|America/St_Lucia","America/Anguilla|America/St_Thomas","America/Anguilla|America/St_Vincent","America/Anguilla|America/Tortola","America/Anguilla|America/Virgin","America/Argentina/Buenos_Aires|America/Argentina/Catamarca","America/Argentina/Buenos_Aires|America/Argentina/ComodRivadavia","America/Argentina/Buenos_Aires|America/Argentina/Cordoba","America/Argentina/Buenos_Aires|America/Argentina/Jujuy","America/Argentina/Buenos_Aires|America/Argentina/La_Rioja","America/Argentina/Buenos_Aires|America/Argentina/Mendoza","America/Argentina/Buenos_Aires|America/Argentina/Rio_Gallegos","America/Argentina/Buenos_Aires|America/Argentina/Salta","America/Argentina/Buenos_Aires|America/Argentina/San_Juan","America/Argentina/Buenos_Aires|America/Argentina/San_Luis","America/Argentina/Buenos_Aires|America/Argentina/Tucuman","America/Argentina/Buenos_Aires|America/Argentina/Ushuaia","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Buenos_Aires|America/Catamarca","America/Argentina/Buenos_Aires|America/Cordoba","America/Argentina/Buenos_Aires|America/Jujuy","America/Argentina/Buenos_Aires|America/Mendoza","America/Argentina/Buenos_Aires|America/Rosario","America/Atikokan|America/Cayman","America/Atikokan|America/Coral_Harbour","America/Atikokan|America/Jamaica","America/Atikokan|America/Panama","America/Atikokan|EST","America/Atikokan|Jamaica","America/Belem|America/Fortaleza","America/Belem|America/Maceio","America/Belem|America/Recife","America/Belem|America/Santarem","America/Belize|America/Costa_Rica","America/Belize|America/El_Salvador","America/Belize|America/Guatemala","America/Belize|America/Managua","America/Belize|America/Regina","America/Belize|America/Swift_Current","America/Belize|America/Tegucigalpa","America/Belize|Canada/East-Saskatchewan","America/Belize|Canada/Saskatchewan","America/Boa_Vista|America/Manaus","America/Boa_Vista|America/Porto_Velho","America/Boa_Vista|Brazil/West","America/Boise|America/Cambridge_Bay","America/Boise|America/Denver","America/Boise|America/Edmonton","America/Boise|America/Inuvik","America/Boise|America/Ojinaga","America/Boise|America/Shiprock","America/Boise|America/Yellowknife","America/Boise|Canada/Mountain","America/Boise|MST7MDT","America/Boise|Navajo","America/Boise|US/Mountain","America/Campo_Grande|America/Cuiaba","America/Chicago|America/Indiana/Knox","America/Chicago|America/Indiana/Tell_City","America/Chicago|America/Knox_IN","America/Chicago|America/Matamoros","America/Chicago|America/Menominee","America/Chicago|America/North_Dakota/Center","America/Chicago|America/North_Dakota/New_Salem","America/Chicago|America/Rainy_River","America/Chicago|America/Rankin_Inlet","America/Chicago|America/Resolute","America/Chicago|America/Winnipeg","America/Chicago|CST6CDT","America/Chicago|Canada/Central","America/Chicago|US/Central","America/Chicago|US/Indiana-Starke","America/Chihuahua|America/Mazatlan","America/Chihuahua|Mexico/BajaSur","America/Creston|America/Dawson_Creek","America/Creston|America/Hermosillo","America/Creston|America/Phoenix","America/Creston|MST","America/Creston|US/Arizona","America/Dawson|America/Ensenada","America/Dawson|America/Los_Angeles","America/Dawson|America/Tijuana","America/Dawson|America/Vancouver","America/Dawson|America/Whitehorse","America/Dawson|Canada/Pacific","America/Dawson|Canada/Yukon","America/Dawson|Mexico/BajaNorte","America/Dawson|PST8PDT","America/Dawson|US/Pacific","America/Dawson|US/Pacific-New","America/Detroit|America/Fort_Wayne","America/Detroit|America/Indiana/Indianapolis","America/Detroit|America/Indiana/Marengo","America/Detroit|America/Indiana/Petersburg","America/Detroit|America/Indiana/Vevay","America/Detroit|America/Indiana/Vincennes","America/Detroit|America/Indiana/Winamac","America/Detroit|America/Indianapolis","America/Detroit|America/Iqaluit","America/Detroit|America/Kentucky/Louisville","America/Detroit|America/Kentucky/Monticello","America/Detroit|America/Louisville","America/Detroit|America/Montreal","America/Detroit|America/Nassau","America/Detroit|America/New_York","America/Detroit|America/Nipigon","America/Detroit|America/Pangnirtung","America/Detroit|America/Thunder_Bay","America/Detroit|America/Toronto","America/Detroit|Canada/Eastern","America/Detroit|EST5EDT","America/Detroit|US/East-Indiana","America/Detroit|US/Eastern","America/Detroit|US/Michigan","America/Eirunepe|America/Porto_Acre","America/Eirunepe|America/Rio_Branco","America/Eirunepe|Brazil/Acre","America/Glace_Bay|America/Halifax","America/Glace_Bay|America/Moncton","America/Glace_Bay|America/Thule","America/Glace_Bay|Atlantic/Bermuda","America/Glace_Bay|Canada/Atlantic","America/Havana|Cuba","America/Merida|America/Mexico_City","America/Merida|America/Monterrey","America/Merida|Mexico/General","America/Metlakatla|Pacific/Pitcairn","America/Noronha|Brazil/DeNoronha","America/Santiago|Antarctica/Palmer","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","Antarctica/McMurdo|Antarctica/South_Pole","Antarctica/McMurdo|NZ","Antarctica/McMurdo|Pacific/Auckland","Asia/Aden|Asia/Baghdad","Asia/Aden|Asia/Bahrain","Asia/Aden|Asia/Kuwait","Asia/Aden|Asia/Qatar","Asia/Aden|Asia/Riyadh","Asia/Aqtau|Asia/Aqtobe","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Ho_Chi_Minh","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Saigon","Asia/Bangkok|Asia/Vientiane","Asia/Calcutta|Asia/Colombo","Asia/Calcutta|Asia/Kolkata","Asia/Chongqing|Asia/Chungking","Asia/Chongqing|Asia/Harbin","Asia/Chongqing|Asia/Macao","Asia/Chongqing|Asia/Macau","Asia/Chongqing|Asia/Shanghai","Asia/Chongqing|Asia/Taipei","Asia/Chongqing|PRC","Asia/Chongqing|ROC","Asia/Dacca|Asia/Dhaka","Asia/Dubai|Asia/Muscat","Asia/Hong_Kong|Hongkong","Asia/Istanbul|Europe/Istanbul","Asia/Istanbul|Turkey","Asia/Jakarta|Asia/Pontianak","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kashgar|Asia/Urumqi","Asia/Kathmandu|Asia/Katmandu","Asia/Kuala_Lumpur|Asia/Kuching","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|EET","Asia/Nicosia|Europe/Athens","Asia/Nicosia|Europe/Bucharest","Asia/Nicosia|Europe/Chisinau","Asia/Nicosia|Europe/Helsinki","Asia/Nicosia|Europe/Kiev","Asia/Nicosia|Europe/Mariehamn","Asia/Nicosia|Europe/Nicosia","Asia/Nicosia|Europe/Riga","Asia/Nicosia|Europe/Sofia","Asia/Nicosia|Europe/Tallinn","Asia/Nicosia|Europe/Tiraspol","Asia/Nicosia|Europe/Uzhgorod","Asia/Nicosia|Europe/Vilnius","Asia/Nicosia|Europe/Zaporozhye","Asia/Pyongyang|Asia/Seoul","Asia/Pyongyang|ROK","Asia/Samarkand|Asia/Tashkent","Asia/Singapore|Singapore","Asia/Tehran|Iran","Asia/Thimbu|Asia/Thimphu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Atlantic/Canary|Atlantic/Faeroe","Atlantic/Canary|Atlantic/Faroe","Atlantic/Canary|Atlantic/Madeira","Atlantic/Canary|Europe/Lisbon","Atlantic/Canary|Portugal","Atlantic/Canary|WET","Australia/ACT|Australia/Canberra","Australia/ACT|Australia/Currie","Australia/ACT|Australia/Hobart","Australia/ACT|Australia/Melbourne","Australia/ACT|Australia/NSW","Australia/ACT|Australia/Sydney","Australia/ACT|Australia/Tasmania","Australia/ACT|Australia/Victoria","Australia/Adelaide|Australia/Broken_Hill","Australia/Adelaide|Australia/South","Australia/Adelaide|Australia/Yancowinna","Australia/Brisbane|Australia/Lindeman","Australia/Brisbane|Australia/Queensland","Australia/Darwin|Australia/North","Australia/LHI|Australia/Lord_Howe","Australia/Perth|Australia/West","Chile/EasterIsland|Pacific/Easter","Eire|Europe/Dublin","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belfast|Europe/Guernsey","Europe/Belfast|Europe/Isle_of_Man","Europe/Belfast|Europe/Jersey","Europe/Belfast|Europe/London","Europe/Belfast|GB","Europe/Belfast|GB-Eire","Europe/Moscow|Europe/Volgograd","Europe/Moscow|W-SU","HST|Pacific/Honolulu","HST|Pacific/Johnston","HST|US/Hawaii","Kwajalein|Pacific/Kwajalein","Kwajalein|Pacific/Majuro","NZ-CHAT|Pacific/Chatham","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Guam|Pacific/Saipan","Pacific/Midway|Pacific/Pago_Pago","Pacific/Midway|Pacific/Samoa","Pacific/Midway|US/Samoa","Pacific/Pohnpei|Pacific/Ponape"]}),a});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularRecaptcha = __webpack_require__(196);

var _angularRecaptcha2 = _interopRequireDefault(_angularRecaptcha);

var _netverify = __webpack_require__(904);

var _netverify2 = _interopRequireDefault(_netverify);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding', [_common2.default, _angularjs2.default, _angularRecaptcha2.default]).service('GmwNetVerify', _netverify2.default).name;


__webpack_require__(905);
__webpack_require__(937);
__webpack_require__(947);
__webpack_require__(949);
__webpack_require__(951);
__webpack_require__(953);
__webpack_require__(955);
__webpack_require__(957);
__webpack_require__(959);
__webpack_require__(961);
__webpack_require__(963);
__webpack_require__(965);
__webpack_require__(967);
__webpack_require__(969);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(974);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorCode = exports.ErrorCode = undefined;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ServerError"] = 9100] = "ServerError";
    ErrorCode[ErrorCode["AuthorizationTokenError"] = 9200] = "AuthorizationTokenError";
    ErrorCode[ErrorCode["SessionExpired"] = 9210] = "SessionExpired";
    ErrorCode[ErrorCode["ImageTransmissionError"] = 9300] = "ImageTransmissionError";
    ErrorCode[ErrorCode["VerificationError"] = 9400] = "VerificationError";
    ErrorCode[ErrorCode["NoNetworkConnection"] = 9800] = "NoNetworkConnection";
    ErrorCode[ErrorCode["UnexpectedClientError"] = 9801] = "UnexpectedClientError";
    ErrorCode[ErrorCode["ProblemCommunicating"] = 9810] = "ProblemCommunicating";
    ErrorCode[ErrorCode["CameraUnavailable"] = 9820] = "CameraUnavailable";
    ErrorCode[ErrorCode["NoAcceptableSubmission"] = 9835] = "NoAcceptableSubmission";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
function isSuccess(message) {
    var m = message;
    return m.data && m.data.transactionStatus === 'SUCCESS';
}
function isError(message) {
    var m = message;
    return m.data && m.data.transactionStatus === 'ERROR';
}

var GmwNetVerify = function () {
    function GmwNetVerify($log, $q, $sce, $window, HoldingApi) {
        var _this = this;

        _classCallCheck(this, GmwNetVerify);

        this.$log = $log;
        this.$q = $q;
        this.$sce = $sce;
        this.$window = $window;
        this.HoldingApi = HoldingApi;
        this.init = function (code) {
            var requireCamera = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.tearDown();
            var deferred = _this.$q.defer();
            return _this.getScanId(code, requireCamera).then(function (_ref) {
                var redirectUrl = _ref.redirectUrl,
                    id = _ref.id;

                // Documentation available here:
                // https://github.com/Jumio/implementation-guides/blob/master/netverify/netverify-web.md
                _this.callback = function (e) {
                    return _this.onMessage(e, deferred, id);
                };
                angular.element(_this.$window).on('message', _this.callback);
                return {
                    url: _this.$sce.trustAsResourceUrl(redirectUrl),
                    promise: deferred.promise
                };
            });
        };
        this.onMessage = function (e, deferred, id) {
            var originalEvent = e.originalEvent;
            if (typeof originalEvent.data !== 'string') {
                return;
            }
            var message = JSON.parse(originalEvent.data);
            _this.$log.debug(message);
            if (isSuccess(message)) {
                _this.markFlowAsComplete(id).then(function () {
                    deferred.resolve();
                });
            }
            if (isError(message)) {
                deferred.reject(message.data.errorCode);
            }
        };
        // following 'any' is needed because otherwise TS can't infer the correct overload of off
        this.tearDown = function () {
            angular.element(_this.$window).off('message', _this.callback);
        };
    }

    _createClass(GmwNetVerify, [{
        key: "getScanId",
        value: function getScanId(code, camera) {
            return this.HoldingApi.post('verification/netverify', { code: code, camera: camera });
        }
    }, {
        key: "markFlowAsComplete",
        value: function markFlowAsComplete(id) {
            return this.HoldingApi.post("verification/netverify/" + id);
        }
    }]);

    return GmwNetVerify;
}();

exports.default = GmwNetVerify;

GmwNetVerify.$inject = ['$log', '$q', '$sce', '$window', 'HoldingApi'];

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hero = __webpack_require__(906);

var _hero2 = _interopRequireDefault(_hero);

var _setup = __webpack_require__(907);

var _setup2 = _interopRequireDefault(_setup);

var _securityQuestions = __webpack_require__(909);

var _securityQuestions2 = _interopRequireDefault(_securityQuestions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var params = {
  hideFooter: true,
  noMobileCompoents: true,
  heroNoMobileActionTabs: true
};

angular.module('app.holding.dashboard.onboarding').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('setup', {
    parent: 'holding.dashboard',
    url: '/setup',
    views: {
      hero: {
        template: _hero2.default
      },
      main: _setup2.default
    },
    params: params,
    data: {
      skipSetupCheck: true
    }
  }).state('setup.security-questions', {
    url: '/security-questions',
    views: { '': _securityQuestions2.default },
    params: params,
    data: {
      skipSetupCheck: true
    }
  });
}]);

__webpack_require__(911);
__webpack_require__(920);
__webpack_require__(929);

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "<holding-tutorial-menu class=\"desktop-only desktop-only--xs\"> </holding-tutorial-menu> <holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Holding Setup'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center></section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SetUpController.$inject = ['$state', 'GmwSetup', 'HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setup = __webpack_require__(908);

var _setup2 = _interopRequireDefault(_setup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = 'SetUpController';

angular.module('app.holding.dashboard.onboarding').controller(controller, SetUpController);

exports.default = {
  template: _setup2.default,
  controller: controller,
  controllerAs: 'setupCtrl'
};


function SetUpController($state, GmwSetup, HoldingUser) {
  'ngInject';

  var vm = this;

  vm.user = HoldingUser.get();
  vm.addOwner = addOwner;
  vm.complete = complete;
  vm.removeOwner = removeOwner;

  function activate() {
    GmwSetup.getSetupStatus(true).then(function (setupData) {
      vm.setupStatus = setupData;
    });
  }

  function addOwner() {
    vm.setupStatus.entities.push({
      isPrimary: false,
      hasCompletedSetup: false,
      hasCompletedPersonalDetails: false,
      hasUploadedId: false,
      hasUploadedPOA: false,
      canBeDeleted: true
    });
    vm.setupStatus.remainingOwners -= 1;
    vm.addedOwner = true;
  }

  function complete() {
    return GmwSetup.completeSetup().then(function () {
      $state.go('holding.dashboard.overview', {}, { reload: true });
    });
  }

  function removeOwner() {
    var entities = vm.setupStatus.entities;
    if (entities[entities.length - 1].canBeDeleted) {
      entities.pop();
      vm.addedOwner = false;
    }
  }

  activate();
}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "<section class=gmw-verification-wrapper ui-view> <div class=floating-sidebar-app-view> <div class=\"floating-sidebar-app-view__main gmw-verification-wrapper__main\"> <header class=gmw-flow-box__header> <div class=\"gmw-holding-number-box gmw-holding-number-box--show-on-break\"> <span class=\"gmw-holding-number-box__label heading-h5\" ng-bind=\"'Holding'|translate\"> </span> <h1 class=\"heading-h1 h-white-text\" ng-bind=setupCtrl.user.holdingNumber> </h1> </div> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Thank you for opening a Goldmoney Holding'|translate\"> </h2> <p class=gmw-flow-box__header-description> <span translate> To finish setting up your Holding, you will need to complete the steps below. </span> </p> </header> <div class=gmw-flow-box-container> <holding-alert-legacy class=info> <span> <span ng-bind=\"'Please make a note of your Holding number'|translate\"></span> <span ng-bind=\"'(' + setupCtrl.user.holdingNumber + '),'\"></span> <span ng-bind=\"'as you will need it in the future to sign in.'|translate\"></span> </span> </holding-alert-legacy> <div class=gmw-verification-container> <div class=gmw-verification-container__section ng-repeat=\"owner in setupCtrl.setupStatus.entities\"> <div class=\"brandon h-dark-text h-margin-bottom-20 h-flex\"> <div class=h-flex-grow> <div ng-if=\"$first && setupCtrl.setupStatus.entities.length > 1\" translate> Primary Owner: {{owner.name}} </div> <div ng-if=!$first> <span ng-if=owner.name translate> Secondary Owner: {{owner.name}} </span> <span ng-if=!owner.name ng-bind=\"'Secondary Owner'|translate\"> </span> </div> </div> <div ng-if=owner.canBeDeleted class=\"brandon h-red-text h-pointer\" ng-click=setupCtrl.removeOwner() ng-bind=\"'Remove Owner'|translate\"> </div> </div> <gmw-verification-step number=1 status=\"owner.hasCompletedPersonalDetails ? 'Complete' : 'Required'\" destination=\"{{$first ? 'setup.personal' : 'setup.add-owner'}}\" code=owner.code> <gmw-verification-step-description> <span class=\"mobile-only mobile-only--xs h-gold-text heading-h5 h-margin-bottom-5\" ng-bind=\"'Step 1'|translate\"> </span> <span class=\"heading-h4 h-dark-text h-margin-bottom-5\" ng-bind=\"'Personal Details'|translate\"> </span> <p class=h-medium-text ng-bind=\"'Please provide your current address and employment information.'|translate\"> </p> </gmw-verification-step-description> </gmw-verification-step> <gmw-verification-step number=2 status=\"(owner.hasCompletedSetup) ? 'Complete' : (owner.hasCompletedPersonalDetails ? 'Required' : 'Incomplete')\" destination=setup.documents.tutorial code=owner.code> <gmw-verification-step-description> <span class=\"mobile-only mobile-only--xs h-gold-text heading-h5 h-margin-bottom-5\" ng-bind=\"'Step 2'|translate\"> </span> <span class=\"heading-h4 h-dark-text h-margin-bottom-5\" ng-bind=\"'Identity and Residence Verification'|translate\"> </span> <p class=h-medium-text ng-bind=\"'You will need to provide your government issued ID as well as proof of residence documents such as recent utility bill in your name.'|translate\"> </p> </gmw-verification-step-description> </gmw-verification-step> </div> </div> </div> <footer class=\"gmw-flow-box-footer gmw-verification-extended-footer\"> <div class=gmw-flow-box-footer__col ng-if=\"setupCtrl.setupStatus.remainingOwners > 0 && !setupCtrl.addedOwner\"> <button class=\"medium-border-cta gmw-responsive-button\" type=button ng-if=\"setupCtrl.setupStatus.remainingOwners > 0 && !setupCtrl.addedOwner\" gmw-action=setupCtrl.addOwner() ng-bind=\"'Add Another Owner'|translate\"> </button> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" ng-disabled=!setupCtrl.setupStatus.hasCompletedSetup gmw-action=setupCtrl.complete() ng-bind=\"'Complete Setup'|translate\"> </button> </div> </footer> </div> <holding-setup-sidebar></holding-setup-sidebar> </div> </section> ";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SecurityQuestionsController.$inject = ['$scope', '$state', 'GmwSecurityQuestions', 'HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _securityQuestions = __webpack_require__(910);

var _securityQuestions2 = _interopRequireDefault(_securityQuestions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = 'SecurityQuestionsController';

angular.module('app.holding.dashboard.onboarding').controller(controller, SecurityQuestionsController);

exports.default = {
  template: _securityQuestions2.default,
  controller: controller,
  controllerAs: 'securityQuestionsCtrl'
};


function SecurityQuestionsController($scope, $state, GmwSecurityQuestions, HoldingUser) {
  'ngInject';

  var vm = this;
  vm.save = save;
  vm.skip = skip;
  vm.answers = [{}, {}, {}];

  function activate() {
    vm.user = HoldingUser.get();

    vm.canSkip = vm.user.loginFlags.setSecurityQuestionsRemainingSessions > 0;
    vm.remainingSessions = vm.user.loginFlags.setSecurityQuestionsRemainingSessions;

    GmwSecurityQuestions.getSecurityQuestions().then(function (questions) {
      vm.questions = questions;
    });
    $scope.$watch('securityQuestionsCtrl.answers', checkUnicity, true);
  }

  function checkUnicity() {
    var questions = uniq(vm.answers.map(function (_) {
      return _.question;
    }));
    var answers = uniq(vm.answers.map(function (_) {
      return _.answer;
    }));
    vm.form.$setValidity('uniqueQuestions', questions.length === vm.answers.length);
    vm.form.$setValidity('uniqueAnswers', answers.length === vm.answers.length);
  }

  function goToOverview() {
    return $state.go('holding.dashboard.overview', {}, { reload: true });
  }

  function save() {
    vm.form.$setSubmitted();
    if (vm.form.$valid) {
      return GmwSecurityQuestions.submitAnswers(vm.answers).then(goToOverview);
    }
    return undefined;
  }

  function skip() {
    return GmwSecurityQuestions.skip().then(goToOverview);
  }

  function uniq(items) {
    return Array.from(new Set(items));
  }

  activate();
}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "<section class=gmw-verification-wrapper> <div class=floating-sidebar-app-view> <div class=\"floating-sidebar-app-view__main gmw-verification-wrapper__main\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Security Questions'|translate\"></h2> <p class=gmw-flow-box__header-description translate> For added security we hold a set of security questions on file, which allows us to validate the ownership of a Holding. The answers will be requested should you contact us by telephone. Please choose and answer 3 security questions from the drop down boxes below. The answers must consist of 1 to 20 numbers and/or letters and no special characters, punctuation marks, or spaces are allowed. The answers are not case sensitive. </p> </header> <div class=\"gmw-flow-box-container gmw-verification-container gmw-verification-container--no-steps\"> <form name=securityQuestionsCtrl.form> <holding-alert-legacy class=error ng-if=\"securityQuestionsCtrl.form.$submitted && securityQuestionsCtrl.form.$error.uniqueQuestions\"> <span translate>Your selected questions must be unique</span> </holding-alert-legacy> <holding-alert-legacy class=error ng-if=\"securityQuestionsCtrl.form.$submitted && securityQuestionsCtrl.form.$error.uniqueAnswers\"> <span translate>Your answers must be unique</span> </holding-alert-legacy> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector class=gmw-input-container--split-half__col label=\"{{'Question 1'|translate}}\" options=securityQuestionsCtrl.questions ng-model=securityQuestionsCtrl.answers[0].question required> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container--split-half__col label-spacer placeholder=\"{{'Enter answer'|translate}}\" ng-model=securityQuestionsCtrl.answers[0].answer required> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector class=gmw-input-container--split-half__col label=\"{{'Question 2'|translate}}\" options=securityQuestionsCtrl.questions ng-model=securityQuestionsCtrl.answers[1].question required> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container--split-half__col label-spacer placeholder=\"{{'Enter answer'|translate}}\" ng-model=securityQuestionsCtrl.answers[1].answer required> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector class=gmw-input-container--split-half__col label=\"{{'Question 3'|translate}}\" options=securityQuestionsCtrl.questions ng-model=securityQuestionsCtrl.answers[2].question required> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container--split-half__col label-spacer placeholder=\"{{'Enter answer'|translate}}\" ng-model=securityQuestionsCtrl.answers[2].answer required> </gmw-box-input-simple> </div> </form> </div> <footer class=\"gmw-flow-box-footer gmw-verification-extended-footer\"> <div class=gmw-flow-box-footer__col ng-if=securityQuestionsCtrl.canSkip> <button class=medium-border-cta type=button ng-click=securityQuestionsCtrl.skip()> <span> <span ng-bind=\"'Skip for Now '|translate\"></span> <span ng-bind=\"'(' + securityQuestionsCtrl.remainingSessions + ' Remaining Sign-Ins)'\"></span> </span> </button> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=securityQuestionsCtrl.save()> <span ng-bind=\"'Save'|translate\"></span> </button> </div> </footer> </div> <holding-setup-sidebar></holding-setup-sidebar> </div> </section> ";

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _addOwner = __webpack_require__(912);

var _addOwner2 = _interopRequireDefault(_addOwner);

var _addOwnerPersonalInfo = __webpack_require__(914);

var _addOwnerPersonalInfo2 = _interopRequireDefault(_addOwnerPersonalInfo);

var _addOwnerStep = __webpack_require__(915);

var _addOwnerStep2 = _interopRequireDefault(_addOwnerStep);

var _addOwnerStep3 = __webpack_require__(916);

var _addOwnerStep4 = _interopRequireDefault(_addOwnerStep3);

var _addOwnerStep5 = __webpack_require__(917);

var _addOwnerStep6 = _interopRequireDefault(_addOwnerStep5);

var _review = __webpack_require__(918);

var _review2 = _interopRequireDefault(_review);

var _addOwnerFlow = __webpack_require__(919);

var _addOwnerFlow2 = _interopRequireDefault(_addOwnerFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var params = {
  hideFooter: true,
  noMobileCompoents: true
};

angular.module('app.holding.dashboard.onboarding').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('setup.add-owner', {
    url: '/add-owner',
    views: { '': _addOwner2.default },
    data: {
      flow: _addOwnerFlow2.default,
      skipSetupCheck: true
    },
    params: params
  }).state('setup.add-owner.personal-info', {
    url: '/personal-info',
    template: _addOwnerPersonalInfo2.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  }).state('setup.add-owner.step1', {
    url: '/step-1',
    template: _addOwnerStep2.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  }).state('setup.add-owner.step2', {
    url: '/step-2',
    template: _addOwnerStep4.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  }).state('setup.add-owner.step3', {
    url: '/step-3',
    template: _addOwnerStep6.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  }).state('setup.add-owner.review', {
    url: '/review',
    template: _review2.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  });

  $urlRouterProvider.when('/setup/add-owner', '/setup/add-owner/personal-info');
}]);

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddOwnerController.$inject = ['$controller', '$scope', '$state', 'HoldingCountries', 'HoldingSettings', 'GmwSetup'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _addOwner = __webpack_require__(913);

var _addOwner2 = _interopRequireDefault(_addOwner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = 'AddOwnerController';

angular.module('app.holding.dashboard.onboarding').controller(controller, AddOwnerController);

exports.default = {
  template: _addOwner2.default,
  controller: controller,
  controllerAs: 'addOwnerCtrl'
};


function AddOwnerController($controller, $scope, $state, HoldingCountries, HoldingSettings, GmwSetup) {
  'ngInject';

  var vm = this;
  vm.countries = HoldingCountries.getAllForSelector();
  vm.model = {
    contactInfo: {
      line2: '',
      phone: {}
    },
    details: {
      employment: {},
      sourceOfFunds: {},
      personalDetails: {
        name: {
          title: 'Mr'
        },
        gender: 'N'
      }
    }
  };
  vm.sameAddress = true;
  vm.shouldShowFatca = shouldShowFatca;
  vm.steps = {
    'setup.add-owner.step1': {
      checks: [{
        function: checkPersonalInfo,
        revertTo: 'setup.add-owner.personal-info'
      }]
    },
    'setup.add-owner.step2': {
      checks: [{
        function: checkAddress,
        revertTo: 'setup.add-owner.step1'
      }]
    },
    'setup.add-owner.step3': {
      checks: [{
        function: checkSource,
        revertTo: 'setup.add-owner.step2'
      }]
    },
    'setup.add-owner.review': {
      checks: [{
        function: checkEmployer,
        revertTo: 'setup.add-owner.step3'
      }],
      next: submit
    }
  };

  activate();

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    HoldingSettings.getProfile().then(function (_ref) {
      var profiles = _ref.profiles;

      vm.primaryProfile = profiles[0];
      $scope.$watch('addOwnerCtrl.sameAddress', function (sameAddress) {
        if (sameAddress) {
          useDefaultAddress();
        } else {
          vm.model.contactInfo.country = null;
          vm.model.contactInfo.line1 = null;
          vm.model.contactInfo.line2 = '';
          vm.model.contactInfo.city = null;
          vm.model.contactInfo.province = null;
          vm.model.contactInfo.residenceYears = null;
          vm.model.contactInfo.zip = null;
        }
      });
    });

    $scope.$watch('addOwnerCtrl.model.contactInfo.country', function (country) {
      vm.model.countryOfResidence = country;
    });
  }

  function checkAddress() {
    return !!vm.model.contactInfo.line1;
  }

  function checkEmployer() {
    return !!vm.model.details.employment.status;
  }

  function checkPersonalInfo() {
    return !!vm.model.details.personalDetails.name.firstName;
  }

  function checkSource() {
    return !!vm.model.details.sourceOfFunds.type;
  }

  function shouldShowFatca(nationality) {
    return [vm.model.details.personalDetails.countryOfNationality, vm.model.details.personalDetails.countryOfSecondNationality, vm.model.contactInfo.country].indexOf(nationality) === -1;
  }

  function submit() {
    switch (vm.model.details.employment.status) {
      case 'Employed':
      case 'SelfEmployed':
      case 'Retired':
      case 'Unemployed':
        vm.model.details.employment.nature = 'Title: ' + vm.model.details.employment.title + '\nSalary: ' + vm.model.details.employment.salary + '\nOther Notes: ' + vm.model.details.employment.nature;
        break;
      case 'Student':
        vm.model.details.employment.nature = 'School: ' + vm.model.details.employment.schoolName + '\nProgram: ' + vm.model.details.employment.schoolProgram + '\nPart-Time Job: ' + vm.model.details.employment.studentPartTime + (vm.model.details.employment.studentPartTime ? '\nTitle: ' + vm.model.details.employment.title + '\nSalary: ' + vm.model.details.employment.salary : '') + '\nOther Notes: ' + vm.model.details.employment.nature;
        if (!vm.model.details.employment.studentPartTime) {
          vm.model.details.employment.name = '';
          vm.model.details.employment.period = 0;
          vm.model.details.employment.address = '';
        }
        break;
      case 'Homemaker':
      case 'Other':
        vm.model.details.employment.name = '';
        vm.model.details.employment.period = 0;
        vm.model.details.employment.address = '';
    }
    return GmwSetup.addOwner(vm.model).then(function () {
      return $state.go('setup', {}, { reload: true });
    });
  }

  function useDefaultAddress() {
    vm.model.contactInfo.country = vm.primaryProfile.address.countryCC2;
    vm.model.contactInfo.line1 = vm.primaryProfile.address.line1;
    vm.model.contactInfo.line2 = vm.primaryProfile.address.line2;
    vm.model.contactInfo.city = vm.primaryProfile.address.city;
    vm.model.contactInfo.province = vm.primaryProfile.address.state;
    vm.model.contactInfo.residenceYears = vm.primaryProfile.address.residenceYears;
    vm.model.contactInfo.zip = vm.primaryProfile.address.zip;
  }
}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=gmw-verification-flow-container> <div class=\"gmw-verification-flow-container__main gmw-flow-box gmw-flow-box--fluid\" ui-view> </div> <div class=gmw-verification-flow-container__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I complete online verification?'|translate}}\" holding-external-link=support.onboarding.documents> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What can I do while my Holding is unverified?'|translate}}\" holding-external-link=support.onboarding.unverified> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'Can I have a joint Holding?'|translate}}\" holding-external-link=support.onboarding.joint> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What is \\'residency\\'?'|translate}}\" holding-external-link=support.onboarding.residency> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> <holding-live-chat-cta class=h-margin-bottom-50></holding-live-chat-cta> </div> </section> ";

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please confirm your residential address. You will later be asked to upload a utility bill or other proof of residence document for this address, so please ensure this is your residential home rather than a mailing or postal address.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=addOwnerCtrl.form novalidate> <div class=gmw-verification-split-form> <div class=gmw-verification-split-form__col> <gmw-title-toggle title=addOwnerCtrl.model.details.personalDetails.name.title> </gmw-title-toggle> <gmw-box-input-simple class=gmw-input-container placeholder=\"{{'First name'|translate}}\" ng-model=addOwnerCtrl.model.details.personalDetails.name.firstName required maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container placeholder=\"{{'Last name'|translate}}\" ng-model=addOwnerCtrl.model.details.personalDetails.name.lastName required maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container placeholder=\"{{'Middle name(s)'|translate}}\" ng-model=addOwnerCtrl.model.details.personalDetails.name.middleName maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container placeholder=\"{{'Former name(s)'|translate}}\" ng-model=addOwnerCtrl.model.details.personalDetails.name.formerName maxlength=100> </gmw-box-input-simple> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" translate> Date of Birth </label> <gmw-date-selector name=date required date-of-birth ng-model=addOwnerCtrl.model.details.personalDetails.dateOfBirth> </gmw-date-selector> </div> </div> <div class=gmw-verification-split-form__col> <gmw-box-phone-selector name=phone required ng-model=addOwnerCtrl.model.contactInfo.phone column=true> </gmw-box-phone-selector> <gmw-box-selector required name=countryOfBirth class=gmw-input-container ng-model=addOwnerCtrl.model.details.personalDetails.countryOfBirth label=\"{{'Birthplace'|translate}}\" placeholder=\"{{'Country of birth'|translate}}\" no-label=true options=addOwnerCtrl.countries> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container placeholder=\"{{'City of birth'|translate}}\" ng-model=addOwnerCtrl.model.details.personalDetails.cityOfBirth required maxlength=50> </gmw-box-input-simple> <gmw-box-selector required name=countryOfNationality class=gmw-input-container ng-model=addOwnerCtrl.model.details.personalDetails.countryOfNationality placeholder=\"{{'Country of nationality'|translate}}\" label=\"{{'Nationality'|translate}}\" no-label=true options=addOwnerCtrl.countries> </gmw-box-selector> <gmw-box-selector name=secondaryNationality class=gmw-input-containe ng-model=addOwnerCtrl.model.details.personalDetails.countryOfSecondNationality placeholder=\"{{'Secondary nationality (optional)'|translate}}\" no-label=true options=addOwnerCtrl.countries> </gmw-box-selector> </div> </div> <holding-augur name=hid ng-model=addOwnerCtrl.model.deviceFingerprint> </holding-augur> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button ui-sref=verification class=\"medium-border-cta gmw-responsive-button mobile-only mobile-only--xxs\"> Skip Step </button> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=addOwnerCtrl.next()> Next Step </button> </div> </footer> ";

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please provide the following details about yourself so that we can verify your Holding'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=addOwnerCtrl.form novalidate> <div class=gmw-verification-split-form> <div class=gmw-verification-split-form__col> <div class=gmw-flow-box__callout> <gmw-checkbox ng-model=addOwnerCtrl.sameAddress> <span class=\"h-dark-text h-medium-text h-bold-text\" translate> Same address as Holding Owner </span> </gmw-checkbox> </div> <gmw-contact-info-form contact-info=addOwnerCtrl.model.contactInfo ng-if=!addOwnerCtrl.sameAddress> </gmw-contact-info-form> </div> <div class=gmw-verification-split-form__col> <gmw-fatca-selector ng-model=addOwnerCtrl.model.details.fatcaPassport us-label=\"{{'Have you ever held a US Passport?'|translate}}\" uk-label=\"{{'Have you ever held a UK Passport?'|translate}}\" nationalities=\"[\n            addOwnerCtrl.model.details.personalDetails.countryOfNationality,\n            addOwnerCtrl.model.details.personalDetails.countryOfSecondNationality,\n            addOwnerCtrl.model.contactInfo.country,\n          ]\"> <span ng-if=\"!$parent.nationalities.includes('US') && !$parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a passport in one of the following countries?'|translate\"> </span> <span ng-if=\"$parent.nationalities.includes('US') || $parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a passport in the following country?'|translate\"> </span> </gmw-fatca-selector> <gmw-fatca-selector ng-model=addOwnerCtrl.model.details.fatcaWork us-label=\"{{'Have you ever held a work permit in the USA?'|translate}}\" uk-label=\"{{'Have you ever held a work permit in the UK?'|translate}}\" nationalities=\"[\n            addOwnerCtrl.model.details.personalDetails.countryOfNationality,\n            addOwnerCtrl.model.details.personalDetails.countryOfSecondNationality,\n            addOwnerCtrl.model.contactInfo.country,\n          ]\"> <span ng-if=\"!$parent.nationalities.includes('US') && !$parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a work permit in one of the following countries?'|translate\"> </span> <span ng-if=\"$parent.nationalities.includes('US') || $parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a work permit in the following country?'|translate\"> </span> </gmw-fatca-selector> </div> </div> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button ui-sref=verification class=\"medium-border-cta gmw-responsive-button mobile-only mobile-only--xxs\"> Skip Step </button> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=addOwnerCtrl.next()> Next Step </button> </div> </footer> ";

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please provide the following details about yourself so that we can verify your Holding'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=addOwnerCtrl.form novalidate> <gmw-source-of-funds ng-model=addOwnerCtrl.model.details.sourceOfFunds label=\"{{'Source of funds'|translate}}\"> </gmw-source-of-funds> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button ui-sref=verification class=\"medium-border-cta gmw-responsive-button mobile-only mobile-only--xxs\"> Skip Step </button> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=addOwnerCtrl.next()> Next Step </button> </div> </footer> ";

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please confirm your employment status and details of your employment. This helps us to know our Clients better.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=addOwnerCtrl.form novalidate> <gmw-employment-selector employment=addOwnerCtrl.model.details.employment> </gmw-employment-selector> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button ui-sref=verification class=\"medium-border-cta gmw-responsive-button mobile-only mobile-only--xxs\"> Skip Step </button> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=addOwnerCtrl.next()> Next Step </button> </div> </footer> ";

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container> <div class=gmw-verification-review> <div class=gmw-verification-review__row> <div class=\"gmw-verification-review__col gmw-verification-review__col--label\" ng-bind=\"'Name'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\"> <span ng-bind=addOwnerCtrl.model.details.personalDetails.name.title></span>. <span ng-bind=addOwnerCtrl.model.details.personalDetails.name.firstName></span> <span ng-bind=addOwnerCtrl.model.details.personalDetails.name.middleName></span> <span ng-bind=addOwnerCtrl.model.details.personalDetails.name.lastName></span> <span ng-if=addOwnerCtrl.model.details.personalDetails.name.formerName> (<span ng-bind=addOwnerCtrl.model.details.personalDetails.name.formerName></span>) </span> </div> <div class=\"gmw-verification-review__col gmw-verification-review__col--modify\"> <a class=h-blue-link ng-bind=\"'Modify'|translate\" ui-sref=setup.add-owner.personal-info> </a> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Gender'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=addOwnerCtrl.model.details.personalDetails.gender> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Date of Birth'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=addOwnerCtrl.model.details.personalDetails.dateOfBirth> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'City and Country of Birth'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\"> <span ng-bind=addOwnerCtrl.model.details.personalDetails.cityOfBirth></span>, <span ng-bind=addOwnerCtrl.model.details.personalDetails.countryOfBirth|holdingCountryName></span> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Country of nationality'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=addOwnerCtrl.model.details.personalDetails.countryOfNationality|holdingCountryName> </div> </div> <div class=gmw-verification-review__row ng-if=addOwnerCtrl.model.details.personalDetails.countryOfSecondNationality> <div class=gmw-verification-review__col ng-bind=\"'Country of second nationality'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=addOwnerCtrl.model.details.personalDetails.countryOfSecondNationality|holdingCountryName> </div> </div> <gmw-review-row label=\"{{'Current employment information'|translate}}\" modify=setup.add-owner.step3> {{addOwnerCtrl.model.details.employment.status|translate}} </gmw-review-row> <div class=gmw-verification-review__separator></div> <gmw-review-row label=\"{{'Have you ever held a passport in the United Kingdom?'|translate}}\" ng-if=\"addOwnerCtrl.shouldShowFatca('GB')\" modify=setup.add-owner.step1> <span ng-if=\"addOwnerCtrl.model.details.fatcaPassport.indexOf('GB') === -1\" translate> No </span> <span ng-if=\"addOwnerCtrl.model.details.fatcaPassport.indexOf('GB') !== -1\" translate> Yes </span> </gmw-review-row> <gmw-review-row label=\"{{'Have you ever held a passport in the United States?'|translate}}\" ng-if=\"addOwnerCtrl.shouldShowFatca('US')\" modify=setup.add-owner.step1> <span ng-if=\"addOwnerCtrl.model.details.fatcaPassport.indexOf('US') === -1\" translate> No </span> <span ng-if=\"addOwnerCtrl.model.details.fatcaPassport.indexOf('US') !== -1\" translate> Yes </span> </gmw-review-row> <gmw-review-row label=\"{{'Have you ever held a work permit in the United Kingdom?'|translate}}\" ng-if=\"addOwnerCtrl.shouldShowFatca('GB')\"> <span ng-if=\"addOwnerCtrl.model.details.fatcaWork.indexOf('GB') === -1\" translate> No </span> <span ng-if=\"addOwnerCtrl.model.details.fatcaWork.indexOf('GB') !== -1\" translate> Yes </span> </gmw-review-row> <gmw-review-row label=\"{{'Have you ever held a work permit in the United States?'|translate}}\" ng-if=\"addOwnerCtrl.shouldShowFatca('US')\"> <span ng-if=\"addOwnerCtrl.model.details.fatcaWork.indexOf('US') === -1\" translate> No </span> <span ng-if=\"addOwnerCtrl.model.details.fatcaWork.indexOf('US') !== -1\" translate> Yes </span> </gmw-review-row> <div class=gmw-verification-review__separator></div> <gmw-review-row label=\"{{'Country of residence'|translate}}\" modify=setup.add-owner.step1> {{addOwnerCtrl.model.contactInfo.country|holdingCountryName}} </gmw-review-row> <gmw-review-row label=\"{{'Address 1'|translate}}\"> {{addOwnerCtrl.model.contactInfo.line1}} </gmw-review-row> <gmw-review-row label=\"{{'Address 2'|translate}}\"> {{addOwnerCtrl.model.contactInfo.line2}} </gmw-review-row> <gmw-review-row label=\"{{'City'|translate}}\"> {{addOwnerCtrl.model.contactInfo.city}} </gmw-review-row> <gmw-review-row label=\"{{'Post code'|translate}}\"> {{addOwnerCtrl.model.contactInfo.zip}} </gmw-review-row> <gmw-review-row label=\"{{'Number of years at this address'|translate}}\"> <span translate>{{addOwnerCtrl.model.contactInfo.residenceYears}} years</span> </gmw-review-row> <gmw-review-row label=\"{{'Telephone number'|translate}}\"> +{{addOwnerCtrl.model.contactInfo.phone.prefix}} {{addOwnerCtrl.model.contactInfo.phone.number}} </gmw-review-row> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=addOwnerCtrl.next() translate> Complete </button> </div> </footer> ";

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Secondary Owner'),
    steps: [{
        key: 'personal-info',
        state: 'setup.add-owner.personal-info',
        heading: (0, _gettext2.default)('Personal Details'),
        label: (0, _gettext2.default)('Personal Info'),
        returnTo: 'setup',
        keepStateOnPrev: true
    }, {
        key: 'step1',
        state: 'setup.add-owner.step1',
        heading: (0, _gettext2.default)('Personal Details'),
        label: (0, _gettext2.default)('Current Address'),
        keepStateOnPrev: true
    }, {
        key: 'step2',
        state: 'setup.add-owner.step2',
        heading: (0, _gettext2.default)('Source of Funds'),
        label: (0, _gettext2.default)('Source of Funds')
    }, {
        key: 'step3',
        state: 'setup.add-owner.step3',
        heading: (0, _gettext2.default)('Employment Status'),
        label: (0, _gettext2.default)('Employment Status')
    }, {
        key: 'review',
        state: 'setup.add-owner.review',
        heading: (0, _gettext2.default)('Review & Confirm Information'),
        label: (0, _gettext2.default)('Review')
    }, {
        key: 'complete',
        state: 'setup.add-owner.complete',
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _documents = __webpack_require__(921);

var _documents2 = _interopRequireDefault(_documents);

var _netverify = __webpack_require__(923);

var _netverify2 = _interopRequireDefault(_netverify);

var _tutorial = __webpack_require__(925);

var _tutorial2 = _interopRequireDefault(_tutorial);

var _flow = __webpack_require__(926);

var _flow2 = _interopRequireDefault(_flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var params = {
  hideFooter: true,
  noMobileCompoents: true,
  heroNoMobileActionTabs: true
};

angular.module('app.holding.dashboard.onboarding').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('setup.documents', {
    url: '/documents/{code:int}',
    views: { '': _documents2.default },
    data: {
      flow: _flow2.default,
      skipSetupCheck: true
    },
    params: params,
    skipSetupCheck: true,
    resolve: _documents2.default.resolve
  }).state('setup.documents.tutorial', {
    url: '/tutorial',
    template: _tutorial2.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  }).state('setup.documents.id', {
    url: '/id',
    component: _netverify2.default,
    params: params,
    data: {
      skipSetupCheck: true
    }
  });

  $urlRouterProvider.when('/setup/documents', '/setup/documents/tutorial');
}]);

__webpack_require__(927);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


getEntityData.$inject = ['$stateParams', 'GmwSetup'];
DocumentsController.$inject = ['$controller', '$q', '$scope', '$state', '$stateParams', 'GmwSetup', 'HoldingSettings', 'entityData'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _documents = __webpack_require__(922);

var _documents2 = _interopRequireDefault(_documents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = 'DocumentsController';

angular.module('app.holding.dashboard.onboarding').controller(controller, DocumentsController);

exports.default = {
  template: _documents2.default,
  controller: controller,
  controllerAs: 'documentsCtrl',
  resolve: {
    entityData: getEntityData
  }
};


function getEntityData($stateParams, GmwSetup) {
  'ngInject';

  return GmwSetup.getSetupStatus(true).then(function (setupData) {
    return setupData.entities.find(function (entity) {
      return entity.code === $stateParams.code;
    });
  });
}

function DocumentsController($controller, $q, $scope, $state, $stateParams, GmwSetup, HoldingSettings, entityData) {
  'ngInject';

  var vm = this;
  vm.entityData = entityData;

  var code = parseInt($stateParams.code, 10);

  vm.idData = {
    code: code,
    metadata: {
      type: 'PhotoIdFull',
      value: {}
    }
  };

  vm.onIdUpload = onIdUpload;

  vm.steps = {
    'setup.documents.tutorial': {
      checks: [{
        function: shouldUploadId,
        revertTo: 'setup.documents.residence'
      }]
    },
    'setup.documents.id': {
      checks: [{
        function: shouldUploadId,
        revertTo: 'setup.documents.residence'
      }]
    },
    'setup.documents.residence': {
      checks: [{
        function: hasUploadedId,
        revertTo: 'setup.documents.id'
      }, {
        function: shouldUploadedPor,
        revertTo: 'setup'
      }]
    }
  };

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });

    HoldingSettings.getProfile().then(function (_ref) {
      var profiles = _ref.profiles;

      var profile = profiles.find(function (_) {
        return _.code === code;
      });
      vm.idData.metadata.value.issuingCountry = profile.countryCC2;
    });
  }

  function hasUploadedId() {
    return vm.entityData.hasUploadedId;
  }

  function isDocument(document) {
    return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document !== null && 'size' in document;
  }

  function onIdUpload() {
    vm.entityData.hasUploadedId = true;
    vm.next();
  }

  function shouldUploadId() {
    return !vm.entityData.hasUploadedId;
  }

  function shouldUploadedPor() {
    return !vm.entityData.hasUploadedPOA;
  }

  activate();
}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=gmw-verification-flow-container> <div class=\"gmw-verification-flow-container__main gmw-flow-box gmw-flow-box--fluid\" ui-view on-complete=documentsCtrl.onIdUpload()> </div> <div class=gmw-verification-flow-container__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I complete online verification?'|translate}}\" holding-external-link=support.onboarding.documents> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What photographic identification documents do you accept?'|translate}}\" holding-external-link=support.onboarding.id> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What documents do you accept as proof of residence?'|translate}}\" holding-external-link=support.onboarding.por> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What is \\'residency\\'?'|translate}}\" holding-external-link=support.onboarding.residency> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> <holding-live-chat-cta class=h-margin-bottom-50></holding-live-chat-cta> </div> </section> ";

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _netverify = __webpack_require__(924);

var _netverify2 = _interopRequireDefault(_netverify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SetupNetverifyController = function () {
    function SetupNetverifyController($stateParams, GmwNetVerify, GmwModal, gettextCatalog) {
        var _this = this;

        _classCallCheck(this, SetupNetverifyController);

        this.$stateParams = $stateParams;
        this.GmwNetVerify = GmwNetVerify;
        this.GmwModal = GmwModal;
        this.gettextCatalog = gettextCatalog;
        this.$onInit = function () {
            _this.init(true);
        };
        this.$onDestroy = function () {
            _this.GmwNetVerify.tearDown();
        };
        this.retry = function () {
            _this.init(true);
        };
        this.upload = function () {
            var confirmationPrompt = _this.gettextCatalog.getString('Uploading an ID rather than using a camera to capture can lead to longer review and verification times. Proceed?');
            _this.GmwModal.showConfirmationModal(confirmationPrompt).then(function () {
                _this.init(false);
            });
        };
    }

    _createClass(SetupNetverifyController, [{
        key: 'init',
        value: function init(requireWebcam) {
            var _this2 = this;

            this.error = undefined;
            this.isUpload = !requireWebcam;
            this.GmwNetVerify.init(this.$stateParams.code, requireWebcam).then(function (_ref) {
                var url = _ref.url,
                    promise = _ref.promise;

                _this2.iframeSrc = url;
                promise.then(function () {
                    _this2.onComplete();
                }).catch(function (errorCode) {
                    _this2.error = errorCode;
                });
            });
        }
    }]);

    return SetupNetverifyController;
}();

SetupNetverifyController.$inject = ['$stateParams', 'GmwNetVerify', 'GmwModal', 'gettextCatalog'];
var Eid = {
    bindings: {
        onComplete: '&'
    },
    controller: SetupNetverifyController,
    template: _netverify2.default
};
var componentName = 'gmwSetupNetverify';
angular.module('app.holding.dashboard.onboarding').component(componentName, Eid);
exports.default = componentName;

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-if=!$ctrl.isUpload ng-bind=\"::('Please ensure that you are using a device that has an enabled camera, and when prompted, grant our site permission to access your camera.'|translate)\"> </p> <p class=gmw-flow-box__header-description ng-if=$ctrl.isUpload ng-bind=\"::('Please choose the ID document type below that you will be uploading for our review.'|translate)\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=success ng-if=$ctrl.success> <span translate>The ID document upload was successful. We will be reviewing your documents and will be in touch to continue your Holding verification.</span> </holding-alert-legacy> <div ng-show=!$ctrl.error id=JUMIOIFRAME class=gmw-netverify-container> <iframe ng-src=\"{{$ctrl.iframeSrc}}\" allow=camera;fullscreen;accelerometer;gyroscope;magnetometer allowfullscreen></iframe> </div> <div ng-show=$ctrl.error ng-switch=$ctrl.error> <div ng-switch-when=9820> <holding-alert-legacy class=warning> <span translate>No Camera or Camera is Blocked</span> </holding-alert-legacy> <p class=\"gmw-flow-box__description gmw-flow-box__description--margin-10\" translate> It appears that you either do not have a compatible camera, or your have blocked our access to the camera. To ensure the fastest possible review time, we suggest that you: </p> <ul class=\"gmw-basic-list gmw-flow-box__description-list\"> <li class=\"gmw-basic-list__item h-medium-text\"> If applicable, change your browser permissions to allow access to your camera, or; </li> <li class=\"gmw-basic-list__item h-medium-text\"> Retry this ID verification step from a device with an enabled camera. </li> </ul> <p class=gmw-flow-box__description translate> Alternatively, you can proceed with uploading your ID but verification times will unfortunately be longer and may require you to go through our offline verification process. </p> </div> <div ng-switch-when=9835> <holding-alert-legacy class=warning> <span translate>ID Verification Failed - Please Try Again</span> </holding-alert-legacy> <p class=\"gmw-flow-box__description gmw-flow-box__description--margin-10\" translate> Unfortunately our systems have not been able to verify your ID document. Please retry verification, ensuring: </p> <ul class=\"gmw-basic-list gmw-flow-box__description-list\"> <li class=\"gmw-basic-list__item h-medium-text\"> The boundaries of your ID are fully contained in the image that you are capturing, and; </li> <li class=\"gmw-basic-list__item h-medium-text\"> That your 'selfie' image does not contain any other people or objects other than your face. </li> </ul> <br> <p class=gmw-flow-box__description translate> In addition to the above suggestions, our video tutorial has some important tips on how to present your ID to ensure that it can be properly processed by our systems: </p> <div class=gmw-verification-flow-container__video> <iframe src=\"https://www.youtube-nocookie.com/embed/0ftTYbLaU0g?autoplay=0&modestbranding=1&rel=0\" frameborder=0 allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> </div> <br><br> <p class=gmw-flow-box__description translate> Alternatively, if you are unable to pass the ID verification after many repeated attempts, you can proceed with uploading your ID. Please not that this will unfortunately result in longer verification times and may require you to go through our offline verification process. </p> </div> <div ng-switch-when=unknown> <holding-alert-legacy class=error> <span translate>An error occurred during ID verification. Please try again.</span> </holding-alert-legacy> </div> <div ng-switch-default> <holding-alert-legacy class=warning> <span translate>ID verification was not successful. Error: {{$ctrl.error}}</span> </holding-alert-legacy> </div> </div> </div> <footer ng-show=!$ctrl.error class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col></div> </footer> <footer ng-show=$ctrl.error class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" gmw-action=$ctrl.upload()> <span translate>Upload Your ID for Review</span> </button> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=$ctrl.retry()> <span translate>Retry ID Verification</span> </button> </div> </footer> ";

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'To verify your identity, you\\'ll need to complete Identity Verification using Jumio Netverify in the next step.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=info> <span ng-bind=\"'iPhone and iPad users, please note that our Identity Verification system requires you to be running iOS 12 or greater.'|translate\"></span> </holding-alert-legacy> <div class=gmw-verification-flow-container__video> <iframe src=\"https://www.youtube-nocookie.com/embed/0ftTYbLaU0g?autoplay=1&modestbranding=1&rel=0\" frameborder=0 allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=documentsCtrl.next() ng-bind=\"'Start ID Verification'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('ID and Residence Verification'),
    steps: [{
        key: 'tutorial',
        state: 'setup.documents.tutorial',
        heading: (0, _gettext2.default)('Verifying Your Identity with Jumio'),
        label: (0, _gettext2.default)('Jumio Tutorial'),
        returnTo: 'setup'
    }, {
        key: 'netverify',
        state: 'setup.documents.id',
        heading: (0, _gettext2.default)('Verify Your Identity'),
        label: (0, _gettext2.default)('Verify Identity'),
        keepStateOnPrev: true
    }, {
        key: 'upload-poa',
        state: 'setup.documents.residence',
        heading: (0, _gettext2.default)('Upload Proof of Residence'),
        label: (0, _gettext2.default)('Upload Proof of Residence')
    }, {
        key: 'complete',
        state: 'setup.complete',
        label: (0, _gettext2.default)('Complete')
    }]
};
exports.default = flow;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProofOfResidenceController.$inject = ['$scope', '$q', '$state', '$stateParams', 'HoldingSettings', 'GmwSetup'];
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _residence = __webpack_require__(928);

var _residence2 = _interopRequireDefault(_residence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateConfig = {
  controller: 'ProofOfResidenceController',
  controllerAs: 'porCtrl',
  data: {
    heroNoMobileActionTabs: true,
    hideFooter: true,
    noMobileCompoents: true,
    skipSetupCheck: true
  },
  template: _residence2.default,
  url: '/residence'
};

angular.module('app.holding.dashboard.onboarding').controller(stateConfig.controller, ProofOfResidenceController).config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('setup.documents.residence', stateConfig);
}]);

function ProofOfResidenceController($scope, $q, $state, $stateParams, HoldingSettings, GmwSetup) {
  'ngInject';

  var code = parseInt($stateParams.code, 10);
  var vm = this;

  vm.dateLimit = (0, _moment2.default)().subtract(90, 'd');

  vm.fileUploadConfig = {
    extensions: ['.pdf', '.png', '.gif', '.jpg', '.jpeg'],
    maxFiles: 1,
    maxSize: '8000000'
  };

  vm.model = {
    porData: {
      code: code,
      metadata: {
        type: 'Generic',
        value: {
          uploadType: 'ProofOfResidence'
        }
      }
    }
  };

  vm.uploadPor = uploadPor;

  function isDocument(document) {
    return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document !== null && 'size' in document;
  }

  function porSelected(newPoaDoc) {
    if (newPoaDoc) {
      if (vm.form) {
        vm.form.$setValidity('invalidDocument', newPoaDoc && isDocument(newPoaDoc[0]));
      }
    }
  }

  function uploadPor() {
    vm.porError = null;
    return GmwSetup.uploadPor(vm.model.por, vm.model.porData).then(function () {
      $state.go('setup', {}, {
        reload: true
      });
    }).catch(function (error) {
      vm.porError = error.message;
      return $q.reject(error);
    });
  }

  $scope.$watch(function () {
    return vm.model.por;
  }, porSelected);
}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please ensure your document meets the criteria and is on the list below of acceptable residence documents.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=porCtrl.form> <div class=gmw-verification-flow-container__small-inner> <holding-alert-legacy class=info> <span ng-bind=\"'It is critical that the uploaded document clearly displays the date of issuance, and that the date is within the last 90 days.'|translate\"></span> </holding-alert-legacy> <div class=gmw-verification-requirements ng-if=\"!(porCtrl.model.por && porCtrl.model.por.length)\"> <div> <div class=gmw-verification-requirements__title ng-bind=\"'Document Criteria'|translate\"> </div> <ul class=gmw-verification-requirements__list> <li> <span ng-bind=\"'Must be a scan/picture of original document - online statements or screenshots are not accepted'|translate\"></span> </li> <li> <span ng-bind=\"'Must be clearly legible'|translate\"></span> </li> <li> <span ng-bind=\"'Must show your full name and address'|translate\"></span> </li> <li> <span ng-bind=\"'Must show the issuance date'|translate\"></span> </li> <li> <span ng-bind=\"'Must have been issued in the last 90 days'|translate\"></span> </li> </ul> </div> <div> <div class=gmw-verification-requirements__title ng-bind=\"'Accepted Documents'|translate\"> </div> <ul class=gmw-verification-requirements__list> <li> <span ng-bind=\"'Utility bill for fixed services'|translate\"></span> </li> <li> <span ng-bind=\"'Bank account statement (no credit cards)'|translate\"></span> </li> <li> <span ng-bind=\"'Personal tax assessment'|translate\"></span> </li> <a holding-external-link=support.onboarding.por class=\"gmw-verification-requirements__link h-blue-link\" ng-bind=\"'See full list'|translate\"> </a> </ul> </div> </div> <holding-file-upload hide-when-selected=true ng-model=porCtrl.model.por required document-config=porCtrl.fileUploadConfig> </holding-file-upload> <gmw-date-selector name=dateOfIssuance label=\"Issuance Date - Must be in last 90 days\" date-limit=porCtrl.dateLimit ng-model=porCtrl.model.dateOfIssuance required> </gmw-date-selector> <div class=\"gmw-input-container gmw-flow-box__callout\"> <gmw-checkbox ng-model=porCtrl.model.agreePorCriteria name=agreePorCriteria required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read the proof of residence document criteria above, and certify that the submitted document meets these requirements.'|translate\"></span> </span> </gmw-checkbox> </div> <div ng-show=porCtrl.form.$invalid ng-messages=porCtrl.form.$error> <div ng-message=dateLimit> <holding-alert-legacy class=error> <span ng-bind=\"'The date of issuance must be within the last 90 days.'|translate\"></span> </holding-alert-legacy> </div> <div ng-message=invalidDocument> <holding-alert-legacy class=error> <span ng-bind=\"'Please select a document to upload.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=error ng-if=porCtrl.porError> <span ng-bind=porCtrl.porError></span> </holding-alert-legacy> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=porCtrl.uploadPor() holding-button-disabled=porCtrl.form.$invalid ng-bind=\"'Complete'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _personalInfo = __webpack_require__(930);

var _personalInfo2 = _interopRequireDefault(_personalInfo);

var _personalStep = __webpack_require__(932);

var _personalStep2 = _interopRequireDefault(_personalStep);

var _personalStep3 = __webpack_require__(933);

var _personalStep4 = _interopRequireDefault(_personalStep3);

var _personalStep5 = __webpack_require__(934);

var _personalStep6 = _interopRequireDefault(_personalStep5);

var _review = __webpack_require__(935);

var _review2 = _interopRequireDefault(_review);

var _personalInfoFlow = __webpack_require__(936);

var _personalInfoFlow2 = _interopRequireDefault(_personalInfoFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.onboarding').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('setup.personal', {
    data: {
      flow: _personalInfoFlow2.default,
      heroNoMobileActionTabs: true,
      hideFooter: true,
      noMobileCompoents: true,
      skipSetupCheck: true
    },
    url: '/personal',
    views: {
      '': _personalInfo2.default
    }
  }).state('setup.personal.step1', {
    data: {
      heroNoMobileActionTabs: true,
      hideFooter: true,
      noMobileCompoents: true,
      skipSetupCheck: true
    },
    template: _personalStep2.default,
    url: '/step-1'
  }).state('setup.personal.step2', {
    data: {
      heroNoMobileActionTabs: true,
      hideFooter: true,
      noMobileCompoents: true,
      skipSetupCheck: true
    },
    template: _personalStep4.default,
    url: '/step-2'
  }).state('setup.personal.step3', {
    data: {
      heroNoMobileActionTabs: true,
      hideFooter: true,
      noMobileCompoents: true,
      skipSetupCheck: true
    },
    template: _personalStep6.default,
    url: '/step-3'
  }).state('setup.personal.review', {
    data: {
      heroNoMobileActionTabs: true,
      hideFooter: true,
      noMobileCompoents: true,
      skipSetupCheck: true
    },
    template: _review2.default,
    url: '/review'
  });

  $urlRouterProvider.when('/setup/personal', '/setup/personal/step-1');
}]);

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


VerificationPersonalController.$inject = ['$controller', '$scope', '$state', 'HoldingUser', 'HoldingCountries', 'HoldingSettings', 'GmwSetup'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _personalInfo = __webpack_require__(931);

var _personalInfo2 = _interopRequireDefault(_personalInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = 'VerificationPersonalController';

angular.module('app.holding.dashboard.onboarding').controller(controller, VerificationPersonalController);

exports.default = {
  template: _personalInfo2.default,
  controller: controller,
  controllerAs: 'verificationPersonalCtrl'
};


function VerificationPersonalController($controller, $scope, $state, HoldingUser, HoldingCountries, HoldingSettings, GmwSetup) {
  'ngInject';

  var vm = this;

  vm.model = {
    code: '',
    contactInfo: {
      line2: '',
      phone: {}
    },
    details: {
      fatcaPassport: [],
      fatcaWork: [],
      sourceOfFunds: {},
      personalDetails: {},
      employment: {}
    }
  };

  vm.shouldShowFatca = shouldShowFatca;

  vm.steps = {
    'setup.personal.step2': {
      checks: [{
        function: checkAddress,
        revertTo: 'setup.personal.step1'
      }]
    },
    'setup.personal.step3': {
      checks: [{
        function: checkSource,
        revertTo: 'setup.personal.step2'
      }]
    },
    'setup.personal.review': {
      checks: [{
        function: checkEmployer,
        revertTo: 'setup.personal.step3'
      }],
      next: submit
    }
  };

  function activate() {
    vm.countries = HoldingCountries.getAllForSelector();
    vm.user = HoldingUser.get();

    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    GmwSetup.getSetupStatus(true).then(function (status) {
      vm.model.code = status.entities[0].code;
    });

    HoldingSettings.getProfile().then(function (_ref) {
      var profiles = _ref.profiles;

      var profile = profiles[0];
      vm.model.contactInfo.country = profile.address.countryCC2;
      vm.model.details.personalDetails = profile.personalDetails;
      vm.model.contactInfo.phone = angular.copy(profile.telephone1);
    });
  }

  function checkAddress() {
    return !!vm.model.contactInfo.line1;
  }

  function checkEmployer() {
    return !!vm.model.details.employment.status;
  }

  function checkSource() {
    return !!vm.model.details.sourceOfFunds.type;
  }

  function shouldShowFatca(nationality) {
    return [vm.model.details.personalDetails.countryOfNationality, vm.model.details.personalDetails.countryOfSecondNationality, vm.model.contactInfo.country].indexOf(nationality) === -1;
  }

  function submit() {
    switch (vm.model.details.employment.status) {
      case 'Employed':
      case 'SelfEmployed':
      case 'Retired':
      case 'Unemployed':
        vm.model.details.employment.nature = 'Title: ' + vm.model.details.employment.title + '\nSalary: ' + vm.model.details.employment.salary + '\nOther Notes: ' + vm.model.details.employment.nature;
        break;
      case 'Student':
        vm.model.details.employment.nature = 'School: ' + vm.model.details.employment.schoolName + '\nProgram: ' + vm.model.details.employment.schoolProgram + '\nPart-Time Job: ' + vm.model.details.employment.studentPartTime + (vm.model.details.employment.studentPartTime ? '\nTitle: ' + vm.model.details.employment.title + '\nSalary: ' + vm.model.details.employment.salary : '') + '\nOther Notes: ' + vm.model.details.employment.nature;
        if (!vm.model.details.employment.studentPartTime) {
          vm.model.details.employment.name = '';
          vm.model.details.employment.period = 0;
          vm.model.details.employment.address = '';
        }
        break;
      case 'Homemaker':
      case 'Other':
        vm.model.details.employment.name = '';
        vm.model.details.employment.period = 0;
        vm.model.details.employment.address = '';
    }
    return GmwSetup.verifyProfile(vm.model).then(function () {
      return $state.go('setup', {}, { reload: true });
    });
  }

  activate();
}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=gmw-verification-flow-container> <div class=\"gmw-verification-flow-container__main gmw-flow-box gmw-flow-box--fluid\" ui-view> </div> <div class=gmw-verification-flow-container__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I complete online verification?'|translate}}\" holding-external-link=support.onboarding.documents> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What can I do while my Holding is unverified?'|translate}}\" holding-external-link=support.onboarding.unverified> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'Can I have a joint Holding?'|translate}}\" holding-external-link=support.onboarding.joint> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What is \\'residency\\'?'|translate}}\" holding-external-link=support.onboarding.residency> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> <holding-live-chat-cta class=h-margin-bottom-50></holding-live-chat-cta> </div> </section> ";

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please confirm your residential address. You will later be asked to upload a utility bill or other proof of residence document for this address, so please ensure this is your residential home rather than a mailing or postal address.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=verificationPersonalCtrl.form novalidate> <div class=gmw-verification-split-form> <div class=gmw-verification-split-form__col> <gmw-contact-info-form read-only-country contact-info=verificationPersonalCtrl.model.contactInfo> </gmw-contact-info-form> </div> <div class=gmw-verification-split-form__col> <gmw-fatca-selector ng-model=verificationPersonalCtrl.model.details.fatcaPassport us-label=\"{{'Have you ever held a US Passport?'|translate}}\" uk-label=\"{{'Have you ever held a UK Passport?'|translate}}\" nationalities=\"[\n            verificationPersonalCtrl.model.details.personalDetails.countryOfNationality,\n            verificationPersonalCtrl.model.details.personalDetails.countryOfSecondNationality,\n            verificationPersonalCtrl.model.contactInfo.country,\n          ]\"> <span ng-if=\"!$parent.nationalities.includes('US') && !$parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a passport in one of the following countries?'|translate\"> </span> <span ng-if=\"$parent.nationalities.includes('US') || $parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a passport in the following country?'|translate\"> </span> </gmw-fatca-selector> <gmw-fatca-selector ng-model=verificationPersonalCtrl.model.details.fatcaWork us-label=\"{{'Have you ever held a work permit in the USA?'|translate}}\" uk-label=\"{{'Have you ever held a work permit in the UK?'|translate}}\" nationalities=\"[\n            verificationPersonalCtrl.model.details.personalDetails.countryOfNationality,\n            verificationPersonalCtrl.model.details.personalDetails.countryOfSecondNationality,\n            verificationPersonalCtrl.model.contactInfo.country,\n          ]\"> <span ng-if=\"!$parent.nationalities.includes('US') && !$parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a work permit in one of the following countries?'|translate\"> </span> <span ng-if=\"$parent.nationalities.includes('US') || $parent.nationalities.includes('GB')\" ng-bind=\"'Have you ever held a work permit in the following country?'|translate\"> </span> </gmw-fatca-selector> </div> </div> <holding-augur name=hid ng-model=verificationPersonalCtrl.model.deviceFingerprint> </holding-augur> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=verificationPersonalCtrl.next() ng-bind=\"'Next Step'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'Please confirm the primary source of the funds that you are sending to your Goldmoney Holding. This could be your salary, an inheritance or a gift, for example.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=verificationPersonalCtrl.form novalidate> <gmw-source-of-funds ng-model=verificationPersonalCtrl.model.details.sourceOfFunds label=\"{{'Primary source of funds'|translate}}\"> </gmw-source-of-funds> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=verificationPersonalCtrl.next() ng-bind=\"'Next Step'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-bind=\"'As a regulated business Goldmoney must collect employment information about our Clients. Please enter your employment details below.'|translate\"> </p> </holding-flow-header> <div class=gmw-flow-box-container> <form name=verificationPersonalCtrl.form novalidate> <gmw-employment-selector employment=verificationPersonalCtrl.model.details.employment> </gmw-employment-selector> </form> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=verificationPersonalCtrl.next() ng-bind=\"'Next Step'|translate\"> </button> </div> </footer> ";

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header></holding-flow-header> <div class=gmw-flow-box-container> <div class=gmw-verification-review> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Name'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\"> <span ng-bind=verificationPersonalCtrl.model.details.personalDetails.name.title></span>. <span ng-bind=verificationPersonalCtrl.model.details.personalDetails.name.firstName></span> <span ng-bind=verificationPersonalCtrl.model.details.personalDetails.name.middleName></span> <span ng-bind=verificationPersonalCtrl.model.details.personalDetails.name.lastName></span> <span ng-if=verificationPersonalCtrl.model.details.personalDetails.name.formerName> (<span ng-bind=verificationPersonalCtrl.model.details.personalDetails.name.formerName></span>) </span> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Gender'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=verificationPersonalCtrl.model.details.personalDetails.gender> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Date of Birth'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=verificationPersonalCtrl.model.details.personalDetails.dateOfBirth> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'City and Country of Birth'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\"> <span ng-bind=verificationPersonalCtrl.model.details.personalDetails.cityOfBirth></span>, <span ng-bind=verificationPersonalCtrl.model.details.personalDetails.countryOfBirth|holdingCountryName></span> </div> </div> <div class=gmw-verification-review__row> <div class=gmw-verification-review__col ng-bind=\"'Country of nationality'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=verificationPersonalCtrl.model.details.personalDetails.countryOfNationality|holdingCountryName> </div> </div> <div class=gmw-verification-review__row ng-if=verificationPersonalCtrl.model.details.personalDetails.countryOfSecondNationality> <div class=gmw-verification-review__col ng-bind=\"'Country of second nationality'|translate\"></div> <div class=\"gmw-verification-review__col h-dark-text\" ng-bind=verificationPersonalCtrl.model.details.personalDetails.countryOfSecondNationality|holdingCountryName> </div> </div> <gmw-review-row label=\"{{'Current employment information'|translate}}\" modify=setup.personal.step3> {{verificationPersonalCtrl.model.details.employment.status|translate}} </gmw-review-row> <div class=gmw-verification-review__separator></div> <gmw-review-row label=\"{{'Have you ever held a passport in the United Kingdom?'|translate}}\" ng-if=\"verificationPersonalCtrl.shouldShowFatca('GB')\" modify=setup.personal.step1> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaPassport.indexOf('GB') === -1\" translate>No</span> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaPassport.indexOf('GB') !== -1\" translate>Yes</span> </gmw-review-row> <gmw-review-row label=\"{{'Have you ever held a passport in the United States?'|translate}}\" ng-if=\"verificationPersonalCtrl.shouldShowFatca('US')\" modify=setup.personal.step1> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaPassport.indexOf('US') === -1\" translate>No</span> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaPassport.indexOf('US') !== -1\" translate>Yes</span> </gmw-review-row> <gmw-review-row label=\"{{'Have you ever held a work permit in the United Kingdom?'|translate}}\" ng-if=\"verificationPersonalCtrl.shouldShowFatca('GB')\"> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaWork.indexOf('GB') === -1\" translate>No</span> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaWork.indexOf('GB') !== -1\" translate>Yes</span> </gmw-review-row> <gmw-review-row label=\"{{'Have you ever held a work permit in the United States?'|translate}}\" ng-if=\"verificationPersonalCtrl.shouldShowFatca('US')\"> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaWork.indexOf('US') === -1\" translate>No</span> <span ng-if=\"verificationPersonalCtrl.model.details.fatcaWork.indexOf('US') !== -1\" translate>Yes</span> </gmw-review-row> <div class=gmw-verification-review__separator></div> <gmw-review-row label=\"{{'Country of residence'|translate}}\" modify=setup.personal.step1> {{verificationPersonalCtrl.model.contactInfo.country|holdingCountryName}} </gmw-review-row> <gmw-review-row label=\"{{'Address 1'|translate}}\"> {{verificationPersonalCtrl.model.contactInfo.line1}} </gmw-review-row> <gmw-review-row label=\"{{'Address 2'|translate}}\"> {{verificationPersonalCtrl.model.contactInfo.line2}} </gmw-review-row> <gmw-review-row label=\"{{'City'|translate}}\"> {{verificationPersonalCtrl.model.contactInfo.city}} </gmw-review-row> <gmw-review-row label=\"{{'Post code'|translate}}\"> {{verificationPersonalCtrl.model.contactInfo.zip}} </gmw-review-row> <gmw-review-row label=\"{{'Number of years at this address'|translate}}\"> <span translate>{{verificationPersonalCtrl.model.contactInfo.residenceYears}} years</span> </gmw-review-row> <gmw-review-row label=\"{{'Telephone number'|translate}}\"> +{{verificationPersonalCtrl.model.contactInfo.phone.prefix}} {{verificationPersonalCtrl.model.contactInfo.phone.number}} </gmw-review-row> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=verificationPersonalCtrl.next() translate> Complete </button> </div> </footer> ";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Personal Info'),
    steps: [{
        key: 'step1',
        state: 'setup.personal.step1',
        heading: (0, _gettext2.default)('Personal Details'),
        label: (0, _gettext2.default)('Personal Info'),
        returnTo: 'setup',
        keepStateOnPrev: true
    }, {
        key: 'step2',
        state: 'setup.personal.step2',
        heading: (0, _gettext2.default)('Primary Source of Funds'),
        label: (0, _gettext2.default)('Source of Funds')
    }, {
        key: 'step3',
        state: 'setup.personal.step3',
        heading: (0, _gettext2.default)('Employment Status'),
        label: (0, _gettext2.default)('Employment Status')
    }, {
        key: 'review',
        state: 'setup.personal.review',
        heading: (0, _gettext2.default)('Review & Confirm Information'),
        label: (0, _gettext2.default)('Review')
    }]
};
exports.default = flow;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _personal = __webpack_require__(938);

var _personal2 = _interopRequireDefault(_personal);

var _step = __webpack_require__(940);

var _step2 = _interopRequireDefault(_step);

var _step3 = __webpack_require__(941);

var _step4 = _interopRequireDefault(_step3);

var _step5 = __webpack_require__(942);

var _step6 = _interopRequireDefault(_step5);

var _step7 = __webpack_require__(943);

var _step8 = _interopRequireDefault(_step7);

var _step9 = __webpack_require__(944);

var _step10 = _interopRequireDefault(_step9);

var _step11 = __webpack_require__(945);

var _step12 = _interopRequireDefault(_step11);

var _signUpPersonalFlow = __webpack_require__(946);

var _signUpPersonalFlow2 = _interopRequireDefault(_signUpPersonalFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.onboarding').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  // For some obscure reason, these redirect are dependent on definition order.
  // Do not move to the bottom or they stop working!
  // Happened to others, see: https://stackoverflow.com/a/26285671/107613
  // It used to be a problem with ui-sref only: https://github.com/angular-ui/ui-router/issues/1584

  $urlRouterProvider.when('/sign-up', '/sign-up/personal/step1');
  $urlRouterProvider.when('/sign-up/corporate', '/sign-up/corporate/step1');
  $urlRouterProvider.when('/sign-up/personal?email&firstName&lastName', '/sign-up/personal/step1?email&firstName&lastName');
  $urlRouterProvider.when('/sign-up/trust', '/sign-up/trust/step1');

  $stateProvider.state('sign-up', {
    data: {
      pageBodyClass: 'body-onboarding',
      pageMetaDescription: 'Open your Holding in Minutes',
      pageTitle: 'Open your Holding in Minutes',
      skipSetupCheck: true
    },
    parent: 'app',
    resolve: {
      countries: ['HoldingCountries', function countries(HoldingCountries) {
        'ngInject';

        return HoldingCountries.load();
      }],
      currencies: ['HoldingCurrencies', function currencies(HoldingCurrencies) {
        'ngInject';

        return HoldingCurrencies.load();
      }]
    },
    url: '/sign-up',
    views: {
      app: {
        template: '<div ui-view="sign-up"></div>'
      }
    }
  }).state('sign-up.corporate', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    url: '/corporate',
    views: {
      'sign-up': _personal2.default
    }
  }).state('sign-up.corporate.step-1', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    template: _step2.default,
    url: '/step1'
  }).state('sign-up.corporate.step-2', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    template: _step4.default,
    url: '/step2'
  }).state('sign-up.personal', {
    data: {
      flow: _signUpPersonalFlow2.default,
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    resolve: _personal2.default.resolve,
    url: '/personal?email&firstName&lastName',
    views: {
      'sign-up': _personal2.default
    }

  }).state('sign-up.personal.step-1', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    template: _step6.default,
    url: '/step1'
  }).state('sign-up.personal.step-2', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    template: _step8.default,
    url: '/step2'
  }).state('sign-up.trust', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    url: '/trust',
    views: {
      'sign-up': _personal2.default
    }
  }).state('sign-up.trust.step-1', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    url: '/step1',
    template: _step10.default
  }).state('sign-up.trust.step-2', {
    data: {
      pageBodyClass: 'body-onboarding',
      skipSetupCheck: true
    },
    template: _step12.default,
    url: '/step2'
  });
}]);

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SignUpPersonalController.$inject = ['$controller', '$q', '$stateParams', '$scope', 'HoldingCountries', 'gettextCatalog', 'GmwSignUp'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _personal = __webpack_require__(939);

var _personal2 = _interopRequireDefault(_personal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var personal = {
  controller: 'SignUpPersonalController',
  controllerAs: 'signUpPersonalCtrl',
  resolve: {
    currencies: ['HoldingCurrencies', function currencies(HoldingCurrencies) {
      'ngInject';

      return HoldingCurrencies.load();
    }]
  },
  template: _personal2.default
};

exports.default = personal;


angular.module('app.holding.dashboard.onboarding').controller(personal.controller, SignUpPersonalController);

function SignUpPersonalController($controller, $q, $stateParams, $scope, HoldingCountries, gettextCatalog, GmwSignUp) {
  'ngInject';

  var vm = this;
  vm.countries = HoldingCountries.getAllForSelector();
  vm.residenceCountries = HoldingCountries.getAllowedResidence();
  vm.showSecondaryPhone = showSecondaryPhone;
  vm.submit = submit;
  vm.steps = {
    'sign-up.personal.step-2': {
      checks: [{
        function: checkBasic,
        revertTo: 'sign-up.personal.step-1'
      }],
      next: submit
    }
  };

  vm.model = {
    email: 'email' in $stateParams ? $stateParams.email : undefined,
    personalDetails: {
      gender: 'N',
      name: {
        firstName: 'firstName' in $stateParams ? $stateParams.firstName : undefined,
        lastName: 'lastName' in $stateParams ? $stateParams.lastName : undefined,
        title: gettextCatalog.getString('Mr')
      }
    },
    riskDisclosure: false,
    subscribe: false,
    type: 'Personal',
    wantsShariaCompliance: false,
    regulation: 'Toronto'
  };

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    vm.currencies = [];
  }

  function checkBasic() {
    return !!vm.model.email;
  }

  function showSecondaryPhone() {
    vm.secondaryPhone = true;
  }

  function submit() {
    return GmwSignUp.signUpPersonal(vm.model);
  }

  activate();
}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports = "<gmw-onboarding-header></gmw-onboarding-header> <div class=initial-onboarding-container> <gmw-sign-in-hero heading=\"{{'Welcome to Goldmoney'|translate}}\"> </gmw-sign-in-hero> <section class=\"initial-onboarding initial-onboarding--large\"> <div class=initial-onboarding__inner> <ui-view></ui-view> </div> <footer class=initial-onboarding__footer> <span class=initial-onboarding__footer-item> <span ng-bind=\"'Already have a Holding?'|translate\"></span> <a ui-sref=auth.sign-in class=h-blue-link ng-attr-title=\"{{'Sign in to Goldmoney'|translate}}\" ng-bind=\"'Sign in here'|translate\"> </a>. </span> </footer> </section> </div> ";

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = "<form name=signUpCorporateCtrl.formStep1 id=formSignUp holding-form-loading=signUpCorporateCtrl.advance() novalidate> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\">Title</label> <gmw-toggle-option-group ng-model=signUpCorporateCtrl.model.personalDetails.name.title> <gmw-toggle-option label=\"{{'Mr'|translate}}\" value=\"'Mr'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Mrs'|translate}}\" value=\"'Mrs'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Miss'|translate}}\" value=\"'Miss'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Ms'|translate}}\" value=\"'Ms'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Dr'|translate}}\" value=\"'Dr'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Prof'|translate}}\" value=\"'Prof'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'First name'|translate}}\" ng-model=signUpCorporateCtrl.model.personalDetails.name.firstName required maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Last name'|translate}}\" ng-model=signUpCorporateCtrl.model.personalDetails.name.lastName required maxlength=100> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Middle name(s)'|translate}}\" ng-model=signUpCorporateCtrl.model.personalDetails.name.middleName maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Former name(s)'|translate}}\" ng-model=signUpCorporateCtrl.model.personalDetails.name.formerName maxlength=100> </gmw-box-input-simple> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\">Gender</label> <gmw-toggle-option-group ng-model=signUpCorporateCtrl.model.personalDetails.gender> <gmw-toggle-option label=\"{{'Male'|translate}}\" value=M> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Female'|translate}}\" value=F> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" translate>Date of Birth</label> <gmw-date-selector name=date required date-of-birth ng-model=signUpCorporateCtrl.model.personalDetails.dateOfBirth> </gmw-date-selector> </div> <gmw-box-phone-selector name=phone required ng-model=signUpCorporateCtrl.model.phone> </gmw-box-phone-selector> <gmw-box-input class=gmw-input-container type=email is-required=true name=email ng-model=signUpCorporateCtrl.model.email no-label=true has-error=\"signUpCorporateCtrl.formStep1.email.$dirty && signUpCorporateCtrl.formStep1.email.$invalid\" placeholder=\"{{'Email address'|translate}}\"> </gmw-box-input> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input class=gmw-input-container--split-half__col required type=password is-required=true name=password ng-model=signUpCorporateCtrl.model.password ng-change=\"signUpCorporateCtrl.repeatPassword = ''\" no-label=true gmw-validate-password placeholder=\"{{'Password'|translate}}\"> </gmw-box-input> <gmw-box-input class=gmw-input-container--split-half__col required type=password is-required=true name=repeatPassword matches=\"{{signUpCorporateCtrl.model.password}}\" ng-model=signUpCorporateCtrl.repeatPassword no-label=true placeholder=\"{{'Repeat password'|translate}}\"> </gmw-box-input> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=signUpCorporateCtrl.formStep1.$invalid> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </form> ";

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "<form name=signUpCorporateCtrl.formStep2 id=formSignUp holding-form-loading=signUpCorporateCtrl.submit() novalidate> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=countryOfBirth class=gmw-input-container--split-half__col ng-model=signUpCorporateCtrl.model.personalDetails.countryOfBirth placeholder=\"{{'Country of birth'|translate}}\" no-label=true options=signUpCorporateCtrl.countries> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'City of birth'|translate}}\" ng-model=signUpCorporateCtrl.model.personalDetails.cityOfBirth required maxlength=50> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=countryOfResidence class=gmw-input-container--split-half__col ng-model=signUpCorporateCtrl.model.personalDetails.countryOfResidence placeholder=\"{{'Country of residence'|translate}}\" no-label=true options=signUpCorporateCtrl.countries> </gmw-box-selector> <gmw-box-selector required name=countryOfNationality class=gmw-input-container--split-half__col ng-model=signUpCorporateCtrl.model.personalDetails.countryOfNationality placeholder=\"{{'Country of nationality'|translate}}\" no-label=true options=signUpCorporateCtrl.countries> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector name=secondaryNationality class=gmw-input-container--split-half__col ng-model=signUpCorporateCtrl.model.personalDetails.countryOfSecondNationality placeholder=\"{{'Secondary nationality (optional)'|translate}}\" no-label=true options=signUpCorporateCtrl.countries> </gmw-box-selector> <div class=gmw-input-container--split-half__col></div> </div> <gmw-toggle-option-group ng-model=signUpCorporateCtrl.model.initialFunding> <gmw-toggle-option label=\"{{'Funding only, up to $150,000USD'|translate}}\" value=149999> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Full service, including prepaid card an personal account transfers'|translate}}\" value=150001> </gmw-toggle-option> </gmw-toggle-option-group> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Referral code (optional)'|translate}}\" label-spacer ng-model=signUpCorporateCtrl.model.referrer> </gmw-box-input-simple> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=signUpCorporateCtrl.formStep2.$invalid> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </form> ";

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = "<form name=signUpPersonalCtrl.form id=formSignUp gmw-submit=signUpPersonalCtrl.next() novalidate> <div class=\"gmw-input-container gmw-input-container--rule-bottom\"> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Select Holding Type'|translate\"></span> <a href=# class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'Individual Holdings can be held by one or more individuals, while Corporate or Trust Holdings are used for matching legal entities.'|translate}}\" ng-bind=\"'Which do I select?'|translate\"> </a> </label> <gmw-toggle-option-group ng-model=signUpPersonalCtrl.model.type> <gmw-toggle-option label=\"{{'Individual'|translate}}\" value=\"'Personal'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Corporate'|translate}}\" value=\"'Corporate'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Trust'|translate}}\" value=\"'Trust'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div ng-switch=signUpPersonalCtrl.model.type> <div ng-switch-when=Corporate> <span class=h-default-text translate> Goldmoney does not currently offer online sign up for corporate, business, or trust Holdings. Please contact <a href=mailto:institutional@goldmoney.com class=h-blue-link>institutional@goldmoney.com</a> in order to apply for a corporate, business, or trust Holding. </span> </div> <div ng-switch-when=Trust> <span class=h-default-text translate> Goldmoney does not currently offer online sign up for corporate, business, or trust Holdings. If your trust is professionally managed, please contact <a href=mailto:institutional@goldmoney.com class=h-blue-link>institutional@goldmoney.com</a> in order to apply for a trust Holding. </span> </div> <div ng-switch-default> <gmw-title-toggle title=signUpPersonalCtrl.model.personalDetails.name.title> </gmw-title-toggle> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Basic Personal Information'|translate\"> </label> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'First name'|translate}}\" ng-model=signUpPersonalCtrl.model.personalDetails.name.firstName required maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Last name'|translate}}\" ng-model=signUpPersonalCtrl.model.personalDetails.name.lastName required maxlength=100> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Middle name(s)'|translate}}\" ng-model=signUpPersonalCtrl.model.personalDetails.name.middleName maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Former/Maiden name(s)'|translate}}\" ng-model=signUpPersonalCtrl.model.personalDetails.name.formerName maxlength=100> </gmw-box-input-simple> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Date of birth'|translate\"> </label> <gmw-date-selector name=date required date-of-birth ng-model=signUpPersonalCtrl.model.personalDetails.dateOfBirth> </gmw-date-selector> </div> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Holding Information'|translate\"></span> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'At least one number, one letter, and between 8 and 50 characters long.'|translate}}\" ng-bind=\"'Password requirements'|translate\"> </a> </label> <gmw-box-input-simple class=gmw-input-container type=email autocomplete=username required name=email ng-model=signUpPersonalCtrl.model.email placeholder=\"{{'Email address'|translate}}\"> </gmw-box-input-simple> <holding-alert-legacy class=error ng-if=\"signUpPersonalCtrl.form.$submitted && signUpPersonalCtrl.form.$error.validPassword\"> <span translate>The chosen password must contain at least one number, one letter, and be between 8 and 50 characters.</span> </holding-alert-legacy> <holding-alert-legacy class=error ng-if=\"signUpPersonalCtrl.form.$submitted && !signUpPersonalCtrl.form.$error.validPassword && signUpPersonalCtrl.form.$error.matches\"> <span translate>The repeated password does not match.</span> </holding-alert-legacy> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col name=password type=password autocomplete=new-password required ng-model=signUpPersonalCtrl.model.password ng-change=\"signUpPersonalCtrl.repeatPassword = ''\" gmw-validate-password placeholder=\"{{'Password'|translate}}\"> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col name=repeatPassword type=password autocomplete=new-password required matches=\"{{signUpPersonalCtrl.model.password}}\" ng-model=signUpPersonalCtrl.repeatPassword placeholder=\"{{'Repeat password'|translate}}\"> </gmw-box-input-simple> </div> <div ng-messages=signUpPersonalCtrl.form.$error> <div ng-message=required ng-if=signUpPersonalCtrl.form.$submitted> <holding-alert-legacy class=error> <span ng-bind=\"'Please ensure that you have entered all required information.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" type=submit> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </div> </div> </form> ";

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "<form name=signUpPersonalCtrl.form id=formSignUp gmw-submit=signUpPersonalCtrl.next() novalidate> <div ng-messages=signUpPersonalCtrl.form.$error> <div ng-message=validNumber ng-if=signUpPersonalCtrl.form.$submitted> <holding-alert-legacy class=error> <span ng-bind=\"'The phone number entered does not appear to be valid.'|translate\"></span> </holding-alert-legacy> </div> </div> <gmw-box-phone-selector name=phone required ng-model=signUpPersonalCtrl.model.phone choose-type> <gmw-label-right> <a href=javascript:; class=\"h-blue-link h-small-text\" ng-if=!signUpPersonalCtrl.secondaryPhone ng-click=signUpPersonalCtrl.showSecondaryPhone() ng-bind=\"'Add Secondary Phone'|translate\"> </a> </gmw-label-right> </gmw-box-phone-selector> <gmw-box-phone-selector name=phone2 ng-model=signUpPersonalCtrl.model.phone2 ng-if=signUpPersonalCtrl.secondaryPhone label=\"{{'Secondary Phone Number'|translate}}\" choose-type> </gmw-box-phone-selector> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Birthplace'|translate\"> </label> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=countryOfBirth class=gmw-input-container--split-half__col ng-model=signUpPersonalCtrl.model.personalDetails.countryOfBirth placeholder=\"{{'Country of birth'|translate}}\" no-label=true options=signUpPersonalCtrl.countries> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container--split-half__col name=cityOfBirth placeholder=\"{{'City/Place of birth'|translate}}\" ng-model=signUpPersonalCtrl.model.personalDetails.cityOfBirth required maxlength=50> </gmw-box-input-simple> </div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Nationality'|translate\"> </label> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=countryOfNationality class=gmw-input-container--split-half__col ng-model=signUpPersonalCtrl.model.personalDetails.countryOfNationality placeholder=\"{{'Country of nationality'|translate}}\" no-label=true options=signUpPersonalCtrl.countries> </gmw-box-selector> <gmw-box-selector name=secondaryNationality class=gmw-input-container--split-half__col ng-model=signUpPersonalCtrl.model.personalDetails.countryOfSecondNationality placeholder=\"{{'Secondary nationality (optional)'|translate}}\" no-label=true options=signUpPersonalCtrl.countries> </gmw-box-selector> </div> <div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Country of Residence'|translate\"></span> <a holding-external-link=support.onboarding.countries target=_blank class=\"h-blue-link h-small-text\" ng-bind=\"'Is your country missing from this list?'|translate\"> </a> </label> <gmw-box-selector required name=countryOfResidence ng-model=signUpPersonalCtrl.model.countryOfResidence placeholder=\"{{'Country of residence'|translate}}\" no-label=true options=signUpPersonalCtrl.residenceCountries> </gmw-box-selector> </div> <div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Referral Code'|translate\"></span> <a holding-external-link=referral.terms target=_blank class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'If you have been referred to Goldmoney and provided with a referral code, you may enter the code here'|translate}}\" ng-bind=\"'What is this?'|translate\"> </a> </label> <gmw-box-input-simple placeholder=\"{{'Referral code (optional)'|translate}}\" no-label=true ng-model=signUpPersonalCtrl.model.referrer> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-checkbox-container\"> <holding-alert-legacy class=error ng-if=\"signUpPersonalCtrl.form.$submitted && !signUpPersonalCtrl.terms\"> <span ng-bind=\"'You must accept the Client Agreement.'|translate\"></span> </holding-alert-legacy> <gmw-checkbox ng-model=signUpPersonalCtrl.terms class=h-margin-bottom-20 name=terms required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read, understood, and accept the terms of the'|translate\"></span> <a href class=h-blue-link ng-if=\"signUpPersonalCtrl.model.regulation == 'Toronto'\" holding-external-link=clientAgreement.regulator.canada ng-bind=\"'Goldmoney Client Agreement'|translate\"></a> <a href class=h-blue-link ng-if=\"signUpPersonalCtrl.model.regulation == 'UK'\" holding-external-link=clientAgreement.regulator.uk ng-bind=\"'Goldmoney Client Agreement'|translate\"></a> </span> </gmw-checkbox> <gmw-checkbox ng-model=signUpPersonalCtrl.model.riskDisclosure ng-if=\"signUpPersonalCtrl.model.countryOfResidence == 'CA'\" class=h-margin-bottom-20 name=subscribe required> <span class=\"h-dark-text h-medium-text h-bold-text\"> <span ng-bind=\"'I have read and understood the'|translate\"></span> <a href class=h-blue-link holding-external-link=riskDisclosure ng-bind=\"'Risk Disclosure Statement'|translate\"></a> </span> </gmw-checkbox> <gmw-checkbox ng-model=signUpPersonalCtrl.model.subscribe name=subscribe> <span class=\"h-dark-text h-medium-text h-bold-text\" translate> I would like to receive <a href class=h-blue-link holding-external-link=research>Goldmoney Research</a> by email. </span> </gmw-checkbox> <holding-augur name=hid ng-model=signUpPersonalCtrl.model.deviceFingerprint> </holding-augur> </div> <div ng-messages=signUpPersonalCtrl.form.$error> <div ng-message=required ng-if=signUpPersonalCtrl.form.$submitted> <holding-alert-legacy class=error> <span ng-bind=\"'Please ensure that you have entered all required information.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=initial-onboarding__dual-cta> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-border-cta h-margin-right-20\" type=button ui-sref=sign-up.personal.step-1> <span ng-bind=\"'Previous'|translate\"></span> </button> </div> <div class=initial-onboarding__dual-cta-col> <button class=\"medium-main-cta gmw-responsive-button\" type=submit> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </div> </form> ";

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "<form name=signUpTrustCtrl.formStep1 id=formSignUp holding-form-loading=signUpTrustCtrl.advance() novalidate> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\">Title</label> <gmw-toggle-option-group ng-model=signUpTrustCtrl.model.personalDetails.name.title> <gmw-toggle-option label=\"{{'Mr'|translate}}\" value=\"'Mr'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Mrs'|translate}}\" value=\"'Mrs'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Miss'|translate}}\" value=\"'Miss'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Ms'|translate}}\" value=\"'Ms'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Dr'|translate}}\" value=\"'Dr'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Prof'|translate}}\" value=\"'Prof'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'First name'|translate}}\" ng-model=signUpTrustCtrl.model.personalDetails.name.firstName required maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Last name'|translate}}\" ng-model=signUpTrustCtrl.model.personalDetails.name.lastName required maxlength=100> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Middle name(s)'|translate}}\" ng-model=signUpTrustCtrl.model.personalDetails.name.middleName maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Former name(s)'|translate}}\" ng-model=signUpTrustCtrl.model.personalDetails.name.formerName maxlength=100> </gmw-box-input-simple> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\">Gender</label> <gmw-toggle-option-group ng-model=signUpTrustCtrl.model.personalDetails.gender> <gmw-toggle-option label=\"{{'Male'|translate}}\" value=M> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Female'|translate}}\" value=F> </gmw-toggle-option> </gmw-toggle-option-group> </div> <div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" translate> Date of Birth </label> <gmw-date-selector name=date required date-of-birth ng-model=signUpTrustCtrl.model.personalDetails.dateOfBirth> </gmw-date-selector> </div> <gmw-box-phone-selector name=phone required ng-model=signUpTrustCtrl.model.phone> </gmw-box-phone-selector> <gmw-box-input class=gmw-input-container type=email is-required=true name=email ng-model=signUpTrustCtrl.model.email no-label=true has-error=\"signUpTrustCtrl.formStep1.email.$dirty && signUpTrustCtrl.formStep1.email.$invalid\" placeholder=\"{{'Email address'|translate}}\"> </gmw-box-input> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input class=gmw-input-container--split-half__col required type=password is-required=true name=password ng-model=signUpTrustCtrl.model.password ng-change=\"signUpTrustCtrl.repeatPassword = ''\" no-label=true gmw-validate-password placeholder=\"{{'Password'|translate}}\"> </gmw-box-input> <gmw-box-input class=gmw-input-container--split-half__col required type=password is-required=true name=repeatPassword matches=\"{{signUpTrustCtrl.model.password}}\" ng-model=signUpTrustCtrl.repeatPassword no-label=true placeholder=\"{{'Repeat password'|translate}}\"> </gmw-box-input> </div> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=signUpTrustCtrl.formStep1.$invalid> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </form> ";

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "<form name=signUpTrustCtrl.formStep2 id=formSignUp holding-form-loading=signUpTrustCtrl.submit() novalidate> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=countryOfBirth class=gmw-input-container--split-half__col ng-model=signUpTrustCtrl.model.personalDetails.countryOfBirth placeholder=\"{{'Country of birth'|translate}}\" no-label=true options=signUpTrustCtrl.countries> </gmw-box-selector> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'City of birth'|translate}}\" ng-model=signUpTrustCtrl.model.personalDetails.cityOfBirth required maxlength=50> </gmw-box-input-simple> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector required name=countryOfResidence class=gmw-input-container--split-half__col ng-model=signUpTrustCtrl.model.personalDetails.countryOfResidence placeholder=\"{{'Country of residence'|translate}}\" no-label=true options=signUpTrustCtrl.countries> </gmw-box-selector> <gmw-box-selector required name=countryOfNationality class=gmw-input-container--split-half__col ng-model=signUpTrustCtrl.model.personalDetails.countryOfNationality placeholder=\"{{'Country of nationality'|translate}}\" no-label=true options=signUpTrustCtrl.countries> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-selector name=secondaryNationality class=gmw-input-container--split-half__col ng-model=signUpTrustCtrl.model.personalDetails.countryOfSecondNationality placeholder=\"{{'Secondary nationality (optional)'|translate}}\" no-label=true options=signUpTrustCtrl.countries> </gmw-box-selector> <div class=gmw-input-container--split-half__col></div> </div> <gmw-toggle-option-group ng-model=signUpTrustCtrl.model.initialFunding> <gmw-toggle-option label=\"{{'Funding only, up to $150,000USD'|translate}}\" value=149999> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Full service, including prepaid card an personal account transfers'|translate}}\" value=150001> </gmw-toggle-option> </gmw-toggle-option-group> <gmw-box-input-simple class=gmw-input-container--split-half__col placeholder=\"{{'Referral code (optional)'|translate}}\" label-spacer ng-model=signUpTrustCtrl.model.referrer> </gmw-box-input-simple> <div class=initial-onboarding__center-cta> <button class=\"medium-main-cta gmw-responsive-button\" holding-button-disabled=signUpTrustCtrl.formStep2.$invalid> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </form> ";

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Sign Up'),
    steps: [{
        key: 'step1',
        state: 'sign-up.personal.step-1',
        heading: (0, _gettext2.default)('Personal Details'),
        label: (0, _gettext2.default)('Current Address'),
        keepStateOnPrev: true
    }, {
        key: 'step2',
        state: 'sign-up.personal.step-2'
    }]
};
exports.default = flow;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _dateSelector = __webpack_require__(948);

var _dateSelector2 = _interopRequireDefault(_dateSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwDateSelector', gmwDateSelector).name;


function gmwDateSelector() {
  'ngInject';

  var limitDate = (0, _moment2.default)().subtract(18, 'y');

  return {
    link: link,
    restrict: 'E',
    require: ['ngModel', '^^form'],
    replace: true,
    scope: {
      dateLimit: '=?',
      label: '@?'
    },
    template: _dateSelector2.default
  };

  function link(scope, _elem, attrs, ctrls) {
    var ngModel = ctrls[0];
    var form = ctrls[1];
    scope.model = {};
    scope.dayOptions = range(1, 31).map(function (value) {
      return {
        value: value,
        label: (0, _moment2.default)({ day: value, month: 0 }).format('DD')
      };
    });
    scope.monthOptions = range(0, 11).map(function (value) {
      return {
        value: value,
        label: (0, _moment2.default)({ month: value }).format('MMMM')
      };
    });

    var dateOfBirth = Object.prototype.hasOwnProperty.call(attrs, 'dateOfBirth');
    var future = Object.prototype.hasOwnProperty.call(attrs, 'future');

    var years = void 0;
    if (dateOfBirth) {
      years = range((0, _moment2.default)().year() - 18, 1900);
    } else if (future) {
      years = range((0, _moment2.default)().year(), 2100);
    } else {
      years = range((0, _moment2.default)().year(), 1900);
    }
    scope.yearOptions = years.map(function (value) {
      return {
        value: value,
        label: (0, _moment2.default)({ year: value }).format('YYYY')
      };
    });

    scope.$watchGroup(['model.day', 'model.month', 'model.year'], onUpdate);

    ngModel.$formatters.push(function (value) {
      var date = (0, _moment2.default)(value);
      if (value && date.isValid()) {
        scope.model.day = date.date();
        scope.model.month = date.month();
        scope.model.year = date.year();
      }
    });

    function checkDate(date) {
      var today = (0, _moment2.default)();
      if (dateOfBirth) {
        return date.isSameOrBefore(limitDate);
      } else if (future) {
        return date.isAfter(today);
      } else if (scope.dateLimit) {
        return date.isSameOrAfter(scope.dateLimit);
      }
      return true;
    }

    function setValidity(key, value) {
      form.day.$setValidity(key, value);
      form.month.$setValidity(key, value);
      form.year.$setValidity(key, value);
    }

    function onUpdate(_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          day = _ref2[0],
          month = _ref2[1],
          year = _ref2[2];

      if (day !== undefined && month !== undefined && year !== undefined) {
        var date = (0, _moment2.default)({ day: day, month: month, year: year });
        if (date.isValid() && checkDate(date)) {
          ngModel.$setViewValue(date.format('YYYY-MM-DD'));
          setValidity('validDate', true);
          setValidity('dateLimit', true);
          scope.valid = true;
        } else {
          ngModel.$setViewValue(undefined);
          if (!date.isValid()) {
            setValidity('validDate', false);
          }
          if (!checkDate(date)) {
            setValidity('dateLimit', false);
          }
          scope.valid = false;
        }
      }
    }
  }
}

function range(start, stop) {
  var step = start > stop ? -1 : 1;
  var result = [];
  for (var i = start; step > 0 ? i <= stop : i >= stop; i += step) {
    result.push(i);
  }
  return result;
}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label ng-if=label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=label> </label> <div class=\"gmw-input-container gmw-input-container--split-thirds\"> <gmw-box-selector name=day class=gmw-input-container--split-thirds__col no-label=true ng-model=model.day options=dayOptions required placeholder=\"{{'Day'|translate}}\"> </gmw-box-selector> <gmw-box-selector name=month class=gmw-input-container--split-thirds__col no-label=true ng-model=model.month options=monthOptions required placeholder=\"{{'Month'|translate}}\"> </gmw-box-selector> <gmw-box-selector name=year class=gmw-input-container--split-thirds__col no-label=true ng-model=model.year options=yearOptions required placeholder=\"{{'Year'|translate}}\"> </gmw-box-selector> </div> </div> ";

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwBoxPhoneSelector.$inject = ['gettextCatalog', 'HoldingPhone', 'HoldingCountries'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _boxPhoneSelector = __webpack_require__(950);

var _boxPhoneSelector2 = _interopRequireDefault(_boxPhoneSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('gm.wealth.common').directive('gmwBoxPhoneSelector', gmwBoxPhoneSelector).name;


function gmwBoxPhoneSelector(gettextCatalog, HoldingPhone, HoldingCountries) {
  'ngInject';

  var phoneTypes = [{
    label: gettextCatalog.getString('Mobile'),
    value: 'M'
  }, {
    label: gettextCatalog.getString('Home'),
    value: 'H'
  }, {
    label: gettextCatalog.getString('Work'),
    value: 'W'
  }];

  var directive = {
    link: link,
    require: 'ngModel',
    replace: true,
    restrict: 'E',
    scope: {
      addSecondary: '=?',
      label: '@?',
      column: '=?'
    },
    template: _boxPhoneSelector2.default,
    transclude: {
      labelRight: '?gmwLabelRight'
    }
  };
  return directive;

  function link(scope, _elem, attrs, ngModel) {
    function onCountryUpdate(country) {
      if (country) {
        scope.model.prefix = HoldingCountries.getPrefix(country);
      }
    }

    function onUpdate(_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          prefix = _ref2[0],
          number = _ref2[1],
          telType = _ref2[2];

      if (prefix && number && (telType || !scope.chooseType)) {
        ngModel.$setViewValue({ prefix: prefix, number: number, telType: telType });
      }
    }

    scope.isRequired = Object.prototype.hasOwnProperty.call(attrs, 'required');

    scope.countryList = HoldingCountries.getPrefixes();
    scope.model = {};
    scope.phoneTypes = phoneTypes;
    scope.chooseType = Object.prototype.hasOwnProperty.call(attrs, 'chooseType');
    scope.$watch('model.country', onCountryUpdate);
    scope.$watchGroup(['model.prefix', 'model.number', 'model.telType'], onUpdate);

    ngModel.$formatters.push(function (value) {
      if (value) {
        scope.model.prefix = value.prefix;
        scope.model.number = value.number;
        scope.model.country = HoldingPhone.getPhoneCountryCode('+' + value.prefix + value.number);
        if ('telType' in value) {
          scope.model.telType = value.telType;
        }
      } else {
        scope.model = {};
      }
    });

    ngModel.$validators.validNumber = function validNumberParser(modelValue, viewValue) {
      var value = modelValue || viewValue || {};
      var prefix = value.prefix,
          number = value.number;

      return !modelValue && !viewValue || HoldingPhone.isValidPhoneNumber('+' + prefix + number);
    };
  }
}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-if=label ng-bind=label></span> <span class=\"heading-h4 h-dark-text\" ng-if=!label translate>Phone Number</span> <div ng-transclude=labelRight></div> </label> <div class=\"gmw-input-container gmw-box-phone-input\" ng-class=\"{ 'gmw-box-phone-input--column': column }\"> <gmw-box-selector ng-if=chooseType class=gmw-box-phone-input__type name=type no-label=true ng-model=model.telType placeholder=\"{{'Select'|translate}}\" ng-required=isRequired options=phoneTypes> </gmw-box-selector> <gmw-box-selector class=gmw-box-phone-input__country name=country no-label=true ng-model=model.country placeholder=\"{{'Country code'|translate}}\" ng-required=isRequired options=countryList> </gmw-box-selector> <gmw-box-input-simple class=gmw-box-phone-input__number placeholder=\"{{'Phone number'|translate}}\" ng-required=isRequired ng-model=model.number> </gmw-box-input-simple> </div> </div> ";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwContactInfoForm.$inject = ['gettextCatalog', 'HoldingCountries'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contactInfoForm = __webpack_require__(952);

var _contactInfoForm2 = _interopRequireDefault(_contactInfoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwContactInfoForm', gmwContactInfoForm).name;


function gmwContactInfoForm(gettextCatalog, HoldingCountries) {
  'ngInject';

  var directive = {
    compile: function compile() {
      return { pre: pre, post: post };
    },
    replace: true,
    require: '^^form',
    restrict: 'E',
    scope: {
      contactInfo: '='
    },
    template: _contactInfoForm2.default
  };
  return directive;

  function pre(scope, _elem, attrs) {
    scope.readOnlyCountry = Object.prototype.hasOwnProperty.call(attrs, 'readOnlyCountry');
  }

  function post(scope, _elem, _attrs, form) {
    scope.countries = HoldingCountries.getAllowedResidence();
    scope.yearsLivedOptions = [{ value: 0, label: gettextCatalog.getString('0 years') }, { value: 1, label: gettextCatalog.getString('1 year') }, { value: 2, label: gettextCatalog.getString('2 years') }, { value: 3, label: gettextCatalog.getString('3 years') }, { value: 4, label: gettextCatalog.getString('4 years') }, { value: 5, label: gettextCatalog.getString('5 years') }, { value: 6, label: gettextCatalog.getString('6 years') }, { value: 7, label: gettextCatalog.getString('7 years') }, { value: 8, label: gettextCatalog.getString('8 years') }, { value: 9, label: gettextCatalog.getString('9 years') }, { value: 10, label: gettextCatalog.getString('10 years or more') }];
    scope.$watch('contactInfo.country', function (country, oldCountry) {
      switch (country) {
        case 'US':
          scope.provinceLabel = gettextCatalog.getString('State');
          scope.postCodeLabel = gettextCatalog.getString('Zip code');
          break;
        case 'GB':
          scope.provinceLabel = gettextCatalog.getString('County');
          scope.postCodeLabel = gettextCatalog.getString('Postcode');
          break;
        case 'CA':
        default:
          scope.provinceLabel = gettextCatalog.getString('Province');
          scope.postCodeLabel = gettextCatalog.getString('Postcode');
          break;
      }

      HoldingCountries.getProvinces(country).then(function (provinces) {
        if (oldCountry && oldCountry !== country) {
          scope.contactInfo.province = null;
          form.province.$setPristine();
        }
        scope.provinces = provinces;
      });
    });
  }
}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = "<div> <gmw-box-selector required ng-if=readOnlyCountry readonly=readonly name=currentCountry class=gmw-input-container ng-model=contactInfo.country placeholder=\"{{'Country of current address'|translate}}\" label=\"{{'Current Address Details'|translate}}\" options=countries> </gmw-box-selector> <gmw-box-selector required ng-if=!readOnlyCountry name=currentCountry class=gmw-input-container ng-model=contactInfo.country placeholder=\"{{'Country of current address'|translate}}\" label=\"{{'Current Address Details'|translate}}\" options=countries> </gmw-box-selector> <gmw-box-input-simple name=addressLine1 class=gmw-input-container placeholder=\"{{'Street address'|translate}}\" ng-model=contactInfo.line1 required maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple name=addressLine2 class=gmw-input-container placeholder=\"{{'Street address line 2'|translate}}\" ng-model=contactInfo.line2 no-label=true maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple name=city class=gmw-input-container placeholder=\"{{'City'|translate}}\" ng-model=contactInfo.city required maxlength=50> </gmw-box-input-simple> <gmw-box-input-simple name=province class=gmw-input-container ng-if=\"!provinces || !provinces.length\" placeholder=\"{{provinceLabel|translate}}\" ng-model=contactInfo.province required maxlength=100> </gmw-box-input-simple> <gmw-box-selector name=province class=gmw-input-container ng-if=\"provinces && provinces.length\" required ng-model=contactInfo.province placeholder=\"{{provinceLabel|translate}}\" no-label=true options=provinces> </gmw-box-selector> <gmw-box-input-simple name=zip class=gmw-input-container placeholder=\"{{postCodeLabel|translate}}\" ng-model=contactInfo.zip required maxlength=25> </gmw-box-input-simple> <gmw-box-selector required name=yearsLived class=gmw-input-container ng-model=contactInfo.residenceYears placeholder=\"{{'Number of years at this address'|translate}}\" no-label=true options=yearsLivedOptions> </gmw-box-selector> </div> ";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwEmploymentSelector.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _employmentSelector = __webpack_require__(954);

var _employmentSelector2 = _interopRequireDefault(_employmentSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwEmploymentSelector', gmwEmploymentSelector).name;


function gmwEmploymentSelector(gettextCatalog) {
  'ngInject';

  var employmentOptions = [{ value: 'Employed', label: gettextCatalog.getString('Employed') }, { value: 'SelfEmployed', label: gettextCatalog.getString('Self-Employed') }, { value: 'Unemployed', label: gettextCatalog.getString('Unemployed') }, { value: 'Retired', label: gettextCatalog.getString('Retired') }, { value: 'Homemaker', label: gettextCatalog.getString('Homemaker') }, { value: 'Student', label: gettextCatalog.getString('Student') }, { value: 'Other', label: gettextCatalog.getString('Other') }];

  var employerDurationOptions = [{ value: 0, label: gettextCatalog.getString('Less than 1 year') }, { value: 1, label: gettextCatalog.getString('1-5 years') }, { value: 6, label: gettextCatalog.getString('6-10 years') }, { value: 10, label: gettextCatalog.getString('More than 10 years') }];

  var salaryOptions = [{ value: 'Under $10,000', label: gettextCatalog.getString('Under $10,000') }, { value: '$10,000 - $40,000', label: gettextCatalog.getString('$10,000 - $40,000') }, { value: '$40,000 - $100,000', label: gettextCatalog.getString('$40,000 - $100,000') }, { value: 'Over $100,000', label: gettextCatalog.getString('Over $100,000') }];

  var directive = {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      employment: '='
    },
    template: _employmentSelector2.default
  };
  return directive;

  function link(scope, _element, _attrs) {
    function clearEmploymentData() {
      scope.employment.name = null;
      scope.employment.period = null;
      scope.employment.title = null;
      scope.employment.salary = null;
      scope.employment.address = null;
      scope.employment.nature = null;
    }

    scope.employmentOptions = employmentOptions;
    scope.employerDurationOptions = employerDurationOptions;
    scope.salaryOptions = salaryOptions;

    scope.$watch('employment.status', function (status, prevStatus) {
      if (status !== prevStatus) {
        clearEmploymentData();
      }
    });
  }
}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "<div> <gmw-box-selector required name=employmentStatus class=gmw-input-container ng-model=employment.status placeholder=\"{{'Employment status'|translate}}\" label=\"{{'Employment Status'|translate}}\" options=employmentOptions> <gmw-label-right> <a href=javascript:; class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'As a regulated business, we are required to collect your employment information.'|translate}}\" ng-bind=\"'Why do we ask this?'|translate\"> </a> </gmw-label-right> </gmw-box-selector> <div ng-switch=employment.status> <div ng-switch-when=Employed|SelfEmployed|Unemployed|Retired ng-switch-when-separator=|> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessName ng-if=\"employment.status === 'Employed'\" ng-model=employment.name label=\"{{'Employer\\'s business name'|translate}}\" placeholder=\"{{'Enter employer\\'s business name'|translate}}\" minlength=2 maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessName ng-if=\"employment.status === 'SelfEmployed'\" ng-model=employment.name label=\"{{'Your business name'|translate}}\" placeholder=\"{{'Enter your business name'|translate}}\" minlength=2 maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessName ng-if=\"employment.status === 'Unemployed' || employment.status === 'Retired'\" ng-model=employment.name label=\"{{'Previous employer\\'s business name'|translate}}\" placeholder=\"{{'Enter your previous employer\\'s business name'|translate}}\" minlength=2 maxlength=100> </gmw-box-input-simple> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentPeriod ng-if=\"employment.status === 'Employed'\" ng-model=employment.period label=\"{{'Length of employment'|translate}}\" options=employerDurationOptions> </gmw-box-selector> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentPeriod ng-if=\"employment.status === 'SelfEmployed'\" ng-model=employment.period label=\"{{'Length of self-employment'|translate}}\" options=employerDurationOptions> </gmw-box-selector> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentPeriod ng-if=\"employment.status === 'Unemployed' || employment.status === 'Retired'\" ng-model=employment.period label=\"{{'Length of previous employment'|translate}}\" options=employerDurationOptions> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=employmentTitle ng-model=employment.title label=\"{{'Job title'|translate}}\" ng-if=\"employment.status === 'Employed' || employment.status === 'SelfEmployed'\" placeholder=\"{{'Please enter your current job title'|translate}}\" minlength=3 maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=employmentTitle ng-model=employment.title label=\"{{'Previous job title'|translate}}\" ng-if=\"employment.status === 'Unemployed' || employment.status === 'Retired'\" placeholder=\"{{'Please enter your previous job title'|translate}}\" minlength=3 maxlength=100> </gmw-box-input-simple> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentSalary ng-model=employment.salary ng-if=\"employment.status === 'Employed' || employment.status === 'SelfEmployed'\" label=\"{{'Approximate Yearly Salary (in USD)'|translate}}\" options=salaryOptions> </gmw-box-selector> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentSalary ng-model=employment.salary ng-if=\"employment.status === 'Unemployed' || employment.status === 'Retired'\" label=\"{{'Previous Yearly Salary (in USD)'|translate}}\" options=salaryOptions> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessAddress type=textarea ng-if=\"employment.status === 'Employed'\" ng-model=employment.address label=\"{{'Employer\\'s Business Address'|translate}}\" placeholder=\"{{'Please enter the full mailing address of your employer'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessAddress type=textarea ng-if=\"employment.status === 'SelfEmployed'\" ng-model=employment.address label=\"{{'Your Business Address'|translate}}\" placeholder=\"{{'Please enter the full mailing address of your business'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessAddress type=textarea ng-if=\"employment.status === 'Unemployed' || employment.status === 'Retired'\" ng-model=employment.address label=\"{{'Previous Employer\\'s Business Address'|translate}}\" placeholder=\"{{'Please enter the full mailing address of your previous employer'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessNature type=textarea ng-if=\"employment.status === 'Employed'\" ng-model=employment.nature label=\"{{'Nature of Employer\\'s Business'|translate}}\" placeholder=\"{{'Please provide additional information about your employer'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessNature type=textarea ng-if=\"employment.status === 'SelfEmployed'\" ng-model=employment.nature label=\"{{'Nature of Your Business'|translate}}\" placeholder=\"{{'Please provide additional information about your business'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessNature type=textarea ng-if=\"employment.status === 'Unemployed' || employment.status === 'Retired'\" ng-model=employment.nature label=\"{{'Nature of Previous Employer\\'s Business'|translate}}\" placeholder=\"{{'Please provide additional information about your previous employer'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> </div> <div class=gmw-input-container> <holding-alert-legacy class=warning ng-if=\"employment.nature.length < 30 && employment.status === 'Employed'\"> <span ng-bind=\"'Please ensure that you include detailed information about the nature of your employer\\'s business. Failure to provide detailed employment information can lead to delays in verifying your new Holding.'|translate\"></span> </holding-alert-legacy> <holding-alert-legacy class=warning ng-if=\"employment.nature.length < 30 && employment.status === 'SelfEmployed'\"> <span ng-bind=\"'Please ensure that you include detailed information about the nature of your business. Failure to provide detailed employment information can lead to delays in verifying your new Holding.'|translate\"></span> </holding-alert-legacy> <holding-alert-legacy class=warning ng-if=\"employment.nature.length < 30 && (employment.status === 'Unemployed' || employment.status === 'Retired')\"> <span ng-bind=\"'Please ensure that you include detailed information about the nature of your previous employer\\'s business. Failure to provide detailed employment information can lead to delays in verifying your new Holding.'|translate\"></span> </holding-alert-legacy> </div> </div> <div ng-switch-when=Student> <div class=\"gmw-input-container gmw-input-container--split-half\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=schoolName ng-model=employment.schoolName label=\"{{'School Name'|translate}}\" placeholder=\"{{'Please enter your school name'|translate}}\" minlength=3 maxlength=100> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=schoolProgram ng-model=employment.schoolProgram label=\"{{'Program or Major'|translate}}\" placeholder=\"{{'Please enter your program or major'|translate}}\" minlength=3 maxlength=100> </gmw-box-input-simple> </div> <div class=gmw-input-container> <label class=gmw-input-container__label> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Do you have a part-time job?'|translate\"></span> </label> <div class=gmw-settings-storage-fee-group> <gmw-radio-option class=gmw-settings-storage-fee-group__radio name=studentPartTime checked=\"employment.studentPartTime === true\" label=\"{{'Yes'|translate}}\" ng-click=\"employment.studentPartTime = true\"> </gmw-radio-option> <gmw-radio-option class=gmw-settings-storage-fee-group__radio name=studentPartTime checked=\"employment.studentPartTime === false\" label=\"{{'No'|translate}}\" ng-click=\"employment.studentPartTime = false\"> </gmw-radio-option> </div> </div> <div class=\"gmw-input-container gmw-input-container--split-half\" ng-if=\"employment.studentPartTime === true\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessName ng-model=employment.name label=\"{{'Employer\\'s business name'|translate}}\" placeholder=\"{{'Enter employer\\'s business name'|translate}}\" minlength=2 maxlength=100> </gmw-box-input-simple> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentPeriod ng-model=employment.period label=\"{{'Length of part-time employment'|translate}}\" options=employerDurationOptions> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\" ng-if=\"employment.studentPartTime === true\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=employmentTitle ng-model=employment.title label=\"{{'Part-time job title'|translate}}\" placeholder=\"{{'Please enter your part-time job title'|translate}}\" minlength=3 maxlength=100> </gmw-box-input-simple> <gmw-box-selector class=gmw-input-container--split-half__col required name=employmentSalary ng-model=employment.salary label=\"{{'Approximate yearly salary (in USD)'|translate}}\" options=salaryOptions> </gmw-box-selector> </div> <div class=\"gmw-input-container gmw-input-container--split-half\" ng-if=\"employment.studentPartTime === true\"> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessAddress type=textarea ng-model=employment.address label=\"{{'Employer\\'s business address'|translate}}\" placeholder=\"{{'Please enter the full mailing address of your employer'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <gmw-box-input-simple class=gmw-input-container--split-half__col required name=businessNature type=textarea ng-model=employment.nature label=\"{{'Nature of employment as a student'|translate}}\" placeholder=\"{{'Please provide any additional relevant information about your current or any recent employment'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> </div> <gmw-box-input-simple class=gmw-input-container ng-if=\"employment.studentPartTime === false\" required name=businessNature type=textarea ng-model=employment.nature label=\"{{'Nature of employment as a student'|translate}}\" placeholder=\"{{'Please provide any additional relevant information about your current or any recent employment'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <holding-alert-legacy class=warning ng-if=\"employment.nature.length < 30\"> <span ng-bind=\"'Please ensure that you include detailed information about the nature of your current employment situation. Failure to provide adequate information can lead to delays in verifying your new Holding.'|translate\"></span> </holding-alert-legacy> </div> <div ng-switch-when=Homemaker> <gmw-box-input-simple class=gmw-input-container required name=businessNature type=textarea ng-model=employment.nature label=\"{{'Nature of Employment as a Homemaker'|translate}}\" placeholder=\"{{'Please provide any additional relevant information about your current or any recent employment'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <holding-alert-legacy class=warning ng-if=\"employment.nature.length < 30\"> <span ng-bind=\"'Please ensure that you include detailed information about the nature of your current employment situation. Failure to provide adequate information can lead to delays in verifying your new Holding.'|translate\"></span> </holding-alert-legacy> </div> <div ng-switch-when=Other> <gmw-box-input-simple class=gmw-input-container required name=businessNature type=textarea ng-model=employment.nature label=\"{{'Nature of Employment Status'|translate}}\" placeholder=\"{{'Please provide additional information about your employment status for our review'|translate}}\" minlength=20 maxlength=2000> </gmw-box-input-simple> <holding-alert-legacy class=warning ng-if=\"employment.nature.length < 30\"> <span ng-bind=\"'Please ensure that you include detailed information about the nature of your employment. Failure to provide detailed employment information can lead to delays in verifying your new Holding.'|translate\"></span> </holding-alert-legacy> </div> </div> </div> ";

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _fatcaSelector = __webpack_require__(956);

var _fatcaSelector2 = _interopRequireDefault(_fatcaSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwFatcaSelector', gmwFatcaSelector).name;


function gmwFatcaSelector() {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    require: ['ngModel', '^^?form'],
    restrict: 'E',
    scope: {
      nationalities: '=',
      usLabel: '@',
      ukLabel: '@'
    },
    template: _fatcaSelector2.default,
    transclude: true
  };
  return directive;

  function link(scope, _element, _attrs, ctrls) {
    var ngModel = ctrls[0];
    scope.ngModel = ngModel;
    scope.form = ctrls[1];
    scope.model = {};

    ngModel.$setViewValue([]);
    scope.$watchGroup(['model.USA', 'model.UK'], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          usa = _ref2[0],
          uk = _ref2[1];

      var value = [];
      if (usa) {
        value.push('US');
      }
      if (uk) {
        value.push('GB');
      }
      ngModel.$setViewValue(value);
    });
    scope.hasNationality = function (nationality) {
      return scope.nationalities.some(function (_) {
        return _ === nationality;
      });
    };
  }
}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <div class=\"gmw-input-container__description gmw-input-container__description--bigger\" ng-transclude> </div> <div class=\"h-flex h-margin-top-10\"> <gmw-checkbox class=h-margin-right-40 name=USA ng-if=\"!hasNationality('US')\" ng-model=model.USA> <span translate class=gmw-checkbox__label> United States of America </span> </gmw-checkbox> <gmw-checkbox class=h-margin-right-40 name=UK ng-if=\"!hasNationality('GB')\" ng-model=model.UK> <span translate class=gmw-checkbox__label> United Kingdom </span> </gmw-checkbox> </div> </div> ";

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _genderToggle = __webpack_require__(958);

var _genderToggle2 = _interopRequireDefault(_genderToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwGenderToggle', gmwGenderToggle).name;


function gmwGenderToggle() {
  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    scope: {
      gender: '='
    },
    template: _genderToggle2.default
  };
}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <gmw-toggle-option-group ng-model=gender> <gmw-toggle-option label=\"{{'Male'|translate}}\" value=\"'M'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Female'|translate}}\" value=\"'F'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> ";

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwIdSelector.$inject = ['HoldingCountries'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _idSelector = __webpack_require__(960);

var _idSelector2 = _interopRequireDefault(_idSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwIdSelector', gmwIdSelector).name;


var config = {
  extensions: '.pdf,.png,.gif,.jpg,.jpeg',
  maxFiles: 1,
  maxSize: '8000000'
};

var documentTypes = [{
  label: 'Driver License',
  value: 'DL'
}, {
  label: 'Passport',
  value: 'PP'
}, {
  label: 'Identity Card',
  value: 'ID'
}, {
  label: 'Residence Permit',
  value: 'RP'
}, {
  label: 'Utility Bill',
  value: 'UB'
}];

function gmwIdSelector(HoldingCountries) {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      data: '='
    },
    template: _idSelector2.default
  };
  return directive;

  function link(scope, _element, _attrs, ctrl) {
    scope.countries = HoldingCountries.getAllForSelector();
    scope.config = config;
    scope.documentTypes = documentTypes;
    scope.ngModel = ctrl;

    var model = {
      document: null
    };

    function ctrlValueUpdated(newDoc) {
      scope.model.document = newDoc;
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        ctrl.$setViewValue(newDoc);
      }
    }

    scope.model = angular.copy(model);

    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(function () {
      return ctrl.$viewValue;
    }, ctrlValueUpdated);
  }
}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{\n    'gmw-verification-flow-container__small-inner': model.document.length < 1,\n    'gmw-verification-split-form': model.document.length > 0,\n  }\"> <div class=gmw-verification-requirements ng-if=\"!model.document || model.document.length < 1\"> <div> <div class=gmw-verification-requirements__title ng-bind=\"'Photo ID Criteria'|translate\"> </div> <ul class=gmw-verification-requirements__list> <li> <span ng-bind=\"'Must be clearly legible'|translate\"></span> </li> <li> <span ng-bind=\"'Must be current and valid'|translate\"></span> </li> <li> <span ng-bind=\"'Must be government issued'|translate\"></span> </li> </ul> </div> <div> <div class=gmw-verification-requirements__title ng-bind=\"'Accepted Photo IDs'|translate\"> </div> <ul class=gmw-verification-requirements__list> <li> <span ng-bind=\"'Passport'|translate\"></span> </li> <li> <span ng-bind=\"'Drivers License (for US, Canada, and UK only)'|translate\"></span> </li> <li> <span ng-bind=\"'National ID'|translate\"></span> </li> </ul> </div> </div> <holding-drag-and-drop file-types=config.extensions max-files=config.maxFiles max-size=config.maxSize ng-model=model.document ng-if=\"!model.document || model.document.length < 1\" parent-error=\"ngModel.$$parentForm.$submitted && ngModel.$invalid\"> </holding-drag-and-drop> <div class=gmw-verification-split-form__col ng-if=\"model.document.length > 0\"> <holding-file-upload-preview ng-model=model.document> </holding-file-upload-preview> </div> <div class=gmw-verification-split-form__col ng-if=\"model.document.length > 0\"> <gmw-box-selector required name=documentType class=gmw-input-container ng-model=data.metadata.value.imType options=documentTypes label=\"{{'Document Type'|translate}}\"> </gmw-box-selector> <gmw-box-input-simple required name=documentNumber class=gmw-input-container placeholder=\"{{'Document number'|translate}}\" label=\"{{'Document Number'|translate}}\" ng-model=data.metadata.value.number> </gmw-box-input-simple> <gmw-box-selector required name=country class=gmw-input-container ng-model=data.metadata.value.issuingCountry options=countries label=\"{{'Issuing Country'|translate}}\"> </gmw-box-selector> <gmw-date-selector name=date required label=\"Expiration Date\" future ng-model=data.metadata.value.expirationDate> </gmw-date-selector> </div> </div> ";

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwOnboardingHeader.$inject = ['$rootScope', 'Environment'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _onboardingHeader = __webpack_require__(962);

var _onboardingHeader2 = _interopRequireDefault(_onboardingHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwOnboardingHeader', gmwOnboardingHeader).name;


function gmwOnboardingHeader($rootScope, Environment) {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    template: _onboardingHeader2.default
  };

  function link(scope) {
    var navOpen = void 0;

    function activate() {
      navOpen = false;
    }

    function isNavOpen() {
      return navOpen;
    }

    function toggleNav() {
      navOpen = !navOpen;

      var pageClasses = $rootScope.pageParams.pageBodyClass.split(' ');
      if (navOpen) {
        pageClasses.push('no-scroll');
        $rootScope.pageParams.pageBodyClass = pageClasses.join(' ');
      } else {
        pageClasses.splice(pageClasses.indexOf('no-scroll'), 1);
        $rootScope.pageParams.pageBodyClass = pageClasses.join(' ');
      }
    }

    scope.isNavOpen = isNavOpen;
    scope.siteUrl = Environment.urls.site;
    scope.supportUrl = Environment.urls.support.main;
    scope.toggleNav = toggleNav;

    activate();
  }
}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = " <header class=onboarding-header> <div class=onboarding-header__top> <div class=\"_wrapper onboarding-header__container\"> <div class=onboarding-header__logo-container> <a href=\"{{siteUrl}}/\"> <svg class=onboarding-header__logo> <use xlink:href=#goldmoney-logo-22></use> </svg> </a> </div> <a href=\"{{supportUrl}}\" class=h-default-link translate> Support </a> </div> </div> </header>";

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reviewRow = __webpack_require__(964);

var _reviewRow2 = _interopRequireDefault(_reviewRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwReviewRow', gmwReviewRow).name;


function gmwReviewRow() {
  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      label: '@',
      modify: '@?'
    },
    template: _reviewRow2.default
  };
}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-verification-review__row> <div class=\"gmw-verification-review__col gmw-verification-review__col--label\" ng-bind=label> </div> <div class=\"gmw-verification-review__col h-dark-text\" ng-transclude> </div> <div class=\"gmw-verification-review__col gmw-verification-review__col--modify\" ng-if=modify> <a class=h-blue-link ng-bind=\"'Modify'|translate\" ui-sref=\"{{modify}}\"> </a> </div> </div> ";

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signInHero = __webpack_require__(966);

var _signInHero2 = _interopRequireDefault(_signInHero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwSignInHero', gmwSignInHero).name;


function gmwSignInHero() {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {},
    template: _signInHero2.default
  };

  function link(scope, _element, attrs) {
    scope.heading = attrs.heading || '';
  }
}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = "<section class=initial-onboarding-hero> <div class=initial-onboarding-hero__content> <h1 class=heading-h1 ng-bind=heading></h1> </div> </section> ";

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwSourceOfFunds.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _sourceOfFunds = __webpack_require__(968);

var _sourceOfFunds2 = _interopRequireDefault(_sourceOfFunds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwSourceOfFunds', gmwSourceOfFunds).name;


function gmwSourceOfFunds(gettextCatalog) {
  'ngInject';

  var options = [{ value: 'Compensation', label: gettextCatalog.getString('Compensation payment') }, { value: 'Gift', label: gettextCatalog.getString('Gift') }, { value: 'Inheritance', label: gettextCatalog.getString('Inheritance or distribution of trust') }, { value: 'Investment', label: gettextCatalog.getString('Investment income (e.g. dividends)') }, { value: 'Loan', label: gettextCatalog.getString('Loan') }, { value: 'Betting', label: gettextCatalog.getString('Lottery, betting, casino winnings') }, { value: 'Insurance', label: gettextCatalog.getString('Maturity of insurance policy or fixed term investment') }, { value: 'Retirement', label: gettextCatalog.getString('Pensions, retirement income') }, { value: 'Salary', label: gettextCatalog.getString('Salary or bonus') }, { value: 'SaleOfBusiness', label: gettextCatalog.getString('Sale of business') }, { value: 'SaleOfInvestments', label: gettextCatalog.getString('Profit realised on sale of investments') }, { value: 'SaleOfProperty', label: gettextCatalog.getString('Profit realised on sale of property') }, { value: 'Other', label: gettextCatalog.getString('Other') }];

  var directive = {
    link: link,
    replace: true,
    require: ['ngModel', '^^?form'],
    restrict: 'E',
    scope: {
      label: '@'
    },
    template: _sourceOfFunds2.default
  };
  return directive;

  function link(scope, _element, _attrs, ctrls) {
    var ngModel = ctrls[0];
    scope.options = options;
    scope.ngModel = ngModel;
    scope.form = ctrls[1];
    scope.model = {};

    ngModel.$formatters.push(function (value) {
      if (value) {
        scope.model.type = value.type;
        scope.model.description = value.description;
      } else {
        scope.model = {};
      }
    });

    scope.$watchGroup(['model.type', 'model.description'], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          description = _ref2[1];

      if (type && description) {
        ngModel.$setViewValue({ type: type, description: description });
      } else {
        ngModel.$setViewValue(undefined);
      }
    });
  }
}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <gmw-box-selector required name=sourceOfFunds class=gmw-input-container ng-model=model.type placeholder=\"{{'Please select'|translate}}\" label=\"{{label}}\" options=options> <gmw-label-right> <a href=# class=\"h-blue-link h-small-text\" gmw-tooltip=\"{{'As a regulated business we are required to collect the primary source of your funds.'|translate}}\" translate> Why do we ask this? </a> </gmw-label-right> </gmw-box-selector> <div class=gmw-input-container ng-if=model.type> <div class=gmw-input-container__description> <span ng-bind=\"'Please provide additional information:'|translate\"></span> <div ng-switch=model.type> <ul class=gmw-basic-list ng-switch-when=Compensation> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Reason for payment'|translate\"></span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Total amount received'|translate\"></span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date received'|translate\"></span> </li> </ul> <ul class=gmw-basic-list ng-switch-when=Gift> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Relationship with the donor'|translate\"></span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Total amount received'|translate\"></span> </li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date received'|translate\"></span> </li> </ul> <ul class=gmw-basic-list ng-switch-when=Inheritance> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Name and address of executor or trustee'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Amount received'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of receipt'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=Investment> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Description of investment'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Amount of investment'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date and amount of investment income received'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=Loan> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date, term and amount of the loan'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Name and address of the lender'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=Insurance> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Full description of policy or investment'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of maturity'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Maturity proceeds'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=Retirement> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Retirement date'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Name and address of employer'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Occupation'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Pension amount'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Final salary'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=Salary> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Name and address of employer'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Annual salary or bonus amount'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Dates employed'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=SaleOfBusiness> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Business name'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Nature of business'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of sale'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Total amount'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Customer\\'s share'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=SaleOfInvestments> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of sale'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of original purchase'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Description of investment'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Original purchase cost'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Total amount of sale proceeds'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=SaleOfProperty> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of sale'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date of original purchase'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Address of property'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Original purchase cost'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Total amount of sale proceeds'|translate\"> </span></li> </ul> <ul class=gmw-basic-list ng-switch-when=SaleOfProperty> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Amount received'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Date received'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'Nature of source'|translate\"> </span></li> <li class=\"gmw-basic-list__item h-medium-text\"> <span class=h-base-text ng-bind=\"'If savings, how generated? (e.g. salary over x years)'|translate\"> </span></li> </ul> </div> </div> <gmw-box-input-simple name=years class=gmw-input-container type=textarea ng-model=model.description minlength=4 required> </gmw-box-input-simple> <holding-alert-legacy class=warning ng-if=\"model.description.length < 50\"> <span ng-bind=\"'Please ensure that you include enough detailed information on your Source of Funds to allow us to verify your Holding. Failure to provide the items specified in the list above is one of the most common causes for Holding verification delays.'|translate\"></span> </holding-alert-legacy> </div> </div> ";

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwTitleToggle.$inject = ['gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _titleToggle = __webpack_require__(970);

var _titleToggle2 = _interopRequireDefault(_titleToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwTitleToggle', gmwTitleToggle).name;


function gmwTitleToggle(gettextCatalog) {
  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    scope: {
      title: '='
    },
    template: _titleToggle2.default,
    link: function link(scope) {
      scope.translate = function (s) {
        return gettextCatalog.getString(s);
      };
    }
  };
}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-input-container> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" translate>Title</label> <gmw-toggle-option-group ng-model=title> <gmw-toggle-option label=\"{{'Mr'|translate}}\" value=\"translate('Mr')\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Mrs'|translate}}\" value=\"translate('Mrs')\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Ms'|translate}}\" value=\"translate('Ms')\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Dr'|translate}}\" value=\"translate('Dr')\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> ";

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwValidatePassword', gmwValidatePassword).name;


function gmwValidatePassword() {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    require: 'ngModel'
  };
  return directive;

  function link(_scope, _element, _attrs, ctrl) {
    ctrl.$validators.validPassword = function validPassword(modelValue, viewValue) {
      var value = modelValue || viewValue;

      var result = !value || angular.isString(value) && value.length >= 8 && value.length <= 50 && value.match(/\d/) !== null && value.match(/[a-zA-Z]/) && !value.match(/['"\\/]/) // disallow " ' / \
      ;
      return result;
    };
  }
}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _verificationRequirement = __webpack_require__(973);

var _verificationRequirement2 = _interopRequireDefault(_verificationRequirement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwVerificationRequirement', gmwVerificationRequirement).name;


function gmwVerificationRequirement() {
  'ngInject';

  var directive = {
    replace: true,
    restrict: 'E',
    scope: {
      image: '@'
    },
    template: _verificationRequirement2.default,
    transclude: true
  };
  return directive;
}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-verification-requirements__col> <div class=gmw-verification-requirements__icon-container> <img ng-src=\"/img/{{image}}.png\" srcset=\"/img/{{image}}.png, /img/{{image}}@2x.png 2x\"> </div> <holding-svg-icon icon=checkmark class=\"gmw-verification-requirements__checkmark mobile-only mobile-only--xxs\"> </holding-svg-icon> <span class=heading-h6 ng-transclude> </span> </div> ";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _verificationStep = __webpack_require__(975);

var _verificationStep2 = _interopRequireDefault(_verificationStep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.onboarding').directive('gmwVerificationStep', gmwVerificationStep).name;


function gmwVerificationStep() {
  'ngInject';

  var directive = {
    link: link,
    replace: true,
    restrict: 'E',
    scope: {
      destination: '@',
      number: '@',
      status: '=',
      code: '=?',
      continue: '=?'
    },
    template: _verificationStep2.default,
    transclude: {
      description: 'gmwVerificationStepDescription',
      additionalStatus: '?gmwVerificationStepAdditionalStatus'
    }
  };
  return directive;

  function link(scope, _element, _attrs, _ctrl, transclude) {
    scope.hasAdditionalStatus = transclude.isSlotFilled('additionalStatus');
  }
}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-verification-step ng-class=\"{\n    'gmw-verification-step--disabled': status !== 'Required' && status !== 'Complete' && !continue,\n    'gmw-verification-step--secondary': isSecondary }\"> <i ng-if=!isSecondary class=\"gmw-verification-step__number h-gold-text heading-h1 desktop-only desktop-only--xs\" ng-bind=number> </i> <div class=gmw-verification-step__inner> <div class=gmw-verification-step__description ng-transclude=description> </div> <div class=gmw-verification-step__status> <div class=gmw-verification-step__status-inner> <span class=\"mobile-only mobile-only--xs\">Status:&nbsp;</span> <span class=h-dark-text> <span ng-bind=status></span> </span> <i ng-if=\"status !== 'Complete'\" class=\"gmw-verification-step__status-icon gmw-verification-step__status-icon--pending desktop-only desktop-only--xs\"> <svg width=21 height=5> <use xlink:href=#ellipsis-icon></use> </svg> </i> </div> <div ng-if=hasAdditionalStatus class=h-margin-top-10 ng-transclude=additionalStatus> </div> </div> </div> <div class=h-flex ng-switch=status> <div class=\"gmw-verification-step__action gmw-verification-step__action--go\" ng-switch-when=Required ui-state=destination ui-state-params=\"{code: code}\"> <holding-svg-icon class=gmw-verification-step__arrow icon=right-arrow> </holding-svg-icon> </div> <div class=\"gmw-verification-step__action gmw-verification-step__action--go\" ng-switch-when=Pending> <holding-svg-icon class=gmw-verification-step__arrow icon=right-arrow> </holding-svg-icon> </div> <div class=\"gmw-verification-step__action gmw-verification-step__action--go\" ng-switch-when=UnderReview ng-if=continue ui-state=destination ui-state-params=\"{code: code}\"> <holding-svg-icon class=gmw-verification-step__arrow icon=right-arrow> </holding-svg-icon> </div> <div class=\"gmw-verification-step__action gmw-verification-step__action--complete\" ng-switch-when=Complete> <holding-svg-icon class=gmw-verification-step__check icon=checkmark> </holding-svg-icon> </div> </div> </div> ";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getFullName(name) {
    if (name.middleName) {
        return name.firstName + ' ' + name.middleName + ' ' + name.lastName;
    } else {
        return name.firstName + ' ' + name.lastName;
    }
}
function hasUploaded(entity, type) {
    return entity.requiredDocs.some(function (doc) {
        return doc.uploadType === type && doc.uploaded;
    });
}
function mapEntity(entity, index) {
    var hasCompletedSetup = entity.hasCompletedSetup;
    // If id upload is pending, hasCompletedSetup will be true
    var hasUploadedId = hasCompletedSetup || hasUploaded(entity, 'PhotoId');
    var shouldVerify = entity.shouldVerify;
    return {
        address: entity.address,
        code: entity.code,
        isPrimary: index === 0,
        hasCompletedPersonalDetails: entity.hasCompletedPersonalDetails,
        hasCompletedSetup: hasCompletedSetup,
        hasUploadedId: hasUploadedId,
        hasUploadedPOA: hasUploaded(entity, 'ProofOfResidence'),
        name: getFullName(entity.name),
        verification: {
            canUseJumio: shouldVerify && !!entity.jumioVerification && entity.jumioVerification.remainingAttempts > 0,
            canUseMail: shouldVerify && entity.postVerificationRequired,
            canUsePostIdent: shouldVerify && entity.postidentVerificationRequired,
            jumio: entity.jumioVerification,
            pendingJumio: !!entity.jumioVerification && entity.jumioVerification.pendingVerifications > 0,
            verified: entity.verified
        }
    };
}

var GmwSetup = exports.GmwSetup = function () {
    function GmwSetup(promiseCache, HoldingApi, HoldingUser) {
        var _this = this;

        _classCallCheck(this, GmwSetup);

        this.promiseCache = promiseCache;
        this.HoldingApi = HoldingApi;
        this.HoldingUser = HoldingUser;
        this.completeSetup = function () {
            var promise = _this.HoldingApi.post('verification/submit');
            return promise.then(function (_ref) {
                var holdingPermissions = _ref.holdingPermissions;

                _this.HoldingUser.init(holdingPermissions);
                _this.promiseCache.remove('hasCompletedSetup');
                _this.promiseCache.remove('needsVerification');
                _this.promiseCache.remove('setupStatus');
            });
        };
        this.hasCompletedSetup = function () {
            return _this.promiseCache({
                ttl: -1,
                key: 'hasCompletedSetup',
                promise: function promise() {
                    return _this.getSetupStatus().then(function (setupData) {
                        return setupData.verificationSubmitted;
                    });
                }
            });
        };
        this.getSetupStatus = function (bustCache) {
            return _this.promiseCache({
                bustCache: bustCache,
                ttl: -1,
                key: 'setupStatus',
                promise: function promise() {
                    return _this.HoldingApi.get('verification', { ignore403: true }).then(function (result) {
                        var entities = result.entities.map(mapEntity);
                        var hasCompletedSetup = entities.every(function (e) {
                            return e.hasCompletedSetup;
                        });
                        return {
                            additionalVerificationRequested: result.additionalVerificationRequested,
                            emails: result.emails,
                            entities: entities,
                            expectedUse: result.expectedUse,
                            hasCompletedSetup: hasCompletedSetup,
                            isFullHolding: result.isFullHolding,
                            remainingOwners: result.remainingOwners,
                            verificationSubmitted: result.verificationSubmitted,
                            verified: result.verified
                        };
                    });
                }
            });
        };
        this.needsVerification = function () {
            return _this.promiseCache({
                ttl: -1,
                key: 'needsVerification',
                promise: function promise() {
                    return _this.getSetupStatus().then(function (setupData) {
                        return setupData.isFullHolding && setupData.hasCompletedSetup && setupData.additionalVerificationRequested;
                    });
                }
            });
        };
    }

    _createClass(GmwSetup, [{
        key: 'addOwner',
        value: function addOwner(addEntityRequest) {
            return this.HoldingApi.post('verification/add', addEntityRequest);
        }
    }, {
        key: 'updateExpectedUse',
        value: function updateExpectedUse(data) {
            return this.HoldingApi.post('verification/expectedUse', data);
        }
    }, {
        key: 'uploadId',
        value: function uploadId(file, metadata) {
            return this.HoldingApi.upload('verification/upload', file, metadata);
        }
    }, {
        key: 'uploadPor',
        value: function uploadPor(file, metadata) {
            return this.HoldingApi.upload('verification/upload', file, metadata);
        }
    }, {
        key: 'verifyProfile',
        value: function verifyProfile(data) {
            return this.HoldingApi.post('verification/verify', data);
        }
    }]);

    return GmwSetup;
}();

GmwSetup.$inject = ['promiseCache', 'HoldingApi', 'HoldingUser'];
angular.module('app.holding.dashboard.onboarding').service('GmwSetup', GmwSetup);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GmwSecurityQuestions = exports.GmwSecurityQuestions = function () {
    function GmwSecurityQuestions(HoldingApi) {
        _classCallCheck(this, GmwSecurityQuestions);

        this.HoldingApi = HoldingApi;
    }

    _createClass(GmwSecurityQuestions, [{
        key: 'getSecurityQuestions',
        value: function getSecurityQuestions() {
            var questionsPromise = this.HoldingApi.get('security/questions');
            return questionsPromise.then(function (questions) {
                return questions.map(function (question) {
                    return {
                        value: question.id,
                        label: question.value
                    };
                });
            });
        }
    }, {
        key: 'skip',
        value: function skip() {
            return this.HoldingApi.post('security/questions/skip');
        }
    }, {
        key: 'submitAnswers',
        value: function submitAnswers(qa) {
            return this.HoldingApi.post('security/questions', { qa: qa });
        }
    }]);

    return GmwSecurityQuestions;
}();

GmwSecurityQuestions.$inject = ['HoldingApi'];
angular.module('app.holding.dashboard.onboarding').service('GmwSecurityQuestions', GmwSecurityQuestions);

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


GmwSignUp.$inject = ['promiseCache', 'HoldingApi', 'HoldingAuth', 'HoldingProperties'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.onboarding').factory('GmwSignUp', GmwSignUp).name;


function GmwSignUp(promiseCache, HoldingApi, HoldingAuth, HoldingProperties) {
  'ngInject';

  return {
    signUpPersonal: signUpPersonal
  };

  function signUpPersonal(data) {
    return HoldingApi.post('signup', data).then(function (user) {
      var riskDisclosure = data.riskDisclosure;

      if (riskDisclosure) {
        HoldingProperties.load().then(function () {
          HoldingAuth.agreeToRiskDisclosure();
        });
      }

      promiseCache.remove('hasCompletedSetup');
      return user;
    }).then(HoldingAuth.processSession);
  }
}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _profile = __webpack_require__(980);

var _profile2 = _interopRequireDefault(_profile);

var _security = __webpack_require__(994);

var _security2 = _interopRequireDefault(_security);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ngModule = angular.module('app.holding.dashboard.settings', [_profile2.default, _security2.default]);

exports.default = ngModule.name;


__webpack_require__(1006);
__webpack_require__(1008);
__webpack_require__(1009);

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _hero = __webpack_require__(981);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(982);

var _main2 = _interopRequireDefault(_main);

var _flow = __webpack_require__(983);

var _flow2 = _interopRequireDefault(_flow);

var _notifications = __webpack_require__(984);

var _notifications2 = _interopRequireDefault(_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ngModule = angular.module('app.holding.dashboard.settings-profile', [_common2.default, _angularjs2.default]);

ngModule.controller(_notifications2.default.controller, _notifications2.default.controllerFunction);

var settingsOverviewCfg = __webpack_require__(986);
var settingsOverviewProfileTpl = __webpack_require__(988);
var settingsOverviewEmailTpl = __webpack_require__(989);
var settingsOverviewCodeTpl = __webpack_require__(990);
var settingsOverviewCompleteTpl = __webpack_require__(991);
var settingsPreferencesCfg = __webpack_require__(992);

ngModule.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  var _$stateProvider$state;

  $stateProvider.state('settings-profile', {
    parent: 'holding.dashboard',
    url: '/profile',
    views: {
      hero: {
        controller: ['HoldingSettings', function controller(HoldingSettings) {
          'ngInject';

          this.showNotificationSettings = HoldingSettings.showNotificationSettings();
        }],
        controllerAs: 'settingsProfileHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-profile.notifications', {
    url: '/notifications',
    views: {
      'settings-profile-main': _notifications2.default
    },
    data: {
      skipSetupCheck: true
    },
    resolve: _notifications2.default.resolve
  }).state('settings-profile.overview', (_$stateProvider$state = {
    url: '/overview',
    views: {
      'settings-profile-main': settingsOverviewCfg
    },
    data: {
      flow: _flow2.default
    }
  }, _defineProperty(_$stateProvider$state, 'data', {
    skipSetupCheck: true
  }), _defineProperty(_$stateProvider$state, 'resolve', settingsOverviewCfg.resolve), _$stateProvider$state)).state('settings-profile.overview.info', {
    url: '/info',
    views: {
      step: {
        template: settingsOverviewProfileTpl
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-profile.overview.email', {
    url: '/email',
    views: {
      step: {
        template: settingsOverviewEmailTpl
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-profile.overview.code', {
    url: '/code',
    views: {
      step: {
        template: settingsOverviewCodeTpl
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-profile.overview.complete', {
    url: '/complete',
    views: {
      step: {
        template: settingsOverviewCompleteTpl
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-profile.preferences', {
    url: '/preferences',
    views: {
      'settings-profile-main': settingsPreferencesCfg
    },
    data: {
      skipSetupCheck: true
    },
    resolve: settingsPreferencesCfg.resolve
  });

  $urlRouterProvider.when('/profile', '/profile/overview');
  $urlRouterProvider.when('/profile/overview', '/profile/overview/info');
}]);

exports.default = ngModule.name;

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Manage Profile'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Overview'|translate\" ui-sref=settings-profile.overview ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true,\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Preferences'|translate\" ui-sref=settings-profile.preferences ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true,\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Notifications'|translate\" ng-if=settingsProfileHeroCtrl.showNotificationSettings ui-sref=settings-profile.notifications ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true,\n        }\"> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=settings-profile-main></div> ";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var flow = {
    steps: [{
        key: 'info',
        state: 'settings-profile.overview.info'
    }, {
        key: 'email',
        state: 'settings-profile.overview.email'
    }, {
        key: 'code',
        state: 'settings-profile.overview.code'
    }, {
        key: 'complete',
        state: 'settings-profile.overview.complete',
        complete: true
    }]
};
exports.default = flow;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SettingsNotificationsController.$inject = ['$log', '$scope', '$timeout', 'HoldingSettings', 'emailNotificationPreferences'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notifications = __webpack_require__(985);

var _notifications2 = _interopRequireDefault(_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _notifications2.default,
  controller: 'SettingsNotificationsController',
  controllerAs: 'settingsNotificationsCtrl',
  controllerFunction: SettingsNotificationsController,
  resolve: {
    emailNotificationPreferences: ['HoldingSettings', function emailNotificationPreferences(HoldingSettings) {
      'ngInject';

      return HoldingSettings.getEmailNotificationSettings();
    }]
  }
};


function SettingsNotificationsController($log, $scope, $timeout, HoldingSettings, emailNotificationPreferences) {
  'ngInject';

  var DEFAULT_MODEL = {
    preferences: {}
  };

  var vm = this;

  var savedAlertTimer = void 0;

  vm.displaySavedAlert = false;
  vm.getPreferenceDescription = getPreferenceDescription;
  vm.isSaving = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.selectPreference = selectPreference;
  vm.updateEmailNotificationPreferences = updateEmailNotificationPreferences;

  function activate() {
    vm.allowedNotificationValues = emailNotificationPreferences.allowedValues;
    vm.currentNotificationValues = emailNotificationPreferences.currentValues;
    vm.pinFlags = emailNotificationPreferences.pinFlags;

    vm.allowedNotificationValues = {};
    HoldingSettings.getEmailNotificationOrder().then(function (order) {
      Object.keys(emailNotificationPreferences.allowedValues).sort(function (a, b) {
        return order.indexOf(a) > order.indexOf(b);
      }).forEach(function (key) {
        vm.allowedNotificationValues[key] = emailNotificationPreferences.allowedValues[key];
      });

      return HoldingSettings.getEmailNotificationLevelOrder();
    }).then(function (order) {
      Object.keys(vm.allowedNotificationValues).forEach(function (notificationPreference) {
        vm.allowedNotificationValues[notificationPreference] = vm.allowedNotificationValues[notificationPreference].sort(function (a, b) {
          return order.indexOf(a) > order.indexOf(b);
        });
        vm.model.preferences[notificationPreference] = vm.currentNotificationValues[notificationPreference];
      });
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function displaySavedAlert() {
    vm.displaySavedAlert = true;
    savedAlertTimer = $timeout(function () {
      vm.displaySavedAlert = false;
    }, 10000);
  }

  function getPreferenceDescription(notificationPreference) {
    return HoldingSettings.getEmailNotificationDescription(notificationPreference);
  }

  function onDestroy() {
    $timeout.cancel(savedAlertTimer);
  }

  function selectPreference(notificationPreference, value) {
    vm.model.preferences[notificationPreference] = value;
  }

  function updateEmailNotificationPreferences() {
    vm.isSaving = true;
    HoldingSettings.updateEmailNotificationPreferences(vm.model.preferences).then(function () {
      displaySavedAlert();
    }).catch(function (error) {
      $log.error(error);

      if (vm.notificationsForm) {
        if ('data' in error && 'code' in error.data) {
          switch (error.data.code) {
            case 'INVALID_INPUT':
              vm.notificationsForm.$setValidity('input', false);
              vm.errorMessage = error.data.message;
              break;
            default:
              vm.notificationsForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.notificationsForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSaving = false;
    });
  }

  $scope.$on('$destroy', onDestroy);

  activate();
}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsNotificationsCtrl.notificationsForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Email Notifications'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-bind=\"'Please choose under which circumstances you would like to receive an email from us.'|translate\"> </p> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsNotificationsCtrl.notificationsForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsNotificationsCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=success ng-if=settingsNotificationsCtrl.displaySavedAlert> <span ng-bind=\"'Your notification settings have been updated.'|translate\"></span> </holding-alert-legacy> <section class=gmw-settings-notifications-grid> <div class=gmw-settings-notifications-grid-item ng-repeat=\"(emailNotification, options) in settingsNotificationsCtrl.allowedNotificationValues track by $index\"> <span class=\"gmw-settings-notifications-grid-item__label heading-h4 h-dark-text\" ng-bind=settingsNotificationsCtrl.getPreferenceDescription(emailNotification)> </span> <div class=gmw-settings-notifications-grid-item__toggle-wrapper> <div class=gmw-settings-notifications-grid-item__toggle ng-repeat=\"option in options track by $index\"> <gmw-radio-option ng-if=\"option === 'NONE'\" name=\"{{emailNotification}}\" checked=\"settingsNotificationsCtrl.model.preferences[emailNotification] === option\" label=\"{{'None' | translate}}\" ng-click=\"settingsNotificationsCtrl.selectPreference(emailNotification, option)\"> </gmw-radio-option> <gmw-radio-option ng-if=\"option === 'SUMMARY'\" name=\"{{emailNotification}}\" checked=\"settingsNotificationsCtrl.model.preferences[emailNotification] === option\" label=\"{{'Summary' | translate}}\" ng-click=\"settingsNotificationsCtrl.selectPreference(emailNotification, option)\"> </gmw-radio-option> <gmw-radio-option ng-if=\"option === 'DETAILED'\" name=\"{{emailNotification}}\" checked=\"settingsNotificationsCtrl.model.preferences[emailNotification] === option\" label=\"{{'Detailed' | translate}}\" ng-click=\"settingsNotificationsCtrl.selectPreference(emailNotification, option)\"> </gmw-radio-option> </div> </div> </div> </section> <div class=gmw-settings-notifications-extra> <span class=gmw-settings-notifications-extra__item translate> If you would like to disable these features, please <a class=h-blue-link ui-sref=holding.dashboard.messages.compose>contact our Relationship Management team</a>. </span> <span class=gmw-settings-notifications-extra__item> <span translate>Withdraw funds transfer PIN code:</span> <span class=h-dark-text ng-if=settingsNotificationsCtrl.pinFlags.rftr translate> Enabled </span> <span class=h-dark-text ng-if=!settingsNotificationsCtrl.pinFlags.rftr translate> Disabled </span> </span> <span class=gmw-settings-notifications-extra__item> <span translate>Delivery PIN code:</span> <span class=h-dark-text ng-if=settingsNotificationsCtrl.pinFlags.delivery translate> Enabled </span> <span class=h-dark-text ng-if=!settingsNotificationsCtrl.pinFlags.delivery translate> Disabled </span> </span> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsNotificationsCtrl.isSaving\n        }\" holding-button-disabled=settingsNotificationsCtrl.notificationsForm.$invalid ng-click=settingsNotificationsCtrl.updateEmailNotificationPreferences()> <span ng-bind=\"'Update'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SettingsOverviewController.$inject = ['$controller', '$log', '$state', '$scope', 'HoldingSettings', 'HoldingUser', 'GmwModal', 'profile', 'gettextCatalog'];
var _overview = __webpack_require__(987);

var _overview2 = _interopRequireDefault(_overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _overview2.default,
  controller: 'SettingsOverviewController',
  controllerAs: 'settingsOverviewCtrl',
  resolve: {
    profile: ['HoldingSettings', function profile(HoldingSettings) {
      'ngInject';

      return HoldingSettings.getProfile();
    }]
  }
};

angular.module('app.holding.dashboard.settings-profile').controller(module.exports.controller, SettingsOverviewController);

function SettingsOverviewController($controller, $log, $state, $scope, HoldingSettings, HoldingUser, GmwModal, profile, gettextCatalog) {
  'ngInject';

  var DEFAULT_MODEL = [];

  var vm = this;
  vm.steps = {
    'settings-profile.overview.email': {
      checks: [{
        function: checkEmailSelected,
        revertTo: 'settings-profile.overview.info'
      }]
    },
    'settings-profile.overview.code': {
      checks: [{
        function: checkCodeExists,
        revertTo: 'settings-profile.overview.info'
      }]
    },
    'settings-profile.overview.complete': {
      checks: [{
        function: checkCodeSubmitted,
        revertTo: 'settings-profile.overview.info'
      }]
    }
  };

  var emailSelected = false;
  var codeGenerated = false;
  var codeSubmitted = false;

  vm.initiateEmailChange = initiateEmailChange;
  vm.isEmailReset = false;
  vm.isModifyingEmail = isModifyingEmail;
  vm.isResendingCode = false;
  vm.isSaving = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.modifyEmail = modifyEmail;
  vm.resendEmailCode = resendEmailCode;
  vm.submitEmailChange = submitEmailChange;
  vm.submitEmailReset = submitEmailReset;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    vm.model.profiles = angular.copy(profile.profiles);
    vm.model.profiles.map(function (userProfile) {
      userProfile.address = formatAddress(userProfile.address);
      userProfile.phone = formatPhone(userProfile.telephone1);
      return userProfile;
    });

    vm.canEditContactInfo = HoldingUser.isAllowed('editContactInfo');
    vm.canEditSecondaryEmail = HoldingUser.isAllowed('setSecondaryEmail');

    HoldingSettings.getEmailSecurityQuestions().then(function (_ref) {
      var questions = _ref.questions;

      vm.model.questions = questions.map(function (question) {
        return { question: question };
      }).sort(function (a, b) {
        return a.question.number > b.question.number;
      });
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function checkEmailSelected() {
    return emailSelected;
  }

  function checkCodeExists() {
    return codeGenerated;
  }

  function checkCodeSubmitted() {
    return codeSubmitted;
  }

  function formatAddress(address) {
    var street = 'line2' in address && address.line2.length > 0 ? address.line1 + '\n' + address.line2 : '' + address.line1;
    var city = 'city' in address && address.city.length > 0 ? '\n' + address.city : '\n';
    var state = 'state' in address && address.state.length > 0 ? ', ' + address.state : '';
    var country = 'countryCC2' in address && address.countryCC2.length > 0 ? '\n' + address.countryCC2 : '\n';
    var zip = 'zip' in address && address.zip.length > 0 ? ', ' + address.zip : '';

    return '' + street + city + state + country + zip;
  }

  function formatPhone(phone) {
    var telTypeDescription = void 0;
    switch (phone.telType) {
      case 'H':
        telTypeDescription = gettextCatalog.getString('(Home)');
        break;
      case 'W':
        telTypeDescription = gettextCatalog.getString('(Work)');
        break;
      case 'M':
        telTypeDescription = gettextCatalog.getString('(Mobile/Cell)');
        break;
      default:
        telTypeDescription = '';
    }
    return telTypeDescription + ' +' + phone.prefix + ' ' + phone.number;
  }

  function initiateEmailChange() {
    var uploadPrompt = gettextCatalog.getString('Complete Captcha');
    return GmwModal.showCaptchaModal(uploadPrompt).then(function (captcha) {
      if (captcha) {
        var emailChangeType = vm.isPrimaryEmail ? HoldingSettings.EMAIL_CHANGE_TYPES.PRIMARY : HoldingSettings.EMAIL_CHANGE_TYPES.SECONDARY;

        vm.isSaving = true;
        vm.model.captcha = captcha;
        HoldingSettings.requestEmailPin(emailChangeType, vm.model.newEmail, vm.model.captcha).then(function () {
          codeGenerated = true;
          $state.go('settings-profile.overview.code');
        }).catch(function (error) {
          $log.error(error);
          if (vm.emailForm) {
            if (error && 'code' in error) {
              switch (error.code) {
                case 'INVALID_INPUT':
                  vm.emailForm.$setValidity('input', false);
                  vm.errorMessage = error.message;
                  break;
                default:
                  vm.emailForm.$setValidity('unknown', false);
                  break;
              }
            } else {
              vm.emailForm.$setValidity('unknown', false);
            }
          }
        }).finally(function () {
          vm.isSaving = false;
        });
      }
      return false;
    });
  }

  function isModifyingEmail() {
    if ('isPrimaryEmail' in vm) {
      if (vm.isPrimaryEmail) {
        return 'primaryEmail' in vm.model.profiles[0] ? vm.model.profiles[0].primaryEmail.length > 0 : false;
      }
      return 'secondaryEmail' in vm.model.profiles[0] ? vm.model.profiles[0].secondaryEmail.length > 0 : false;
    }
    return false;
  }

  function modifyEmail() {
    var isPrimaryEmail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    emailSelected = true;

    vm.isPrimaryEmail = isPrimaryEmail;
    $state.go('settings-profile.overview.email');
  }

  function resendEmailCode() {
    var uploadPrompt = gettextCatalog.getString('Complete Captcha');
    vm.isResendingCode = true;
    GmwModal.showCaptchaModal(uploadPrompt).then(function (captcha) {
      vm.model.captcha = captcha;
      initiateEmailChange().then(function () {
        vm.isResendingCode = false;
      }).catch(function (error) {
        $log.error(error);
      });
    });
  }

  function submitEmailChange() {
    var emailChangeType = vm.isPrimaryEmail ? HoldingSettings.EMAIL_CHANGE_TYPES.PRIMARY : HoldingSettings.EMAIL_CHANGE_TYPES.SECONDARY;

    vm.isSaving = true;
    HoldingSettings.submitEmailChange(emailChangeType, vm.model.newEmail, vm.model.code).then(function () {
      codeSubmitted = true;
      $state.go('settings-profile.overview.complete');
    }).catch(function (error) {
      $log.error(error);
      if (vm.codeForm) {
        if (error && 'code' in error) {
          switch (error.code) {
            case 'INVALID_INPUT':
              vm.codeForm.$setValidity('input', false);
              vm.errorMessage = error.message;
              break;
            default:
              vm.codeForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.codeForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSaving = false;
    });
  }

  function submitEmailReset() {
    vm.isSaving = true;
    HoldingSettings.submitEmailReset(vm.model.newEmail, vm.model.questions).then(function () {
      codeSubmitted = true;
      vm.isEmailReset = true;
      $state.go('settings-profile.overview.complete');
    }).catch(function (error) {
      $log.error(error);
      if (vm.codeForm) {
        if ('data' in error && 'code' in error.data) {
          switch (error.data.code) {
            case 'INVALID_INPUT':
              vm.codeForm.$setValidity('input', false);
              vm.errorMessage = error.data.message;
              break;
            default:
              vm.codeForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.codeForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSaving = false;
    });
  }

  activate();
}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsOverviewCtrl.preferencesForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Contact Details'|translate\"> </h2> <p class=gmw-flow-box__header-description translate> Please confirm your contact information is correct. Should your details change, please modify your information below or notify your personal Relationship Manager via <a class=h-blue-link ui-sref=\"holding.dashboard.messages.compose({ category: 'CONTACT', })\">secure message</a>. </p> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsOverviewCtrl.preferencesForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsOverviewCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=success ng-if=settingsOverviewCtrl.displaySavedAlert> <span ng-bind=\"'Your preference settings have been updated.'|translate\"></span> </holding-alert-legacy> <section class=gmw-settings-section ng-repeat=\"profile in settingsOverviewCtrl.model.profiles track by $index\"> <div class=\"gmw-settings-section__heading h-large-text h-margin-bottom-30\" translate> Owner Contact Details </div> <div class=h-flex-col> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Name'|translate\"> </span> </div> <div class=gmw-settings-container__col> <gmw-box-input ng-disabled=true name=name ng-model=profile.name placeholder=\"{{'Please enter a name'|translate}}\" no-label=true> </gmw-box-input> </div> </div> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Address'|translate\"> </span> <a class=\"h-medium-text h-blue-link\" ng-if=settingsOverviewCtrl.canEditContactInfo ui-sref=\"holding.dashboard.messages.compose({\n                category: 'CONTACT',\n                subject: 'Contact details change request for ' + profile.name,\n              })\" ng-bind=\"'Modify'|translate\"> </a> </div> <div class=gmw-settings-container__col> <gmw-box-input ng-disabled=true name=address type=textarea ng-model=profile.address placeholder=\"{{'Please enter an address'|translate}}\" no-label=true> </gmw-box-input> </div> </div> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Telephone'|translate\"> </span> <a class=\"h-medium-text h-blue-link\" ng-if=settingsOverviewCtrl.canEditContactInfo ui-sref=\"holding.dashboard.messages.compose({\n                category: 'CONTACT',\n                subject: 'Telephone change request for ' + profile.name,\n              })\" ng-bind=\"'Modify'|translate\"> </a> </div> <div class=gmw-settings-container__col> <gmw-box-input ng-disabled=true name=phone ng-model=profile.phone placeholder=\"{{'Please enter a telephone number'|translate}}\" no-label=true> </gmw-box-input> </div> </div> </div> </section> </div> </div> ";

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsOverviewCtrl.emailForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-if=settingsOverviewCtrl.isPrimaryEmail ng-bind=\"'Enter New Primary Email Address'|translate\"> </h2> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-if=!settingsOverviewCtrl.isPrimaryEmail ng-bind=\"'Enter New Secondary Email Address'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-if=\"settingsOverviewCtrl.isModifyingEmail() && settingsOverviewCtrl.isPrimaryEmail\"> <span ng-bind=\"'Your Current Primary Email Address is:'|translate\"></span> <span class=h-dark-text ng-bind=settingsOverviewCtrl.model.profiles[0].primaryEmail></span> </p> <p class=gmw-flow-box__header-description ng-if=\"settingsOverviewCtrl.isModifyingEmail() && !settingsOverviewCtrl.isPrimaryEmail\"> <span ng-bind=\"'Your Current Secondary Email Address is:'|translate\"></span> <span class=h-dark-text ng-bind=settingsOverviewCtrl.model.profiles[0].secondaryEmail></span> </p> <p class=gmw-flow-box__header-description> <span ng-bind=\"'Before we can add a new email address, you will receive a confirmation email with a security code which we ask you to enter on the next page.'|translate\"></span> </p> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsOverviewCtrl.emailForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsOverviewCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=gmw-input-container> <gmw-box-input required name=name type=email ng-if=settingsOverviewCtrl.isPrimaryEmail ng-model=settingsOverviewCtrl.model.newEmail placeholder=\"{{'Email address'|translate}}\" label=\"{{'Enter your new email address'|translate}}\"> </gmw-box-input> <gmw-box-input required name=name type=email ng-if=!settingsOverviewCtrl.isPrimaryEmail ng-model=settingsOverviewCtrl.model.newEmail placeholder=\"{{'Email address'|translate}}\" label=\"{{'Enter your new secondary email address'|translate}}\"> </gmw-box-input> <div class=gmw-input-container__tooltip ng-if=settingsOverviewCtrl.isModifyingEmail()> <a href class=\"h-blue-link tooltip-bottom\" ng-click=\"settingsOverviewCtrl.showForgotReset = true\" ng-bind=\"'No longer have access to your current email address?'|translate\"></a> </div> </div> <section class=gmw-answer-security-questions ng-if=settingsOverviewCtrl.showForgotReset> <label class=\"gmw-answer-security-questions__title heading-h4 h-dark-text\" ng-bind=\"'Answer the following security questions'|translate\"> </label> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=\"gmw-input-container--split-half__col gmw-answer-security-questions__label\"> <span> <span class=h-dark-text ng-bind=settingsOverviewCtrl.model.questions[0].question.number> </span>. <span ng-bind=settingsOverviewCtrl.model.questions[0].question.question></span> </span> </div> <gmw-box-input required name=securityQuestionOne class=gmw-input-container--split-half__col ng-model=settingsOverviewCtrl.model.questions[0].answer placeholder=\"{{'Enter answer'|translate}}\" no-label=true> </gmw-box-input> </div> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=\"gmw-input-container--split-half__col gmw-answer-security-questions__label\"> <span> <span class=h-dark-text ng-bind=settingsOverviewCtrl.model.questions[1].question.number> </span>. <span ng-bind=settingsOverviewCtrl.model.questions[1].question.question></span> </span> </div> <gmw-box-input required name=securityQuestionTwo class=gmw-input-container--split-half__col ng-model=settingsOverviewCtrl.model.questions[1].answer placeholder=\"{{'Enter answer'|translate}}\" no-label=true> </gmw-box-input> </div> </section> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsOverviewCtrl.isSaving\n        }\" ng-if=!settingsOverviewCtrl.showForgotReset holding-button-disabled=settingsOverviewCtrl.emailForm.$invalid ng-click=settingsOverviewCtrl.initiateEmailChange()> <span ng-bind=\"'Next Step'|translate\"></span> </button> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsOverviewCtrl.isSaving\n        }\" ng-if=settingsOverviewCtrl.showForgotReset holding-button-disabled=settingsOverviewCtrl.emailForm.$invalid ng-click=settingsOverviewCtrl.submitEmailReset()> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsOverviewCtrl.codeForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Enter Security Code from Email'|translate\"> </h2> <p class=gmw-flow-box__header-description> <span ng-if=settingsOverviewCtrl.isPrimaryEmail translate> Your request to change your Primary Email Address to {{settingsOverviewCtrl.model.newEmail}} has been logged. Please check your email <span class=h-dark-text>{{settingsOverviewCtrl.model.profiles[0].primaryEmail}}</span> for a message from Goldmoney, which will include a security code. Insert the security code into the box below and click 'Next Step'. </span> <span ng-if=!settingsOverviewCtrl.isPrimaryEmail translate> Your request to change your Secondary Email Address to {{settingsOverviewCtrl.model.newEmail}} has been logged. Please check your email <span class=h-dark-text>{{settingsOverviewCtrl.model.profiles[0].secondaryEmail}}</span> for a message from Goldmoney, which will include a security code. Insert the security code into the box below and click 'Next Step'. </span> </p> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsOverviewCtrl.codeForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsOverviewCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=success> <span ng-bind=\"'Security code was sent to'|translate\"></span> <span ng-bind=settingsOverviewCtrl.model.profiles[0].primaryEmail></span> </holding-alert-legacy> <div class=gmw-input-container> <gmw-box-input required name=code ng-model=settingsOverviewCtrl.model.code placeholder=\"{{'Security code'|translate}}\" label=\"Enter security code\"> </gmw-box-input> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <button class=\"medium-border-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsOverviewCtrl.isResendingCode\n        }\" ng-click=settingsOverviewCtrl.resendEmailCode()> <span ng-bind=\"'Re-Send Code'|translate\"></span> </button> </div> <div class=gmw-flow-box-footer__col> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsOverviewCtrl.isSaving && !settingsOverviewCtrl.isResendingCode\n        }\" holding-button-disabled=settingsOverviewCtrl.codeForm.$invalid ng-click=settingsOverviewCtrl.submitEmailChange()> <span ng-bind=\"'Next Step'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\"> <gmw-generic-complete-header ng-if=\"!settingsOverviewCtrl.isEmailReset && settingsOverviewCtrl.isPrimaryEmail\" title=\"{{'Your Primary Email Address has been updated'|translate}}\"> </gmw-generic-complete-header> <gmw-generic-complete-header ng-if=\"!settingsOverviewCtrl.isEmailReset && !settingsOverviewCtrl.isPrimaryEmail\" title=\"{{'Your Secondary Email Address has been updated'|translate}}\"> </gmw-generic-complete-header> <gmw-generic-complete-header pending=true ng-if=\"settingsOverviewCtrl.isEmailReset && settingsOverviewCtrl.isPrimaryEmail\" title=\"{{'Your request to update your Primary Email Address has been sent'|translate}}\"> </gmw-generic-complete-header> <gmw-generic-complete-header pending=true ng-if=\"settingsOverviewCtrl.isEmailReset && !settingsOverviewCtrl.isPrimaryEmail\" title=\"{{'Your request to update your Secondary Email Address has been sent'|translate}}\"> </gmw-generic-complete-header> <div class=gmw-flow-box-container> <div class=gmw-flow-box__callout ng-if=!settingsOverviewCtrl.isEmailReset> <div class=h-margin-bottom-20> <span ng-if=settingsOverviewCtrl.isPrimaryEmail translate> Your Primary email Address has been updated to <span class=h-dark-text>{{settingsOverviewCtrl.model.newEmail}}</span>. All future correspondence from Goldmoney will now be sent to your Primary Email Address, as well as your Secondary Email Address if you also have a Secondary Email Address recorded in your Holding. </span> <span ng-if=!settingsOverviewCtrl.isPrimaryEmail translate> Your Secondary email Address has been updated to <span class=h-dark-text>{{settingsOverviewCtrl.model.newEmail}}</span>. All future correspondence from Goldmoney will now be sent to your Primary Email Address, as well as your Secondary Email Address if you also have a Secondary Email Address recorded in your Holding. </span> </div> <span ng-bind=\"'If you change your email in the future, always update the email address recorded in your Holding first.'|translate\"></span> </div> <div class=gmw-flow-box__callout ng-if=settingsOverviewCtrl.isEmailReset> <div class=h-margin-bottom-20> <span ng-if=settingsOverviewCtrl.isPrimaryEmail translate> Your request to update your Primary Email Address To {{settingsOverviewCtrl.model.newEmail}} has been sent. You will receive a response within the next business day. </span> <span ng-if=!settingsOverviewCtrl.isPrimaryEmail translate> Your request to update your Secondary Email Address To {{settingsOverviewCtrl.model.newEmail}} has been sent. You will receive a response within the next business day. </span> </div> <div> <span ng-if=settingsOverviewCtrl.isPrimaryEmail translate> A Goldmoney Support Representative may contact you by telephone before effecting the change of your Primary Email Address. </span> <span ng-if=!settingsOverviewCtrl.isPrimaryEmail translate> A Goldmoney Support Representative may contact you by telephone before effecting the change of your Secondary Email Address. </span> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-border-cta gmw-responsive-button\" ui-sref=settings-profile.overview ui-sref-opts=\"{\n          reload: true,\n        }\"> <span ng-bind=\"'Return to Overview'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SettingsPreferencesController.$inject = ['$log', '$q', '$scope', '$rootScope', '$timeout', 'HoldingPreferences', 'HoldingCurrencies', 'HoldingTimezones', 'HoldingUser', 'HoldingMetals', 'PreferencesResolve', 'HoldingTransfers'];
var _preferences = __webpack_require__(993);

var _preferences2 = _interopRequireDefault(_preferences);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  controller: 'SettingsPreferencesController',
  controllerAs: 'settingsPreferencesCtrl',
  resolve: {
    PreferencesResolve: ['$q', 'HoldingPreferences', function PreferencesResolve($q, HoldingPreferences) {
      'ngInject';

      var deferred = $q.defer();
      HoldingPreferences.getPreferences().then(function (preferences) {
        deferred.resolve(preferences);
      }).catch(function (error) {
        deferred.resolve(error);
      });
      return deferred.promise;
    }]
  },
  template: _preferences2.default
};

angular.module('app.holding.dashboard.settings-profile').controller('SettingsPreferencesController', SettingsPreferencesController);

function SettingsPreferencesController($log, $q, $scope, $rootScope, $timeout, HoldingPreferences, HoldingCurrencies, HoldingTimezones, HoldingUser, HoldingMetals, PreferencesResolve, HoldingTransfers) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  var savedAlertTimer = void 0;

  vm.displaySavedAlert = false;
  vm.isSaving = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.selectStorageFeeOption = selectStorageFeeOption;
  vm.updatePreferences = updatePreferences;

  function activate() {
    vm.user = HoldingUser.get();
    vm.model.transferAlias = vm.user.alias;
    vm.model.preferences = PreferencesResolve;
    vm.model.storageCurrency = 'storageCurrency' in PreferencesResolve ? 'currency' : 'metal';

    vm.showTransferAliasSetting = HoldingUser.isAllowed('receivePayment');

    HoldingPreferences.getAccountPurposeTypesForSelector().then(function (accountPurposeOptions) {
      vm.accountPurposeOptions = accountPurposeOptions;
      vm.currencyDisplayOptions = HoldingCurrencies.getAllFiatForSelectorWithName();
      vm.timezoneDisplayOptions = HoldingTimezones.getAllForSelectorWithName();
      vm.unitDisplayOptions = HoldingMetals.getAllUnitsForSelectorWithName();
    }).catch(function (error) {
      $log.error(error);
    });
  }

  function displaySavedAlert() {
    vm.displaySavedAlert = true;
    savedAlertTimer = $timeout(function () {
      vm.displaySavedAlert = false;
    }, 10000);
  }

  function onDestroy() {
    $timeout.cancel(savedAlertTimer);
  }

  function onStorageCurrencyChange(newStoragePref) {
    if (newStoragePref === 'currency') {
      vm.storageCurrencyDisplayOptions = HoldingCurrencies.getAllFiatForSelectorWithName();
    } else {
      vm.model.preferences.storageCurrency = null;
      vm.storageCurrencyDisplayOptions = null;
    }
  }

  function selectStorageFeeOption(feePreference) {
    vm.model.storageCurrency = feePreference;
  }

  function updatePreferences() {
    vm.errorMessage = null;
    vm.isSaving = true;

    $q.all([HoldingPreferences.updatePreferences(vm.model.preferences), HoldingTransfers.updateTransferAlias(vm.model.transferAlias)]).then(function () {
      displaySavedAlert();
      $rootScope.$broadcast('gmw:settings:profile:preferences:updated');
    }).catch(function (error) {
      $log.error(error);
      vm.errorMessage = error.message;
    }).finally(function () {
      vm.isSaving = false;
    });
  }

  $scope.$on('$destroy', onDestroy);
  $scope.$watch(function () {
    return vm.model.storageCurrency;
  }, onStorageCurrencyChange);

  activate();
}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsPreferencesCtrl.preferencesForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Holding Preferences'|translate\"> </h2> <p class=gmw-flow-box__header-description translate> Please choose your preferences and click <span class=h-dark-text>Update</span> below. </p> </header> <div class=gmw-flow-box-container> <holding-alert-legacy class=error ng-if=settingsPreferencesCtrl.errorMessage> <span ng-bind=settingsPreferencesCtrl.errorMessage></span> </holding-alert-legacy> <holding-alert-legacy class=success ng-if=settingsPreferencesCtrl.displaySavedAlert> <span ng-bind=\"'Your preference settings have been updated.'|translate\"></span> </holding-alert-legacy> <section class=h-flex-col> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Display Currency'|translate\"> </span> </div> <div class=gmw-settings-container__col> <gmw-box-selector required name=currency ng-model=settingsPreferencesCtrl.model.preferences.displayCurrency options=settingsPreferencesCtrl.currencyDisplayOptions placeholder=\"{{'Select display currency'|translate}}\" no-label=true> </gmw-box-selector> </div> </div> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Metal Weight'|translate\"> </span> </div> <div class=gmw-settings-container__col> <gmw-box-selector required name=unit ng-model=settingsPreferencesCtrl.model.preferences.metalUnit options=settingsPreferencesCtrl.unitDisplayOptions placeholder=\"{{'Select metal unit'|translate}}\" no-label=true> </gmw-box-selector> </div> </div> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Time Zone'|translate\"> </span> </div> <div class=gmw-settings-container__col> <gmw-box-selector required name=timezone ng-model=settingsPreferencesCtrl.model.preferences.timezone options=settingsPreferencesCtrl.timezoneDisplayOptions placeholder=\"{{'Select timezone'|translate}}\" no-label=true> </gmw-box-selector> </div> </div> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Purpose of Holding'|translate\"> </span> </div> <div class=gmw-settings-container__col> <gmw-box-selector required name=reason ng-model=settingsPreferencesCtrl.model.preferences.holdingPurpose.reason options=settingsPreferencesCtrl.accountPurposeOptions placeholder=\"{{'Select reason'|translate}}\" no-label=true meta-text=\"{{'What\\'s This?'|translate}}\" meta-description=\"{{'This is your reason or purpose for having a Holding with Goldmoney. As a regulated business, we are required to collect this information from our customers.'|translate}}\"> </gmw-box-selector> <gmw-box-input required ng-if=\"settingsPreferencesCtrl.model.preferences.holdingPurpose.reason === 'OTHER'\" name=reasonDescription ng-model=settingsPreferencesCtrl.model.preferences.holdingPurpose.description placeholder=\"{{'Please enter a reason'|translate}}\"> </gmw-box-input> </div> </div> <div class=gmw-settings-container> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Payment of Storage Fees'|translate\"> </span> </div> <div class=gmw-settings-container__col> <div class=gmw-settings-storage-fee-group> <gmw-radio-option class=gmw-settings-storage-fee-group__radio name=feesMetal checked=\"settingsPreferencesCtrl.model.storageCurrency === 'metal'\" label=\"{{'Metal'|translate}}\" ng-click=\"settingsPreferencesCtrl.selectStorageFeeOption('metal')\"> </gmw-radio-option> <gmw-radio-option name=feesCurrency class=gmw-settings-storage-fee-group__radio checked=\"settingsPreferencesCtrl.model.storageCurrency === 'currency'\" label=\"{{'Currency'|translate}}\" ng-click=\"settingsPreferencesCtrl.selectStorageFeeOption('currency')\"> </gmw-radio-option> </div> <gmw-box-selector ng-if=\"settingsPreferencesCtrl.model.storageCurrency === 'currency'\" ng-required=\"settingsPreferencesCtrl.model.storageCurrency === 'currency'\" class=h-margin-bottom-30 name=currency ng-model=settingsPreferencesCtrl.model.preferences.storageCurrency options=settingsPreferencesCtrl.storageCurrencyDisplayOptions placeholder=\"{{'Select currency'|translate}}\" no-label=true meta-text=\"{{'About Storage Fees'|translate}}\" meta-url=https://www.goldmoney.com/why-goldmoney> </gmw-box-selector> </div> </div> <div class=gmw-settings-container ng-if=settingsPreferencesCtrl.showTransferAliasSetting> <div class=gmw-settings-container__col> <span class=\"heading-h4 h-dark-text\" ng-bind=\"'Transfer Alias'|translate\"> </span> </div> <div class=gmw-settings-container__col> <holding-transfer-alias-input name=alias ng-minlength=6 ng-maxlength=20 ng-model=settingsPreferencesCtrl.model.transferAlias> </holding-transfer-alias-input> </div> </div> </section> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsPreferencesCtrl.isSaving\n        }\" holding-button-disabled=settingsPreferencesCtrl.preferencesForm.$invalid ng-click=settingsPreferencesCtrl.updatePreferences()> <span ng-bind=\"'Update'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _hero = __webpack_require__(995);

var _hero2 = _interopRequireDefault(_hero);

var _main = __webpack_require__(996);

var _main2 = _interopRequireDefault(_main);

var _holdingSecurityFlow = __webpack_require__(997);

var _holdingSecurityFlow2 = _interopRequireDefault(_holdingSecurityFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ngModule = angular.module('app.holding.dashboard.settings-security', [_common2.default, _angularjs2.default]);

var settingsSecurityBankAccountCfg = __webpack_require__(998);

var settingsSecurityHoldingCfg = __webpack_require__(1000);
var settingsSecurityHoldingLandingTpl = __webpack_require__(1002);
var settingsSecurityHoldingSmsTpl = __webpack_require__(1003);
var settingsSecurityIpCfg = __webpack_require__(1004);

ngModule.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('settings-security', {
    parent: 'holding.dashboard',
    url: '/security',
    views: {
      hero: {
        controller: ['HoldingSettings', function controller(HoldingSettings) {
          'ngInject';

          this.showLockBankAccount = HoldingSettings.showLockBankAccount();
        }],
        controllerAs: 'settingsSecurityHeroCtrl',
        template: _hero2.default
      },
      main: {
        template: _main2.default
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-security.bank-account', {
    url: '/bank-account',
    views: {
      'settings-security-main': settingsSecurityBankAccountCfg
    },
    resolve: settingsSecurityBankAccountCfg.resolve,
    data: {
      skipSetupCheck: true
    }
  }).state('settings-security.holding', {
    url: '/?stateId',
    views: {
      'settings-security-main': settingsSecurityHoldingCfg
    },
    data: {
      flow: _holdingSecurityFlow2.default,
      skipSetupCheck: true
    }
  }).state('settings-security.holding.landing', {
    url: 'holding',
    views: {
      step: {
        template: settingsSecurityHoldingLandingTpl
      }
    },
    data: {
      skipSetupCheck: true
    }
  }).state('settings-security.holding.sms', {
    url: 'sms/:type',
    views: {
      step: {
        template: settingsSecurityHoldingSmsTpl
      }
    },
    data: {
      heroNoMobileActionTabs: true,
      skipSetupCheck: true
    }
  }).state('settings-security.ip', {
    url: '/ip',
    views: {
      'settings-security-main': settingsSecurityIpCfg
    },
    data: {
      skipSetupCheck: true
    },
    resolve: settingsSecurityIpCfg.resolve
  });

  $urlRouterProvider.when('/security', '/security/');
  $urlRouterProvider.when('/security/', '/security/holding');
}]);

exports.default = ngModule.name;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls></holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Manage Security'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Holding'|translate\" ui-sref=settings-security.holding ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'Bank Accounts'|translate\" ng-if=settingsSecurityHeroCtrl.showLockBankAccount ui-sref=settings-security.bank-account ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> <holding-dashboard-hero-actions-tabs-item label=\"'IP Access List'|translate\" mobile-label=\"'IP List'|translate\" ui-sref=settings-security.ip ui-sref-active=holding-dashboard-hero-actions-tabs-item--active ui-sref-opts=\"{\n          reload: true\n        }\"> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper ui-view=settings-security-main></div> ";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Holding Security'),
    sidebar: false,
    steps: [{
        key: 'landing',
        state: 'settings-security.holding.landing',
        heading: (0, _gettext2.default)('Holding Security')
    }, {
        key: 'sms',
        state: 'settings-security.holding.sms',
        heading: (0, _gettext2.default)('Update SMS Telephone Number')
    }]
};
exports.default = flow;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SettingsSecurityBankAccountController.$inject = ['$log', '$rootScope', 'HoldingSettings', 'bankAccounts', 'LockStatus'];
var _bankAccount = __webpack_require__(999);

var _bankAccount2 = _interopRequireDefault(_bankAccount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _bankAccount2.default,
  controller: 'SettingsSecurityBankAccountController',
  controllerAs: 'settingsSecurityBankAccountCtrl',
  resolve: {
    bankAccounts: ['$q', 'HoldingBankAccounts', function bankAccounts($q, HoldingBankAccounts) {
      'ngInject';

      var deferred = $q.defer();
      HoldingBankAccounts.get().then(function (accounts) {
        deferred.resolve(accounts);
      }).catch(function (error) {
        deferred.resolve(error);
      });
      return deferred.promise;
    }],
    LockStatus: ['$q', 'HoldingSettings', function LockStatus($q, HoldingSettings) {
      'ngInject';

      var deferred = $q.defer();
      HoldingSettings.getBankAccountLockStatus().then(function (_ref) {
        var locked = _ref.locked;

        deferred.resolve(locked);
      }).catch(function (error) {
        deferred.resolve(error);
      });
      return deferred.promise;
    }]
  }
};

angular.module('app.holding.dashboard.settings-security').controller(module.exports.controller, SettingsSecurityBankAccountController);

function SettingsSecurityBankAccountController($log, $rootScope, HoldingSettings, bankAccounts, LockStatus) {
  'ngInject';

  var vm = this;

  vm.isSaving = false;
  vm.updateLockStatus = updateLockStatus;

  function activate() {
    vm.bankAccounts = bankAccounts;
    vm.lockStatus = LockStatus;
  }

  function updateLockStatus() {
    vm.isSaving = true;
    HoldingSettings.lockBankAccounts().then(function () {
      vm.lockStatus = true;
      $rootScope.$broadcast('gmw:settings:security:bankAccounts:updated');
    }).catch(function (error) {
      $log.error(error);

      if (vm.bankAccountForm) {
        if ('data' in error && 'code' in error.data) {
          switch (error.data.code) {
            case 'INVALID_INPUT':
              vm.bankAccountForm.$setValidity('input', false);
              vm.errorMessage = error.data.message;
              break;
            default:
              vm.bankAccountForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.bankAccountForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSaving = false;
    });
  }

  activate();
}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-if=settingsSecurityBankAccountCtrl.lockStatus> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Lock Bank Accounts'|translate\"> </h2> </header> <div class=gmw-flow-box-container> <holding-alert-legacy class=success> <span ng-bind=\"'Your bank accounts are locked.'|translate\"></span> </holding-alert-legacy> <p class=gmw-flow-box__description> <span ng-bind=\"'Should you wish to unlock your bank accounts, please send us a'|translate\"></span> <a class=h-blue-link ui-sref=\"holding.dashboard.messages.compose({\n          category: 'OTHER',\n          subject: 'Remove bank account lock',\n        })\" ng-bind=\"'secure message.'|translate\"></a> </p> </div> </div> <div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-if=!settingsSecurityBankAccountCtrl.lockStatus ng-form=settingsSecurityBankAccountCtrl.bankAccountForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Lock Bank Accounts'|translate\"> </h2> <p class=gmw-flow-box__header-description> <span ng-bind=\"'In case your computer is compromised, this feature is useful to further protect your Holding. By locking your bank account(s) you are ensuring that no further bank accounts may be added, and any monies will only be transferred into those bank accounts listed below.'|translate\"></span> </p> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsSecurityBankAccountCtrl.bankAccountForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsSecurityBankAccountCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <gmw-main-table small=true ng-if=\"settingsSecurityBankAccountCtrl.bankAccounts.length > 0\"> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Nickname'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Currency'|translate\"> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row ng-repeat=\"account in settingsSecurityBankAccountCtrl.bankAccounts track by account.code\"> <gmw-main-table-body-col class=h-light-text ng-bind=::account.nickName.value|gmwTruncate:20> </gmw-main-table-body-col> <gmw-main-table-body-col class=h-light-text> <gmw-flag country=account.currencyCode.value|holdingCurrencyCountry></gmw-flag> <span ng-bind=::account.currencyCode.value></span> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <p class=gmw-flow-box__description translate> Please be certain that you have added all the bank accounts you expect to use with Goldmoney, before they are locked. Once locked, no other bank accounts may be added. Click the <span class=h-dark-text>Lock</span> button if you wish to <span class=h-dark-text>permanently lock</span> the above accounts to this Holding, preventing adding bank accounts in the future. </p> <p class=gmw-flow-box__description translate> Should you wish to unlock your bank accounts, please send us a <a class=h-blue-link ui-sref=\"holding.dashboard.messages.compose({\n          category: 'OTHER',\n          subject: 'Remove bank account lock',\n        })\">secure message. </a> </p> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsSecurityBankAccountCtrl.isSaving\n        }\" holding-button-disabled=settingsSecurityBankAccountCtrl.bankAccountForm.$invalid ng-click=settingsSecurityBankAccountCtrl.updateLockStatus()> <span ng-bind=\"'Lock'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SettingsSecurityHoldingController.$inject = ['$controller', '$log', '$scope', '$state', '$stateParams', '$timeout', 'HoldingSettings', 'GmwModal', 'HoldingUser', 'gettextCatalog'];
var _holding = __webpack_require__(1001);

var _holding2 = _interopRequireDefault(_holding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _holding2.default,
  controller: 'SettingsSecurityHoldingController',
  controllerAs: 'settingsSecurityHoldingCtrl'
};

angular.module('app.holding.dashboard.settings-security').controller(module.exports.controller, SettingsSecurityHoldingController);

function SettingsSecurityHoldingController($controller, $log, $scope, $state, $stateParams, $timeout, HoldingSettings, GmwModal, HoldingUser, gettextCatalog) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;
  vm.steps = {
    'settings-security.holding.sms': {
      checks: [{
        function: checkCodeExists,
        revertTo: 'settings-security.holding.landing'
      }]
    }
  };

  var codeGenerated = false;
  var savedAlertTimer = void 0;

  vm.areTransfersDisabled = false;
  vm.displayPasswordSavedAlert = false;
  vm.isDisablingTransfers = false;
  vm.isSavingPassword = false;
  vm.isSavingSms = false;
  vm.lockTransfers = lockTransfers;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.removeSmsNumber = removeSmsNumber;
  vm.requestSmsPin = requestSmsPin;
  vm.requestSmsRemovePin = requestSmsRemovePin;
  vm.showSmsPinSettings = HoldingUser.isAllowed('enableSMS');
  vm.updatePassword = updatePassword;
  vm.updateSmsNumber = updateSmsNumber;

  function activate() {
    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    if (vm.showSmsPinSettings) {
      vm.isSmsPinEnabled = false;
      vm.user = HoldingUser.get();
      if ('smsTelephoneNumber' in vm.user && vm.user.smsTelephoneNumber.length > 0) {
        vm.model.smsTelephoneNumber = angular.copy(vm.user.smsTelephoneNumber);
        vm.isSmsPinEnabled = true;
      }
    }

    if ('stateId' in $stateParams && angular.isString($stateParams.stateId) && $stateParams.stateId.length > 0) {
      switch ($stateParams.stateId) {
        case 'smsAdded':
          vm.showStateMessage = 'smsAdded';
          break;
        case 'smsRemoved':
          vm.showStateMessage = 'smsRemoved';
          break;
        default:
          break;
      }
    }

    vm.showTransferLockFeature = !HoldingUser.isHidden('makePayment');
    if (vm.showTransferLockFeature) {
      var makeTransferPermissions = HoldingUser.getPermission('makePayment');
      vm.areTransfersDisabled = makeTransferPermissions.message == 'lock';
    }
  }

  function checkCodeExists() {
    return codeGenerated;
  }

  function clearPasswordForm() {
    vm.model = angular.copy(DEFAULT_MODEL);
    if (vm.passwordForm) {
      vm.passwordForm.$setUntouched();
      vm.passwordForm.$setPristine();
    }
  }

  function displayPasswordSavedAlert() {
    vm.displayPasswordSavedAlert = true;
    savedAlertTimer = $timeout(function () {
      vm.displayPasswordSavedAlert = false;
    }, 10000);
  }

  function lockTransfers() {
    vm.isDisablingTransfers = true;
    HoldingSettings.lockTransfers().then(function () {
      vm.areTransfersDisabled = true;

      vm.displayTransfersLockedAlert = true;
      savedAlertTimer = $timeout(function () {
        vm.displayTransfersLockedAlert = false;
      }, 10000);
    }).catch(function (error) {
      $log.error(error);
      if (vm.holdingForm) {
        vm.holdingForm.$setValidity('unknown', false);
      }
    }).finally(function () {
      vm.isDisablingTransfers = false;
    });
  }

  function onDestroy() {
    $timeout.cancel(savedAlertTimer);
  }

  function onPasswordChanged(newPassword, oldPassword) {
    if (newPassword !== oldPassword) {
      if (vm.holdingForm) {
        vm.holdingForm.$setValidity('input', true);
        vm.holdingForm.$setValidity('unknown', true);
      }

      if (vm.passwordForm) {
        vm.passwordForm.$setUntouched();
        vm.passwordForm.$setPristine();
      }
    }
  }

  function onPinChanged(newPin, OldPin) {
    if (newPin !== OldPin) {
      if (vm.holdingForm) {
        vm.holdingForm.$setValidity('input', true);
        vm.holdingForm.$setValidity('unknown', true);
      }
    }
  }

  function onNewPasswordChanged(newPassword, oldPassword) {
    if (newPassword !== oldPassword) {
      if (vm.holdingForm) {
        vm.holdingForm.$setValidity('input', true);
        vm.holdingForm.$setValidity('unknown', true);
      }

      if (vm.passwordForm) {
        vm.passwordForm.$setUntouched();
        vm.passwordForm.$setPristine();
        vm.passwordForm.newPasswordRepeat.$setUntouched();
        vm.passwordForm.newPasswordRepeat.$setPristine();
      }
      vm.model.newPasswordRepeat = '';
    }
  }

  function removeSmsNumber() {
    vm.isSavingSms = true;
    HoldingSettings.removeSmsNumber(vm.model.pin).then(function () {
      codeGenerated = true;
      vm.smsState = 'remove';
      $state.go('settings-security.holding.landing', {
        stateId: 'smsRemoved'
      }, {
        reload: true
      });
    }).catch(function (error) {
      $log.error(error);
      if (vm.holdingForm) {
        if (error && 'code' in error) {
          switch (error.code) {
            case 'INVALID_INPUT':
            case 'NOT_FOUND':
              vm.holdingForm.$setValidity('input', false);
              vm.errorMessage = error.message;
              break;
            default:
              vm.holdingForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.holdingForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSavingSms = false;
    });
  }

  function requestSmsPin() {
    var uploadPrompt = gettextCatalog.getString('Complete Captcha');
    GmwModal.showCaptchaModal(uploadPrompt).then(function (captcha) {
      if (captcha) {
        vm.isSavingSms = true;
        vm.model.captcha = captcha;
        HoldingSettings.requestSmsPin(vm.model.smsTelephoneNumber, vm.model.captcha).then(function () {
          codeGenerated = true;
          vm.smsState = 'add';
          $state.go('settings-security.holding.sms', {
            type: 'add'
          });
        }).catch(function (error) {
          $log.error(error);
          if (vm.holdingForm) {
            if (error && 'code' in error) {
              switch (error.code) {
                case 'INVALID_INPUT':
                case 'NOT_FOUND':
                  vm.holdingForm.$setValidity('input', false);
                  vm.errorMessage = error.message;
                  break;
                default:
                  vm.holdingForm.$setValidity('unknown', false);
                  break;
              }
            } else {
              vm.holdingForm.$setValidity('unknown', false);
            }
          }
        }).finally(function () {
          vm.isSavingSms = false;
        });
      }
      return false;
    });
  }

  function requestSmsRemovePin() {
    var uploadPrompt = gettextCatalog.getString('Complete Captcha');
    GmwModal.showCaptchaModal(uploadPrompt).then(function (captcha) {
      if (captcha) {
        vm.model.captcha = captcha;
        HoldingSettings.requestSmsRemovePin(vm.model.captcha).then(function () {
          codeGenerated = true;
          vm.smsState = 'remove';
          $state.go('settings-security.holding.sms', {
            type: 'remove'
          });
        }).catch(function (error) {
          $log.error(error);
          if (vm.holdingForm) {
            if (error && 'code' in error) {
              switch (error.code) {
                case 'INVALID_INPUT':
                case 'NOT_FOUND':
                  vm.holdingForm.$setValidity('input', false);
                  vm.errorMessage = error.message;
                  break;
                default:
                  vm.holdingForm.$setValidity('unknown', false);
                  break;
              }
            } else {
              vm.holdingForm.$setValidity('unknown', false);
            }
          }
        }).finally(function () {
          vm.isSavingSms = false;
        });
      }
      return false;
    });
  }

  function updatePassword() {
    vm.isSavingPassword = true;
    HoldingSettings.updatePassword(vm.model.password, vm.model.newPassword).then(function () {
      displayPasswordSavedAlert();
      clearPasswordForm();
    }).catch(function (error) {
      $log.error(error);

      if (vm.passwordForm) {
        if (error && 'code' in error) {
          switch (error.code) {
            case 'INVALID_INPUT':
              vm.holdingForm.$setValidity('input', false);
              vm.errorMessage = error.message;
              break;
            default:
              vm.holdingForm.$setValidity('unknown', false);
              clearPasswordForm();
              break;
          }
        } else {
          vm.holdingForm.$setValidity('unknown', false);
          clearPasswordForm();
        }
      }
    }).finally(function () {
      vm.isSavingPassword = false;
    });
  }

  function updateSmsNumber() {
    vm.isSavingSms = true;
    return HoldingSettings.updateSmsNumber(vm.model.smsTelephoneNumber, vm.model.pin).then(function () {
      codeGenerated = true;
      $state.go('settings-security.holding.landing', {
        stateId: 'smsAdded'
      }, {
        reload: true
      });
    }).catch(function (error) {
      $log.error(error);
      if (vm.holdingForm) {
        if (error && 'code' in error) {
          switch (error.code) {
            case 'INVALID_INPUT':
              vm.holdingForm.$setValidity('input', false);
              vm.errorMessage = error.message;
              break;
            default:
              vm.holdingForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.holdingForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSavingSms = false;
    });
  }

  $scope.$on('$destroy', onDestroy);
  $scope.$watch(function () {
    return vm.model.password;
  }, onPasswordChanged);
  $scope.$watch(function () {
    return vm.model.newPassword;
  }, onNewPasswordChanged);
  $scope.$watch(function () {
    return vm.model.pin;
  }, onPinChanged);

  activate();
}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=step></div> ";

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsSecurityHoldingCtrl.holdingForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Holding Security'|translate\"> </h2> </header> <div class=gmw-flow-box-container ng-attr-ng-form=\"(!settingsSecurityHoldingCtrl.showSmsPinSettings) ? settingsSecurityHoldingCtrl.passwordForm : undefined\"> <div ng-messages=settingsSecurityHoldingCtrl.holdingForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsSecurityHoldingCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <div ng-switch=settingsSecurityHoldingCtrl.showStateMessage> <div ng-switch-when=smsAdded> <holding-alert-legacy class=success> <span translate>You've successfully enabled your SMS pin.</span> </holding-alert-legacy> </div> <div ng-switch-when=smsRemoved> <holding-alert-legacy class=success> <span translate>You've successfully removed your SMS pin.</span> </holding-alert-legacy> </div> </div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=!settingsSecurityHoldingCtrl.showSmsPinSettings ng-bind=\"'Change Holding Password'|translate\"></label> <holding-alert-legacy class=success ng-if=\"!settingsSecurityHoldingCtrl.showSmsPinSettings && settingsSecurityHoldingCtrl.displayPasswordSavedAlert\"> <span ng-bind=\"'Your new password has been saved.'|translate\"></span> </holding-alert-legacy> <holding-alert-legacy class=success ng-if=settingsSecurityHoldingCtrl.displayTransfersLockedAlert> <span ng-bind=\"'Transfers from your Holding are now locked.'|translate\"></span> </holding-alert-legacy> <p class=gmw-flow-box__description ng-if=!settingsSecurityHoldingCtrl.showSmsPinSettings ng-bind=\"'Your password must be at least eight characters long and contain one number and one letter. Always use a unique password; we do not recommend repurposing passwords from other websites or accounts.'|translate\"> </p> <div class=gmw-input-container ng-if=!settingsSecurityHoldingCtrl.showSmsPinSettings> <gmw-box-input required name=password type=password has-error=\"settingsSecurityHoldingCtrl.passwordForm.password.$dirty && settingsSecurityHoldingCtrl.passwordForm.password.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.password placeholder=\"{{'Current password'|translate}}\" no-label=true> </gmw-box-input> </div> <div class=gmw-input-container ng-if=!settingsSecurityHoldingCtrl.showSmsPinSettings> <gmw-box-input required name=newPassword type=password minlength=8 pattern=\"(?=(?:[^a-zA-Z]*[a-zA-Z]){1})(?=(?:\\D*\\d){1}).*\" has-error=\"settingsSecurityHoldingCtrl.passwordForm.newPassword.$dirty && settingsSecurityHoldingCtrl.passwordForm.newPassword.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.newPassword placeholder=\"{{'New password'|translate}}\" no-label=true> </gmw-box-input> </div> <div class=gmw-input-container ng-if=!settingsSecurityHoldingCtrl.showSmsPinSettings> <gmw-box-input required name=newPasswordRepeat type=password minlength=8 pattern=\"(?=(?:[^a-zA-Z]*[a-zA-Z]){1})(?=(?:\\D*\\d){1}).*\" has-error=\"settingsSecurityHoldingCtrl.passwordForm.newPasswordRepeat.$dirty && settingsSecurityHoldingCtrl.passwordForm.newPasswordRepeat.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.newPasswordRepeat gmw-matches=\"{{settingsSecurityHoldingCtrl.model.newPassword}}\" placeholder=\"{{'Re-type new password'|translate}}\" no-label=true> </gmw-box-input> </div> <section class=gmw-settings-dual-col ng-if=settingsSecurityHoldingCtrl.showSmsPinSettings> <div class=gmw-settings-dual-col__col ng-form=settingsSecurityHoldingCtrl.passwordForm> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Change Holding Password'|translate\"></label> <holding-alert-legacy class=success ng-if=settingsSecurityHoldingCtrl.displayPasswordSavedAlert> <span ng-bind=\"'Your new password has been saved.'|translate\"></span> </holding-alert-legacy> <p class=gmw-flow-box__description ng-bind=\"'Your password must be at least eight characters long and contain one number and one letter. Always use a unique password; we do not recommend repurposing passwords from other websites or accounts.'|translate\"> </p> <div class=gmw-input-container> <gmw-box-input required name=password type=password has-error=\"settingsSecurityHoldingCtrl.passwordForm.password.$dirty && settingsSecurityHoldingCtrl.passwordForm.password.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.password placeholder=\"{{'Current password'|translate}}\" no-label=true> </gmw-box-input> </div> <div class=gmw-input-container> <gmw-box-input required name=newPassword type=password minlength=8 pattern=\"(?=(?:[^a-zA-Z]*[a-zA-Z]){1})(?=(?:\\D*\\d){1}).*\" has-error=\"settingsSecurityHoldingCtrl.passwordForm.newPassword.$dirty && settingsSecurityHoldingCtrl.passwordForm.newPassword.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.newPassword placeholder=\"{{'New password'|translate}}\" no-label=true> </gmw-box-input> </div> <div class=gmw-input-container> <gmw-box-input required name=newPasswordRepeat type=password minlength=8 pattern=\"(?=(?:[^a-zA-Z]*[a-zA-Z]){1})(?=(?:\\D*\\d){1}).*\" has-error=\"settingsSecurityHoldingCtrl.passwordForm.newPasswordRepeat.$dirty && settingsSecurityHoldingCtrl.passwordForm.newPasswordRepeat.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.newPasswordRepeat gmw-matches=\"{{settingsSecurityHoldingCtrl.model.newPassword}}\" placeholder=\"{{'Re-type new password'|translate}}\" no-label=true> </gmw-box-input> </div> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n            'loading-button': settingsSecurityHoldingCtrl.isSavingPassword\n          }\" holding-button-disabled=settingsSecurityHoldingCtrl.passwordForm.$invalid ng-click=settingsSecurityHoldingCtrl.updatePassword()> <span ng-bind=\"'Update'|translate\"></span> </button> </div> <div class=gmw-settings-dual-col__col> <div class=gmw-input-container ng-form=settingsSecurityHoldingCtrl.smsForm> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=settingsSecurityHoldingCtrl.isSmsPinEnabled ng-bind=\"'SMS Verification Enabled'|translate\"></label> <p class=gmw-flow-box__description ng-if=settingsSecurityHoldingCtrl.isSmsPinEnabled ng-bind=\"'Your security code will be sent to the mobile number listed below. Click Remove to change or delete this number.'|translate\"> </p> <gmw-main-table small=true ng-if=settingsSecurityHoldingCtrl.isSmsPinEnabled> <gmw-main-table-header> <gmw-main-table-header-col class=\"heading-h5 h-light-text\" ng-bind=\"'Telephone Number'|translate\"> </gmw-main-table-header-col> <gmw-main-table-header-col class=gmw-main-table__head-cell--actions> </gmw-main-table-header-col> </gmw-main-table-header> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col> <span ng-bind=::settingsSecurityHoldingCtrl.model.smsTelephoneNumber></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--actions> <svg class=gmw-main-table__body-cell--close-icon ng-click=settingsSecurityHoldingCtrl.requestSmsRemovePin()> <use xlink:href=#cross-icon></use> </svg> <a class=h-red-link ng-click=settingsSecurityHoldingCtrl.requestSmsRemovePin() ng-bind=\"'Remove'|translate\"></a> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=!settingsSecurityHoldingCtrl.isSmsPinEnabled ng-bind=\"'Require SMS Verification'|translate\"></label> <p class=gmw-flow-box__description ng-if=!settingsSecurityHoldingCtrl.isSmsPinEnabled ng-bind=\"'Unique security PIN codes must be entered in your Dashboard to remove funds or take physical delivery. By default, PIN codes will be sent to your email address. Should you wish to receive PIN codes via text message instead of email, please add your mobile number below.'|translate\"> </p> <div class=gmw-input-container ng-if=!settingsSecurityHoldingCtrl.isSmsPinEnabled> <gmw-box-phone-input required name=smsTelephoneNumber ng-model=settingsSecurityHoldingCtrl.model.smsTelephoneNumber label=\"{{'Telephone Number'|translate}}\" placeholder=\"{{'No telephone number is currently set'|translate}}\">> </gmw-box-phone-input> </div> <button class=\"medium-main-cta gmw-responsive-button\" ng-if=!settingsSecurityHoldingCtrl.isSmsPinEnabled ng-class=\"{\n              'loading-button': settingsSecurityHoldingCtrl.isSavingSms\n            }\" holding-button-disabled=settingsSecurityHoldingCtrl.smsForm.$invalid ng-click=settingsSecurityHoldingCtrl.requestSmsPin()> <span ng-bind=\"'Add Number'|translate\"></span> </button> </div> <div class=gmw-input-container ng-form=settingsSecurityHoldingCtrl.transferForm ng-if=settingsSecurityHoldingCtrl.showTransferLockFeature> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=settingsSecurityHoldingCtrl.areTransfersDisabled ng-bind=\"'Transfers Disabled'|translate\"></label> <p class=gmw-flow-box__description ng-if=settingsSecurityHoldingCtrl.areTransfersDisabled> <span ng-bind=\"'Transfers from your Holding are currently disabled. To remove this restriction, please'|translate\"></span> <a class=h-blue-link ui-sref=\"holding.dashboard.messages.compose({\n                category: 'OTHER',\n                subject: 'Remove transfer lock',\n              })\" ng-bind=\"'contact Relationship Management.'|translate\"></a> </p> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=!settingsSecurityHoldingCtrl.areTransfersDisabled ng-bind=\"'Disable Transfers'|translate\"></label> <p class=gmw-flow-box__description ng-if=!settingsSecurityHoldingCtrl.areTransfersDisabled ng-bind=\"'To disable transfers from your Holding, preventing the transfer of metal to another Holding, please click the button below. Note that you will need to contact our Relationship Management team to re-enable transfers should you wish to send one in the future.'|translate\"> </p> <button class=\"medium-main-cta gmw-responsive-button\" ng-if=!settingsSecurityHoldingCtrl.areTransfersDisabled ng-class=\"{\n              'loading-button': settingsSecurityHoldingCtrl.isDisablingTransfers\n            }\" holding-button-disabled=settingsSecurityHoldingCtrl.transferForm.$invalid ng-click=settingsSecurityHoldingCtrl.lockTransfers()> <span ng-bind=\"'Disable Transfers'|translate\"></span> </button> </div> </div> </section></div> </div> <footer class=gmw-flow-box-footer ng-if=!settingsSecurityHoldingCtrl.showSmsPinSettings> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsSecurityHoldingCtrl.isSavingPassword\n        }\" holding-button-disabled=settingsSecurityHoldingCtrl.passwordForm.$invalid ng-click=settingsSecurityHoldingCtrl.updatePassword()> <span ng-bind=\"'Update'|translate\"></span> </button> </div> </footer> ";

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsSecurityHoldingCtrl.smsPinForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-if=\"settingsSecurityHoldingCtrl.smsState === 'add'\" ng-bind=\"'Update SMS Telephone Number'|translate\"> </h2> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-if=\"settingsSecurityHoldingCtrl.smsState === 'remove'\" ng-bind=\"'Remove SMS Verification'|translate\"> </h2> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsSecurityHoldingCtrl.smsPinForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsSecurityHoldingCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <p class=gmw-flow-box__description ng-if=\"settingsSecurityHoldingCtrl.smsState === 'add'\"> <span ng-bind=\"'Your request to add your SMS telephone number has been received and a confirmation message has been sent to'|translate\"></span> <span class=h-dark-text ng-bind=::settingsSecurityHoldingCtrl.model.smsTelephoneNumber></span>. <span ng-bind=\"'Please check your SMS inbox for a message from Goldmoney. Enter the security code below and click continue. If this has been done in error, please do not enter the security code.'|translate\"></span> </p> <p class=gmw-flow-box__description ng-if=\"settingsSecurityHoldingCtrl.smsState === 'remove'\"> <span ng-bind=\"'Your request to remove your SMS telephone number has been received and a confirmation message has been sent to'|translate\"></span> <span class=h-dark-text ng-bind=::settingsSecurityHoldingCtrl.model.smsTelephoneNumber></span>. <span ng-bind=\"'Please check your SMS inbox for a message from Goldmoney. Enter the security code below and click continue. If this has been done in error, please do not enter the security code.'|translate\"></span> </p> <div class=gmw-input-container> <gmw-box-input required name=pin has-error=\"settingsSecurityHoldingCtrl.smsPinForm.pin.$dirty && settingsSecurityHoldingCtrl.smsPinForm.pin.$invalid\" ng-model=settingsSecurityHoldingCtrl.model.pin ng-change=\"settingsSecurityHoldingCtrl.model.pin = (settingsSecurityHoldingCtrl.model.pin|uppercase)\" placeholder=\"{{'Enter code'|translate}}\" label=\"{{'Security Code'|translate}}\"> </gmw-box-input> </div> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-if=\"settingsSecurityHoldingCtrl.smsState === 'add'\" ng-class=\"{\n          'loading-button': settingsSecurityHoldingCtrl.isSavingSms\n        }\" holding-button-disabled=settingsSecurityHoldingCtrl.smsPinForm.$invalid ng-click=settingsSecurityHoldingCtrl.updateSmsNumber()> <span ng-bind=\"'Confirm'|translate\"></span> </button> <button class=\"medium-main-cta gmw-responsive-button\" ng-if=\"settingsSecurityHoldingCtrl.smsState === 'remove'\" ng-class=\"{\n          'loading-button': settingsSecurityHoldingCtrl.isSavingSms\n        }\" holding-button-disabled=settingsSecurityHoldingCtrl.smsPinForm.$invalid ng-click=settingsSecurityHoldingCtrl.removeSmsNumber()> <span ng-bind=\"'Confirm'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SettingsSecurityIpWhitelistController.$inject = ['$log', '$scope', '$timeout', 'HoldingSettings', 'ipWhitelist'];
var _ip = __webpack_require__(1005);

var _ip2 = _interopRequireDefault(_ip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  template: _ip2.default,
  controller: 'SettingsSecurityIpWhitelistController',
  controllerAs: 'settingsSecurityIpWhitelistCtrl',
  resolve: {
    ipWhitelist: ['$q', 'HoldingSettings', function ipWhitelist($q, HoldingSettings) {
      'ngInject';

      var deferred = $q.defer();
      HoldingSettings.getIpWhitelist().then(function (_ref) {
        var whiteList = _ref.whiteList;

        deferred.resolve(whiteList);
      }).catch(function (error) {
        deferred.resolve(error);
      });
      return deferred.promise;
    }]
  }
};

angular.module('app.holding.dashboard.settings-security').controller(module.exports.controller, SettingsSecurityIpWhitelistController);

function SettingsSecurityIpWhitelistController($log, $scope, $timeout, HoldingSettings, ipWhitelist) {
  'ngInject';

  var DEFAULT_MODEL = {};

  var vm = this;

  var savedAlertTimer = void 0;

  vm.clearIpWhitelist = clearIpWhitelist;
  vm.displaySavedAlert = false;
  vm.isSaving = false;
  vm.model = angular.copy(DEFAULT_MODEL);
  vm.updateIpWhitelist = updateIpWhitelist;

  function activate() {
    vm.model.ipWhitelist = angular.copy(ipWhitelist);
    vm.currentIpWhitelist = ipWhitelist;

    HoldingSettings.getIpAddress().then(function (_ref2) {
      var currentIp = _ref2.currentIp;

      vm.currentIp = currentIp;
    }).catch(function (error) {
      $log.error(error);
      if (vm.ipWhitelistForm) {
        vm.ipWhitelistForm.$setValidity('unknown', false);
      }
    });
  }

  function clearIpWhitelist() {
    vm.model.ipWhitelist = '';
    updateIpWhitelist().then(function () {
      reloadIpWhitelist();
    }).catch(function (error) {
      $log.error(error);
      if (vm.ipWhitelistForm) {
        vm.ipWhitelistForm.$setValidity('unknown', false);
      }
    });
  }

  function displaySavedAlert() {
    vm.displaySavedAlert = true;
    savedAlertTimer = $timeout(function () {
      vm.displaySavedAlert = false;
    }, 10000);
  }

  function onDestroy() {
    $timeout.cancel(savedAlertTimer);
  }

  function onIpWhitelistChange(newIpWhitelist, oldIpWhitelist) {
    if (newIpWhitelist !== oldIpWhitelist) {
      if (vm.ipWhitelistForm) {
        vm.ipWhitelistForm.$setValidity('input', true);
        vm.ipWhitelistForm.$setValidity('unknown', true);
      }
    }
  }

  function reloadIpWhitelist() {
    HoldingSettings.getIpWhitelist().then(function (_ref3) {
      var whiteList = _ref3.whiteList;

      vm.model.ipWhitelist = angular.copy(whiteList);
      vm.currentIpWhitelist = whiteList;
    }).catch(function (error) {
      $log.error(error);
      if (vm.ipWhitelistForm) {
        vm.ipWhitelistForm.$setValidity('unknown', false);
      }
    });
  }

  function updateIpWhitelist() {
    vm.isSaving = true;
    return HoldingSettings.updateIpWhitelist(vm.model.ipWhitelist).then(function () {
      displaySavedAlert();
      reloadIpWhitelist();
    }).catch(function (error) {
      $log.error(error);

      if (vm.ipWhitelistForm) {
        if (error && 'code' in error) {
          switch (error.code) {
            case 'INVALID_INPUT':
              vm.ipWhitelistForm.$setValidity('input', false);
              vm.errorMessage = error.message;
              break;
            default:
              vm.ipWhitelistForm.$setValidity('unknown', false);
              break;
          }
        } else {
          vm.ipWhitelistForm.$setValidity('unknown', false);
        }
      }
    }).finally(function () {
      vm.isSaving = false;
    });
  }

  $scope.$on('$destroy', onDestroy);
  $scope.$watch(function () {
    return vm.model.ipWhitelist;
  }, onIpWhitelistChange);

  activate();
}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gmw-flow-box gmw-flow-box--full-width\" ng-form=settingsSecurityIpWhitelistCtrl.ipWhitelistForm> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'IP Access List'|translate\"> </h2> <p class=gmw-flow-box__header-description> <span ng-bind=\"'You can limit access to your Holding to specified IP (internet protocol) addresses.'|translate\"></span> </p> <p class=gmw-flow-box__header-description> <span class=h-dark-text ng-bind=\"'Note: Do not apply IP Access List settings to your Holding unless you are certain that you know the full range of IP addresses from which you will access your Holding. Failure to do so could result in you being locked out of your Holding.'|translate\"></span> </p> </header> <div class=gmw-flow-box-container> <div ng-messages=settingsSecurityIpWhitelistCtrl.ipWhitelistForm.$error> <div ng-message=input> <holding-alert-legacy class=error> <span ng-bind=::settingsSecurityIpWhitelistCtrl.errorMessage></span> </holding-alert-legacy> </div> <div ng-message=unknown> <holding-alert-legacy class=error> <span ng-bind=\"'An error has occurred - please try again later.'|translate\"></span> </holding-alert-legacy> </div> </div> <holding-alert-legacy class=success ng-if=settingsSecurityIpWhitelistCtrl.displaySavedAlert> <span ng-bind=\"'Your IP access settings have been updated.'|translate\"></span> </holding-alert-legacy> <section class=gmw-settings-dual-col> <div class=gmw-settings-dual-col__col> <holding-alert class=info> <main> <span> <span ng-bind=\"'If you have issues accessing your Holding due to applying an IP Access List, please contact our Relationship Management team'|translate\"> </span> </span> </main> <cta> <a ui-sref=\"holding.dashboard.messages.compose({\n                category: 'OTHER',\n                subject: 'IP access list issue',\n              })\"> Contact Relationship Management </a> </cta> </holding-alert> <p class=gmw-flow-box__description ng-bind=\"'Note that you can limit access to your Holding to one or more IP addresses, specify both IP4 and IP6 addresses, or allow for IP address ranges, by either specifying the address range or using CIDR notation.'|translate\"> </p> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-bind=\"'Examples'|translate\"> </label> <gmw-main-table small=true> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col> <span ng-bind=\"'Single IP Address'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col> 192.168.34.58 </gmw-main-table-body-col> </gmw-main-table-body-row> <gmw-main-table-body-row> <gmw-main-table-body-col> <span ng-bind=\"'Multiple IP Addresses'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col> 192.168.34.58 172.16.127.13 </gmw-main-table-body-col> </gmw-main-table-body-row> <gmw-main-table-body-row> <gmw-main-table-body-col> <span ng-bind=\"'IP Address Range'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col> 192.168.34.58-192.168.34.255 </gmw-main-table-body-col> </gmw-main-table-body-row> <gmw-main-table-body-row> <gmw-main-table-body-col> <span ng-bind=\"'IP Address Range (CIDR Format)'|translate\"></span> </gmw-main-table-body-col> <gmw-main-table-body-col> 192.168.34.0/24 </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> </div> <div class=gmw-settings-dual-col__col> <div class=gmw-flow-box__callout> <span ng-bind=\"'Your Current Public IP Address'|translate\"></span> <span class=h-dark-text ng-bind=settingsSecurityIpWhitelistCtrl.currentIp></span> </div> <label class=\"gmw-input-container__label heading-h4 h-dark-text\" ng-if=settingsSecurityIpWhitelistCtrl.currentIpWhitelist ng-bind=\"'Current Allowed IP Addresses'|translate\"> </label> <gmw-main-table small=true ng-if=settingsSecurityIpWhitelistCtrl.currentIpWhitelist> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col> <span ng-bind=settingsSecurityIpWhitelistCtrl.currentIpWhitelist></span> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--actions> <svg class=gmw-main-table__body-cell--close-icon ng-click=settingsSecurityIpWhitelistCtrl.clearIpWhitelist()> <use xlink:href=#cross-icon></use> </svg> <a class=h-red-link ng-click=settingsSecurityIpWhitelistCtrl.clearIpWhitelist() ng-bind=\"'Remove'|translate\"></a> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <div class=gmw-input-container> <gmw-box-input required name=ip has-error=\"settingsSecurityIpWhitelistCtrl.ipWhitelistForm.password.$dirty && settingsSecurityIpWhitelistCtrl.ipWhitelistForm.password.$invalid\" ng-model=settingsSecurityIpWhitelistCtrl.model.ipWhitelist label=\"{{'Add IP Addresses to Access List'|translate}}\" placeholder=\"{{'E.g 168.197.22.34'|translate}}\"> </gmw-box-input> </div> </div> </section> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button class=\"medium-main-cta gmw-responsive-button\" ng-class=\"{\n          'loading-button': settingsSecurityIpWhitelistCtrl.isSaving\n        }\" holding-button-disabled=settingsSecurityIpWhitelistCtrl.ipWhitelistForm.$invalid ng-click=settingsSecurityIpWhitelistCtrl.updateIpWhitelist()> <span ng-bind=\"'Update'|translate\"></span> </button> </div> </footer> </div> ";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transferAliasInput = __webpack_require__(1007);

var _transferAliasInput2 = _interopRequireDefault(_transferAliasInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.settings-profile').directive('holdingTransferAliasInput', holdingTransferAliasInput).name;


function holdingTransferAliasInput() {
  'ngInject';

  var directive = {
    link: link,
    template: _transferAliasInput2.default,
    restrict: 'E',
    require: 'ngModel',
    scope: true
  };
  return directive;

  function prepareInput(value) {
    if (!value) {
      return value;
    }
    return value.trim().replace(/[^0-9a-z]/gi, '').toUpperCase();
  }

  function link(scope, _element, _attrs, ctrl) {
    scope.ctrl = ctrl;
    scope.model = {};
    scope.$watch('model.value', function (value) {
      if (value) {
        var newValue = prepareInput(value);
        scope.model.value = newValue;
        ctrl.$setViewValue(newValue);
      }
    });

    ctrl.$formatters.push(function (value) {
      scope.model.value = value;
    });
  }
}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=gmw-box-input ng-class=\"{\n      'gmw-box-input--focus': active,\n      'gmw-box-input--disabled': disabled,\n      'gmw-box-input--error': ctrl.$dirty && ctrl.$invalid,\n    }\"> <input class=gmw-box-input__input type=text ng-model=model.value placeholder=\"{{'Transfer alias (6 to 20 characters)'|translate}}\"> <div class=gmw-input-container__meta> <a href=https://support.goldmoney.com/hc/articles/360000744327 class=h-blue-link target=_blank ng-bind=\"'What is a Transfer Alias?'|translate\"> </a> </div> </div> </div> ";

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingPreferences.$inject = ['$q', 'HoldingApi', 'gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.settings').factory('HoldingPreferences', HoldingPreferences).name;


function HoldingPreferences($q, HoldingApi, gettextCatalog) {
  'ngInject';

  var ACCOUNT_PURPOSE_TYPES = [{
    key: 'INVESTMENT',
    description: gettextCatalog.getString('Investment, savings, or diversification')
  }, {
    key: 'OTHER',
    description: gettextCatalog.getString('Other')
  }];

  return {
    getAccountPurposeTypesForSelector: getAccountPurposeTypesForSelector,
    getPreferences: getPreferences,
    updatePreferences: updatePreferences
  };

  function getAccountPurposeTypesForSelector() {
    return $q.when(ACCOUNT_PURPOSE_TYPES.map(function (purposeType) {
      return {
        value: purposeType.key,
        label: purposeType.description
      };
    }));
  }

  function getPreferences() {
    return HoldingApi.get('preferences');
  }

  function updatePreferences(preferences) {
    return HoldingApi.put('preferences', preferences);
  }
}

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingSettings.$inject = ['$q', 'HoldingApi', 'HoldingUser', 'gettextCatalog'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.settings').factory('HoldingSettings', HoldingSettings).name;


function HoldingSettings($q, HoldingApi, HoldingUser, gettextCatalog) {
  'ngInject';

  var EMAIL_CHANGE_TYPES = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY'
  };

  var EMAIL_NOTIFICATION = {
    notifyAddFunds: {
      description: gettextCatalog.getString('Add Funds')
    },
    notifyRemoveFunds: {
      description: gettextCatalog.getString('Withdraw Funds')
    },
    notifyBuyOrder: {
      description: gettextCatalog.getString('Buy Order')
    },
    notifySellOrder: {
      description: gettextCatalog.getString('Sell Order')
    },
    notifyExchangeOrders: {
      description: gettextCatalog.getString('Exchange Order')
    },
    notifyPaymentOut: {
      description: gettextCatalog.getString('Send Transfer')
    },
    notifyPayment: {
      description: gettextCatalog.getString('Receive Transfer')
    },
    notifyLogin: {
      description: gettextCatalog.getString('Holding Login')
    }
  };

  var EMAIL_NOTIFICATION_LEVEL_ORDER = ['NONE', 'SUMMARY', 'DETAILED'];

  return {
    EMAIL_CHANGE_TYPES: EMAIL_CHANGE_TYPES,
    getBankAccountLockStatus: getBankAccountLockStatus,
    getEmailNotificationDescription: getEmailNotificationDescription,
    getEmailNotificationLevelOrder: getEmailNotificationLevelOrder,
    getEmailNotificationOrder: getEmailNotificationOrder,
    getEmailNotificationSettings: getEmailNotificationSettings,
    getEmailSecurityQuestions: getEmailSecurityQuestions,
    getIpAddress: getIpAddress,
    getIpWhitelist: getIpWhitelist,
    getProfile: getProfile,
    lockBankAccounts: lockBankAccounts,
    lockTransfers: lockTransfers,
    removeSmsNumber: removeSmsNumber,
    requestEmailPin: requestEmailPin,
    requestSmsPin: requestSmsPin,
    requestSmsRemovePin: requestSmsRemovePin,
    showLockBankAccount: showLockBankAccount,
    showNotificationSettings: showNotificationSettings,
    submitEmailChange: submitEmailChange,
    submitEmailReset: submitEmailReset,
    updateEmailNotificationPreferences: updateEmailNotificationPreferences,
    updateIpWhitelist: updateIpWhitelist,
    updatePassword: updatePassword,
    updateSmsNumber: updateSmsNumber
  };

  function getBankAccountLockStatus() {
    return HoldingApi.get('security/lockBankAccount');
  }

  function getEmailNotificationDescription(notificationPreference) {
    return EMAIL_NOTIFICATION[notificationPreference].description;
  }

  function getEmailNotificationLevelOrder() {
    return $q.when(EMAIL_NOTIFICATION_LEVEL_ORDER);
  }

  function getEmailNotificationOrder() {
    return $q.when(Object.keys(EMAIL_NOTIFICATION));
  }

  function getEmailNotificationSettings() {
    return HoldingApi.get('emailNotifications');
  }

  function getEmailSecurityQuestions() {
    return HoldingApi.get('profile/changeEmail/questions');
  }

  function getIpAddress() {
    return HoldingApi.get('security/ipWhiteList/ip');
  }

  function getIpWhitelist() {
    return HoldingApi.get('security/ipWhiteList');
  }

  function getProfile() {
    return HoldingApi.get('profile');
  }

  function lockBankAccounts() {
    return HoldingApi.post('security/lockBankAccount');
  }

  function lockTransfers() {
    return HoldingApi.put('holdings/paymentLock');
  }

  function removeSmsNumber(pin) {
    return HoldingApi.post('security/sms/delete/validate', {
      pin: pin
    });
  }

  function requestEmailPin(emailChangeType, newEmail, captcha) {
    return HoldingApi.post('profile/changeEmail/pin', {
      emailChangeType: emailChangeType,
      newEmail: newEmail
    }, {
      captcha: captcha
    });
  }

  function requestSmsPin(newMobileNumber, captcha) {
    return HoldingApi.post('security/sms/pin', {
      newMobileNumber: newMobileNumber
    }, {
      captcha: captcha
    });
  }

  function requestSmsRemovePin(captcha) {
    return HoldingApi.post('security/sms/delete/pin', {}, {
      captcha: captcha
    });
  }

  function showLockBankAccount() {
    return !HoldingUser.isHidden('addBankAccount') || !HoldingUser.isHidden('deleteBankAccount');
  }

  function showNotificationSettings() {
    return HoldingUser.isAllowed('receiveEmail');
  }

  function submitEmailChange(emailChangeType, newEmail, pin) {
    return HoldingApi.post('profile/changeEmail/confirm', {
      emailChangeType: emailChangeType,
      newEmail: newEmail,
      pin: pin
    });
  }

  function submitEmailReset(newEmail, answers) {
    return HoldingApi.post('profile/changeEmail/request', {
      newEmail: newEmail,
      answers: answers
    });
  }

  function updateEmailNotificationPreferences(notificationPreferences) {
    return HoldingApi.put('emailNotifications', notificationPreferences);
  }

  function updateIpWhitelist(newWhiteList) {
    return HoldingApi.post('security/ipWhiteList', {
      newWhiteList: newWhiteList
    });
  }

  function updatePassword(currentPassword, newPassword) {
    return HoldingApi.post('security/password', {
      currentPassword: currentPassword,
      newPassword: newPassword
    });
  }

  function updateSmsNumber(newMobileNumber, pin) {
    return HoldingApi.post('security/sms/validate', {
      newMobileNumber: newMobileNumber,
      pin: pin
    });
  }
}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(35);

var _angular2 = _interopRequireDefault(_angular);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

var _hero = __webpack_require__(1011);

var _hero2 = _interopRequireDefault(_hero);

var _physical = __webpack_require__(1012);

var _physical2 = _interopRequireDefault(_physical);

var _flow = __webpack_require__(1013);

var _flow2 = _interopRequireDefault(_flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ngModule = _angular2.default.module('app.holding.dashboard.physical', [_common2.default]);
var deliveryCfg = __webpack_require__(1014);
var deliveryOverviewCfg = __webpack_require__(1015);
var deliveryCreateCfg = __webpack_require__(1017);
var deliveryCreateAmountTpl = __webpack_require__(1019);
var deliveryCreateAddressTpl = __webpack_require__(1020);
var deliveryCreateReviewTpl = __webpack_require__(1021);
function PhysicalHeroController(GmwPhysical) {
    'ngInject';

    this.showRedeemBars = GmwPhysical.showRedeemBars();
}
PhysicalHeroController.$inject = ['GmwPhysical'];
function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('physical', {
        parent: 'holding.dashboard',
        url: '/physical',
        views: {
            hero: {
                controller: PhysicalHeroController,
                controllerAs: 'physicalHeroCtrl',
                template: _hero2.default
            },
            main: {
                template: '<div class="_wrapper" ui-view></div>'
            }
        }
    }).state('physical.delivery', {
        url: '/delivery',
        views: { '': deliveryCfg }
    }).state('physical.delivery.overview', {
        url: '/overview?complete',
        views: { '@physical.delivery': deliveryOverviewCfg },
        resolve: deliveryOverviewCfg.resolve
    }).state('physical.delivery.create', {
        url: '/create',
        views: { '@physical.delivery': deliveryCreateCfg },
        data: {
            flow: _flow2.default
        }
    }).state('physical.delivery.create.amount', {
        url: '/amount',
        views: { step: { template: deliveryCreateAmountTpl } }
    }).state('physical.delivery.create.address', {
        url: '/address',
        views: { step: { template: deliveryCreateAddressTpl } }
    }).state('physical.delivery.create.review', {
        url: '/review',
        views: { step: { template: deliveryCreateReviewTpl } }
    });
    $urlRouterProvider.when('/physical/delivery', '/physical/delivery/overview');
    $urlRouterProvider.when('/physical/delivery/create', '/physical/delivery/create/amount');
}
routeConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
ngModule.config(routeConfig).service('GmwPhysical', _physical2.default);
exports.default = ngModule.name;

__webpack_require__(1022);

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls> <div class=\"holding-dashboard-hero-actions__button holding-dashboard-hero-actions__button--back\" ng-if=\"('physical.schiffgold.catalog-detail'|isState)||('physical.schiffgold.checkout.review-redemption'|isState)\" ui-sref=physical.schiffgold.catalog> <svg class=holding-dashboard-hero-actions__button-icon width=16 height=16> <use xlink:href=#left-arrow-icon></use> </svg> </div> <right-mobile-action> <gmw-cart-icon></gmw-cart-icon> </right-mobile-action> </holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Goldmoney Physical'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center ng-if=physicalHeroCtrl.showRedeemBars> <holding-dashboard-hero-actions-tabs> <holding-dashboard-hero-actions-tabs-item label=\"'Goldmoney Bars'|translate\" mobile-label=\"'Goldmoney Bars'|translate\" ui-sref=physical.delivery ui-sref-active=holding-dashboard-hero-actions-tabs-item--active> </holding-dashboard-hero-actions-tabs-item> </holding-dashboard-hero-actions-tabs> </section> <section class=\"holding-dashboard-hero-actions__right holding-dashboard-hero-actions__right--has-actions\"> <gmw-country-indicator ng-if=\"('physical.schiffgold.catalog'|isState)||('physical.schiffgold.catalog-detail'|isState)\"></gmw-country-indicator> <gmw-cart-icon class=\"mobile-only mobile-only--md h-margin-left-20\"></gmw-cart-icon> </section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function findPriceBracket(quantity, priceBrackets) {
    return priceBrackets.find(function (p) {
        return p.from <= quantity && (!p.to || p.to > quantity);
    });
}
var CacheKey = 'physical-catalog';

var GmwPhysical = function () {
    function GmwPhysical(HoldingApi, HoldingUser, promiseCache, $q) {
        _classCallCheck(this, GmwPhysical);

        this.HoldingApi = HoldingApi;
        this.HoldingUser = HoldingUser;
        this.promiseCache = promiseCache;
        this.$q = $q;
        this.cart = [];
        this.countryCode = undefined;
    }

    _createClass(GmwPhysical, [{
        key: 'selectCountry',
        value: function selectCountry(countryCode) {
            this.countryCode = countryCode;
            this.clearCart();
        }
    }, {
        key: 'clearCart',
        value: function clearCart() {
            this.cart = [];
        }
    }, {
        key: 'unsetCountry',
        value: function unsetCountry() {
            this.countryCode = undefined;
            this.promiseCache.remove(CacheKey);
        }
    }, {
        key: 'getCatalog',
        value: function getCatalog() {
            var _this = this;

            if (!this.countryCode) {
                return this.$q.resolve([]);
            }
            return this.promiseCache({
                key: CacheKey,
                promise: function promise() {
                    return _this.HoldingApi.get('schiffgold/catalog', {
                        params: { countryCode: _this.countryCode }
                    }).then(function (catalog) {
                        return catalog.items;
                    });
                },
                ttl: -1
            });
        }
    }, {
        key: 'getItemById',
        value: function getItemById(id) {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var catalog;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.getCatalog();

                            case 2:
                                catalog = _context.sent;
                                return _context.abrupt('return', catalog.find(function (item) {
                                    return item.id === id;
                                }));

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    }, {
        key: 'addToCart',
        value: function addToCart(item, quantity) {
            var existingItem = this.cart.find(function (i) {
                return i.item === item;
            });
            if (existingItem) {
                existingItem.quantity += quantity;
            } else {
                this.cart.push({ item: item, quantity: quantity });
            }
        }
    }, {
        key: 'unitPrice',
        value: function unitPrice(item, quantity) {
            var priceBracket = findPriceBracket(quantity, item.prices);
            if (!priceBracket) {
                return undefined;
            }
            return priceBracket.price;
        }
    }, {
        key: 'quantityPrice',
        value: function quantityPrice(item, quantity) {
            var priceBracket = findPriceBracket(quantity, item.prices);
            if (!priceBracket) {
                return undefined;
            }
            return {
                amount: priceBracket.price.amount * quantity,
                currency: priceBracket.price.currency
            };
        }
    }, {
        key: 'subtotal',
        value: function subtotal() {
            var _this2 = this;

            var amount = this.cart.reduce(function (prev, curr) {
                var lineTotal = _this2.quantityPrice(curr.item, curr.quantity);
                if (lineTotal) {
                    return prev + lineTotal.amount;
                }
                return prev;
            }, 0);
            return { amount: amount, currency: 'USD' };
        }
    }, {
        key: 'getCountries',
        value: function getCountries() {
            var _this3 = this;

            return this.promiseCache({
                key: 'physical-countries',
                promise: function promise() {
                    return _this3.HoldingApi.get('schiffgold/countries');
                },
                ttl: -1
            });
        }
    }, {
        key: 'validCart',
        value: function validCart() {
            var goldWeight = this.cart.filter(function (i) {
                return i.item.metal === 'Gold';
            }).reduce(function (prev, curr) {
                return prev + curr.item.weightTOz * curr.quantity;
            }, 0);
            if (goldWeight >= 2) {
                return true;
            }
            var silverWeight = this.cart.filter(function (i) {
                return i.item.metal === 'Silver';
            }).reduce(function (prev, curr) {
                return prev + curr.item.weightTOz * curr.quantity;
            }, 0);
            if (silverWeight >= 20) {
                return true;
            }
            return false;
        }
    }, {
        key: 'preview',
        value: function preview(address) {
            return this.HoldingApi.post('schiffgold/preview', {
                items: this.cart.map(function (i) {
                    return { id: i.item.id, quantity: i.quantity };
                }),
                address: address
            });
        }
    }, {
        key: 'confirm',
        value: function confirm(id, address, metal, vault) {
            return this.HoldingApi.post('schiffgold/confirm', {
                items: this.cart.map(function (i) {
                    return { id: i.item.id, quantity: i.quantity };
                }),
                address: address,
                metal: metal,
                id: id,
                split: 'Equal',
                vaults: [vault]
            });
        }
    }, {
        key: 'purchase',
        value: function purchase(id, address, metal, vault, pin) {
            return this.HoldingApi.post('schiffgold/purchase', {
                items: this.cart.map(function (i) {
                    return { id: i.item.id, quantity: i.quantity };
                }),
                address: address,
                metal: metal,
                id: id,
                split: 'Equal',
                vaults: [vault],
                pin: pin
            });
        }
    }, {
        key: 'remove',
        value: function remove(lineItem) {
            var index = this.cart.findIndex(function (l) {
                return l === lineItem;
            });
            this.cart.splice(index, 1);
        }
    }, {
        key: 'showRedeemBars',
        value: function showRedeemBars() {
            return !this.HoldingUser.isHidden('redeemBars');
        }
    }]);

    return GmwPhysical;
}();

exports.default = GmwPhysical;

GmwPhysical.$inject = ['HoldingApi', 'HoldingUser', 'promiseCache', '$q'];

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gettext = __webpack_require__(6);

var _gettext2 = _interopRequireDefault(_gettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flow = {
    name: (0, _gettext2.default)('Buy Gold'),
    cancel: {
        state: 'physical.delivery'
    },
    complete: {
        state: 'physical.delivery'
    },
    steps: [{
        key: 'amount',
        state: 'physical.delivery.create.amount',
        heading: (0, _gettext2.default)('Take Delivery of Goldmoney Bars'),
        label: (0, _gettext2.default)('Select Bar Size & Quantity')
    }, {
        key: 'address',
        state: 'physical.delivery.create.address',
        heading: (0, _gettext2.default)('Choose Delivery Method'),
        label: (0, _gettext2.default)('Delivery Method')
    }, {
        key: 'review',
        state: 'physical.delivery.create.review',
        cancel: true,
        heading: (0, _gettext2.default)('Purchase Summary'),
        label: (0, _gettext2.default)('Review')
    }]
};
exports.default = flow;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  controller: 'GoldmoneyBarsController',
  controllerAs: 'redeemCtrl',
  template: '<ui-view></ui-view>'
};

angular.module('app.holding.dashboard.physical').controller(module.exports.controller, GoldmoneyBarsController);

function GoldmoneyBarsController() {
  'ngInject';
}

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RedeemOverViewController.$inject = ['HoldingUser', '$stateParams', 'orders'];
var _overview = __webpack_require__(1016);

var _overview2 = _interopRequireDefault(_overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  controller: 'RedeemOverViewController',
  controllerAs: 'redeemOverviewCtrl',
  resolve: {
    orders: ['$q', 'HoldingBaird', function orders($q, HoldingBaird) {
      'ngInject';

      return HoldingBaird.getRedemptionOrders().then(function (_ref) {
        var orders = _ref.orders;

        if (orders.length > 0) {
          return orders;
        }
        return $q.reject({ redirectTo: 'physical.delivery.create' });
      }).catch(function () {
        return $q.reject({ redirectTo: 'physical.delivery.create' });
      });
    }]
  },
  template: _overview2.default
};

angular.module('app.holding.dashboard.physical').controller(module.exports.controller, RedeemOverViewController);

function RedeemOverViewController(HoldingUser, $stateParams, orders) {
  'ngInject';

  var vm = this;

  vm.canRedeemBars = HoldingUser.isAllowed('redeemBars');
  vm.orders = orders;
  if ($stateParams.complete === 'success') {
    vm.success = true;
  }
}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "<section class=\"gmw-flow-box gmw-flow-box--center\" ng-if=!redeemOverviewCtrl.canRedeemBars> <holding-permission-based-empty-state permission=redeemBars></holding-permission-based-empty-state> </section> <section ng-if=redeemOverviewCtrl.canRedeemBars> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'Pending &amp; Completed Deliveries'|translate\"></h2> </header> <div class=gmw-flow-box-container> <holding-alert-legacy class=success ng-if=redeemOverviewCtrl.success> Bar Delivery Order Successful </holding-alert-legacy> <holding-redemptions-list orders=redeemOverviewCtrl.orders> </holding-redemptions-list> </div> <footer class=gmw-flow-box-footer> <div class=\"gmw-flow-box-footer__col gmw-flow-box-footer__col--center\"> <button ui-sref=physical.delivery.create class=\"medium-main-cta gmw-responsive-button\"> <span ng-bind=\"'New Delivery'|translate\"></span> </button> </div> </footer> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'Can I take physical possession of my precious metal?'|translate}}\" href holding-external-link=support.redemption.possession> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'Are there tax implications?'|translate}}\" href holding-external-link=support.redemption.tax> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'To which countries do you deliver bars?'|translate}}\" href holding-external-link=support.redemption.countries> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> </section> ";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RedeemCreateController.$inject = ['$controller', '$filter', '$q', '$scope', '$state', 'HoldingBaird', 'HoldingVaults', 'HoldingUser'];
var _create = __webpack_require__(1018);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  controller: 'RedeemCreateController',
  controllerAs: 'redeemCreateCtrl',
  template: _create2.default
};

angular.module('app.holding.dashboard.physical').controller(module.exports.controller, RedeemCreateController);

function RedeemCreateController($controller, $filter, $q, $scope, $state, HoldingBaird, HoldingVaults, HoldingUser) {
  'ngInject';

  var vm = this;
  var locationNameFilter = $filter('holdingVaultLocation');
  var model = {
    bars: [{
      id: 1
    }, {
      id: 2
    }]
  };
  var result = {};

  vm.steps = {
    'physical.delivery.create.address': {
      checks: [{
        function: checkAmount,
        revertTo: 'physical.delivery.create.amount'
      }],
      next: previewRedemption
    },
    'physical.delivery.create.review': {
      checks: [{
        function: checkAmount,
        revertTo: 'physical.delivery.create.amount'
      }, {
        function: checkAddress,
        revertTo: 'physical.delivery.create.address'
      }],
      next: executeRedemption
    }
  };

  vm.model = model;
  vm.result = result;
  vm.selectEntity = selectEntity;

  activate();

  function activate() {
    vm.user = HoldingUser.get();

    vm.canCollectBars = HoldingUser.isAllowed('collectBars');
    vm.canTakeDelivery = HoldingUser.isAllowed('redeemBars');

    $controller('BaseFlowController', { vm: vm, $scope: $scope });
    vm.availableError = null;
    HoldingBaird.getRedemptionAvailable().then(function (_ref) {
      var bars = _ref.bars,
          entities = _ref.entities;

      vm.enabled100g = bars.find(function (bar) {
        return bar.metal.amount === 100;
      });
      vm.enabled1000g = bars.find(function (bar) {
        return bar.metal.amount === 1000;
      }) && vm.canCollectBars;
      vm.entities = entities;
    }).catch(function (error) {
      vm.availableError = error.message;
    });
  }

  function checkAmount() {
    return model.bars.some(function (bar) {
      return !!bar.qty;
    });
  }

  function checkAddress() {
    // TODO implement
    return true;
  }

  function executeRedemption() {
    vm.executionError = null;
    return HoldingBaird.redeem(model).then(complete).catch(function (error) {
      vm.executionError = error.message;
      return $q.reject(error);
    });
  }

  function complete() {
    return $state.go('physical.delivery.overview', { complete: 'success' });
  }

  function previewRedemption() {
    return HoldingBaird.previewRedemption(model).then(function (preview) {
      vm.preview = preview;
      vm.entity = vm.entities.find(function (entity) {
        return entity.id === model.delivery;
      });
      vm.pinRequired = preview.pinRequired;
      vm.locations = preview.locations.map(function (vault) {
        var vaultInfo = HoldingVaults.getVaultInfoById(vault);
        var name = vaultInfo.name;
        var country = locationNameFilter(vault);
        return {
          value: vault,
          label: name + ' ' + country
        };
      });
      if (vm.locations.length > 0) {
        vm.model.location = vm.locations[0].value;
      }
      vm.canExecute = vm.locations.length > 0;
    });
  }

  function selectEntity(entity) {
    model.delivery = entity;
  }
}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = "<section class=\"gmw-flow-box gmw-flow-box--center\" ng-if=!redeemCreateCtrl.canTakeDelivery> <holding-permission-based-empty-state permission=redeemBars></holding-permission-based-empty-state> </section> <section ng-if=redeemCreateCtrl.canTakeDelivery> <div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view=step></div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'Can I take physical possession of my precious metal?'|translate}}\" href holding-external-link=support.redemption.possession> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'Are there tax implications?'|translate}}\" href holding-external-link=support.redemption.tax> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'To which countries do you deliver bars?'|translate}}\" href holding-external-link=support.redemption.countries> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'I want to contact Goldmoney'|translate}}\" href=https://support.goldmoney.com/hc/requests/new> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> </section> ";

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span translate ng-if=!redeemCreateCtrl.canCollectBars> While your precious metals are secure in our network of insured vaults, if you wish to store them yourself we can arrange for delivery of them to you directly. </span> <span translate ng-if=redeemCreateCtrl.canCollectBars> While your precious metals are secure in our network of insured vaults, if you wish to store them yourself we can arrange for collection or delivery of them to you directly. </span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=redeemCreateCtrl.form> <h4 class=\"heading-h4 h-dark-text\" translate ng-if=!redeemCreateCtrl.availableError> Please Select the Bar Size and Quantity </h4> <holding-alert-legacy class=error ng-if=redeemCreateCtrl.availableError ng-bind=redeemCreateCtrl.availableError> </holding-alert-legacy> <div class=gmw-redemption-metals> <div class=gmw-redemption-metals__col ng-if=redeemCreateCtrl.enabled1000g> <div class=\"gmw-redemption-metals__illustration gmw-redemption-metals__illustration-1000g\"></div> <div class=gmw-redemption-metals__input> <gmw-box-input class=gmw-input-container name=amount1000g type=text ng-required=!(redeemCreateCtrl.model.bars[1].qty) has-error=\"redeemCreateCtrl.form.amount1000g.$dirty && redeemCreateCtrl.form.amount1000g.$invalid\" ng-model=redeemCreateCtrl.model.bars[0].qty no-label gmw-number-int placeholder=0> </gmw-box-input> <span class=\"heading-h4 gmw-redemption-metals__input-description\">&times; 1kg bar</span> </div> </div> <div class=gmw-redemption-metals__col ng-if=redeemCreateCtrl.enabled100g> <div class=\"gmw-redemption-metals__illustration gmw-redemption-metals__illustration-100g\"></div> <div class=gmw-redemption-metals__input> <gmw-box-input class=gmw-input-container name=amount100g type=text ng-required=!(redeemCreateCtrl.model.bars[0].qty) has-error=\"redeemCreateCtrl.form.amount100g.$dirty && redeemCreateCtrl.form.amount100g.$invalid\" ng-model=redeemCreateCtrl.model.bars[1].qty no-label gmw-number-int placeholder=0> </gmw-box-input> <span class=\"heading-h4 gmw-redemption-metals__input-description\">&times; 100 gram bar</span> </div> </div> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=redeemCreateCtrl.cancel() on-next=redeemCreateCtrl.next() step-disabled=\"redeemCreateCtrl.form.$invalid || redeemCreateCtrl.form.$submitted || redeemCreateCtrl.availableError\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description> <span translate ng-if=!redeemCreateCtrl.canCollectBars> To ensure fastest shipping times, please ensure the mailing address below is correct. </span> <span translate ng-if=redeemCreateCtrl.canCollectBars> Please select the delivery method for your Goldmoney Bars below. If choosing to have the bars shipped, please ensure the mailing address is correct. </span> </p> </holding-flow-header> <div class=gmw-flow-box-container ng-form=redeemCreateCtrl.form> <holding-alert class=info ng-if=!redeemCreateCtrl.canCollectBars title=\"{{'Please Note'|translate}}\"> <main> <span ng-bind=\"'Bar collection is only available to UK residents'|translate\"></span> </main> </holding-alert> <gmw-main-table ng-click=redeemCreateCtrl.selectEntity(null)> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--select gmw-main-table__body-cell--select-left\"> <gmw-radio-option checked=!redeemCreateCtrl.model.delivery ng-if=redeemCreateCtrl.canCollectBars> </gmw-radio-option> <gmw-radio-option ng-if=!redeemCreateCtrl.canCollectBars gmw-disabled=true> </gmw-radio-option> </gmw-main-table-body-col> <gmw-main-table-body-col ng-bind=\"'Collect in person in London, England'|translate\"></gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> <gmw-main-table ng-repeat=\"entity in redeemCreateCtrl.entities track by entity.id\" ng-click=redeemCreateCtrl.selectEntity(entity.id)> <gmw-main-table-body> <gmw-main-table-body-row> <gmw-main-table-body-col class=\"gmw-main-table__body-cell--select gmw-main-table__body-cell--select-left\"> <gmw-radio-option checked=\"redeemCreateCtrl.model.delivery === entity.id\"> </gmw-radio-option> </gmw-main-table-body-col> <gmw-main-table-body-col class=gmw-main-table__body-cell--multiline> <div> <span class=h-dark-text translate>Ship by insured mail to {{::entity.name}}</span><br> <span class=\"h-dark-text gmw-redemption-address-label\" ng-bind=\"'Address'|translate\"></span><br> <span ng-bind=::entity.address.line1></span><br> <span ng-if=::entity.address.line2><span ng-bind=::entity.address.line2></span><br></span> <span ng-bind=::entity.address.city></span> <span ng-bind=::entity.address.state></span><br> <span ng-bind=::entity.address.countryCC2|holdingCountryName></span> <span ng-bind=::entity.address.zip></span> </div> </gmw-main-table-body-col> </gmw-main-table-body-row> </gmw-main-table-body> </gmw-main-table> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=redeemCreateCtrl.cancel() on-next=redeemCreateCtrl.next() step-disabled=\"redeemCreateCtrl.form.$invalid || redeemCreateCtrl.form.$submitted\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description ng-if=redeemCreateCtrl.pinRequired> <span translate>A delivery PIN has been sent to you.</span> </p> </holding-flow-header> <div class=gmw-flow-box-container> <div ng-form=redeemCreateCtrl.form> <div ng-show=\"redeemCreateCtrl.form.pin.$dirty && redeemCreateCtrl.form.pin.$invalid\" ng-messages=redeemCreateCtrl.form.pin.$error> <div ng-message=required> <holding-alert-legacy class=error> <span ng-bind=\"'Please enter a valid pin value.'|translate\"></span> </holding-alert-legacy> </div> </div> <div class=gmw-flow-pin ng-if=redeemCreateCtrl.pinRequired> <div class=\"gmw-input-container gmw-input-container--split-half\"> <div class=gmw-input-container--split-half__col> <span class=\"gmw-flow-pin__title heading-h4 h-dark-text\" ng-bind=\"'Enter Delivery Pin'|translate\"> </span> <a href class=h-blue-link ng-bind=\"'What is this?'|translate\" gmw-tooltip=\"{{'Two-step authentication requires that you enter a seven-digit PIN code to transfer funds. This randomly generated PIN has been sent via email or text message (per your account settings). Please enter the PIN to complete your transfer.'|translate}}\"> </a> </div> <div class=gmw-input-container--split-half__col> <gmw-box-input required name=pin no-label=true has-error=\"redeemCreateCtrl.form.pin.$dirty && redeemCreateCtrl.form.pin.$invalid\" ng-model=redeemCreateCtrl.model.pin placeholder=\"{{'Enter pin'|translate}}\"> <gmw-box-input-meta-left> <svg class=gmw-box-input__icon width=15px height=20px> <use xlink:href=#lock-icon></use> </svg> </gmw-box-input-meta-left> </gmw-box-input> </div> </div> </div> <holding-alert-legacy class=info ng-if=!redeemCreateCtrl.canExecute ng-bind=\"'You currently do not have sufficient funds in your Holding to pay the total amount shown above. You can reduce the total amount by purchasing fewer bars or by collecting the bars instead of having them shipped to you. Click back to return to the previous page to make changes or to start over.'|translate\"></holding-alert-legacy> <div class=\"gmw-recap-table gmw-recap-table--shadow gmw-recap-table--small-padding\"> <gmw-recap-table-header label=\"{{'Summary of Purchase Cost'|translate}}\"></gmw-recap-table-header> <div class=\"gmw-recap-table__body gmw-recap-table__body--narrow\"> <div ng-repeat=\"element in redeemCreateCtrl.preview.breakdown track by element.bar.id\"> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=element.desc> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::element.totalWeight|gmwFormatProduct> </span> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=element.feeDesc> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::element.fabricationFee|gmwFormatProduct> </span> </div> </div> </div> <div class=gmw-recap-table__row> <div class=gmw-recap-table__col ng-bind=redeemCreateCtrl.preview.feeDesc> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::redeemCreateCtrl.preview.deliveryFee|gmwFormatProduct> </span> </div> </div> <div class=gmw-recap-table__row> <div class=\"gmw-recap-table__col h-dark-text\" ng-bind=\"'Total'|translate\"> </div> <div class=gmw-recap-table__col> <span class=gmw-recap-table__value ng-bind=::redeemCreateCtrl.preview.total|gmwFormatProduct> </span> </div> </div> </div> </div> <gmw-box-selector required ng-if=\"redeemCreateCtrl.locations.length > 1\" name=location class=gmw-input-container ng-model=redeemCreateCtrl.model.location label=\"{{'Vault to be used for Payment'|translate}}\" options=redeemCreateCtrl.locations> </gmw-box-selector> <gmw-box-selector required readonly=readonly ng-if=\"redeemCreateCtrl.locations.length === 1\" name=location class=gmw-input-container ng-model=redeemCreateCtrl.model.location label=\"{{'Vault to be used for Payment'|translate}}\" options=redeemCreateCtrl.locations> </gmw-box-selector> <p class=gmw-flow-box__description ng-if=\"::!redeemCreateCtrl.entity && redeemCreateCtrl.canExecute\"> <span ng-bind=\"'You chose to collect the Goldmoney Gold Bars in person at the offices of Baird &amp; Co. in London, United Kingdom. When the bars are ready for collection, we will provide you with detailed collection instructions.'|translate\"></span> </p> <div class=\"gmw-recap-table gmw-recap-table--shadow\" ng-if=\"redeemCreateCtrl.entity && redeemCreateCtrl.canExecute\"> <span class=\"h-dark-text gmw-redemption-address-label\" ng-bind=\"'Delivery Address for Bar Shipment'|translate\"></span><br> <span ng-bind=::redeemCreateCtrl.entity.address.line1></span><br> <span ng-if=::redeemCreateCtrl.entity.address.line2><span ng-bind=::redeemCreateCtrl.entity.address.line2></span><br></span> <span ng-bind=::redeemCreateCtrl.entity.address.city></span> <span ng-bind=::redeemCreateCtrl.entity.address.state></span><br> <span ng-bind=::redeemCreateCtrl.entity.address.countryCC2|holdingCountryName></span> <span ng-bind=::redeemCreateCtrl.entity.address.zip></span> </div> <div class=gmw-flow-box__callout ng-if=redeemCreateCtrl.canExecute> <gmw-checkbox ng-model=redeemCreateCtrl.terms class=h-margin-bottom-20 required> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"redeemCreateCtrl.user.regulation == 'Toronto'\" translate> I accept the terms of the <a class=h-blue-link holding-external-link=clientAgreement.regulator.canada>Goldmoney Client Agreement</a>. </span> <span class=\"h-dark-text h-medium-text h-bold-text\" ng-if=\"redeemCreateCtrl.user.regulation == 'UK'\" translate> I accept the terms of the <a class=h-blue-link holding-external-link=clientAgreement.regulator.uk>Goldmoney Client Agreement</a>. </span> </gmw-checkbox> <gmw-checkbox ng-model=redeemCreateCtrl.confirm required> <span class=\"h-dark-text h-medium-text h-bold-text\" translate ng-if=!redeemCreateCtrl.entity> I understand that, upon clicking <span class=h-dark-text>Next Step</span>, this order will be executed and cannot be amended or cancelled. </span> <span class=\"h-dark-text h-medium-text h-bold-text\" translate ng-if=redeemCreateCtrl.entity> I confirm this is my correct shipping address and that I authorise anyone at this address to take delivery of the bar shipment on my behalf. </span> </gmw-checkbox> </div> </div> <holding-alert-legacy class=error ng-if=redeemCreateCtrl.executionError> <span ng-bind=redeemCreateCtrl.executionError></span> </holding-alert-legacy> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col> <holding-flow-indicator></holding-flow-indicator> </div> <holding-flow-controls on-cancel=redeemCreateCtrl.cancel() on-next=redeemCreateCtrl.next() step-disabled=\"redeemCreateCtrl.form.$invalid || redeemCreateCtrl.form.$submitted || !redeemCreateCtrl.canExecute\"> </holding-flow-controls> </footer> ";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingBaird.$inject = ['$rootScope', 'HoldingApi', 'HoldingUser'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.physical').factory('HoldingBaird', HoldingBaird).name;


function HoldingBaird($rootScope, HoldingApi, HoldingUser) {
  'ngInject';

  var key = 'gmw:bars:available';

  return {
    getRedemptionAvailable: getRedemptionAvailable,
    getRedemptionOrders: getRedemptionOrders,
    previewRedemption: previewRedemption,
    redeem: redeem,
    showRedeemBars: showRedeemBars
  };

  function addDefault(bar) {
    if (!bar.qty) {
      bar.qty = 0;
    }
    return bar;
  }

  function getRedemptionAvailable() {
    return HoldingApi.get('bars/redemption/available');
  }

  function getRedemptionOrders() {
    return HoldingApi.get('bars/redemption/orders');
  }

  function notifyBarsChanged() {
    $rootScope.$broadcast('gmw:balance:changed');
  }

  function previewRedemption(_ref) {
    var bars = _ref.bars,
        delivery = _ref.delivery;

    var data = {
      delivery: delivery,
      bars: bars.map(addDefault)
    };
    return HoldingApi.post('bars/redemption/preview', data);
  }

  function redeem(_ref2) {
    var bars = _ref2.bars,
        delivery = _ref2.delivery,
        pin = _ref2.pin,
        location = _ref2.location;

    var data = {
      delivery: delivery,
      bars: bars.map(addDefault),
      pin: pin,
      location: location
    };
    return HoldingApi.post('bars/redemption/redeem', data);
  }

  function showRedeemBars() {
    return !HoldingUser.isHidden('redeemBars');
  }
}

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularjs = __webpack_require__(2);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _common = __webpack_require__(1);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app.holding.dashboard.verification', [_angularjs2.default, _common2.default]).name;


__webpack_require__(1024);
__webpack_require__(1025);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


gmwFieldValidation.$inject = ['$compile'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app.holding.dashboard.verification').directive('gmwFieldValidation', gmwFieldValidation).name;


function gmwFieldValidation($compile) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'A',
    priority: 1000
  };
  return directive;

  function link(scope, element, attrs) {
    if (!attrs.addedValidation) {
      element.attr('ng-required', attrs.gmwFieldValidation + '.required');
      element.attr('ng-maxlength', attrs.gmwFieldValidation + '.max');
      element.attr('ng-minlength', attrs.gmwFieldValidation + '.min');
      element.attr('ng-pattern', attrs.gmwFieldValidation + '.pattern');
      element.attr('ng-if', attrs.gmwFieldValidation + '.show');
      element.attr('description', '{{' + attrs.gmwFieldValidation + '|holdingValidationInfo}}');

      element.attr('added-validation', true);
      $compile(element)(scope);
    }
  }
}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hero = __webpack_require__(1026);

var _hero2 = _interopRequireDefault(_hero);

var _verification = __webpack_require__(1027);

var _verification2 = _interopRequireDefault(_verification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.verification').config(['$stateProvider', function ($stateProvider) {
  'ngInject';

  $stateProvider.state('verification', {
    data: {
      noMobileCompoents: true,
      heroNoMobileActionTabs: true
    },
    parent: 'holding.dashboard',
    url: '/verification',
    views: {
      hero: {
        template: _hero2.default
      },
      main: _verification2.default
    }
  });
}]);

__webpack_require__(1029);

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "<holding-dashboard-header></holding-dashboard-header> <section class=holding-dashboard-hero-actions> <section class=holding-dashboard-hero-actions__left> <holding-dashboard-hero-actions-main-controls> </holding-dashboard-hero-actions-main-controls> <holding-dashboard-hero-actions-main-title title=\"{{'Holding Verification'|translate}}\"> </holding-dashboard-hero-actions-main-title> </section> <section class=holding-dashboard-hero-actions__center> </section> <section class=holding-dashboard-hero-actions__right></section> </section> <holding-dashboard-hero-bg></holding-dashboard-hero-bg> ";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


VerificationController.$inject = ['HoldingUser', 'GmwSetup'];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _verification = __webpack_require__(1028);

var _verification2 = _interopRequireDefault(_verification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = 'VerificationController';

angular.module('app.holding.dashboard.verification').controller(controller, VerificationController);

exports.default = {
  template: _verification2.default,
  controller: controller,
  controllerAs: 'verificationCtrl'
};


function VerificationController(HoldingUser, GmwSetup) {
  'ngInject';

  var vm = this;

  function activate() {
    vm.user = HoldingUser.get();

    GmwSetup.getSetupStatus(true).then(function (_ref) {
      var entities = _ref.entities;

      vm.entities = entities;
      vm.entities.map(function (entity) {
        entity.usClient = entity.address.country === 'US';
        return entity;
      });
      vm.canUseJumio = vm.entities.some(function (_) {
        return _.verification.canUseJumio;
      });
    });
  }

  activate();
}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = "<section class=gmw-verification-wrapper ui-view> <div class=floating-sidebar-app-view> <div class=\"floating-sidebar-app-view__main gmw-verification-wrapper__main\"> <header class=gmw-flow-box__header> <h2 class=\"gmw-flow-box__header-title heading-h1 h-dark-text\" ng-bind=\"'We Require Additional Information'|translate\"> </h2> <p class=gmw-flow-box__header-description ng-bind=\"'To complete the verification of your Holding to enable you to use all Holding features, please complete one of the options below:'|translate\"> </p> </header> <div class=\"gmw-flow-box-container gmw-verification-container gmw-verification-container--no-steps\"> <div class=gmw-verification-container__section ng-repeat=\"entity in verificationCtrl.entities\" ng-if=!entity.verification.verified> <div class=\"brandon h-dark-text h-margin-bottom-20 h-flex\"> <div class=h-flex-grow> <div ng-if=$first> <span ng-bind=\"'Primary Owner:'|translate\"></span> <span ng-bind=::entity.name></span> </div> <div ng-if=!$first> <span ng-bind=\"'Secondary Owner:'|translate\"></span> <span ng-bind=::entity.name></span> </div> </div> </div> <div class=\"gmw-verification-step gmw-verification-step--no-step\"> <div class=gmw-verification-step__inner> <div class=gmw-verification-step__description> <span class=\"heading-h4 h-dark-text\" ng-if=entity.verification.pendingJumio ng-bind=\"'Online Verification'|translate\"></span> <p class=\"h-medium-text h-margin-bottom-15\" ng-if=entity.verification.pendingJumio translate> Thank you for submitting your information. Our team will begin the review process and will advise you on any further information or documentation that is required to complete your verification. </p> <span class=\"heading-h4 h-dark-text\" ng-if=entity.verification.canUseJumio ng-bind=\"'Online Verification'|translate\"></span> <p class=\"h-medium-text h-margin-bottom-15\" ng-if=entity.verification.canUseJumio ng-bind=\"'Provide additional verification information via Jumio Netverify'|translate\"> </p> <span class=\"gmw-verification-step__or gold-text h-default-text h-margin-bottom-15\" ng-if=entity.verification.canUseJumio translate> OR </span> <span class=\"heading-h4 h-dark-text\" ng-if=\"entity.verification.canUseMail || entity.verification.canUsePostIdent\" translate> Offline Verification </span> <p class=h-medium-text ng-if=entity.verification.canUseMail> <span ng-bind=\"'Print verification forms and send via mail to our office.'|translate\"></span> <br> <a class=\"gmw-more-link h-margin-top-5\" holding-external-link=documents.mailVerification download> <span ng-bind=\"'Download Forms'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </p> <p class=h-medium-text ng-if=entity.verification.canUsePostIdent> <span ng-bind=\"'Verify Via PostIdent'|translate\"></span> <a holding-external-link=support.onboarding.postident class=h-blue-link ng-bind=\"'Learn More'|translate\"></a> <br> <a class=\"gmw-more-link h-margin-top-5\" holding-external-link=documents.postIdentVerification download> <span ng-bind=\"'Download Forms'|translate\"></span> <svg class=gmw-more-link__arrow> <use xlink:href=#long-small-right-arrow></use> </svg> </a> </p> </div> </div> <div class=h-flex ng-if=entity.verification.canUseJumio> <div class=\"gmw-verification-step__action gmw-verification-step__action--go\" ui-sref=\"verification.netverify.perform({code: entity.code})\"> <holding-svg-icon class=gmw-verification-step__arrow icon=right-arrow> </holding-svg-icon> </div> </div> </div> </div> </div> </div> <holding-setup-sidebar></holding-setup-sidebar> </div> </section> ";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _flow = __webpack_require__(1030);

var _flow2 = _interopRequireDefault(_flow);

var _netverify = __webpack_require__(1031);

var _netverify2 = _interopRequireDefault(_netverify);

var _perform = __webpack_require__(1033);

var _perform2 = _interopRequireDefault(_perform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app.holding.dashboard.onboarding').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('verification.netverify', {
        data: {
            flow: _flow2.default,
            heroNoMobileActionTabs: true,
            hideFooter: true,
            noMobileCompoents: true,
            skipSetupCheck: true
        },
        params: {
            code: {
                type: 'int'
            }
        },
        url: '/:code/netverify',
        views: {
            '': {
                component: _netverify2.default
            }
        }
    }).state('verification.netverify.perform', {
        data: {
            skipSetupCheck: true
        },
        template: _perform2.default,
        url: '/perform'
    });
}]);

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = {"name":"Online Verification","steps":[{"key":"netverify","state":"verification.netverify.perform","heading":"Perform Online Verification","label":"Online Verification","returnTo":"verification","keepStateOnPrev":true}]}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _netverify = __webpack_require__(1032);

var _netverify2 = _interopRequireDefault(_netverify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VerificationNetverifyController = function VerificationNetverifyController($state, $stateParams, GmwNetVerify) {
    var _this = this;

    _classCallCheck(this, VerificationNetverifyController);

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.GmwNetVerify = GmwNetVerify;
    this.$onInit = function () {
        _this.start();
    };
    this.$onDestroy = function () {
        _this.GmwNetVerify.tearDown();
    };
    this.start = function () {
        _this.GmwNetVerify.init(_this.$stateParams.code).then(function (_ref) {
            var url = _ref.url,
                promise = _ref.promise;

            _this.iframeSrc = url;
            promise.then(function () {
                _this.$state.go('holding.dashboard.overview', {}, { reload: true });
            }).catch(function (errorCode) {
                _this.error = errorCode;
            });
        });
    };
    this.retry = function () {
        _this.error = undefined;
        _this.start();
    };
};

VerificationNetverifyController.$inject = ['$state', '$stateParams', 'GmwNetVerify'];
var Eid = {
    controller: VerificationNetverifyController,
    template: _netverify2.default
};
var componentName = 'gmwVerificationNetverify';
angular.module('app.holding.dashboard.onboarding').component(componentName, Eid);
exports.default = componentName;

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "<div class=_wrapper> <div class=\"gmw-mobile-flow-step mobile-only mobile-only--xxs\" gmw-flow-hide-complete> <holding-flow-indicator></holding-flow-indicator> </div> <section class=sidebar-app-view> <div class=\"sidebar-app-view__main gmw-flow-box\" ui-view on-complete=verificationCtrl.onNetverifyComplete()> </div> <div class=sidebar-app-view__sidebar> <holding-flow-sidebar> <holding-flow-sidebar-progress-section></holding-flow-sidebar-progress-section> <holding-flow-sidebar-section header=\"{{'Do you need help?'|translate}}\"> <holding-flow-sidebar-list> <gmw-sidebar-list-link label=\"{{'How do I complete online verification?'|translate}}\" holding-external-link=support.onboarding.documents> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'What photographic identification documents do you accept?'|translate}}\" holding-external-link=support.onboarding.id> </gmw-sidebar-list-link> <gmw-sidebar-list-link label=\"{{'Can I have a joint Holding?'|translate}}\" holding-external-link=support.onboarding.por> </gmw-sidebar-list-link> </holding-flow-sidebar-list> </holding-flow-sidebar-section> </holding-flow-sidebar> </div> </section> </div> ";

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = "<holding-flow-header> <p class=gmw-flow-box__header-description translate> Please ensure your photo ID meets the criteria and is on the list below of acceptable documents. </p> </holding-flow-header> <div class=gmw-flow-box-container> <holding-alert-legacy class=success ng-if=$ctrl.success> <span translate>The document upload was successful. We will be reviewing your documents and will soon update your verification status.</span> </holding-alert-legacy> <div ng-if=$ctrl.error ng-switch=$ctrl.error> <div ng-switch-when=9820> <span class=\"heading-h4 dark-text\" translate>Camera Not Available</span> <p class=gmw-flow-box__description translate> It appears that your configuration does not have a webcam or camera. Please retry with a device equipped with a webcam or camera, or use one of the other verification options. </p> </div> <div ng-switch-when=unknown> <holding-alert-legacy class=error> <span translate>An error occurred during verification. Please try again later.</span> </holding-alert-legacy> </div> <div ng-switch-default> <holding-alert-legacy class=warning> <span translate>Document verification was not successful. Error: {{$ctrl.error}}</span> </holding-alert-legacy> <button class=\"medium-main-cta gmw-responsive-button\" gmw-action=$ctrl.retry()> <span translate>Try Again</span> </button> </div> </div> <div id=JUMIOIFRAME class=gmw-netverify-container> <iframe ng-src=\"{{$ctrl.iframeSrc}}\" allow=camera;fullscreen;accelerometer;gyroscope;magnetometer allowfullscreen></iframe> </div> </div> <footer class=gmw-flow-box-footer> <div class=gmw-flow-box-footer__col></div> </footer> ";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').config(['$provide', function ($provide) {
  'ngInject';

  $provide.decorator('$state', ['$delegate', '$transitions', function ($delegate, $transitions) {
    $transitions.onStart({}, function (trans) {
      $delegate.toParams = trans.params();
      $delegate.next = trans.to().name;
    });
    return $delegate;
  }]);
}]).name;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').config(['$compileProvider', '$logProvider', 'HoldingEnvironment', function ($compileProvider, $logProvider, HoldingEnvironment) {
  'ngInject';

  $compileProvider.debugInfoEnabled(HoldingEnvironment.settings.debug);
  $logProvider.debugEnabled(!!HoldingEnvironment.settings.log.debug);
}]).name;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').config(['$compileProvider', '$httpProvider', '$sceDelegateProvider', function ($compileProvider, $httpProvider, $sceDelegateProvider) {
  'ngInject';

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|http|mailto|bitcoin):/);
  $httpProvider.defaults.withCredentials = true;
  $sceDelegateProvider.resourceUrlWhitelist(['self']);
}]).name;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').config(['$locationProvider', function ($locationProvider) {
  'ngInject';

  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
}]).name;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingAugur.$inject = ['$window'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').directive('holdingAugur', holdingAugur).name;


function holdingAugur($window) {
  'ngInject';

  var HID = null;

  return {
    link: link,
    require: 'ngModel',
    restrict: 'E'
  };

  function link(_scope, _element, _attrs, ctrl) {
    function createAugurScript() {
      var date = Date.now().toString();
      var el = $window.$('<script src="//cdn1.identitymind.com/dfp-wrapper/d.js?t=' + date + '"></script>');

      $window.$('head').append(el);
    }

    function registerCallback(ngModelCtrl) {
      $window.dfpCallback = function (error, result) {
        var resultJson = JSON.stringify(error === null ? result : error);

        HID = resultJson;
        ngModelCtrl.$setViewValue(resultJson);
      };
    }

    ctrl.$setViewValue('');

    if (HID) {
      ctrl.$setViewValue(HID);
    } else {
      registerCallback(ctrl);
      createAugurScript();
    }
  }
}

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').directive('holdingButtonDisabled', holdingButtonDisabled).name;


function holdingButtonDisabled() {
  'ngInject';

  return {
    link: link,
    restrict: 'A',
    scope: {
      holdingButtonDisabled: '='
    }
  };

  function link(scope, element) {
    function onAttributeChange(needDisabled) {
      if (needDisabled) {
        element.addClass('disabled');
        element.prop('disabled', true);
      } else {
        element.removeClass('disabled');
        element.prop('disabled', false);
      }

      element.prop('disabled', needDisabled);
    }

    scope.$watch('holdingButtonDisabled', onAttributeChange);
  }
}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingCaptcha.$inject = ['$timeout', '$window', 'HoldingConfig'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').directive('holdingCaptcha', holdingCaptcha).name;


function holdingCaptcha($timeout, $window, HoldingConfig) {
  'ngInject';

  var _createdReCaptchaScript = false;
  var _initedReCaptcha = false;

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    template: '<div></div>'
  };

  function link(scope, element, _attrs, ctrl) {
    var initTimer = void 0;

    function createReCaptchaScript() {
      if (!_createdReCaptchaScript) {
        var el = $window.$('\n          <script src="https://www.google.com/recaptcha/api.js?onload=initReCaptcha&render=explicit" async defer></script>\n          ');

        $window.$('head').append(el);

        _createdReCaptchaScript = true;
      }
    }

    function initReCaptchaCb(cb) {
      if (_initedReCaptcha) {
        initTimer = $timeout(cb.bind(null, $window.grecaptcha));
      } else {
        $window.initReCaptcha = function _initReCaptcha() {
          _initedReCaptcha = true;
          cb($window.grecaptcha);
        };
      }
    }

    function onCaptchaReset() {
      ctrl.$setViewValue(null);
      $window.grecaptcha.reset();
    }

    function onDestroy() {
      $timeout.cancel(initTimer);
    }

    scope.$on('gm:captcha:reset', onCaptchaReset);
    scope.$on('$destroy', onDestroy);

    createReCaptchaScript();

    initReCaptchaCb(function (grecaptcha) {
      grecaptcha.render(element[0], {
        sitekey: HoldingConfig.recaptcha.sitekey,
        callback: function callback(resp) {
          ctrl.$setViewValue(resp);
        },
        'expired-callback': function expiredCallback() {
          ctrl.$setViewValue(null);
        }
      });
    });
  }
}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dragAndDrop = __webpack_require__(1042);

var _dragAndDrop2 = _interopRequireDefault(_dragAndDrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app').directive('holdingDragAndDrop', holdingDragAndDrop).name;


function holdingDragAndDrop() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      fileTypes: '=',
      maxFiles: '=',
      maxSize: '=',
      maxTotalSize: '=',
      parentError: '=?'
    },
    template: _dragAndDrop2.default
  };

  function link(scope, _element, attrs, ctrl) {
    function ctrlValueUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        scope.model.document = newDoc;
      }
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        ctrl.$setViewValue(newDoc);
      }
    }

    function initiateSelection(event) {
      angular.element('#dragAndDropInput').trigger('click');
      if (event) {
        event.preventDefault();
      }
    }

    function onNoBrowseChanged() {
      scope.noBrowseLabel = 'noBrowseLabel' in attrs && angular.isDefined(attrs.noBrowseLabel);
    }

    var model = {
      document: null
    };

    scope.initiateSelection = initiateSelection;
    scope.model = angular.copy(model);

    attrs.$observe('noBrowseLabel', onNoBrowseChanged);
    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(function () {
      return ctrl.$viewValue;
    }, ctrlValueUpdated);
  }
}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-drag-and-drop ng-form=form> <div ng-show=form.$invalid ng-messages=form.$error> <div ng-message=maxFiles> <holding-alert class=error> <main> <span> You may only upload {{maxFiles}} documents. </span> </main> </holding-alert> </div> <div ng-message=maxSize> <holding-alert class=error> <main> <span> The file you are attempting to upload is too large - please use a file under {{(maxSize / 1000000)}} MB in size. </span> </main> </holding-alert> </div> <div ng-message=pattern> <holding-alert class=error> <main> <span> You've attempted to upload an invalid file type - valid types end in one of {{filetypes}}. </span> </main> </holding-alert> </div> </div> <input style=display:none id=dragAndDropInput type=file ng-model=model.document ngf-select ngf-max-files=maxFiles ngf-max-size=maxSize ngf-max-total-size=maxTotalSize accept=\"{{fileTypes}}\" ngf-keep=\"'distinct'\" ngf-pattern=fileTypes> <label for=dragAndDropInput class=gmw-drag-and-drop__main ng-class=\"{\n      'gmw-drag-and-drop__main--error': form.$invalid || parentError,\n    }\" ngf-drag-over-class=\"'gmw-drag-and-drop__main--drag-active'\" ng-model=model.document ngf-drop ngf-max-files=maxFiles ngf-max-size=maxSize ngf-max-total-size=maxTotalSize ngf-keep=\"'distinct'\" ngf-pattern=fileTypes ng-click=initiateSelection($event)> <svg class=gmw-drag-and-drop__icon> <use xlink:href=#file-upload-icon></use> </svg> <div class=\"gmw-drag-and-drop__text desktop-only desktop-only--xxs\"> <div class=gmw-drag-and-drop__text-instructions> <div class=\"gmw-drag-and-drop__text-instructions--primary h-dark-text\" ng-bind=\"'Drop Files Here'|translate\"> </div> <div class=gmw-drag-and-drop__text-instructions--secondary ng-bind=\"'Or click to upload'|translate\"> </div> <div class=\"gmw-drag-and-drop__text-instructions--details very-h-light-text\" translate> {{fileTypes}} no larger than {{maxSize / 1000000}} MB </div> </div> <div class=gmw-drag-and-drop__text-browse ng-if=!noBrowseLabel> <a href class=h-blue-link ng-bind=\"'Browse'|translate\"></a> </div> </div> <div class=\"gmw-drag-and-drop__text mobile-only mobile-only--xxs\"> <div class=gmw-drag-and-drop__text-browse> <a href class=h-blue-link ng-bind=\"'Take Photo or Browse Files'|translate\"></a> </div> </div> </label> </div> ";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fileUpload = __webpack_require__(1044);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app').directive('holdingFileUpload', holdingFileUpload).name;


function holdingFileUpload() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      documentConfig: '=',
      hideWhenSelected: '=?'
    },
    template: _fileUpload2.default
  };

  function link(scope, _element, attrs, ctrl) {
    function ctrlValueUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        scope.model.document = newDoc;
      }
    }

    function documentConfigUpdated() {
      scope.maxFiles = scope.documentConfig.maxFiles;
      scope.maxSize = scope.documentConfig.maxSize;
      scope.maxTotalSize = scope.documentConfig.maxTotalSize;
      scope.permittedFileTypes = scope.documentConfig.extensions.join();
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        if (newDoc && newDoc.length) {
          ctrl.$setViewValue(newDoc);
        } else {
          ctrl.$setViewValue([]);
        }
      }
    }

    var DEFAULT_MODEL = {
      document: []
    };

    scope.model = angular.copy(DEFAULT_MODEL);
    scope.ngModel = ctrl;
    scope.noBrowseLabel = 'noBrowseLabel' in attrs && angular.isDefined(attrs.noBrowseLabel);
    scope.uploadPercent = 0;

    scope.$watch('documentConfig', documentConfigUpdated);
    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(function () {
      return ctrl.$viewValue;
    }, ctrlValueUpdated);
  }
}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-file-upload> <div class=gmw-file-upload__container ng-if=\"!model.document || model.document.length < 1 || maxFiles > 0\"> <holding-drag-and-drop file-types=permittedFileTypes max-files=maxFiles max-size=maxSize max-total-size=maxTotalSize ng-model=model.document ng-if=\"!(model.document && model.document.length > 0) || !hideWhenSelected\" ng-attr-no-browse-label=\"{{noBrowseLabel || undefined}}\" parent-error=\"ngModel.$$parentForm.$submitted && ngModel.$invalid\"> </holding-drag-and-drop> </div> <div class=gmw-file-upload__container ng-if=\"model.document.length > 0\"> <holding-file-upload-preview ng-model=model.document> </holding-file-upload-preview> </div> </div> ";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fileUploadPreview = __webpack_require__(1046);

var _fileUploadPreview2 = _interopRequireDefault(_fileUploadPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app').directive('holdingFileUploadPreview', holdingFileUploadPreview).name;


function holdingFileUploadPreview() {
  'ngInject';

  return {
    link: link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      progress: '=?'
    },
    template: _fileUploadPreview2.default
  };

  function link(scope, _element, _attrs, ctrl) {
    var model = {
      document: null
    };

    function ctrlValueUpdated(newDoc) {
      scope.model.document = newDoc;
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        ctrl.$setViewValue(newDoc);
      }
    }

    function rejectFile(index) {
      if (scope.model.document && scope.model.document.length > 1) {
        scope.model.document.splice(index, 1);
      } else {
        scope.model.document = [];
      }
    }

    scope.model = model;
    scope.rejectFile = rejectFile;

    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(function () {
      return ctrl.$viewValue;
    }, ctrlValueUpdated);
  }
}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = "<div class=gmw-file-upload-image-preview ng-repeat=\"document in model.document track by $index\"> <div class=gmw-file-upload-image-preview__reject ng-click=$parent.rejectFile($index)> <svg class=gmw-file-upload-image-preview__reject-icon> <use xlink:href=#cross-icon></use> </svg> </div> <div class=gmw-file-upload-image-preview__wrap ng-class=\"{\n      'gmw-file-upload-image-preview__wrap--no-image': document.type === 'application/pdf',\n    }\"> <img class=gmw-file-upload-image-preview__image ngf-src=document ng-if=\"document.type !== 'application/pdf'\"> <i class=gmw-file-upload-image-preview__check ng-class=\"{\n        'gmw-file-upload-image-preview__check--center': document.type !== 'application/pdf'\n      }\"> <svg class=gmw-file-upload-image-preview__check-icon> <use xlink:href=#checkmark-icon></use> </svg> </i> <div class=h-margin-top-15> <div class=h-default-text> <span class=h-dark-text ng-bind=\"'Name:'|translate\"></span> <span ng-bind=document.name></span> </div> <div class=h-default-text> <span class=h-dark-text ng-bind=\"'Type:'|translate\"></span> <span ng-bind=document.type></span> </div> <div class=h-default-text> <span class=h-dark-text ng-bind=\"'Size:'|translate\"></span> <span ng-bind=\"(document.size/1000000|number:2) + 'MB'\"></span> </div> </div> </div> </div> ";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingFormLoading.$inject = ['$parse', '$timeout'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').directive('holdingFormLoading', holdingFormLoading).name;


function holdingFormLoading($parse, $timeout) {
  'ngInject';

  return {
    compile: compile,
    restrict: 'A'
  };

  function compile(_element, attrs) {
    var fn = $parse(attrs.holdingFormLoading, null, true);

    return function _formLoading(scope, element) {
      element.on('submit', function ($event) {
        var btnEl = element.find('button:submit');

        btnEl.addClass('loading-button');
        btnEl.prop('disabled', true);

        $timeout(function () {
          var result = fn(scope, { $event: $event });

          if (result && angular.isFunction(result.finally)) {
            result.finally(function () {
              btnEl.removeClass('loading-button');
              btnEl.prop('disabled', false);
            });
          } else {
            btnEl.removeClass('loading-button');
            btnEl.prop('disabled', false);
          }
        });
      });
    };
  }
}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingExternalLink.$inject = ['$log', 'HoldingEnvironment'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').directive('holdingExternalLink', holdingExternalLink).name;


function holdingExternalLink($log, HoldingEnvironment) {
  'ngInject';

  return {
    compile: compile,
    restrict: 'A'
  };

  function compile(element, attrs) {
    if (attrs.holdingExternalLink) {
      var keys = attrs.holdingExternalLink.split('.');

      var linkPath = HoldingEnvironment.urls;
      var isValidLink = true;

      angular.forEach(keys, function (key) {
        if (key in linkPath) {
          linkPath = linkPath[key];
        } else {
          isValidLink = false;
        }
      });

      if (isValidLink) {
        switch (element.context.tagName) {
          case 'A':
            attrs.$set('href', linkPath);
            attrs.$set('target', '_blank');
            break;
          default:
            attrs.$set('onclick', 'window.open(\'' + linkPath + '\');');
            break;
        }
      } else {
        $log.error('Broken url reference:', attrs.holdingExternalLink);
      }
    } else {
      $log.error('Missing url reference:', attrs.holdingExternalLink);
    }
  }
}

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


holdingReloadPage.$inject = ['$window'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').directive('holdingReloadPage', holdingReloadPage).name;


function holdingReloadPage($window) {
  'ngInject';

  return {
    link: link,
    restrict: 'A'
  };

  function link(scope, element) {
    function clickHandler(event) {
      event.preventDefault();
      $window.location.reload();
    }

    function onDestroy() {
      element.off('click', clickHandler);
    }

    element.on('click', clickHandler);
    scope.$on('$destroy', onDestroy);
  }
}

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgIcon = __webpack_require__(1051);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app').directive('holdingSvgIcon', holdingSvgIcon).name;


function holdingSvgIcon() {
  'ngInject';

  return {
    link: link,
    replace: true,
    restrict: 'E',
    scope: true,
    template: _svgIcon2.default
  };

  function link(scope, _element, attrs) {
    attrs.$observe('icon', function (icon) {
      if (icon) {
        scope.icon = icon;
      }
    });
  }
}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "<svg class=h-fill-gmw-icon> <use xlink:href=\"\" ng-attr-xlink:href=\"{{'#' + icon + '-icon'}}\"></use> </svg> ";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').run(['$rootScope', '$state', '$document', '$transitions', 'promiseCache', function ($rootScope, $state, $document, $transitions, promiseCache) {
  'ngInject';

  $transitions.onError({}, function (transition) {
    var _transition$error = transition.error(),
        detail = _transition$error.detail;

    // auth errors


    if (detail && detail.status === 403) {
      promiseCache.removeAll();
      $state.go('auth.sign-in', {}, {
        reload: true
      });
    }

    // check for resolve redirects
    if (detail && detail.redirectTo) {
      $state.go(detail.redirectTo, Object.assign({}, detail.params), {
        reload: detail.reload
      });
    }
  });

  $transitions.onSuccess({}, function (transition) {
    if (!transition) {
      return;
    }

    var _transition$$to = transition.$to(),
        data = _transition$$to.data;

    $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;

    // page title, meta, class logic
    $rootScope.pageParams = {};
    if (data) {
      var heroNoMobileActionTabs = data.heroNoMobileActionTabs,
          hideFooter = data.hideFooter,
          noMobileCompoents = data.noMobileCompoents,
          pageBodyClass = data.pageBodyClass,
          pageMetaDescription = data.pageMetaDescription,
          pageTitle = data.pageTitle,
          smallHero = data.smallHero;


      angular.extend($rootScope.pageParams, {
        heroNoMobileActionTabs: heroNoMobileActionTabs,
        hideFooter: hideFooter,
        noMobileCompoents: noMobileCompoents,
        pageBodyClass: pageBodyClass,
        pageMetaDescription: pageMetaDescription,
        pageTitle: pageTitle,
        smallHero: smallHero
      });
    }
  });
}]).name;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('app').run(['$rootScope', 'promiseCache', 'HoldingAppVersion', function ($rootScope, promiseCache, HoldingAppVersion) {
  'ngInject';

  $rootScope.chineseVersion = "en" === 'zh-CN';

  $rootScope.$on('gmw:settings:profile:preferences:updated', function () {
    promiseCache.removeAll();
  });
  $rootScope.$on('gmw:settings:security:bankAccounts:updated', function () {
    promiseCache.removeAll();
  });

  HoldingAppVersion.init();
}]).name;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingAppUtilities.$inject = ['$timeout'];
angular.module('app').factory('HoldingAppUtilities', HoldingAppUtilities);

function HoldingAppUtilities($timeout) {
  'ngInject';

  return {
    padString: padString,
    throttle: throttle
  };

  function padString(origStr, width) {
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

    var str = '' + origStr;
    return str.length >= width ? str : new Array(width - str.length + 1).join(z) + str;
  }

  function throttle(fn, time) {
    var _this = this;

    var _timeout = void 0;

    return function () {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      if (_timeout) {
        $timeout.cancel(_timeout);
      }

      _timeout = $timeout(function () {
        return fn.apply(_this, params);
      }, time);

      return _timeout;
    };
  }
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


HoldingAppVersion.$inject = ['$q', '$http', '$interval', '$log', '$rootScope', '$timeout', 'HoldingAppVersionValue'];
angular.module('app').factory('HoldingAppVersion', HoldingAppVersion);

function HoldingAppVersion($q, $http, $interval, $log, $rootScope, $timeout, HoldingAppVersionValue) {
  'ngInject';

  var APP_VERSION_FILE = '/version.txt';
  var CHECK_APP_VERSION_INTERVAL = 30000;
  var GLOBAL_APP_RELOAD_PARAM = 'reloadApp';

  return {
    init: init
  };

  function checkAppVersion() {
    return getAppVersion().then(function (hash) {
      if (hash !== HoldingAppVersionValue) {
        $log.debug('need to refresh pages', hash, APP_VERSION_FILE);
      }

      $timeout(function () {
        $rootScope.globalAlerts[GLOBAL_APP_RELOAD_PARAM] = hash !== HoldingAppVersionValue;
      });
    }, function (error) {
      return $log.error(error);
    });
  }

  function getAppVersion() {
    return $http.get(APP_VERSION_FILE, {
      cache: false,
      params: {
        t: Date.now()
      }
    }).then(function (_ref) {
      var data = _ref.data;
      return $q.resolve(data);
    }, function () {
      return $q.reject('Can\'t get app version.');
    });
  }

  function init() {
    if (!$rootScope.globalAlerts) {
      $rootScope.globalAlerts = {};
    }

    $interval(checkAppVersion, CHECK_APP_VERSION_INTERVAL);
  }
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _x2js = __webpack_require__(1057);

var _x2js2 = _interopRequireDefault(_x2js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('app').value('X2JS', _x2js2.default).name;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	Copyright 2015 Axinom
	Copyright 2011-2013 Abdulla Abdurakhmanov
	Original sources are available at https://code.google.com/p/x2js/

	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at

	http://www.apache.org/licenses/LICENSE-2.0

	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
*/

/*
	Supported export methods:
	* AMD
	* <script> (window.X2JS)
	* Node.js

	Limitations:
	* Attribute namespace prefixes are not parsed as such.
	* Overall the serialization/deserializaton code is "best effort" and not foolproof.
*/

// Module definition pattern used is returnExports from https://github.com/umdjs/umd
(function (root, factory) {
	"use strict";

	/* global define */
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && module.exports) {
		// Node. Does not work with strict CommonJS, but only CommonJS-like
		// environments that support module.exports, like Node.
		module.exports = factory(require("@xmldom/xmldom").DOMParser);
	} else {
		// Browser globals (root is window)
		root.X2JS = factory();
	}
})(this, function (CustomDOMParser) {
	"use strict";

	// We return a constructor that can be used to make X2JS instances.
	return function X2JS(config) {
		var VERSION = "3.4.4";

		config = config || {};

		function initConfigDefaults() {
			// If set to "property" then <element>_asArray will be created
			// to allow you to access any element as an array (even if there is only one of it).
			config.arrayAccessForm = config.arrayAccessForm || "none";

			// If "text" then <empty></empty> will be transformed to "".
			// If "object" then <empty></empty> will be transformed to {}.
			config.emptyNodeForm = config.emptyNodeForm || "text";

			// Function that will be called for each elements, if the function returns true, the element will be skipped
			// function(name, value) { return true; };
			config.jsAttributeFilter = config.jsAttributeFilter;

			// Function that will be called for each elements, the element value will be replaced by the returned value
			// function(name, value) { return parseFloat(value); };
			config.jsAttributeConverter = config.jsAttributeConverter;

			// Allows attribute values to be converted on the fly during parsing to objects.
			// 	"test": function(name, value) { return true; }
			//	"convert": function(name, value) { return parseFloat(value); };
			// convert() will be called for every attribute where test() returns true
			// and the return value from convert() will replace the original value of the attribute.
			config.attributeConverters = config.attributeConverters || [];

			// Any elements that match the paths here will have their text parsed
			// as an XML datetime value (2011-11-12T13:00:00-07:00 style).
			// The path can be a plain string (parent.child1.child2),
			// a regex (/.*\.child2/) or function(elementPath).
			config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];

			// Any elements that match the paths listed here will be stored in JavaScript objects
			// as arrays even if there is only one of them. The path can be a plain string
			// (parent.child1.child2), a regex (/.*\.child2/) or function(elementName, elementPath).
			config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];

            // xmldom constructor arguments
            // @see https://github.com/jindw/xmldom#api-reference
			config.xmldomOptions = config.xmldomOptions || {};

			// If true, a toString function is generated to print nodes containing text or cdata.
			// Useful if you want to accept both plain text and CData as equivalent inputs.
			if (config.enableToStringFunc === undefined) {
				config.enableToStringFunc = true;
			}

			// If true, empty text tags are ignored for elements with child nodes.
			if (config.skipEmptyTextNodesForObj === undefined) {
				config.skipEmptyTextNodesForObj = true;
			}

			// If true, whitespace is trimmed from text nodes.
			if (config.stripWhitespaces === undefined) {
				config.stripWhitespaces = true;
			}

			// If true, double quotes are used in generated XML.
			if (config.useDoubleQuotes === undefined) {
				config.useDoubleQuotes = true;
			}

			// If true, the root element of the XML document is ignored when converting to objects.
			// The result will directly have the root element's children as its own properties.
			if (config.ignoreRoot === undefined) {
				config.ignoreRoot = false;
			}

			// Whether XML characters in text are escaped when reading/writing XML.
			if (config.escapeMode === undefined) {
				config.escapeMode = true;
			}

			// Prefix to use for properties that are created to represent XML attributes.
			if (config.attributePrefix === undefined) {
				config.attributePrefix = "_";
			}

			// If true, empty elements will created as self closing elements (<element />)
			// If false, empty elements will be created with start and end tags (<element></element>)
			if (config.selfClosingElements === undefined) {
				config.selfClosingElements = true;
			}

			// If this property defined as false and an XML element has CData node ONLY, it will be converted to text without additional property "__cdata"
			if (config.keepCData === undefined) {
				config.keepCData = false;
			}

			// If this property defined as true, use { __text: 'abc' } over 'abc'
			if (config.keepText === undefined) {
				config.keepText = false;
			}

			// If true, will output dates in UTC
			if (config.jsDateUTC === undefined) {
				config.jsDateUTC = false;
			}
		}

		function initRequiredPolyfills() {
			function pad(number) {
				var r = String(number);
				if (r.length === 1) {
					r = '0' + r;
				}
				return r;
			}
			// Hello IE8-
			if (typeof String.prototype.trim !== 'function') {
				String.prototype.trim = function trim() {
					return this.replace(/^\s+|^\n+|(\s|\n)+$/g, '');
				};
			}
			if (typeof Date.prototype.toISOString !== 'function') {
				// Implementation from http://stackoverflow.com/questions/2573521/how-do-i-output-an-iso-8601-formatted-string-in-javascript
				Date.prototype.toISOString = function toISOString() {
					var MS_IN_S = 1000;

					return this.getUTCFullYear()
						+ '-' + pad(this.getUTCMonth() + 1)
						+ '-' + pad(this.getUTCDate())
						+ 'T' + pad(this.getUTCHours())
						+ ':' + pad(this.getUTCMinutes())
						+ ':' + pad(this.getUTCSeconds())
						+ '.' + String((this.getUTCMilliseconds() / MS_IN_S).toFixed(3)).slice(2, 5)
						+ 'Z';
				};
			}
		}

		initConfigDefaults();
		initRequiredPolyfills();

		var DOMNodeTypes = {
			"ELEMENT_NODE": 1,
			"TEXT_NODE": 3,
			"CDATA_SECTION_NODE": 4,
			"COMMENT_NODE": 8,
			"DOCUMENT_NODE": 9
		};

		function getDomNodeLocalName(domNode) {
			var localName = domNode.localName;
			if (localName == null) {
				// Yeah, this is IE!!
				localName = domNode.baseName;
			}
			if (localName == null || localName === "") {
				// ==="" is IE too
				localName = domNode.nodeName;
			}
			return localName;
		}

		function getDomNodeNamespacePrefix(node) {
			return node.prefix;
		}

		function escapeXmlChars(str) {
			if (typeof str === "string")
				return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
			else
				return str;
		}

		function unescapeXmlChars(str) {
			return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&amp;/g, '&');
		}

		function ensureProperArrayAccessForm(element, childName, elementPath) {
			switch (config.arrayAccessForm) {
				case "property":
					if (!(element[childName] instanceof Array))
						element[childName + "_asArray"] = [element[childName]];
					else
						element[childName + "_asArray"] = element[childName];
					break;
			}

			if (!(element[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0) {
				var match = false;

				for (var i = 0; i < config.arrayAccessFormPaths.length; i++) {
					var arrayPath = config.arrayAccessFormPaths[i];
					if (typeof arrayPath === "string") {
						if (arrayPath === elementPath) {
							match = true;
							break;
						}
					} else if (arrayPath instanceof RegExp) {
						if (arrayPath.test(elementPath)) {
							match = true;
							break;
						}
					} else if (typeof arrayPath === "function") {
						if (arrayPath(childName, elementPath)) {
							match = true;
							break;
						}
					}
				}

				if (match)
					element[childName] = [element[childName]];
			}
		}

		function xmlDateTimeToDate(prop) {
			// Implementation based up on http://stackoverflow.com/questions/8178598/xml-datetime-to-javascript-date-object
			// Improved to support full spec and optional parts
			var MINUTES_PER_HOUR = 60;

			var bits = prop.split(/[-T:+Z]/g);

			var d = new Date(bits[0], bits[1] - 1, bits[2]);
			var secondBits = bits[5].split("\.");
			d.setHours(bits[3], bits[4], secondBits[0]);
			if (secondBits.length > 1)
				d.setMilliseconds(secondBits[1]);

			// Get supplied time zone offset in minutes
			if (bits[6] && bits[7]) {
				var offsetMinutes = bits[6] * MINUTES_PER_HOUR + Number(bits[7]);
				var sign = /\d\d-\d\d:\d\d$/.test(prop) ? '-' : '+';

				// Apply the sign
				offsetMinutes = 0 + (sign === '-' ? -1 * offsetMinutes : offsetMinutes);

				// Apply offset and local timezone
				d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());
			} else if (prop.indexOf("Z", prop.length - 1) !== -1) {
				d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));
			}

			// d is now a local time equivalent to the supplied time
			return d;
		}

		function convertToDateIfRequired(value, childName, fullPath) {
			if (config.datetimeAccessFormPaths.length > 0) {
				var pathWithoutTextNode = fullPath.split("\.#")[0];

				for (var i = 0; i < config.datetimeAccessFormPaths.length; i++) {
					var candidatePath = config.datetimeAccessFormPaths[i];
					if (typeof candidatePath === "string") {
						if (candidatePath === pathWithoutTextNode)
							return xmlDateTimeToDate(value);
					} else if (candidatePath instanceof RegExp) {
						if (candidatePath.test(pathWithoutTextNode))
							return xmlDateTimeToDate(value);
					} else if (typeof candidatePath === "function") {
						if (candidatePath(pathWithoutTextNode))
							return xmlDateTimeToDate(value);
					}
				}
			}

			return value;
		}

		function deserializeRootElementChildren(rootElement) {
			var result = {};
			var children = rootElement.childNodes;

			// Alternative for firstElementChild which is not supported in some environments
			for (var i = 0; i < children.length; i++) {
				var child = children.item(i);
				if (child.nodeType === DOMNodeTypes.ELEMENT_NODE) {
					var childName = getDomNodeLocalName(child);

					if (config.ignoreRoot)
						result = deserializeDomChildren(child, childName);
					else
						result[childName] = deserializeDomChildren(child, childName);
				}
			}

			return result;
		}

		function deserializeElementChildren(element, elementPath) {
			var result = {};
			result.__cnt = 0;

			var nodeChildren = element.childNodes;

			// Child nodes.
			for (var iChild = 0; iChild < nodeChildren.length; iChild++) {
				var child = nodeChildren.item(iChild);
				var childName = getDomNodeLocalName(child);

				if (child.nodeType === DOMNodeTypes.COMMENT_NODE)
					continue;

				result.__cnt++;

				// We deliberately do not accept everything falsey here because
				// elements that resolve to empty string should still be preserved.
				if (result[childName] == null) {
					result[childName] = deserializeDomChildren(child, elementPath + "." + childName);
					ensureProperArrayAccessForm(result, childName, elementPath + "." + childName);
				} else {
					if (!(result[childName] instanceof Array)) {
						result[childName] = [result[childName]];
						ensureProperArrayAccessForm(result, childName, elementPath + "." + childName);
					}

					result[childName][result[childName].length] = deserializeDomChildren(child, elementPath + "." + childName);
				}
			}

			// Attributes
			for (var iAttribute = 0; iAttribute < element.attributes.length; iAttribute++) {
				var attribute = element.attributes.item(iAttribute);
				result.__cnt++;

				var adjustedValue = attribute.value;
				for (var iConverter = 0; iConverter < config.attributeConverters.length; iConverter++) {
					var converter = config.attributeConverters[iConverter];
					if (converter.test.call(null, attribute.name, attribute.value))
						adjustedValue = converter.convert.call(null, attribute.name, attribute.value);
				}

				result[config.attributePrefix + attribute.name] = adjustedValue;
			}

			// Node namespace prefix
			var namespacePrefix = getDomNodeNamespacePrefix(element);
			if (namespacePrefix) {
				result.__cnt++;
				result.__prefix = namespacePrefix;
			}

			if (result["#text"]) {
				result.__text = result["#text"];

				if (result.__text instanceof Array) {
					result.__text = result.__text.join("\n");
				}

				if (config.escapeMode)
					result.__text = unescapeXmlChars(result.__text);

				if (config.stripWhitespaces)
					result.__text = result.__text.trim();

				delete result["#text"];

				if (config.arrayAccessForm === "property")
					delete result["#text_asArray"];

				result.__text = convertToDateIfRequired(result.__text, "#text", elementPath + ".#text");
			}

			if (result.hasOwnProperty('#cdata-section')) {
				result.__cdata = result["#cdata-section"];
				delete result["#cdata-section"];

				if (config.arrayAccessForm === "property")
					delete result["#cdata-section_asArray"];
			}

			if (result.__cnt === 1 && result.__text && !config.keepText) {
				result = result.__text;
			} else if (result.__cnt === 0 && config.emptyNodeForm === "text") {
				result = '';
			} else if (result.__cnt > 1 && result.__text !== undefined && config.skipEmptyTextNodesForObj) {
				if (config.stripWhitespaces && result.__text === "" || result.__text.trim() === "") {
					delete result.__text;
				}
			}
			delete result.__cnt;

			/**
			 * We are checking if we are creating a __cdata property or if we just add the content of cdata inside result.
			 * But, if we have a property inside xml tag (<tag PROPERTY="1"></tag>), and a cdata inside, we can't ignore it.
			 * In this case we are keeping __cdata property.
			 */
			if (!config.keepCData && (!result.hasOwnProperty('__text') && result.hasOwnProperty('__cdata') && Object.keys(result).length === 1)) {
				return (result.__cdata ? result.__cdata : '');
			}

			if (config.enableToStringFunc && (result.__text || result.__cdata)) {
				result.toString = function toString() {
					return (this.__text ? this.__text : '') + (this.__cdata ? this.__cdata : '');
				};
			}

			return result;
		}

		function deserializeDomChildren(node, parentPath) {
			if (node.nodeType === DOMNodeTypes.DOCUMENT_NODE) {
				return deserializeRootElementChildren(node);
			} else if (node.nodeType === DOMNodeTypes.ELEMENT_NODE) {
				return deserializeElementChildren(node, parentPath);
			} else if (node.nodeType === DOMNodeTypes.TEXT_NODE || node.nodeType === DOMNodeTypes.CDATA_SECTION_NODE) {
				return node.nodeValue;
			} else {
				return null;
			}
		}

		function serializeStartTag(jsObject, elementName, attributeNames, selfClosing) {
			var resultStr = "<" + ((jsObject && jsObject.__prefix) ? (jsObject.__prefix + ":") : "") + elementName;

			if (attributeNames) {
				for (var i = 0; i < attributeNames.length; i++) {
					var attributeName = attributeNames[i];
					var attributeValue = jsObject[attributeName];

					if (config.escapeMode)
						attributeValue = escapeXmlChars(attributeValue);

					resultStr += " " + attributeName.substr(config.attributePrefix.length) + "=";

					if (config.useDoubleQuotes)
						resultStr += '"' + attributeValue + '"';
					else
						resultStr += "'" + attributeValue + "'";
				}
			}

			if (!selfClosing)
				resultStr += ">";
			else
				resultStr += " />";

			return resultStr;
		}

		function serializeEndTag(jsObject, elementName) {
			return "</" + ((jsObject && jsObject.__prefix) ? (jsObject.__prefix + ":") : "") + elementName + ">";
		}

		function endsWith(str, suffix) {
			return str.indexOf(suffix, str.length - suffix.length) !== -1;
		}

		function isSpecialProperty(jsonObj, propertyName) {
			if ((config.arrayAccessForm === "property" && endsWith(propertyName.toString(), ("_asArray")))
				|| propertyName.toString().indexOf(config.attributePrefix) === 0
				|| propertyName.toString().indexOf("__") === 0
				|| (jsonObj[propertyName] instanceof Function))
				return true;
			else
				return false;
		}

		function getDataElementCount(jsObject) {
			var count = 0;

			if (jsObject instanceof Object) {
				for (var propertyName in jsObject) {
					if (isSpecialProperty(jsObject, propertyName))
						continue;

					count++;
				}
			}

			return count;
		}

		function getDataAttributeNames(jsObject) {
			var names = [];

			if (jsObject instanceof Object) {
				for (var attributeName in jsObject) {
					if (attributeName.toString().indexOf("__") === -1
						&& attributeName.toString().indexOf(config.attributePrefix) === 0) {
						names.push(attributeName);
					}
				}
			}

			return names;
		}

		function serializeComplexTextNodeContents(textNode) {
			var result = "";

			if (textNode.__cdata) {
				result += "<![CDATA[" + textNode.__cdata + "]]>";
			}

			if (textNode.__text || typeof (textNode.__text) === 'number' || typeof (textNode.__text) === 'boolean') {
				if (config.escapeMode)
					result += escapeXmlChars(textNode.__text);
				else
					result += textNode.__text;
			}

			return result;
		}

		function serializeTextNodeContents(textNode) {
			var result = "";

			if (textNode instanceof Object) {
				result += serializeComplexTextNodeContents(textNode);
			} else if (textNode !== null) {
				if (config.escapeMode)
					result += escapeXmlChars(textNode);
				else
					result += textNode;
			}

			return result;
		}

		function serializeArray(elementArray, elementName, attributes) {
			var result = "";

			if (elementArray.length === 0) {
				result += serializeStartTag(elementArray, elementName, attributes, true);
			} else {
				for (var i = 0; i < elementArray.length; i++) {
					result += serializeJavaScriptObject(elementArray[i], elementName, getDataAttributeNames(elementArray[i]));
				}
			}

			return result;
		}

		function serializeJavaScriptObject(element, elementName, attributes) {
			var result = "";

			// Filter out elements
			if (config.jsAttributeFilter && config.jsAttributeFilter.call(null, elementName, element)) {
				return result;
			}
			// Convert element
			if (config.jsAttributeConverter) {
				element = config.jsAttributeConverter.call(null, elementName, element);
			}
			if ((element === undefined || element === null || element === '') && config.selfClosingElements) {
				result += serializeStartTag(element, elementName, attributes, true);
			} else if (typeof element === 'object') {
				if (Object.prototype.toString.call(element) === '[object Array]') {
					result += serializeArray(element, elementName, attributes);
				} else if (element instanceof Date) {
					result += serializeStartTag(element, elementName, attributes, false);
					// Serialize date
					result += config.jsDateUTC ? element.toUTCString() : element.toISOString();
					result += serializeEndTag(element, elementName);
				} else {
					var childElementCount = getDataElementCount(element);
					if (childElementCount > 0 || typeof (element.__text) === 'number' || typeof (element.__text) === 'boolean' || element.__text || element.__cdata) {
						result += serializeStartTag(element, elementName, attributes, false);
						result += serializeJavaScriptObjectChildren(element);
						result += serializeEndTag(element, elementName);
					} else if (config.selfClosingElements) {
						result += serializeStartTag(element, elementName, attributes, true);
					} else {
						result += serializeStartTag(element, elementName, attributes, false);
						result += serializeEndTag(element, elementName);
					}
				}
			} else {
				result += serializeStartTag(element, elementName, attributes, false);
				result += serializeTextNodeContents(element);
				result += serializeEndTag(element, elementName);
			}

			return result;
		}

		function serializeJavaScriptObjectChildren(jsObject) {
			var result = "";

			var elementCount = getDataElementCount(jsObject);

			if (elementCount > 0) {
				for (var elementName in jsObject) {
					if (isSpecialProperty(jsObject, elementName))
						continue;

					var element = jsObject[elementName];
					var attributes = getDataAttributeNames(element);

					result += serializeJavaScriptObject(element, elementName, attributes);
				}
			}

			result += serializeTextNodeContents(jsObject);

			return result;
		}

		function parseXml(xml) {
			if (xml === undefined) {
				return null;
			}

			if (typeof xml !== "string") {
				return null;
			}

			var parser = null;
			var domNode = null;

			if (CustomDOMParser) {
				// This branch is used for node.js, with the xmldom parser.
				parser = new CustomDOMParser(config.xmldomOptions);

				domNode = parser.parseFromString(xml, "text/xml");
			} else if (window && window.DOMParser) {
				parser = new window.DOMParser();
				var parsererrorNS = null;

				var isIEParser = window.ActiveXObject || "ActiveXObject" in window;

				// IE9+ now is here
				if (!isIEParser && document.all && !document.addEventListener) {
					try {
						parsererrorNS = parser.parseFromString("INVALID", "text/xml").childNodes[0].namespaceURI;
					} catch (err) {
						parsererrorNS = null;
					}
				}

				try {
					domNode = parser.parseFromString(xml, "text/xml");
					if (parsererrorNS !== null && domNode.getElementsByTagNameNS(parsererrorNS, "parsererror").length > 0) {
						domNode = null;
					}
				} catch (err) {
					domNode = null;
				}
			} else {
				// IE :(
				if (xml.indexOf("<?") === 0) {
					xml = xml.substr(xml.indexOf("?>") + 2);
				}

				/* global ActiveXObject */
				domNode = new ActiveXObject("Microsoft.XMLDOM");
				domNode.async = "false";
				domNode.loadXML(xml);
			}

			return domNode;
		}

		this.asArray = function asArray(prop) {
			if (prop === undefined || prop === null) {
				return [];
			} else if (prop instanceof Array) {
				return prop;
			} else {
				return [prop];
			}
		};

		this.toXmlDateTime = function toXmlDateTime(dt) {
			if (dt instanceof Date) {
				return dt.toISOString();
			} else if (typeof (dt) === 'number') {
				return new Date(dt).toISOString();
			} else {
				return null;
			}
		};

		this.asDateTime = function asDateTime(prop) {
			if (typeof (prop) === "string") {
				return xmlDateTimeToDate(prop);
			} else {
				return prop;
			}
		};

		/*
			Internally the logic works in a cycle:
			DOM->JS - implemented by custom logic (deserialization).
			JS->XML - implemented by custom logic (serialization).
			XML->DOM - implemented by browser.
		*/

		// Transformns an XML string into DOM-tree
		this.xml2dom = function xml2dom(xml) {
			return parseXml(xml);
		};

		// Transforms a DOM tree to JavaScript objects.
		this.dom2js = function dom2js(domNode) {
			return deserializeDomChildren(domNode, null);
		};

		// Transforms JavaScript objects to a DOM tree.
		this.js2dom = function js2dom(jsObject) {
			var xml = this.js2xml(jsObject);
			return parseXml(xml);
		};

		// Transformns an XML string into JavaScript objects.
		this.xml2js = function xml2js(xml) {
			var domNode = parseXml(xml);
			if (domNode != null)
				return this.dom2js(domNode);
			else
				return null;
		};

		// Transforms JavaScript objects into an XML string.
		this.js2xml = function js2xml(jsObject) {
			return serializeJavaScriptObjectChildren(jsObject);
		};

		this.getVersion = function getVersion() {
			return VERSION;
		};
	};
});


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// holding.js